"use client";
var bL = Object.defineProperty;
var u = (s, t) => bL(s, "name", { value: t, configurable: !0 });
import Y, { createContext as $L, useState as VS, useMemo as ZS, useEffect as v0, useRef as xL } from "react";
var kL = Object.defineProperty, m = /* @__PURE__ */ u((s, t) => kL(s, "name", { value: t, configurable: !0 }), "c$2");
const U$ = /* @__PURE__ */ m((s) => {
  s && requestAnimationFrame(() => {
    var t;
    return (t = s == null ? void 0 : s.focus) == null ? void 0 : t.call(s);
  });
}, "autofocusRef");
async function _o(s, t = "wy-") {
  const i = [];
  for (let n = s; n = n.parentElement; )
    n.matches(":not(:defined)") && n.localName.startsWith(t) && i.push(customElements.whenDefined(n.localName));
  await Promise.all(i);
}
u(_o, "Lw$1");
m(_o, "whenParentsDefined");
const c3 = /* @__PURE__ */ m((s, t) => {
  let i;
  const n = new ResizeObserver(() => {
    const { isConnected: r } = s;
    r !== i && (i = r, t(r, s));
  });
  return n.observe(s), n;
}, "observeConnected");
async function N$(s, t = !0) {
  if (s.isConnected === t)
    return t;
  {
    let i;
    const n = new Promise((a) => i = a), r = c3(s, (a) => {
      a === t && (i == null || i(t));
    });
    return await n, r.disconnect(), t;
  }
}
u(N$, "_w$1");
m(N$, "whenConnected");
async function h3() {
  Bt(), document.hidden && await new Promise((s) => {
    window.addEventListener(
      "visibilitychange",
      () => {
        document.hidden || s(!0);
      },
      { once: !0 }
    );
  });
}
u(h3, "Mw$1");
m(h3, "whenDocumentVisible");
const B$ = {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  /* @ts-ignore */
  opacityProperty: !0,
  visibilityProperty: !0,
  // Legacy compatibility
  checkOpacity: !0,
  checkVisibilityCSS: !0
};
function j$(s, t = !0, i = B$, n) {
  s.checkVisibility(i) === t ? n(t) : requestAnimationFrame(() => j$(s, t, i, n));
}
u(j$, "_d$1");
m(j$, "untilVisibility");
async function xg(s, t = !0, i = B$) {
  s.checkVisibility(i) !== t && await new Promise((n) => {
    j$(s, t, i, n);
  });
}
u(xg, "Yw$1");
m(xg, "whenElementVisible");
function O0(s) {
  return s.getRootNode() instanceof ShadowRoot;
}
u(O0, "Cw$1");
m(O0, "isInShadowDom");
function kg() {
  var s;
  return !!((s = document.body) != null && s.showPopover && !/native code/i.test(document.body.showPopover.toString()));
}
u(kg, "Ew$1");
m(kg, "isPopoverPolyfilled");
function _1() {
  return typeof window < "u";
}
u(_1, "Vw$1");
m(_1, "isDomAvailable");
function Bt() {
  if (typeof window > "u")
    throw Error("DOM not available");
}
u(Bt, "Md$1");
m(Bt, "throwOnDomNotAvailable");
let b0 = [], d3 = [];
(() => {
  let s = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((t) => t ? parseInt(t, 36) : 1);
  for (let t = 0, i = 0; t < s.length; t++)
    (t % 2 ? d3 : b0).push(i = i + s[t]);
})();
function u3(s) {
  if (s < 768) return !1;
  for (let t = 0, i = b0.length; ; ) {
    let n = t + i >> 1;
    if (s < b0[n]) i = n;
    else if (s >= d3[n]) t = n + 1;
    else return !0;
    if (t == i) return !1;
  }
}
u(u3, "mg$1");
m(u3, "isExtendingChar");
function $0(s) {
  return s >= 127462 && s <= 127487;
}
u($0, "Rc$1");
m($0, "isRegionalIndicator");
const DS = 8205;
function p3(s, t, i = !0, n = !0) {
  return (i ? X$ : f3)(s, t, n);
}
u(p3, "gg$1");
m(p3, "findClusterBreak$1");
function X$(s, t, i) {
  if (t == s.length) return t;
  t && F$(s.charCodeAt(t)) && H$(s.charCodeAt(t - 1)) && t--;
  let n = Iw(s, t);
  for (t += x0(n); t < s.length; ) {
    let r = Iw(s, t);
    if (n == DS || r == DS || i && u3(r))
      t += x0(r), n = r;
    else if ($0(r)) {
      let a = 0, o = t - 2;
      for (; o >= 0 && $0(Iw(s, o)); )
        a++, o -= 2;
      if (a % 2 == 0) break;
      t += 2;
    } else
      break;
  }
  return t;
}
u(X$, "Cd$1");
m(X$, "nextClusterBreak");
function f3(s, t, i) {
  for (; t > 0; ) {
    let n = X$(s, t - 2, i);
    if (n < t) return n;
    t--;
  }
  return 0;
}
u(f3, "bg$1");
m(f3, "prevClusterBreak");
function Iw(s, t) {
  let i = s.charCodeAt(t);
  if (!H$(i) || t + 1 == s.length) return i;
  let n = s.charCodeAt(t + 1);
  return F$(n) ? (i - 55296 << 10) + (n - 56320) + 65536 : i;
}
u(Iw, "Po$1");
m(Iw, "codePointAt$1");
function F$(s) {
  return s >= 56320 && s < 57344;
}
u(F$, "Ed");
m(F$, "surrogateLow$1");
function H$(s) {
  return s >= 55296 && s < 56320;
}
u(H$, "Vd$1");
m(H$, "surrogateHigh$1");
function x0(s) {
  return s < 65536 ? 1 : 2;
}
u(x0, "vc$1");
m(x0, "codePointSize$1");
var Ra;
const y3 = (Ra = class {
  /**
  Get the line description around the given position.
  */
  lineAt(t) {
    if (t < 0 || t > this.length)
      throw new RangeError(`Invalid position ${t} in document of length ${this.length}`);
    return this.lineInner(t, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(t) {
    if (t < 1 || t > this.lines)
      throw new RangeError(`Invalid line number ${t} in ${this.lines}-line document`);
    return this.lineInner(t, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(t, i, n) {
    [t, i] = mo(this, t, i);
    let r = [];
    return this.decompose(
      0,
      t,
      r,
      2
      /* Open.To */
    ), n.length && n.decompose(
      0,
      n.length,
      r,
      3
      /* Open.To */
    ), this.decompose(
      i,
      this.length,
      r,
      1
      /* Open.From */
    ), Ww.from(r, this.length - (i - t) + n.length);
  }
  /**
  Append another document to this one.
  */
  append(t) {
    return this.replace(this.length, this.length, t);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(t, i = this.length) {
    [t, i] = mo(this, t, i);
    let n = [];
    return this.decompose(t, i, n, 0), Ww.from(n, i - t);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(t) {
    if (t == this)
      return !0;
    if (t.length != this.length || t.lines != this.lines)
      return !1;
    let i = this.scanIdentical(t, 1), n = this.length - this.scanIdentical(t, -1), r = new Vy(this), a = new Vy(t);
    for (let o = i, l = i; ; ) {
      if (r.next(o), a.next(o), o = 0, r.lineBreak != a.lineBreak || r.done != a.done || r.value != a.value)
        return !1;
      if (l += r.value.length, r.done || l >= n)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(t = 1) {
    return new Vy(this, t);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(t, i = this.length) {
    return new b3(this, t, i);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(t, i) {
    let n;
    if (t == null)
      n = this.iter();
    else {
      i == null && (i = this.lines + 1);
      let r = this.line(t).from;
      n = this.iterRange(r, Math.max(r, i == this.lines + 1 ? this.length : i <= 1 ? 0 : this.line(i - 1).to));
    }
    return new x3(n);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let t = [];
    return this.flatten(t), t;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(t) {
    if (t.length == 0)
      throw new RangeError("A document must have at least one line");
    return t.length == 1 && !t[0] ? Ra.empty : t.length <= 32 ? new nn(t) : Ww.from(nn.split(t, []));
  }
}, u(Ra, "Ls"), Ra);
m(y3, "Text");
let Ie = y3;
var li;
const m3 = (li = class extends Ie {
  constructor(t, i = g3(t)) {
    super(), this.text = t, this.length = i;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(t, i, n, r) {
    for (let a = 0; ; a++) {
      let o = this.text[a], l = r + o.length;
      if ((i ? n : l) >= t)
        return new SL(r, l, n, o);
      r = l + 1, n++;
    }
  }
  decompose(t, i, n, r) {
    let a = t <= 0 && i >= this.length ? this : new li(k0(this.text, t, i), Math.min(i, this.length) - Math.max(0, t));
    if (r & 1) {
      let o = n.pop(), l = Wy(a.text, o.text.slice(), 0, a.length);
      if (l.length <= 32)
        n.push(new li(l, o.length + a.length));
      else {
        let c = l.length >> 1;
        n.push(new li(l.slice(0, c)), new li(l.slice(c)));
      }
    } else
      n.push(a);
  }
  replace(t, i, n) {
    if (!(n instanceof li))
      return super.replace(t, i, n);
    [t, i] = mo(this, t, i);
    let r = Wy(this.text, Wy(n.text, k0(this.text, 0, t)), i), a = this.length + n.length - (i - t);
    return r.length <= 32 ? new li(r, a) : Ww.from(li.split(r, []), a);
  }
  sliceString(t, i = this.length, n = `
`) {
    [t, i] = mo(this, t, i);
    let r = "";
    for (let a = 0, o = 0; a <= i && o < this.text.length; o++) {
      let l = this.text[o], c = a + l.length;
      a > t && o && (r += n), t < c && i > a && (r += l.slice(Math.max(0, t - a), i - a)), a = c + 1;
    }
    return r;
  }
  flatten(t) {
    for (let i of this.text)
      t.push(i);
  }
  scanIdentical() {
    return 0;
  }
  static split(t, i) {
    let n = [], r = -1;
    for (let a of t)
      n.push(a), r += a.length + 1, n.length == 32 && (i.push(new li(n, r)), n = [], r = -1);
    return r > -1 && i.push(new li(n, r)), i;
  }
}, u(li, "Ze"), li);
m(m3, "TextLeaf");
let nn = m3;
var en;
const w3 = (en = class extends Ie {
  constructor(t, i) {
    super(), this.children = t, this.length = i, this.lines = 0;
    for (let n of t)
      this.lines += n.lines;
  }
  lineInner(t, i, n, r) {
    for (let a = 0; ; a++) {
      let o = this.children[a], l = r + o.length, c = n + o.lines - 1;
      if ((i ? c : l) >= t)
        return o.lineInner(t, i, n, r);
      r = l + 1, n = c + 1;
    }
  }
  decompose(t, i, n, r) {
    for (let a = 0, o = 0; o <= i && a < this.children.length; a++) {
      let l = this.children[a], c = o + l.length;
      if (t <= c && i >= o) {
        let h = r & ((o <= t ? 1 : 0) | (c >= i ? 2 : 0));
        o >= t && c <= i && !h ? n.push(l) : l.decompose(t - o, i - o, n, h);
      }
      o = c + 1;
    }
  }
  replace(t, i, n) {
    if ([t, i] = mo(this, t, i), n.lines < this.lines)
      for (let r = 0, a = 0; r < this.children.length; r++) {
        let o = this.children[r], l = a + o.length;
        if (t >= a && i <= l) {
          let c = o.replace(t - a, i - a, n), h = this.lines - o.lines + c.lines;
          if (c.lines < h >> 4 && c.lines > h >> 6) {
            let d = this.children.slice();
            return d[r] = c, new en(d, this.length - (i - t) + n.length);
          }
          return super.replace(a, l, c);
        }
        a = l + 1;
      }
    return super.replace(t, i, n);
  }
  sliceString(t, i = this.length, n = `
`) {
    [t, i] = mo(this, t, i);
    let r = "";
    for (let a = 0, o = 0; a < this.children.length && o <= i; a++) {
      let l = this.children[a], c = o + l.length;
      o > t && a && (r += n), t < c && i > o && (r += l.sliceString(t - o, i - o, n)), o = c + 1;
    }
    return r;
  }
  flatten(t) {
    for (let i of this.children)
      i.flatten(t);
  }
  scanIdentical(t, i) {
    if (!(t instanceof en))
      return 0;
    let n = 0, [r, a, o, l] = i > 0 ? [0, 0, this.children.length, t.children.length] : [this.children.length - 1, t.children.length - 1, -1, -1];
    for (; ; r += i, a += i) {
      if (r == o || a == l)
        return n;
      let c = this.children[r], h = t.children[a];
      if (c != h)
        return n + c.scanIdentical(h, i);
      n += c.length + 1;
    }
  }
  static from(t, i = t.reduce((n, r) => n + r.length + 1, -1)) {
    let n = 0;
    for (let w of t)
      n += w.lines;
    if (n < 32) {
      let w = [];
      for (let g of t)
        g.flatten(w);
      return new nn(w, i);
    }
    let r = Math.max(
      32,
      n >> 5
      /* Tree.BranchShift */
    ), a = r << 1, o = r >> 1, l = [], c = 0, h = -1, d = [];
    function f(w) {
      let g;
      if (w.lines > a && w instanceof en)
        for (let b of w.children)
          f(b);
      else w.lines > o && (c > o || !c) ? (y(), l.push(w)) : w instanceof nn && c && (g = d[d.length - 1]) instanceof nn && w.lines + g.lines <= 32 ? (c += w.lines, h += w.length + 1, d[d.length - 1] = new nn(g.text.concat(w.text), g.length + 1 + w.length)) : (c + w.lines > r && y(), c += w.lines, h += w.length + 1, d.push(w));
    }
    u(f, "u"), m(f, "add");
    function y() {
      c != 0 && (l.push(d.length == 1 ? d[0] : en.from(d, h)), h = -1, c = d.length = 0);
    }
    u(y, "d"), m(y, "flush");
    for (let w of t)
      f(w);
    return y(), l.length == 1 ? l[0] : new en(l, i);
  }
}, u(en, "gt"), en);
m(w3, "TextNode");
let Ww = w3;
Ie.empty = /* @__PURE__ */ new nn([""], 0);
function g3(s) {
  let t = -1;
  for (let i of s)
    t += i.length + 1;
  return t;
}
u(g3, "yg$1");
m(g3, "textLength");
function Wy(s, t, i = 0, n = 1e9) {
  for (let r = 0, a = 0, o = !0; a < s.length && r <= n; a++) {
    let l = s[a], c = r + l.length;
    c >= i && (c > n && (l = l.slice(0, n - r)), r < i && (l = l.slice(i - r)), o ? (t[t.length - 1] += l, o = !1) : t.push(l)), r = c + 1;
  }
  return t;
}
u(Wy, "Xn$1");
m(Wy, "appendText");
function k0(s, t, i) {
  return Wy(s, [""], t, i);
}
u(k0, "Tc$1");
m(k0, "sliceText");
var gc;
const v3 = (gc = class {
  constructor(t, i = 1) {
    this.dir = i, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [t], this.offsets = [i > 0 ? 1 : (t instanceof nn ? t.text.length : t.children.length) << 1];
  }
  nextInner(t, i) {
    for (this.done = this.lineBreak = !1; ; ) {
      let n = this.nodes.length - 1, r = this.nodes[n], a = this.offsets[n], o = a >> 1, l = r instanceof nn ? r.text.length : r.children.length;
      if (o == (i > 0 ? l : 0)) {
        if (n == 0)
          return this.done = !0, this.value = "", this;
        i > 0 && this.offsets[n - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((a & 1) == (i > 0 ? 0 : 1)) {
        if (this.offsets[n] += i, t == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        t--;
      } else if (r instanceof nn) {
        let c = r.text[o + (i < 0 ? -1 : 0)];
        if (this.offsets[n] += i, c.length > Math.max(0, t))
          return this.value = t == 0 ? c : i > 0 ? c.slice(t) : c.slice(0, c.length - t), this;
        t -= c.length;
      } else {
        let c = r.children[o + (i < 0 ? -1 : 0)];
        t > c.length ? (t -= c.length, this.offsets[n] += i) : (i < 0 && this.offsets[n]--, this.nodes.push(c), this.offsets.push(i > 0 ? 1 : (c instanceof nn ? c.text.length : c.children.length) << 1));
      }
    }
  }
  next(t = 0) {
    return t < 0 && (this.nextInner(-t, -this.dir), t = this.value.length), this.nextInner(t, this.dir);
  }
}, u(gc, "Wh"), gc);
m(v3, "RawTextCursor");
let Vy = v3;
var vc;
const O3 = (vc = class {
  constructor(t, i, n) {
    this.value = "", this.done = !1, this.cursor = new Vy(t, i > n ? -1 : 1), this.pos = i > n ? t.length : 0, this.from = Math.min(i, n), this.to = Math.max(i, n);
  }
  nextInner(t, i) {
    if (i < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    t += Math.max(0, i < 0 ? this.pos - this.to : this.from - this.pos);
    let n = i < 0 ? this.pos - this.from : this.to - this.pos;
    t > n && (t = n), n -= t;
    let { value: r } = this.cursor.next(t);
    return this.pos += (r.length + t) * i, this.value = r.length <= n ? r : i < 0 ? r.slice(r.length - n) : r.slice(0, n), this.done = !this.value, this;
  }
  next(t = 0) {
    return t < 0 ? t = Math.max(t, this.from - this.pos) : t > 0 && (t = Math.min(t, this.to - this.pos)), this.nextInner(t, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}, u(vc, "Uh"), vc);
m(O3, "PartialTextCursor");
let b3 = O3;
var Oc;
const $3 = (Oc = class {
  constructor(t) {
    this.inner = t, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(t = 0) {
    let { done: i, lineBreak: n, value: r } = this.inner.next(t);
    return i && this.afterBreak ? (this.value = "", this.afterBreak = !1) : i ? (this.done = !0, this.value = "") : n ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = r, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}, u(Oc, "Lh"), Oc);
m($3, "LineCursor");
let x3 = $3;
typeof Symbol < "u" && (Ie.prototype[Symbol.iterator] = function() {
  return this.iter();
}, Vy.prototype[Symbol.iterator] = b3.prototype[Symbol.iterator] = x3.prototype[Symbol.iterator] = function() {
  return this;
});
var Ev, bc;
let SL = (Ev = (bc = class {
  /**
  @internal
  */
  constructor(t, i, n, r) {
    this.from = t, this.to = i, this.number = n, this.text = r;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}, u(bc, "Ti$1"), bc), m(Ev, "Line"), Ev);
function mo(s, t, i) {
  return t = Math.max(0, Math.min(s.length, t)), [t, Math.max(t, Math.min(s.length, i))];
}
u(mo, "Yi$1");
m(mo, "clip");
function sn(s, t, i = !0, n = !0) {
  return p3(s, t, i, n);
}
u(sn, "de$2");
m(sn, "findClusterBreak");
function k3(s) {
  return s >= 56320 && s < 57344;
}
u(k3, "Pg$1");
m(k3, "surrogateLow");
function S3(s) {
  return s >= 55296 && s < 56320;
}
u(S3, "wg$1");
m(S3, "surrogateHigh");
function Bs(s, t) {
  let i = s.charCodeAt(t);
  if (!S3(i) || t + 1 == s.length)
    return i;
  let n = s.charCodeAt(t + 1);
  return k3(n) ? (i - 55296 << 10) + (n - 56320) + 65536 : i;
}
u(Bs, "Et$1");
m(Bs, "codePointAt");
function P3(s) {
  return s <= 65535 ? String.fromCharCode(s) : (s -= 65536, String.fromCharCode((s >> 10) + 55296, (s & 1023) + 56320));
}
u(P3, "xg$1");
m(P3, "fromCodePoint");
function va(s) {
  return s < 65536 ? 1 : 2;
}
u(va, "di$1");
m(va, "codePointSize");
const S0 = /\r\n?|\n/;
var hi = /* @__PURE__ */ function(s) {
  return s[s.Simple = 0] = "Simple", s[s.TrackDel = 1] = "TrackDel", s[s.TrackBefore = 2] = "TrackBefore", s[s.TrackAfter = 3] = "TrackAfter", s;
}(hi || (hi = {})), vs;
const C3 = (vs = class {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(t) {
    this.sections = t;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let t = 0;
    for (let i = 0; i < this.sections.length; i += 2)
      t += this.sections[i];
    return t;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let t = 0;
    for (let i = 0; i < this.sections.length; i += 2) {
      let n = this.sections[i + 1];
      t += n < 0 ? this.sections[i] : n;
    }
    return t;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(t) {
    for (let i = 0, n = 0, r = 0; i < this.sections.length; ) {
      let a = this.sections[i++], o = this.sections[i++];
      o < 0 ? (t(n, r, a), r += a) : r += o, n += a;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(t, i = !1) {
    Sg(this, t, i);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let t = [];
    for (let i = 0; i < this.sections.length; ) {
      let n = this.sections[i++], r = this.sections[i++];
      r < 0 ? t.push(n, r) : t.push(r, n);
    }
    return new vs(t);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(t) {
    return this.empty ? t : t.empty ? this : Y$(this, t);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(t, i = !1) {
    return t.empty ? this : Pg(this, t, i);
  }
  mapPos(t, i = -1, n = hi.Simple) {
    let r = 0, a = 0;
    for (let o = 0; o < this.sections.length; ) {
      let l = this.sections[o++], c = this.sections[o++], h = r + l;
      if (c < 0) {
        if (h > t)
          return a + (t - r);
        a += l;
      } else {
        if (n != hi.Simple && h >= t && (n == hi.TrackDel && r < t && h > t || n == hi.TrackBefore && r < t || n == hi.TrackAfter && h > t))
          return null;
        if (h > t || h == t && i < 0 && !l)
          return t == r || i < 0 ? a : a + c;
        a += c;
      }
      r = h;
    }
    if (t > r)
      throw new RangeError(`Position ${t} is out of range for changeset of length ${r}`);
    return a;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(t, i = t) {
    for (let n = 0, r = 0; n < this.sections.length && r <= i; ) {
      let a = this.sections[n++], o = this.sections[n++], l = r + a;
      if (o >= 0 && r <= i && l >= t)
        return r < t && l > i ? "cover" : !0;
      r = l;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let i = 0; i < this.sections.length; ) {
      let n = this.sections[i++], r = this.sections[i++];
      t += (t ? " " : "") + n + (r >= 0 ? ":" + r : "");
    }
    return t;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2 || t.some((i) => typeof i != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new vs(t);
  }
  /**
  @internal
  */
  static create(t) {
    return new vs(t);
  }
}, u(vs, "bi"), vs);
m(C3, "ChangeDesc");
let oc = C3;
var Ti;
const Q3 = (Ti = class extends oc {
  constructor(t, i) {
    super(t), this.inserted = i;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(t) {
    if (this.length != t.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return Sg(this, (i, n, r, a, o) => t = t.replace(r, r + (n - i), o), !1), t;
  }
  mapDesc(t, i = !1) {
    return Pg(this, t, i, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(t) {
    let i = this.sections.slice(), n = [];
    for (let r = 0, a = 0; r < i.length; r += 2) {
      let o = i[r], l = i[r + 1];
      if (l >= 0) {
        i[r] = l, i[r + 1] = o;
        let c = r >> 1;
        for (; n.length < c; )
          n.push(Ie.empty);
        n.push(o ? t.slice(a, a + o) : Ie.empty);
      }
      a += o;
    }
    return new Ti(i, n);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(t) {
    return this.empty ? t : t.empty ? this : Y$(this, t, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(t, i = !1) {
    return t.empty ? this : Pg(this, t, i, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(t, i = !1) {
    Sg(this, t, i);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return oc.create(this.sections);
  }
  /**
  @internal
  */
  filter(t) {
    let i = [], n = [], r = [], a = new Gy(this);
    e: for (let o = 0, l = 0; ; ) {
      let c = o == t.length ? 1e9 : t[o++];
      for (; l < c || l == c && a.len == 0; ) {
        if (a.done)
          break e;
        let d = Math.min(a.len, c - l);
        qt(r, d, -1);
        let f = a.ins == -1 ? -1 : a.off == 0 ? a.ins : 0;
        qt(i, d, f), f > 0 && fs(n, i, a.text), a.forward(d), l += d;
      }
      let h = t[o++];
      for (; l < h; ) {
        if (a.done)
          break e;
        let d = Math.min(a.len, h - l);
        qt(i, d, -1), qt(r, d, a.ins == -1 ? -1 : a.off == 0 ? a.ins : 0), a.forward(d), l += d;
      }
    }
    return {
      changes: new Ti(i, n),
      filtered: oc.create(r)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let t = [];
    for (let i = 0; i < this.sections.length; i += 2) {
      let n = this.sections[i], r = this.sections[i + 1];
      r < 0 ? t.push(n) : r == 0 ? t.push([n]) : t.push([n].concat(this.inserted[i >> 1].toJSON()));
    }
    return t;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(t, i, n) {
    let r = [], a = [], o = 0, l = null;
    function c(d = !1) {
      if (!d && !r.length)
        return;
      o < i && qt(r, i - o, -1);
      let f = new Ti(r, a);
      l = l ? l.compose(f.map(l)) : f, r = [], a = [], o = 0;
    }
    u(c, "a"), m(c, "flush");
    function h(d) {
      if (Array.isArray(d))
        for (let f of d)
          h(f);
      else if (d instanceof Ti) {
        if (d.length != i)
          throw new RangeError(`Mismatched change set length (got ${d.length}, expected ${i})`);
        c(), l = l ? l.compose(d.map(l)) : d;
      } else {
        let { from: f, to: y = f, insert: w } = d;
        if (f > y || f < 0 || y > i)
          throw new RangeError(`Invalid change range ${f} to ${y} (in doc of length ${i})`);
        let g = w ? typeof w == "string" ? Ie.of(w.split(n || S0)) : w : Ie.empty, b = g.length;
        if (f == y && b == 0)
          return;
        f < o && c(), f > o && qt(r, f - o, -1), qt(r, y - f, b), fs(a, r, g), o = y;
      }
    }
    return u(h, "h"), m(h, "process"), h(t), c(!l), l;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(t) {
    return new Ti(t ? [t, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(t) {
    if (!Array.isArray(t))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let i = [], n = [];
    for (let r = 0; r < t.length; r++) {
      let a = t[r];
      if (typeof a == "number")
        i.push(a, -1);
      else {
        if (!Array.isArray(a) || typeof a[0] != "number" || a.some((o, l) => l && typeof o != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (a.length == 1)
          i.push(a[0], 0);
        else {
          for (; n.length < r; )
            n.push(Ie.empty);
          n[r] = Ie.of(a.slice(1)), i.push(a[0], n[r].length);
        }
      }
    }
    return new Ti(i, n);
  }
  /**
  @internal
  */
  static createSet(t, i) {
    return new Ti(t, i);
  }
}, u(Ti, "He"), Ti);
m(Q3, "ChangeSet");
let hn = Q3;
function qt(s, t, i, n = !1) {
  if (t == 0 && i <= 0)
    return;
  let r = s.length - 2;
  r >= 0 && i <= 0 && i == s[r + 1] ? s[r] += t : r >= 0 && t == 0 && s[r] == 0 ? s[r + 1] += i : n ? (s[r] += t, s[r + 1] += i) : s.push(t, i);
}
u(qt, "le$2");
m(qt, "addSection");
function fs(s, t, i) {
  if (i.length == 0)
    return;
  let n = t.length - 2 >> 1;
  if (n < s.length)
    s[s.length - 1] = s[s.length - 1].append(i);
  else {
    for (; s.length < n; )
      s.push(Ie.empty);
    s.push(i);
  }
}
u(fs, "yt$2");
m(fs, "addInsert");
function Sg(s, t, i) {
  let n = s.inserted;
  for (let r = 0, a = 0, o = 0; o < s.sections.length; ) {
    let l = s.sections[o++], c = s.sections[o++];
    if (c < 0)
      r += l, a += l;
    else {
      let h = r, d = a, f = Ie.empty;
      for (; h += l, d += c, c && n && (f = f.append(n[o - 2 >> 1])), !(i || o == s.sections.length || s.sections[o + 1] < 0); )
        l = s.sections[o++], c = s.sections[o++];
      t(r, h, a, d, f), r = h, a = d;
    }
  }
}
u(Sg, "Jo$1");
m(Sg, "iterChanges");
function Pg(s, t, i, n = !1) {
  let r = [], a = n ? [] : null, o = new Gy(s), l = new Gy(t);
  for (let c = -1; ; ) {
    if (o.done && l.len || l.done && o.len)
      throw new Error("Mismatched change set lengths");
    if (o.ins == -1 && l.ins == -1) {
      let h = Math.min(o.len, l.len);
      qt(r, h, -1), o.forward(h), l.forward(h);
    } else if (l.ins >= 0 && (o.ins < 0 || c == o.i || o.off == 0 && (l.len < o.len || l.len == o.len && !i))) {
      let h = l.len;
      for (qt(r, l.ins, -1); h; ) {
        let d = Math.min(o.len, h);
        o.ins >= 0 && c < o.i && o.len <= d && (qt(r, 0, o.ins), a && fs(a, r, o.text), c = o.i), o.forward(d), h -= d;
      }
      l.next();
    } else if (o.ins >= 0) {
      let h = 0, d = o.len;
      for (; d; )
        if (l.ins == -1) {
          let f = Math.min(d, l.len);
          h += f, d -= f, l.forward(f);
        } else if (l.ins == 0 && l.len < d)
          d -= l.len, l.next();
        else
          break;
      qt(r, h, c < o.i ? o.ins : 0), a && c < o.i && fs(a, r, o.text), c = o.i, o.forward(o.len - d);
    } else {
      if (o.done && l.done)
        return a ? hn.createSet(r, a) : oc.create(r);
      throw new Error("Mismatched change set lengths");
    }
  }
}
u(Pg, "el$1");
m(Pg, "mapSet");
function Y$(s, t, i = !1) {
  let n = [], r = i ? [] : null, a = new Gy(s), o = new Gy(t);
  for (let l = !1; ; ) {
    if (a.done && o.done)
      return r ? hn.createSet(n, r) : oc.create(n);
    if (a.ins == 0)
      qt(n, a.len, 0, l), a.next();
    else if (o.len == 0 && !o.done)
      qt(n, 0, o.ins, l), r && fs(r, n, o.text), o.next();
    else {
      if (a.done || o.done)
        throw new Error("Mismatched change set lengths");
      {
        let c = Math.min(a.len2, o.len), h = n.length;
        if (a.ins == -1) {
          let d = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
          qt(n, c, d, l), r && d && fs(r, n, o.text);
        } else o.ins == -1 ? (qt(n, a.off ? 0 : a.len, c, l), r && fs(r, n, a.textBit(c))) : (qt(n, a.off ? 0 : a.len, o.off ? 0 : o.ins, l), r && !o.off && fs(r, n, o.text));
        l = (a.ins > c || o.ins >= 0 && o.len > c) && (l || n.length > h), a.forward2(c), o.forward(c);
      }
    }
  }
}
u(Y$, "Xd$1");
m(Y$, "composeSets");
var $c;
const T3 = ($c = class {
  constructor(t) {
    this.set = t, this.i = 0, this.next();
  }
  next() {
    let { sections: t } = this.set;
    this.i < t.length ? (this.len = t[this.i++], this.ins = t[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: t } = this.set, i = this.i - 2 >> 1;
    return i >= t.length ? Ie.empty : t[i];
  }
  textBit(t) {
    let { inserted: i } = this.set, n = this.i - 2 >> 1;
    return n >= i.length && !t ? Ie.empty : i[n].slice(this.off, t == null ? void 0 : this.off + t);
  }
  forward(t) {
    t == this.len ? this.next() : (this.len -= t, this.off += t);
  }
  forward2(t) {
    this.ins == -1 ? this.forward(t) : t == this.ins ? this.next() : (this.ins -= t, this.off += t);
  }
}, u($c, "_h"), $c);
m(T3, "SectionIter");
let Gy = T3;
var nr;
const M3 = (nr = class {
  constructor(t, i, n) {
    this.from = t, this.to = i, this.flags = n;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let t = this.flags & 7;
    return t == 7 ? null : t;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let t = this.flags >> 6;
    return t == 16777215 ? void 0 : t;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(t, i = -1) {
    let n, r;
    return this.empty ? n = r = t.mapPos(this.from, i) : (n = t.mapPos(this.from, 1), r = t.mapPos(this.to, -1)), n == this.from && r == this.to ? this : new nr(n, r, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(t, i = t) {
    if (t <= this.anchor && i >= this.anchor)
      return J.range(t, i);
    let n = Math.abs(t - this.anchor) > Math.abs(i - this.anchor) ? t : i;
    return J.range(this.anchor, n);
  }
  /**
  Compare this range to another range.
  */
  eq(t, i = !1) {
    return this.anchor == t.anchor && this.head == t.head && (!i || !this.empty || this.assoc == t.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(t) {
    if (!t || typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return J.range(t.anchor, t.head);
  }
  /**
  @internal
  */
  static create(t, i, n) {
    return new nr(t, i, n);
  }
}, u(nr, "Rr"), nr);
m(M3, "SelectionRange");
let gw = M3;
var Qt;
const R3 = (Qt = class {
  constructor(t, i) {
    this.ranges = t, this.mainIndex = i;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(t, i = -1) {
    return t.empty ? this : Qt.create(this.ranges.map((n) => n.map(t, i)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(t, i = !1) {
    if (this.ranges.length != t.ranges.length || this.mainIndex != t.mainIndex)
      return !1;
    for (let n = 0; n < this.ranges.length; n++)
      if (!this.ranges[n].eq(t.ranges[n], i))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new Qt([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(t, i = !0) {
    return Qt.create([t].concat(this.ranges), i ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(t, i = this.mainIndex) {
    let n = this.ranges.slice();
    return n[i] = t, Qt.create(n, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((t) => t.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(t) {
    if (!t || !Array.isArray(t.ranges) || typeof t.main != "number" || t.main >= t.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new Qt(t.ranges.map((i) => gw.fromJSON(i)), t.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(t, i = t) {
    return new Qt([Qt.range(t, i)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(t, i = 0) {
    if (t.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let n = 0, r = 0; r < t.length; r++) {
      let a = t[r];
      if (a.empty ? a.from <= n : a.from < n)
        return Qt.normalized(t.slice(), i);
      n = a.to;
    }
    return new Qt(t, i);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(t, i = 0, n, r) {
    return gw.create(t, t, (i == 0 ? 0 : i < 0 ? 8 : 16) | (n == null ? 7 : Math.min(6, n)) | (r ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(t, i, n, r) {
    let a = (n ?? 16777215) << 6 | (r == null ? 7 : Math.min(6, r));
    return i < t ? gw.create(i, t, 48 | a) : gw.create(t, i, (i > t ? 8 : 0) | a);
  }
  /**
  @internal
  */
  static normalized(t, i = 0) {
    let n = t[i];
    t.sort((r, a) => r.from - a.from), i = t.indexOf(n);
    for (let r = 1; r < t.length; r++) {
      let a = t[r], o = t[r - 1];
      if (a.empty ? a.from <= o.to : a.from < o.to) {
        let l = o.from, c = Math.max(a.to, o.to);
        r <= i && i--, t.splice(--r, 2, a.anchor > a.head ? Qt.range(c, l) : Qt.range(l, c));
      }
    }
    return new Qt(t, i);
  }
}, u(Qt, "he"), Qt);
m(R3, "EditorSelection");
let J = R3;
function G$(s, t) {
  for (let i of s.ranges)
    if (i.to > t)
      throw new RangeError("Selection points outside of document");
}
u(G$, "Id$1");
m(G$, "checkSelection");
let K$ = 0;
var Aa;
const A3 = (Aa = class {
  constructor(t, i, n, r, a) {
    this.combine = t, this.compareInput = i, this.compare = n, this.isStatic = r, this.id = K$++, this.default = t([]), this.extensions = typeof a == "function" ? a(this) : a;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(t = {}) {
    return new Aa(t.combine || ((i) => i), t.compareInput || ((i, n) => i === n), t.compare || (t.combine ? (i, n) => i === n : L1), !!t.static, t.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(t) {
    return new Vw([], this, 0, t);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(t, i) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Vw(t, this, 1, i);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(t, i) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Vw(t, this, 2, i);
  }
  from(t, i) {
    return i || (i = /* @__PURE__ */ m((n) => n, "get")), this.compute([t], (n) => i(n.field(t)));
  }
}, u(Aa, "_s"), Aa);
m(A3, "Facet");
let me = A3;
function L1(s, t) {
  return s == t || s.length == t.length && s.every((i, n) => i === t[n]);
}
u(L1, "Fa$1");
m(L1, "sameArray$1");
var xc;
const E3 = (xc = class {
  constructor(t, i, n, r) {
    this.dependencies = t, this.facet = i, this.type = n, this.value = r, this.id = K$++;
  }
  dynamicSlot(t) {
    var i;
    let n = this.value, r = this.facet.compareInput, a = this.id, o = t[a] >> 1, l = this.type == 2, c = !1, h = !1, d = [];
    for (let f of this.dependencies)
      f == "doc" ? c = !0 : f == "selection" ? h = !0 : ((i = t[f.id]) !== null && i !== void 0 ? i : 1) & 1 || d.push(t[f.id]);
    return {
      create(f) {
        return f.values[o] = n(f), 1;
      },
      update(f, y) {
        if (c && y.docChanged || h && (y.docChanged || y.selection) || Cg(f, d)) {
          let w = n(f);
          if (l ? !P0(w, f.values[o], r) : !r(w, f.values[o]))
            return f.values[o] = w, 1;
        }
        return 0;
      },
      reconfigure: /* @__PURE__ */ m((f, y) => {
        let w, g = y.config.address[a];
        if (g != null) {
          let b = Ky(y, g);
          if (this.dependencies.every((k) => k instanceof me ? y.facet(k) === f.facet(k) : k instanceof As ? y.field(k, !1) == f.field(k, !1) : !0) || (l ? P0(w = n(f), b, r) : r(w = n(f), b)))
            return f.values[o] = b, 0;
        } else
          w = n(f);
        return f.values[o] = w, 1;
      }, "reconfigure")
    };
  }
}, u(xc, "Mh"), xc);
m(E3, "FacetProvider");
let Vw = E3;
function P0(s, t, i) {
  if (s.length != t.length)
    return !1;
  for (let n = 0; n < s.length; n++)
    if (!i(s[n], t[n]))
      return !1;
  return !0;
}
u(P0, "Ac$1");
m(P0, "compareArray");
function Cg(s, t) {
  let i = !1;
  for (let n of t)
    lc(s, n) & 1 && (i = !0);
  return i;
}
u(Cg, "tl$1");
m(Cg, "ensureAll");
function z3(s, t, i) {
  let n = i.map((c) => s[c.id]), r = i.map((c) => c.type), a = n.filter((c) => !(c & 1)), o = s[t.id] >> 1;
  function l(c) {
    let h = [];
    for (let d = 0; d < n.length; d++) {
      let f = Ky(c, n[d]);
      if (r[d] == 2)
        for (let y of f)
          h.push(y);
      else
        h.push(f);
    }
    return t.combine(h);
  }
  return u(l, "l"), m(l, "get"), {
    create(c) {
      for (let h of n)
        lc(c, h);
      return c.values[o] = l(c), 1;
    },
    update(c, h) {
      if (!Cg(c, a))
        return 0;
      let d = l(c);
      return t.compare(d, c.values[o]) ? 0 : (c.values[o] = d, 1);
    },
    reconfigure(c, h) {
      let d = Cg(c, n), f = h.config.facets[t.id], y = h.facet(t);
      if (f && !d && L1(i, f))
        return c.values[o] = y, 0;
      let w = l(c);
      return t.compare(w, y) ? (c.values[o] = y, 0) : (c.values[o] = w, 1);
    }
  };
}
u(z3, "Qg$1");
m(z3, "dynamicFacetSlot");
const qS = /* @__PURE__ */ me.define({ static: !0 });
var Ea;
const _3 = (Ea = class {
  constructor(t, i, n, r, a) {
    this.id = t, this.createF = i, this.updateF = n, this.compareF = r, this.spec = a, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(t) {
    let i = new Ea(K$++, t.create, t.update, t.compare || ((n, r) => n === r), t);
    return t.provide && (i.provides = t.provide(i)), i;
  }
  create(t) {
    let i = t.facet(qS).find((n) => n.field == this);
    return ((i == null ? void 0 : i.create) || this.createF)(t);
  }
  /**
  @internal
  */
  slot(t) {
    let i = t[this.id] >> 1;
    return {
      create: /* @__PURE__ */ m((n) => (n.values[i] = this.create(n), 1), "create"),
      update: /* @__PURE__ */ m((n, r) => {
        let a = n.values[i], o = this.updateF(a, r);
        return this.compareF(a, o) ? 0 : (n.values[i] = o, 1);
      }, "update"),
      reconfigure: /* @__PURE__ */ m((n, r) => r.config.address[this.id] != null ? (n.values[i] = r.field(this), 0) : (n.values[i] = this.create(n), 1), "reconfigure")
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(t) {
    return [this, qS.of({ field: this, create: t })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}, u(Ea, "Ms"), Ea);
m(_3, "StateField");
let As = _3;
const Oa = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function Il(s) {
  return (t) => new I3(t, s);
}
u(Il, "ir$1");
m(Il, "prec");
const Lo = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ Il(Oa.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ Il(Oa.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ Il(Oa.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ Il(Oa.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ Il(Oa.lowest)
};
var kc;
const L3 = (kc = class {
  constructor(t, i) {
    this.inner = t, this.prec = i;
  }
}, u(kc, "Yh"), kc);
m(L3, "PrecExtension");
let I3 = L3;
var za;
const W3 = (za = class {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(t) {
    return new C0(this, t);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(t) {
    return za.reconfigure.of({ compartment: this, extension: t });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(t) {
    return t.config.compartments.get(this);
  }
}, u(za, "Ys"), za);
m(W3, "Compartment");
let V3 = W3;
var Sc;
const Z3 = (Sc = class {
  constructor(t, i) {
    this.compartment = t, this.inner = i;
  }
}, u(Sc, "Ch"), Sc);
m(Z3, "CompartmentInstance");
let C0 = Z3;
var _a;
const D3 = (_a = class {
  constructor(t, i, n, r, a, o) {
    for (this.base = t, this.compartments = i, this.dynamicSlots = n, this.address = r, this.staticValues = a, this.facets = o, this.statusTemplate = []; this.statusTemplate.length < n.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(t) {
    let i = this.address[t.id];
    return i == null ? t.default : this.staticValues[i >> 1];
  }
  static resolve(t, i, n) {
    let r = [], a = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Map();
    for (let y of q3(t, i, o))
      y instanceof As ? r.push(y) : (a[y.facet.id] || (a[y.facet.id] = [])).push(y);
    let l = /* @__PURE__ */ Object.create(null), c = [], h = [];
    for (let y of r)
      l[y.id] = h.length << 1, h.push((w) => y.slot(w));
    let d = n == null ? void 0 : n.config.facets;
    for (let y in a) {
      let w = a[y], g = w[0].facet, b = d && d[y] || [];
      if (w.every(
        (k) => k.type == 0
        /* Provider.Static */
      ))
        if (l[g.id] = c.length << 1 | 1, L1(b, w))
          c.push(n.facet(g));
        else {
          let k = g.combine(w.map(($) => $.value));
          c.push(n && g.compare(k, n.facet(g)) ? n.facet(g) : k);
        }
      else {
        for (let k of w)
          k.type == 0 ? (l[k.id] = c.length << 1 | 1, c.push(k.value)) : (l[k.id] = h.length << 1, h.push(($) => k.dynamicSlot($)));
        l[g.id] = h.length << 1, h.push((k) => z3(k, g, w));
      }
    }
    let f = h.map((y) => y(l));
    return new _a(t, o, f, l, c, a);
  }
}, u(_a, "Cs"), _a);
m(D3, "Configuration");
let US = D3;
function q3(s, t, i) {
  let n = [[], [], [], [], []], r = /* @__PURE__ */ new Map();
  function a(o, l) {
    let c = r.get(o);
    if (c != null) {
      if (c <= l)
        return;
      let h = n[c].indexOf(o);
      h > -1 && n[c].splice(h, 1), o instanceof C0 && i.delete(o.compartment);
    }
    if (r.set(o, l), Array.isArray(o))
      for (let h of o)
        a(h, l);
    else if (o instanceof C0) {
      if (i.has(o.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let h = t.get(o.compartment) || o.inner;
      i.set(o.compartment, h), a(h, l);
    } else if (o instanceof I3)
      a(o.inner, o.prec);
    else if (o instanceof As)
      n[l].push(o), o.provides && a(o.provides, l);
    else if (o instanceof Vw)
      n[l].push(o), o.facet.extensions && a(o.facet.extensions, Oa.default);
    else {
      let h = o.extension;
      if (!h)
        throw new Error(`Unrecognized extension value in extension set (${o}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      a(h, l);
    }
  }
  return u(a, "s"), m(a, "inner"), a(s, Oa.default), n.reduce((o, l) => o.concat(l));
}
u(q3, "kg$1");
m(q3, "flatten");
function lc(s, t) {
  if (t & 1)
    return 2;
  let i = t >> 1, n = s.status[i];
  if (n == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (n & 2)
    return n;
  s.status[i] = 4;
  let r = s.computeSlot(s, s.config.dynamicSlots[i]);
  return s.status[i] = 2 | r;
}
u(lc, "mr$1");
m(lc, "ensureAddr");
function Ky(s, t) {
  return t & 1 ? s.config.staticValues[t >> 1] : s.values[t >> 1];
}
u(Ky, "Jn$1");
m(Ky, "getAddr");
const U3 = /* @__PURE__ */ me.define(), Q0 = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => s.some((t) => t), "combine"),
  static: !0
}), N3 = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => s.length ? s[0] : void 0, "combine"),
  static: !0
}), B3 = /* @__PURE__ */ me.define(), j3 = /* @__PURE__ */ me.define(), X3 = /* @__PURE__ */ me.define(), F3 = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => s.length ? s[0] : !1, "combine")
});
var Pc;
const H3 = (Pc = class {
  /**
  @internal
  */
  constructor(t, i) {
    this.type = t, this.value = i;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new PL();
  }
}, u(Pc, "Eh"), Pc);
m(H3, "Annotation");
let Es = H3;
var Cc;
const Y3 = (Cc = class {
  /**
  Create an instance of this annotation.
  */
  of(t) {
    return new Es(this, t);
  }
}, u(Cc, "Vh"), Cc);
m(Y3, "AnnotationType");
let PL = Y3;
var Qc;
const G3 = (Qc = class {
  /**
  @internal
  */
  constructor(t) {
    this.map = t;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(t) {
    return new qe(this, t);
  }
}, u(Qc, "Xh"), Qc);
m(G3, "StateEffectType");
let CL = G3;
var La;
const K3 = (La = class {
  /**
  @internal
  */
  constructor(t, i) {
    this.type = t, this.value = i;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(t) {
    let i = this.type.map(this.value, t);
    return i === void 0 ? void 0 : i == this.value ? this : new La(this.type, i);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(t) {
    return this.type == t;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(t = {}) {
    return new CL(t.map || ((i) => i));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(t, i) {
    if (!t.length)
      return t;
    let n = [];
    for (let r of t) {
      let a = r.map(i);
      a && n.push(a);
    }
    return n;
  }
}, u(La, "Es"), La);
m(K3, "StateEffect");
let qe = K3;
qe.reconfigure = /* @__PURE__ */ qe.define();
qe.appendConfig = /* @__PURE__ */ qe.define();
var zn;
const J3 = (zn = class {
  constructor(t, i, n, r, a, o) {
    this.startState = t, this.changes = i, this.selection = n, this.effects = r, this.annotations = a, this.scrollIntoView = o, this._doc = null, this._state = null, n && G$(n, i.newLength), a.some((l) => l.type == zn.time) || (this.annotations = a.concat(zn.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(t, i, n, r, a, o) {
    return new zn(t, i, n, r, a, o);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(t) {
    for (let i of this.annotations)
      if (i.type == t)
        return i.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(t) {
    let i = this.annotation(zn.userEvent);
    return !!(i && (i == t || i.length > t.length && i.slice(0, t.length) == t && i[t.length] == "."));
  }
}, u(zn, "It"), zn);
m(J3, "Transaction");
let di = J3;
di.time = /* @__PURE__ */ Es.define();
di.userEvent = /* @__PURE__ */ Es.define();
di.addToHistory = /* @__PURE__ */ Es.define();
di.remote = /* @__PURE__ */ Es.define();
function eC(s, t) {
  let i = [];
  for (let n = 0, r = 0; ; ) {
    let a, o;
    if (n < s.length && (r == t.length || t[r] >= s[n]))
      a = s[n++], o = s[n++];
    else if (r < t.length)
      a = t[r++], o = t[r++];
    else
      return i;
    !i.length || i[i.length - 1] < a ? i.push(a, o) : i[i.length - 1] < o && (i[i.length - 1] = o);
  }
}
u(eC, "Rg$1");
m(eC, "joinRanges");
function J$(s, t, i) {
  var n;
  let r, a, o;
  return i ? (r = t.changes, a = hn.empty(t.changes.length), o = s.changes.compose(t.changes)) : (r = t.changes.map(s.changes), a = s.changes.mapDesc(t.changes, !0), o = s.changes.compose(r)), {
    changes: o,
    selection: t.selection ? t.selection.map(a) : (n = s.selection) === null || n === void 0 ? void 0 : n.map(r),
    effects: qe.mapEffects(s.effects, r).concat(qe.mapEffects(t.effects, a)),
    annotations: s.annotations.length ? s.annotations.concat(t.annotations) : t.annotations,
    scrollIntoView: s.scrollIntoView || t.scrollIntoView
  };
}
u(J$, "Gd$1");
m(J$, "mergeTransaction");
function Qg(s, t, i) {
  let n = t.selection, r = Sa(t.annotations);
  return t.userEvent && (r = r.concat(di.userEvent.of(t.userEvent))), {
    changes: t.changes instanceof hn ? t.changes : hn.of(t.changes || [], i, s.facet(N3)),
    selection: n && (n instanceof J ? n : J.single(n.anchor, n.head)),
    effects: Sa(t.effects),
    annotations: r,
    scrollIntoView: !!t.scrollIntoView
  };
}
u(Qg, "sl$1");
m(Qg, "resolveTransactionInner");
function ex(s, t, i) {
  let n = Qg(s, t.length ? t[0] : {}, s.doc.length);
  t.length && t[0].filter === !1 && (i = !1);
  for (let a = 1; a < t.length; a++) {
    t[a].filter === !1 && (i = !1);
    let o = !!t[a].sequential;
    n = J$(n, Qg(s, t[a], o ? n.changes.newLength : s.doc.length), o);
  }
  let r = di.create(s, n.changes, n.selection, n.effects, n.annotations, n.scrollIntoView);
  return iC(i ? tC(r) : r);
}
u(ex, "Fd$1");
m(ex, "resolveTransaction");
function tC(s) {
  let t = s.startState, i = !0;
  for (let r of t.facet(B3)) {
    let a = r(s);
    if (a === !1) {
      i = !1;
      break;
    }
    Array.isArray(a) && (i = i === !0 ? a : eC(i, a));
  }
  if (i !== !0) {
    let r, a;
    if (i === !1)
      a = s.changes.invertedDesc, r = hn.empty(t.doc.length);
    else {
      let o = s.changes.filter(i);
      r = o.changes, a = o.filtered.mapDesc(o.changes).invertedDesc;
    }
    s = di.create(t, r, s.selection && s.selection.map(a), qe.mapEffects(s.effects, a), s.annotations, s.scrollIntoView);
  }
  let n = t.facet(j3);
  for (let r = n.length - 1; r >= 0; r--) {
    let a = n[r](s);
    a instanceof di ? s = a : Array.isArray(a) && a.length == 1 && a[0] instanceof di ? s = a[0] : s = ex(t, Sa(a), !1);
  }
  return s;
}
u(tC, "$g$1");
m(tC, "filterTransaction");
function iC(s) {
  let t = s.startState, i = t.facet(X3), n = s;
  for (let r = i.length - 1; r >= 0; r--) {
    let a = i[r](s);
    a && Object.keys(a).length && (n = J$(n, Qg(t, a, s.changes.newLength), !0));
  }
  return n == s ? s : di.create(t, s.changes, s.selection, n.effects, n.annotations, n.scrollIntoView);
}
u(iC, "vg$1");
m(iC, "extendTransaction");
const QL = [];
function Sa(s) {
  return s == null ? QL : Array.isArray(s) ? s : [s];
}
u(Sa, "Ri$1");
m(Sa, "asArray");
var ys = /* @__PURE__ */ function(s) {
  return s[s.Word = 0] = "Word", s[s.Space = 1] = "Space", s[s.Other = 2] = "Other", s;
}(ys || (ys = {}));
const TL = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let T0;
try {
  T0 = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function nC(s) {
  if (T0)
    return T0.test(s);
  for (let t = 0; t < s.length; t++) {
    let i = s[t];
    if (/\w/.test(i) || i > "" && (i.toUpperCase() != i.toLowerCase() || TL.test(i)))
      return !0;
  }
  return !1;
}
u(nC, "Zg$1");
m(nC, "hasWordChar");
function sC(s) {
  return (t) => {
    if (!/\S/.test(t))
      return ys.Space;
    if (nC(t))
      return ys.Word;
    for (let i = 0; i < s.length; i++)
      if (t.indexOf(s[i]) > -1)
        return ys.Word;
    return ys.Other;
  };
}
u(sC, "Wg$1");
m(sC, "makeCategorizer");
var Kt;
const rC = (Kt = class {
  constructor(t, i, n, r, a, o) {
    this.config = t, this.doc = i, this.selection = n, this.values = r, this.status = t.statusTemplate.slice(), this.computeSlot = a, o && (o._state = this);
    for (let l = 0; l < this.config.dynamicSlots.length; l++)
      lc(this, l << 1);
    this.computeSlot = null;
  }
  field(t, i = !0) {
    let n = this.config.address[t.id];
    if (n == null) {
      if (i)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return lc(this, n), Ky(this, n);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...t) {
    return ex(this, t, !0);
  }
  /**
  @internal
  */
  applyTransaction(t) {
    let i = this.config, { base: n, compartments: r } = i;
    for (let l of t.effects)
      l.is(V3.reconfigure) ? (i && (r = /* @__PURE__ */ new Map(), i.compartments.forEach((c, h) => r.set(h, c)), i = null), r.set(l.value.compartment, l.value.extension)) : l.is(qe.reconfigure) ? (i = null, n = l.value) : l.is(qe.appendConfig) && (i = null, n = Sa(n).concat(l.value));
    let a;
    i ? a = t.startState.values.slice() : (i = US.resolve(n, r, this), a = new Kt(i, this.doc, this.selection, i.dynamicSlots.map(() => null), (l, c) => c.reconfigure(l, this), null).values);
    let o = t.startState.facet(Q0) ? t.newSelection : t.newSelection.asSingle();
    new Kt(i, t.newDoc, o, a, (l, c) => c.update(l, t), t);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(t) {
    return typeof t == "string" && (t = this.toText(t)), this.changeByRange((i) => ({
      changes: { from: i.from, to: i.to, insert: t },
      range: J.cursor(i.from + t.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(t) {
    let i = this.selection, n = t(i.ranges[0]), r = this.changes(n.changes), a = [n.range], o = Sa(n.effects);
    for (let l = 1; l < i.ranges.length; l++) {
      let c = t(i.ranges[l]), h = this.changes(c.changes), d = h.map(r);
      for (let y = 0; y < l; y++)
        a[y] = a[y].map(d);
      let f = r.mapDesc(h, !0);
      a.push(c.range.map(f)), r = r.compose(d), o = qe.mapEffects(o, d).concat(qe.mapEffects(Sa(c.effects), f));
    }
    return {
      changes: r,
      selection: J.create(a, i.mainIndex),
      effects: o
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(t = []) {
    return t instanceof hn ? t : hn.of(t, this.doc.length, this.facet(Kt.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(t) {
    return Ie.of(t.split(this.facet(Kt.lineSeparator) || S0));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(t = 0, i = this.doc.length) {
    return this.doc.sliceString(t, i, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(t) {
    let i = this.config.address[t.id];
    return i == null ? t.default : (lc(this, i), Ky(this, i));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(t) {
    let i = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (t)
      for (let n in t) {
        let r = t[n];
        r instanceof As && this.config.address[r.id] != null && (i[n] = r.spec.toJSON(this.field(t[n]), this));
      }
    return i;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(t, i = {}, n) {
    if (!t || typeof t.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let r = [];
    if (n) {
      for (let a in n)
        if (Object.prototype.hasOwnProperty.call(t, a)) {
          let o = n[a], l = t[a];
          r.push(o.init((c) => o.spec.fromJSON(l, c)));
        }
    }
    return Kt.create({
      doc: t.doc,
      selection: J.fromJSON(t.selection),
      extensions: i.extensions ? r.concat([i.extensions]) : r
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(t = {}) {
    let i = US.resolve(t.extensions || [], /* @__PURE__ */ new Map()), n = t.doc instanceof Ie ? t.doc : Ie.of((t.doc || "").split(i.staticFacet(Kt.lineSeparator) || S0)), r = t.selection ? t.selection instanceof J ? t.selection : J.single(t.selection.anchor, t.selection.head) : J.single(0);
    return G$(r, n.length), i.staticFacet(Q0) || (r = r.asSingle()), new Kt(i, n, r, i.dynamicSlots.map(() => null), (a, o) => o.create(a), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(Kt.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(Kt.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(F3);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(t, ...i) {
    for (let n of this.facet(Kt.phrases))
      if (Object.prototype.hasOwnProperty.call(n, t)) {
        t = n[t];
        break;
      }
    return i.length && (t = t.replace(/\$(\$|\d*)/g, (n, r) => {
      if (r == "$")
        return "$";
      let a = +(r || 1);
      return !a || a > i.length ? n : i[a - 1];
    })), t;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(t, i, n = -1) {
    let r = [];
    for (let a of this.facet(U3))
      for (let o of a(this, i, n))
        Object.prototype.hasOwnProperty.call(o, t) && r.push(o[t]);
    return r;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(t) {
    return sC(this.languageDataAt("wordChars", t).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(t) {
    let { text: i, from: n, length: r } = this.doc.lineAt(t), a = this.charCategorizer(t), o = t - n, l = t - n;
    for (; o > 0; ) {
      let c = sn(i, o, !1);
      if (a(i.slice(c, o)) != ys.Word)
        break;
      o = c;
    }
    for (; l < r; ) {
      let c = sn(i, l);
      if (a(i.slice(l, c)) != ys.Word)
        break;
      l = c;
    }
    return o == l ? null : J.range(o + n, l + n);
  }
}, u(Kt, "xe"), Kt);
m(rC, "EditorState");
let kt = rC;
kt.allowMultipleSelections = Q0;
kt.tabSize = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => s.length ? s[0] : 4, "combine")
});
kt.lineSeparator = N3;
kt.readOnly = F3;
kt.phrases = /* @__PURE__ */ me.define({
  compare(s, t) {
    let i = Object.keys(s), n = Object.keys(t);
    return i.length == n.length && i.every((r) => s[r] == t[r]);
  }
});
kt.languageData = U3;
kt.changeFilter = B3;
kt.transactionFilter = j3;
kt.transactionExtender = X3;
V3.reconfigure = /* @__PURE__ */ qe.define();
function tx(s, t, i = {}) {
  let n = {};
  for (let r of s)
    for (let a of Object.keys(r)) {
      let o = r[a], l = n[a];
      if (l === void 0)
        n[a] = o;
      else if (!(l === o || o === void 0)) if (Object.hasOwnProperty.call(i, a))
        n[a] = i[a](l, o);
      else
        throw new Error("Config merge conflict for field " + a);
    }
  for (let r in t)
    n[r] === void 0 && (n[r] = t[r]);
  return n;
}
u(tx, "Hd$1");
m(tx, "combineConfig");
var Tc;
const aC = (Tc = class {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(t) {
    return this == t;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(t, i = t) {
    return M0.create(t, i, this);
  }
}, u(Tc, "Ih"), Tc);
m(aC, "RangeValue");
let wo = aC;
wo.prototype.startSide = wo.prototype.endSide = 0;
wo.prototype.point = !1;
wo.prototype.mapMode = hi.TrackDel;
var vw, Mc;
let M0 = (vw = (Mc = class {
  constructor(t, i, n) {
    this.from = t, this.to = i, this.value = n;
  }
  /**
  @internal
  */
  static create(t, i, n) {
    return new vw(t, i, n);
  }
}, u(Mc, "ei$1"), Mc), m(vw, "Range"), vw);
function Tg(s, t) {
  return s.from - t.from || s.value.startSide - t.value.startSide;
}
u(Tg, "al$1");
m(Tg, "cmpRange");
var Ia;
const oC = (Ia = class {
  constructor(t, i, n, r) {
    this.from = t, this.to = i, this.value = n, this.maxPoint = r;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(t, i, n, r = 0) {
    let a = n ? this.to : this.from;
    for (let o = r, l = a.length; ; ) {
      if (o == l)
        return o;
      let c = o + l >> 1, h = a[c] - t || (n ? this.value[c].endSide : this.value[c].startSide) - i;
      if (c == o)
        return h >= 0 ? o : l;
      h >= 0 ? l = c : o = c + 1;
    }
  }
  between(t, i, n, r) {
    for (let a = this.findIndex(i, -1e9, !0), o = this.findIndex(n, 1e9, !1, a); a < o; a++)
      if (r(this.from[a] + t, this.to[a] + t, this.value[a]) === !1)
        return !1;
  }
  map(t, i) {
    let n = [], r = [], a = [], o = -1, l = -1;
    for (let c = 0; c < this.value.length; c++) {
      let h = this.value[c], d = this.from[c] + t, f = this.to[c] + t, y, w;
      if (d == f) {
        let g = i.mapPos(d, h.startSide, h.mapMode);
        if (g == null || (y = w = g, h.startSide != h.endSide && (w = i.mapPos(d, h.endSide), w < y)))
          continue;
      } else if (y = i.mapPos(d, h.startSide), w = i.mapPos(f, h.endSide), y > w || y == w && h.startSide > 0 && h.endSide <= 0)
        continue;
      (w - y || h.endSide - h.startSide) < 0 || (o < 0 && (o = y), h.point && (l = Math.max(l, w - y)), n.push(h), r.push(y - o), a.push(w - o));
    }
    return { mapped: n.length ? new Ia(r, a, n, l) : null, pos: o };
  }
}, u(Ia, "Vs"), Ia);
m(oC, "Chunk");
let ML = oC;
var yi;
const lC = (yi = class {
  constructor(t, i, n, r) {
    this.chunkPos = t, this.chunk = i, this.nextLayer = n, this.maxPoint = r;
  }
  /**
  @internal
  */
  static create(t, i, n, r) {
    return new yi(t, i, n, r);
  }
  /**
  @internal
  */
  get length() {
    let t = this.chunk.length - 1;
    return t < 0 ? 0 : Math.max(this.chunkEnd(t), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let t = this.nextLayer.size;
    for (let i of this.chunk)
      t += i.value.length;
    return t;
  }
  /**
  @internal
  */
  chunkEnd(t) {
    return this.chunkPos[t] + this.chunk[t].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(t) {
    let { add: i = [], sort: n = !1, filterFrom: r = 0, filterTo: a = this.length } = t, o = t.filter;
    if (i.length == 0 && !o)
      return this;
    if (n && (i = i.slice().sort(Tg)), this.isEmpty)
      return i.length ? yi.of(i) : this;
    let l = new uC(this, null, -1).goto(0), c = 0, h = [], d = new Mg();
    for (; l.value || c < i.length; )
      if (c < i.length && (l.from - i[c].from || l.startSide - i[c].value.startSide) >= 0) {
        let f = i[c++];
        d.addInner(f.from, f.to, f.value) || h.push(f);
      } else l.rangeIndex == 1 && l.chunkIndex < this.chunk.length && (c == i.length || this.chunkEnd(l.chunkIndex) < i[c].from) && (!o || r > this.chunkEnd(l.chunkIndex) || a < this.chunkPos[l.chunkIndex]) && d.addChunk(this.chunkPos[l.chunkIndex], this.chunk[l.chunkIndex]) ? l.nextChunk() : ((!o || r > l.to || a < l.from || o(l.from, l.to, l.value)) && (d.addInner(l.from, l.to, l.value) || h.push(M0.create(l.from, l.to, l.value))), l.next());
    return d.finishInner(this.nextLayer.isEmpty && !h.length ? yi.empty : this.nextLayer.update({ add: h, filter: o, filterFrom: r, filterTo: a }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(t) {
    if (t.empty || this.isEmpty)
      return this;
    let i = [], n = [], r = -1;
    for (let o = 0; o < this.chunk.length; o++) {
      let l = this.chunkPos[o], c = this.chunk[o], h = t.touchesRange(l, l + c.length);
      if (h === !1)
        r = Math.max(r, c.maxPoint), i.push(c), n.push(t.mapPos(l));
      else if (h === !0) {
        let { mapped: d, pos: f } = c.map(l, t);
        d && (r = Math.max(r, d.maxPoint), i.push(d), n.push(f));
      }
    }
    let a = this.nextLayer.map(t);
    return i.length == 0 ? a : new yi(n, i, a || yi.empty, r);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(t, i, n) {
    if (!this.isEmpty) {
      for (let r = 0; r < this.chunk.length; r++) {
        let a = this.chunkPos[r], o = this.chunk[r];
        if (i >= a && t <= a + o.length && o.between(a, t - a, i - a, n) === !1)
          return;
      }
      this.nextLayer.between(t, i, n);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(t = 0) {
    return A0.from([this]).goto(t);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(t, i = 0) {
    return A0.from(t).goto(i);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(t, i, n, r, a = -1) {
    let o = t.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= a), l = i.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= a), c = R0(o, l, n), h = new jf(o, c, a), d = new jf(l, c, a);
    n.iterGaps((f, y, w) => E0(h, f, d, y, w, r)), n.empty && n.length == 0 && E0(h, 0, d, 0, 0, r);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(t, i, n = 0, r) {
    r == null && (r = 999999999);
    let a = t.filter((d) => !d.isEmpty && i.indexOf(d) < 0), o = i.filter((d) => !d.isEmpty && t.indexOf(d) < 0);
    if (a.length != o.length)
      return !1;
    if (!a.length)
      return !0;
    let l = R0(a, o), c = new jf(a, l, 0).goto(n), h = new jf(o, l, 0).goto(n);
    for (; ; ) {
      if (c.to != h.to || !Rg(c.active, h.active) || c.point && (!h.point || !c.point.eq(h.point)))
        return !1;
      if (c.to > r)
        return !0;
      c.next(), h.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(t, i, n, r, a = -1) {
    let o = new jf(t, null, a).goto(i), l = i, c = o.openStart;
    for (; ; ) {
      let h = Math.min(o.to, n);
      if (o.point) {
        let d = o.activeForPoint(o.to), f = o.pointFrom < i ? d.length + 1 : o.point.startSide < 0 ? d.length : Math.min(d.length, c);
        r.point(l, h, o.point, d, f, o.pointRank), c = Math.min(o.openEnd(h), d.length);
      } else h > l && (r.span(l, h, o.active, c), c = o.openEnd(h));
      if (o.to > n)
        return c + (o.point && o.to > n ? 1 : 0);
      l = o.to, o.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(t, i = !1) {
    let n = new Mg();
    for (let r of t instanceof M0 ? [t] : i ? cC(t) : t)
      n.add(r.from, r.to, r.value);
    return n.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(t) {
    if (!t.length)
      return yi.empty;
    let i = t[t.length - 1];
    for (let n = t.length - 2; n >= 0; n--)
      for (let r = t[n]; r != yi.empty; r = r.nextLayer)
        i = new yi(r.chunkPos, r.chunk, i, Math.max(r.maxPoint, i.maxPoint));
    return i;
  }
}, u(yi, "Ce"), yi);
m(lC, "RangeSet");
let ti = lC;
ti.empty = /* @__PURE__ */ new ti([], [], null, -1);
function cC(s) {
  if (s.length > 1)
    for (let t = s[0], i = 1; i < s.length; i++) {
      let n = s[i];
      if (Tg(t, n) > 0)
        return s.slice().sort(Tg);
      t = n;
    }
  return s;
}
u(cC, "Ug$1");
m(cC, "lazySort");
ti.empty.nextLayer = ti.empty;
var Wa;
const hC = (Wa = class {
  finishChunk(t) {
    this.chunks.push(new ML(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, t && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(t, i, n) {
    this.addInner(t, i, n) || (this.nextLayer || (this.nextLayer = new Wa())).add(t, i, n);
  }
  /**
  @internal
  */
  addInner(t, i, n) {
    let r = t - this.lastTo || n.startSide - this.last.endSide;
    if (r <= 0 && (t - this.lastFrom || n.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return r < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = t), this.from.push(t - this.chunkStart), this.to.push(i - this.chunkStart), this.last = n, this.lastFrom = t, this.lastTo = i, this.value.push(n), n.point && (this.maxPoint = Math.max(this.maxPoint, i - t)), !0);
  }
  /**
  @internal
  */
  addChunk(t, i) {
    if ((t - this.lastTo || i.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, i.maxPoint), this.chunks.push(i), this.chunkPos.push(t);
    let n = i.value.length - 1;
    return this.last = i.value[n], this.lastFrom = i.from[n] + t, this.lastTo = i.to[n] + t, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(ti.empty);
  }
  /**
  @internal
  */
  finishInner(t) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return t;
    let i = ti.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(t) : t, this.setMaxPoint);
    return this.from = null, i;
  }
}, u(Wa, "Xs"), Wa);
m(hC, "RangeSetBuilder");
let Mg = hC;
function R0(s, t, i) {
  let n = /* @__PURE__ */ new Map();
  for (let a of s)
    for (let o = 0; o < a.chunk.length; o++)
      a.chunk[o].maxPoint <= 0 && n.set(a.chunk[o], a.chunkPos[o]);
  let r = /* @__PURE__ */ new Set();
  for (let a of t)
    for (let o = 0; o < a.chunk.length; o++) {
      let l = n.get(a.chunk[o]);
      l != null && (i ? i.mapPos(l) : l) == a.chunkPos[o] && !(i != null && i.touchesRange(l, l + a.chunk[o].length)) && r.add(a.chunk[o]);
    }
  return r;
}
u(R0, "Wc$1");
m(R0, "findSharedChunks");
var Rc;
const dC = (Rc = class {
  constructor(t, i, n, r = 0) {
    this.layer = t, this.skip = i, this.minPoint = n, this.rank = r;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(t, i = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(t, i, !1), this;
  }
  gotoInner(t, i, n) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let r = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(r) || this.layer.chunkEnd(this.chunkIndex) < t || r.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, n = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let r = this.layer.chunk[this.chunkIndex].findIndex(t - this.layer.chunkPos[this.chunkIndex], i, !0);
      (!n || this.rangeIndex < r) && this.setRangeIndex(r);
    }
    this.next();
  }
  forward(t, i) {
    (this.to - t || this.endSide - i) < 0 && this.gotoInner(t, i, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let t = this.layer.chunkPos[this.chunkIndex], i = this.layer.chunk[this.chunkIndex], n = t + i.from[this.rangeIndex];
        if (this.from = n, this.to = t + i.to[this.rangeIndex], this.value = i.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(t) {
    if (t == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = t;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(t) {
    return this.from - t.from || this.startSide - t.startSide || this.rank - t.rank || this.to - t.to || this.endSide - t.endSide;
  }
}, u(Rc, "jh"), Rc);
m(dC, "LayerCursor");
let uC = dC;
var Va;
const pC = (Va = class {
  constructor(t) {
    this.heap = t;
  }
  static from(t, i = null, n = -1) {
    let r = [];
    for (let a = 0; a < t.length; a++)
      for (let o = t[a]; !o.isEmpty; o = o.nextLayer)
        o.maxPoint >= n && r.push(new uC(o, i, n, a));
    return r.length == 1 ? r[0] : new Va(r);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(t, i = -1e9) {
    for (let n of this.heap)
      n.goto(t, i);
    for (let n = this.heap.length >> 1; n >= 0; n--)
      Zw(this.heap, n);
    return this.next(), this;
  }
  forward(t, i) {
    for (let n of this.heap)
      n.forward(t, i);
    for (let n = this.heap.length >> 1; n >= 0; n--)
      Zw(this.heap, n);
    (this.to - t || this.value.endSide - i) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let t = this.heap[0];
      this.from = t.from, this.to = t.to, this.value = t.value, this.rank = t.rank, t.value && t.next(), Zw(this.heap, 0);
    }
  }
}, u(Va, "Is"), Va);
m(pC, "HeapCursor");
let A0 = pC;
function Zw(s, t) {
  for (let i = s[t]; ; ) {
    let n = (t << 1) + 1;
    if (n >= s.length)
      break;
    let r = s[n];
    if (n + 1 < s.length && r.compare(s[n + 1]) >= 0 && (r = s[n + 1], n++), i.compare(r) < 0)
      break;
    s[n] = i, s[t] = r, t = n;
  }
}
u(Zw, "wo$1");
m(Zw, "heapBubble");
var Ac;
const fC = (Ac = class {
  constructor(t, i, n) {
    this.minPoint = n, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = A0.from(t, i, n);
  }
  goto(t, i = -1e9) {
    return this.cursor.goto(t, i), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = t, this.endSide = i, this.openStart = -1, this.next(), this;
  }
  forward(t, i) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - t || this.active[this.minActive].endSide - i) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(t, i);
  }
  removeActive(t) {
    yy(this.active, t), yy(this.activeTo, t), yy(this.activeRank, t), this.minActive = z0(this.active, this.activeTo);
  }
  addActive(t) {
    let i = 0, { value: n, to: r, rank: a } = this.cursor;
    for (; i < this.activeRank.length && (a - this.activeRank[i] || r - this.activeTo[i]) > 0; )
      i++;
    my(this.active, i, n), my(this.activeTo, i, r), my(this.activeRank, i, a), t && my(t, i, this.cursor.from), this.minActive = z0(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let t = this.to, i = this.point;
    this.point = null;
    let n = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let r = this.minActive;
      if (r > -1 && (this.activeTo[r] - this.cursor.from || this.active[r].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[r] > t) {
          this.to = this.activeTo[r], this.endSide = this.active[r].endSide;
          break;
        }
        this.removeActive(r), n && yy(n, r);
      } else if (this.cursor.value)
        if (this.cursor.from > t) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let a = this.cursor.value;
          if (!a.point)
            this.addActive(n), this.cursor.next();
          else if (i && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = a, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = a.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (n) {
      this.openStart = 0;
      for (let r = n.length - 1; r >= 0 && n[r] < t; r--)
        this.openStart++;
    }
  }
  activeForPoint(t) {
    if (!this.active.length)
      return this.active;
    let i = [];
    for (let n = this.active.length - 1; n >= 0 && !(this.activeRank[n] < this.pointRank); n--)
      (this.activeTo[n] > t || this.activeTo[n] == t && this.active[n].endSide >= this.point.endSide) && i.push(this.active[n]);
    return i.reverse();
  }
  openEnd(t) {
    let i = 0;
    for (let n = this.activeTo.length - 1; n >= 0 && this.activeTo[n] > t; n--)
      i++;
    return i;
  }
}, u(Ac, "qh"), Ac);
m(fC, "SpanCursor");
let jf = fC;
function E0(s, t, i, n, r, a) {
  s.goto(t), i.goto(n);
  let o = n + r, l = n, c = n - t;
  for (; ; ) {
    let h = s.to + c - i.to, d = h || s.endSide - i.endSide, f = d < 0 ? s.to + c : i.to, y = Math.min(f, o);
    if (s.point || i.point ? s.point && i.point && (s.point == i.point || s.point.eq(i.point)) && Rg(s.activeForPoint(s.to), i.activeForPoint(i.to)) || a.comparePoint(l, y, s.point, i.point) : y > l && !Rg(s.active, i.active) && a.compareRange(l, y, s.active, i.active), f > o)
      break;
    (h || s.openEnd != i.openEnd) && a.boundChange && a.boundChange(f), l = f, d <= 0 && s.next(), d >= 0 && i.next();
  }
}
u(E0, "Uc$1");
m(E0, "compare");
function Rg(s, t) {
  if (s.length != t.length)
    return !1;
  for (let i = 0; i < s.length; i++)
    if (s[i] != t[i] && !s[i].eq(t[i]))
      return !1;
  return !0;
}
u(Rg, "fl$1");
m(Rg, "sameValues");
function yy(s, t) {
  for (let i = t, n = s.length - 1; i < n; i++)
    s[i] = s[i + 1];
  s.pop();
}
u(yy, "wn$1");
m(yy, "remove");
function my(s, t, i) {
  for (let n = s.length - 1; n >= t; n--)
    s[n + 1] = s[n];
  s[t] = i;
}
u(my, "xn$1");
m(my, "insert");
function z0(s, t) {
  let i = -1, n = 1e9;
  for (let r = 0; r < t.length; r++)
    (t[r] - n || s[r].endSide - s[i].endSide) < 0 && (i = r, n = t[r]);
  return i;
}
u(z0, "Lc$1");
m(z0, "findMinIndex");
function xr(s, t, i = s.length) {
  let n = 0;
  for (let r = 0; r < i && r < s.length; )
    s.charCodeAt(r) == 9 ? (n += t - n % t, r++) : (n++, r = sn(s, r));
  return n;
}
u(xr, "ut$1");
m(xr, "countColumn");
function yC(s, t, i, n) {
  for (let r = 0, a = 0; ; ) {
    if (a >= t)
      return r;
    if (r == s.length)
      break;
    a += s.charCodeAt(r) == 9 ? i - a % i : 1, r = sn(s, r);
  }
  return n === !0 ? -1 : s.length;
}
u(yC, "Lg$1");
m(yC, "findColumn");
const _0 = "ͼ", NS = typeof Symbol > "u" ? "__" + _0 : Symbol.for(_0), L0 = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), BS = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
var Ec;
const mC = (Ec = class {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(t, i) {
    this.rules = [];
    let { finish: n } = i || {};
    function r(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    u(r, "n"), m(r, "splitSelector");
    function a(o, l, c, h) {
      let d = [], f = /^@(\w+)\b/.exec(o[0]), y = f && f[1] == "keyframes";
      if (f && l == null) return c.push(o[0] + ";");
      for (let w in l) {
        let g = l[w];
        if (/&/.test(w))
          a(
            w.split(/,\s*/).map((b) => o.map((k) => b.replace(/&/, k))).reduce((b, k) => b.concat(k)),
            g,
            c
          );
        else if (g && typeof g == "object") {
          if (!f) throw new RangeError("The value of a property (" + w + ") should be a primitive value.");
          a(r(w), g, d, y);
        } else g != null && d.push(w.replace(/_.*/, "").replace(/[A-Z]/g, (b) => "-" + b.toLowerCase()) + ": " + g + ";");
      }
      (d.length || y) && c.push((n && !f && !h ? o.map(n) : o).join(", ") + " {" + d.join(" ") + "}");
    }
    u(a, "s"), m(a, "render");
    for (let o in t) a(r(o), t[o], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let t = BS[NS] || 1;
    return BS[NS] = t + 1, _0 + t.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(t, i, n) {
    let r = t[L0], a = n && n.nonce;
    r ? a && r.setNonce(a) : r = new RL(t, a), r.mount(Array.isArray(i) ? i : [i], t);
  }
}, u(Ec, "zh"), Ec);
m(mC, "StyleModule");
let kr = mC, jS = /* @__PURE__ */ new Map();
var zc;
const wC = (zc = class {
  constructor(t, i) {
    let n = t.ownerDocument || t, r = n.defaultView;
    if (!t.head && t.adoptedStyleSheets && r.CSSStyleSheet) {
      let a = jS.get(n);
      if (a) return t[L0] = a;
      this.sheet = new r.CSSStyleSheet(), jS.set(n, this);
    } else
      this.styleTag = n.createElement("style"), i && this.styleTag.setAttribute("nonce", i);
    this.modules = [], t[L0] = this;
  }
  mount(t, i) {
    let n = this.sheet, r = 0, a = 0;
    for (let o = 0; o < t.length; o++) {
      let l = t[o], c = this.modules.indexOf(l);
      if (c < a && c > -1 && (this.modules.splice(c, 1), a--, c = -1), c == -1) {
        if (this.modules.splice(a++, 0, l), n) for (let h = 0; h < l.rules.length; h++)
          n.insertRule(l.rules[h], r++);
      } else {
        for (; a < c; ) r += this.modules[a++].rules.length;
        r += l.rules.length, a++;
      }
    }
    if (n)
      i.adoptedStyleSheets.indexOf(this.sheet) < 0 && (i.adoptedStyleSheets = [this.sheet, ...i.adoptedStyleSheets]);
    else {
      let o = "";
      for (let c = 0; c < this.modules.length; c++)
        o += this.modules[c].getRules() + `
`;
      this.styleTag.textContent = o;
      let l = i.head || i;
      this.styleTag.parentNode != l && l.insertBefore(this.styleTag, l.firstChild);
    }
  }
  setNonce(t) {
    this.styleTag && this.styleTag.getAttribute("nonce") != t && this.styleTag.setAttribute("nonce", t);
  }
}, u(zc, "Dh"), zc);
m(wC, "StyleSet");
let RL = wC;
var Sr = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Jy = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, AL = typeof navigator < "u" && /Mac/.test(navigator.platform), EL = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ut = 0; Ut < 10; Ut++) Sr[48 + Ut] = Sr[96 + Ut] = String(Ut);
for (var Ut = 1; Ut <= 24; Ut++) Sr[Ut + 111] = "F" + Ut;
for (var Ut = 65; Ut <= 90; Ut++)
  Sr[Ut] = String.fromCharCode(Ut + 32), Jy[Ut] = String.fromCharCode(Ut);
for (var zv in Sr) Jy.hasOwnProperty(zv) || (Jy[zv] = Sr[zv]);
function gC(s) {
  var t = AL && s.metaKey && s.shiftKey && !s.ctrlKey && !s.altKey || EL && s.shiftKey && s.key && s.key.length == 1 || s.key == "Unidentified", i = !t && s.key || (s.shiftKey ? Jy : Sr)[s.keyCode] || s.key || "Unidentified";
  return i == "Esc" && (i = "Escape"), i == "Del" && (i = "Delete"), i == "Left" && (i = "ArrowLeft"), i == "Up" && (i = "ArrowUp"), i == "Right" && (i = "ArrowRight"), i == "Down" && (i = "ArrowDown"), i;
}
u(gC, "Yg$1");
m(gC, "keyName");
function tf(s) {
  let t;
  return s.nodeType == 11 ? t = s.getSelection ? s : s.ownerDocument : t = s, t.getSelection();
}
u(tf, "Gr$1");
m(tf, "getSelection");
function Ag(s, t) {
  return t ? s == t || s.contains(t.nodeType != 1 ? t.parentNode : t) : !1;
}
u(Ag, "Ol$1");
m(Ag, "contains");
function Zy(s, t) {
  if (!t.anchorNode)
    return !1;
  try {
    return Ag(s, t.anchorNode);
  } catch {
    return !1;
  }
}
u(Zy, "In$1");
m(Zy, "hasSelection");
function go(s) {
  return s.nodeType == 3 ? Cr(s, 0, s.nodeValue.length).getClientRects() : s.nodeType == 1 ? s.getClientRects() : [];
}
u(go, "Ei$1");
m(go, "clientRectsFor");
function cc(s, t, i, n) {
  return i ? I0(s, t, i, n, -1) || I0(s, t, i, n, 1) : !1;
}
u(cc, "gr$1");
m(cc, "isEquivalentPosition");
function Pr(s) {
  for (var t = 0; ; t++)
    if (s = s.previousSibling, !s)
      return t;
}
u(Pr, "ii$1");
m(Pr, "domIndex");
function em(s) {
  return s.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(s.nodeName);
}
u(em, "ts$1");
m(em, "isBlockElement");
function I0(s, t, i, n, r) {
  for (; ; ) {
    if (s == i && t == n)
      return !0;
    if (t == (r < 0 ? 0 : dn(s))) {
      if (s.nodeName == "DIV")
        return !1;
      let a = s.parentNode;
      if (!a || a.nodeType != 1)
        return !1;
      t = Pr(s) + (r < 0 ? 0 : 1), s = a;
    } else if (s.nodeType == 1) {
      if (s = s.childNodes[t + (r < 0 ? -1 : 0)], s.nodeType == 1 && s.contentEditable == "false")
        return !1;
      t = r < 0 ? dn(s) : 0;
    } else
      return !1;
  }
}
u(I0, "Cc");
m(I0, "scanFor");
function dn(s) {
  return s.nodeType == 3 ? s.nodeValue.length : s.childNodes.length;
}
u(dn, "rt$2");
m(dn, "maxOffset");
function Af(s, t) {
  let i = t ? s.left : s.right;
  return { left: i, right: i, top: s.top, bottom: s.bottom };
}
u(Af, "pn$1");
m(Af, "flattenRect");
function vC(s) {
  let t = s.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: s.innerWidth,
    top: 0,
    bottom: s.innerHeight
  };
}
u(vC, "Cg$1");
m(vC, "windowRect");
function ix(s, t) {
  let i = t.width / s.offsetWidth, n = t.height / s.offsetHeight;
  return (i > 0.995 && i < 1.005 || !isFinite(i) || Math.abs(t.width - s.offsetWidth) < 1) && (i = 1), (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(t.height - s.offsetHeight) < 1) && (n = 1), { scaleX: i, scaleY: n };
}
u(ix, "Kd$1");
m(ix, "getScale");
function OC(s, t, i, n, r, a, o, l) {
  let c = s.ownerDocument, h = c.defaultView || window;
  for (let d = s, f = !1; d && !f; )
    if (d.nodeType == 1) {
      let y, w = d == c.body, g = 1, b = 1;
      if (w)
        y = vC(h);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(d).position) && (f = !0), d.scrollHeight <= d.clientHeight && d.scrollWidth <= d.clientWidth) {
          d = d.assignedSlot || d.parentNode;
          continue;
        }
        let C = d.getBoundingClientRect();
        ({ scaleX: g, scaleY: b } = ix(d, C)), y = {
          left: C.left,
          right: C.left + d.clientWidth * g,
          top: C.top,
          bottom: C.top + d.clientHeight * b
        };
      }
      let k = 0, $ = 0;
      if (r == "nearest")
        t.top < y.top ? ($ = -(y.top - t.top + o), i > 0 && t.bottom > y.bottom + $ && ($ = t.bottom - y.bottom + $ + o)) : t.bottom > y.bottom && ($ = t.bottom - y.bottom + o, i < 0 && t.top - $ < y.top && ($ = -(y.top + $ - t.top + o)));
      else {
        let C = t.bottom - t.top, E = y.bottom - y.top;
        $ = (r == "center" && C <= E ? t.top + C / 2 - E / 2 : r == "start" || r == "center" && i < 0 ? t.top - o : t.bottom - E + o) - y.top;
      }
      if (n == "nearest" ? t.left < y.left ? (k = -(y.left - t.left + a), i > 0 && t.right > y.right + k && (k = t.right - y.right + k + a)) : t.right > y.right && (k = t.right - y.right + a, i < 0 && t.left < y.left + k && (k = -(y.left + k - t.left + a))) : k = (n == "center" ? t.left + (t.right - t.left) / 2 - (y.right - y.left) / 2 : n == "start" == l ? t.left - a : t.right - (y.right - y.left) + a) - y.left, k || $)
        if (w)
          h.scrollBy(k, $);
        else {
          let C = 0, E = 0;
          if ($) {
            let A = d.scrollTop;
            d.scrollTop += $ / b, E = (d.scrollTop - A) * b;
          }
          if (k) {
            let A = d.scrollLeft;
            d.scrollLeft += k / g, C = (d.scrollLeft - A) * g;
          }
          t = {
            left: t.left - C,
            top: t.top - E,
            right: t.right - C,
            bottom: t.bottom - E
          }, C && Math.abs(C - k) < 1 && (n = "nearest"), E && Math.abs(E - $) < 1 && (r = "nearest");
        }
      if (w)
        break;
      d = d.assignedSlot || d.parentNode;
    } else if (d.nodeType == 11)
      d = d.host;
    else
      break;
}
u(OC, "Eg$1");
m(OC, "scrollRectIntoView");
function bC(s) {
  let t = s.ownerDocument, i, n;
  for (let r = s.parentNode; r && !(r == t.body || i && n); )
    if (r.nodeType == 1)
      !n && r.scrollHeight > r.clientHeight && (n = r), !i && r.scrollWidth > r.clientWidth && (i = r), r = r.assignedSlot || r.parentNode;
    else if (r.nodeType == 11)
      r = r.host;
    else
      break;
  return { x: i, y: n };
}
u(bC, "Vg$1");
m(bC, "scrollableParents");
var _c;
const $C = (_c = class {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(t) {
    return this.anchorNode == t.anchorNode && this.anchorOffset == t.anchorOffset && this.focusNode == t.focusNode && this.focusOffset == t.focusOffset;
  }
  setRange(t) {
    let { anchorNode: i, focusNode: n } = t;
    this.set(i, Math.min(t.anchorOffset, i ? dn(i) : 0), n, Math.min(t.focusOffset, n ? dn(n) : 0));
  }
  set(t, i, n, r) {
    this.anchorNode = t, this.anchorOffset = i, this.focusNode = n, this.focusOffset = r;
  }
}, u(_c, "Bh"), _c);
m($C, "DOMSelectionState");
let zL = $C, Tl = null;
function nx(s) {
  if (s.setActive)
    return s.setActive();
  if (Tl)
    return s.focus(Tl);
  let t = [];
  for (let i = s; i && (t.push(i, i.scrollTop, i.scrollLeft), i != i.ownerDocument); i = i.parentNode)
    ;
  if (s.focus(Tl == null ? {
    get preventScroll() {
      return Tl = { preventScroll: !0 }, !0;
    }
  } : void 0), !Tl) {
    Tl = !1;
    for (let i = 0; i < t.length; ) {
      let n = t[i++], r = t[i++], a = t[i++];
      n.scrollTop != r && (n.scrollTop = r), n.scrollLeft != a && (n.scrollLeft = a);
    }
  }
}
u(nx, "Jd$1");
m(nx, "focusPreventScroll");
let XS;
function Cr(s, t, i = t) {
  let n = XS || (XS = document.createRange());
  return n.setEnd(s, i), n.setStart(s, t), n;
}
u(Cr, "ri$1");
m(Cr, "textRange");
function Pa(s, t, i, n) {
  let r = { key: t, code: t, keyCode: i, which: i, cancelable: !0 };
  n && ({ altKey: r.altKey, ctrlKey: r.ctrlKey, shiftKey: r.shiftKey, metaKey: r.metaKey } = n);
  let a = new KeyboardEvent("keydown", r);
  a.synthetic = !0, s.dispatchEvent(a);
  let o = new KeyboardEvent("keyup", r);
  return o.synthetic = !0, s.dispatchEvent(o), a.defaultPrevented || o.defaultPrevented;
}
u(Pa, "$i$1");
m(Pa, "dispatchKey");
function xC(s) {
  for (; s; ) {
    if (s && (s.nodeType == 9 || s.nodeType == 11 && s.host))
      return s;
    s = s.assignedSlot || s.parentNode;
  }
  return null;
}
u(xC, "Xg$1");
m(xC, "getRoot");
function sx(s) {
  for (; s.attributes.length; )
    s.removeAttributeNode(s.attributes[0]);
}
u(sx, "eO");
m(sx, "clearAttributes");
function kC(s, t) {
  let i = t.focusNode, n = t.focusOffset;
  if (!i || t.anchorNode != i || t.anchorOffset != n)
    return !1;
  for (n = Math.min(n, dn(i)); ; )
    if (n) {
      if (i.nodeType != 1)
        return !1;
      let r = i.childNodes[n - 1];
      r.contentEditable == "false" ? n-- : (i = r, n = dn(i));
    } else {
      if (i == s)
        return !0;
      n = Pr(i), i = i.parentNode;
    }
}
u(kC, "Ig$1");
m(kC, "atElementStart");
function rx(s) {
  return s.scrollTop > Math.max(1, s.scrollHeight - s.clientHeight - 4);
}
u(rx, "tO");
m(rx, "isScrolledToBottom");
function ax(s, t) {
  for (let i = s, n = t; ; ) {
    if (i.nodeType == 3 && n > 0)
      return { node: i, offset: n };
    if (i.nodeType == 1 && n > 0) {
      if (i.contentEditable == "false")
        return null;
      i = i.childNodes[n - 1], n = dn(i);
    } else if (i.parentNode && !em(i))
      n = Pr(i), i = i.parentNode;
    else
      return null;
  }
}
u(ax, "iO");
m(ax, "textNodeBefore");
function ox(s, t) {
  for (let i = s, n = t; ; ) {
    if (i.nodeType == 3 && n < i.nodeValue.length)
      return { node: i, offset: n };
    if (i.nodeType == 1 && n < i.childNodes.length) {
      if (i.contentEditable == "false")
        return null;
      i = i.childNodes[n], n = 0;
    } else if (i.parentNode && !em(i))
      n = Pr(i) + 1, i = i.parentNode;
    else
      return null;
  }
}
u(ox, "rO");
m(ox, "textNodeAfter");
var sr;
const SC = (sr = class {
  constructor(t, i, n = !0) {
    this.node = t, this.offset = i, this.precise = n;
  }
  static before(t, i) {
    return new sr(t.parentNode, Pr(t), i);
  }
  static after(t, i) {
    return new sr(t.parentNode, Pr(t) + 1, i);
  }
}, u(sr, "$r"), sr);
m(SC, "DOMPos");
let Ri = SC;
const lx = [];
var rr;
const PC = (rr = class {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(t) {
    let i = this.posAtStart;
    for (let n of this.children) {
      if (n == t)
        return i;
      i += n.length + n.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(t) {
    return this.posBefore(t) + t.length;
  }
  sync(t, i) {
    if (this.flags & 2) {
      let n = this.dom, r = null, a;
      for (let o of this.children) {
        if (o.flags & 7) {
          if (!o.dom && (a = r ? r.nextSibling : n.firstChild)) {
            let l = rr.get(a);
            (!l || !l.parent && l.canReuseDOM(o)) && o.reuseDOM(a);
          }
          o.sync(t, i), o.flags &= -8;
        }
        if (a = r ? r.nextSibling : n.firstChild, i && !i.written && i.node == n && a != o.dom && (i.written = !0), o.dom.parentNode == n)
          for (; a && a != o.dom; )
            a = W0(a);
        else
          n.insertBefore(o.dom, a);
        r = o.dom;
      }
      for (a = r ? r.nextSibling : n.firstChild, a && i && i.node == n && (i.written = !0); a; )
        a = W0(a);
    } else if (this.flags & 1)
      for (let n of this.children)
        n.flags & 7 && (n.sync(t, i), n.flags &= -8);
  }
  reuseDOM(t) {
  }
  localPosFromDOM(t, i) {
    let n;
    if (t == this.dom)
      n = this.dom.childNodes[i];
    else {
      let r = dn(t) == 0 ? 0 : i == 0 ? -1 : 1;
      for (; ; ) {
        let a = t.parentNode;
        if (a == this.dom)
          break;
        r == 0 && a.firstChild != a.lastChild && (t == a.firstChild ? r = -1 : r = 1), t = a;
      }
      r < 0 ? n = t : n = t.nextSibling;
    }
    if (n == this.dom.firstChild)
      return 0;
    for (; n && !rr.get(n); )
      n = n.nextSibling;
    if (!n)
      return this.length;
    for (let r = 0, a = 0; ; r++) {
      let o = this.children[r];
      if (o.dom == n)
        return a;
      a += o.length + o.breakAfter;
    }
  }
  domBoundsAround(t, i, n = 0) {
    let r = -1, a = -1, o = -1, l = -1;
    for (let c = 0, h = n, d = n; c < this.children.length; c++) {
      let f = this.children[c], y = h + f.length;
      if (h < t && y > i)
        return f.domBoundsAround(t, i, h);
      if (y >= t && r == -1 && (r = c, a = h), h > i && f.dom.parentNode == this.dom) {
        o = c, l = d;
        break;
      }
      d = y, h = y + f.breakAfter;
    }
    return {
      from: a,
      to: l < 0 ? n + this.length : l,
      startDOM: (r ? this.children[r - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
    };
  }
  markDirty(t = !1) {
    this.flags |= 2, this.markParentsDirty(t);
  }
  markParentsDirty(t) {
    for (let i = this.parent; i; i = i.parent) {
      if (t && (i.flags |= 2), i.flags & 1)
        return;
      i.flags |= 1, t = !1;
    }
  }
  setParent(t) {
    this.parent != t && (this.parent = t, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(t) {
    this.dom != t && (this.dom && (this.dom.cmView = null), this.dom = t, t.cmView = this);
  }
  get rootView() {
    for (let t = this; ; ) {
      let i = t.parent;
      if (!i)
        return t;
      t = i;
    }
  }
  replaceChildren(t, i, n = lx) {
    this.markDirty();
    for (let r = t; r < i; r++) {
      let a = this.children[r];
      a.parent == this && n.indexOf(a) < 0 && a.destroy();
    }
    n.length < 250 ? this.children.splice(t, i - t, ...n) : this.children = [].concat(this.children.slice(0, t), n, this.children.slice(i));
    for (let r = 0; r < n.length; r++)
      n[r].setParent(this);
  }
  ignoreMutation(t) {
    return !1;
  }
  ignoreEvent(t) {
    return !1;
  }
  childCursor(t = this.length) {
    return new QC(this.children, t, this.children.length);
  }
  childPos(t, i = 1) {
    return this.childCursor().findPos(t, i);
  }
  toString() {
    let t = this.constructor.name.replace("View", "");
    return t + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (t == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(t) {
    return t.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(t, i, n, r, a, o) {
    return !1;
  }
  become(t) {
    return !1;
  }
  canReuseDOM(t) {
    return t.constructor == this.constructor && !((this.flags | t.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let t of this.children)
      t.parent == this && t.destroy();
    this.parent = null;
  }
}, u(rr, "vr"), rr);
m(PC, "ContentView");
let Ge = PC;
Ge.prototype.breakAfter = 0;
function W0(s) {
  let t = s.nextSibling;
  return s.parentNode.removeChild(s), t;
}
u(W0, "Vc$1");
m(W0, "rm$1");
var Lc;
const CC = (Lc = class {
  constructor(t, i, n) {
    this.children = t, this.pos = i, this.i = n, this.off = 0;
  }
  findPos(t, i = 1) {
    for (; ; ) {
      if (t > this.pos || t == this.pos && (i > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = t - this.pos, this;
      let n = this.children[--this.i];
      this.pos -= n.length + n.breakAfter;
    }
  }
}, u(Lc, "Nh"), Lc);
m(CC, "ChildCursor");
let QC = CC;
function cx(s, t, i, n, r, a, o, l, c) {
  let { children: h } = s, d = h.length ? h[t] : null, f = a.length ? a[a.length - 1] : null, y = f ? f.breakAfter : o;
  if (!(t == n && d && !o && !y && a.length < 2 && d.merge(i, r, a.length ? f : null, i == 0, l, c))) {
    if (n < h.length) {
      let w = h[n];
      w && (r < w.length || w.breakAfter && f != null && f.breakAfter) ? (t == n && (w = w.split(r), r = 0), !y && f && w.merge(0, r, f, !0, 0, c) ? a[a.length - 1] = w : ((r || w.children.length && !w.children[0].length) && w.merge(0, r, null, !1, 0, c), a.push(w))) : w != null && w.breakAfter && (f ? f.breakAfter = 1 : o = 1), n++;
    }
    for (d && (d.breakAfter = o, i > 0 && (!o && a.length && d.merge(i, d.length, a[0], !1, l, 0) ? d.breakAfter = a.shift().breakAfter : (i < d.length || d.children.length && d.children[d.children.length - 1].length == 0) && d.merge(i, d.length, null, !1, l, 0), t++)); t < n && a.length; )
      if (h[n - 1].become(a[a.length - 1]))
        n--, a.pop(), c = a.length ? 0 : l;
      else if (h[t].become(a[0]))
        t++, a.shift(), l = a.length ? 0 : c;
      else
        break;
    !a.length && t && n < h.length && !h[t - 1].breakAfter && h[n].merge(0, 0, h[t - 1], !1, l, c) && t--, (t < n || a.length) && s.replaceChildren(t, n, a);
  }
}
u(cx, "nO");
m(cx, "replaceRange");
function hx(s, t, i, n, r, a) {
  let o = s.childCursor(), { i: l, off: c } = o.findPos(i, 1), { i: h, off: d } = o.findPos(t, -1), f = t - i;
  for (let y of n)
    f += y.length;
  s.length += f, cx(s, h, d, l, c, n, 0, r, a);
}
u(hx, "sO");
m(hx, "mergeChildrenInto");
let mi = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, V0 = typeof document < "u" ? document : { documentElement: { style: {} } };
const Z0 = /* @__PURE__ */ /Edge\/(\d+)/.exec(mi.userAgent), TC = /* @__PURE__ */ /MSIE \d/.test(mi.userAgent), D0 = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(mi.userAgent), I1 = !!(TC || D0 || Z0), FS = !I1 && /* @__PURE__ */ /gecko\/(\d+)/i.test(mi.userAgent), _v = !I1 && /* @__PURE__ */ /Chrome\/(\d+)/.exec(mi.userAgent), HS = "webkitFontSmoothing" in V0.documentElement.style, MC = !I1 && /* @__PURE__ */ /Apple Computer/.test(mi.vendor), YS = MC && (/* @__PURE__ */ /Mobile\/\w+/.test(mi.userAgent) || mi.maxTouchPoints > 2);
var te = {
  mac: YS || /* @__PURE__ */ /Mac/.test(mi.platform),
  windows: /* @__PURE__ */ /Win/.test(mi.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(mi.platform),
  ie: I1,
  ie_version: TC ? V0.documentMode || 6 : D0 ? +D0[1] : Z0 ? +Z0[1] : 0,
  gecko: FS,
  gecko_version: FS ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(mi.userAgent) || [0, 0])[1] : 0,
  chrome: !!_v,
  chrome_version: _v ? +_v[1] : 0,
  ios: YS,
  android: /* @__PURE__ */ /Android\b/.test(mi.userAgent),
  webkit: HS,
  safari: MC,
  webkit_version: HS ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(mi.userAgent) || [0, 0])[1] : 0,
  tabSize: V0.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const _L = 256;
var ar;
const RC = (ar = class extends Ge {
  constructor(t) {
    super(), this.text = t;
  }
  get length() {
    return this.text.length;
  }
  createDOM(t) {
    this.setDOM(t || document.createTextNode(this.text));
  }
  sync(t, i) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (i && i.node == this.dom && (i.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(t) {
    t.nodeType == 3 && this.createDOM(t);
  }
  merge(t, i, n) {
    return this.flags & 8 || n && (!(n instanceof ar) || this.length - (i - t) + n.length > _L || n.flags & 8) ? !1 : (this.text = this.text.slice(0, t) + (n ? n.text : "") + this.text.slice(i), this.markDirty(), !0);
  }
  split(t) {
    let i = new ar(this.text.slice(t));
    return this.text = this.text.slice(0, t), this.markDirty(), i.flags |= this.flags & 8, i;
  }
  localPosFromDOM(t, i) {
    return t == this.dom ? i : i ? this.text.length : 0;
  }
  domAtPos(t) {
    return new Ri(this.dom, t);
  }
  domBoundsAround(t, i, n) {
    return { from: n, to: n + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(t, i) {
    return EC(this.dom, t, i);
  }
}, u(ar, "Tr"), ar);
m(RC, "TextView");
let Qr = RC;
var or;
const AC = (or = class extends Ge {
  constructor(t, i = [], n = 0) {
    super(), this.mark = t, this.children = i, this.length = n;
    for (let r of i)
      r.setParent(this);
  }
  setAttrs(t) {
    if (sx(t), this.mark.class && (t.className = this.mark.class), this.mark.attrs)
      for (let i in this.mark.attrs)
        t.setAttribute(i, this.mark.attrs[i]);
    return t;
  }
  canReuseDOM(t) {
    return super.canReuseDOM(t) && !((this.flags | t.flags) & 8);
  }
  reuseDOM(t) {
    t.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, i) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(t, i);
  }
  merge(t, i, n, r, a, o) {
    return n && (!(n instanceof or && n.mark.eq(this.mark)) || t && a <= 0 || i < this.length && o <= 0) ? !1 : (hx(this, t, i, n ? n.children.slice() : [], a - 1, o - 1), this.markDirty(), !0);
  }
  split(t) {
    let i = [], n = 0, r = -1, a = 0;
    for (let l of this.children) {
      let c = n + l.length;
      c > t && i.push(n < t ? l.split(t - n) : l), r < 0 && n >= t && (r = a), n = c, a++;
    }
    let o = this.length - t;
    return this.length = t, r > -1 && (this.children.length = r, this.markDirty()), new or(this.mark, i, o);
  }
  domAtPos(t) {
    return dx(this, t);
  }
  coordsAt(t, i) {
    return px(this, t, i);
  }
}, u(or, "Ar"), or);
m(AC, "MarkView");
let nf = AC;
function EC(s, t, i) {
  let n = s.nodeValue.length;
  t > n && (t = n);
  let r = t, a = t, o = 0;
  t == 0 && i < 0 || t == n && i >= 0 ? te.chrome || te.gecko || (t ? (r--, o = 1) : a < n && (a++, o = -1)) : i < 0 ? r-- : a < n && a++;
  let l = Cr(s, r, a).getClientRects();
  if (!l.length)
    return null;
  let c = l[(o ? o < 0 : i >= 0) ? 0 : l.length - 1];
  return te.safari && !o && c.width == 0 && (c = Array.prototype.find.call(l, (h) => h.width) || c), o ? Af(c, o < 0) : c || null;
}
u(EC, "qg$1");
m(EC, "textCoords");
var _n;
const zC = (_n = class extends Ge {
  static create(t, i, n) {
    return new _n(t, i, n);
  }
  constructor(t, i, n) {
    super(), this.widget = t, this.length = i, this.side = n, this.prevWidget = null;
  }
  split(t) {
    let i = _n.create(this.widget, this.length - t, this.side);
    return this.length -= t, i;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(t, i, n, r, a, o) {
    return n && (!(n instanceof _n) || !this.widget.compare(n.widget) || t > 0 && a <= 0 || i < this.length && o <= 0) ? !1 : (this.length = t + (n ? n.length : 0) + (this.length - i), !0);
  }
  become(t) {
    return t instanceof _n && t.side == this.side && this.widget.constructor == t.widget.constructor ? (this.widget.compare(t.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Ie.empty;
    let t = this;
    for (; t.parent; )
      t = t.parent;
    let { view: i } = t, n = i && i.state.doc, r = this.posAtStart;
    return n ? n.slice(r, r + this.length) : Ie.empty;
  }
  domAtPos(t) {
    return (this.length ? t == 0 : this.side > 0) ? Ri.before(this.dom) : Ri.after(this.dom, t == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t, i) {
    let n = this.widget.coordsAt(this.dom, t, i);
    if (n)
      return n;
    let r = this.dom.getClientRects(), a = null;
    if (!r.length)
      return null;
    let o = this.side ? this.side < 0 : t > 0;
    for (let l = o ? r.length - 1 : 0; a = r[l], !(t > 0 ? l == 0 : l == r.length - 1 || a.top < a.bottom); l += o ? -1 : 1)
      ;
    return Af(a, !o);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}, u(_n, "jt"), _n);
m(zC, "WidgetView");
let _C = zC;
var lr;
const LC = (lr = class extends Ge {
  constructor(t) {
    super(), this.side = t;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(t) {
    return t instanceof lr && t.side == this.side;
  }
  split() {
    return new lr(this.side);
  }
  sync() {
    if (!this.dom) {
      let t = document.createElement("img");
      t.className = "cm-widgetBuffer", t.setAttribute("aria-hidden", "true"), this.setDOM(t);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(t) {
    return this.side > 0 ? Ri.before(this.dom) : Ri.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Ie.empty;
  }
  get isHidden() {
    return !0;
  }
}, u(lr, "Zr"), lr);
m(LC, "WidgetBufferView");
let q0 = LC;
Qr.prototype.children = _C.prototype.children = q0.prototype.children = lx;
function dx(s, t) {
  let i = s.dom, { children: n } = s, r = 0;
  for (let a = 0; r < n.length; r++) {
    let o = n[r], l = a + o.length;
    if (!(l == a && o.getSide() <= 0)) {
      if (t > a && t < l && o.dom.parentNode == i)
        return o.domAtPos(t - a);
      if (t <= a)
        break;
      a = l;
    }
  }
  for (let a = r; a > 0; a--) {
    let o = n[a - 1];
    if (o.dom.parentNode == i)
      return o.domAtPos(o.length);
  }
  for (let a = r; a < n.length; a++) {
    let o = n[a];
    if (o.dom.parentNode == i)
      return o.domAtPos(0);
  }
  return new Ri(i, 0);
}
u(dx, "aO");
m(dx, "inlineDOMAtPos");
function ux(s, t, i) {
  let n, { children: r } = s;
  i > 0 && t instanceof nf && r.length && (n = r[r.length - 1]) instanceof nf && n.mark.eq(t.mark) ? ux(n, t.children[0], i - 1) : (r.push(t), t.setParent(s)), s.length += t.length;
}
u(ux, "hO");
m(ux, "joinInlineInto");
function px(s, t, i) {
  let n = null, r = -1, a = null, o = -1;
  function l(h, d) {
    for (let f = 0, y = 0; f < h.children.length && y <= d; f++) {
      let w = h.children[f], g = y + w.length;
      g >= d && (w.children.length ? l(w, d - y) : (!a || a.isHidden && i > 0) && (g > d || y == g && w.getSide() > 0) ? (a = w, o = d - y) : (y < d || y == g && w.getSide() < 0 && !w.isHidden) && (n = w, r = d - y)), y = g;
    }
  }
  u(l, "l"), m(l, "scan"), l(s, t);
  let c = (i < 0 ? n : a) || n || a;
  return c ? c.coordsAt(Math.max(0, c == n ? r : o), i) : IC(s);
}
u(px, "fO");
m(px, "coordsInChildren");
function IC(s) {
  let t = s.dom.lastChild;
  if (!t)
    return s.dom.getBoundingClientRect();
  let i = go(t);
  return i[i.length - 1] || null;
}
u(IC, "zg$1");
m(IC, "fallbackRect");
function Eg(s, t) {
  for (let i in s)
    i == "class" && t.class ? t.class += " " + s.class : i == "style" && t.style ? t.style += ";" + s.style : t[i] = s[i];
  return t;
}
u(Eg, "yl$1");
m(Eg, "combineAttrs");
const GS = /* @__PURE__ */ Object.create(null);
function tm(s, t, i) {
  if (s == t)
    return !0;
  s || (s = GS), t || (t = GS);
  let n = Object.keys(s), r = Object.keys(t);
  if (n.length - (i && n.indexOf(i) > -1 ? 1 : 0) != r.length - (i && r.indexOf(i) > -1 ? 1 : 0))
    return !1;
  for (let a of n)
    if (a != i && (r.indexOf(a) == -1 || s[a] !== t[a]))
      return !1;
  return !0;
}
u(tm, "ns$1");
m(tm, "attrsEq");
function zg(s, t, i) {
  let n = !1;
  if (t)
    for (let r in t)
      i && r in i || (n = !0, r == "style" ? s.style.cssText = "" : s.removeAttribute(r));
  if (i)
    for (let r in i)
      t && t[r] == i[r] || (n = !0, r == "style" ? s.style.cssText = i[r] : s.setAttribute(r, i[r]));
  return n;
}
u(zg, "Sl$1");
m(zg, "updateAttrs");
function WC(s) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i = 0; i < s.attributes.length; i++) {
    let n = s.attributes[i];
    t[n.name] = n.value;
  }
  return t;
}
u(WC, "Dg$1");
m(WC, "getAttrs$1");
var Ic;
const VC = (Ic = class {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(t) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(t, i) {
    return !1;
  }
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(t) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(t, i, n) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(t) {
  }
}, u(Ic, "Gh"), Ic);
m(VC, "WidgetType");
let Ef = VC;
var Un = /* @__PURE__ */ function(s) {
  return s[s.Text = 0] = "Text", s[s.WidgetBefore = 1] = "WidgetBefore", s[s.WidgetAfter = 2] = "WidgetAfter", s[s.WidgetRange = 3] = "WidgetRange", s;
}(Un || (Un = {})), Wc;
const ZC = (Wc = class extends wo {
  constructor(t, i, n, r) {
    super(), this.startSide = t, this.endSide = i, this.widget = n, this.spec = r;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(t) {
    return new fx(t);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(t) {
    let i = Math.max(-1e4, Math.min(1e4, t.side || 0)), n = !!t.block;
    return i += n && !t.inlineOrder ? i > 0 ? 3e8 : -4e8 : i > 0 ? 1e8 : -1e8, new sf(t, i, i, n, t.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(t) {
    let i = !!t.block, n, r;
    if (t.isBlockGap)
      n = -5e8, r = 4e8;
    else {
      let { start: a, end: o } = mx(t, i);
      n = (a ? i ? -3e8 : -1 : 5e8) - 1, r = (o ? i ? 2e8 : 1 : -6e8) + 1;
    }
    return new sf(t, n, r, i, t.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(t) {
    return new yx(t);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(t, i = !1) {
    return ti.of(t, i);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}, u(Wc, "Fh"), Wc);
m(ZC, "Decoration");
let Xe = ZC;
Xe.none = ti.empty;
var Za;
const DC = (Za = class extends Xe {
  constructor(t) {
    let { start: i, end: n } = mx(t);
    super(i ? -1 : 5e8, n ? 1 : -6e8, null, t), this.tagName = t.tagName || "span", this.class = t.class || "", this.attrs = t.attributes || null;
  }
  eq(t) {
    var i, n;
    return this == t || t instanceof Za && this.tagName == t.tagName && (this.class || ((i = this.attrs) === null || i === void 0 ? void 0 : i.class)) == (t.class || ((n = t.attrs) === null || n === void 0 ? void 0 : n.class)) && tm(this.attrs, t.attrs, "class");
  }
  range(t, i = t) {
    if (t >= i)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(t, i);
  }
}, u(Za, "js"), Za);
m(DC, "MarkDecoration");
let fx = DC;
fx.prototype.point = !1;
var Da;
const qC = (Da = class extends Xe {
  constructor(t) {
    super(-2e8, -2e8, null, t);
  }
  eq(t) {
    return t instanceof Da && this.spec.class == t.spec.class && tm(this.spec.attributes, t.spec.attributes);
  }
  range(t, i = t) {
    if (i != t)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(t, i);
  }
}, u(Da, "qs"), Da);
m(qC, "LineDecoration");
let yx = qC;
yx.prototype.mapMode = hi.TrackBefore;
yx.prototype.point = !0;
var qa;
const UC = (qa = class extends Xe {
  constructor(t, i, n, r, a, o) {
    super(i, n, a, t), this.block = r, this.isReplace = o, this.mapMode = r ? i <= 0 ? hi.TrackBefore : hi.TrackAfter : hi.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? Un.WidgetRange : this.startSide <= 0 ? Un.WidgetBefore : Un.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(t) {
    return t instanceof qa && NC(this.widget, t.widget) && this.block == t.block && this.startSide == t.startSide && this.endSide == t.endSide;
  }
  range(t, i = t) {
    if (this.isReplace && (t > i || t == i && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && i != t)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(t, i);
  }
}, u(qa, "zs"), qa);
m(UC, "PointDecoration");
let sf = UC;
sf.prototype.point = !0;
function mx(s, t = !1) {
  let { inclusiveStart: i, inclusiveEnd: n } = s;
  return i == null && (i = s.inclusive), n == null && (n = s.inclusive), { start: i ?? t, end: n ?? t };
}
u(mx, "cO");
m(mx, "getInclusive");
function NC(s, t) {
  return s == t || !!(s && t && s.compare(t));
}
u(NC, "Bg$1");
m(NC, "widgetsEq");
function Dy(s, t, i, n = 0) {
  let r = i.length - 1;
  r >= 0 && i[r] + n >= s ? i[r] = Math.max(i[r], t) : i.push(s, t);
}
u(Dy, "jn$1");
m(Dy, "addRange");
var Ln;
const BC = (Ln = class extends Ge {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(t, i, n, r, a, o) {
    if (n) {
      if (!(n instanceof Ln))
        return !1;
      this.dom || n.transferDOM(this);
    }
    return r && this.setDeco(n ? n.attrs : null), hx(this, t, i, n ? n.children.slice() : [], a, o), !0;
  }
  split(t) {
    let i = new Ln();
    if (i.breakAfter = this.breakAfter, this.length == 0)
      return i;
    let { i: n, off: r } = this.childPos(t);
    r && (i.append(this.children[n].split(r), 0), this.children[n].merge(r, this.children[n].length, null, !1, 0, 0), n++);
    for (let a = n; a < this.children.length; a++)
      i.append(this.children[a], 0);
    for (; n > 0 && this.children[n - 1].length == 0; )
      this.children[--n].destroy();
    return this.children.length = n, this.markDirty(), this.length = t, i;
  }
  transferDOM(t) {
    this.dom && (this.markDirty(), t.setDOM(this.dom), t.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(t) {
    tm(this.attrs, t) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = t);
  }
  append(t, i) {
    ux(this, t, i);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(t) {
    let i = t.spec.attributes, n = t.spec.class;
    i && (this.attrs = Eg(i, this.attrs || {})), n && (this.attrs = Eg({ class: n }, this.attrs || {}));
  }
  domAtPos(t) {
    return dx(this, t);
  }
  reuseDOM(t) {
    t.nodeName == "DIV" && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, i) {
    var n;
    this.dom ? this.flags & 4 && (sx(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (zg(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(t, i);
    let r = this.dom.lastChild;
    for (; r && Ge.get(r) instanceof nf; )
      r = r.lastChild;
    if (!r || !this.length || r.nodeName != "BR" && ((n = Ge.get(r)) === null || n === void 0 ? void 0 : n.isEditable) == !1 && (!te.ios || !this.children.some((a) => a instanceof Qr))) {
      let a = document.createElement("BR");
      a.cmIgnore = !0, this.dom.appendChild(a);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let t = 0, i;
    for (let n of this.children) {
      if (!(n instanceof Qr) || /[^ -~]/.test(n.text))
        return null;
      let r = go(n.dom);
      if (r.length != 1)
        return null;
      t += r[0].width, i = r[0].height;
    }
    return t ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: t / this.length,
      textHeight: i
    } : null;
  }
  coordsAt(t, i) {
    let n = px(this, t, i);
    if (!this.children.length && n && this.parent) {
      let { heightOracle: r } = this.parent.view.viewState, a = n.bottom - n.top;
      if (Math.abs(a - r.lineHeight) < 2 && r.textHeight < a) {
        let o = (a - r.textHeight) / 2;
        return { top: n.top + o, bottom: n.bottom - o, left: n.left, right: n.left };
      }
    }
    return n;
  }
  become(t) {
    return t instanceof Ln && this.children.length == 0 && t.children.length == 0 && tm(this.attrs, t.attrs) && this.breakAfter == t.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(t, i) {
    for (let n = 0, r = 0; n < t.children.length; n++) {
      let a = t.children[n], o = r + a.length;
      if (o >= i) {
        if (a instanceof Ln)
          return a;
        if (o > i)
          break;
      }
      r = o + a.breakAfter;
    }
    return null;
  }
}, u(Ln, "qt"), Ln);
m(BC, "LineView");
let oi = BC;
var Os;
const jC = (Os = class extends Ge {
  constructor(t, i, n) {
    super(), this.widget = t, this.length = i, this.deco = n, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(t, i, n, r, a, o) {
    return n && (!(n instanceof Os) || !this.widget.compare(n.widget) || t > 0 && a <= 0 || i < this.length && o <= 0) ? !1 : (this.length = t + (n ? n.length : 0) + (this.length - i), !0);
  }
  domAtPos(t) {
    return t == 0 ? Ri.before(this.dom) : Ri.after(this.dom, t == this.length);
  }
  split(t) {
    let i = this.length - t;
    this.length = t;
    let n = new Os(this.widget, i, this.deco);
    return n.breakAfter = this.breakAfter, n;
  }
  get children() {
    return lx;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Ie.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(t) {
    return t instanceof Os && t.widget.constructor == this.widget.constructor ? (t.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, this.deco = t.deco, this.breakAfter = t.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(t, i) {
    return this.widget.coordsAt(this.dom, t, i) || (this.widget instanceof U0 ? null : Af(this.dom.getBoundingClientRect(), this.length ? t == 0 : i <= 0));
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(t) {
    let { startSide: i, endSide: n } = this.deco;
    return i == n ? !1 : t < 0 ? i < 0 : n > 0;
  }
}, u(Os, "yi"), Os);
m(jC, "BlockWidgetView");
let qy = jC;
var Vc;
const XC = (Vc = class extends Ef {
  constructor(t) {
    super(), this.height = t;
  }
  toDOM() {
    let t = document.createElement("div");
    return t.className = "cm-gap", this.updateDOM(t), t;
  }
  eq(t) {
    return t.height == this.height;
  }
  updateDOM(t) {
    return t.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}, u(Vc, "Hh"), Vc);
m(XC, "BlockGapWidget");
let U0 = XC;
var Ua;
const FC = (Ua = class {
  constructor(t, i, n, r) {
    this.doc = t, this.pos = i, this.end = n, this.disallowBlockEffectsFor = r, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = i;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let t = this.content[this.content.length - 1];
    return !(t.breakAfter || t instanceof qy && t.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new oi()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(t = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(wy(new q0(-1), t), t.length), this.pendingBuffer = 0);
  }
  addBlockWidget(t) {
    this.flushBuffer(), this.curLine = null, this.content.push(t);
  }
  finish(t) {
    this.pendingBuffer && t <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(t && this.content.length && this.content[this.content.length - 1] instanceof qy) && this.getLine();
  }
  buildText(t, i, n) {
    for (; t > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: a, lineBreak: o, done: l } = this.cursor.next(this.skip);
        if (this.skip = 0, l)
          throw new Error("Ran out of text content when drawing inline views");
        if (o) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, t--;
          continue;
        } else
          this.text = a, this.textOff = 0;
      }
      let r = Math.min(
        this.text.length - this.textOff,
        t,
        512
        /* T.Chunk */
      );
      this.flushBuffer(i.slice(i.length - n)), this.getLine().append(wy(new Qr(this.text.slice(this.textOff, this.textOff + r)), i), n), this.atCursorPos = !0, this.textOff += r, t -= r, n = 0;
    }
  }
  span(t, i, n, r) {
    this.buildText(i - t, n, r), this.pos = i, this.openStart < 0 && (this.openStart = r);
  }
  point(t, i, n, r, a, o) {
    if (this.disallowBlockEffectsFor[o] && n instanceof sf) {
      if (n.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (i > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let l = i - t;
    if (n instanceof sf)
      if (n.block)
        n.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new qy(n.widget || rf.block, l, n));
      else {
        let c = _C.create(n.widget || rf.inline, l, l ? 0 : n.startSide), h = this.atCursorPos && !c.isEditable && a <= r.length && (t < i || n.startSide > 0), d = !c.isEditable && (t < i || a > r.length || n.startSide <= 0), f = this.getLine();
        this.pendingBuffer == 2 && !h && !c.isEditable && (this.pendingBuffer = 0), this.flushBuffer(r), h && (f.append(wy(new q0(1), r), a), a = r.length + Math.max(0, a - r.length)), f.append(wy(c, r), a), this.atCursorPos = d, this.pendingBuffer = d ? t < i || a > r.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = r.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(n);
    l && (this.textOff + l <= this.text.length ? this.textOff += l : (this.skip += l - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = i), this.openStart < 0 && (this.openStart = a);
  }
  static build(t, i, n, r, a) {
    let o = new Ua(t, i, n, a);
    return o.openEnd = ti.spans(r, i, n, o), o.openStart < 0 && (o.openStart = o.openEnd), o.finish(o.openEnd), o;
  }
}, u(Ua, "Ds"), Ua);
m(FC, "ContentBuilder");
let Lv = FC;
function wy(s, t) {
  for (let i of t)
    s = new nf(i, [s], s.length);
  return s;
}
u(wy, "Qn$1");
m(wy, "wrapMarks");
var Zc;
const HC = (Zc = class extends Ef {
  constructor(t) {
    super(), this.tag = t;
  }
  eq(t) {
    return t.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(t) {
    return t.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}, u(Zc, "Kh"), Zc);
m(HC, "NullWidget");
let rf = HC;
rf.inline = /* @__PURE__ */ new rf("span");
rf.block = /* @__PURE__ */ new rf("div");
var gt = /* @__PURE__ */ function(s) {
  return s[s.LTR = 0] = "LTR", s[s.RTL = 1] = "RTL", s;
}(gt || (gt = {}));
const vo = gt.LTR, wx = gt.RTL;
function gx(s) {
  let t = [];
  for (let i = 0; i < s.length; i++)
    t.push(1 << +s[i]);
  return t;
}
u(gx, "uO");
m(gx, "dec");
const LL = /* @__PURE__ */ gx("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), IL = /* @__PURE__ */ gx("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), N0 = /* @__PURE__ */ Object.create(null), xn = [];
for (let s of ["()", "[]", "{}"]) {
  let t = /* @__PURE__ */ s.charCodeAt(0), i = /* @__PURE__ */ s.charCodeAt(1);
  N0[t] = i, N0[i] = -t;
}
function vx(s) {
  return s <= 247 ? LL[s] : 1424 <= s && s <= 1524 ? 2 : 1536 <= s && s <= 1785 ? IL[s - 1536] : 1774 <= s && s <= 2220 ? 4 : 8192 <= s && s <= 8204 ? 256 : 64336 <= s && s <= 65023 ? 4 : 1;
}
u(vx, "dO");
m(vx, "charType");
const WL = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
var Dc;
const YC = (Dc = class {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? wx : vo;
  }
  /**
  @internal
  */
  constructor(t, i, n) {
    this.from = t, this.to = i, this.level = n;
  }
  /**
  @internal
  */
  side(t, i) {
    return this.dir == i == t ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(t, i) {
    return t == (this.dir == i);
  }
  /**
  @internal
  */
  static find(t, i, n, r) {
    let a = -1;
    for (let o = 0; o < t.length; o++) {
      let l = t[o];
      if (l.from <= i && l.to >= i) {
        if (l.level == n)
          return o;
        (a < 0 || (r != 0 ? r < 0 ? l.from < i : l.to > i : t[a].level > l.level)) && (a = o);
      }
    }
    if (a < 0)
      throw new RangeError("Index out of range");
    return a;
  }
}, u(Dc, "Jh"), Dc);
m(YC, "BidiSpan");
let Gs = YC;
function Ox(s, t) {
  if (s.length != t.length)
    return !1;
  for (let i = 0; i < s.length; i++) {
    let n = s[i], r = t[i];
    if (n.from != r.from || n.to != r.to || n.direction != r.direction || !Ox(n.inner, r.inner))
      return !1;
  }
  return !0;
}
u(Ox, "OO");
m(Ox, "isolatesEq");
const De = [];
function GC(s, t, i, n, r) {
  for (let a = 0; a <= n.length; a++) {
    let o = a ? n[a - 1].to : t, l = a < n.length ? n[a].from : i, c = a ? 256 : r;
    for (let h = o, d = c, f = c; h < l; h++) {
      let y = vx(s.charCodeAt(h));
      y == 512 ? y = d : y == 8 && f == 4 && (y = 16), De[h] = y == 4 ? 2 : y, y & 7 && (f = y), d = y;
    }
    for (let h = o, d = c, f = c; h < l; h++) {
      let y = De[h];
      if (y == 128)
        h < l - 1 && d == De[h + 1] && d & 24 ? y = De[h] = d : De[h] = 256;
      else if (y == 64) {
        let w = h + 1;
        for (; w < l && De[w] == 64; )
          w++;
        let g = h && d == 8 || w < i && De[w] == 8 ? f == 1 ? 1 : 8 : 256;
        for (let b = h; b < w; b++)
          De[b] = g;
        h = w - 1;
      } else y == 8 && f == 1 && (De[h] = 1);
      d = y, y & 7 && (f = y);
    }
  }
}
u(GC, "Hg$1");
m(GC, "computeCharTypes");
function KC(s, t, i, n, r) {
  let a = r == 1 ? 2 : 1;
  for (let o = 0, l = 0, c = 0; o <= n.length; o++) {
    let h = o ? n[o - 1].to : t, d = o < n.length ? n[o].from : i;
    for (let f = h, y, w, g; f < d; f++)
      if (w = N0[y = s.charCodeAt(f)])
        if (w < 0) {
          for (let b = l - 3; b >= 0; b -= 3)
            if (xn[b + 1] == -w) {
              let k = xn[b + 2], $ = k & 2 ? r : k & 4 ? k & 1 ? a : r : 0;
              $ && (De[f] = De[xn[b]] = $), l = b;
              break;
            }
        } else {
          if (xn.length == 189)
            break;
          xn[l++] = f, xn[l++] = y, xn[l++] = c;
        }
      else if ((g = De[f]) == 2 || g == 1) {
        let b = g == r;
        c = b ? 0 : 1;
        for (let k = l - 3; k >= 0; k -= 3) {
          let $ = xn[k + 2];
          if ($ & 2)
            break;
          if (b)
            xn[k + 2] |= 2;
          else {
            if ($ & 4)
              break;
            xn[k + 2] |= 4;
          }
        }
      }
  }
}
u(KC, "Kg$1");
m(KC, "processBracketPairs");
function JC(s, t, i, n) {
  for (let r = 0, a = n; r <= i.length; r++) {
    let o = r ? i[r - 1].to : s, l = r < i.length ? i[r].from : t;
    for (let c = o; c < l; ) {
      let h = De[c];
      if (h == 256) {
        let d = c + 1;
        for (; ; )
          if (d == l) {
            if (r == i.length)
              break;
            d = i[r++].to, l = r < i.length ? i[r].from : t;
          } else if (De[d] == 256)
            d++;
          else
            break;
        let f = a == 1, y = (d < t ? De[d] : n) == 1, w = f == y ? f ? 1 : 2 : n;
        for (let g = d, b = r, k = b ? i[b - 1].to : s; g > c; )
          g == k && (g = i[--b].from, k = b ? i[b - 1].to : s), De[--g] = w;
        c = d;
      } else
        a = h, c++;
    }
  }
}
u(JC, "Jg$1");
m(JC, "processNeutrals");
function _g(s, t, i, n, r, a, o) {
  let l = n % 2 ? 2 : 1;
  if (n % 2 == r % 2)
    for (let c = t, h = 0; c < i; ) {
      let d = !0, f = !1;
      if (h == a.length || c < a[h].from) {
        let b = De[c];
        b != l && (d = !1, f = b == 16);
      }
      let y = !d && l == 1 ? [] : null, w = d ? n : n + 1, g = c;
      e: for (; ; )
        if (h < a.length && g == a[h].from) {
          if (f)
            break e;
          let b = a[h];
          if (!d)
            for (let k = b.to, $ = h + 1; ; ) {
              if (k == i)
                break e;
              if ($ < a.length && a[$].from == k)
                k = a[$++].to;
              else {
                if (De[k] == l)
                  break e;
                break;
              }
            }
          if (h++, y)
            y.push(b);
          else {
            b.from > c && o.push(new Gs(c, b.from, w));
            let k = b.direction == vo != !(w % 2);
            Lg(s, k ? n + 1 : n, r, b.inner, b.from, b.to, o), c = b.to;
          }
          g = b.to;
        } else {
          if (g == i || (d ? De[g] != l : De[g] == l))
            break;
          g++;
        }
      y ? _g(s, c, g, n + 1, r, y, o) : c < g && o.push(new Gs(c, g, w)), c = g;
    }
  else
    for (let c = i, h = a.length; c > t; ) {
      let d = !0, f = !1;
      if (!h || c > a[h - 1].to) {
        let b = De[c - 1];
        b != l && (d = !1, f = b == 16);
      }
      let y = !d && l == 1 ? [] : null, w = d ? n : n + 1, g = c;
      e: for (; ; )
        if (h && g == a[h - 1].to) {
          if (f)
            break e;
          let b = a[--h];
          if (!d)
            for (let k = b.from, $ = h; ; ) {
              if (k == t)
                break e;
              if ($ && a[$ - 1].to == k)
                k = a[--$].from;
              else {
                if (De[k - 1] == l)
                  break e;
                break;
              }
            }
          if (y)
            y.push(b);
          else {
            b.to < c && o.push(new Gs(b.to, c, w));
            let k = b.direction == vo != !(w % 2);
            Lg(s, k ? n + 1 : n, r, b.inner, b.from, b.to, o), c = b.from;
          }
          g = b.from;
        } else {
          if (g == t || (d ? De[g - 1] != l : De[g - 1] == l))
            break;
          g--;
        }
      y ? _g(s, g, c, n + 1, r, y, o) : g < c && o.push(new Gs(g, c, w)), c = g;
    }
}
u(_g, "wl$1");
m(_g, "emitSpans");
function Lg(s, t, i, n, r, a, o) {
  let l = t % 2 ? 2 : 1;
  GC(s, r, a, n, l), KC(s, r, a, n, l), JC(r, a, n, l), _g(s, r, a, t, i, n, o);
}
u(Lg, "xl$1");
m(Lg, "computeSectionOrder");
function e9(s, t, i) {
  if (!s)
    return [new Gs(0, 0, t == wx ? 1 : 0)];
  if (t == vo && !i.length && !WL.test(s))
    return bx(s.length);
  if (i.length)
    for (; s.length > De.length; )
      De[De.length] = 256;
  let n = [], r = t == vo ? 0 : 1;
  return Lg(s, r, r, i, 0, s.length, n), n;
}
u(e9, "e0$1");
m(e9, "computeOrder");
function bx(s) {
  return [new Gs(0, s, 0)];
}
u(bx, "pO");
m(bx, "trivialOrder");
let t9 = "";
function i9(s, t, i, n, r) {
  var a;
  let o = n.head - s.from, l = Gs.find(t, o, (a = n.bidiLevel) !== null && a !== void 0 ? a : -1, n.assoc), c = t[l], h = c.side(r, i);
  if (o == h) {
    let y = l += r ? 1 : -1;
    if (y < 0 || y >= t.length)
      return null;
    c = t[l = y], o = c.side(!r, i), h = c.side(r, i);
  }
  let d = sn(s.text, o, c.forward(r, i));
  (d < c.from || d > c.to) && (d = h), t9 = s.text.slice(Math.min(o, d), Math.max(o, d));
  let f = l == (r ? t.length - 1 : 0) ? null : t[l + (r ? 1 : -1)];
  return f && d == h && f.level + (r ? 0 : 1) < c.level ? J.cursor(f.side(!r, i) + s.from, f.forward(r, i) ? 1 : -1, f.level) : J.cursor(d + s.from, c.forward(r, i) ? -1 : 1, c.level);
}
u(i9, "t0$1");
m(i9, "moveVisually");
function n9(s, t, i) {
  for (let n = t; n < i; n++) {
    let r = vx(s.charCodeAt(n));
    if (r == 1)
      return vo;
    if (r == 2 || r == 4)
      return wx;
  }
  return vo;
}
u(n9, "i0$1");
m(n9, "autoDirection");
const s9 = /* @__PURE__ */ me.define(), r9 = /* @__PURE__ */ me.define(), a9 = /* @__PURE__ */ me.define(), o9 = /* @__PURE__ */ me.define(), B0 = /* @__PURE__ */ me.define(), l9 = /* @__PURE__ */ me.define(), c9 = /* @__PURE__ */ me.define(), $x = /* @__PURE__ */ me.define(), xx = /* @__PURE__ */ me.define(), h9 = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => s.some((t) => t), "combine")
}), VL = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => s.some((t) => t), "combine")
}), d9 = /* @__PURE__ */ me.define();
var cr;
const u9 = (cr = class {
  constructor(t, i = "nearest", n = "nearest", r = 5, a = 5, o = !1) {
    this.range = t, this.y = i, this.x = n, this.yMargin = r, this.xMargin = a, this.isSnapshot = o;
  }
  map(t) {
    return t.empty ? this : new cr(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(t) {
    return this.range.to <= t.doc.length ? this : new cr(J.cursor(t.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}, u(cr, "Wr"), cr);
m(u9, "ScrollTarget");
let Iv = u9;
const Ow = /* @__PURE__ */ qe.define({ map: /* @__PURE__ */ m((s, t) => s.map(t), "map") }), p9 = /* @__PURE__ */ qe.define();
function gi(s, t, i) {
  let n = s.facet(o9);
  n.length ? n[0](t) : window.onerror ? window.onerror(String(t), i, void 0, void 0, t) : i ? console.error(i + ":", t) : console.error(t);
}
u(gi, "Re$2");
m(gi, "logException");
const ds = /* @__PURE__ */ me.define({ combine: /* @__PURE__ */ m((s) => s.length ? s[0] : !0, "combine") });
let ZL = 0;
const gy = /* @__PURE__ */ me.define();
var hr;
const f9 = (hr = class {
  constructor(t, i, n, r, a) {
    this.id = t, this.create = i, this.domEventHandlers = n, this.domEventObservers = r, this.extension = a(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(t, i) {
    const { eventHandlers: n, eventObservers: r, provide: a, decorations: o } = i || {};
    return new hr(ZL++, t, n, r, (l) => {
      let c = [gy.of(l)];
      return o && c.push(im.of((h) => {
        let d = h.plugin(l);
        return d ? o(d) : Xe.none;
      })), a && c.push(a(l)), c;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(t, i) {
    return hr.define((n) => new t(n), i);
  }
}, u(hr, "Ur"), hr);
m(f9, "ViewPlugin");
let Ps = f9;
var qc;
const y9 = (qc = class {
  constructor(t) {
    this.spec = t, this.mustUpdate = null, this.value = null;
  }
  update(t) {
    if (this.value) {
      if (this.mustUpdate) {
        let i = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(i);
          } catch (n) {
            if (gi(i.state, n, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(t);
      } catch (i) {
        gi(t.state, i, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(t) {
    var i;
    if (!((i = this.value) === null || i === void 0) && i.destroy)
      try {
        this.value.destroy();
      } catch (n) {
        gi(t.state, n, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}, u(qc, "ef"), qc);
m(y9, "PluginInstance");
let Wv = y9;
const m9 = /* @__PURE__ */ me.define(), kx = /* @__PURE__ */ me.define(), im = /* @__PURE__ */ me.define(), w9 = /* @__PURE__ */ me.define(), Sx = /* @__PURE__ */ me.define(), g9 = /* @__PURE__ */ me.define();
function j0(s, t) {
  let i = s.state.facet(g9);
  if (!i.length)
    return i;
  let n = i.map((a) => a instanceof Function ? a(s) : a), r = [];
  return ti.spans(n, t.from, t.to, {
    point() {
    },
    span(a, o, l, c) {
      let h = a - t.from, d = o - t.from, f = r;
      for (let y = l.length - 1; y >= 0; y--, c--) {
        let w = l[y].spec.bidiIsolate, g;
        if (w == null && (w = n9(t.text, h, d)), c > 0 && f.length && (g = f[f.length - 1]).to == h && g.direction == w)
          g.to = d, f = g.inner;
        else {
          let b = { from: h, to: d, direction: w, inner: [] };
          f.push(b), f = b.inner;
        }
      }
    }
  }), r;
}
u(j0, "zc$1");
m(j0, "getIsolatedRanges");
const v9 = /* @__PURE__ */ me.define();
function W1(s) {
  let t = 0, i = 0, n = 0, r = 0;
  for (let a of s.state.facet(v9)) {
    let o = a(s);
    o && (o.left != null && (t = Math.max(t, o.left)), o.right != null && (i = Math.max(i, o.right)), o.top != null && (n = Math.max(n, o.top)), o.bottom != null && (r = Math.max(r, o.bottom)));
  }
  return { left: t, right: i, top: n, bottom: r };
}
u(W1, "rh$1");
m(W1, "getScrollMargins");
const vy = /* @__PURE__ */ me.define();
var bs;
const O9 = (bs = class {
  constructor(t, i, n, r) {
    this.fromA = t, this.toA = i, this.fromB = n, this.toB = r;
  }
  join(t) {
    return new bs(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
  }
  addToSet(t) {
    let i = t.length, n = this;
    for (; i > 0; i--) {
      let r = t[i - 1];
      if (!(r.fromA > n.toA)) {
        if (r.toA < n.fromA)
          break;
        n = n.join(r), t.splice(i - 1, 1);
      }
    }
    return t.splice(i, 0, n), t;
  }
  static extendWithRanges(t, i) {
    if (i.length == 0)
      return t;
    let n = [];
    for (let r = 0, a = 0, o = 0, l = 0; ; r++) {
      let c = r == t.length ? null : t[r], h = o - l, d = c ? c.fromB : 1e9;
      for (; a < i.length && i[a] < d; ) {
        let f = i[a], y = i[a + 1], w = Math.max(l, f), g = Math.min(d, y);
        if (w <= g && new bs(w + h, g + h, w, g).addToSet(n), y > d)
          break;
        a += 2;
      }
      if (!c)
        return n;
      new bs(c.fromA, c.toA, c.fromB, c.toB).addToSet(n), o = c.toA, l = c.toB;
    }
  }
}, u(bs, "Si"), bs);
m(O9, "ChangedRange");
let er = O9;
var Na;
const b9 = (Na = class {
  constructor(t, i, n) {
    this.view = t, this.state = i, this.transactions = n, this.flags = 0, this.startState = t.state, this.changes = hn.empty(this.startState.doc.length);
    for (let a of n)
      this.changes = this.changes.compose(a.changes);
    let r = [];
    this.changes.iterChangedRanges((a, o, l, c) => r.push(new er(a, o, l, c))), this.changedRanges = r;
  }
  /**
  @internal
  */
  static create(t, i, n) {
    return new Na(t, i, n);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((t) => t.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}, u(Na, "Bs"), Na);
m(b9, "ViewUpdate");
let KS = b9;
var Uc;
const $9 = (Uc = class extends Ge {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(t) {
    super(), this.view = t, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = Xe.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(t.contentDOM), this.children = [new oi()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new er(0, 0, 0, t.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(t) {
    var i;
    let n = t.changedRanges;
    this.minWidth > 0 && n.length && (n.every(({ fromA: h, toA: d }) => d < this.minWidthFrom || h > this.minWidthTo) ? (this.minWidthFrom = t.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = t.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(t);
    let r = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((i = this.domChanged) === null || i === void 0) && i.newSel ? r = this.domChanged.newSel.head : !Q9(t.changes, this.hasComposition) && !t.selectionSet && (r = t.state.selection.main.head));
    let a = r > -1 ? k9(this.view, t.changes, r) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: h, to: d } = this.hasComposition;
      n = new er(h, d, t.changes.mapPos(h, -1), t.changes.mapPos(d, 1)).addToSet(n.slice());
    }
    this.hasComposition = a ? { from: a.range.fromB, to: a.range.toB } : null, (te.ie || te.chrome) && !a && t && t.state.doc.lines != t.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, l = this.updateDeco(), c = P9(o, l, t.changes);
    return n = er.extendWithRanges(n, c), !(this.flags & 7) && n.length == 0 ? !1 : (this.updateInner(n, t.startState.doc.length, a), t.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(t, i, n) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(t, i, n);
    let { observer: r } = this.view;
    r.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o = te.chrome || te.ios ? { node: r.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, o), this.flags &= -8, o && (o.written || r.selectionRange.focusNode != o.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (o) => o.flags &= -9
      /* ViewFlag.Composition */
    );
    let a = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o of this.children)
        o instanceof qy && o.widget instanceof U0 && a.push(o.dom);
    r.updateGaps(a);
  }
  updateChildren(t, i, n) {
    let r = n ? n.range.addToSet(t.slice()) : t, a = this.childCursor(i);
    for (let o = r.length - 1; ; o--) {
      let l = o >= 0 ? r[o] : null;
      if (!l)
        break;
      let { fromA: c, toA: h, fromB: d, toB: f } = l, y, w, g, b;
      if (n && n.range.fromB < f && n.range.toB > d) {
        let A = Lv.build(this.view.state.doc, d, n.range.fromB, this.decorations, this.dynamicDecorationMap), R = Lv.build(this.view.state.doc, n.range.toB, f, this.decorations, this.dynamicDecorationMap);
        w = A.breakAtStart, g = A.openStart, b = R.openEnd;
        let L = this.compositionView(n);
        R.breakAtStart ? L.breakAfter = 1 : R.content.length && L.merge(L.length, L.length, R.content[0], !1, R.openStart, 0) && (L.breakAfter = R.content[0].breakAfter, R.content.shift()), A.content.length && L.merge(0, 0, A.content[A.content.length - 1], !0, 0, A.openEnd) && A.content.pop(), y = A.content.concat(L).concat(R.content);
      } else
        ({ content: y, breakAtStart: w, openStart: g, openEnd: b } = Lv.build(this.view.state.doc, d, f, this.decorations, this.dynamicDecorationMap));
      let { i: k, off: $ } = a.findPos(h, 1), { i: C, off: E } = a.findPos(c, -1);
      cx(this, C, E, k, $, y, w, g, b);
    }
    n && this.fixCompositionDOM(n);
  }
  updateEditContextFormatting(t) {
    this.editContextFormatting = this.editContextFormatting.map(t.changes);
    for (let i of t.transactions)
      for (let n of i.effects)
        n.is(p9) && (this.editContextFormatting = n.value);
  }
  compositionView(t) {
    let i = new Qr(t.text.nodeValue);
    i.flags |= 8;
    for (let { deco: r } of t.marks)
      i = new nf(r, [i], i.length);
    let n = new oi();
    return n.append(i, 0), n;
  }
  fixCompositionDOM(t) {
    let i = /* @__PURE__ */ m((a, o) => {
      o.flags |= 8 | (o.children.some(
        (c) => c.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(o);
      let l = Ge.get(a);
      l && l != o && (l.dom = null), o.setDOM(a);
    }, "fix"), n = this.childPos(t.range.fromB, 1), r = this.children[n.i];
    i(t.line, r);
    for (let a = t.marks.length - 1; a >= -1; a--)
      n = r.childPos(n.off, 1), r = r.children[n.i], i(a >= 0 ? t.marks[a].node : t.text, r);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(t = !1, i = !1) {
    (t || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let n = this.view.root.activeElement, r = n == this.dom, a = !r && !(this.view.state.facet(ds) || this.dom.tabIndex > -1) && Zy(this.dom, this.view.observer.selectionRange) && !(n && this.dom.contains(n));
    if (!(r || i || a))
      return;
    let o = this.forceSelection;
    this.forceSelection = !1;
    let l = this.view.state.selection.main, c = this.moveToLine(this.domAtPos(l.anchor)), h = l.empty ? c : this.moveToLine(this.domAtPos(l.head));
    if (te.gecko && l.empty && !this.hasComposition && x9(c)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => c.node.insertBefore(f, c.node.childNodes[c.offset] || null)), c = h = new Ri(f, 0), o = !0;
    }
    let d = this.view.observer.selectionRange;
    (o || !d.focusNode || (!cc(c.node, c.offset, d.anchorNode, d.anchorOffset) || !cc(h.node, h.offset, d.focusNode, d.focusOffset)) && !this.suppressWidgetCursorChange(d, l)) && (this.view.observer.ignore(() => {
      te.android && te.chrome && this.dom.contains(d.focusNode) && C9(d.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let f = tf(this.view.root);
      if (f) if (l.empty) {
        if (te.gecko) {
          let y = S9(c.node, c.offset);
          if (y && y != 3) {
            let w = (y == 1 ? ax : ox)(c.node, c.offset);
            w && (c = new Ri(w.node, w.offset));
          }
        }
        f.collapse(c.node, c.offset), l.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = l.bidiLevel);
      } else if (f.extend) {
        f.collapse(c.node, c.offset);
        try {
          f.extend(h.node, h.offset);
        } catch {
        }
      } else {
        let y = document.createRange();
        l.anchor > l.head && ([c, h] = [h, c]), y.setEnd(h.node, h.offset), y.setStart(c.node, c.offset), f.removeAllRanges(), f.addRange(y);
      }
      a && this.view.root.activeElement == this.dom && (this.dom.blur(), n && n.focus());
    }), this.view.observer.setSelectionRange(c, h)), this.impreciseAnchor = c.precise ? null : new Ri(d.anchorNode, d.anchorOffset), this.impreciseHead = h.precise ? null : new Ri(d.focusNode, d.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(t, i) {
    return this.hasComposition && i.empty && cc(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset) && this.posFromDOM(t.focusNode, t.focusOffset) == i.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: t } = this, i = t.state.selection.main, n = tf(t.root), { anchorNode: r, anchorOffset: a } = t.observer.selectionRange;
    if (!n || !i.empty || !i.assoc || !n.modify)
      return;
    let o = oi.find(this, i.head);
    if (!o)
      return;
    let l = o.posAtStart;
    if (i.head == l || i.head == l + o.length)
      return;
    let c = this.coordsAt(i.head, -1), h = this.coordsAt(i.head, 1);
    if (!c || !h || c.bottom > h.top)
      return;
    let d = this.domAtPos(i.head + i.assoc);
    n.collapse(d.node, d.offset), n.modify("move", i.assoc < 0 ? "forward" : "backward", "lineboundary"), t.observer.readSelectionRange();
    let f = t.observer.selectionRange;
    t.docView.posFromDOM(f.anchorNode, f.anchorOffset) != i.from && n.collapse(r, a);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(t) {
    let i = this.dom, n;
    if (t.node != i)
      return t;
    for (let r = t.offset; !n && r < i.childNodes.length; r++) {
      let a = Ge.get(i.childNodes[r]);
      a instanceof oi && (n = a.domAtPos(0));
    }
    for (let r = t.offset - 1; !n && r >= 0; r--) {
      let a = Ge.get(i.childNodes[r]);
      a instanceof oi && (n = a.domAtPos(a.length));
    }
    return n ? new Ri(n.node, n.offset, !0) : t;
  }
  nearest(t) {
    for (let i = t; i; ) {
      let n = Ge.get(i);
      if (n && n.rootView == this)
        return n;
      i = i.parentNode;
    }
    return null;
  }
  posFromDOM(t, i) {
    let n = this.nearest(t);
    if (!n)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return n.localPosFromDOM(t, i) + n.posAtStart;
  }
  domAtPos(t) {
    let { i, off: n } = this.childCursor().findPos(t, -1);
    for (; i < this.children.length - 1; ) {
      let r = this.children[i];
      if (n < r.length || r instanceof oi)
        break;
      i++, n = 0;
    }
    return this.children[i].domAtPos(n);
  }
  coordsAt(t, i) {
    let n = null, r = 0;
    for (let a = this.length, o = this.children.length - 1; o >= 0; o--) {
      let l = this.children[o], c = a - l.breakAfter, h = c - l.length;
      if (c < t)
        break;
      if (h <= t && (h < t || l.covers(-1)) && (c > t || l.covers(1)) && (!n || l instanceof oi && !(n instanceof oi && i >= 0)))
        n = l, r = h;
      else if (n && h == t && c == t && l instanceof qy && Math.abs(i) < 2) {
        if (l.deco.startSide < 0)
          break;
        o && (n = null);
      }
      a = h;
    }
    return n ? n.coordsAt(t - r, i) : null;
  }
  coordsForChar(t) {
    let { i, off: n } = this.childPos(t, 1), r = this.children[i];
    if (!(r instanceof oi))
      return null;
    for (; r.children.length; ) {
      let { i: l, off: c } = r.childPos(n, 1);
      for (; ; l++) {
        if (l == r.children.length)
          return null;
        if ((r = r.children[l]).length)
          break;
      }
      n = c;
    }
    if (!(r instanceof Qr))
      return null;
    let a = sn(r.text, n);
    if (a == n)
      return null;
    let o = Cr(r.dom, n, a).getClientRects();
    for (let l = 0; l < o.length; l++) {
      let c = o[l];
      if (l == o.length - 1 || c.top < c.bottom && c.left < c.right)
        return c;
    }
    return null;
  }
  measureVisibleLineHeights(t) {
    let i = [], { from: n, to: r } = t, a = this.view.contentDOM.clientWidth, o = a > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, l = -1, c = this.view.textDirection == gt.LTR;
    for (let h = 0, d = 0; d < this.children.length; d++) {
      let f = this.children[d], y = h + f.length;
      if (y > r)
        break;
      if (h >= n) {
        let w = f.dom.getBoundingClientRect();
        if (i.push(w.height), o) {
          let g = f.dom.lastChild, b = g ? go(g) : [];
          if (b.length) {
            let k = b[b.length - 1], $ = c ? k.right - w.left : w.right - k.left;
            $ > l && (l = $, this.minWidth = a, this.minWidthFrom = h, this.minWidthTo = y);
          }
        }
      }
      h = y + f.breakAfter;
    }
    return i;
  }
  textDirectionAt(t) {
    let { i } = this.childPos(t, 1);
    return getComputedStyle(this.children[i].dom).direction == "rtl" ? gt.RTL : gt.LTR;
  }
  measureTextSize() {
    for (let a of this.children)
      if (a instanceof oi) {
        let o = a.measureTextSize();
        if (o)
          return o;
      }
    let t = document.createElement("div"), i, n, r;
    return t.className = "cm-line", t.style.width = "99999px", t.style.position = "absolute", t.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(t);
      let a = go(t.firstChild)[0];
      i = t.getBoundingClientRect().height, n = a ? a.width / 27 : 7, r = a ? a.height : i, t.remove();
    }), { lineHeight: i, charWidth: n, textHeight: r };
  }
  childCursor(t = this.length) {
    let i = this.children.length;
    return i && (t -= this.children[--i].length), new QC(this.children, t, i);
  }
  computeBlockGapDeco() {
    let t = [], i = this.view.viewState;
    for (let n = 0, r = 0; ; r++) {
      let a = r == i.viewports.length ? null : i.viewports[r], o = a ? a.from - 1 : this.length;
      if (o > n) {
        let l = (i.lineBlockAt(o).bottom - i.lineBlockAt(n).top) / this.view.scaleY;
        t.push(Xe.replace({
          widget: new U0(l),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(n, o));
      }
      if (!a)
        break;
      n = a.to + 1;
    }
    return Xe.set(t);
  }
  updateDeco() {
    let t = 1, i = this.view.state.facet(im).map((a) => (this.dynamicDecorationMap[t++] = typeof a == "function") ? a(this.view) : a), n = !1, r = this.view.state.facet(w9).map((a, o) => {
      let l = typeof a == "function";
      return l && (n = !0), l ? a(this.view) : a;
    });
    for (r.length && (this.dynamicDecorationMap[t++] = n, i.push(ti.join(r))), this.decorations = [
      this.editContextFormatting,
      ...i,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; t < this.decorations.length; )
      this.dynamicDecorationMap[t++] = !1;
    return this.decorations;
  }
  scrollIntoView(t) {
    if (t.isSnapshot) {
      let h = this.view.viewState.lineBlockAt(t.range.head);
      this.view.scrollDOM.scrollTop = h.top - t.yMargin, this.view.scrollDOM.scrollLeft = t.xMargin;
      return;
    }
    for (let h of this.view.state.facet(d9))
      try {
        if (h(this.view, t.range, t))
          return !0;
      } catch (d) {
        gi(this.view.state, d, "scroll handler");
      }
    let { range: i } = t, n = this.coordsAt(i.head, i.empty ? i.assoc : i.head > i.anchor ? -1 : 1), r;
    if (!n)
      return;
    !i.empty && (r = this.coordsAt(i.anchor, i.anchor > i.head ? -1 : 1)) && (n = {
      left: Math.min(n.left, r.left),
      top: Math.min(n.top, r.top),
      right: Math.max(n.right, r.right),
      bottom: Math.max(n.bottom, r.bottom)
    });
    let a = W1(this.view), o = {
      left: n.left - a.left,
      top: n.top - a.top,
      right: n.right + a.right,
      bottom: n.bottom + a.bottom
    }, { offsetWidth: l, offsetHeight: c } = this.view.scrollDOM;
    OC(this.view.scrollDOM, o, i.head < i.anchor ? -1 : 1, t.x, t.y, Math.max(Math.min(t.xMargin, l), -l), Math.max(Math.min(t.yMargin, c), -c), this.view.textDirection == gt.LTR);
  }
}, u(Uc, "tf"), Uc);
m($9, "DocView");
let JS = $9;
function x9(s) {
  return s.node.nodeType == 1 && s.node.firstChild && (s.offset == 0 || s.node.childNodes[s.offset - 1].contentEditable == "false") && (s.offset == s.node.childNodes.length || s.node.childNodes[s.offset].contentEditable == "false");
}
u(x9, "s0$1");
m(x9, "betweenUneditable");
function Px(s, t) {
  let i = s.observer.selectionRange;
  if (!i.focusNode)
    return null;
  let n = ax(i.focusNode, i.focusOffset), r = ox(i.focusNode, i.focusOffset), a = n || r;
  if (r && n && r.node != n.node) {
    let l = Ge.get(r.node);
    if (!l || l instanceof Qr && l.text != r.node.nodeValue)
      a = r;
    else if (s.docView.lastCompositionAfterCursor) {
      let c = Ge.get(n.node);
      !c || c instanceof Qr && c.text != n.node.nodeValue || (a = r);
    }
  }
  if (s.docView.lastCompositionAfterCursor = a != n, !a)
    return null;
  let o = t - a.offset;
  return { from: o, to: o + a.node.nodeValue.length, node: a.node };
}
u(Px, "AO");
m(Px, "findCompositionNode");
function k9(s, t, i) {
  let n = Px(s, i);
  if (!n)
    return null;
  let { node: r, from: a, to: o } = n, l = r.nodeValue;
  if (/[\n\r]/.test(l) || s.state.doc.sliceString(n.from, n.to) != l)
    return null;
  let c = t.invertedDesc, h = new er(c.mapPos(a), c.mapPos(o), a, o), d = [];
  for (let f = r.parentNode; ; f = f.parentNode) {
    let y = Ge.get(f);
    if (y instanceof nf)
      d.push({ node: f, deco: y.mark });
    else {
      if (y instanceof oi || f.nodeName == "DIV" && f.parentNode == s.contentDOM)
        return { range: h, text: r, marks: d, line: f };
      if (f != s.contentDOM)
        d.push({ node: f, deco: new fx({
          inclusive: !0,
          attributes: WC(f),
          tagName: f.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
u(k9, "o0$1");
m(k9, "findCompositionRange");
function S9(s, t) {
  return s.nodeType != 1 ? 0 : (t && s.childNodes[t - 1].contentEditable == "false" ? 1 : 0) | (t < s.childNodes.length && s.childNodes[t].contentEditable == "false" ? 2 : 0);
}
u(S9, "l0$1");
m(S9, "nextToUneditable");
var Vv, Nc;
let DL = (Vv = (Nc = class {
  constructor() {
    this.changes = [];
  }
  compareRange(t, i) {
    Dy(t, i, this.changes);
  }
  comparePoint(t, i) {
    Dy(t, i, this.changes);
  }
  boundChange(t) {
    Dy(t, t, this.changes);
  }
}, u(Nc, "Ai$1"), Nc), m(Vv, "DecorationComparator"), Vv);
function P9(s, t, i) {
  let n = new DL();
  return ti.compare(s, t, i, n), n.changes;
}
u(P9, "h0$1");
m(P9, "findChangedDeco");
function C9(s, t) {
  for (let i = s; i && i != t; i = i.assignedSlot || i.parentNode)
    if (i.nodeType == 1 && i.contentEditable == "false")
      return !0;
  return !1;
}
u(C9, "f0$1");
m(C9, "inUneditable");
function Q9(s, t) {
  let i = !1;
  return t && s.iterChangedRanges((n, r) => {
    n < t.to && r > t.from && (i = !0);
  }), i;
}
u(Q9, "c0$1");
m(Q9, "touchesComposition");
function T9(s, t, i = 1) {
  let n = s.charCategorizer(t), r = s.doc.lineAt(t), a = t - r.from;
  if (r.length == 0)
    return J.cursor(t);
  a == 0 ? i = 1 : a == r.length && (i = -1);
  let o = a, l = a;
  i < 0 ? o = sn(r.text, a, !1) : l = sn(r.text, a);
  let c = n(r.text.slice(o, l));
  for (; o > 0; ) {
    let h = sn(r.text, o, !1);
    if (n(r.text.slice(h, o)) != c)
      break;
    o = h;
  }
  for (; l < r.length; ) {
    let h = sn(r.text, l);
    if (n(r.text.slice(l, h)) != c)
      break;
    l = h;
  }
  return J.range(o + r.from, l + r.from);
}
u(T9, "u0$1");
m(T9, "groupAt");
function M9(s, t) {
  return t.left > s ? t.left - s : Math.max(0, s - t.right);
}
u(M9, "d0$1");
m(M9, "getdx");
function R9(s, t) {
  return t.top > s ? t.top - s : Math.max(0, s - t.bottom);
}
u(R9, "O0$1");
m(R9, "getdy");
function Dw(s, t) {
  return s.top < t.bottom - 1 && s.bottom > t.top + 1;
}
u(Dw, "ko$1");
m(Dw, "yOverlap");
function X0(s, t) {
  return t < s.top ? { top: t, left: s.left, right: s.right, bottom: s.bottom } : s;
}
u(X0, "Dc$1");
m(X0, "upTop");
function F0(s, t) {
  return t > s.bottom ? { top: s.top, left: s.left, right: s.right, bottom: t } : s;
}
u(F0, "Bc$1");
m(F0, "upBot");
function Ig(s, t, i) {
  let n, r, a, o, l = !1, c, h, d, f;
  for (let g = s.firstChild; g; g = g.nextSibling) {
    let b = go(g);
    for (let k = 0; k < b.length; k++) {
      let $ = b[k];
      r && Dw(r, $) && ($ = X0(F0($, r.bottom), r.top));
      let C = M9(t, $), E = R9(i, $);
      if (C == 0 && E == 0)
        return g.nodeType == 3 ? H0(g, t, i) : Ig(g, t, i);
      if (!n || o > E || o == E && a > C) {
        n = g, r = $, a = C, o = E;
        let A = E ? i < $.top ? -1 : 1 : C ? t < $.left ? -1 : 1 : 0;
        l = !A || (A > 0 ? k < b.length - 1 : k > 0);
      }
      C == 0 ? i > $.bottom && (!d || d.bottom < $.bottom) ? (c = g, d = $) : i < $.top && (!f || f.top > $.top) && (h = g, f = $) : d && Dw(d, $) ? d = F0(d, $.bottom) : f && Dw(f, $) && (f = X0(f, $.top));
    }
  }
  if (d && d.bottom >= i ? (n = c, r = d) : f && f.top <= i && (n = h, r = f), !n)
    return { node: s, offset: 0 };
  let y = Math.max(r.left, Math.min(r.right, t));
  if (n.nodeType == 3)
    return H0(n, y, i);
  if (l && n.contentEditable != "false")
    return Ig(n, y, i);
  let w = Array.prototype.indexOf.call(s.childNodes, n) + (t >= (r.left + r.right) / 2 ? 1 : 0);
  return { node: s, offset: w };
}
u(Ig, "kl$1");
m(Ig, "domPosAtCoords");
function H0(s, t, i) {
  let n = s.nodeValue.length, r = -1, a = 1e9, o = 0;
  for (let l = 0; l < n; l++) {
    let c = Cr(s, l, l + 1).getClientRects();
    for (let h = 0; h < c.length; h++) {
      let d = c[h];
      if (d.top == d.bottom)
        continue;
      o || (o = t - d.left);
      let f = (d.top > i ? d.top - i : i - d.bottom) - 1;
      if (d.left - 1 <= t && d.right + 1 >= t && f < a) {
        let y = t >= (d.left + d.right) / 2, w = y;
        if ((te.chrome || te.gecko) && Cr(s, l).getBoundingClientRect().left == d.right && (w = !y), f <= 0)
          return { node: s, offset: l + (w ? 1 : 0) };
        r = l + (w ? 1 : 0), a = f;
      }
    }
  }
  return { node: s, offset: r > -1 ? r : o > 0 ? s.nodeValue.length : 0 };
}
u(H0, "Nc$1");
m(H0, "domPosInText");
function Cx(s, t, i, n = -1) {
  var r, a;
  let o = s.contentDOM.getBoundingClientRect(), l = o.top + s.viewState.paddingTop, c, { docHeight: h } = s.viewState, { x: d, y: f } = t, y = f - l;
  if (y < 0)
    return 0;
  if (y > h)
    return s.state.doc.length;
  for (let A = s.viewState.heightOracle.textHeight / 2, R = !1; c = s.elementAtHeight(y), c.type != Un.Text; )
    for (; y = n > 0 ? c.bottom + A : c.top - A, !(y >= 0 && y <= h); ) {
      if (R)
        return i ? null : 0;
      R = !0, n = -n;
    }
  f = l + y;
  let w = c.from;
  if (w < s.viewport.from)
    return s.viewport.from == 0 ? 0 : i ? null : Y0(s, o, c, d, f);
  if (w > s.viewport.to)
    return s.viewport.to == s.state.doc.length ? s.state.doc.length : i ? null : Y0(s, o, c, d, f);
  let g = s.dom.ownerDocument, b = s.root.elementFromPoint ? s.root : g, k = b.elementFromPoint(d, f);
  k && !s.contentDOM.contains(k) && (k = null), k || (d = Math.max(o.left + 1, Math.min(o.right - 1, d)), k = b.elementFromPoint(d, f), k && !s.contentDOM.contains(k) && (k = null));
  let $, C = -1;
  if (k && ((r = s.docView.nearest(k)) === null || r === void 0 ? void 0 : r.isEditable) != !1) {
    if (g.caretPositionFromPoint) {
      let A = g.caretPositionFromPoint(d, f);
      A && ({ offsetNode: $, offset: C } = A);
    } else if (g.caretRangeFromPoint) {
      let A = g.caretRangeFromPoint(d, f);
      A && ({ startContainer: $, startOffset: C } = A, (!s.contentDOM.contains($) || te.safari && A9($, C, d) || te.chrome && E9($, C, d)) && ($ = void 0));
    }
    $ && (C = Math.min(dn($), C));
  }
  if (!$ || !s.docView.dom.contains($)) {
    let A = oi.find(s.docView, w);
    if (!A)
      return y > c.top + c.height / 2 ? c.to : c.from;
    ({ node: $, offset: C } = Ig(A.dom, d, f));
  }
  let E = s.docView.nearest($);
  if (!E)
    return null;
  if (E.isWidget && ((a = E.dom) === null || a === void 0 ? void 0 : a.nodeType) == 1) {
    let A = E.dom.getBoundingClientRect();
    return t.y < A.top || t.y <= A.bottom && t.x <= (A.left + A.right) / 2 ? E.posAtStart : E.posAtEnd;
  } else
    return E.localPosFromDOM($, C) + E.posAtStart;
}
u(Cx, "ZO");
m(Cx, "posAtCoords");
function Y0(s, t, i, n, r) {
  let a = Math.round((n - t.left) * s.defaultCharacterWidth);
  if (s.lineWrapping && i.height > s.defaultLineHeight * 1.5) {
    let l = s.viewState.heightOracle.textHeight, c = Math.floor((r - i.top - (s.defaultLineHeight - l) * 0.5) / l);
    a += c * s.viewState.heightOracle.lineLength;
  }
  let o = s.state.sliceDoc(i.from, i.to);
  return i.from + yC(o, a, s.state.tabSize);
}
u(Y0, "Gc$1");
m(Y0, "posAtCoordsImprecise");
function A9(s, t, i) {
  let n;
  if (s.nodeType != 3 || t != (n = s.nodeValue.length))
    return !1;
  for (let r = s.nextSibling; r; r = r.nextSibling)
    if (r.nodeType != 1 || r.nodeName != "BR")
      return !1;
  return Cr(s, n - 1, n).getBoundingClientRect().left > i;
}
u(A9, "p0$1");
m(A9, "isSuspiciousSafariCaretResult");
function E9(s, t, i) {
  if (t != 0)
    return !1;
  for (let r = s; ; ) {
    let a = r.parentNode;
    if (!a || a.nodeType != 1 || a.firstChild != r)
      return !1;
    if (a.classList.contains("cm-line"))
      break;
    r = a;
  }
  let n = s.nodeType == 1 ? s.getBoundingClientRect() : Cr(s, 0, Math.max(s.nodeValue.length, 1)).getBoundingClientRect();
  return i - n.left > 5;
}
u(E9, "m0$1");
m(E9, "isSuspiciousChromeCaretResult");
function z9(s, t) {
  let i = s.lineBlockAt(t);
  if (Array.isArray(i.type)) {
    for (let n of i.type)
      if (n.to > t || n.to == t && (n.to == i.to || n.type == Un.Text))
        return n;
  }
  return i;
}
u(z9, "g0$1");
m(z9, "blockAt");
function _9(s, t, i, n) {
  let r = z9(s, t.head), a = !n || r.type != Un.Text || !(s.lineWrapping || r.widgetLineBreaks) ? null : s.coordsAtPos(t.assoc < 0 && t.head > r.from ? t.head - 1 : t.head);
  if (a) {
    let o = s.dom.getBoundingClientRect(), l = s.textDirectionAt(r.from), c = s.posAtCoords({
      x: i == (l == gt.LTR) ? o.right - 1 : o.left + 1,
      y: (a.top + a.bottom) / 2
    });
    if (c != null)
      return J.cursor(c, i ? -1 : 1);
  }
  return J.cursor(i ? r.to : r.from, i ? -1 : 1);
}
u(_9, "b0$1");
m(_9, "moveToLineBoundary");
function G0(s, t, i, n) {
  let r = s.state.doc.lineAt(t.head), a = s.bidiSpans(r), o = s.textDirectionAt(r.from);
  for (let l = t, c = null; ; ) {
    let h = i9(r, a, o, l, i), d = t9;
    if (!h) {
      if (r.number == (i ? s.state.doc.lines : 1))
        return l;
      d = `
`, r = s.state.doc.line(r.number + (i ? 1 : -1)), a = s.bidiSpans(r), h = s.visualLineSide(r, !i);
    }
    if (c) {
      if (!c(d))
        return l;
    } else {
      if (!n)
        return h;
      c = n(d);
    }
    l = h;
  }
}
u(G0, "Fc$1");
m(G0, "moveByChar");
function L9(s, t, i) {
  let n = s.state.charCategorizer(t), r = n(i);
  return (a) => {
    let o = n(a);
    return r == ys.Space && (r = o), r == o;
  };
}
u(L9, "y0$1");
m(L9, "byGroup");
function I9(s, t, i, n) {
  let r = t.head, a = i ? 1 : -1;
  if (r == (i ? s.state.doc.length : 0))
    return J.cursor(r, t.assoc);
  let o = t.goalColumn, l, c = s.contentDOM.getBoundingClientRect(), h = s.coordsAtPos(r, t.assoc || -1), d = s.documentTop;
  if (h)
    o == null && (o = h.left - c.left), l = a < 0 ? h.top : h.bottom;
  else {
    let w = s.viewState.lineBlockAt(r);
    o == null && (o = Math.min(c.right - c.left, s.defaultCharacterWidth * (r - w.from))), l = (a < 0 ? w.top : w.bottom) + d;
  }
  let f = c.left + o, y = n ?? s.viewState.heightOracle.textHeight >> 1;
  for (let w = 0; ; w += 10) {
    let g = l + (y + w) * a, b = Cx(s, { x: f, y: g }, !1, a);
    if (g < c.top || g > c.bottom || (a < 0 ? b < r : b > r)) {
      let k = s.docView.coordsForChar(b), $ = !k || g < k.top ? -1 : 1;
      return J.cursor(b, $, void 0, o);
    }
  }
}
u(I9, "S0$1");
m(I9, "moveVertically");
function Uy(s, t, i) {
  for (; ; ) {
    let n = 0;
    for (let r of s)
      r.between(t - 1, t + 1, (a, o, l) => {
        if (t > a && t < o) {
          let c = n || i || (t - a < o - t ? -1 : 1);
          t = c < 0 ? a : o, n = c;
        }
      });
    if (!n)
      return t;
  }
}
u(Uy, "qn$1");
m(Uy, "skipAtomicRanges");
function qw(s, t, i) {
  let n = Uy(s.state.facet(Sx).map((r) => r(s)), i.from, t.head > i.from ? -1 : 1);
  return n == i.from ? i : J.cursor(n, n < i.from ? 1 : -1);
}
u(qw, "Ro$1");
m(qw, "skipAtoms");
const Oy = "￿";
var Bc;
const W9 = (Bc = class {
  constructor(t, i) {
    this.points = t, this.text = "", this.lineSeparator = i.facet(kt.lineSeparator);
  }
  append(t) {
    this.text += t;
  }
  lineBreak() {
    this.text += Oy;
  }
  readRange(t, i) {
    if (!t)
      return this;
    let n = t.parentNode;
    for (let r = t; ; ) {
      this.findPointBefore(n, r);
      let a = this.text.length;
      this.readNode(r);
      let o = r.nextSibling;
      if (o == i)
        break;
      let l = Ge.get(r), c = Ge.get(o);
      (l && c ? l.breakAfter : (l ? l.breakAfter : em(r)) || em(o) && (r.nodeName != "BR" || r.cmIgnore) && this.text.length > a) && this.lineBreak(), r = o;
    }
    return this.findPointBefore(n, i), this;
  }
  readTextNode(t) {
    let i = t.nodeValue;
    for (let n of this.points)
      n.node == t && (n.pos = this.text.length + Math.min(n.offset, i.length));
    for (let n = 0, r = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let a = -1, o = 1, l;
      if (this.lineSeparator ? (a = i.indexOf(this.lineSeparator, n), o = this.lineSeparator.length) : (l = r.exec(i)) && (a = l.index, o = l[0].length), this.append(i.slice(n, a < 0 ? i.length : a)), a < 0)
        break;
      if (this.lineBreak(), o > 1)
        for (let c of this.points)
          c.node == t && c.pos > this.text.length && (c.pos -= o - 1);
      n = a + o;
    }
  }
  readNode(t) {
    if (t.cmIgnore)
      return;
    let i = Ge.get(t), n = i && i.overrideDOMText;
    if (n != null) {
      this.findPointInside(t, n.length);
      for (let r = n.iter(); !r.next().done; )
        r.lineBreak ? this.lineBreak() : this.append(r.value);
    } else t.nodeType == 3 ? this.readTextNode(t) : t.nodeName == "BR" ? t.nextSibling && this.lineBreak() : t.nodeType == 1 && this.readRange(t.firstChild, null);
  }
  findPointBefore(t, i) {
    for (let n of this.points)
      n.node == t && t.childNodes[n.offset] == i && (n.pos = this.text.length);
  }
  findPointInside(t, i) {
    for (let n of this.points)
      (t.nodeType == 3 ? n.node == t : t.contains(n.node)) && (n.pos = this.text.length + (V9(t, n.node, n.offset) ? i : 0));
  }
}, u(Bc, "rf"), Bc);
m(W9, "DOMReader");
let qL = W9;
function V9(s, t, i) {
  for (; ; ) {
    if (!t || i < dn(t))
      return !1;
    if (t == s)
      return !0;
    i = Pr(t) + 1, t = t.parentNode;
  }
}
u(V9, "P0$1");
m(V9, "isAtEnd");
var jc;
const Z9 = (jc = class {
  constructor(t, i) {
    this.node = t, this.offset = i, this.pos = -1;
  }
}, u(jc, "nf"), jc);
m(Z9, "DOMPoint");
let eP = Z9;
var Xc;
const D9 = (Xc = class {
  constructor(t, i, n, r) {
    this.typeOver = r, this.bounds = null, this.text = "", this.domChanged = i > -1;
    let { impreciseHead: a, impreciseAnchor: o } = t.docView;
    if (t.state.readOnly && i > -1)
      this.newSel = null;
    else if (i > -1 && (this.bounds = t.docView.domBoundsAround(i, n, 0))) {
      let l = a || o ? [] : N9(t), c = new qL(l, t.state);
      c.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = c.text, this.newSel = B9(l, this.bounds.from);
    } else {
      let l = t.observer.selectionRange, c = a && a.node == l.focusNode && a.offset == l.focusOffset || !Ag(t.contentDOM, l.focusNode) ? t.state.selection.main.head : t.docView.posFromDOM(l.focusNode, l.focusOffset), h = o && o.node == l.anchorNode && o.offset == l.anchorOffset || !Ag(t.contentDOM, l.anchorNode) ? t.state.selection.main.anchor : t.docView.posFromDOM(l.anchorNode, l.anchorOffset), d = t.viewport;
      if ((te.ios || te.chrome) && t.state.selection.main.empty && c != h && (d.from > 0 || d.to < t.state.doc.length)) {
        let f = Math.min(c, h), y = Math.max(c, h), w = d.from - f, g = d.to - y;
        (w == 0 || w == 1 || f == 0) && (g == 0 || g == -1 || y == t.state.doc.length) && (c = 0, h = t.state.doc.length);
      }
      this.newSel = J.single(h, c);
    }
  }
}, u(Xc, "sf"), Xc);
m(D9, "DOMChange");
let UL = D9;
function Qx(s, t) {
  let i, { newSel: n } = t, r = s.state.selection.main, a = s.inputState.lastKeyTime > Date.now() - 100 ? s.inputState.lastKeyCode : -1;
  if (t.bounds) {
    let { from: o, to: l } = t.bounds, c = r.from, h = null;
    (a === 8 || te.android && t.text.length < l - o) && (c = r.to, h = "end");
    let d = U9(s.state.doc.sliceString(o, l, Oy), t.text, c - o, h);
    d && (te.chrome && a == 13 && d.toB == d.from + 2 && t.text.slice(d.from, d.toB) == Oy + Oy && d.toB--, i = {
      from: o + d.from,
      to: o + d.toA,
      insert: Ie.of(t.text.slice(d.from, d.toB).split(Oy))
    });
  } else n && (!s.hasFocus && s.state.facet(ds) || n.main.eq(r)) && (n = null);
  if (!i && !n)
    return !1;
  if (!i && t.typeOver && !r.empty && n && n.main.empty ? i = { from: r.from, to: r.to, insert: s.state.doc.slice(r.from, r.to) } : (te.mac || te.android) && i && i.from == i.to && i.from == r.head - 1 && /^\. ?$/.test(i.insert.toString()) && s.contentDOM.getAttribute("autocorrect") == "off" ? (n && i.insert.length == 2 && (n = J.single(n.main.anchor - 1, n.main.head - 1)), i = { from: i.from, to: i.to, insert: Ie.of([i.insert.toString().replace(".", " ")]) }) : i && i.from >= r.from && i.to <= r.to && (i.from != r.from || i.to != r.to) && r.to - r.from - (i.to - i.from) <= 4 ? i = {
    from: r.from,
    to: r.to,
    insert: s.state.doc.slice(r.from, i.from).append(i.insert).append(s.state.doc.slice(i.to, r.to))
  } : te.chrome && i && i.from == i.to && i.from == r.head && i.insert.toString() == `
 ` && s.lineWrapping && (n && (n = J.single(n.main.anchor - 1, n.main.head - 1)), i = { from: r.from, to: r.to, insert: Ie.of([" "]) }), i)
    return V1(s, i, n, a);
  if (n && !n.main.eq(r)) {
    let o = !1, l = "select";
    return s.inputState.lastSelectionTime > Date.now() - 50 && (s.inputState.lastSelectionOrigin == "select" && (o = !0), l = s.inputState.lastSelectionOrigin), s.dispatch({ selection: n, scrollIntoView: o, userEvent: l }), !0;
  } else
    return !1;
}
u(Qx, "WO");
m(Qx, "applyDOMChange");
function V1(s, t, i, n = -1) {
  if (te.ios && s.inputState.flushIOSKey(t))
    return !0;
  let r = s.state.selection.main;
  if (te.android && (t.to == r.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (t.from == r.from || t.from == r.from - 1 && s.state.sliceDoc(t.from, r.from) == " ") && t.insert.length == 1 && t.insert.lines == 2 && Pa(s.contentDOM, "Enter", 13) || (t.from == r.from - 1 && t.to == r.to && t.insert.length == 0 || n == 8 && t.insert.length < t.to - t.from && t.to > r.head) && Pa(s.contentDOM, "Backspace", 8) || t.from == r.from && t.to == r.to + 1 && t.insert.length == 0 && Pa(s.contentDOM, "Delete", 46)))
    return !0;
  let a = t.insert.toString();
  s.inputState.composing >= 0 && s.inputState.composing++;
  let o, l = /* @__PURE__ */ m(() => o || (o = q9(s, t, i)), "defaultInsert");
  return s.state.facet(l9).some((c) => c(s, t.from, t.to, a, l)) || s.dispatch(l()), !0;
}
u(V1, "nh$1");
m(V1, "applyDOMChangeInner");
function q9(s, t, i) {
  let n, r = s.state, a = r.selection.main;
  if (t.from >= a.from && t.to <= a.to && t.to - t.from >= (a.to - a.from) / 3 && (!i || i.main.empty && i.main.from == t.from + t.insert.length) && s.inputState.composing < 0) {
    let l = a.from < t.from ? r.sliceDoc(a.from, t.from) : "", c = a.to > t.to ? r.sliceDoc(t.to, a.to) : "";
    n = r.replaceSelection(s.state.toText(l + t.insert.sliceString(0, void 0, s.state.lineBreak) + c));
  } else {
    let l = r.changes(t), c = i && i.main.to <= l.newLength ? i.main : void 0;
    if (r.selection.ranges.length > 1 && s.inputState.composing >= 0 && t.to <= a.to && t.to >= a.to - 10) {
      let h = s.state.sliceDoc(t.from, t.to), d, f = i && Px(s, i.main.head);
      if (f) {
        let g = t.insert.length - (t.to - t.from);
        d = { from: f.from, to: f.to - g };
      } else
        d = s.state.doc.lineAt(a.head);
      let y = a.to - t.to, w = a.to - a.from;
      n = r.changeByRange((g) => {
        if (g.from == a.from && g.to == a.to)
          return { changes: l, range: c || g.map(l) };
        let b = g.to - y, k = b - h.length;
        if (g.to - g.from != w || s.state.sliceDoc(k, b) != h || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        g.to >= d.from && g.from <= d.to)
          return { range: g };
        let $ = r.changes({ from: k, to: b, insert: t.insert }), C = g.to - a.to;
        return {
          changes: $,
          range: c ? J.range(Math.max(0, c.anchor + C), Math.max(0, c.head + C)) : g.map($)
        };
      });
    } else
      n = {
        changes: l,
        selection: c && r.selection.replaceRange(c)
      };
  }
  let o = "input.type";
  return (s.composing || s.inputState.compositionPendingChange && s.inputState.compositionEndedAt > Date.now() - 50) && (s.inputState.compositionPendingChange = !1, o += ".compose", s.inputState.compositionFirstChange && (o += ".start", s.inputState.compositionFirstChange = !1)), r.update(n, { userEvent: o, scrollIntoView: !0 });
}
u(q9, "w0$1");
m(q9, "applyDefaultInsert");
function U9(s, t, i, n) {
  let r = Math.min(s.length, t.length), a = 0;
  for (; a < r && s.charCodeAt(a) == t.charCodeAt(a); )
    a++;
  if (a == r && s.length == t.length)
    return null;
  let o = s.length, l = t.length;
  for (; o > 0 && l > 0 && s.charCodeAt(o - 1) == t.charCodeAt(l - 1); )
    o--, l--;
  if (n == "end") {
    let c = Math.max(0, a - Math.min(o, l));
    i -= o + c - a;
  }
  if (o < a && s.length < t.length) {
    let c = i <= a && i >= o ? a - i : 0;
    a -= c, l = a + (l - o), o = a;
  } else if (l < a) {
    let c = i <= a && i >= l ? a - i : 0;
    a -= c, o = a + (o - l), l = a;
  }
  return { from: a, toA: o, toB: l };
}
u(U9, "x0$1");
m(U9, "findDiff");
function N9(s) {
  let t = [];
  if (s.root.activeElement != s.contentDOM)
    return t;
  let { anchorNode: i, anchorOffset: n, focusNode: r, focusOffset: a } = s.observer.selectionRange;
  return i && (t.push(new eP(i, n)), (r != i || a != n) && t.push(new eP(r, a))), t;
}
u(N9, "Q0$1");
m(N9, "selectionPoints");
function B9(s, t) {
  if (s.length == 0)
    return null;
  let i = s[0].pos, n = s.length == 2 ? s[1].pos : i;
  return i > -1 && n > -1 ? J.single(i + t, n + t) : null;
}
u(B9, "k0$1");
m(B9, "selectionFromPoints");
var Fc;
const j9 = (Fc = class {
  setSelectionOrigin(t) {
    this.lastSelectionOrigin = t, this.lastSelectionTime = Date.now();
  }
  constructor(t) {
    this.view = t, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = t.hasFocus, te.safari && t.contentDOM.addEventListener("input", () => null), te.gecko && h7(t.contentDOM.ownerDocument);
  }
  handleEvent(t) {
    !t7(this.view, t) || this.ignoreDuringComposition(t) || t.type == "keydown" && this.keydown(t) || this.runHandlers(t.type, t);
  }
  runHandlers(t, i) {
    let n = this.handlers[t];
    if (n) {
      for (let r of n.observers)
        r(this.view, i);
      for (let r of n.handlers) {
        if (i.defaultPrevented)
          break;
        if (r(this.view, i)) {
          i.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(t) {
    let i = X9(t), n = this.handlers, r = this.view.contentDOM;
    for (let a in i)
      if (a != "scroll") {
        let o = !i[a].handlers.length, l = n[a];
        l && o != !l.handlers.length && (r.removeEventListener(a, this.handleEvent), l = null), l || r.addEventListener(a, this.handleEvent, { passive: o });
      }
    for (let a in n)
      a != "scroll" && !i[a] && r.removeEventListener(a, this.handleEvent);
    this.handlers = i;
  }
  keydown(t) {
    if (this.lastKeyCode = t.keyCode, this.lastKeyTime = Date.now(), t.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && t.keyCode != 27 && H9.indexOf(t.keyCode) < 0 && (this.tabFocusMode = -1), te.android && te.chrome && !t.synthetic && (t.keyCode == 13 || t.keyCode == 8))
      return this.view.observer.delayAndroidKey(t.key, t.keyCode), !0;
    let i;
    return te.ios && !t.synthetic && !t.altKey && !t.metaKey && ((i = F9.find((n) => n.keyCode == t.keyCode)) && !t.ctrlKey || BL.indexOf(t.key) > -1 && t.ctrlKey && !t.shiftKey) ? (this.pendingIOSKey = i || t, setTimeout(() => this.flushIOSKey(), 250), !0) : (t.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(t) {
    let i = this.pendingIOSKey;
    return !i || i.key == "Enter" && t && t.from < t.to && /^\S+$/.test(t.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, Pa(this.view.contentDOM, i.key, i.keyCode, i instanceof KeyboardEvent ? i : void 0));
  }
  ignoreDuringComposition(t) {
    return /^key/.test(t.type) ? this.composing > 0 ? !0 : te.safari && !te.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(t) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = t;
  }
  update(t) {
    this.view.observer.update(t), this.mouseSelection && this.mouseSelection.update(t), this.draggedContent && t.docChanged && (this.draggedContent = this.draggedContent.map(t.changes)), t.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}, u(Fc, "of"), Fc);
m(j9, "InputState");
let NL = j9;
function K0(s, t) {
  return (i, n) => {
    try {
      return t.call(s, n, i);
    } catch (r) {
      gi(i.state, r);
    }
  };
}
u(K0, "Hc$1");
m(K0, "bindHandler");
function X9(s) {
  let t = /* @__PURE__ */ Object.create(null);
  function i(n) {
    return t[n] || (t[n] = { observers: [], handlers: [] });
  }
  u(i, "t"), m(i, "record");
  for (let n of s) {
    let r = n.spec;
    if (r && r.domEventHandlers)
      for (let a in r.domEventHandlers) {
        let o = r.domEventHandlers[a];
        o && i(a).handlers.push(K0(n.value, o));
      }
    if (r && r.domEventObservers)
      for (let a in r.domEventObservers) {
        let o = r.domEventObservers[a];
        o && i(a).observers.push(K0(n.value, o));
      }
  }
  for (let n in un)
    i(n).handlers.push(un[n]);
  for (let n in ji)
    i(n).observers.push(ji[n]);
  return t;
}
u(X9, "R0$1");
m(X9, "computeHandlers");
const F9 = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], BL = "dthko", H9 = [16, 17, 18, 20, 91, 92, 224, 225], bw = 6;
function by(s) {
  return Math.max(0, s) * 0.7 + 8;
}
u(by, "$n$1");
m(by, "dragScrollSpeed");
function Y9(s, t) {
  return Math.max(Math.abs(s.clientX - t.clientX), Math.abs(s.clientY - t.clientY));
}
u(Y9, "v0$1");
m(Y9, "dist");
var Hc;
const G9 = (Hc = class {
  constructor(t, i, n, r) {
    this.view = t, this.startEvent = i, this.style = n, this.mustSelect = r, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = i, this.scrollParents = bC(t.contentDOM), this.atoms = t.state.facet(Sx).map((o) => o(t));
    let a = t.contentDOM.ownerDocument;
    a.addEventListener("mousemove", this.move = this.move.bind(this)), a.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = i.shiftKey, this.multiple = t.state.facet(kt.allowMultipleSelections) && K9(t, i), this.dragging = e7(t, i) && Mx(i) == 1 ? null : !1;
  }
  start(t) {
    this.dragging === !1 && this.select(t);
  }
  move(t) {
    if (t.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && Y9(this.startEvent, t) < 10)
      return;
    this.select(this.lastEvent = t);
    let i = 0, n = 0, r = 0, a = 0, o = this.view.win.innerWidth, l = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: r, right: o } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: a, bottom: l } = this.scrollParents.y.getBoundingClientRect());
    let c = W1(this.view);
    t.clientX - c.left <= r + bw ? i = -by(r - t.clientX) : t.clientX + c.right >= o - bw && (i = by(t.clientX - o)), t.clientY - c.top <= a + bw ? n = -by(a - t.clientY) : t.clientY + c.bottom >= l - bw && (n = by(t.clientY - l)), this.setScrollSpeed(i, n);
  }
  up(t) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || t.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let t = this.view.contentDOM.ownerDocument;
    t.removeEventListener("mousemove", this.move), t.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(t, i) {
    this.scrollSpeed = { x: t, y: i }, t || i ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: t, y: i } = this.scrollSpeed;
    t && this.scrollParents.x && (this.scrollParents.x.scrollLeft += t, t = 0), i && this.scrollParents.y && (this.scrollParents.y.scrollTop += i, i = 0), (t || i) && this.view.win.scrollBy(t, i), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(t) {
    let i = null;
    for (let n = 0; n < t.ranges.length; n++) {
      let r = t.ranges[n], a = null;
      if (r.empty) {
        let o = Uy(this.atoms, r.from, 0);
        o != r.from && (a = J.cursor(o, -1));
      } else {
        let o = Uy(this.atoms, r.from, -1), l = Uy(this.atoms, r.to, 1);
        (o != r.from || l != r.to) && (a = J.range(r.from == r.anchor ? o : l, r.from == r.head ? o : l));
      }
      a && (i || (i = t.ranges.slice()), i[n] = a);
    }
    return i ? J.create(i, t.mainIndex) : t;
  }
  select(t) {
    let { view: i } = this, n = this.skipAtoms(this.style.get(t, this.extend, this.multiple));
    (this.mustSelect || !n.eq(i.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: n,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(t) {
    t.transactions.some((i) => i.isUserEvent("input.type")) ? this.destroy() : this.style.update(t) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}, u(Hc, "lf"), Hc);
m(G9, "MouseSelection");
let jL = G9;
function K9(s, t) {
  let i = s.state.facet(s9);
  return i.length ? i[0](t) : te.mac ? t.metaKey : t.ctrlKey;
}
u(K9, "T0$1");
m(K9, "addsSelectionRange");
function J9(s, t) {
  let i = s.state.facet(r9);
  return i.length ? i[0](t) : te.mac ? !t.altKey : !t.ctrlKey;
}
u(J9, "A0$1");
m(J9, "dragMovesSelection");
function e7(s, t) {
  let { main: i } = s.state.selection;
  if (i.empty)
    return !1;
  let n = tf(s.root);
  if (!n || n.rangeCount == 0)
    return !0;
  let r = n.getRangeAt(0).getClientRects();
  for (let a = 0; a < r.length; a++) {
    let o = r[a];
    if (o.left <= t.clientX && o.right >= t.clientX && o.top <= t.clientY && o.bottom >= t.clientY)
      return !0;
  }
  return !1;
}
u(e7, "Z0$1");
m(e7, "isInPrimarySelection");
function t7(s, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let i = t.target, n; i != s.contentDOM; i = i.parentNode)
    if (!i || i.nodeType == 11 || (n = Ge.get(i)) && n.ignoreEvent(t))
      return !1;
  return !0;
}
u(t7, "W0$1");
m(t7, "eventBelongsToEditor");
const un = /* @__PURE__ */ Object.create(null), ji = /* @__PURE__ */ Object.create(null), i7 = te.ie && te.ie_version < 15 || te.ios && te.webkit_version < 604;
function n7(s) {
  let t = s.dom.parentNode;
  if (!t)
    return;
  let i = t.appendChild(document.createElement("textarea"));
  i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.focus(), setTimeout(() => {
    s.focus(), i.remove(), Tx(s, i.value);
  }, 50);
}
u(n7, "U0$1");
m(n7, "capturePaste");
function Nm(s, t, i) {
  for (let n of s.facet(t))
    i = n(i, s);
  return i;
}
u(Nm, "po$1");
m(Nm, "textFilter");
function Tx(s, t) {
  t = Nm(s.state, $x, t);
  let { state: i } = s, n, r = 1, a = i.toText(t), o = a.lines == i.selection.ranges.length;
  if (i2 != null && i.selection.ranges.every((l) => l.empty) && i2 == a.toString()) {
    let l = -1;
    n = i.changeByRange((c) => {
      let h = i.doc.lineAt(c.from);
      if (h.from == l)
        return { range: c };
      l = h.from;
      let d = i.toText((o ? a.line(r++).text : t) + i.lineBreak);
      return {
        changes: { from: h.from, insert: d },
        range: J.cursor(c.from + d.length)
      };
    });
  } else o ? n = i.changeByRange((l) => {
    let c = a.line(r++);
    return {
      changes: { from: l.from, to: l.to, insert: c.text },
      range: J.cursor(l.from + c.length)
    };
  }) : n = i.replaceSelection(a);
  s.dispatch(n, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
u(Tx, "MO");
m(Tx, "doPaste");
ji.scroll = (s) => {
  s.inputState.lastScrollTop = s.scrollDOM.scrollTop, s.inputState.lastScrollLeft = s.scrollDOM.scrollLeft;
};
un.keydown = (s, t) => (s.inputState.setSelectionOrigin("select"), t.keyCode == 27 && s.inputState.tabFocusMode != 0 && (s.inputState.tabFocusMode = Date.now() + 2e3), !1);
ji.touchstart = (s, t) => {
  s.inputState.lastTouchTime = Date.now(), s.inputState.setSelectionOrigin("select.pointer");
};
ji.touchmove = (s) => {
  s.inputState.setSelectionOrigin("select.pointer");
};
un.mousedown = (s, t) => {
  if (s.observer.flush(), s.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let i = null;
  for (let n of s.state.facet(a9))
    if (i = n(s, t), i)
      break;
  if (!i && t.button == 0 && (i = r7(s, t)), i) {
    let n = !s.hasFocus;
    s.inputState.startMouseSelection(new jL(s, t, i, n)), n && s.observer.ignore(() => {
      nx(s.contentDOM);
      let a = s.root.activeElement;
      a && !a.contains(s.contentDOM) && a.blur();
    });
    let r = s.inputState.mouseSelection;
    if (r)
      return r.start(t), r.dragging === !1;
  }
  return !1;
};
function J0(s, t, i, n) {
  if (n == 1)
    return J.cursor(t, i);
  if (n == 2)
    return T9(s.state, t, i);
  {
    let r = oi.find(s.docView, t), a = s.state.doc.lineAt(r ? r.posAtEnd : t), o = r ? r.posAtStart : a.from, l = r ? r.posAtEnd : a.to;
    return l < s.state.doc.length && l == a.to && l++, J.range(o, l);
  }
}
u(J0, "Kc$1");
m(J0, "rangeForClick");
let tP = /* @__PURE__ */ m((s, t, i) => t >= i.top && t <= i.bottom && s >= i.left && s <= i.right, "inside");
function s7(s, t, i, n) {
  let r = oi.find(s.docView, t);
  if (!r)
    return 1;
  let a = t - r.posAtStart;
  if (a == 0)
    return 1;
  if (a == r.length)
    return -1;
  let o = r.coordsAt(a, -1);
  if (o && tP(i, n, o))
    return -1;
  let l = r.coordsAt(a, 1);
  return l && tP(i, n, l) ? 1 : o && o.bottom >= n ? -1 : 1;
}
u(s7, "L0$1");
m(s7, "findPositionSide");
function e2(s, t) {
  let i = s.posAtCoords({ x: t.clientX, y: t.clientY }, !1);
  return { pos: i, bias: s7(s, i, t.clientX, t.clientY) };
}
u(e2, "eu$1");
m(e2, "queryPos");
const XL = te.ie && te.ie_version <= 11;
let iP = null, nP = 0, sP = 0;
function Mx(s) {
  if (!XL)
    return s.detail;
  let t = iP, i = sP;
  return iP = s, sP = Date.now(), nP = !t || i > Date.now() - 400 && Math.abs(t.clientX - s.clientX) < 2 && Math.abs(t.clientY - s.clientY) < 2 ? (nP + 1) % 3 : 1;
}
u(Mx, "YO");
m(Mx, "getClickType");
function r7(s, t) {
  let i = e2(s, t), n = Mx(t), r = s.state.selection;
  return {
    update(a) {
      a.docChanged && (i.pos = a.changes.mapPos(i.pos), r = r.map(a.changes));
    },
    get(a, o, l) {
      let c = e2(s, a), h, d = J0(s, c.pos, c.bias, n);
      if (i.pos != c.pos && !o) {
        let f = J0(s, i.pos, i.bias, n), y = Math.min(f.from, d.from), w = Math.max(f.to, d.to);
        d = y < d.from ? J.range(y, w) : J.range(w, y);
      }
      return o ? r.replaceRange(r.main.extend(d.from, d.to)) : l && n == 1 && r.ranges.length > 1 && (h = a7(r, c.pos)) ? h : l ? r.addRange(d) : J.create([d]);
    }
  };
}
u(r7, "M0$1");
m(r7, "basicMouseSelection");
function a7(s, t) {
  for (let i = 0; i < s.ranges.length; i++) {
    let { from: n, to: r } = s.ranges[i];
    if (n <= t && r >= t)
      return J.create(s.ranges.slice(0, i).concat(s.ranges.slice(i + 1)), s.mainIndex == i ? 0 : s.mainIndex - (s.mainIndex > i ? 1 : 0));
  }
  return null;
}
u(a7, "Y0$1");
m(a7, "removeRangeAround");
un.dragstart = (s, t) => {
  let { selection: { main: i } } = s.state;
  if (t.target.draggable) {
    let r = s.docView.nearest(t.target);
    if (r && r.isWidget) {
      let a = r.posAtStart, o = a + r.length;
      (a >= i.to || o <= i.from) && (i = J.range(a, o));
    }
  }
  let { inputState: n } = s;
  return n.mouseSelection && (n.mouseSelection.dragging = !0), n.draggedContent = i, t.dataTransfer && (t.dataTransfer.setData("Text", Nm(s.state, xx, s.state.sliceDoc(i.from, i.to))), t.dataTransfer.effectAllowed = "copyMove"), !1;
};
un.dragend = (s) => (s.inputState.draggedContent = null, !1);
function t2(s, t, i, n) {
  if (i = Nm(s.state, $x, i), !i)
    return;
  let r = s.posAtCoords({ x: t.clientX, y: t.clientY }, !1), { draggedContent: a } = s.inputState, o = n && a && J9(s, t) ? { from: a.from, to: a.to } : null, l = { from: r, insert: i }, c = s.state.changes(o ? [o, l] : l);
  s.focus(), s.dispatch({
    changes: c,
    selection: { anchor: c.mapPos(r, -1), head: c.mapPos(r, 1) },
    userEvent: o ? "move.drop" : "input.drop"
  }), s.inputState.draggedContent = null;
}
u(t2, "nu$1");
m(t2, "dropText");
un.drop = (s, t) => {
  if (!t.dataTransfer)
    return !1;
  if (s.state.readOnly)
    return !0;
  let i = t.dataTransfer.files;
  if (i && i.length) {
    let n = Array(i.length), r = 0, a = /* @__PURE__ */ m(() => {
      ++r == i.length && t2(s, t, n.filter((o) => o != null).join(s.state.lineBreak), !1);
    }, "finishFile");
    for (let o = 0; o < i.length; o++) {
      let l = new FileReader();
      l.onerror = a, l.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(l.result) || (n[o] = l.result), a();
      }, l.readAsText(i[o]);
    }
    return !0;
  } else {
    let n = t.dataTransfer.getData("Text");
    if (n)
      return t2(s, t, n, !0), !0;
  }
  return !1;
};
un.paste = (s, t) => {
  if (s.state.readOnly)
    return !0;
  s.observer.flush();
  let i = i7 ? null : t.clipboardData;
  return i ? (Tx(s, i.getData("text/plain") || i.getData("text/uri-list")), !0) : (n7(s), !1);
};
function o7(s, t) {
  let i = s.dom.parentNode;
  if (!i)
    return;
  let n = i.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.value = t, n.focus(), n.selectionEnd = t.length, n.selectionStart = 0, setTimeout(() => {
    n.remove(), s.focus();
  }, 50);
}
u(o7, "C0$1");
m(o7, "captureCopy");
function l7(s) {
  let t = [], i = [], n = !1;
  for (let r of s.selection.ranges)
    r.empty || (t.push(s.sliceDoc(r.from, r.to)), i.push(r));
  if (!t.length) {
    let r = -1;
    for (let { from: a } of s.selection.ranges) {
      let o = s.doc.lineAt(a);
      o.number > r && (t.push(o.text), i.push({ from: o.from, to: Math.min(s.doc.length, o.to + 1) })), r = o.number;
    }
    n = !0;
  }
  return { text: Nm(s, xx, t.join(s.lineBreak)), ranges: i, linewise: n };
}
u(l7, "E0$1");
m(l7, "copiedRange");
let i2 = null;
un.copy = un.cut = (s, t) => {
  let { text: i, ranges: n, linewise: r } = l7(s.state);
  if (!i && !r)
    return !1;
  i2 = r ? i : null, t.type == "cut" && !s.state.readOnly && s.dispatch({
    changes: n,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let a = i7 ? null : t.clipboardData;
  return a ? (a.clearData(), a.setData("text/plain", i), !0) : (o7(s, i), !1);
};
const c7 = /* @__PURE__ */ Es.define();
function Rx(s, t) {
  let i = [];
  for (let n of s.facet(c9)) {
    let r = n(s, t);
    r && i.push(r);
  }
  return i ? s.update({ effects: i, annotations: c7.of(!0) }) : null;
}
u(Rx, "EO");
m(Rx, "focusChangeTransaction");
function Ax(s) {
  setTimeout(() => {
    let t = s.hasFocus;
    if (t != s.inputState.notifiedFocused) {
      let i = Rx(s.state, t);
      i ? s.dispatch(i) : s.update([]);
    }
  }, 10);
}
u(Ax, "VO");
m(Ax, "updateForFocusChange");
ji.focus = (s) => {
  s.inputState.lastFocusTime = Date.now(), !s.scrollDOM.scrollTop && (s.inputState.lastScrollTop || s.inputState.lastScrollLeft) && (s.scrollDOM.scrollTop = s.inputState.lastScrollTop, s.scrollDOM.scrollLeft = s.inputState.lastScrollLeft), Ax(s);
};
ji.blur = (s) => {
  s.observer.clearSelectionRange(), Ax(s);
};
ji.compositionstart = ji.compositionupdate = (s) => {
  s.observer.editContext || (s.inputState.compositionFirstChange == null && (s.inputState.compositionFirstChange = !0), s.inputState.composing < 0 && (s.inputState.composing = 0));
};
ji.compositionend = (s) => {
  s.observer.editContext || (s.inputState.composing = -1, s.inputState.compositionEndedAt = Date.now(), s.inputState.compositionPendingKey = !0, s.inputState.compositionPendingChange = s.observer.pendingRecords().length > 0, s.inputState.compositionFirstChange = null, te.chrome && te.android ? s.observer.flushSoon() : s.inputState.compositionPendingChange ? Promise.resolve().then(() => s.observer.flush()) : setTimeout(() => {
    s.inputState.composing < 0 && s.docView.hasComposition && s.update([]);
  }, 50));
};
ji.contextmenu = (s) => {
  s.inputState.lastContextMenu = Date.now();
};
un.beforeinput = (s, t) => {
  var i, n;
  if (t.inputType == "insertReplacementText" && s.observer.editContext) {
    let a = (i = t.dataTransfer) === null || i === void 0 ? void 0 : i.getData("text/plain"), o = t.getTargetRanges();
    if (a && o.length) {
      let l = o[0], c = s.posAtDOM(l.startContainer, l.startOffset), h = s.posAtDOM(l.endContainer, l.endOffset);
      return V1(s, { from: c, to: h, insert: s.state.toText(a) }, null), !0;
    }
  }
  let r;
  if (te.chrome && te.android && (r = F9.find((a) => a.inputType == t.inputType)) && (s.observer.delayAndroidKey(r.key, r.keyCode), r.key == "Backspace" || r.key == "Delete")) {
    let a = ((n = window.visualViewport) === null || n === void 0 ? void 0 : n.height) || 0;
    setTimeout(() => {
      var o;
      (((o = window.visualViewport) === null || o === void 0 ? void 0 : o.height) || 0) > a + 10 && s.hasFocus && (s.contentDOM.blur(), s.focus());
    }, 100);
  }
  return te.ios && t.inputType == "deleteContentForward" && s.observer.flushSoon(), te.safari && t.inputType == "insertText" && s.inputState.composing >= 0 && setTimeout(() => ji.compositionend(s, t), 20), !1;
};
const rP = /* @__PURE__ */ new Set();
function h7(s) {
  rP.has(s) || (rP.add(s), s.addEventListener("copy", () => {
  }), s.addEventListener("cut", () => {
  }));
}
u(h7, "V0$1");
m(h7, "firefoxCopyCutHack");
const aP = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let af = !1;
function n2() {
  af = !1;
}
u(n2, "lu$1");
m(n2, "clearHeightChangeFlag");
var Yc;
const d7 = (Yc = class {
  constructor(t) {
    this.lineWrapping = t, this.doc = Ie.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(t, i) {
    let n = this.doc.lineAt(i).number - this.doc.lineAt(t).number + 1;
    return this.lineWrapping && (n += Math.max(0, Math.ceil((i - t - n * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * n;
  }
  heightForLine(t) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((t - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(t) {
    return this.doc = t, this;
  }
  mustRefreshForWrapping(t) {
    return aP.indexOf(t) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(t) {
    let i = !1;
    for (let n = 0; n < t.length; n++) {
      let r = t[n];
      r < 0 ? n++ : this.heightSamples[Math.floor(r * 10)] || (i = !0, this.heightSamples[Math.floor(r * 10)] = !0);
    }
    return i;
  }
  refresh(t, i, n, r, a, o) {
    let l = aP.indexOf(t) > -1, c = Math.round(i) != Math.round(this.lineHeight) || this.lineWrapping != l;
    if (this.lineWrapping = l, this.lineHeight = i, this.charWidth = n, this.textHeight = r, this.lineLength = a, c) {
      this.heightSamples = {};
      for (let h = 0; h < o.length; h++) {
        let d = o[h];
        d < 0 ? h++ : this.heightSamples[Math.floor(d * 10)] = !0;
      }
    }
    return c;
  }
}, u(Yc, "af"), Yc);
m(d7, "HeightOracle");
let FL = d7;
var Gc;
const u7 = (Gc = class {
  constructor(t, i) {
    this.from = t, this.heights = i, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}, u(Gc, "hf"), Gc);
m(u7, "MeasuredHeights");
let HL = u7;
var Ba;
const p7 = (Ba = class {
  /**
  @internal
  */
  constructor(t, i, n, r, a) {
    this.from = t, this.length = i, this.top = n, this.height = r, this._content = a;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? Un.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof sf ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(t) {
    let i = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(t._content) ? t._content : [t]);
    return new Ba(this.from, this.length + t.length, this.top, this.height + t.height, i);
  }
}, u(Ba, "Ns"), Ba);
m(p7, "BlockInfo");
let Hs = p7;
var je = /* @__PURE__ */ function(s) {
  return s[s.ByPos = 0] = "ByPos", s[s.ByHeight = 1] = "ByHeight", s[s.ByPosNoHeight = 2] = "ByPosNoHeight", s;
}(je || (je = {}));
const Uw = 1e-3;
var $s;
const f7 = ($s = class {
  constructor(t, i, n = 2) {
    this.length = t, this.height = i, this.flags = n;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(t) {
    this.flags = (t ? 2 : 0) | this.flags & -3;
  }
  setHeight(t) {
    this.height != t && (Math.abs(this.height - t) > Uw && (af = !0), this.height = t);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(t, i, n) {
    return $s.of(n);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(t, i) {
    i.push(this);
  }
  decomposeRight(t, i) {
    i.push(this);
  }
  applyChanges(t, i, n, r) {
    let a = this, o = n.doc;
    for (let l = r.length - 1; l >= 0; l--) {
      let { fromA: c, toA: h, fromB: d, toB: f } = r[l], y = a.lineAt(c, je.ByPosNoHeight, n.setDoc(i), 0, 0), w = y.to >= h ? y : a.lineAt(h, je.ByPosNoHeight, n, 0, 0);
      for (f += w.to - h, h = w.to; l > 0 && y.from <= r[l - 1].toA; )
        c = r[l - 1].fromA, d = r[l - 1].fromB, l--, c < y.from && (y = a.lineAt(c, je.ByPosNoHeight, n, 0, 0));
      d += y.from - c, c = y.from;
      let g = KL.build(n.setDoc(o), t, d, f);
      a = nm(a, a.replace(c, h, g));
    }
    return a.updateHeight(n, 0);
  }
  static empty() {
    return new Rn(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(t) {
    if (t.length == 1)
      return t[0];
    let i = 0, n = t.length, r = 0, a = 0;
    for (; ; )
      if (i == n)
        if (r > a * 2) {
          let l = t[i - 1];
          l.break ? t.splice(--i, 1, l.left, null, l.right) : t.splice(--i, 1, l.left, l.right), n += 1 + l.break, r -= l.size;
        } else if (a > r * 2) {
          let l = t[n];
          l.break ? t.splice(n, 1, l.left, null, l.right) : t.splice(n, 1, l.left, l.right), n += 2 + l.break, a -= l.size;
        } else
          break;
      else if (r < a) {
        let l = t[i++];
        l && (r += l.size);
      } else {
        let l = t[--n];
        l && (a += l.size);
      }
    let o = 0;
    return t[i - 1] == null ? (o = 1, i--) : t[i] == null && (o = 1, n++), new YL($s.of(t.slice(0, i)), o, $s.of(t.slice(n)));
  }
}, u($s, "Pi"), $s);
m(f7, "HeightMap");
let an = f7;
function nm(s, t) {
  return s == t ? s : (s.constructor != t.constructor && (af = !0), t);
}
u(nm, "ls$1");
m(nm, "replace");
an.prototype.size = 1;
var Kc;
const y7 = (Kc = class extends an {
  constructor(t, i, n) {
    super(t, i), this.deco = n;
  }
  blockAt(t, i, n, r) {
    return new Hs(r, this.length, n, this.height, this.deco || 0);
  }
  lineAt(t, i, n, r, a) {
    return this.blockAt(0, n, r, a);
  }
  forEachLine(t, i, n, r, a, o) {
    t <= a + this.length && i >= a && o(this.blockAt(0, n, r, a));
  }
  updateHeight(t, i = 0, n = !1, r) {
    return r && r.from <= i && r.more && this.setHeight(r.heights[r.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}, u(Kc, "ff"), Kc);
m(y7, "HeightMapBlock");
let m7 = y7;
var dr;
const w7 = (dr = class extends m7 {
  constructor(t, i) {
    super(t, i, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(t, i, n, r) {
    return new Hs(r, this.length, n, this.height, this.breaks);
  }
  replace(t, i, n) {
    let r = n[0];
    return n.length == 1 && (r instanceof dr || r instanceof hc && r.flags & 4) && Math.abs(this.length - r.length) < 10 ? (r instanceof hc ? r = new dr(r.length, this.height) : r.height = this.height, this.outdated || (r.outdated = !1), r) : an.of(n);
  }
  updateHeight(t, i = 0, n = !1, r) {
    return r && r.from <= i && r.more ? this.setHeight(r.heights[r.index++]) : (n || this.outdated) && this.setHeight(Math.max(this.widgetHeight, t.heightForLine(this.length - this.collapsed)) + this.breaks * t.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}, u(dr, "Lr"), dr);
m(w7, "HeightMapText");
let Rn = w7;
var Jt;
const g7 = (Jt = class extends an {
  constructor(t) {
    super(t, 0);
  }
  heightMetrics(t, i) {
    let n = t.doc.lineAt(i).number, r = t.doc.lineAt(i + this.length).number, a = r - n + 1, o, l = 0;
    if (t.lineWrapping) {
      let c = Math.min(this.height, t.lineHeight * a);
      o = c / a, this.length > a + 1 && (l = (this.height - c) / (this.length - a - 1));
    } else
      o = this.height / a;
    return { firstLine: n, lastLine: r, perLine: o, perChar: l };
  }
  blockAt(t, i, n, r) {
    let { firstLine: a, lastLine: o, perLine: l, perChar: c } = this.heightMetrics(i, r);
    if (i.lineWrapping) {
      let h = r + (t < i.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (t - n) / this.height)) * this.length)), d = i.doc.lineAt(h), f = l + d.length * c, y = Math.max(n, t - f / 2);
      return new Hs(d.from, d.length, y, f, 0);
    } else {
      let h = Math.max(0, Math.min(o - a, Math.floor((t - n) / l))), { from: d, length: f } = i.doc.line(a + h);
      return new Hs(d, f, n + l * h, l, 0);
    }
  }
  lineAt(t, i, n, r, a) {
    if (i == je.ByHeight)
      return this.blockAt(t, n, r, a);
    if (i == je.ByPosNoHeight) {
      let { from: w, to: g } = n.doc.lineAt(t);
      return new Hs(w, g - w, 0, 0, 0);
    }
    let { firstLine: o, perLine: l, perChar: c } = this.heightMetrics(n, a), h = n.doc.lineAt(t), d = l + h.length * c, f = h.number - o, y = r + l * f + c * (h.from - a - f);
    return new Hs(h.from, h.length, Math.max(r, Math.min(y, r + this.height - d)), d, 0);
  }
  forEachLine(t, i, n, r, a, o) {
    t = Math.max(t, a), i = Math.min(i, a + this.length);
    let { firstLine: l, perLine: c, perChar: h } = this.heightMetrics(n, a);
    for (let d = t, f = r; d <= i; ) {
      let y = n.doc.lineAt(d);
      if (d == t) {
        let g = y.number - l;
        f += c * g + h * (t - a - g);
      }
      let w = c + h * y.length;
      o(new Hs(y.from, y.length, f, w, 0)), f += w, d = y.to + 1;
    }
  }
  replace(t, i, n) {
    let r = this.length - i;
    if (r > 0) {
      let a = n[n.length - 1];
      a instanceof Jt ? n[n.length - 1] = new Jt(a.length + r) : n.push(null, new Jt(r - 1));
    }
    if (t > 0) {
      let a = n[0];
      a instanceof Jt ? n[0] = new Jt(t + a.length) : n.unshift(new Jt(t - 1), null);
    }
    return an.of(n);
  }
  decomposeLeft(t, i) {
    i.push(new Jt(t - 1), null);
  }
  decomposeRight(t, i) {
    i.push(null, new Jt(this.length - t - 1));
  }
  updateHeight(t, i = 0, n = !1, r) {
    let a = i + this.length;
    if (r && r.from <= i + this.length && r.more) {
      let o = [], l = Math.max(i, r.from), c = -1;
      for (r.from > i && o.push(new Jt(r.from - i - 1).updateHeight(t, i)); l <= a && r.more; ) {
        let d = t.doc.lineAt(l).length;
        o.length && o.push(null);
        let f = r.heights[r.index++];
        c == -1 ? c = f : Math.abs(f - c) >= Uw && (c = -2);
        let y = new Rn(d, f);
        y.outdated = !1, o.push(y), l += d + 1;
      }
      l <= a && o.push(null, new Jt(a - l).updateHeight(t, l));
      let h = an.of(o);
      return (c < 0 || Math.abs(h.height - this.height) >= Uw || Math.abs(c - this.heightMetrics(t, i).perLine) >= Uw) && (af = !0), nm(this, h);
    } else (n || this.outdated) && (this.setHeight(t.heightForGap(i, i + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}, u(Jt, "Qe"), Jt);
m(g7, "HeightMapGap");
let hc = g7;
var Jc;
const v7 = (Jc = class extends an {
  constructor(t, i, n) {
    super(t.length + i + n.length, t.height + n.height, i | (t.outdated || n.outdated ? 2 : 0)), this.left = t, this.right = n, this.size = t.size + n.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(t, i, n, r) {
    let a = n + this.left.height;
    return t < a ? this.left.blockAt(t, i, n, r) : this.right.blockAt(t, i, a, r + this.left.length + this.break);
  }
  lineAt(t, i, n, r, a) {
    let o = r + this.left.height, l = a + this.left.length + this.break, c = i == je.ByHeight ? t < o : t < l, h = c ? this.left.lineAt(t, i, n, r, a) : this.right.lineAt(t, i, n, o, l);
    if (this.break || (c ? h.to < l : h.from > l))
      return h;
    let d = i == je.ByPosNoHeight ? je.ByPosNoHeight : je.ByPos;
    return c ? h.join(this.right.lineAt(l, d, n, o, l)) : this.left.lineAt(l, d, n, r, a).join(h);
  }
  forEachLine(t, i, n, r, a, o) {
    let l = r + this.left.height, c = a + this.left.length + this.break;
    if (this.break)
      t < c && this.left.forEachLine(t, i, n, r, a, o), i >= c && this.right.forEachLine(t, i, n, l, c, o);
    else {
      let h = this.lineAt(c, je.ByPos, n, r, a);
      t < h.from && this.left.forEachLine(t, h.from - 1, n, r, a, o), h.to >= t && h.from <= i && o(h), i > h.to && this.right.forEachLine(h.to + 1, i, n, l, c, o);
    }
  }
  replace(t, i, n) {
    let r = this.left.length + this.break;
    if (i < r)
      return this.balanced(this.left.replace(t, i, n), this.right);
    if (t > this.left.length)
      return this.balanced(this.left, this.right.replace(t - r, i - r, n));
    let a = [];
    t > 0 && this.decomposeLeft(t, a);
    let o = a.length;
    for (let l of n)
      a.push(l);
    if (t > 0 && s2(a, o - 1), i < this.length) {
      let l = a.length;
      this.decomposeRight(i, a), s2(a, l);
    }
    return an.of(a);
  }
  decomposeLeft(t, i) {
    let n = this.left.length;
    if (t <= n)
      return this.left.decomposeLeft(t, i);
    i.push(this.left), this.break && (n++, t >= n && i.push(null)), t > n && this.right.decomposeLeft(t - n, i);
  }
  decomposeRight(t, i) {
    let n = this.left.length, r = n + this.break;
    if (t >= r)
      return this.right.decomposeRight(t - r, i);
    t < n && this.left.decomposeRight(t, i), this.break && t < r && i.push(null), i.push(this.right);
  }
  balanced(t, i) {
    return t.size > 2 * i.size || i.size > 2 * t.size ? an.of(this.break ? [t, null, i] : [t, i]) : (this.left = nm(this.left, t), this.right = nm(this.right, i), this.setHeight(t.height + i.height), this.outdated = t.outdated || i.outdated, this.size = t.size + i.size, this.length = t.length + this.break + i.length, this);
  }
  updateHeight(t, i = 0, n = !1, r) {
    let { left: a, right: o } = this, l = i + a.length + this.break, c = null;
    return r && r.from <= i + a.length && r.more ? c = a = a.updateHeight(t, i, n, r) : a.updateHeight(t, i, n), r && r.from <= l + o.length && r.more ? c = o = o.updateHeight(t, l, n, r) : o.updateHeight(t, l, n), c ? this.balanced(a, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}, u(Jc, "cf"), Jc);
m(v7, "HeightMapBranch");
let YL = v7;
function s2(s, t) {
  let i, n;
  s[t] == null && (i = s[t - 1]) instanceof hc && (n = s[t + 1]) instanceof hc && s.splice(t - 1, 3, new hc(i.length + 1 + n.length));
}
u(s2, "au$1");
m(s2, "mergeGaps");
const GL = 5;
var ja;
const O7 = (ja = class {
  constructor(t, i) {
    this.pos = t, this.oracle = i, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(t, i) {
    if (this.lineStart > -1) {
      let n = Math.min(i, this.lineEnd), r = this.nodes[this.nodes.length - 1];
      r instanceof Rn ? r.length += n - this.pos : (n > this.pos || !this.isCovered) && this.nodes.push(new Rn(n - this.pos, -1)), this.writtenTo = n, i > n && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = i;
  }
  point(t, i, n) {
    if (t < i || n.heightRelevant) {
      let r = n.widget ? n.widget.estimatedHeight : 0, a = n.widget ? n.widget.lineBreaks : 0;
      r < 0 && (r = this.oracle.lineHeight);
      let o = i - t;
      n.block ? this.addBlock(new m7(o, r, n)) : (o || a || r >= GL) && this.addLineDeco(r, a, o);
    } else i > t && this.span(t, i);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: t, to: i } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = t, this.lineEnd = i, this.writtenTo < t && ((this.writtenTo < t - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, t - 1)), this.nodes.push(null)), this.pos > t && this.nodes.push(new Rn(this.pos - t, -1)), this.writtenTo = this.pos;
  }
  blankContent(t, i) {
    let n = new hc(i - t);
    return this.oracle.doc.lineAt(t).to == i && (n.flags |= 4), n;
  }
  ensureLine() {
    this.enterLine();
    let t = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (t instanceof Rn)
      return t;
    let i = new Rn(0, -1);
    return this.nodes.push(i), i;
  }
  addBlock(t) {
    this.enterLine();
    let i = t.deco;
    i && i.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(t), this.writtenTo = this.pos = this.pos + t.length, i && i.endSide > 0 && (this.covering = t);
  }
  addLineDeco(t, i, n) {
    let r = this.ensureLine();
    r.length += n, r.collapsed += n, r.widgetHeight = Math.max(r.widgetHeight, t), r.breaks += i, this.writtenTo = this.pos = this.pos + n;
  }
  finish(t) {
    let i = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(i instanceof Rn) && !this.isCovered ? this.nodes.push(new Rn(0, -1)) : (this.writtenTo < this.pos || i == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let n = t;
    for (let r of this.nodes)
      r instanceof Rn && r.updateHeight(this.oracle, n), n += r ? r.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(t, i, n, r) {
    let a = new ja(n, t);
    return ti.spans(i, n, r, a, 0), a.finish(n);
  }
}, u(ja, "Gs"), ja);
m(O7, "NodeBuilder");
let KL = O7;
function b7(s, t, i) {
  let n = new JL();
  return ti.compare(s, t, i, n, 0), n.changes;
}
u(b7, "I0$1");
m(b7, "heightRelevantDecoChanges");
var eh;
const $7 = (eh = class {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(t, i, n, r) {
    (t < i || n && n.heightRelevant || r && r.heightRelevant) && Dy(t, i, this.changes, 5);
  }
}, u(eh, "uf"), eh);
m($7, "DecorationComparator");
let JL = $7;
function x7(s, t) {
  let i = s.getBoundingClientRect(), n = s.ownerDocument, r = n.defaultView || window, a = Math.max(0, i.left), o = Math.min(r.innerWidth, i.right), l = Math.max(0, i.top), c = Math.min(r.innerHeight, i.bottom);
  for (let h = s.parentNode; h && h != n.body; )
    if (h.nodeType == 1) {
      let d = h, f = window.getComputedStyle(d);
      if ((d.scrollHeight > d.clientHeight || d.scrollWidth > d.clientWidth) && f.overflow != "visible") {
        let y = d.getBoundingClientRect();
        a = Math.max(a, y.left), o = Math.min(o, y.right), l = Math.max(l, y.top), c = Math.min(h == s.parentNode ? r.innerHeight : c, y.bottom);
      }
      h = f.position == "absolute" || f.position == "fixed" ? d.offsetParent : d.parentNode;
    } else if (h.nodeType == 11)
      h = h.host;
    else
      break;
  return {
    left: a - i.left,
    right: Math.max(a, o) - i.left,
    top: l - (i.top + t),
    bottom: Math.max(l, c) - (i.top + t)
  };
}
u(x7, "j0$1");
m(x7, "visiblePixelRange");
function k7(s) {
  let t = s.getBoundingClientRect(), i = s.ownerDocument.defaultView || window;
  return t.left < i.innerWidth && t.right > 0 && t.top < i.innerHeight && t.bottom > 0;
}
u(k7, "q0$1");
m(k7, "inWindow");
function S7(s, t) {
  let i = s.getBoundingClientRect();
  return {
    left: 0,
    right: i.right - i.left,
    top: t,
    bottom: i.bottom - (i.top + t)
  };
}
u(S7, "z0$1");
m(S7, "fullPixelRange");
var th;
const P7 = (th = class {
  constructor(t, i, n, r) {
    this.from = t, this.to = i, this.size = n, this.displaySize = r;
  }
  static same(t, i) {
    if (t.length != i.length)
      return !1;
    for (let n = 0; n < t.length; n++) {
      let r = t[n], a = i[n];
      if (r.from != a.from || r.to != a.to || r.size != a.size)
        return !1;
    }
    return !0;
  }
  draw(t, i) {
    return Xe.replace({
      widget: new eI(this.displaySize * (i ? t.scaleY : t.scaleX), i)
    }).range(this.from, this.to);
  }
}, u(th, "df"), th);
m(P7, "LineGap");
let Zv = P7;
var ih;
const C7 = (ih = class extends Ef {
  constructor(t, i) {
    super(), this.size = t, this.vertical = i;
  }
  eq(t) {
    return t.size == this.size && t.vertical == this.vertical;
  }
  toDOM() {
    let t = document.createElement("div");
    return this.vertical ? t.style.height = this.size + "px" : (t.style.width = this.size + "px", t.style.height = "2px", t.style.display = "inline-block"), t;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}, u(ih, "Of"), ih);
m(C7, "LineGapWidget");
let eI = C7;
var nh;
const Q7 = (nh = class {
  constructor(t) {
    this.state = t, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = lP, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = gt.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let i = t.facet(kx).some((n) => typeof n != "function" && n.class == "cm-lineWrapping");
    this.heightOracle = new FL(i), this.stateDeco = t.facet(im).filter((n) => typeof n != "function"), this.heightMap = an.empty().applyChanges(this.stateDeco, Ie.empty, this.heightOracle.setDoc(t.doc), [new er(0, 0, 0, t.doc.length)]);
    for (let n = 0; n < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); n++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = Xe.set(this.lineGaps.map((n) => n.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let t = [this.viewport], { main: i } = this.state.selection;
    for (let n = 0; n <= 1; n++) {
      let r = n ? i.head : i.anchor;
      if (!t.some(({ from: a, to: o }) => r >= a && r <= o)) {
        let { from: a, to: o } = this.lineBlockAt(r);
        t.push(new $w(a, o));
      }
    }
    return this.viewports = t.sort((n, r) => n.from - r.from), this.updateScaler();
  }
  updateScaler() {
    let t = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? lP : new tI(this.heightOracle, this.heightMap, this.viewports), t.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (t) => {
      this.viewportLines.push(rc(t, this.scaler));
    });
  }
  update(t, i = null) {
    this.state = t.state;
    let n = this.stateDeco;
    this.stateDeco = this.state.facet(im).filter((d) => typeof d != "function");
    let r = t.changedRanges, a = er.extendWithRanges(r, b7(n, this.stateDeco, t ? t.changes : hn.empty(this.state.doc.length))), o = this.heightMap.height, l = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    n2(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, t.startState.doc, this.heightOracle.setDoc(this.state.doc), a), (this.heightMap.height != o || af) && (t.flags |= 2), l ? (this.scrollAnchorPos = t.changes.mapPos(l.from, -1), this.scrollAnchorHeight = l.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let c = a.length ? this.mapViewport(this.viewport, t.changes) : this.viewport;
    (i && (i.range.head < c.from || i.range.head > c.to) || !this.viewportIsAppropriate(c)) && (c = this.getViewport(0, i));
    let h = c.from != this.viewport.from || c.to != this.viewport.to;
    this.viewport = c, t.flags |= this.updateForViewport(), (h || !t.changes.empty || t.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, t.changes))), t.flags |= this.computeVisibleRanges(t.changes), i && (this.scrollTarget = i), !this.mustEnforceCursorAssoc && t.selectionSet && t.view.lineWrapping && t.state.selection.main.empty && t.state.selection.main.assoc && !t.state.facet(VL) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(t) {
    let i = t.contentDOM, n = window.getComputedStyle(i), r = this.heightOracle, a = n.whiteSpace;
    this.defaultTextDirection = n.direction == "rtl" ? gt.RTL : gt.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(a), l = i.getBoundingClientRect(), c = o || this.mustMeasureContent || this.contentDOMHeight != l.height;
    this.contentDOMHeight = l.height, this.mustMeasureContent = !1;
    let h = 0, d = 0;
    if (l.width && l.height) {
      let { scaleX: A, scaleY: R } = ix(i, l);
      (A > 5e-3 && Math.abs(this.scaleX - A) > 5e-3 || R > 5e-3 && Math.abs(this.scaleY - R) > 5e-3) && (this.scaleX = A, this.scaleY = R, h |= 16, o = c = !0);
    }
    let f = (parseInt(n.paddingTop) || 0) * this.scaleY, y = (parseInt(n.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f || this.paddingBottom != y) && (this.paddingTop = f, this.paddingBottom = y, h |= 18), this.editorWidth != t.scrollDOM.clientWidth && (r.lineWrapping && (c = !0), this.editorWidth = t.scrollDOM.clientWidth, h |= 16);
    let w = t.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != w && (this.scrollAnchorHeight = -1, this.scrollTop = w), this.scrolledToBottom = rx(t.scrollDOM);
    let g = (this.printing ? S7 : x7)(i, this.paddingTop), b = g.top - this.pixelViewport.top, k = g.bottom - this.pixelViewport.bottom;
    this.pixelViewport = g;
    let $ = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if ($ != this.inView && (this.inView = $, $ && (c = !0)), !this.inView && !this.scrollTarget && !k7(t.dom))
      return 0;
    let C = l.width;
    if ((this.contentDOMWidth != C || this.editorHeight != t.scrollDOM.clientHeight) && (this.contentDOMWidth = l.width, this.editorHeight = t.scrollDOM.clientHeight, h |= 16), c) {
      let A = t.docView.measureVisibleLineHeights(this.viewport);
      if (r.mustRefreshForHeights(A) && (o = !0), o || r.lineWrapping && Math.abs(C - this.contentDOMWidth) > r.charWidth) {
        let { lineHeight: R, charWidth: L, textHeight: I } = t.docView.measureTextSize();
        o = R > 0 && r.refresh(a, R, L, I, C / L, A), o && (t.docView.minWidth = 0, h |= 16);
      }
      b > 0 && k > 0 ? d = Math.max(b, k) : b < 0 && k < 0 && (d = Math.min(b, k)), n2();
      for (let R of this.viewports) {
        let L = R.from == this.viewport.from ? A : t.docView.measureVisibleLineHeights(R);
        this.heightMap = (o ? an.empty().applyChanges(this.stateDeco, Ie.empty, this.heightOracle, [new er(0, 0, 0, t.state.doc.length)]) : this.heightMap).updateHeight(r, 0, o, new HL(R.from, L));
      }
      af && (h |= 2);
    }
    let E = !this.viewportIsAppropriate(this.viewport, d) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return E && (h & 2 && (h |= this.updateScaler()), this.viewport = this.getViewport(d, this.scrollTarget), h |= this.updateForViewport()), (h & 2 || E) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, t)), h |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, t.docView.enforceCursorAssoc()), h;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(t, i) {
    let n = 0.5 - Math.max(-0.5, Math.min(0.5, t / 1e3 / 2)), r = this.heightMap, a = this.heightOracle, { visibleTop: o, visibleBottom: l } = this, c = new $w(r.lineAt(o - n * 1e3, je.ByHeight, a, 0, 0).from, r.lineAt(l + (1 - n) * 1e3, je.ByHeight, a, 0, 0).to);
    if (i) {
      let { head: h } = i.range;
      if (h < c.from || h > c.to) {
        let d = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = r.lineAt(h, je.ByPos, a, 0, 0), y;
        i.y == "center" ? y = (f.top + f.bottom) / 2 - d / 2 : i.y == "start" || i.y == "nearest" && h < c.from ? y = f.top : y = f.bottom - d, c = new $w(r.lineAt(y - 1e3 / 2, je.ByHeight, a, 0, 0).from, r.lineAt(y + d + 1e3 / 2, je.ByHeight, a, 0, 0).to);
      }
    }
    return c;
  }
  mapViewport(t, i) {
    let n = i.mapPos(t.from, -1), r = i.mapPos(t.to, 1);
    return new $w(this.heightMap.lineAt(n, je.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(r, je.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: t, to: i }, n = 0) {
    if (!this.inView)
      return !0;
    let { top: r } = this.heightMap.lineAt(t, je.ByPos, this.heightOracle, 0, 0), { bottom: a } = this.heightMap.lineAt(i, je.ByPos, this.heightOracle, 0, 0), { visibleTop: o, visibleBottom: l } = this;
    return (t == 0 || r <= o - Math.max(10, Math.min(
      -n,
      250
      /* VP.MaxCoverMargin */
    ))) && (i == this.state.doc.length || a >= l + Math.max(10, Math.min(
      n,
      250
      /* VP.MaxCoverMargin */
    ))) && r > o - 2 * 1e3 && a < l + 2 * 1e3;
  }
  mapLineGaps(t, i) {
    if (!t.length || i.empty)
      return t;
    let n = [];
    for (let r of t)
      i.touchesRange(r.from, r.to) || n.push(new Zv(i.mapPos(r.from), i.mapPos(r.to), r.size, r.displaySize));
    return n;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(t, i) {
    let n = this.heightOracle.lineWrapping, r = n ? 1e4 : 2e3, a = r >> 1, o = r << 1;
    if (this.defaultTextDirection != gt.LTR && !n)
      return [];
    let l = [], c = /* @__PURE__ */ m((d, f, y, w) => {
      if (f - d < a)
        return;
      let g = this.state.selection.main, b = [g.from];
      g.empty || b.push(g.to);
      for (let $ of b)
        if ($ > d && $ < f) {
          c(d, $ - 10, y, w), c($ + 10, f, y, w);
          return;
        }
      let k = R7(t, ($) => $.from >= y.from && $.to <= y.to && Math.abs($.from - d) < a && Math.abs($.to - f) < a && !b.some((C) => $.from < C && $.to > C));
      if (!k) {
        if (f < y.to && i && n && i.visibleRanges.some((E) => E.from <= f && E.to >= f)) {
          let E = i.moveToLineBoundary(J.cursor(f), !1, !0).head;
          E > d && (f = E);
        }
        let $ = this.gapSize(y, d, f, w), C = n || $ < 2e6 ? $ : 2e6;
        k = new Zv(d, f, $, C);
      }
      l.push(k);
    }, "addGap"), h = /* @__PURE__ */ m((d) => {
      if (d.length < o || d.type != Un.Text)
        return;
      let f = M7(d.from, d.to, this.stateDeco);
      if (f.total < o)
        return;
      let y = this.scrollTarget ? this.scrollTarget.range.head : null, w, g;
      if (n) {
        let b = r / this.heightOracle.lineLength * this.heightOracle.lineHeight, k, $;
        if (y != null) {
          let C = xy(f, y), E = ((this.visibleBottom - this.visibleTop) / 2 + b) / d.height;
          k = C - E, $ = C + E;
        } else
          k = (this.visibleTop - d.top - b) / d.height, $ = (this.visibleBottom - d.top + b) / d.height;
        w = $y(f, k), g = $y(f, $);
      } else {
        let b = f.total * this.heightOracle.charWidth, k = r * this.heightOracle.charWidth, $ = 0;
        if (b > 2e6)
          for (let L of t)
            L.from >= d.from && L.from < d.to && L.size != L.displaySize && L.from * this.heightOracle.charWidth + $ < this.pixelViewport.left && ($ = L.size - L.displaySize);
        let C = this.pixelViewport.left + $, E = this.pixelViewport.right + $, A, R;
        if (y != null) {
          let L = xy(f, y), I = ((E - C) / 2 + k) / b;
          A = L - I, R = L + I;
        } else
          A = (C - k) / b, R = (E + k) / b;
        w = $y(f, A), g = $y(f, R);
      }
      w > d.from && c(d.from, w, d, f), g < d.to && c(g, d.to, d, f);
    }, "checkLine");
    for (let d of this.viewportLines)
      Array.isArray(d.type) ? d.type.forEach(h) : h(d);
    return l;
  }
  gapSize(t, i, n, r) {
    let a = xy(r, n) - xy(r, i);
    return this.heightOracle.lineWrapping ? t.height * a : r.total * this.heightOracle.charWidth * a;
  }
  updateLineGaps(t) {
    Zv.same(t, this.lineGaps) || (this.lineGaps = t, this.lineGapDeco = Xe.set(t.map((i) => i.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(t) {
    let i = this.stateDeco;
    this.lineGaps.length && (i = i.concat(this.lineGapDeco));
    let n = [];
    ti.spans(i, this.viewport.from, this.viewport.to, {
      span(a, o) {
        n.push({ from: a, to: o });
      },
      point() {
      }
    }, 20);
    let r = 0;
    if (n.length != this.visibleRanges.length)
      r = 12;
    else
      for (let a = 0; a < n.length && !(r & 8); a++) {
        let o = this.visibleRanges[a], l = n[a];
        (o.from != l.from || o.to != l.to) && (r |= 4, t && t.mapPos(o.from, -1) == l.from && t.mapPos(o.to, 1) == l.to || (r |= 8));
      }
    return this.visibleRanges = n, r;
  }
  lineBlockAt(t) {
    return t >= this.viewport.from && t <= this.viewport.to && this.viewportLines.find((i) => i.from <= t && i.to >= t) || rc(this.heightMap.lineAt(t, je.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(t) {
    return t >= this.viewportLines[0].top && t <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((i) => i.top <= t && i.bottom >= t) || rc(this.heightMap.lineAt(this.scaler.fromDOM(t), je.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(t) {
    let i = this.lineBlockAtHeight(t + 8);
    return i.from >= this.viewport.from || this.viewportLines[0].top - t > 200 ? i : this.viewportLines[0];
  }
  elementAtHeight(t) {
    return rc(this.heightMap.blockAt(this.scaler.fromDOM(t), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}, u(nh, "pf"), nh);
m(Q7, "ViewState");
let oP = Q7;
var sh;
const T7 = (sh = class {
  constructor(t, i) {
    this.from = t, this.to = i;
  }
}, u(sh, "mf"), sh);
m(T7, "Viewport");
let $w = T7;
function M7(s, t, i) {
  let n = [], r = s, a = 0;
  return ti.spans(i, s, t, {
    span() {
    },
    point(o, l) {
      o > r && (n.push({ from: r, to: o }), a += o - r), r = l;
    }
  }, 20), r < t && (n.push({ from: r, to: t }), a += t - r), { total: a, ranges: n };
}
u(M7, "D0$1");
m(M7, "lineStructure");
function $y({ total: s, ranges: t }, i) {
  if (i <= 0)
    return t[0].from;
  if (i >= 1)
    return t[t.length - 1].to;
  let n = Math.floor(s * i);
  for (let r = 0; ; r++) {
    let { from: a, to: o } = t[r], l = o - a;
    if (n <= l)
      return a + n;
    n -= l;
  }
}
u($y, "vn$1");
m($y, "findPosition");
function xy(s, t) {
  let i = 0;
  for (let { from: n, to: r } of s.ranges) {
    if (t <= r) {
      i += t - n;
      break;
    }
    i += r - n;
  }
  return i / s.total;
}
u(xy, "Tn$1");
m(xy, "findFraction");
function R7(s, t) {
  for (let i of s)
    if (t(i))
      return i;
}
u(R7, "B0$1");
m(R7, "find");
const lP = {
  toDOM(s) {
    return s;
  },
  fromDOM(s) {
    return s;
  },
  scale: 1,
  eq(s) {
    return s == this;
  }
};
var Xa;
const A7 = (Xa = class {
  constructor(t, i, n) {
    let r = 0, a = 0, o = 0;
    this.viewports = n.map(({ from: l, to: c }) => {
      let h = i.lineAt(l, je.ByPos, t, 0, 0).top, d = i.lineAt(c, je.ByPos, t, 0, 0).bottom;
      return r += d - h, { from: l, to: c, top: h, bottom: d, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - r) / (i.height - r);
    for (let l of this.viewports)
      l.domTop = o + (l.top - a) * this.scale, o = l.domBottom = l.domTop + (l.bottom - l.top), a = l.bottom;
  }
  toDOM(t) {
    for (let i = 0, n = 0, r = 0; ; i++) {
      let a = i < this.viewports.length ? this.viewports[i] : null;
      if (!a || t < a.top)
        return r + (t - n) * this.scale;
      if (t <= a.bottom)
        return a.domTop + (t - a.top);
      n = a.bottom, r = a.domBottom;
    }
  }
  fromDOM(t) {
    for (let i = 0, n = 0, r = 0; ; i++) {
      let a = i < this.viewports.length ? this.viewports[i] : null;
      if (!a || t < a.domTop)
        return n + (t - r) / this.scale;
      if (t <= a.domBottom)
        return a.top + (t - a.domTop);
      n = a.bottom, r = a.domBottom;
    }
  }
  eq(t) {
    return t instanceof Xa ? this.scale == t.scale && this.viewports.length == t.viewports.length && this.viewports.every((i, n) => i.from == t.viewports[n].from && i.to == t.viewports[n].to) : !1;
  }
}, u(Xa, "Fs"), Xa);
m(A7, "BigScaler");
let tI = A7;
function rc(s, t) {
  if (t.scale == 1)
    return s;
  let i = t.toDOM(s.top), n = t.toDOM(s.bottom);
  return new Hs(s.from, s.length, i, n - i, Array.isArray(s._content) ? s._content.map((r) => rc(r, t)) : s._content);
}
u(rc, "dr");
m(rc, "scaleBlock");
const xw = /* @__PURE__ */ me.define({ combine: /* @__PURE__ */ m((s) => s.join(" "), "combine") }), r2 = /* @__PURE__ */ me.define({ combine: /* @__PURE__ */ m((s) => s.indexOf(!0) > -1, "combine") }), a2 = /* @__PURE__ */ kr.newName(), E7 = /* @__PURE__ */ kr.newName(), z7 = /* @__PURE__ */ kr.newName(), _7 = { "&light": "." + E7, "&dark": "." + z7 };
function Wg(s, t, i) {
  return new kr(t, {
    finish(n) {
      return /&/.test(n) ? n.replace(/&\w*/, (r) => {
        if (r == "&")
          return s;
        if (!i || !i[r])
          throw new RangeError(`Unsupported selector: ${r}`);
        return i[r];
      }) : s + " " + n;
    }
  });
}
u(Wg, "Vl");
m(Wg, "buildTheme");
const iI = /* @__PURE__ */ Wg("." + a2, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, _7), nI = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, Dv = te.ie && te.ie_version <= 11;
var rh;
const L7 = (rh = class {
  constructor(t) {
    this.view = t, this.active = !1, this.editContext = null, this.selectionRange = new zL(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver((i) => {
      for (let n of i)
        this.queue.push(n);
      (te.ie && te.ie_version <= 11 || te.ios && t.composing) && i.some((n) => n.type == "childList" && n.removedNodes.length || n.type == "characterData" && n.oldValue.length > n.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && t.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(te.chrome && te.chrome_version < 126) && (this.editContext = new rI(t), t.state.facet(ds) && (t.contentDOM.editContext = this.editContext.editContext)), Dv && (this.onCharData = (i) => {
      this.queue.push({
        target: i.target,
        type: "characterData",
        oldValue: i.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var i;
      ((i = this.view.docView) === null || i === void 0 ? void 0 : i.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(t.scrollDOM)), this.addWindowListeners(this.win = t.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((i) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), i.length > 0 && i[i.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((i) => {
      i.length > 0 && i[i.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(t) {
    this.view.inputState.runHandlers("scroll", t), this.intersecting && this.view.measure();
  }
  onScroll(t) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(t);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(t) {
    (t.type == "change" || !t.type) && !t.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(t) {
    if (this.gapIntersection && (t.length != this.gaps.length || this.gaps.some((i, n) => i != t[n]))) {
      this.gapIntersection.disconnect();
      for (let i of t)
        this.gapIntersection.observe(i);
      this.gaps = t;
    }
  }
  onSelectionChange(t) {
    let i = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: n } = this, r = this.selectionRange;
    if (n.state.facet(ds) ? n.root.activeElement != this.dom : !Zy(this.dom, r))
      return;
    let a = r.anchorNode && n.docView.nearest(r.anchorNode);
    if (a && a.ignoreEvent(t)) {
      i || (this.selectionChanged = !1);
      return;
    }
    (te.ie && te.ie_version <= 11 || te.android && te.chrome) && !n.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    r.focusNode && cc(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: t } = this, i = tf(t.root);
    if (!i)
      return !1;
    let n = te.safari && t.root.nodeType == 11 && t.root.activeElement == this.dom && I7(this.view, i) || i;
    if (!n || this.selectionRange.eq(n))
      return !1;
    let r = Zy(this.dom, n);
    return r && !this.selectionChanged && t.inputState.lastFocusTime > Date.now() - 200 && t.inputState.lastTouchTime < Date.now() - 300 && kC(this.dom, n) ? (this.view.inputState.lastFocusTime = 0, t.docView.updateSelection(), !1) : (this.selectionRange.setRange(n), r && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(t, i) {
    this.selectionRange.set(t.node, t.offset, i.node, i.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let t = 0, i = null;
    for (let n = this.dom; n; )
      if (n.nodeType == 1)
        !i && t < this.scrollTargets.length && this.scrollTargets[t] == n ? t++ : i || (i = this.scrollTargets.slice(0, t)), i && i.push(n), n = n.assignedSlot || n.parentNode;
      else if (n.nodeType == 11)
        n = n.host;
      else
        break;
    if (t < this.scrollTargets.length && !i && (i = this.scrollTargets.slice(0, t)), i) {
      for (let n of this.scrollTargets)
        n.removeEventListener("scroll", this.onScroll);
      for (let n of this.scrollTargets = i)
        n.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(t) {
    if (!this.active)
      return t();
    try {
      return this.stop(), t();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, nI), Dv && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), Dv && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(t, i) {
    var n;
    if (!this.delayedAndroidKey) {
      let r = /* @__PURE__ */ m(() => {
        let a = this.delayedAndroidKey;
        a && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = a.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && a.force && Pa(this.dom, a.key, a.keyCode));
      }, "flush");
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(r);
    }
    (!this.delayedAndroidKey || t == "Enter") && (this.delayedAndroidKey = {
      key: t,
      keyCode: i,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((n = this.delayedAndroidKey) === null || n === void 0) && n.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let t of this.observer.takeRecords())
      this.queue.push(t);
    return this.queue;
  }
  processRecords() {
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let i = -1, n = -1, r = !1;
    for (let a of t) {
      let o = this.readMutation(a);
      o && (o.typeOver && (r = !0), i == -1 ? { from: i, to: n } = o : (i = Math.min(o.from, i), n = Math.max(o.to, n)));
    }
    return { from: i, to: n, typeOver: r };
  }
  readChange() {
    let { from: t, to: i, typeOver: n } = this.processRecords(), r = this.selectionChanged && Zy(this.dom, this.selectionRange);
    if (t < 0 && !r)
      return null;
    t > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let a = new UL(this.view, t, i, n);
    return this.view.docView.domChanged = { newSel: a.newSel ? a.newSel.main : null }, a;
  }
  // Apply pending changes, if any
  flush(t = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    t && this.readSelectionRange();
    let i = this.readChange();
    if (!i)
      return this.view.requestMeasure(), !1;
    let n = this.view.state, r = Qx(this.view, i);
    return this.view.state == n && (i.domChanged || i.newSel && !i.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), r;
  }
  readMutation(t) {
    let i = this.view.docView.nearest(t.target);
    if (!i || i.ignoreMutation(t))
      return null;
    if (i.markDirty(t.type == "attributes"), t.type == "attributes" && (i.flags |= 4), t.type == "childList") {
      let n = o2(i, t.previousSibling || t.target.previousSibling, -1), r = o2(i, t.nextSibling || t.target.nextSibling, 1);
      return {
        from: n ? i.posAfter(n) : i.posAtStart,
        to: r ? i.posBefore(r) : i.posAtEnd,
        typeOver: !1
      };
    } else return t.type == "characterData" ? { from: i.posAtStart, to: i.posAtEnd, typeOver: t.target.nodeValue == t.oldValue } : null;
  }
  setWindow(t) {
    t != this.win && (this.removeWindowListeners(this.win), this.win = t, this.addWindowListeners(this.win));
  }
  addWindowListeners(t) {
    t.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : t.addEventListener("beforeprint", this.onPrint), t.addEventListener("scroll", this.onScroll), t.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(t) {
    t.removeEventListener("scroll", this.onScroll), t.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : t.removeEventListener("beforeprint", this.onPrint), t.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(t) {
    this.editContext && (this.editContext.update(t), t.startState.facet(ds) != t.state.facet(ds) && (t.view.contentDOM.editContext = t.state.facet(ds) ? this.editContext.editContext : null));
  }
  destroy() {
    var t, i, n;
    this.stop(), (t = this.intersection) === null || t === void 0 || t.disconnect(), (i = this.gapIntersection) === null || i === void 0 || i.disconnect(), (n = this.resizeScroll) === null || n === void 0 || n.disconnect();
    for (let r of this.scrollTargets)
      r.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}, u(rh, "gf"), rh);
m(L7, "DOMObserver");
let sI = L7;
function o2(s, t, i) {
  for (; t; ) {
    let n = Ge.get(t);
    if (n && n.parent == s)
      return n;
    let r = t.parentNode;
    t = r != s.dom ? r : i > 0 ? t.nextSibling : t.previousSibling;
  }
  return null;
}
u(o2, "fu$1");
m(o2, "findChild");
function l2(s, t) {
  let i = t.startContainer, n = t.startOffset, r = t.endContainer, a = t.endOffset, o = s.docView.domAtPos(s.state.selection.main.anchor);
  return cc(o.node, o.offset, r, a) && ([i, n, r, a] = [r, a, i, n]), { anchorNode: i, anchorOffset: n, focusNode: r, focusOffset: a };
}
u(l2, "cu$1");
m(l2, "buildSelectionRangeFromRange");
function I7(s, t) {
  if (t.getComposedRanges) {
    let r = t.getComposedRanges(s.root)[0];
    if (r)
      return l2(s, r);
  }
  let i = null;
  function n(r) {
    r.preventDefault(), r.stopImmediatePropagation(), i = r.getTargetRanges()[0];
  }
  return u(n, "i"), m(n, "read"), s.contentDOM.addEventListener("beforeinput", n, !0), s.dom.ownerDocument.execCommand("indent"), s.contentDOM.removeEventListener("beforeinput", n, !0), i ? l2(s, i) : null;
}
u(I7, "F0$1");
m(I7, "safariSelectionRangeHack");
var ah;
const W7 = (ah = class {
  constructor(t) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.composing = null, this.resetRange(t.state);
    let i = this.editContext = new window.EditContext({
      text: t.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, t.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(t.state.selection.main.head)
    });
    this.handlers.textupdate = (n) => {
      let r = t.state.selection.main, { anchor: a, head: o } = r, l = this.toEditorPos(n.updateRangeStart), c = this.toEditorPos(n.updateRangeEnd);
      t.inputState.composing >= 0 && !this.composing && (this.composing = { contextBase: n.updateRangeStart, editorBase: l, drifted: !1 });
      let h = { from: l, to: c, insert: Ie.of(n.text.split(`
`)) };
      if (h.from == this.from && a < this.from ? h.from = a : h.to == this.to && a > this.to && (h.to = a), h.from == h.to && !h.insert.length) {
        let d = J.single(this.toEditorPos(n.selectionStart), this.toEditorPos(n.selectionEnd));
        d.main.eq(r) || t.dispatch({ selection: d, userEvent: "select" });
        return;
      }
      if ((te.mac || te.android) && h.from == o - 1 && /^\. ?$/.test(n.text) && t.contentDOM.getAttribute("autocorrect") == "off" && (h = { from: l, to: c, insert: Ie.of([n.text.replace(".", " ")]) }), this.pendingContextChange = h, !t.state.readOnly) {
        let d = this.to - this.from + (h.to - h.from + h.insert.length);
        V1(t, h, J.single(this.toEditorPos(n.selectionStart, d), this.toEditorPos(n.selectionEnd, d)));
      }
      this.pendingContextChange && (this.revertPending(t.state), this.setSelection(t.state));
    }, this.handlers.characterboundsupdate = (n) => {
      let r = [], a = null;
      for (let o = this.toEditorPos(n.rangeStart), l = this.toEditorPos(n.rangeEnd); o < l; o++) {
        let c = t.coordsForChar(o);
        a = c && new DOMRect(c.left, c.top, c.right - c.left, c.bottom - c.top) || a || new DOMRect(), r.push(a);
      }
      i.updateCharacterBounds(n.rangeStart, r);
    }, this.handlers.textformatupdate = (n) => {
      let r = [];
      for (let a of n.getTextFormats()) {
        let o = a.underlineStyle, l = a.underlineThickness;
        if (o != "None" && l != "None") {
          let c = this.toEditorPos(a.rangeStart), h = this.toEditorPos(a.rangeEnd);
          if (c < h) {
            let d = `text-decoration: underline ${o == "Dashed" ? "dashed " : o == "Squiggle" ? "wavy " : ""}${l == "Thin" ? 1 : 2}px`;
            r.push(Xe.mark({ attributes: { style: d } }).range(c, h));
          }
        }
      }
      t.dispatch({ effects: p9.of(Xe.set(r)) });
    }, this.handlers.compositionstart = () => {
      t.inputState.composing < 0 && (t.inputState.composing = 0, t.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (t.inputState.composing = -1, t.inputState.compositionFirstChange = null, this.composing) {
        let { drifted: n } = this.composing;
        this.composing = null, n && this.reset(t.state);
      }
    };
    for (let n in this.handlers)
      i.addEventListener(n, this.handlers[n]);
    this.measureReq = { read: /* @__PURE__ */ m((n) => {
      this.editContext.updateControlBounds(n.contentDOM.getBoundingClientRect());
      let r = tf(n.root);
      r && r.rangeCount && this.editContext.updateSelectionBounds(r.getRangeAt(0).getBoundingClientRect());
    }, "read") };
  }
  applyEdits(t) {
    let i = 0, n = !1, r = this.pendingContextChange;
    return t.changes.iterChanges((a, o, l, c, h) => {
      if (n)
        return;
      let d = h.length - (o - a);
      if (r && o >= r.to)
        if (r.from == a && r.to == o && r.insert.eq(h)) {
          r = this.pendingContextChange = null, i += d, this.to += d;
          return;
        } else
          r = null, this.revertPending(t.state);
      if (a += i, o += i, o <= this.from)
        this.from += d, this.to += d;
      else if (a < this.to) {
        if (a < this.from || o > this.to || this.to - this.from + h.length > 3e4) {
          n = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(a), this.toContextPos(o), h.toString()), this.to += d;
      }
      i += d;
    }), r && !n && this.revertPending(t.state), !n;
  }
  update(t) {
    let i = this.pendingContextChange;
    this.composing && (this.composing.drifted || t.transactions.some((n) => !n.isUserEvent("input.type") && n.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = t.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(t) || !this.rangeIsValid(t.state) ? (this.pendingContextChange = null, this.reset(t.state)) : (t.docChanged || t.selectionSet || i) && this.setSelection(t.state), (t.geometryChanged || t.docChanged || t.selectionSet) && t.view.requestMeasure(this.measureReq);
  }
  resetRange(t) {
    let { head: i } = t.selection.main;
    this.from = Math.max(
      0,
      i - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      t.doc.length,
      i + 1e4
      /* CxVp.Margin */
    );
  }
  reset(t) {
    this.resetRange(t), this.editContext.updateText(0, this.editContext.text.length, t.doc.sliceString(this.from, this.to)), this.setSelection(t);
  }
  revertPending(t) {
    let i = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(i.from), this.toContextPos(i.from + i.insert.length), t.doc.sliceString(i.from, i.to));
  }
  setSelection(t) {
    let { main: i } = t.selection, n = this.toContextPos(Math.max(this.from, Math.min(this.to, i.anchor))), r = this.toContextPos(i.head);
    (this.editContext.selectionStart != n || this.editContext.selectionEnd != r) && this.editContext.updateSelection(n, r);
  }
  rangeIsValid(t) {
    let { head: i } = t.selection.main;
    return !(this.from > 0 && i - this.from < 500 || this.to < t.doc.length && this.to - i < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(t, i = this.to - this.from) {
    t = Math.min(t, i);
    let n = this.composing;
    return n && n.drifted ? n.editorBase + (t - n.contextBase) : t + this.from;
  }
  toContextPos(t) {
    let i = this.composing;
    return i && i.drifted ? i.contextBase + (t - i.editorBase) : t - this.from;
  }
  destroy() {
    for (let t in this.handlers)
      this.editContext.removeEventListener(t, this.handlers[t]);
  }
}, u(ah, "bf"), ah);
m(W7, "EditContextManager");
let rI = W7;
var ur;
const V7 = (ur = class {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(t = {}) {
    var i;
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), t.parent && t.parent.appendChild(this.dom);
    let { dispatch: n } = t;
    this.dispatchTransactions = t.dispatchTransactions || n && ((r) => r.forEach((a) => n(a, this))) || ((r) => this.update(r)), this.dispatch = this.dispatch.bind(this), this._root = t.root || xC(t.parent) || document, this.viewState = new oP(t.state || kt.create(t)), t.scrollTo && t.scrollTo.is(Ow) && (this.viewState.scrollTarget = t.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(gy).map((r) => new Wv(r));
    for (let r of this.plugins)
      r.update(this);
    this.observer = new sI(this), this.inputState = new NL(this), this.inputState.ensureHandlers(this.plugins), this.docView = new JS(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((i = document.fonts) === null || i === void 0) && i.ready && document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...t) {
    let i = t.length == 1 && t[0] instanceof di ? t : t.length == 1 && Array.isArray(t[0]) ? t[0] : [this.state.update(...t)];
    this.dispatchTransactions(i, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let i = !1, n = !1, r, a = this.state;
    for (let y of t) {
      if (y.startState != a)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      a = y.state;
    }
    if (this.destroyed) {
      this.viewState.state = a;
      return;
    }
    let o = this.hasFocus, l = 0, c = null;
    t.some((y) => y.annotation(c7)) ? (this.inputState.notifiedFocused = o, l = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, c = Rx(a, o), c || (l = 1));
    let h = this.observer.delayedAndroidKey, d = null;
    if (h ? (this.observer.clearDelayedAndroidKey(), d = this.observer.readChange(), (d && !this.state.doc.eq(a.doc) || !this.state.selection.eq(a.selection)) && (d = null)) : this.observer.clear(), a.facet(kt.phrases) != this.state.facet(kt.phrases))
      return this.setState(a);
    r = KS.create(this, a, t), r.flags |= l;
    let f = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let y of t) {
        if (f && (f = f.map(y.changes)), y.scrollIntoView) {
          let { main: w } = y.state.selection;
          f = new Iv(w.empty ? w : J.cursor(w.head, w.head > w.anchor ? -1 : 1));
        }
        for (let w of y.effects)
          w.is(Ow) && (f = w.value.clip(this.state));
      }
      this.viewState.update(r, f), this.bidiCache = hP.update(this.bidiCache, r.changes), r.empty || (this.updatePlugins(r), this.inputState.update(r)), i = this.docView.update(r), this.state.facet(vy) != this.styleModules && this.mountStyles(), n = this.updateAttrs(), this.showAnnouncements(t), this.docView.updateSelection(i, t.some((y) => y.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (r.startState.facet(xw) != r.state.facet(xw) && (this.viewState.mustMeasureContent = !0), (i || n || f || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), i && this.docViewUpdate(), !r.empty)
      for (let y of this.state.facet(B0))
        try {
          y(r);
        } catch (w) {
          gi(this.state, w, "update listener");
        }
    (c || d) && Promise.resolve().then(() => {
      c && this.state == c.startState && this.dispatch(c), d && !Qx(this, d) && h.force && Pa(this.contentDOM, h.key, h.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = t;
      return;
    }
    this.updateState = 2;
    let i = this.hasFocus;
    try {
      for (let n of this.plugins)
        n.destroy(this);
      this.viewState = new oP(t), this.plugins = t.facet(gy).map((n) => new Wv(n)), this.pluginMap.clear();
      for (let n of this.plugins)
        n.update(this);
      this.docView.destroy(), this.docView = new JS(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    i && this.focus(), this.requestMeasure();
  }
  updatePlugins(t) {
    let i = t.startState.facet(gy), n = t.state.facet(gy);
    if (i != n) {
      let r = [];
      for (let a of n) {
        let o = i.indexOf(a);
        if (o < 0)
          r.push(new Wv(a));
        else {
          let l = this.plugins[o];
          l.mustUpdate = t, r.push(l);
        }
      }
      for (let a of this.plugins)
        a.mustUpdate != t && a.destroy(this);
      this.plugins = r, this.pluginMap.clear();
    } else
      for (let r of this.plugins)
        r.mustUpdate = t;
    for (let r = 0; r < this.plugins.length; r++)
      this.plugins[r].update(this);
    i != n && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let t of this.plugins) {
      let i = t.value;
      if (i && i.docViewUpdate)
        try {
          i.docViewUpdate(this);
        } catch (n) {
          gi(this.state, n, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(t = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, t && this.observer.forceFlush();
    let i = null, n = this.scrollDOM, r = n.scrollTop * this.scaleY, { scrollAnchorPos: a, scrollAnchorHeight: o } = this.viewState;
    Math.abs(r - this.viewState.scrollTop) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let l = 0; ; l++) {
        if (o < 0)
          if (rx(n))
            a = -1, o = this.viewState.heightMap.height;
          else {
            let w = this.viewState.scrollAnchorAt(r);
            a = w.from, o = w.top;
          }
        this.updateState = 1;
        let c = this.viewState.measure(this);
        if (!c && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (l > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let h = [];
        c & 4 || ([this.measureRequests, h] = [h, this.measureRequests]);
        let d = h.map((w) => {
          try {
            return w.read(this);
          } catch (g) {
            return gi(this.state, g), cP;
          }
        }), f = KS.create(this, this.state, []), y = !1;
        f.flags |= c, i ? i.flags |= c : i = f, this.updateState = 2, f.empty || (this.updatePlugins(f), this.inputState.update(f), this.updateAttrs(), y = this.docView.update(f), y && this.docViewUpdate());
        for (let w = 0; w < h.length; w++)
          if (d[w] != cP)
            try {
              let g = h[w];
              g.write && g.write(d[w], this);
            } catch (g) {
              gi(this.state, g);
            }
        if (y && this.docView.updateSelection(!0), !f.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, o = -1;
              continue;
            } else {
              let w = (a < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(a).top) - o;
              if (w > 1 || w < -1) {
                r = r + w, n.scrollTop = r / this.scaleY, o = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (i && !i.empty)
      for (let l of this.state.facet(B0))
        l(i);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return a2 + " " + (this.state.facet(r2) ? z7 : E7) + " " + this.state.facet(xw);
  }
  updateAttrs() {
    let t = c2(this, m9, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), i = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: this.state.facet(ds) ? "true" : "false",
      class: "cm-content",
      style: `${te.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (i["aria-readonly"] = "true"), c2(this, kx, i);
    let n = this.observer.ignore(() => {
      let r = zg(this.contentDOM, this.contentAttrs, i), a = zg(this.dom, this.editorAttrs, t);
      return r || a;
    });
    return this.editorAttrs = t, this.contentAttrs = i, n;
  }
  showAnnouncements(t) {
    let i = !0;
    for (let n of t)
      for (let r of n.effects)
        if (r.is(ur.announce)) {
          i && (this.announceDOM.textContent = ""), i = !1;
          let a = this.announceDOM.appendChild(document.createElement("div"));
          a.textContent = r.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(vy);
    let t = this.state.facet(ur.cspNonce);
    kr.mount(this.root, this.styleModules.concat(iI).reverse(), t ? { nonce: t } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(t) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), t) {
      if (this.measureRequests.indexOf(t) > -1)
        return;
      if (t.key != null) {
        for (let i = 0; i < this.measureRequests.length; i++)
          if (this.measureRequests[i].key === t.key) {
            this.measureRequests[i] = t;
            return;
          }
      }
      this.measureRequests.push(t);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(t) {
    let i = this.pluginMap.get(t);
    return (i === void 0 || i && i.spec != t) && this.pluginMap.set(t, i = this.plugins.find((n) => n.spec == t) || null), i && i.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(t) {
    return this.readMeasured(), this.viewState.elementAtHeight(t);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(t) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(t);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(t) {
    return this.viewState.lineBlockAt(t);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(t, i, n) {
    return qw(this, t, G0(this, t, i, n));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(t, i) {
    return qw(this, t, G0(this, t, i, (n) => L9(this, t.head, n)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(t, i) {
    let n = this.bidiSpans(t), r = this.textDirectionAt(t.from), a = n[i ? n.length - 1 : 0];
    return J.cursor(a.side(i, r) + t.from, a.forward(!i, r) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(t, i, n = !0) {
    return _9(this, t, i, n);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(t, i, n) {
    return qw(this, t, I9(this, t, i, n));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(t) {
    return this.docView.domAtPos(t);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(t, i = 0) {
    return this.docView.posFromDOM(t, i);
  }
  posAtCoords(t, i = !0) {
    return this.readMeasured(), Cx(this, t, i);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(t, i = 1) {
    this.readMeasured();
    let n = this.docView.coordsAt(t, i);
    if (!n || n.left == n.right)
      return n;
    let r = this.state.doc.lineAt(t), a = this.bidiSpans(r), o = a[Gs.find(a, t - r.from, -1, i)];
    return Af(n, o.dir == gt.LTR == i > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(t) {
    return this.readMeasured(), this.docView.coordsForChar(t);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(t) {
    return !this.state.facet(h9) || t < this.viewport.from || t > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(t));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(t) {
    if (t.length > aI)
      return bx(t.length);
    let i = this.textDirectionAt(t.from), n;
    for (let a of this.bidiCache)
      if (a.from == t.from && a.dir == i && (a.fresh || Ox(a.isolates, n = j0(this, t))))
        return a.order;
    n || (n = j0(this, t));
    let r = e9(t.text, i, n);
    return this.bidiCache.push(new hP(t.from, t.to, i, n, !0, r)), r;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var t;
    return (this.dom.ownerDocument.hasFocus() || te.safari && ((t = this.inputState) === null || t === void 0 ? void 0 : t.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      nx(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(t) {
    this._root != t && (this._root = t, this.observer.setWindow((t.nodeType == 9 ? t : t.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let t of this.plugins)
      t.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(t, i = {}) {
    return Ow.of(new Iv(typeof t == "number" ? J.cursor(t) : t, i.y, i.x, i.yMargin, i.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: t, scrollLeft: i } = this.scrollDOM, n = this.viewState.scrollAnchorAt(t);
    return Ow.of(new Iv(J.cursor(n.from), "start", "start", n.top - t, i, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(t) {
    t == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof t == "boolean" ? this.inputState.tabFocusMode = t ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + t);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(t) {
    return Ps.define(() => ({}), { eventHandlers: t });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(t) {
    return Ps.define(() => ({}), { eventObservers: t });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(t, i) {
    let n = kr.newName(), r = [xw.of(n), vy.of(Wg(`.${n}`, t))];
    return i && i.dark && r.push(r2.of(!0)), r;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(t) {
    return Lo.lowest(vy.of(Wg("." + a2, t, _7)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(t) {
    var i;
    let n = t.querySelector(".cm-content"), r = n && Ge.get(n) || Ge.get(t);
    return ((i = r == null ? void 0 : r.rootView) === null || i === void 0 ? void 0 : i.view) || null;
  }
}, u(ur, "_r"), ur);
m(V7, "EditorView");
let $e = V7;
$e.styleModule = vy;
$e.inputHandler = l9;
$e.clipboardInputFilter = $x;
$e.clipboardOutputFilter = xx;
$e.scrollHandler = d9;
$e.focusChangeEffect = c9;
$e.perLineTextDirection = h9;
$e.exceptionSink = o9;
$e.updateListener = B0;
$e.editable = ds;
$e.mouseSelectionStyle = a9;
$e.dragMovesSelection = r9;
$e.clickAddsSelectionRange = s9;
$e.decorations = im;
$e.outerDecorations = w9;
$e.atomicRanges = Sx;
$e.bidiIsolatedRanges = g9;
$e.scrollMargins = v9;
$e.darkTheme = r2;
$e.cspNonce = /* @__PURE__ */ me.define({ combine: /* @__PURE__ */ m((s) => s.length ? s[0] : "", "combine") });
$e.contentAttributes = kx;
$e.editorAttributes = m9;
$e.lineWrapping = /* @__PURE__ */ $e.contentAttributes.of({ class: "cm-lineWrapping" });
$e.announce = /* @__PURE__ */ qe.define();
const aI = 4096, cP = {};
var Fa;
const Z7 = (Fa = class {
  constructor(t, i, n, r, a, o) {
    this.from = t, this.to = i, this.dir = n, this.isolates = r, this.fresh = a, this.order = o;
  }
  static update(t, i) {
    if (i.empty && !t.some((a) => a.fresh))
      return t;
    let n = [], r = t.length ? t[t.length - 1].dir : gt.LTR;
    for (let a = Math.max(0, t.length - 10); a < t.length; a++) {
      let o = t[a];
      o.dir == r && !i.touchesRange(o.from, o.to) && n.push(new Fa(i.mapPos(o.from, 1), i.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return n;
  }
}, u(Fa, "Hs"), Fa);
m(Z7, "CachedOrder");
let hP = Z7;
function c2(s, t, i) {
  for (let n = s.state.facet(t), r = n.length - 1; r >= 0; r--) {
    let a = n[r], o = typeof a == "function" ? a(s) : a;
    o && Eg(o, i);
  }
  return i;
}
u(c2, "du$1");
m(c2, "attrsFromFacet");
const oI = te.mac ? "mac" : te.windows ? "win" : te.linux ? "linux" : "key";
function D7(s, t) {
  const i = s.split(/-(?!$)/);
  let n = i[i.length - 1];
  n == "Space" && (n = " ");
  let r, a, o, l;
  for (let c = 0; c < i.length - 1; ++c) {
    const h = i[c];
    if (/^(cmd|meta|m)$/i.test(h))
      l = !0;
    else if (/^a(lt)?$/i.test(h))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(h))
      a = !0;
    else if (/^s(hift)?$/i.test(h))
      o = !0;
    else if (/^mod$/i.test(h))
      t == "mac" ? l = !0 : a = !0;
    else
      throw new Error("Unrecognized modifier name: " + h);
  }
  return r && (n = "Alt-" + n), a && (n = "Ctrl-" + n), l && (n = "Meta-" + n), o && (n = "Shift-" + n), n;
}
u(D7, "J0$1");
m(D7, "normalizeKeyName");
function ky(s, t, i) {
  return t.altKey && (s = "Alt-" + s), t.ctrlKey && (s = "Ctrl-" + s), t.metaKey && (s = "Meta-" + s), i !== !1 && t.shiftKey && (s = "Shift-" + s), s;
}
u(ky, "Zn$1");
m(ky, "modifiers");
const lI = /* @__PURE__ */ Lo.default(/* @__PURE__ */ $e.domEventHandlers({
  keydown(s, t) {
    return N7(q7(t.state), s, t, "editor");
  }
})), Z1 = /* @__PURE__ */ me.define({ enables: lI }), dP = /* @__PURE__ */ new WeakMap();
function q7(s) {
  let t = s.facet(Z1), i = dP.get(t);
  return i || dP.set(t, i = U7(t.reduce((n, r) => n.concat(r), []))), i;
}
u(q7, "tb$1");
m(q7, "getKeymap");
let Ys = null;
const cI = 4e3;
function U7(s, t = oI) {
  let i = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ m((o, l) => {
    let c = n[o];
    if (c == null)
      n[o] = l;
    else if (c != l)
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
  }, "checkPrefix"), a = /* @__PURE__ */ m((o, l, c, h, d) => {
    var f, y;
    let w = i[o] || (i[o] = /* @__PURE__ */ Object.create(null)), g = l.split(/ (?!$)/).map(($) => D7($, t));
    for (let $ = 1; $ < g.length; $++) {
      let C = g.slice(0, $).join(" ");
      r(C, !0), w[C] || (w[C] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(E) => {
          let A = Ys = { view: E, prefix: C, scope: o };
          return setTimeout(() => {
            Ys == A && (Ys = null);
          }, cI), !0;
        }]
      });
    }
    let b = g.join(" ");
    r(b, !1);
    let k = w[b] || (w[b] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((y = (f = w._any) === null || f === void 0 ? void 0 : f.run) === null || y === void 0 ? void 0 : y.slice()) || []
    });
    c && k.run.push(c), h && (k.preventDefault = !0), d && (k.stopPropagation = !0);
  }, "add");
  for (let o of s) {
    let l = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any)
      for (let h of l) {
        let d = i[h] || (i[h] = /* @__PURE__ */ Object.create(null));
        d._any || (d._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        let { any: f } = o;
        for (let y in d)
          d[y].run.push((w) => f(w, h2));
      }
    let c = o[t] || o.key;
    if (c)
      for (let h of l)
        a(h, c, o.run, o.preventDefault, o.stopPropagation), o.shift && a(h, "Shift-" + c, o.shift, o.preventDefault, o.stopPropagation);
  }
  return i;
}
u(U7, "rb$1");
m(U7, "buildKeymap");
let h2 = null;
function N7(s, t, i, n) {
  h2 = t;
  let r = gC(t), a = Bs(r, 0), o = va(a) == r.length && r != " ", l = "", c = !1, h = !1, d = !1;
  Ys && Ys.view == i && Ys.scope == n && (l = Ys.prefix + " ", H9.indexOf(t.keyCode) < 0 && (h = !0, Ys = null));
  let f = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ m((k) => {
    if (k) {
      for (let $ of k.run)
        if (!f.has($) && (f.add($), $(i)))
          return k.stopPropagation && (d = !0), !0;
      k.preventDefault && (k.stopPropagation && (d = !0), h = !0);
    }
    return !1;
  }, "runFor"), w = s[n], g, b;
  return w && (y(w[l + ky(r, t, !o)]) ? c = !0 : o && (t.altKey || t.metaKey || t.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(te.windows && t.ctrlKey && t.altKey) && (g = Sr[t.keyCode]) && g != r ? (y(w[l + ky(g, t, !0)]) || t.shiftKey && (b = Jy[t.keyCode]) != r && b != g && y(w[l + ky(b, t, !1)])) && (c = !0) : o && t.shiftKey && y(w[l + ky(r, t, !0)]) && (c = !0), !c && y(w._any) && (c = !0)), h && (c = !0), c && d && t.stopPropagation(), h2 = null, c;
}
u(N7, "nb$1");
m(N7, "runHandlers");
const B7 = /* @__PURE__ */ qe.define({
  map(s, t) {
    return s == null ? null : t.mapPos(s);
  }
}), Sy = /* @__PURE__ */ As.define({
  create() {
    return null;
  },
  update(s, t) {
    return s != null && (s = t.changes.mapPos(s)), t.effects.reduce((i, n) => n.is(B7) ? n.value : i, s);
  }
}), hI = /* @__PURE__ */ Ps.fromClass(class {
  constructor(s) {
    this.view = s, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(s) {
    var t;
    let i = s.state.field(Sy);
    i == null ? this.cursor != null && ((t = this.cursor) === null || t === void 0 || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (s.startState.field(Sy) != i || s.docChanged || s.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: s } = this, t = s.state.field(Sy), i = t != null && s.coordsAtPos(t);
    if (!i)
      return null;
    let n = s.scrollDOM.getBoundingClientRect();
    return {
      left: i.left - n.left + s.scrollDOM.scrollLeft * s.scaleX,
      top: i.top - n.top + s.scrollDOM.scrollTop * s.scaleY,
      height: i.bottom - i.top
    };
  }
  drawCursor(s) {
    if (this.cursor) {
      let { scaleX: t, scaleY: i } = this.view;
      s ? (this.cursor.style.left = s.left / t + "px", this.cursor.style.top = s.top / i + "px", this.cursor.style.height = s.height / i + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(s) {
    this.view.state.field(Sy) != s && this.view.dispatch({ effects: B7.of(s) });
  }
}, {
  eventObservers: {
    dragover(s) {
      this.setDropPos(this.view.posAtCoords({ x: s.clientX, y: s.clientY }));
    },
    dragleave(s) {
      (s.target == this.view.contentDOM || !this.view.contentDOM.contains(s.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function dI() {
  return [Sy, hI];
}
u(dI, "lb$1");
m(dI, "dropCursor");
function d2(s, t, i, n, r) {
  t.lastIndex = 0;
  for (let a = s.iterRange(i, n), o = i, l; !a.next().done; o += a.value.length)
    if (!a.lineBreak)
      for (; l = t.exec(a.value); )
        r(o + l.index, l);
}
u(d2, "mu$1");
m(d2, "iterMatches");
function j7(s, t) {
  let i = s.visibleRanges;
  if (i.length == 1 && i[0].from == s.viewport.from && i[0].to == s.viewport.to)
    return i;
  let n = [];
  for (let { from: r, to: a } of i)
    r = Math.max(s.state.doc.lineAt(r).from, r - t), a = Math.min(s.state.doc.lineAt(a).to, a + t), n.length && n[n.length - 1].to >= r ? n[n.length - 1].to = a : n.push({ from: r, to: a });
  return n;
}
u(j7, "ab$1");
m(j7, "matchRanges");
var oh;
const X7 = (oh = class {
  /**
  Create a decorator.
  */
  constructor(t) {
    const { regexp: i, decoration: n, decorate: r, boundary: a, maxLength: o = 1e3 } = t;
    if (!i.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = i, r)
      this.addMatch = (l, c, h, d) => r(d, h, h + l[0].length, l, c);
    else if (typeof n == "function")
      this.addMatch = (l, c, h, d) => {
        let f = n(l, c, h);
        f && d(h, h + l[0].length, f);
      };
    else if (n)
      this.addMatch = (l, c, h, d) => d(h, h + l[0].length, n);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = a, this.maxLength = o;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(t) {
    let i = new Mg(), n = i.add.bind(i);
    for (let { from: r, to: a } of j7(t, this.maxLength))
      d2(t.state.doc, this.regexp, r, a, (o, l) => this.addMatch(l, t, o, n));
    return i.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(t, i) {
    let n = 1e9, r = -1;
    return t.docChanged && t.changes.iterChanges((a, o, l, c) => {
      c >= t.view.viewport.from && l <= t.view.viewport.to && (n = Math.min(l, n), r = Math.max(c, r));
    }), t.viewportMoved || r - n > 1e3 ? this.createDeco(t.view) : r > -1 ? this.updateRange(t.view, i.map(t.changes), n, r) : i;
  }
  updateRange(t, i, n, r) {
    for (let a of t.visibleRanges) {
      let o = Math.max(a.from, n), l = Math.min(a.to, r);
      if (l > o) {
        let c = t.state.doc.lineAt(o), h = c.to < l ? t.state.doc.lineAt(l) : c, d = Math.max(a.from, c.from), f = Math.min(a.to, h.to);
        if (this.boundary) {
          for (; o > c.from; o--)
            if (this.boundary.test(c.text[o - 1 - c.from])) {
              d = o;
              break;
            }
          for (; l < h.to; l++)
            if (this.boundary.test(h.text[l - h.from])) {
              f = l;
              break;
            }
        }
        let y = [], w, g = /* @__PURE__ */ m((b, k, $) => y.push($.range(b, k)), "add");
        if (c == h)
          for (this.regexp.lastIndex = d - c.from; (w = this.regexp.exec(c.text)) && w.index < f - c.from; )
            this.addMatch(w, t, w.index + c.from, g);
        else
          d2(t.state.doc, this.regexp, d, f, (b, k) => this.addMatch(k, t, b, g));
        i = i.update({ filterFrom: d, filterTo: f, filter: /* @__PURE__ */ m((b, k) => b < d || k > f, "filter"), add: y });
      }
    }
    return i;
  }
}, u(oh, "yf"), oh);
m(X7, "MatchDecorator");
let uI = X7;
var lh;
const F7 = (lh = class extends Ef {
  constructor(t) {
    super(), this.content = t;
  }
  toDOM(t) {
    let i = document.createElement("span");
    return i.className = "cm-placeholder", i.style.pointerEvents = "none", i.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(t) : this.content.cloneNode(!0)), typeof this.content == "string" ? i.setAttribute("aria-label", "placeholder " + this.content) : i.setAttribute("aria-hidden", "true"), i;
  }
  coordsAt(t) {
    let i = t.firstChild ? go(t.firstChild) : [];
    if (!i.length)
      return null;
    let n = window.getComputedStyle(t.parentNode), r = Af(i[0], n.direction != "rtl"), a = parseInt(n.lineHeight);
    return r.bottom - r.top > a * 1.5 ? { left: r.left, right: r.right, top: r.top, bottom: r.top + a } : r;
  }
  ignoreEvent() {
    return !1;
  }
}, u(lh, "Sf"), lh);
m(F7, "Placeholder");
let pI = F7;
function fI(s) {
  return Ps.fromClass(class {
    constructor(t) {
      this.view = t, this.placeholder = s ? Xe.set([Xe.widget({ widget: new pI(s), side: 1 }).range(0)]) : Xe.none;
    }
    get decorations() {
      return this.view.state.doc.length ? Xe.none : this.placeholder;
    }
  }, { decorations: /* @__PURE__ */ m((t) => t.decorations, "decorations") });
}
u(fI, "hb$1");
m(fI, "placeholder");
const Xf = "-10000px";
var ch;
const H7 = (ch = class {
  constructor(t, i, n, r) {
    this.facet = i, this.createTooltipView = n, this.removeTooltipView = r, this.input = t.state.facet(i), this.tooltips = this.input.filter((o) => o);
    let a = null;
    this.tooltipViews = this.tooltips.map((o) => a = n(o, a));
  }
  update(t, i) {
    var n;
    let r = t.state.facet(this.facet), a = r.filter((c) => c);
    if (r === this.input) {
      for (let c of this.tooltipViews)
        c.update && c.update(t);
      return !1;
    }
    let o = [], l = i ? [] : null;
    for (let c = 0; c < a.length; c++) {
      let h = a[c], d = -1;
      if (h) {
        for (let f = 0; f < this.tooltips.length; f++) {
          let y = this.tooltips[f];
          y && y.create == h.create && (d = f);
        }
        if (d < 0)
          o[c] = this.createTooltipView(h, c ? o[c - 1] : null), l && (l[c] = !!h.above);
        else {
          let f = o[c] = this.tooltipViews[d];
          l && (l[c] = i[d]), f.update && f.update(t);
        }
      }
    }
    for (let c of this.tooltipViews)
      o.indexOf(c) < 0 && (this.removeTooltipView(c), (n = c.destroy) === null || n === void 0 || n.call(c));
    return i && (l.forEach((c, h) => i[h] = c), i.length = l.length), this.input = r, this.tooltips = a, this.tooltipViews = o, !0;
  }
}, u(ch, "Pf"), ch);
m(H7, "TooltipViewManager");
let yI = H7;
function Y7(s) {
  let { win: t } = s;
  return { top: 0, left: 0, bottom: t.innerHeight, right: t.innerWidth };
}
u(Y7, "fb$1");
m(Y7, "windowSpace");
const qv = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => {
    var t, i, n;
    return {
      position: te.ios ? "absolute" : ((t = s.find((r) => r.position)) === null || t === void 0 ? void 0 : t.position) || "fixed",
      parent: ((i = s.find((r) => r.parent)) === null || i === void 0 ? void 0 : i.parent) || null,
      tooltipSpace: ((n = s.find((r) => r.tooltipSpace)) === null || n === void 0 ? void 0 : n.tooltipSpace) || Y7
    };
  }, "combine")
}), uP = /* @__PURE__ */ new WeakMap(), G7 = /* @__PURE__ */ Ps.fromClass(class {
  constructor(s) {
    this.view = s, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let t = s.state.facet(qv);
    this.position = t.position, this.parent = t.parent, this.classes = s.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new yI(s, K7, (i, n) => this.createTooltip(i, n), (i) => {
      this.resizeObserver && this.resizeObserver.unobserve(i.dom), i.dom.remove();
    }), this.above = this.manager.tooltips.map((i) => !!i.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((i) => {
      Date.now() > this.lastTransaction - 50 && i.length > 0 && i[i.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), s.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let s of this.manager.tooltipViews)
        this.intersectionObserver.observe(s.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(s) {
    s.transactions.length && (this.lastTransaction = Date.now());
    let t = this.manager.update(s, this.above);
    t && this.observeIntersection();
    let i = t || s.geometryChanged, n = s.state.facet(qv);
    if (n.position != this.position && !this.madeAbsolute) {
      this.position = n.position;
      for (let r of this.manager.tooltipViews)
        r.dom.style.position = this.position;
      i = !0;
    }
    if (n.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = n.parent, this.createContainer();
      for (let r of this.manager.tooltipViews)
        this.container.appendChild(r.dom);
      i = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    i && this.maybeMeasure();
  }
  createTooltip(s, t) {
    let i = s.create(this.view), n = t ? t.dom : null;
    if (i.dom.classList.add("cm-tooltip"), s.arrow && !i.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let r = document.createElement("div");
      r.className = "cm-tooltip-arrow", i.dom.appendChild(r);
    }
    return i.dom.style.position = this.position, i.dom.style.top = Xf, i.dom.style.left = "0px", this.container.insertBefore(i.dom, n), i.mount && i.mount(this.view), this.resizeObserver && this.resizeObserver.observe(i.dom), i;
  }
  destroy() {
    var s, t, i;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let n of this.manager.tooltipViews)
      n.dom.remove(), (s = n.destroy) === null || s === void 0 || s.call(n);
    this.parent && this.container.remove(), (t = this.resizeObserver) === null || t === void 0 || t.disconnect(), (i = this.intersectionObserver) === null || i === void 0 || i.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let s = 1, t = 1, i = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: a } = this.manager.tooltipViews[0];
      if (te.gecko)
        i = a.offsetParent != this.container.ownerDocument.body;
      else if (a.style.top == Xf && a.style.left == "0px") {
        let o = a.getBoundingClientRect();
        i = Math.abs(o.top + 1e4) > 1 || Math.abs(o.left) > 1;
      }
    }
    if (i || this.position == "absolute")
      if (this.parent) {
        let a = this.parent.getBoundingClientRect();
        a.width && a.height && (s = a.width / this.parent.offsetWidth, t = a.height / this.parent.offsetHeight);
      } else
        ({ scaleX: s, scaleY: t } = this.view.viewState);
    let n = this.view.scrollDOM.getBoundingClientRect(), r = W1(this.view);
    return {
      visible: {
        left: n.left + r.left,
        top: n.top + r.top,
        right: n.right - r.right,
        bottom: n.bottom - r.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((a, o) => {
        let l = this.manager.tooltipViews[o];
        return l.getCoords ? l.getCoords(a.pos) : this.view.coordsAtPos(a.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: a }) => a.getBoundingClientRect()),
      space: this.view.state.facet(qv).tooltipSpace(this.view),
      scaleX: s,
      scaleY: t,
      makeAbsolute: i
    };
  }
  writeMeasure(s) {
    var t;
    if (s.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let l of this.manager.tooltipViews)
        l.dom.style.position = "absolute";
    }
    let { visible: i, space: n, scaleX: r, scaleY: a } = s, o = [];
    for (let l = 0; l < this.manager.tooltips.length; l++) {
      let c = this.manager.tooltips[l], h = this.manager.tooltipViews[l], { dom: d } = h, f = s.pos[l], y = s.size[l];
      if (!f || c.clip !== !1 && (f.bottom <= Math.max(i.top, n.top) || f.top >= Math.min(i.bottom, n.bottom) || f.right < Math.max(i.left, n.left) - 0.1 || f.left > Math.min(i.right, n.right) + 0.1)) {
        d.style.top = Xf;
        continue;
      }
      let w = c.arrow ? h.dom.querySelector(".cm-tooltip-arrow") : null, g = w ? 7 : 0, b = y.right - y.left, k = (t = uP.get(h)) !== null && t !== void 0 ? t : y.bottom - y.top, $ = h.offset || wI, C = this.view.textDirection == gt.LTR, E = y.width > n.right - n.left ? C ? n.left : n.right - y.width : C ? Math.max(n.left, Math.min(f.left - (w ? 14 : 0) + $.x, n.right - b)) : Math.min(Math.max(n.left, f.left - b + (w ? 14 : 0) - $.x), n.right - b), A = this.above[l];
      !c.strictSide && (A ? f.top - k - g - $.y < n.top : f.bottom + k + g + $.y > n.bottom) && A == n.bottom - f.bottom > f.top - n.top && (A = this.above[l] = !A);
      let R = (A ? f.top - n.top : n.bottom - f.bottom) - g;
      if (R < k && h.resize !== !1) {
        if (R < this.view.defaultLineHeight) {
          d.style.top = Xf;
          continue;
        }
        uP.set(h, k), d.style.height = (k = R) / a + "px";
      } else d.style.height && (d.style.height = "");
      let L = A ? f.top - k - g - $.y : f.bottom + g + $.y, I = E + b;
      if (h.overlap !== !0)
        for (let D of o)
          D.left < I && D.right > E && D.top < L + k && D.bottom > L && (L = A ? D.top - k - 2 - g : D.bottom + g + 2);
      if (this.position == "absolute" ? (d.style.top = (L - s.parent.top) / a + "px", u2(d, (E - s.parent.left) / r)) : (d.style.top = L / a + "px", u2(d, E / r)), w) {
        let D = f.left + (C ? $.x : -$.x) - (E + 14 - 7);
        w.style.left = D / r + "px";
      }
      h.overlap !== !0 && o.push({ left: E, top: L, right: I, bottom: L + k }), d.classList.toggle("cm-tooltip-above", A), d.classList.toggle("cm-tooltip-below", !A), h.positioned && h.positioned(s.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let s of this.manager.tooltipViews)
        s.dom.style.top = Xf;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function u2(s, t) {
  let i = parseInt(s.style.left, 10);
  (isNaN(i) || Math.abs(t - i) > 1) && (s.style.left = t + "px");
}
u(u2, "bu$1");
m(u2, "setLeftStyle");
const mI = /* @__PURE__ */ $e.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), wI = { x: 0, y: 0 }, K7 = /* @__PURE__ */ me.define({
  enables: [G7, mI]
});
function Ex(s, t) {
  let i = s.plugin(G7);
  if (!i)
    return null;
  let n = i.manager.tooltips.indexOf(t);
  return n < 0 ? null : i.manager.tooltipViews[n];
}
u(Ex, "BO");
m(Ex, "getTooltip");
var hh;
const J7 = (hh = class extends wo {
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(t) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(t) {
  }
}, u(hh, "wf"), hh);
m(J7, "GutterMarker");
let of = J7;
of.prototype.elementClass = "";
of.prototype.toDOM = void 0;
of.prototype.mapMode = hi.TrackBefore;
of.prototype.startSide = of.prototype.endSide = -1;
of.prototype.point = !0;
const e8 = 1024;
let gI = 0;
var dh;
const t8 = (dh = class {
  constructor(t, i) {
    this.from = t, this.to = i;
  }
}, u(dh, "xf"), dh);
m(t8, "Range");
let qi = t8;
var uh;
const i8 = (uh = class {
  /**
  Create a new node prop type.
  */
  constructor(t = {}) {
    this.id = gI++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(t) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = Et.match(t)), (i) => {
      let n = t(i);
      return n === void 0 ? null : [this, n];
    };
  }
}, u(uh, "Qf"), uh);
m(i8, "NodeProp");
let Oe = i8;
Oe.closedBy = new Oe({ deserialize: /* @__PURE__ */ m((s) => s.split(" "), "deserialize") });
Oe.openedBy = new Oe({ deserialize: /* @__PURE__ */ m((s) => s.split(" "), "deserialize") });
Oe.group = new Oe({ deserialize: /* @__PURE__ */ m((s) => s.split(" "), "deserialize") });
Oe.isolate = new Oe({ deserialize: /* @__PURE__ */ m((s) => {
  if (s && s != "rtl" && s != "ltr" && s != "auto")
    throw new RangeError("Invalid value for isolate: " + s);
  return s || "auto";
}, "deserialize") });
Oe.contextHash = new Oe({ perNode: !0 });
Oe.lookAhead = new Oe({ perNode: !0 });
Oe.mounted = new Oe({ perNode: !0 });
var ph;
const n8 = (ph = class {
  constructor(t, i, n) {
    this.tree = t, this.overlay = i, this.parser = n;
  }
  /**
  @internal
  */
  static get(t) {
    return t && t.props && t.props[Oe.mounted.id];
  }
}, u(ph, "kf"), ph);
m(n8, "MountedTree");
let sm = n8;
const vI = /* @__PURE__ */ Object.create(null);
var Ha;
const s8 = (Ha = class {
  /**
  @internal
  */
  constructor(t, i, n, r = 0) {
    this.name = t, this.props = i, this.id = n, this.flags = r;
  }
  /**
  Define a node type.
  */
  static define(t) {
    let i = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : vI, n = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), r = new Ha(t.name || "", i, t.id, n);
    if (t.props) {
      for (let a of t.props)
        if (Array.isArray(a) || (a = a(r)), a) {
          if (a[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          i[a[0].id] = a[1];
        }
    }
    return r;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(t) {
    return this.props[t.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      let i = this.prop(Oe.group);
      return i ? i.indexOf(t) > -1 : !1;
    }
    return this.id == t;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(t) {
    let i = /* @__PURE__ */ Object.create(null);
    for (let n in t)
      for (let r of n.split(" "))
        i[r] = t[n];
    return (n) => {
      for (let r = n.prop(Oe.group), a = -1; a < (r ? r.length : 0); a++) {
        let o = i[a < 0 ? n.name : r[a]];
        if (o)
          return o;
      }
    };
  }
}, u(Ha, "Ks"), Ha);
m(s8, "NodeType");
let Et = s8;
Et.none = new Et(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
var Ya;
const r8 = (Ya = class {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(t) {
    this.types = t;
    for (let i = 0; i < t.length; i++)
      if (t[i].id != i)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...t) {
    let i = [];
    for (let n of this.types) {
      let r = null;
      for (let a of t) {
        let o = a(n);
        o && (r || (r = Object.assign({}, n.props)), r[o[0].id] = o[1]);
      }
      i.push(r ? new Et(n.name, r, n.id, n.flags) : n);
    }
    return new Ya(i);
  }
}, u(Ya, "Js"), Ya);
m(r8, "NodeSet");
let D1 = r8;
const kw = /* @__PURE__ */ new WeakMap(), pP = /* @__PURE__ */ new WeakMap();
var Ne;
(function(s) {
  s[s.ExcludeBuffers = 1] = "ExcludeBuffers", s[s.IncludeAnonymous = 2] = "IncludeAnonymous", s[s.IgnoreMounts = 4] = "IgnoreMounts", s[s.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Ne || (Ne = {}));
var pr;
const a8 = (pr = class {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(t, i, n, r, a) {
    if (this.type = t, this.children = i, this.positions = n, this.length = r, this.props = null, a && a.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [o, l] of a)
        this.props[typeof o == "number" ? o : o.id] = l;
    }
  }
  /**
  @internal
  */
  toString() {
    let t = sm.get(this);
    if (t && !t.overlay)
      return t.tree.toString();
    let i = "";
    for (let n of this.children) {
      let r = n.toString();
      r && (i && (i += ","), i += r);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (i.length ? "(" + i + ")" : "") : i;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(t = 0) {
    return new Zg(this.topNode, t);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(t, i = 0, n = 0) {
    let r = kw.get(this) || this.topNode, a = new Zg(r);
    return a.moveTo(t, i), kw.set(this, a._tree), a;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new Xi(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(t, i = 0) {
    let n = cf(kw.get(this) || this.topNode, t, i, !1);
    return kw.set(this, n), n;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(t, i = 0) {
    let n = cf(pP.get(this) || this.topNode, t, i, !0);
    return pP.set(this, n), n;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(t, i = 0) {
    return y8(this, t, i);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(t) {
    let { enter: i, leave: n, from: r = 0, to: a = this.length } = t, o = t.mode || 0, l = (o & Ne.IncludeAnonymous) > 0;
    for (let c = this.cursor(o | Ne.IncludeAnonymous); ; ) {
      let h = !1;
      if (c.from <= a && c.to >= r && (!l && c.type.isAnonymous || i(c) !== !1)) {
        if (c.firstChild())
          continue;
        h = !0;
      }
      for (; h && n && (l || !c.type.isAnonymous) && n(c), !c.nextSibling(); ) {
        if (!c.parent())
          return;
        h = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let t = [];
    if (this.props)
      for (let i in this.props)
        t.push([+i, this.props[i]]);
    return t;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(t = {}) {
    return this.children.length <= 8 ? this : U1(Et.none, this.children, this.positions, 0, this.children.length, 0, this.length, (i, n, r) => new pr(this.type, i, n, r, this.propValues), t.makeTree || ((i, n, r) => new pr(Et.none, i, n, r)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(t) {
    return w8(t);
  }
}, u(pr, "Mr"), pr);
m(a8, "Tree");
let ze = a8;
ze.empty = new ze(Et.none, [], [], 0);
var Ga;
const o8 = (Ga = class {
  constructor(t, i) {
    this.buffer = t, this.index = i;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new Ga(this.buffer, this.index);
  }
}, u(Ga, "eo"), Ga);
m(o8, "FlatBufferCursor");
let OI = o8;
var Ka;
const l8 = (Ka = class {
  /**
  Create a tree buffer.
  */
  constructor(t, i, n) {
    this.buffer = t, this.length = i, this.set = n;
  }
  /**
  @internal
  */
  get type() {
    return Et.none;
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    for (let i = 0; i < this.buffer.length; )
      t.push(this.childString(i)), i = this.buffer[i + 3];
    return t.join(",");
  }
  /**
  @internal
  */
  childString(t) {
    let i = this.buffer[t], n = this.buffer[t + 3], r = this.set.types[i], a = r.name;
    if (/\W/.test(a) && !r.isError && (a = JSON.stringify(a)), t += 4, n == t)
      return a;
    let o = [];
    for (; t < n; )
      o.push(this.childString(t)), t = this.buffer[t + 3];
    return a + "(" + o.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(t, i, n, r, a) {
    let { buffer: o } = this, l = -1;
    for (let c = t; c != i && !(zx(a, r, o[c + 1], o[c + 2]) && (l = c, n > 0)); c = o[c + 3])
      ;
    return l;
  }
  /**
  @internal
  */
  slice(t, i, n) {
    let r = this.buffer, a = new Uint16Array(i - t), o = 0;
    for (let l = t, c = 0; l < i; ) {
      a[c++] = r[l++], a[c++] = r[l++] - n;
      let h = a[c++] = r[l++] - n;
      a[c++] = r[l++] - t, o = Math.max(o, h);
    }
    return new Ka(a, o, this.set);
  }
}, u(Ka, "to"), Ka);
m(l8, "TreeBuffer");
let lf = l8;
function zx(s, t, i, n) {
  switch (s) {
    case -2:
      return i < t;
    case -1:
      return n >= t && i < t;
    case 0:
      return i < t && n > t;
    case 1:
      return i <= t && n > t;
    case 2:
      return n > t;
    case 4:
      return !0;
  }
}
u(zx, "GO");
m(zx, "checkSide");
function cf(s, t, i, n) {
  for (var r; s.from == s.to || (i < 1 ? s.from >= t : s.from > t) || (i > -1 ? s.to <= t : s.to < t); ) {
    let o = !n && s instanceof Xi && s.index < 0 ? null : s.parent;
    if (!o)
      return s;
    s = o;
  }
  let a = n ? 0 : Ne.IgnoreOverlays;
  if (n)
    for (let o = s, l = o.parent; l; o = l, l = o.parent)
      o instanceof Xi && o.index < 0 && ((r = l.enter(t, i, a)) === null || r === void 0 ? void 0 : r.from) != o.from && (s = l);
  for (; ; ) {
    let o = s.enter(t, i, a);
    if (!o)
      return s;
    s = o;
  }
}
u(cf, "rn$1");
m(cf, "resolveNode");
var fh;
const c8 = (fh = class {
  cursor(t = 0) {
    return new Zg(this, t);
  }
  getChild(t, i = null, n = null) {
    let r = p2(this, t, i, n);
    return r.length ? r[0] : null;
  }
  getChildren(t, i = null, n = null) {
    return p2(this, t, i, n);
  }
  resolve(t, i = 0) {
    return cf(this, t, i, !1);
  }
  resolveInner(t, i = 0) {
    return cf(this, t, i, !0);
  }
  matchContext(t) {
    return Vg(this, t);
  }
  enterUnfinishedNodesBefore(t) {
    let i = this.childBefore(t), n = this;
    for (; i; ) {
      let r = i.lastChild;
      if (!r || r.to != i.to)
        break;
      r.type.isError && r.from == r.to ? (n = i, i = r.prevSibling) : i = r;
    }
    return n;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}, u(fh, "Rf"), fh);
m(c8, "BaseNode");
let h8 = c8;
var xs;
const d8 = (xs = class extends h8 {
  constructor(t, i, n, r) {
    super(), this._tree = t, this.from = i, this.index = n, this._parent = r;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(t, i, n, r, a = 0) {
    for (let o = this; ; ) {
      for (let { children: l, positions: c } = o._tree, h = i > 0 ? l.length : -1; t != h; t += i) {
        let d = l[t], f = c[t] + o.from;
        if (zx(r, n, f, f + d.length)) {
          if (d instanceof lf) {
            if (a & Ne.ExcludeBuffers)
              continue;
            let y = d.findChild(0, d.buffer.length, i, n - f, r);
            if (y > -1)
              return new rm(new bI(o, d, t, f), null, y);
          } else if (a & Ne.IncludeAnonymous || !d.type.isAnonymous || q1(d)) {
            let y;
            if (!(a & Ne.IgnoreMounts) && (y = sm.get(d)) && !y.overlay)
              return new xs(y.tree, f, t, o);
            let w = new xs(d, f, t, o);
            return a & Ne.IncludeAnonymous || !w.type.isAnonymous ? w : w.nextChild(i < 0 ? d.children.length - 1 : 0, i, n, r);
          }
        }
      }
      if (a & Ne.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? t = o.index + i : t = i < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.nextChild(
      0,
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, i, n = 0) {
    let r;
    if (!(n & Ne.IgnoreOverlays) && (r = sm.get(this._tree)) && r.overlay) {
      let a = t - this.from;
      for (let { from: o, to: l } of r.overlay)
        if ((i > 0 ? o <= a : o < a) && (i < 0 ? l >= a : l > a))
          return new xs(r.tree, r.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, t, i, n);
  }
  nextSignificantParent() {
    let t = this;
    for (; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}, u(xs, "wi"), xs);
m(d8, "TreeNode");
let Xi = d8;
function p2(s, t, i, n) {
  let r = s.cursor(), a = [];
  if (!r.firstChild())
    return a;
  if (i != null) {
    for (let o = !1; !o; )
      if (o = r.type.is(i), !r.nextSibling())
        return a;
  }
  for (; ; ) {
    if (n != null && r.type.is(n))
      return a;
    if (r.type.is(t) && a.push(r.node), !r.nextSibling())
      return n == null ? a : [];
  }
}
u(p2, "Su$1");
m(p2, "getChildren");
function Vg(s, t, i = t.length - 1) {
  for (let n = s.parent; i >= 0; n = n.parent) {
    if (!n)
      return !1;
    if (!n.type.isAnonymous) {
      if (t[i] && t[i] != n.name)
        return !1;
      i--;
    }
  }
  return !0;
}
u(Vg, "Nl");
m(Vg, "matchNodeContext");
var yh;
const u8 = (yh = class {
  constructor(t, i, n, r) {
    this.parent = t, this.buffer = i, this.index = n, this.start = r;
  }
}, u(yh, "$f"), yh);
m(u8, "BufferContext");
let bI = u8;
var In;
const p8 = (In = class extends h8 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(t, i, n) {
    super(), this.context = t, this._parent = i, this.index = n, this.type = t.buffer.set.types[t.buffer.buffer[n]];
  }
  child(t, i, n) {
    let { buffer: r } = this.context, a = r.findChild(this.index + 4, r.buffer[this.index + 3], t, i - this.context.start, n);
    return a < 0 ? null : new In(this.context, this, a);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.child(
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.child(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, i, n = 0) {
    if (n & Ne.ExcludeBuffers)
      return null;
    let { buffer: r } = this.context, a = r.findChild(this.index + 4, r.buffer[this.index + 3], i > 0 ? 1 : -1, t - this.context.start, i);
    return a < 0 ? null : new In(this.context, this, a);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(t) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + t,
      t,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: t } = this.context, i = t.buffer[this.index + 3];
    return i < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new In(this.context, this._parent, i) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: t } = this.context, i = this._parent ? this._parent.index + 4 : 0;
    return this.index == i ? this.externalSibling(-1) : new In(this.context, this._parent, t.findChild(
      i,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let t = [], i = [], { buffer: n } = this.context, r = this.index + 4, a = n.buffer[this.index + 3];
    if (a > r) {
      let o = n.buffer[this.index + 1];
      t.push(n.slice(r, a, o)), i.push(0);
    }
    return new ze(this.type, t, i, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}, u(In, "zt"), In);
m(p8, "BufferNode");
let rm = p8;
function _x(s) {
  if (!s.length)
    return null;
  let t = 0, i = s[0];
  for (let a = 1; a < s.length; a++) {
    let o = s[a];
    (o.from > i.from || o.to < i.to) && (i = o, t = a);
  }
  let n = i instanceof Xi && i.index < 0 ? null : i.parent, r = s.slice();
  return n ? r[t] = n : r.splice(t, 1), new $I(r, i);
}
u(_x, "FO");
m(_x, "iterStack");
var mh;
const f8 = (mh = class {
  constructor(t, i) {
    this.heads = t, this.node = i;
  }
  get next() {
    return _x(this.heads);
  }
}, u(mh, "vf"), mh);
m(f8, "StackIterator");
let $I = f8;
function y8(s, t, i) {
  let n = s.resolveInner(t, i), r = null;
  for (let a = n instanceof Xi ? n : n.context.parent; a; a = a.parent)
    if (a.index < 0) {
      let o = a.parent;
      (r || (r = [n])).push(o.resolve(t, i)), a = o;
    } else {
      let o = sm.get(a.tree);
      if (o && o.overlay && o.overlay[0].from <= t && o.overlay[o.overlay.length - 1].to >= t) {
        let l = new Xi(o.tree, o.overlay[0].from + a.from, -1, a);
        (r || (r = [n])).push(cf(l, t, i, !1));
      }
    }
  return r ? _x(r) : n;
}
u(y8, "pb$1");
m(y8, "stackIterator");
var wh;
const m8 = (wh = class {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(t, i = 0) {
    if (this.mode = i, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof Xi)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (let n = t._parent; n; n = n._parent)
        this.stack.unshift(n.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  yieldNode(t) {
    return t ? (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0) : !1;
  }
  yieldBuf(t, i) {
    this.index = t;
    let { start: n, buffer: r } = this.buffer;
    return this.type = i || r.set.types[r.buffer[t]], this.from = n + r.buffer[t + 1], this.to = n + r.buffer[t + 2], !0;
  }
  /**
  @internal
  */
  yield(t) {
    return t ? t instanceof Xi ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(t, i, n) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, i, n, this.mode));
    let { buffer: r } = this.buffer, a = r.findChild(this.index + 4, r.buffer[this.index + 3], t, i - this.buffer.start, n);
    return a < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(a));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(t) {
    return this.enterChild(
      1,
      t,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(t) {
    return this.enterChild(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(t, i, n = this.mode) {
    return this.buffer ? n & Ne.ExcludeBuffers ? !1 : this.enterChild(1, t, i) : this.yield(this._tree.enter(t, i, n));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Ne.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let t = this.mode & Ne.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  }
  /**
  @internal
  */
  sibling(t) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode)) : !1;
    let { buffer: i } = this.buffer, n = this.stack.length - 1;
    if (t < 0) {
      let r = n < 0 ? 0 : this.stack[n] + 4;
      if (this.index != r)
        return this.yieldBuf(i.findChild(
          r,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let r = i.buffer[this.index + 3];
      if (r < (n < 0 ? i.buffer.length : i.buffer[this.stack[n] + 3]))
        return this.yieldBuf(r);
    }
    return n < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(t) {
    let i, n, { buffer: r } = this;
    if (r) {
      if (t > 0) {
        if (this.index < r.buffer.buffer.length)
          return !1;
      } else
        for (let a = 0; a < this.index; a++)
          if (r.buffer.buffer[a + 3] < this.index)
            return !1;
      ({ index: i, parent: n } = r);
    } else
      ({ index: i, _parent: n } = this._tree);
    for (; n; { index: i, _parent: n } = n)
      if (i > -1)
        for (let a = i + t, o = t < 0 ? -1 : n._tree.children.length; a != o; a += t) {
          let l = n._tree.children[a];
          if (this.mode & Ne.IncludeAnonymous || l instanceof lf || !l.type.isAnonymous || q1(l))
            return !1;
        }
    return !0;
  }
  move(t, i) {
    if (i && this.enterChild(
      t,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(t = !0) {
    return this.move(1, t);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(t = !0) {
    return this.move(-1, t);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(t, i = 0) {
    for (; (this.from == this.to || (i < 1 ? this.from >= t : this.from > t) || (i > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, i); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let t = this.bufferNode, i = null, n = 0;
    if (t && t.context == this.buffer)
      e: for (let r = this.index, a = this.stack.length; a >= 0; ) {
        for (let o = t; o; o = o._parent)
          if (o.index == r) {
            if (r == this.index)
              return o;
            i = o, n = a + 1;
            break e;
          }
        r = this.stack[--a];
      }
    for (let r = n; r < this.stack.length; r++)
      i = new rm(this.buffer, i, this.stack[r]);
    return this.bufferNode = new rm(this.buffer, i, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(t, i) {
    for (let n = 0; ; ) {
      let r = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          n++;
          continue;
        }
        this.type.isAnonymous || (r = !0);
      }
      for (; r && i && i(this), r = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!n)
          return;
        this.parent(), n--, r = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(t) {
    if (!this.buffer)
      return Vg(this.node, t);
    let { buffer: i } = this.buffer, { types: n } = i.set;
    for (let r = t.length - 1, a = this.stack.length - 1; r >= 0; a--) {
      if (a < 0)
        return Vg(this.node, t, r);
      let o = n[i.buffer[this.stack[a]]];
      if (!o.isAnonymous) {
        if (t[r] && t[r] != o.name)
          return !1;
        r--;
      }
    }
    return !0;
  }
}, u(wh, "Tf"), wh);
m(m8, "TreeCursor");
let Zg = m8;
function q1(s) {
  return s.children.some((t) => t instanceof lf || !t.type.isAnonymous || q1(t));
}
u(q1, "sh$1");
m(q1, "hasChild");
function w8(s) {
  var t;
  let { buffer: i, nodeSet: n, maxBufferLength: r = e8, reused: a = [], minRepeatType: o = n.types.length } = s, l = Array.isArray(i) ? new OI(i, i.length) : i, c = n.types, h = 0, d = 0;
  function f(R, L, I, D, j, ee) {
    let { id: se, start: oe, end: we, size: re } = l, _e = d;
    for (; re < 0; )
      if (l.next(), re == -1) {
        let Ct = a[se];
        I.push(Ct), D.push(oe - R);
        return;
      } else if (re == -3) {
        h = se;
        return;
      } else if (re == -4) {
        d = se;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${re}`);
    let Pe = c[se], He, We, ft = oe - R;
    if (we - oe <= r && (We = k(l.pos - L, j))) {
      let Ct = new Uint16Array(We.size - We.skip), xt = l.pos - We.size, Yt = Ct.length;
      for (; l.pos > xt; )
        Yt = $(We.start, Ct, Yt);
      He = new lf(Ct, we - We.start, n), ft = We.start - R;
    } else {
      let Ct = l.pos - re;
      l.next();
      let xt = [], Yt = [], ni = se >= o ? se : -1, Gt = 0, Jn = we;
      for (; l.pos > Ct; )
        ni >= 0 && l.id == ni && l.size >= 0 ? (l.end <= Jn - r && (g(xt, Yt, oe, Gt, l.end, Jn, ni, _e), Gt = xt.length, Jn = l.end), l.next()) : ee > 2500 ? y(oe, Ct, xt, Yt) : f(oe, Ct, xt, Yt, ni, ee + 1);
      if (ni >= 0 && Gt > 0 && Gt < xt.length && g(xt, Yt, oe, Gt, oe, Jn, ni, _e), xt.reverse(), Yt.reverse(), ni > -1 && Gt > 0) {
        let Is = w(Pe);
        He = U1(Pe, xt, Yt, 0, xt.length, 0, we - oe, Is, Is);
      } else
        He = b(Pe, xt, Yt, we - oe, _e - we);
    }
    I.push(He), D.push(ft);
  }
  u(f, "u"), m(f, "takeNode");
  function y(R, L, I, D) {
    let j = [], ee = 0, se = -1;
    for (; l.pos > L; ) {
      let { id: oe, start: we, end: re, size: _e } = l;
      if (_e > 4)
        l.next();
      else {
        if (se > -1 && we < se)
          break;
        se < 0 && (se = re - r), j.push(oe, we, re), ee++, l.next();
      }
    }
    if (ee) {
      let oe = new Uint16Array(ee * 4), we = j[j.length - 2];
      for (let re = j.length - 3, _e = 0; re >= 0; re -= 3)
        oe[_e++] = j[re], oe[_e++] = j[re + 1] - we, oe[_e++] = j[re + 2] - we, oe[_e++] = _e;
      I.push(new lf(oe, j[2] - we, n)), D.push(we - R);
    }
  }
  u(y, "d"), m(y, "takeFlatNode");
  function w(R) {
    return (L, I, D) => {
      let j = 0, ee = L.length - 1, se, oe;
      if (ee >= 0 && (se = L[ee]) instanceof ze) {
        if (!ee && se.type == R && se.length == D)
          return se;
        (oe = se.prop(Oe.lookAhead)) && (j = I[ee] + se.length + oe);
      }
      return b(R, L, I, D, j);
    };
  }
  u(w, "O"), m(w, "makeBalanced");
  function g(R, L, I, D, j, ee, se, oe) {
    let we = [], re = [];
    for (; R.length > D; )
      we.push(R.pop()), re.push(L.pop() + I - j);
    R.push(b(n.types[se], we, re, ee - j, oe - ee)), L.push(j - I);
  }
  u(g, "p"), m(g, "makeRepeatLeaf");
  function b(R, L, I, D, j = 0, ee) {
    if (h) {
      let se = [Oe.contextHash, h];
      ee = ee ? [se].concat(ee) : [se];
    }
    if (j > 25) {
      let se = [Oe.lookAhead, j];
      ee = ee ? [se].concat(ee) : [se];
    }
    return new ze(R, L, I, D, ee);
  }
  u(b, "g"), m(b, "makeTree");
  function k(R, L) {
    let I = l.fork(), D = 0, j = 0, ee = 0, se = I.end - r, oe = { size: 0, start: 0, skip: 0 };
    e: for (let we = I.pos - R; I.pos > we; ) {
      let re = I.size;
      if (I.id == L && re >= 0) {
        oe.size = D, oe.start = j, oe.skip = ee, ee += 4, D += 4, I.next();
        continue;
      }
      let _e = I.pos - re;
      if (re < 0 || _e < we || I.start < se)
        break;
      let Pe = I.id >= o ? 4 : 0, He = I.start;
      for (I.next(); I.pos > _e; ) {
        if (I.size < 0)
          if (I.size == -3)
            Pe += 4;
          else
            break e;
        else I.id >= o && (Pe += 4);
        I.next();
      }
      j = He, D += re, ee += Pe;
    }
    return (L < 0 || D == R) && (oe.size = D, oe.start = j, oe.skip = ee), oe.size > 4 ? oe : void 0;
  }
  u(k, "b"), m(k, "findBufferSize");
  function $(R, L, I) {
    let { id: D, start: j, end: ee, size: se } = l;
    if (l.next(), se >= 0 && D < o) {
      let oe = I;
      if (se > 4) {
        let we = l.pos - (se - 4);
        for (; l.pos > we; )
          I = $(R, L, I);
      }
      L[--I] = oe, L[--I] = ee - R, L[--I] = j - R, L[--I] = D;
    } else se == -3 ? h = D : se == -4 && (d = D);
    return I;
  }
  u($, "y"), m($, "copyToBuffer");
  let C = [], E = [];
  for (; l.pos > 0; )
    f(s.start || 0, s.bufferStart || 0, C, E, -1, 0);
  let A = (t = s.length) !== null && t !== void 0 ? t : C.length ? E[0] + C[0].length : 0;
  return new ze(c[s.topID], C.reverse(), E.reverse(), A);
}
u(w8, "mb$1");
m(w8, "buildTree");
const fP = /* @__PURE__ */ new WeakMap();
function Ny(s, t) {
  if (!s.isAnonymous || t instanceof lf || t.type != s)
    return 1;
  let i = fP.get(t);
  if (i == null) {
    i = 1;
    for (let n of t.children) {
      if (n.type != s || !(n instanceof ze)) {
        i = 1;
        break;
      }
      i += Ny(s, n);
    }
    fP.set(t, i);
  }
  return i;
}
u(Ny, "Dn$1");
m(Ny, "nodeSize");
function U1(s, t, i, n, r, a, o, l, c) {
  let h = 0;
  for (let g = n; g < r; g++)
    h += Ny(s, t[g]);
  let d = Math.ceil(
    h * 1.5 / 8
    /* Balance.BranchFactor */
  ), f = [], y = [];
  function w(g, b, k, $, C) {
    for (let E = k; E < $; ) {
      let A = E, R = b[E], L = Ny(s, g[E]);
      for (E++; E < $; E++) {
        let I = Ny(s, g[E]);
        if (L + I >= d)
          break;
        L += I;
      }
      if (E == A + 1) {
        if (L > d) {
          let I = g[A];
          w(I.children, I.positions, 0, I.children.length, b[A] + C);
          continue;
        }
        f.push(g[A]);
      } else {
        let I = b[E - 1] + g[E - 1].length - R;
        f.push(U1(s, g, b, A, E, R, I, null, c));
      }
      y.push(R + C - a);
    }
  }
  return u(w, "O"), m(w, "divide"), w(t, i, n, r, 0), (l || c)(f, y, o);
}
u(U1, "oh$1");
m(U1, "balanceRange");
var gh;
const g8 = (gh = class {
  constructor() {
    this.map = /* @__PURE__ */ new WeakMap();
  }
  setBuffer(t, i, n) {
    let r = this.map.get(t);
    r || this.map.set(t, r = /* @__PURE__ */ new Map()), r.set(i, n);
  }
  getBuffer(t, i) {
    let n = this.map.get(t);
    return n && n.get(i);
  }
  /**
  Set the value for this syntax node.
  */
  set(t, i) {
    t instanceof rm ? this.setBuffer(t.context.buffer, t.index, i) : t instanceof Xi && this.map.set(t.tree, i);
  }
  /**
  Retrieve value for this syntax node, if it exists in the map.
  */
  get(t) {
    return t instanceof rm ? this.getBuffer(t.context.buffer, t.index) : t instanceof Xi ? this.map.get(t.tree) : void 0;
  }
  /**
  Set the value for the node that a cursor currently points to.
  */
  cursorSet(t, i) {
    t.buffer ? this.setBuffer(t.buffer.buffer, t.index, i) : this.map.set(t.tree, i);
  }
  /**
  Retrieve the value for the node that a cursor currently points
  to.
  */
  cursorGet(t) {
    return t.buffer ? this.getBuffer(t.buffer.buffer, t.index) : this.map.get(t.tree);
  }
}, u(gh, "Af"), gh);
m(g8, "NodeWeakMap");
let v8 = g8;
var fr;
const O8 = (fr = class {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(t, i, n, r, a = !1, o = !1) {
    this.from = t, this.to = i, this.tree = n, this.offset = r, this.open = (a ? 1 : 0) | (o ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(t, i = [], n = !1) {
    let r = [new fr(0, t.length, t, 0, !1, n)];
    for (let a of i)
      a.to > t.length && r.push(a);
    return r;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(t, i, n = 128) {
    if (!i.length)
      return t;
    let r = [], a = 1, o = t.length ? t[0] : null;
    for (let l = 0, c = 0, h = 0; ; l++) {
      let d = l < i.length ? i[l] : null, f = d ? d.fromA : 1e9;
      if (f - c >= n)
        for (; o && o.from < f; ) {
          let y = o;
          if (c >= y.from || f <= y.to || h) {
            let w = Math.max(y.from, c) - h, g = Math.min(y.to, f) - h;
            y = w >= g ? null : new fr(w, g, y.tree, y.offset + h, l > 0, !!d);
          }
          if (y && r.push(y), o.to > f)
            break;
          o = a < t.length ? t[a++] : null;
        }
      if (!d)
        break;
      c = d.toA, h = d.toA - d.toB;
    }
    return r;
  }
}, u(fr, "Yr"), fr);
m(O8, "TreeFragment");
let dc = O8;
var vh;
const b8 = (vh = class {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(t, i, n) {
    return typeof t == "string" && (t = new xI(t)), n = n ? n.length ? n.map((r) => new qi(r.from, r.to)) : [new qi(0, 0)] : [new qi(0, t.length)], this.createParse(t, i || [], n);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(t, i, n) {
    let r = this.startParse(t, i, n);
    for (; ; ) {
      let a = r.advance();
      if (a)
        return a;
    }
  }
}, u(vh, "Zf"), vh);
m(b8, "Parser");
let N1 = b8;
var Oh;
const $8 = (Oh = class {
  constructor(t) {
    this.string = t;
  }
  get length() {
    return this.string.length;
  }
  chunk(t) {
    return this.string.slice(t);
  }
  get lineChunks() {
    return !1;
  }
  read(t, i) {
    return this.string.slice(t, i);
  }
}, u(Oh, "Wf"), Oh);
m($8, "StringInput");
let xI = $8;
function Lx(s) {
  return (t, i, n, r) => new SI(t, s, i, n, r);
}
u(Lx, "HO");
m(Lx, "parseMixed");
var bh;
const x8 = (bh = class {
  constructor(t, i, n, r, a) {
    this.parser = t, this.parse = i, this.overlay = n, this.target = r, this.from = a;
  }
}, u(bh, "Uf"), bh);
m(x8, "InnerParse");
let yP = x8;
function f2(s) {
  if (!s.length || s.some((t) => t.from >= t.to))
    throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(s));
}
u(f2, "wu$1");
m(f2, "checkRanges");
var $h;
const k8 = ($h = class {
  constructor(t, i, n, r, a, o, l) {
    this.parser = t, this.predicate = i, this.mounts = n, this.index = r, this.start = a, this.target = o, this.prev = l, this.depth = 0, this.ranges = [];
  }
}, u($h, "Lf"), $h);
m(k8, "ActiveOverlay");
let kI = k8;
const y2 = new Oe({ perNode: !0 });
var xh;
const S8 = (xh = class {
  constructor(t, i, n, r, a) {
    this.nest = i, this.input = n, this.fragments = r, this.ranges = a, this.inner = [], this.innerDone = 0, this.baseTree = null, this.stoppedAt = null, this.baseParse = t;
  }
  advance() {
    if (this.baseParse) {
      let n = this.baseParse.advance();
      if (!n)
        return null;
      if (this.baseParse = null, this.baseTree = n, this.startInner(), this.stoppedAt != null)
        for (let r of this.inner)
          r.parse.stopAt(this.stoppedAt);
    }
    if (this.innerDone == this.inner.length) {
      let n = this.baseTree;
      return this.stoppedAt != null && (n = new ze(n.type, n.children, n.positions, n.length, n.propValues.concat([[y2, this.stoppedAt]]))), n;
    }
    let t = this.inner[this.innerDone], i = t.parse.advance();
    if (i) {
      this.innerDone++;
      let n = Object.assign(/* @__PURE__ */ Object.create(null), t.target.props);
      n[Oe.mounted.id] = new sm(i, t.overlay, t.parser), t.target.props = n;
    }
    return null;
  }
  get parsedPos() {
    if (this.baseParse)
      return 0;
    let t = this.input.length;
    for (let i = this.innerDone; i < this.inner.length; i++)
      this.inner[i].from < t && (t = Math.min(t, this.inner[i].parse.parsedPos));
    return t;
  }
  stopAt(t) {
    if (this.stoppedAt = t, this.baseParse)
      this.baseParse.stopAt(t);
    else
      for (let i = this.innerDone; i < this.inner.length; i++)
        this.inner[i].parse.stopAt(t);
  }
  startInner() {
    let t = new PI(this.fragments), i = null, n = null, r = new Zg(new Xi(this.baseTree, this.ranges[0].from, 0, null), Ne.IncludeAnonymous | Ne.IgnoreMounts);
    e: for (let a, o; ; ) {
      let l = !0, c;
      if (this.stoppedAt != null && r.from >= this.stoppedAt)
        l = !1;
      else if (t.hasNode(r)) {
        if (i) {
          let h = i.mounts.find((d) => d.frag.from <= r.from && d.frag.to >= r.to && d.mount.overlay);
          if (h)
            for (let d of h.mount.overlay) {
              let f = d.from + h.pos, y = d.to + h.pos;
              f >= r.from && y <= r.to && !i.ranges.some((w) => w.from < y && w.to > f) && i.ranges.push({ from: f, to: y });
            }
        }
        l = !1;
      } else if (n && (o = P8(n.ranges, r.from, r.to)))
        l = o != 2;
      else if (!r.type.isAnonymous && (a = this.nest(r, this.input)) && (r.from < r.to || !a.overlay)) {
        r.tree || C8(r);
        let h = t.findMounts(r.from, a.parser);
        if (typeof a.overlay == "function")
          i = new kI(a.parser, a.overlay, h, this.inner.length, r.from, r.tree, i);
        else {
          let d = w2(this.ranges, a.overlay || (r.from < r.to ? [new qi(r.from, r.to)] : []));
          d.length && f2(d), (d.length || !a.overlay) && this.inner.push(new yP(a.parser, d.length ? a.parser.startParse(this.input, g2(h, d), d) : a.parser.startParse(""), a.overlay ? a.overlay.map((f) => new qi(f.from - r.from, f.to - r.from)) : null, r.tree, d.length ? d[0].from : r.from)), a.overlay ? d.length && (n = { ranges: d, depth: 0, prev: n }) : l = !1;
        }
      } else i && (c = i.predicate(r)) && (c === !0 && (c = new qi(r.from, r.to)), c.from < c.to && i.ranges.push(c));
      if (l && r.firstChild())
        i && i.depth++, n && n.depth++;
      else
        for (; !r.nextSibling(); ) {
          if (!r.parent())
            break e;
          if (i && !--i.depth) {
            let h = w2(this.ranges, i.ranges);
            h.length && (f2(h), this.inner.splice(i.index, 0, new yP(i.parser, i.parser.startParse(this.input, g2(i.mounts, h), h), i.ranges.map((d) => new qi(d.from - i.start, d.to - i.start)), i.target, h[0].from))), i = i.prev;
          }
          n && !--n.depth && (n = n.prev);
        }
    }
  }
}, u(xh, "_f"), xh);
m(S8, "MixedParse");
let SI = S8;
function P8(s, t, i) {
  for (let n of s) {
    if (n.from >= i)
      break;
    if (n.to > t)
      return n.from <= t && n.to >= i ? 2 : 1;
  }
  return 0;
}
u(P8, "gb$1");
m(P8, "checkCover");
function m2(s, t, i, n, r, a) {
  if (t < i) {
    let o = s.buffer[t + 1];
    n.push(s.slice(t, i, o)), r.push(o - a);
  }
}
u(m2, "xu$1");
m(m2, "sliceBuf");
function C8(s) {
  let { node: t } = s, i = [], n = t.context.buffer;
  do
    i.push(s.index), s.parent();
  while (!s.tree);
  let r = s.tree, a = r.children.indexOf(n), o = r.children[a], l = o.buffer, c = [a];
  function h(d, f, y, w, g, b) {
    let k = i[b], $ = [], C = [];
    m2(o, d, k, $, C, w);
    let E = l[k + 1], A = l[k + 2];
    c.push($.length);
    let R = b ? h(k + 4, l[k + 3], o.set.types[l[k]], E, A - E, b - 1) : t.toTree();
    return $.push(R), C.push(E - w), m2(o, l[k + 3], f, $, C, w), new ze(y, $, C, g);
  }
  u(h, "h"), m(h, "split"), r.children[a] = h(0, l.length, Et.none, 0, o.length, i.length - 1);
  for (let d of c) {
    let f = s.tree.children[d], y = s.tree.positions[d];
    s.yield(new Xi(f, y + s.from, d, s._tree));
  }
}
u(C8, "bb$1");
m(C8, "materialize");
var kh;
const Q8 = (kh = class {
  constructor(t, i) {
    this.offset = i, this.done = !1, this.cursor = t.cursor(Ne.IncludeAnonymous | Ne.IgnoreMounts);
  }
  // Move to the first node (in pre-order) that starts at or after `pos`.
  moveTo(t) {
    let { cursor: i } = this, n = t - this.offset;
    for (; !this.done && i.from < n; )
      i.to >= t && i.enter(n, 1, Ne.IgnoreOverlays | Ne.ExcludeBuffers) || i.next(!1) || (this.done = !0);
  }
  hasNode(t) {
    if (this.moveTo(t.from), !this.done && this.cursor.from + this.offset == t.from && this.cursor.tree)
      for (let i = this.cursor.tree; ; ) {
        if (i == t.tree)
          return !0;
        if (i.children.length && i.positions[0] == 0 && i.children[0] instanceof ze)
          i = i.children[0];
        else
          break;
      }
    return !1;
  }
}, u(kh, "Mf"), kh);
m(Q8, "StructureCursor");
let mP = Q8;
var Uv, Sh;
let PI = (Uv = (Sh = class {
  constructor(t) {
    var i;
    if (this.fragments = t, this.curTo = 0, this.fragI = 0, t.length) {
      let n = this.curFrag = t[0];
      this.curTo = (i = n.tree.prop(y2)) !== null && i !== void 0 ? i : n.to, this.inner = new mP(n.tree, -n.offset);
    } else
      this.curFrag = this.inner = null;
  }
  hasNode(t) {
    for (; this.curFrag && t.from >= this.curTo; )
      this.nextFrag();
    return this.curFrag && this.curFrag.from <= t.from && this.curTo >= t.to && this.inner.hasNode(t);
  }
  nextFrag() {
    var t;
    if (this.fragI++, this.fragI == this.fragments.length)
      this.curFrag = this.inner = null;
    else {
      let i = this.curFrag = this.fragments[this.fragI];
      this.curTo = (t = i.tree.prop(y2)) !== null && t !== void 0 ? t : i.to, this.inner = new mP(i.tree, -i.offset);
    }
  }
  findMounts(t, i) {
    var n;
    let r = [];
    if (this.inner) {
      this.inner.cursor.moveTo(t, 1);
      for (let a = this.inner.cursor.node; a; a = a.parent) {
        let o = (n = a.tree) === null || n === void 0 ? void 0 : n.prop(Oe.mounted);
        if (o && o.parser == i)
          for (let l = this.fragI; l < this.fragments.length; l++) {
            let c = this.fragments[l];
            if (c.from >= a.to)
              break;
            c.tree == this.curFrag.tree && r.push({
              frag: c,
              pos: a.from - c.offset,
              mount: o
            });
          }
      }
    }
    return r;
  }
}, u(Sh, "Zi$1"), Sh), m(Uv, "FragmentCursor"), Uv);
function w2(s, t) {
  let i = null, n = t;
  for (let r = 1, a = 0; r < s.length; r++) {
    let o = s[r - 1].to, l = s[r].from;
    for (; a < n.length; a++) {
      let c = n[a];
      if (c.from >= l)
        break;
      c.to <= o || (i || (n = i = t.slice()), c.from < o ? (i[a] = new qi(c.from, o), c.to > l && i.splice(a + 1, 0, new qi(l, c.to))) : c.to > l ? i[a--] = new qi(l, c.to) : i.splice(a--, 1));
    }
  }
  return n;
}
u(w2, "Qu$1");
m(w2, "punchRanges");
function T8(s, t, i, n) {
  let r = 0, a = 0, o = !1, l = !1, c = -1e9, h = [];
  for (; ; ) {
    let d = r == s.length ? 1e9 : o ? s[r].to : s[r].from, f = a == t.length ? 1e9 : l ? t[a].to : t[a].from;
    if (o != l) {
      let y = Math.max(c, i), w = Math.min(d, f, n);
      y < w && h.push(new qi(y, w));
    }
    if (c = Math.min(d, f), c == 1e9)
      break;
    d == c && (o ? (o = !1, r++) : o = !0), f == c && (l ? (l = !1, a++) : l = !0);
  }
  return h;
}
u(T8, "Sb$1");
m(T8, "findCoverChanges");
function g2(s, t) {
  let i = [];
  for (let { pos: n, mount: r, frag: a } of s) {
    let o = n + (r.overlay ? r.overlay[0].from : 0), l = o + r.tree.length, c = Math.max(a.from, o), h = Math.min(a.to, l);
    if (r.overlay) {
      let d = r.overlay.map((y) => new qi(y.from + n, y.to + n)), f = T8(t, d, c, h);
      for (let y = 0, w = c; ; y++) {
        let g = y == f.length, b = g ? h : f[y].from;
        if (b > w && i.push(new dc(w, b, r.tree, -o, a.from >= w || a.openStart, a.to <= b || a.openEnd)), g)
          break;
        w = f[y].to;
      }
    } else
      i.push(new dc(c, h, r.tree, -o, a.from >= o || a.openStart, a.to <= l || a.openEnd));
  }
  return i;
}
u(g2, "ku$1");
m(g2, "enterFragments");
let CI = 0;
var Ja;
const M8 = (Ja = class {
  /**
  @internal
  */
  constructor(t, i, n) {
    this.set = t, this.base = i, this.modified = n, this.id = CI++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(t) {
    if (t != null && t.base)
      throw new Error("Can not derive from a modified tag");
    let i = new Ja([], null, []);
    if (i.set.push(i), t)
      for (let n of t.set)
        i.set.push(n);
    return i;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let t = new wP();
    return (i) => i.modified.indexOf(t) > -1 ? i : wP.get(i.base || i, i.modified.concat(t).sort((n, r) => n.id - r.id));
  }
}, u(Ja, "io"), Ja);
m(M8, "Tag");
let hs = M8, QI = 0;
var eo;
const R8 = (eo = class {
  constructor() {
    this.instances = [], this.id = QI++;
  }
  static get(t, i) {
    if (!i.length)
      return t;
    let n = i[0].instances.find((l) => l.base == t && A8(i, l.modified));
    if (n)
      return n;
    let r = [], a = new hs(r, t, i);
    for (let l of i)
      l.instances.push(a);
    let o = E8(i);
    for (let l of t.set)
      if (!l.modified.length)
        for (let c of o)
          r.push(eo.get(l, c));
    return a;
  }
}, u(eo, "ro"), eo);
m(R8, "Modifier");
let wP = R8;
function A8(s, t) {
  return s.length == t.length && s.every((i, n) => i == t[n]);
}
u(A8, "xb$1");
m(A8, "sameArray");
function E8(s) {
  let t = [[]];
  for (let i = 0; i < s.length; i++)
    for (let n = 0, r = t.length; n < r; n++)
      t.push(t[n].concat(s[i]));
  return t.sort((i, n) => n.length - i.length);
}
u(E8, "Qb$1");
m(E8, "powerSet");
function Io(s) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i in s) {
    let n = s[i];
    Array.isArray(n) || (n = [n]);
    for (let r of i.split(" "))
      if (r) {
        let a = [], o = 2, l = r;
        for (let f = 0; ; ) {
          if (l == "..." && f > 0 && f + 3 == r.length) {
            o = 1;
            break;
          }
          let y = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(l);
          if (!y)
            throw new RangeError("Invalid path: " + r);
          if (a.push(y[0] == "*" ? "" : y[0][0] == '"' ? JSON.parse(y[0]) : y[0]), f += y[0].length, f == r.length)
            break;
          let w = r[f++];
          if (f == r.length && w == "!") {
            o = 0;
            break;
          }
          if (w != "/")
            throw new RangeError("Invalid path: " + r);
          l = r.slice(f);
        }
        let c = a.length - 1, h = a[c];
        if (!h)
          throw new RangeError("Invalid path: " + r);
        let d = new Dg(n, o, c > 0 ? a.slice(0, c) : null);
        t[h] = d.sort(t[h]);
      }
  }
  return z8.add(t);
}
u(Io, "Ji$1");
m(Io, "styleTags");
const z8 = new Oe();
var Nv, Ph;
let Dg = (Nv = (Ph = class {
  constructor(t, i, n, r) {
    this.tags = t, this.mode = i, this.context = n, this.next = r;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}, u(Ph, "Wi$1"), Ph), m(Nv, "Rule"), Nv);
Dg.empty = new Dg([], 2, null);
function Ix(s, t) {
  let i = /* @__PURE__ */ Object.create(null);
  for (let a of s)
    if (!Array.isArray(a.tag))
      i[a.tag.id] = a.class;
    else
      for (let o of a.tag)
        i[o.id] = a.class;
  let { scope: n, all: r = null } = t || {};
  return {
    style: /* @__PURE__ */ m((a) => {
      let o = r;
      for (let l of a)
        for (let c of l.set) {
          let h = i[c.id];
          if (h) {
            o = o ? o + " " + h : h;
            break;
          }
        }
      return o;
    }, "style"),
    scope: n
  };
}
u(Ix, "JO");
m(Ix, "tagHighlighter");
function _8(s, t) {
  let i = null;
  for (let n of s) {
    let r = n.style(t);
    r && (i = i ? i + " " + r : r);
  }
  return i;
}
u(_8, "kb$1");
m(_8, "highlightTags");
function L8(s, t, i, n = 0, r = s.length) {
  let a = new TI(n, Array.isArray(t) ? t : [t], i);
  a.highlightRange(s.cursor(), n, r, "", a.highlighters), a.flush(r);
}
u(L8, "Rb$1");
m(L8, "highlightTree");
var Ch;
const I8 = (Ch = class {
  constructor(t, i, n) {
    this.at = t, this.highlighters = i, this.span = n, this.class = "";
  }
  startSpan(t, i) {
    i != this.class && (this.flush(t), t > this.at && (this.at = t), this.class = i);
  }
  flush(t) {
    t > this.at && this.class && this.span(this.at, t, this.class);
  }
  highlightRange(t, i, n, r, a) {
    let { type: o, from: l, to: c } = t;
    if (l >= n || c <= i)
      return;
    o.isTop && (a = this.highlighters.filter((w) => !w.scope || w.scope(o)));
    let h = r, d = W8(t) || Dg.empty, f = _8(a, d.tags);
    if (f && (h && (h += " "), h += f, d.mode == 1 && (r += (r ? " " : "") + f)), this.startSpan(Math.max(i, l), h), d.opaque)
      return;
    let y = t.tree && t.tree.prop(Oe.mounted);
    if (y && y.overlay) {
      let w = t.node.enter(y.overlay[0].from + l, 1), g = this.highlighters.filter((k) => !k.scope || k.scope(y.tree.type)), b = t.firstChild();
      for (let k = 0, $ = l; ; k++) {
        let C = k < y.overlay.length ? y.overlay[k] : null, E = C ? C.from + l : c, A = Math.max(i, $), R = Math.min(n, E);
        if (A < R && b)
          for (; t.from < R && (this.highlightRange(t, A, R, r, a), this.startSpan(Math.min(R, t.to), h), !(t.to >= E || !t.nextSibling())); )
            ;
        if (!C || E > n)
          break;
        $ = C.to + l, $ > i && (this.highlightRange(w.cursor(), Math.max(i, C.from + l), Math.min(n, $), "", g), this.startSpan(Math.min(n, $), h));
      }
      b && t.parent();
    } else if (t.firstChild()) {
      y && (r = "");
      do
        if (!(t.to <= i)) {
          if (t.from >= n)
            break;
          this.highlightRange(t, i, n, r, a), this.startSpan(Math.min(n, t.to), h);
        }
      while (t.nextSibling());
      t.parent();
    }
  }
}, u(Ch, "Yf"), Ch);
m(I8, "HighlightBuilder");
let TI = I8;
function W8(s) {
  let t = s.type.prop(z8);
  for (; t && t.context && !s.matchContext(t.context); )
    t = t.next;
  return t || null;
}
u(W8, "$b$1");
m(W8, "getStyleTags");
const H = hs.define, Sw = H(), js = H(), gP = H(js), vP = H(js), Xs = H(), Pw = H(Xs), Bv = H(Xs), Tn = H(), na = H(Tn), kn = H(), Sn = H(), v2 = H(), Ff = H(v2), Cw = H(), Q = {
  /**
  A comment.
  */
  comment: Sw,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: H(Sw),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: H(Sw),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: H(Sw),
  /**
  Any kind of identifier.
  */
  name: js,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: H(js),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: gP,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: H(gP),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: vP,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: H(vP),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: H(js),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: H(js),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: H(js),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: H(js),
  /**
  A literal value.
  */
  literal: Xs,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: Pw,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: H(Pw),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: H(Pw),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: H(Pw),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: Bv,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: H(Bv),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: H(Bv),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: H(Xs),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: H(Xs),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: H(Xs),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: H(Xs),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: H(Xs),
  /**
  A language keyword.
  */
  keyword: kn,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: H(kn),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: H(kn),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: H(kn),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: H(kn),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: H(kn),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: H(kn),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: H(kn),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: H(kn),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: H(kn),
  /**
  An operator.
  */
  operator: Sn,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: H(Sn),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: H(Sn),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: H(Sn),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: H(Sn),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: H(Sn),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: H(Sn),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: H(Sn),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: H(Sn),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: H(Sn),
  /**
  Program or markup punctuation.
  */
  punctuation: v2,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: H(v2),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: Ff,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: H(Ff),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: H(Ff),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: H(Ff),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: H(Ff),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Tn,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: na,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: H(na),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: H(na),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: H(na),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: H(na),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: H(na),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: H(na),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: H(Tn),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: H(Tn),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: H(Tn),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: H(Tn),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: H(Tn),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: H(Tn),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: H(Tn),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: H(Tn),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: H(),
  /**
  Deleted text.
  */
  deleted: H(),
  /**
  Changed text.
  */
  changed: H(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: H(),
  /**
  Metadata or meta-instruction.
  */
  meta: Cw,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: H(Cw),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: H(Cw),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: H(Cw),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: hs.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: hs.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: hs.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: hs.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: hs.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: hs.defineModifier()
};
Ix([
  { tag: Q.link, class: "tok-link" },
  { tag: Q.heading, class: "tok-heading" },
  { tag: Q.emphasis, class: "tok-emphasis" },
  { tag: Q.strong, class: "tok-strong" },
  { tag: Q.keyword, class: "tok-keyword" },
  { tag: Q.atom, class: "tok-atom" },
  { tag: Q.bool, class: "tok-bool" },
  { tag: Q.url, class: "tok-url" },
  { tag: Q.labelName, class: "tok-labelName" },
  { tag: Q.inserted, class: "tok-inserted" },
  { tag: Q.deleted, class: "tok-deleted" },
  { tag: Q.literal, class: "tok-literal" },
  { tag: Q.string, class: "tok-string" },
  { tag: Q.number, class: "tok-number" },
  { tag: [Q.regexp, Q.escape, Q.special(Q.string)], class: "tok-string2" },
  { tag: Q.variableName, class: "tok-variableName" },
  { tag: Q.local(Q.variableName), class: "tok-variableName tok-local" },
  { tag: Q.definition(Q.variableName), class: "tok-variableName tok-definition" },
  { tag: Q.special(Q.variableName), class: "tok-variableName2" },
  { tag: Q.definition(Q.propertyName), class: "tok-propertyName tok-definition" },
  { tag: Q.typeName, class: "tok-typeName" },
  { tag: Q.namespace, class: "tok-namespace" },
  { tag: Q.className, class: "tok-className" },
  { tag: Q.macroName, class: "tok-macroName" },
  { tag: Q.propertyName, class: "tok-propertyName" },
  { tag: Q.operator, class: "tok-operator" },
  { tag: Q.comment, class: "tok-comment" },
  { tag: Q.meta, class: "tok-meta" },
  { tag: Q.invalid, class: "tok-invalid" },
  { tag: Q.punctuation, class: "tok-punctuation" }
]);
var jv;
const Ks = /* @__PURE__ */ new Oe();
function Bm(s) {
  return me.define({
    combine: s ? (t) => t.concat(s) : void 0
  });
}
u(Bm, "mo$1");
m(Bm, "defineLanguageFacet");
const Wx = /* @__PURE__ */ new Oe();
var Qh;
const V8 = (Qh = class {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(t, i, n = [], r = "") {
    this.data = t, this.name = r, kt.prototype.hasOwnProperty("tree") || Object.defineProperty(kt.prototype, "tree", { get() {
      return nt(this);
    } }), this.parser = i, this.extension = [
      hf.of(this),
      kt.languageData.of((a, o, l) => {
        let c = O2(a, o, l), h = c.type.prop(Ks);
        if (!h)
          return [];
        let d = a.facet(h), f = c.type.prop(Wx);
        if (f) {
          let y = c.resolve(o - c.from, l);
          for (let w of f)
            if (w.test(y, a)) {
              let g = a.facet(w.facet);
              return w.type == "replace" ? g : g.concat(d);
            }
        }
        return d;
      })
    ].concat(n);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(t, i, n = -1) {
    return O2(t, i, n).type.prop(Ks) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(t) {
    let i = t.facet(hf);
    if ((i == null ? void 0 : i.data) == this.data)
      return [{ from: 0, to: t.doc.length }];
    if (!i || !i.allowsNesting)
      return [];
    let n = [], r = /* @__PURE__ */ m((a, o) => {
      if (a.prop(Ks) == this.data) {
        n.push({ from: o, to: o + a.length });
        return;
      }
      let l = a.prop(Oe.mounted);
      if (l) {
        if (l.tree.prop(Ks) == this.data) {
          if (l.overlay)
            for (let c of l.overlay)
              n.push({ from: c.from + o, to: c.to + o });
          else
            n.push({ from: o, to: o + a.length });
          return;
        } else if (l.overlay) {
          let c = n.length;
          if (r(l.tree, l.overlay[0].from + o), n.length > c)
            return;
        }
      }
      for (let c = 0; c < a.children.length; c++) {
        let h = a.children[c];
        h instanceof ze && r(h, a.positions[c] + o);
      }
    }, "explore");
    return r(nt(t), 0), n;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}, u(Qh, "Cf"), Qh);
m(V8, "Language");
let Ai = V8;
Ai.setState = /* @__PURE__ */ qe.define();
function O2(s, t, i) {
  let n = s.facet(hf), r = nt(s).topNode;
  if (!n || n.allowsNesting)
    for (let a = r; a; a = a.enter(t, i, Ne.ExcludeBuffers))
      a.type.isTop && (r = a);
  return r;
}
u(O2, "vu$1");
m(O2, "topNodeAt");
var yr;
const Z8 = (yr = class extends Ai {
  constructor(t, i, n) {
    super(t, i, [], n), this.parser = i;
  }
  /**
  Define a language from a parser.
  */
  static define(t) {
    let i = Bm(t.languageData);
    return new yr(i, t.parser.configure({
      props: [Ks.add((n) => n.isTop ? i : void 0)]
    }), t.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(t, i) {
    return new yr(this.data, this.parser.configure(t), i || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}, u(yr, "Cr"), yr);
m(Z8, "LRLanguage");
let Vx = Z8;
function nt(s) {
  let t = s.field(Ai.state, !1);
  return t ? t.tree : ze.empty;
}
u(nt, "J$2");
m(nt, "syntaxTree");
var Th;
const D8 = (Th = class {
  /**
  Create an input object for the given document.
  */
  constructor(t) {
    this.doc = t, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(t) {
    return this.string = this.cursor.next(t - this.cursorPos).value, this.cursorPos = t + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(t) {
    return this.syncTo(t), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(t, i) {
    let n = this.cursorPos - this.string.length;
    return t < n || i >= this.cursorPos ? this.doc.sliceString(t, i) : this.string.slice(t - n, i - n);
  }
}, u(Th, "Ef"), Th);
m(D8, "DocInput");
let MI = D8, Hf = null;
var mr;
const q8 = (mr = class {
  constructor(t, i, n = [], r, a, o, l, c) {
    this.parser = t, this.state = i, this.fragments = n, this.tree = r, this.treeLen = a, this.viewport = o, this.skipped = l, this.scheduleOn = c, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(t, i, n) {
    return new mr(t, i, [], ze.empty, 0, n, [], null);
  }
  startParse() {
    return this.parser.startParse(new MI(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(t, i) {
    return i != null && i >= this.state.doc.length && (i = void 0), this.tree != ze.empty && this.isDone(i ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var n;
      if (typeof t == "number") {
        let r = Date.now() + t;
        t = /* @__PURE__ */ m(() => Date.now() > r, "until");
      }
      for (this.parse || (this.parse = this.startParse()), i != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > i) && i < this.state.doc.length && this.parse.stopAt(i); ; ) {
        let r = this.parse.advance();
        if (r)
          if (this.fragments = this.withoutTempSkipped(dc.addTree(r, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (n = this.parse.stoppedAt) !== null && n !== void 0 ? n : this.state.doc.length, this.tree = r, this.parse = null, this.treeLen < (i ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (t())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let t, i;
    this.parse && (t = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > t) && this.parse.stopAt(t), this.withContext(() => {
      for (; !(i = this.parse.advance()); )
        ;
    }), this.treeLen = t, this.tree = i, this.fragments = this.withoutTempSkipped(dc.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(t) {
    let i = Hf;
    Hf = this;
    try {
      return t();
    } finally {
      Hf = i;
    }
  }
  withoutTempSkipped(t) {
    for (let i; i = this.tempSkipped.pop(); )
      t = b2(t, i.from, i.to);
    return t;
  }
  /**
  @internal
  */
  changes(t, i) {
    let { fragments: n, tree: r, treeLen: a, viewport: o, skipped: l } = this;
    if (this.takeTree(), !t.empty) {
      let c = [];
      if (t.iterChangedRanges((h, d, f, y) => c.push({ fromA: h, toA: d, fromB: f, toB: y })), n = dc.applyChanges(n, c), r = ze.empty, a = 0, o = { from: t.mapPos(o.from, -1), to: t.mapPos(o.to, 1) }, this.skipped.length) {
        l = [];
        for (let h of this.skipped) {
          let d = t.mapPos(h.from, 1), f = t.mapPos(h.to, -1);
          d < f && l.push({ from: d, to: f });
        }
      }
    }
    return new mr(this.parser, i, n, r, a, o, l, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(t) {
    if (this.viewport.from == t.from && this.viewport.to == t.to)
      return !1;
    this.viewport = t;
    let i = this.skipped.length;
    for (let n = 0; n < this.skipped.length; n++) {
      let { from: r, to: a } = this.skipped[n];
      r < t.to && a > t.from && (this.fragments = b2(this.fragments, r, a), this.skipped.splice(n--, 1));
    }
    return this.skipped.length >= i ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(t, i) {
    this.skipped.push({ from: t, to: i });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(t) {
    return new class extends N1 {
      createParse(i, n, r) {
        let a = r[0].from, o = r[r.length - 1].to;
        return {
          parsedPos: a,
          advance() {
            let l = Hf;
            if (l) {
              for (let c of r)
                l.tempSkipped.push(c);
              t && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, t]) : t);
            }
            return this.parsedPos = o, new ze(Et.none, [], [], o - a);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(t) {
    t = Math.min(t, this.state.doc.length);
    let i = this.fragments;
    return this.treeLen >= t && i.length && i[0].from == 0 && i[0].to >= t;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return Hf;
  }
}, u(mr, "Er"), mr);
m(q8, "ParseContext");
let qg = q8;
function b2(s, t, i) {
  return dc.applyChanges(s, [{ fromA: t, toA: i, fromB: t, toB: i }]);
}
u(b2, "Tu$1");
m(b2, "cutFragments");
var wr;
const U8 = (wr = class {
  constructor(t) {
    this.context = t, this.tree = t.tree;
  }
  apply(t) {
    if (!t.docChanged && this.tree == this.context.tree)
      return this;
    let i = this.context.changes(t.changes, t.state), n = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), i.viewport.to);
    return i.work(20, n) || i.takeTree(), new wr(i);
  }
  static init(t) {
    let i = Math.min(3e3, t.doc.length), n = qg.create(t.facet(hf).parser, t, { from: 0, to: i });
    return n.work(20, i) || n.takeTree(), new wr(n);
  }
}, u(wr, "Vr"), wr);
m(U8, "LanguageState");
let $2 = U8;
Ai.state = /* @__PURE__ */ As.define({
  create: $2.init,
  update(s, t) {
    for (let i of t.effects)
      if (i.is(Ai.setState))
        return i.value;
    return t.startState.facet(hf) != t.state.facet(hf) ? $2.init(t.state) : s.apply(t);
  }
});
let N8 = /* @__PURE__ */ m((s) => {
  let t = setTimeout(
    () => s(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(t);
}, "requestIdle");
typeof requestIdleCallback < "u" && (N8 = /* @__PURE__ */ m((s) => {
  let t = -1, i = setTimeout(
    () => {
      t = requestIdleCallback(s, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => t < 0 ? clearTimeout(i) : cancelIdleCallback(t);
}, "requestIdle"));
const Xv = typeof navigator < "u" && !((jv = navigator.scheduling) === null || jv === void 0) && jv.isInputPending ? () => navigator.scheduling.isInputPending() : null;
var Fv, Mh;
const RI = /* @__PURE__ */ Ps.fromClass((Fv = (Mh = class {
  constructor(t) {
    this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(t) {
    let i = this.view.state.field(Ai.state).context;
    (i.updateViewport(t.view.viewport) || this.view.viewport.to > i.treeLen) && this.scheduleWork(), (t.docChanged || t.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(i);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: t } = this.view, i = t.field(Ai.state);
    (i.tree != i.context.tree || !i.context.isDone(t.doc.length)) && (this.working = N8(this.work));
  }
  work(t) {
    this.working = null;
    let i = Date.now();
    if (this.chunkEnd < i && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = i + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: n, viewport: { to: r } } = this.view, a = n.field(Ai.state);
    if (a.tree == a.context.tree && a.context.isDone(
      r + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, t && !Xv ? Math.max(25, t.timeRemaining() - 5) : 1e9), l = a.context.treeLen < r && n.doc.length > r + 1e3, c = a.context.work(() => Xv && Xv() || Date.now() > o, r + (l ? 0 : 1e5));
    this.chunkBudget -= Date.now() - i, (c || this.chunkBudget <= 0) && (a.context.takeTree(), this.view.dispatch({ effects: Ai.setState.of(new $2(a.context)) })), this.chunkBudget > 0 && !(c && !l) && this.scheduleWork(), this.checkAsyncSchedule(a.context);
  }
  checkAsyncSchedule(t) {
    t.scheduleOn && (this.workScheduled++, t.scheduleOn.then(() => this.scheduleWork()).catch((i) => gi(this.view.state, i)).then(() => this.workScheduled--), t.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, u(Mh, "Ui$1"), Mh), m(Fv, "ParseWorker"), Fv), {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), hf = /* @__PURE__ */ me.define({
  combine(s) {
    return s.length ? s[0] : null;
  },
  enables: /* @__PURE__ */ m((s) => [
    Ai.state,
    RI,
    $e.contentAttributes.compute([s], (t) => {
      let i = t.facet(s);
      return i && i.name ? { "data-language": i.name } : {};
    })
  ], "enables")
});
var Rh;
const B8 = (Rh = class {
  /**
  Create a language support object.
  */
  constructor(t, i = []) {
    this.language = t, this.support = i, this.extension = [t, i];
  }
}, u(Rh, "Vf"), Rh);
m(B8, "LanguageSupport");
let df = B8;
var to;
const j8 = (to = class {
  constructor(t, i, n, r, a, o = void 0) {
    this.name = t, this.alias = i, this.extensions = n, this.filename = r, this.loadFunc = a, this.support = o, this.loading = null;
  }
  /**
  Start loading the the language. Will return a promise that
  resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
  object when the language successfully loads.
  */
  load() {
    return this.loading || (this.loading = this.loadFunc().then((t) => this.support = t, (t) => {
      throw this.loading = null, t;
    }));
  }
  /**
  Create a language description.
  */
  static of(t) {
    let { load: i, support: n } = t;
    if (!i) {
      if (!n)
        throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
      i = /* @__PURE__ */ m(() => Promise.resolve(n), "load");
    }
    return new to(t.name, (t.alias || []).concat(t.name).map((r) => r.toLowerCase()), t.extensions || [], t.filename, i, n);
  }
  /**
  Look for a language in the given array of descriptions that
  matches the filename. Will first match
  [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
  and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
  and return the first language that matches.
  */
  static matchFilename(t, i) {
    for (let r of t)
      if (r.filename && r.filename.test(i))
        return r;
    let n = /\.([^.]+)$/.exec(i);
    if (n) {
      for (let r of t)
        if (r.extensions.indexOf(n[1]) > -1)
          return r;
    }
    return null;
  }
  /**
  Look for a language whose name or alias matches the the given
  name (case-insensitively). If `fuzzy` is true, and no direct
  matchs is found, this'll also search for a language whose name
  or alias occurs in the string (for names shorter than three
  characters, only when surrounded by non-word characters).
  */
  static matchLanguageName(t, i, n = !0) {
    i = i.toLowerCase();
    for (let r of t)
      if (r.alias.some((a) => a == i))
        return r;
    if (n)
      for (let r of t)
        for (let a of r.alias) {
          let o = i.indexOf(a);
          if (o > -1 && (a.length > 2 || !/\w/.test(i[o - 1]) && !/\w/.test(i[o + a.length])))
            return r;
        }
    return null;
  }
}, u(to, "no"), to);
m(j8, "LanguageDescription");
let OP = j8;
const AI = /* @__PURE__ */ me.define(), B1 = /* @__PURE__ */ me.define({
  combine: /* @__PURE__ */ m((s) => {
    if (!s.length)
      return "  ";
    let t = s[0];
    if (!t || /\S/.test(t) || Array.from(t).some((i) => i != t[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(s[0]));
    return t;
  }, "combine")
});
function am(s) {
  let t = s.facet(B1);
  return t.charCodeAt(0) == 9 ? s.tabSize * t.length : t.length;
}
u(am, "li$1");
m(am, "getIndentUnit");
function x2(s, t) {
  let i = "", n = s.tabSize, r = s.facet(B1)[0];
  if (r == "	") {
    for (; t >= n; )
      i += "	", t -= n;
    r = " ";
  }
  for (let a = 0; a < t; a++)
    i += r;
  return i;
}
u(x2, "gs$1");
m(x2, "indentString");
function X8(s, t) {
  s instanceof kt && (s = new Zx(s));
  for (let n of s.state.facet(AI)) {
    let r = n(s, t);
    if (r !== void 0)
      return r;
  }
  let i = nt(s.state);
  return i.length >= t ? H8(s, i, t) : null;
}
u(X8, "tp$1");
m(X8, "getIndentation");
var Ah;
const F8 = (Ah = class {
  /**
  Create an indent context.
  */
  constructor(t, i = {}) {
    this.state = t, this.options = i, this.unit = am(t);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(t, i = 1) {
    let n = this.state.doc.lineAt(t), { simulateBreak: r, simulateDoubleBreak: a } = this.options;
    return r != null && r >= n.from && r <= n.to ? a && r == t ? { text: "", from: t } : (i < 0 ? r < t : r <= t) ? { text: n.text.slice(r - n.from), from: r } : { text: n.text.slice(0, r - n.from), from: n.from } : n;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(t, i = 1) {
    if (this.options.simulateDoubleBreak && t == this.options.simulateBreak)
      return "";
    let { text: n, from: r } = this.lineAt(t, i);
    return n.slice(t - r, Math.min(n.length, t + 100 - r));
  }
  /**
  Find the column for the given position.
  */
  column(t, i = 1) {
    let { text: n, from: r } = this.lineAt(t, i), a = this.countColumn(n, t - r), o = this.options.overrideIndentation ? this.options.overrideIndentation(r) : -1;
    return o > -1 && (a += o - this.countColumn(n, n.search(/\S|$/))), a;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(t, i = t.length) {
    return xr(t, this.state.tabSize, i);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(t, i = 1) {
    let { text: n, from: r } = this.lineAt(t, i), a = this.options.overrideIndentation;
    if (a) {
      let o = a(r);
      if (o > -1)
        return o;
    }
    return this.countColumn(n, n.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}, u(Ah, "Xf"), Ah);
m(F8, "IndentContext");
let Zx = F8;
const zf = /* @__PURE__ */ new Oe();
function H8(s, t, i) {
  let n = t.resolveStack(i), r = t.resolveInner(i, -1).resolve(i, 0).enterUnfinishedNodesBefore(i);
  if (r != n.node) {
    let a = [];
    for (let o = r; o && !(o.from == n.node.from && o.type == n.node.type); o = o.parent)
      a.push(o);
    for (let o = a.length - 1; o >= 0; o--)
      n = { node: a[o], next: n };
  }
  return Dx(n, s, i);
}
u(H8, "Ab$1");
m(H8, "syntaxIndentation");
function Dx(s, t, i) {
  for (let n = s; n; n = n.next) {
    let r = G8(n.node);
    if (r)
      return r(EI.create(t, i, n));
  }
  return 0;
}
u(Dx, "ip$1");
m(Dx, "indentFor");
function Y8(s) {
  return s.pos == s.options.simulateBreak && s.options.simulateDoubleBreak;
}
u(Y8, "Zb$1");
m(Y8, "ignoreClosed");
function G8(s) {
  let t = s.type.prop(zf);
  if (t)
    return t;
  let i = s.firstChild, n;
  if (i && (n = i.type.prop(Oe.closedBy))) {
    let r = s.lastChild, a = r && n.indexOf(r.name) > -1;
    return (o) => qx(o, !0, 1, void 0, a && !Y8(o) ? r.from : void 0);
  }
  return s.parent == null ? K8 : null;
}
u(G8, "Wb$1");
m(G8, "indentStrategy");
function K8() {
  return 0;
}
u(K8, "Ub$1");
m(K8, "topIndent");
var io;
const J8 = (io = class extends Zx {
  constructor(t, i, n) {
    super(t.state, t.options), this.base = t, this.pos = i, this.context = n;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(t, i, n) {
    return new io(t, i, n);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(t) {
    let i = this.state.doc.lineAt(t.from);
    for (; ; ) {
      let n = t.resolve(i.from);
      for (; n.parent && n.parent.from == n.from; )
        n = n.parent;
      if (e6(n, t))
        break;
      i = this.state.doc.lineAt(n.from);
    }
    return this.lineIndent(i.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return Dx(this.context.next, this.base, this.pos);
  }
}, u(io, "so"), io);
m(J8, "TreeIndentContext");
let EI = J8;
function e6(s, t) {
  for (let i = t; i; i = i.parent)
    if (s == i)
      return !0;
  return !1;
}
u(e6, "Lb$1");
m(e6, "isParent");
function t6(s) {
  let t = s.node, i = t.childAfter(t.from), n = t.lastChild;
  if (!i)
    return null;
  let r = s.options.simulateBreak, a = s.state.doc.lineAt(i.from), o = r == null || r <= a.from ? a.to : Math.min(a.to, r);
  for (let l = i.to; ; ) {
    let c = t.childAfter(l);
    if (!c || c == n)
      return null;
    if (!c.type.isSkipped) {
      if (c.from >= o)
        return null;
      let h = /^ */.exec(a.text.slice(i.to - a.from))[0].length;
      return { from: i.from, to: i.to + h };
    }
    l = c.to;
  }
}
u(t6, "_b$1");
m(t6, "bracketedAligned");
function i6({ closing: s, align: t = !0, units: i = 1 }) {
  return (n) => qx(n, t, i, s);
}
u(i6, "Mb$1");
m(i6, "delimitedIndent");
function qx(s, t, i, n, r) {
  let a = s.textAfter, o = a.match(/^\s*/)[0].length, l = n && a.slice(o, o + n.length) == n || r == s.pos + o, c = t ? t6(s) : null;
  return c ? l ? s.column(c.from) : s.column(c.to) : s.baseIndent + (l ? 0 : s.unit * i);
}
u(qx, "rp$1");
m(qx, "delimitedStrategy");
const zI = /* @__PURE__ */ m((s) => s.baseIndent, "flatIndent");
function By({ except: s, units: t = 1 } = {}) {
  return (i) => {
    let n = s && s.test(i.textAfter);
    return i.baseIndent + (n ? 0 : t * i.unit);
  };
}
u(By, "Bn$1");
m(By, "continuedIndent");
const _I = /* @__PURE__ */ me.define(), jm = /* @__PURE__ */ new Oe();
function Ux(s) {
  let t = s.firstChild, i = s.lastChild;
  return t && t.to < i.from ? { from: t.to, to: i.type.isError ? s.to : i.from } : null;
}
u(Ux, "np$1");
m(Ux, "foldInside");
var no;
const n6 = (no = class {
  constructor(t, i) {
    this.specs = t;
    let n;
    function r(l) {
      let c = kr.newName();
      return (n || (n = /* @__PURE__ */ Object.create(null)))["." + c] = l, c;
    }
    u(r, "n"), m(r, "def");
    const a = typeof i.all == "string" ? i.all : i.all ? r(i.all) : void 0, o = i.scope;
    this.scope = o instanceof Ai ? (l) => l.prop(Ks) == o.data : o ? (l) => l == o : void 0, this.style = Ix(t.map((l) => ({
      tag: l.tag,
      class: l.class || r(Object.assign({}, l, { tag: null }))
    })), {
      all: a
    }).style, this.module = n ? new kr(n) : null, this.themeType = i.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(t, i) {
    return new no(t, i || {});
  }
}, u(no, "oo"), no);
m(n6, "HighlightStyle");
let s6 = n6;
const k2 = /* @__PURE__ */ me.define(), r6 = /* @__PURE__ */ me.define({
  combine(s) {
    return s.length ? [s[0]] : null;
  }
});
function Nw(s) {
  let t = s.facet(k2);
  return t.length ? t : s.facet(r6);
}
u(Nw, "Wo$1");
m(Nw, "getHighlighters");
function LI(s, t) {
  let i = [WI], n;
  return s instanceof s6 && (s.module && i.push($e.styleModule.of(s.module)), n = s.themeType), t != null && t.fallback ? i.push(r6.of(s)) : n ? i.push(k2.computeN([$e.darkTheme], (r) => r.facet($e.darkTheme) == (n == "dark") ? [s] : [])) : i.push(k2.of(s)), i;
}
u(LI, "Eb$1");
m(LI, "syntaxHighlighting");
var Eh;
const a6 = (Eh = class {
  constructor(t) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = nt(t.state), this.decorations = this.buildDeco(t, Nw(t.state)), this.decoratedTo = t.viewport.to;
  }
  update(t) {
    let i = nt(t.state), n = Nw(t.state), r = n != Nw(t.startState), { viewport: a } = t.view, o = t.changes.mapPos(this.decoratedTo, 1);
    i.length < a.to && !r && i.type == this.tree.type && o >= a.to ? (this.decorations = this.decorations.map(t.changes), this.decoratedTo = o) : (i != this.tree || t.viewportChanged || r) && (this.tree = i, this.decorations = this.buildDeco(t.view, n), this.decoratedTo = a.to);
  }
  buildDeco(t, i) {
    if (!i || !this.tree.length)
      return Xe.none;
    let n = new Mg();
    for (let { from: r, to: a } of t.visibleRanges)
      L8(this.tree, i, (o, l, c) => {
        n.add(o, l, this.markCache[c] || (this.markCache[c] = Xe.mark({ class: c })));
      }, r, a);
    return n.finish();
  }
}, u(Eh, "If"), Eh);
m(a6, "TreeHighlighter");
let II = a6;
const WI = /* @__PURE__ */ Lo.high(/* @__PURE__ */ Ps.fromClass(II, {
  decorations: /* @__PURE__ */ m((s) => s.decorations, "decorations")
}));
Q.meta, Q.link, Q.heading, Q.emphasis, Q.strong, Q.strikethrough, Q.keyword, Q.atom, Q.bool, Q.url, Q.contentSeparator, Q.labelName, Q.literal, Q.inserted, Q.string, Q.deleted, Q.regexp, Q.escape, Q.string, Q.variableName, Q.variableName, Q.typeName, Q.namespace, Q.className, Q.variableName, Q.macroName, Q.propertyName, Q.comment, Q.invalid;
const VI = 1e4, ZI = "()[]{}", o6 = /* @__PURE__ */ new Oe();
function Ug(s, t, i) {
  let n = s.prop(t < 0 ? Oe.openedBy : Oe.closedBy);
  if (n)
    return n;
  if (s.name.length == 1) {
    let r = i.indexOf(s.name);
    if (r > -1 && r % 2 == (t < 0 ? 1 : 0))
      return [i[r + t]];
  }
  return null;
}
u(Ug, "la$1");
m(Ug, "matchingNodes");
function Ng(s) {
  let t = s.type.prop(o6);
  return t ? t(s.node) : s;
}
u(Ng, "aa$1");
m(Ng, "findHandle");
function $a(s, t, i, n = {}) {
  let r = n.maxScanDistance || VI, a = n.brackets || ZI, o = nt(s), l = o.resolveInner(t, i);
  for (let c = l; c; c = c.parent) {
    let h = Ug(c.type, i, a);
    if (h && c.from < c.to) {
      let d = Ng(c);
      if (d && (i > 0 ? t >= d.from && t < d.to : t > d.from && t <= d.to))
        return l6(s, t, i, c, d, h, a);
    }
  }
  return c6(s, t, i, o, l.type, r, a);
}
u($a, "gi$1");
m($a, "matchBrackets");
function l6(s, t, i, n, r, a, o) {
  let l = n.parent, c = { from: r.from, to: r.to }, h = 0, d = l == null ? void 0 : l.cursor();
  if (d && (i < 0 ? d.childBefore(n.from) : d.childAfter(n.to)))
    do
      if (i < 0 ? d.to <= n.from : d.from >= n.to) {
        if (h == 0 && a.indexOf(d.type.name) > -1 && d.from < d.to) {
          let f = Ng(d);
          return { start: c, end: f ? { from: f.from, to: f.to } : void 0, matched: !0 };
        } else if (Ug(d.type, i, o))
          h++;
        else if (Ug(d.type, -i, o)) {
          if (h == 0) {
            let f = Ng(d);
            return {
              start: c,
              end: f && f.from < f.to ? { from: f.from, to: f.to } : void 0,
              matched: !1
            };
          }
          h--;
        }
      }
    while (i < 0 ? d.prevSibling() : d.nextSibling());
  return { start: c, matched: !1 };
}
u(l6, "jb$1");
m(l6, "matchMarkedBrackets");
function c6(s, t, i, n, r, a, o) {
  let l = i < 0 ? s.sliceDoc(t - 1, t) : s.sliceDoc(t, t + 1), c = o.indexOf(l);
  if (c < 0 || c % 2 == 0 != i > 0)
    return null;
  let h = { from: i < 0 ? t - 1 : t, to: i > 0 ? t + 1 : t }, d = s.doc.iterRange(t, i > 0 ? s.doc.length : 0), f = 0;
  for (let y = 0; !d.next().done && y <= a; ) {
    let w = d.value;
    i < 0 && (y += w.length);
    let g = t + y * i;
    for (let b = i > 0 ? 0 : w.length - 1, k = i > 0 ? w.length : -1; b != k; b += i) {
      let $ = o.indexOf(w[b]);
      if (!($ < 0 || n.resolveInner(g + b, 1).type != r))
        if ($ % 2 == 0 == i > 0)
          f++;
        else {
          if (f == 1)
            return { start: h, end: { from: g + b, to: g + b + 1 }, matched: $ >> 1 == c >> 1 };
          f--;
        }
    }
    i > 0 && (y += w.length);
  }
  return d.done ? { start: h, matched: !1 } : null;
}
u(c6, "qb$1");
m(c6, "matchPlainBrackets");
function S2(s, t, i, n = 0, r = 0) {
  t == null && (t = s.search(/[^\s\u00a0]/), t == -1 && (t = s.length));
  let a = r;
  for (let o = n; o < t; o++)
    s.charCodeAt(o) == 9 ? a += i - a % i : a++;
  return a;
}
u(S2, "Au$1");
m(S2, "countCol");
var zh;
const h6 = (zh = class {
  /**
  Create a stream.
  */
  constructor(t, i, n, r) {
    this.string = t, this.tabSize = i, this.indentUnit = n, this.overrideIndent = r, this.pos = 0, this.start = 0, this.lastColumnPos = 0, this.lastColumnValue = 0;
  }
  /**
  True if we are at the end of the line.
  */
  eol() {
    return this.pos >= this.string.length;
  }
  /**
  True if we are at the start of the line.
  */
  sol() {
    return this.pos == 0;
  }
  /**
  Get the next code unit after the current position, or undefined
  if we're at the end of the line.
  */
  peek() {
    return this.string.charAt(this.pos) || void 0;
  }
  /**
  Read the next code unit and advance `this.pos`.
  */
  next() {
    if (this.pos < this.string.length)
      return this.string.charAt(this.pos++);
  }
  /**
  Match the next character against the given string, regular
  expression, or predicate. Consume and return it if it matches.
  */
  eat(t) {
    let i = this.string.charAt(this.pos), n;
    if (typeof t == "string" ? n = i == t : n = i && (t instanceof RegExp ? t.test(i) : t(i)), n)
      return ++this.pos, i;
  }
  /**
  Continue matching characters that match the given string,
  regular expression, or predicate function. Return true if any
  characters were consumed.
  */
  eatWhile(t) {
    let i = this.pos;
    for (; this.eat(t); )
      ;
    return this.pos > i;
  }
  /**
  Consume whitespace ahead of `this.pos`. Return true if any was
  found.
  */
  eatSpace() {
    let t = this.pos;
    for (; /[\s\u00a0]/.test(this.string.charAt(this.pos)); )
      ++this.pos;
    return this.pos > t;
  }
  /**
  Move to the end of the line.
  */
  skipToEnd() {
    this.pos = this.string.length;
  }
  /**
  Move to directly before the given character, if found on the
  current line.
  */
  skipTo(t) {
    let i = this.string.indexOf(t, this.pos);
    if (i > -1)
      return this.pos = i, !0;
  }
  /**
  Move back `n` characters.
  */
  backUp(t) {
    this.pos -= t;
  }
  /**
  Get the column position at `this.pos`.
  */
  column() {
    return this.lastColumnPos < this.start && (this.lastColumnValue = S2(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue;
  }
  /**
  Get the indentation column of the current line.
  */
  indentation() {
    var t;
    return (t = this.overrideIndent) !== null && t !== void 0 ? t : S2(this.string, null, this.tabSize);
  }
  /**
  Match the input against the given string or regular expression
  (which should start with a `^`). Return true or the regexp match
  if it matches.
  
  Unless `consume` is set to `false`, this will move `this.pos`
  past the matched text.
  
  When matching a string `caseInsensitive` can be set to true to
  make the match case-insensitive.
  */
  match(t, i, n) {
    if (typeof t == "string") {
      let r = /* @__PURE__ */ m((o) => n ? o.toLowerCase() : o, "cased"), a = this.string.substr(this.pos, t.length);
      return r(a) == r(t) ? (i !== !1 && (this.pos += t.length), !0) : null;
    } else {
      let r = this.string.slice(this.pos).match(t);
      return r && r.index > 0 ? null : (r && i !== !1 && (this.pos += r[0].length), r);
    }
  }
  /**
  Get the current token.
  */
  current() {
    return this.string.slice(this.start, this.pos);
  }
}, u(zh, "jf"), zh);
m(h6, "StringStream");
let d6 = h6;
function u6(s) {
  return {
    name: s.name || "",
    token: s.token,
    blankLine: s.blankLine || (() => {
    }),
    startState: s.startState || (() => !0),
    copyState: s.copyState || p6,
    indent: s.indent || (() => null),
    languageData: s.languageData || {},
    tokenTable: s.tokenTable || jx
  };
}
u(u6, "zb$1");
m(u6, "fullParser");
function p6(s) {
  if (typeof s != "object")
    return s;
  let t = {};
  for (let i in s) {
    let n = s[i];
    t[i] = n instanceof Array ? n.slice() : n;
  }
  return t;
}
u(p6, "Db$1");
m(p6, "defaultCopyState");
const bP = /* @__PURE__ */ new WeakMap();
var so;
const f6 = (so = class extends Ai {
  constructor(t) {
    let i = Bm(t.languageData), n = u6(t), r, a = new class extends N1 {
      createParse(o, l, c) {
        return new qI(r, o, l, c);
      }
    }();
    super(i, a, [], t.name), this.topNode = v6(i, this), r = this, this.streamParser = n, this.stateAfter = new Oe({ perNode: !0 }), this.tokenTable = t.tokenTable ? new g6(n.tokenTable) : NI;
  }
  /**
  Define a stream language.
  */
  static define(t) {
    return new so(t);
  }
  /**
  @internal
  */
  getIndent(t) {
    let i, { overrideIndentation: n } = t.options;
    n && (i = bP.get(t.state), i != null && i < t.pos - 1e4 && (i = void 0));
    let r = j1(this, t.node.tree, t.node.from, t.node.from, i ?? t.pos), a, o;
    if (r ? (o = r.state, a = r.pos + 1) : (o = this.streamParser.startState(t.unit), a = t.node.from), t.pos - a > 1e4)
      return null;
    for (; a < t.pos; ) {
      let c = t.state.doc.lineAt(a), h = Math.min(t.pos, c.to);
      if (c.length) {
        let d = n ? n(c.from) : -1, f = new d6(c.text, t.state.tabSize, t.unit, d < 0 ? void 0 : d);
        for (; f.pos < h - c.from; )
          Bx(this.streamParser.token, f, o);
      } else
        this.streamParser.blankLine(o, t.unit);
      if (h == t.pos)
        break;
      a = c.to + 1;
    }
    let l = t.lineAt(t.pos);
    return n && i == null && bP.set(t.state, l.from), this.streamParser.indent(o, /^\s*(.*)/.exec(l.text)[1], t);
  }
  get allowsNesting() {
    return !1;
  }
}, u(so, "lo"), so);
m(f6, "StreamLanguage");
let DI = f6;
function j1(s, t, i, n, r) {
  let a = i >= n && i + t.length <= r && t.prop(s.stateAfter);
  if (a)
    return { state: s.streamParser.copyState(a), pos: i + t.length };
  for (let o = t.children.length - 1; o >= 0; o--) {
    let l = t.children[o], c = i + t.positions[o], h = l instanceof ze && c < r && j1(s, l, c, n, r);
    if (h)
      return h;
  }
  return null;
}
u(j1, "ah$1");
m(j1, "findState");
function Nx(s, t, i, n, r) {
  if (r && i <= 0 && n >= t.length)
    return t;
  !r && i == 0 && t.type == s.topNode && (r = !0);
  for (let a = t.children.length - 1; a >= 0; a--) {
    let o = t.positions[a], l = t.children[a], c;
    if (o < n && l instanceof ze) {
      if (!(c = Nx(s, l, i - o, n - o, r)))
        break;
      return r ? new ze(t.type, t.children.slice(0, a).concat(c), t.positions.slice(0, a + 1), o + c.length) : c;
    }
  }
  return null;
}
u(Nx, "lp$1");
m(Nx, "cutTree");
function y6(s, t, i, n, r) {
  for (let a of t) {
    let o = a.from + (a.openStart ? 25 : 0), l = a.to - (a.openEnd ? 25 : 0), c = o <= i && l > i && j1(s, a.tree, 0 - a.offset, i, l), h;
    if (c && c.pos <= n && (h = Nx(s, a.tree, i + a.offset, c.pos + a.offset, !1)))
      return { state: c.state, tree: h };
  }
  return { state: s.streamParser.startState(r ? am(r) : 4), tree: ze.empty };
}
u(y6, "Bb$1");
m(y6, "findStartInFragments");
var Hv, _h;
let qI = (Hv = (_h = class {
  constructor(t, i, n, r) {
    this.lang = t, this.input = i, this.fragments = n, this.ranges = r, this.stoppedAt = null, this.chunks = [], this.chunkPos = [], this.chunk = [], this.chunkReused = void 0, this.rangeIndex = 0, this.to = r[r.length - 1].to;
    let a = qg.get(), o = r[0].from, { state: l, tree: c } = y6(t, n, o, this.to, a == null ? void 0 : a.state);
    this.state = l, this.parsedPos = this.chunkStart = o + c.length;
    for (let h = 0; h < c.children.length; h++)
      this.chunks.push(c.children[h]), this.chunkPos.push(c.positions[h]);
    a && this.parsedPos < a.viewport.from - 1e5 && r.some((h) => h.from <= a.viewport.from && h.to >= a.viewport.from) && (this.state = this.lang.streamParser.startState(am(a.state)), a.skipUntilInView(this.parsedPos, a.viewport.from), this.parsedPos = a.viewport.from), this.moveRangeIndex();
  }
  advance() {
    let t = qg.get(), i = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt), n = Math.min(
      i,
      this.chunkStart + 2048
      /* C.ChunkSize */
    );
    for (t && (n = Math.min(n, t.viewport.to)); this.parsedPos < n; )
      this.parseLine(t);
    return this.chunkStart < this.parsedPos && this.finishChunk(), this.parsedPos >= i ? this.finish() : t && this.parsedPos >= t.viewport.to ? (t.skipUntilInView(this.parsedPos, i), this.finish()) : null;
  }
  stopAt(t) {
    this.stoppedAt = t;
  }
  lineAfter(t) {
    let i = this.input.chunk(t);
    if (this.input.lineChunks)
      i == `
` && (i = "");
    else {
      let n = i.indexOf(`
`);
      n > -1 && (i = i.slice(0, n));
    }
    return t + i.length <= this.to ? i : i.slice(0, this.to - t);
  }
  nextLine() {
    let t = this.parsedPos, i = this.lineAfter(t), n = t + i.length;
    for (let r = this.rangeIndex; ; ) {
      let a = this.ranges[r].to;
      if (a >= n || (i = i.slice(0, a - (n - i.length)), r++, r == this.ranges.length))
        break;
      let o = this.ranges[r].from, l = this.lineAfter(o);
      i += l, n = o + l.length;
    }
    return { line: i, end: n };
  }
  skipGapsTo(t, i, n) {
    for (; ; ) {
      let r = this.ranges[this.rangeIndex].to, a = t + i;
      if (n > 0 ? r > a : r >= a)
        break;
      let o = this.ranges[++this.rangeIndex].from;
      i += o - r;
    }
    return i;
  }
  moveRangeIndex() {
    for (; this.ranges[this.rangeIndex].to < this.parsedPos; )
      this.rangeIndex++;
  }
  emitToken(t, i, n, r) {
    let a = 4;
    if (this.ranges.length > 1) {
      r = this.skipGapsTo(i, r, 1), i += r;
      let l = this.chunk.length;
      r = this.skipGapsTo(n, r, -1), n += r, a += this.chunk.length - l;
    }
    let o = this.chunk.length - 4;
    return a == 4 && o >= 0 && this.chunk[o] == t && this.chunk[o + 2] == i ? this.chunk[o + 2] = n : this.chunk.push(t, i, n, a), r;
  }
  parseLine(t) {
    let { line: i, end: n } = this.nextLine(), r = 0, { streamParser: a } = this.lang, o = new d6(i, t ? t.state.tabSize : 4, t ? am(t.state) : 2);
    if (o.eol())
      a.blankLine(this.state, o.indentUnit);
    else
      for (; !o.eol(); ) {
        let l = Bx(a.token, o, this.state);
        if (l && (r = this.emitToken(this.lang.tokenTable.resolve(l), this.parsedPos + o.start, this.parsedPos + o.pos, r)), o.start > 1e4)
          break;
      }
    this.parsedPos = n, this.moveRangeIndex(), this.parsedPos < this.to && this.parsedPos++;
  }
  finishChunk() {
    let t = ze.build({
      buffer: this.chunk,
      start: this.chunkStart,
      length: this.parsedPos - this.chunkStart,
      nodeSet: UI,
      topID: 0,
      maxBufferLength: 2048,
      reused: this.chunkReused
    });
    t = new ze(t.type, t.children, t.positions, t.length, [[this.lang.stateAfter, this.lang.streamParser.copyState(this.state)]]), this.chunks.push(t), this.chunkPos.push(this.chunkStart - this.ranges[0].from), this.chunk = [], this.chunkReused = void 0, this.chunkStart = this.parsedPos;
  }
  finish() {
    return new ze(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
  }
}, u(_h, "Li$1"), _h), m(Hv, "Parse"), Hv);
function Bx(s, t, i) {
  t.start = t.pos;
  for (let n = 0; n < 10; n++) {
    let r = s(t, i);
    if (t.pos > t.start)
      return r;
  }
  throw new Error("Stream parser failed to advance stream.");
}
u(Bx, "ap$1");
m(Bx, "readToken$1");
const jx = /* @__PURE__ */ Object.create(null), om = [Et.none], UI = /* @__PURE__ */ new D1(om), $P = [], xP = /* @__PURE__ */ Object.create(null), m6 = /* @__PURE__ */ Object.create(null);
for (let [s, t] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  m6[s] = /* @__PURE__ */ Xx(jx, t);
var Lh;
const w6 = (Lh = class {
  constructor(t) {
    this.extra = t, this.table = Object.assign(/* @__PURE__ */ Object.create(null), m6);
  }
  resolve(t) {
    return t ? this.table[t] || (this.table[t] = Xx(this.extra, t)) : 0;
  }
}, u(Lh, "qf"), Lh);
m(w6, "TokenTable");
let g6 = w6;
const NI = /* @__PURE__ */ new g6(jx);
function Bw(s, t) {
  $P.indexOf(s) > -1 || ($P.push(s), console.warn(t));
}
u(Bw, "Uo$1");
m(Bw, "warnForPart");
function Xx(s, t) {
  let i = [];
  for (let l of t.split(" ")) {
    let c = [];
    for (let h of l.split(".")) {
      let d = s[h] || Q[h];
      d ? typeof d == "function" ? c.length ? c = c.map(d) : Bw(h, `Modifier ${h} used at start of tag`) : c.length ? Bw(h, `Tag ${h} used as modifier`) : c = Array.isArray(d) ? d : [d] : Bw(h, `Unknown highlighting tag ${h}`);
    }
    for (let h of c)
      i.push(h);
  }
  if (!i.length)
    return 0;
  let n = t.replace(/ /g, "_"), r = n + " " + i.map((l) => l.id), a = xP[r];
  if (a)
    return a.id;
  let o = xP[r] = Et.define({
    id: om.length,
    name: n,
    props: [Io({ [n]: i })]
  });
  return om.push(o), o.id;
}
u(Xx, "fp$1");
m(Xx, "createTokenType");
function v6(s, t) {
  let i = Et.define({ id: om.length, name: "Document", props: [
    Ks.add(() => s),
    zf.add(() => (n) => t.getIndent(n))
  ], top: !0 });
  return om.push(i), i;
}
u(v6, "Hb$1");
m(v6, "docID");
gt.RTL, gt.LTR;
var Ih;
const O6 = (Ih = class {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(t, i, n, r) {
    this.state = t, this.pos = i, this.explicit = n, this.view = r, this.abortListeners = [], this.abortOnDocChange = !1;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(t) {
    let i = nt(this.state).resolveInner(this.pos, -1);
    for (; i && t.indexOf(i.name) < 0; )
      i = i.parent;
    return i ? {
      from: i.from,
      to: this.pos,
      text: this.state.sliceDoc(i.from, this.pos),
      type: i.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(t) {
    let i = this.state.doc.lineAt(this.pos), n = Math.max(i.from, this.pos - 250), r = i.text.slice(n - i.from, this.pos - i.from), a = r.search(Yx(t, !1));
    return a < 0 ? null : { from: n + a, to: this.pos, text: r.slice(a) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(t, i, n) {
    t == "abort" && this.abortListeners && (this.abortListeners.push(i), n && n.onDocChange && (this.abortOnDocChange = !0));
  }
}, u(Ih, "zf"), Ih);
m(O6, "CompletionContext");
let Fx = O6;
function P2(s) {
  let t = Object.keys(s).join(""), i = /\w/.test(t);
  return i && (t = t.replace(/\w/g, "")), `[${i ? "\\w" : ""}${t.replace(/[^\w\s]/g, "\\$&")}]`;
}
u(P2, "Lu$1");
m(P2, "toSet");
function b6(s) {
  let t = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  for (let { label: r } of s) {
    t[r[0]] = !0;
    for (let a = 1; a < r.length; a++)
      i[r[a]] = !0;
  }
  let n = P2(t) + P2(i) + "*$";
  return [new RegExp("^" + n), new RegExp(n)];
}
u(b6, "Kb$1");
m(b6, "prefixMatch");
function Hx(s) {
  let t = s.map((r) => typeof r == "string" ? { label: r } : r), [i, n] = t.every((r) => /^\w+$/.test(r.label)) ? [/\w*$/, /\w+$/] : b6(t);
  return (r) => {
    let a = r.matchBefore(n);
    return a || r.explicit ? { from: a ? a.from : r.pos, options: t, validFor: i } : null;
  };
}
u(Hx, "cp$1");
m(Hx, "completeFromList");
function $6(s, t) {
  return (i) => {
    for (let n = nt(i.state).resolveInner(i.pos, -1); n; n = n.parent) {
      if (s.indexOf(n.name) > -1)
        return null;
      if (n.type.isTop)
        break;
    }
    return t(i);
  };
}
u($6, "Jb$1");
m($6, "ifNotIn");
var Wh;
const x6 = (Wh = class {
  constructor(t, i, n, r) {
    this.completion = t, this.source = i, this.match = n, this.score = r;
  }
}, u(Wh, "Df"), Wh);
m(x6, "Option");
let kP = x6;
function tr(s) {
  return s.selection.main.from;
}
u(tr, "Kt$1");
m(tr, "cur");
function Yx(s, t) {
  var i;
  let { source: n } = s, r = t && n[0] != "^", a = n[n.length - 1] != "$";
  return !r && !a ? s : new RegExp(`${r ? "^" : ""}(?:${n})${a ? "$" : ""}`, (i = s.flags) !== null && i !== void 0 ? i : s.ignoreCase ? "i" : "");
}
u(Yx, "up$1");
m(Yx, "ensureAnchor");
const Gx = /* @__PURE__ */ Es.define();
function k6(s, t, i, n) {
  let { main: r } = s.selection, a = i - r.from, o = n - r.from;
  return Object.assign(Object.assign({}, s.changeByRange((l) => {
    if (l != r && i != n && s.sliceDoc(l.from + a, l.from + o) != s.sliceDoc(i, n))
      return { range: l };
    let c = s.toText(t);
    return {
      changes: { from: l.from + a, to: n == r.from ? l.to : l.from + o, insert: c },
      range: J.cursor(l.from + a + c.length)
    };
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
u(k6, "e1$1");
m(k6, "insertCompletionText");
const SP = /* @__PURE__ */ new WeakMap();
function S6(s) {
  if (!Array.isArray(s))
    return s;
  let t = SP.get(s);
  return t || SP.set(s, t = Hx(s)), t;
}
u(S6, "t1$1");
m(S6, "asSource");
const Bg = /* @__PURE__ */ qe.define(), lm = /* @__PURE__ */ qe.define();
var Vh;
const P6 = (Vh = class {
  constructor(t) {
    this.pattern = t, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let i = 0; i < t.length; ) {
      let n = Bs(t, i), r = va(n);
      this.chars.push(n);
      let a = t.slice(i, i + r), o = a.toUpperCase();
      this.folded.push(Bs(o == a ? a.toLowerCase() : o, 0)), i += r;
    }
    this.astral = t.length != this.chars.length;
  }
  ret(t, i) {
    return this.score = t, this.matched = i, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(t) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (t.length < this.pattern.length)
      return null;
    let { chars: i, folded: n, any: r, precise: a, byWord: o } = this;
    if (i.length == 1) {
      let C = Bs(t, 0), E = va(C), A = E == t.length ? 0 : -100;
      if (C != i[0]) if (C == n[0])
        A += -200;
      else
        return null;
      return this.ret(A, [0, E]);
    }
    let l = t.indexOf(this.pattern);
    if (l == 0)
      return this.ret(t.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let c = i.length, h = 0;
    if (l < 0) {
      for (let C = 0, E = Math.min(t.length, 200); C < E && h < c; ) {
        let A = Bs(t, C);
        (A == i[h] || A == n[h]) && (r[h++] = C), C += va(A);
      }
      if (h < c)
        return null;
    }
    let d = 0, f = 0, y = !1, w = 0, g = -1, b = -1, k = /[a-z]/.test(t), $ = !0;
    for (let C = 0, E = Math.min(t.length, 200), A = 0; C < E && f < c; ) {
      let R = Bs(t, C);
      l < 0 && (d < c && R == i[d] && (a[d++] = C), w < c && (R == i[w] || R == n[w] ? (w == 0 && (g = C), b = C + 1, w++) : w = 0));
      let L, I = R < 255 ? R >= 48 && R <= 57 || R >= 97 && R <= 122 ? 2 : R >= 65 && R <= 90 ? 1 : 0 : (L = P3(R)) != L.toLowerCase() ? 1 : L != L.toUpperCase() ? 2 : 0;
      (!C || I == 1 && k || A == 0 && I != 0) && (i[f] == R || n[f] == R && (y = !0) ? o[f++] = C : o.length && ($ = !1)), A = I, C += va(R);
    }
    return f == c && o[0] == 0 && $ ? this.result(-100 + (y ? -200 : 0), o, t) : w == c && g == 0 ? this.ret(-200 - t.length + (b == t.length ? 0 : -100), [0, b]) : l > -1 ? this.ret(-700 - t.length, [l, l + this.pattern.length]) : w == c ? this.ret(-900 - t.length, [g, b]) : f == c ? this.result(-100 + (y ? -200 : 0) + -700 + ($ ? 0 : -1100), o, t) : i.length == 2 ? null : this.result((r[0] ? -700 : 0) + -200 + -1100, r, t);
  }
  result(t, i, n) {
    let r = [], a = 0;
    for (let o of i) {
      let l = o + (this.astral ? va(Bs(n, o)) : 1);
      a && r[a - 1] == o ? r[a - 1] = l : (r[a++] = o, r[a++] = l);
    }
    return this.ret(t - n.length, r);
  }
}, u(Vh, "Bf"), Vh);
m(P6, "FuzzyMatcher");
let BI = P6;
var Zh;
const C6 = (Zh = class {
  constructor(t) {
    this.pattern = t, this.matched = [], this.score = 0, this.folded = t.toLowerCase();
  }
  match(t) {
    if (t.length < this.pattern.length)
      return null;
    let i = t.slice(0, this.pattern.length), n = i == this.pattern ? 0 : i.toLowerCase() == this.folded ? -200 : null;
    return n == null ? null : (this.matched = [0, i.length], this.score = n + (t.length == this.pattern.length ? 0 : -100), this);
  }
}, u(Zh, "Nf"), Zh);
m(C6, "StrictMatcher");
let jI = C6;
const Rt = /* @__PURE__ */ me.define({
  combine(s) {
    return tx(s, {
      activateOnTyping: !0,
      activateOnCompletion: /* @__PURE__ */ m(() => !1, "activateOnCompletion"),
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: /* @__PURE__ */ m(() => "", "tooltipClass"),
      optionClass: /* @__PURE__ */ m(() => "", "optionClass"),
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: Q6,
      filterStrict: !1,
      compareCompletions: /* @__PURE__ */ m((t, i) => t.label.localeCompare(i.label), "compareCompletions"),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: /* @__PURE__ */ m((t, i) => t && i, "defaultKeymap"),
      closeOnBlur: /* @__PURE__ */ m((t, i) => t && i, "closeOnBlur"),
      icons: /* @__PURE__ */ m((t, i) => t && i, "icons"),
      tooltipClass: /* @__PURE__ */ m((t, i) => (n) => C2(t(n), i(n)), "tooltipClass"),
      optionClass: /* @__PURE__ */ m((t, i) => (n) => C2(t(n), i(n)), "optionClass"),
      addToOptions: /* @__PURE__ */ m((t, i) => t.concat(i), "addToOptions"),
      filterStrict: /* @__PURE__ */ m((t, i) => t || i, "filterStrict")
    });
  }
});
function C2(s, t) {
  return s ? t ? s + " " + t : s : t;
}
u(C2, "Mu$1");
m(C2, "joinClass");
function Q6(s, t, i, n, r, a) {
  let o = s.textDirection == gt.RTL, l = o, c = !1, h = "top", d, f, y = t.left - r.left, w = r.right - t.right, g = n.right - n.left, b = n.bottom - n.top;
  if (l && y < Math.min(g, w) ? l = !1 : !l && w < Math.min(g, y) && (l = !0), g <= (l ? y : w))
    d = Math.max(r.top, Math.min(i.top, r.bottom - b)) - t.top, f = Math.min(400, l ? y : w);
  else {
    c = !0, f = Math.min(
      400,
      (o ? t.right : r.right - t.left) - 30
      /* Info.Margin */
    );
    let C = r.bottom - t.bottom;
    C >= b || C > t.top ? d = i.bottom - t.top : (h = "bottom", d = t.bottom - i.top);
  }
  let k = (t.bottom - t.top) / a.offsetHeight, $ = (t.right - t.left) / a.offsetWidth;
  return {
    style: `${h}: ${d / k}px; max-width: ${f / $}px`,
    class: "cm-completionInfo-" + (c ? o ? "left-narrow" : "right-narrow" : l ? "left" : "right")
  };
}
u(Q6, "i1$1");
m(Q6, "defaultPositionInfo");
function T6(s) {
  let t = s.addToOptions.slice();
  return s.icons && t.push({
    render(i) {
      let n = document.createElement("div");
      return n.classList.add("cm-completionIcon"), i.type && n.classList.add(...i.type.split(/\s+/g).map((r) => "cm-completionIcon-" + r)), n.setAttribute("aria-hidden", "true"), n;
    },
    position: 20
  }), t.push({
    render(i, n, r, a) {
      let o = document.createElement("span");
      o.className = "cm-completionLabel";
      let l = i.displayLabel || i.label, c = 0;
      for (let h = 0; h < a.length; ) {
        let d = a[h++], f = a[h++];
        d > c && o.appendChild(document.createTextNode(l.slice(c, d)));
        let y = o.appendChild(document.createElement("span"));
        y.appendChild(document.createTextNode(l.slice(d, f))), y.className = "cm-completionMatchedText", c = f;
      }
      return c < l.length && o.appendChild(document.createTextNode(l.slice(c))), o;
    },
    position: 50
  }, {
    render(i) {
      if (!i.detail)
        return null;
      let n = document.createElement("span");
      return n.className = "cm-completionDetail", n.textContent = i.detail, n;
    },
    position: 80
  }), t.sort((i, n) => i.position - n.position).map((i) => i.render);
}
u(T6, "r1$1");
m(T6, "optionContent");
function jw(s, t, i) {
  if (s <= i)
    return { from: 0, to: s };
  if (t < 0 && (t = 0), t <= s >> 1) {
    let r = Math.floor(t / i);
    return { from: r * i, to: (r + 1) * i };
  }
  let n = Math.floor((s - t) / i);
  return { from: s - (n + 1) * i, to: s - n * i };
}
u(jw, "Lo$1");
m(jw, "rangeAroundSelected");
var Dh;
const M6 = (Dh = class {
  constructor(t, i, n) {
    this.view = t, this.stateField = i, this.applyCompletion = n, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: /* @__PURE__ */ m(() => this.measureInfo(), "read"),
      write: /* @__PURE__ */ m((c) => this.placeInfo(c), "write"),
      key: this
    }, this.space = null, this.currentClass = "";
    let r = t.state.field(i), { options: a, selected: o } = r.open, l = t.state.facet(Rt);
    this.optionContent = T6(l), this.optionClass = l.optionClass, this.tooltipClass = l.tooltipClass, this.range = jw(a.length, o, l.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(t.state), this.dom.addEventListener("mousedown", (c) => {
      let { options: h } = t.state.field(i).open;
      for (let d = c.target, f; d && d != this.dom; d = d.parentNode)
        if (d.nodeName == "LI" && (f = /-(\d+)$/.exec(d.id)) && +f[1] < h.length) {
          this.applyCompletion(t, h[+f[1]]), c.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (c) => {
      let h = t.state.field(this.stateField, !1);
      h && h.tooltip && t.state.facet(Rt).closeOnBlur && c.relatedTarget != t.contentDOM && t.dispatch({ effects: lm.of(null) });
    }), this.showOptions(a, r.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(t, i) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(t, i, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(t) {
    var i;
    let n = t.state.field(this.stateField), r = t.startState.field(this.stateField);
    if (this.updateTooltipClass(t.state), n != r) {
      let { options: a, selected: o, disabled: l } = n.open;
      (!r.open || r.open.options != a) && (this.range = jw(a.length, o, t.state.facet(Rt).maxRenderedOptions), this.showOptions(a, n.id)), this.updateSel(), l != ((i = r.open) === null || i === void 0 ? void 0 : i.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!l);
    }
  }
  updateTooltipClass(t) {
    let i = this.tooltipClass(t);
    if (i != this.currentClass) {
      for (let n of this.currentClass.split(" "))
        n && this.dom.classList.remove(n);
      for (let n of i.split(" "))
        n && this.dom.classList.add(n);
      this.currentClass = i;
    }
  }
  positioned(t) {
    this.space = t, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let t = this.view.state.field(this.stateField), i = t.open;
    if ((i.selected > -1 && i.selected < this.range.from || i.selected >= this.range.to) && (this.range = jw(i.options.length, i.selected, this.view.state.facet(Rt).maxRenderedOptions), this.showOptions(i.options, t.id)), this.updateSelectedOption(i.selected)) {
      this.destroyInfo();
      let { completion: n } = i.options[i.selected], { info: r } = n;
      if (!r)
        return;
      let a = typeof r == "string" ? document.createTextNode(r) : r(n);
      if (!a)
        return;
      "then" in a ? a.then((o) => {
        o && this.view.state.field(this.stateField, !1) == t && this.addInfoPane(o, n);
      }).catch((o) => gi(this.view.state, o, "completion info")) : this.addInfoPane(a, n);
    }
  }
  addInfoPane(t, i) {
    this.destroyInfo();
    let n = this.info = document.createElement("div");
    if (n.className = "cm-tooltip cm-completionInfo", t.nodeType != null)
      n.appendChild(t), this.infoDestroy = null;
    else {
      let { dom: r, destroy: a } = t;
      n.appendChild(r), this.infoDestroy = a || null;
    }
    this.dom.appendChild(n), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(t) {
    let i = null;
    for (let n = this.list.firstChild, r = this.range.from; n; n = n.nextSibling, r++)
      n.nodeName != "LI" || !n.id ? r-- : r == t ? n.hasAttribute("aria-selected") || (n.setAttribute("aria-selected", "true"), i = n) : n.hasAttribute("aria-selected") && n.removeAttribute("aria-selected");
    return i && A6(this.list, i), i;
  }
  measureInfo() {
    let t = this.dom.querySelector("[aria-selected]");
    if (!t || !this.info)
      return null;
    let i = this.dom.getBoundingClientRect(), n = this.info.getBoundingClientRect(), r = t.getBoundingClientRect(), a = this.space;
    if (!a) {
      let o = this.dom.ownerDocument.defaultView || window;
      a = { left: 0, top: 0, right: o.innerWidth, bottom: o.innerHeight };
    }
    return r.top > Math.min(a.bottom, i.bottom) - 10 || r.bottom < Math.max(a.top, i.top) + 10 ? null : this.view.state.facet(Rt).positionInfo(this.view, i, r, n, a, this.dom);
  }
  placeInfo(t) {
    this.info && (t ? (t.style && (this.info.style.cssText = t.style), this.info.className = "cm-tooltip cm-completionInfo " + (t.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(t, i, n) {
    const r = document.createElement("ul");
    r.id = i, r.setAttribute("role", "listbox"), r.setAttribute("aria-expanded", "true"), r.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let a = null;
    for (let o = n.from; o < n.to; o++) {
      let { completion: l, match: c } = t[o], { section: h } = l;
      if (h) {
        let y = typeof h == "string" ? h : h.name;
        if (y != a && (o > n.from || n.from == 0))
          if (a = y, typeof h != "string" && h.header)
            r.appendChild(h.header(h));
          else {
            let w = r.appendChild(document.createElement("completion-section"));
            w.textContent = y;
          }
      }
      const d = r.appendChild(document.createElement("li"));
      d.id = i + "-" + o, d.setAttribute("role", "option");
      let f = this.optionClass(l);
      f && (d.className = f);
      for (let y of this.optionContent) {
        let w = y(l, this.view.state, this.view, c);
        w && d.appendChild(w);
      }
    }
    return n.from && r.classList.add("cm-completionListIncompleteTop"), n.to < t.length && r.classList.add("cm-completionListIncompleteBottom"), r;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}, u(Dh, "Gf"), Dh);
m(M6, "CompletionTooltip");
let XI = M6;
function R6(s, t) {
  return (i) => new XI(i, s, t);
}
u(R6, "n1$1");
m(R6, "completionTooltip");
function A6(s, t) {
  let i = s.getBoundingClientRect(), n = t.getBoundingClientRect(), r = i.height / s.offsetHeight;
  n.top < i.top ? s.scrollTop -= (i.top - n.top) / r : n.bottom > i.bottom && (s.scrollTop += (n.bottom - i.bottom) / r);
}
u(A6, "s1$1");
m(A6, "scrollIntoView");
function Q2(s) {
  return (s.boost || 0) * 100 + (s.apply ? 10 : 0) + (s.info ? 5 : 0) + (s.type ? 1 : 0);
}
u(Q2, "Yu$1");
m(Q2, "score");
function E6(s, t) {
  let i = [], n = null, r = /* @__PURE__ */ m((h) => {
    i.push(h);
    let { section: d } = h.completion;
    if (d) {
      n || (n = []);
      let f = typeof d == "string" ? d : d.name;
      n.some((y) => y.name == f) || n.push(typeof d == "string" ? { name: f } : d);
    }
  }, "addOption"), a = t.facet(Rt);
  for (let h of s)
    if (h.hasResult()) {
      let d = h.result.getMatch;
      if (h.result.filter === !1)
        for (let f of h.result.options)
          r(new kP(f, h.source, d ? d(f) : [], 1e9 - i.length));
      else {
        let f = t.sliceDoc(h.from, h.to), y, w = a.filterStrict ? new jI(f) : new BI(f);
        for (let g of h.result.options)
          if (y = w.match(g.label)) {
            let b = g.displayLabel ? d ? d(g, y.matched) : [] : y.matched;
            r(new kP(g, h.source, b, y.score + (g.boost || 0)));
          }
      }
    }
  if (n) {
    let h = /* @__PURE__ */ Object.create(null), d = 0, f = /* @__PURE__ */ m((y, w) => {
      var g, b;
      return ((g = y.rank) !== null && g !== void 0 ? g : 1e9) - ((b = w.rank) !== null && b !== void 0 ? b : 1e9) || (y.name < w.name ? -1 : 1);
    }, "cmp");
    for (let y of n.sort(f))
      d -= 1e5, h[y.name] = d;
    for (let y of i) {
      let { section: w } = y.completion;
      w && (y.score += h[typeof w == "string" ? w : w.name]);
    }
  }
  let o = [], l = null, c = a.compareCompletions;
  for (let h of i.sort((d, f) => f.score - d.score || c(d.completion, f.completion))) {
    let d = h.completion;
    !l || l.label != d.label || l.detail != d.detail || l.type != null && d.type != null && l.type != d.type || l.apply != d.apply || l.boost != d.boost ? o.push(h) : Q2(h.completion) > Q2(l) && (o[o.length - 1] = h), l = h.completion;
  }
  return o;
}
u(E6, "o1$1");
m(E6, "sortOptions");
var Wn;
const z6 = (Wn = class {
  constructor(t, i, n, r, a, o) {
    this.options = t, this.attrs = i, this.tooltip = n, this.timestamp = r, this.selected = a, this.disabled = o;
  }
  setSelected(t, i) {
    return t == this.selected || t >= this.options.length ? this : new Wn(this.options, T2(i, t), this.tooltip, this.timestamp, t, this.disabled);
  }
  static build(t, i, n, r, a, o) {
    if (r && !o && t.some((h) => h.isPending))
      return r.setDisabled();
    let l = E6(t, i);
    if (!l.length)
      return r && t.some((h) => h.isPending) ? r.setDisabled() : null;
    let c = i.facet(Rt).selectOnOpen ? 0 : -1;
    if (r && r.selected != c && r.selected != -1) {
      let h = r.options[r.selected].completion;
      for (let d = 0; d < l.length; d++)
        if (l[d].completion == h) {
          c = d;
          break;
        }
    }
    return new Wn(l, T2(n, c), {
      pos: t.reduce((h, d) => d.hasResult() ? Math.min(h, d.from) : h, 1e8),
      create: JI,
      above: a.aboveCursor
    }, r ? r.timestamp : Date.now(), c, !1);
  }
  map(t) {
    return new Wn(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: t.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new Wn(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
  }
}, u(Wn, "Dt"), Wn);
m(z6, "CompletionDialog");
let FI = z6;
var gr;
const _6 = (gr = class {
  constructor(t, i, n) {
    this.active = t, this.id = i, this.open = n;
  }
  static start() {
    return new gr(KI, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(t) {
    let { state: i } = t, n = i.facet(Rt), r = (n.override || i.languageDataAt("autocomplete", tr(i)).map(S6)).map((l) => (this.active.find((c) => c.source == l) || new xa(
      l,
      this.active.some(
        (c) => c.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(t, n));
    r.length == this.active.length && r.every((l, c) => l == this.active[c]) && (r = this.active);
    let a = this.open, o = t.effects.some((l) => l.is(Jx));
    a && t.docChanged && (a = a.map(t.changes)), t.selection || r.some((l) => l.hasResult() && t.changes.touchesRange(l.from, l.to)) || !L6(r, this.active) || o ? a = FI.build(r, i, this.id, a, n, o) : a && a.disabled && !r.some((l) => l.isPending) && (a = null), !a && r.every((l) => !l.isPending) && r.some((l) => l.hasResult()) && (r = r.map((l) => l.hasResult() ? new xa(
      l.source,
      0
      /* State.Inactive */
    ) : l));
    for (let l of t.effects)
      l.is(D6) && (a = a && a.setSelected(l.value, this.id));
    return r == this.active && a == this.open ? this : new gr(r, this.id, a);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? YI : GI;
  }
}, u(gr, "Xr"), gr);
m(_6, "CompletionState");
let HI = _6;
function L6(s, t) {
  if (s == t)
    return !0;
  for (let i = 0, n = 0; ; ) {
    for (; i < s.length && !s[i].hasResult(); )
      i++;
    for (; n < t.length && !t[n].hasResult(); )
      n++;
    let r = i == s.length, a = n == t.length;
    if (r || a)
      return r == a;
    if (s[i++].result != t[n++].result)
      return !1;
  }
}
u(L6, "l1$1");
m(L6, "sameResults");
const YI = {
  "aria-autocomplete": "list"
}, GI = {};
function T2(s, t) {
  let i = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": s
  };
  return t > -1 && (i["aria-activedescendant"] = s + "-" + t), i;
}
u(T2, "Cu$1");
m(T2, "makeAttrs");
const KI = [];
function Kx(s, t) {
  if (s.isUserEvent("input.complete")) {
    let n = s.annotation(Gx);
    if (n && t.activateOnCompletion(n))
      return 12;
  }
  let i = s.isUserEvent("input.type");
  return i && t.activateOnTyping ? 5 : i ? 1 : s.isUserEvent("delete.backward") ? 2 : s.selection ? 8 : s.docChanged ? 16 : 0;
}
u(Kx, "dp$1");
m(Kx, "getUpdateType");
var Vn;
const I6 = (Vn = class {
  constructor(t, i, n = !1) {
    this.source = t, this.state = i, this.explicit = n;
  }
  hasResult() {
    return !1;
  }
  get isPending() {
    return this.state == 1;
  }
  update(t, i) {
    let n = Kx(t, i), r = this;
    (n & 8 || n & 16 && this.touches(t)) && (r = new Vn(
      r.source,
      0
      /* State.Inactive */
    )), n & 4 && r.state == 0 && (r = new Vn(
      this.source,
      1
      /* State.Pending */
    )), r = r.updateFor(t, n);
    for (let a of t.effects)
      if (a.is(Bg))
        r = new Vn(r.source, 1, a.value);
      else if (a.is(lm))
        r = new Vn(
          r.source,
          0
          /* State.Inactive */
        );
      else if (a.is(Jx))
        for (let o of a.value)
          o.source == r.source && (r = o);
    return r;
  }
  updateFor(t, i) {
    return this.map(t.changes);
  }
  map(t) {
    return this;
  }
  touches(t) {
    return t.changes.touchesRange(tr(t.state));
  }
}, u(Vn, "Bt"), Vn);
m(I6, "ActiveSource");
let xa = I6;
var ks;
const W6 = (ks = class extends xa {
  constructor(t, i, n, r, a, o) {
    super(t, 3, i), this.limit = n, this.result = r, this.from = a, this.to = o;
  }
  hasResult() {
    return !0;
  }
  updateFor(t, i) {
    var n;
    if (!(i & 3))
      return this.map(t.changes);
    let r = this.result;
    r.map && !t.changes.empty && (r = r.map(r, t.changes));
    let a = t.changes.mapPos(this.from), o = t.changes.mapPos(this.to, 1), l = tr(t.state);
    if (l > o || !r || i & 2 && (tr(t.startState) == this.from || l < this.limit))
      return new xa(
        this.source,
        i & 4 ? 1 : 0
        /* State.Inactive */
      );
    let c = t.changes.mapPos(this.limit);
    return Z6(r.validFor, t.state, a, o) ? new ks(this.source, this.explicit, c, r, a, o) : r.update && (r = r.update(r, a, o, new Fx(t.state, l, !1))) ? new ks(this.source, this.explicit, c, r, r.from, (n = r.to) !== null && n !== void 0 ? n : tr(t.state)) : new xa(this.source, 1, this.explicit);
  }
  map(t) {
    return t.empty ? this : (this.result.map ? this.result.map(this.result, t) : this.result) ? new ks(this.source, this.explicit, t.mapPos(this.limit), this.result, t.mapPos(this.from), t.mapPos(this.to, 1)) : new xa(
      this.source,
      0
      /* State.Inactive */
    );
  }
  touches(t) {
    return t.changes.touchesRange(this.from, this.to);
  }
}, u(ks, "xi"), ks);
m(W6, "ActiveResult");
let V6 = W6;
function Z6(s, t, i, n) {
  if (!s)
    return !1;
  let r = t.sliceDoc(i, n);
  return typeof s == "function" ? s(r, i, n, t) : Yx(s, !0).test(r);
}
u(Z6, "c1$1");
m(Z6, "checkValid");
const Jx = /* @__PURE__ */ qe.define({
  map(s, t) {
    return s.map((i) => i.map(t));
  }
}), D6 = /* @__PURE__ */ qe.define(), ci = /* @__PURE__ */ As.define({
  create() {
    return HI.start();
  },
  update(s, t) {
    return s.update(t);
  },
  provide: /* @__PURE__ */ m((s) => [
    K7.from(s, (t) => t.tooltip),
    $e.contentAttributes.from(s, (t) => t.attrs)
  ], "provide")
});
function X1(s, t) {
  const i = t.completion.apply || t.completion.label;
  let n = s.state.field(ci).active.find((r) => r.source == t.source);
  return n instanceof V6 ? (typeof i == "string" ? s.dispatch(Object.assign(Object.assign({}, k6(s.state, i, n.from, n.to)), { annotations: Gx.of(t.completion) })) : i(s, t.completion, n.from, n.to), !0) : !1;
}
u(X1, "uh$1");
m(X1, "applyCompletion");
const JI = /* @__PURE__ */ R6(ci, X1);
function Py(s, t = "option") {
  return (i) => {
    let n = i.state.field(ci, !1);
    if (!n || !n.open || n.open.disabled || Date.now() - n.open.timestamp < i.state.facet(Rt).interactionDelay)
      return !1;
    let r = 1, a;
    t == "page" && (a = Ex(i, n.open.tooltip)) && (r = Math.max(2, Math.floor(a.dom.offsetHeight / a.dom.querySelector("li").offsetHeight) - 1));
    let { length: o } = n.open.options, l = n.open.selected > -1 ? n.open.selected + r * (s ? 1 : -1) : s ? 0 : o - 1;
    return l < 0 ? l = t == "page" ? 0 : o - 1 : l >= o && (l = t == "page" ? o - 1 : 0), i.dispatch({ effects: D6.of(l) }), !0;
  };
}
u(Py, "Mn$1");
m(Py, "moveCompletionSelection");
const eW = /* @__PURE__ */ m((s) => {
  let t = s.state.field(ci, !1);
  return s.state.readOnly || !t || !t.open || t.open.selected < 0 || t.open.disabled || Date.now() - t.open.timestamp < s.state.facet(Rt).interactionDelay ? !1 : X1(s, t.open.options[t.open.selected]);
}, "acceptCompletion"), PP = /* @__PURE__ */ m((s) => s.state.field(ci, !1) ? (s.dispatch({ effects: Bg.of(!0) }), !0) : !1, "startCompletion"), tW = /* @__PURE__ */ m((s) => {
  let t = s.state.field(ci, !1);
  return !t || !t.active.some(
    (i) => i.state != 0
    /* State.Inactive */
  ) ? !1 : (s.dispatch({ effects: lm.of(null) }), !0);
}, "closeCompletion");
var qh;
const q6 = (qh = class {
  constructor(t, i) {
    this.active = t, this.context = i, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}, u(qh, "Ff"), qh);
m(q6, "RunningQuery");
let iW = q6;
const nW = 50, sW = 1e3, rW = /* @__PURE__ */ Ps.fromClass(class {
  constructor(s) {
    this.view = s, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let t of s.state.field(ci).active)
      t.isPending && this.startQuery(t);
  }
  update(s) {
    let t = s.state.field(ci), i = s.state.facet(Rt);
    if (!s.selectionSet && !s.docChanged && s.startState.field(ci) == t)
      return;
    let n = s.transactions.some((a) => {
      let o = Kx(a, i);
      return o & 8 || (a.selection || a.docChanged) && !(o & 3);
    });
    for (let a = 0; a < this.running.length; a++) {
      let o = this.running[a];
      if (n || o.context.abortOnDocChange && s.docChanged || o.updates.length + s.transactions.length > nW && Date.now() - o.time > sW) {
        for (let l of o.context.abortListeners)
          try {
            l();
          } catch (c) {
            gi(this.view.state, c);
          }
        o.context.abortListeners = null, this.running.splice(a--, 1);
      } else
        o.updates.push(...s.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), s.transactions.some((a) => a.effects.some((o) => o.is(Bg))) && (this.pendingStart = !0);
    let r = this.pendingStart ? 50 : i.activateOnTypingDelay;
    if (this.debounceUpdate = t.active.some((a) => a.isPending && !this.running.some((o) => o.active.source == a.source)) ? setTimeout(() => this.startUpdate(), r) : -1, this.composing != 0)
      for (let a of s.transactions)
        a.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && a.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: s } = this.view, t = s.field(ci);
    for (let i of t.active)
      i.isPending && !this.running.some((n) => n.active.source == i.source) && this.startQuery(i);
    this.running.length && t.open && t.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Rt).updateSyncTime));
  }
  startQuery(s) {
    let { state: t } = this.view, i = tr(t), n = new Fx(t, i, s.explicit, this.view), r = new iW(s, n);
    this.running.push(r), Promise.resolve(s.source(n)).then((a) => {
      r.context.aborted || (r.done = a || null, this.scheduleAccept());
    }, (a) => {
      this.view.dispatch({ effects: lm.of(null) }), gi(this.view.state, a);
    });
  }
  scheduleAccept() {
    this.running.every((s) => s.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Rt).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var s;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let t = [], i = this.view.state.facet(Rt), n = this.view.state.field(ci);
    for (let r = 0; r < this.running.length; r++) {
      let a = this.running[r];
      if (a.done === void 0)
        continue;
      if (this.running.splice(r--, 1), a.done) {
        let l = tr(a.updates.length ? a.updates[0].startState : this.view.state), c = Math.min(l, a.done.from + (a.active.explicit ? 0 : 1)), h = new V6(a.active.source, a.active.explicit, c, a.done, a.done.from, (s = a.done.to) !== null && s !== void 0 ? s : l);
        for (let d of a.updates)
          h = h.update(d, i);
        if (h.hasResult()) {
          t.push(h);
          continue;
        }
      }
      let o = n.active.find((l) => l.source == a.active.source);
      if (o && o.isPending)
        if (a.done == null) {
          let l = new xa(
            a.active.source,
            0
            /* State.Inactive */
          );
          for (let c of a.updates)
            l = l.update(c, i);
          l.isPending || t.push(l);
        } else
          this.startQuery(o);
    }
    (t.length || n.open && n.open.disabled) && this.view.dispatch({ effects: Jx.of(t) });
  }
}, {
  eventHandlers: {
    blur(s) {
      let t = this.view.state.field(ci, !1);
      if (t && t.tooltip && this.view.state.facet(Rt).closeOnBlur) {
        let i = t.open && Ex(this.view, t.open.tooltip);
        (!i || !i.dom.contains(s.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: lm.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: Bg.of(!1) }), 20), this.composing = 0;
    }
  }
}), aW = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), oW = /* @__PURE__ */ Lo.highest(/* @__PURE__ */ $e.domEventHandlers({
  keydown(s, t) {
    let i = t.state.field(ci, !1);
    if (!i || !i.open || i.open.disabled || i.open.selected < 0 || s.key.length > 1 || s.ctrlKey && !(aW && s.altKey) || s.metaKey)
      return !1;
    let n = i.open.options[i.open.selected], r = i.active.find((o) => o.source == n.source), a = n.completion.commitCharacters || r.result.commitCharacters;
    return a && a.indexOf(s.key) > -1 && X1(t, n), !1;
  }
})), U6 = /* @__PURE__ */ $e.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
var Uh;
const N6 = (Uh = class {
  constructor(t, i, n, r) {
    this.field = t, this.line = i, this.from = n, this.to = r;
  }
}, u(Uh, "Hf"), Uh);
m(N6, "FieldPos");
let lW = N6;
var ro;
const B6 = (ro = class {
  constructor(t, i, n) {
    this.field = t, this.from = i, this.to = n;
  }
  map(t) {
    let i = t.mapPos(this.from, -1, hi.TrackDel), n = t.mapPos(this.to, 1, hi.TrackDel);
    return i == null || n == null ? null : new ro(this.field, i, n);
  }
}, u(ro, "ao"), ro);
m(B6, "FieldRange");
let cW = B6;
var ao;
const j6 = (ao = class {
  constructor(t, i) {
    this.lines = t, this.fieldPositions = i;
  }
  instantiate(t, i) {
    let n = [], r = [i], a = t.doc.lineAt(i), o = /^\s*/.exec(a.text)[0];
    for (let c of this.lines) {
      if (n.length) {
        let h = o, d = /^\t*/.exec(c)[0].length;
        for (let f = 0; f < d; f++)
          h += t.facet(B1);
        r.push(i + h.length - d), c = h + c.slice(d);
      }
      n.push(c), i += c.length + 1;
    }
    let l = this.fieldPositions.map((c) => new cW(c.field, r[c.line] + c.from, r[c.line] + c.to));
    return { text: n, ranges: l };
  }
  static parse(t) {
    let i = [], n = [], r = [], a;
    for (let o of t.split(/\r\n?|\n/)) {
      for (; a = /[#$]\{(?:(\d+)(?::([^}]*))?|((?:\\[{}]|[^}])*))\}/.exec(o); ) {
        let l = a[1] ? +a[1] : null, c = a[2] || a[3] || "", h = -1, d = c.replace(/\\[{}]/g, (f) => f[1]);
        for (let f = 0; f < i.length; f++)
          (l != null ? i[f].seq == l : d && i[f].name == d) && (h = f);
        if (h < 0) {
          let f = 0;
          for (; f < i.length && (l == null || i[f].seq != null && i[f].seq < l); )
            f++;
          i.splice(f, 0, { seq: l, name: d }), h = f;
          for (let y of r)
            y.field >= h && y.field++;
        }
        r.push(new lW(h, n.length, a.index, a.index + d.length)), o = o.slice(0, a.index) + c + o.slice(a.index + a[0].length);
      }
      o = o.replace(/\\([{}])/g, (l, c, h) => {
        for (let d of r)
          d.line == n.length && d.from > h && (d.from--, d.to--);
        return c;
      }), n.push(o);
    }
    return new ao(n, r);
  }
}, u(ao, "ho"), ao);
m(j6, "Snippet");
let hW = j6, dW = /* @__PURE__ */ Xe.widget({ widget: /* @__PURE__ */ new class extends Ef {
  toDOM() {
    let s = document.createElement("span");
    return s.className = "cm-snippetFieldPosition", s;
  }
  ignoreEvent() {
    return !1;
  }
}() }), uW = /* @__PURE__ */ Xe.mark({ class: "cm-snippetField" });
var oo;
const X6 = (oo = class {
  constructor(t, i) {
    this.ranges = t, this.active = i, this.deco = Xe.set(t.map((n) => (n.from == n.to ? dW : uW).range(n.from, n.to)));
  }
  map(t) {
    let i = [];
    for (let n of this.ranges) {
      let r = n.map(t);
      if (!r)
        return null;
      i.push(r);
    }
    return new oo(i, this.active);
  }
  selectionInsideField(t) {
    return t.ranges.every((i) => this.ranges.some((n) => n.field == this.active && n.from <= i.from && n.to >= i.to));
  }
}, u(oo, "fo"), oo);
m(X6, "ActiveSnippet");
let F1 = X6;
const Xm = /* @__PURE__ */ qe.define({
  map(s, t) {
    return s && s.map(t);
  }
}), pW = /* @__PURE__ */ qe.define(), cm = /* @__PURE__ */ As.define({
  create() {
    return null;
  },
  update(s, t) {
    for (let i of t.effects) {
      if (i.is(Xm))
        return i.value;
      if (i.is(pW) && s)
        return new F1(s.ranges, i.value);
    }
    return s && t.docChanged && (s = s.map(t.changes)), s && t.selection && !s.selectionInsideField(t.selection) && (s = null), s;
  },
  provide: /* @__PURE__ */ m((s) => $e.decorations.from(s, (t) => t ? t.deco : Xe.none), "provide")
});
function H1(s, t) {
  return J.create(s.filter((i) => i.field == t).map((i) => J.range(i.from, i.to)));
}
u(H1, "dh$1");
m(H1, "fieldSelection");
function F6(s) {
  let t = hW.parse(s);
  return (i, n, r, a) => {
    let { text: o, ranges: l } = t.instantiate(i.state, r), { main: c } = i.state.selection, h = {
      changes: { from: r, to: a == c.from ? c.to : a, insert: Ie.of(o) },
      scrollIntoView: !0,
      annotations: n ? [Gx.of(n), di.userEvent.of("input.complete")] : void 0
    };
    if (l.length && (h.selection = H1(l, 0)), l.some((d) => d.field > 0)) {
      let d = new F1(l, 0), f = h.effects = [Xm.of(d)];
      i.state.field(cm, !1) === void 0 && f.push(qe.appendConfig.of([cm, gW, vW, U6]));
    }
    i.dispatch(i.state.update(h));
  };
}
u(F6, "w1$1");
m(F6, "snippet");
function ek(s) {
  return ({ state: t, dispatch: i }) => {
    let n = t.field(cm, !1);
    if (!n || s < 0 && n.active == 0)
      return !1;
    let r = n.active + s, a = s > 0 && !n.ranges.some((o) => o.field == r + s);
    return i(t.update({
      selection: H1(n.ranges, r),
      effects: Xm.of(a ? null : new F1(n.ranges, r)),
      scrollIntoView: !0
    })), !0;
  };
}
u(ek, "gp$1");
m(ek, "moveField");
const fW = /* @__PURE__ */ m(({ state: s, dispatch: t }) => s.field(cm, !1) ? (t(s.update({ effects: Xm.of(null) })), !0) : !1, "clearSnippet"), yW = /* @__PURE__ */ ek(1), mW = /* @__PURE__ */ ek(-1), wW = [
  { key: "Tab", run: yW, shift: mW },
  { key: "Escape", run: fW }
], CP = /* @__PURE__ */ me.define({
  combine(s) {
    return s.length ? s[0] : wW;
  }
}), gW = /* @__PURE__ */ Lo.highest(/* @__PURE__ */ Z1.compute([CP], (s) => s.facet(CP)));
function ai(s, t) {
  return Object.assign(Object.assign({}, t), { apply: F6(s) });
}
u(ai, "me$2");
m(ai, "snippetCompletion");
const vW = /* @__PURE__ */ $e.domEventHandlers({
  mousedown(s, t) {
    let i = t.state.field(cm, !1), n;
    if (!i || (n = t.posAtCoords({ x: s.clientX, y: s.clientY })) == null)
      return !1;
    let r = i.ranges.find((a) => a.from <= n && a.to >= n);
    return !r || r.field == i.active ? !1 : (t.dispatch({
      selection: H1(i.ranges, r.field),
      effects: Xm.of(i.ranges.some((a) => a.field > r.field) ? new F1(i.ranges, r.field) : null),
      scrollIntoView: !0
    }), !0);
  }
}), H6 = /* @__PURE__ */ new class extends wo {
}();
H6.startSide = 1;
H6.endSide = -1;
function OW(s = {}) {
  return [
    oW,
    ci,
    Rt.of(s),
    rW,
    $W,
    U6
  ];
}
u(OW, "T1$1");
m(OW, "autocompletion");
const bW = [
  { key: "Ctrl-Space", run: PP },
  { mac: "Alt-`", run: PP },
  { key: "Escape", run: tW },
  { key: "ArrowDown", run: /* @__PURE__ */ Py(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ Py(!1) },
  { key: "PageDown", run: /* @__PURE__ */ Py(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ Py(!1, "page") },
  { key: "Enter", run: eW }
], $W = /* @__PURE__ */ Lo.highest(/* @__PURE__ */ Z1.computeN([Rt], (s) => s.facet(Rt).defaultKeymap ? [bW] : []));
function xW(s) {
  let t = s.field(ci, !1);
  return t && t.active.some((i) => i.isPending) ? "pending" : t && t.active.some(
    (i) => i.state != 0
    /* State.Inactive */
  ) ? "active" : null;
}
u(xW, "W1$1");
m(xW, "completionStatus");
var lo;
const Y6 = (lo = class {
  static create(t, i, n, r, a) {
    let o = r + (r << 8) + t + (i << 4) | 0;
    return new lo(t, i, n, o, a, [], []);
  }
  constructor(t, i, n, r, a, o, l) {
    this.type = t, this.value = i, this.from = n, this.hash = r, this.end = a, this.children = o, this.positions = l, this.hashProp = [[Oe.contextHash, r]];
  }
  addChild(t, i) {
    t.prop(Oe.contextHash) != this.hash && (t = new ze(t.type, t.children, t.positions, t.length, this.hashProp)), this.children.push(t), this.positions.push(i);
  }
  toTree(t, i = this.end) {
    let n = this.children.length - 1;
    return n >= 0 && (i = Math.max(i, this.positions[n] + this.children[n].length + this.from)), new ze(t.types[this.type], this.children, this.positions, i - this.from).balance({
      makeTree: /* @__PURE__ */ m((r, a, o) => new ze(Et.none, r, a, o, this.hashProp), "makeTree")
    });
  }
}, u(lo, "co"), lo);
m(Y6, "CompositeBlock");
let QP = Y6;
var X;
(function(s) {
  s[s.Document = 1] = "Document", s[s.CodeBlock = 2] = "CodeBlock", s[s.FencedCode = 3] = "FencedCode", s[s.Blockquote = 4] = "Blockquote", s[s.HorizontalRule = 5] = "HorizontalRule", s[s.BulletList = 6] = "BulletList", s[s.OrderedList = 7] = "OrderedList", s[s.ListItem = 8] = "ListItem", s[s.ATXHeading1 = 9] = "ATXHeading1", s[s.ATXHeading2 = 10] = "ATXHeading2", s[s.ATXHeading3 = 11] = "ATXHeading3", s[s.ATXHeading4 = 12] = "ATXHeading4", s[s.ATXHeading5 = 13] = "ATXHeading5", s[s.ATXHeading6 = 14] = "ATXHeading6", s[s.SetextHeading1 = 15] = "SetextHeading1", s[s.SetextHeading2 = 16] = "SetextHeading2", s[s.HTMLBlock = 17] = "HTMLBlock", s[s.LinkReference = 18] = "LinkReference", s[s.Paragraph = 19] = "Paragraph", s[s.CommentBlock = 20] = "CommentBlock", s[s.ProcessingInstructionBlock = 21] = "ProcessingInstructionBlock", s[s.Escape = 22] = "Escape", s[s.Entity = 23] = "Entity", s[s.HardBreak = 24] = "HardBreak", s[s.Emphasis = 25] = "Emphasis", s[s.StrongEmphasis = 26] = "StrongEmphasis", s[s.Link = 27] = "Link", s[s.Image = 28] = "Image", s[s.InlineCode = 29] = "InlineCode", s[s.HTMLTag = 30] = "HTMLTag", s[s.Comment = 31] = "Comment", s[s.ProcessingInstruction = 32] = "ProcessingInstruction", s[s.Autolink = 33] = "Autolink", s[s.HeaderMark = 34] = "HeaderMark", s[s.QuoteMark = 35] = "QuoteMark", s[s.ListMark = 36] = "ListMark", s[s.LinkMark = 37] = "LinkMark", s[s.EmphasisMark = 38] = "EmphasisMark", s[s.CodeMark = 39] = "CodeMark", s[s.CodeText = 40] = "CodeText", s[s.CodeInfo = 41] = "CodeInfo", s[s.LinkTitle = 42] = "LinkTitle", s[s.LinkLabel = 43] = "LinkLabel", s[s.URL = 44] = "URL";
})(X || (X = {}));
var Nh;
const G6 = (Nh = class {
  /// @internal
  constructor(t, i) {
    this.start = t, this.content = i, this.marks = [], this.parsers = [];
  }
}, u(Nh, "Kf"), Nh);
m(G6, "LeafBlock");
let kW = G6;
var Bh;
const K6 = (Bh = class {
  constructor() {
    this.text = "", this.baseIndent = 0, this.basePos = 0, this.depth = 0, this.markers = [], this.pos = 0, this.indent = 0, this.next = -1;
  }
  /// @internal
  forward() {
    this.basePos > this.pos && this.forwardInner();
  }
  /// @internal
  forwardInner() {
    let t = this.skipSpace(this.basePos);
    this.indent = this.countIndent(t, this.pos, this.indent), this.pos = t, this.next = t == this.text.length ? -1 : this.text.charCodeAt(t);
  }
  /// Skip whitespace after the given position, return the position of
  /// the next non-space character or the end of the line if there's
  /// only space after `from`.
  skipSpace(t) {
    return uc(this.text, t);
  }
  /// @internal
  reset(t) {
    for (this.text = t, this.baseIndent = this.basePos = this.pos = this.indent = 0, this.forwardInner(), this.depth = 1; this.markers.length; )
      this.markers.pop();
  }
  /// Move the line's base position forward to the given position.
  /// This should only be called by composite [block
  /// parsers](#BlockParser.parse) or [markup skipping
  /// functions](#NodeSpec.composite).
  moveBase(t) {
    this.basePos = t, this.baseIndent = this.countIndent(t, this.pos, this.indent);
  }
  /// Move the line's base position forward to the given _column_.
  moveBaseColumn(t) {
    this.baseIndent = t, this.basePos = this.findColumn(t);
  }
  /// Store a composite-block-level marker. Should be called from
  /// [markup skipping functions](#NodeSpec.composite) when they
  /// consume any non-whitespace characters.
  addMarker(t) {
    this.markers.push(t);
  }
  /// Find the column position at `to`, optionally starting at a given
  /// position and column.
  countIndent(t, i = 0, n = 0) {
    for (let r = i; r < t; r++)
      n += this.text.charCodeAt(r) == 9 ? 4 - n % 4 : 1;
    return n;
  }
  /// Find the position corresponding to the given column.
  findColumn(t) {
    let i = 0;
    for (let n = 0; i < this.text.length && n < t; i++)
      n += this.text.charCodeAt(i) == 9 ? 4 - n % 4 : 1;
    return i;
  }
  /// @internal
  scrub() {
    if (!this.baseIndent)
      return this.text;
    let t = "";
    for (let i = 0; i < this.basePos; i++)
      t += " ";
    return t + this.text.slice(this.basePos);
  }
}, u(Bh, "Jf"), Bh);
m(K6, "Line");
let SW = K6;
function M2(s, t, i) {
  if (i.pos == i.text.length || s != t.block && i.indent >= t.stack[i.depth + 1].value + i.baseIndent)
    return !0;
  if (i.indent >= i.baseIndent + 4)
    return !1;
  let n = (s.type == X.OrderedList ? K1 : G1)(i, t, !1);
  return n > 0 && (s.type != X.BulletList || Y1(i, t, !1) < 0) && i.text.charCodeAt(i.pos + n - 1) == s.value;
}
u(M2, "Xu$1");
m(M2, "skipForList");
const J6 = {
  [X.Blockquote](s, t, i) {
    return i.next != 62 ? !1 : (i.markers.push(Re(X.QuoteMark, t.lineStart + i.pos, t.lineStart + i.pos + 1)), i.moveBase(i.pos + (Ii(i.text.charCodeAt(i.pos + 1)) ? 2 : 1)), s.end = t.lineStart + i.text.length, !0);
  },
  [X.ListItem](s, t, i) {
    return i.indent < i.baseIndent + s.value && i.next > -1 ? !1 : (i.moveBaseColumn(i.baseIndent + s.value), !0);
  },
  [X.OrderedList]: M2,
  [X.BulletList]: M2,
  [X.Document]() {
    return !0;
  }
};
function Ii(s) {
  return s == 32 || s == 9 || s == 10 || s == 13;
}
u(Ii, "Me$2");
m(Ii, "space$2");
function uc(s, t = 0) {
  for (; t < s.length && Ii(s.charCodeAt(t)); )
    t++;
  return t;
}
u(uc, "wr$1");
m(uc, "skipSpace");
function R2(s, t, i) {
  for (; t > i && Ii(s.charCodeAt(t - 1)); )
    t--;
  return t;
}
u(R2, "Iu$1");
m(R2, "skipSpaceBack");
function tk(s) {
  if (s.next != 96 && s.next != 126)
    return -1;
  let t = s.pos + 1;
  for (; t < s.text.length && s.text.charCodeAt(t) == s.next; )
    t++;
  if (t < s.pos + 3)
    return -1;
  if (s.next == 96) {
    for (let i = t; i < s.text.length; i++)
      if (s.text.charCodeAt(i) == 96)
        return -1;
  }
  return t;
}
u(tk, "Sp$1");
m(tk, "isFencedCode");
function ik(s) {
  return s.next != 62 ? -1 : s.text.charCodeAt(s.pos + 1) == 32 ? 2 : 1;
}
u(ik, "Pp$1");
m(ik, "isBlockquote");
function Y1(s, t, i) {
  if (s.next != 42 && s.next != 45 && s.next != 95)
    return -1;
  let n = 1;
  for (let r = s.pos + 1; r < s.text.length; r++) {
    let a = s.text.charCodeAt(r);
    if (a == s.next)
      n++;
    else if (!Ii(a))
      return -1;
  }
  return i && s.next == 45 && rk(s) > -1 && s.depth == t.stack.length || n < 3 ? -1 : 1;
}
u(Y1, "Oh$1");
m(Y1, "isHorizontalRule");
function nk(s, t) {
  for (let i = s.stack.length - 1; i >= 0; i--)
    if (s.stack[i].type == t)
      return !0;
  return !1;
}
u(nk, "wp$1");
m(nk, "inList");
function G1(s, t, i) {
  return (s.next == 45 || s.next == 43 || s.next == 42) && (s.pos == s.text.length - 1 || Ii(s.text.charCodeAt(s.pos + 1))) && (!i || nk(t, X.BulletList) || s.skipSpace(s.pos + 2) < s.text.length) ? 1 : -1;
}
u(G1, "ph$1");
m(G1, "isBulletList");
function K1(s, t, i) {
  let n = s.pos, r = s.next;
  for (; r >= 48 && r <= 57; ) {
    if (n++, n == s.text.length)
      return -1;
    r = s.text.charCodeAt(n);
  }
  return n == s.pos || n > s.pos + 9 || r != 46 && r != 41 || n < s.text.length - 1 && !Ii(s.text.charCodeAt(n + 1)) || i && !nk(t, X.OrderedList) && (s.skipSpace(n + 1) == s.text.length || n > s.pos + 1 || s.next != 49) ? -1 : n + 1 - s.pos;
}
u(K1, "mh$1");
m(K1, "isOrderedList");
function sk(s) {
  if (s.next != 35)
    return -1;
  let t = s.pos + 1;
  for (; t < s.text.length && s.text.charCodeAt(t) == 35; )
    t++;
  if (t < s.text.length && s.text.charCodeAt(t) != 32)
    return -1;
  let i = t - s.pos;
  return i > 6 ? -1 : i;
}
u(sk, "xp$1");
m(sk, "isAtxHeading");
function rk(s) {
  if (s.next != 45 && s.next != 61 || s.indent >= s.baseIndent + 4)
    return -1;
  let t = s.pos + 1;
  for (; t < s.text.length && s.text.charCodeAt(t) == s.next; )
    t++;
  let i = t;
  for (; t < s.text.length && Ii(s.text.charCodeAt(t)); )
    t++;
  return t == s.text.length ? i : -1;
}
u(rk, "Qp$1");
m(rk, "isSetextUnderline");
const A2 = /^[ \t]*$/, eQ = /-->/, tQ = /\?>/, E2 = [
  [/^<(?:script|pre|style)(?:\s|>|$)/i, /<\/(?:script|pre|style)>/i],
  [/^\s*<!--/, eQ],
  [/^\s*<\?/, tQ],
  [/^\s*<![A-Z]/, />/],
  [/^\s*<!\[CDATA\[/, /\]\]>/],
  [/^\s*<\/?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|\/?>|$)/i, A2],
  [/^\s*(?:<\/[a-z][\w-]*\s*>|<[a-z][\w-]*(\s+[a-z:_][\w-.]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*>)\s*$/i, A2]
];
function ak(s, t, i) {
  if (s.next != 60)
    return -1;
  let n = s.text.slice(s.pos);
  for (let r = 0, a = E2.length - (i ? 1 : 0); r < a; r++)
    if (E2[r][0].test(n))
      return r;
  return -1;
}
u(ak, "$p$1");
m(ak, "isHTMLBlock");
function z2(s, t) {
  let i = s.countIndent(t, s.pos, s.indent), n = s.countIndent(s.skipSpace(t), t, i);
  return n >= i + 5 ? i + 1 : n;
}
u(z2, "ju$1");
m(z2, "getListIndent");
function qs(s, t, i) {
  let n = s.length - 1;
  n >= 0 && s[n].to == t && s[n].type == X.CodeText ? s[n].to = i : s.push(Re(X.CodeText, t, i));
}
u(qs, "Ct$1");
m(qs, "addCodeText");
const Qw = {
  LinkReference: void 0,
  IndentedCode(s, t) {
    let i = t.baseIndent + 4;
    if (t.indent < i)
      return !1;
    let n = t.findColumn(i), r = s.lineStart + n, a = s.lineStart + t.text.length, o = [], l = [];
    for (qs(o, r, a); s.nextLine() && t.depth >= s.stack.length; )
      if (t.pos == t.text.length) {
        qs(l, s.lineStart - 1, s.lineStart);
        for (let c of t.markers)
          l.push(c);
      } else {
        if (t.indent < i)
          break;
        {
          if (l.length) {
            for (let h of l)
              h.type == X.CodeText ? qs(o, h.from, h.to) : o.push(h);
            l = [];
          }
          qs(o, s.lineStart - 1, s.lineStart);
          for (let h of t.markers)
            o.push(h);
          a = s.lineStart + t.text.length;
          let c = s.lineStart + t.findColumn(t.baseIndent + 4);
          c < a && qs(o, c, a);
        }
      }
    return l.length && (l = l.filter((c) => c.type != X.CodeText), l.length && (t.markers = l.concat(t.markers))), s.addNode(s.buffer.writeElements(o, -r).finish(X.CodeBlock, a - r), r), !0;
  },
  FencedCode(s, t) {
    let i = tk(t);
    if (i < 0)
      return !1;
    let n = s.lineStart + t.pos, r = t.next, a = i - t.pos, o = t.skipSpace(i), l = R2(t.text, t.text.length, o), c = [Re(X.CodeMark, n, n + a)];
    o < l && c.push(Re(X.CodeInfo, s.lineStart + o, s.lineStart + l));
    for (let h = !0; s.nextLine() && t.depth >= s.stack.length; h = !1) {
      let d = t.pos;
      if (t.indent - t.baseIndent < 4)
        for (; d < t.text.length && t.text.charCodeAt(d) == r; )
          d++;
      if (d - t.pos >= a && t.skipSpace(d) == t.text.length) {
        for (let f of t.markers)
          c.push(f);
        c.push(Re(X.CodeMark, s.lineStart + t.pos, s.lineStart + d)), s.nextLine();
        break;
      } else {
        h || qs(c, s.lineStart - 1, s.lineStart);
        for (let w of t.markers)
          c.push(w);
        let f = s.lineStart + t.basePos, y = s.lineStart + t.text.length;
        f < y && qs(c, f, y);
      }
    }
    return s.addNode(s.buffer.writeElements(c, -n).finish(X.FencedCode, s.prevLineEnd() - n), n), !0;
  },
  Blockquote(s, t) {
    let i = ik(t);
    return i < 0 ? !1 : (s.startContext(X.Blockquote, t.pos), s.addNode(X.QuoteMark, s.lineStart + t.pos, s.lineStart + t.pos + 1), t.moveBase(t.pos + i), null);
  },
  HorizontalRule(s, t) {
    if (Y1(t, s, !1) < 0)
      return !1;
    let i = s.lineStart + t.pos;
    return s.nextLine(), s.addNode(X.HorizontalRule, i), !0;
  },
  BulletList(s, t) {
    let i = G1(t, s, !1);
    if (i < 0)
      return !1;
    s.block.type != X.BulletList && s.startContext(X.BulletList, t.basePos, t.next);
    let n = z2(t, t.pos + 1);
    return s.startContext(X.ListItem, t.basePos, n - t.baseIndent), s.addNode(X.ListMark, s.lineStart + t.pos, s.lineStart + t.pos + i), t.moveBaseColumn(n), null;
  },
  OrderedList(s, t) {
    let i = K1(t, s, !1);
    if (i < 0)
      return !1;
    s.block.type != X.OrderedList && s.startContext(X.OrderedList, t.basePos, t.text.charCodeAt(t.pos + i - 1));
    let n = z2(t, t.pos + i);
    return s.startContext(X.ListItem, t.basePos, n - t.baseIndent), s.addNode(X.ListMark, s.lineStart + t.pos, s.lineStart + t.pos + i), t.moveBaseColumn(n), null;
  },
  ATXHeading(s, t) {
    let i = sk(t);
    if (i < 0)
      return !1;
    let n = t.pos, r = s.lineStart + n, a = R2(t.text, t.text.length, n), o = a;
    for (; o > n && t.text.charCodeAt(o - 1) == t.next; )
      o--;
    (o == a || o == n || !Ii(t.text.charCodeAt(o - 1))) && (o = t.text.length);
    let l = s.buffer.write(X.HeaderMark, 0, i).writeElements(s.parser.parseInline(t.text.slice(n + i + 1, o), r + i + 1), -r);
    o < t.text.length && l.write(X.HeaderMark, o - n, a - n);
    let c = l.finish(X.ATXHeading1 - 1 + i, t.text.length - n);
    return s.nextLine(), s.addNode(c, r), !0;
  },
  HTMLBlock(s, t) {
    let i = ak(t, s, !1);
    if (i < 0)
      return !1;
    let n = s.lineStart + t.pos, r = E2[i][1], a = [], o = r != A2;
    for (; !r.test(t.text) && s.nextLine(); ) {
      if (t.depth < s.stack.length) {
        o = !1;
        break;
      }
      for (let h of t.markers)
        a.push(h);
    }
    o && s.nextLine();
    let l = r == eQ ? X.CommentBlock : r == tQ ? X.ProcessingInstructionBlock : X.HTMLBlock, c = s.prevLineEnd();
    return s.addNode(s.buffer.writeElements(a, -n).finish(l, c - n), n), !0;
  },
  SetextHeading: void 0
  // Specifies relative precedence for block-continue function
};
var jh;
const iQ = (jh = class {
  constructor(t) {
    this.stage = 0, this.elts = [], this.pos = 0, this.start = t.start, this.advance(t.content);
  }
  nextLine(t, i, n) {
    if (this.stage == -1)
      return !1;
    let r = n.content + `
` + i.scrub(), a = this.advance(r);
    return a > -1 && a < r.length ? this.complete(t, n, a) : !1;
  }
  finish(t, i) {
    return (this.stage == 2 || this.stage == 3) && uc(i.content, this.pos) == i.content.length ? this.complete(t, i, i.content.length) : !1;
  }
  complete(t, i, n) {
    return t.addLeafElement(i, Re(X.LinkReference, this.start, this.start + n, this.elts)), !0;
  }
  nextStage(t) {
    return t ? (this.pos = t.to - this.start, this.elts.push(t), this.stage++, !0) : (t === !1 && (this.stage = -1), !1);
  }
  advance(t) {
    for (; ; ) {
      if (this.stage == -1)
        return -1;
      if (this.stage == 0) {
        if (!this.nextStage(hk(t, this.pos, this.start, !0)))
          return -1;
        if (t.charCodeAt(this.pos) != 58)
          return this.stage = -1;
        this.elts.push(Re(X.LinkMark, this.pos + this.start, this.pos + this.start + 1)), this.pos++;
      } else if (this.stage == 1) {
        if (!this.nextStage(lk(t, uc(t, this.pos), this.start)))
          return -1;
      } else if (this.stage == 2) {
        let i = uc(t, this.pos), n = 0;
        if (i > this.pos) {
          let r = ck(t, i, this.start);
          if (r) {
            let a = Xw(t, r.to - this.start);
            a > 0 && (this.nextStage(r), n = a);
          }
        }
        return n || (n = Xw(t, this.pos)), n > 0 && n < t.length ? n : -1;
      } else
        return Xw(t, this.pos);
    }
  }
}, u(jh, "ec"), jh);
m(iQ, "LinkReferenceParser");
let PW = iQ;
function Xw(s, t) {
  for (; t < s.length; t++) {
    let i = s.charCodeAt(t);
    if (i == 10)
      break;
    if (!Ii(i))
      return -1;
  }
  return t;
}
u(Xw, "_o$1");
m(Xw, "lineEnd");
var Xh;
const nQ = (Xh = class {
  nextLine(t, i, n) {
    let r = i.depth < t.stack.length ? -1 : rk(i), a = i.next;
    if (r < 0)
      return !1;
    let o = Re(X.HeaderMark, t.lineStart + i.pos, t.lineStart + r);
    return t.nextLine(), t.addLeafElement(n, Re(a == 61 ? X.SetextHeading1 : X.SetextHeading2, n.start, t.prevLineEnd(), [
      ...t.parser.parseInline(n.content, n.start),
      o
    ])), !0;
  }
  finish() {
    return !1;
  }
}, u(Xh, "tc"), Xh);
m(nQ, "SetextHeadingParser");
let CW = nQ;
const QW = {
  LinkReference(s, t) {
    return t.content.charCodeAt(0) == 91 ? new PW(t) : null;
  },
  SetextHeading() {
    return new CW();
  }
}, TW = [
  (s, t) => sk(t) >= 0,
  (s, t) => tk(t) >= 0,
  (s, t) => ik(t) >= 0,
  (s, t) => G1(t, s, !0) >= 0,
  (s, t) => K1(t, s, !0) >= 0,
  (s, t) => Y1(t, s, !0) >= 0,
  (s, t) => ak(t, s, !0) >= 0
], MW = { text: "", end: 0 };
var Fh;
const sQ = (Fh = class {
  /// @internal
  constructor(t, i, n, r) {
    this.parser = t, this.input = i, this.ranges = r, this.line = new SW(), this.atEnd = !1, this.reusePlaceholders = /* @__PURE__ */ new Map(), this.stoppedAt = null, this.rangeI = 0, this.to = r[r.length - 1].to, this.lineStart = this.absoluteLineStart = this.absoluteLineEnd = r[0].from, this.block = QP.create(X.Document, 0, this.lineStart, 0, 0), this.stack = [this.block], this.fragments = n.length ? new zW(n, i) : null, this.readLine();
  }
  get parsedPos() {
    return this.absoluteLineStart;
  }
  advance() {
    if (this.stoppedAt != null && this.absoluteLineStart > this.stoppedAt)
      return this.finish();
    let { line: t } = this;
    for (; ; ) {
      for (let n = 0; ; ) {
        let r = t.depth < this.stack.length ? this.stack[this.stack.length - 1] : null;
        for (; n < t.markers.length && (!r || t.markers[n].from < r.end); ) {
          let a = t.markers[n++];
          this.addNode(a.type, a.from, a.to);
        }
        if (!r)
          break;
        this.finishContext();
      }
      if (t.pos < t.text.length)
        break;
      if (!this.nextLine())
        return this.finish();
    }
    if (this.fragments && this.reuseFragment(t.basePos))
      return null;
    e: for (; ; ) {
      for (let n of this.parser.blockParsers)
        if (n) {
          let r = n(this, t);
          if (r != !1) {
            if (r == !0)
              return null;
            t.forward();
            continue e;
          }
        }
      break;
    }
    let i = new kW(this.lineStart + t.pos, t.text.slice(t.pos));
    for (let n of this.parser.leafBlockParsers)
      if (n) {
        let r = n(this, i);
        r && i.parsers.push(r);
      }
    e: for (; this.nextLine() && t.pos != t.text.length; ) {
      if (t.indent < t.baseIndent + 4) {
        for (let n of this.parser.endLeafBlock)
          if (n(this, t, i))
            break e;
      }
      for (let n of i.parsers)
        if (n.nextLine(this, t, i))
          return null;
      i.content += `
` + t.scrub();
      for (let n of t.markers)
        i.marks.push(n);
    }
    return this.finishLeaf(i), null;
  }
  stopAt(t) {
    if (this.stoppedAt != null && this.stoppedAt < t)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t;
  }
  reuseFragment(t) {
    if (!this.fragments.moveTo(this.absoluteLineStart + t, this.absoluteLineStart) || !this.fragments.matches(this.block.hash))
      return !1;
    let i = this.fragments.takeNodes(this);
    return i ? (this.absoluteLineStart += i, this.lineStart = dk(this.absoluteLineStart, this.ranges), this.moveRangeI(), this.absoluteLineStart < this.to ? (this.lineStart++, this.absoluteLineStart++, this.readLine()) : (this.atEnd = !0, this.readLine()), !0) : !1;
  }
  /// The number of parent blocks surrounding the current block.
  get depth() {
    return this.stack.length;
  }
  /// Get the type of the parent block at the given depth. When no
  /// depth is passed, return the type of the innermost parent.
  parentType(t = this.depth - 1) {
    return this.parser.nodeSet.types[this.stack[t].type];
  }
  /// Move to the next input line. This should only be called by
  /// (non-composite) [block parsers](#BlockParser.parse) that consume
  /// the line directly, or leaf block parser
  /// [`nextLine`](#LeafBlockParser.nextLine) methods when they
  /// consume the current line (and return true).
  nextLine() {
    return this.lineStart += this.line.text.length, this.absoluteLineEnd >= this.to ? (this.absoluteLineStart = this.absoluteLineEnd, this.atEnd = !0, this.readLine(), !1) : (this.lineStart++, this.absoluteLineStart = this.absoluteLineEnd + 1, this.moveRangeI(), this.readLine(), !0);
  }
  moveRangeI() {
    for (; this.rangeI < this.ranges.length - 1 && this.absoluteLineStart >= this.ranges[this.rangeI].to; )
      this.rangeI++, this.absoluteLineStart = Math.max(this.absoluteLineStart, this.ranges[this.rangeI].from);
  }
  /// @internal
  scanLine(t) {
    let i = MW;
    if (i.end = t, t >= this.to)
      i.text = "";
    else if (i.text = this.lineChunkAt(t), i.end += i.text.length, this.ranges.length > 1) {
      let n = this.absoluteLineStart, r = this.rangeI;
      for (; this.ranges[r].to < i.end; ) {
        r++;
        let a = this.ranges[r].from, o = this.lineChunkAt(a);
        i.end = a + o.length, i.text = i.text.slice(0, this.ranges[r - 1].to - n) + o, n = i.end - i.text.length;
      }
    }
    return i;
  }
  /// @internal
  readLine() {
    let { line: t } = this, { text: i, end: n } = this.scanLine(this.absoluteLineStart);
    for (this.absoluteLineEnd = n, t.reset(i); t.depth < this.stack.length; t.depth++) {
      let r = this.stack[t.depth], a = this.parser.skipContextMarkup[r.type];
      if (!a)
        throw new Error("Unhandled block context " + X[r.type]);
      if (!a(r, this, t))
        break;
      t.forward();
    }
  }
  lineChunkAt(t) {
    let i = this.input.chunk(t), n;
    if (this.input.lineChunks)
      n = i == `
` ? "" : i;
    else {
      let r = i.indexOf(`
`);
      n = r < 0 ? i : i.slice(0, r);
    }
    return t + n.length > this.to ? n.slice(0, this.to - t) : n;
  }
  /// The end position of the previous line.
  prevLineEnd() {
    return this.atEnd ? this.lineStart : this.lineStart - 1;
  }
  /// @internal
  startContext(t, i, n = 0) {
    this.block = QP.create(t, n, this.lineStart + i, this.block.hash, this.lineStart + this.line.text.length), this.stack.push(this.block);
  }
  /// Start a composite block. Should only be called from [block
  /// parser functions](#BlockParser.parse) that return null.
  startComposite(t, i, n = 0) {
    this.startContext(this.parser.getNodeType(t), i, n);
  }
  /// @internal
  addNode(t, i, n) {
    typeof t == "number" && (t = new ze(this.parser.nodeSet.types[t], uf, uf, (n ?? this.prevLineEnd()) - i)), this.block.addChild(t, i - this.block.from);
  }
  /// Add a block element. Can be called by [block
  /// parsers](#BlockParser.parse).
  addElement(t) {
    this.block.addChild(t.toTree(this.parser.nodeSet), t.from - this.block.from);
  }
  /// Add a block element from a [leaf parser](#LeafBlockParser). This
  /// makes sure any extra composite block markup (such as blockquote
  /// markers) inside the block are also added to the syntax tree.
  addLeafElement(t, i) {
    this.addNode(this.buffer.writeElements(Xg(i.children, t.marks), -i.from).finish(i.type, i.to - i.from), i.from);
  }
  /// @internal
  finishContext() {
    let t = this.stack.pop(), i = this.stack[this.stack.length - 1];
    i.addChild(t.toTree(this.parser.nodeSet), t.from - i.from), this.block = i;
  }
  finish() {
    for (; this.stack.length > 1; )
      this.finishContext();
    return this.addGaps(this.block.toTree(this.parser.nodeSet, this.lineStart));
  }
  addGaps(t) {
    return this.ranges.length > 1 ? ok(this.ranges, 0, t.topNode, this.ranges[0].from, this.reusePlaceholders) : t;
  }
  /// @internal
  finishLeaf(t) {
    for (let n of t.parsers)
      if (n.finish(this, t))
        return;
    let i = Xg(this.parser.parseInline(t.content, t.start), t.marks);
    this.addNode(this.buffer.writeElements(i, -t.start).finish(X.Paragraph, t.content.length), t.start);
  }
  elt(t, i, n, r) {
    return typeof t == "string" ? Re(this.parser.getNodeType(t), i, n, r) : new dQ(t, i);
  }
  /// @internal
  get buffer() {
    return new cQ(this.parser.nodeSet);
  }
}, u(Fh, "ic"), Fh);
m(sQ, "BlockContext");
let RW = sQ;
function ok(s, t, i, n, r) {
  let a = s[t].to, o = [], l = [], c = i.from + n;
  function h(d, f) {
    for (; f ? d >= a : d > a; ) {
      let y = s[t + 1].from - a;
      n += y, d += y, t++, a = s[t].to;
    }
  }
  u(h, "h"), m(h, "movePastNext");
  for (let d = i.firstChild; d; d = d.nextSibling) {
    h(d.from + n, !0);
    let f = d.from + n, y, w = r.get(d.tree);
    w ? y = w : d.to + n > a ? (y = ok(s, t, d, n, r), h(d.to + n, !1)) : y = d.toTree(), o.push(y), l.push(f - c);
  }
  return h(i.to + n, !1), new ze(i.type, o, l, i.to + n - c, i.tree ? i.tree.propValues : void 0);
}
u(ok, "vp$1");
m(ok, "injectGaps");
var co;
const rQ = (co = class extends N1 {
  /// @internal
  constructor(t, i, n, r, a, o, l, c, h) {
    super(), this.nodeSet = t, this.blockParsers = i, this.leafBlockParsers = n, this.blockNames = r, this.endLeafBlock = a, this.skipContextMarkup = o, this.inlineParsers = l, this.inlineNames = c, this.wrappers = h, this.nodeTypes = /* @__PURE__ */ Object.create(null);
    for (let d of t.types)
      this.nodeTypes[d.name] = d.id;
  }
  createParse(t, i, n) {
    let r = new RW(this, t, i, n);
    for (let a of this.wrappers)
      r = a(r, t, i, n);
    return r;
  }
  /// Reconfigure the parser.
  configure(t) {
    let i = jg(t);
    if (!i)
      return this;
    let { nodeSet: n, skipContextMarkup: r } = this, a = this.blockParsers.slice(), o = this.leafBlockParsers.slice(), l = this.blockNames.slice(), c = this.inlineParsers.slice(), h = this.inlineNames.slice(), d = this.endLeafBlock.slice(), f = this.wrappers;
    if (Wl(i.defineNodes)) {
      r = Object.assign({}, r);
      let y = n.types.slice(), w;
      for (let g of i.defineNodes) {
        let { name: b, block: k, composite: $, style: C } = typeof g == "string" ? { name: g } : g;
        if (y.some((R) => R.name == b))
          continue;
        $ && (r[y.length] = (R, L, I) => $(L, I, R.value));
        let E = y.length, A = $ ? ["Block", "BlockContext"] : k ? E >= X.ATXHeading1 && E <= X.SetextHeading2 ? ["Block", "LeafBlock", "Heading"] : ["Block", "LeafBlock"] : void 0;
        y.push(Et.define({
          id: E,
          name: b,
          props: A && [[Oe.group, A]]
        })), C && (w || (w = {}), Array.isArray(C) || C instanceof hs ? w[b] = C : Object.assign(w, C));
      }
      n = new D1(y), w && (n = n.extend(Io(w)));
    }
    if (Wl(i.props) && (n = n.extend(...i.props)), Wl(i.remove))
      for (let y of i.remove) {
        let w = this.blockNames.indexOf(y), g = this.inlineNames.indexOf(y);
        w > -1 && (a[w] = o[w] = void 0), g > -1 && (c[g] = void 0);
      }
    if (Wl(i.parseBlock))
      for (let y of i.parseBlock) {
        let w = l.indexOf(y.name);
        if (w > -1)
          a[w] = y.parse, o[w] = y.leaf;
        else {
          let g = y.before ? Cy(l, y.before) : y.after ? Cy(l, y.after) + 1 : l.length - 1;
          a.splice(g, 0, y.parse), o.splice(g, 0, y.leaf), l.splice(g, 0, y.name);
        }
        y.endLeaf && d.push(y.endLeaf);
      }
    if (Wl(i.parseInline))
      for (let y of i.parseInline) {
        let w = h.indexOf(y.name);
        if (w > -1)
          c[w] = y.parse;
        else {
          let g = y.before ? Cy(h, y.before) : y.after ? Cy(h, y.after) + 1 : h.length - 1;
          c.splice(g, 0, y.parse), h.splice(g, 0, y.name);
        }
      }
    return i.wrap && (f = f.concat(i.wrap)), new co(n, a, o, l, d, r, c, h, f);
  }
  /// @internal
  getNodeType(t) {
    let i = this.nodeTypes[t];
    if (i == null)
      throw new RangeError(`Unknown node type '${t}'`);
    return i;
  }
  /// Parse the given piece of inline text at the given offset,
  /// returning an array of [`Element`](#Element) objects representing
  /// the inline content.
  parseInline(t, i) {
    let n = new AW(this, t, i);
    e: for (let r = i; r < n.end; ) {
      let a = n.char(r);
      for (let o of this.inlineParsers)
        if (o) {
          let l = o(n, a, r);
          if (l >= 0) {
            r = l;
            continue e;
          }
        }
      r++;
    }
    return n.resolveMarkers(0);
  }
}, u(co, "uo"), co);
m(rQ, "MarkdownParser");
let aQ = rQ;
function Wl(s) {
  return s != null && s.length > 0;
}
u(Wl, "or$1");
m(Wl, "nonEmpty");
function jg(s) {
  if (!Array.isArray(s))
    return s;
  if (s.length == 0)
    return null;
  let t = jg(s[0]);
  if (s.length == 1)
    return t;
  let i = jg(s.slice(1));
  if (!i || !t)
    return t || i;
  let n = /* @__PURE__ */ m((o, l) => (o || uf).concat(l || uf), "conc"), r = t.wrap, a = i.wrap;
  return {
    props: n(t.props, i.props),
    defineNodes: n(t.defineNodes, i.defineNodes),
    parseBlock: n(t.parseBlock, i.parseBlock),
    parseInline: n(t.parseInline, i.parseInline),
    remove: n(t.remove, i.remove),
    wrap: r ? a ? (o, l, c, h) => r(a(o, l, c, h), l, c, h) : r : a
  };
}
u(jg, "Ra$1");
m(jg, "resolveConfig");
function Cy(s, t) {
  let i = s.indexOf(t);
  if (i < 0)
    throw new RangeError(`Position specified relative to unknown parser ${t}`);
  return i;
}
u(Cy, "Cn$1");
m(Cy, "findName");
let oQ = [Et.none];
for (let s = 1, t; t = X[s]; s++)
  oQ[s] = Et.define({
    id: s,
    name: t,
    props: s >= X.Escape ? [] : [[Oe.group, s in J6 ? ["Block", "BlockContext"] : ["Block", "LeafBlock"]]],
    top: t == "Document"
  });
const uf = [];
var Hh;
const lQ = (Hh = class {
  constructor(t) {
    this.nodeSet = t, this.content = [], this.nodes = [];
  }
  write(t, i, n, r = 0) {
    return this.content.push(t, i, n, 4 + r * 4), this;
  }
  writeElements(t, i = 0) {
    for (let n of t)
      n.writeTo(this, i);
    return this;
  }
  finish(t, i) {
    return ze.build({
      buffer: this.content,
      nodeSet: this.nodeSet,
      reused: this.nodes,
      topID: t,
      length: i
    });
  }
}, u(Hh, "rc"), Hh);
m(lQ, "Buffer");
let cQ = lQ;
var Yv, Yh;
let hm = (Yv = (Yh = class {
  /// @internal
  constructor(t, i, n, r = uf) {
    this.type = t, this.from = i, this.to = n, this.children = r;
  }
  /// @internal
  writeTo(t, i) {
    let n = t.content.length;
    t.writeElements(this.children, i), t.content.push(this.type, this.from + i, this.to + i, t.content.length + 4 - n);
  }
  /// @internal
  toTree(t) {
    return new cQ(t).writeElements(this.children, -this.from).finish(this.type, this.to - this.from);
  }
}, u(Yh, "_i$1"), Yh), m(Yv, "Element"), Yv);
var Gh;
const hQ = (Gh = class {
  constructor(t, i) {
    this.tree = t, this.from = i;
  }
  get to() {
    return this.from + this.tree.length;
  }
  get type() {
    return this.tree.type.id;
  }
  get children() {
    return uf;
  }
  writeTo(t, i) {
    t.nodes.push(this.tree), t.content.push(t.nodes.length - 1, this.from + i, this.to + i, -1);
  }
  toTree() {
    return this.tree;
  }
}, u(Gh, "nc"), Gh);
m(hQ, "TreeElement");
let dQ = hQ;
function Re(s, t, i, n) {
  return new hm(s, t, i, n);
}
u(Re, "E$1");
m(Re, "elt");
const uQ = { resolve: "Emphasis", mark: "EmphasisMark" }, pQ = { resolve: "Emphasis", mark: "EmphasisMark" }, Vl = {}, _2 = {};
var Kh;
const fQ = (Kh = class {
  constructor(t, i, n, r) {
    this.type = t, this.from = i, this.to = n, this.side = r;
  }
}, u(Kh, "sc"), Kh);
m(fQ, "InlineDelimiter");
let Vi = fQ;
const TP = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
let dm = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\u2010-\u2027]/;
try {
  dm = new RegExp("[\\p{Pc}|\\p{Pd}|\\p{Pe}|\\p{Pf}|\\p{Pi}|\\p{Po}|\\p{Ps}]", "u");
} catch {
}
const Gv = {
  Escape(s, t, i) {
    if (t != 92 || i == s.end - 1)
      return -1;
    let n = s.char(i + 1);
    for (let r = 0; r < TP.length; r++)
      if (TP.charCodeAt(r) == n)
        return s.append(Re(X.Escape, i, i + 2));
    return -1;
  },
  Entity(s, t, i) {
    if (t != 38)
      return -1;
    let n = /^(?:#\d+|#x[a-f\d]+|\w+);/i.exec(s.slice(i + 1, i + 31));
    return n ? s.append(Re(X.Entity, i, i + 1 + n[0].length)) : -1;
  },
  InlineCode(s, t, i) {
    if (t != 96 || i && s.char(i - 1) == 96)
      return -1;
    let n = i + 1;
    for (; n < s.end && s.char(n) == 96; )
      n++;
    let r = n - i, a = 0;
    for (; n < s.end; n++)
      if (s.char(n) == 96) {
        if (a++, a == r && s.char(n + 1) != 96)
          return s.append(Re(X.InlineCode, i, n + 1, [
            Re(X.CodeMark, i, i + r),
            Re(X.CodeMark, n + 1 - r, n + 1)
          ]));
      } else
        a = 0;
    return -1;
  },
  HTMLTag(s, t, i) {
    if (t != 60 || i == s.end - 1)
      return -1;
    let n = s.slice(i + 1, s.end), r = /^(?:[a-z][-\w+.]+:[^\s>]+|[a-z\d.!#$%&'*+/=?^_`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*)>/i.exec(n);
    if (r)
      return s.append(Re(X.Autolink, i, i + 1 + r[0].length, [
        Re(X.LinkMark, i, i + 1),
        // url[0] includes the closing bracket, so exclude it from this slice
        Re(X.URL, i + 1, i + r[0].length),
        Re(X.LinkMark, i + r[0].length, i + 1 + r[0].length)
      ]));
    let a = /^!--[^>](?:-[^-]|[^-])*?-->/i.exec(n);
    if (a)
      return s.append(Re(X.Comment, i, i + 1 + a[0].length));
    let o = /^\?[^]*?\?>/.exec(n);
    if (o)
      return s.append(Re(X.ProcessingInstruction, i, i + 1 + o[0].length));
    let l = /^(?:![A-Z][^]*?>|!\[CDATA\[[^]*?\]\]>|\/\s*[a-zA-Z][\w-]*\s*>|\s*[a-zA-Z][\w-]*(\s+[a-zA-Z:_][\w-.:]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*(\/\s*)?>)/.exec(n);
    return l ? s.append(Re(X.HTMLTag, i, i + 1 + l[0].length)) : -1;
  },
  Emphasis(s, t, i) {
    if (t != 95 && t != 42)
      return -1;
    let n = i + 1;
    for (; s.char(n) == t; )
      n++;
    let r = s.slice(i - 1, i), a = s.slice(n, n + 1), o = dm.test(r), l = dm.test(a), c = /\s|^$/.test(r), h = /\s|^$/.test(a), d = !h && (!l || c || o), f = !c && (!o || h || l), y = d && (t == 42 || !f || o), w = f && (t == 42 || !d || l);
    return s.append(new Vi(t == 95 ? uQ : pQ, i, n, (y ? 1 : 0) | (w ? 2 : 0)));
  },
  HardBreak(s, t, i) {
    if (t == 92 && s.char(i + 1) == 10)
      return s.append(Re(X.HardBreak, i, i + 2));
    if (t == 32) {
      let n = i + 1;
      for (; s.char(n) == 32; )
        n++;
      if (s.char(n) == 10 && n >= i + 2)
        return s.append(Re(X.HardBreak, i, n + 1));
    }
    return -1;
  },
  Link(s, t, i) {
    return t == 91 ? s.append(new Vi(
      Vl,
      i,
      i + 1,
      1
      /* Mark.Open */
    )) : -1;
  },
  Image(s, t, i) {
    return t == 33 && s.char(i + 1) == 91 ? s.append(new Vi(
      _2,
      i,
      i + 2,
      1
      /* Mark.Open */
    )) : -1;
  },
  LinkEnd(s, t, i) {
    if (t != 93)
      return -1;
    for (let n = s.parts.length - 1; n >= 0; n--) {
      let r = s.parts[n];
      if (r instanceof Vi && (r.type == Vl || r.type == _2)) {
        if (!r.side || s.skipSpace(r.to) == i && !/[(\[]/.test(s.slice(i + 1, i + 2)))
          return s.parts[n] = null, -1;
        let a = s.takeContent(n), o = s.parts[n] = yQ(s, a, r.type == Vl ? X.Link : X.Image, r.from, i + 1);
        if (r.type == Vl)
          for (let l = 0; l < n; l++) {
            let c = s.parts[l];
            c instanceof Vi && c.type == Vl && (c.side = 0);
          }
        return o.to;
      }
    }
    return -1;
  }
};
function yQ(s, t, i, n, r) {
  let { text: a } = s, o = s.char(r), l = r;
  if (t.unshift(Re(X.LinkMark, n, n + (i == X.Image ? 2 : 1))), t.push(Re(X.LinkMark, r - 1, r)), o == 40) {
    let c = s.skipSpace(r + 1), h = lk(a, c - s.offset, s.offset), d;
    h && (c = s.skipSpace(h.to), c != h.to && (d = ck(a, c - s.offset, s.offset), d && (c = s.skipSpace(d.to)))), s.char(c) == 41 && (t.push(Re(X.LinkMark, r, r + 1)), l = c + 1, h && t.push(h), d && t.push(d), t.push(Re(X.LinkMark, c, l)));
  } else if (o == 91) {
    let c = hk(a, r - s.offset, s.offset, !1);
    c && (t.push(c), l = c.to);
  }
  return Re(i, n, l, t);
}
u(yQ, "M1$1");
m(yQ, "finishLink");
function lk(s, t, i) {
  if (s.charCodeAt(t) == 60) {
    for (let n = t + 1; n < s.length; n++) {
      let r = s.charCodeAt(n);
      if (r == 62)
        return Re(X.URL, t + i, n + 1 + i);
      if (r == 60 || r == 10)
        return !1;
    }
    return null;
  } else {
    let n = 0, r = t;
    for (let a = !1; r < s.length; r++) {
      let o = s.charCodeAt(r);
      if (Ii(o))
        break;
      if (a)
        a = !1;
      else if (o == 40)
        n++;
      else if (o == 41) {
        if (!n)
          break;
        n--;
      } else o == 92 && (a = !0);
    }
    return r > t ? Re(X.URL, t + i, r + i) : r == s.length ? null : !1;
  }
}
u(lk, "Wp");
m(lk, "parseURL");
function ck(s, t, i) {
  let n = s.charCodeAt(t);
  if (n != 39 && n != 34 && n != 40)
    return !1;
  let r = n == 40 ? 41 : n;
  for (let a = t + 1, o = !1; a < s.length; a++) {
    let l = s.charCodeAt(a);
    if (o)
      o = !1;
    else {
      if (l == r)
        return Re(X.LinkTitle, t + i, a + 1 + i);
      l == 92 && (o = !0);
    }
  }
  return null;
}
u(ck, "Up$1");
m(ck, "parseLinkTitle");
function hk(s, t, i, n) {
  for (let r = !1, a = t + 1, o = Math.min(s.length, a + 999); a < o; a++) {
    let l = s.charCodeAt(a);
    if (r)
      r = !1;
    else {
      if (l == 93)
        return n ? !1 : Re(X.LinkLabel, t + i, a + 1 + i);
      if (n && !Ii(l) && (n = !1), l == 91)
        return !1;
      l == 92 && (r = !0);
    }
  }
  return null;
}
u(hk, "Lp$1");
m(hk, "parseLinkLabel");
var Jh;
const mQ = (Jh = class {
  /// @internal
  constructor(t, i, n) {
    this.parser = t, this.text = i, this.offset = n, this.parts = [];
  }
  /// Get the character code at the given (document-relative)
  /// position.
  char(t) {
    return t >= this.end ? -1 : this.text.charCodeAt(t - this.offset);
  }
  /// The position of the end of this inline section.
  get end() {
    return this.offset + this.text.length;
  }
  /// Get a substring of this inline section. Again uses
  /// document-relative positions.
  slice(t, i) {
    return this.text.slice(t - this.offset, i - this.offset);
  }
  /// @internal
  append(t) {
    return this.parts.push(t), t.to;
  }
  /// Add a [delimiter](#DelimiterType) at this given position. `open`
  /// and `close` indicate whether this delimiter is opening, closing,
  /// or both. Returns the end of the delimiter, for convenient
  /// returning from [parse functions](#InlineParser.parse).
  addDelimiter(t, i, n, r, a) {
    return this.append(new Vi(t, i, n, (r ? 1 : 0) | (a ? 2 : 0)));
  }
  /// Returns true when there is an unmatched link or image opening
  /// token before the current position.
  get hasOpenLink() {
    for (let t = this.parts.length - 1; t >= 0; t--) {
      let i = this.parts[t];
      if (i instanceof Vi && (i.type == Vl || i.type == _2))
        return !0;
    }
    return !1;
  }
  /// Add an inline element. Returns the end of the element.
  addElement(t) {
    return this.append(t);
  }
  /// Resolve markers between this.parts.length and from, wrapping matched markers in the
  /// appropriate node and updating the content of this.parts. @internal
  resolveMarkers(t) {
    for (let n = t; n < this.parts.length; n++) {
      let r = this.parts[n];
      if (!(r instanceof Vi && r.type.resolve && r.side & 2))
        continue;
      let a = r.type == uQ || r.type == pQ, o = r.to - r.from, l, c = n - 1;
      for (; c >= t; c--) {
        let g = this.parts[c];
        if (g instanceof Vi && g.side & 1 && g.type == r.type && // Ignore emphasis delimiters where the character count doesn't match
        !(a && (r.side & 1 || g.side & 2) && (g.to - g.from + o) % 3 == 0 && ((g.to - g.from) % 3 || o % 3))) {
          l = g;
          break;
        }
      }
      if (!l)
        continue;
      let h = r.type.resolve, d = [], f = l.from, y = r.to;
      if (a) {
        let g = Math.min(2, l.to - l.from, o);
        f = l.to - g, y = r.from + g, h = g == 1 ? "Emphasis" : "StrongEmphasis";
      }
      l.type.mark && d.push(this.elt(l.type.mark, f, l.to));
      for (let g = c + 1; g < n; g++)
        this.parts[g] instanceof hm && d.push(this.parts[g]), this.parts[g] = null;
      r.type.mark && d.push(this.elt(r.type.mark, r.from, y));
      let w = this.elt(h, f, y, d);
      this.parts[c] = a && l.from != f ? new Vi(l.type, l.from, f, l.side) : null, (this.parts[n] = a && r.to != y ? new Vi(r.type, y, r.to, r.side) : null) ? this.parts.splice(n, 0, w) : this.parts[n] = w;
    }
    let i = [];
    for (let n = t; n < this.parts.length; n++) {
      let r = this.parts[n];
      r instanceof hm && i.push(r);
    }
    return i;
  }
  /// Find an opening delimiter of the given type. Returns `null` if
  /// no delimiter is found, or an index that can be passed to
  /// [`takeContent`](#InlineContext.takeContent) otherwise.
  findOpeningDelimiter(t) {
    for (let i = this.parts.length - 1; i >= 0; i--) {
      let n = this.parts[i];
      if (n instanceof Vi && n.type == t)
        return i;
    }
    return null;
  }
  /// Remove all inline elements and delimiters starting from the
  /// given index (which you should get from
  /// [`findOpeningDelimiter`](#InlineContext.findOpeningDelimiter),
  /// resolve delimiters inside of them, and return them as an array
  /// of elements.
  takeContent(t) {
    let i = this.resolveMarkers(t);
    return this.parts.length = t, i;
  }
  /// Skip space after the given (document) position, returning either
  /// the position of the next non-space character or the end of the
  /// section.
  skipSpace(t) {
    return uc(this.text, t - this.offset) + this.offset;
  }
  elt(t, i, n, r) {
    return typeof t == "string" ? Re(this.parser.getNodeType(t), i, n, r) : new dQ(t, i);
  }
}, u(Jh, "oc"), Jh);
m(mQ, "InlineContext");
let AW = mQ;
function Xg(s, t) {
  if (!t.length)
    return s;
  if (!s.length)
    return t;
  let i = s.slice(), n = 0;
  for (let r of t) {
    for (; n < i.length && i[n].to < r.to; )
      n++;
    if (n < i.length && i[n].from < r.from) {
      let a = i[n];
      a instanceof hm && (i[n] = new hm(a.type, a.from, a.to, Xg(a.children, [r])));
    } else
      i.splice(n++, 0, r);
  }
  return i;
}
u(Xg, "Ta$1");
m(Xg, "injectMarks");
const EW = [X.CodeBlock, X.ListItem, X.OrderedList, X.BulletList];
var Kv, ed;
let zW = (Kv = (ed = class {
  constructor(t, i) {
    this.fragments = t, this.input = i, this.i = 0, this.fragment = null, this.fragmentEnd = -1, this.cursor = null, t.length && (this.fragment = t[this.i++]);
  }
  nextFragment() {
    this.fragment = this.i < this.fragments.length ? this.fragments[this.i++] : null, this.cursor = null, this.fragmentEnd = -1;
  }
  moveTo(t, i) {
    for (; this.fragment && this.fragment.to <= t; )
      this.nextFragment();
    if (!this.fragment || this.fragment.from > (t ? t - 1 : 0))
      return !1;
    if (this.fragmentEnd < 0) {
      let a = this.fragment.to;
      for (; a > 0 && this.input.read(a - 1, a) != `
`; )
        a--;
      this.fragmentEnd = a ? a - 1 : 0;
    }
    let n = this.cursor;
    n || (n = this.cursor = this.fragment.tree.cursor(), n.firstChild());
    let r = t + this.fragment.offset;
    for (; n.to <= r; )
      if (!n.parent())
        return !1;
    for (; ; ) {
      if (n.from >= r)
        return this.fragment.from <= i;
      if (!n.childAfter(r))
        return !1;
    }
  }
  matches(t) {
    let i = this.cursor.tree;
    return i && i.prop(Oe.contextHash) == t;
  }
  takeNodes(t) {
    let i = this.cursor, n = this.fragment.offset, r = this.fragmentEnd - (this.fragment.openEnd ? 1 : 0), a = t.absoluteLineStart, o = a, l = t.block.children.length, c = o, h = l;
    for (; ; ) {
      if (i.to - n > r) {
        if (i.type.isAnonymous && i.firstChild())
          continue;
        break;
      }
      let d = dk(i.from - n, t.ranges);
      if (i.to - n <= t.ranges[t.rangeI].to)
        t.addNode(i.tree, d);
      else {
        let f = new ze(t.parser.nodeSet.types[X.Paragraph], [], [], 0, t.block.hashProp);
        t.reusePlaceholders.set(f, i.tree), t.addNode(f, d);
      }
      if (i.type.is("Block") && (EW.indexOf(i.type.id) < 0 ? (o = i.to - n, l = t.block.children.length) : (o = c, l = h, c = i.to - n, h = t.block.children.length)), !i.nextSibling())
        break;
    }
    for (; t.block.children.length > l; )
      t.block.children.pop(), t.block.positions.pop();
    return o - a;
  }
}, u(ed, "Mi$1"), ed), m(Kv, "FragmentCursor"), Kv);
function dk(s, t) {
  let i = s;
  for (let n = 1; n < t.length; n++) {
    let r = t[n - 1].to, a = t[n].from;
    r < s && (i -= a - r);
  }
  return i;
}
u(dk, "_p$1");
m(dk, "toRelative");
const _W = Io({
  "Blockquote/...": Q.quote,
  HorizontalRule: Q.contentSeparator,
  "ATXHeading1/... SetextHeading1/...": Q.heading1,
  "ATXHeading2/... SetextHeading2/...": Q.heading2,
  "ATXHeading3/...": Q.heading3,
  "ATXHeading4/...": Q.heading4,
  "ATXHeading5/...": Q.heading5,
  "ATXHeading6/...": Q.heading6,
  "Comment CommentBlock": Q.comment,
  Escape: Q.escape,
  Entity: Q.character,
  "Emphasis/...": Q.emphasis,
  "StrongEmphasis/...": Q.strong,
  "Link/... Image/...": Q.link,
  "OrderedList/... BulletList/...": Q.list,
  "BlockQuote/...": Q.quote,
  "InlineCode CodeText": Q.monospace,
  "URL Autolink": Q.url,
  "HeaderMark HardBreak QuoteMark ListMark LinkMark EmphasisMark CodeMark": Q.processingInstruction,
  "CodeInfo LinkLabel": Q.labelName,
  LinkTitle: Q.string,
  Paragraph: Q.content
}), LW = new aQ(new D1(oQ).extend(_W), Object.keys(Qw).map((s) => Qw[s]), Object.keys(Qw).map((s) => QW[s]), Object.keys(Qw), TW, J6, Object.keys(Gv).map((s) => Gv[s]), Object.keys(Gv), []);
function wQ(s, t, i) {
  let n = [];
  for (let r = s.firstChild, a = t; ; r = r.nextSibling) {
    let o = r ? r.from : i;
    if (o > a && n.push({ from: a, to: o }), !r)
      break;
    a = r.to;
  }
  return n;
}
u(wQ, "X1$1");
m(wQ, "leftOverSpace");
function gQ(s) {
  let { codeParser: t, htmlParser: i } = s;
  return { wrap: Lx((n, r) => {
    let a = n.type.id;
    if (t && (a == X.CodeBlock || a == X.FencedCode)) {
      let o = "";
      if (a == X.FencedCode) {
        let c = n.node.getChild(X.CodeInfo);
        c && (o = r.read(c.from, c.to));
      }
      let l = t(o);
      if (l)
        return { parser: l, overlay: /* @__PURE__ */ m((c) => c.type.id == X.CodeText, "overlay") };
    } else if (i && (a == X.HTMLBlock || a == X.HTMLTag))
      return { parser: i, overlay: wQ(n.node, n.from, n.to) };
    return null;
  }) };
}
u(gQ, "I1$1");
m(gQ, "parseCode");
const IW = { resolve: "Strikethrough", mark: "StrikethroughMark" }, WW = {
  defineNodes: [{
    name: "Strikethrough",
    style: { "Strikethrough/...": Q.strikethrough }
  }, {
    name: "StrikethroughMark",
    style: Q.processingInstruction
  }],
  parseInline: [{
    name: "Strikethrough",
    parse(s, t, i) {
      if (t != 126 || s.char(i + 1) != 126 || s.char(i + 2) == 126)
        return -1;
      let n = s.slice(i - 1, i), r = s.slice(i + 2, i + 3), a = /\s|^$/.test(n), o = /\s|^$/.test(r), l = dm.test(n), c = dm.test(r);
      return s.addDelimiter(IW, i, i + 2, !o && (!c || a || l), !a && (!l || o || c));
    },
    after: "Emphasis"
  }]
};
function pc(s, t, i = 0, n, r = 0) {
  let a = 0, o = !0, l = -1, c = -1, h = !1, d = /* @__PURE__ */ m(() => {
    n.push(s.elt("TableCell", r + l, r + c, s.parser.parseInline(t.slice(l, c), r + l)));
  }, "parseCell");
  for (let f = i; f < t.length; f++) {
    let y = t.charCodeAt(f);
    y == 124 && !h ? ((!o || l > -1) && a++, o = !1, n && (l > -1 && d(), n.push(s.elt("TableDelimiter", f + r, f + r + 1))), l = c = -1) : (h || y != 32 && y != 9) && (l < 0 && (l = f), c = f + 1), h = !h && y == 92;
  }
  return l > -1 && (a++, n && d()), a;
}
u(pc, "xr$1");
m(pc, "parseRow");
function L2(s, t) {
  for (let i = t; i < s.length; i++) {
    let n = s.charCodeAt(i);
    if (n == 124)
      return !0;
    n == 92 && i++;
  }
  return !1;
}
u(L2, "zu$1");
m(L2, "hasPipe");
const vQ = /^\|?(\s*:?-+:?\s*\|)+(\s*:?-+:?\s*)?$/;
var td;
const OQ = (td = class {
  constructor() {
    this.rows = null;
  }
  nextLine(t, i, n) {
    if (this.rows == null) {
      this.rows = !1;
      let r;
      if ((i.next == 45 || i.next == 58 || i.next == 124) && vQ.test(r = i.text.slice(i.pos))) {
        let a = [];
        pc(t, n.content, 0, a, n.start) == pc(t, r, i.pos) && (this.rows = [
          t.elt("TableHeader", n.start, n.start + n.content.length, a),
          t.elt("TableDelimiter", t.lineStart + i.pos, t.lineStart + i.text.length)
        ]);
      }
    } else if (this.rows) {
      let r = [];
      pc(t, i.text, i.pos, r, t.lineStart), this.rows.push(t.elt("TableRow", t.lineStart + i.pos, t.lineStart + i.text.length, r));
    }
    return !1;
  }
  finish(t, i) {
    return this.rows ? (t.addLeafElement(i, t.elt("Table", i.start, i.start + i.content.length, this.rows)), !0) : !1;
  }
}, u(td, "lc"), td);
m(OQ, "TableParser");
let MP = OQ;
const VW = {
  defineNodes: [
    { name: "Table", block: !0 },
    { name: "TableHeader", style: { "TableHeader/...": Q.heading } },
    "TableRow",
    { name: "TableCell", style: Q.content },
    { name: "TableDelimiter", style: Q.processingInstruction }
  ],
  parseBlock: [{
    name: "Table",
    leaf(s, t) {
      return L2(t.content, 0) ? new MP() : null;
    },
    endLeaf(s, t, i) {
      if (i.parsers.some((r) => r instanceof MP) || !L2(t.text, t.basePos))
        return !1;
      let n = s.scanLine(s.absoluteLineEnd + 1).text;
      return vQ.test(n) && pc(s, t.text, t.basePos) == pc(s, n, t.basePos);
    },
    before: "SetextHeading"
  }]
};
var id;
const bQ = (id = class {
  nextLine() {
    return !1;
  }
  finish(t, i) {
    return t.addLeafElement(i, t.elt("Task", i.start, i.start + i.content.length, [
      t.elt("TaskMarker", i.start, i.start + 3),
      ...t.parser.parseInline(i.content.slice(3), i.start + 3)
    ])), !0;
  }
}, u(id, "ac"), id);
m(bQ, "TaskParser");
let ZW = bQ;
const DW = {
  defineNodes: [
    { name: "Task", block: !0, style: Q.list },
    { name: "TaskMarker", style: Q.atom }
  ],
  parseBlock: [{
    name: "TaskList",
    leaf(s, t) {
      return /^\[[ xX]\][ \t]/.test(t.content) && s.parentType().name == "ListItem" ? new ZW() : null;
    },
    after: "SetextHeading"
  }]
}, RP = /(www\.)|(https?:\/\/)|([\w.+-]+@)|(mailto:|xmpp:)/gy, AP = /[\w-]+(\.[\w-]+)+(\/[^\s<]*)?/gy, qW = /[\w-]+\.[\w-]+($|\/)/, EP = /[\w.+-]+@[\w-]+(\.[\w.-]+)+/gy, zP = /\/[a-zA-Z\d@.]+/gy;
function I2(s, t, i, n) {
  let r = 0;
  for (let a = t; a < i; a++)
    s[a] == n && r++;
  return r;
}
u(I2, "Fu$1");
m(I2, "count");
function $Q(s, t) {
  AP.lastIndex = t;
  let i = AP.exec(s);
  if (!i || qW.exec(i[0])[0].indexOf("_") > -1)
    return -1;
  let n = t + i[0].length;
  for (; ; ) {
    let r = s[n - 1], a;
    if (/[?!.,:*_~]/.test(r) || r == ")" && I2(s, t, n, ")") > I2(s, t, n, "("))
      n--;
    else if (r == ";" && (a = /&(?:#\d+|#x[a-f\d]+|\w+);$/.exec(s.slice(t, n))))
      n = t + a.index;
    else
      break;
  }
  return n;
}
u($Q, "N1$1");
m($Q, "autolinkURLEnd");
function W2(s, t) {
  EP.lastIndex = t;
  let i = EP.exec(s);
  if (!i)
    return -1;
  let n = i[0][i[0].length - 1];
  return n == "_" || n == "-" ? -1 : t + i[0].length - (n == "." ? 1 : 0);
}
u(W2, "Hu$1");
m(W2, "autolinkEmailEnd");
const UW = {
  parseInline: [{
    name: "Autolink",
    parse(s, t, i) {
      let n = i - s.offset;
      RP.lastIndex = n;
      let r = RP.exec(s.text), a = -1;
      if (!r)
        return -1;
      if (r[1] || r[2]) {
        if (a = $Q(s.text, n + r[0].length), a > -1 && s.hasOpenLink) {
          let o = /([^\[\]]|\[[^\]]*\])*/.exec(s.text.slice(n, a));
          a = n + o[0].length;
        }
      } else r[3] ? a = W2(s.text, n) : (a = W2(s.text, n + r[0].length), a > -1 && r[0] == "xmpp:" && (zP.lastIndex = a, r = zP.exec(s.text), r && (a = r.index + r[0].length)));
      return a < 0 ? -1 : (s.addElement(s.elt("URL", i, a + s.offset)), a + s.offset);
    }
  }]
}, NW = [VW, DW, WW, UW];
function uk(s, t, i) {
  return (n, r, a) => {
    if (r != s || n.char(a + 1) == s)
      return -1;
    let o = [n.elt(i, a, a + 1)];
    for (let l = a + 1; l < n.end; l++) {
      let c = n.char(l);
      if (c == s)
        return n.addElement(n.elt(t, a, l + 1, o.concat(n.elt(i, l, l + 1))));
      if (c == 92 && o.push(n.elt("Escape", l, l++ + 2)), Ii(c))
        break;
    }
    return -1;
  };
}
u(uk, "Yp$1");
m(uk, "parseSubSuper");
const BW = {
  defineNodes: [
    { name: "Superscript", style: Q.special(Q.content) },
    { name: "SuperscriptMark", style: Q.processingInstruction }
  ],
  parseInline: [{
    name: "Superscript",
    parse: uk(94, "Superscript", "SuperscriptMark")
  }]
}, jW = {
  defineNodes: [
    { name: "Subscript", style: Q.special(Q.content) },
    { name: "SubscriptMark", style: Q.processingInstruction }
  ],
  parseInline: [{
    name: "Subscript",
    parse: uk(126, "Subscript", "SubscriptMark")
  }]
}, XW = {
  defineNodes: [{ name: "Emoji", style: Q.character }],
  parseInline: [{
    name: "Emoji",
    parse(s, t, i) {
      let n;
      return t != 58 || !(n = /^[a-zA-Z_0-9]+:/.exec(s.slice(i + 1, s.end))) ? -1 : s.addElement(s.elt("Emoji", i, i + 1 + n[0].length));
    }
  }]
};
var vr;
const xQ = (vr = class {
  /**
  @internal
  */
  constructor(t, i, n, r, a, o, l, c, h, d = 0, f) {
    this.p = t, this.stack = i, this.state = n, this.reducePos = r, this.pos = a, this.score = o, this.buffer = l, this.bufferBase = c, this.curContext = h, this.lookAhead = d, this.parent = f;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((t, i) => i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(t, i, n = 0) {
    let r = t.parser.context;
    return new vr(t, [], i, n, n, 0, [], 0, r ? new _P(r, r.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(t, i) {
    this.stack.push(this.state, i, this.bufferBase + this.buffer.length), this.state = t;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(t) {
    var i;
    let n = t >> 19, r = t & 65535, { parser: a } = this.p;
    this.reducePos < this.pos - 25 && this.setLookAhead(this.pos);
    let o = a.dynamicPrecedence(r);
    if (o && (this.score += o), n == 0) {
      this.pushState(a.getGoto(this.state, r, !0), this.reducePos), r < a.minRepeatTerm && this.storeNode(r, this.reducePos, this.reducePos, 4, !0), this.reduceContext(r, this.reducePos);
      return;
    }
    let l = this.stack.length - (n - 1) * 3 - (t & 262144 ? 6 : 0), c = l ? this.stack[l - 2] : this.p.ranges[0].from, h = this.reducePos - c;
    h >= 2e3 && !(!((i = this.p.parser.nodeSet.types[r]) === null || i === void 0) && i.isAnonymous) && (c == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = h) : this.p.lastBigReductionSize < h && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = c, this.p.lastBigReductionSize = h));
    let d = l ? this.stack[l - 1] : 0, f = this.bufferBase + this.buffer.length - d;
    if (r < a.minRepeatTerm || t & 131072) {
      let y = a.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(r, c, y, f + 4, !0);
    }
    if (t & 262144)
      this.state = this.stack[l];
    else {
      let y = this.stack[l - 3];
      this.state = a.getGoto(y, r, !0);
    }
    for (; this.stack.length > l; )
      this.stack.pop();
    this.reduceContext(r, c);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(t, i, n, r = 4, a = !1) {
    if (t == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let o = this, l = this.buffer.length;
      if (l == 0 && o.parent && (l = o.bufferBase - o.parent.bufferBase, o = o.parent), l > 0 && o.buffer[l - 4] == 0 && o.buffer[l - 1] > -1) {
        if (i == n)
          return;
        if (o.buffer[l - 2] >= i) {
          o.buffer[l - 2] = n;
          return;
        }
      }
    }
    if (!a || this.pos == n)
      this.buffer.push(t, i, n, r);
    else {
      let o = this.buffer.length;
      if (o > 0 && this.buffer[o - 4] != 0)
        for (; o > 0 && this.buffer[o - 2] > n; )
          this.buffer[o] = this.buffer[o - 4], this.buffer[o + 1] = this.buffer[o - 3], this.buffer[o + 2] = this.buffer[o - 2], this.buffer[o + 3] = this.buffer[o - 1], o -= 4, r > 4 && (r -= 4);
      this.buffer[o] = t, this.buffer[o + 1] = i, this.buffer[o + 2] = n, this.buffer[o + 3] = r;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(t, i, n, r) {
    if (t & 131072)
      this.pushState(t & 65535, this.pos);
    else if (t & 262144)
      this.pos = r, this.shiftContext(i, n), i <= this.p.parser.maxNode && this.buffer.push(i, n, r, 4);
    else {
      let a = t, { parser: o } = this.p;
      (r > this.pos || i <= o.maxNode) && (this.pos = r, o.stateFlag(
        a,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = r)), this.pushState(a, n), this.shiftContext(i, n), i <= o.maxNode && this.buffer.push(i, n, r, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(t, i, n, r) {
    t & 65536 ? this.reduce(t) : this.shift(t, i, n, r);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(t, i) {
    let n = this.p.reused.length - 1;
    (n < 0 || this.p.reused[n] != t) && (this.p.reused.push(t), n++);
    let r = this.pos;
    this.reducePos = this.pos = r + t.length, this.pushState(i, r), this.buffer.push(
      n,
      r,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, t, this, this.p.stream.reset(this.pos - t.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let t = this, i = t.buffer.length;
    for (; i > 0 && t.buffer[i - 2] > t.reducePos; )
      i -= 4;
    let n = t.buffer.slice(i), r = t.bufferBase + i;
    for (; t && r == t.bufferBase; )
      t = t.parent;
    return new vr(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, n, r, this.curContext, this.lookAhead, t);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(t, i) {
    let n = t <= this.p.parser.maxNode;
    n && this.storeNode(t, this.pos, i, 4), this.storeNode(0, this.pos, i, n ? 8 : 4), this.pos = this.reducePos = i, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(t) {
    for (let i = new HW(this); ; ) {
      let n = this.p.parser.stateSlot(
        i.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(i.state, t);
      if (n == 0)
        return !1;
      if (!(n & 65536))
        return !0;
      i.reduce(n);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(t) {
    if (this.stack.length >= 300)
      return [];
    let i = this.p.parser.nextStates(this.state);
    if (i.length > 8 || this.stack.length >= 120) {
      let r = [];
      for (let a = 0, o; a < i.length; a += 2)
        (o = i[a + 1]) != this.state && this.p.parser.hasAction(o, t) && r.push(i[a], o);
      if (this.stack.length < 120)
        for (let a = 0; r.length < 8 && a < i.length; a += 2) {
          let o = i[a + 1];
          r.some((l, c) => c & 1 && l == o) || r.push(i[a], o);
        }
      i = r;
    }
    let n = [];
    for (let r = 0; r < i.length && n.length < 4; r += 2) {
      let a = i[r + 1];
      if (a == this.state)
        continue;
      let o = this.split();
      o.pushState(a, this.pos), o.storeNode(0, o.pos, o.pos, 4, !0), o.shiftContext(i[r], this.pos), o.reducePos = this.pos, o.score -= 200, n.push(o);
    }
    return n;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: t } = this.p, i = t.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if (!(i & 65536))
      return !1;
    if (!t.validAction(this.state, i)) {
      let n = i >> 19, r = i & 65535, a = this.stack.length - n * 3;
      if (a < 0 || t.getGoto(this.stack[a], r, !1) < 0) {
        let o = this.findForcedReduction();
        if (o == null)
          return !1;
        i = o;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(i), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: t } = this.p, i = [], n = /* @__PURE__ */ m((r, a) => {
      if (!i.includes(r))
        return i.push(r), t.allActions(r, (o) => {
          if (!(o & 393216)) if (o & 65536) {
            let l = (o >> 19) - a;
            if (l > 1) {
              let c = o & 65535, h = this.stack.length - l * 3;
              if (h >= 0 && t.getGoto(this.stack[h], c, !1) >= 0)
                return l << 19 | 65536 | c;
            }
          } else {
            let l = n(o, a + 1);
            if (l != null)
              return l;
          }
        });
    }, "explore");
    return n(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: t } = this.p;
    return t.data[t.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !t.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(t) {
    if (this.state != t.state || this.stack.length != t.stack.length)
      return !1;
    for (let i = 0; i < this.stack.length; i += 3)
      if (this.stack[i] != t.stack[i])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(t) {
    return this.p.parser.dialect.flags[t];
  }
  shiftContext(t, i) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, t, this, this.p.stream.reset(i)));
  }
  reduceContext(t, i) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, t, this, this.p.stream.reset(i)));
  }
  /**
  @internal
  */
  emitContext() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(t) {
    if (t != this.curContext.context) {
      let i = new _P(this.curContext.tracker, t);
      i.hash != this.curContext.hash && this.emitContext(), this.curContext = i;
    }
  }
  /**
  @internal
  */
  setLookAhead(t) {
    t > this.lookAhead && (this.emitLookAhead(), this.lookAhead = t);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}, u(vr, "Ir"), vr);
m(xQ, "Stack");
let FW = xQ;
var nd;
const kQ = (nd = class {
  constructor(t, i) {
    this.tracker = t, this.context = i, this.hash = t.strict ? t.hash(i) : 0;
  }
}, u(nd, "hc"), nd);
m(kQ, "StackContext");
let _P = kQ;
var sd;
const SQ = (sd = class {
  constructor(t) {
    this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
  }
  reduce(t) {
    let i = t & 65535, n = t >> 19;
    n == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (n - 1) * 3;
    let r = this.start.p.parser.getGoto(this.stack[this.base - 3], i, !0);
    this.state = r;
  }
}, u(sd, "fc"), sd);
m(SQ, "SimulatedStack");
let HW = SQ;
var Or;
const PQ = (Or = class {
  constructor(t, i, n) {
    this.stack = t, this.pos = i, this.index = n, this.buffer = t.buffer, this.index == 0 && this.maybeNext();
  }
  static create(t, i = t.bufferBase + t.buffer.length) {
    return new Or(t, i, i - t.bufferBase);
  }
  maybeNext() {
    let t = this.stack.parent;
    t != null && (this.index = this.stack.bufferBase - t.bufferBase, this.stack = t, this.buffer = t.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new Or(this.stack, this.pos, this.index);
  }
}, u(Or, "jr"), Or);
m(PQ, "StackBufferCursor");
let YW = PQ;
function ac(s, t = Uint16Array) {
  if (typeof s != "string")
    return s;
  let i = null;
  for (let n = 0, r = 0; n < s.length; ) {
    let a = 0;
    for (; ; ) {
      let o = s.charCodeAt(n++), l = !1;
      if (o == 126) {
        a = 65535;
        break;
      }
      o >= 92 && o--, o >= 34 && o--;
      let c = o - 32;
      if (c >= 46 && (c -= 46, l = !0), a += c, l)
        break;
      a *= 46;
    }
    i ? i[r++] = a : i = new t(a);
  }
  return i;
}
u(ac, "pr");
m(ac, "decodeArray");
var rd;
const CQ = (rd = class {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}, u(rd, "cc"), rd);
m(CQ, "CachedToken");
let Fw = CQ;
const LP = new Fw();
var ad;
const QQ = (ad = class {
  /**
  @internal
  */
  constructor(t, i) {
    this.input = t, this.ranges = i, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = LP, this.rangeIndex = 0, this.pos = this.chunkPos = i[0].from, this.range = i[0], this.end = i[i.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(t, i) {
    let n = this.range, r = this.rangeIndex, a = this.pos + t;
    for (; a < n.from; ) {
      if (!r)
        return null;
      let o = this.ranges[--r];
      a -= n.from - o.to, n = o;
    }
    for (; i < 0 ? a > n.to : a >= n.to; ) {
      if (r == this.ranges.length - 1)
        return null;
      let o = this.ranges[++r];
      a += o.from - n.to, n = o;
    }
    return a;
  }
  /**
  @internal
  */
  clipPos(t) {
    if (t >= this.range.from && t < this.range.to)
      return t;
    for (let i of this.ranges)
      if (i.to > t)
        return Math.max(t, i.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(t) {
    let i = this.chunkOff + t, n, r;
    if (i >= 0 && i < this.chunk.length)
      n = this.pos + t, r = this.chunk.charCodeAt(i);
    else {
      let a = this.resolveOffset(t, 1);
      if (a == null)
        return -1;
      if (n = a, n >= this.chunk2Pos && n < this.chunk2Pos + this.chunk2.length)
        r = this.chunk2.charCodeAt(n - this.chunk2Pos);
      else {
        let o = this.rangeIndex, l = this.range;
        for (; l.to <= n; )
          l = this.ranges[++o];
        this.chunk2 = this.input.chunk(this.chunk2Pos = n), n + this.chunk2.length > l.to && (this.chunk2 = this.chunk2.slice(0, l.to - n)), r = this.chunk2.charCodeAt(0);
      }
    }
    return n >= this.token.lookAhead && (this.token.lookAhead = n + 1), r;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(t, i = 0) {
    let n = i ? this.resolveOffset(i, -1) : this.pos;
    if (n == null || n < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = t, this.token.end = n;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(t, i) {
    this.token.value = t, this.token.end = i;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: t, chunkPos: i } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = t, this.chunk2Pos = i, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let t = this.input.chunk(this.pos), i = this.pos + t.length;
      this.chunk = i > this.range.to ? t.slice(0, this.range.to - this.pos) : t, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(t = 1) {
    for (this.chunkOff += t; this.pos + t >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      t -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += t, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(t, i) {
    if (i ? (this.token = i, i.start = t, i.lookAhead = t + 1, i.value = i.extended = -1) : this.token = LP, this.pos != t) {
      if (this.pos = t, t == this.end)
        return this.setDone(), this;
      for (; t < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; t >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      t >= this.chunkPos && t < this.chunkPos + this.chunk.length ? this.chunkOff = t - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(t, i) {
    if (t >= this.chunkPos && i <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(t - this.chunkPos, i - this.chunkPos);
    if (t >= this.chunk2Pos && i <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(t - this.chunk2Pos, i - this.chunk2Pos);
    if (t >= this.range.from && i <= this.range.to)
      return this.input.read(t, i);
    let n = "";
    for (let r of this.ranges) {
      if (r.from >= i)
        break;
      r.to > t && (n += this.input.read(Math.max(r.from, t), Math.min(r.to, i)));
    }
    return n;
  }
}, u(ad, "uc"), ad);
m(QQ, "InputStream");
let GW = QQ;
var od;
const TQ = (od = class {
  constructor(t, i) {
    this.data = t, this.id = i;
  }
  token(t, i) {
    let { parser: n } = i.p;
    pk(this.data, t, i, this.id, n.data, n.tokenPrecTable);
  }
}, u(od, "dc"), od);
m(TQ, "TokenGroup");
let fc = TQ;
fc.prototype.contextual = fc.prototype.fallback = fc.prototype.extend = !1;
var ld;
const MQ = (ld = class {
  constructor(t, i, n) {
    this.precTable = i, this.elseToken = n, this.data = typeof t == "string" ? ac(t) : t;
  }
  token(t, i) {
    let n = t.pos, r = 0;
    for (; ; ) {
      let a = t.next < 0, o = t.resolveOffset(1, 1);
      if (pk(this.data, t, i, 0, this.data, this.precTable), t.token.value > -1)
        break;
      if (this.elseToken == null)
        return;
      if (a || r++, o == null)
        break;
      t.reset(o, t.token);
    }
    r && (t.reset(n, t.token), t.acceptToken(this.elseToken, r));
  }
}, u(ld, "Oc"), ld);
m(MQ, "LocalTokenGroup");
let Fg = MQ;
Fg.prototype.contextual = fc.prototype.fallback = fc.prototype.extend = !1;
var cd;
const RQ = (cd = class {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(t, i = {}) {
    this.token = t, this.contextual = !!i.contextual, this.fallback = !!i.fallback, this.extend = !!i.extend;
  }
}, u(cd, "pc"), cd);
m(RQ, "ExternalTokenizer");
let vn = RQ;
function pk(s, t, i, n, r, a) {
  let o = 0, l = 1 << n, { dialect: c } = i.p.parser;
  e: for (; l & s[o]; ) {
    let h = s[o + 1];
    for (let w = o + 3; w < h; w += 2)
      if ((s[w + 1] & l) > 0) {
        let g = s[w];
        if (c.allows(g) && (t.token.value == -1 || t.token.value == g || AQ(g, t.token.value, r, a))) {
          t.acceptToken(g);
          break;
        }
      }
    let d = t.next, f = 0, y = s[o + 2];
    if (t.next < 0 && y > f && s[h + y * 3 - 3] == 65535) {
      o = s[h + y * 3 - 1];
      continue e;
    }
    for (; f < y; ) {
      let w = f + y >> 1, g = h + w + (w << 1), b = s[g], k = s[g + 1] || 65536;
      if (d < b)
        y = w;
      else if (d >= k)
        f = w + 1;
      else {
        o = s[g + 2], t.advance();
        continue e;
      }
    }
    break;
  }
}
u(pk, "Cp$1");
m(pk, "readToken");
function V2(s, t, i) {
  for (let n = t, r; (r = s[n]) != 65535; n++)
    if (r == i)
      return n - t;
  return -1;
}
u(V2, "Ju$1");
m(V2, "findOffset");
function AQ(s, t, i, n) {
  let r = V2(i, n, t);
  return r < 0 || V2(i, n, s) < r;
}
u(AQ, "ey$1");
m(AQ, "overrides");
const ki = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let Jv = null;
function Z2(s, t, i) {
  let n = s.cursor(Ne.IncludeAnonymous);
  for (n.moveTo(t); ; )
    if (!(i < 0 ? n.childBefore(t) : n.childAfter(t)))
      for (; ; ) {
        if ((i < 0 ? n.to < t : n.from > t) && !n.type.isError)
          return i < 0 ? Math.max(0, Math.min(
            n.to - 1,
            t - 25
            /* Lookahead.Margin */
          )) : Math.min(s.length, Math.max(
            n.from + 1,
            t + 25
            /* Lookahead.Margin */
          ));
        if (i < 0 ? n.prevSibling() : n.nextSibling())
          break;
        if (!n.parent())
          return i < 0 ? 0 : s.length;
      }
}
u(Z2, "ed");
m(Z2, "cutAt");
var hd;
const EQ = (hd = class {
  constructor(t, i) {
    this.fragments = t, this.nodeSet = i, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let t = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (t) {
      for (this.safeFrom = t.openStart ? Z2(t.tree, t.from + t.offset, 1) - t.offset : t.from, this.safeTo = t.openEnd ? Z2(t.tree, t.to + t.offset, -1) - t.offset : t.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(t.tree), this.start.push(-t.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(t) {
    if (t < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= t; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let i = this.trees.length - 1;
      if (i < 0)
        return this.nextFragment(), null;
      let n = this.trees[i], r = this.index[i];
      if (r == n.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let a = n.children[r], o = this.start[i] + n.positions[r];
      if (o > t)
        return this.nextStart = o, null;
      if (a instanceof ze) {
        if (o == t) {
          if (o < this.safeFrom)
            return null;
          let l = o + a.length;
          if (l <= this.safeTo) {
            let c = a.prop(Oe.lookAhead);
            if (!c || l + c < this.fragment.to)
              return a;
          }
        }
        this.index[i]++, o + a.length >= Math.max(this.safeFrom, t) && (this.trees.push(a), this.start.push(o), this.index.push(0));
      } else
        this.index[i]++, this.nextStart = o + a.length;
    }
  }
}, u(hd, "mc"), hd);
m(EQ, "FragmentCursor");
let KW = EQ;
var dd;
const zQ = (dd = class {
  constructor(t, i) {
    this.stream = i, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map((n) => new Fw());
  }
  getActions(t) {
    let i = 0, n = null, { parser: r } = t.p, { tokenizers: a } = r, o = r.stateSlot(
      t.state,
      3
      /* ParseState.TokenizerMask */
    ), l = t.curContext ? t.curContext.hash : 0, c = 0;
    for (let h = 0; h < a.length; h++) {
      if (!(1 << h & o))
        continue;
      let d = a[h], f = this.tokens[h];
      if (!(n && !d.fallback) && ((d.contextual || f.start != t.pos || f.mask != o || f.context != l) && (this.updateCachedToken(f, d, t), f.mask = o, f.context = l), f.lookAhead > f.end + 25 && (c = Math.max(f.lookAhead, c)), f.value != 0)) {
        let y = i;
        if (f.extended > -1 && (i = this.addActions(t, f.extended, f.end, i)), i = this.addActions(t, f.value, f.end, i), !d.extend && (n = f, i > y))
          break;
      }
    }
    for (; this.actions.length > i; )
      this.actions.pop();
    return c && t.setLookAhead(c), !n && t.pos == this.stream.end && (n = new Fw(), n.value = t.p.parser.eofTerm, n.start = n.end = t.pos, i = this.addActions(t, n.value, n.end, i)), this.mainToken = n, this.actions;
  }
  getMainToken(t) {
    if (this.mainToken)
      return this.mainToken;
    let i = new Fw(), { pos: n, p: r } = t;
    return i.start = n, i.end = Math.min(n + 1, r.stream.end), i.value = n == r.stream.end ? r.parser.eofTerm : 0, i;
  }
  updateCachedToken(t, i, n) {
    let r = this.stream.clipPos(n.pos);
    if (i.token(this.stream.reset(r, t), n), t.value > -1) {
      let { parser: a } = n.p;
      for (let o = 0; o < a.specialized.length; o++)
        if (a.specialized[o] == t.value) {
          let l = a.specializers[o](this.stream.read(t.start, t.end), n);
          if (l >= 0 && n.p.parser.dialect.allows(l >> 1)) {
            l & 1 ? t.extended = l >> 1 : t.value = l >> 1;
            break;
          }
        }
    } else
      t.value = 0, t.end = this.stream.clipPos(r + 1);
  }
  putAction(t, i, n, r) {
    for (let a = 0; a < r; a += 3)
      if (this.actions[a] == t)
        return r;
    return this.actions[r++] = t, this.actions[r++] = i, this.actions[r++] = n, r;
  }
  addActions(t, i, n, r) {
    let { state: a } = t, { parser: o } = t.p, { data: l } = o;
    for (let c = 0; c < 2; c++)
      for (let h = o.stateSlot(
        a,
        c ? 2 : 1
        /* ParseState.Actions */
      ); ; h += 3) {
        if (l[h] == 65535)
          if (l[h + 1] == 1)
            h = An(l, h + 2);
          else {
            r == 0 && l[h + 1] == 2 && (r = this.putAction(An(l, h + 2), i, n, r));
            break;
          }
        l[h] == i && (r = this.putAction(An(l, h + 1), i, n, r));
      }
    return r;
  }
}, u(dd, "gc"), dd);
m(zQ, "TokenCache");
let JW = zQ;
var ud;
const _Q = (ud = class {
  constructor(t, i, n, r) {
    this.parser = t, this.input = i, this.ranges = r, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new GW(i, r), this.tokens = new JW(t, this.stream), this.topTerm = t.top[1];
    let { from: a } = r[0];
    this.stacks = [FW.start(this, t.top[0], a)], this.fragments = n.length && this.stream.end - a > t.bufferLength * 4 ? new KW(n, t.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let t = this.stacks, i = this.minStackPos, n = this.stacks = [], r, a;
    if (this.bigReductionCount > 300 && t.length == 1) {
      let [o] = t;
      for (; o.forceReduce() && o.stack.length && o.stack[o.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let o = 0; o < t.length; o++) {
      let l = t[o];
      for (; ; ) {
        if (this.tokens.mainToken = null, l.pos > i)
          n.push(l);
        else {
          if (this.advanceStack(l, n, t))
            continue;
          {
            r || (r = [], a = []), r.push(l);
            let c = this.tokens.getMainToken(l);
            a.push(c.value, c.end);
          }
        }
        break;
      }
    }
    if (!n.length) {
      let o = r && ZQ(r);
      if (o)
        return ki && console.log("Finish with " + this.stackID(o)), this.stackToTree(o);
      if (this.parser.strict)
        throw ki && r && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + i);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && r) {
      let o = this.stoppedAt != null && r[0].pos > this.stoppedAt ? r[0] : this.runRecovery(r, a, n);
      if (o)
        return ki && console.log("Force-finish " + this.stackID(o)), this.stackToTree(o.forceAll());
    }
    if (this.recovering) {
      let o = this.recovering == 1 ? 1 : this.recovering * 3;
      if (n.length > o)
        for (n.sort((l, c) => c.score - l.score); n.length > o; )
          n.pop();
      n.some((l) => l.reducePos > i) && this.recovering--;
    } else if (n.length > 1) {
      e: for (let o = 0; o < n.length - 1; o++) {
        let l = n[o];
        for (let c = o + 1; c < n.length; c++) {
          let h = n[c];
          if (l.sameState(h) || l.buffer.length > 500 && h.buffer.length > 500)
            if ((l.score - h.score || l.buffer.length - h.buffer.length) > 0)
              n.splice(c--, 1);
            else {
              n.splice(o--, 1);
              continue e;
            }
        }
      }
      n.length > 12 && n.splice(
        12,
        n.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = n[0].pos;
    for (let o = 1; o < n.length; o++)
      n[o].pos < this.minStackPos && (this.minStackPos = n[o].pos);
    return null;
  }
  stopAt(t) {
    if (this.stoppedAt != null && this.stoppedAt < t)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(t, i, n) {
    let r = t.pos, { parser: a } = this, o = ki ? this.stackID(t) + " -> " : "";
    if (this.stoppedAt != null && r > this.stoppedAt)
      return t.forceReduce() ? t : null;
    if (this.fragments) {
      let h = t.curContext && t.curContext.tracker.strict, d = h ? t.curContext.hash : 0;
      for (let f = this.fragments.nodeAt(r); f; ) {
        let y = this.parser.nodeSet.types[f.type.id] == f.type ? a.getGoto(t.state, f.type.id) : -1;
        if (y > -1 && f.length && (!h || (f.prop(Oe.contextHash) || 0) == d))
          return t.useNode(f, y), ki && console.log(o + this.stackID(t) + ` (via reuse of ${a.getName(f.type.id)})`), !0;
        if (!(f instanceof ze) || f.children.length == 0 || f.positions[0] > 0)
          break;
        let w = f.children[0];
        if (w instanceof ze && f.positions[0] == 0)
          f = w;
        else
          break;
      }
    }
    let l = a.stateSlot(
      t.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (l > 0)
      return t.reduce(l), ki && console.log(o + this.stackID(t) + ` (via always-reduce ${a.getName(
        l & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (t.stack.length >= 8400)
      for (; t.stack.length > 6e3 && t.forceReduce(); )
        ;
    let c = this.tokens.getActions(t);
    for (let h = 0; h < c.length; ) {
      let d = c[h++], f = c[h++], y = c[h++], w = h == c.length || !n, g = w ? t : t.split(), b = this.tokens.mainToken;
      if (g.apply(d, f, b ? b.start : g.pos, y), ki && console.log(o + this.stackID(g) + ` (via ${d & 65536 ? `reduce of ${a.getName(
        d & 65535
        /* Action.ValueMask */
      )}` : "shift"} for ${a.getName(f)} @ ${r}${g == t ? "" : ", split"})`), w)
        return !0;
      g.pos > r ? i.push(g) : n.push(g);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(t, i) {
    let n = t.pos;
    for (; ; ) {
      if (!this.advanceStack(t, null, null))
        return !1;
      if (t.pos > n)
        return D2(t, i), !0;
    }
  }
  runRecovery(t, i, n) {
    let r = null, a = !1;
    for (let o = 0; o < t.length; o++) {
      let l = t[o], c = i[o << 1], h = i[(o << 1) + 1], d = ki ? this.stackID(l) + " -> " : "";
      if (l.deadEnd && (a || (a = !0, l.restart(), ki && console.log(d + this.stackID(l) + " (restarted)"), this.advanceFully(l, n))))
        continue;
      let f = l.split(), y = d;
      for (let w = 0; f.forceReduce() && w < 10 && (ki && console.log(y + this.stackID(f) + " (via force-reduce)"), !this.advanceFully(f, n)); w++)
        ki && (y = this.stackID(f) + " -> ");
      for (let w of l.recoverByInsert(c))
        ki && console.log(d + this.stackID(w) + " (via recover-insert)"), this.advanceFully(w, n);
      this.stream.end > l.pos ? (h == l.pos && (h++, c = 0), l.recoverByDelete(c, h), ki && console.log(d + this.stackID(l) + ` (via recover-delete ${this.parser.getName(c)})`), D2(l, n)) : (!r || r.score < l.score) && (r = l);
    }
    return r;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(t) {
    return t.close(), ze.build({
      buffer: YW.create(t),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: t.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(t) {
    let i = (Jv || (Jv = /* @__PURE__ */ new WeakMap())).get(t);
    return i || Jv.set(t, i = String.fromCodePoint(this.nextStackID++)), i + t;
  }
}, u(ud, "bc"), ud);
m(_Q, "Parse");
let eV = _Q;
function D2(s, t) {
  for (let i = 0; i < t.length; i++) {
    let n = t[i];
    if (n.pos == s.pos && n.sameState(s)) {
      t[i].score < s.score && (t[i] = s);
      return;
    }
  }
  t.push(s);
}
u(D2, "td");
m(D2, "pushStackDedup");
var pd;
const LQ = (pd = class {
  constructor(t, i, n) {
    this.source = t, this.flags = i, this.disabled = n;
  }
  allows(t) {
    return !this.disabled || this.disabled[t] == 0;
  }
}, u(pd, "yc"), pd);
m(LQ, "Dialect");
let tV = LQ;
const eO = /* @__PURE__ */ m((s) => s, "id");
var fd;
const IQ = (fd = class {
  /**
  Define a context tracker.
  */
  constructor(t) {
    this.start = t.start, this.shift = t.shift || eO, this.reduce = t.reduce || eO, this.reuse = t.reuse || eO, this.hash = t.hash || (() => 0), this.strict = t.strict !== !1;
  }
}, u(fd, "Sc"), fd);
m(IQ, "ContextTracker");
let WQ = IQ;
var br;
const VQ = (br = class extends N1 {
  /**
  @internal
  */
  constructor(t) {
    if (super(), this.wrappers = [], t.version != 14)
      throw new RangeError(`Parser version (${t.version}) doesn't match runtime version (14)`);
    let i = t.nodeNames.split(" ");
    this.minRepeatTerm = i.length;
    for (let l = 0; l < t.repeatNodeCount; l++)
      i.push("");
    let n = Object.keys(t.topRules).map((l) => t.topRules[l][1]), r = [];
    for (let l = 0; l < i.length; l++)
      r.push([]);
    function a(l, c, h) {
      r[l].push([c, c.deserialize(String(h))]);
    }
    if (u(a, "s"), m(a, "setProp"), t.nodeProps)
      for (let l of t.nodeProps) {
        let c = l[0];
        typeof c == "string" && (c = Oe[c]);
        for (let h = 1; h < l.length; ) {
          let d = l[h++];
          if (d >= 0)
            a(d, c, l[h++]);
          else {
            let f = l[h + -d];
            for (let y = -d; y > 0; y--)
              a(l[h++], c, f);
            h++;
          }
        }
      }
    this.nodeSet = new D1(i.map((l, c) => Et.define({
      name: c >= this.minRepeatTerm ? void 0 : l,
      id: c,
      props: r[c],
      top: n.indexOf(c) > -1,
      error: c == 0,
      skipped: t.skippedNodes && t.skippedNodes.indexOf(c) > -1
    }))), t.propSources && (this.nodeSet = this.nodeSet.extend(...t.propSources)), this.strict = !1, this.bufferLength = e8;
    let o = ac(t.tokenData);
    this.context = t.context, this.specializerSpecs = t.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let l = 0; l < this.specializerSpecs.length; l++)
      this.specialized[l] = this.specializerSpecs[l].term;
    this.specializers = this.specializerSpecs.map(q2), this.states = ac(t.states, Uint32Array), this.data = ac(t.stateData), this.goto = ac(t.goto), this.maxTerm = t.maxTerm, this.tokenizers = t.tokenizers.map((l) => typeof l == "number" ? new fc(o, l) : l), this.topRules = t.topRules, this.dialects = t.dialects || {}, this.dynamicPrecedences = t.dynamicPrecedences || null, this.tokenPrecTable = t.tokenPrec, this.termNames = t.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(t, i, n) {
    let r = new eV(this, t, i, n);
    for (let a of this.wrappers)
      r = a(r, t, i, n);
    return r;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(t, i, n = !1) {
    let r = this.goto;
    if (i >= r[0])
      return -1;
    for (let a = r[i + 1]; ; ) {
      let o = r[a++], l = o & 1, c = r[a++];
      if (l && n)
        return c;
      for (let h = a + (o >> 1); a < h; a++)
        if (r[a] == t)
          return c;
      if (l)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(t, i) {
    let n = this.data;
    for (let r = 0; r < 2; r++)
      for (let a = this.stateSlot(
        t,
        r ? 2 : 1
        /* ParseState.Actions */
      ), o; ; a += 3) {
        if ((o = n[a]) == 65535)
          if (n[a + 1] == 1)
            o = n[a = An(n, a + 2)];
          else {
            if (n[a + 1] == 2)
              return An(n, a + 2);
            break;
          }
        if (o == i || o == 0)
          return An(n, a + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(t, i) {
    return this.states[t * 6 + i];
  }
  /**
  @internal
  */
  stateFlag(t, i) {
    return (this.stateSlot(
      t,
      0
      /* ParseState.Flags */
    ) & i) > 0;
  }
  /**
  @internal
  */
  validAction(t, i) {
    return !!this.allActions(t, (n) => n == i ? !0 : null);
  }
  /**
  @internal
  */
  allActions(t, i) {
    let n = this.stateSlot(
      t,
      4
      /* ParseState.DefaultReduce */
    ), r = n ? i(n) : void 0;
    for (let a = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); r == null; a += 3) {
      if (this.data[a] == 65535)
        if (this.data[a + 1] == 1)
          a = An(this.data, a + 2);
        else
          break;
      r = i(An(this.data, a + 1));
    }
    return r;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(t) {
    let i = [];
    for (let n = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); ; n += 3) {
      if (this.data[n] == 65535)
        if (this.data[n + 1] == 1)
          n = An(this.data, n + 2);
        else
          break;
      if (!(this.data[n + 2] & 1)) {
        let r = this.data[n + 1];
        i.some((a, o) => o & 1 && a == r) || i.push(this.data[n], r);
      }
    }
    return i;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(t) {
    let i = Object.assign(Object.create(br.prototype), this);
    if (t.props && (i.nodeSet = this.nodeSet.extend(...t.props)), t.top) {
      let n = this.topRules[t.top];
      if (!n)
        throw new RangeError(`Invalid top rule name ${t.top}`);
      i.top = n;
    }
    return t.tokenizers && (i.tokenizers = this.tokenizers.map((n) => {
      let r = t.tokenizers.find((a) => a.from == n);
      return r ? r.to : n;
    })), t.specializers && (i.specializers = this.specializers.slice(), i.specializerSpecs = this.specializerSpecs.map((n, r) => {
      let a = t.specializers.find((l) => l.from == n.external);
      if (!a)
        return n;
      let o = Object.assign(Object.assign({}, n), { external: a.to });
      return i.specializers[r] = q2(o), o;
    })), t.contextTracker && (i.context = t.contextTracker), t.dialect && (i.dialect = this.parseDialect(t.dialect)), t.strict != null && (i.strict = t.strict), t.wrap && (i.wrappers = i.wrappers.concat(t.wrap)), t.bufferLength != null && (i.bufferLength = t.bufferLength), i;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(t) {
    return this.termNames ? this.termNames[t] : String(t <= this.maxNode && this.nodeSet.types[t].name || t);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(t) {
    let i = this.dynamicPrecedences;
    return i == null ? 0 : i[t] || 0;
  }
  /**
  @internal
  */
  parseDialect(t) {
    let i = Object.keys(this.dialects), n = i.map(() => !1);
    if (t)
      for (let a of t.split(" ")) {
        let o = i.indexOf(a);
        o >= 0 && (n[o] = !0);
      }
    let r = null;
    for (let a = 0; a < i.length; a++)
      if (!n[a])
        for (let o = this.dialects[i[a]], l; (l = this.data[o++]) != 65535; )
          (r || (r = new Uint8Array(this.maxTerm + 1)))[l] = 1;
    return new tV(t, n, r);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(t) {
    return new br(t);
  }
}, u(br, "qr"), br);
m(VQ, "LRParser");
let fk = VQ;
function An(s, t) {
  return s[t] | s[t + 1] << 16;
}
u(An, "lt$2");
m(An, "pair");
function ZQ(s) {
  let t = null;
  for (let i of s) {
    let n = i.p.stoppedAt;
    (i.pos == i.p.stream.end || n != null && i.pos > n) && i.p.parser.stateFlag(
      i.state,
      2
      /* StateFlag.Accepting */
    ) && (!t || t.score < i.score) && (t = i);
  }
  return t;
}
u(ZQ, "ty$1");
m(ZQ, "findFinished");
function q2(s) {
  if (s.external) {
    let t = s.extend ? 1 : 0;
    return (i, n) => s.external(i, n) << 1 | t;
  }
  return s.get;
}
u(q2, "id");
m(q2, "getSpecializer");
const iV = 54, nV = 1, sV = 55, rV = 2, aV = 56, oV = 3, IP = 4, lV = 5, Hg = 6, DQ = 7, qQ = 8, UQ = 9, NQ = 10, cV = 11, hV = 12, dV = 13, tO = 57, uV = 14, WP = 58, BQ = 20, pV = 22, jQ = 23, fV = 24, U2 = 26, XQ = 27, yV = 28, mV = 31, wV = 34, gV = 36, vV = 37, OV = 0, bV = 1, $V = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  command: !0,
  embed: !0,
  frame: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0,
  menuitem: !0
}, xV = {
  dd: !0,
  li: !0,
  optgroup: !0,
  option: !0,
  p: !0,
  rp: !0,
  rt: !0,
  tbody: !0,
  td: !0,
  tfoot: !0,
  th: !0,
  tr: !0
}, VP = {
  dd: { dd: !0, dt: !0 },
  dt: { dd: !0, dt: !0 },
  li: { li: !0 },
  option: { option: !0, optgroup: !0 },
  optgroup: { optgroup: !0 },
  p: {
    address: !0,
    article: !0,
    aside: !0,
    blockquote: !0,
    dir: !0,
    div: !0,
    dl: !0,
    fieldset: !0,
    footer: !0,
    form: !0,
    h1: !0,
    h2: !0,
    h3: !0,
    h4: !0,
    h5: !0,
    h6: !0,
    header: !0,
    hgroup: !0,
    hr: !0,
    menu: !0,
    nav: !0,
    ol: !0,
    p: !0,
    pre: !0,
    section: !0,
    table: !0,
    ul: !0
  },
  rp: { rp: !0, rt: !0 },
  rt: { rp: !0, rt: !0 },
  tbody: { tbody: !0, tfoot: !0 },
  td: { td: !0, th: !0 },
  tfoot: { tbody: !0 },
  th: { td: !0, th: !0 },
  thead: { tbody: !0, tfoot: !0 },
  tr: { tr: !0 }
};
function FQ(s) {
  return s == 45 || s == 46 || s == 58 || s >= 65 && s <= 90 || s == 95 || s >= 97 && s <= 122 || s >= 161;
}
u(FQ, "Qy$1");
m(FQ, "nameChar");
function yk(s) {
  return s == 9 || s == 10 || s == 13 || s == 32;
}
u(yk, "Dp$1");
m(yk, "isSpace");
let ZP = null, DP = null, qP = 0;
function Yg(s, t) {
  let i = s.pos + t;
  if (qP == i && DP == s) return ZP;
  let n = s.peek(t);
  for (; yk(n); ) n = s.peek(++t);
  let r = "";
  for (; FQ(n); )
    r += String.fromCharCode(n), n = s.peek(++t);
  return DP = s, qP = i, ZP = r ? r.toLowerCase() : n == kV || n == SV ? void 0 : null;
}
u(Yg, "Va$1");
m(Yg, "tagNameAfter");
const HQ = 60, Gg = 62, mk = 47, kV = 63, SV = 33, PV = 45;
function N2(s, t) {
  this.name = s, this.parent = t;
}
u(N2, "hd");
m(N2, "ElementContext");
const CV = [Hg, NQ, DQ, qQ, UQ], QV = new WQ({
  start: null,
  shift(s, t, i, n) {
    return CV.indexOf(t) > -1 ? new N2(Yg(n, 1) || "", s) : s;
  },
  reduce(s, t) {
    return t == BQ && s ? s.parent : s;
  },
  reuse(s, t, i, n) {
    let r = t.type.id;
    return r == Hg || r == gV ? new N2(Yg(n, 1) || "", s) : s;
  },
  strict: !1
}), TV = new vn((s, t) => {
  if (s.next != HQ) {
    s.next < 0 && t.context && s.acceptToken(tO);
    return;
  }
  s.advance();
  let i = s.next == mk;
  i && s.advance();
  let n = Yg(s, 0);
  if (n === void 0) return;
  if (!n) return s.acceptToken(i ? uV : Hg);
  let r = t.context ? t.context.name : null;
  if (i) {
    if (n == r) return s.acceptToken(cV);
    if (r && xV[r]) return s.acceptToken(tO, -2);
    if (t.dialectEnabled(OV)) return s.acceptToken(hV);
    for (let a = t.context; a; a = a.parent) if (a.name == n) return;
    s.acceptToken(dV);
  } else {
    if (n == "script") return s.acceptToken(DQ);
    if (n == "style") return s.acceptToken(qQ);
    if (n == "textarea") return s.acceptToken(UQ);
    if ($V.hasOwnProperty(n)) return s.acceptToken(NQ);
    r && VP[r] && VP[r][n] ? s.acceptToken(tO, -1) : s.acceptToken(Hg);
  }
}, { contextual: !0 }), MV = new vn((s) => {
  for (let t = 0, i = 0; ; i++) {
    if (s.next < 0) {
      i && s.acceptToken(WP);
      break;
    }
    if (s.next == PV)
      t++;
    else if (s.next == Gg && t >= 2) {
      i >= 3 && s.acceptToken(WP, -2);
      break;
    } else
      t = 0;
    s.advance();
  }
});
function YQ(s) {
  for (; s; s = s.parent)
    if (s.name == "svg" || s.name == "math") return !0;
  return !1;
}
u(YQ, "Wy$1");
m(YQ, "inForeignElement");
const RV = new vn((s, t) => {
  if (s.next == mk && s.peek(1) == Gg) {
    let i = t.dialectEnabled(bV) || YQ(t.context);
    s.acceptToken(i ? lV : IP, 2);
  } else s.next == Gg && s.acceptToken(IP, 1);
});
function J1(s, t, i) {
  let n = 2 + s.length;
  return new vn((r) => {
    for (let a = 0, o = 0, l = 0; ; l++) {
      if (r.next < 0) {
        l && r.acceptToken(t);
        break;
      }
      if (a == 0 && r.next == HQ || a == 1 && r.next == mk || a >= 2 && a < n && r.next == s.charCodeAt(a - 2))
        a++, o++;
      else if ((a == 2 || a == n) && yk(r.next))
        o++;
      else if (a == n && r.next == Gg) {
        l > o ? r.acceptToken(t, -o) : r.acceptToken(i, -(o - 2));
        break;
      } else if ((r.next == 10 || r.next == 13) && l) {
        r.acceptToken(t, 1);
        break;
      } else
        a = o = 0;
      r.advance();
    }
  });
}
u(J1, "bh$1");
m(J1, "contentTokenizer");
const AV = J1("script", iV, nV), EV = J1("style", sV, rV), zV = J1("textarea", aV, oV), _V = Io({
  "Text RawText": Q.content,
  "StartTag StartCloseTag SelfClosingEndTag EndTag": Q.angleBracket,
  TagName: Q.tagName,
  "MismatchedCloseTag/TagName": [Q.tagName, Q.invalid],
  AttributeName: Q.attributeName,
  "AttributeValue UnquotedAttributeValue": Q.attributeValue,
  Is: Q.definitionOperator,
  "EntityReference CharacterReference": Q.character,
  Comment: Q.blockComment,
  ProcessingInst: Q.processingInstruction,
  DoctypeDecl: Q.documentMeta
}), LV = fk.deserialize({
  version: 14,
  states: ",xOVO!rOOO!WQ#tO'#CqO!]Q#tO'#CzO!bQ#tO'#C}O!gQ#tO'#DQO!lQ#tO'#DSO!qOaO'#CpO!|ObO'#CpO#XOdO'#CpO$eO!rO'#CpOOO`'#Cp'#CpO$lO$fO'#DTO$tQ#tO'#DVO$yQ#tO'#DWOOO`'#Dk'#DkOOO`'#DY'#DYQVO!rOOO%OQ&rO,59]O%ZQ&rO,59fO%fQ&rO,59iO%qQ&rO,59lO%|Q&rO,59nOOOa'#D^'#D^O&XOaO'#CxO&dOaO,59[OOOb'#D_'#D_O&lObO'#C{O&wObO,59[OOOd'#D`'#D`O'POdO'#DOO'[OdO,59[OOO`'#Da'#DaO'dO!rO,59[O'kQ#tO'#DROOO`,59[,59[OOOp'#Db'#DbO'pO$fO,59oOOO`,59o,59oO'xQ#|O,59qO'}Q#|O,59rOOO`-E7W-E7WO(SQ&rO'#CsOOQW'#DZ'#DZO(bQ&rO1G.wOOOa1G.w1G.wOOO`1G/Y1G/YO(mQ&rO1G/QOOOb1G/Q1G/QO(xQ&rO1G/TOOOd1G/T1G/TO)TQ&rO1G/WOOO`1G/W1G/WO)`Q&rO1G/YOOOa-E7[-E7[O)kQ#tO'#CyOOO`1G.v1G.vOOOb-E7]-E7]O)pQ#tO'#C|OOOd-E7^-E7^O)uQ#tO'#DPOOO`-E7_-E7_O)zQ#|O,59mOOOp-E7`-E7`OOO`1G/Z1G/ZOOO`1G/]1G/]OOO`1G/^1G/^O*PQ,UO,59_OOQW-E7X-E7XOOOa7+$c7+$cOOO`7+$t7+$tOOOb7+$l7+$lOOOd7+$o7+$oOOO`7+$r7+$rO*[Q#|O,59eO*aQ#|O,59hO*fQ#|O,59kOOO`1G/X1G/XO*kO7[O'#CvO*|OMhO'#CvOOQW1G.y1G.yOOO`1G/P1G/POOO`1G/S1G/SOOO`1G/V1G/VOOOO'#D['#D[O+_O7[O,59bOOQW,59b,59bOOOO'#D]'#D]O+pOMhO,59bOOOO-E7Y-E7YOOQW1G.|1G.|OOOO-E7Z-E7Z",
  stateData: ",]~O!^OS~OUSOVPOWQOXROYTO[]O][O^^O`^Oa^Ob^Oc^Ox^O{_O!dZO~OfaO~OfbO~OfcO~OfdO~OfeO~O!WfOPlP!ZlP~O!XiOQoP!ZoP~O!YlORrP!ZrP~OUSOVPOWQOXROYTOZqO[]O][O^^O`^Oa^Ob^Oc^Ox^O!dZO~O!ZrO~P#dO![sO!euO~OfvO~OfwO~OS|OT}OhyO~OS!POT}OhyO~OS!ROT}OhyO~OS!TOT}OhyO~OS}OT}OhyO~O!WfOPlX!ZlX~OP!WO!Z!XO~O!XiOQoX!ZoX~OQ!ZO!Z!XO~O!YlORrX!ZrX~OR!]O!Z!XO~O!Z!XO~P#dOf!_O~O![sO!e!aO~OS!bO~OS!cO~Oi!dOSgXTgXhgX~OS!fOT!gOhyO~OS!hOT!gOhyO~OS!iOT!gOhyO~OS!jOT!gOhyO~OS!gOT!gOhyO~Of!kO~Of!lO~Of!mO~OS!nO~Ok!qO!`!oO!b!pO~OS!rO~OS!sO~OS!tO~Oa!uOb!uOc!uO!`!wO!a!uO~Oa!xOb!xOc!xO!b!wO!c!xO~Oa!uOb!uOc!uO!`!{O!a!uO~Oa!xOb!xOc!xO!b!{O!c!xO~OT~bac!dx{!d~",
  goto: "%p!`PPPPPPPPPPPPPPPPPPPP!a!gP!mPP!yP!|#P#S#Y#]#`#f#i#l#r#x!aP!a!aP$O$U$l$r$x%O%U%[%bPPPPPPPP%hX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
  nodeNames: "⚠ StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
  maxTerm: 67,
  context: QV,
  nodeProps: [
    ["closedBy", -10, 1, 2, 3, 7, 8, 9, 10, 11, 12, 13, "EndTag", 6, "EndTag SelfClosingEndTag", -4, 21, 30, 33, 36, "CloseTag"],
    ["openedBy", 4, "StartTag StartCloseTag", 5, "StartTag", -4, 29, 32, 35, 37, "OpenTag"],
    ["group", -9, 14, 17, 18, 19, 20, 39, 40, 41, 42, "Entity", 16, "Entity TextContent", -3, 28, 31, 34, "TextContent Entity"],
    ["isolate", -11, 21, 29, 30, 32, 33, 35, 36, 37, 38, 41, 42, "ltr", -3, 26, 27, 39, ""]
  ],
  propSources: [_V],
  skippedNodes: [0],
  repeatNodeCount: 9,
  tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|c`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bX`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UV`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pT`POv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!cpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({W`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!a`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!a`!cpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYkWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]``P!a`!cp!^^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebhSkWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXhSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vchS`P!a`!cpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!`h`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WihSkWc!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zbkWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOa!R!R7tP;=`<%l7S!Z8OYkWa!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{ihSkWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbhSkWa!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QchSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXhSa!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TakWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOb!R!RAwP;=`<%lAY!ZBRYkWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbhSkWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbhSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXhSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!bx`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYlhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_khS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_X`P!a`!cp!eQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZhSfQ`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!a`!cpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!a`!cp!dPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!a`!cpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!a`!cpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!a`!cpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!a`!cpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!a`!cpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!a`!cpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!a`!cpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!cpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO{PP!-nP;=`<%l!-Sq!-xS!cp{POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!a`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!a`{POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!a`!cp{POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!a`!cpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!a`!cpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!a`!cpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!a`!cpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!a`!cpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!a`!cpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!cpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOxPP!7TP;=`<%l!6Vq!7]V!cpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!cpxPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!a`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!a`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!a`xPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!a`!cpxPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXiS`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
  tokenizers: [AV, EV, zV, RV, TV, MV, 0, 1, 2, 3, 4, 5],
  topRules: { Document: [0, 15] },
  dialects: { noMatch: 0, selfClosing: 509 },
  tokenPrec: 511
});
function wk(s, t) {
  let i = /* @__PURE__ */ Object.create(null);
  for (let n of s.getChildren(jQ)) {
    let r = n.getChild(fV), a = n.getChild(U2) || n.getChild(XQ);
    r && (i[t.read(r.from, r.to)] = a ? a.type.id == U2 ? t.read(a.from + 1, a.to - 1) : t.read(a.from, a.to) : "");
  }
  return i;
}
u(wk, "Np$1");
m(wk, "getAttrs");
function B2(s, t) {
  let i = s.getChild(pV);
  return i ? t.read(i.from, i.to) : " ";
}
u(B2, "fd");
m(B2, "findTagName");
function Hw(s, t, i) {
  let n;
  for (let r of i)
    if (!r.attrs || r.attrs(n || (n = wk(s.node.parent.firstChild, t))))
      return { parser: r.parser };
  return null;
}
u(Hw, "Vo$1");
m(Hw, "maybeNest");
function gk(s = [], t = []) {
  let i = [], n = [], r = [], a = [];
  for (let l of s)
    (l.tag == "script" ? i : l.tag == "style" ? n : l.tag == "textarea" ? r : a).push(l);
  let o = t.length ? /* @__PURE__ */ Object.create(null) : null;
  for (let l of t) (o[l.name] || (o[l.name] = [])).push(l);
  return Lx((l, c) => {
    let h = l.type.id;
    if (h == yV) return Hw(l, c, i);
    if (h == mV) return Hw(l, c, n);
    if (h == wV) return Hw(l, c, r);
    if (h == BQ && a.length) {
      let d = l.node, f = d.firstChild, y = f && B2(f, c), w;
      if (y) {
        for (let g of a)
          if (g.tag == y && (!g.attrs || g.attrs(w || (w = wk(f, c))))) {
            let b = d.lastChild, k = b.type.id == vV ? b.from : d.to;
            if (k > f.to)
              return { parser: g.parser, overlay: [{ from: f.to, to: k }] };
          }
      }
    }
    if (o && h == jQ) {
      let d = l.node, f;
      if (f = d.firstChild) {
        let y = o[c.read(f.from, f.to)];
        if (y) for (let w of y) {
          if (w.tagName && w.tagName != B2(d.parent, c)) continue;
          let g = d.lastChild;
          if (g.type.id == U2) {
            let b = g.from + 1, k = g.lastChild, $ = g.to - (k && k.isError ? 0 : 1);
            if ($ > b) return { parser: w.parser, overlay: [{ from: b, to: $ }] };
          } else if (g.type.id == XQ)
            return { parser: w.parser, overlay: [{ from: g.from, to: g.to }] };
        }
      }
    }
    return null;
  });
}
u(gk, "Gp$1");
m(gk, "configureNesting");
const IV = 99, UP = 1, WV = 100, VV = 101, NP = 2, GQ = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], ZV = 58, DV = 40, KQ = 95, qV = 91, Yw = 45, UV = 46, NV = 35, BV = 37, jV = 38, XV = 92, FV = 10;
function pf(s) {
  return s >= 65 && s <= 90 || s >= 97 && s <= 122 || s >= 161;
}
u(pf, "dn$1");
m(pf, "isAlpha");
function vk(s) {
  return s >= 48 && s <= 57;
}
u(vk, "Kp$1");
m(vk, "isDigit");
const HV = new vn((s, t) => {
  for (let i = !1, n = 0, r = 0; ; r++) {
    let { next: a } = s;
    if (pf(a) || a == Yw || a == KQ || i && vk(a))
      !i && (a != Yw || r > 0) && (i = !0), n === r && a == Yw && n++, s.advance();
    else if (a == XV && s.peek(1) != FV)
      s.advance(), s.next > -1 && s.advance(), i = !0;
    else {
      i && s.acceptToken(a == DV ? WV : n == 2 && t.canShift(NP) ? NP : VV);
      break;
    }
  }
}), YV = new vn((s) => {
  if (GQ.includes(s.peek(-1))) {
    let { next: t } = s;
    (pf(t) || t == KQ || t == NV || t == UV || t == qV || t == ZV && pf(s.peek(1)) || t == Yw || t == jV) && s.acceptToken(IV);
  }
}), GV = new vn((s) => {
  if (!GQ.includes(s.peek(-1))) {
    let { next: t } = s;
    if (t == BV && (s.advance(), s.acceptToken(UP)), pf(t)) {
      do
        s.advance();
      while (pf(s.next) || vk(s.next));
      s.acceptToken(UP);
    }
  }
}), KV = Io({
  "AtKeyword import charset namespace keyframes media supports": Q.definitionKeyword,
  "from to selector": Q.keyword,
  NamespaceName: Q.namespace,
  KeyframeName: Q.labelName,
  KeyframeRangeName: Q.operatorKeyword,
  TagName: Q.tagName,
  ClassName: Q.className,
  PseudoClassName: Q.constant(Q.className),
  IdName: Q.labelName,
  "FeatureName PropertyName": Q.propertyName,
  AttributeName: Q.attributeName,
  NumberLiteral: Q.number,
  KeywordQuery: Q.keyword,
  UnaryQueryOp: Q.operatorKeyword,
  "CallTag ValueName": Q.atom,
  VariableName: Q.variableName,
  Callee: Q.operatorKeyword,
  Unit: Q.unit,
  "UniversalSelector NestingSelector": Q.definitionOperator,
  MatchOp: Q.compareOperator,
  "ChildOp SiblingOp, LogicOp": Q.logicOperator,
  BinOp: Q.arithmeticOperator,
  Important: Q.modifier,
  Comment: Q.blockComment,
  ColorLiteral: Q.color,
  "ParenthesizedContent StringLiteral": Q.string,
  ":": Q.punctuation,
  "PseudoOp #": Q.derefOperator,
  "; ,": Q.separator,
  "( )": Q.paren,
  "[ ]": Q.squareBracket,
  "{ }": Q.brace
}), JV = { __proto__: null, lang: 32, "nth-child": 32, "nth-last-child": 32, "nth-of-type": 32, "nth-last-of-type": 32, dir: 32, "host-context": 32, url: 60, "url-prefix": 60, domain: 60, regexp: 60, selector: 138 }, eZ = { __proto__: null, "@import": 118, "@media": 142, "@charset": 146, "@namespace": 150, "@keyframes": 156, "@supports": 168 }, tZ = { __proto__: null, not: 132, only: 132 }, iZ = fk.deserialize({
  version: 14,
  states: ":^QYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DTO$vQ[O'#DWOOQP'#Em'#EmO${QdO'#DgO%jQ[O'#DtO${QdO'#DvO%{Q[O'#DxO&WQ[O'#D{O&`Q[O'#ERO&nQ[O'#ETOOQS'#El'#ElOOQS'#EW'#EWQYQ[OOO&uQXO'#CdO'jQWO'#DcO'oQWO'#EsO'zQ[O'#EsQOQWOOP(UO#tO'#C_POOO)C@[)C@[OOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(aQ[O'#E[O({QWO,58{O)TQ[O,59SO$qQ[O,59oO$vQ[O,59rO(aQ[O,59uO(aQ[O,59wO(aQ[O,59xO)`Q[O'#DbOOQS,58{,58{OOQP'#Ck'#CkOOQO'#DR'#DROOQP,59S,59SO)gQWO,59SO)lQWO,59SOOQP'#DV'#DVOOQP,59o,59oOOQO'#DX'#DXO)qQ`O,59rOOQS'#Cp'#CpO${QdO'#CqO)yQvO'#CsO+ZQtO,5:ROOQO'#Cx'#CxO)lQWO'#CwO+oQWO'#CyO+tQ[O'#DOOOQS'#Ep'#EpOOQO'#Dj'#DjO+|Q[O'#DqO,[QWO'#EtO&`Q[O'#DoO,jQWO'#DrOOQO'#Eu'#EuO)OQWO,5:`O,oQpO,5:bOOQS'#Dz'#DzO,wQWO,5:dO,|Q[O,5:dOOQO'#D}'#D}O-UQWO,5:gO-ZQWO,5:mO-cQWO,5:oOOQS-E8U-E8UO${QdO,59}O-kQ[O'#E^O-xQWO,5;_O-xQWO,5;_POOO'#EV'#EVP.TO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO.zQXO,5:vOOQO-E8Y-E8YOOQS1G.g1G.gOOQP1G.n1G.nO)gQWO1G.nO)lQWO1G.nOOQP1G/Z1G/ZO/XQ`O1G/^O/rQXO1G/aO0YQXO1G/cO0pQXO1G/dO1WQWO,59|O1]Q[O'#DSO1dQdO'#CoOOQP1G/^1G/^O${QdO1G/^O1kQpO,59]OOQS,59_,59_O${QdO,59aO1sQWO1G/mOOQS,59c,59cO1xQ!bO,59eOOQS'#DP'#DPOOQS'#EY'#EYO2QQ[O,59jOOQS,59j,59jO2YQWO'#DjO2eQWO,5:VO2jQWO,5:]O&`Q[O,5:XO&`Q[O'#E_O2rQWO,5;`O2}QWO,5:ZO(aQ[O,5:^OOQS1G/z1G/zOOQS1G/|1G/|OOQS1G0O1G0OO3`QWO1G0OO3eQdO'#EOOOQS1G0R1G0ROOQS1G0X1G0XOOQS1G0Z1G0ZO3pQtO1G/iOOQO,5:x,5:xO4WQ[O,5:xOOQO-E8[-E8[O4eQWO1G0yPOOO-E8T-E8TPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$x7+$xO${QdO7+$xOOQS1G/h1G/hO4pQXO'#ErO4wQWO,59nO4|QtO'#EXO5tQdO'#EoO6OQWO,59ZO6TQpO7+$xOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%X7+%XO6]QWO1G/POOQS-E8W-E8WOOQS1G/U1G/UO${QdO1G/qOOQO1G/w1G/wOOQO1G/s1G/sO6bQWO,5:yOOQO-E8]-E8]O6pQXO1G/xOOQS7+%j7+%jO6wQYO'#CsOOQO'#EQ'#EQO7SQ`O'#EPOOQO'#EP'#EPO7_QWO'#E`O7gQdO,5:jOOQS,5:j,5:jO7rQtO'#E]O${QdO'#E]O8sQdO7+%TOOQO7+%T7+%TOOQO1G0d1G0dO9WQpO<<HdO9`QWO,5;^OOQP1G/Y1G/YOOQS-E8V-E8VO${QdO'#EZO9hQWO,5;ZOOQT1G.u1G.uOOQP<<Hd<<HdOOQS7+$k7+$kO9pQdO7+%]OOQO7+%d7+%dOOQO,5:k,5:kO3hQdO'#EaO7_QWO,5:zOOQS,5:z,5:zOOQS-E8^-E8^OOQS1G0U1G0UO9wQtO,5:wOOQS-E8Z-E8ZOOQO<<Ho<<HoOOQPAN>OAN>OO:xQdO,5:uOOQO-E8X-E8XOOQO<<Hw<<HwOOQO,5:{,5:{OOQO-E8_-E8_OOQS1G0f1G0f",
  stateData: ";[~O#ZOS#[QQ~OUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XRO#bTO~OQfOUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XeO#bTO~O#U#gP~P!ZO#[jO~O#XlO~O]qO^qOqsOtoOxrO!OtO!RvO#VuO#bnO~O!TwO~P#pO`}O#WzO#XyO~O#X!OO~O#X!QO~OQ![Ob!TOf![Oh![On!YOq!ZO#W!WO#X!SO#e!UO~Ob!^O!d!`O!g!aO#X!]O!T#hP~Oh!fOn!YO#X!eO~Oh!hO#X!hO~Ob!^O!d!`O!g!aO#X!]O~O!Y#hP~P%jO]WX]!WX^WXqWXtWXxWX!OWX!RWX!TWX#VWX#bWX~O]!mO~O!Y!nO#U#gX!S#gX~O#U#gX!S#gX~P!ZO#]!qO#^!qO#_!sO~OUYOXYO]VO^VOqXOxWO#XRO#bTO~OtoO!TwO~O`!zO#WzO#XyO~O!S#gP~P!ZOb#RO~Ob#SO~Op#TO|#UO~OP#WObgXjgX!YgX!dgX!ggX#XgXagXQgXfgXhgXngXqgXtgX!XgX#UgX#WgX#egXpgX!SgX~Ob!^Oj#XO!d!`O!g!aO#X!]O!Y#hP~Ob#[O~Op#`O#X#]O~Ob!^O!d!`O!g!aO#X#aO~Ot#eO!b#dO!T#hX!Y#hX~Ob#hO~Oj#XO!Y#jO~O!Y#kO~Oh#lOn!YO~O!T#mO~O!TwO!b#dO~O!TwO!Y#pO~O!Y#QX#U#QX!S#QX~P!ZO!Y!nO#U#ga!S#ga~O#]!qO#^!qO#_#wO~O]qO^qOqsOxrO!OtO!RvO#VuO#bnO~Ot#Oa!T#Oaa#Oa~P.`Op#yO|#zO~O]qO^qOqsOxrO#bnO~Ot}i!O}i!R}i!T}i#V}ia}i~P/aOt!Pi!O!Pi!R!Pi!T!Pi#V!Pia!Pi~P/aOt!Qi!O!Qi!R!Qi!T!Qi#V!Qia!Qi~P/aO!S#{O~Oa#fP~P(aOa#cP~P${Oa$SOj#XO~O!Y$UO~Oh$VOo$VO~Op$XO#X#]O~O]!`Xa!^X!b!^X~O]$YO~Oa$ZO!b#dO~Ot#eO!T#ha!Y#ha~O!b#dOt!ca!T!ca!Y!caa!ca~O!Y$`O~O!S$gO#X$bO#e$aO~Oj#XOt$iO!X$kO!Y!Vi#U!Vi!S!Vi~P${O!Y#Qa#U#Qa!S#Qa~P!ZO!Y!nO#U#gi!S#gi~Oa#fX~P#pOa$oO~Oj#XOQ!{Xa!{Xb!{Xf!{Xh!{Xn!{Xq!{Xt!{X#W!{X#X!{X#e!{X~Ot$qOa#cX~P${Oa$sO~Oj#XOp$tO~Oa$uO~O!b#dOt#Ra!T#Ra!Y#Ra~Oa$wO~P.`OP#WOtgX!TgX~O#e$aOt!sX!T!sX~Ot$yO!TwO~O!S$}O#X$bO#e$aO~Oj#XOQ#PXb#PXf#PXh#PXn#PXq#PXt#PX!X#PX!Y#PX#U#PX#W#PX#X#PX#e#PX!S#PX~Ot$iO!X%QO!Y!Vq#U!Vq!S!Vq~P${Oj#XOp%RO~OtoOa#fa~Ot$qOa#ca~Oa%UO~P${Oj#XOQ#Pab#Paf#Pah#Pan#Paq#Pat#Pa!X#Pa!Y#Pa#U#Pa#W#Pa#X#Pa#e#Pa!S#Pa~Oa!}at!}a~P${O#Zo#[#ej!R#e~",
  goto: "-g#jPPP#kP#nP#w$WP#w$g#wPP$mPPP$s$|$|P%`P$|P$|%z&^PPPP$|&vP&z'Q#wP'W#w'^P#wP#w#wPPP'd'y(WPP#nPP(_(_(i(_P(_P(_(_P#nP#nP#nP(l#nP(o(r(u(|#nP#nP)R)X)h)v)|*S*^*d*n*t*zPPPPPPPPPP+Q+ZP+v+yP,o,r,x-RRkQ_bOPdhw!n#skYOPdhotuvw!n#R#h#skSOPdhotuvw!n#R#h#sQmTR!tnQ{VR!xqQ!x}Q#Z!XR#x!zq![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%Sp![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%SU$d#m$f$yR$x$cq!XZ]!T!m#S#U#X#q#z$P$Y$i$j$q$v%Sp![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%SQ!f^R#l!gT#^!Z#_Q|VR!yqQ!x|R#x!yQ!PWR!{rQ!RXR!|sQxUQ!wpQ#i!cQ#o!jQ#p!kQ${$eR%X$zSgPwQ!phQ#r!nR$l#sZfPhw!n#sa!b[`a!V!^!`#d#eR#b!^R!g^R!i_R#n!iS$e#m$fR%V$yV$c#m$f$yQ!rjR#v!rQdOShPwU!ldh#sR#s!nQ$P#SU$p$P$v%SQ$v$YR%S$qQ#_!ZR$W#_Q$r$PR%T$rQpUS!vp$nR$n#|Q$j#qR%P$jQ!ogS#t!o#uR#u!pQ#f!_R$^#fQ$f#mR$|$fQ$z$eR%W$z_cOPdhw!n#s^UOPdhw!n#sQ!uoQ!}tQ#OuQ#PvQ#|#RR$_#hR$Q#SQ!VZQ!d]Q#V!TQ#q!m[$O#S$P$Y$q$v%SQ$R#UQ$T#XS$h#q$jQ$m#zR%O$iR#}#RQiPR#QwQ!c[Q!kaR#Y!VU!_[a!VQ!j`Q#c!^Q#g!`Q$[#dR$]#e",
  nodeNames: "⚠ Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent ] [ LineNames LineName , PseudoClassName ArgList IdSelector # IdName AttributeSelector AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
  maxTerm: 117,
  nodeProps: [
    ["isolate", -2, 3, 24, ""],
    ["openedBy", 17, "(", 32, "[", 50, "{"],
    ["closedBy", 18, ")", 33, "]", 51, "}"]
  ],
  propSources: [KV],
  skippedNodes: [0, 3, 87],
  repeatNodeCount: 11,
  tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#Z~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#Z~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!X[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYxQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QS|So`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!RQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#e[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#e[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSt^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#bQOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#[~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!Y^Oy%^z;'S%^;'S;=`%o<%lO%^dCoS|SOy%^z;'S%^;'S;=`%o<%lO%^bDQU!OQOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS!OQo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[![Qo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^nFfSq^Oy%^z;'S%^;'S;=`%o<%lO%^nFwSp^Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!bQo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!TUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!S^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!RQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
  tokenizers: [YV, GV, HV, 1, 2, 3, 4, new Fg("m~RRYZ[z{a~~g~aO#^~~dP!P!Qg~lO#_~~", 28, 105)],
  topRules: { StyleSheet: [0, 4], Styles: [1, 86] },
  specialized: [{ term: 100, get: /* @__PURE__ */ m((s) => JV[s] || -1, "get") }, { term: 58, get: /* @__PURE__ */ m((s) => eZ[s] || -1, "get") }, { term: 101, get: /* @__PURE__ */ m((s) => tZ[s] || -1, "get") }],
  tokenPrec: 1200
});
let iO = null;
function Gw() {
  if (!iO && typeof document == "object" && document.body) {
    let { style: s } = document.body, t = [], i = /* @__PURE__ */ new Set();
    for (let n in s)
      n != "cssText" && n != "cssFloat" && typeof s[n] == "string" && (/[A-Z]/.test(n) && (n = n.replace(/[A-Z]/g, (r) => "-" + r.toLowerCase())), i.has(n) || (t.push(n), i.add(n)));
    iO = t.sort().map((n) => ({ type: "property", label: n }));
  }
  return iO || [];
}
u(Gw, "Io$1");
m(Gw, "properties");
const BP = /* @__PURE__ */ [
  "active",
  "after",
  "any-link",
  "autofill",
  "backdrop",
  "before",
  "checked",
  "cue",
  "default",
  "defined",
  "disabled",
  "empty",
  "enabled",
  "file-selector-button",
  "first",
  "first-child",
  "first-letter",
  "first-line",
  "first-of-type",
  "focus",
  "focus-visible",
  "focus-within",
  "fullscreen",
  "has",
  "host",
  "host-context",
  "hover",
  "in-range",
  "indeterminate",
  "invalid",
  "is",
  "lang",
  "last-child",
  "last-of-type",
  "left",
  "link",
  "marker",
  "modal",
  "not",
  "nth-child",
  "nth-last-child",
  "nth-last-of-type",
  "nth-of-type",
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "part",
  "placeholder",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "selection",
  "slotted",
  "target",
  "target-text",
  "valid",
  "visited",
  "where"
].map((s) => ({ type: "class", label: s })), jP = /* @__PURE__ */ [
  "above",
  "absolute",
  "activeborder",
  "additive",
  "activecaption",
  "after-white-space",
  "ahead",
  "alias",
  "all",
  "all-scroll",
  "alphabetic",
  "alternate",
  "always",
  "antialiased",
  "appworkspace",
  "asterisks",
  "attr",
  "auto",
  "auto-flow",
  "avoid",
  "avoid-column",
  "avoid-page",
  "avoid-region",
  "axis-pan",
  "background",
  "backwards",
  "baseline",
  "below",
  "bidi-override",
  "blink",
  "block",
  "block-axis",
  "bold",
  "bolder",
  "border",
  "border-box",
  "both",
  "bottom",
  "break",
  "break-all",
  "break-word",
  "bullets",
  "button",
  "button-bevel",
  "buttonface",
  "buttonhighlight",
  "buttonshadow",
  "buttontext",
  "calc",
  "capitalize",
  "caps-lock-indicator",
  "caption",
  "captiontext",
  "caret",
  "cell",
  "center",
  "checkbox",
  "circle",
  "cjk-decimal",
  "clear",
  "clip",
  "close-quote",
  "col-resize",
  "collapse",
  "color",
  "color-burn",
  "color-dodge",
  "column",
  "column-reverse",
  "compact",
  "condensed",
  "contain",
  "content",
  "contents",
  "content-box",
  "context-menu",
  "continuous",
  "copy",
  "counter",
  "counters",
  "cover",
  "crop",
  "cross",
  "crosshair",
  "currentcolor",
  "cursive",
  "cyclic",
  "darken",
  "dashed",
  "decimal",
  "decimal-leading-zero",
  "default",
  "default-button",
  "dense",
  "destination-atop",
  "destination-in",
  "destination-out",
  "destination-over",
  "difference",
  "disc",
  "discard",
  "disclosure-closed",
  "disclosure-open",
  "document",
  "dot-dash",
  "dot-dot-dash",
  "dotted",
  "double",
  "down",
  "e-resize",
  "ease",
  "ease-in",
  "ease-in-out",
  "ease-out",
  "element",
  "ellipse",
  "ellipsis",
  "embed",
  "end",
  "ethiopic-abegede-gez",
  "ethiopic-halehame-aa-er",
  "ethiopic-halehame-gez",
  "ew-resize",
  "exclusion",
  "expanded",
  "extends",
  "extra-condensed",
  "extra-expanded",
  "fantasy",
  "fast",
  "fill",
  "fill-box",
  "fixed",
  "flat",
  "flex",
  "flex-end",
  "flex-start",
  "footnotes",
  "forwards",
  "from",
  "geometricPrecision",
  "graytext",
  "grid",
  "groove",
  "hand",
  "hard-light",
  "help",
  "hidden",
  "hide",
  "higher",
  "highlight",
  "highlighttext",
  "horizontal",
  "hsl",
  "hsla",
  "hue",
  "icon",
  "ignore",
  "inactiveborder",
  "inactivecaption",
  "inactivecaptiontext",
  "infinite",
  "infobackground",
  "infotext",
  "inherit",
  "initial",
  "inline",
  "inline-axis",
  "inline-block",
  "inline-flex",
  "inline-grid",
  "inline-table",
  "inset",
  "inside",
  "intrinsic",
  "invert",
  "italic",
  "justify",
  "keep-all",
  "landscape",
  "large",
  "larger",
  "left",
  "level",
  "lighter",
  "lighten",
  "line-through",
  "linear",
  "linear-gradient",
  "lines",
  "list-item",
  "listbox",
  "listitem",
  "local",
  "logical",
  "loud",
  "lower",
  "lower-hexadecimal",
  "lower-latin",
  "lower-norwegian",
  "lowercase",
  "ltr",
  "luminosity",
  "manipulation",
  "match",
  "matrix",
  "matrix3d",
  "medium",
  "menu",
  "menutext",
  "message-box",
  "middle",
  "min-intrinsic",
  "mix",
  "monospace",
  "move",
  "multiple",
  "multiple_mask_images",
  "multiply",
  "n-resize",
  "narrower",
  "ne-resize",
  "nesw-resize",
  "no-close-quote",
  "no-drop",
  "no-open-quote",
  "no-repeat",
  "none",
  "normal",
  "not-allowed",
  "nowrap",
  "ns-resize",
  "numbers",
  "numeric",
  "nw-resize",
  "nwse-resize",
  "oblique",
  "opacity",
  "open-quote",
  "optimizeLegibility",
  "optimizeSpeed",
  "outset",
  "outside",
  "outside-shape",
  "overlay",
  "overline",
  "padding",
  "padding-box",
  "painted",
  "page",
  "paused",
  "perspective",
  "pinch-zoom",
  "plus-darker",
  "plus-lighter",
  "pointer",
  "polygon",
  "portrait",
  "pre",
  "pre-line",
  "pre-wrap",
  "preserve-3d",
  "progress",
  "push-button",
  "radial-gradient",
  "radio",
  "read-only",
  "read-write",
  "read-write-plaintext-only",
  "rectangle",
  "region",
  "relative",
  "repeat",
  "repeating-linear-gradient",
  "repeating-radial-gradient",
  "repeat-x",
  "repeat-y",
  "reset",
  "reverse",
  "rgb",
  "rgba",
  "ridge",
  "right",
  "rotate",
  "rotate3d",
  "rotateX",
  "rotateY",
  "rotateZ",
  "round",
  "row",
  "row-resize",
  "row-reverse",
  "rtl",
  "run-in",
  "running",
  "s-resize",
  "sans-serif",
  "saturation",
  "scale",
  "scale3d",
  "scaleX",
  "scaleY",
  "scaleZ",
  "screen",
  "scroll",
  "scrollbar",
  "scroll-position",
  "se-resize",
  "self-start",
  "self-end",
  "semi-condensed",
  "semi-expanded",
  "separate",
  "serif",
  "show",
  "single",
  "skew",
  "skewX",
  "skewY",
  "skip-white-space",
  "slide",
  "slider-horizontal",
  "slider-vertical",
  "sliderthumb-horizontal",
  "sliderthumb-vertical",
  "slow",
  "small",
  "small-caps",
  "small-caption",
  "smaller",
  "soft-light",
  "solid",
  "source-atop",
  "source-in",
  "source-out",
  "source-over",
  "space",
  "space-around",
  "space-between",
  "space-evenly",
  "spell-out",
  "square",
  "start",
  "static",
  "status-bar",
  "stretch",
  "stroke",
  "stroke-box",
  "sub",
  "subpixel-antialiased",
  "svg_masks",
  "super",
  "sw-resize",
  "symbolic",
  "symbols",
  "system-ui",
  "table",
  "table-caption",
  "table-cell",
  "table-column",
  "table-column-group",
  "table-footer-group",
  "table-header-group",
  "table-row",
  "table-row-group",
  "text",
  "text-bottom",
  "text-top",
  "textarea",
  "textfield",
  "thick",
  "thin",
  "threeddarkshadow",
  "threedface",
  "threedhighlight",
  "threedlightshadow",
  "threedshadow",
  "to",
  "top",
  "transform",
  "translate",
  "translate3d",
  "translateX",
  "translateY",
  "translateZ",
  "transparent",
  "ultra-condensed",
  "ultra-expanded",
  "underline",
  "unidirectional-pan",
  "unset",
  "up",
  "upper-latin",
  "uppercase",
  "url",
  "var",
  "vertical",
  "vertical-text",
  "view-box",
  "visible",
  "visibleFill",
  "visiblePainted",
  "visibleStroke",
  "visual",
  "w-resize",
  "wait",
  "wave",
  "wider",
  "window",
  "windowframe",
  "windowtext",
  "words",
  "wrap",
  "wrap-reverse",
  "x-large",
  "x-small",
  "xor",
  "xx-large",
  "xx-small"
].map((s) => ({ type: "keyword", label: s })).concat(/* @__PURE__ */ [
  "aliceblue",
  "antiquewhite",
  "aqua",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "fuchsia",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "grey",
  "green",
  "greenyellow",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "linen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "navy",
  "oldlace",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "white",
  "whitesmoke",
  "yellow",
  "yellowgreen"
].map((s) => ({ type: "constant", label: s }))), nZ = /* @__PURE__ */ [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "footer",
  "form",
  "header",
  "hgroup",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "meter",
  "nav",
  "ol",
  "output",
  "p",
  "pre",
  "ruby",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul"
].map((s) => ({ type: "type", label: s })), Ws = /^(\w[\w-]*|-\w[\w-]*|)$/, sZ = /^-(-[\w-]*)?$/;
function JQ(s, t) {
  var i;
  if ((s.name == "(" || s.type.isError) && (s = s.parent || s), s.name != "ArgList")
    return !1;
  let n = (i = s.parent) === null || i === void 0 ? void 0 : i.firstChild;
  return (n == null ? void 0 : n.name) != "Callee" ? !1 : t.sliceString(n.from, n.to) == "var";
}
u(JQ, "lS");
m(JQ, "isVarArg");
const XP = /* @__PURE__ */ new v8(), rZ = ["Declaration"];
function eT(s) {
  for (let t = s; ; ) {
    if (t.type.isTop)
      return t;
    if (!(t = t.parent))
      return s;
  }
}
u(eT, "hS");
m(eT, "astTop");
function Ok(s, t, i) {
  if (t.to - t.from > 4096) {
    let n = XP.get(t);
    if (n)
      return n;
    let r = [], a = /* @__PURE__ */ new Set(), o = t.cursor(Ne.IncludeAnonymous);
    if (o.firstChild())
      do
        for (let l of Ok(s, o.node, i))
          a.has(l.label) || (a.add(l.label), r.push(l));
      while (o.nextSibling());
    return XP.set(t, r), r;
  } else {
    let n = [], r = /* @__PURE__ */ new Set();
    return t.cursor().iterate((a) => {
      var o;
      if (i(a) && a.matchContext(rZ) && ((o = a.node.nextSibling) === null || o === void 0 ? void 0 : o.name) == ":") {
        let l = s.sliceString(a.from, a.to);
        r.has(l) || (r.add(l), n.push({ label: l, type: "variable" }));
      }
    }), n;
  }
}
u(Ok, "Jp$1");
m(Ok, "variableNames");
const aZ = /* @__PURE__ */ m((s) => (t) => {
  let { state: i, pos: n } = t, r = nt(i).resolveInner(n, -1), a = r.type.isError && r.from == r.to - 1 && i.doc.sliceString(r.from, r.to) == "-";
  if (r.name == "PropertyName" || (a || r.name == "TagName") && /^(Block|Styles)$/.test(r.resolve(r.to).name))
    return { from: r.from, options: Gw(), validFor: Ws };
  if (r.name == "ValueName")
    return { from: r.from, options: jP, validFor: Ws };
  if (r.name == "PseudoClassName")
    return { from: r.from, options: BP, validFor: Ws };
  if (s(r) || (t.explicit || a) && JQ(r, i.doc))
    return {
      from: s(r) || a ? r.from : n,
      options: Ok(i.doc, eT(r), s),
      validFor: sZ
    };
  if (r.name == "TagName") {
    for (let { parent: c } = r; c; c = c.parent)
      if (c.name == "Block")
        return { from: r.from, options: Gw(), validFor: Ws };
    return { from: r.from, options: nZ, validFor: Ws };
  }
  if (!t.explicit)
    return null;
  let o = r.resolve(n), l = o.childBefore(n);
  return l && l.name == ":" && o.name == "PseudoClassSelector" ? { from: n, options: BP, validFor: Ws } : l && l.name == ":" && o.name == "Declaration" || o.name == "ArgList" ? { from: n, options: jP, validFor: Ws } : o.name == "Block" || o.name == "Styles" ? { from: n, options: Gw(), validFor: Ws } : null;
}, "defineCSSCompletionSource"), oZ = /* @__PURE__ */ aZ((s) => s.name == "VariableName"), Kg = /* @__PURE__ */ Vx.define({
  name: "css",
  parser: /* @__PURE__ */ iZ.configure({
    props: [
      /* @__PURE__ */ zf.add({
        Declaration: /* @__PURE__ */ By()
      }),
      /* @__PURE__ */ jm.add({
        "Block KeyframeList": Ux
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*\}$/,
    wordChars: "-"
  }
});
function tT() {
  return new df(Kg, Kg.data.of({ autocomplete: oZ }));
}
u(tT, "im$1");
m(tT, "css");
const lZ = 312, FP = 1, cZ = 2, hZ = 3, dZ = 4, uZ = 313, pZ = 315, fZ = 316, yZ = 5, mZ = 6, wZ = 0, j2 = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], iT = 125, gZ = 59, X2 = 47, vZ = 42, OZ = 43, bZ = 45, $Z = 60, xZ = 44, kZ = 63, SZ = 46, PZ = new WQ({
  start: !1,
  shift(s, t) {
    return t == yZ || t == mZ || t == pZ ? s : t == fZ;
  },
  strict: !1
}), CZ = new vn((s, t) => {
  let { next: i } = s;
  (i == iT || i == -1 || t.context) && s.acceptToken(uZ);
}, { contextual: !0, fallback: !0 }), QZ = new vn((s, t) => {
  let { next: i } = s, n;
  j2.indexOf(i) > -1 || i == X2 && ((n = s.peek(1)) == X2 || n == vZ) || i != iT && i != gZ && i != -1 && !t.context && s.acceptToken(lZ);
}, { contextual: !0 }), TZ = new vn((s, t) => {
  let { next: i } = s;
  if (i == OZ || i == bZ) {
    if (s.advance(), i == s.next) {
      s.advance();
      let n = !t.context && t.canShift(FP);
      s.acceptToken(n ? FP : cZ);
    }
  } else i == kZ && s.peek(1) == SZ && (s.advance(), s.advance(), (s.next < 48 || s.next > 57) && s.acceptToken(hZ));
}, { contextual: !0 });
function Kw(s, t) {
  return s >= 65 && s <= 90 || s >= 97 && s <= 122 || s == 95 || s >= 192 || !t && s >= 48 && s <= 57;
}
u(Kw, "jo$1");
m(Kw, "identifierChar");
const MZ = new vn((s, t) => {
  if (s.next != $Z || !t.dialectEnabled(wZ) || (s.advance(), s.next == X2)) return;
  let i = 0;
  for (; j2.indexOf(s.next) > -1; )
    s.advance(), i++;
  if (Kw(s.next, !0)) {
    for (s.advance(), i++; Kw(s.next, !1); )
      s.advance(), i++;
    for (; j2.indexOf(s.next) > -1; )
      s.advance(), i++;
    if (s.next == xZ) return;
    for (let n = 0; ; n++) {
      if (n == 7) {
        if (!Kw(s.next, !0)) return;
        break;
      }
      if (s.next != "extends".charCodeAt(n)) break;
      s.advance(), i++;
    }
  }
  s.acceptToken(dZ, -i);
}), RZ = Io({
  "get set async static": Q.modifier,
  "for while do if else switch try catch finally return throw break continue default case": Q.controlKeyword,
  "in of await yield void typeof delete instanceof": Q.operatorKeyword,
  "let var const using function class extends": Q.definitionKeyword,
  "import export from": Q.moduleKeyword,
  "with debugger as new": Q.keyword,
  TemplateString: Q.special(Q.string),
  super: Q.atom,
  BooleanLiteral: Q.bool,
  this: Q.self,
  null: Q.null,
  Star: Q.modifier,
  VariableName: Q.variableName,
  "CallExpression/VariableName TaggedTemplateExpression/VariableName": Q.function(Q.variableName),
  VariableDefinition: Q.definition(Q.variableName),
  Label: Q.labelName,
  PropertyName: Q.propertyName,
  PrivatePropertyName: Q.special(Q.propertyName),
  "CallExpression/MemberExpression/PropertyName": Q.function(Q.propertyName),
  "FunctionDeclaration/VariableDefinition": Q.function(Q.definition(Q.variableName)),
  "ClassDeclaration/VariableDefinition": Q.definition(Q.className),
  PropertyDefinition: Q.definition(Q.propertyName),
  PrivatePropertyDefinition: Q.definition(Q.special(Q.propertyName)),
  UpdateOp: Q.updateOperator,
  "LineComment Hashbang": Q.lineComment,
  BlockComment: Q.blockComment,
  Number: Q.number,
  String: Q.string,
  Escape: Q.escape,
  ArithOp: Q.arithmeticOperator,
  LogicOp: Q.logicOperator,
  BitOp: Q.bitwiseOperator,
  CompareOp: Q.compareOperator,
  RegExp: Q.regexp,
  Equals: Q.definitionOperator,
  Arrow: Q.function(Q.punctuation),
  ": Spread": Q.punctuation,
  "( )": Q.paren,
  "[ ]": Q.squareBracket,
  "{ }": Q.brace,
  "InterpolationStart InterpolationEnd": Q.special(Q.brace),
  ".": Q.derefOperator,
  ", ;": Q.separator,
  "@": Q.meta,
  TypeName: Q.typeName,
  TypeDefinition: Q.definition(Q.typeName),
  "type enum interface implements namespace module declare": Q.definitionKeyword,
  "abstract global Privacy readonly override": Q.modifier,
  "is keyof unique infer": Q.operatorKeyword,
  JSXAttributeValue: Q.attributeValue,
  JSXText: Q.content,
  "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": Q.angleBracket,
  "JSXIdentifier JSXNameSpacedName": Q.tagName,
  "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": Q.attributeName,
  "JSXBuiltin/JSXIdentifier": Q.standard(Q.tagName)
}), AZ = { __proto__: null, export: 20, as: 25, from: 33, default: 36, async: 41, function: 42, extends: 54, this: 58, true: 66, false: 66, null: 78, void: 82, typeof: 86, super: 102, new: 136, delete: 148, yield: 157, await: 161, class: 166, public: 229, private: 229, protected: 229, readonly: 231, instanceof: 250, satisfies: 253, in: 254, const: 256, import: 290, keyof: 345, unique: 349, infer: 355, is: 391, abstract: 411, implements: 413, type: 415, let: 418, var: 420, using: 423, interface: 429, enum: 433, namespace: 439, module: 441, declare: 445, global: 449, for: 468, of: 477, while: 480, with: 484, do: 488, if: 492, else: 494, switch: 498, case: 504, try: 510, catch: 514, finally: 518, return: 522, throw: 526, break: 530, continue: 534, debugger: 538 }, EZ = { __proto__: null, async: 123, get: 125, set: 127, declare: 189, public: 191, private: 191, protected: 191, static: 193, abstract: 195, override: 197, readonly: 203, accessor: 205, new: 395 }, zZ = { __proto__: null, "<": 187 }, _Z = fk.deserialize({
  version: 14,
  states: "$@QO%TQ^OOO%[Q^OOO'_Q`OOP(lOWOOO*zQ?NdO'#CiO+RO!bO'#CjO+aO#tO'#CjO+oO!0LbO'#D^O.QQ^O'#DdO.bQ^O'#DoO%[Q^O'#DwO0fQ^O'#EPOOQ?Mr'#EX'#EXO1PQWO'#EUOOQO'#Em'#EmOOQO'#Ih'#IhO1XQWO'#GpO1dQWO'#ElO1iQWO'#ElO3hQ?NdO'#JmO6[Q?NdO'#JnO6uQWO'#F[O6zQ&jO'#FsOOQ?Mr'#Fe'#FeO7VO,YO'#FeO7eQ7[O'#FzO9RQWO'#FyOOQ?Mr'#Jn'#JnOOQ?Mp'#Jm'#JmO9WQWO'#GtOOQU'#KZ'#KZO9cQWO'#IUO9hQ?MxO'#IVOOQU'#JZ'#JZOOQU'#IZ'#IZQ`Q^OOO`Q^OOO9pQMnO'#DsO9wQ^O'#D{O:OQ^O'#D}O9^QWO'#GpO:VQ7[O'#CoO:eQWO'#EkO:pQWO'#EvO:uQ7[O'#FdO;dQWO'#GpOOQO'#K['#K[O;iQWO'#K[O;wQWO'#GxO;wQWO'#GyO;wQWO'#G{O9^QWO'#HOO<nQWO'#HRO>VQWO'#CeO>gQWO'#H_O>oQWO'#HeO>oQWO'#HgO`Q^O'#HiO>oQWO'#HkO>oQWO'#HnO>tQWO'#HtO>yQ?MyO'#HzO%[Q^O'#H|O?UQ?MyO'#IOO?aQ?MyO'#IQO9hQ?MxO'#ISO?lQ?NdO'#CiO@nQ`O'#DiQOQWOOO%[Q^O'#D}OAUQWO'#EQO:VQ7[O'#EkOAaQWO'#EkOAlQpO'#FdOOQU'#Cg'#CgOOQ?Mp'#Dn'#DnOOQ?Mp'#Jq'#JqO%[Q^O'#JqOOQO'#Jt'#JtOOQO'#Id'#IdOBlQ`O'#EdOOQ?Mp'#Ec'#EcOOQ?Mp'#Jx'#JxOChQ?NQO'#EdOCrQ`O'#ETOOQO'#Js'#JsODWQ`O'#JtOEeQ`O'#ETOCrQ`O'#EdPErO#@ItO'#CbPOOO)CDx)CDxOOOO'#I['#I[OE}O!bO,59UOOQ?Mr,59U,59UOOOO'#I]'#I]OF]O#tO,59UO%[Q^O'#D`OOOO'#I_'#I_OFkO!0LbO,59xOOQ?Mr,59x,59xOFyQ^O'#I`OG^QWO'#JoOI]QrO'#JoO+}Q^O'#JoOIdQWO,5:OOIzQWO'#EmOJXQWO'#KOOJdQWO'#J}OJdQWO'#J}OJlQWO,5;ZOJqQWO'#J|OOQ?Mv,5:Z,5:ZOJxQ^O,5:ZOLvQ?NdO,5:cOMgQWO,5:kONQQ?MxO'#J{ONXQWO'#JzO9WQWO'#JzONmQWO'#JzONuQWO,5;YONzQWO'#JzO!#PQrO'#JnOOQ?Mr'#Ci'#CiO%[Q^O'#EPO!#oQrO,5:pOOQQ'#Ju'#JuOOQO-E<f-E<fO9^QWO,5=[O!$VQWO,5=[O!$[Q^O,5;WO!&_Q7[O'#EhO!'xQWO,5;WO!'}Q^O'#DvO!(XQ`O,5;aO!(aQ`O,5;aO%[Q^O,5;aOOQU'#FS'#FSOOQU'#FU'#FUO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bOOQU'#FY'#FYO!(oQ^O,5;sOOQ?Mr,5;x,5;xOOQ?Mr,5;y,5;yOOQ?Mr,5;{,5;{O%[Q^O'#IlO!*rQ?MxO,5<gO%[Q^O,5;bO!&_Q7[O,5;bO!+aQ7[O,5;bO!-RQ7[O'#EZO%[Q^O,5;vOOQ?Mr,5;z,5;zO!-YQ&jO'#FiO!.VQ&jO'#KSO!-qQ&jO'#KSO!.^Q&jO'#KSOOQO'#KS'#KSO!.rQ&jO,5<ROOOS,5<_,5<_O!/TQ^O'#FuOOOS'#Ik'#IkO7VO,YO,5<PO!/[Q&jO'#FwOOQ?Mr,5<P,5<PO!/{Q!LQO'#CvOOQ?Mr'#Cz'#CzO!0`O!0LbO'#DOO!0|Q7[O,5<dO!1TQWO,5<fO!2pQ$ISO'#GVO!2}QWO'#GWO!3SQWO'#GWO!4rQ$ISO'#G[O!5nQ`O'#G`OOQO'#Gk'#GkO!+hQ7[O'#GjOOQO'#Gm'#GmO!+hQ7[O'#GlO!6aQ!LQO'#JgOOQ?Mr'#Jg'#JgO!6kQWO'#JfO!6yQWO'#JeO!7RQWO'#CuOOQ?Mr'#Cx'#CxO!7ZQWO'#CzOOQ?Mr'#DS'#DSOOQ?Mr'#DU'#DUO1SQWO'#DWO!+hQ7[O'#F}O!+hQ7[O'#GPO!7`QWO'#GRO!7eQWO'#GSO!3SQWO'#GYO!+hQ7[O'#G_O!7jQWO'#EnO!8XQWO,5<eOOQ?Mp'#Cr'#CrO!8aQWO'#EoO!9ZQ`O'#EpOOQ?Mp'#J|'#J|O!9bQ?MxO'#K]O9hQ?MxO,5=`O`Q^O,5>pOOQU'#Jc'#JcOOQU,5>q,5>qOOQU-E<X-E<XO!;aQ?NdO,5:_O!9UQ`O,5:]O!=zQ?NdO,5:gO%[Q^O,5:gO!@bQ?NdO,5:iOOQO,5@v,5@vO!ARQ7[O,5=[O!AaQ?MxO'#JdO9RQWO'#JdO!ArQ?MxO,59ZO!A}Q`O,59ZO!BVQ7[O,59ZO:VQ7[O,59ZO!BbQWO,5;WO!BjQWO'#H^O!COQWO'#K`O%[Q^O,5;|O!9UQ`O,5<OO!CWQWO,5=wO!C]QWO,5=wO!CbQWO,5=wO9hQ?MxO,5=wO;wQWO,5=gOOQO'#Cv'#CvO!CpQ`O,5=dO!CxQ7[O,5=eO!DTQWO,5=gO!DYQpO,5=jO!DbQWO'#K[O>tQWO'#HTO9^QWO'#HVO!DgQWO'#HVO:VQ7[O'#HXO!DlQWO'#HXOOQU,5=m,5=mO!DqQWO'#HYO!ESQWO'#CoO!EXQWO,59PO!EcQWO,59PO!GhQ^O,59POOQU,59P,59PO!GxQ?MxO,59PO%[Q^O,59PO!JTQ^O'#HaOOQU'#Hb'#HbOOQU'#Hc'#HcO`Q^O,5=yO!JkQWO,5=yO`Q^O,5>PO`Q^O,5>RO!JpQWO,5>TO`Q^O,5>VO!JuQWO,5>YO!JzQ^O,5>`OOQU,5>f,5>fO%[Q^O,5>fO9hQ?MxO,5>hOOQU,5>j,5>jO# UQWO,5>jOOQU,5>l,5>lO# UQWO,5>lOOQU,5>n,5>nO# rQ`O'#D[O%[Q^O'#JqO# |Q`O'#JqO#!kQ`O'#DjO#!|Q`O'#DjO#%_Q^O'#DjO#%fQWO'#JpO#%nQWO,5:TO#%sQWO'#EqO#&RQWO'#KPO#&ZQWO,5;[O#&`Q`O'#DjO#&mQ`O'#ESOOQ?Mr,5:l,5:lO%[Q^O,5:lO#&tQWO,5:lO>tQWO,5;VO!A}Q`O,5;VO!BVQ7[O,5;VO:VQ7[O,5;VO#&|QWO,5@]O#'RQ(CYO,5:pOOQO-E<b-E<bO#(XQ?NQO,5;OOCrQ`O,5:oO#(cQ`O,5:oOCrQ`O,5;OO!ArQ?MxO,5:oOOQ?Mp'#Eg'#EgOOQO,5;O,5;OO%[Q^O,5;OO#(pQ?MxO,5;OO#({Q?MxO,5;OO!A}Q`O,5:oOOQO,5;U,5;UO#)ZQ?MxO,5;OPOOO'#IY'#IYP#)oO#@ItO,58|POOO,58|,58|OOOO-E<Y-E<YOOQ?Mr1G.p1G.pOOOO-E<Z-E<ZO#)zQpO,59zOOOO-E<]-E<]OOQ?Mr1G/d1G/dO#*PQrO,5>zO+}Q^O,5>zOOQO,5?Q,5?QO#*ZQ^O'#I`OOQO-E<^-E<^O#*hQWO,5@ZO#*pQrO,5@ZO#*wQWO,5@iOOQ?Mr1G/j1G/jO%[Q^O,5@jO#+PQWO'#IfOOQO-E<d-E<dO#*wQWO,5@iOOQ?Mp1G0u1G0uOOQ?Mv1G/u1G/uOOQ?Mv1G0V1G0VO%[Q^O,5@gO#+eQ?MxO,5@gO#+vQ?MxO,5@gO#+}QWO,5@fO9WQWO,5@fO#,VQWO,5@fO#,eQWO'#IiO#+}QWO,5@fOOQ?Mp1G0t1G0tO!(XQ`O,5:rO!(dQ`O,5:rOOQQ,5:t,5:tO#-VQYO,5:tO#-_Q7[O1G2vO9^QWO1G2vOOQ?Mr1G0r1G0rO#-mQ?NdO1G0rO#.rQ?NbO,5;SOOQ?Mr'#GU'#GUO#/`Q?NdO'#JgO!$[Q^O1G0rO#1hQrO'#JrO%[Q^O'#JrO#1rQWO,5:bOOQ?Mr'#D['#D[OOQ?Mr1G0{1G0{O%[Q^O1G0{OOQ?Mr1G1e1G1eO#1wQWO1G0{O#4]Q?NdO1G0|O#4dQ?NdO1G0|O#6zQ?NdO1G0|O#7RQ?NdO1G0|O#9iQ?NdO1G0|O#<PQ?NdO1G0|O#<WQ?NdO1G0|O#<_Q?NdO1G0|O#>uQ?NdO1G0|O#>|Q?NdO1G0|O#AZQ07bO'#CiO#CUQ07bO1G1_O#C]Q07bO'#JnO#CpQ?NdO,5?WOOQ?Mp-E<j-E<jO#E}Q?NdO1G0|O#FzQ?NdO1G0|OOQ?Mr1G0|1G0|O#GzQ7[O'#JwO#HUQWO,5:uO#HZQ?NdO1G1bO#H}Q&jO,5<VO#IVQ&jO,5<WO#I_Q&jO'#FnO#IvQWO'#FmOOQO'#KT'#KTOOQO'#Ij'#IjO#I{Q&jO1G1mOOQ?Mr1G1m1G1mOOOS1G1x1G1xO#J^Q07bO'#JmO#JhQWO,5<aO!(oQ^O,5<aOOOS-E<i-E<iOOQ?Mr1G1k1G1kO#JmQ`O'#KSOOQ?Mr,5<c,5<cO#JuQ`O,5<cO!&_Q7[O'#DQOOOO'#I^'#I^O#JzO!0LbO,59jOOQ?Mr,59j,59jO%[Q^O1G2OO!7eQWO'#InO#KVQ7[O,5<xOOQ?Mr,5<u,5<uO!+hQ7[O'#IqO#KuQ7[O,5=UO!+hQ7[O'#IsO#LhQ7[O,5=WO!&_Q7[O,5=YOOQO1G2Q1G2QO#LrQpO'#CrO#MVQ$ISO'#EoO#NUQ`O'#G`O#NrQpO,5<qO#NyQWO'#KWO9WQWO'#KWO$ XQWO,5<sO!+hQ7[O,5<rO$ ^QWO'#GXO$ oQWO,5<rO$ tQpO'#GUO$!RQpO'#KXO$!]QWO'#KXO!&_Q7[O'#KXO$!bQWO,5<vO$!gQ`O'#GaO!5iQ`O'#GaO$!xQWO'#GcO$!}QWO'#GeO!3SQWO'#GhO$#SQ?MxO'#IpO$#_Q`O,5<zOOQ?Mv,5<z,5<zO$#fQ`O'#GaO$#tQ`O'#GbO$#|Q`O'#GbO$$RQ7[O,5=UO$$cQ7[O,5=WOOQ?Mr,5=Z,5=ZO!+hQ7[O,5@QO!+hQ7[O,5@QO$$sQWO'#IuO$%OQWO,5@PO$%WQWO,59aOOQ?Mr,59f,59fO$%zQ!LSO,59rOOQ?Mr'#Jk'#JkO$&mQ7[O,5<iO$'`Q7[O,5<kO@fQWO,5<mOOQ?Mr,5<n,5<nO$'jQWO,5<tO$'oQ7[O,5<yO$(PQWO'#JzO!$[Q^O1G2PO$(UQWO1G2PO9WQWO'#J}O9WQWO'#EqO%[Q^O'#EqO9WQWO'#IwO$(ZQ?MxO,5@wOOQU1G2z1G2zOOQU1G4[1G4[OOQ?Mr1G/y1G/yOOQ?Mr1G/w1G/wO$*]Q?NdO1G0ROOQU1G2v1G2vO!&_Q7[O1G2vO%[Q^O1G2vO#-bQWO1G2vO$,aQ7[O'#EhOOQ?Mp,5@O,5@OO$,kQ?MxO,5@OOOQU1G.u1G.uO!ArQ?MxO1G.uO!A}Q`O1G.uO!BVQ7[O1G.uO$,|QWO1G0rO$-RQWO'#CiO$-^QWO'#KaO$-fQWO,5=xO$-kQWO'#KaO$-pQWO'#KaO$.OQWO'#I}O$.^QWO,5@zO$.fQrO1G1hOOQ?Mr1G1j1G1jO9^QWO1G3cO@fQWO1G3cO$.mQWO1G3cO$.rQWO1G3cOOQU1G3c1G3cO!DTQWO1G3RO!&_Q7[O1G3OO$.wQWO1G3OOOQU1G3P1G3PO!&_Q7[O1G3PO$.|QWO1G3PO$/UQ`O'#G}OOQU1G3R1G3RO!5iQ`O'#IyO!DYQpO1G3UOOQU1G3U1G3UOOQU,5=o,5=oO$/^Q7[O,5=qO9^QWO,5=qO$!}QWO,5=sO9RQWO,5=sO!A}Q`O,5=sO!BVQ7[O,5=sO:VQ7[O,5=sO$/lQWO'#K_O$/wQWO,5=tOOQU1G.k1G.kO$/|Q?MxO1G.kO@fQWO1G.kO$0XQWO1G.kO9hQ?MxO1G.kO$2aQrO,5@|O$2nQWO,5@|O9WQWO,5@|O$2yQ^O,5={O$3QQWO,5={OOQU1G3e1G3eO`Q^O1G3eOOQU1G3k1G3kOOQU1G3m1G3mO>oQWO1G3oO$3VQ^O1G3qO$7ZQ^O'#HpOOQU1G3t1G3tO$7hQWO'#HvO>tQWO'#HxOOQU1G3z1G3zO$7pQ^O1G3zO9hQ?MxO1G4QOOQU1G4S1G4SOOQ?Mp'#G]'#G]O9hQ?MxO1G4UO9hQ?MxO1G4WO$;wQWO,5@]O!(oQ^O,5;]O9WQWO,5;]O>tQWO,5:UO!(oQ^O,5:UO!A}Q`O,5:UO$;|Q07bO,5:UOOQO,5;],5;]O$<WQ`O'#IaO$<nQWO,5@[OOQ?Mr1G/o1G/oO$<vQ`O'#IgO$=QQWO,5@kOOQ?Mp1G0v1G0vO#!|Q`O,5:UOOQO'#Ic'#IcO$=YQ`O,5:nOOQ?Mv,5:n,5:nO#&wQWO1G0WOOQ?Mr1G0W1G0WO%[Q^O1G0WOOQ?Mr1G0q1G0qO>tQWO1G0qO!A}Q`O1G0qO!BVQ7[O1G0qOOQ?Mp1G5w1G5wO!ArQ?MxO1G0ZOOQO1G0j1G0jO%[Q^O1G0jO$=aQ?MxO1G0jO$=lQ?MxO1G0jO!A}Q`O1G0ZOCrQ`O1G0ZO$=zQ?MxO1G0jOOQO1G0Z1G0ZO$>`Q?NdO1G0jPOOO-E<W-E<WPOOO1G.h1G.hOOOO1G/f1G/fO$>jQpO,5<gO$>rQrO1G4fOOQO1G4l1G4lO%[Q^O,5>zO$>|QWO1G5uO$?UQWO1G6TO$?^QrO1G6UO9WQWO,5?QO$?hQ?NdO1G6RO%[Q^O1G6RO$?xQ?MxO1G6RO$@ZQWO1G6QO$@ZQWO1G6QO9WQWO1G6QO$@cQWO,5?TO9WQWO,5?TOOQO,5?T,5?TO$@wQWO,5?TO$(PQWO,5?TOOQO-E<g-E<gOOQQ1G0^1G0^OOQQ1G0`1G0`O#-YQWO1G0`OOQU7+(b7+(bO!&_Q7[O7+(bO%[Q^O7+(bO$AVQWO7+(bO$AbQ7[O7+(bO$ApQ?NdO,5=UO$CxQ?NdO,5=WO$FQQ?NdO,5=UO$H`Q?NdO,5=WO$JnQ?NdO,59rO$LsQ?NdO,5<iO$N{Q?NdO,5<kO%#TQ?NdO,5<yOOQ?Mr7+&^7+&^O%%cQ?NdO7+&^O%&VQ^O'#IbO%&dQWO,5@^O%&lQrO,5@^OOQ?Mr1G/|1G/|O%&vQWO7+&gOOQ?Mr7+&g7+&gO%&{Q07bO,5:cO%[Q^O7+&yO%'VQ07bO,5:_O%'dQ07bO,5:gO%'nQ07bO,5:iO%'xQ7[O'#IeO%(SQWO,5@cOOQ?Mr1G0a1G0aOOQO1G1q1G1qOOQO1G1r1G1rO%([QtO,5<YO!(oQ^O,5<XOOQO-E<h-E<hOOQ?Mr7+'X7+'XOOOS7+'d7+'dOOOS1G1{1G1{O%(gQWO1G1{OOQ?Mr1G1}1G1}O%(lQpO,59lOOOO-E<[-E<[OOQ?Mr1G/U1G/UO%(sQ?NdO7+'jOOQ?Mr,5?Y,5?YO%)gQpO,5?YOOQ?Mr1G2d1G2dP!&_Q7[O'#InPOQ?Mr-E<l-E<lO%*VQ7[O,5?]OOQ?Mr-E<o-E<oO%*xQ7[O,5?_OOQ?Mr-E<q-E<qO%+SQpO1G2tO%+ZQpO'#CrO%+qQ7[O'#J}O%+xQ^O'#EqOOQ?Mr1G2]1G2]O%,SQWO'#ImO%,hQWO,5@rO%,hQWO,5@rO%,pQWO,5@rO%,{QWO,5@rOOQO1G2_1G2_O%-ZQ7[O1G2^O!+hQ7[O1G2^O%-kQ$ISO'#IoO%-xQWO,5@sO!&_Q7[O,5@sO%.QQpO,5@sOOQ?Mr1G2b1G2bOOQ?Mp,5<{,5<{OOQ?Mp,5<|,5<|O$(PQWO,5<|OCcQWO,5<|O!A}Q`O,5<{OOQO'#Gd'#GdO%.[QWO,5<}OOQ?Mp,5=P,5=PO$(PQWO,5=SOOQO,5?[,5?[OOQO-E<n-E<nOOQ?Mv1G2f1G2fO!5iQ`O,5<{O%.dQWO,5<|O$!xQWO,5<}O%.oQ`O,5<|O!+hQ7[O'#IqO%/`Q7[O1G2pO!+hQ7[O'#IsO%0RQ7[O1G2rO%0]Q7[O1G5lO%0gQ7[O1G5lOOQO,5?a,5?aOOQO-E<s-E<sOOQO1G.{1G.{O!9UQ`O,59tO%[Q^O,59tOOQ?Mr,5<h,5<hO%0tQWO1G2XO!+hQ7[O1G2`O%0yQ?NdO7+'kOOQ?Mr7+'k7+'kO!$[Q^O7+'kO%1mQWO,5;]OOQ?Mp,5?c,5?cOOQ?Mp-E<u-E<uO%1rQpO'#KYO#&wQWO7+(bO4UQrO7+(bO$AYQWO7+(bO%1|Q?NbO'#CiO%2aQ?NbO,5=QO%3RQWO,5=QOOQ?Mp1G5j1G5jOOQU7+$a7+$aO!ArQ?MxO7+$aO!A}Q`O7+$aO!$[Q^O7+&^O%3WQWO'#I|O%3oQWO,5@{OOQO1G3d1G3dO9^QWO,5@{O%3oQWO,5@{O%3wQWO,5@{OOQO,5?i,5?iOOQO-E<{-E<{OOQ?Mr7+'S7+'SO%3|QWO7+(}O9hQ?MxO7+(}O9^QWO7+(}O@fQWO7+(}OOQU7+(m7+(mO%4RQ?NbO7+(jO!&_Q7[O7+(jO%4]QpO7+(kOOQU7+(k7+(kO!&_Q7[O7+(kO%4dQWO'#K^O%4oQWO,5=iOOQO,5?e,5?eOOQO-E<w-E<wOOQU7+(p7+(pO%6RQ`O'#HWOOQU1G3]1G3]O!&_Q7[O1G3]O%[Q^O1G3]O%6YQWO1G3]O%6eQ7[O1G3]O9hQ?MxO1G3_O$!}QWO1G3_O9RQWO1G3_O!A}Q`O1G3_O!BVQ7[O1G3_O%6sQWO'#I{O%7XQWO,5@yO%7aQ`O,5@yOOQ?Mp1G3`1G3`OOQU7+$V7+$VO@fQWO7+$VO9hQ?MxO7+$VO%7lQWO7+$VO%[Q^O1G6hO%[Q^O1G6iO%7qQ?MxO1G6hO%7{Q^O1G3gO%8SQWO1G3gO%8XQ^O1G3gOOQU7+)P7+)PO9hQ?MxO7+)ZO`Q^O7+)]OOQU'#Kd'#KdOOQU'#JO'#JOO%8`Q^O,5>[OOQU,5>[,5>[O%[Q^O'#HqO%8mQWO'#HsOOQU,5>b,5>bO9WQWO,5>bOOQU,5>d,5>dOOQU7+)f7+)fOOQU7+)l7+)lOOQU7+)p7+)pOOQU7+)r7+)rO%8rQ`O1G5wO%9WQ07bO1G0wO%9bQWO1G0wOOQO1G/p1G/pO%9mQ07bO1G/pO>tQWO1G/pO!(oQ^O'#DjOOQO,5>{,5>{OOQO-E<_-E<_OOQO,5?R,5?ROOQO-E<e-E<eO!A}Q`O1G/pOOQO-E<a-E<aOOQ?Mv1G0Y1G0YOOQ?Mr7+%r7+%rO#&wQWO7+%rOOQ?Mr7+&]7+&]O>tQWO7+&]O!A}Q`O7+&]OOQO7+%u7+%uO$>`Q?NdO7+&UOOQO7+&U7+&UO%[Q^O7+&UO%9wQ?MxO7+&UO!ArQ?MxO7+%uO!A}Q`O7+%uO%:SQ?MxO7+&UO%:bQ?NdO7++mO%[Q^O7++mO%:rQWO7++lO%:rQWO7++lOOQO1G4o1G4oO9WQWO1G4oO%:zQWO1G4oOOQQ7+%z7+%zO#&wQWO<<K|O4UQrO<<K|O%;YQWO<<K|OOQU<<K|<<K|O!&_Q7[O<<K|O%[Q^O<<K|O%;bQWO<<K|O%;mQ?NdO,5?]O%=uQ?NdO,5?_O%?}Q?NdO1G2^O%B]Q?NdO1G2pO%DeQ?NdO1G2rO%FmQrO,5>|O%[Q^O,5>|OOQO-E<`-E<`O%FwQWO1G5xOOQ?Mr<<JR<<JRO%GPQ07bO1G0rO%IWQ07bO1G0|O%I_Q07bO1G0|O%K`Q07bO1G0|O%KgQ07bO1G0|O%MhQ07bO1G0|O& iQ07bO1G0|O& pQ07bO1G0|O& wQ07bO1G0|O&#xQ07bO1G0|O&$PQ07bO1G0|O&$WQ?NdO<<JeO&&OQ07bO1G0|O&&{Q07bO1G0|O&'{Q07bO'#JgO&*OQ07bO1G1bO&*]Q07bO1G0RO&*gQ7[O,5?POOQO-E<c-E<cO!(oQ^O'#FpOOQO'#KU'#KUOOQO1G1t1G1tO&*qQWO1G1sO&*vQ07bO,5?WOOOS7+'g7+'gOOOO1G/W1G/WOOQ?Mr1G4t1G4tO!+hQ7[O7+(`O&-WQrO'#CiO&-bQWO,5?XO9WQWO,5?XOOQO-E<k-E<kO&-pQWO1G6^O&-pQWO1G6^O&-xQWO1G6^O&.TQ7[O7+'xO&.eQpO,5?ZO&.oQWO,5?ZO!&_Q7[O,5?ZOOQO-E<m-E<mO&.tQpO1G6_O&/OQWO1G6_OOQ?Mp1G2h1G2hO$(PQWO1G2hOOQ?Mp1G2g1G2gO&/WQWO1G2iO!&_Q7[O1G2iOOQ?Mp1G2n1G2nO!A}Q`O1G2gOCcQWO1G2hO&/]QWO1G2iO&/eQWO1G2hO$!xQWO1G2iO&0XQ7[O,5?]OOQ?Mr-E<p-E<pO&0zQ7[O,5?_OOQ?Mr-E<r-E<rO!+hQ7[O7++WOOQ?Mr1G/`1G/`O&1UQWO1G/`OOQ?Mr7+'s7+'sO&1ZQ7[O7+'zO&1kQ?NdO<<KVOOQ?Mr<<KV<<KVO&2_QWO1G0wO!&_Q7[O'#IvO&2dQWO,5@tO&4fQrO<<K|O!&_Q7[O1G2lOOQU<<G{<<G{O!ArQ?MxO<<G{O&4mQ?NdO<<IxOOQ?Mr<<Ix<<IxOOQO,5?h,5?hO&5aQWO,5?hO&5fQWO,5?hOOQO-E<z-E<zO&5tQWO1G6gO&5tQWO1G6gO9^QWO1G6gO@fQWO<<LiOOQU<<Li<<LiO&5|QWO<<LiO9hQ?MxO<<LiOOQU<<LU<<LUO%4RQ?NbO<<LUOOQU<<LV<<LVO%4]QpO<<LVO&6RQ`O'#IxO&6^QWO,5@xO!(oQ^O,5@xOOQU1G3T1G3TO%+xQ^O'#JqOOQO'#Iz'#IzO9hQ?MxO'#IzO&6fQ`O,5=rOOQU,5=r,5=rO&6mQ`O'#EdO&7RQ`O'#GcO&7WQWO7+(wO&7]QWO7+(wOOQU7+(w7+(wO!&_Q7[O7+(wO%[Q^O7+(wO&7eQWO7+(wOOQU7+(y7+(yO9hQ?MxO7+(yO$!}QWO7+(yO9RQWO7+(yO!A}Q`O7+(yO&7pQWO,5?gOOQO-E<y-E<yOOQO'#HZ'#HZO&7{QWO1G6eO9hQ?MxO<<GqOOQU<<Gq<<GqO@fQWO<<GqO&8TQWO7+,SO&8YQWO7+,TO%[Q^O7+,SO%[Q^O7+,TOOQU7+)R7+)RO&8_QWO7+)RO&8dQ^O7+)RO&8kQWO7+)ROOQU<<Lu<<LuOOQU<<Lw<<LwOOQU-E<|-E<|OOQU1G3v1G3vO&8pQWO,5>]OOQU,5>_,5>_O&8uQWO1G3|O9WQWO7+&cO!(oQ^O7+&cOOQO7+%[7+%[O&8zQ07bO1G6UO>tQWO7+%[OOQ?Mr<<I^<<I^OOQ?Mr<<Iw<<IwO>tQWO<<IwOOQO<<Ip<<IpO$>`Q?NdO<<IpO%[Q^O<<IpOOQO<<Ia<<IaO!ArQ?MxO<<IaO&9UQ?MxO<<IpO&9aQ?NdO<= XO&9qQWO<= WOOQO7+*Z7+*ZO9WQWO7+*ZOOQUANAhANAhO&9yQrOANAhO!&_Q7[OANAhO#&wQWOANAhO4UQrOANAhO&:QQWOANAhO%[Q^OANAhO&:YQ?NdO7+'xO&<hQ?NdO,5?]O&>pQ?NdO,5?_O&@xQ?NdO7+'zO&CWQrO1G4hO&CbQ07bO7+&^O&EcQ07bO,5=UO&GgQ07bO,5=WO&GwQ07bO,5=UO&HXQ07bO,5=WO&HiQ07bO,59rO&JlQ07bO,5<iO&LlQ07bO,5<kO&N}Q07bO,5<yO'!pQ07bO7+'jO'!}Q07bO7+'kO'#[QWO,5<[OOQO7+'_7+'_O'#aQ7[O<<KzOOQO1G4s1G4sO'#hQWO1G4sO'#sQWO1G4sO'$RQWO7++xO'$RQWO7++xO!&_Q7[O1G4uO'$ZQpO1G4uO'$eQWO7++yOOQ?Mp7+(S7+(SO'$mQWO7+(TO'$xQpO7+(TOOQ?Mp7+(R7+(RO$(PQWO7+(SO'%PQWO7+(TO!&_Q7[O7+(TOCcQWO7+(SO'%UQWO7+(TO'%^Q7[O<<NrOOQ?Mr7+$z7+$zO'%hQpO,5?bOOQO-E<t-E<tO'%rQ?NbO7+(WOOQUAN=gAN=gO9^QWO1G5SOOQO1G5S1G5SO'&SQWO1G5SO'&XQWO7+,RO'&XQWO7+,RO9hQ?MxOANBTO@fQWOANBTOOQUANBTANBTOOQUANApANApOOQUANAqANAqO'&aQWO,5?dOOQO-E<v-E<vO'&lQ07bO1G6dOOQO,5?f,5?fOOQO-E<x-E<xOOQU1G3^1G3^O%+xQ^O,5<}O'&vQWO,5<}OOQU<<Lc<<LcO!&_Q7[O<<LcO&7WQWO<<LcO'&{QWO<<LcO%[Q^O<<LcOOQU<<Le<<LeO9hQ?MxO<<LeO$!}QWO<<LeO9RQWO<<LeO''TQ`O1G5RO''`QWO7+,POOQUAN=]AN=]O9hQ?MxOAN=]OOQU<= n<= nOOQU<= o<= oO''hQWO<= nO''mQWO<= oOOQU<<Lm<<LmO''rQWO<<LmO''wQ^O<<LmOOQU1G3w1G3wO>tQWO7+)hO'(OQWO<<I}O'(ZQ07bO<<I}OOQO<<Hv<<HvOOQ?MrAN?cAN?cOOQOAN?[AN?[O$>`Q?NdOAN?[OOQOAN>{AN>{O%[Q^OAN?[OOQO<<Mu<<MuOOQUG27SG27SO!&_Q7[OG27SO#&wQWOG27SO'(eQrOG27SO4UQrOG27SO'(lQWOG27SO'(tQ07bO<<JeO')RQ07bO1G2^O'*tQ07bO,5?]O',tQ07bO,5?_O'.tQ07bO1G2pO'0tQ07bO1G2rO'2tQ07bO<<KVO'3RQ07bO<<IxOOQO1G1v1G1vO!+hQ7[OANAfOOQO7+*_7+*_O'3`QWO7+*_O'3kQWO<= dO'3sQpO7+*aOOQ?Mp<<Ko<<KoO$(PQWO<<KoOCcQWO<<KoO'3}QWO<<KoOOQ?Mp<<Kn<<KnO'4YQpO<<KoO$(PQWO<<KnO'4aQWO<<KoO!&_Q7[O<<KoOOQO7+*n7+*nO9^QWO7+*nO'4fQWO<= mOOQUG27oG27oO9hQ?MxOG27oO!(oQ^O1G5OO'4nQWO7+,OO&7WQWOANA}OOQUANA}ANA}O!&_Q7[OANA}O'4vQWOANA}OOQUANBPANBPO9hQ?MxOANBPO$!}QWOANBPOOQO'#H['#H[OOQO7+*m7+*mOOQUG22wG22wOOQUANEYANEYOOQUANEZANEZOOQUANBXANBXO'5OQWOANBXOOQU<<MS<<MSO!(oQ^OAN?iOOQOG24vG24vO$>`Q?NdOG24vO#&wQWOLD,nOOQULD,nLD,nO!&_Q7[OLD,nO'5TQrOLD,nO'5[Q07bO7+'xO'6}Q07bO,5?]O'8}Q07bO,5?_O':}Q07bO7+'zO'<pQ7[OG27QOOQO<<My<<MyOOQ?MpANAZANAZO$(PQWOANAZOCcQWOANAZO'=QQWOANAZOOQ?MpANAYANAYO'=]QpOANAZOOQO<<NY<<NYOOQULD-ZLD-ZO'=dQ07bO7+*jOOQUG27iG27iO&7WQWOG27iO!&_Q7[OG27iOOQUG27kG27kO9hQ?MxOG27kOOQUG27sG27sO'=nQ07bOG25TOOQOLD*bLD*bOOQU!$(!Y!$(!YO#&wQWO!$(!YO!&_Q7[O!$(!YO'=xQ?NdOG27QOOQ?MpG26uG26uO$(PQWOG26uOCcQWOG26uO'@WQWOG26uOOQULD-TLD-TO&7WQWOLD-TOOQULD-VLD-VOOQU!)9Et!)9EtO#&wQWO!)9EtOOQ?MpLD,aLD,aO$(PQWOLD,aOCcQWOLD,aOOQU!$(!o!$(!oOOQU!.K;`!.K;`O'@cQ07bOG27QOOQ?Mp!$( {!$( {O$(PQWO!$( {OOQ?Mp!)9Eg!)9EgO!(oQ^O'#DwO1PQWO'#EUO'BUQrO'#JmO'B]QMnO'#DsO'BdQ^O'#D{O'BkQrO'#CiO'ERQrO'#CiO!(oQ^O'#D}O'EcQ^O,5;WO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O'#IlO'GfQWO,5<gO!(oQ^O,5;bO'GnQ7[O,5;bO'IXQ7[O,5;bO!(oQ^O,5;vO!&_Q7[O'#GjO'GnQ7[O'#GjO!&_Q7[O'#GlO'GnQ7[O'#GlO1SQWO'#DWO1SQWO'#DWO!&_Q7[O'#F}O'GnQ7[O'#F}O!&_Q7[O'#GPO'GnQ7[O'#GPO!&_Q7[O'#G_O'GnQ7[O'#G_O!(oQ^O,5:gO'I`Q`O'#D[O!(oQ^O,5@jO'EcQ^O1G0rO'IjQ07bO'#CiO!(oQ^O1G2OO!&_Q7[O'#IqO'GnQ7[O'#IqO!&_Q7[O'#IsO'GnQ7[O'#IsO'ItQpO'#CrO!&_Q7[O,5<rO'GnQ7[O,5<rO'EcQ^O1G2PO!(oQ^O7+&yO!&_Q7[O1G2^O'GnQ7[O1G2^O!&_Q7[O'#IqO'GnQ7[O'#IqO!&_Q7[O'#IsO'GnQ7[O'#IsO!&_Q7[O1G2`O'GnQ7[O1G2`O'EcQ^O7+'kO'EcQ^O7+&^O!&_Q7[OANAfO'GnQ7[OANAfO'JXQWO'#ElO'J^QWO'#ElO'JfQWO'#F[O'JkQWO'#EvO'JpQWO'#KOO'J{QWO'#J|O'KWQWO,5;WO'K]Q7[O,5<dO'KdQWO'#GWO'KiQWO'#GWO'KnQWO,5<eO'KvQWO,5;WO'LOQ07bO1G1_O'LVQWO,5<rO'L[QWO,5<rO'LaQWO,5<tO'LfQWO,5<tO'LkQWO1G2PO'LpQWO1G0rO'LuQ7[O<<KzO'L|Q7[O<<KzO7eQ7[O'#FzO9RQWO'#FyOAaQWO'#EkO!(oQ^O,5;sO!3SQWO'#GWO!3SQWO'#GWO!3SQWO'#GYO!3SQWO'#GYO!+hQ7[O7+(`O!+hQ7[O7+(`O%+SQpO1G2tO%+SQpO1G2tO!&_Q7[O,5=YO!&_Q7[O,5=Y",
  stateData: "'NQ~O'wOS'xOSTOS'yRQ~OPYOQYOSfOY!VOaqOdzOeyOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![XO!fuO!iZO!lYO!mYO!nYO!pvO!rwO!uxO!y]O#t!PO$V|O%e}O%g!QO%i!OO%j!OO%k!OO%n!RO%p!SO%s!TO%t!TO%v!UO&S!WO&Y!XO&[!YO&^!ZO&`![O&c!]O&i!^O&o!_O&q!`O&s!aO&u!bO&w!cO(OSO(QTO(TUO([VO(j[O(yiO~OWtO~P`OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(O!dO(QTO(TUO([VO(j[O(yiO~Oa!wOp!nO!P!oO!_!yO!`!vO!a!vO!y;QO#Q!pO#R!pO#S!xO#T!pO#U!pO#X!zO#Y!zO(P!lO(QTO(TUO(`!mO(j!sO~O'y!{O~OP]XR]X[]Xa]Xo]X}]X!P]X!Y]X!i]X!m]X#O]X#P]X#]]X#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X'u]X([]X(m]X(t]X(u]X~O!d%PX~P(qO_!}O(Q#PO(R!}O(S#PO~O_#QO(S#PO(T#PO(U#QO~Ou#SO!R#TO(]#TO(^#VO~OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(O;UO(QTO(TUO([VO(j[O(yiO~O!X#ZO!Y#WO!V(cP!V(qP~P+}O!Z#cO~P`OPYOQYOSfOd!jOe!iOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(QTO(TUO([VO(j[O(yiO~Om#mO!X#iO!y]O#f#lO#g#iO(O;VO!h(nP~P.iO!i#oO(O#nO~O!u#sO!y]O%e#tO~O#h#uO~O!d#vO#h#uO~OP$[OR#zO[$cOo$aO}#yO!P#{O!Y$_O!i#xO!m$[O#O$RO#k$OO#l$PO#m$PO#n$PO#o$QO#p$RO#q$RO#r$bO#s$RO#u$SO#w$UO#y$WO#z$XO([VO(m$YO(t#|O(u#}O~Oa(aX'u(aX's(aX!h(aX!V(aX![(aX%f(aX!d(aX~P1qO#P$dO#]$eO$P$eOP(bXR(bX[(bXo(bX}(bX!P(bX!Y(bX!i(bX!m(bX#O(bX#k(bX#l(bX#m(bX#n(bX#o(bX#p(bX#q(bX#r(bX#s(bX#u(bX#w(bX#y(bX#z(bX([(bX(m(bX(t(bX(u(bX![(bX%f(bX~Oa(bX'u(bX's(bX!V(bX!h(bXs(bX!d(bX~P4UO#]$eO~O$[$hO$^$gO$e$mO~OSfO![$nO$h$oO$j$qO~Oh%VOm%WOo%XOp$tOq$tOw%YOy%ZO{%[O!P${O![$|O!f%aO!i$xO#g%bO$V%_O$r%]O$t%^O$w%`O(O$sO(QTO(TUO([$uO(t$}O(u%POg(XP~O!i%cO~O!P%fO![%gO(O%eO~O!d%kO~Oa%lO'u%lO~O}%pO~P%[O(P!lO~P%[O%k%tO~P%[Oh%VO!i%cO(O%eO(P!lO~Oe%{O!i%cO(O%eO~O#s$RO~O}&QO![%}O!i&PO%g&TO(O%eO(P!lO(QTO(TUO`)SP~O!u#sO~O%p&VO!P)OX![)OX(O)OX~O(O&WO~O!r&]O#t!PO%g!QO%i!OO%j!OO%k!OO%n!RO%p!SO%s!TO%t!TO~Od&bOe&aO!u&_O%e&`O%x&^O~P;|Od&eOeyO![&dO!r&]O!uxO!y]O#t!PO%e}O%i!OO%j!OO%k!OO%n!RO%p!SO%s!TO%t!TO%v!UO~Ob&hO#]&kO%g&fO(P!lO~P=RO!i&lO!r&pO~O!i#oO~O![XO~Oa%lO't&xO'u%lO~Oa%lO't&{O'u%lO~Oa%lO't&}O'u%lO~O's]X!V]Xs]X!h]X&W]X![]X%f]X!d]X~P(qO!_'[O!`'TO!a'TO(P!lO(QTO(TUO~Op'RO!P'QO!X'UO(`'PO!Z(dP!Z(sP~P@YOk'_O![']O(O%eO~Oe'dO!i%cO(O%eO~O}&QO!i&PO~Op!nO!P!oO!y;QO#Q!pO#R!pO#T!pO#U!pO(P!lO(QTO(TUO(`!mO(j!sO~O!_'jO!`'iO!a'iO#S!pO#X'kO#Y'kO~PAtOa%lOh%VO!d#vO!i%cO'u%lO(m'mO~O!m'qO#]'oO~PCSOp!nO!P!oO(QTO(TUO(`!mO(j!sO~O![XOp(hX!P(hX!_(hX!`(hX!a(hX!y(hX#Q(hX#R(hX#S(hX#T(hX#U(hX#X(hX#Y(hX(P(hX(Q(hX(T(hX(`(hX(j(hX~O!`'iO!a'iO(P!lO~PCrO'z'uO'{'uO'|'wO~O_!}O(Q'yO(R!}O(S'yO~O_#QO(S'yO(T'yO(U#QO~Ou#SO!R#TO(]#TO(^'}O~O!X(PO!V'SX!V'YX!Y'SX!Y'YX~P+}O!Y(RO!V(cX~OP$[OR#zO[$cOo$aO}#yO!P#{O!Y(RO!i#xO!m$[O#O$RO#k$OO#l$PO#m$PO#n$PO#o$QO#p$RO#q$RO#r$bO#s$RO#u$SO#w$UO#y$WO#z$XO([VO(m$YO(t#|O(u#}O~O!V(cX~PGfO!V(WO~O!V(pX!Y(pX!d(pX!h(pX(m(pX~O#](pX#h#aX!Z(pX~PIiO#](XO!V(rX!Y(rX~O!Y(YO!V(qX~O!V(]O~O#]$eO~PIiO!Z(^O~P`OR#zO}#yO!P#{O!i#xO([VOP!ka[!kao!ka!Y!ka!m!ka#O!ka#k!ka#l!ka#m!ka#n!ka#o!ka#p!ka#q!ka#r!ka#s!ka#u!ka#w!ka#y!ka#z!ka(m!ka(t!ka(u!ka~Oa!ka'u!ka's!ka!V!ka!h!kas!ka![!ka%f!ka!d!ka~PKPO!h(_O~O!d#vO#](`O(m'mO!Y(oXa(oX'u(oX~O!h(oX~PMlO!P%fO![%gO!y]O#f(eO#g(dO(O%eO~O!Y(fO!h(nX~O!h(hO~O!P%fO![%gO#g(dO(O%eO~OP(bXR(bX[(bXo(bX}(bX!P(bX!Y(bX!i(bX!m(bX#O(bX#k(bX#l(bX#m(bX#n(bX#o(bX#p(bX#q(bX#r(bX#s(bX#u(bX#w(bX#y(bX#z(bX([(bX(m(bX(t(bX(u(bX~O!d#vO!h(bX~P! YOR(jO}(iO!i#xO#P$dO!y!xa!P!xa~O!u!xa%e!xa![!xa#f!xa#g!xa(O!xa~P!#ZO!u(nO~OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![XO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(O!dO(QTO(TUO([VO(j[O(yiO~Oh%VOm%WOo%XOp$tOq$tOw%YOy%ZO{;nO!P${O![$|O!f=OO!i$xO#g;tO$V%_O$r;pO$t;rO$w%`O(O(rO(QTO(TUO([$uO(t$}O(u%PO~O#h(tO~O!X(vO!h(fP~P%[O(`(xO(j[O~O!P(zO!i#xO(`(xO(j[O~OP;POQ;POSfOd<zOe!iOmkOo;POpkOqkOwkOy;PO{;PO!PWO!TkO!UkO![!eO!f;SO!iZO!l;PO!m;PO!n;PO!p;TO!r;WO!u!hO$V!kO(O)XO(QTO(TUO([VO(j[O(y<xO~O!Y$_Oa$oa'u$oa's$oa!h$oa!V$oa![$oa%f$oa!d$oa~O#t)`O~P!&_Oh%VOm%WOo%XOp$tOq$tOw%YOy%ZO{%[O!P${O![$|O!f%aO!i$xO#g%bO$V%_O$r%]O$t%^O$w%`O(O(rO(QTO(TUO([$uO(t$}O(u%PO~Og(kP~P!+hO})eO!d)dO![$]X$Y$]X$[$]X$^$]X$e$]X~O!d)dO![(vX$Y(vX$[(vX$^(vX$e(vX~O})eO~P!-qO})eO![(vX$Y(vX$[(vX$^(vX$e(vX~O![)gO$Y)kO$[)fO$^)fO$e)lO~O!X)oO~P!(oO$[$hO$^$gO$e)sO~Ok$xX}$xX!P$xX#P$xX(t$xX(u$xX~OgjXg$xXkjX!YjX#]jX~P!/gOu)uO(])vO(^)xO~Ok*RO})zO!P){O(t$}O(u%PO~Og)yO~P!0kOg*SO~Oh%VOm%WOo%XOp$tOq$tOw%YOy%ZO{;nO!P*UO![*VO!f=OO!i$xO#g;tO$V%_O$r;pO$t;rO$w%`O(QTO(TUO([$uO(t$}O(u%PO~O!X*YO(O*TO!h(zP~P!1YO#h*[O~O!i*]O~Oh%VOm%WOo%XOp$tOq$tOw%YOy%ZO{;nO!P${O![$|O!f=OO!i$xO#g;tO$V%_O$r;pO$t;rO$w%`O(O*_O(QTO(TUO([$uO(t$}O(u%PO~O!X*bO!V({P~P!3XOo*nO!P*fO!_*lO!`*eO!a*eO!i*]O#X*mO%]*hO(P!lO(`!mO~O!Z*kO~P!4|O#P$dOk(ZX}(ZX!P(ZX(t(ZX(u(ZX!Y(ZX#](ZX~Og(ZX#}(ZX~P!5uOk*sO#]*rOg(YX!Y(YX~O!Y*tOg(XX~O(O&WOg(XP~Op*wO~O!i*|O~O(O(rO~Om+QO!P%fO!X#iO![%gO!y]O#f#lO#g#iO(O%eO!h(nP~O!d#vO#h+RO~O!P%fO!X+TO!Y(YO![%gO(O%eO!V(qP~Op'XO!P+VO!X+UO(QTO(TUO(`(xO~O!Z(sP~P!8uO!Y+WOa)PX'u)PX~OP$[OR#zO[$cOo$aO}#yO!P#{O!i#xO!m$[O#O$RO#k$OO#l$PO#m$PO#n$PO#o$QO#p$RO#q$RO#r$bO#s$RO#u$SO#w$UO#y$WO#z$XO([VO(m$YO(t#|O(u#}O~Oa!ga!Y!ga'u!ga's!ga!V!ga!h!gas!ga![!ga%f!ga!d!ga~P!9mOR#zO}#yO!P#{O!i#xO([VOP!oa[!oao!oa!Y!oa!m!oa#O!oa#k!oa#l!oa#m!oa#n!oa#o!oa#p!oa#q!oa#r!oa#s!oa#u!oa#w!oa#y!oa#z!oa(m!oa(t!oa(u!oa~Oa!oa'u!oa's!oa!V!oa!h!oas!oa![!oa%f!oa!d!oa~P!<TOR#zO}#yO!P#{O!i#xO([VOP!qa[!qao!qa!Y!qa!m!qa#O!qa#k!qa#l!qa#m!qa#n!qa#o!qa#p!qa#q!qa#r!qa#s!qa#u!qa#w!qa#y!qa#z!qa(m!qa(t!qa(u!qa~Oa!qa'u!qa's!qa!V!qa!h!qas!qa![!qa%f!qa!d!qa~P!>kOh%VOk+aO![']O%f+`O~O!d+cOa(WX![(WX'u(WX!Y(WX~Oa%lO![XO'u%lO~Oh%VO!i%cO~Oh%VO!i%cO(O%eO~O!d#vO#h(tO~Ob+nO%g+oO(O+kO(QTO(TUO!Z)TP~O!Y+pO`)SX~O[+tO~O`+uO~O![%}O(O%eO(P!lO`)SP~Oh%VO#]+zO~Oh%VOk+}O![$|O~O![,PO~O},RO![XO~O%k%tO~O!u,WO~Oe,]O~Ob,^O(O#nO(QTO(TUO!Z)RP~Oe%{O~O%g!QO(O&WO~P=RO[,cO`,bO~OPYOQYOSfOdzOeyOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO!fuO!iZO!lYO!mYO!nYO!pvO!uxO!y]O%e}O(QTO(TUO([VO(j[O(yiO~O![!eO!r!gO$V!kO(O!dO~P!EkO`,bOa%lO'u%lO~OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!u!hO$V!kO(O!dO(QTO(TUO([VO(j[O(yiO~Oa,hO!rwO#t!OO%i!OO%j!OO%k!OO~P!HTO!i&lO~O&Y,nO~O![,pO~O&k,rO&m,sOP&haQ&haS&haY&haa&had&hae&ham&hao&hap&haq&haw&hay&ha{&ha!P&ha!T&ha!U&ha![&ha!f&ha!i&ha!l&ha!m&ha!n&ha!p&ha!r&ha!u&ha!y&ha#t&ha$V&ha%e&ha%g&ha%i&ha%j&ha%k&ha%n&ha%p&ha%s&ha%t&ha%v&ha&S&ha&Y&ha&[&ha&^&ha&`&ha&c&ha&i&ha&o&ha&q&ha&s&ha&u&ha&w&ha's&ha(O&ha(Q&ha(T&ha([&ha(j&ha(y&ha!Z&ha&a&hab&ha&f&ha~O(O,xO~Oh!bX!Y!OX!Z!OX!d!OX!d!bX!i!bX#]!OX~O!Y!bX!Z!bX~P# ZO!d,}O#],|Oh(eX!Y#eX!Y(eX!Z#eX!Z(eX!d(eX!i(eX~Oh%VO!d-PO!i%cO!Y!^X!Z!^X~Op!nO!P!oO(QTO(TUO(`!mO~OP;POQ;POSfOd<zOe!iOmkOo;POpkOqkOwkOy;PO{;PO!PWO!TkO!UkO![!eO!f;SO!iZO!l;PO!m;PO!n;PO!p;TO!r;WO!u!hO$V!kO(QTO(TUO([VO(j[O(y<xO~O(O;zO~P##_O!Y-TO!Z(dX~O!Z-VO~O!d,}O#],|O!Y#eX!Z#eX~O!Y-WO!Z(sX~O!Z-YO~O!`-ZO!a-ZO(P!lO~P#!|O!Z-^O~P'_Ok-aO![']O~O!V-fO~Op!xa!_!xa!`!xa!a!xa#Q!xa#R!xa#S!xa#T!xa#U!xa#X!xa#Y!xa(P!xa(Q!xa(T!xa(`!xa(j!xa~P!#ZO!m-kO#]-iO~PCSO!`-mO!a-mO(P!lO~PCrOa%lO#]-iO'u%lO~Oa%lO!d#vO#]-iO'u%lO~Oa%lO!d#vO!m-kO#]-iO'u%lO(m'mO~O'z'uO'{'uO'|-rO~Os-sO~O!V'Sa!Y'Sa~P!9mO!X-wO!V'SX!Y'SX~P%[O!Y(RO!V(ca~O!V(ca~PGfO!Y(YO!V(qa~O!P%fO!X-{O![%gO(O%eO!V'YX!Y'YX~O#]-}O!Y(oa!h(oaa(oa'u(oa~O!d#vO~P#+eO!Y(fO!h(na~O!P%fO![%gO#g.RO(O%eO~Om.WO!P%fO!X.TO![%gO!y]O#f.VO#g.TO(O%eO!Y']X!h']X~OR.[O!i#xO~Oh%VOk._O![']O%f.^O~Oa#`i!Y#`i'u#`i's#`i!V#`i!h#`is#`i![#`i%f#`i!d#`i~P!9mOk=UO})zO!P){O(t$}O(u%PO~O#h#[aa#[a#]#[a'u#[a!Y#[a!h#[a![#[a!V#[a~P#.aO#h(ZXP(ZXR(ZX[(ZXa(ZXo(ZX!i(ZX!m(ZX#O(ZX#k(ZX#l(ZX#m(ZX#n(ZX#o(ZX#p(ZX#q(ZX#r(ZX#s(ZX#u(ZX#w(ZX#y(ZX#z(ZX'u(ZX([(ZX(m(ZX!h(ZX!V(ZX's(ZXs(ZX![(ZX%f(ZX!d(ZX~P!5uO!Y.lO!h(fX~P!9mO!h.oO~O!V.qO~OP$[OR#zO}#yO!P#{O!i#xO!m$[O([VO[#jia#jio#ji!Y#ji#O#ji#l#ji#m#ji#n#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji'u#ji(m#ji(t#ji(u#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#k#ji~P#1|O#k$OO~P#1|OP$[OR#zOo$aO}#yO!P#{O!i#xO!m$[O#k$OO#l$PO#m$PO#n$PO([VO[#jia#ji!Y#ji#O#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji'u#ji(m#ji(t#ji(u#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#o#ji~P#4kO#o$QO~P#4kOP$[OR#zO[$cOo$aO}#yO!P#{O!i#xO!m$[O#O$RO#k$OO#l$PO#m$PO#n$PO#o$QO#p$RO#q$RO#r$bO#s$RO([VOa#ji!Y#ji#w#ji#y#ji#z#ji'u#ji(m#ji(t#ji(u#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#u#ji~P#7YOP$[OR#zO[$cOo$aO}#yO!P#{O!i#xO!m$[O#O$RO#k$OO#l$PO#m$PO#n$PO#o$QO#p$RO#q$RO#r$bO#s$RO#u$SO([VO(u#}Oa#ji!Y#ji#y#ji#z#ji'u#ji(m#ji(t#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#w$UO~P#9pO#w#ji~P#9pO#u$SO~P#7YOP$[OR#zO[$cOo$aO}#yO!P#{O!i#xO!m$[O#O$RO#k$OO#l$PO#m$PO#n$PO#o$QO#p$RO#q$RO#r$bO#s$RO#u$SO#w$UO([VO(t#|O(u#}Oa#ji!Y#ji#z#ji'u#ji(m#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#y#ji~P#<fO#y$WO~P#<fOP]XR]X[]Xo]X}]X!P]X!i]X!m]X#O]X#P]X#]]X#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X([]X(m]X(t]X(u]X!Y]X!Z]X~O#}]X~P#?TOP$[OR#zO[;hOo;fO}#yO!P#{O!i#xO!m$[O#O;]O#k;YO#l;ZO#m;ZO#n;ZO#o;[O#p;]O#q;]O#r;gO#s;]O#u;^O#w;`O#y;bO#z;cO([VO(m$YO(t#|O(u#}O~O#}.sO~P#AbO#P$dO#];iO$P;iO#}(bX!Z(bX~P! YOa'`a!Y'`a'u'`a's'`a!h'`a!V'`as'`a!['`a%f'`a!d'`a~P!9mO[#jia#jio#ji!Y#ji#O#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji'u#ji(m#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~OP$[OR#zO}#yO!P#{O!i#xO!m$[O#k$OO#l$PO#m$PO#n$PO([VO(t#ji(u#ji~P#DdOk=UO})zO!P){O(t$}O(u%POP#jiR#ji!i#ji!m#ji#k#ji#l#ji#m#ji#n#ji([#ji~P#DdO!Y.wOg(kX~P!0kOg.yO~Oa$Oi!Y$Oi'u$Oi's$Oi!V$Oi!h$Ois$Oi![$Oi%f$Oi!d$Oi~P!9mO$[.zO$^.zO~O$[.{O$^.{O~O!d)dO#].|O![$bX$Y$bX$[$bX$^$bX$e$bX~O!X.}O~O![)gO$Y/PO$[)fO$^)fO$e/QO~O!Y;dO!Z(aX~P#AbO!Z/RO~O!d)dO$e(vX~O$e/TO~Ou)uO(])vO(^/WO~O!V/[O~P!&_O(t$}Ok%^a}%^a!P%^a(u%^a!Y%^a#]%^a~Og%^a#}%^a~P#K^O(u%POk%`a}%`a!P%`a(t%`a!Y%`a#]%`a~Og%`a#}%`a~P#LPO!YfX!dfX!hfX!h$xX(mfX~P!/gO!X/eO!Y(YO(O/dO!V(qP!V({P~P!1YOo*nO!_*lO!`*eO!a*eO!i*]O#X*mO%]*hO(P!lO~Op'XO!P/fO!X+UO!Z*kO(QTO(TUO(`;wO!Z(sP~P#MjO!h/gO~P#.aO!Y/hO!d#vO(m'mO!h(zX~O!h/mO~O!P%fO!X*YO![%gO(O%eO!h(zP~O#h/oO~O!V$xX!Y$xX!d%PX~P!/gO!Y/pO!V({X~P#.aO!d/rO~O!V/tO~Oh%VOo/xO!d#vO!i%cO(m'mO~O(O/zO~O!d+cO~Oa%lO!Y0OO'u%lO~O!Z0QO~P!4|O!`0RO!a0RO(P!lO(`!mO~O!P0TO(`!mO~O#X0UO~Og%^a!Y%^a#]%^a#}%^a~P!0kOg%`a!Y%`a#]%`a#}%`a~P!0kO(O&WOg'iX!Y'iX~O!Y*tOg(Xa~Og0_O~OR0`O}0`O!P0aO#P$dOkza(tza(uza!Yza#]za~Ogza#}za~P$%]O})zO!P){Ok$qa(t$qa(u$qa!Y$qa#]$qa~Og$qa#}$qa~P$&UO})zO!P){Ok$sa(t$sa(u$sa!Y$sa#]$sa~Og$sa#}$sa~P$&wO#h0dO~Og%Ra!Y%Ra#]%Ra#}%Ra~P!0kO!d#vO~O#h0gO~O!Y+WOa)Pa'u)Pa~OR#zO}#yO!P#{O!i#xO([VOP!oi[!oio!oi!Y!oi!m!oi#O!oi#k!oi#l!oi#m!oi#n!oi#o!oi#p!oi#q!oi#r!oi#s!oi#u!oi#w!oi#y!oi#z!oi(m!oi(t!oi(u!oi~Oa!oi'u!oi's!oi!V!oi!h!ois!oi![!oi%f!oi!d!oi~P$(fOh%VOo%XOp$tOq$tOw%YOy%ZO{;nO!P${O![$|O!f=OO!i$xO#g;tO$V%_O$r;pO$t;rO$w%`O(QTO(TUO([$uO(t$}O(u%PO~Om0pO(O0oO~P$*|O!d+cOa(Wa![(Wa'u(Wa!Y(Wa~O#h0vO~O[]X!YfX!ZfX~O!Y0wO!Z)TX~O!Z0yO~O[0zO~Ob0|O(O+kO(QTO(TUO~O![%}O(O%eO`'qX!Y'qX~O!Y+pO`)Sa~O!h1PO~P!9mO[1SO~O`1TO~O#]1WO~Ok1ZO![$|O~O(`(xO!Z)QP~Oh%VOk1dO![1aO%f1cO~O[1nO!Y1lO!Z)RX~O!Z1oO~O`1qOa%lO'u%lO~O(O#nO(QTO(TUO~O#P$dO#]$eO$P$eOP(bXR(bX[(bXo(bX}(bX!P(bX!Y(bX!i(bX!m(bX#O(bX#k(bX#l(bX#m(bX#n(bX#o(bX#p(bX#q(bX#r(bX#u(bX#w(bX#y(bX#z(bX([(bX(m(bX(t(bX(u(bX~O#s1tO&W1uOa(bX~P$0dO#]$eO#s1tO&W1uO~Oa1wO~P%[Oa1yO~O&a1|OP&_iQ&_iS&_iY&_ia&_id&_ie&_im&_io&_ip&_iq&_iw&_iy&_i{&_i!P&_i!T&_i!U&_i![&_i!f&_i!i&_i!l&_i!m&_i!n&_i!p&_i!r&_i!u&_i!y&_i#t&_i$V&_i%e&_i%g&_i%i&_i%j&_i%k&_i%n&_i%p&_i%s&_i%t&_i%v&_i&S&_i&Y&_i&[&_i&^&_i&`&_i&c&_i&i&_i&o&_i&q&_i&s&_i&u&_i&w&_i's&_i(O&_i(Q&_i(T&_i([&_i(j&_i(y&_i!Z&_ib&_i&f&_i~Ob2SO!Z2QO&f2RO~P`O![XO!i2UO~O&m,sOP&hiQ&hiS&hiY&hia&hid&hie&him&hio&hip&hiq&hiw&hiy&hi{&hi!P&hi!T&hi!U&hi![&hi!f&hi!i&hi!l&hi!m&hi!n&hi!p&hi!r&hi!u&hi!y&hi#t&hi$V&hi%e&hi%g&hi%i&hi%j&hi%k&hi%n&hi%p&hi%s&hi%t&hi%v&hi&S&hi&Y&hi&[&hi&^&hi&`&hi&c&hi&i&hi&o&hi&q&hi&s&hi&u&hi&w&hi's&hi(O&hi(Q&hi(T&hi([&hi(j&hi(y&hi!Z&hi&a&hib&hi&f&hi~O!V2[O~O!Y!^a!Z!^a~P#AbOp!nO!P!oO!X2bO(`!mO!Y'TX!Z'TX~P@YO!Y-TO!Z(da~O!Y'ZX!Z'ZX~P!8uO!Y-WO!Z(sa~O!Z2iO~P'_Oa%lO#]2rO'u%lO~Oa%lO!d#vO#]2rO'u%lO~Oa%lO!d#vO!m2vO#]2rO'u%lO(m'mO~Oa%lO'u%lO~P!9mO!Y$_Os$oa~O!V'Si!Y'Si~P!9mO!Y(RO!V(ci~O!Y(YO!V(qi~O!V(ri!Y(ri~P!9mO!Y(oi!h(oia(oi'u(oi~P!9mO#]2xO!Y(oi!h(oia(oi'u(oi~O!Y(fO!h(ni~O!P%fO![%gO!y]O#f2}O#g2|O(O%eO~O!P%fO![%gO#g2|O(O%eO~Ok3UO![']O%f3TO~Oh%VOk3UO![']O%f3TO~O#h%^aP%^aR%^a[%^aa%^ao%^a!i%^a!m%^a#O%^a#k%^a#l%^a#m%^a#n%^a#o%^a#p%^a#q%^a#r%^a#s%^a#u%^a#w%^a#y%^a#z%^a'u%^a([%^a(m%^a!h%^a!V%^a's%^as%^a![%^a%f%^a!d%^a~P#K^O#h%`aP%`aR%`a[%`aa%`ao%`a!i%`a!m%`a#O%`a#k%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#u%`a#w%`a#y%`a#z%`a'u%`a([%`a(m%`a!h%`a!V%`a's%`as%`a![%`a%f%`a!d%`a~P#LPO#h%^aP%^aR%^a[%^aa%^ao%^a!Y%^a!i%^a!m%^a#O%^a#k%^a#l%^a#m%^a#n%^a#o%^a#p%^a#q%^a#r%^a#s%^a#u%^a#w%^a#y%^a#z%^a'u%^a([%^a(m%^a!h%^a!V%^a's%^a#]%^as%^a![%^a%f%^a!d%^a~P#.aO#h%`aP%`aR%`a[%`aa%`ao%`a!Y%`a!i%`a!m%`a#O%`a#k%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#u%`a#w%`a#y%`a#z%`a'u%`a([%`a(m%`a!h%`a!V%`a's%`a#]%`as%`a![%`a%f%`a!d%`a~P#.aO#hzaPza[zaazaoza!iza!mza#Oza#kza#lza#mza#nza#oza#pza#qza#rza#sza#uza#wza#yza#zza'uza([za(mza!hza!Vza'szasza![za%fza!dza~P$%]O#h$qaP$qaR$qa[$qaa$qao$qa!i$qa!m$qa#O$qa#k$qa#l$qa#m$qa#n$qa#o$qa#p$qa#q$qa#r$qa#s$qa#u$qa#w$qa#y$qa#z$qa'u$qa([$qa(m$qa!h$qa!V$qa's$qas$qa![$qa%f$qa!d$qa~P$&UO#h$saP$saR$sa[$saa$sao$sa!i$sa!m$sa#O$sa#k$sa#l$sa#m$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#u$sa#w$sa#y$sa#z$sa'u$sa([$sa(m$sa!h$sa!V$sa's$sas$sa![$sa%f$sa!d$sa~P$&wO#h%RaP%RaR%Ra[%Raa%Rao%Ra!Y%Ra!i%Ra!m%Ra#O%Ra#k%Ra#l%Ra#m%Ra#n%Ra#o%Ra#p%Ra#q%Ra#r%Ra#s%Ra#u%Ra#w%Ra#y%Ra#z%Ra'u%Ra([%Ra(m%Ra!h%Ra!V%Ra's%Ra#]%Ras%Ra![%Ra%f%Ra!d%Ra~P#.aOa#`q!Y#`q'u#`q's#`q!V#`q!h#`qs#`q![#`q%f#`q!d#`q~P!9mO!X3^O!Y'UX!h'UX~P%[O!Y.lO!h(fa~O!Y.lO!h(fa~P!9mO!V3aO~O#}!ka!Z!ka~PKPO#}!ga!Y!ga!Z!ga~P#AbO#}!oa!Z!oa~P!<TO#}!qa!Z!qa~P!>kOg'XX!Y'XX~P!+hO!Y.wOg(ka~OSfO![3uO$c3vO~O!Z3zO~Os3{O~P#.aOa$lq!Y$lq'u$lq's$lq!V$lq!h$lqs$lq![$lq%f$lq!d$lq~P!9mO!V3|O~P#.aO})zO!P){O(u%POk'ea(t'ea!Y'ea#]'ea~Og'ea#}'ea~P%)nO})zO!P){Ok'ga(t'ga(u'ga!Y'ga#]'ga~Og'ga#}'ga~P%*aO(m$YO~P#.aO!VfX!V$xX!YfX!Y$xX!d%PX#]fX~P!/gO(O<QO~P!1YOmkO(O4OO~P.iO!P%fO!X4QO![%gO(O%eO!Y'aX!h'aX~O!Y/hO!h(za~O!Y/hO!d#vO!h(za~O!Y/hO!d#vO(m'mO!h(za~Og$zi!Y$zi#]$zi#}$zi~P!0kO!X4YO!V'cX!Y'cX~P!3XO!Y/pO!V({a~O!Y/pO!V({a~P#.aO!d#vO#s4bO~Oo4eO!d#vO(m'mO~O!P4hO(`!mO~O(t$}Ok%^i}%^i!P%^i(u%^i!Y%^i#]%^i~Og%^i#}%^i~P%.wO(u%POk%`i}%`i!P%`i(t%`i!Y%`i#]%`i~Og%`i#}%`i~P%/jOg(Yi!Y(Yi~P!0kO#]4mOg(Yi!Y(Yi~P!0kO!h4pO~Oa$mq!Y$mq'u$mq's$mq!V$mq!h$mqs$mq![$mq%f$mq!d$mq~P!9mO!V4tO~O!Y4uO![(|X~P#.aOa$xX![$xX%Z]X'u$xX!Y$xX~P!/gO%Z4xOalXklX}lX!PlX![lX'ulX(tlX(ulX!YlX~O%Z4xO~Ob5OO%g5PO(O+kO(QTO(TUO!Y'pX!Z'pX~O!Y0wO!Z)Ta~O[5TO~O`5UO~Oa%lO'u%lO~P#.aO![$|O~P#.aO!Y5^O#]5`O!Z)QX~O!Z5aO~Oo5hOp!nO!P5bO!_!yO!`!vO!a!vO!y;QO#Q!pO#R!pO#S!pO#T!pO#U!pO#X5gO#Y!zO(P!lO(QTO(TUO(`!mO(j!sO~O!Z5fO~P%4tOk5mO![1aO%f5lO~Oh%VOk5mO![1aO%f5lO~Ob5tO(O#nO(QTO(TUO!Y'oX!Z'oX~O!Y1lO!Z)Ra~O(QTO(TUO(`5vO~O`5zO~O#s5}O&W6OO~PMlO!h6PO~P%[Oa6RO~Oa6RO~P%[Ob2SO!Z6WO&f2RO~P`O!d6YO~O!d6[Oh(ei!Y(ei!Z(ei!d(ei!i(ei~O!Y#ei!Z#ei~P#AbO#]6]O!Y#ei!Z#ei~O!Y!^i!Z!^i~P#AbOa%lO#]6fO'u%lO~Oa%lO!d#vO#]6fO'u%lO~O!Y(oq!h(oqa(oq'u(oq~P!9mO!Y(fO!h(nq~O!P%fO![%gO#g6mO(O%eO~O![']O%f6pO~Ok6tO![']O%f6pO~O#h'eaP'eaR'ea['eaa'eao'ea!i'ea!m'ea#O'ea#k'ea#l'ea#m'ea#n'ea#o'ea#p'ea#q'ea#r'ea#s'ea#u'ea#w'ea#y'ea#z'ea'u'ea(['ea(m'ea!h'ea!V'ea's'eas'ea!['ea%f'ea!d'ea~P%)nO#h'gaP'gaR'ga['gaa'gao'ga!i'ga!m'ga#O'ga#k'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#u'ga#w'ga#y'ga#z'ga'u'ga(['ga(m'ga!h'ga!V'ga's'gas'ga!['ga%f'ga!d'ga~P%*aO#h$ziP$ziR$zi[$zia$zio$zi!Y$zi!i$zi!m$zi#O$zi#k$zi#l$zi#m$zi#n$zi#o$zi#p$zi#q$zi#r$zi#s$zi#u$zi#w$zi#y$zi#z$zi'u$zi([$zi(m$zi!h$zi!V$zi's$zi#]$zis$zi![$zi%f$zi!d$zi~P#.aO#h%^iP%^iR%^i[%^ia%^io%^i!i%^i!m%^i#O%^i#k%^i#l%^i#m%^i#n%^i#o%^i#p%^i#q%^i#r%^i#s%^i#u%^i#w%^i#y%^i#z%^i'u%^i([%^i(m%^i!h%^i!V%^i's%^is%^i![%^i%f%^i!d%^i~P%.wO#h%`iP%`iR%`i[%`ia%`io%`i!i%`i!m%`i#O%`i#k%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#u%`i#w%`i#y%`i#z%`i'u%`i([%`i(m%`i!h%`i!V%`i's%`is%`i![%`i%f%`i!d%`i~P%/jO!Y'Ua!h'Ua~P!9mO!Y.lO!h(fi~O#}#`i!Y#`i!Z#`i~P#AbOP$[OR#zO}#yO!P#{O!i#xO!m$[O([VO[#jio#ji#O#ji#l#ji#m#ji#n#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji#}#ji(m#ji(t#ji(u#ji!Y#ji!Z#ji~O#k#ji~P%G^O#k;YO~P%G^OP$[OR#zOo;fO}#yO!P#{O!i#xO!m$[O#k;YO#l;ZO#m;ZO#n;ZO([VO[#ji#O#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji#}#ji(m#ji(t#ji(u#ji!Y#ji!Z#ji~O#o#ji~P%IfO#o;[O~P%IfOP$[OR#zO[;hOo;fO}#yO!P#{O!i#xO!m$[O#O;]O#k;YO#l;ZO#m;ZO#n;ZO#o;[O#p;]O#q;]O#r;gO#s;]O([VO#w#ji#y#ji#z#ji#}#ji(m#ji(t#ji(u#ji!Y#ji!Z#ji~O#u#ji~P%KnOP$[OR#zO[;hOo;fO}#yO!P#{O!i#xO!m$[O#O;]O#k;YO#l;ZO#m;ZO#n;ZO#o;[O#p;]O#q;]O#r;gO#s;]O#u;^O([VO(u#}O#y#ji#z#ji#}#ji(m#ji(t#ji!Y#ji!Z#ji~O#w;`O~P%MoO#w#ji~P%MoO#u;^O~P%KnOP$[OR#zO[;hOo;fO}#yO!P#{O!i#xO!m$[O#O;]O#k;YO#l;ZO#m;ZO#n;ZO#o;[O#p;]O#q;]O#r;gO#s;]O#u;^O#w;`O([VO(t#|O(u#}O#z#ji#}#ji(m#ji!Y#ji!Z#ji~O#y#ji~P&!OO#y;bO~P&!OOa#{y!Y#{y'u#{y's#{y!V#{y!h#{ys#{y![#{y%f#{y!d#{y~P!9mO[#jio#ji#O#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji#}#ji(m#ji!Y#ji!Z#ji~OP$[OR#zO}#yO!P#{O!i#xO!m$[O#k;YO#l;ZO#m;ZO#n;ZO([VO(t#ji(u#ji~P&$zOk=VO})zO!P){O(t$}O(u%POP#jiR#ji!i#ji!m#ji#k#ji#l#ji#m#ji#n#ji([#ji~P&$zO#P$dOP(ZXR(ZX[(ZXk(ZXo(ZX}(ZX!P(ZX!i(ZX!m(ZX#O(ZX#k(ZX#l(ZX#m(ZX#n(ZX#o(ZX#p(ZX#q(ZX#r(ZX#s(ZX#u(ZX#w(ZX#y(ZX#z(ZX#}(ZX([(ZX(m(ZX(t(ZX(u(ZX!Y(ZX!Z(ZX~O#}$Oi!Y$Oi!Z$Oi~P#AbO#}!oi!Z!oi~P$(fOg'Xa!Y'Xa~P!0kO!Z7WO~O!Y'`a!Z'`a~P#AbOP]XR]X[]Xo]X}]X!P]X!V]X!Y]X!i]X!m]X#O]X#P]X#]]X#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X([]X(m]X(t]X(u]X~O!d%WX#s%WX~P&+QO!d#vO(m'mO!Y'aa!h'aa~O!Y/hO!h(zi~O!Y/hO!d#vO!h(zi~Og$zq!Y$zq#]$zq#}$zq~P!0kO!V'ca!Y'ca~P#.aO!d7_O~O!Y/pO!V({i~P#.aO!Y/pO!V({i~O!V7cO~O!d#vO#s7hO~Oo7iO!d#vO(m'mO~O})zO!P){O(u%POk'fa(t'fa!Y'fa#]'fa~Og'fa#}'fa~P&/pO})zO!P){Ok'ha(t'ha(u'ha!Y'ha#]'ha~Og'ha#}'ha~P&0cO!V7lO~Og$|q!Y$|q#]$|q#}$|q~P!0kOa$my!Y$my'u$my's$my!V$my!h$mys$my![$my%f$my!d$my~P!9mO!d6[O~O!Y4uO![(|a~O![']OP$SaR$Sa[$Sao$Sa}$Sa!P$Sa!Y$Sa!i$Sa!m$Sa#O$Sa#k$Sa#l$Sa#m$Sa#n$Sa#o$Sa#p$Sa#q$Sa#r$Sa#s$Sa#u$Sa#w$Sa#y$Sa#z$Sa([$Sa(m$Sa(t$Sa(u$Sa~O%f6pO~P&2lOa#`y!Y#`y'u#`y's#`y!V#`y!h#`ys#`y![#`y%f#`y!d#`y~P!9mO[7qO~Ob7sO(O+kO(QTO(TUO~O!Y0wO!Z)Ti~O`7wO~O(`(xO!Y'lX!Z'lX~O!Y5^O!Z)Qa~O!Z8QO~P%4tOp!nO!P8RO(QTO(TUO(`!mO(j!sO~O#X8SO~O![1aO~O![1aO%f8UO~Ok8XO![1aO%f8UO~O[8^O!Y'oa!Z'oa~O!Y1lO!Z)Ri~O!h8bO~O!h8cO~O!h8fO~O!h8fO~P%[Oa8hO~O!d8iO~O!h8jO~O!Y(ri!Z(ri~P#AbOa%lO#]8rO'u%lO~O!Y(oy!h(oya(oy'u(oy~P!9mO!Y(fO!h(ny~O%f8uO~P&2lO![']O%f8uO~O#h$zqP$zqR$zq[$zqa$zqo$zq!Y$zq!i$zq!m$zq#O$zq#k$zq#l$zq#m$zq#n$zq#o$zq#p$zq#q$zq#r$zq#s$zq#u$zq#w$zq#y$zq#z$zq'u$zq([$zq(m$zq!h$zq!V$zq's$zq#]$zqs$zq![$zq%f$zq!d$zq~P#.aO#h'faP'faR'fa['faa'fao'fa!i'fa!m'fa#O'fa#k'fa#l'fa#m'fa#n'fa#o'fa#p'fa#q'fa#r'fa#s'fa#u'fa#w'fa#y'fa#z'fa'u'fa(['fa(m'fa!h'fa!V'fa's'fas'fa!['fa%f'fa!d'fa~P&/pO#h'haP'haR'ha['haa'hao'ha!i'ha!m'ha#O'ha#k'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#u'ha#w'ha#y'ha#z'ha'u'ha(['ha(m'ha!h'ha!V'ha's'has'ha!['ha%f'ha!d'ha~P&0cO#h$|qP$|qR$|q[$|qa$|qo$|q!Y$|q!i$|q!m$|q#O$|q#k$|q#l$|q#m$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#u$|q#w$|q#y$|q#z$|q'u$|q([$|q(m$|q!h$|q!V$|q's$|q#]$|qs$|q![$|q%f$|q!d$|q~P#.aO!Y'Ui!h'Ui~P!9mO#}#`q!Y#`q!Z#`q~P#AbO(t$}OP%^aR%^a[%^ao%^a!i%^a!m%^a#O%^a#k%^a#l%^a#m%^a#n%^a#o%^a#p%^a#q%^a#r%^a#s%^a#u%^a#w%^a#y%^a#z%^a#}%^a([%^a(m%^a!Y%^a!Z%^a~Ok%^a}%^a!P%^a(u%^a~P&CoO(u%POP%`aR%`a[%`ao%`a!i%`a!m%`a#O%`a#k%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#u%`a#w%`a#y%`a#z%`a#}%`a([%`a(m%`a!Y%`a!Z%`a~Ok%`a}%`a!P%`a(t%`a~P&EsOk=VO})zO!P){O(u%PO~P&CoOk=VO})zO!P){O(t$}O~P&EsOR0`O}0`O!P0aO#P$dOPza[zakzaoza!iza!mza#Oza#kza#lza#mza#nza#oza#pza#qza#rza#sza#uza#wza#yza#zza#}za([za(mza(tza(uza!Yza!Zza~O})zO!P){OP$qaR$qa[$qak$qao$qa!i$qa!m$qa#O$qa#k$qa#l$qa#m$qa#n$qa#o$qa#p$qa#q$qa#r$qa#s$qa#u$qa#w$qa#y$qa#z$qa#}$qa([$qa(m$qa(t$qa(u$qa!Y$qa!Z$qa~O})zO!P){OP$saR$sa[$sak$sao$sa!i$sa!m$sa#O$sa#k$sa#l$sa#m$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#u$sa#w$sa#y$sa#z$sa#}$sa([$sa(m$sa(t$sa(u$sa!Y$sa!Z$sa~Ok=VO})zO!P){O(t$}O(u%PO~OP%RaR%Ra[%Rao%Ra!i%Ra!m%Ra#O%Ra#k%Ra#l%Ra#m%Ra#n%Ra#o%Ra#p%Ra#q%Ra#r%Ra#s%Ra#u%Ra#w%Ra#y%Ra#z%Ra#}%Ra([%Ra(m%Ra!Y%Ra!Z%Ra~P&NlO#}$lq!Y$lq!Z$lq~P#AbO#}$mq!Y$mq!Z$mq~P#AbO!Z9SO~O#}9TO~P!0kO!d#vO!Y'ai!h'ai~O!d#vO(m'mO!Y'ai!h'ai~O!Y/hO!h(zq~O!V'ci!Y'ci~P#.aO!Y/pO!V({q~Oo9[O!d#vO(m'mO~O!V9]O~P#.aO!V9]O~O!d#vO#s9bO~Og(Yy!Y(Yy~P!0kO!Y'ja!['ja~P#.aOa%Yq![%Yq'u%Yq!Y%Yq~P#.aO[9dO~O!Y0wO!Z)Tq~O#]9hO!Y'la!Z'la~O!Y5^O!Z)Qi~P#AbO!P4hO~O![1aO%f9lO~O(QTO(TUO(`9qO~O!Y1lO!Z)Rq~O!h9tO~O!h9uO~O!h9vO~O!h9vO~P%[O#]9yO!Y#ey!Z#ey~O!Y#ey!Z#ey~P#AbO%f:OO~P&2lO![']O%f:OO~O#}#{y!Y#{y!Z#{y~P#AbOP$ziR$zi[$zio$zi!i$zi!m$zi#O$zi#k$zi#l$zi#m$zi#n$zi#o$zi#p$zi#q$zi#r$zi#s$zi#u$zi#w$zi#y$zi#z$zi#}$zi([$zi(m$zi!Y$zi!Z$zi~P&NlO})zO!P){O(u%POP'eaR'ea['eak'eao'ea!i'ea!m'ea#O'ea#k'ea#l'ea#m'ea#n'ea#o'ea#p'ea#q'ea#r'ea#s'ea#u'ea#w'ea#y'ea#z'ea#}'ea(['ea(m'ea(t'ea!Y'ea!Z'ea~O})zO!P){OP'gaR'ga['gak'gao'ga!i'ga!m'ga#O'ga#k'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#u'ga#w'ga#y'ga#z'ga#}'ga(['ga(m'ga(t'ga(u'ga!Y'ga!Z'ga~O(t$}OP%^iR%^i[%^ik%^io%^i}%^i!P%^i!i%^i!m%^i#O%^i#k%^i#l%^i#m%^i#n%^i#o%^i#p%^i#q%^i#r%^i#s%^i#u%^i#w%^i#y%^i#z%^i#}%^i([%^i(m%^i(u%^i!Y%^i!Z%^i~O(u%POP%`iR%`i[%`ik%`io%`i}%`i!P%`i!i%`i!m%`i#O%`i#k%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#u%`i#w%`i#y%`i#z%`i#}%`i([%`i(m%`i(t%`i!Y%`i!Z%`i~O#}$my!Y$my!Z$my~P#AbO#}#`y!Y#`y!Z#`y~P#AbO!d#vO!Y'aq!h'aq~O!Y/hO!h(zy~O!V'cq!Y'cq~P#.aOo:YO!d#vO(m'mO~O!V:ZO~P#.aO!V:ZO~O!Y0wO!Z)Ty~O!Y5^O!Z)Qq~O![1aO%f:cO~O!h:fO~O%f:kO~P&2lOP$zqR$zq[$zqo$zq!i$zq!m$zq#O$zq#k$zq#l$zq#m$zq#n$zq#o$zq#p$zq#q$zq#r$zq#s$zq#u$zq#w$zq#y$zq#z$zq#}$zq([$zq(m$zq!Y$zq!Z$zq~P&NlO})zO!P){O(u%POP'faR'fa['fak'fao'fa!i'fa!m'fa#O'fa#k'fa#l'fa#m'fa#n'fa#o'fa#p'fa#q'fa#r'fa#s'fa#u'fa#w'fa#y'fa#z'fa#}'fa(['fa(m'fa(t'fa!Y'fa!Z'fa~O})zO!P){OP'haR'ha['hak'hao'ha!i'ha!m'ha#O'ha#k'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#u'ha#w'ha#y'ha#z'ha#}'ha(['ha(m'ha(t'ha(u'ha!Y'ha!Z'ha~OP$|qR$|q[$|qo$|q!i$|q!m$|q#O$|q#k$|q#l$|q#m$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#u$|q#w$|q#y$|q#z$|q#}$|q([$|q(m$|q!Y$|q!Z$|q~P&NlOg%b!Z!Y%b!Z#]%b!Z#}%b!Z~P!0kOo:oO!d#vO(m'mO~O!V:pO~P#.aO!Y'lq!Z'lq~P#AbO!Y#e!Z!Z#e!Z~P#AbO#h%b!ZP%b!ZR%b!Z[%b!Za%b!Zo%b!Z!Y%b!Z!i%b!Z!m%b!Z#O%b!Z#k%b!Z#l%b!Z#m%b!Z#n%b!Z#o%b!Z#p%b!Z#q%b!Z#r%b!Z#s%b!Z#u%b!Z#w%b!Z#y%b!Z#z%b!Z'u%b!Z([%b!Z(m%b!Z!h%b!Z!V%b!Z's%b!Z#]%b!Zs%b!Z![%b!Z%f%b!Z!d%b!Z~P#.aOo:xO!d#vO(m'mO~OP%b!ZR%b!Z[%b!Zo%b!Z!i%b!Z!m%b!Z#O%b!Z#k%b!Z#l%b!Z#m%b!Z#n%b!Z#o%b!Z#p%b!Z#q%b!Z#r%b!Z#s%b!Z#u%b!Z#w%b!Z#y%b!Z#z%b!Z#}%b!Z([%b!Z(m%b!Z!Y%b!Z!Z%b!Z~P&NlOs(aX~P1qO}%pO~P!(oO(P!lO~P!(oO!VfX!YfX#]fX~P&+QOP]XR]X[]Xo]X}]X!P]X!Y]X!YfX!i]X!m]X#O]X#P]X#]]X#]fX#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X([]X(m]X(t]X(u]X~O!dfX!h]X!hfX(mfX~P'BxOP;POQ;POSfOd<zOe!iOmkOo;POpkOqkOwkOy;PO{;PO!PWO!TkO!UkO![XO!f;SO!iZO!l;PO!m;PO!n;PO!p;TO!r;WO!u!hO$V!kO(O)XO(QTO(TUO([VO(j[O(y<xO~O!Y;dO!Z$oa~Oh%VOm%WOo%XOp$tOq$tOw%YOy%ZO{;oO!P${O![$|O!f=PO!i$xO#g;uO$V%_O$r;qO$t;sO$w%`O(O(rO(QTO(TUO([$uO(t$}O(u%PO~O#t)`O~P'GnOo!bX(m!bX~P# ZO!Z]X!ZfX~P'BxO!VfX!V$xX!YfX!Y$xX#]fX~P!/gO#h;XO~O!d#vO#h;XO~O#];iO~O#s;]O~O#];xO!Y(rX!Z(rX~O#];iO!Y(pX!Z(pX~O#h;yO~Og;{O~P!0kO#h<RO~O#h<SO~O!d#vO#h<TO~O!d#vO#h;yO~O#}<UO~P#AbO#h<VO~O#h<WO~O#h<]O~O#h<^O~O#h<_O~O#h<`O~O#}<aO~P!0kO#}<bO~P!0kO#P#Q#R#T#U#X#f#g#r(y$r$t$w%Z%e%f%g%n%p%s%t%v%x~'yT#l!U'w(P#mp#k#no}'x$['x(O$^(`~",
  goto: "$4Q)XPPPPPP)YPP)]P)nP+O/PPPPP5xPP6`PP<V?mP@QP@QPPP@QPBRP@QP@QP@QPBVPB[PByPGrPPPGvPPPPGvJxPPPKOKzPGvPGvPPNYGvPPPGvPGvP!!aGvP!%v!&{!'UP!'x!'|!'x!+YPPPPPPP!+y!&{PP!,Z!-gP!0jGvGv!0o!3z!8b!8b!<`PPP!<hGvPPPPPPPPPPP!?vP!ATPPGv!BfPGvPGvGvGvGvGvPGv!CxP!GRP!JWP!J[!Jf!Jj!JjP!GOP!Jn!JnP!MsP!MwGvGv!M}##RBV@QP@QP@Q@QP#$_@Q@Q#&j@Q#)Z@Q#+`@Q@Q#,O#.]#.]#.b#.k#.]#.wP#.]P@Q#/a@Q#3S@Q@Q5xPPP#6{PPP#7f#7fP#7fP#7|#7fPP#8SP#7yP#7y#8g#7y#9R#9X5u)]#9[)]P#9c#9c#9cP)]P)]P)]P)]PP)]P#9i#9lP#9l)]P#9pP#9sP)]P)]P)]P)]P)]P)])]PP#9y#:P#:[#:b#:h#:n#:t#;S#;Y#;d#;j#;t#;z#<[#<b#=S#=f#=l#=r#>Q#>g#@V#@e#@l#BR#Ba#C|#D[#Db#Dh#Dn#Dx#EO#EU#E`#Er#ExPPPPPPPPPP#FOPPPPPPP#Fs#Iz#KZ#Kb#KjPPP$!sP$!|$%t$,^$,a$,d$-P$-S$-Z$-cP$-i$-lP$.Y$.^$/U$0d$0i$1PPP$1U$1[$1`P$1c$1g$1k$2a$2x$3a$3e$3h$3k$3q$3t$3x$3|R!|RoqOXst!Z#d%k&o&q&r&t,k,p1|2PY!vQ']-]1a5eQ%rvQ%zyQ&R|Q&g!VS'T!e-TQ'c!iS'i!r!yU*e$|*V*jQ+i%{Q+v&TQ,[&aQ-Z'[Q-e'dQ-m'jQ0R*lQ1k,]R;v;T%QdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)y+R+V,h,k,p-a-i-w-}.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3^5b5m5}6O6R6f8R8X8h8rS#q];Q!r)Z$Z$n'U)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{U*y%[;n;oQ+n%}Q,^&dQ,e&lQ0m+aQ0q+cQ0|+oQ1s,cQ3Q._Q5O0wQ5t1lQ6r3UQ7s5PR8x6t'OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{t!nQ!r!v!y!z'T'[']'i'j'k-T-Z-]-m1a5e5g$|$ti#v$b$c$d$x${%O%Q%]%^%b)u){)}*P*R*U*[*b*r*s+`+c+z+}.^.w/]/e/o/p/r0V0X0d1W1Z1c3T3}4Y4b4m4u4x5l6p7_7h8U8u9T9b9l:O:c:k;g;h;j;k;l;m;p;q;r;s;t;u;|;}<O<P<R<S<V<W<X<Y<Z<[<]<^<a<b<x=Q=R=U=VQ&U|Q'R!eU'X%g*V-WQ+n%}Q,^&dQ0c*|Q0|+oQ1R+uQ1r,bQ1s,cQ5O0wQ5X1TQ5t1lQ5w1nQ5x1qQ7s5PQ7v5UQ8a5zQ9g7wR9r8^rnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PR,`&h&x^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<z<{[#]WZ#W#Z'U(P!b%hm#h#i#l$x%c%f(Y(d(e(f*U*Y*]+T+U+W,g,}-{.R.S.T.V/e/h2U2|2}4Q6[6mQ%uxQ%yyS&O|&TQ&[!TQ'`!hQ'b!iQ(m#sS+h%z%{Q+l%}Q,V&_Q,Z&aS-d'c'dQ.a(nQ0u+iQ0{+oQ0}+pQ1Q+tQ1f,WS1j,[,]Q2n-eQ4}0wQ5R0zQ5W1SQ5s1kQ7r5PQ7u5TQ9c7qR:^9d!O$zi$d%O%Q%]%^%b)}*P*[*r*s.w/o0V0X0d3}4m9T<x=Q=R!S%wy!i!u%y%z%{'S'b'c'd'h'r*d+h+i-Q-d-e-l/y0u2g2n2u4dQ+b%uQ+{&XQ,O&YQ,Y&aQ.`(mQ1e,VU1i,Z,[,]Q3V.aQ5n1fS5r1j1kQ8]5s#^<|#v$b$c$x${)u){*R*U*b+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4u4x5l6p7_7h8U8u9b9l:O:c:k;j;l;p;r;t;|<O<R<V<X<Z<]<a=U=Vo<};g;h;k;m;q;s;u;}<P<S<W<Y<[<^<bW%Ti%V*t<xS&X!Q&fQ&Y!RQ&Z!SR+y&V$}%Si#v$b$c$d$x${%O%Q%]%^%b)u){)}*P*R*U*[*b*r*s+`+c+z+}.^.w/]/e/o/p/r0V0X0d1W1Z1c3T3}4Y4b4m4u4x5l6p7_7h8U8u9T9b9l:O:c:k;g;h;j;k;l;m;p;q;r;s;t;u;|;}<O<P<R<S<V<W<X<Y<Z<[<]<^<a<b<x=Q=R=U=VT)v$u)wV*y%[;n;oW'X!e%g*V-WS(y#y#zQ+]%pQ+s&QS.Y(i(jQ1[,PQ4n0`R7{5^'OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{$i$^c#Y#e%o%q%s(O(U(p(u(})O)P)Q)R)S)T)U)V)W)Y)[)^)c)m+^+r-R-p-u-z-|.k.n.r.t.u.v/X0e2]2`2p2w3]3b3c3d3e3f3g3h3i3j3k3l3m3n3q3r3y4r4{6_6e6j6y6z7T7U7}8l8p8z9Q9R9{:`:g;R<oT#TV#U'PkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{Q'V!eR2c-Tv!nQ!e!r!v!y!z'T'[']'i'j'k-T-Z-]-m1a5e5gU*d$|*V*jS/y*e*lQ0S*mQ1^,RQ4d0RR4g0UnqOXst!Z#d%k&o&q&r&t,k,p1|2PQ&v!^Q's!xS(o#u;XQ+f%xQ,T&[Q,U&^Q-b'aQ-o'lS.j(t;yS0f+R<TQ0s+gQ1`,SQ2T,rQ2V,sQ2_-OQ2l-cQ2o-gS4s0g<_Q4y0tS4|0v<`Q6^2aQ6b2mQ6g2tQ7p4zQ8m6`Q8n6cQ8q6hR9x8j$d$]c#Y#e%q%s(O(U(p(u(})O)P)Q)R)S)T)U)V)W)Y)[)^)c)m+^+r-R-p-u-z-|.k.n.r.u.v/X0e2]2`2p2w3]3b3c3d3e3f3g3h3i3j3k3l3m3n3q3r3y4r4{6_6e6j6y6z7T7U7}8l8p8z9Q9R9{:`:g;R<oS(k#p'fQ({#zS+[%o.tS.Z(j(lR3O.['OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{S#q];QQ&q!XQ&r!YQ&t![Q&u!]R1{,nQ'^!hQ+_%uQ-`'`S.](m+bQ2j-_W3S.`.a0l0nQ6a2kW6n3P3R3V4wU8t6o6q6sU9}8v8w8yS:i9|:PQ:t:jR:z:uU!wQ']-]T5c1a5e!Q_OXZ`st!V!Z#d#h%c%k&f&h&o&q&r&t(f,k,p.S1|2P]!pQ!r']-]1a5eT#q];Q%[{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)y+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5b5m5}6O6R6f6t8R8X8h8rS(y#y#zS.Y(i(j!s<f$Z$n'U)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{U$fd)Z,eS(l#p'fU*q%R(s3pU0b*x.f7PQ4w0mQ6o3QQ8w6rR:P8xm!tQ!r!v!y!z']'i'j'k-]-m1a5e5gQ'q!uS(b#g1vS-k'h'tQ/k*XQ/w*dQ2v-nQ4U/lS4_/x0SQ7Z4PS7f4e4gQ9V7[Q9Z7cQ9`7iS:X9[9]S:n:Y:ZS:w:o:pR:}:xQ#wbQ'p!uS(a#g1vS(c#m+QQ+S%dQ+d%vQ+j%|U-j'h'q'tQ.O(bQ/j*XQ/v*dQ/|*gQ0r+eQ1g,XS2s-k-nQ2{.WS4T/k/lS4^/w0SQ4a/{Q4c/}Q5p1hQ6i2vQ7Y4PQ7^4US7b4_4gQ7g4fQ8Z5qS9U7Z7[Q9Y7cQ9^7fQ9a7jQ9o8[Q:V9VS:W9Z9]Q:[9`Q:e9pS:m:X:ZS:v:n:pQ:|:wQ;O:}Q<i<dQ<t<mR<u<nV!wQ']-]%[aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)y+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5b5m5}6O6R6f6t8R8X8h8rS#wz!j!r<c$Z$n'U)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{R<i<z%[bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)y+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5b5m5}6O6R6f6t8R8X8h8rQ%dj!S%vy!i!u%y%z%{'S'b'c'd'h'r*d+h+i-Q-d-e-l/y0u2g2n2u4dS%|z!jQ+e%wQ,X&aW1h,Y,Z,[,]U5q1i1j1kS8[5r5sQ9p8]!r<d$Z$n'U)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{Q<m<yR<n<z%OeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&o&q&r&t&x'Q'_'o(R(X(`(t(v(z)y+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5b5m5}6O6R6f6t8R8X8h8rY#bWZ#W#Z(P!b%hm#h#i#l$x%c%f(Y(d(e(f*U*Y*]+T+U+W,g,}-{.R.S.T.V/e/h2U2|2}4Q6[6mQ,f&l!p<e$Z$n)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{R<h'UU'Y!e%g*VR2e-W%QdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)y+R+V,h,k,p-a-i-w-}.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3^5b5m5}6O6R6f8R8X8h8r!r)Z$Z$n'U)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{Q,e&lQ0m+aQ3Q._Q6r3UR8x6t!b$Tc#Y%o(O(U(p(u)V)W)[)c+r-p-u-z-|.k.n/X0e2p2w3]3m4r4{6e6j6y8p9{;R!P;_)Y)m-R.t2]2`3b3k3l3q3y6_6z7T7U7}8l8z9Q9R:`:g<o!f$Vc#Y%o(O(U(p(u)S)T)V)W)[)c+r-p-u-z-|.k.n/X0e2p2w3]3m4r4{6e6j6y8p9{;R!T;a)Y)m-R.t2]2`3b3h3i3k3l3q3y6_6z7T7U7}8l8z9Q9R:`:g<o!^$Zc#Y%o(O(U(p(u)[)c+r-p-u-z-|.k.n/X0e2p2w3]3m4r4{6e6j6y8p9{;RQ3}/cz<{)Y)m-R.t2]2`3b3q3y6_6z7T7U7}8l8z9Q9R:`:g<oQ=Q=SR=R=T'OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{S$oh$pR3v.|'VgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.|.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{T$kf$qQ$ifS)f$l)jR)r$qT$jf$qT)h$l)j'VhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)y+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.|.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5`5b5m5}6O6R6]6f6t8R8X8h8r9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{T$oh$pQ$rhR)q$p%[jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)y+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5b5m5}6O6R6f6t8R8X8h8r!s<y$Z$n'U)o,|-P.}2b3u5`6]9h9y;P;S;T;W;X;Y;Z;[;];^;_;`;a;b;c;d;f;i;v;x;y;{<T<U<_<`<{#elOPXZst!Z!`!o#S#d#o#{$n%k&h&k&l&o&q&r&t&x'Q'_(z)o+V+a,h,k,p-a._.}/f0a1d1t1u1w1y1|2P2R3U3u5b5m5}6O6R6t8R8X8h!O%Ri$d%O%Q%]%^%b)}*P*[*r*s.w/o0V0X0d3}4m9T<x=Q=R#^(s#v$b$c$x${)u){*R*U*b+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4u4x5l6p7_7h8U8u9b9l:O:c:k;j;l;p;r;t;|<O<R<V<X<Z<]<a=U=VQ*}%`Q/Y)zo3p;g;h;k;m;q;s;u;}<P<S<W<Y<[<^<b!O$yi$d%O%Q%]%^%b)}*P*[*r*s.w/o0V0X0d3}4m9T<x=Q=RQ*^$zU*g$|*V*jQ+O%aQ/}*h#^<k#v$b$c$x${)u){*R*U*b+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4u4x5l6p7_7h8U8u9b9l:O:c:k;j;l;p;r;t;|<O<R<V<X<Z<]<a=U=Vn<l;g;h;k;m;q;s;u;}<P<S<W<Y<[<^<bQ<p<|Q<q<}Q<r=OR<s=P!O%Ri$d%O%Q%]%^%b)}*P*[*r*s.w/o0V0X0d3}4m9T<x=Q=R#^(s#v$b$c$x${)u){*R*U*b+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4u4x5l6p7_7h8U8u9b9l:O:c:k;j;l;p;r;t;|<O<R<V<X<Z<]<a=U=Vo3p;g;h;k;m;q;s;u;}<P<S<W<Y<[<^<bnoOXst!Z#d%k&o&q&r&t,k,p1|2PS*a${*UQ,y&{Q,z&}R4X/p$|%Si#v$b$c$d$x${%O%Q%]%^%b)u){)}*P*R*U*[*b*r*s+`+c+z+}.^.w/]/e/o/p/r0V0X0d1W1Z1c3T3}4Y4b4m4u4x5l6p7_7h8U8u9T9b9l:O:c:k;g;h;j;k;l;m;p;q;r;s;t;u;|;}<O<P<R<S<V<W<X<Y<Z<[<]<^<a<b<x=Q=R=U=VQ+|&YQ1Y,OQ5[1XR7z5]V*i$|*V*jU*i$|*V*jT5d1a5eU/{*f/f5bS4f0T8RR7j4hQ+d%vQ/|*gQ0r+eQ1g,XQ5p1hQ8Z5qQ9o8[R:e9p!O%Oi$d%O%Q%]%^%b)}*P*[*r*s.w/o0V0X0d3}4m9T<x=Q=Rr)}$v)a*O*p+P/n0Z0[3s4V4q7X7k:U<j<v<wS0V*o0W#^;j#v$b$c$x${)u){*R*U*b+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4u4x5l6p7_7h8U8u9b9l:O:c:k;j;l;p;r;t;|<O<R<V<X<Z<]<a=U=Vn;k;g;h;k;m;q;s;u;}<P<S<W<Y<[<^<b!`;|(q)_*W*`.b.e.i/U/Z/c/s0k1V1X3Y4W4[5Z5]6u6x7`7d7m7o9X9_:]:l=S=T`;}3o6{7O7S8{:Q:T:{S<X.d3ZT<Y6}9O!O%Qi$d%O%Q%]%^%b)}*P*[*r*s.w/o0V0X0d3}4m9T<x=Q=Rv*P$v)a*Q*o+P/_/n0Z0[3s4V4i4q7X7k:U<j<v<wS0X*p0Y#^;l#v$b$c$x${)u){*R*U*b+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4u4x5l6p7_7h8U8u9b9l:O:c:k;j;l;p;r;t;|<O<R<V<X<Z<]<a=U=Vn;m;g;h;k;m;q;s;u;}<P<S<W<Y<[<^<b!d<O(q)_*W*`.c.d.i/U/Z/c/s0k1V1X3W3Y4W4[5Z5]6u6v6x7`7d7m7o9X9_:]:l=S=Td<P3o6|6}7S8{8|:Q:R:T:{S<Z.e3[T<[7O9PrnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PQ&c!UR,h&lrnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PR&c!UQ,Q&ZR1U+ysnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PQ1b,VS5k1e1fU8T5i5j5nS9k8V8WS:a9j9mQ:q:bR:y:rQ&j!VR,a&fR5w1nS&O|&TR0}+pQ&o!WR,k&pR,q&uT1},p2PR,u&vQ,t&vR2W,uQ'v!{R-q'vSsOtQ#dXT%ns#dQ#OTR'x#OQ#RUR'z#RQ)w$uR/V)wQ#UVR'|#UQ#XWU(S#X(T-xQ(T#YR-x(UQ-U'VR2d-UQ.m(uS3_.m3`R3`.nQ-]']R2h-]Y!rQ']-]1a5eR'g!rQ.x)aR3t.xU#_W%f*UU(Z#_([-yQ([#`R-y(VQ-X'YR2f-Xt`OXst!V!Z#d%k&f&h&o&q&r&t,k,p1|2PS#hZ%cU#r`#h.SR.S(fQ(g#jQ.P(cW.X(g.P2y6kQ2y.QR6k2zQ)j$lR/O)jQ$phR)p$pQ$`cU)]$`-t;eQ-t;RR;e)mQ/i*XW4R/i4S7]9WU4S/j/k/lS7]4T4UR9W7^$Z)|$v(q)_)a*W*`*o*p*z*{+P.d.e.g.h.i/U/Z/_/a/c/n/s0Z0[0k1V1X3W3X3Y3o3s4V4W4[4i4k4q5Z5]6u6v6w6x6}7O7Q7R7S7X7`7d7k7m7o8{8|8}9X9_:Q:R:S:T:U:]:l:{<j<v<w=S=TQ/q*`U4Z/q4]7aQ4]/sR7a4[S*j$|*VR0P*jr*O$v)a*o*p+P/n0Z0[3s4V4q7X7k:U<j<v<w!`.b(q)_*W*`.d.e.i/U/Z/c/s0k1V1X3Y4W4[5Z5]6u6x7`7d7m7o9X9_:]:l=S=TU/`*O.b6{a6{3o6}7O7S8{:Q:T:{Q0W*oQ3Z.dU4j0W3Z9OR9O6}v*Q$v)a*o*p+P/_/n0Z0[3s4V4i4q7X7k:U<j<v<w!d.c(q)_*W*`.d.e.i/U/Z/c/s0k1V1X3W3Y4W4[5Z5]6u6v6x7`7d7m7o9X9_:]:l=S=TU/b*Q.c6|e6|3o6}7O7S8{8|:Q:R:T:{Q0Y*pQ3[.eU4l0Y3[9PR9P7OQ*u%UR0^*uQ4v0kR7n4vQ+X%iR0j+XQ5_1[S7|5_9iR9i7}Q,S&[R1_,SQ5e1aR8P5eQ1m,^S5u1m8_R8_5wQ0x+lW5Q0x5S7t9eQ5S0{Q7t5RR9e7uQ+q&OR1O+qQ2P,pR6V2PYrOXst#dQ&s!ZQ+Z%kQ,j&oQ,l&qQ,m&rQ,o&tQ1z,kS1},p2PR6U1|Q%mpQ&w!_Q&z!aQ&|!bQ'O!cQ'n!uQ+Y%jQ+f%xQ+x&UQ,`&jQ,w&yW-h'h'p'q'tQ-o'lQ0O*iQ0s+gS1p,a,dQ2X,vQ2Y,yQ2Z,zQ2o-gW2q-j-k-n-pQ4y0tQ5V1RQ5Y1VQ5o1gQ5y1rQ6T1{U6d2p2s2vQ6g2tQ7p4zQ7x5XQ7y5ZQ8O5dQ8Y5pQ8`5xS8o6e6iQ8q6hQ9f7vQ9n8ZQ9s8aQ9z8pQ:_9gQ:d9oQ:h9{R:s:eQ%xyQ'a!iQ'l!uU+g%y%z%{Q-O'SU-c'b'c'dS-g'h'rQ/u*dS0t+h+iQ2a-QS2m-d-eQ2t-lQ4`/yQ4z0uQ6`2gQ6c2nQ6h2uR7e4dS$wi<xR*v%VU%Ui%V<xR0]*tQ$viS(q#v+cS)_$b$cQ)a$dQ*W$xS*`${*UQ*o%OQ*p%QQ*z%]Q*{%^Q+P%bQ.d;jQ.e;lQ.g;pQ.h;rQ.i;tQ/U)uS/Z){/]Q/_)}Q/a*PQ/c*RQ/n*[S/s*b/eQ0Z*rQ0[*sh0k+`.^1c3T5l6p8U8u9l:O:c:kQ1V+zQ1X+}Q3W;|Q3X<OQ3Y<RS3o;g;hQ3s.wQ4V/oQ4W/pQ4[/rQ4i0VQ4k0XQ4q0dQ5Z1WQ5]1ZQ6u<VQ6v<XQ6w<ZQ6x<]Q6};kQ7O;mQ7Q;qQ7R;sQ7S;uQ7X3}Q7`4YQ7d4bQ7k4mQ7m4uQ7o4xQ8{<SQ8|;}Q8}<PQ9X7_Q9_7hQ:Q<WQ:R<YQ:S<[Q:T<^Q:U9TQ:]9bQ:l<aQ:{<bQ<j<xQ<v=QQ<w=RQ=S=UR=T=VQ*x%[Q.f;nR7P;onpOXst!Z#d%k&o&q&r&t,k,p1|2PQ!fPS#fZ#oQ&y!`U'e!o5b8RQ'{#SQ(|#{Q)n$nS,d&h&kQ,i&lQ,v&xQ,{'QQ-_'_Q.p(zQ/S)oS0h+V/fQ0n+aQ1x,hQ2k-aQ3R._Q3x.}Q4o0aQ5j1dQ5{1tQ5|1uQ6Q1wQ6S1yQ6X2RQ6s3UQ7V3uQ8W5mQ8d5}Q8e6OQ8g6RQ8y6tQ9m8XR9w8h#YcOPXZst!Z!`!o#d#o#{%k&h&k&l&o&q&r&t&x'Q'_(z+V+a,h,k,p-a._/f0a1d1t1u1w1y1|2P2R3U5b5m5}6O6R6t8R8X8hQ#YWQ#eYQ%ouQ%qvS%sw!gS(O#W(RQ(U#ZQ(p#uQ(u#xQ(}$OQ)O$PQ)P$QQ)Q$RQ)R$SQ)S$TQ)T$UQ)U$VQ)V$WQ)W$XQ)Y$ZQ)[$_Q)^$aQ)c$eW)m$n)o.}3uQ+^%rQ+r&PS-R'U2bQ-p'oS-u(P-wQ-z(XQ-|(`Q.k(tQ.n(vQ.r;PQ.t;SQ.u;TQ.v;WQ/X)yQ0e+RQ2],|Q2`-PQ2p-iQ2w-}Q3].lQ3b;XQ3c;YQ3d;ZQ3e;[Q3f;]Q3g;^Q3h;_Q3i;`Q3j;aQ3k;bQ3l;cQ3m.sQ3n;fQ3q;iQ3r;vQ3y;dQ4r0gQ4{0vQ6_;xQ6e2rQ6j2xQ6y3^Q6z;yQ7T;{Q7U<TQ7}5`Q8l6]Q8p6fQ8z<UQ9Q<_Q9R<`Q9{8rQ:`9hQ:g9yQ;R#SR<o<{R#[WR'W!el!tQ!r!v!y!z']'i'j'k-]-m1a5e5gS'S!e-TS-Q'T'[R2g-ZR(w#xQ!fQT-[']-]]!qQ!r']-]1a5eQ#p]R'f;QR)b$dY!uQ']-]1a5eQ'h!rS'r!v!yS't!z5gS-l'i'jQ-n'kR2u-mT#kZ%cS#jZ%cS%im,gU(c#h#i#lS.Q(d(eQ.U(fQ0i+WQ2z.RU2{.S.T.VS6l2|2}R8s6md#^W#W#Z%f(P(Y*U+T-{/er#gZm#h#i#l%c(d(e(f+W.R.S.T.V2|2}6mS*X$x*]Q/l*YQ1v,gQ2^,}Q4P/hQ6Z2UQ7[4QQ8k6[T<g'U+UV#aW%f*UU#`W%f*US(Q#W(YU(V#Z+T/eS-S'U+UT-v(P-{V'Z!e%g*VQ$lfR)t$qT)i$l)jR3w.|T*Z$x*]T*c${*UQ0l+`Q3P.^Q5i1cQ6q3TQ8V5lQ8v6pQ9j8UQ9|8uQ:b9lQ:j:OQ:r:cR:u:knqOXst!Z#d%k&o&q&r&t,k,p1|2PQ&i!VR,`&ftmOXst!U!V!Z#d%k&f&o&q&r&t,k,p1|2PR,g&lT%jm,gR1],PR,_&dQ&S|R+w&TR+m%}T&m!W&pT&n!W&pT2O,p2P",
  nodeNames: "⚠ ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in const CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
  maxTerm: 376,
  context: PZ,
  nodeProps: [
    ["isolate", -8, 5, 6, 14, 34, 36, 48, 50, 52, ""],
    ["group", -26, 9, 17, 19, 65, 204, 208, 212, 213, 215, 218, 221, 231, 233, 239, 241, 243, 245, 248, 254, 260, 262, 264, 266, 268, 270, 271, "Statement", -34, 13, 14, 29, 32, 33, 39, 48, 51, 52, 54, 59, 67, 69, 73, 77, 79, 81, 82, 107, 108, 117, 118, 135, 138, 140, 141, 142, 143, 144, 146, 147, 166, 167, 169, "Expression", -23, 28, 30, 34, 38, 40, 42, 171, 173, 175, 176, 178, 179, 180, 182, 183, 184, 186, 187, 188, 198, 200, 202, 203, "Type", -3, 85, 100, 106, "ClassItem"],
    ["openedBy", 23, "<", 35, "InterpolationStart", 53, "[", 57, "{", 70, "(", 159, "JSXStartCloseTag"],
    ["closedBy", 24, ">", 37, "InterpolationEnd", 47, "]", 58, "}", 71, ")", 164, "JSXEndTag"]
  ],
  propSources: [RZ],
  skippedNodes: [0, 5, 6, 274],
  repeatNodeCount: 37,
  tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$h&j(U!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(U!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$h&j(RpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(RpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$h&j(Rp(U!b'w0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(S#S$h&j'x0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$h&j(Rp(U!b'x0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$h&j!m),Q(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#u(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#u(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(Q':f$h&j(U!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$h&j(U!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$h&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$c`$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$c``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$c`$h&j(U!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(U!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$c`(U!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$h&j(Rp(U!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$h&j(Rp(U!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$h&j(U!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$h&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(U!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$h&j(RpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(RpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Rp(U!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$h&j(j%1l(Rp(U!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$h&j(Rp(U!b$[#t(O,2j(`$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$h&j(Rp(U!b$[#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$h&j(Rp(U!b#m(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$h&j$P(Ch(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(u+JY$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$h&j#y(Ch(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(T';W$h&j(RpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$h&j(RpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$h&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$c`$h&j(RpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(RpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$c`(RpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!i/.^$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!h!Lf$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$h&j(Rp(U!b(P%&f#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$h&j(Rp(U!b#k(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$h&j(Rp(U!bo+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!Y+Jf$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$h&j(Rp(U!b}.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_!X!L^$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$h&j(Rp(U!b#l(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$h&j(Rp(U!b!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$h&j(U!b!U7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$h&j!U7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$h&j!U7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!U7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!U7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$h&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$h&j(U!b!U7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(U!b!U7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(U!b!U7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(U!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$h&j(U!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$h&j(Rp!U7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$h&j(Rp!U7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Rp!U7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Rp!U7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(RpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$h&j(RpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$h&j(Rp(U!b!U7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Rp(U!b!U7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Rp(U!b!U7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Rp(U!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$h&j(Rp(U!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$h&j(Rp(U!b'y0/l!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$h&j(Rp(U!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$h&j(U!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$h&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(U!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$h&j(RpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(RpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Rp(U!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$h&j$P(Ch(Rp(U!b!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Y#t$h&j(Rp(U!b!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!d$b$h&j#})Lv(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#O-<U(Rp(U!b(y7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$j&j(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#o(Ch(Rp(U!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$P(Ch(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#p(Ch(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#]*!Y$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#h(Cl$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#p(Ch$e#|$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#p(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#o(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#o(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(m(Ct$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$h&j#z(Ch(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!y$Ip$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!P0,v$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$h&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$h&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$h&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$h&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$h&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!V#)l$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#w(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$h&j(Rp(U!b([+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$h&j(Rp(U!b(O,2j$^#t(`$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$h&j(Rp(U!b$^#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X![#Hb(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(t+JY$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z(Kd$?V_!Z(Cds`$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!n7`$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$h&j(Rp(U!b'w0/l$[#t(O,2j(`$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$h&j(Rp(U!b'x0/l$[#t(O,2j(`$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
  tokenizers: [QZ, TZ, MZ, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, CZ, new Fg("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOu~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!R~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(^~~", 141, 335), new Fg("j~RQYZXz{^~^O'{~~aP!P!Qd~iO'|~~", 25, 318)],
  topRules: { Script: [0, 7], SingleExpression: [1, 272], SingleClassItem: [2, 273] },
  dialects: { jsx: 0, ts: 14725 },
  dynamicPrecedences: { 77: 1, 79: 1, 91: 1, 167: 1, 196: 1 },
  specialized: [{ term: 322, get: /* @__PURE__ */ m((s) => AZ[s] || -1, "get") }, { term: 338, get: /* @__PURE__ */ m((s) => EZ[s] || -1, "get") }, { term: 92, get: /* @__PURE__ */ m((s) => zZ[s] || -1, "get") }],
  tokenPrec: 14749
}), nT = [
  /* @__PURE__ */ ai("function ${name}(${params}) {\n	${}\n}", {
    label: "function",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("for (let ${name} of ${collection}) {\n	${}\n}", {
    label: "for",
    detail: "of loop",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("do {\n	${}\n} while (${})", {
    label: "do",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("while (${}) {\n	${}\n}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ ai(`try {
	\${}
} catch (\${error}) {
	\${}
}`, {
    label: "try",
    detail: "/ catch block",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("if (${}) {\n	${}\n}", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  /* @__PURE__ */ ai(`if (\${}) {
	\${}
} else {
	\${}
}`, {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  /* @__PURE__ */ ai(`class \${name} {
	constructor(\${params}) {
		\${}
	}
}`, {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ ai('import {${names}} from "${module}"\n${}', {
    label: "import",
    detail: "named",
    type: "keyword"
  }),
  /* @__PURE__ */ ai('import ${name} from "${module}"\n${}', {
    label: "import",
    detail: "default",
    type: "keyword"
  })
], LZ = /* @__PURE__ */ nT.concat([
  /* @__PURE__ */ ai("interface ${name} {\n	${}\n}", {
    label: "interface",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("type ${name} = ${type}", {
    label: "type",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ ai("enum ${name} {\n	${}\n}", {
    label: "enum",
    detail: "definition",
    type: "keyword"
  })
]), HP = /* @__PURE__ */ new v8(), sT = /* @__PURE__ */ new Set([
  "Script",
  "Block",
  "FunctionExpression",
  "FunctionDeclaration",
  "ArrowFunction",
  "MethodDeclaration",
  "ForStatement"
]);
function Zl(s) {
  return (t, i) => {
    let n = t.node.getChild("VariableDefinition");
    return n && i(n, s), !0;
  };
}
u(Zl, "lr");
m(Zl, "defID");
const IZ = ["FunctionDeclaration"], WZ = {
  FunctionDeclaration: /* @__PURE__ */ Zl("function"),
  ClassDeclaration: /* @__PURE__ */ Zl("class"),
  ClassExpression: /* @__PURE__ */ m(() => !0, "ClassExpression"),
  EnumDeclaration: /* @__PURE__ */ Zl("constant"),
  TypeAliasDeclaration: /* @__PURE__ */ Zl("type"),
  NamespaceDeclaration: /* @__PURE__ */ Zl("namespace"),
  VariableDefinition(s, t) {
    s.matchContext(IZ) || t(s, "variable");
  },
  TypeDefinition(s, t) {
    t(s, "type");
  },
  __proto__: null
};
function bk(s, t) {
  let i = HP.get(t);
  if (i)
    return i;
  let n = [], r = !0;
  function a(o, l) {
    let c = s.sliceString(o.from, o.to);
    n.push({ label: c, type: l });
  }
  return u(a, "s"), m(a, "def"), t.cursor(Ne.IncludeAnonymous).iterate((o) => {
    if (r)
      r = !1;
    else if (o.name) {
      let l = WZ[o.name];
      if (l && l(o, a) || sT.has(o.name))
        return !1;
    } else if (o.to - o.from > 8192) {
      for (let l of bk(s, o.node))
        n.push(l);
      return !1;
    }
  }), HP.set(t, n), n;
}
u(bk, "om$1");
m(bk, "getScope");
const Jg = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/, $k = [
  "TemplateString",
  "String",
  "RegExp",
  "LineComment",
  "BlockComment",
  "VariableDefinition",
  "TypeDefinition",
  "Label",
  "PropertyDefinition",
  "PropertyName",
  "PrivatePropertyDefinition",
  "PrivatePropertyName",
  ".",
  "?."
];
function rT(s) {
  let t = nt(s.state).resolveInner(s.pos, -1);
  if ($k.indexOf(t.name) > -1)
    return null;
  let i = t.name == "VariableName" || t.to - t.from < 20 && Jg.test(s.state.sliceDoc(t.from, t.to));
  if (!i && !s.explicit)
    return null;
  let n = [];
  for (let r = t; r; r = r.parent)
    sT.has(r.name) && (n = n.concat(bk(s.state.doc, r)));
  return {
    options: n,
    from: i ? t.from : s.pos,
    validFor: Jg
  };
}
u(rT, "lm$1");
m(rT, "localCompletionSource");
function Jw(s, t, i) {
  var n;
  let r = [];
  for (; ; ) {
    let a = t.firstChild, o;
    if ((a == null ? void 0 : a.name) == "VariableName")
      return r.push(s(a)), { path: r.reverse(), name: i };
    if ((a == null ? void 0 : a.name) == "MemberExpression" && ((n = o = a.lastChild) === null || n === void 0 ? void 0 : n.name) == "PropertyName")
      r.push(s(o)), t = a;
    else
      return null;
  }
}
u(Jw, "qo$1");
m(Jw, "pathFor");
function aT(s) {
  let t = /* @__PURE__ */ m((n) => s.state.doc.sliceString(n.from, n.to), "read"), i = nt(s.state).resolveInner(s.pos, -1);
  return i.name == "PropertyName" ? Jw(t, i.parent, t(i)) : (i.name == "." || i.name == "?.") && i.parent.name == "MemberExpression" ? Jw(t, i.parent, "") : $k.indexOf(i.name) > -1 ? null : i.name == "VariableName" || i.to - i.from < 20 && Jg.test(t(i)) ? { path: [], name: t(i) } : i.name == "MemberExpression" ? Jw(t, i, "") : s.explicit ? { path: [], name: "" } : null;
}
u(aT, "am$1");
m(aT, "completionPath");
function oT(s, t) {
  let i = [], n = /* @__PURE__ */ new Set();
  for (let r = 0; ; r++) {
    for (let o of (Object.getOwnPropertyNames || Object.keys)(s)) {
      if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(o) || n.has(o))
        continue;
      n.add(o);
      let l;
      try {
        l = s[o];
      } catch {
        continue;
      }
      i.push({
        label: o,
        type: typeof l == "function" ? /^[A-Z]/.test(o) ? "class" : t ? "function" : "method" : t ? "variable" : "property",
        boost: -r
      });
    }
    let a = Object.getPrototypeOf(s);
    if (!a)
      return i;
    s = a;
  }
}
u(oT, "XS");
m(oT, "enumeratePropertyCompletions");
function VZ(s) {
  let t = /* @__PURE__ */ new Map();
  return (i) => {
    let n = aT(i);
    if (!n)
      return null;
    let r = s;
    for (let o of n.path)
      if (r = r[o], !r)
        return null;
    let a = t.get(r);
    return a || t.set(r, a = oT(r, !n.path.length)), {
      from: i.pos - n.name.length,
      options: a,
      validFor: Jg
    };
  };
}
u(VZ, "IS");
m(VZ, "scopeCompletionSource");
const on = /* @__PURE__ */ Vx.define({
  name: "javascript",
  parser: /* @__PURE__ */ _Z.configure({
    props: [
      /* @__PURE__ */ zf.add({
        IfStatement: /* @__PURE__ */ By({ except: /^\s*({|else\b)/ }),
        TryStatement: /* @__PURE__ */ By({ except: /^\s*({|catch\b|finally\b)/ }),
        LabeledStatement: zI,
        SwitchBody: /* @__PURE__ */ m((s) => {
          let t = s.textAfter, i = /^\s*\}/.test(t), n = /^\s*(case|default)\b/.test(t);
          return s.baseIndent + (i ? 0 : n ? 1 : 2) * s.unit;
        }, "SwitchBody"),
        Block: /* @__PURE__ */ i6({ closing: "}" }),
        ArrowFunction: /* @__PURE__ */ m((s) => s.baseIndent + s.unit, "ArrowFunction"),
        "TemplateString BlockComment": /* @__PURE__ */ m(() => null, "TemplateString BlockComment"),
        "Statement Property": /* @__PURE__ */ By({ except: /^{/ }),
        JSXElement(s) {
          let t = /^\s*<\//.test(s.textAfter);
          return s.lineIndent(s.node.from) + (t ? 0 : s.unit);
        },
        JSXEscape(s) {
          let t = /\s*\}/.test(s.textAfter);
          return s.lineIndent(s.node.from) + (t ? 0 : s.unit);
        },
        "JSXOpenTag JSXSelfClosingTag"(s) {
          return s.column(s.node.from) + s.unit;
        }
      }),
      /* @__PURE__ */ jm.add({
        "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": Ux,
        BlockComment(s) {
          return { from: s.from + 2, to: s.to - 2 };
        }
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`"] },
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
    wordChars: "$"
  }
}), lT = {
  test: /* @__PURE__ */ m((s) => /^JSX/.test(s.name), "test"),
  facet: /* @__PURE__ */ Bm({ commentTokens: { block: { open: "{/*", close: "*/}" } } })
}, cT = /* @__PURE__ */ on.configure({ dialect: "ts" }, "typescript"), hT = /* @__PURE__ */ on.configure({
  dialect: "jsx",
  props: [/* @__PURE__ */ Wx.add((s) => s.isTop ? [lT] : void 0)]
}), dT = /* @__PURE__ */ on.configure({
  dialect: "jsx ts",
  props: [/* @__PURE__ */ Wx.add((s) => s.isTop ? [lT] : void 0)]
}, "typescript");
let uT = /* @__PURE__ */ m((s) => ({ label: s, type: "keyword" }), "kwCompletion");
const pT = /* @__PURE__ */ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(uT), ZZ = /* @__PURE__ */ pT.concat(/* @__PURE__ */ ["declare", "implements", "private", "protected", "public"].map(uT));
function fT(s = {}) {
  let t = s.jsx ? s.typescript ? dT : hT : s.typescript ? cT : on, i = s.typescript ? LZ.concat(ZZ) : nT.concat(pT);
  return new df(t, [
    on.data.of({
      autocomplete: $6($k, Hx(i))
    }),
    on.data.of({
      autocomplete: rT
    }),
    s.jsx ? qZ : []
  ]);
}
u(fT, "um$1");
m(fT, "javascript");
function yT(s) {
  for (; ; ) {
    if (s.name == "JSXOpenTag" || s.name == "JSXSelfClosingTag" || s.name == "JSXFragmentTag")
      return s;
    if (s.name == "JSXEscape" || !s.parent)
      return null;
    s = s.parent;
  }
}
u(yT, "qS");
m(yT, "findOpenTag");
function F2(s, t, i = s.length) {
  for (let n = t == null ? void 0 : t.firstChild; n; n = n.nextSibling)
    if (n.name == "JSXIdentifier" || n.name == "JSXBuiltin" || n.name == "JSXNamespacedName" || n.name == "JSXMemberExpression")
      return s.sliceString(n.from, Math.min(n.to, i));
  return "";
}
u(F2, "bd$1");
m(F2, "elementName$1");
const DZ = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), qZ = /* @__PURE__ */ $e.inputHandler.of((s, t, i, n, r) => {
  if ((DZ ? s.composing : s.compositionStarted) || s.state.readOnly || t != i || n != ">" && n != "/" || !on.isActiveAt(s.state, t, -1))
    return !1;
  let a = r(), { state: o } = a, l = o.changeByRange((c) => {
    var h;
    let { head: d } = c, f = nt(o).resolveInner(d - 1, -1), y;
    if (f.name == "JSXStartTag" && (f = f.parent), !(o.doc.sliceString(d - 1, d) != n || f.name == "JSXAttributeValue" && f.to > d)) {
      if (n == ">" && f.name == "JSXFragmentTag")
        return { range: c, changes: { from: d, insert: "</>" } };
      if (n == "/" && f.name == "JSXStartCloseTag") {
        let w = f.parent, g = w.parent;
        if (g && w.from == d - 2 && ((y = F2(o.doc, g.firstChild, d)) || ((h = g.firstChild) === null || h === void 0 ? void 0 : h.name) == "JSXFragmentTag")) {
          let b = `${y}>`;
          return { range: J.cursor(d + b.length, -1), changes: { from: d, insert: b } };
        }
      } else if (n == ">") {
        let w = yT(f);
        if (w && w.name == "JSXOpenTag" && !/^\/?>|^<\//.test(o.doc.sliceString(d, d + 2)) && (y = F2(o.doc, w, d)))
          return { range: c, changes: { from: d, insert: `</${y}>` } };
      }
    }
    return { range: c };
  });
  return l.changes.empty ? !1 : (s.dispatch([
    a,
    o.update(l, { userEvent: "input.complete", scrollIntoView: !0 })
  ]), !0);
});
function UZ(s, t) {
  return t || (t = {
    parserOptions: { ecmaVersion: 2019, sourceType: "module" },
    env: { browser: !0, node: !0, es6: !0, es2015: !0, es2017: !0, es2020: !0 },
    rules: {}
  }, s.getRules().forEach((i, n) => {
    i.meta.docs.recommended && (t.rules[n] = 2);
  })), (i) => {
    let { state: n } = i, r = [];
    for (let { from: a, to: o } of on.findRegions(n)) {
      let l = n.doc.lineAt(a), c = { line: l.number - 1, col: a - l.from, pos: a };
      for (let h of s.verify(n.sliceDoc(a, o), t))
        r.push(mT(h, n.doc, c));
    }
    return r;
  };
}
u(UZ, "DS");
m(UZ, "esLint");
function H2(s, t, i, n) {
  return i.line(s + n.line).from + t + (s == 1 ? n.col - 1 : -1);
}
u(H2, "yd");
m(H2, "mapPos");
function mT(s, t, i) {
  let n = H2(s.line, s.column, t, i), r = {
    from: n,
    to: s.endLine != null && s.endColumn != 1 ? H2(s.endLine, s.endColumn, t, i) : n,
    message: s.message,
    source: s.ruleId ? "eslint:" + s.ruleId : "eslint",
    severity: s.severity == 1 ? "warning" : "error"
  };
  if (s.fix) {
    let { range: a, text: o } = s.fix, l = a[0] + i.pos - n, c = a[1] + i.pos - n;
    r.actions = [{
      name: "fix",
      apply(h, d) {
        h.dispatch({ changes: { from: d + l, to: d + c, insert: o }, scrollIntoView: !0 });
      }
    }];
  }
  return r;
}
u(mT, "BS");
m(mT, "translateDiagnostic");
const Yf = ["_blank", "_self", "_top", "_parent"], nO = ["ascii", "utf-8", "utf-16", "latin1", "latin1"], sO = ["get", "post", "put", "delete"], rO = ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"], Si = ["true", "false"], ue = {}, NZ = {
  a: {
    attrs: {
      href: null,
      ping: null,
      type: null,
      media: null,
      target: Yf,
      hreflang: null
    }
  },
  abbr: ue,
  address: ue,
  area: {
    attrs: {
      alt: null,
      coords: null,
      href: null,
      target: null,
      ping: null,
      media: null,
      hreflang: null,
      type: null,
      shape: ["default", "rect", "circle", "poly"]
    }
  },
  article: ue,
  aside: ue,
  audio: {
    attrs: {
      src: null,
      mediagroup: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["none", "metadata", "auto"],
      autoplay: ["autoplay"],
      loop: ["loop"],
      controls: ["controls"]
    }
  },
  b: ue,
  base: { attrs: { href: null, target: Yf } },
  bdi: ue,
  bdo: ue,
  blockquote: { attrs: { cite: null } },
  body: ue,
  br: ue,
  button: {
    attrs: {
      form: null,
      formaction: null,
      name: null,
      value: null,
      autofocus: ["autofocus"],
      disabled: ["autofocus"],
      formenctype: rO,
      formmethod: sO,
      formnovalidate: ["novalidate"],
      formtarget: Yf,
      type: ["submit", "reset", "button"]
    }
  },
  canvas: { attrs: { width: null, height: null } },
  caption: ue,
  center: ue,
  cite: ue,
  code: ue,
  col: { attrs: { span: null } },
  colgroup: { attrs: { span: null } },
  command: {
    attrs: {
      type: ["command", "checkbox", "radio"],
      label: null,
      icon: null,
      radiogroup: null,
      command: null,
      title: null,
      disabled: ["disabled"],
      checked: ["checked"]
    }
  },
  data: { attrs: { value: null } },
  datagrid: { attrs: { disabled: ["disabled"], multiple: ["multiple"] } },
  datalist: { attrs: { data: null } },
  dd: ue,
  del: { attrs: { cite: null, datetime: null } },
  details: { attrs: { open: ["open"] } },
  dfn: ue,
  div: ue,
  dl: ue,
  dt: ue,
  em: ue,
  embed: { attrs: { src: null, type: null, width: null, height: null } },
  eventsource: { attrs: { src: null } },
  fieldset: { attrs: { disabled: ["disabled"], form: null, name: null } },
  figcaption: ue,
  figure: ue,
  footer: ue,
  form: {
    attrs: {
      action: null,
      name: null,
      "accept-charset": nO,
      autocomplete: ["on", "off"],
      enctype: rO,
      method: sO,
      novalidate: ["novalidate"],
      target: Yf
    }
  },
  h1: ue,
  h2: ue,
  h3: ue,
  h4: ue,
  h5: ue,
  h6: ue,
  head: {
    children: ["title", "base", "link", "style", "meta", "script", "noscript", "command"]
  },
  header: ue,
  hgroup: ue,
  hr: ue,
  html: {
    attrs: { manifest: null }
  },
  i: ue,
  iframe: {
    attrs: {
      src: null,
      srcdoc: null,
      name: null,
      width: null,
      height: null,
      sandbox: ["allow-top-navigation", "allow-same-origin", "allow-forms", "allow-scripts"],
      seamless: ["seamless"]
    }
  },
  img: {
    attrs: {
      alt: null,
      src: null,
      ismap: null,
      usemap: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"]
    }
  },
  input: {
    attrs: {
      alt: null,
      dirname: null,
      form: null,
      formaction: null,
      height: null,
      list: null,
      max: null,
      maxlength: null,
      min: null,
      name: null,
      pattern: null,
      placeholder: null,
      size: null,
      src: null,
      step: null,
      value: null,
      width: null,
      accept: ["audio/*", "video/*", "image/*"],
      autocomplete: ["on", "off"],
      autofocus: ["autofocus"],
      checked: ["checked"],
      disabled: ["disabled"],
      formenctype: rO,
      formmethod: sO,
      formnovalidate: ["novalidate"],
      formtarget: Yf,
      multiple: ["multiple"],
      readonly: ["readonly"],
      required: ["required"],
      type: [
        "hidden",
        "text",
        "search",
        "tel",
        "url",
        "email",
        "password",
        "datetime",
        "date",
        "month",
        "week",
        "time",
        "datetime-local",
        "number",
        "range",
        "color",
        "checkbox",
        "radio",
        "file",
        "submit",
        "image",
        "reset",
        "button"
      ]
    }
  },
  ins: { attrs: { cite: null, datetime: null } },
  kbd: ue,
  keygen: {
    attrs: {
      challenge: null,
      form: null,
      name: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      keytype: ["RSA"]
    }
  },
  label: { attrs: { for: null, form: null } },
  legend: ue,
  li: { attrs: { value: null } },
  link: {
    attrs: {
      href: null,
      type: null,
      hreflang: null,
      media: null,
      sizes: ["all", "16x16", "16x16 32x32", "16x16 32x32 64x64"]
    }
  },
  map: { attrs: { name: null } },
  mark: ue,
  menu: { attrs: { label: null, type: ["list", "context", "toolbar"] } },
  meta: {
    attrs: {
      content: null,
      charset: nO,
      name: ["viewport", "application-name", "author", "description", "generator", "keywords"],
      "http-equiv": ["content-language", "content-type", "default-style", "refresh"]
    }
  },
  meter: { attrs: { value: null, min: null, low: null, high: null, max: null, optimum: null } },
  nav: ue,
  noscript: ue,
  object: {
    attrs: {
      data: null,
      type: null,
      name: null,
      usemap: null,
      form: null,
      width: null,
      height: null,
      typemustmatch: ["typemustmatch"]
    }
  },
  ol: {
    attrs: { reversed: ["reversed"], start: null, type: ["1", "a", "A", "i", "I"] },
    children: ["li", "script", "template", "ul", "ol"]
  },
  optgroup: { attrs: { disabled: ["disabled"], label: null } },
  option: { attrs: { disabled: ["disabled"], label: null, selected: ["selected"], value: null } },
  output: { attrs: { for: null, form: null, name: null } },
  p: ue,
  param: { attrs: { name: null, value: null } },
  pre: ue,
  progress: { attrs: { value: null, max: null } },
  q: { attrs: { cite: null } },
  rp: ue,
  rt: ue,
  ruby: ue,
  samp: ue,
  script: {
    attrs: {
      type: ["text/javascript"],
      src: null,
      async: ["async"],
      defer: ["defer"],
      charset: nO
    }
  },
  section: ue,
  select: {
    attrs: {
      form: null,
      name: null,
      size: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      multiple: ["multiple"]
    }
  },
  slot: { attrs: { name: null } },
  small: ue,
  source: { attrs: { src: null, type: null, media: null } },
  span: ue,
  strong: ue,
  style: {
    attrs: {
      type: ["text/css"],
      media: null,
      scoped: null
    }
  },
  sub: ue,
  summary: ue,
  sup: ue,
  table: ue,
  tbody: ue,
  td: { attrs: { colspan: null, rowspan: null, headers: null } },
  template: ue,
  textarea: {
    attrs: {
      dirname: null,
      form: null,
      maxlength: null,
      name: null,
      placeholder: null,
      rows: null,
      cols: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      readonly: ["readonly"],
      required: ["required"],
      wrap: ["soft", "hard"]
    }
  },
  tfoot: ue,
  th: { attrs: { colspan: null, rowspan: null, headers: null, scope: ["row", "col", "rowgroup", "colgroup"] } },
  thead: ue,
  time: { attrs: { datetime: null } },
  title: ue,
  tr: ue,
  track: {
    attrs: {
      src: null,
      label: null,
      default: null,
      kind: ["subtitles", "captions", "descriptions", "chapters", "metadata"],
      srclang: null
    }
  },
  ul: { children: ["li", "script", "template", "ul", "ol"] },
  var: ue,
  video: {
    attrs: {
      src: null,
      poster: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["auto", "metadata", "none"],
      autoplay: ["autoplay"],
      mediagroup: ["movie"],
      muted: ["muted"],
      controls: ["controls"]
    }
  },
  wbr: ue
}, wT = {
  accesskey: null,
  class: null,
  contenteditable: Si,
  contextmenu: null,
  dir: ["ltr", "rtl", "auto"],
  draggable: ["true", "false", "auto"],
  dropzone: ["copy", "move", "link", "string:", "file:"],
  hidden: ["hidden"],
  id: null,
  inert: ["inert"],
  itemid: null,
  itemprop: null,
  itemref: null,
  itemscope: ["itemscope"],
  itemtype: null,
  lang: ["ar", "bn", "de", "en-GB", "en-US", "es", "fr", "hi", "id", "ja", "pa", "pt", "ru", "tr", "zh"],
  spellcheck: Si,
  autocorrect: Si,
  autocapitalize: Si,
  style: null,
  tabindex: null,
  title: null,
  translate: ["yes", "no"],
  rel: ["stylesheet", "alternate", "author", "bookmark", "help", "license", "next", "nofollow", "noreferrer", "prefetch", "prev", "search", "tag"],
  role: /* @__PURE__ */ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
  "aria-activedescendant": null,
  "aria-atomic": Si,
  "aria-autocomplete": ["inline", "list", "both", "none"],
  "aria-busy": Si,
  "aria-checked": ["true", "false", "mixed", "undefined"],
  "aria-controls": null,
  "aria-describedby": null,
  "aria-disabled": Si,
  "aria-dropeffect": null,
  "aria-expanded": ["true", "false", "undefined"],
  "aria-flowto": null,
  "aria-grabbed": ["true", "false", "undefined"],
  "aria-haspopup": Si,
  "aria-hidden": Si,
  "aria-invalid": ["true", "false", "grammar", "spelling"],
  "aria-label": null,
  "aria-labelledby": null,
  "aria-level": null,
  "aria-live": ["off", "polite", "assertive"],
  "aria-multiline": Si,
  "aria-multiselectable": Si,
  "aria-owns": null,
  "aria-posinset": null,
  "aria-pressed": ["true", "false", "mixed", "undefined"],
  "aria-readonly": Si,
  "aria-relevant": null,
  "aria-required": Si,
  "aria-selected": ["true", "false", "undefined"],
  "aria-setsize": null,
  "aria-sort": ["ascending", "descending", "none", "other"],
  "aria-valuemax": null,
  "aria-valuemin": null,
  "aria-valuenow": null,
  "aria-valuetext": null
}, gT = /* @__PURE__ */ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((s) => "on" + s);
for (let s of gT)
  wT[s] = null;
var yd;
const vT = (yd = class {
  constructor(t, i) {
    this.tags = Object.assign(Object.assign({}, NZ), t), this.globalAttrs = Object.assign(Object.assign({}, wT), i), this.allTags = Object.keys(this.tags), this.globalAttrNames = Object.keys(this.globalAttrs);
  }
}, u(yd, "Pc"), yd);
m(vT, "Schema");
let um = vT;
um.default = /* @__PURE__ */ new um();
function Oo(s, t, i = s.length) {
  if (!t)
    return "";
  let n = t.firstChild, r = n && n.getChild("TagName");
  return r ? s.sliceString(r.from, Math.min(r.to, i)) : "";
}
u(Oo, "Hi$1");
m(Oo, "elementName");
function bo(s, t = !1) {
  for (; s; s = s.parent)
    if (s.name == "Element")
      if (t)
        t = !1;
      else
        return s;
  return null;
}
u(bo, "Ki$1");
m(bo, "findParentElement");
function xk(s, t, i) {
  let n = i.tags[Oo(s, bo(t))];
  return (n == null ? void 0 : n.children) || i.allTags;
}
u(xk, "mm$1");
m(xk, "allowedChildren");
function ev(s, t) {
  let i = [];
  for (let n = bo(t); n && !n.type.isTop; n = bo(n.parent)) {
    let r = Oo(s, n);
    if (r && n.lastChild.name == "CloseTag")
      break;
    r && i.indexOf(r) < 0 && (t.name == "EndTag" || t.from >= n.firstChild.to) && i.push(r);
  }
  return i;
}
u(ev, "Qh$1");
m(ev, "openTags");
const OT = /^[:\-\.\w\u00b7-\uffff]*$/;
function Y2(s, t, i, n, r) {
  let a = /\s*>/.test(s.sliceDoc(r, r + 5)) ? "" : ">", o = bo(i, !0);
  return {
    from: n,
    to: r,
    options: xk(s.doc, o, t).map((l) => ({ label: l, type: "type" })).concat(ev(s.doc, i).map((l, c) => ({
      label: "/" + l,
      apply: "/" + l + a,
      type: "type",
      boost: 99 - c
    }))),
    validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
  };
}
u(Y2, "Sd$1");
m(Y2, "completeTag");
function G2(s, t, i, n) {
  let r = /\s*>/.test(s.sliceDoc(n, n + 5)) ? "" : ">";
  return {
    from: i,
    to: n,
    options: ev(s.doc, t).map((a, o) => ({ label: a, apply: a + r, type: "type", boost: 99 - o })),
    validFor: OT
  };
}
u(G2, "Pd$1");
m(G2, "completeCloseTag");
function bT(s, t, i, n) {
  let r = [], a = 0;
  for (let o of xk(s.doc, i, t))
    r.push({ label: "<" + o, type: "type" });
  for (let o of ev(s.doc, i))
    r.push({ label: "</" + o + ">", type: "type", boost: 99 - a++ });
  return { from: n, to: n, options: r, validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/ };
}
u(bT, "GS");
m(bT, "completeStartTag");
function $T(s, t, i, n, r) {
  let a = bo(i), o = a ? t.tags[Oo(s.doc, a)] : null, l = o && o.attrs ? Object.keys(o.attrs) : [], c = o && o.globalAttrs === !1 ? l : l.length ? l.concat(t.globalAttrNames) : t.globalAttrNames;
  return {
    from: n,
    to: r,
    options: c.map((h) => ({ label: h, type: "property" })),
    validFor: OT
  };
}
u($T, "FS");
m($T, "completeAttrName");
function xT(s, t, i, n, r) {
  var a;
  let o = (a = i.parent) === null || a === void 0 ? void 0 : a.getChild("AttributeName"), l = [], c;
  if (o) {
    let h = s.sliceDoc(o.from, o.to), d = t.globalAttrs[h];
    if (!d) {
      let f = bo(i), y = f ? t.tags[Oo(s.doc, f)] : null;
      d = (y == null ? void 0 : y.attrs) && y.attrs[h];
    }
    if (d) {
      let f = s.sliceDoc(n, r).toLowerCase(), y = '"', w = '"';
      /^['"]/.test(f) ? (c = f[0] == '"' ? /^[^"]*$/ : /^[^']*$/, y = "", w = s.sliceDoc(r, r + 1) == f[0] ? "" : f[0], f = f.slice(1), n++) : c = /^[^\s<>='"]*$/;
      for (let g of d)
        l.push({ label: g, apply: y + g + w, type: "constant" });
    }
  }
  return { from: n, to: r, options: l, validFor: c };
}
u(xT, "HS");
m(xT, "completeAttrValue");
function kk(s, t) {
  let { state: i, pos: n } = t, r = nt(i).resolveInner(n, -1), a = r.resolve(n);
  for (let o = n, l; a == r && (l = r.childBefore(o)); ) {
    let c = l.lastChild;
    if (!c || !c.type.isError || c.from < c.to)
      break;
    a = r = l, o = c.from;
  }
  return r.name == "TagName" ? r.parent && /CloseTag$/.test(r.parent.name) ? G2(i, r, r.from, n) : Y2(i, s, r, r.from, n) : r.name == "StartTag" ? Y2(i, s, r, n, n) : r.name == "StartCloseTag" || r.name == "IncompleteCloseTag" ? G2(i, r, n, n) : r.name == "OpenTag" || r.name == "SelfClosingTag" || r.name == "AttributeName" ? $T(i, s, r, r.name == "AttributeName" ? r.from : n, n) : r.name == "Is" || r.name == "AttributeValue" || r.name == "UnquotedAttributeValue" ? xT(i, s, r, r.name == "Is" ? n : r.from, n) : t.explicit && (a.name == "Element" || a.name == "Text" || a.name == "Document") ? bT(i, s, r, n) : null;
}
u(kk, "bm$1");
m(kk, "htmlCompletionFor");
function kT(s) {
  return kk(um.default, s);
}
u(kT, "ym$1");
m(kT, "htmlCompletionSource");
function ST(s) {
  let { extraTags: t, extraGlobalAttributes: i } = s, n = i || t ? new um(t, i) : um.default;
  return (r) => kk(n, r);
}
u(ST, "Sm$1");
m(ST, "htmlCompletionSourceWith");
const BZ = /* @__PURE__ */ on.parser.configure({ top: "SingleExpression" }), PT = [
  {
    tag: "script",
    attrs: /* @__PURE__ */ m((s) => s.type == "text/typescript" || s.lang == "ts", "attrs"),
    parser: cT.parser
  },
  {
    tag: "script",
    attrs: /* @__PURE__ */ m((s) => s.type == "text/babel" || s.type == "text/jsx", "attrs"),
    parser: hT.parser
  },
  {
    tag: "script",
    attrs: /* @__PURE__ */ m((s) => s.type == "text/typescript-jsx", "attrs"),
    parser: dT.parser
  },
  {
    tag: "script",
    attrs(s) {
      return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(s.type);
    },
    parser: BZ
  },
  {
    tag: "script",
    attrs(s) {
      return !s.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(s.type);
    },
    parser: on.parser
  },
  {
    tag: "style",
    attrs(s) {
      return (!s.lang || s.lang == "css") && (!s.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(s.type));
    },
    parser: Kg.parser
  }
], CT = /* @__PURE__ */ [
  {
    name: "style",
    parser: /* @__PURE__ */ Kg.parser.configure({ top: "Styles" })
  }
].concat(/* @__PURE__ */ gT.map((s) => ({ name: s, parser: on.parser }))), QT = /* @__PURE__ */ Vx.define({
  name: "html",
  parser: /* @__PURE__ */ LV.configure({
    props: [
      /* @__PURE__ */ zf.add({
        Element(s) {
          let t = /^(\s*)(<\/)?/.exec(s.textAfter);
          return s.node.to <= s.pos + t[0].length ? s.continue() : s.lineIndent(s.node.from) + (t[2] ? 0 : s.unit);
        },
        "OpenTag CloseTag SelfClosingTag"(s) {
          return s.column(s.node.from) + s.unit;
        },
        Document(s) {
          if (s.pos + /\s*/.exec(s.textAfter)[0].length < s.node.to)
            return s.continue();
          let t = null, i;
          for (let n = s.node; ; ) {
            let r = n.lastChild;
            if (!r || r.name != "Element" || r.to != n.to)
              break;
            t = n = r;
          }
          return t && !((i = t.lastChild) && (i.name == "CloseTag" || i.name == "SelfClosingTag")) ? s.lineIndent(t.from) + s.unit : null;
        }
      }),
      /* @__PURE__ */ jm.add({
        Element(s) {
          let t = s.firstChild, i = s.lastChild;
          return !t || t.name != "OpenTag" ? null : { from: t.to, to: i.name == "CloseTag" ? i.from : s.to };
        }
      }),
      /* @__PURE__ */ o6.add({
        "OpenTag CloseTag": /* @__PURE__ */ m((s) => s.getChild("TagName"), "OpenTag CloseTag")
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "<!--", close: "-->" } },
    indentOnInput: /^\s*<\/\w+\W$/,
    wordChars: "-._"
  }
}), eg = /* @__PURE__ */ QT.configure({
  wrap: /* @__PURE__ */ gk(PT, CT)
});
function TT(s = {}) {
  let t = "", i;
  s.matchClosingTags === !1 && (t = "noMatch"), s.selfClosingTags === !0 && (t = (t ? t + " " : "") + "selfClosing"), (s.nestedLanguages && s.nestedLanguages.length || s.nestedAttributes && s.nestedAttributes.length) && (i = gk((s.nestedLanguages || []).concat(PT), (s.nestedAttributes || []).concat(CT)));
  let n = i ? QT.configure({ wrap: i, dialect: t }) : t ? eg.configure({ dialect: t }) : eg;
  return new df(n, [
    eg.data.of({ autocomplete: ST(s) }),
    s.autoCloseTags !== !1 ? jZ : [],
    fT().support,
    tT().support
  ]);
}
u(TT, "xm$1");
m(TT, "html");
const YP = /* @__PURE__ */ new Set(/* @__PURE__ */ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" ")), jZ = /* @__PURE__ */ $e.inputHandler.of((s, t, i, n, r) => {
  if (s.composing || s.state.readOnly || t != i || n != ">" && n != "/" || !eg.isActiveAt(s.state, t, -1))
    return !1;
  let a = r(), { state: o } = a, l = o.changeByRange((c) => {
    var h, d, f;
    let y = o.doc.sliceString(c.from - 1, c.to) == n, { head: w } = c, g = nt(o).resolveInner(w, -1), b;
    if (y && n == ">" && g.name == "EndTag") {
      let k = g.parent;
      if (((d = (h = k.parent) === null || h === void 0 ? void 0 : h.lastChild) === null || d === void 0 ? void 0 : d.name) != "CloseTag" && (b = Oo(o.doc, k.parent, w)) && !YP.has(b)) {
        let $ = w + (o.doc.sliceString(w, w + 1) === ">" ? 1 : 0), C = `</${b}>`;
        return { range: c, changes: { from: w, to: $, insert: C } };
      }
    } else if (y && n == "/" && g.name == "IncompleteCloseTag") {
      let k = g.parent;
      if (g.from == w - 2 && ((f = k.lastChild) === null || f === void 0 ? void 0 : f.name) != "CloseTag" && (b = Oo(o.doc, k, w)) && !YP.has(b)) {
        let $ = w + (o.doc.sliceString(w, w + 1) === ">" ? 1 : 0), C = `${b}>`;
        return {
          range: J.cursor(w + C.length, -1),
          changes: { from: w, to: $, insert: C }
        };
      }
    }
    return { range: c };
  });
  return l.changes.empty ? !1 : (s.dispatch([
    a,
    o.update(l, {
      userEvent: "input.complete",
      scrollIntoView: !0
    })
  ]), !0);
}), MT = /* @__PURE__ */ Bm({ commentTokens: { block: { open: "<!--", close: "-->" } } }), RT = /* @__PURE__ */ new Oe(), AT = /* @__PURE__ */ LW.configure({
  props: [
    /* @__PURE__ */ jm.add((s) => !s.is("Block") || s.is("Document") || e1(s) != null || ET(s) ? void 0 : (t, i) => ({ from: i.doc.lineAt(t.from).to, to: t.to })),
    /* @__PURE__ */ RT.add(e1),
    /* @__PURE__ */ zf.add({
      Document: /* @__PURE__ */ m(() => null, "Document")
    }),
    /* @__PURE__ */ Ks.add({
      Document: MT
    })
  ]
});
function e1(s) {
  let t = /^(?:ATX|Setext)Heading(\d)$/.exec(s.name);
  return t ? +t[1] : void 0;
}
u(e1, "ja$1");
m(e1, "isHeading");
function ET(s) {
  return s.name == "OrderedList" || s.name == "BulletList";
}
u(ET, "eP");
m(ET, "isList");
function zT(s, t) {
  let i = s;
  for (; ; ) {
    let n = i.nextSibling, r;
    if (!n || (r = e1(n.type)) != null && r <= t)
      break;
    i = n;
  }
  return i.to;
}
u(zT, "tP");
m(zT, "findSectionEnd");
const XZ = /* @__PURE__ */ _I.of((s, t, i) => {
  for (let n = nt(s).resolveInner(i, -1); n && !(n.from < t); n = n.parent) {
    let r = n.type.prop(RT);
    if (r == null)
      continue;
    let a = zT(n, r);
    if (a > i)
      return { from: i, to: a };
  }
  return null;
});
function tv(s) {
  return new Ai(MT, s, [XZ], "markdown");
}
u(tv, "Rh$1");
m(tv, "mkLang");
const FZ = /* @__PURE__ */ tv(AT), HZ = /* @__PURE__ */ AT.configure([NW, jW, BW, XW, {
  props: [
    /* @__PURE__ */ jm.add({
      Table: /* @__PURE__ */ m((s, t) => ({ from: t.doc.lineAt(s.from).to, to: s.to }), "Table")
    })
  ]
}]), _T = /* @__PURE__ */ tv(HZ);
function LT(s, t) {
  return (i) => {
    if (i && s) {
      let n = null;
      if (i = /\S*/.exec(i)[0], typeof s == "function" ? n = s(i) : n = OP.matchLanguageName(s, i, !0), n instanceof OP)
        return n.support ? n.support.language.parser : qg.getSkippingParser(n.load());
      if (n)
        return n.parser;
    }
    return t ? t.parser : null;
  };
}
u(LT, "nP");
m(LT, "getCodeParser");
var md;
const IT = (md = class {
  constructor(t, i, n, r, a, o, l) {
    this.node = t, this.from = i, this.to = n, this.spaceBefore = r, this.spaceAfter = a, this.type = o, this.item = l;
  }
  blank(t, i = !0) {
    let n = this.spaceBefore + (this.node.name == "Blockquote" ? ">" : "");
    if (t != null) {
      for (; n.length < t; )
        n += " ";
      return n;
    } else {
      for (let r = this.to - this.from - n.length - this.spaceAfter.length; r > 0; r--)
        n += " ";
      return n + (i ? this.spaceAfter : "");
    }
  }
  marker(t, i) {
    let n = this.node.name == "OrderedList" ? String(+Pk(this.item, t)[2] + i) : "";
    return this.spaceBefore + n + this.type + this.spaceAfter;
  }
}, u(md, "wc"), md);
m(IT, "Context");
let aO = IT;
function Sk(s, t) {
  let i = [], n = [];
  for (let r = s; r; r = r.parent) {
    if (r.name == "FencedCode")
      return n;
    (r.name == "ListItem" || r.name == "Blockquote") && i.push(r);
  }
  for (let r = i.length - 1; r >= 0; r--) {
    let a = i[r], o, l = t.lineAt(a.from), c = a.from - l.from;
    if (a.name == "Blockquote" && (o = /^ *>( ?)/.exec(l.text.slice(c))))
      n.push(new aO(a, c, c + o[0].length, "", o[1], ">", null));
    else if (a.name == "ListItem" && a.parent.name == "OrderedList" && (o = /^( *)\d+([.)])( *)/.exec(l.text.slice(c)))) {
      let h = o[3], d = o[0].length;
      h.length >= 4 && (h = h.slice(0, h.length - 4), d -= 4), n.push(new aO(a.parent, c, c + d, o[1], h, o[2], a));
    } else if (a.name == "ListItem" && a.parent.name == "BulletList" && (o = /^( *)([-+*])( {1,4}\[[ xX]\])?( +)/.exec(l.text.slice(c)))) {
      let h = o[4], d = o[0].length;
      h.length > 4 && (h = h.slice(0, h.length - 4), d -= 4);
      let f = o[2];
      o[3] && (f += o[3].replace(/[xX]/, " ")), n.push(new aO(a.parent, c, c + d, o[1], h, f, a));
    }
  }
  return n;
}
u(Sk, "Tm$1");
m(Sk, "getContext");
function Pk(s, t) {
  return /^(\s*)(\d+)(?=[.)])/.exec(t.sliceString(s.from, s.from + 10));
}
u(Pk, "Am$1");
m(Pk, "itemNumber");
function tg(s, t, i, n = 0) {
  for (let r = -1, a = s; ; ) {
    if (a.name == "ListItem") {
      let l = Pk(a, t), c = +l[2];
      if (r >= 0) {
        if (c != r + 1)
          return;
        i.push({ from: a.from + l[1].length, to: a.from + l[0].length, insert: String(r + 2 + n) });
      }
      r = c;
    }
    let o = a.nextSibling;
    if (!o)
      break;
    a = o;
  }
}
u(tg, "No$1");
m(tg, "renumberList");
function iv(s, t) {
  let i = /^[ \t]*/.exec(s)[0].length;
  if (!i || t.facet(B1) != "	")
    return s;
  let n = xr(s, 4, i), r = "";
  for (let a = n; a > 0; )
    a >= 4 ? (r += "	", a -= 4) : (r += " ", a--);
  return r + s.slice(i);
}
u(iv, "vh$1");
m(iv, "normalizeIndent");
const YZ = /* @__PURE__ */ m(({ state: s, dispatch: t }) => {
  let i = nt(s), { doc: n } = s, r = null, a = s.changeByRange((o) => {
    if (!o.empty || !_T.isActiveAt(s, o.from, 0))
      return r = { range: o };
    let l = o.from, c = n.lineAt(l), h = Sk(i.resolveInner(l, -1), n);
    for (; h.length && h[h.length - 1].from > l - c.from; )
      h.pop();
    if (!h.length)
      return r = { range: o };
    let d = h[h.length - 1];
    if (d.to - d.spaceAfter.length > l - c.from)
      return r = { range: o };
    let f = l >= d.to - d.spaceAfter.length && !/\S/.test(c.text.slice(d.to));
    if (d.item && f) {
      let k = d.node.firstChild, $ = d.node.getChild("ListItem", "ListItem");
      if (k.to >= l || $ && $.to < l || c.from > 0 && !/[^\s>]/.test(n.lineAt(c.from - 1).text)) {
        let C = h.length > 1 ? h[h.length - 2] : null, E, A = "";
        C && C.item ? (E = c.from + C.from, A = C.marker(n, 1)) : E = c.from + (C ? C.to : 0);
        let R = [{ from: E, to: l, insert: A }];
        return d.node.name == "OrderedList" && tg(d.item, n, R, -2), C && C.node.name == "OrderedList" && tg(C.item, n, R), { range: J.cursor(E + A.length), changes: R };
      } else {
        let C = J2(h, s, c);
        return {
          range: J.cursor(l + C.length + 1),
          changes: { from: c.from, insert: C + s.lineBreak }
        };
      }
    }
    if (d.node.name == "Blockquote" && f && c.from) {
      let k = n.lineAt(c.from - 1), $ = />\s*$/.exec(k.text);
      if ($ && $.index == d.from) {
        let C = s.changes([
          { from: k.from + $.index, to: k.to },
          { from: c.from + d.from, to: c.to }
        ]);
        return { range: o.map(C), changes: C };
      }
    }
    let y = [];
    d.node.name == "OrderedList" && tg(d.item, n, y);
    let w = d.item && d.item.from < c.from, g = "";
    if (!w || /^[\s\d.)\-+*>]*/.exec(c.text)[0].length >= d.to)
      for (let k = 0, $ = h.length - 1; k <= $; k++)
        g += k == $ && !w ? h[k].marker(n, 1) : h[k].blank(k < $ ? xr(c.text, 4, h[k + 1].from) - g.length : null);
    let b = l;
    for (; b > c.from && /\s/.test(c.text.charAt(b - c.from - 1)); )
      b--;
    return g = iv(g, s), WT(d.node, s.doc) && (g = J2(h, s, c) + s.lineBreak + g), y.push({ from: b, to: l, insert: s.lineBreak + g }), { range: J.cursor(b + g.length + 1), changes: y };
  });
  return r ? !1 : (t(s.update(a, { scrollIntoView: !0, userEvent: "input" })), !0);
}, "insertNewlineContinueMarkup");
function K2(s) {
  return s.name == "QuoteMark" || s.name == "ListMark";
}
u(K2, "xd$1");
m(K2, "isMark");
function WT(s, t) {
  if (s.name != "OrderedList" && s.name != "BulletList")
    return !1;
  let i = s.firstChild, n = s.getChild("ListItem", "ListItem");
  if (!n)
    return !1;
  let r = t.lineAt(i.to), a = t.lineAt(n.from), o = /^[\s>]*$/.test(r.text);
  return r.number + (o ? 0 : 1) < a.number;
}
u(WT, "sP");
m(WT, "nonTightList");
function J2(s, t, i) {
  let n = "";
  for (let r = 0, a = s.length - 2; r <= a; r++)
    n += s[r].blank(r < a ? xr(i.text, 4, Math.min(i.text.length, s[r + 1].from)) - n.length : null, r < a);
  return iv(n, t);
}
u(J2, "Qd$1");
m(J2, "blankLine");
function VT(s, t) {
  let i = s.resolveInner(t, -1), n = t;
  K2(i) && (n = i.from, i = i.parent);
  for (let r; r = i.childBefore(n); )
    if (K2(r))
      n = r.from;
    else if (r.name == "OrderedList" || r.name == "BulletList")
      i = r.lastChild, n = i.to;
    else
      break;
  return i;
}
u(VT, "oP");
m(VT, "contextNodeForDelete");
const GZ = /* @__PURE__ */ m(({ state: s, dispatch: t }) => {
  let i = nt(s), n = null, r = s.changeByRange((a) => {
    let o = a.from, { doc: l } = s;
    if (a.empty && _T.isActiveAt(s, a.from)) {
      let c = l.lineAt(o), h = Sk(VT(i, o), l);
      if (h.length) {
        let d = h[h.length - 1], f = d.to - d.spaceAfter.length + (d.spaceAfter ? 1 : 0);
        if (o - c.from > f && !/\S/.test(c.text.slice(f, o - c.from)))
          return {
            range: J.cursor(c.from + f),
            changes: { from: c.from + f, to: o }
          };
        if (o - c.from == f && // Only apply this if we're on the line that has the
        // construct's syntax, or there's only indentation in the
        // target range
        (!d.item || c.from <= d.item.from || !/\S/.test(c.text.slice(0, d.to)))) {
          let y = c.from + d.from;
          if (d.item && d.node.from < d.item.from && /\S/.test(c.text.slice(d.from, d.to))) {
            let w = d.blank(xr(c.text, 4, d.to) - xr(c.text, 4, d.from));
            return y == c.from && (w = iv(w, s)), {
              range: J.cursor(y + w.length),
              changes: { from: y, to: c.from + d.to, insert: w }
            };
          }
          if (y < o)
            return { range: J.cursor(y), changes: { from: y, to: o } };
        }
      }
    }
    return n = { range: a };
  });
  return n ? !1 : (t(s.update(r, { scrollIntoView: !0, userEvent: "delete" })), !0);
}, "deleteMarkupBackward"), KZ = [
  { key: "Enter", run: YZ },
  { key: "Backspace", run: GZ }
], ZT = /* @__PURE__ */ TT({ matchClosingTags: !1 });
function JZ(s = {}) {
  let { codeLanguages: t, defaultCodeLanguage: i, addKeymap: n = !0, base: { parser: r } = FZ, completeHTMLTags: a = !0, htmlTagLanguage: o = ZT } = s;
  if (!(r instanceof aQ))
    throw new RangeError("Base parser provided to `markdown` should be a Markdown parser");
  let l = s.extensions ? [s.extensions] : [], c = [o.support], h;
  i instanceof df ? (c.push(i.support), h = i.language) : i && (h = i);
  let d = t || h ? LT(t, h) : void 0;
  l.push(gQ({ codeParser: d, htmlParser: o.language.parser })), n && c.push(Lo.high(Z1.of(KZ)));
  let f = tv(r.configure(l));
  return a && c.push(f.data.of({ autocomplete: DT })), new df(f, c);
}
u(JZ, "_m$1");
m(JZ, "markdown");
function DT(s) {
  let { state: t, pos: i } = s, n = /<[:\-\.\w\u00b7-\uffff]*$/.exec(t.sliceDoc(i - 25, i));
  if (!n)
    return null;
  let r = nt(t).resolveInner(i, -1);
  for (; r && !r.type.isTop; ) {
    if (r.name == "CodeBlock" || r.name == "FencedCode" || r.name == "ProcessingInstructionBlock" || r.name == "CommentBlock" || r.name == "Link" || r.name == "Image")
      return null;
    r = r.parent;
  }
  return {
    from: i - n[0].length,
    to: i,
    options: qT(),
    validFor: /^<[:\-\.\w\u00b7-\uffff]*$/
  };
}
u(DT, "lP");
m(DT, "htmlTagCompletion");
let oO = null;
function qT() {
  if (oO)
    return oO;
  let s = kT(new Fx(kt.create({ extensions: ZT }), 0, !0));
  return oO = s ? s.options : [];
}
u(qT, "aP");
m(qT, "htmlTagCompletions");
function eD(s) {
  return new df(DI.define(s));
}
u(eD, "w$2");
m(eD, "legacy");
function tD(s) {
  return import(
    /* webpackIgnore: true */
    /* @vite-ignore */
    new URL("./@codemirror/lang-sql/dist/index.js", typeof WEAVY_IMPORT_URL == "string" && (!import.meta.url || !new URL(import.meta.url).href.startsWith(WEAVY_IMPORT_URL)) ? WEAVY_IMPORT_URL : import.meta.url).href
  ).then((t) => t.sql({ dialect: t[s] }));
}
u(tD, "Ot$2");
m(tD, "sql");
function iD(s) {
  const t = new Event("Weavy-SoftSubmit");
  return s.dom.dispatchEvent(t), !0;
}
u(iD, "Mm$1");
m(iD, "softSubmit");
const GP = new uI({
  regexp: /(\[(.+?)\])(\(@u(\d+)\))/g,
  decoration: /* @__PURE__ */ m((s) => Xe.replace({
    // NOTE: can't use backspace to go "up one row" when inclusive is false
    inclusive: !0,
    widget: new nD(s)
  }), "decoration")
});
var wd;
const UT = (wd = class extends Ef {
  constructor(t) {
    super(), this.match = t;
  }
  eq(t) {
    return t.match[1] === this.match[1];
  }
  toDOM() {
    Bt();
    const t = document.createElement("span");
    return t.className = "wy-mention", t.innerHTML = typeof this.match[5] < "u" ? this.match[5] : this.match[2], t;
  }
  ignoreEvent() {
    return !1;
  }
}, u(wd, "xc"), wd);
m(UT, "MentionWidget");
let nD = UT;
Ps.fromClass(
  class {
    constructor(s) {
      this.mentions = GP.createDeco(s);
    }
    update(s) {
      this.mentions = GP.updateDeco(s, this.mentions);
    }
  },
  {
    decorations: /* @__PURE__ */ m((s) => s.mentions, "decorations"),
    provide: /* @__PURE__ */ m((s) => $e.atomicRanges.of((t) => {
      var i;
      return ((i = t.plugin(s)) == null ? void 0 : i.mentions) || Xe.none;
    }), "provide")
  }
);
function sD(s, t) {
  return ({ state: i, dispatch: n }) => {
    if (i.readOnly)
      return !1;
    let r = s(t, i);
    return r ? (n(i.update(r)), !0) : !1;
  };
}
u(sD, "Th$1");
m(sD, "command");
function Ck(s, t) {
  let i = s.languageDataAt("commentTokens", t);
  return i.length ? i[0] : {};
}
u(Ck, "Ah$1");
m(Ck, "getConfig");
const Gf = 50;
function NT(s, { open: t, close: i }, n, r) {
  let a = s.sliceDoc(n - Gf, n), o = s.sliceDoc(r, r + Gf), l = /\s*$/.exec(a)[0].length, c = /^\s*/.exec(o)[0].length, h = a.length - l;
  if (a.slice(h - t.length, h) == t && o.slice(c, c + i.length) == i)
    return {
      open: { pos: n - l, margin: l && 1 },
      close: { pos: r + c, margin: c && 1 }
    };
  let d, f;
  r - n <= 2 * Gf ? d = f = s.sliceDoc(n, r) : (d = s.sliceDoc(n, n + Gf), f = s.sliceDoc(r - Gf, r));
  let y = /^\s*/.exec(d)[0].length, w = /\s*$/.exec(f)[0].length, g = f.length - w - i.length;
  return d.slice(y, y + t.length) == t && f.slice(g, g + i.length) == i ? {
    open: {
      pos: n + y + t.length,
      margin: /\s/.test(d.charAt(y + t.length)) ? 1 : 0
    },
    close: {
      pos: r - w - i.length,
      margin: /\s/.test(f.charAt(g - 1)) ? 1 : 0
    }
  } : null;
}
u(NT, "bP");
m(NT, "findBlockComment");
function rD(s) {
  let t = [];
  for (let i of s.selection.ranges) {
    let n = s.doc.lineAt(i.from), r = i.to <= n.to ? n : s.doc.lineAt(i.to);
    r.from > n.from && r.from == i.to && (r = i.to == n.to + 1 ? n : s.doc.lineAt(i.to - 1));
    let a = t.length - 1;
    a >= 0 && t[a].to > n.from ? t[a].to = r.to : t.push({ from: n.from + /^\s*/.exec(n.text)[0].length, to: r.to });
  }
  return t;
}
u(rD, "yP");
m(rD, "selectedLineRanges");
function aD(s, t, i = t.selection.ranges) {
  let n = i.map((a) => Ck(t, a.from).block);
  if (!n.every((a) => a))
    return null;
  let r = i.map((a, o) => NT(t, n[o], a.from, a.to));
  if (s != 2 && !r.every((a) => a))
    return { changes: t.changes(i.map((a, o) => r[o] ? [] : [{ from: a.from, insert: n[o].open + " " }, { from: a.to, insert: " " + n[o].close }])) };
  if (s != 1 && r.some((a) => a)) {
    let a = [];
    for (let o = 0, l; o < r.length; o++)
      if (l = r[o]) {
        let c = n[o], { open: h, close: d } = l;
        a.push({ from: h.pos - c.open.length, to: h.pos + h.margin }, { from: d.pos - d.margin, to: d.pos + c.close.length });
      }
    return { changes: a };
  }
  return null;
}
u(aD, "Ym$1");
m(aD, "changeBlockComment");
function oD(s, t, i = t.selection.ranges) {
  let n = [], r = -1;
  for (let { from: a, to: o } of i) {
    let l = n.length, c = 1e9, h = Ck(t, a).line;
    if (h) {
      for (let d = a; d <= o; ) {
        let f = t.doc.lineAt(d);
        if (f.from > r && (a == o || o > f.from)) {
          r = f.from;
          let y = /^\s*/.exec(f.text)[0].length, w = y == f.length, g = f.text.slice(y, y + h.length) == h ? y : -1;
          y < f.text.length && y < c && (c = y), n.push({ line: f, comment: g, token: h, indent: y, empty: w, single: !1 });
        }
        d = f.to + 1;
      }
      if (c < 1e9)
        for (let d = l; d < n.length; d++)
          n[d].indent < n[d].line.text.length && (n[d].indent = c);
      n.length == l + 1 && (n[l].single = !0);
    }
  }
  if (s != 2 && n.some((a) => a.comment < 0 && (!a.empty || a.single))) {
    let a = [];
    for (let { line: l, token: c, indent: h, empty: d, single: f } of n)
      (f || !d) && a.push({ from: l.from + h, insert: c + " " });
    let o = t.changes(a);
    return { changes: o, selection: t.selection.map(o, 1) };
  } else if (s != 1 && n.some((a) => a.comment >= 0)) {
    let a = [];
    for (let { line: o, comment: l, token: c } of n)
      if (l >= 0) {
        let h = o.from + l, d = h + c.length;
        o.text[d - o.from] == " " && d++, a.push({ from: h, to: d });
      }
    return { changes: a };
  }
  return null;
}
u(oD, "SP");
m(oD, "changeLineComment");
const e$ = /* @__PURE__ */ Es.define(), lD = /* @__PURE__ */ Es.define(), cD = /* @__PURE__ */ me.define(), BT = /* @__PURE__ */ me.define({
  combine(s) {
    return tx(s, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: /* @__PURE__ */ m((t, i) => i, "joinToEvent")
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: /* @__PURE__ */ m((t, i) => (n, r) => t(n, r) || i(n, r), "joinToEvent")
    });
  }
}), jT = /* @__PURE__ */ As.define({
  create() {
    return jy.empty;
  },
  update(s, t) {
    let i = t.state.facet(BT), n = t.annotation(e$);
    if (n) {
      let c = ms.fromTransaction(t, n.selection), h = n.side, d = h == 0 ? s.undone : s.done;
      return c ? d = pm(d, d.length, i.minDepth, c) : d = Mk(d, t.startState.selection), new jy(h == 0 ? n.rest : d, h == 0 ? d : n.rest);
    }
    let r = t.annotation(lD);
    if ((r == "full" || r == "before") && (s = s.isolate()), t.annotation(di.addToHistory) === !1)
      return t.changes.empty ? s : s.addMapping(t.changes.desc);
    let a = ms.fromTransaction(t), o = t.annotation(di.time), l = t.annotation(di.userEvent);
    return a ? s = s.addChanges(a, o, l, i, t) : t.selection && (s = s.addSelection(t.startState.selection, o, l, i.newGroupDelay)), (r == "full" || r == "after") && (s = s.isolate()), s;
  },
  toJSON(s) {
    return { done: s.done.map((t) => t.toJSON()), undone: s.undone.map((t) => t.toJSON()) };
  },
  fromJSON(s) {
    return new jy(s.done.map(ms.fromJSON), s.undone.map(ms.fromJSON));
  }
});
function hD(s = {}) {
  return [
    jT,
    BT.of(s),
    $e.domEventHandlers({
      beforeinput(t, i) {
        let n = t.inputType == "historyUndo" ? dD : t.inputType == "historyRedo" ? uD : null;
        return n ? (t.preventDefault(), n(i)) : !1;
      }
    })
  ];
}
u(hD, "xP");
m(hD, "history");
function Qk(s, t) {
  return function({ state: i, dispatch: n }) {
    if (!t && i.readOnly)
      return !1;
    let r = i.field(jT, !1);
    if (!r)
      return !1;
    let a = r.pop(s, i, t);
    return a ? (n(a), !0) : !1;
  };
}
u(Qk, "go$1");
m(Qk, "cmd");
const dD = /* @__PURE__ */ Qk(0, !1), uD = /* @__PURE__ */ Qk(1, !1);
var Zn;
const XT = (Zn = class {
  constructor(t, i, n, r, a) {
    this.changes = t, this.effects = i, this.mapped = n, this.startSelection = r, this.selectionsAfter = a;
  }
  setSelAfter(t) {
    return new Zn(this.changes, this.effects, this.mapped, this.startSelection, t);
  }
  toJSON() {
    var t, i, n;
    return {
      changes: (t = this.changes) === null || t === void 0 ? void 0 : t.toJSON(),
      mapped: (i = this.mapped) === null || i === void 0 ? void 0 : i.toJSON(),
      startSelection: (n = this.startSelection) === null || n === void 0 ? void 0 : n.toJSON(),
      selectionsAfter: this.selectionsAfter.map((r) => r.toJSON())
    };
  }
  static fromJSON(t) {
    return new Zn(t.changes && hn.fromJSON(t.changes), [], t.mapped && oc.fromJSON(t.mapped), t.startSelection && J.fromJSON(t.startSelection), t.selectionsAfter.map(J.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(t, i) {
    let n = Ui;
    for (let r of t.startState.facet(cD)) {
      let a = r(t);
      a.length && (n = n.concat(a));
    }
    return !n.length && t.changes.empty ? null : new Zn(t.changes.invert(t.startState.doc), n, void 0, i || t.startState.selection, Ui);
  }
  static selection(t) {
    return new Zn(void 0, Ui, void 0, void 0, t);
  }
}, u(Zn, "Nt"), Zn);
m(XT, "HistEvent");
let ms = XT;
function pm(s, t, i, n) {
  let r = t + 1 > i + 20 ? t - i - 1 : 0, a = s.slice(r, t);
  return a.push(n), a;
}
u(pm, "Us$1");
m(pm, "updateBranch");
function FT(s, t) {
  let i = [], n = !1;
  return s.iterChangedRanges((r, a) => i.push(r, a)), t.iterChangedRanges((r, a, o, l) => {
    for (let c = 0; c < i.length; ) {
      let h = i[c++], d = i[c++];
      l >= h && o <= d && (n = !0);
    }
  }), n;
}
u(FT, "RP");
m(FT, "isAdjacent");
function HT(s, t) {
  return s.ranges.length == t.ranges.length && s.ranges.filter((i, n) => i.empty != t.ranges[n].empty).length === 0;
}
u(HT, "$P");
m(HT, "eqSelectionShape");
function Tk(s, t) {
  return s.length ? t.length ? s.concat(t) : s : t;
}
u(Tk, "Xm$1");
m(Tk, "conc");
const Ui = [], pD = 200;
function Mk(s, t) {
  if (s.length) {
    let i = s[s.length - 1], n = i.selectionsAfter.slice(Math.max(0, i.selectionsAfter.length - pD));
    return n.length && n[n.length - 1].eq(t) ? s : (n.push(t), pm(s, s.length - 1, 1e9, i.setSelAfter(n)));
  } else
    return [ms.selection([t])];
}
u(Mk, "Im$1");
m(Mk, "addSelection");
function YT(s) {
  let t = s[s.length - 1], i = s.slice();
  return i[s.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), i;
}
u(YT, "TP");
m(YT, "popSelection");
function ig(s, t) {
  if (!s.length)
    return s;
  let i = s.length, n = Ui;
  for (; i; ) {
    let r = GT(s[i - 1], t, n);
    if (r.changes && !r.changes.empty || r.effects.length) {
      let a = s.slice(0, i);
      return a[i - 1] = r, a;
    } else
      t = r.mapped, i--, n = r.selectionsAfter;
  }
  return n.length ? [ms.selection(n)] : Ui;
}
u(ig, "Fo$1");
m(ig, "addMappingToBranch");
function GT(s, t, i) {
  let n = Tk(s.selectionsAfter.length ? s.selectionsAfter.map((l) => l.map(t)) : Ui, i);
  if (!s.changes)
    return ms.selection(n);
  let r = s.changes.map(t), a = t.mapDesc(s.changes, !0), o = s.mapped ? s.mapped.composeDesc(a) : a;
  return new ms(r, qe.mapEffects(s.effects, t), o, s.startSelection.map(a), n);
}
u(GT, "AP");
m(GT, "mapEvent");
const fD = /^(input\.type|delete)($|\.)/;
var Dn;
const KT = (Dn = class {
  constructor(t, i, n = 0, r = void 0) {
    this.done = t, this.undone = i, this.prevTime = n, this.prevUserEvent = r;
  }
  isolate() {
    return this.prevTime ? new Dn(this.done, this.undone) : this;
  }
  addChanges(t, i, n, r, a) {
    let o = this.done, l = o[o.length - 1];
    return l && l.changes && !l.changes.empty && t.changes && (!n || fD.test(n)) && (!l.selectionsAfter.length && i - this.prevTime < r.newGroupDelay && r.joinToEvent(a, FT(l.changes, t.changes)) || // For compose (but not compose.start) events, always join with previous event
    n == "input.type.compose") ? o = pm(o, o.length - 1, r.minDepth, new ms(t.changes.compose(l.changes), Tk(qe.mapEffects(t.effects, l.changes), l.effects), l.mapped, l.startSelection, Ui)) : o = pm(o, o.length, r.minDepth, t), new Dn(o, Ui, i, n);
  }
  addSelection(t, i, n, r) {
    let a = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Ui;
    return a.length > 0 && i - this.prevTime < r && n == this.prevUserEvent && n && /^select($|\.)/.test(n) && HT(a[a.length - 1], t) ? this : new Dn(Mk(this.done, t), this.undone, i, n);
  }
  addMapping(t) {
    return new Dn(ig(this.done, t), ig(this.undone, t), this.prevTime, this.prevUserEvent);
  }
  pop(t, i, n) {
    let r = t == 0 ? this.done : this.undone;
    if (r.length == 0)
      return null;
    let a = r[r.length - 1], o = a.selectionsAfter[0] || i.selection;
    if (n && a.selectionsAfter.length)
      return i.update({
        selection: a.selectionsAfter[a.selectionsAfter.length - 1],
        annotations: e$.of({ side: t, rest: YT(r), selection: o }),
        userEvent: t == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (a.changes) {
      let l = r.length == 1 ? Ui : r.slice(0, r.length - 1);
      return a.mapped && (l = ig(l, a.mapped)), i.update({
        changes: a.changes,
        selection: a.startSelection,
        effects: a.effects,
        annotations: e$.of({ side: t, rest: l, selection: o }),
        filter: !1,
        userEvent: t == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}, u(Dn, "Gt"), Dn);
m(KT, "HistoryState");
let jy = KT;
jy.empty = /* @__PURE__ */ new jy(Ui, Ui);
function Fm(s, t) {
  return J.create(s.ranges.map(t), s.mainIndex);
}
u(Fm, "tr$1");
m(Fm, "updateSel");
function Hm(s, t) {
  return s.update({ selection: t, scrollIntoView: !0, userEvent: "select" });
}
u(Hm, "st$1");
m(Hm, "setSel");
function nv({ state: s, dispatch: t }, i) {
  let n = Fm(s.selection, i);
  return n.eq(s.selection, !0) ? !1 : (t(Hm(s, n)), !0);
}
u(nv, "ze$2");
m(nv, "moveSel");
function Ym(s, t) {
  return J.cursor(t ? s.to : s.from);
}
u(Ym, "bo");
m(Ym, "rangeEnd");
function yD(s, t) {
  return nv(s, (i) => i.empty ? s.moveByChar(i, t) : Ym(i, t));
}
u(yD, "jm$1");
m(yD, "cursorByChar");
function mD(s) {
  return s.textDirectionAt(s.state.selection.main.head) == gt.LTR;
}
u(mD, "ae$2");
m(mD, "ltrAtCursor");
function wD(s, t) {
  return nv(s, (i) => i.empty ? s.moveByGroup(i, t) : Ym(i, t));
}
u(wD, "Dm$1");
m(wD, "cursorByGroup");
function JT(s, t, i) {
  if (t.type.prop(i))
    return !0;
  let n = t.to - t.from;
  return n && (n > 2 || /[^\s,.;:]/.test(s.sliceDoc(t.from, t.to))) || t.firstChild;
}
u(JT, "_P");
m(JT, "interestingNode");
function gD(s, t, i) {
  let n = nt(s).resolveInner(t.head), r = i ? Oe.closedBy : Oe.openedBy;
  for (let c = t.head; ; ) {
    let h = i ? n.childAfter(c) : n.childBefore(c);
    if (!h)
      break;
    JT(s, h, r) ? n = h : c = i ? h.to : h.from;
  }
  let a = n.type.prop(r), o, l;
  return a && (o = i ? $a(s, n.from, 1) : $a(s, n.to, -1)) && o.matched ? l = i ? o.end.to : o.end.from : l = i ? n.to : n.from, J.cursor(l, i ? -1 : 1);
}
u(gD, "yo$1");
m(gD, "moveBySyntax");
function vD(s, t) {
  return nv(s, (i) => {
    if (!i.empty)
      return Ym(i, t);
    let n = s.moveVertically(i, t);
    return n.head != i.head ? n : s.moveToLineBoundary(i, t);
  });
}
u(vD, "Bm$1");
m(vD, "cursorByLine");
function Rk(s) {
  let t = s.scrollDOM.clientHeight < s.scrollDOM.scrollHeight - 2, i = 0, n = 0, r;
  if (t) {
    for (let a of s.state.facet($e.scrollMargins)) {
      let o = a(s);
      o != null && o.top && (i = Math.max(o == null ? void 0 : o.top, i)), o != null && o.bottom && (n = Math.max(o == null ? void 0 : o.bottom, n));
    }
    r = s.scrollDOM.clientHeight - i - n;
  } else
    r = (s.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: i,
    marginBottom: n,
    selfScroll: t,
    height: Math.max(s.defaultLineHeight, r - 5)
  };
}
u(Rk, "Fm$1");
m(Rk, "pageInfo");
function OD(s, t) {
  let i = Rk(s), { state: n } = s, r = Fm(n.selection, (o) => o.empty ? s.moveVertically(o, t, i.height) : Ym(o, t));
  if (r.eq(n.selection))
    return !1;
  let a;
  if (i.selfScroll) {
    let o = s.coordsAtPos(n.selection.main.head), l = s.scrollDOM.getBoundingClientRect(), c = l.top + i.marginTop, h = l.bottom - i.marginBottom;
    o && o.top > c && o.bottom < h && (a = $e.scrollIntoView(r.main.head, { y: "start", yMargin: o.top - c }));
  }
  return s.dispatch(Hm(n, r), { effects: a }), !0;
}
u(OD, "Hm$1");
m(OD, "cursorByPage");
function bD(s, t, i) {
  let n = s.lineBlockAt(t.head), r = s.moveToLineBoundary(t, i);
  if (r.head == t.head && r.head != (i ? n.to : n.from) && (r = s.moveToLineBoundary(t, i, !1)), !i && r.head == n.from && n.length) {
    let a = /^\s*/.exec(s.state.sliceDoc(n.from, Math.min(n.from + 100, n.to)))[0].length;
    a && t.head != n.from + a && (r = J.cursor(n.from + a));
  }
  return r;
}
u(bD, "Ut$2");
m(bD, "moveByLineBoundary");
function $D(s, t, i) {
  let n = !1, r = Fm(s.selection, (a) => {
    let o = $a(s, a.head, -1) || $a(s, a.head, 1) || a.head > 0 && $a(s, a.head - 1, 1) || a.head < s.doc.length && $a(s, a.head + 1, -1);
    if (!o || !o.end)
      return a;
    n = !0;
    let l = o.start.from == a.head ? o.end.to : o.end.from;
    return J.cursor(l);
  });
  return n ? (t(Hm(s, r)), !0) : !1;
}
u($D, "qP");
m($D, "toMatchingBracket");
function Gm(s, t) {
  let i = Fm(s.state.selection, (n) => {
    let r = t(n);
    return J.range(n.anchor, r.head, r.goalColumn, r.bidiLevel || void 0);
  });
  return i.eq(s.state.selection) ? !1 : (s.dispatch(Hm(s.state, i)), !0);
}
u(Gm, "Ye$2");
m(Gm, "extendSel");
function xD(s, t) {
  return Gm(s, (i) => s.moveByChar(i, t));
}
u(xD, "Km$1");
m(xD, "selectByChar");
function kD(s, t) {
  return Gm(s, (i) => s.moveByGroup(i, t));
}
u(kD, "tg$1");
m(kD, "selectByGroup");
function SD(s, t) {
  return Gm(s, (i) => s.moveVertically(i, t));
}
u(SD, "ig$1");
m(SD, "selectByLine");
function PD(s, t) {
  return Gm(s, (i) => s.moveVertically(i, t, Rk(s).height));
}
u(PD, "sg$1");
m(PD, "selectByPage");
function CD(s, t) {
  if (s.state.readOnly)
    return !1;
  let i = "delete.selection", { state: n } = s, r = n.changeByRange((a) => {
    let { from: o, to: l } = a;
    if (o == l) {
      let c = t(a);
      c < o ? (i = "delete.backward", c = Qy(s, c, !1)) : c > o && (i = "delete.forward", c = Qy(s, c, !0)), o = Math.min(o, c), l = Math.max(l, c);
    } else
      o = Qy(s, o, !1), l = Qy(s, l, !0);
    return o == l ? { range: a } : { changes: { from: o, to: l }, range: J.cursor(o, o < a.head ? -1 : 1) };
  });
  return r.changes.empty ? !1 : (s.dispatch(n.update(r, {
    scrollIntoView: !0,
    userEvent: i,
    effects: i == "delete.selection" ? $e.announce.of(n.phrase("Selection deleted")) : void 0
  })), !0);
}
u(CD, "Sn$1");
m(CD, "deleteBy");
function Qy(s, t, i) {
  if (s instanceof $e)
    for (let n of s.state.facet($e.atomicRanges).map((r) => r(s)))
      n.between(t, t, (r, a) => {
        r < t && a > t && (t = i ? a : r);
      });
  return t;
}
u(Qy, "Vn$1");
m(Qy, "skipAtomic");
function Ak(s) {
  let t = [], i = -1;
  for (let n of s.selection.ranges) {
    let r = s.doc.lineAt(n.from), a = s.doc.lineAt(n.to);
    if (!n.empty && n.to == a.from && (a = s.doc.lineAt(n.to - 1)), i >= r.number) {
      let o = t[t.length - 1];
      o.to = a.to, o.ranges.push(n);
    } else
      t.push({ from: r.from, to: a.to, ranges: [n] });
    i = a.number + 1;
  }
  return t;
}
u(Ak, "So$1");
m(Ak, "selectedLineBlocks");
function QD(s, t, i) {
  if (s.readOnly)
    return !1;
  let n = [], r = [];
  for (let a of Ak(s)) {
    if (i ? a.to == s.doc.length : a.from == 0)
      continue;
    let o = s.doc.lineAt(i ? a.to + 1 : a.from - 1), l = o.length + 1;
    if (i) {
      n.push({ from: a.to, to: o.to }, { from: a.from, insert: o.text + s.lineBreak });
      for (let c of a.ranges)
        r.push(J.range(Math.min(s.doc.length, c.anchor + l), Math.min(s.doc.length, c.head + l)));
    } else {
      n.push({ from: o.from, to: a.from }, { from: a.to, insert: s.lineBreak + o.text });
      for (let c of a.ranges)
        r.push(J.range(c.anchor - l, c.head - l));
    }
  }
  return n.length ? (t(s.update({
    changes: n,
    scrollIntoView: !0,
    selection: J.create(r, s.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
u(QD, "fg$1");
m(QD, "moveLine");
function TD(s, t, i) {
  if (s.readOnly)
    return !1;
  let n = [];
  for (let r of Ak(s))
    i ? n.push({ from: r.from, insert: s.doc.slice(r.from, r.to) + s.lineBreak }) : n.push({ from: r.to, insert: s.lineBreak + s.doc.slice(r.from, r.to) });
  return t(s.update({ changes: n, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
u(TD, "cg$1");
m(TD, "copyLine");
function eM(s, t) {
  if (/\(\)|\[\]|\{\}/.test(s.sliceDoc(t - 1, t + 1)))
    return { from: t, to: t };
  let i = nt(s).resolveInner(t), n = i.childBefore(t), r = i.childAfter(t), a;
  return n && r && n.to <= t && r.from >= t && (a = n.type.prop(Oe.closedBy)) && a.indexOf(r.name) > -1 && s.doc.lineAt(n.to).from == s.doc.lineAt(r.from).from && !/\S/.test(s.sliceDoc(n.to, r.from)) ? { from: n.to, to: r.from } : null;
}
u(eM, "gw$1");
m(eM, "isBetweenBrackets");
function MD(s) {
  return ({ state: t, dispatch: i }) => {
    if (t.readOnly)
      return !1;
    let n = t.changeByRange((r) => {
      let { from: a, to: o } = r, l = t.doc.lineAt(a), c = !s && a == o && eM(t, a);
      s && (a = o = (o <= l.to ? l : t.doc.lineAt(o)).to);
      let h = new Zx(t, { simulateBreak: a, simulateDoubleBreak: !!c }), d = X8(h, a);
      for (d == null && (d = xr(/^\s*/.exec(t.doc.lineAt(a).text)[0], t.tabSize)); o < l.to && /\s/.test(l.text[o - l.from]); )
        o++;
      c ? { from: a, to: o } = c : a > l.from && a < l.from + 100 && !/\S/.test(l.text.slice(0, a)) && (a = l.from);
      let f = ["", x2(t, d)];
      return c && f.push(x2(t, h.lineIndent(l.from, -1))), {
        changes: { from: a, to: o, insert: Ie.of(f) },
        range: J.cursor(a + 1 + f[1].length)
      };
    });
    return i(t.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
u(MD, "ug$1");
m(MD, "newlineAndIndent");
function RD(s, t) {
  let i = -1;
  return s.changeByRange((n) => {
    let r = [];
    for (let o = n.from; o <= n.to; ) {
      let l = s.doc.lineAt(o);
      l.number > i && (n.empty || n.to > l.from) && (t(l, r, n), i = l.number), o = l.to + 1;
    }
    let a = s.changes(r);
    return {
      changes: r,
      range: J.range(a.mapPos(n.anchor, 1), a.mapPos(n.head, 1))
    };
  });
}
u(RD, "Zh$1");
m(RD, "changeBySelectedLine");
s6.define([
  { tag: Q.meta, class: "code" },
  { tag: Q.link, class: "wy-link" },
  { tag: Q.heading, textDecoration: "underline", fontWeight: "bold" },
  { tag: Q.emphasis, fontStyle: "italic" },
  { tag: Q.strong, fontWeight: "bold" },
  { tag: Q.strikethrough, textDecoration: "line-through" },
  { tag: Q.keyword, class: "code token keyword" },
  { tag: [Q.atom, Q.bool], class: "code token builtin" },
  { tag: [Q.url, Q.contentSeparator, Q.labelName], class: "code token prolog" },
  { tag: Q.literal, class: "code token char" },
  { tag: Q.inserted, class: "code token inserted" },
  { tag: Q.deleted, class: "code token deleted" },
  { tag: Q.string, class: "code token string" },
  { tag: [Q.regexp, Q.escape, Q.special(Q.string)], class: "code token regex" },
  { tag: Q.definition(Q.variableName), class: "code token constant" },
  { tag: Q.local(Q.variableName), class: "code token variable" },
  { tag: [Q.typeName, Q.namespace], class: "code token keyword" },
  { tag: Q.className, class: "code token class-name" },
  { tag: [Q.special(Q.variableName), Q.macroName], class: "code token function" },
  { tag: Q.propertyName, class: "code token property" },
  { tag: Q.comment, class: "code token comment" },
  { tag: Q.invalid, color: "#f00", class: "code token" }
]);
function AD(s) {
  Ek(s, "start");
  var t = {}, i = s.languageData || {}, n = !1;
  for (var r in s) if (r != i && s.hasOwnProperty(r))
    for (var a = t[r] = [], o = s[r], l = 0; l < o.length; l++) {
      var c = o[l];
      a.push(new nM(c, s)), (c.indent || c.dedent) && (n = !0);
    }
  return {
    name: i.name,
    startState: /* @__PURE__ */ m(function() {
      return { state: "start", pending: null, indent: n ? [] : null };
    }, "startState"),
    copyState: /* @__PURE__ */ m(function(h) {
      var d = { state: h.state, pending: h.pending, indent: h.indent && h.indent.slice(0) };
      return h.stack && (d.stack = h.stack.slice(0)), d;
    }, "copyState"),
    token: sM(t),
    indent: rM(t, i),
    languageData: i
  };
}
u(AD, "Iw$1");
m(AD, "simpleMode");
function Ek(s, t) {
  if (!s.hasOwnProperty(t))
    throw new Error("Undefined state " + t + " in simple mode");
}
u(Ek, "dg$1");
m(Ek, "ensureState");
function tM(s, t) {
  if (!s) return /(?:)/;
  var i = "";
  return s instanceof RegExp ? (s.ignoreCase && (i = "i"), s = s.source) : s = String(s), new RegExp("^(?:" + s + ")", i);
}
u(tM, "$w$1");
m(tM, "toRegex");
function iM(s) {
  if (!s) return null;
  if (s.apply) return s;
  if (typeof s == "string") return s.replace(/\./g, " ");
  for (var t = [], i = 0; i < s.length; i++)
    t.push(s[i] && s[i].replace(/\./g, " "));
  return t;
}
u(iM, "vw$1");
m(iM, "asToken");
function nM(s, t) {
  (s.next || s.push) && Ek(t, s.next || s.push), this.regex = tM(s.regex), this.token = iM(s.token), this.data = s;
}
u(nM, "Tw$1");
m(nM, "Rule");
function sM(s) {
  return function(t, i) {
    if (i.pending) {
      var n = i.pending.shift();
      return i.pending.length == 0 && (i.pending = null), t.pos += n.text.length, n.token;
    }
    for (var r = s[i.state], a = 0; a < r.length; a++) {
      var o = r[a], l = (!o.data.sol || t.sol()) && t.match(o.regex);
      if (l) {
        o.data.next ? i.state = o.data.next : o.data.push ? ((i.stack || (i.stack = [])).push(i.state), i.state = o.data.push) : o.data.pop && i.stack && i.stack.length && (i.state = i.stack.pop()), o.data.indent && i.indent.push(t.indentation() + t.indentUnit), o.data.dedent && i.indent.pop();
        var c = o.token;
        if (c && c.apply && (c = c(l)), l.length > 2 && o.token && typeof o.token != "string") {
          i.pending = [];
          for (var h = 2; h < l.length; h++)
            l[h] && i.pending.push({ text: l[h], token: o.token[h - 1] });
          return t.backUp(l[0].length - (l[1] ? l[1].length : 0)), c[0];
        } else return c && c.join ? c[0] : c;
      }
    }
    return t.next(), null;
  };
}
u(sM, "Aw$1");
m(sM, "tokenFunction");
function rM(s, t) {
  return function(i, n) {
    if (i.indent == null || t.dontIndentStates && t.doneIndentState.indexOf(i.state) > -1)
      return null;
    var r = i.indent.length - 1, a = s[i.state];
    e: for (; ; ) {
      for (var o = 0; o < a.length; o++) {
        var l = a[o];
        if (l.data.dedent && l.data.dedentIfLineStart !== !1) {
          var c = l.regex.exec(n);
          if (c && c[0]) {
            r--, (l.next || l.push) && (a = s[l.next || l.push]), n = n.slice(c[0].length);
            continue e;
          }
        }
      }
      break;
    }
    return r < 0 ? 0 : i.indent[r];
  };
}
u(rM, "Zw$1");
m(rM, "indentFunction");
var ED = Object.defineProperty, ve = /* @__PURE__ */ u((s, t) => ED(s, "name", { value: t, configurable: !0 }), "o$1");
const t$ = "lit-localize-status", zD = /* @__PURE__ */ ve((s, ...t) => ({
  strTag: !0,
  strings: s,
  values: t
}), "_str"), ie = zD, _D = /* @__PURE__ */ ve((s) => typeof s != "string" && "strTag" in s, "isStrTagged"), aM = /* @__PURE__ */ ve((s, t, i) => {
  let n = s[0];
  for (let r = 1; r < s.length; r++)
    n += t[i ? i[r - 1] : r - 1], n += s[r];
  return n;
}, "joinStringsAndValues"), oM = /* @__PURE__ */ ve((s) => _D(s) ? aM(s.strings, s.values) : s, "defaultMsg");
let T = oM, KP = !1;
function lM(s) {
  if (KP)
    throw new Error("lit-localize can only be configured once");
  T = s, KP = !0;
}
u(lM, "rt$1");
ve(lM, "_installMsgImplementation");
var gd;
const cM = (gd = class {
  constructor(t) {
    this.__litLocalizeEventHandler = (i) => {
      i.detail.status === "ready" && this.host.requestUpdate();
    }, this.host = t;
  }
  hostConnected() {
    window.addEventListener(t$, this.__litLocalizeEventHandler);
  }
  hostDisconnected() {
    window.removeEventListener(t$, this.__litLocalizeEventHandler);
  }
}, u(gd, "_e"), gd);
ve(cM, "LocalizeController");
let LD = cM;
const ID = /* @__PURE__ */ ve((s) => s.addController(new LD(s)), "_updateWhenLocaleChanges"), WD = ID, be = /* @__PURE__ */ ve(() => (s, t) => (s.addInitializer(WD), s), "localized");
var vd;
const hM = (vd = class {
  constructor() {
    this.settled = !1, this.promise = new Promise((t, i) => {
      this._resolve = t, this._reject = i;
    });
  }
  resolve(t) {
    this.settled = !0, this._resolve(t);
  }
  reject(t) {
    this.settled = !0, this._reject(t);
  }
}, u(vd, "ve"), vd);
ve(hM, "Deferred");
let dM = hM;
const ls = [];
for (let s = 0; s < 256; s++)
  ls[s] = (s >> 4 & 15).toString(16) + (s & 15).toString(16);
function uM(s) {
  let t = 0, i = 8997, n = 0, r = 33826, a = 0, o = 40164, l = 0, c = 52210;
  for (let h = 0; h < s.length; h++)
    i ^= s.charCodeAt(h), t = i * 435, n = r * 435, a = o * 435, l = c * 435, a += i << 8, l += r << 8, n += t >>> 16, i = t & 65535, a += n >>> 16, r = n & 65535, c = l + (a >>> 16) & 65535, o = a & 65535;
  return ls[c >> 8] + ls[c & 255] + ls[o >> 8] + ls[o & 255] + ls[r >> 8] + ls[r & 255] + ls[i >> 8] + ls[i & 255];
}
u(uM, "ot");
ve(uM, "fnv1a64");
const VD = "", ZD = "h", DD = "s";
function pM(s, t) {
  return (t ? ZD : DD) + uM(typeof s == "string" ? s : s.join(VD));
}
u(pM, "ht$1");
ve(pM, "generateMsgId");
const JP = /* @__PURE__ */ new WeakMap(), e4 = /* @__PURE__ */ new Map();
function fM(s, t, i) {
  if (s) {
    const n = (i == null ? void 0 : i.id) ?? yM(t), r = s[n];
    if (r) {
      if (typeof r == "string")
        return r;
      if ("strTag" in r)
        return aM(
          r.strings,
          // Cast `template` because its type wasn't automatically narrowed (but
          // we know it must be the same type as `localized`).
          t.values,
          r.values
        );
      {
        let a = JP.get(r);
        return a === void 0 && (a = r.values, JP.set(r, a)), {
          ...r,
          values: a.map((o) => t.values[o])
        };
      }
    }
  }
  return oM(t);
}
u(fM, "ft");
ve(fM, "runtimeMsg");
function yM(s) {
  const t = typeof s == "string" ? s : s.strings;
  let i = e4.get(t);
  return i === void 0 && (i = pM(t, typeof s != "string" && !("strTag" in s)), e4.set(t, i)), i;
}
u(yM, "gt");
ve(yM, "generateId");
function ng(s) {
  window.dispatchEvent(new CustomEvent(t$, { detail: s }));
}
u(ng, "re");
ve(ng, "dispatchStatusEvent");
let t1 = "", lO, mM, i1, i$, wM, wa = new dM();
wa.resolve();
let Tw = 0;
const qD = /* @__PURE__ */ ve((s) => (lM((t, i) => fM(wM, t, i)), t1 = mM = s.sourceLocale, i1 = new Set(s.targetLocales), i1.add(s.sourceLocale), i$ = s.loadLocale, { getLocale: UD, setLocale: ND }), "configureLocalization"), UD = /* @__PURE__ */ ve(() => t1, "getLocale"), ND = /* @__PURE__ */ ve((s) => {
  if (s === (lO ?? t1))
    return wa.promise;
  if (!i1 || !i$)
    throw new Error("Internal error");
  if (!i1.has(s))
    throw new Error("Invalid locale code");
  Tw++;
  const t = Tw;
  return lO = s, wa.settled && (wa = new dM()), ng({ status: "loading", loadingLocale: s }), (s === mM ? (
    // We could switch to the source locale synchronously, but we prefer to
    // queue it on a microtask so that switching locales is consistently
    // asynchronous.
    Promise.resolve({ templates: void 0 })
  ) : i$(s)).then((i) => {
    Tw === t && (t1 = s, lO = void 0, wM = i.templates, ng({ status: "ready", readyLocale: s }), wa.resolve());
  }, (i) => {
    Tw === t && (ng({
      status: "error",
      errorLocale: s,
      errorMessage: i.toString()
    }), wa.reject(i));
  }), wa.promise;
}, "setLocale");
var cO, Od;
const BD = (cO = (Od = class {
  get shadowRoot() {
    return this.__host.__shadowRoot;
  }
  constructor(t) {
    this.ariaAtomic = "", this.ariaAutoComplete = "", this.ariaBraileLabel = "", this.ariaBraileRoleDescription = "", this.ariaBusy = "", this.ariaChecked = "", this.ariaColCount = "", this.ariaColIndex = "", this.ariaColSpan = "", this.ariaCurrent = "", this.ariaDescription = "", this.ariaDisabled = "", this.ariaExpanded = "", this.ariaHasPopup = "", this.ariaHidden = "", this.ariaInvalid = "", this.ariaKeyShortcuts = "", this.ariaLabel = "", this.ariaLevel = "", this.ariaLive = "", this.ariaModal = "", this.ariaMultiLine = "", this.ariaMultiSelectable = "", this.ariaOrientation = "", this.ariaPlaceholder = "", this.ariaPosInSet = "", this.ariaPressed = "", this.ariaReadOnly = "", this.ariaRequired = "", this.ariaRoleDescription = "", this.ariaRowCount = "", this.ariaRowIndex = "", this.ariaRowSpan = "", this.ariaSelected = "", this.ariaSetSize = "", this.ariaSort = "", this.ariaValueMax = "", this.ariaValueMin = "", this.ariaValueNow = "", this.ariaValueText = "", this.role = "", this.form = null, this.labels = [], this.states = /* @__PURE__ */ new Set(), this.validationMessage = "", this.validity = {}, this.willValidate = !0, this.__host = t;
  }
  checkValidity() {
    return console.warn("`ElementInternals.checkValidity()` was called on the server.This method always returns true."), !0;
  }
  reportValidity() {
    return !0;
  }
  setFormValue() {
  }
  setValidity() {
  }
}, u(Od, "M"), Od), ve(cO, "ElementInternals"), cO), t4 = /* @__PURE__ */ new WeakMap(), Kf = /* @__PURE__ */ ve((s) => {
  let t = t4.get(s);
  return t === void 0 && t4.set(s, t = /* @__PURE__ */ new Map()), t;
}, "attributesForElement");
var hO, bd;
const jD = (hO = (bd = class {
  constructor() {
    this.__shadowRootMode = null, this.__shadowRoot = null, this.__internals = null;
  }
  get attributes() {
    return Array.from(Kf(this)).map(([t, i]) => ({
      name: t,
      value: i
    }));
  }
  get shadowRoot() {
    return this.__shadowRootMode === "closed" ? null : this.__shadowRoot;
  }
  setAttribute(t, i) {
    Kf(this).set(t, String(i));
  }
  removeAttribute(t) {
    Kf(this).delete(t);
  }
  toggleAttribute(t, i) {
    if (this.hasAttribute(t)) {
      if (i === void 0 || !i)
        return this.removeAttribute(t), !1;
    } else
      return i === void 0 || i ? (this.setAttribute(t, ""), !0) : !1;
    return !0;
  }
  hasAttribute(t) {
    return Kf(this).has(t);
  }
  attachShadow(t) {
    const i = { host: this };
    return this.__shadowRootMode = t.mode, t && t.mode === "open" && (this.__shadowRoot = i), i;
  }
  attachInternals() {
    if (this.__internals !== null)
      throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
    const t = new BD(this);
    return this.__internals = t, t;
  }
  getAttribute(t) {
    return Kf(this).get(t) ?? null;
  }
}, u(bd, "P"), bd), ve(hO, "Element"), hO);
var dO, $d;
const XD = (dO = ($d = class extends jD {
}, u($d, "x"), $d), ve(dO, "HTMLElement"), dO), FD = XD;
var uO, xd;
const HD = (uO = (xd = class {
  constructor() {
    this.__definitions = /* @__PURE__ */ new Map();
  }
  define(t, i) {
    if (this.__definitions.has(t))
      throw new Error(`Failed to execute 'define' on 'CustomElementRegistry': the name "${t}" has already been used with this registry`);
    this.__definitions.set(t, {
      ctor: i,
      // Note it's important we read `observedAttributes` in case it is a getter
      // with side-effects, as is the case in Lit, where it triggers class
      // finalization.
      //
      // TODO(aomarks) To be spec compliant, we should also capture the
      // registration-time lifecycle methods like `connectedCallback`. For them
      // to be actually accessible to e.g. the Lit SSR element renderer, though,
      // we'd need to introduce a new API for accessing them (since `get` only
      // returns the constructor).
      observedAttributes: i.observedAttributes ?? []
    });
  }
  get(t) {
    const i = this.__definitions.get(t);
    return i == null ? void 0 : i.ctor;
  }
}, u(xd, "U"), xd), ve(uO, "CustomElementRegistry"), uO), YD = HD, GD = new YD(), Xy = globalThis, sv = Xy.ShadowRoot && (Xy.ShadyCSS === void 0 || Xy.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, zk = Symbol(), i4 = /* @__PURE__ */ new WeakMap();
var pO, kd;
let gM = (pO = (kd = class {
  constructor(t, i, n) {
    if (this._$cssResult$ = !0, n !== zk) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = i;
  }
  get styleSheet() {
    let t = this.o;
    const i = this.t;
    if (sv && t === void 0) {
      const n = i !== void 0 && i.length === 1;
      n && (t = i4.get(i)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && i4.set(i, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
}, u(kd, "H"), kd), ve(pO, "n"), pO);
const vM = /* @__PURE__ */ ve((s) => new gM(typeof s == "string" ? s : s + "", void 0, zk), "r$1"), de = /* @__PURE__ */ ve((s, ...t) => {
  const i = s.length === 1 ? s[0] : t.reduce((n, r, a) => n + ((o) => {
    if (o._$cssResult$ === !0) return o.cssText;
    if (typeof o == "number") return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(r) + s[a + 1], s[0]);
  return new gM(i, s, zk);
}, "i"), OM = /* @__PURE__ */ ve((s, t) => {
  if (sv) s.adoptedStyleSheets = t.map((i) => i instanceof CSSStyleSheet ? i : i.styleSheet);
  else for (const i of t) {
    const n = document.createElement("style"), r = Xy.litNonce;
    r !== void 0 && n.setAttribute("nonce", r), n.textContent = i.cssText, s.appendChild(n);
  }
}, "S$1"), n4 = sv || Xy.CSSStyleSheet === void 0 ? (s) => s : (s) => s instanceof CSSStyleSheet ? ((t) => {
  let i = "";
  for (const n of t.cssRules) i += n.cssText;
  return vM(i);
})(s) : s, { is: KD, defineProperty: JD, getOwnPropertyDescriptor: eq, getOwnPropertyNames: tq, getOwnPropertySymbols: iq, getPrototypeOf: nq } = Object, Tr = globalThis;
Tr.customElements ?? (Tr.customElements = GD);
const s4 = Tr.trustedTypes, sq = s4 ? s4.emptyScript : "", r4 = Tr.reactiveElementPolyfillSupport, Fy = /* @__PURE__ */ ve((s, t) => s, "f$2"), n1 = { toAttribute(s, t) {
  switch (t) {
    case Boolean:
      s = s ? sq : null;
      break;
    case Object:
    case Array:
      s = s == null ? s : JSON.stringify(s);
  }
  return s;
}, fromAttribute(s, t) {
  let i = s;
  switch (t) {
    case Boolean:
      i = s !== null;
      break;
    case Number:
      i = s === null ? null : Number(s);
      break;
    case Object:
    case Array:
      try {
        i = JSON.parse(s);
      } catch {
        i = null;
      }
  }
  return i;
} }, _k = /* @__PURE__ */ ve((s, t) => !KD(s, t), "y"), a4 = { attribute: !0, type: String, converter: n1, reflect: !1, hasChanged: _k };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), Tr.litPropertyMetadata ?? (Tr.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
var fO, Sd;
let Dl = (fO = (Sd = class extends (globalThis.HTMLElement ?? FD) {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, i = a4) {
    if (i.state && (i.attribute = !1), this._$Ei(), this.elementProperties.set(t, i), !i.noAccessor) {
      const n = Symbol(), r = this.getPropertyDescriptor(t, n, i);
      r !== void 0 && JD(this.prototype, t, r);
    }
  }
  static getPropertyDescriptor(t, i, n) {
    const { get: r, set: a } = eq(this.prototype, t) ?? { get() {
      return this[i];
    }, set(o) {
      this[i] = o;
    } };
    return { get() {
      return r == null ? void 0 : r.call(this);
    }, set(o) {
      const l = r == null ? void 0 : r.call(this);
      a.call(this, o), this.requestUpdate(t, l, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? a4;
  }
  static _$Ei() {
    if (this.hasOwnProperty(Fy("elementProperties"))) return;
    const t = nq(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(Fy("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Fy("properties"))) {
      const i = this.properties, n = [...tq(i), ...iq(i)];
      for (const r of n) this.createProperty(r, i[r]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const i = litPropertyMetadata.get(t);
      if (i !== void 0) for (const [n, r] of i) this.elementProperties.set(n, r);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [i, n] of this.elementProperties) {
      const r = this._$Eu(i, n);
      r !== void 0 && this._$Eh.set(r, i);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const i = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const r of n) i.unshift(n4(r));
    } else t !== void 0 && i.push(n4(t));
    return i;
  }
  static _$Eu(t, i) {
    const n = i.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((i) => this.enableUpdating = i), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((i) => i(this));
  }
  addController(t) {
    var i;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((i = t.hostConnected) == null || i.call(t));
  }
  removeController(t) {
    var i;
    (i = this._$EO) == null || i.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), i = this.constructor.elementProperties;
    for (const n of i.keys()) this.hasOwnProperty(n) && (t.set(n, this[n]), delete this[n]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return OM(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((i) => {
      var n;
      return (n = i.hostConnected) == null ? void 0 : n.call(i);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((i) => {
      var n;
      return (n = i.hostDisconnected) == null ? void 0 : n.call(i);
    });
  }
  attributeChangedCallback(t, i, n) {
    this._$AK(t, n);
  }
  _$EC(t, i) {
    var n;
    const r = this.constructor.elementProperties.get(t), a = this.constructor._$Eu(t, r);
    if (a !== void 0 && r.reflect === !0) {
      const o = (((n = r.converter) == null ? void 0 : n.toAttribute) !== void 0 ? r.converter : n1).toAttribute(i, r.type);
      this._$Em = t, o == null ? this.removeAttribute(a) : this.setAttribute(a, o), this._$Em = null;
    }
  }
  _$AK(t, i) {
    var n;
    const r = this.constructor, a = r._$Eh.get(t);
    if (a !== void 0 && this._$Em !== a) {
      const o = r.getPropertyOptions(a), l = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((n = o.converter) == null ? void 0 : n.fromAttribute) !== void 0 ? o.converter : n1;
      this._$Em = a, this[a] = l.fromAttribute(i, o.type), this._$Em = null;
    }
  }
  requestUpdate(t, i, n) {
    if (t !== void 0) {
      if (n ?? (n = this.constructor.getPropertyOptions(t)), !(n.hasChanged ?? _k)(this[t], i)) return;
      this.P(t, i, n);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, i, n) {
    this._$AL.has(t) || this._$AL.set(t, i), n.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (i) {
      Promise.reject(i);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [a, o] of this._$Ep) this[a] = o;
        this._$Ep = void 0;
      }
      const r = this.constructor.elementProperties;
      if (r.size > 0) for (const [a, o] of r) o.wrapped !== !0 || this._$AL.has(a) || this[a] === void 0 || this.P(a, this[a], o);
    }
    let i = !1;
    const n = this._$AL;
    try {
      i = this.shouldUpdate(n), i ? (this.willUpdate(n), (t = this._$EO) == null || t.forEach((r) => {
        var a;
        return (a = r.hostUpdate) == null ? void 0 : a.call(r);
      }), this.update(n)) : this._$EU();
    } catch (r) {
      throw i = !1, this._$EU(), r;
    }
    i && this._$AE(n);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var i;
    (i = this._$EO) == null || i.forEach((n) => {
      var r;
      return (r = n.hostUpdated) == null ? void 0 : r.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((i) => this._$EC(i, this[i]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}, u(Sd, "L$1"), Sd), ve(fO, "g"), fO);
Dl.elementStyles = [], Dl.shadowRootOptions = { mode: "open" }, Dl[Fy("elementProperties")] = /* @__PURE__ */ new Map(), Dl[Fy("finalized")] = /* @__PURE__ */ new Map(), r4 == null || r4({ ReactiveElement: Dl }), (Tr.reactiveElementVersions ?? (Tr.reactiveElementVersions = [])).push("2.0.4");
const fm = globalThis, s1 = fm.trustedTypes, o4 = s1 ? s1.createPolicy("lit-html", { createHTML: /* @__PURE__ */ ve((s) => s, "createHTML") }) : void 0, Lk = "$lit$", us = `lit$${Math.random().toFixed(9).slice(2)}$`, Ik = "?" + us, rq = `<${Ik}>`, $o = fm.document === void 0 ? { createTreeWalker: /* @__PURE__ */ ve(() => ({}), "createTreeWalker") } : document, ym = /* @__PURE__ */ ve(() => $o.createComment(""), "lt"), mm = /* @__PURE__ */ ve((s) => s === null || typeof s != "object" && typeof s != "function", "st"), Wk = Array.isArray, bM = /* @__PURE__ */ ve((s) => Wk(s) || typeof (s == null ? void 0 : s[Symbol.iterator]) == "function", "$"), yO = `[ 	
\f\r]`, Jf = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, l4 = /-->/g, c4 = />/g, sa = RegExp(`>|${yO}(?:([^\\s"'>=/]+)(${yO}*=${yO}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), h4 = /'/g, d4 = /"/g, $M = /^(?:script|style|textarea|title)$/i, xM = /* @__PURE__ */ ve((s) => (t, ...i) => ({ _$litType$: s, strings: t, values: i }), "P"), O = xM(1), u4 = xM(2), pn = Symbol.for("lit-noChange"), M = Symbol.for("lit-nothing"), p4 = /* @__PURE__ */ new WeakMap(), ka = $o.createTreeWalker($o, 129);
function Vk(s, t) {
  if (!Wk(s) || !s.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return o4 !== void 0 ? o4.createHTML(t) : t;
}
u(Vk, "Qe$1");
ve(Vk, "N");
const kM = /* @__PURE__ */ ve((s, t) => {
  const i = s.length - 1, n = [];
  let r, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = Jf;
  for (let l = 0; l < i; l++) {
    const c = s[l];
    let h, d, f = -1, y = 0;
    for (; y < c.length && (o.lastIndex = y, d = o.exec(c), d !== null); ) y = o.lastIndex, o === Jf ? d[1] === "!--" ? o = l4 : d[1] !== void 0 ? o = c4 : d[2] !== void 0 ? ($M.test(d[2]) && (r = RegExp("</" + d[2], "g")), o = sa) : d[3] !== void 0 && (o = sa) : o === sa ? d[0] === ">" ? (o = r ?? Jf, f = -1) : d[1] === void 0 ? f = -2 : (f = o.lastIndex - d[2].length, h = d[1], o = d[3] === void 0 ? sa : d[3] === '"' ? d4 : h4) : o === d4 || o === h4 ? o = sa : o === l4 || o === c4 ? o = Jf : (o = sa, r = void 0);
    const w = o === sa && s[l + 1].startsWith("/>") ? " " : "";
    a += o === Jf ? c + rq : f >= 0 ? (n.push(h), c.slice(0, f) + Lk + c.slice(f) + us + w) : c + us + (f === -2 ? l : w);
  }
  return [Vk(s, a + (s[i] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), n];
}, "U");
var ho;
const SM = (ho = class {
  constructor({ strings: t, _$litType$: i }, n) {
    let r;
    this.parts = [];
    let a = 0, o = 0;
    const l = t.length - 1, c = this.parts, [h, d] = kM(t, i);
    if (this.el = ho.createElement(h, n), ka.currentNode = this.el.content, i === 2 || i === 3) {
      const f = this.el.content.firstChild;
      f.replaceWith(...f.childNodes);
    }
    for (; (r = ka.nextNode()) !== null && c.length < l; ) {
      if (r.nodeType === 1) {
        if (r.hasAttributes()) for (const f of r.getAttributeNames()) if (f.endsWith(Lk)) {
          const y = d[o++], w = r.getAttribute(f).split(us), g = /([.?@])?(.*)/.exec(y);
          c.push({ type: 1, index: a, name: g[2], strings: w, ctor: g[1] === "." ? RM : g[1] === "?" ? EM : g[1] === "@" ? _M : Km }), r.removeAttribute(f);
        } else f.startsWith(us) && (c.push({ type: 6, index: a }), r.removeAttribute(f));
        if ($M.test(r.tagName)) {
          const f = r.textContent.split(us), y = f.length - 1;
          if (y > 0) {
            r.textContent = s1 ? s1.emptyScript : "";
            for (let w = 0; w < y; w++) r.append(f[w], ym()), ka.nextNode(), c.push({ type: 2, index: ++a });
            r.append(f[y], ym());
          }
        }
      } else if (r.nodeType === 8) if (r.data === Ik) c.push({ type: 2, index: a });
      else {
        let f = -1;
        for (; (f = r.data.indexOf(us, f + 1)) !== -1; ) c.push({ type: 7, index: a }), f += us.length - 1;
      }
      a++;
    }
  }
  static createElement(t, i) {
    const n = $o.createElement("template");
    return n.innerHTML = t, n;
  }
}, u(ho, "se"), ho);
ve(SM, "B");
let n$ = SM;
function Mr(s, t, i = s, n) {
  var r, a;
  if (t === pn) return t;
  let o = n !== void 0 ? (r = i.o) == null ? void 0 : r[n] : i.l;
  const l = mm(t) ? void 0 : t._$litDirective$;
  return (o == null ? void 0 : o.constructor) !== l && ((a = o == null ? void 0 : o._$AO) == null || a.call(o, !1), l === void 0 ? o = void 0 : (o = new l(s), o._$AT(s, i, n)), n !== void 0 ? (i.o ?? (i.o = []))[n] = o : i.l = o), o !== void 0 && (t = Mr(s, o._$AS(s, t.values), o, n)), t;
}
u(Mr, "w$1");
ve(Mr, "z");
var Pd;
const PM = (Pd = class {
  constructor(t, i) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: i }, parts: n } = this._$AD, r = ((t == null ? void 0 : t.creationScope) ?? $o).importNode(i, !0);
    ka.currentNode = r;
    let a = ka.nextNode(), o = 0, l = 0, c = n[0];
    for (; c !== void 0; ) {
      if (o === c.index) {
        let h;
        c.type === 2 ? h = new rv(a, a.nextSibling, this, t) : c.type === 1 ? h = new c.ctor(a, c.name, c.strings, this, t) : c.type === 6 && (h = new IM(a, this, t)), this._$AV.push(h), c = n[++l];
      }
      o !== (c == null ? void 0 : c.index) && (a = ka.nextNode(), o++);
    }
    return ka.currentNode = $o, r;
  }
  p(t) {
    let i = 0;
    for (const n of this._$AV) n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, i), i += n.strings.length - 2) : n._$AI(t[i])), i++;
  }
}, u(Pd, "Ae"), Pd);
ve(PM, "F");
let CM = PM;
var uo;
const QM = (uo = class {
  get _$AU() {
    var t;
    return ((t = this._$AM) == null ? void 0 : t._$AU) ?? this.v;
  }
  constructor(t, i, n, r) {
    this.type = 2, this._$AH = M, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = n, this.options = r, this.v = (r == null ? void 0 : r.isConnected) ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const i = this._$AM;
    return i !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = i.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, i = this) {
    t = Mr(this, t, i), mm(t) ? t === M || t == null || t === "" ? (this._$AH !== M && this._$AR(), this._$AH = M) : t !== this._$AH && t !== pn && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : bM(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== M && mm(this._$AH) ? this._$AA.nextSibling.data = t : this.T($o.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var i;
    const { values: n, _$litType$: r } = t, a = typeof r == "number" ? this._$AC(t) : (r.el === void 0 && (r.el = n$.createElement(Vk(r.h, r.h[0]), this.options)), r);
    if (((i = this._$AH) == null ? void 0 : i._$AD) === a) this._$AH.p(n);
    else {
      const o = new CM(a, this), l = o.u(this.options);
      o.p(n), this.T(l), this._$AH = o;
    }
  }
  _$AC(t) {
    let i = p4.get(t.strings);
    return i === void 0 && p4.set(t.strings, i = new n$(t)), i;
  }
  k(t) {
    Wk(this._$AH) || (this._$AH = [], this._$AR());
    const i = this._$AH;
    let n, r = 0;
    for (const a of t) r === i.length ? i.push(n = new uo(this.O(ym()), this.O(ym()), this, this.options)) : n = i[r], n._$AI(a), r++;
    r < i.length && (this._$AR(n && n._$AB.nextSibling, r), i.length = r);
  }
  _$AR(t = this._$AA.nextSibling, i) {
    var n;
    for ((n = this._$AP) == null ? void 0 : n.call(this, !1, !0, i); t && t !== this._$AB; ) {
      const r = t.nextSibling;
      t.remove(), t = r;
    }
  }
  setConnected(t) {
    var i;
    this._$AM === void 0 && (this.v = t, (i = this._$AP) == null || i.call(this, t));
  }
}, u(uo, "ie"), uo);
ve(QM, "et");
let rv = QM;
var Cd;
const TM = (Cd = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, i, n, r, a) {
    this.type = 1, this._$AH = M, this._$AN = void 0, this.element = t, this.name = i, this._$AM = r, this.options = a, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = M;
  }
  _$AI(t, i = this, n, r) {
    const a = this.strings;
    let o = !1;
    if (a === void 0) t = Mr(this, t, i, 0), o = !mm(t) || t !== this._$AH && t !== pn, o && (this._$AH = t);
    else {
      const l = t;
      let c, h;
      for (t = a[0], c = 0; c < a.length - 1; c++) h = Mr(this, l[n + c], i, c), h === pn && (h = this._$AH[c]), o || (o = !mm(h) || h !== this._$AH[c]), h === M ? t = M : t !== M && (t += (h ?? "") + a[c + 1]), this._$AH[c] = h;
    }
    o && !r && this.j(t);
  }
  j(t) {
    t === M ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}, u(Cd, "ye"), Cd);
ve(TM, "G");
let Km = TM;
var Qd;
const MM = (Qd = class extends Km {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === M ? void 0 : t;
  }
}, u(Qd, "Se"), Qd);
ve(MM, "Y");
let RM = MM;
var Td;
const AM = (Td = class extends Km {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== M);
  }
}, u(Td, "Ee"), Td);
ve(AM, "Z");
let EM = AM;
var Md;
const zM = (Md = class extends Km {
  constructor(t, i, n, r, a) {
    super(t, i, n, r, a), this.type = 5;
  }
  _$AI(t, i = this) {
    if ((t = Mr(this, t, i, 0) ?? M) === pn) return;
    const n = this._$AH, r = t === M && n !== M || t.capture !== n.capture || t.once !== n.once || t.passive !== n.passive, a = t !== M && (n === M || r);
    r && this.element.removeEventListener(this.name, this, n), a && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var i;
    typeof this._$AH == "function" ? this._$AH.call(((i = this.options) == null ? void 0 : i.host) ?? this.element, t) : this._$AH.handleEvent(t);
  }
}, u(Md, "we"), Md);
ve(zM, "q");
let _M = zM;
var Rd;
const LM = (Rd = class {
  constructor(t, i, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    Mr(this, t);
  }
}, u(Rd, "ke"), Rd);
ve(LM, "K");
let IM = LM;
const aq = { M: Lk, P: us, A: Ik, C: 1, L: kM, R: CM, D: bM, V: Mr, I: rv, H: Km, N: EM, U: _M, B: RM, F: IM }, f4 = fm.litHtmlPolyfillSupport;
f4 == null || f4(n$, rv), (fm.litHtmlVersions ?? (fm.litHtmlVersions = [])).push("3.2.0");
const WM = /* @__PURE__ */ ve((s, t, i) => {
  const n = (i == null ? void 0 : i.renderBefore) ?? t;
  let r = n._$litPart$;
  if (r === void 0) {
    const a = (i == null ? void 0 : i.renderBefore) ?? null;
    n._$litPart$ = r = new rv(t.insertBefore(ym(), a), a, void 0, i ?? {});
  }
  return r._$AI(s), r;
}, "Q");
var Ad;
const VM = (Ad = class extends Dl {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var t;
    const i = super.createRenderRoot();
    return (t = this.renderOptions).renderBefore ?? (t.renderBefore = i.firstChild), i;
  }
  update(t) {
    const i = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = WM(i, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this.o) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this.o) == null || t.setConnected(!1);
  }
  render() {
    return pn;
  }
}, u(Ad, "Re"), Ad);
ve(VM, "h");
let G = VM;
var y4;
G._$litElement$ = !0, G.finalized = !0, (y4 = globalThis.litElementHydrateSupport) == null || y4.call(globalThis, { LitElement: G });
const m4 = globalThis.litElementPolyfillSupport;
m4 == null || m4({ LitElement: G });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
O`<strong>${0}</strong> redigerade <em>${1}</em>`, O`<strong>${0}</strong> nämnde dig i ett inlägg`, O`<strong>${0}</strong> kommenterade på <strong>${1}</strong>`, O`<strong>${0}</strong> reagerade med ${1} på <em>${2}</em>`, O`<strong>${0}</strong> svarade på ett inlägg`, O`<strong>${0}</strong> redigerade ett inlägg`, O`<strong>${0}</strong> nämnde dig i ett meddelande`, O`<strong>${0}</strong> nämnde dig i en kommentar`, O`<strong>${0}</strong> och <strong>${1}</strong> röstade i din omröstning`, O`<strong>${0}</strong> reagerade med ${1} på ditt inlägg`, O`<strong>${0}</strong> reagerade med ${1} på din kommentar`, O`Nytt meddelande från <strong>${0}</strong>`, O`<strong>${0}</strong> svarade på ditt inlägg`, O`<strong>${0}</strong> röstade i din omröstning`, O`<strong>${0}</strong> publicerade ett inlägg i <strong>${1}</strong>`, O`<strong>${0}</strong> gillade ditt meddelande`, O`<strong>${0}</strong>, <strong>${1}</strong> och <strong>${2}</strong> röstade i din omröstning`, O`<strong>${0}</strong> lade till <em>${1}</em> till <strong>${2}</strong>`, O`<strong>${0}</strong> skickade ett meddelande i <strong>${1}</strong>`, O`<strong>${0}</strong> reagerade med ${1} på ditt meddelande`, O`<strong>${0}</strong> gillade <em>${1}</em>`, O`<strong>${0}</strong> gillade ditt inlägg`, O`<strong>${0}</strong> gillade din kommentar`, O`<strong>${0}</strong> och ${1} andra röstade i din omröstning`, O`<strong>${0}</strong> kommenterade på <em>${1}</em>`, ie`${0} svarade på ditt inlägg`, ie`${0} röstade i din omröstning`, ie`Öppna i ${0}?`, ie`${0} skriver${1}`, ie`${0} och ${1} röstade i din omröstning`, ie`${0} kommenterade på ${1}`, ie`${0} gillade ${1}`, ie`${0} skickade ett meddelande i ${1}`, ie`${0} redigerade ett inlägg`, ie`Röster på ${0}`, ie`${0} kommentarer`, ie`Sedd av ${0} vid ${1}`, ie`${0} och ${1} andra röstade i din omröstning`, ie`Nytt meddelande från ${0}`, ie`${0} reagerade med ${1} på ditt inlägg`, ie`${0} nämnde dig i ett inlägg`, ie`${0} nämnde dig i en kommentar`, ie`${0} publicerade ett inlägg i ${1}`, ie`${0} gillade ditt inlägg`, ie`${0} nämnde dig i ett meddelande`, ie`${0} reagerade med ${1} på din kommentar`, ie` Öppna i ${0}
        `, ie`${0} svarade på ett inlägg`, ie`${0} lade till ${1} till ${2}`, ie`${0} redigerade ${1}`, ie`${0} gillade ditt meddelande`, ie`${0}, ${1} och ${2} röstade i din omröstning`, ie`${0} reagerade med ${1} på ${2}`, ie`${0} reagerade med ${1} på ditt meddelande`, ie`${0} gillade din kommentar`, ie`${0} skriver${1}`;
var oq = Object.defineProperty, ZM = /* @__PURE__ */ u((s) => {
  throw TypeError(s);
}, "Np"), p = /* @__PURE__ */ u((s, t) => oq(s, "name", { value: t, configurable: !0 }), "c"), Zk = /* @__PURE__ */ u((s, t, i) => t.has(s) || ZM("Cannot " + i), "bd"), P = /* @__PURE__ */ u((s, t, i) => (Zk(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "b"), U = /* @__PURE__ */ u((s, t, i) => t.has(s) ? ZM("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "T"), q = /* @__PURE__ */ u((s, t, i, n) => (Zk(s, t, "write to private field"), t.set(s, i), i), "I"), ye = /* @__PURE__ */ u((s, t, i) => (Zk(s, t, "access private method"), i), "tt"), s$ = /* @__PURE__ */ u((s, t, i, n) => ({
  set _(r) {
    q(s, t, r);
  },
  get _() {
    return P(s, t, n);
  }
}), "Pc");
function wm(s) {
  return Object.prototype.toString.call(s) === "[object Object]";
}
u(wm, "Lc");
p(wm, "isObject$1");
function gm(s) {
  if (wm(s) === !1) return !1;
  const t = s.constructor;
  if (t === void 0) return !0;
  const i = t.prototype;
  return !(wm(i) === !1 || Object.prototype.hasOwnProperty.call(i, "isPrototypeOf") === !1);
}
u(gm, "Rc");
p(gm, "isPlainObject$1");
function Hy(s, t, i = !1) {
  s = s || {}, t = t || {};
  const n = {};
  for (const r in s)
    Object.prototype.hasOwnProperty.call(s, r) && (n[r] = s[r]);
  for (const r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (i && n[r] && gm(n[r]) && gm(t[r]) ? n[r] = Hy(
      n[r],
      t[r],
      i
    ) : n[r] = t[r]);
  return n;
}
u(Hy, "Ec");
p(Hy, "assign");
function yc(s, t, i = !1, n = !1) {
  if (!n && (!gm(s) || !gm(t)) || n && (!wm(s) || !wm(t)))
    return !1;
  const r = Object.getOwnPropertyNames(s), a = Object.getOwnPropertyNames(t);
  if (!i && r.length !== a.length)
    return !1;
  for (let o = 0; o < r.length; o++) {
    const l = r[o], c = s[l], h = t[l];
    if (c !== h && !yc(c, h, i))
      return !1;
  }
  return !0;
}
u(yc, "ko");
p(yc, "eqObjects");
function Dk(s) {
  return Object.entries(s);
}
u(Dk, "dy");
p(Dk, "objectAsIterable");
function qk(s) {
  return s.charAt(0).toUpperCase() + s.substring(1).toLowerCase();
}
u(qk, "hy");
p(qk, "toUpperCaseFirst");
const lq = '\\s,.:;"', cq = new RegExp(`^|[${lq}]|$`, "g");
function Uk(s) {
  return s.length > 0 ? s.replace(/([a-z\d])([A-Z]+)/g, "$1-$2").replace(/_|\s+/g, "-").toLowerCase() : s;
}
u(Uk, "py");
p(Uk, "toKebabCase");
function DM(s, t = 2) {
  if (!s)
    return null;
  let i = "";
  const n = s.split(cq).filter((r) => r);
  return n.length == 1 ? i = n[0] : n.forEach((r) => {
    i += r.charAt(0);
  }), i.substring(0, t).toUpperCase();
}
u(DM, "Vf");
p(DM, "getInitials");
const hq = {
  //mode: 'cors', // no-cors, *cors, same-origin
  // cache: 'default' means the server is in control of the caching which is preferred instead of using 'reload'
  //cache: 'default', // *default, no-cache, reload, force-cache, only-if-cached
  credentials: "omit",
  // include, *same-origin, omit
  headers: {
    // https://stackoverflow.com/questions/8163703/cross-domain-ajax-doesnt-send-x-requested-with-header
    "X-Requested-With": "XMLHttpRequest"
  },
  redirect: "manual"
  // manual, *follow, error
  //referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
};
function ff() {
  return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
}
u(ff, "So");
p(ff, "S4");
function qM(s) {
  if (s && s.ok && s.body) {
    const t = s.body.getReader();
    return new ReadableStream({
      start(i) {
        const n = /* @__PURE__ */ p(() => t.read().then(({ done: r, value: a }) => {
          if (r) {
            i.close();
            return;
          }
          return i.enqueue(a), n();
        }), "pump");
        return n();
      }
    });
  } else
    throw new Error("Could not parse text stream");
}
u(qM, "Uf");
p(qM, "getTextStreamFromResponse");
function UM(s) {
  let t;
  try {
    if (t = window[s], t) {
      const i = "__storage_test__";
      t.setItem(i, i), t.removeItem(i);
    }
  } catch (i) {
    i instanceof DOMException && i.name === "QuotaExceededError" && // acknowledge QuotaExceededError only if there's something already stored
    t && t.length !== 0 && console.error("Storage not available:", s);
  }
  return t;
}
u(UM, "qf");
p(UM, "getStorage");
var Ed;
const NM = (Ed = class extends Error {
  constructor() {
    super("Instance destroyed"), this.name = "DestroyError";
  }
}, u(Ed, "hp"), Ed);
p(NM, "DestroyError");
let mt = NM;
var mO, zd, _f = (mO = (zd = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, u(zd, "Ar"), zd), p(mO, "Subscribable"), mO), yf = typeof window > "u" || "Deno" in globalThis;
function Qi() {
}
u(Qi, "Ve");
p(Qi, "noop$1");
function BM(s, t) {
  return typeof s == "function" ? s(t) : s;
}
u(BM, "Nf");
p(BM, "functionalUpdate");
function r1(s) {
  return typeof s == "number" && s >= 0 && s !== 1 / 0;
}
u(r1, "Ad");
p(r1, "isValidTimeout");
function Nk(s, t) {
  return Math.max(s + (t || 0) - Date.now(), 0);
}
u(Nk, "uy");
p(Nk, "timeUntilStale");
function Ca(s, t) {
  return typeof s == "function" ? s(t) : s;
}
u(Ca, "Sr");
p(Ca, "resolveStaleTime");
function Zi(s, t) {
  return typeof s == "function" ? s(t) : s;
}
u(Zi, "Ge");
p(Zi, "resolveEnabled");
function r$(s, t) {
  const {
    type: i = "all",
    exact: n,
    fetchStatus: r,
    predicate: a,
    queryKey: o,
    stale: l
  } = s;
  if (o) {
    if (n) {
      if (t.queryHash !== av(o, t.options))
        return !1;
    } else if (!mf(t.queryKey, o))
      return !1;
  }
  if (i !== "all") {
    const c = t.isActive();
    if (i === "active" && !c || i === "inactive" && c)
      return !1;
  }
  return !(typeof l == "boolean" && t.isStale() !== l || r && r !== t.state.fetchStatus || a && !a(t));
}
u(r$, "Qp");
p(r$, "matchQuery");
function a$(s, t) {
  const { exact: i, status: n, predicate: r, mutationKey: a } = s;
  if (a) {
    if (!t.options.mutationKey)
      return !1;
    if (i) {
      if (Rr(t.options.mutationKey) !== Rr(a))
        return !1;
    } else if (!mf(t.options.mutationKey, a))
      return !1;
  }
  return !(n && t.state.status !== n || r && !r(t));
}
u(a$, "Kp");
p(a$, "matchMutation");
function av(s, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Rr)(s);
}
u(av, "zh");
p(av, "hashQueryKeyByOptions");
function Rr(s) {
  return JSON.stringify(
    s,
    (t, i) => a1(i) ? Object.keys(i).sort().reduce((n, r) => (n[r] = i[r], n), {}) : i
  );
}
u(Rr, "Vs");
p(Rr, "hashKey");
function mf(s, t) {
  return s === t ? !0 : typeof s != typeof t ? !1 : s && t && typeof s == "object" && typeof t == "object" ? !Object.keys(t).some((i) => !mf(s[i], t[i])) : !1;
}
u(mf, "Eo");
p(mf, "partialMatchKey");
function Lf(s, t) {
  if (s === t)
    return s;
  const i = o$(s) && o$(t);
  if (i || a1(s) && a1(t)) {
    const n = i ? s : Object.keys(s), r = n.length, a = i ? t : Object.keys(t), o = a.length, l = i ? [] : {};
    let c = 0;
    for (let h = 0; h < o; h++) {
      const d = i ? h : a[h];
      (!i && n.includes(d) || i) && s[d] === void 0 && t[d] === void 0 ? (l[d] = void 0, c++) : (l[d] = Lf(s[d], t[d]), l[d] === s[d] && s[d] !== void 0 && c++);
    }
    return r === o && c === r ? s : l;
  }
  return t;
}
u(Lf, "hc");
p(Lf, "replaceEqualDeep");
function vm(s, t) {
  if (!t || Object.keys(s).length !== Object.keys(t).length)
    return !1;
  for (const i in s)
    if (s[i] !== t[i])
      return !1;
  return !0;
}
u(vm, "Ic");
p(vm, "shallowEqualObjects");
function o$(s) {
  return Array.isArray(s) && s.length === Object.keys(s).length;
}
u(o$, "Gp");
p(o$, "isPlainArray");
function a1(s) {
  if (!l$(s))
    return !1;
  const t = s.constructor;
  if (t === void 0)
    return !0;
  const i = t.prototype;
  return !(!l$(i) || !i.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(s) !== Object.prototype);
}
u(a1, "Ld");
p(a1, "isPlainObject");
function l$(s) {
  return Object.prototype.toString.call(s) === "[object Object]";
}
u(l$, "Yp");
p(l$, "hasObjectPrototype");
function jM(s) {
  return new Promise((t) => {
    setTimeout(t, s);
  });
}
u(jM, "jf");
p(jM, "sleep");
function o1(s, t, i) {
  return typeof i.structuralSharing == "function" ? i.structuralSharing(s, t) : i.structuralSharing !== !1 ? Lf(s, t) : t;
}
u(o1, "Rd");
p(o1, "replaceData");
function XM(s, t, i = 0) {
  const n = [...s, t];
  return i && n.length > i ? n.slice(1) : n;
}
u(XM, "Wf");
p(XM, "addToEnd");
function FM(s, t, i = 0) {
  const n = [t, ...s];
  return i && n.length > i ? n.slice(0, -1) : n;
}
u(FM, "Qf");
p(FM, "addToStart");
var Bk = Symbol();
function jk(s, t) {
  return !s.queryFn && t != null && t.initialPromise ? () => t.initialPromise : !s.queryFn || s.queryFn === Bk ? () => Promise.reject(new Error(`Missing queryFn: '${s.queryHash}'`)) : s.queryFn;
}
u(jk, "yy");
p(jk, "ensureQueryFn");
var Ml, ra, ey, wO, _d, dq = (wO = (_d = class extends _f {
  constructor() {
    super(), U(this, Ml), U(this, ra), U(this, ey), q(this, ey, (t) => {
      if (!yf && window.addEventListener) {
        const i = /* @__PURE__ */ p(() => t(), "listener");
        return window.addEventListener("visibilitychange", i, !1), () => {
          window.removeEventListener("visibilitychange", i);
        };
      }
    });
  }
  onSubscribe() {
    P(this, ra) || this.setEventListener(P(this, ey));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = P(this, ra)) == null || t.call(this), q(this, ra, void 0));
  }
  setEventListener(t) {
    var i;
    q(this, ey, t), (i = P(this, ra)) == null || i.call(this), q(this, ra, t((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    }));
  }
  setFocused(t) {
    P(this, Ml) !== t && (q(this, Ml, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((i) => {
      i(t);
    });
  }
  isFocused() {
    var t;
    return typeof P(this, Ml) == "boolean" ? P(this, Ml) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, u(_d, "Rr"), _d), Ml = /* @__PURE__ */ new WeakMap(), ra = /* @__PURE__ */ new WeakMap(), ey = /* @__PURE__ */ new WeakMap(), p(wO, "FocusManager"), wO), Xk = new dq(), ty, aa, iy, gO, Ld, uq = (gO = (Ld = class extends _f {
  constructor() {
    super(), U(this, ty, !0), U(this, aa), U(this, iy), q(this, iy, (t) => {
      if (!yf && window.addEventListener) {
        const i = /* @__PURE__ */ p(() => t(!0), "onlineListener"), n = /* @__PURE__ */ p(() => t(!1), "offlineListener");
        return window.addEventListener("online", i, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", i), window.removeEventListener("offline", n);
        };
      }
    });
  }
  onSubscribe() {
    P(this, aa) || this.setEventListener(P(this, iy));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = P(this, aa)) == null || t.call(this), q(this, aa, void 0));
  }
  setEventListener(t) {
    var i;
    q(this, iy, t), (i = P(this, aa)) == null || i.call(this), q(this, aa, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    P(this, ty) !== t && (q(this, ty, t), this.listeners.forEach((i) => {
      i(t);
    }));
  }
  isOnline() {
    return P(this, ty);
  }
}, u(Ld, "Fr"), Ld), ty = /* @__PURE__ */ new WeakMap(), aa = /* @__PURE__ */ new WeakMap(), iy = /* @__PURE__ */ new WeakMap(), p(gO, "OnlineManager"), gO), l1 = new uq();
function c1() {
  let s, t;
  const i = new Promise((r, a) => {
    s = r, t = a;
  });
  i.status = "pending", i.catch(() => {
  });
  function n(r) {
    Object.assign(i, r), delete i.resolve, delete i.reject;
  }
  return u(n, "s"), p(n, "finalize"), i.resolve = (r) => {
    n({
      status: "fulfilled",
      value: r
    }), s(r);
  }, i.reject = (r) => {
    n({
      status: "rejected",
      reason: r
    }), t(r);
  }, i;
}
u(c1, "Id");
p(c1, "pendingThenable");
function HM(s) {
  return Math.min(1e3 * 2 ** s, 3e4);
}
u(HM, "Yf");
p(HM, "defaultRetryDelay");
function Fk(s) {
  return (s ?? "online") === "online" ? l1.isOnline() : !0;
}
u(Fk, "wy");
p(Fk, "canFetch");
var vO, Id, YM = (vO = (Id = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}, u(Id, "Dr"), Id), p(vO, "CancelledError"), vO);
function sg(s) {
  return s instanceof YM;
}
u(sg, "xd");
p(sg, "isCancelledError");
function Hk(s) {
  let t = !1, i = 0, n = !1, r;
  const a = c1(), o = /* @__PURE__ */ p((b) => {
    var k;
    n || (y(new YM(b)), (k = s.abort) == null || k.call(s));
  }, "cancel"), l = /* @__PURE__ */ p(() => {
    t = !0;
  }, "cancelRetry"), c = /* @__PURE__ */ p(() => {
    t = !1;
  }, "continueRetry"), h = /* @__PURE__ */ p(() => Xk.isFocused() && (s.networkMode === "always" || l1.isOnline()) && s.canRun(), "canContinue"), d = /* @__PURE__ */ p(() => Fk(s.networkMode) && s.canRun(), "canStart"), f = /* @__PURE__ */ p((b) => {
    var k;
    n || (n = !0, (k = s.onSuccess) == null || k.call(s, b), r == null || r(), a.resolve(b));
  }, "resolve"), y = /* @__PURE__ */ p((b) => {
    var k;
    n || (n = !0, (k = s.onError) == null || k.call(s, b), r == null || r(), a.reject(b));
  }, "reject"), w = /* @__PURE__ */ p(() => new Promise((b) => {
    var k;
    r = /* @__PURE__ */ p(($) => {
      (n || h()) && b($);
    }, "continueFn"), (k = s.onPause) == null || k.call(s);
  }).then(() => {
    var b;
    r = void 0, n || (b = s.onContinue) == null || b.call(s);
  }), "pause"), g = /* @__PURE__ */ p(() => {
    if (n)
      return;
    let b;
    const k = i === 0 ? s.initialPromise : void 0;
    try {
      b = k ?? s.fn();
    } catch ($) {
      b = Promise.reject($);
    }
    Promise.resolve(b).then(f).catch(($) => {
      var C;
      if (n)
        return;
      const E = s.retry ?? (yf ? 0 : 3), A = s.retryDelay ?? HM, R = typeof A == "function" ? A(i, $) : A, L = E === !0 || typeof E == "number" && i < E || typeof E == "function" && E(i, $);
      if (t || !L) {
        y($);
        return;
      }
      i++, (C = s.onFail) == null || C.call(s, i, $), jM(R).then(() => h() ? void 0 : w()).then(() => {
        t ? y($) : g();
      });
    });
  }, "run");
  return {
    promise: a,
    cancel: o,
    continue: /* @__PURE__ */ p(() => (r == null || r(), a), "continue"),
    cancelRetry: l,
    continueRetry: c,
    canStart: d,
    start: /* @__PURE__ */ p(() => (d() ? g() : w().then(g), a), "start")
  };
}
u(Hk, "my");
p(Hk, "createRetryer");
function GM() {
  let s = [], t = 0, i = /* @__PURE__ */ p((l) => {
    l();
  }, "notifyFn"), n = /* @__PURE__ */ p((l) => {
    l();
  }, "batchNotifyFn"), r = /* @__PURE__ */ p((l) => setTimeout(l, 0), "scheduleFn");
  const a = /* @__PURE__ */ p((l) => {
    t ? s.push(l) : r(() => {
      i(l);
    });
  }, "schedule"), o = /* @__PURE__ */ p(() => {
    const l = s;
    s = [], l.length && r(() => {
      n(() => {
        l.forEach((c) => {
          i(c);
        });
      });
    });
  }, "flush");
  return {
    batch: /* @__PURE__ */ p((l) => {
      let c;
      t++;
      try {
        c = l();
      } finally {
        t--, t || o();
      }
      return c;
    }, "batch"),
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: /* @__PURE__ */ p((l) => (...c) => {
      a(() => {
        l(...c);
      });
    }, "batchCalls"),
    schedule: a,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: /* @__PURE__ */ p((l) => {
      i = l;
    }, "setNotifyFunction"),
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: /* @__PURE__ */ p((l) => {
      n = l;
    }, "setBatchNotifyFunction"),
    setScheduler: /* @__PURE__ */ p((l) => {
      r = l;
    }, "setScheduler")
  };
}
u(GM, "Zf");
p(GM, "createNotifyManager");
var Nt = GM(), Rl, OO, Wd, KM = (OO = (Wd = class {
  constructor() {
    U(this, Rl);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), r1(this.gcTime) && q(this, Rl, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? (yf ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    P(this, Rl) && (clearTimeout(P(this, Rl)), q(this, Rl, void 0));
  }
}, u(Wd, "Hr"), Wd), Rl = /* @__PURE__ */ new WeakMap(), p(OO, "Removable"), OO), ny, sy, Ki, si, Mw, Al, Pn, ns, bO, Vd, pq = (bO = (Vd = class extends KM {
  constructor(t) {
    super(), U(this, Pn), U(this, ny), U(this, sy), U(this, Ki), U(this, si), U(this, Mw), U(this, Al), q(this, Al, !1), q(this, Mw, t.defaultOptions), this.setOptions(t.options), this.observers = [], q(this, Ki, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, q(this, ny, JM(this.options)), this.state = t.state ?? P(this, ny), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = P(this, si)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...P(this, Mw), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && P(this, Ki).remove(this);
  }
  setData(t, i) {
    const n = o1(this.state.data, t, this.options);
    return ye(this, Pn, ns).call(this, {
      data: n,
      type: "success",
      dataUpdatedAt: i == null ? void 0 : i.updatedAt,
      manual: i == null ? void 0 : i.manual
    }), n;
  }
  setState(t, i) {
    ye(this, Pn, ns).call(this, { type: "setState", state: t, setStateOptions: i });
  }
  cancel(t) {
    var i, n;
    const r = (i = P(this, si)) == null ? void 0 : i.promise;
    return (n = P(this, si)) == null || n.cancel(t), r ? r.then(Qi).catch(Qi) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(P(this, ny));
  }
  isActive() {
    return this.observers.some(
      (t) => Zi(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Bk || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !Nk(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const i = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    i == null || i.refetch({ cancelRefetch: !1 }), (t = P(this, si)) == null || t.continue();
  }
  onOnline() {
    var t;
    const i = this.observers.find((n) => n.shouldFetchOnReconnect());
    i == null || i.refetch({ cancelRefetch: !1 }), (t = P(this, si)) == null || t.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), P(this, Ki).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((i) => i !== t), this.observers.length || (P(this, si) && (P(this, Al) ? P(this, si).cancel({ revert: !0 }) : P(this, si).cancelRetry()), this.scheduleGc()), P(this, Ki).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || ye(this, Pn, ns).call(this, { type: "invalidate" });
  }
  fetch(t, i) {
    var n, r, a;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && i != null && i.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (P(this, si))
        return P(this, si).continueRetry(), P(this, si).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const f = this.observers.find((y) => y.options.queryFn);
      f && this.setOptions(f.options);
    }
    const o = new AbortController(), l = /* @__PURE__ */ p((f) => {
      Object.defineProperty(f, "signal", {
        enumerable: !0,
        get: /* @__PURE__ */ p(() => (q(this, Al, !0), o.signal), "get")
      });
    }, "addSignalProperty"), c = /* @__PURE__ */ p(() => {
      const f = jk(this.options, i), y = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return l(y), q(this, Al, !1), this.options.persister ? this.options.persister(
        f,
        y,
        this
      ) : f(y);
    }, "fetchFn"), h = {
      fetchOptions: i,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: c
    };
    l(h), (n = this.options.behavior) == null || n.onFetch(
      h,
      this
    ), q(this, sy, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((r = h.fetchOptions) == null ? void 0 : r.meta)) && ye(this, Pn, ns).call(this, { type: "fetch", meta: (a = h.fetchOptions) == null ? void 0 : a.meta });
    const d = /* @__PURE__ */ p((f) => {
      var y, w, g, b;
      sg(f) && f.silent || ye(this, Pn, ns).call(this, {
        type: "error",
        error: f
      }), sg(f) || ((w = (y = P(this, Ki).config).onError) == null || w.call(
        y,
        f,
        this
      ), (b = (g = P(this, Ki).config).onSettled) == null || b.call(
        g,
        this.state.data,
        f,
        this
      )), this.scheduleGc();
    }, "onError");
    return q(this, si, Hk({
      initialPromise: i == null ? void 0 : i.initialPromise,
      fn: h.fetchFn,
      abort: o.abort.bind(o),
      onSuccess: /* @__PURE__ */ p((f) => {
        var y, w, g, b;
        if (f === void 0) {
          d(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(f);
        } catch (k) {
          d(k);
          return;
        }
        (w = (y = P(this, Ki).config).onSuccess) == null || w.call(y, f, this), (b = (g = P(this, Ki).config).onSettled) == null || b.call(
          g,
          f,
          this.state.error,
          this
        ), this.scheduleGc();
      }, "onSuccess"),
      onError: d,
      onFail: /* @__PURE__ */ p((f, y) => {
        ye(this, Pn, ns).call(this, { type: "failed", failureCount: f, error: y });
      }, "onFail"),
      onPause: /* @__PURE__ */ p(() => {
        ye(this, Pn, ns).call(this, { type: "pause" });
      }, "onPause"),
      onContinue: /* @__PURE__ */ p(() => {
        ye(this, Pn, ns).call(this, { type: "continue" });
      }, "onContinue"),
      retry: h.options.retry,
      retryDelay: h.options.retryDelay,
      networkMode: h.options.networkMode,
      canRun: /* @__PURE__ */ p(() => !0, "canRun")
    })), P(this, si).start();
  }
}, u(Vd, "Ur"), Vd), ny = /* @__PURE__ */ new WeakMap(), sy = /* @__PURE__ */ new WeakMap(), Ki = /* @__PURE__ */ new WeakMap(), si = /* @__PURE__ */ new WeakMap(), Mw = /* @__PURE__ */ new WeakMap(), Al = /* @__PURE__ */ new WeakMap(), Pn = /* @__PURE__ */ new WeakSet(), ns = /* @__PURE__ */ p(function(s) {
  const t = /* @__PURE__ */ p((i) => {
    switch (s.type) {
      case "failed":
        return {
          ...i,
          fetchFailureCount: s.failureCount,
          fetchFailureReason: s.error
        };
      case "pause":
        return {
          ...i,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...i,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...i,
          ...Yk(i.data, this.options),
          fetchMeta: s.meta ?? null
        };
      case "success":
        return {
          ...i,
          data: s.data,
          dataUpdateCount: i.dataUpdateCount + 1,
          dataUpdatedAt: s.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!s.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const n = s.error;
        return sg(n) && n.revert && P(this, sy) ? { ...P(this, sy), fetchStatus: "idle" } : {
          ...i,
          error: n,
          errorUpdateCount: i.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: i.fetchFailureCount + 1,
          fetchFailureReason: n,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...i,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...i,
          ...s.state
        };
    }
  }, "reducer");
  this.state = t(this.state), Nt.batch(() => {
    this.observers.forEach((i) => {
      i.onQueryUpdate();
    }), P(this, Ki).notify({ query: this, type: "updated", action: s });
  });
}, "#dispatch"), p(bO, "Query"), bO);
function Yk(s, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Fk(t.networkMode) ? "fetching" : "paused",
    ...s === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
u(Yk, "gy");
p(Yk, "fetchState");
function JM(s) {
  const t = typeof s.initialData == "function" ? s.initialData() : s.initialData, i = t !== void 0, n = i ? typeof s.initialDataUpdatedAt == "function" ? s.initialDataUpdatedAt() : s.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: i ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: i ? "success" : "pending",
    fetchStatus: "idle"
  };
}
u(JM, "Jf");
p(JM, "getDefaultState$1");
var ss, $O, Zd, fq = ($O = (Zd = class extends _f {
  constructor(t = {}) {
    super(), U(this, ss), this.config = t, q(this, ss, /* @__PURE__ */ new Map());
  }
  build(t, i, n) {
    const r = i.queryKey, a = i.queryHash ?? av(r, i);
    let o = this.get(a);
    return o || (o = new pq({
      cache: this,
      queryKey: r,
      queryHash: a,
      options: t.defaultQueryOptions(i),
      state: n,
      defaultOptions: t.getQueryDefaults(r)
    }), this.add(o)), o;
  }
  add(t) {
    P(this, ss).has(t.queryHash) || (P(this, ss).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const i = P(this, ss).get(t.queryHash);
    i && (t.destroy(), i === t && P(this, ss).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    Nt.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return P(this, ss).get(t);
  }
  getAll() {
    return [...P(this, ss).values()];
  }
  find(t) {
    const i = { exact: !0, ...t };
    return this.getAll().find(
      (n) => r$(i, n)
    );
  }
  findAll(t = {}) {
    const i = this.getAll();
    return Object.keys(t).length > 0 ? i.filter((n) => r$(t, n)) : i;
  }
  notify(t) {
    Nt.batch(() => {
      this.listeners.forEach((i) => {
        i(t);
      });
    });
  }
  onFocus() {
    Nt.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    Nt.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, u(Zd, "qr"), Zd), ss = /* @__PURE__ */ new WeakMap(), p($O, "QueryCache"), $O), rs, pi, El, as, Vs, xO, Dd, yq = (xO = (Dd = class extends KM {
  constructor(t) {
    super(), U(this, as), U(this, rs), U(this, pi), U(this, El), this.mutationId = t.mutationId, q(this, pi, t.mutationCache), q(this, rs, []), this.state = t.state || Gk(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    P(this, rs).includes(t) || (P(this, rs).push(t), this.clearGcTimeout(), P(this, pi).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    q(this, rs, P(this, rs).filter((i) => i !== t)), this.scheduleGc(), P(this, pi).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    P(this, rs).length || (this.state.status === "pending" ? this.scheduleGc() : P(this, pi).remove(this));
  }
  continue() {
    var t;
    return ((t = P(this, El)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var i, n, r, a, o, l, c, h, d, f, y, w, g, b, k, $, C, E, A, R;
    q(this, El, Hk({
      fn: /* @__PURE__ */ p(() => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")), "fn"),
      onFail: /* @__PURE__ */ p((D, j) => {
        ye(this, as, Vs).call(this, { type: "failed", failureCount: D, error: j });
      }, "onFail"),
      onPause: /* @__PURE__ */ p(() => {
        ye(this, as, Vs).call(this, { type: "pause" });
      }, "onPause"),
      onContinue: /* @__PURE__ */ p(() => {
        ye(this, as, Vs).call(this, { type: "continue" });
      }, "onContinue"),
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: /* @__PURE__ */ p(() => P(this, pi).canRun(this), "canRun")
    }));
    const L = this.state.status === "pending", I = !P(this, El).canStart();
    try {
      if (!L) {
        ye(this, as, Vs).call(this, { type: "pending", variables: t, isPaused: I }), await ((n = (i = P(this, pi).config).onMutate) == null ? void 0 : n.call(
          i,
          t,
          this
        ));
        const j = await ((a = (r = this.options).onMutate) == null ? void 0 : a.call(r, t));
        j !== this.state.context && ye(this, as, Vs).call(this, {
          type: "pending",
          context: j,
          variables: t,
          isPaused: I
        });
      }
      const D = await P(this, El).start();
      return await ((l = (o = P(this, pi).config).onSuccess) == null ? void 0 : l.call(
        o,
        D,
        t,
        this.state.context,
        this
      )), await ((h = (c = this.options).onSuccess) == null ? void 0 : h.call(c, D, t, this.state.context)), await ((f = (d = P(this, pi).config).onSettled) == null ? void 0 : f.call(
        d,
        D,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((w = (y = this.options).onSettled) == null ? void 0 : w.call(y, D, null, t, this.state.context)), ye(this, as, Vs).call(this, { type: "success", data: D }), D;
    } catch (D) {
      try {
        throw await ((b = (g = P(this, pi).config).onError) == null ? void 0 : b.call(
          g,
          D,
          t,
          this.state.context,
          this
        )), await (($ = (k = this.options).onError) == null ? void 0 : $.call(
          k,
          D,
          t,
          this.state.context
        )), await ((E = (C = P(this, pi).config).onSettled) == null ? void 0 : E.call(
          C,
          void 0,
          D,
          this.state.variables,
          this.state.context,
          this
        )), await ((R = (A = this.options).onSettled) == null ? void 0 : R.call(
          A,
          void 0,
          D,
          t,
          this.state.context
        )), D;
      } finally {
        ye(this, as, Vs).call(this, { type: "error", error: D });
      }
    } finally {
      P(this, pi).runNext(this);
    }
  }
}, u(Dd, "Nr"), Dd), rs = /* @__PURE__ */ new WeakMap(), pi = /* @__PURE__ */ new WeakMap(), El = /* @__PURE__ */ new WeakMap(), as = /* @__PURE__ */ new WeakSet(), Vs = /* @__PURE__ */ p(function(s) {
  const t = /* @__PURE__ */ p((i) => {
    switch (s.type) {
      case "failed":
        return {
          ...i,
          failureCount: s.failureCount,
          failureReason: s.error
        };
      case "pause":
        return {
          ...i,
          isPaused: !0
        };
      case "continue":
        return {
          ...i,
          isPaused: !1
        };
      case "pending":
        return {
          ...i,
          context: s.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: s.isPaused,
          status: "pending",
          variables: s.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...i,
          data: s.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...i,
          data: void 0,
          error: s.error,
          failureCount: i.failureCount + 1,
          failureReason: s.error,
          isPaused: !1,
          status: "error"
        };
    }
  }, "reducer");
  this.state = t(this.state), Nt.batch(() => {
    P(this, rs).forEach((i) => {
      i.onMutationUpdate(s);
    }), P(this, pi).notify({
      mutation: this,
      type: "updated",
      action: s
    });
  });
}, "#dispatch"), p(xO, "Mutation"), xO);
function Gk() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
u(Gk, "by");
p(Gk, "getDefaultState");
var Zs, Cn, Rw, kO, qd, mq = (kO = (qd = class extends _f {
  constructor(t = {}) {
    super(), U(this, Zs), U(this, Cn), U(this, Rw), this.config = t, q(this, Zs, /* @__PURE__ */ new Set()), q(this, Cn, /* @__PURE__ */ new Map()), q(this, Rw, 0);
  }
  build(t, i, n) {
    const r = new yq({
      mutationCache: this,
      mutationId: ++s$(this, Rw)._,
      options: t.defaultMutationOptions(i),
      state: n
    });
    return this.add(r), r;
  }
  add(t) {
    P(this, Zs).add(t);
    const i = Ty(t);
    if (typeof i == "string") {
      const n = P(this, Cn).get(i);
      n ? n.push(t) : P(this, Cn).set(i, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (P(this, Zs).delete(t)) {
      const i = Ty(t);
      if (typeof i == "string") {
        const n = P(this, Cn).get(i);
        if (n)
          if (n.length > 1) {
            const r = n.indexOf(t);
            r !== -1 && n.splice(r, 1);
          } else n[0] === t && P(this, Cn).delete(i);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const i = Ty(t);
    if (typeof i == "string") {
      const n = P(this, Cn).get(i), r = n == null ? void 0 : n.find(
        (a) => a.state.status === "pending"
      );
      return !r || r === t;
    } else
      return !0;
  }
  runNext(t) {
    var i;
    const n = Ty(t);
    if (typeof n == "string") {
      const r = (i = P(this, Cn).get(n)) == null ? void 0 : i.find((a) => a !== t && a.state.isPaused);
      return (r == null ? void 0 : r.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    Nt.batch(() => {
      P(this, Zs).forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), P(this, Zs).clear(), P(this, Cn).clear();
    });
  }
  getAll() {
    return Array.from(P(this, Zs));
  }
  find(t) {
    const i = { exact: !0, ...t };
    return this.getAll().find(
      (n) => a$(i, n)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((i) => a$(t, i));
  }
  notify(t) {
    Nt.batch(() => {
      this.listeners.forEach((i) => {
        i(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((i) => i.state.isPaused);
    return Nt.batch(
      () => Promise.all(
        t.map((i) => i.continue().catch(Qi))
      )
    );
  }
}, u(qd, "jr"), qd), Zs = /* @__PURE__ */ new WeakMap(), Cn = /* @__PURE__ */ new WeakMap(), Rw = /* @__PURE__ */ new WeakMap(), p(kO, "MutationCache"), kO);
function Ty(s) {
  var t;
  return (t = s.options.scope) == null ? void 0 : t.id;
}
u(Ty, "Mc");
p(Ty, "scopeFor");
function Om(s) {
  return {
    onFetch: /* @__PURE__ */ p((t, i) => {
      var n, r, a, o, l;
      const c = t.options, h = (a = (r = (n = t.fetchOptions) == null ? void 0 : n.meta) == null ? void 0 : r.fetchMore) == null ? void 0 : a.direction, d = ((o = t.state.data) == null ? void 0 : o.pages) || [], f = ((l = t.state.data) == null ? void 0 : l.pageParams) || [];
      let y = { pages: [], pageParams: [] }, w = 0;
      const g = /* @__PURE__ */ p(async () => {
        let b = !1;
        const k = /* @__PURE__ */ p((E) => {
          Object.defineProperty(E, "signal", {
            enumerable: !0,
            get: /* @__PURE__ */ p(() => (t.signal.aborted ? b = !0 : t.signal.addEventListener("abort", () => {
              b = !0;
            }), t.signal), "get")
          });
        }, "addSignalProperty"), $ = jk(t.options, t.fetchOptions), C = /* @__PURE__ */ p(async (E, A, R) => {
          if (b)
            return Promise.reject();
          if (A == null && E.pages.length)
            return Promise.resolve(E);
          const L = {
            queryKey: t.queryKey,
            pageParam: A,
            direction: R ? "backward" : "forward",
            meta: t.options.meta
          };
          k(L);
          const I = await $(
            L
          ), { maxPages: D } = t.options, j = R ? FM : XM;
          return {
            pages: j(E.pages, I, D),
            pageParams: j(E.pageParams, A, D)
          };
        }, "fetchPage");
        if (h && d.length) {
          const E = h === "backward", A = E ? Kk : h1, R = {
            pages: d,
            pageParams: f
          }, L = A(c, R);
          y = await C(R, L, E);
        } else {
          const E = s ?? d.length;
          do {
            const A = w === 0 ? f[0] ?? c.initialPageParam : h1(c, y);
            if (w > 0 && A == null)
              break;
            y = await C(y, A), w++;
          } while (w < E);
        }
        return y;
      }, "fetchFn");
      t.options.persister ? t.fetchFn = () => {
        var b, k;
        return (k = (b = t.options).persister) == null ? void 0 : k.call(
          b,
          g,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          i
        );
      } : t.fetchFn = g;
    }, "onFetch")
  };
}
u(Om, "Fc");
p(Om, "infiniteQueryBehavior");
function h1(s, { pages: t, pageParams: i }) {
  const n = t.length - 1;
  return t.length > 0 ? s.getNextPageParam(
    t[n],
    t,
    i[n],
    i
  ) : void 0;
}
u(h1, "Td");
p(h1, "getNextPageParam");
function Kk(s, { pages: t, pageParams: i }) {
  var n;
  return t.length > 0 ? (n = s.getPreviousPageParam) == null ? void 0 : n.call(s, t[0], t, i[0], i) : void 0;
}
u(Kk, "xy");
p(Kk, "getPreviousPageParam");
function eR(s, t) {
  return t ? h1(s, t) != null : !1;
}
u(eR, "s1");
p(eR, "hasNextPage");
function tR(s, t) {
  return !t || !s.getPreviousPageParam ? !1 : Kk(s, t) != null;
}
u(tR, "r1");
p(tR, "hasPreviousPage");
var rt, oa, la, ry, ay, ca, oy, ly, SO, Ud, wq = (SO = (Ud = class {
  constructor(t = {}) {
    U(this, rt), U(this, oa), U(this, la), U(this, ry), U(this, ay), U(this, ca), U(this, oy), U(this, ly), q(this, rt, t.queryCache || new fq()), q(this, oa, t.mutationCache || new mq()), q(this, la, t.defaultOptions || {}), q(this, ry, /* @__PURE__ */ new Map()), q(this, ay, /* @__PURE__ */ new Map()), q(this, ca, 0);
  }
  mount() {
    s$(this, ca)._++, P(this, ca) === 1 && (q(this, oy, Xk.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), P(this, rt).onFocus());
    })), q(this, ly, l1.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), P(this, rt).onOnline());
    })));
  }
  unmount() {
    var t, i;
    s$(this, ca)._--, P(this, ca) === 0 && ((t = P(this, oy)) == null || t.call(this), q(this, oy, void 0), (i = P(this, ly)) == null || i.call(this), q(this, ly, void 0));
  }
  isFetching(t) {
    return P(this, rt).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return P(this, oa).findAll({ ...t, status: "pending" }).length;
  }
  getQueryData(t) {
    var i;
    const n = this.defaultQueryOptions({ queryKey: t });
    return (i = P(this, rt).get(n.queryHash)) == null ? void 0 : i.state.data;
  }
  ensureQueryData(t) {
    const i = this.defaultQueryOptions(t), n = P(this, rt).build(this, i), r = n.state.data;
    return r === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && n.isStaleByTime(Ca(i.staleTime, n)) && this.prefetchQuery(i), Promise.resolve(r));
  }
  getQueriesData(t) {
    return P(this, rt).findAll(t).map(({ queryKey: i, state: n }) => {
      const r = n.data;
      return [i, r];
    });
  }
  setQueryData(t, i, n) {
    const r = this.defaultQueryOptions({ queryKey: t }), a = P(this, rt).get(
      r.queryHash
    ), o = a == null ? void 0 : a.state.data, l = BM(i, o);
    if (l !== void 0)
      return P(this, rt).build(this, r).setData(l, { ...n, manual: !0 });
  }
  setQueriesData(t, i, n) {
    return Nt.batch(
      () => P(this, rt).findAll(t).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, i, n)
      ])
    );
  }
  getQueryState(t) {
    var i;
    const n = this.defaultQueryOptions({ queryKey: t });
    return (i = P(this, rt).get(
      n.queryHash
    )) == null ? void 0 : i.state;
  }
  removeQueries(t) {
    const i = P(this, rt);
    Nt.batch(() => {
      i.findAll(t).forEach((n) => {
        i.remove(n);
      });
    });
  }
  resetQueries(t, i) {
    const n = P(this, rt), r = {
      type: "active",
      ...t
    };
    return Nt.batch(() => (n.findAll(t).forEach((a) => {
      a.reset();
    }), this.refetchQueries(r, i)));
  }
  cancelQueries(t, i = {}) {
    const n = { revert: !0, ...i }, r = Nt.batch(
      () => P(this, rt).findAll(t).map((a) => a.cancel(n))
    );
    return Promise.all(r).then(Qi).catch(Qi);
  }
  invalidateQueries(t, i = {}) {
    return Nt.batch(() => {
      if (P(this, rt).findAll(t).forEach((r) => {
        r.invalidate();
      }), (t == null ? void 0 : t.refetchType) === "none")
        return Promise.resolve();
      const n = {
        ...t,
        type: (t == null ? void 0 : t.refetchType) ?? (t == null ? void 0 : t.type) ?? "active"
      };
      return this.refetchQueries(n, i);
    });
  }
  refetchQueries(t, i = {}) {
    const n = {
      ...i,
      cancelRefetch: i.cancelRefetch ?? !0
    }, r = Nt.batch(
      () => P(this, rt).findAll(t).filter((a) => !a.isDisabled()).map((a) => {
        let o = a.fetch(void 0, n);
        return n.throwOnError || (o = o.catch(Qi)), a.state.fetchStatus === "paused" ? Promise.resolve() : o;
      })
    );
    return Promise.all(r).then(Qi);
  }
  fetchQuery(t) {
    const i = this.defaultQueryOptions(t);
    i.retry === void 0 && (i.retry = !1);
    const n = P(this, rt).build(this, i);
    return n.isStaleByTime(
      Ca(i.staleTime, n)
    ) ? n.fetch(i) : Promise.resolve(n.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(Qi).catch(Qi);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = Om(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(Qi).catch(Qi);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = Om(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return l1.isOnline() ? P(this, oa).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return P(this, rt);
  }
  getMutationCache() {
    return P(this, oa);
  }
  getDefaultOptions() {
    return P(this, la);
  }
  setDefaultOptions(t) {
    q(this, la, t);
  }
  setQueryDefaults(t, i) {
    P(this, ry).set(Rr(t), {
      queryKey: t,
      defaultOptions: i
    });
  }
  getQueryDefaults(t) {
    const i = [...P(this, ry).values()], n = {};
    return i.forEach((r) => {
      mf(t, r.queryKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  setMutationDefaults(t, i) {
    P(this, ay).set(Rr(t), {
      mutationKey: t,
      defaultOptions: i
    });
  }
  getMutationDefaults(t) {
    const i = [...P(this, ay).values()];
    let n = {};
    return i.forEach((r) => {
      mf(t, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const i = {
      ...P(this, la).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return i.queryHash || (i.queryHash = av(
      i.queryKey,
      i
    )), i.refetchOnReconnect === void 0 && (i.refetchOnReconnect = i.networkMode !== "always"), i.throwOnError === void 0 && (i.throwOnError = !!i.suspense), !i.networkMode && i.persister && (i.networkMode = "offlineFirst"), i.queryFn === Bk && (i.enabled = !1), i;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...P(this, la).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    P(this, rt).clear(), P(this, oa).clear();
  }
}, u(Ud, "Yr"), Ud), rt = /* @__PURE__ */ new WeakMap(), oa = /* @__PURE__ */ new WeakMap(), la = /* @__PURE__ */ new WeakMap(), ry = /* @__PURE__ */ new WeakMap(), ay = /* @__PURE__ */ new WeakMap(), ca = /* @__PURE__ */ new WeakMap(), oy = /* @__PURE__ */ new WeakMap(), ly = /* @__PURE__ */ new WeakMap(), p(SO, "QueryClient"), SO), Pi, Ee, Aw, fi, zl, cy, ha, os, Ew, hy, dy, _l, Ll, da, uy, at, py, PO, CO, QO, TO, MO, RO, AO, w4, EO, Nd, iR = (EO = (Nd = class extends _f {
  constructor(t, i) {
    super(), U(this, at), U(this, Pi), U(this, Ee), U(this, Aw), U(this, fi), U(this, zl), U(this, cy), U(this, ha), U(this, os), U(this, Ew), U(this, hy), U(this, dy), U(this, _l), U(this, Ll), U(this, da), U(this, uy, /* @__PURE__ */ new Set()), this.options = i, q(this, Pi, t), q(this, os, null), q(this, ha, c1()), this.options.experimental_prefetchInRender || P(this, ha).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(i);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (P(this, Ee).addObserver(this), c$(P(this, Ee), this.options) ? ye(this, at, py).call(this) : this.updateResult(), ye(this, at, TO).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return d1(
      P(this, Ee),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return d1(
      P(this, Ee),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), ye(this, at, MO).call(this), ye(this, at, RO).call(this), P(this, Ee).removeObserver(this);
  }
  setOptions(t, i) {
    const n = this.options, r = P(this, Ee);
    if (this.options = P(this, Pi).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Zi(this.options.enabled, P(this, Ee)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    ye(this, at, AO).call(this), P(this, Ee).setOptions(this.options), n._defaulted && !vm(this.options, n) && P(this, Pi).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: P(this, Ee),
      observer: this
    });
    const a = this.hasListeners();
    a && h$(
      P(this, Ee),
      r,
      this.options,
      n
    ) && ye(this, at, py).call(this), this.updateResult(i), a && (P(this, Ee) !== r || Zi(this.options.enabled, P(this, Ee)) !== Zi(n.enabled, P(this, Ee)) || Ca(this.options.staleTime, P(this, Ee)) !== Ca(n.staleTime, P(this, Ee))) && ye(this, at, PO).call(this);
    const o = ye(this, at, CO).call(this);
    a && (P(this, Ee) !== r || Zi(this.options.enabled, P(this, Ee)) !== Zi(n.enabled, P(this, Ee)) || o !== P(this, da)) && ye(this, at, QO).call(this, o);
  }
  getOptimisticResult(t) {
    const i = P(this, Pi).getQueryCache().build(P(this, Pi), t), n = this.createResult(i, t);
    return sR(this, n) && (q(this, fi, n), q(this, cy, this.options), q(this, zl, P(this, Ee).state)), n;
  }
  getCurrentResult() {
    return P(this, fi);
  }
  trackResult(t, i) {
    const n = {};
    return Object.keys(t).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: /* @__PURE__ */ p(() => (this.trackProp(r), i == null || i(r), t[r]), "get")
      });
    }), n;
  }
  trackProp(t) {
    P(this, uy).add(t);
  }
  getCurrentQuery() {
    return P(this, Ee);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const i = P(this, Pi).defaultQueryOptions(t), n = P(this, Pi).getQueryCache().build(P(this, Pi), i);
    return n.fetch().then(() => this.createResult(n, i));
  }
  fetch(t) {
    return ye(this, at, py).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), P(this, fi)));
  }
  createResult(t, i) {
    var n;
    const r = P(this, Ee), a = this.options, o = P(this, fi), l = P(this, zl), c = P(this, cy), h = t !== r ? t.state : P(this, Aw), { state: d } = t;
    let f = { ...d }, y = !1, w;
    if (i._optimisticResults) {
      const I = this.hasListeners(), D = !I && c$(t, i), j = I && h$(t, r, i, a);
      (D || j) && (f = {
        ...f,
        ...Yk(d.data, t.options)
      }), i._optimisticResults === "isRestoring" && (f.fetchStatus = "idle");
    }
    let { error: g, errorUpdatedAt: b, status: k } = f;
    if (i.select && f.data !== void 0)
      if (o && f.data === (l == null ? void 0 : l.data) && i.select === P(this, Ew))
        w = P(this, hy);
      else
        try {
          q(this, Ew, i.select), w = i.select(f.data), w = o1(o == null ? void 0 : o.data, w, i), q(this, hy, w), q(this, os, null);
        } catch (I) {
          q(this, os, I);
        }
    else
      w = f.data;
    if (i.placeholderData !== void 0 && w === void 0 && k === "pending") {
      let I;
      if (o != null && o.isPlaceholderData && i.placeholderData === (c == null ? void 0 : c.placeholderData))
        I = o.data;
      else if (I = typeof i.placeholderData == "function" ? i.placeholderData(
        (n = P(this, dy)) == null ? void 0 : n.state.data,
        P(this, dy)
      ) : i.placeholderData, i.select && I !== void 0)
        try {
          I = i.select(I), q(this, os, null);
        } catch (D) {
          q(this, os, D);
        }
      I !== void 0 && (k = "success", w = o1(
        o == null ? void 0 : o.data,
        I,
        i
      ), y = !0);
    }
    P(this, os) && (g = P(this, os), w = P(this, hy), b = Date.now(), k = "error");
    const $ = f.fetchStatus === "fetching", C = k === "pending", E = k === "error", A = C && $, R = w !== void 0, L = {
      status: k,
      fetchStatus: f.fetchStatus,
      isPending: C,
      isSuccess: k === "success",
      isError: E,
      isInitialLoading: A,
      isLoading: A,
      data: w,
      dataUpdatedAt: f.dataUpdatedAt,
      error: g,
      errorUpdatedAt: b,
      failureCount: f.fetchFailureCount,
      failureReason: f.fetchFailureReason,
      errorUpdateCount: f.errorUpdateCount,
      isFetched: f.dataUpdateCount > 0 || f.errorUpdateCount > 0,
      isFetchedAfterMount: f.dataUpdateCount > h.dataUpdateCount || f.errorUpdateCount > h.errorUpdateCount,
      isFetching: $,
      isRefetching: $ && !C,
      isLoadingError: E && !R,
      isPaused: f.fetchStatus === "paused",
      isPlaceholderData: y,
      isRefetchError: E && R,
      isStale: ov(t, i),
      refetch: this.refetch,
      promise: P(this, ha)
    };
    if (this.options.experimental_prefetchInRender) {
      const I = /* @__PURE__ */ p((ee) => {
        L.status === "error" ? ee.reject(L.error) : L.data !== void 0 && ee.resolve(L.data);
      }, "finalizeThenableIfPossible"), D = /* @__PURE__ */ p(() => {
        const ee = q(this, ha, L.promise = c1());
        I(ee);
      }, "recreateThenable"), j = P(this, ha);
      switch (j.status) {
        case "pending":
          t.queryHash === r.queryHash && I(j);
          break;
        case "fulfilled":
          (L.status === "error" || L.data !== j.value) && D();
          break;
        case "rejected":
          (L.status !== "error" || L.error !== j.reason) && D();
          break;
      }
    }
    return L;
  }
  updateResult(t) {
    const i = P(this, fi), n = this.createResult(P(this, Ee), this.options);
    if (q(this, zl, P(this, Ee).state), q(this, cy, this.options), P(this, zl).data !== void 0 && q(this, dy, P(this, Ee)), vm(n, i))
      return;
    q(this, fi, n);
    const r = {}, a = /* @__PURE__ */ p(() => {
      if (!i)
        return !0;
      const { notifyOnChangeProps: o } = this.options, l = typeof o == "function" ? o() : o;
      if (l === "all" || !l && !P(this, uy).size)
        return !0;
      const c = new Set(
        l ?? P(this, uy)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(P(this, fi)).some((h) => {
        const d = h;
        return P(this, fi)[d] !== i[d] && c.has(d);
      });
    }, "shouldNotifyListeners");
    (t == null ? void 0 : t.listeners) !== !1 && a() && (r.listeners = !0), ye(this, at, w4).call(this, { ...r, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && ye(this, at, TO).call(this);
  }
}, u(Nd, "en"), Nd), Pi = /* @__PURE__ */ new WeakMap(), Ee = /* @__PURE__ */ new WeakMap(), Aw = /* @__PURE__ */ new WeakMap(), fi = /* @__PURE__ */ new WeakMap(), zl = /* @__PURE__ */ new WeakMap(), cy = /* @__PURE__ */ new WeakMap(), ha = /* @__PURE__ */ new WeakMap(), os = /* @__PURE__ */ new WeakMap(), Ew = /* @__PURE__ */ new WeakMap(), hy = /* @__PURE__ */ new WeakMap(), dy = /* @__PURE__ */ new WeakMap(), _l = /* @__PURE__ */ new WeakMap(), Ll = /* @__PURE__ */ new WeakMap(), da = /* @__PURE__ */ new WeakMap(), uy = /* @__PURE__ */ new WeakMap(), at = /* @__PURE__ */ new WeakSet(), py = /* @__PURE__ */ p(function(s) {
  ye(this, at, AO).call(this);
  let t = P(this, Ee).fetch(
    this.options,
    s
  );
  return s != null && s.throwOnError || (t = t.catch(Qi)), t;
}, "#executeFetch"), PO = /* @__PURE__ */ p(function() {
  ye(this, at, MO).call(this);
  const s = Ca(
    this.options.staleTime,
    P(this, Ee)
  );
  if (yf || P(this, fi).isStale || !r1(s))
    return;
  const t = Nk(P(this, fi).dataUpdatedAt, s) + 1;
  q(this, _l, setTimeout(() => {
    P(this, fi).isStale || this.updateResult();
  }, t));
}, "#updateStaleTimeout"), CO = /* @__PURE__ */ p(function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(P(this, Ee)) : this.options.refetchInterval) ?? !1;
}, "#computeRefetchInterval"), QO = /* @__PURE__ */ p(function(s) {
  ye(this, at, RO).call(this), q(this, da, s), !(yf || Zi(this.options.enabled, P(this, Ee)) === !1 || !r1(P(this, da)) || P(this, da) === 0) && q(this, Ll, setInterval(() => {
    (this.options.refetchIntervalInBackground || Xk.isFocused()) && ye(this, at, py).call(this);
  }, P(this, da)));
}, "#updateRefetchInterval"), TO = /* @__PURE__ */ p(function() {
  ye(this, at, PO).call(this), ye(this, at, QO).call(this, ye(this, at, CO).call(this));
}, "#updateTimers"), MO = /* @__PURE__ */ p(function() {
  P(this, _l) && (clearTimeout(P(this, _l)), q(this, _l, void 0));
}, "#clearStaleTimeout"), RO = /* @__PURE__ */ p(function() {
  P(this, Ll) && (clearInterval(P(this, Ll)), q(this, Ll, void 0));
}, "#clearRefetchInterval"), AO = /* @__PURE__ */ p(function() {
  const s = P(this, Pi).getQueryCache().build(P(this, Pi), this.options);
  if (s === P(this, Ee))
    return;
  const t = P(this, Ee);
  q(this, Ee, s), q(this, Aw, s.state), this.hasListeners() && (t == null || t.removeObserver(this), s.addObserver(this));
}, "#updateQuery"), w4 = /* @__PURE__ */ p(function(s) {
  Nt.batch(() => {
    s.listeners && this.listeners.forEach((t) => {
      t(P(this, fi));
    }), P(this, Pi).getQueryCache().notify({
      query: P(this, Ee),
      type: "observerResultsUpdated"
    });
  });
}, "#notify"), p(EO, "QueryObserver"), EO);
function nR(s, t) {
  return Zi(t.enabled, s) !== !1 && s.state.data === void 0 && !(s.state.status === "error" && t.retryOnMount === !1);
}
u(nR, "a1");
p(nR, "shouldLoadOnMount");
function c$(s, t) {
  return nR(s, t) || s.state.data !== void 0 && d1(s, t, t.refetchOnMount);
}
u(c$, "Zp");
p(c$, "shouldFetchOnMount");
function d1(s, t, i) {
  if (Zi(t.enabled, s) !== !1) {
    const n = typeof i == "function" ? i(s) : i;
    return n === "always" || n !== !1 && ov(s, t);
  }
  return !1;
}
u(d1, "Nd");
p(d1, "shouldFetchOn");
function h$(s, t, i, n) {
  return (s !== t || Zi(n.enabled, s) === !1) && (!i.suspense || s.state.status !== "error") && ov(s, i);
}
u(h$, "Xp");
p(h$, "shouldFetchOptionally");
function ov(s, t) {
  return Zi(t.enabled, s) !== !1 && s.isStaleByTime(Ca(t.staleTime, s));
}
u(ov, "Oh");
p(ov, "isStale");
function sR(s, t) {
  return !vm(s.getCurrentResult(), t);
}
u(sR, "o1");
p(sR, "shouldAssignObserverCurrentProperties");
var zO, Bd, gq = (zO = (Bd = class extends iR {
  constructor(t, i) {
    super(t, i);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(t, i) {
    super.setOptions(
      {
        ...t,
        behavior: Om()
      },
      i
    );
  }
  getOptimisticResult(t) {
    return t.behavior = Om(), super.getOptimisticResult(t);
  }
  fetchNextPage(t) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(t) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(t, i) {
    var n, r;
    const { state: a } = t, o = super.createResult(t, i), { isFetching: l, isRefetching: c, isError: h, isRefetchError: d } = o, f = (r = (n = a.fetchMeta) == null ? void 0 : n.fetchMore) == null ? void 0 : r.direction, y = h && f === "forward", w = l && f === "forward", g = h && f === "backward", b = l && f === "backward";
    return {
      ...o,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: eR(i, a.data),
      hasPreviousPage: tR(i, a.data),
      isFetchNextPageError: y,
      isFetchingNextPage: w,
      isFetchPreviousPageError: g,
      isFetchingPreviousPage: b,
      isRefetchError: d && !y && !g,
      isRefetching: c && !w && !b
    };
  }
}, u(Bd, "sn"), Bd), p(zO, "InfiniteQueryObserver"), zO), ua, pa, Ci, Ds, fa, zw, _O, LO, jd, Ve = (LO = (jd = class extends _f {
  constructor(t, i) {
    super(), U(this, fa), U(this, ua), U(this, pa), U(this, Ci), U(this, Ds), q(this, ua, t), this.setOptions(i), this.bindMethods(), ye(this, fa, zw).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    var i;
    const n = this.options;
    this.options = P(this, ua).defaultMutationOptions(t), vm(this.options, n) || P(this, ua).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: P(this, Ci),
      observer: this
    }), n != null && n.mutationKey && this.options.mutationKey && Rr(n.mutationKey) !== Rr(this.options.mutationKey) ? this.reset() : ((i = P(this, Ci)) == null ? void 0 : i.state.status) === "pending" && P(this, Ci).setOptions(this.options);
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || (t = P(this, Ci)) == null || t.removeObserver(this);
  }
  onMutationUpdate(t) {
    ye(this, fa, zw).call(this), ye(this, fa, _O).call(this, t);
  }
  getCurrentResult() {
    return P(this, pa);
  }
  reset() {
    var t;
    (t = P(this, Ci)) == null || t.removeObserver(this), q(this, Ci, void 0), ye(this, fa, zw).call(this), ye(this, fa, _O).call(this);
  }
  mutate(t, i) {
    var n;
    return q(this, Ds, i), (n = P(this, Ci)) == null || n.removeObserver(this), q(this, Ci, P(this, ua).getMutationCache().build(P(this, ua), this.options)), P(this, Ci).addObserver(this), P(this, Ci).execute(t);
  }
}, u(jd, "rn"), jd), ua = /* @__PURE__ */ new WeakMap(), pa = /* @__PURE__ */ new WeakMap(), Ci = /* @__PURE__ */ new WeakMap(), Ds = /* @__PURE__ */ new WeakMap(), fa = /* @__PURE__ */ new WeakSet(), zw = /* @__PURE__ */ p(function() {
  var s;
  const t = ((s = P(this, Ci)) == null ? void 0 : s.state) ?? Gk();
  q(this, pa, {
    ...t,
    isPending: t.status === "pending",
    isSuccess: t.status === "success",
    isError: t.status === "error",
    isIdle: t.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, "#updateResult"), _O = /* @__PURE__ */ p(function(s) {
  Nt.batch(() => {
    var t, i, n, r, a, o, l, c;
    if (P(this, Ds) && this.hasListeners()) {
      const h = P(this, pa).variables, d = P(this, pa).context;
      (s == null ? void 0 : s.type) === "success" ? ((i = (t = P(this, Ds)).onSuccess) == null || i.call(t, s.data, h, d), (r = (n = P(this, Ds)).onSettled) == null || r.call(n, s.data, null, h, d)) : (s == null ? void 0 : s.type) === "error" && ((o = (a = P(this, Ds)).onError) == null || o.call(a, s.error, h, d), (c = (l = P(this, Ds)).onSettled) == null || c.call(
        l,
        void 0,
        s.error,
        h,
        d
      ));
    }
    this.listeners.forEach((h) => {
      h(P(this, pa));
    });
  });
}, "#notify"), p(LO, "MutationObserver"), LO);
function Jk(s) {
  return s;
}
u(Jk, "Cy");
p(Jk, "defaultTransformerFn");
function rR(s) {
  return {
    mutationKey: s.options.mutationKey,
    state: s.state,
    ...s.options.scope && { scope: s.options.scope },
    ...s.meta && { meta: s.meta }
  };
}
u(rR, "l1");
p(rR, "dehydrateMutation");
function aR(s, t) {
  var i;
  return {
    state: {
      ...s.state,
      ...s.state.data !== void 0 && {
        data: t(s.state.data)
      }
    },
    queryKey: s.queryKey,
    queryHash: s.queryHash,
    ...s.state.status === "pending" && {
      promise: (i = s.promise) == null ? void 0 : i.then(t).catch((n) => Promise.reject(new Error("redacted")))
    },
    ...s.meta && { meta: s.meta }
  };
}
u(aR, "d1");
p(aR, "dehydrateQuery");
function oR(s) {
  return s.state.isPaused;
}
u(oR, "h1");
p(oR, "defaultShouldDehydrateMutation");
function lR(s) {
  return s.state.status === "success";
}
u(lR, "p1");
p(lR, "defaultShouldDehydrateQuery");
function cR(s, t = {}) {
  var i, n, r;
  const a = t.shouldDehydrateMutation ?? ((i = s.getDefaultOptions().dehydrate) == null ? void 0 : i.shouldDehydrateMutation) ?? oR, o = s.getMutationCache().getAll().flatMap(
    (d) => a(d) ? [rR(d)] : []
  ), l = t.shouldDehydrateQuery ?? ((n = s.getDefaultOptions().dehydrate) == null ? void 0 : n.shouldDehydrateQuery) ?? lR, c = t.serializeData ?? ((r = s.getDefaultOptions().dehydrate) == null ? void 0 : r.serializeData) ?? Jk, h = s.getQueryCache().getAll().flatMap(
    (d) => l(d) ? [aR(d, c)] : []
  );
  return { mutations: o, queries: h };
}
u(cR, "u1");
p(cR, "dehydrate");
function hR(s, t, i) {
  var n, r;
  if (typeof t != "object" || t === null)
    return;
  const a = s.getMutationCache(), o = s.getQueryCache(), l = ((n = i == null ? void 0 : i.defaultOptions) == null ? void 0 : n.deserializeData) ?? ((r = s.getDefaultOptions().hydrate) == null ? void 0 : r.deserializeData) ?? Jk, c = t.mutations || [], h = t.queries || [];
  c.forEach(({ state: d, ...f }) => {
    var y, w;
    a.build(
      s,
      {
        ...(y = s.getDefaultOptions().hydrate) == null ? void 0 : y.mutations,
        ...(w = i == null ? void 0 : i.defaultOptions) == null ? void 0 : w.mutations,
        ...f
      },
      d
    );
  }), h.forEach(({ queryKey: d, state: f, queryHash: y, meta: w, promise: g }) => {
    var b, k;
    let $ = o.get(y);
    const C = f.data === void 0 ? f.data : l(f.data);
    if ($) {
      if ($.state.dataUpdatedAt < f.dataUpdatedAt) {
        const { fetchStatus: E, ...A } = f;
        $.setState({
          ...A,
          data: C
        });
      }
    } else
      $ = o.build(
        s,
        {
          ...(b = s.getDefaultOptions().hydrate) == null ? void 0 : b.queries,
          ...(k = i == null ? void 0 : i.defaultOptions) == null ? void 0 : k.queries,
          queryKey: d,
          queryHash: y,
          meta: w
        },
        // Reset fetch status to idle to avoid
        // query being stuck in fetching state upon hydration
        {
          ...f,
          data: C,
          fetchStatus: "idle"
        }
      );
    if (g) {
      const E = Promise.resolve(g).then(l);
      $.fetch(void 0, { initialPromise: E });
    }
  });
}
u(hR, "y1");
p(hR, "hydrate");
var Te = /* @__PURE__ */ ((s) => (s.Chat = "d65dd4bc-418e-403c-9f56-f9cf4da931ed", s.Comments = "88f96a08-c6c1-4eac-a0bd-5bf8fba1a3fd", s.Files = "523edd88-4bbf-4547-b60f-2859a6d2ddc1", s.Posts = "5ebfa152-de85-48da-82dd-30a1b560c313", s.ChatRoom = "edb400ac-839b-45a7-b2a8-6a01820d1c44", s.PrivateChat = "7e14f418-8f15-46f4-b182-f619b671e470", s.BotChat = "2352a1c6-abc6-420e-8b85-ca7d5aed8779", s))(Te || {}), vi = /* @__PURE__ */ ((s) => (s.Chat = "chat", s.Comments = "comments", s.Files = "files", s.Posts = "posts", s.ChatRoom = "chat_room", s.PrivateChat = "private_chat", s.BotChat = "bot_chat", s))(vi || {}), dR = /* @__PURE__ */ ((s) => (s["d65dd4bc-418e-403c-9f56-f9cf4da931ed"] = "chat", s["88f96a08-c6c1-4eac-a0bd-5bf8fba1a3fd"] = "comments", s["523edd88-4bbf-4547-b60f-2859a6d2ddc1"] = "files", s["5ebfa152-de85-48da-82dd-30a1b560c313"] = "posts", s["edb400ac-839b-45a7-b2a8-6a01820d1c44"] = "chat_room", s["7e14f418-8f15-46f4-b182-f619b671e470"] = "private_chat", s["2352a1c6-abc6-420e-8b85-ca7d5aed8779"] = "bot_chat", s))(dR || {}), uR = /* @__PURE__ */ ((s) => (s.chat = "d65dd4bc-418e-403c-9f56-f9cf4da931ed", s.comments = "88f96a08-c6c1-4eac-a0bd-5bf8fba1a3fd", s.files = "523edd88-4bbf-4547-b60f-2859a6d2ddc1", s.posts = "5ebfa152-de85-48da-82dd-30a1b560c313", s.chat_room = "edb400ac-839b-45a7-b2a8-6a01820d1c44", s.private_chat = "7e14f418-8f15-46f4-b182-f619b671e470", s.bot_chat = "2352a1c6-abc6-420e-8b85-ca7d5aed8779", s))(uR || {}), pR = /* @__PURE__ */ ((s) => (s["2352a1c6-abc6-420e-8b85-ca7d5aed8779"] = "bot_chat", s))(pR || {}), fR = /* @__PURE__ */ ((s) => (s.bot_chat = "2352a1c6-abc6-420e-8b85-ca7d5aed8779", s))(fR || {}), Ni = /* @__PURE__ */ ((s) => (s.Unknown = "unknown", s))(Ni || {}), Fs = /* @__PURE__ */ ((s) => (s.None = "none", s.Read = "read", s.Write = "write", s.Admin = "admin", s))(Fs || {}), Ar = /* @__PURE__ */ ((s) => (s.List = "list", s.Read = "read", s.Create = "create", s.Update = "update", s.Delete = "delete", s.Admin = "admin", s))(Ar || {}), Bi = /* @__PURE__ */ ((s) => (s.App = "app", s.File = "file", s.Message = "message", s.User = "user", s.Comment = "comment", s.Post = "post", s))(Bi || {});
function ln(s, t, i, n, r, a = "GET") {
  return {
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: t,
    queryFn: /* @__PURE__ */ p(async () => {
      const o = await s.fetch(i || "/api/" + t.join("/"), { method: a, body: r });
      if (o.ok)
        return await o.json();
      throw new Error(`Error calling ${i || "/api/" + t.join("/")}`);
    }, "queryFn"),
    ...n
  };
}
u(ln, "yi");
p(ln, "getApiOptions");
async function u1(s, t, i, n, r, a = "GET", o = !1) {
  const l = s.queryClient, c = ln(s, t, i, n, r, a);
  return o ? (c.staleTime = 1, await l.fetchQuery(c)) : await l.ensureQueryData(c);
}
u(u1, "Wd");
p(u1, "getApi");
function yR(s, t, i = Ni.Unknown, n) {
  return i === Ni.Unknown ? ln(s, ["apps", t]) : ln(s, ["apps", t], void 0, void 0, JSON.stringify({ type: i, ...n }), "PUT");
}
u(yR, "w1");
p(yR, "getAppOptions");
function mR(s, t, i = Ni.Unknown, n) {
  return i === Ni.Unknown ? u1(s, ["apps", t]) : u1(s, ["apps", t], void 0, void 0, JSON.stringify({ type: i, ...n }), "PUT");
}
u(mR, "f1");
p(mR, "getApp");
function e5(s, t) {
  const i = s.queryClient, n = ["apps", t.uid];
  return {
    mutationFn: /* @__PURE__ */ p(async ({ subscribe: r }) => {
      if (t.id >= 1) {
        const a = await s.fetch(`/api/apps/${t.id}/${r ? "subscribe" : "unsubscribe"}`, {
          method: "POST"
        });
        if (!a.ok)
          throw await a.json();
      } else
        throw new Error(`Could not subscribe to app ${t.uid}.`);
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => {
      let a;
      return i.setQueryData(n, (o) => (a = o.is_subscribed, { ...o, is_subscribed: r.subscribe })), {
        previousSubscribe: a,
        subscribe: r.subscribe
      };
    }, "onMutate"),
    onError(r, a, o) {
      o && o.previousSubscribe !== void 0 && i.setQueryData(n, (l) => ({ ...l, is_subscribed: o == null ? void 0 : o.previousSubscribe }));
    }
  };
}
u(e5, "Sy");
p(e5, "getAppSubscribeMutationOptions");
function wR(s, t = [Te.ChatRoom, Te.PrivateChat], i, n = {}) {
  const r = new URLSearchParams({
    count_only: "true",
    unread: "true"
  });
  i && r.append("member", i), t == null || t.forEach((o) => r.append("type", o));
  const a = `/api/apps?${r.toString()}`;
  return ln(s, ["apps", "badge", t], a, n);
}
u(wR, "m1");
p(wR, "getBadgeOptions$1");
function gR(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ members: t, type: i }) => await (await s.fetch("/api/apps", {
      method: "POST",
      body: JSON.stringify({
        members: t,
        type: i
      })
    })).json(), "mutationFn"),
    onSettled: /* @__PURE__ */ p(async () => {
      await s.queryClient.invalidateQueries({ queryKey: ["apps"] });
    }, "onSettled")
  };
}
u(gR, "v1");
p(gR, "getAddAppMutationOptions");
function vR(s) {
  return new Ve(s.queryClient, gR(s));
}
u(vR, "g1");
p(vR, "getAddAppMutation");
function OR(s, t = {}, i, n, r, a) {
  return {
    ...t,
    initialPageParam: 0,
    queryKey: ["apps", "list", i, n, a],
    queryFn: /* @__PURE__ */ p(async (o) => {
      var l;
      const c = new URLSearchParams();
      n && c.append("member", n), o.pageParam && c.append("skip", (l = o.pageParam) == null ? void 0 : l.toString()), i == null || i.forEach((y) => c.append("type", y)), c.append("order_by", a);
      const h = r == null ? void 0 : r();
      h && c.append("q", h);
      const d = `/api/apps?${c.toString()}`, f = await (await s.fetch(d)).json();
      return f.data = f.data || [], f;
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((o) => {
      if (o.end && (o == null ? void 0 : o.end) < (o == null ? void 0 : o.count))
        return o.end;
    }, "getNextPageParam")
  };
}
u(OR, "b1");
p(OR, "getAppListOptions");
const vq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r);
      const a = this;
      this.api = {
        apps: {
          async getApp(o) {
            return await mR(a, o);
          }
        }
      };
    }
  }, u(i, "t"), i), p(t, "WeavyApi"), t;
}, "WeavyApiMixin"), Oq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // AUTHENTICATION
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), this._whenTokenFactory = new Promise((a) => {
        this._resolveTokenFactory = a;
      }), this._whenUrlAndTokenFactory = new Promise((a) => {
        this._resolveUrlAndTokenFactory = a;
      }), this._whenTokenIsValid = new Promise((a) => {
        this._resolveTokenIsValid = a;
      }), this._tokenPromise = null, this._token = "", this._validTokenFromFactory = async (a = !1) => {
        var o, l;
        const c = [this.whenTokenFactory()];
        this.tokenFactoryRetryDelay !== 1 / 0 && c.push(new Promise((d) => setTimeout(d, this.tokenFactoryRetryDelay))), await Promise.race(c);
        const h = await ((o = this.tokenFactory) == null ? void 0 : o.call(this, a)) ?? "";
        if (this._validateToken(h)) {
          if (a && h === this._token && this.tokenFactoryRetryDelay !== 1 / 0)
            return await new Promise((d) => setTimeout(d, this.tokenFactoryRetryDelay)), await this._validTokenFromFactory(!0);
        } else if (this._whenTokenFactory = new Promise((d) => {
          this._resolveTokenFactory = d;
        }), !a)
          return await this._validTokenFromFactory(!1);
        if (!h)
          throw new TypeError("Could not get a valid token from tokenFactory.");
        return (l = this._resolveTokenFactory) == null || l.call(this, !0), this.whenUrl().then(this._resolveUrlAndTokenFactory), h;
      }, Promise.all([this.whenUrl(), this.whenTokenFactory()]).then(() => {
        var a;
        this.url && this.tokenFactory && ((a = this._resolveUrlAndTokenFactory) == null || a.call(this, !0));
      });
    }
    async whenTokenFactory() {
      await this._whenTokenFactory;
    }
    async whenUrlAndTokenFactory() {
      await this._whenUrlAndTokenFactory;
    }
    async whenTokenIsValid() {
      await this._whenTokenIsValid;
    }
    /**
     * Async function returning an `access_token` string for _your_ authenticated user. A boolean `refresh` parameter is provided to let you now if a fresh token is needed from Weavy.
     */
    get tokenFactory() {
      return this._tokenFactory;
    }
    set tokenFactory(r) {
      if (this.isDestroyed)
        throw new mt();
      this._tokenFactory && this._tokenFactory !== r && this.whenTokenFactory().then(() => {
        this.queryClient.refetchQueries({ stale: !0 });
      }), this._tokenFactory = r ?? void 0, this._tokenFactory && queueMicrotask(() => {
        var a;
        (a = this._resolveTokenFactory) == null || a.call(this, !0);
      });
    }
    /**
     * An URL to an endpoint returning an JSON data containing an `access_token` string property for _your_ authenticated user. A boolean `refresh=true` query parameter is provided in the request to let you now if when a fresh token is needed from Weavy.
     */
    get tokenUrl() {
      return this._tokenUrl;
    }
    set tokenUrl(r) {
      if (this.isDestroyed)
        throw new mt();
      try {
        if (typeof r == "string")
          r && (this._tokenUrl = new URL(r, window.location.toString()));
        else if (r instanceof URL)
          this._tokenUrl = r;
        else if (r == null)
          this._tokenUrl = void 0;
        else
          throw -1;
      } catch (a) {
        throw new Error("Invalid url", a);
      }
      this._tokenUrl && !this.tokenFactory && (this.tokenFactory = async (a) => {
        if (!this.tokenUrl)
          throw new Error("tokenURL property is not valid");
        const o = new URL(this.tokenUrl);
        a ? o.searchParams.set("refresh", "true") : o.searchParams.delete("refresh");
        const l = await fetch(o);
        if (l.ok) {
          const c = await l.json();
          if (c.access_token === void 0)
            throw new Error("Token response does not contain required property: access_token");
          return c.access_token;
        } else
          throw new Error("Could not get access token from server!");
      });
    }
    _validateToken(r) {
      var a;
      if (!r)
        return !1;
      if (typeof r != "string")
        throw new TypeError(`You have provided an invalid string access token of type ${typeof r}.`);
      if (typeof r == "string" && !r.startsWith("wyu_"))
        throw r.startsWith("wys_") ? new TypeError("You have provided an API key for authentication. Provide a user access token instead.") : new TypeError("You have provided an invalid string as access token.");
      return (a = this._resolveTokenIsValid) == null || a.call(this, r), !0;
    }
    async getToken(r = !1) {
      if (this.isDestroyed)
        throw new mt();
      if (this._token && !r)
        return this._token;
      if (this._tokenPromise)
        return await this._tokenPromise;
      this._tokenPromise = new Promise((a, o) => {
        this._validTokenFromFactory(r).then(a).catch(o), this.tokenFactoryTimeout !== 1 / 0 && setTimeout(() => o(new Error("Token factory timeout.")), this.tokenFactoryTimeout), window.addEventListener("offline", () => o(new Error("Network changed.")), { once: !0 }), window.addEventListener("online", () => o(new Error("Network changed.")), { once: !0 });
      });
      try {
        const a = await this._tokenPromise;
        return this._tokenPromise = null, this._token = a, this._token;
      } catch (a) {
        throw this._tokenPromise = null, a;
      }
    }
  }, u(i, "t"), i), p(t, "WeavyAuthentication"), t;
}, "WeavyAuthenticationMixin");
var _w = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bR(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
u(bR, "k1");
p(bR, "getDefaultExportFromCjs");
function rg(s) {
  throw new Error('Could not dynamically require "' + s + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
u(rg, "$d");
p(rg, "commonjsRequire");
var $R = { exports: {} };
(function(s, t) {
  var i;
  i = /* @__PURE__ */ p(() => (() => {
    var Yo, Go, Ko, Jo, el, tl, il, nl, sl, rl, al, ol, ts, ll, cl, hl, dl, ul, is, pl, fl, yl, ml, ta, wl, gl, vl, Ol, bl, $l, xl, kl, ia, Sl, Pl, Cl;
    var n = { d: /* @__PURE__ */ p((N, v) => {
      for (var S in v) n.o(v, S) && !n.o(N, S) && Object.defineProperty(N, S, { enumerable: !0, get: v[S] });
    }, "d") };
    n.g = function() {
      if (typeof globalThis == "object") return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object") return window;
      }
    }(), n.o = (N, v) => Object.prototype.hasOwnProperty.call(N, v), n.r = (N) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(N, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(N, "t", { value: !0 });
    };
    var r, a = {};
    n.r(a), n.d(a, { AbortError: /* @__PURE__ */ p(() => f, "AbortError"), DefaultHttpClient: /* @__PURE__ */ p(() => fS, "DefaultHttpClient"), HttpClient: /* @__PURE__ */ p(() => j, "HttpClient"), HttpError: /* @__PURE__ */ p(() => l, "HttpError"), HttpResponse: /* @__PURE__ */ p(() => I, "HttpResponse"), HttpTransportType: /* @__PURE__ */ p(() => yt, "HttpTransportType"), HubConnection: /* @__PURE__ */ p(() => $S, "HubConnection"), HubConnectionBuilder: /* @__PURE__ */ p(() => OL, "HubConnectionBuilder"), HubConnectionState: /* @__PURE__ */ p(() => Be, "HubConnectionState"), JsonHubProtocol: /* @__PURE__ */ p(() => LS, "JsonHubProtocol"), LogLevel: /* @__PURE__ */ p(() => r, "LogLevel"), MessageType: /* @__PURE__ */ p(() => xe, "MessageType"), NullLogger: /* @__PURE__ */ p(() => se, "NullLogger"), Subject: /* @__PURE__ */ p(() => gS, "Subject"), TimeoutError: /* @__PURE__ */ p(() => h, "TimeoutError"), TransferFormat: /* @__PURE__ */ p(() => Zt, "TransferFormat"), VERSION: /* @__PURE__ */ p(() => oe, "VERSION") });
    const o = (Yo = class extends Error {
      constructor(v, S) {
        const z = new.target.prototype;
        super(`${v}: Status code '${S}'`), this.statusCode = S, this.__proto__ = z;
      }
    }, u(Yo, "Ul"), Yo);
    p(o, "i");
    let l = o;
    const c = (Go = class extends Error {
      constructor(v = "A timeout occurred.") {
        const S = new.target.prototype;
        super(v), this.__proto__ = S;
      }
    }, u(Go, "ql"), Go);
    p(c, "n");
    let h = c;
    const d = (Ko = class extends Error {
      constructor(v = "An abort occurred.") {
        const S = new.target.prototype;
        super(v), this.__proto__ = S;
      }
    }, u(Ko, "Nl"), Ko);
    p(d, "r");
    let f = d;
    const y = (Jo = class extends Error {
      constructor(v, S) {
        const z = new.target.prototype;
        super(v), this.transport = S, this.errorType = "UnsupportedTransportError", this.__proto__ = z;
      }
    }, u(Jo, "jl"), Jo);
    p(y, "o");
    let w = y;
    const g = (el = class extends Error {
      constructor(v, S) {
        const z = new.target.prototype;
        super(v), this.transport = S, this.errorType = "DisabledTransportError", this.__proto__ = z;
      }
    }, u(el, "Wl"), el);
    p(g, "h");
    let b = g;
    const k = (tl = class extends Error {
      constructor(v, S) {
        const z = new.target.prototype;
        super(v), this.transport = S, this.errorType = "FailedToStartTransportError", this.__proto__ = z;
      }
    }, u(tl, "Ql"), tl);
    p(k, "c");
    let $ = k;
    const C = (il = class extends Error {
      constructor(v) {
        const S = new.target.prototype;
        super(v), this.errorType = "FailedToNegotiateWithServerError", this.__proto__ = S;
      }
    }, u(il, "Kl"), il);
    p(C, "a");
    let E = C;
    const A = (nl = class extends Error {
      constructor(v, S) {
        const z = new.target.prototype;
        super(v), this.innerErrors = S, this.__proto__ = z;
      }
    }, u(nl, "Gl"), nl);
    p(A, "l");
    let R = A;
    const L = (sl = class {
      constructor(v, S, z) {
        this.statusCode = v, this.statusText = S, this.content = z;
      }
    }, u(sl, "Yl"), sl);
    p(L, "u");
    let I = L;
    const D = (rl = class {
      get(v, S) {
        return this.send({ ...S, method: "GET", url: v });
      }
      post(v, S) {
        return this.send({ ...S, method: "POST", url: v });
      }
      delete(v, S) {
        return this.send({ ...S, method: "DELETE", url: v });
      }
      getCookieString(v) {
        return "";
      }
    }, u(rl, "Zl"), rl);
    p(D, "d");
    let j = D;
    (function(N) {
      N[N.Trace = 0] = "Trace", N[N.Debug = 1] = "Debug", N[N.Information = 2] = "Information", N[N.Warning = 3] = "Warning", N[N.Error = 4] = "Error", N[N.Critical = 5] = "Critical", N[N.None = 6] = "None";
    })(r || (r = {}));
    const ee = (al = class {
      constructor() {
      }
      log(v, S) {
      }
    }, u(al, "Xl"), al);
    p(ee, "f");
    let se = ee;
    se.instance = new se();
    const oe = "8.0.7", we = (ol = class {
      static isRequired(v, S) {
        if (v == null) throw new Error(`The '${S}' argument is required.`);
      }
      static isNotEmpty(v, S) {
        if (!v || v.match(/^\s*$/)) throw new Error(`The '${S}' argument should not be empty.`);
      }
      static isIn(v, S, z) {
        if (!(v in S)) throw new Error(`Unknown ${z} value: ${v}.`);
      }
    }, u(ol, "Jl"), ol);
    p(we, "w");
    let re = we;
    const _e = (ts = class {
      static get isBrowser() {
        return !ts.isNode && typeof window == "object" && typeof window.document == "object";
      }
      static get isWebWorker() {
        return !ts.isNode && typeof self == "object" && "importScripts" in self;
      }
      static get isReactNative() {
        return !ts.isNode && typeof window == "object" && window.document === void 0;
      }
      static get isNode() {
        return typeof process < "u" && process.release && process.release.name === "node";
      }
    }, u(ts, "hr"), ts);
    p(_e, "g");
    let Pe = _e;
    function He(N, v) {
      let S = "";
      return We(N) ? (S = `Binary data of length ${N.byteLength}`, v && (S += `. Content: '${function(z) {
        const _ = new Uint8Array(z);
        let W = "";
        return _.forEach((Z) => {
          W += `0x${Z < 16 ? "0" : ""}${Z.toString(16)} `;
        }), W.substr(0, W.length - 1);
      }(N)}'`)) : typeof N == "string" && (S = `String data of length ${N.length}`, v && (S += `. Content: '${N}'`)), S;
    }
    u(He, "U"), p(He, "m");
    function We(N) {
      return N && typeof ArrayBuffer < "u" && (N instanceof ArrayBuffer || N.constructor && N.constructor.name === "ArrayBuffer");
    }
    u(We, "O"), p(We, "y");
    async function ft(N, v, S, z, _, W) {
      const Z = {}, [le, ce] = Gt();
      Z[le] = ce, N.log(r.Trace, `(${v} transport) sending data. ${He(_, W.logMessageContent)}.`);
      const Qe = We(_) ? "arraybuffer" : "text", Ue = await S.post(z, { content: _, headers: { ...Z, ...W.headers }, responseType: Qe, timeout: W.timeout, withCredentials: W.withCredentials });
      N.log(r.Trace, `(${v} transport) request complete. Response status: ${Ue.statusCode}.`);
    }
    u(ft, "V"), p(ft, "b");
    const Ct = (ll = class {
      constructor(v, S) {
        this.i = v, this.h = S;
      }
      dispose() {
        const v = this.i.observers.indexOf(this.h);
        v > -1 && this.i.observers.splice(v, 1), this.i.observers.length === 0 && this.i.cancelCallback && this.i.cancelCallback().catch((S) => {
        });
      }
    }, u(ll, "td"), ll);
    p(Ct, "v");
    let xt = Ct;
    const Yt = (cl = class {
      constructor(v) {
        this.l = v, this.out = console;
      }
      log(v, S) {
        if (v >= this.l) {
          const z = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${r[v]}: ${S}`;
          switch (v) {
            case r.Critical:
            case r.Error:
              this.out.error(z);
              break;
            case r.Warning:
              this.out.warn(z);
              break;
            case r.Information:
              this.out.info(z);
              break;
            default:
              this.out.log(z);
          }
        }
      }
    }, u(cl, "ed"), cl);
    p(Yt, "E");
    let ni = Yt;
    function Gt() {
      let N = "X-SignalR-User-Agent";
      return Pe.isNode && (N = "User-Agent"), [N, Jn(oe, Is(), Pe.isNode ? "NodeJS" : "Browser", mw())];
    }
    u(Gt, "H"), p(Gt, "$");
    function Jn(N, v, S, z) {
      let _ = "Microsoft SignalR/";
      const W = N.split(".");
      return _ += `${W[0]}.${W[1]}`, _ += ` (${N}; `, _ += v && v !== "" ? `${v}; ` : "Unknown OS; ", _ += `${S}`, _ += z ? `; ${z}` : "; Unknown Runtime Version", _ += ")", _;
    }
    u(Jn, "W"), p(Jn, "C");
    function Is() {
      if (!Pe.isNode) return "";
      switch (process.platform) {
        case "win32":
          return "Windows NT";
        case "darwin":
          return "macOS";
        case "linux":
          return "Linux";
        default:
          return process.platform;
      }
    }
    u(Is, "ft"), p(Is, "S");
    function mw() {
      if (Pe.isNode) return process.versions.node;
    }
    u(mw, "wt"), p(mw, "k");
    function Ho(N) {
      return N.stack ? N.stack : N.message ? N.message : `${N}`;
    }
    u(Ho, "ut"), p(Ho, "P");
    const dS = (hl = class extends j {
      constructor(v) {
        if (super(), this.u = v, typeof fetch > "u" || Pe.isNode) {
          const S = rg;
          this.p = new (S("tough-cookie")).CookieJar(), typeof fetch > "u" ? this.m = S("node-fetch") : this.m = fetch, this.m = S("fetch-cookie")(this.m, this.p);
        } else this.m = fetch.bind(function() {
          if (typeof globalThis < "u") return globalThis;
          if (typeof self < "u") return self;
          if (typeof window < "u") return window;
          if (n.g !== void 0) return n.g;
          throw new Error("could not find global");
        }());
        if (typeof AbortController > "u") {
          const S = rg;
          this.v = S("abort-controller");
        } else this.v = AbortController;
      }
      async send(v) {
        if (v.abortSignal && v.abortSignal.aborted) throw new f();
        if (!v.method) throw new Error("No method defined.");
        if (!v.url) throw new Error("No url defined.");
        const S = new this.v();
        let z;
        v.abortSignal && (v.abortSignal.onabort = () => {
          S.abort(), z = new f();
        });
        let _, W = null;
        if (v.timeout) {
          const ce = v.timeout;
          W = setTimeout(() => {
            S.abort(), this.u.log(r.Warning, "Timeout from HTTP request."), z = new h();
          }, ce);
        }
        v.content === "" && (v.content = void 0), v.content && (v.headers = v.headers || {}, We(v.content) ? v.headers["Content-Type"] = "application/octet-stream" : v.headers["Content-Type"] = "text/plain;charset=UTF-8");
        try {
          _ = await this.m(v.url, { body: v.content, cache: "no-cache", credentials: v.withCredentials === !0 ? "include" : "same-origin", headers: { "X-Requested-With": "XMLHttpRequest", ...v.headers }, method: v.method, mode: "cors", redirect: "follow", signal: S.signal });
        } catch (ce) {
          throw z || (this.u.log(r.Warning, `Error from HTTP request. ${ce}.`), ce);
        } finally {
          W && clearTimeout(W), v.abortSignal && (v.abortSignal.onabort = null);
        }
        if (!_.ok) {
          const ce = await Av(_, "text");
          throw new l(ce || _.statusText, _.status);
        }
        const Z = Av(_, v.responseType), le = await Z;
        return new I(_.status, _.statusText, le);
      }
      getCookieString(v) {
        let S = "";
        return Pe.isNode && this.p && this.p.getCookies(v, (z, _) => S = _.join("; ")), S;
      }
    }, u(hl, "id"), hl);
    p(dS, "T");
    let oL = dS;
    function Av(N, v) {
      let S;
      switch (v) {
        case "arraybuffer":
          S = N.arrayBuffer();
          break;
        case "text":
        default:
          S = N.text();
          break;
        case "blob":
        case "document":
        case "json":
          throw new Error(`${v} is not supported.`);
      }
      return S;
    }
    u(Av, "he"), p(Av, "I");
    const uS = (dl = class extends j {
      constructor(v) {
        super(), this.u = v;
      }
      send(v) {
        return v.abortSignal && v.abortSignal.aborted ? Promise.reject(new f()) : v.method ? v.url ? new Promise((S, z) => {
          const _ = new XMLHttpRequest();
          _.open(v.method, v.url, !0), _.withCredentials = v.withCredentials === void 0 || v.withCredentials, _.setRequestHeader("X-Requested-With", "XMLHttpRequest"), v.content === "" && (v.content = void 0), v.content && (We(v.content) ? _.setRequestHeader("Content-Type", "application/octet-stream") : _.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"));
          const W = v.headers;
          W && Object.keys(W).forEach((Z) => {
            _.setRequestHeader(Z, W[Z]);
          }), v.responseType && (_.responseType = v.responseType), v.abortSignal && (v.abortSignal.onabort = () => {
            _.abort(), z(new f());
          }), v.timeout && (_.timeout = v.timeout), _.onload = () => {
            v.abortSignal && (v.abortSignal.onabort = null), _.status >= 200 && _.status < 300 ? S(new I(_.status, _.statusText, _.response || _.responseText)) : z(new l(_.response || _.responseText || _.statusText, _.status));
          }, _.onerror = () => {
            this.u.log(r.Warning, `Error from HTTP request. ${_.status}: ${_.statusText}.`), z(new l(_.statusText, _.status));
          }, _.ontimeout = () => {
            this.u.log(r.Warning, "Timeout from HTTP request."), z(new h());
          }, _.send(v.content);
        }) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
      }
    }, u(dl, "sd"), dl);
    p(uS, "_");
    let lL = uS;
    const pS = (ul = class extends j {
      constructor(v) {
        if (super(), typeof fetch < "u" || Pe.isNode) this.$ = new oL(v);
        else {
          if (typeof XMLHttpRequest > "u") throw new Error("No usable HttpClient found.");
          this.$ = new lL(v);
        }
      }
      send(v) {
        return v.abortSignal && v.abortSignal.aborted ? Promise.reject(new f()) : v.method ? v.url ? this.$.send(v) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
      }
      getCookieString(v) {
        return this.$.getCookieString(v);
      }
    }, u(ul, "rd"), ul);
    p(pS, "H");
    let fS = pS;
    const yS = (is = class {
      static write(v) {
        return `${v}${is.RecordSeparator}`;
      }
      static parse(v) {
        if (v[v.length - 1] !== is.RecordSeparator) throw new Error("Message is incomplete.");
        const S = v.split(is.RecordSeparator);
        return S.pop(), S;
      }
    }, u(is, "pr"), is);
    p(yS, "D");
    let es = yS;
    es.RecordSeparatorCode = 30, es.RecordSeparator = String.fromCharCode(es.RecordSeparatorCode);
    const mS = (pl = class {
      writeHandshakeRequest(v) {
        return es.write(JSON.stringify(v));
      }
      parseHandshakeResponse(v) {
        let S, z;
        if (We(v)) {
          const Z = new Uint8Array(v), le = Z.indexOf(es.RecordSeparatorCode);
          if (le === -1) throw new Error("Message is incomplete.");
          const ce = le + 1;
          S = String.fromCharCode.apply(null, Array.prototype.slice.call(Z.slice(0, ce))), z = Z.byteLength > ce ? Z.slice(ce).buffer : null;
        } else {
          const Z = v, le = Z.indexOf(es.RecordSeparator);
          if (le === -1) throw new Error("Message is incomplete.");
          const ce = le + 1;
          S = Z.substring(0, ce), z = Z.length > ce ? Z.substring(ce) : null;
        }
        const _ = es.parse(S), W = JSON.parse(_[0]);
        if (W.type) throw new Error("Expected a handshake response from the server.");
        return [z, W];
      }
    }, u(pl, "nd"), pl);
    p(mS, "R");
    let cL = mS;
    var xe, Be;
    (function(N) {
      N[N.Invocation = 1] = "Invocation", N[N.StreamItem = 2] = "StreamItem", N[N.Completion = 3] = "Completion", N[N.StreamInvocation = 4] = "StreamInvocation", N[N.CancelInvocation = 5] = "CancelInvocation", N[N.Ping = 6] = "Ping", N[N.Close = 7] = "Close", N[N.Ack = 8] = "Ack", N[N.Sequence = 9] = "Sequence";
    })(xe || (xe = {}));
    const wS = (fl = class {
      constructor() {
        this.observers = [];
      }
      next(v) {
        for (const S of this.observers) S.next(v);
      }
      error(v) {
        for (const S of this.observers) S.error && S.error(v);
      }
      complete() {
        for (const v of this.observers) v.complete && v.complete();
      }
      subscribe(v) {
        return this.observers.push(v), new xt(this, v);
      }
    }, u(fl, "ad"), fl);
    p(wS, "U");
    let gS = wS;
    const vS = (yl = class {
      constructor(v, S, z) {
        this.C = 1e5, this.S = [], this.k = 0, this.P = !1, this.T = 1, this.I = 0, this._ = 0, this.H = !1, this.D = v, this.R = S, this.C = z;
      }
      async A(v) {
        const S = this.D.writeMessage(v);
        let z = Promise.resolve();
        if (this.U(v)) {
          this.k++;
          let _ = /* @__PURE__ */ p(() => {
          }, "t"), W = /* @__PURE__ */ p(() => {
          }, "i");
          We(S) ? this._ += S.byteLength : this._ += S.length, this._ >= this.C && (z = new Promise((Z, le) => {
            _ = Z, W = le;
          })), this.S.push(new dL(S, this.k, _, W));
        }
        try {
          this.H || await this.R.send(S);
        } catch {
          this.L();
        }
        await z;
      }
      N(v) {
        let S = -1;
        for (let z = 0; z < this.S.length; z++) {
          const _ = this.S[z];
          if (_.q <= v.sequenceId) S = z, We(_.M) ? this._ -= _.M.byteLength : this._ -= _.M.length, _.j();
          else {
            if (!(this._ < this.C)) break;
            _.j();
          }
        }
        S !== -1 && (this.S = this.S.slice(S + 1));
      }
      W(v) {
        if (this.P) return v.type === xe.Sequence && (this.P = !1, !0);
        if (!this.U(v)) return !0;
        const S = this.T;
        return this.T++, S <= this.I ? (S === this.I && this.O(), !1) : (this.I = S, this.O(), !0);
      }
      F(v) {
        v.sequenceId > this.T ? this.R.stop(new Error("Sequence ID greater than amount of messages we've received.")) : this.T = v.sequenceId;
      }
      L() {
        this.H = !0, this.P = !0;
      }
      async B() {
        const v = this.S.length !== 0 ? this.S[0].q : this.k + 1;
        await this.R.send(this.D.writeMessage({ type: xe.Sequence, sequenceId: v }));
        const S = this.S;
        for (const z of S) await this.R.send(z.M);
        this.H = !1;
      }
      X(v) {
        v != null || (v = new Error("Unable to reconnect to server."));
        for (const S of this.S) S.J(v);
      }
      U(v) {
        switch (v.type) {
          case xe.Invocation:
          case xe.StreamItem:
          case xe.Completion:
          case xe.StreamInvocation:
          case xe.CancelInvocation:
            return !0;
          case xe.Close:
          case xe.Sequence:
          case xe.Ping:
          case xe.Ack:
            return !1;
        }
      }
      O() {
        this.V === void 0 && (this.V = setTimeout(async () => {
          try {
            this.H || await this.R.send(this.D.writeMessage({ type: xe.Ack, sequenceId: this.I }));
          } catch {
          }
          clearTimeout(this.V), this.V = void 0;
        }, 1e3));
      }
    }, u(yl, "od"), yl);
    p(vS, "L");
    let hL = vS;
    const OS = (ml = class {
      constructor(v, S, z, _) {
        this.M = v, this.q = S, this.j = z, this.J = _;
      }
    }, u(ml, "cd"), ml);
    p(OS, "N");
    let dL = OS;
    (function(N) {
      N.Disconnected = "Disconnected", N.Connecting = "Connecting", N.Connected = "Connected", N.Disconnecting = "Disconnecting", N.Reconnecting = "Reconnecting";
    })(Be || (Be = {}));
    const bS = (ta = class {
      static create(v, S, z, _, W, Z, le) {
        return new ta(v, S, z, _, W, Z, le);
      }
      constructor(v, S, z, _, W, Z, le) {
        this.K = 0, this.G = () => {
          this.u.log(r.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        }, re.isRequired(v, "connection"), re.isRequired(S, "logger"), re.isRequired(z, "protocol"), this.serverTimeoutInMilliseconds = W ?? 3e4, this.keepAliveIntervalInMilliseconds = Z ?? 15e3, this.Y = le ?? 1e5, this.u = S, this.D = z, this.connection = v, this.Z = _, this.tt = new cL(), this.connection.onreceive = (ce) => this.et(ce), this.connection.onclose = (ce) => this.st(ce), this.it = {}, this.nt = {}, this.rt = [], this.ot = [], this.ht = [], this.ct = 0, this.lt = !1, this.ut = Be.Disconnected, this.dt = !1, this.ft = this.D.writeMessage({ type: xe.Ping });
      }
      get state() {
        return this.ut;
      }
      get connectionId() {
        return this.connection && this.connection.connectionId || null;
      }
      get baseUrl() {
        return this.connection.baseUrl || "";
      }
      set baseUrl(v) {
        if (this.ut !== Be.Disconnected && this.ut !== Be.Reconnecting) throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        if (!v) throw new Error("The HubConnection url must be a valid url.");
        this.connection.baseUrl = v;
      }
      start() {
        return this.wt = this.gt(), this.wt;
      }
      async gt() {
        if (this.ut !== Be.Disconnected) return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        this.ut = Be.Connecting, this.u.log(r.Debug, "Starting HubConnection.");
        try {
          await this.yt(), Pe.isBrowser && window.document.addEventListener("freeze", this.G), this.ut = Be.Connected, this.dt = !0, this.u.log(r.Debug, "HubConnection connected successfully.");
        } catch (v) {
          return this.ut = Be.Disconnected, this.u.log(r.Debug, `HubConnection failed to start successfully because of error '${v}'.`), Promise.reject(v);
        }
      }
      async yt() {
        this.bt = void 0, this.lt = !1;
        const v = new Promise((S, z) => {
          this.vt = S, this.Et = z;
        });
        await this.connection.start(this.D.transferFormat);
        try {
          let S = this.D.version;
          this.connection.features.reconnect || (S = 1);
          const z = { protocol: this.D.name, version: S };
          if (this.u.log(r.Debug, "Sending handshake request."), await this.$t(this.tt.writeHandshakeRequest(z)), this.u.log(r.Information, `Using HubProtocol '${this.D.name}'.`), this.Ct(), this.St(), this.kt(), await v, this.bt) throw this.bt;
          this.connection.features.reconnect && (this.Pt = new hL(this.D, this.connection, this.Y), this.connection.features.disconnected = this.Pt.L.bind(this.Pt), this.connection.features.resend = () => {
            if (this.Pt) return this.Pt.B();
          }), this.connection.features.inherentKeepAlive || await this.$t(this.ft);
        } catch (S) {
          throw this.u.log(r.Debug, `Hub handshake failed with error '${S}' during start(). Stopping HubConnection.`), this.Ct(), this.Tt(), await this.connection.stop(S), S;
        }
      }
      async stop() {
        const v = this.wt;
        this.connection.features.reconnect = !1, this.It = this._t(), await this.It;
        try {
          await v;
        } catch {
        }
      }
      _t(v) {
        if (this.ut === Be.Disconnected) return this.u.log(r.Debug, `Call to HubConnection.stop(${v}) ignored because it is already in the disconnected state.`), Promise.resolve();
        if (this.ut === Be.Disconnecting) return this.u.log(r.Debug, `Call to HttpConnection.stop(${v}) ignored because the connection is already in the disconnecting state.`), this.It;
        const S = this.ut;
        return this.ut = Be.Disconnecting, this.u.log(r.Debug, "Stopping HubConnection."), this.Ht ? (this.u.log(r.Debug, "Connection stopped during reconnect delay. Done reconnecting."), clearTimeout(this.Ht), this.Ht = void 0, this.Dt(), Promise.resolve()) : (S === Be.Connected && this.Rt(), this.Ct(), this.Tt(), this.bt = v || new f("The connection was stopped before the hub handshake could complete."), this.connection.stop(v));
      }
      async Rt() {
        try {
          await this.xt(this.At());
        } catch {
        }
      }
      stream(v, ...S) {
        const [z, _] = this.Ut(S), W = this.Lt(v, S, _);
        let Z;
        const le = new gS();
        return le.cancelCallback = () => {
          const ce = this.Nt(W.invocationId);
          return delete this.it[W.invocationId], Z.then(() => this.xt(ce));
        }, this.it[W.invocationId] = (ce, Qe) => {
          Qe ? le.error(Qe) : ce && (ce.type === xe.Completion ? ce.error ? le.error(new Error(ce.error)) : le.complete() : le.next(ce.item));
        }, Z = this.xt(W).catch((ce) => {
          le.error(ce), delete this.it[W.invocationId];
        }), this.qt(z, Z), le;
      }
      $t(v) {
        return this.kt(), this.connection.send(v);
      }
      xt(v) {
        return this.Pt ? this.Pt.A(v) : this.$t(this.D.writeMessage(v));
      }
      send(v, ...S) {
        const [z, _] = this.Ut(S), W = this.xt(this.Mt(v, S, !0, _));
        return this.qt(z, W), W;
      }
      invoke(v, ...S) {
        const [z, _] = this.Ut(S), W = this.Mt(v, S, !1, _);
        return new Promise((Z, le) => {
          this.it[W.invocationId] = (Qe, Ue) => {
            Ue ? le(Ue) : Qe && (Qe.type === xe.Completion ? Qe.error ? le(new Error(Qe.error)) : Z(Qe.result) : le(new Error(`Unexpected message type: ${Qe.type}`)));
          };
          const ce = this.xt(W).catch((Qe) => {
            le(Qe), delete this.it[W.invocationId];
          });
          this.qt(z, ce);
        });
      }
      on(v, S) {
        v && S && (v = v.toLowerCase(), this.nt[v] || (this.nt[v] = []), this.nt[v].indexOf(S) === -1 && this.nt[v].push(S));
      }
      off(v, S) {
        if (!v) return;
        v = v.toLowerCase();
        const z = this.nt[v];
        if (z) if (S) {
          const _ = z.indexOf(S);
          _ !== -1 && (z.splice(_, 1), z.length === 0 && delete this.nt[v]);
        } else delete this.nt[v];
      }
      onclose(v) {
        v && this.rt.push(v);
      }
      onreconnecting(v) {
        v && this.ot.push(v);
      }
      onreconnected(v) {
        v && this.ht.push(v);
      }
      et(v) {
        if (this.Ct(), this.lt || (v = this.jt(v), this.lt = !0), v) {
          const S = this.D.parseMessages(v, this.u);
          for (const z of S) if (!this.Pt || this.Pt.W(z)) switch (z.type) {
            case xe.Invocation:
              this.Wt(z).catch((_) => {
                this.u.log(r.Error, `Invoke client method threw error: ${Ho(_)}`);
              });
              break;
            case xe.StreamItem:
            case xe.Completion: {
              const _ = this.it[z.invocationId];
              if (_) {
                z.type === xe.Completion && delete this.it[z.invocationId];
                try {
                  _(z);
                } catch (W) {
                  this.u.log(r.Error, `Stream callback threw error: ${Ho(W)}`);
                }
              }
              break;
            }
            case xe.Ping:
              break;
            case xe.Close: {
              this.u.log(r.Information, "Close message received from server.");
              const _ = z.error ? new Error("Server returned an error on close: " + z.error) : void 0;
              z.allowReconnect === !0 ? this.connection.stop(_) : this.It = this._t(_);
              break;
            }
            case xe.Ack:
              this.Pt && this.Pt.N(z);
              break;
            case xe.Sequence:
              this.Pt && this.Pt.F(z);
              break;
            default:
              this.u.log(r.Warning, `Invalid message type: ${z.type}.`);
          }
        }
        this.St();
      }
      jt(v) {
        let S, z;
        try {
          [z, S] = this.tt.parseHandshakeResponse(v);
        } catch (_) {
          const W = "Error parsing handshake response: " + _;
          this.u.log(r.Error, W);
          const Z = new Error(W);
          throw this.Et(Z), Z;
        }
        if (S.error) {
          const _ = "Server returned handshake error: " + S.error;
          this.u.log(r.Error, _);
          const W = new Error(_);
          throw this.Et(W), W;
        }
        return this.u.log(r.Debug, "Server handshake complete."), this.vt(), z;
      }
      kt() {
        this.connection.features.inherentKeepAlive || (this.K = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds, this.Tt());
      }
      St() {
        if (!(this.connection.features && this.connection.features.inherentKeepAlive || (this.Ot = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds), this.Ft !== void 0))) {
          let v = this.K - (/* @__PURE__ */ new Date()).getTime();
          v < 0 && (v = 0), this.Ft = setTimeout(async () => {
            if (this.ut === Be.Connected) try {
              await this.$t(this.ft);
            } catch {
              this.Tt();
            }
          }, v);
        }
      }
      serverTimeout() {
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
      }
      async Wt(v) {
        const S = v.target.toLowerCase(), z = this.nt[S];
        if (!z) return this.u.log(r.Warning, `No client method with the name '${S}' found.`), void (v.invocationId && (this.u.log(r.Warning, `No result given for '${S}' method and invocation ID '${v.invocationId}'.`), await this.xt(this.Bt(v.invocationId, "Client didn't provide a result.", null))));
        const _ = z.slice(), W = !!v.invocationId;
        let Z, le, ce;
        for (const Qe of _) try {
          const Ue = Z;
          Z = await Qe.apply(this, v.arguments), W && Z && Ue && (this.u.log(r.Error, `Multiple results provided for '${S}'. Sending error to server.`), ce = this.Bt(v.invocationId, "Client provided multiple results.", null)), le = void 0;
        } catch (Ue) {
          le = Ue, this.u.log(r.Error, `A callback for the method '${S}' threw error '${Ue}'.`);
        }
        ce ? await this.xt(ce) : W ? (le ? ce = this.Bt(v.invocationId, `${le}`, null) : Z !== void 0 ? ce = this.Bt(v.invocationId, null, Z) : (this.u.log(r.Warning, `No result given for '${S}' method and invocation ID '${v.invocationId}'.`), ce = this.Bt(v.invocationId, "Client didn't provide a result.", null)), await this.xt(ce)) : Z && this.u.log(r.Error, `Result given for '${S}' method but server is not expecting a result.`);
      }
      st(v) {
        this.u.log(r.Debug, `HubConnection.connectionClosed(${v}) called while in state ${this.ut}.`), this.bt = this.bt || v || new f("The underlying connection was closed before the hub handshake could complete."), this.vt && this.vt(), this.Xt(v || new Error("Invocation canceled due to the underlying connection being closed.")), this.Ct(), this.Tt(), this.ut === Be.Disconnecting ? this.Dt(v) : this.ut === Be.Connected && this.Z ? this.Jt(v) : this.ut === Be.Connected && this.Dt(v);
      }
      Dt(v) {
        if (this.dt) {
          this.ut = Be.Disconnected, this.dt = !1, this.Pt && (this.Pt.X(v ?? new Error("Connection closed.")), this.Pt = void 0), Pe.isBrowser && window.document.removeEventListener("freeze", this.G);
          try {
            this.rt.forEach((S) => S.apply(this, [v]));
          } catch (S) {
            this.u.log(r.Error, `An onclose callback called with error '${v}' threw error '${S}'.`);
          }
        }
      }
      async Jt(v) {
        const S = Date.now();
        let z = 0, _ = v !== void 0 ? v : new Error("Attempting to reconnect due to a unknown error."), W = this.zt(z++, 0, _);
        if (W === null) return this.u.log(r.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt."), void this.Dt(v);
        if (this.ut = Be.Reconnecting, v ? this.u.log(r.Information, `Connection reconnecting because of error '${v}'.`) : this.u.log(r.Information, "Connection reconnecting."), this.ot.length !== 0) {
          try {
            this.ot.forEach((Z) => Z.apply(this, [v]));
          } catch (Z) {
            this.u.log(r.Error, `An onreconnecting callback called with error '${v}' threw error '${Z}'.`);
          }
          if (this.ut !== Be.Reconnecting) return void this.u.log(r.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        }
        for (; W !== null; ) {
          if (this.u.log(r.Information, `Reconnect attempt number ${z} will start in ${W} ms.`), await new Promise((Z) => {
            this.Ht = setTimeout(Z, W);
          }), this.Ht = void 0, this.ut !== Be.Reconnecting) return void this.u.log(r.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
          try {
            if (await this.yt(), this.ut = Be.Connected, this.u.log(r.Information, "HubConnection reconnected successfully."), this.ht.length !== 0) try {
              this.ht.forEach((Z) => Z.apply(this, [this.connection.connectionId]));
            } catch (Z) {
              this.u.log(r.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${Z}'.`);
            }
            return;
          } catch (Z) {
            if (this.u.log(r.Information, `Reconnect attempt failed because of error '${Z}'.`), this.ut !== Be.Reconnecting) return this.u.log(r.Debug, `Connection moved to the '${this.ut}' from the reconnecting state during reconnect attempt. Done reconnecting.`), void (this.ut === Be.Disconnecting && this.Dt());
            _ = Z instanceof Error ? Z : new Error(Z.toString()), W = this.zt(z++, Date.now() - S, _);
          }
        }
        this.u.log(r.Information, `Reconnect retries have been exhausted after ${Date.now() - S} ms and ${z} failed attempts. Connection disconnecting.`), this.Dt();
      }
      zt(v, S, z) {
        try {
          return this.Z.nextRetryDelayInMilliseconds({ elapsedMilliseconds: S, previousRetryCount: v, retryReason: z });
        } catch (_) {
          return this.u.log(r.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${v}, ${S}) threw error '${_}'.`), null;
        }
      }
      Xt(v) {
        const S = this.it;
        this.it = {}, Object.keys(S).forEach((z) => {
          const _ = S[z];
          try {
            _(null, v);
          } catch (W) {
            this.u.log(r.Error, `Stream 'error' callback called with '${v}' threw error: ${Ho(W)}`);
          }
        });
      }
      Tt() {
        this.Ft && (clearTimeout(this.Ft), this.Ft = void 0);
      }
      Ct() {
        this.Ot && clearTimeout(this.Ot);
      }
      Mt(v, S, z, _) {
        if (z) return _.length !== 0 ? { arguments: S, streamIds: _, target: v, type: xe.Invocation } : { arguments: S, target: v, type: xe.Invocation };
        {
          const W = this.ct;
          return this.ct++, _.length !== 0 ? { arguments: S, invocationId: W.toString(), streamIds: _, target: v, type: xe.Invocation } : { arguments: S, invocationId: W.toString(), target: v, type: xe.Invocation };
        }
      }
      qt(v, S) {
        if (v.length !== 0) {
          S || (S = Promise.resolve());
          for (const z in v) v[z].subscribe({ complete: /* @__PURE__ */ p(() => {
            S = S.then(() => this.xt(this.Bt(z)));
          }, "complete"), error: /* @__PURE__ */ p((_) => {
            let W;
            W = _ instanceof Error ? _.message : _ && _.toString ? _.toString() : "Unknown error", S = S.then(() => this.xt(this.Bt(z, W)));
          }, "error"), next: /* @__PURE__ */ p((_) => {
            S = S.then(() => this.xt(this.Vt(z, _)));
          }, "next") });
        }
      }
      Ut(v) {
        const S = [], z = [];
        for (let _ = 0; _ < v.length; _++) {
          const W = v[_];
          if (this.Kt(W)) {
            const Z = this.ct;
            this.ct++, S[Z] = W, z.push(Z.toString()), v.splice(_, 1);
          }
        }
        return [S, z];
      }
      Kt(v) {
        return v && v.subscribe && typeof v.subscribe == "function";
      }
      Lt(v, S, z) {
        const _ = this.ct;
        return this.ct++, z.length !== 0 ? { arguments: S, invocationId: _.toString(), streamIds: z, target: v, type: xe.StreamInvocation } : { arguments: S, invocationId: _.toString(), target: v, type: xe.StreamInvocation };
      }
      Nt(v) {
        return { invocationId: v, type: xe.CancelInvocation };
      }
      Vt(v, S) {
        return { invocationId: v, item: S, type: xe.StreamItem };
      }
      Bt(v, S, z) {
        return S ? { error: S, invocationId: v, type: xe.Completion } : { invocationId: v, result: z, type: xe.Completion };
      }
      At() {
        return { type: xe.Close };
      }
    }, u(ta, "Cc"), ta);
    p(bS, "q");
    let $S = bS;
    const uL = [0, 2e3, 1e4, 3e4, null], xS = (wl = class {
      constructor(v) {
        this.Gt = v !== void 0 ? [...v, null] : uL;
      }
      nextRetryDelayInMilliseconds(v) {
        return this.Gt[v.previousRetryCount];
      }
    }, u(wl, "ld"), wl);
    p(xS, "j");
    let kS = xS;
    const SS = (gl = class {
    }, u(gl, "dd"), gl);
    p(SS, "W");
    let ea = SS;
    ea.Authorization = "Authorization", ea.Cookie = "Cookie";
    const PS = (vl = class extends j {
      constructor(v, S) {
        super(), this.Qt = v, this.Yt = S;
      }
      async send(v) {
        let S = !0;
        this.Yt && (!this.Zt || v.url && v.url.indexOf("/negotiate?") > 0) && (S = !1, this.Zt = await this.Yt()), this.te(v);
        const z = await this.Qt.send(v);
        return S && z.statusCode === 401 && this.Yt ? (this.Zt = await this.Yt(), this.te(v), await this.Qt.send(v)) : z;
      }
      te(v) {
        v.headers || (v.headers = {}), this.Zt ? v.headers[ea.Authorization] = `Bearer ${this.Zt}` : this.Yt && v.headers[ea.Authorization] && delete v.headers[ea.Authorization];
      }
      getCookieString(v) {
        return this.Qt.getCookieString(v);
      }
    }, u(vl, "hd"), vl);
    p(PS, "O");
    let pL = PS;
    var yt, Zt;
    (function(N) {
      N[N.None = 0] = "None", N[N.WebSockets = 1] = "WebSockets", N[N.ServerSentEvents = 2] = "ServerSentEvents", N[N.LongPolling = 4] = "LongPolling";
    })(yt || (yt = {})), function(N) {
      N[N.Text = 1] = "Text", N[N.Binary = 2] = "Binary";
    }(Zt || (Zt = {}));
    const CS = (Ol = class {
      constructor() {
        this.ee = !1, this.onabort = null;
      }
      abort() {
        this.ee || (this.ee = !0, this.onabort && this.onabort());
      }
      get signal() {
        return this;
      }
      get aborted() {
        return this.ee;
      }
    }, u(Ol, "pd"), Ol);
    p(CS, "X");
    let fL = CS;
    const QS = (bl = class {
      get pollAborted() {
        return this.se.aborted;
      }
      constructor(v, S, z) {
        this.$ = v, this.u = S, this.se = new fL(), this.ie = z, this.ne = !1, this.onreceive = null, this.onclose = null;
      }
      async connect(v, S) {
        if (re.isRequired(v, "url"), re.isRequired(S, "transferFormat"), re.isIn(S, Zt, "transferFormat"), this.re = v, this.u.log(r.Trace, "(LongPolling transport) Connecting."), S === Zt.Binary && typeof XMLHttpRequest < "u" && typeof new XMLHttpRequest().responseType != "string") throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        const [z, _] = Gt(), W = { [z]: _, ...this.ie.headers }, Z = { abortSignal: this.se.signal, headers: W, timeout: 1e5, withCredentials: this.ie.withCredentials };
        S === Zt.Binary && (Z.responseType = "arraybuffer");
        const le = `${v}&_=${Date.now()}`;
        this.u.log(r.Trace, `(LongPolling transport) polling: ${le}.`);
        const ce = await this.$.get(le, Z);
        ce.statusCode !== 200 ? (this.u.log(r.Error, `(LongPolling transport) Unexpected response code: ${ce.statusCode}.`), this.oe = new l(ce.statusText || "", ce.statusCode), this.ne = !1) : this.ne = !0, this.he = this.ce(this.re, Z);
      }
      async ce(v, S) {
        try {
          for (; this.ne; ) try {
            const z = `${v}&_=${Date.now()}`;
            this.u.log(r.Trace, `(LongPolling transport) polling: ${z}.`);
            const _ = await this.$.get(z, S);
            _.statusCode === 204 ? (this.u.log(r.Information, "(LongPolling transport) Poll terminated by server."), this.ne = !1) : _.statusCode !== 200 ? (this.u.log(r.Error, `(LongPolling transport) Unexpected response code: ${_.statusCode}.`), this.oe = new l(_.statusText || "", _.statusCode), this.ne = !1) : _.content ? (this.u.log(r.Trace, `(LongPolling transport) data received. ${He(_.content, this.ie.logMessageContent)}.`), this.onreceive && this.onreceive(_.content)) : this.u.log(r.Trace, "(LongPolling transport) Poll timed out, reissuing.");
          } catch (z) {
            this.ne ? z instanceof h ? this.u.log(r.Trace, "(LongPolling transport) Poll timed out, reissuing.") : (this.oe = z, this.ne = !1) : this.u.log(r.Trace, `(LongPolling transport) Poll errored after shutdown: ${z.message}`);
          }
        } finally {
          this.u.log(r.Trace, "(LongPolling transport) Polling complete."), this.pollAborted || this.ae();
        }
      }
      async send(v) {
        return this.ne ? ft(this.u, "LongPolling", this.$, this.re, v, this.ie) : Promise.reject(new Error("Cannot send until the transport is connected"));
      }
      async stop() {
        this.u.log(r.Trace, "(LongPolling transport) Stopping polling."), this.ne = !1, this.se.abort();
        try {
          await this.he, this.u.log(r.Trace, `(LongPolling transport) sending DELETE request to ${this.re}.`);
          const v = {}, [S, z] = Gt();
          v[S] = z;
          const _ = { headers: { ...v, ...this.ie.headers }, timeout: this.ie.timeout, withCredentials: this.ie.withCredentials };
          let W;
          try {
            await this.$.delete(this.re, _);
          } catch (Z) {
            W = Z;
          }
          W ? W instanceof l && (W.statusCode === 404 ? this.u.log(r.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.") : this.u.log(r.Trace, `(LongPolling transport) Error sending a DELETE request: ${W}`)) : this.u.log(r.Trace, "(LongPolling transport) DELETE request accepted.");
        } finally {
          this.u.log(r.Trace, "(LongPolling transport) Stop finished."), this.ae();
        }
      }
      ae() {
        if (this.onclose) {
          let v = "(LongPolling transport) Firing onclose event.";
          this.oe && (v += " Error: " + this.oe), this.u.log(r.Trace, v), this.onclose(this.oe);
        }
      }
    }, u(bl, "ud"), bl);
    p(QS, "J");
    let TS = QS;
    const MS = ($l = class {
      constructor(v, S, z, _) {
        this.$ = v, this.Zt = S, this.u = z, this.ie = _, this.onreceive = null, this.onclose = null;
      }
      async connect(v, S) {
        return re.isRequired(v, "url"), re.isRequired(S, "transferFormat"), re.isIn(S, Zt, "transferFormat"), this.u.log(r.Trace, "(SSE transport) Connecting."), this.re = v, this.Zt && (v += (v.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this.Zt)}`), new Promise((z, _) => {
          let W, Z = !1;
          if (S === Zt.Text) {
            if (Pe.isBrowser || Pe.isWebWorker) W = new this.ie.EventSource(v, { withCredentials: this.ie.withCredentials });
            else {
              const le = this.$.getCookieString(v), ce = {};
              ce.Cookie = le;
              const [Qe, Ue] = Gt();
              ce[Qe] = Ue, W = new this.ie.EventSource(v, { withCredentials: this.ie.withCredentials, headers: { ...ce, ...this.ie.headers } });
            }
            try {
              W.onmessage = (le) => {
                if (this.onreceive) try {
                  this.u.log(r.Trace, `(SSE transport) data received. ${He(le.data, this.ie.logMessageContent)}.`), this.onreceive(le.data);
                } catch (ce) {
                  return void this.le(ce);
                }
              }, W.onerror = (le) => {
                Z ? this.le() : _(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
              }, W.onopen = () => {
                this.u.log(r.Information, `SSE connected to ${this.re}`), this.ue = W, Z = !0, z();
              };
            } catch (le) {
              return void _(le);
            }
          } else _(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        });
      }
      async send(v) {
        return this.ue ? ft(this.u, "SSE", this.$, this.re, v, this.ie) : Promise.reject(new Error("Cannot send until the transport is connected"));
      }
      stop() {
        return this.le(), Promise.resolve();
      }
      le(v) {
        this.ue && (this.ue.close(), this.ue = void 0, this.onclose && this.onclose(v));
      }
    }, u($l, "yd"), $l);
    p(MS, "z");
    let yL = MS;
    const RS = (xl = class {
      constructor(v, S, z, _, W, Z) {
        this.u = z, this.Yt = S, this.de = _, this.fe = W, this.$ = v, this.onreceive = null, this.onclose = null, this.pe = Z;
      }
      async connect(v, S) {
        let z;
        return re.isRequired(v, "url"), re.isRequired(S, "transferFormat"), re.isIn(S, Zt, "transferFormat"), this.u.log(r.Trace, "(WebSockets transport) Connecting."), this.Yt && (z = await this.Yt()), new Promise((_, W) => {
          let Z;
          v = v.replace(/^http/, "ws");
          const le = this.$.getCookieString(v);
          let ce = !1;
          if (Pe.isNode || Pe.isReactNative) {
            const Qe = {}, [Ue, Ql] = Gt();
            Qe[Ue] = Ql, z && (Qe[ea.Authorization] = `Bearer ${z}`), le && (Qe[ea.Cookie] = le), Z = new this.fe(v, void 0, { headers: { ...Qe, ...this.pe } });
          } else z && (v += (v.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(z)}`);
          Z || (Z = new this.fe(v)), S === Zt.Binary && (Z.binaryType = "arraybuffer"), Z.onopen = (Qe) => {
            this.u.log(r.Information, `WebSocket connected to ${v}.`), this.we = Z, ce = !0, _();
          }, Z.onerror = (Qe) => {
            let Ue = null;
            Ue = typeof ErrorEvent < "u" && Qe instanceof ErrorEvent ? Qe.error : "There was an error with the transport", this.u.log(r.Information, `(WebSockets transport) ${Ue}.`);
          }, Z.onmessage = (Qe) => {
            if (this.u.log(r.Trace, `(WebSockets transport) data received. ${He(Qe.data, this.de)}.`), this.onreceive) try {
              this.onreceive(Qe.data);
            } catch (Ue) {
              return void this.le(Ue);
            }
          }, Z.onclose = (Qe) => {
            if (ce) this.le(Qe);
            else {
              let Ue = null;
              Ue = typeof ErrorEvent < "u" && Qe instanceof ErrorEvent ? Qe.error : "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.", W(new Error(Ue));
            }
          };
        });
      }
      send(v) {
        return this.we && this.we.readyState === this.fe.OPEN ? (this.u.log(r.Trace, `(WebSockets transport) sending data. ${He(v, this.de)}.`), this.we.send(v), Promise.resolve()) : Promise.reject("WebSocket is not in the OPEN state");
      }
      stop() {
        return this.we && this.le(void 0), Promise.resolve();
      }
      le(v) {
        this.we && (this.we.onclose = () => {
        }, this.we.onmessage = () => {
        }, this.we.onerror = () => {
        }, this.we.close(), this.we = void 0), this.u.log(r.Trace, "(WebSockets transport) socket closed."), this.onclose && (!this.ge(v) || v.wasClean !== !1 && v.code === 1e3 ? v instanceof Error ? this.onclose(v) : this.onclose() : this.onclose(new Error(`WebSocket closed with status code: ${v.code} (${v.reason || "no reason given"}).`)));
      }
      ge(v) {
        return v && typeof v.wasClean == "boolean" && typeof v.code == "number";
      }
    }, u(xl, "wd"), xl);
    p(RS, "V");
    let mL = RS;
    const AS = (kl = class {
      constructor(v, S = {}) {
        var z;
        if (this.me = () => {
        }, this.features = {}, this.ye = 1, re.isRequired(v, "url"), this.u = (z = S.logger) === void 0 ? new ni(r.Information) : z === null ? se.instance : z.log !== void 0 ? z : new ni(z), this.baseUrl = this.be(v), (S = S || {}).logMessageContent = S.logMessageContent !== void 0 && S.logMessageContent, typeof S.withCredentials != "boolean" && S.withCredentials !== void 0) throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        S.withCredentials = S.withCredentials === void 0 || S.withCredentials, S.timeout = S.timeout === void 0 ? 1e5 : S.timeout;
        let _ = null, W = null;
        if (Pe.isNode) {
          const Z = rg;
          _ = Z("ws"), W = Z("eventsource");
        }
        Pe.isNode || typeof WebSocket > "u" || S.WebSocket ? Pe.isNode && !S.WebSocket && _ && (S.WebSocket = _) : S.WebSocket = WebSocket, Pe.isNode || typeof EventSource > "u" || S.EventSource ? Pe.isNode && !S.EventSource && W !== void 0 && (S.EventSource = W) : S.EventSource = EventSource, this.$ = new pL(S.httpClient || new fS(this.u), S.accessTokenFactory), this.ut = "Disconnected", this.dt = !1, this.ie = S, this.onreceive = null, this.onclose = null;
      }
      async start(v) {
        if (v = v || Zt.Binary, re.isIn(v, Zt, "transferFormat"), this.u.log(r.Debug, `Starting connection with transfer format '${Zt[v]}'.`), this.ut !== "Disconnected") return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        if (this.ut = "Connecting", this.ve = this.yt(v), await this.ve, this.ut === "Disconnecting") {
          const S = "Failed to start the HttpConnection before stop() was called.";
          return this.u.log(r.Error, S), await this.It, Promise.reject(new f(S));
        }
        if (this.ut !== "Connected") {
          const S = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
          return this.u.log(r.Error, S), Promise.reject(new f(S));
        }
        this.dt = !0;
      }
      send(v) {
        return this.ut !== "Connected" ? Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State.")) : (this.Ee || (this.Ee = new gL(this.transport)), this.Ee.send(v));
      }
      async stop(v) {
        return this.ut === "Disconnected" ? (this.u.log(r.Debug, `Call to HttpConnection.stop(${v}) ignored because the connection is already in the disconnected state.`), Promise.resolve()) : this.ut === "Disconnecting" ? (this.u.log(r.Debug, `Call to HttpConnection.stop(${v}) ignored because the connection is already in the disconnecting state.`), this.It) : (this.ut = "Disconnecting", this.It = new Promise((S) => {
          this.me = S;
        }), await this._t(v), void await this.It);
      }
      async _t(v) {
        this.$e = v;
        try {
          await this.ve;
        } catch {
        }
        if (this.transport) {
          try {
            await this.transport.stop();
          } catch (S) {
            this.u.log(r.Error, `HttpConnection.transport.stop() threw error '${S}'.`), this.Ce();
          }
          this.transport = void 0;
        } else this.u.log(r.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
      }
      async yt(v) {
        let S = this.baseUrl;
        this.Yt = this.ie.accessTokenFactory, this.$.Yt = this.Yt;
        try {
          if (this.ie.skipNegotiation) {
            if (this.ie.transport !== yt.WebSockets) throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            this.transport = this.Se(yt.WebSockets), await this.ke(S, v);
          } else {
            let z = null, _ = 0;
            do {
              if (z = await this.Pe(S), this.ut === "Disconnecting" || this.ut === "Disconnected") throw new f("The connection was stopped during negotiation.");
              if (z.error) throw new Error(z.error);
              if (z.ProtocolVersion) throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
              if (z.url && (S = z.url), z.accessToken) {
                const W = z.accessToken;
                this.Yt = () => W, this.$.Zt = W, this.$.Yt = void 0;
              }
              _++;
            } while (z.url && _ < 100);
            if (_ === 100 && z.url) throw new Error("Negotiate redirection limit exceeded.");
            await this.Te(S, this.ie.transport, z, v);
          }
          this.transport instanceof TS && (this.features.inherentKeepAlive = !0), this.ut === "Connecting" && (this.u.log(r.Debug, "The HttpConnection connected successfully."), this.ut = "Connected");
        } catch (z) {
          return this.u.log(r.Error, "Failed to start the connection: " + z), this.ut = "Disconnected", this.transport = void 0, this.me(), Promise.reject(z);
        }
      }
      async Pe(v) {
        const S = {}, [z, _] = Gt();
        S[z] = _;
        const W = this.Ie(v);
        this.u.log(r.Debug, `Sending negotiation request: ${W}.`);
        try {
          const Z = await this.$.post(W, { content: "", headers: { ...S, ...this.ie.headers }, timeout: this.ie.timeout, withCredentials: this.ie.withCredentials });
          if (Z.statusCode !== 200) return Promise.reject(new Error(`Unexpected status code returned from negotiate '${Z.statusCode}'`));
          const le = JSON.parse(Z.content);
          return (!le.negotiateVersion || le.negotiateVersion < 1) && (le.connectionToken = le.connectionId), le.useStatefulReconnect && this.ie._e !== !0 ? Promise.reject(new E("Client didn't negotiate Stateful Reconnect but the server did.")) : le;
        } catch (Z) {
          let le = "Failed to complete negotiation with the server: " + Z;
          return Z instanceof l && Z.statusCode === 404 && (le += " Either this is not a SignalR endpoint or there is a proxy blocking the connection."), this.u.log(r.Error, le), Promise.reject(new E(le));
        }
      }
      He(v, S) {
        return S ? v + (v.indexOf("?") === -1 ? "?" : "&") + `id=${S}` : v;
      }
      async Te(v, S, z, _) {
        let W = this.He(v, z.connectionToken);
        if (this.De(S)) return this.u.log(r.Debug, "Connection was provided an instance of ITransport, using that directly."), this.transport = S, await this.ke(W, _), void (this.connectionId = z.connectionId);
        const Z = [], le = z.availableTransports || [];
        let ce = z;
        for (const Qe of le) {
          const Ue = this.Re(Qe, S, _, (ce == null ? void 0 : ce.useStatefulReconnect) === !0);
          if (Ue instanceof Error) Z.push(`${Qe.transport} failed:`), Z.push(Ue);
          else if (this.De(Ue)) {
            if (this.transport = Ue, !ce) {
              try {
                ce = await this.Pe(v);
              } catch (Ql) {
                return Promise.reject(Ql);
              }
              W = this.He(v, ce.connectionToken);
            }
            try {
              return await this.ke(W, _), void (this.connectionId = ce.connectionId);
            } catch (Ql) {
              if (this.u.log(r.Error, `Failed to start the transport '${Qe.transport}': ${Ql}`), ce = void 0, Z.push(new $(`${Qe.transport} failed: ${Ql}`, yt[Qe.transport])), this.ut !== "Connecting") {
                const WS = "Failed to select transport before stop() was called.";
                return this.u.log(r.Debug, WS), Promise.reject(new f(WS));
              }
            }
          }
        }
        return Z.length > 0 ? Promise.reject(new R(`Unable to connect to the server with any of the available transports. ${Z.join(" ")}`, Z)) : Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
      }
      Se(v) {
        switch (v) {
          case yt.WebSockets:
            if (!this.ie.WebSocket) throw new Error("'WebSocket' is not supported in your environment.");
            return new mL(this.$, this.Yt, this.u, this.ie.logMessageContent, this.ie.WebSocket, this.ie.headers || {});
          case yt.ServerSentEvents:
            if (!this.ie.EventSource) throw new Error("'EventSource' is not supported in your environment.");
            return new yL(this.$, this.$.Zt, this.u, this.ie);
          case yt.LongPolling:
            return new TS(this.$, this.u, this.ie);
          default:
            throw new Error(`Unknown transport: ${v}.`);
        }
      }
      ke(v, S) {
        return this.transport.onreceive = this.onreceive, this.features.reconnect ? this.transport.onclose = async (z) => {
          let _ = !1;
          if (this.features.reconnect) {
            try {
              this.features.disconnected(), await this.transport.connect(v, S), await this.features.resend();
            } catch {
              _ = !0;
            }
            _ && this.Ce(z);
          } else this.Ce(z);
        } : this.transport.onclose = (z) => this.Ce(z), this.transport.connect(v, S);
      }
      Re(v, S, z, _) {
        const W = yt[v.transport];
        if (W == null) return this.u.log(r.Debug, `Skipping transport '${v.transport}' because it is not supported by this client.`), new Error(`Skipping transport '${v.transport}' because it is not supported by this client.`);
        if (!function(Z, le) {
          return !Z || (le & Z) != 0;
        }(S, W)) return this.u.log(r.Debug, `Skipping transport '${yt[W]}' because it was disabled by the client.`), new b(`'${yt[W]}' is disabled by the client.`, W);
        if (!(v.transferFormats.map((Z) => Zt[Z]).indexOf(z) >= 0)) return this.u.log(r.Debug, `Skipping transport '${yt[W]}' because it does not support the requested transfer format '${Zt[z]}'.`), new Error(`'${yt[W]}' does not support ${Zt[z]}.`);
        if (W === yt.WebSockets && !this.ie.WebSocket || W === yt.ServerSentEvents && !this.ie.EventSource) return this.u.log(r.Debug, `Skipping transport '${yt[W]}' because it is not supported in your environment.'`), new w(`'${yt[W]}' is not supported in your environment.`, W);
        this.u.log(r.Debug, `Selecting transport '${yt[W]}'.`);
        try {
          return this.features.reconnect = W === yt.WebSockets ? _ : void 0, this.Se(W);
        } catch (Z) {
          return Z;
        }
      }
      De(v) {
        return v && typeof v == "object" && "connect" in v;
      }
      Ce(v) {
        if (this.u.log(r.Debug, `HttpConnection.stopConnection(${v}) called while in state ${this.ut}.`), this.transport = void 0, v = this.$e || v, this.$e = void 0, this.ut !== "Disconnected") {
          if (this.ut === "Connecting") throw this.u.log(r.Warning, `Call to HttpConnection.stopConnection(${v}) was ignored because the connection is still in the connecting state.`), new Error(`HttpConnection.stopConnection(${v}) was called while the connection is still in the connecting state.`);
          if (this.ut === "Disconnecting" && this.me(), v ? this.u.log(r.Error, `Connection disconnected with error '${v}'.`) : this.u.log(r.Information, "Connection disconnected."), this.Ee && (this.Ee.stop().catch((S) => {
            this.u.log(r.Error, `TransportSendQueue.stop() threw error '${S}'.`);
          }), this.Ee = void 0), this.connectionId = void 0, this.ut = "Disconnected", this.dt) {
            this.dt = !1;
            try {
              this.onclose && this.onclose(v);
            } catch (S) {
              this.u.log(r.Error, `HttpConnection.onclose(${v}) threw error '${S}'.`);
            }
          }
        } else this.u.log(r.Debug, `Call to HttpConnection.stopConnection(${v}) was ignored because the connection is already in the disconnected state.`);
      }
      be(v) {
        if (v.lastIndexOf("https://", 0) === 0 || v.lastIndexOf("http://", 0) === 0) return v;
        if (!Pe.isBrowser) throw new Error(`Cannot resolve '${v}'.`);
        const S = window.document.createElement("a");
        return S.href = v, this.u.log(r.Information, `Normalizing '${v}' to '${S.href}'.`), S.href;
      }
      Ie(v) {
        const S = new URL(v);
        S.pathname.endsWith("/") ? S.pathname += "negotiate" : S.pathname += "/negotiate";
        const z = new URLSearchParams(S.searchParams);
        return z.has("negotiateVersion") || z.append("negotiateVersion", this.ye.toString()), z.has("useStatefulReconnect") ? z.get("useStatefulReconnect") === "true" && (this.ie._e = !0) : this.ie._e === !0 && z.append("useStatefulReconnect", "true"), S.search = z.toString(), S.toString();
      }
    }, u(kl, "fd"), kl);
    p(AS, "K");
    let wL = AS;
    const ES = (ia = class {
      constructor(v) {
        this.xe = v, this.Ae = [], this.Ue = !0, this.Le = new ww(), this.Ne = new ww(), this.qe = this.Me();
      }
      send(v) {
        return this.je(v), this.Ne || (this.Ne = new ww()), this.Ne.promise;
      }
      stop() {
        return this.Ue = !1, this.Le.resolve(), this.qe;
      }
      je(v) {
        if (this.Ae.length && typeof this.Ae[0] != typeof v) throw new Error(`Expected data to be of type ${typeof this.Ae} but was of type ${typeof v}`);
        this.Ae.push(v), this.Le.resolve();
      }
      async Me() {
        for (; ; ) {
          if (await this.Le.promise, !this.Ue) {
            this.Ne && this.Ne.reject("Connection stopped.");
            break;
          }
          this.Le = new ww();
          const v = this.Ne;
          this.Ne = void 0;
          const S = typeof this.Ae[0] == "string" ? this.Ae.join("") : ia.We(this.Ae);
          this.Ae.length = 0;
          try {
            await this.xe.send(S), v.resolve();
          } catch (z) {
            v.reject(z);
          }
        }
      }
      static We(v) {
        const S = v.map((W) => W.byteLength).reduce((W, Z) => W + Z), z = new Uint8Array(S);
        let _ = 0;
        for (const W of v) z.set(new Uint8Array(W), _), _ += W.byteLength;
        return z.buffer;
      }
    }, u(ia, "_c"), ia);
    p(ES, "G");
    let gL = ES;
    const zS = (Sl = class {
      constructor() {
        this.promise = new Promise((v, S) => [this.j, this.Oe] = [v, S]);
      }
      resolve() {
        this.j();
      }
      reject(v) {
        this.Oe(v);
      }
    }, u(Sl, "md"), Sl);
    p(zS, "Q");
    let ww = zS;
    const _S = (Pl = class {
      constructor() {
        this.name = "json", this.version = 2, this.transferFormat = Zt.Text;
      }
      parseMessages(v, S) {
        if (typeof v != "string") throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        if (!v) return [];
        S === null && (S = se.instance);
        const z = es.parse(v), _ = [];
        for (const W of z) {
          const Z = JSON.parse(W);
          if (typeof Z.type != "number") throw new Error("Invalid payload.");
          switch (Z.type) {
            case xe.Invocation:
              this.U(Z);
              break;
            case xe.StreamItem:
              this.Fe(Z);
              break;
            case xe.Completion:
              this.Be(Z);
              break;
            case xe.Ping:
            case xe.Close:
              break;
            case xe.Ack:
              this.Xe(Z);
              break;
            case xe.Sequence:
              this.Je(Z);
              break;
            default:
              S.log(r.Information, "Unknown message type '" + Z.type + "' ignored.");
              continue;
          }
          _.push(Z);
        }
        return _;
      }
      writeMessage(v) {
        return es.write(JSON.stringify(v));
      }
      U(v) {
        this.ze(v.target, "Invalid payload for Invocation message."), v.invocationId !== void 0 && this.ze(v.invocationId, "Invalid payload for Invocation message.");
      }
      Fe(v) {
        if (this.ze(v.invocationId, "Invalid payload for StreamItem message."), v.item === void 0) throw new Error("Invalid payload for StreamItem message.");
      }
      Be(v) {
        if (v.result && v.error) throw new Error("Invalid payload for Completion message.");
        !v.result && v.error && this.ze(v.error, "Invalid payload for Completion message."), this.ze(v.invocationId, "Invalid payload for Completion message.");
      }
      Xe(v) {
        if (typeof v.sequenceId != "number") throw new Error("Invalid SequenceId for Ack message.");
      }
      Je(v) {
        if (typeof v.sequenceId != "number") throw new Error("Invalid SequenceId for Sequence message.");
      }
      ze(v, S) {
        if (typeof v != "string" || v === "") throw new Error(S);
      }
    }, u(Pl, "vd"), Pl);
    p(_S, "Y");
    let LS = _S;
    const vL = { trace: r.Trace, debug: r.Debug, info: r.Information, information: r.Information, warn: r.Warning, warning: r.Warning, error: r.Error, critical: r.Critical, none: r.None }, IS = (Cl = class {
      configureLogging(v) {
        if (re.isRequired(v, "logging"), v.log !== void 0) this.logger = v;
        else if (typeof v == "string") {
          const S = function(z) {
            const _ = vL[z.toLowerCase()];
            if (_ !== void 0) return _;
            throw new Error(`Unknown log level: ${z}`);
          }(v);
          this.logger = new ni(S);
        } else this.logger = new ni(v);
        return this;
      }
      withUrl(v, S) {
        return re.isRequired(v, "url"), re.isNotEmpty(v, "url"), this.url = v, this.httpConnectionOptions = typeof S == "object" ? { ...this.httpConnectionOptions, ...S } : { ...this.httpConnectionOptions, transport: S }, this;
      }
      withHubProtocol(v) {
        return re.isRequired(v, "protocol"), this.protocol = v, this;
      }
      withAutomaticReconnect(v) {
        if (this.reconnectPolicy) throw new Error("A reconnectPolicy has already been set.");
        return v ? Array.isArray(v) ? this.reconnectPolicy = new kS(v) : this.reconnectPolicy = v : this.reconnectPolicy = new kS(), this;
      }
      withServerTimeout(v) {
        return re.isRequired(v, "milliseconds"), this.Ve = v, this;
      }
      withKeepAliveInterval(v) {
        return re.isRequired(v, "milliseconds"), this.Ke = v, this;
      }
      withStatefulReconnect(v) {
        return this.httpConnectionOptions === void 0 && (this.httpConnectionOptions = {}), this.httpConnectionOptions._e = !0, this.Y = v == null ? void 0 : v.bufferSize, this;
      }
      build() {
        const v = this.httpConnectionOptions || {};
        if (v.logger === void 0 && (v.logger = this.logger), !this.url) throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        const S = new wL(this.url, v);
        return $S.create(S, this.logger || se.instance, this.protocol || new LS(), this.reconnectPolicy, this.Ve, this.Ke, this.Y);
      }
    }, u(Cl, "gd"), Cl);
    p(IS, "tt");
    let OL = IS;
    return Uint8Array.prototype.indexOf || Object.defineProperty(Uint8Array.prototype, "indexOf", { value: Array.prototype.indexOf, writable: !0 }), Uint8Array.prototype.slice || Object.defineProperty(Uint8Array.prototype, "slice", { value: /* @__PURE__ */ p(function(N, v) {
      return new Uint8Array(Array.prototype.slice.call(this, N, v));
    }, "value"), writable: !0 }), Uint8Array.prototype.forEach || Object.defineProperty(Uint8Array.prototype, "forEach", { value: Array.prototype.forEach, writable: !0 }), a;
  })(), "e"), s.exports = i();
})($R);
var g4 = $R.exports;
const bq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), this._whenConnectionRequested = new Promise((a) => {
        this._resolveConnectionRequested = a;
      }), this._whenConnectionCreated = new Promise((a) => {
        this._resolveConnectionCreated = a;
      }), this._connectionEventListeners = [], this.signalRAccessTokenRefresh = !1, this._whenConnectionStarted = new Promise((a, o) => {
        this._whenConnectionStartedResolve = a, this._whenConnectionStartedReject = o;
      }), this.whenConnectionRequested().then(() => {
        this.isDestroyed || this.createConnection();
      });
    }
    async whenConnectionRequested() {
      await this._whenConnectionRequested;
    }
    async whenConnectionCreated() {
      return await this._whenConnectionCreated;
    }
    get rtmConnection() {
      return this._connection;
    }
    async whenConnectionStarted() {
      return await this._whenConnectionStarted;
    }
    async createConnection() {
      var r;
      if (this.isDestroyed)
        throw new mt();
      if (this.networkStateIsPending = !0, await this.whenUrlAndTokenFactory(), this._connection) {
        const a = new URL("/hubs/rtm", this.url);
        this._connection.baseUrl !== a.toString() && (this.connectionState = "reconnecting", console.info(
          this.weavyId,
          "Reconnecting due to changed url.",
          this._connection.baseUrl,
          "=>",
          a.toString()
        ), await this.disconnect(), this._connection.baseUrl = a.toString(), this.connect());
      } else {
        this.connectionState = "connecting";
        const a = new URL("/hubs/rtm", this.url);
        this._connection = new g4.HubConnectionBuilder().configureLogging(g4.LogLevel.None).withUrl(a.toString(), {
          accessTokenFactory: /* @__PURE__ */ p(async () => {
            try {
              if (this.signalRAccessTokenRefresh) {
                const o = await this.getToken(!0);
                return this.signalRAccessTokenRefresh = !1, o;
              } else
                return await this.getToken();
            } catch (o) {
              throw console.error(o), o;
            }
          }, "accessTokenFactory")
        }).withAutomaticReconnect({
          nextRetryDelayInMilliseconds: /* @__PURE__ */ p((o) => !this.isDestroyed && window.navigator.onLine && (document == null ? void 0 : document.visibilityState) !== "hidden" && o.elapsedMilliseconds < 6e4 ? [0, 2e3, 1e4][o.previousRetryCount] || 1e4 : null, "nextRetryDelayInMilliseconds")
        }).build(), this._connection.onclose(async () => {
          console.info(this.weavyId, "SignalR closed."), this.connectionState = "disconnected", !this.isDestroyed && (this.networkStateIsPending = !0, this._whenConnectionStarted = new Promise((o, l) => {
            this._whenConnectionStartedResolve = o, this._whenConnectionStartedReject = l;
          }), this.connect());
        }), this._connection.onreconnecting(() => {
          console.info(this.weavyId, "SignalR reconnecting..."), this.connectionState = "reconnecting";
        }), this._connection.onreconnected(() => {
          var o;
          console.info(this.weavyId, "SignalR reconnected."), this.connectionState = "connected", this.networkStateIsPending = !1;
          for (let l = 0; l < this._connectionEventListeners.length; l++)
            (o = this._connection) == null || o.invoke("Subscribe", this._connectionEventListeners[l].name);
        }), (r = this._resolveConnectionCreated) == null || r.call(this, this._connection), this.connect();
      }
      return this._connection;
    }
    async disconnect() {
      this._connection && (await this._connection.stop(), this.connectionState = "disconnected");
    }
    async connect() {
      var r;
      if (this.isDestroyed)
        throw new mt();
      let a;
      this._connection ? a = this._connection : a = await this.whenConnectionCreated(), console.info(this.weavyId, "Connecting SignalR...");
      try {
        if (!window.navigator.onLine)
          throw new Error();
        await Promise.race([a.start(), this.whenConnectionStarted()]), this.signalRAccessTokenRefresh = !1, this.networkStateIsPending = !1, this.connectionState = "connected", (r = this._whenConnectionStartedResolve) == null || r.call(this, a), console.info(this.weavyId, "SignalR connected.");
      } catch (o) {
        if (o instanceof mt)
          return console.warn(this.weavyId, "SignalR connection aborted."), a;
        window.navigator.onLine ? !this.signalRAccessTokenRefresh && window.document.visibilityState !== "hidden" && o.toString().includes("Unauthorized") ? (console.info(this.weavyId, "Retrying SignalR connect with fresh token."), this.signalRAccessTokenRefresh = !0) : (console.info(
          this.weavyId,
          "Server is probably down, retrying SignalR connect after a delay or when window regains focus."
        ), this.connectionState = "reconnecting", await new Promise((l) => {
          setTimeout(l, 5e3), window.addEventListener("visibilitychange", l, { once: !0 }), window.addEventListener("offline", l, { once: !0 }), window.addEventListener("online", l, { once: !0 });
        })) : (this.networkStateIsPending = !1, console.info(this.weavyId, "Offline, reconnecting SignalR when online."), await new Promise((l) => {
          window.addEventListener("online", l, { once: !0 });
        })), window.navigator.onLine && (document == null ? void 0 : document.visibilityState) !== "hidden" && await new Promise((l) => setTimeout(l, 1e3)), this.checkVersion(), this.networkStateIsPending = !0, await this.connect();
      }
      return a;
    }
    async subscribe(r, a, o) {
      var l;
      if (this.isDestroyed)
        throw new mt();
      (l = this._resolveConnectionRequested) == null || l.call(this, !0);
      try {
        const c = r ? r + ":" + a : a;
        if (this._connectionEventListeners || await new Promise((h) => queueMicrotask(() => h(!0))), this._connectionEventListeners.some((h) => h.name === c && h.callback === o))
          throw new Error("Duplicate subscribe: " + c);
        if (this._connectionEventListeners.push({ name: c, callback: o }), await this.whenConnectionStarted(), !this._connection)
          throw new Error("Connection not created");
        this._connection.on(c, o), await this._connection.invoke("Subscribe", c);
      } catch (c) {
        c instanceof mt || console.error(this.weavyId, "Error in Subscribe:", c);
      }
    }
    async unsubscribe(r, a, o) {
      var l;
      if (this.isDestroyed)
        throw new mt();
      try {
        const c = r ? r + ":" + a : a, h = this._connectionEventListeners.findIndex((d) => d.name === c && d.callback === o);
        if (h !== -1) {
          if (this._connectionEventListeners.splice(h, 1), await this.whenConnectionStarted(), !this._connection)
            throw new Error("Connection not created");
          (l = this._connection) == null || l.off(c, o), this._connectionEventListeners.some((d) => d.name === c) || await this._connection.invoke("Unsubscribe", c);
        }
      } catch (c) {
        c instanceof mt || console.error(this.weavyId, "Error in Unsubscribe:", c);
      }
    }
    destroy() {
      super.destroy(), this.disconnect(), this._whenConnectionStartedReject && (this._whenConnectionStarted.catch(() => {
      }), this._whenConnectionStartedReject(new mt()));
    }
  }, u(i, "t"), i), p(t, "WeavyConnection"), t;
}, "WeavyConnectionMixin");
var p1 = /* @__PURE__ */ ((s) => (s.JSON = "application/json;charset=utf-8", s.FormData = "multipart/form-data;charset=utf-8", s.URLEncoded = "application/x-www-form-urlencoded;charset=utf-8", s.Text = "text/plain;charset=utf-8", s.Auto = "", s))(p1 || {});
const $q = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // FETCH
    async fetchOptions(r = {}, a = !0) {
      if (this.isDestroyed)
        throw new mt();
      const o = {
        headers: {
          "X-Weavy-Source": `${rn.sourceName}@${rn.version}`,
          "Content-Type": p1.JSON
        },
        method: "GET"
      }, l = Hy(Hy(hq, o, !0), r, !0);
      return a ? Hy(
        l,
        {
          headers: {
            Authorization: "Bearer " + await this.getToken()
          }
        },
        !0
      ) : l;
    }
    async fetch(r, a, o = !0) {
      if (this.isDestroyed)
        throw new mt();
      const l = await this.fetchOptions(a);
      this.networkStateIsPending = !0;
      const c = await fetch(new URL(r, this.url), l);
      if (c.ok)
        this.networkStateIsPending = !1, this.serverState = "ok";
      else if (c.status === 401 || c.status === 403) {
        if (o)
          return await this.getToken(!0), await this.fetch(r, a, !1);
        this.networkStateIsPending = !1, this.serverState = "unauthorized";
      } else
        this.networkStateIsPending = !1;
      return c;
    }
    async upload(r, a, o, l = p1.JSON, c, h = !0) {
      if (this.isDestroyed)
        throw new mt();
      const d = await this.getToken();
      return await new Promise((f, y) => {
        const w = new XMLHttpRequest();
        w.open(a, new URL(r, this.url), !0), w.setRequestHeader("Authorization", "Bearer " + d), w.setRequestHeader("X-Weavy-Source", `${rn.sourceName}@${rn.version}`), l && w.setRequestHeader("Content-Type", l), c && w.upload.addEventListener("progress", (g) => {
          c(g.loaded / g.total * 100 || 100);
        }), w.onload = (g) => {
          h && (w.status === 401 || w.status === 401) ? this.getToken(!0).then(() => this.upload(r, a, o, l, c, !1)).then(f).catch(y) : f(new Response(w.response, { status: w.status, statusText: w.statusText }));
        }, w.onerror = y, w.send(o);
      });
    }
    // DEPRECATED
    async get(r) {
      return console.warn(`weavy.get() is deprecated, use weavy.fetch("${r}") instead.`), this.fetch(r);
    }
    // DEPRECATED
    async post(r, a, o, l) {
      console.warn(
        `weavy.post() is deprecated, use weavy.fetch("${r}", { method: "${a}"}) instead.`
      );
      const c = l ? { "Content-Type": l } : void 0;
      return this.fetch(r, { method: a, body: o, headers: c });
    }
  }, u(i, "t"), i), p(t, "WeavyFetch"), t;
}, "WeavyFetchMixin"), xR = "en", xq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    constructor() {
      super(...arguments), this._locales = /* @__PURE__ */ new Map([
        ["sv-SE", () => import(
          /* webpackIgnore: true */
          /* @vite-ignore */
          new URL("./es/locales/sv-SE.js", typeof WEAVY_IMPORT_URL == "string" && (!import.meta.url || !new URL(import.meta.url).href.startsWith(WEAVY_IMPORT_URL)) ? WEAVY_IMPORT_URL : import.meta.url).href
        ).then((r) => r.svSE)]
      ]), this._locale = t.sourceLocale;
    }
    /**
     * The locale used in the Weavy source.
     */
    static get sourceLocale() {
      try {
        return xR;
      } catch {
        return "";
      }
    }
    get locales() {
      return Array.from(this._locales.entries());
    }
    set locales(r) {
      if (this.isDestroyed)
        throw new mt();
      if (this.localization)
        throw new Error("Locales may only be configured once");
      if (r) {
        if (!Array.isArray(r))
          throw new TypeError("Provided locales have invalid format.");
        r.forEach((a) => {
          if (!Array.isArray(a) || a.length !== 2 || typeof a[0] != "string")
            throw new TypeError("Invalid locale provided: " + a[0]);
          this._locales.set(...a);
        }), this.configureLocalization();
      }
    }
    get localization() {
      return this._localization;
    }
    /**
     * Selected locale. The locale must be pre configured in `.locales`.
     */
    get locale() {
      return this._locale;
    }
    set locale(r) {
      if (this.isDestroyed)
        throw new mt();
      !this.locale && !r || (r || (r = t.sourceLocale), this._locale = r, this.localization ? this.localization.setLocale(this.locale) : queueMicrotask(() => {
        this.localization ? this.localization.setLocale(this.locale) : this.locale !== t.sourceLocale && (this._locales.has(this.locale) && this.configureLocalization(), this.localization ? this.localization.setLocale(this.locale) : console.error(
          this.weavyId,
          `You need to configure additional languages in config to use '${r}'.`
        ));
      }));
    }
    async loadLocale(r) {
      var a;
      if (this.isDestroyed)
        throw new mt();
      if ((a = this._locales) != null && a.has(r)) {
        const o = this._locales.get(r);
        return console.info(
          this.weavyId,
          typeof o == "function" ? "loading locale" : "preloaded locale",
          r
        ), await (typeof o == "function" ? o() : o);
      } else
        throw new Error("The requested locale is not configured");
    }
    configureLocalization() {
      var r;
      if (this.isDestroyed)
        throw new mt();
      if ((r = this._locales) != null && r.size && !this.localization) {
        const a = this._locales.keys();
        console.info(this.weavyId, "Configuring locales", a);
        const { getLocale: o, setLocale: l } = qD({
          sourceLocale: t.sourceLocale,
          targetLocales: a,
          loadLocale: /* @__PURE__ */ p((c) => this.loadLocale(c), "loadLocale")
        });
        this._localization = {
          getLocale: o,
          setLocale: l
        };
      }
    }
  }, u(i, "t"), i), p(t, "WeavyLocalization"), t;
}, "WeavyLocalizationMixin"), kq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), this._networkEvents = /* @__PURE__ */ new Set(), this._connectionState = "connecting", this._serverState = "ok", this._networkState = window.navigator.onLine ? "online" : "offline", this._networkStateIsPending = !1, window.addEventListener("online", () => {
        this.networkState = "online";
      }), window.addEventListener("offline", () => {
        this.networkState = "offline", this.networkStateIsPending = !1;
      });
    }
    get networkState() {
      return this._networkState;
    }
    set networkState(r) {
      this._networkState = r, this.triggerNetworkChange();
    }
    get serverState() {
      return this._serverState;
    }
    set serverState(r) {
      this._serverState = r, this.triggerNetworkChange();
    }
    get connectionState() {
      return this._connectionState;
    }
    set connectionState(r) {
      this._connectionState = r, this.triggerNetworkChange();
    }
    get networkStateIsPending() {
      return this._networkStateIsPending;
    }
    set networkStateIsPending(r) {
      this._networkStateIsPending = r, this.triggerNetworkChange();
    }
    get network() {
      return {
        state: this._networkState === "online" ? this._connectionState === "connected" || this._serverState === "ok" ? "online" : "unreachable" : "offline",
        isPending: this._networkStateIsPending
      };
    }
    triggerNetworkChange() {
      const r = this.network;
      this._networkEvents.forEach((a) => {
        a(r);
      });
    }
    addNetworkListener(r) {
      this._networkEvents.add(r);
    }
    removeNetworkListener(r) {
      this._networkEvents.delete(r);
    }
  }, u(i, "t"), i), p(t, "WeavyNetwork"), t;
}, "WeavyNetworkMixin");
function ag() {
}
u(ag, "kd");
p(ag, "noop");
function kR({
  storage: s,
  key: t = "REACT_QUERY_OFFLINE_CACHE",
  throttleTime: i = 1e3,
  serialize: n = JSON.stringify,
  deserialize: r = JSON.parse,
  retry: a
}) {
  if (s) {
    const o = /* @__PURE__ */ p((l) => {
      try {
        s.setItem(t, n(l));
        return;
      } catch (c) {
        return c;
      }
    }, "trySave");
    return {
      persistClient: SR((l) => {
        let c = l, h = o(c), d = 0;
        for (; h && c; )
          d++, c = a == null ? void 0 : a({
            persistedClient: c,
            error: h,
            errorCount: d
          }), c && (h = o(c));
      }, i),
      restoreClient: /* @__PURE__ */ p(() => {
        const l = s.getItem(t);
        if (l)
          return r(l);
      }, "restoreClient"),
      removeClient: /* @__PURE__ */ p(() => {
        s.removeItem(t);
      }, "removeClient")
    };
  }
  return {
    persistClient: ag,
    restoreClient: ag,
    removeClient: ag
  };
}
u(kR, "z1");
p(kR, "createSyncStoragePersister");
function SR(s, t = 100) {
  let i = null, n;
  return function(...r) {
    n = r, i === null && (i = setTimeout(() => {
      s(...n), i = null;
    }, t));
  };
}
u(SR, "S1");
p(SR, "throttle$2");
var Sq = ["added", "removed", "updated"];
function d$(s) {
  return Sq.includes(s);
}
u(d$, "tu");
p(d$, "isCacheEventType");
async function PR({
  queryClient: s,
  persister: t,
  maxAge: i = 1e3 * 60 * 60 * 24,
  buster: n = "",
  hydrateOptions: r
}) {
  try {
    const a = await t.restoreClient();
    if (a)
      if (a.timestamp) {
        const o = Date.now() - a.timestamp > i, l = a.buster !== n;
        o || l ? t.removeClient() : hR(s, a.clientState, r);
      } else
        t.removeClient();
  } catch {
    t.removeClient();
  }
}
u(PR, "O1");
p(PR, "persistQueryClientRestore");
async function u$({
  queryClient: s,
  persister: t,
  buster: i = "",
  dehydrateOptions: n
}) {
  const r = {
    buster: i,
    timestamp: Date.now(),
    clientState: cR(s, n)
  };
  await t.persistClient(r);
}
u(u$, "eu");
p(u$, "persistQueryClientSave");
function CR(s) {
  const t = s.queryClient.getQueryCache().subscribe((n) => {
    d$(n.type) && u$(s);
  }), i = s.queryClient.getMutationCache().subscribe((n) => {
    d$(n.type) && u$(s);
  });
  return () => {
    t(), i();
  };
}
u(CR, "A1");
p(CR, "persistQueryClientSubscribe");
const Pq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // QUERY CLIENT
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), this._queryClient = new wq({
        defaultOptions: {
          queries: {
            staleTime: this.staleTime,
            gcTime: this.gcTime
          }
        }
      }), this.initQueryClient();
    }
    get queryClient() {
      return this._queryClient;
    }
    async initQueryClient() {
      if (this.isDestroyed)
        throw new mt();
      await this.whenUrl();
      try {
        this._sessionStoragePersister = kR({
          key: "WEAVY_QUERY_OFFLINE_CACHE",
          storage: window.sessionStorage,
          throttleTime: this.staleTime
        });
        const r = {
          queryClient: this._queryClient,
          persister: this._sessionStoragePersister,
          maxAge: this.gcTime,
          // 24h - should match gcTime
          buster: this.cachePrefix,
          // Cache busting parameter (build hash or similar)
          hydrateOptions: void 0,
          dehydrateOptions: {
            shouldDehydrateMutation: /* @__PURE__ */ p((a) => {
              var o, l;
              const c = ((l = (o = a.state.context) == null ? void 0 : o.status) == null ? void 0 : l.state) === "pending";
              return !!(a.state.context && !c || a.state.isPaused);
            }, "shouldDehydrateMutation")
          }
        };
        await PR(r), this._unsubscribeQueryClient = CR(r);
      } catch {
        console.warn(this.weavyId, "Query cache persister not available.");
      }
      this.host.isConnected && this._queryClient.mount(), this._hostIsConnectedObserver = c3(this.host, (r) => {
        this.isDestroyed || (r ? (console.info(this.weavyId, "Query client mounted"), this._queryClient.mount()) : (console.info(this.weavyId, "Query client unmounted"), this._queryClient.unmount()));
      });
    }
    async disconnectQueryClient() {
      var r, a;
      console.info(this.weavyId, "Query client disconnected"), await this._queryClient.cancelQueries(), this.queryClient.setQueriesData({}, void 0), this.queryClient.resetQueries(), (r = this._sessionStoragePersister) == null || r.removeClient(), (a = this._unsubscribeQueryClient) == null || a.call(this), this._queryClient.unmount(), this._queryClient.clear();
    }
    destroy() {
      var r;
      super.destroy(), (r = this._hostIsConnectedObserver) == null || r.disconnect(), this.disconnectQueryClient();
    }
  }, u(i, "t"), i), p(t, "WeavyQuery"), t;
}, "WeavyQueryMixin"), Cq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), this._notificationEvents = rn.defaults.notificationEvents ?? !1, this.dispatchRealtimeEvent = (a) => {
        Bt();
        const o = this.host !== document.documentElement ? { composed: !0 } : { bubbles: !0 };
        switch (a.action) {
          case "notification_created":
          case "notification_updated":
          case "notification_deleted":
          case "notifications_marked": {
            const l = new CustomEvent("wy-notifications", {
              ...o,
              detail: a
            });
            this.host.dispatchEvent(l);
          }
        }
      };
    }
    get notificationEvents() {
      return this._notificationEvents;
    }
    set notificationEvents(r) {
      this.realtimeUnsubscribe(), this._notificationEvents = r ?? !1, this.realtimeSubscribe();
    }
    async realtimeSubscribe() {
      const r = this;
      this.notificationEvents && (r.subscribe(null, "notification_created", this.dispatchRealtimeEvent), r.subscribe(null, "notification_updated", this.dispatchRealtimeEvent), r.subscribe(null, "notifications_marked", this.dispatchRealtimeEvent));
    }
    realtimeUnsubscribe() {
      const r = this;
      this.notificationEvents && (r.unsubscribe(null, "notification_created", this.dispatchRealtimeEvent), r.unsubscribe(null, "notification_updated", this.dispatchRealtimeEvent), r.unsubscribe(null, "notifications_marked", this.dispatchRealtimeEvent));
    }
    destroy() {
      this.realtimeUnsubscribe(), super.destroy();
    }
  }, u(i, "t"), i), p(t, "WeavyRealtime"), t;
}, "WeavyRealtimeMixin");
function ri(s) {
  return s < 0 ? -1 : s === 0 ? 0 : 1;
}
u(ri, "Ce");
p(ri, "signum");
function mc(s, t, i) {
  return (1 - i) * s + i * t;
}
u(mc, "Co");
p(mc, "lerp");
function QR(s, t, i) {
  return i < s ? s : i > t ? t : i;
}
u(QR, "I1");
p(QR, "clampInt");
function bm(s, t, i) {
  return i < s ? s : i > t ? t : i;
}
u(bm, "Hc");
p(bm, "clampDouble");
function lv(s) {
  return s = s % 360, s < 0 && (s = s + 360), s;
}
u(lv, "Ah");
p(lv, "sanitizeDegreesDouble");
function TR(s, t) {
  return lv(t - s) <= 180 ? 1 : -1;
}
u(TR, "T1");
p(TR, "rotationDirection");
function MR(s, t) {
  return 180 - Math.abs(Math.abs(s - t) - 180);
}
u(MR, "F1");
p(MR, "differenceDegrees");
function f1(s, t) {
  const i = s[0] * t[0][0] + s[1] * t[0][1] + s[2] * t[0][2], n = s[0] * t[1][0] + s[1] * t[1][1] + s[2] * t[1][2], r = s[0] * t[2][0] + s[1] * t[2][1] + s[2] * t[2][2];
  return [i, n, r];
}
u(f1, "Qd");
p(f1, "matrixMultiply");
const Qq = [
  [0.41233895, 0.35762064, 0.18051042],
  [0.2126, 0.7152, 0.0722],
  [0.01932141, 0.11916382, 0.95034478]
], Tq = [
  [
    3.2413774792388685,
    -1.5376652402851851,
    -0.49885366846268053
  ],
  [
    -0.9691452513005321,
    1.8758853451067872,
    0.04156585616912061
  ],
  [
    0.05562093689691305,
    -0.20395524564742123,
    1.0571799111220335
  ]
], Mq = [95.047, 100, 108.883];
function cv(s, t, i) {
  return (255 << 24 | (s & 255) << 16 | (t & 255) << 8 | i & 255) >>> 0;
}
u(cv, "Lh");
p(cv, "argbFromRgb");
function p$(s) {
  const t = ir(s[0]), i = ir(s[1]), n = ir(s[2]);
  return cv(t, i, n);
}
u(p$, "iu");
p(p$, "argbFromLinrgb");
function t5(s) {
  return s >> 16 & 255;
}
u(t5, "Ay");
p(t5, "redFromArgb");
function i5(s) {
  return s >> 8 & 255;
}
u(i5, "Ly");
p(i5, "greenFromArgb");
function n5(s) {
  return s & 255;
}
u(n5, "Ry");
p(n5, "blueFromArgb");
function RR(s, t, i) {
  const n = Tq, r = n[0][0] * s + n[0][1] * t + n[0][2] * i, a = n[1][0] * s + n[1][1] * t + n[1][2] * i, o = n[2][0] * s + n[2][1] * t + n[2][2] * i, l = ir(r), c = ir(a), h = ir(o);
  return cv(l, c, h);
}
u(RR, "B1");
p(RR, "argbFromXyz");
function AR(s) {
  const t = Qa(t5(s)), i = Qa(i5(s)), n = Qa(n5(s));
  return f1([t, i, n], Qq);
}
u(AR, "U1");
p(AR, "xyzFromArgb");
function ER(s) {
  const t = ws(s), i = ir(t);
  return cv(i, i, i);
}
u(ER, "q1");
p(ER, "argbFromLstar");
function y1(s) {
  const t = AR(s)[1];
  return 116 * s5(t / 100) - 16;
}
u(y1, "Kd");
p(y1, "lstarFromArgb");
function ws(s) {
  return 100 * _R((s + 16) / 116);
}
u(ws, "rs");
p(ws, "yFromLstar");
function m1(s) {
  return s5(s / 100) * 116 - 16;
}
u(m1, "Gd");
p(m1, "lstarFromY");
function Qa(s) {
  const t = s / 255;
  return t <= 0.040449936 ? t / 12.92 * 100 : Math.pow((t + 0.055) / 1.055, 2.4) * 100;
}
u(Qa, "Er");
p(Qa, "linearized");
function ir(s) {
  const t = s / 100;
  let i = 0;
  return t <= 31308e-7 ? i = t * 12.92 : i = 1.055 * Math.pow(t, 1 / 2.4) - 0.055, QR(0, 255, Math.round(i * 255));
}
u(ir, "Ds");
p(ir, "delinearized");
function zR() {
  return Mq;
}
u(zR, "N1");
p(zR, "whitePointD65");
function s5(s) {
  const t = 0.008856451679035631, i = 24389 / 27;
  return s > t ? Math.pow(s, 1 / 3) : (i * s + 16) / 116;
}
u(s5, "Iy");
p(s5, "labF");
function _R(s) {
  const t = 0.008856451679035631, i = 24389 / 27, n = s * s * s;
  return n > t ? n : (116 * s - 16) / i;
}
u(_R, "j1");
p(_R, "labInvf");
var po;
const LR = (po = class {
  /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */
  static make(t = zR(), i = 200 / Math.PI * ws(50) / 100, n = 50, r = 2, a = !1) {
    const o = t, l = o[0] * 0.401288 + o[1] * 0.650173 + o[2] * -0.051461, c = o[0] * -0.250268 + o[1] * 1.204414 + o[2] * 0.045854, h = o[0] * -2079e-6 + o[1] * 0.048952 + o[2] * 0.953127, d = 0.8 + r / 10, f = d >= 0.9 ? mc(0.59, 0.69, (d - 0.9) * 10) : mc(0.525, 0.59, (d - 0.8) * 10);
    let y = a ? 1 : d * (1 - 1 / 3.6 * Math.exp((-i - 42) / 92));
    y = y > 1 ? 1 : y < 0 ? 0 : y;
    const w = d, g = [
      y * (100 / l) + 1 - y,
      y * (100 / c) + 1 - y,
      y * (100 / h) + 1 - y
    ], b = 1 / (5 * i + 1), k = b * b * b * b, $ = 1 - k, C = k * i + 0.1 * $ * $ * Math.cbrt(5 * i), E = ws(n) / t[1], A = 1.48 + Math.sqrt(E), R = 0.725 / Math.pow(E, 0.2), L = R, I = [
      Math.pow(C * g[0] * l / 100, 0.42),
      Math.pow(C * g[1] * c / 100, 0.42),
      Math.pow(C * g[2] * h / 100, 0.42)
    ], D = [
      400 * I[0] / (I[0] + 27.13),
      400 * I[1] / (I[1] + 27.13),
      400 * I[2] / (I[2] + 27.13)
    ], j = (2 * D[0] + D[1] + 0.05 * D[2]) * R;
    return new po(E, j, R, L, f, w, g, C, Math.pow(C, 0.25), A);
  }
  /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */
  constructor(t, i, n, r, a, o, l, c, h, d) {
    this.n = t, this.aw = i, this.nbb = n, this.ncb = r, this.c = a, this.nc = o, this.rgbD = l, this.fl = c, this.fLRoot = h, this.z = d;
  }
}, u(po, "pl"), po);
p(LR, "ViewingConditions");
let gs = LR;
gs.DEFAULT = gs.make();
var Mi;
const IR = (Mi = class {
  /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */
  constructor(t, i, n, r, a, o, l, c, h) {
    this.hue = t, this.chroma = i, this.j = n, this.q = r, this.m = a, this.s = o, this.jstar = l, this.astar = c, this.bstar = h;
  }
  /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */
  distance(t) {
    const i = this.jstar - t.jstar, n = this.astar - t.astar, r = this.bstar - t.bstar, a = Math.sqrt(i * i + n * n + r * r);
    return 1.41 * Math.pow(a, 0.63);
  }
  /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */
  static fromInt(t) {
    return Mi.fromIntInViewingConditions(t, gs.DEFAULT);
  }
  /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */
  static fromIntInViewingConditions(t, i) {
    const n = (t & 16711680) >> 16, r = (t & 65280) >> 8, a = t & 255, o = Qa(n), l = Qa(r), c = Qa(a), h = 0.41233895 * o + 0.35762064 * l + 0.18051042 * c, d = 0.2126 * o + 0.7152 * l + 0.0722 * c, f = 0.01932141 * o + 0.11916382 * l + 0.95034478 * c, y = 0.401288 * h + 0.650173 * d - 0.051461 * f, w = -0.250268 * h + 1.204414 * d + 0.045854 * f, g = -2079e-6 * h + 0.048952 * d + 0.953127 * f, b = i.rgbD[0] * y, k = i.rgbD[1] * w, $ = i.rgbD[2] * g, C = Math.pow(i.fl * Math.abs(b) / 100, 0.42), E = Math.pow(i.fl * Math.abs(k) / 100, 0.42), A = Math.pow(i.fl * Math.abs($) / 100, 0.42), R = ri(b) * 400 * C / (C + 27.13), L = ri(k) * 400 * E / (E + 27.13), I = ri($) * 400 * A / (A + 27.13), D = (11 * R + -12 * L + I) / 11, j = (R + L - 2 * I) / 9, ee = (20 * R + 20 * L + 21 * I) / 20, se = (40 * R + 20 * L + I) / 20, oe = Math.atan2(j, D) * 180 / Math.PI, we = oe < 0 ? oe + 360 : oe >= 360 ? oe - 360 : oe, re = we * Math.PI / 180, _e = se * i.nbb, Pe = 100 * Math.pow(_e / i.aw, i.c * i.z), He = 4 / i.c * Math.sqrt(Pe / 100) * (i.aw + 4) * i.fLRoot, We = we < 20.14 ? we + 360 : we, ft = 0.25 * (Math.cos(We * Math.PI / 180 + 2) + 3.8), Ct = 5e4 / 13 * ft * i.nc * i.ncb * Math.sqrt(D * D + j * j) / (ee + 0.305), xt = Math.pow(Ct, 0.9) * Math.pow(1.64 - Math.pow(0.29, i.n), 0.73), Yt = xt * Math.sqrt(Pe / 100), ni = Yt * i.fLRoot, Gt = 50 * Math.sqrt(xt * i.c / (i.aw + 4)), Jn = (1 + 100 * 7e-3) * Pe / (1 + 7e-3 * Pe), Is = 1 / 0.0228 * Math.log(1 + 0.0228 * ni), mw = Is * Math.cos(re), Ho = Is * Math.sin(re);
    return new Mi(we, Yt, Pe, He, ni, Gt, Jn, mw, Ho);
  }
  /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */
  static fromJch(t, i, n) {
    return Mi.fromJchInViewingConditions(t, i, n, gs.DEFAULT);
  }
  /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */
  static fromJchInViewingConditions(t, i, n, r) {
    const a = 4 / r.c * Math.sqrt(t / 100) * (r.aw + 4) * r.fLRoot, o = i * r.fLRoot, l = i / Math.sqrt(t / 100), c = 50 * Math.sqrt(l * r.c / (r.aw + 4)), h = n * Math.PI / 180, d = (1 + 100 * 7e-3) * t / (1 + 7e-3 * t), f = 1 / 0.0228 * Math.log(1 + 0.0228 * o), y = f * Math.cos(h), w = f * Math.sin(h);
    return new Mi(n, i, t, a, o, c, d, y, w);
  }
  /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */
  static fromUcs(t, i, n) {
    return Mi.fromUcsInViewingConditions(t, i, n, gs.DEFAULT);
  }
  /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */
  static fromUcsInViewingConditions(t, i, n, r) {
    const a = i, o = n, l = Math.sqrt(a * a + o * o), c = (Math.exp(l * 0.0228) - 1) / 0.0228 / r.fLRoot;
    let h = Math.atan2(o, a) * (180 / Math.PI);
    h < 0 && (h += 360);
    const d = t / (1 - (t - 100) * 7e-3);
    return Mi.fromJchInViewingConditions(d, c, h, r);
  }
  /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */
  toInt() {
    return this.viewed(gs.DEFAULT);
  }
  /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */
  viewed(t) {
    const i = this.chroma === 0 || this.j === 0 ? 0 : this.chroma / Math.sqrt(this.j / 100), n = Math.pow(i / Math.pow(1.64 - Math.pow(0.29, t.n), 0.73), 1 / 0.9), r = this.hue * Math.PI / 180, a = 0.25 * (Math.cos(r + 2) + 3.8), o = t.aw * Math.pow(this.j / 100, 1 / t.c / t.z), l = a * (5e4 / 13) * t.nc * t.ncb, c = o / t.nbb, h = Math.sin(r), d = Math.cos(r), f = 23 * (c + 0.305) * n / (23 * l + 11 * n * d + 108 * n * h), y = f * d, w = f * h, g = (460 * c + 451 * y + 288 * w) / 1403, b = (460 * c - 891 * y - 261 * w) / 1403, k = (460 * c - 220 * y - 6300 * w) / 1403, $ = Math.max(0, 27.13 * Math.abs(g) / (400 - Math.abs(g))), C = ri(g) * (100 / t.fl) * Math.pow($, 1 / 0.42), E = Math.max(0, 27.13 * Math.abs(b) / (400 - Math.abs(b))), A = ri(b) * (100 / t.fl) * Math.pow(E, 1 / 0.42), R = Math.max(0, 27.13 * Math.abs(k) / (400 - Math.abs(k))), L = ri(k) * (100 / t.fl) * Math.pow(R, 1 / 0.42), I = C / t.rgbD[0], D = A / t.rgbD[1], j = L / t.rgbD[2], ee = 1.86206786 * I - 1.01125463 * D + 0.14918677 * j, se = 0.38752654 * I + 0.62144744 * D - 897398e-8 * j, oe = -0.0158415 * I - 0.03412294 * D + 1.04996444 * j;
    return RR(ee, se, oe);
  }
  /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
  /// CAM16.
  static fromXyzInViewingConditions(t, i, n, r) {
    const a = 0.401288 * t + 0.650173 * i - 0.051461 * n, o = -0.250268 * t + 1.204414 * i + 0.045854 * n, l = -2079e-6 * t + 0.048952 * i + 0.953127 * n, c = r.rgbD[0] * a, h = r.rgbD[1] * o, d = r.rgbD[2] * l, f = Math.pow(r.fl * Math.abs(c) / 100, 0.42), y = Math.pow(r.fl * Math.abs(h) / 100, 0.42), w = Math.pow(r.fl * Math.abs(d) / 100, 0.42), g = ri(c) * 400 * f / (f + 27.13), b = ri(h) * 400 * y / (y + 27.13), k = ri(d) * 400 * w / (w + 27.13), $ = (11 * g + -12 * b + k) / 11, C = (g + b - 2 * k) / 9, E = (20 * g + 20 * b + 21 * k) / 20, A = (40 * g + 20 * b + k) / 20, R = Math.atan2(C, $) * 180 / Math.PI, L = R < 0 ? R + 360 : R >= 360 ? R - 360 : R, I = L * Math.PI / 180, D = A * r.nbb, j = 100 * Math.pow(D / r.aw, r.c * r.z), ee = 4 / r.c * Math.sqrt(j / 100) * (r.aw + 4) * r.fLRoot, se = L < 20.14 ? L + 360 : L, oe = 1 / 4 * (Math.cos(se * Math.PI / 180 + 2) + 3.8), we = 5e4 / 13 * oe * r.nc * r.ncb * Math.sqrt($ * $ + C * C) / (E + 0.305), re = Math.pow(we, 0.9) * Math.pow(1.64 - Math.pow(0.29, r.n), 0.73), _e = re * Math.sqrt(j / 100), Pe = _e * r.fLRoot, He = 50 * Math.sqrt(re * r.c / (r.aw + 4)), We = (1 + 100 * 7e-3) * j / (1 + 7e-3 * j), ft = Math.log(1 + 0.0228 * Pe) / 0.0228, Ct = ft * Math.cos(I), xt = ft * Math.sin(I);
    return new Mi(L, _e, j, ee, Pe, He, We, Ct, xt);
  }
  /// XYZ representation of CAM16 seen in [viewingConditions].
  xyzInViewingConditions(t) {
    const i = this.chroma === 0 || this.j === 0 ? 0 : this.chroma / Math.sqrt(this.j / 100), n = Math.pow(i / Math.pow(1.64 - Math.pow(0.29, t.n), 0.73), 1 / 0.9), r = this.hue * Math.PI / 180, a = 0.25 * (Math.cos(r + 2) + 3.8), o = t.aw * Math.pow(this.j / 100, 1 / t.c / t.z), l = a * (5e4 / 13) * t.nc * t.ncb, c = o / t.nbb, h = Math.sin(r), d = Math.cos(r), f = 23 * (c + 0.305) * n / (23 * l + 11 * n * d + 108 * n * h), y = f * d, w = f * h, g = (460 * c + 451 * y + 288 * w) / 1403, b = (460 * c - 891 * y - 261 * w) / 1403, k = (460 * c - 220 * y - 6300 * w) / 1403, $ = Math.max(0, 27.13 * Math.abs(g) / (400 - Math.abs(g))), C = ri(g) * (100 / t.fl) * Math.pow($, 1 / 0.42), E = Math.max(0, 27.13 * Math.abs(b) / (400 - Math.abs(b))), A = ri(b) * (100 / t.fl) * Math.pow(E, 1 / 0.42), R = Math.max(0, 27.13 * Math.abs(k) / (400 - Math.abs(k))), L = ri(k) * (100 / t.fl) * Math.pow(R, 1 / 0.42), I = C / t.rgbD[0], D = A / t.rgbD[1], j = L / t.rgbD[2], ee = 1.86206786 * I - 1.01125463 * D + 0.14918677 * j, se = 0.38752654 * I + 0.62144744 * D - 897398e-8 * j, oe = -0.0158415 * I - 0.03412294 * D + 1.04996444 * j;
    return [ee, se, oe];
  }
}, u(Mi, "oi"), Mi);
p(IR, "Cam16");
let En = IR;
var ge;
const WR = (ge = class {
  /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */
  static sanitizeRadians(t) {
    return (t + Math.PI * 8) % (Math.PI * 2);
  }
  /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */
  static trueDelinearized(t) {
    const i = t / 100;
    let n = 0;
    return i <= 31308e-7 ? n = i * 12.92 : n = 1.055 * Math.pow(i, 1 / 2.4) - 0.055, n * 255;
  }
  static chromaticAdaptation(t) {
    const i = Math.pow(Math.abs(t), 0.42);
    return ri(t) * 400 * i / (i + 27.13);
  }
  /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */
  static hueOf(t) {
    const i = f1(t, ge.SCALED_DISCOUNT_FROM_LINRGB), n = ge.chromaticAdaptation(i[0]), r = ge.chromaticAdaptation(i[1]), a = ge.chromaticAdaptation(i[2]), o = (11 * n + -12 * r + a) / 11, l = (n + r - 2 * a) / 9;
    return Math.atan2(l, o);
  }
  static areInCyclicOrder(t, i, n) {
    const r = ge.sanitizeRadians(i - t), a = ge.sanitizeRadians(n - t);
    return r < a;
  }
  /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */
  static intercept(t, i, n) {
    return (i - t) / (n - t);
  }
  static lerpPoint(t, i, n) {
    return [
      t[0] + (n[0] - t[0]) * i,
      t[1] + (n[1] - t[1]) * i,
      t[2] + (n[2] - t[2]) * i
    ];
  }
  /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */
  static setCoordinate(t, i, n, r) {
    const a = ge.intercept(t[r], i, n[r]);
    return ge.lerpPoint(t, a, n);
  }
  static isBounded(t) {
    return 0 <= t && t <= 100;
  }
  /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */
  static nthVertex(t, i) {
    const n = ge.Y_FROM_LINRGB[0], r = ge.Y_FROM_LINRGB[1], a = ge.Y_FROM_LINRGB[2], o = i % 4 <= 1 ? 0 : 100, l = i % 2 === 0 ? 0 : 100;
    if (i < 4) {
      const c = o, h = l, d = (t - c * r - h * a) / n;
      return ge.isBounded(d) ? [d, c, h] : [-1, -1, -1];
    } else if (i < 8) {
      const c = o, h = l, d = (t - h * n - c * a) / r;
      return ge.isBounded(d) ? [h, d, c] : [-1, -1, -1];
    } else {
      const c = o, h = l, d = (t - c * n - h * r) / a;
      return ge.isBounded(d) ? [c, h, d] : [-1, -1, -1];
    }
  }
  /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */
  static bisectToSegment(t, i) {
    let n = [-1, -1, -1], r = n, a = 0, o = 0, l = !1, c = !0;
    for (let h = 0; h < 12; h++) {
      const d = ge.nthVertex(t, h);
      if (d[0] < 0)
        continue;
      const f = ge.hueOf(d);
      if (!l) {
        n = d, r = d, a = f, o = f, l = !0;
        continue;
      }
      (c || ge.areInCyclicOrder(a, f, o)) && (c = !1, ge.areInCyclicOrder(a, i, f) ? (r = d, o = f) : (n = d, a = f));
    }
    return [n, r];
  }
  static midpoint(t, i) {
    return [
      (t[0] + i[0]) / 2,
      (t[1] + i[1]) / 2,
      (t[2] + i[2]) / 2
    ];
  }
  static criticalPlaneBelow(t) {
    return Math.floor(t - 0.5);
  }
  static criticalPlaneAbove(t) {
    return Math.ceil(t - 0.5);
  }
  /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */
  static bisectToLimit(t, i) {
    const n = ge.bisectToSegment(t, i);
    let r = n[0], a = ge.hueOf(r), o = n[1];
    for (let l = 0; l < 3; l++)
      if (r[l] !== o[l]) {
        let c = -1, h = 255;
        r[l] < o[l] ? (c = ge.criticalPlaneBelow(ge.trueDelinearized(r[l])), h = ge.criticalPlaneAbove(ge.trueDelinearized(o[l]))) : (c = ge.criticalPlaneAbove(ge.trueDelinearized(r[l])), h = ge.criticalPlaneBelow(ge.trueDelinearized(o[l])));
        for (let d = 0; d < 8 && !(Math.abs(h - c) <= 1); d++) {
          const f = Math.floor((c + h) / 2), y = ge.CRITICAL_PLANES[f], w = ge.setCoordinate(r, y, o, l), g = ge.hueOf(w);
          ge.areInCyclicOrder(a, i, g) ? (o = w, h = f) : (r = w, a = g, c = f);
        }
      }
    return ge.midpoint(r, o);
  }
  static inverseChromaticAdaptation(t) {
    const i = Math.abs(t), n = Math.max(0, 27.13 * i / (400 - i));
    return ri(t) * Math.pow(n, 1 / 0.42);
  }
  /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */
  static findResultByJ(t, i, n) {
    let r = Math.sqrt(n) * 11;
    const a = gs.DEFAULT, o = 1 / Math.pow(1.64 - Math.pow(0.29, a.n), 0.73), l = 0.25 * (Math.cos(t + 2) + 3.8) * (5e4 / 13) * a.nc * a.ncb, c = Math.sin(t), h = Math.cos(t);
    for (let d = 0; d < 5; d++) {
      const f = r / 100, y = i === 0 || r === 0 ? 0 : i / Math.sqrt(f), w = Math.pow(y * o, 1 / 0.9), g = a.aw * Math.pow(f, 1 / a.c / a.z) / a.nbb, b = 23 * (g + 0.305) * w / (23 * l + 11 * w * h + 108 * w * c), k = b * h, $ = b * c, C = (460 * g + 451 * k + 288 * $) / 1403, E = (460 * g - 891 * k - 261 * $) / 1403, A = (460 * g - 220 * k - 6300 * $) / 1403, R = ge.inverseChromaticAdaptation(C), L = ge.inverseChromaticAdaptation(E), I = ge.inverseChromaticAdaptation(A), D = f1([R, L, I], ge.LINRGB_FROM_SCALED_DISCOUNT);
      if (D[0] < 0 || D[1] < 0 || D[2] < 0)
        return 0;
      const j = ge.Y_FROM_LINRGB[0], ee = ge.Y_FROM_LINRGB[1], se = ge.Y_FROM_LINRGB[2], oe = j * D[0] + ee * D[1] + se * D[2];
      if (oe <= 0)
        return 0;
      if (d === 4 || Math.abs(oe - n) < 2e-3)
        return D[0] > 100.01 || D[1] > 100.01 || D[2] > 100.01 ? 0 : p$(D);
      r = r - (oe - n) * r / (2 * oe);
    }
    return 0;
  }
  /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */
  static solveToInt(t, i, n) {
    if (i < 1e-4 || n < 1e-4 || n > 99.9999)
      return ER(n);
    t = lv(t);
    const r = t / 180 * Math.PI, a = ws(n), o = ge.findResultByJ(r, i, a);
    if (o !== 0)
      return o;
    const l = ge.bisectToLimit(a, r);
    return p$(l);
  }
  /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */
  static solveToCam(t, i, n) {
    return En.fromInt(ge.solveToInt(t, i, n));
  }
}, u(ge, "it"), ge);
p(WR, "HctSolver");
let Js = WR;
Js.SCALED_DISCOUNT_FROM_LINRGB = [
  [
    0.001200833568784504,
    0.002389694492170889,
    2795742885861124e-19
  ],
  [
    5891086651375999e-19,
    0.0029785502573438758,
    3270666104008398e-19
  ],
  [
    10146692491640572e-20,
    5364214359186694e-19,
    0.0032979401770712076
  ]
];
Js.LINRGB_FROM_SCALED_DISCOUNT = [
  [
    1373.2198709594231,
    -1100.4251190754821,
    -7.278681089101213
  ],
  [
    -271.815969077903,
    559.6580465940733,
    -32.46047482791194
  ],
  [
    1.9622899599665666,
    -57.173814538844006,
    308.7233197812385
  ]
];
Js.Y_FROM_LINRGB = [0.2126, 0.7152, 0.0722];
Js.CRITICAL_PLANES = [
  0.015176349177441876,
  0.045529047532325624,
  0.07588174588720938,
  0.10623444424209313,
  0.13658714259697685,
  0.16693984095186062,
  0.19729253930674434,
  0.2276452376616281,
  0.2579979360165119,
  0.28835063437139563,
  0.3188300904430532,
  0.350925934958123,
  0.3848314933096426,
  0.42057480301049466,
  0.458183274052838,
  0.4976837250274023,
  0.5391024159806381,
  0.5824650784040898,
  0.6277969426914107,
  0.6751227633498623,
  0.7244668422128921,
  0.775853049866786,
  0.829304845476233,
  0.8848452951698498,
  0.942497089126609,
  1.0022825574869039,
  1.0642236851973577,
  1.1283421258858297,
  1.1946592148522128,
  1.2631959812511864,
  1.3339731595349034,
  1.407011200216447,
  1.4823302800086415,
  1.5599503113873272,
  1.6398909516233677,
  1.7221716113234105,
  1.8068114625156377,
  1.8938294463134073,
  1.9832442801866852,
  2.075074464868551,
  2.1693382909216234,
  2.2660538449872063,
  2.36523901573795,
  2.4669114995532007,
  2.5710888059345764,
  2.6777882626779785,
  2.7870270208169257,
  2.898822059350997,
  3.0131901897720907,
  3.1301480604002863,
  3.2497121605402226,
  3.3718988244681087,
  3.4967242352587946,
  3.624204428461639,
  3.754355295633311,
  3.887192587735158,
  4.022731918402185,
  4.160988767090289,
  4.301978482107941,
  4.445716283538092,
  4.592217266055746,
  4.741496401646282,
  4.893568542229298,
  5.048448422192488,
  5.20615066083972,
  5.3666897647573375,
  5.5300801301023865,
  5.696336044816294,
  5.865471690767354,
  6.037501145825082,
  6.212438385869475,
  6.390297286737924,
  6.571091626112461,
  6.7548350853498045,
  6.941541251256611,
  7.131223617812143,
  7.323895587840543,
  7.5195704746346665,
  7.7182615035334345,
  7.919981813454504,
  8.124744458384042,
  8.332562408825165,
  8.543448553206703,
  8.757415699253682,
  8.974476575321063,
  9.194643831691977,
  9.417930041841839,
  9.644347703669503,
  9.873909240696694,
  10.106627003236781,
  10.342513269534024,
  10.58158024687427,
  10.8238400726681,
  11.069304815507364,
  11.317986476196008,
  11.569896988756009,
  11.825048221409341,
  12.083451977536606,
  12.345119996613247,
  12.610063955123938,
  12.878295467455942,
  13.149826086772048,
  13.42466730586372,
  13.702830557985108,
  13.984327217668513,
  14.269168601521828,
  14.55736596900856,
  14.848930523210871,
  15.143873411576273,
  15.44220572664832,
  15.743938506781891,
  16.04908273684337,
  16.35764934889634,
  16.66964922287304,
  16.985093187232053,
  17.30399201960269,
  17.62635644741625,
  17.95219714852476,
  18.281524751807332,
  18.614349837764564,
  18.95068293910138,
  19.290534541298456,
  19.633915083172692,
  19.98083495742689,
  20.331304511189067,
  20.685334046541502,
  21.042933821039977,
  21.404114048223256,
  21.76888489811322,
  22.137256497705877,
  22.50923893145328,
  22.884842241736916,
  23.264076429332462,
  23.6469514538663,
  24.033477234264016,
  24.42366364919083,
  24.817520537484558,
  25.21505769858089,
  25.61628489293138,
  26.021211842414342,
  26.429848230738664,
  26.842203703840827,
  27.258287870275353,
  27.678110301598522,
  28.10168053274597,
  28.529008062403893,
  28.96010235337422,
  29.39497283293396,
  29.83362889318845,
  30.276079891419332,
  30.722335150426627,
  31.172403958865512,
  31.62629557157785,
  32.08401920991837,
  32.54558406207592,
  33.010999283389665,
  33.4802739966603,
  33.953417292456834,
  34.430438229418264,
  34.911345834551085,
  35.39614910352207,
  35.88485700094671,
  36.37747846067349,
  36.87402238606382,
  37.37449765026789,
  37.87891309649659,
  38.38727753828926,
  38.89959975977785,
  39.41588851594697,
  39.93615253289054,
  40.460400508064545,
  40.98864111053629,
  41.520882981230194,
  42.05713473317016,
  42.597404951718396,
  43.141702194811224,
  43.6900349931913,
  44.24241185063697,
  44.798841244188324,
  45.35933162437017,
  45.92389141541209,
  46.49252901546552,
  47.065252796817916,
  47.64207110610409,
  48.22299226451468,
  48.808024568002054,
  49.3971762874833,
  49.9904556690408,
  50.587870934119984,
  51.189430279724725,
  51.79514187861014,
  52.40501387947288,
  53.0190544071392,
  53.637271562750364,
  54.259673423945976,
  54.88626804504493,
  55.517063457223934,
  56.15206766869424,
  56.79128866487574,
  57.43473440856916,
  58.08241284012621,
  58.734331877617365,
  59.39049941699807,
  60.05092333227251,
  60.715611475655585,
  61.38457167773311,
  62.057811747619894,
  62.7353394731159,
  63.417162620860914,
  64.10328893648692,
  64.79372614476921,
  65.48848194977529,
  66.18756403501224,
  66.89098006357258,
  67.59873767827808,
  68.31084450182222,
  69.02730813691093,
  69.74813616640164,
  70.47333615344107,
  71.20291564160104,
  71.93688215501312,
  72.67524319850172,
  73.41800625771542,
  74.16517879925733,
  74.9167682708136,
  75.67278210128072,
  76.43322770089146,
  77.1981124613393,
  77.96744375590167,
  78.74122893956174,
  79.51947534912904,
  80.30219030335869,
  81.08938110306934,
  81.88105503125999,
  82.67721935322541,
  83.4778813166706,
  84.28304815182372,
  85.09272707154808,
  85.90692527145302,
  86.72564993000343,
  87.54890820862819,
  88.3767072518277,
  89.2090541872801,
  90.04595612594655,
  90.88742016217518,
  91.73345337380438,
  92.58406282226491,
  93.43925555268066,
  94.29903859396902,
  95.16341895893969,
  96.03240364439274,
  96.9059996312159,
  97.78421388448044,
  98.6670533535366,
  99.55452497210776
];
var Ss;
const VR = (Ss = class {
  static from(t, i, n) {
    return new Ss(Js.solveToInt(t, i, n));
  }
  /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */
  static fromInt(t) {
    return new Ss(t);
  }
  toInt() {
    return this.argb;
  }
  /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */
  get hue() {
    return this.internalHue;
  }
  /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */
  set hue(t) {
    this.setInternalState(Js.solveToInt(t, this.internalChroma, this.internalTone));
  }
  get chroma() {
    return this.internalChroma;
  }
  /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */
  set chroma(t) {
    this.setInternalState(Js.solveToInt(this.internalHue, t, this.internalTone));
  }
  /** Lightness. Ranges from 0 to 100. */
  get tone() {
    return this.internalTone;
  }
  /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */
  set tone(t) {
    this.setInternalState(Js.solveToInt(this.internalHue, this.internalChroma, t));
  }
  constructor(t) {
    this.argb = t;
    const i = En.fromInt(t);
    this.internalHue = i.hue, this.internalChroma = i.chroma, this.internalTone = y1(t), this.argb = t;
  }
  setInternalState(t) {
    const i = En.fromInt(t);
    this.internalHue = i.hue, this.internalChroma = i.chroma, this.internalTone = y1(t), this.argb = t;
  }
  /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */
  inViewingConditions(t) {
    const i = En.fromInt(this.toInt()).xyzInViewingConditions(t), n = En.fromXyzInViewingConditions(i[0], i[1], i[2], gs.make());
    return Ss.from(n.hue, n.chroma, m1(i[1]));
  }
}, u(Ss, "zr"), Ss);
p(VR, "Hct");
let wi = VR;
var fo;
const ZR = (fo = class {
  /**
   * Blend the design color's HCT hue towards the key color's HCT
   * hue, in a way that leaves the original color recognizable and
   * recognizably shifted towards the key color.
   *
   * @param designColor ARGB representation of an arbitrary color.
   * @param sourceColor ARGB representation of the main theme color.
   * @return The design color with a hue shifted towards the
   * system's color, a slightly warmer/cooler variant of the design
   * color's hue.
   */
  static harmonize(t, i) {
    const n = wi.fromInt(t), r = wi.fromInt(i), a = MR(n.hue, r.hue), o = Math.min(a * 0.5, 15), l = lv(n.hue + o * TR(n.hue, r.hue));
    return wi.from(l, n.chroma, n.tone).toInt();
  }
  /**
   * Blends hue from one color into another. The chroma and tone of
   * the original color are maintained.
   *
   * @param from ARGB representation of color
   * @param to ARGB representation of color
   * @param amount how much blending to perform; 0.0 >= and <= 1.0
   * @return from, with a hue blended towards to. Chroma and tone
   * are constant.
   */
  static hctHue(t, i, n) {
    const r = fo.cam16Ucs(t, i, n), a = En.fromInt(r), o = En.fromInt(t);
    return wi.from(a.hue, o.chroma, y1(t)).toInt();
  }
  /**
   * Blend in CAM16-UCS space.
   *
   * @param from ARGB representation of color
   * @param to ARGB representation of color
   * @param amount how much blending to perform; 0.0 >= and <= 1.0
   * @return from, blended towards to. Hue, chroma, and tone will
   * change.
   */
  static cam16Ucs(t, i, n) {
    const r = En.fromInt(t), a = En.fromInt(i), o = r.jstar, l = r.astar, c = r.bstar, h = a.jstar, d = a.astar, f = a.bstar, y = o + (h - o) * n, w = l + (d - l) * n, g = c + (f - c) * n;
    return En.fromUcs(y, w, g).toInt();
  }
}, u(fo, "ul"), fo);
p(ZR, "Blend");
let Qn = ZR;
var tn;
const DR = (tn = class {
  /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */
  static ratioOfTones(t, i) {
    return t = bm(0, 100, t), i = bm(0, 100, i), tn.ratioOfYs(ws(t), ws(i));
  }
  static ratioOfYs(t, i) {
    const n = t > i ? t : i, r = n === i ? t : i;
    return (n + 5) / (r + 5);
  }
  /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */
  static lighter(t, i) {
    if (t < 0 || t > 100)
      return -1;
    const n = ws(t), r = i * (n + 5) - 5, a = tn.ratioOfYs(r, n), o = Math.abs(a - i);
    if (a < i && o > 0.04)
      return -1;
    const l = m1(r) + 0.4;
    return l < 0 || l > 100 ? -1 : l;
  }
  /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */
  static darker(t, i) {
    if (t < 0 || t > 100)
      return -1;
    const n = ws(t), r = (n + 5) / i - 5, a = tn.ratioOfYs(n, r), o = Math.abs(a - i);
    if (a < i && o > 0.04)
      return -1;
    const l = m1(r) - 0.4;
    return l < 0 || l > 100 ? -1 : l;
  }
  /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */
  static lighterUnsafe(t, i) {
    const n = tn.lighter(t, i);
    return n < 0 ? 100 : n;
  }
  /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */
  static darkerUnsafe(t, i) {
    const n = tn.darker(t, i);
    return n < 0 ? 0 : n;
  }
}, u(tn, "Qi"), tn);
p(DR, "Contrast");
let Wi = DR;
var yo;
const qR = (yo = class {
  /**
   * Returns true if a color is disliked.
   *
   * @param hct A color to be judged.
   * @return Whether the color is disliked.
   *
   * Disliked is defined as a dark yellow-green that is not neutral.
   */
  static isDisliked(t) {
    const i = Math.round(t.hue) >= 90 && Math.round(t.hue) <= 111, n = Math.round(t.chroma) > 16, r = Math.round(t.tone) < 65;
    return i && n && r;
  }
  /**
   * If a color is disliked, lighten it to make it likable.
   *
   * @param hct A color to be judged.
   * @return A new color if the original color is disliked, or the original
   *   color if it is acceptable.
   */
  static fixIfDisliked(t) {
    return yo.isDisliked(t) ? wi.from(t.hue, t.chroma, 70) : t;
  }
}, u(yo, "yl"), yo);
p(qR, "DislikeAnalyzer");
let Rq = qR;
var Tt;
const UR = (Tt = class {
  /**
   * Create a DynamicColor defined by a TonalPalette and HCT tone.
   *
   * @param args Functions with DynamicScheme as input. Must provide a palette
   * and tone. May provide a background DynamicColor and ToneDeltaConstraint.
   */
  static fromPalette(t) {
    return new Tt(t.name ?? "", t.palette, t.tone, t.isBackground ?? !1, t.background, t.secondBackground, t.contrastCurve, t.toneDeltaPair);
  }
  /**
   * The base constructor for DynamicColor.
   *
   * _Strongly_ prefer using one of the convenience constructors. This class is
   * arguably too flexible to ensure it can support any scenario. Functional
   * arguments allow  overriding without risks that come with subclasses.
   *
   * For example, the default behavior of adjust tone at max contrast
   * to be at a 7.0 ratio with its background is principled and
   * matches accessibility guidance. That does not mean it's the desired
   * approach for _every_ design system, and every color pairing,
   * always, in every case.
   *
   * @param name The name of the dynamic color. Defaults to empty.
   * @param palette Function that provides a TonalPalette given
   * DynamicScheme. A TonalPalette is defined by a hue and chroma, so this
   * replaces the need to specify hue/chroma. By providing a tonal palette, when
   * contrast adjustments are made, intended chroma can be preserved.
   * @param tone Function that provides a tone, given a DynamicScheme.
   * @param isBackground Whether this dynamic color is a background, with
   * some other color as the foreground. Defaults to false.
   * @param background The background of the dynamic color (as a function of a
   *     `DynamicScheme`), if it exists.
   * @param secondBackground A second background of the dynamic color (as a
   *     function of a `DynamicScheme`), if it
   * exists.
   * @param contrastCurve A `ContrastCurve` object specifying how its contrast
   * against its background should behave in various contrast levels options.
   * @param toneDeltaPair A `ToneDeltaPair` object specifying a tone delta
   * constraint between two colors. One of them must be the color being
   * constructed.
   */
  constructor(t, i, n, r, a, o, l, c) {
    if (this.name = t, this.palette = i, this.tone = n, this.isBackground = r, this.background = a, this.secondBackground = o, this.contrastCurve = l, this.toneDeltaPair = c, this.hctCache = /* @__PURE__ */ new Map(), !a && o)
      throw new Error(`Color ${t} has secondBackgrounddefined, but background is not defined.`);
    if (!a && l)
      throw new Error(`Color ${t} has contrastCurvedefined, but background is not defined.`);
    if (a && !l)
      throw new Error(`Color ${t} has backgrounddefined, but contrastCurve is not defined.`);
  }
  /**
   * Return a ARGB integer (i.e. a hex code).
   *
   * @param scheme Defines the conditions of the user interface, for example,
   * whether or not it is dark mode or light mode, and what the desired
   * contrast level is.
   */
  getArgb(t) {
    return this.getHct(t).toInt();
  }
  /**
   * Return a color, expressed in the HCT color space, that this
   * DynamicColor is under the conditions in scheme.
   *
   * @param scheme Defines the conditions of the user interface, for example,
   * whether or not it is dark mode or light mode, and what the desired
   * contrast level is.
   */
  getHct(t) {
    const i = this.hctCache.get(t);
    if (i != null)
      return i;
    const n = this.getTone(t), r = this.palette(t).getHct(n);
    return this.hctCache.size > 4 && this.hctCache.clear(), this.hctCache.set(t, r), r;
  }
  /**
   * Return a tone, T in the HCT color space, that this DynamicColor is under
   * the conditions in scheme.
   *
   * @param scheme Defines the conditions of the user interface, for example,
   * whether or not it is dark mode or light mode, and what the desired
   * contrast level is.
   */
  getTone(t) {
    const i = t.contrastLevel < 0;
    if (this.toneDeltaPair) {
      const n = this.toneDeltaPair(t), r = n.roleA, a = n.roleB, o = n.delta, l = n.polarity, c = n.stayTogether, h = this.background(t).getTone(t), d = l === "nearer" || l === "lighter" && !t.isDark || l === "darker" && t.isDark, f = d ? r : a, y = d ? a : r, w = this.name === f.name, g = t.isDark ? 1 : -1, b = f.contrastCurve.getContrast(t.contrastLevel), k = y.contrastCurve.getContrast(t.contrastLevel), $ = f.tone(t);
      let C = Wi.ratioOfTones(h, $) >= b ? $ : Tt.foregroundTone(h, b);
      const E = y.tone(t);
      let A = Wi.ratioOfTones(h, E) >= k ? E : Tt.foregroundTone(h, k);
      return i && (C = Tt.foregroundTone(h, b), A = Tt.foregroundTone(h, k)), (A - C) * g >= o || (A = bm(0, 100, C + o * g), (A - C) * g >= o || (C = bm(0, 100, A - o * g))), 50 <= C && C < 60 ? g > 0 ? (C = 60, A = Math.max(A, C + o * g)) : (C = 49, A = Math.min(A, C + o * g)) : 50 <= A && A < 60 && (c ? g > 0 ? (C = 60, A = Math.max(A, C + o * g)) : (C = 49, A = Math.min(A, C + o * g)) : g > 0 ? A = 60 : A = 49), w ? C : A;
    } else {
      let n = this.tone(t);
      if (this.background == null)
        return n;
      const r = this.background(t).getTone(t), a = this.contrastCurve.getContrast(t.contrastLevel);
      if (Wi.ratioOfTones(r, n) >= a || (n = Tt.foregroundTone(r, a)), i && (n = Tt.foregroundTone(r, a)), this.isBackground && 50 <= n && n < 60 && (Wi.ratioOfTones(49, r) >= a ? n = 49 : n = 60), this.secondBackground) {
        const [o, l] = [this.background, this.secondBackground], [c, h] = [o(t).getTone(t), l(t).getTone(t)], [d, f] = [Math.max(c, h), Math.min(c, h)];
        if (Wi.ratioOfTones(d, n) >= a && Wi.ratioOfTones(f, n) >= a)
          return n;
        const y = Wi.lighter(d, a), w = Wi.darker(f, a), g = [];
        return y !== -1 && g.push(y), w !== -1 && g.push(w), Tt.tonePrefersLightForeground(c) || Tt.tonePrefersLightForeground(h) ? y < 0 ? 100 : y : g.length === 1 ? g[0] : w < 0 ? 0 : w;
      }
      return n;
    }
  }
  /**
   * Given a background tone, find a foreground tone, while ensuring they reach
   * a contrast ratio that is as close to [ratio] as possible.
   *
   * @param bgTone Tone in HCT. Range is 0 to 100, undefined behavior when it
   *     falls outside that range.
   * @param ratio The contrast ratio desired between bgTone and the return
   *     value.
   */
  static foregroundTone(t, i) {
    const n = Wi.lighterUnsafe(t, i), r = Wi.darkerUnsafe(t, i), a = Wi.ratioOfTones(n, t), o = Wi.ratioOfTones(r, t);
    if (Tt.tonePrefersLightForeground(t)) {
      const l = Math.abs(a - o) < 0.1 && a < i && o < i;
      return a >= i || a >= o || l ? n : r;
    } else
      return o >= i || o >= a ? r : n;
  }
  /**
   * Returns whether [tone] prefers a light foreground.
   *
   * People prefer white foregrounds on ~T60-70. Observed over time, and also
   * by Andrew Somers during research for APCA.
   *
   * T60 used as to create the smallest discontinuity possible when skipping
   * down to T49 in order to ensure light foregrounds.
   * Since `tertiaryContainer` in dark monochrome scheme requires a tone of
   * 60, it should not be adjusted. Therefore, 60 is excluded here.
   */
  static tonePrefersLightForeground(t) {
    return Math.round(t) < 60;
  }
  /**
   * Returns whether [tone] can reach a contrast ratio of 4.5 with a lighter
   * color.
   */
  static toneAllowsLightForeground(t) {
    return Math.round(t) <= 49;
  }
  /**
   * Adjust a tone such that white has 4.5 contrast, if the tone is
   * reasonably close to supporting it.
   */
  static enableLightForeground(t) {
    return Tt.tonePrefersLightForeground(t) && !Tt.toneAllowsLightForeground(t) ? 49 : t;
  }
}, u(Tt, "me"), Tt);
p(UR, "DynamicColor");
let he = UR;
var $m;
(function(s) {
  s[s.MONOCHROME = 0] = "MONOCHROME", s[s.NEUTRAL = 1] = "NEUTRAL", s[s.TONAL_SPOT = 2] = "TONAL_SPOT", s[s.VIBRANT = 3] = "VIBRANT", s[s.EXPRESSIVE = 4] = "EXPRESSIVE", s[s.FIDELITY = 5] = "FIDELITY", s[s.CONTENT = 6] = "CONTENT", s[s.RAINBOW = 7] = "RAINBOW", s[s.FRUIT_SALAD = 8] = "FRUIT_SALAD";
})($m || ($m = {}));
var Xd;
const NR = (Xd = class {
  /**
   * Creates a `ContrastCurve` object.
   *
   * @param low Contrast requirement for contrast level -1.0
   * @param normal Contrast requirement for contrast level 0.0
   * @param medium Contrast requirement for contrast level 0.5
   * @param high Contrast requirement for contrast level 1.0
   */
  constructor(t, i, n, r) {
    this.low = t, this.normal = i, this.medium = n, this.high = r;
  }
  /**
   * Returns the contrast ratio at a given contrast level.
   *
   * @param contrastLevel The contrast level. 0.0 is the default (normal);
   * -1.0 is the lowest; 1.0 is the highest.
   * @return The contrast ratio, a number between 1.0 and 21.0.
   */
  getContrast(t) {
    return t <= -1 ? this.low : t < 0 ? mc(this.low, this.normal, (t - -1) / 1) : t < 0.5 ? mc(this.normal, this.medium, (t - 0) / 0.5) : t < 1 ? mc(this.medium, this.high, (t - 0.5) / 0.5) : this.high;
  }
}, u(Xd, "pp"), Xd);
p(NR, "ContrastCurve");
let Ae = NR;
var Fd;
const BR = (Fd = class {
  /**
   * Documents a constraint in tone distance between two DynamicColors.
   *
   * The polarity is an adjective that describes "A", compared to "B".
   *
   * For instance, ToneDeltaPair(A, B, 15, 'darker', stayTogether) states that
   * A's tone should be at least 15 darker than B's.
   *
   * 'nearer' and 'farther' describes closeness to the surface roles. For
   * instance, ToneDeltaPair(A, B, 10, 'nearer', stayTogether) states that A
   * should be 10 lighter than B in light mode, and 10 darker than B in dark
   * mode.
   *
   * @param roleA The first role in a pair.
   * @param roleB The second role in a pair.
   * @param delta Required difference between tones. Absolute value, negative
   * values have undefined behavior.
   * @param polarity The relative relation between tones of roleA and roleB,
   * as described above.
   * @param stayTogether Whether these two roles should stay on the same side of
   * the "awkward zone" (T50-59). This is necessary for certain cases where
   * one role has two backgrounds.
   */
  constructor(t, i, n, r, a) {
    this.roleA = t, this.roleB = i, this.delta = n, this.polarity = r, this.stayTogether = a;
  }
}, u(Fd, "up"), Fd);
p(BR, "ToneDeltaPair");
let $i = BR;
function Wo(s) {
  return s.variant === $m.FIDELITY || s.variant === $m.CONTENT;
}
u(Wo, "lo");
p(Wo, "isFidelity");
function st(s) {
  return s.variant === $m.MONOCHROME;
}
u(st, "Ht");
p(st, "isMonochrome");
function jR(s, t, i, n) {
  let r = i, a = wi.from(s, t, i);
  if (a.chroma < t) {
    let o = a.chroma;
    for (; a.chroma < t; ) {
      r += n ? -1 : 1;
      const l = wi.from(s, t, r);
      if (o > l.chroma || Math.abs(l.chroma - t) < 0.4)
        break;
      const c = Math.abs(l.chroma - t), h = Math.abs(a.chroma - t);
      c < h && (a = l), o = Math.max(o, l.chroma);
    }
  }
  return r;
}
u(jR, "W1");
p(jR, "findDesiredChromaByTone");
function XR(s) {
  return gs.make(
    /*whitePoint=*/
    void 0,
    /*adaptingLuminance=*/
    void 0,
    /*backgroundLstar=*/
    s.isDark ? 30 : 80,
    /*surround=*/
    void 0,
    /*discountingIlluminant=*/
    void 0
  );
}
u(XR, "Q1");
p(XR, "viewingConditionsForAlbers");
function hv(s, t) {
  const i = s.inViewingConditions(XR(t));
  return he.tonePrefersLightForeground(s.tone) && !he.toneAllowsLightForeground(i.tone) ? he.enableLightForeground(s.tone) : he.enableLightForeground(i.tone);
}
u(hv, "Rh");
p(hv, "performAlbers");
var $r;
const FR = ($r = class {
  static highestSurface(t) {
    return t.isDark ? $r.surfaceBright : $r.surfaceDim;
  }
}, u($r, "zo"), $r);
p(FR, "MaterialDynamicColors");
let V = FR;
V.contentAccentToneDelta = 15;
V.primaryPaletteKeyColor = he.fromPalette({
  name: "primary_palette_key_color",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.primaryPalette.keyColor.tone, "tone")
});
V.secondaryPaletteKeyColor = he.fromPalette({
  name: "secondary_palette_key_color",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.secondaryPalette.keyColor.tone, "tone")
});
V.tertiaryPaletteKeyColor = he.fromPalette({
  name: "tertiary_palette_key_color",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.tertiaryPalette.keyColor.tone, "tone")
});
V.neutralPaletteKeyColor = he.fromPalette({
  name: "neutral_palette_key_color",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.neutralPalette.keyColor.tone, "tone")
});
V.neutralVariantPaletteKeyColor = he.fromPalette({
  name: "neutral_variant_palette_key_color",
  palette: /* @__PURE__ */ p((s) => s.neutralVariantPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.neutralVariantPalette.keyColor.tone, "tone")
});
V.background = he.fromPalette({
  name: "background",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 6 : 98, "tone"),
  isBackground: !0
});
V.onBackground = he.fromPalette({
  name: "on_background",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 90 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.background, "background"),
  contrastCurve: new Ae(3, 3, 4.5, 7)
});
V.surface = he.fromPalette({
  name: "surface",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 6 : 98, "tone"),
  isBackground: !0
});
V.surfaceDim = he.fromPalette({
  name: "surface_dim",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 6 : 87, "tone"),
  isBackground: !0
});
V.surfaceBright = he.fromPalette({
  name: "surface_bright",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 24 : 98, "tone"),
  isBackground: !0
});
V.surfaceContainerLowest = he.fromPalette({
  name: "surface_container_lowest",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 4 : 100, "tone"),
  isBackground: !0
});
V.surfaceContainerLow = he.fromPalette({
  name: "surface_container_low",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 10 : 96, "tone"),
  isBackground: !0
});
V.surfaceContainer = he.fromPalette({
  name: "surface_container",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 12 : 94, "tone"),
  isBackground: !0
});
V.surfaceContainerHigh = he.fromPalette({
  name: "surface_container_high",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 17 : 92, "tone"),
  isBackground: !0
});
V.surfaceContainerHighest = he.fromPalette({
  name: "surface_container_highest",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 22 : 90, "tone"),
  isBackground: !0
});
V.onSurface = he.fromPalette({
  name: "on_surface",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 90 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.surfaceVariant = he.fromPalette({
  name: "surface_variant",
  palette: /* @__PURE__ */ p((s) => s.neutralVariantPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 30 : 90, "tone"),
  isBackground: !0
});
V.onSurfaceVariant = he.fromPalette({
  name: "on_surface_variant",
  palette: /* @__PURE__ */ p((s) => s.neutralVariantPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 80 : 30, "tone"),
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(3, 4.5, 7, 11)
});
V.inverseSurface = he.fromPalette({
  name: "inverse_surface",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 90 : 20, "tone")
});
V.inverseOnSurface = he.fromPalette({
  name: "inverse_on_surface",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 20 : 95, "tone"),
  background: /* @__PURE__ */ p((s) => V.inverseSurface, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.outline = he.fromPalette({
  name: "outline",
  palette: /* @__PURE__ */ p((s) => s.neutralVariantPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 60 : 50, "tone"),
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1.5, 3, 4.5, 7)
});
V.outlineVariant = he.fromPalette({
  name: "outline_variant",
  palette: /* @__PURE__ */ p((s) => s.neutralVariantPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 30 : 80, "tone"),
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7)
});
V.shadow = he.fromPalette({
  name: "shadow",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => 0, "tone")
});
V.scrim = he.fromPalette({
  name: "scrim",
  palette: /* @__PURE__ */ p((s) => s.neutralPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => 0, "tone")
});
V.surfaceTint = he.fromPalette({
  name: "surface_tint",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 80 : 40, "tone"),
  isBackground: !0
});
V.primary = he.fromPalette({
  name: "primary",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? s.isDark ? 100 : 0 : s.isDark ? 80 : 40, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(3, 4.5, 7, 11),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.primaryContainer, V.primary, 15, "nearer", !1), "toneDeltaPair")
});
V.onPrimary = he.fromPalette({
  name: "on_primary",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? s.isDark ? 10 : 90 : s.isDark ? 20 : 100, "tone"),
  background: /* @__PURE__ */ p((s) => V.primary, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.primaryContainer = he.fromPalette({
  name: "primary_container",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => Wo(s) ? hv(s.sourceColorHct, s) : st(s) ? s.isDark ? 85 : 25 : s.isDark ? 30 : 90, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.primaryContainer, V.primary, 15, "nearer", !1), "toneDeltaPair")
});
V.onPrimaryContainer = he.fromPalette({
  name: "on_primary_container",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => Wo(s) ? he.foregroundTone(V.primaryContainer.tone(s), 4.5) : st(s) ? s.isDark ? 0 : 100 : s.isDark ? 90 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.primaryContainer, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.inversePrimary = he.fromPalette({
  name: "inverse_primary",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 40 : 80, "tone"),
  background: /* @__PURE__ */ p((s) => V.inverseSurface, "background"),
  contrastCurve: new Ae(3, 4.5, 7, 11)
});
V.secondary = he.fromPalette({
  name: "secondary",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 80 : 40, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(3, 4.5, 7, 11),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.secondaryContainer, V.secondary, 15, "nearer", !1), "toneDeltaPair")
});
V.onSecondary = he.fromPalette({
  name: "on_secondary",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? s.isDark ? 10 : 100 : s.isDark ? 20 : 100, "tone"),
  background: /* @__PURE__ */ p((s) => V.secondary, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.secondaryContainer = he.fromPalette({
  name: "secondary_container",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => {
    const t = s.isDark ? 30 : 90;
    if (st(s))
      return s.isDark ? 30 : 85;
    if (!Wo(s))
      return t;
    let i = jR(s.secondaryPalette.hue, s.secondaryPalette.chroma, t, !s.isDark);
    return i = hv(s.secondaryPalette.getHct(i), s), i;
  }, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.secondaryContainer, V.secondary, 15, "nearer", !1), "toneDeltaPair")
});
V.onSecondaryContainer = he.fromPalette({
  name: "on_secondary_container",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => Wo(s) ? he.foregroundTone(V.secondaryContainer.tone(s), 4.5) : s.isDark ? 90 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.secondaryContainer, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.tertiary = he.fromPalette({
  name: "tertiary",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? s.isDark ? 90 : 25 : s.isDark ? 80 : 40, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(3, 4.5, 7, 11),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.tertiaryContainer, V.tertiary, 15, "nearer", !1), "toneDeltaPair")
});
V.onTertiary = he.fromPalette({
  name: "on_tertiary",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? s.isDark ? 10 : 90 : s.isDark ? 20 : 100, "tone"),
  background: /* @__PURE__ */ p((s) => V.tertiary, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.tertiaryContainer = he.fromPalette({
  name: "tertiary_container",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => {
    if (st(s))
      return s.isDark ? 60 : 49;
    if (!Wo(s))
      return s.isDark ? 30 : 90;
    const t = hv(s.tertiaryPalette.getHct(s.sourceColorHct.tone), s), i = s.tertiaryPalette.getHct(t);
    return Rq.fixIfDisliked(i).tone;
  }, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.tertiaryContainer, V.tertiary, 15, "nearer", !1), "toneDeltaPair")
});
V.onTertiaryContainer = he.fromPalette({
  name: "on_tertiary_container",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? s.isDark ? 0 : 100 : Wo(s) ? he.foregroundTone(V.tertiaryContainer.tone(s), 4.5) : s.isDark ? 90 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.tertiaryContainer, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.error = he.fromPalette({
  name: "error",
  palette: /* @__PURE__ */ p((s) => s.errorPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 80 : 40, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(3, 4.5, 7, 11),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.errorContainer, V.error, 15, "nearer", !1), "toneDeltaPair")
});
V.onError = he.fromPalette({
  name: "on_error",
  palette: /* @__PURE__ */ p((s) => s.errorPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 20 : 100, "tone"),
  background: /* @__PURE__ */ p((s) => V.error, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.errorContainer = he.fromPalette({
  name: "error_container",
  palette: /* @__PURE__ */ p((s) => s.errorPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 30 : 90, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.errorContainer, V.error, 15, "nearer", !1), "toneDeltaPair")
});
V.onErrorContainer = he.fromPalette({
  name: "on_error_container",
  palette: /* @__PURE__ */ p((s) => s.errorPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => s.isDark ? 90 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.errorContainer, "background"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.primaryFixed = he.fromPalette({
  name: "primary_fixed",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 40 : 90, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.primaryFixed, V.primaryFixedDim, 10, "lighter", !0), "toneDeltaPair")
});
V.primaryFixedDim = he.fromPalette({
  name: "primary_fixed_dim",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 30 : 80, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.primaryFixed, V.primaryFixedDim, 10, "lighter", !0), "toneDeltaPair")
});
V.onPrimaryFixed = he.fromPalette({
  name: "on_primary_fixed",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 100 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.primaryFixedDim, "background"),
  secondBackground: /* @__PURE__ */ p((s) => V.primaryFixed, "secondBackground"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.onPrimaryFixedVariant = he.fromPalette({
  name: "on_primary_fixed_variant",
  palette: /* @__PURE__ */ p((s) => s.primaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 90 : 30, "tone"),
  background: /* @__PURE__ */ p((s) => V.primaryFixedDim, "background"),
  secondBackground: /* @__PURE__ */ p((s) => V.primaryFixed, "secondBackground"),
  contrastCurve: new Ae(3, 4.5, 7, 11)
});
V.secondaryFixed = he.fromPalette({
  name: "secondary_fixed",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 80 : 90, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.secondaryFixed, V.secondaryFixedDim, 10, "lighter", !0), "toneDeltaPair")
});
V.secondaryFixedDim = he.fromPalette({
  name: "secondary_fixed_dim",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 70 : 80, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.secondaryFixed, V.secondaryFixedDim, 10, "lighter", !0), "toneDeltaPair")
});
V.onSecondaryFixed = he.fromPalette({
  name: "on_secondary_fixed",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.secondaryFixedDim, "background"),
  secondBackground: /* @__PURE__ */ p((s) => V.secondaryFixed, "secondBackground"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.onSecondaryFixedVariant = he.fromPalette({
  name: "on_secondary_fixed_variant",
  palette: /* @__PURE__ */ p((s) => s.secondaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 25 : 30, "tone"),
  background: /* @__PURE__ */ p((s) => V.secondaryFixedDim, "background"),
  secondBackground: /* @__PURE__ */ p((s) => V.secondaryFixed, "secondBackground"),
  contrastCurve: new Ae(3, 4.5, 7, 11)
});
V.tertiaryFixed = he.fromPalette({
  name: "tertiary_fixed",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 40 : 90, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.tertiaryFixed, V.tertiaryFixedDim, 10, "lighter", !0), "toneDeltaPair")
});
V.tertiaryFixedDim = he.fromPalette({
  name: "tertiary_fixed_dim",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 30 : 80, "tone"),
  isBackground: !0,
  background: /* @__PURE__ */ p((s) => V.highestSurface(s), "background"),
  contrastCurve: new Ae(1, 1, 3, 7),
  toneDeltaPair: /* @__PURE__ */ p((s) => new $i(V.tertiaryFixed, V.tertiaryFixedDim, 10, "lighter", !0), "toneDeltaPair")
});
V.onTertiaryFixed = he.fromPalette({
  name: "on_tertiary_fixed",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 100 : 10, "tone"),
  background: /* @__PURE__ */ p((s) => V.tertiaryFixedDim, "background"),
  secondBackground: /* @__PURE__ */ p((s) => V.tertiaryFixed, "secondBackground"),
  contrastCurve: new Ae(4.5, 7, 11, 21)
});
V.onTertiaryFixedVariant = he.fromPalette({
  name: "on_tertiary_fixed_variant",
  palette: /* @__PURE__ */ p((s) => s.tertiaryPalette, "palette"),
  tone: /* @__PURE__ */ p((s) => st(s) ? 90 : 30, "tone"),
  background: /* @__PURE__ */ p((s) => V.tertiaryFixedDim, "background"),
  secondBackground: /* @__PURE__ */ p((s) => V.tertiaryFixed, "secondBackground"),
  contrastCurve: new Ae(3, 4.5, 7, 11)
});
var qn;
const HR = (qn = class {
  /**
   * @param argb ARGB representation of a color
   * @return Tones matching that color's hue and chroma.
   */
  static fromInt(t) {
    const i = wi.fromInt(t);
    return qn.fromHct(i);
  }
  /**
   * @param hct Hct
   * @return Tones matching that color's hue and chroma.
   */
  static fromHct(t) {
    return new qn(t.hue, t.chroma, t);
  }
  /**
   * @param hue HCT hue
   * @param chroma HCT chroma
   * @return Tones matching hue and chroma.
   */
  static fromHueAndChroma(t, i) {
    return new qn(t, i, qn.createKeyColor(t, i));
  }
  constructor(t, i, n) {
    this.hue = t, this.chroma = i, this.keyColor = n, this.cache = /* @__PURE__ */ new Map();
  }
  static createKeyColor(t, i) {
    let n = wi.from(t, i, 50), r = Math.abs(n.chroma - i);
    for (let a = 1; a < 50; a += 1) {
      if (Math.round(i) === Math.round(n.chroma))
        return n;
      const o = wi.from(t, i, 50 + a), l = Math.abs(o.chroma - i);
      l < r && (r = l, n = o);
      const c = wi.from(t, i, 50 - a), h = Math.abs(c.chroma - i);
      h < r && (r = h, n = c);
    }
    return n;
  }
  /**
   * @param tone HCT tone, measured from 0 to 100.
   * @return ARGB representation of a color with that tone.
   */
  tone(t) {
    let i = this.cache.get(t);
    return i === void 0 && (i = wi.from(this.hue, this.chroma, t).toInt(), this.cache.set(t, i)), i;
  }
  /**
   * @param tone HCT tone.
   * @return HCT representation of a color with that tone.
   */
  getHct(t) {
    return wi.fromInt(this.tone(t));
  }
}, u(qn, "Ps"), qn);
p(HR, "TonalPalette");
let Ye = HR;
function f$(s) {
  const t = t5(s), i = i5(s), n = n5(s), r = [t.toString(16), i.toString(16), n.toString(16)];
  for (const [a, o] of r.entries())
    o.length === 1 && (r[a] = "0" + o);
  return "#" + r.join("");
}
u(f$, "su");
p(f$, "hexFromArgb");
function YR(s) {
  s = s.replace("#", "");
  const t = s.length === 3, i = s.length === 6, n = s.length === 8;
  if (!t && !i && !n)
    throw new Error("unexpected hex " + s);
  let r = 0, a = 0, o = 0;
  return t ? (r = Mn(s.slice(0, 1).repeat(2)), a = Mn(s.slice(1, 2).repeat(2)), o = Mn(s.slice(2, 3).repeat(2))) : i ? (r = Mn(s.slice(0, 2)), a = Mn(s.slice(2, 4)), o = Mn(s.slice(4, 6))) : n && (r = Mn(s.slice(2, 4)), a = Mn(s.slice(4, 6)), o = Mn(s.slice(6, 8))), (255 << 24 | (r & 255) << 16 | (a & 255) << 8 | o & 255) >>> 0;
}
u(YR, "K1");
p(YR, "argbFromHex");
function Mn(s) {
  return parseInt(s, 16);
}
u(Mn, "Pi");
p(Mn, "parseIntHex");
function GR(s, t = !1) {
  var i;
  const n = (i = s.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/)) == null ? void 0 : i.slice(1).map((c, h) => h === 3 ? Math.round(parseFloat(c) * 255) : parseFloat(c));
  if (!n)
    throw new Error("Could not parse rgba color.");
  const [r, a, o, l] = n;
  return ((t ? 255 : l & 255) << 24 | (r & 255) << 16 | (a & 255) << 8 | o & 255) >>> 0;
}
u(GR, "G1");
p(GR, "argbFromRgba");
function KR(s) {
  Bt();
  const t = document.createElement("wy-compute-styles");
  t.setAttribute("style", `color: ${s} !important;`), document.documentElement.append(t);
  const i = window.getComputedStyle(t).color;
  return t.remove(), i;
}
u(KR, "Y1");
p(KR, "getComputedColor");
function w1(s) {
  return getComputedStyle(s).getPropertyValue("--wy-theme-color") || void 0;
}
u(w1, "Zd");
p(w1, "getCSSThemeColor");
function JR(s, t) {
  let i = w1(s);
  const n = new MutationObserver(() => {
    const o = w1(s);
    o !== i && (i = o, t(o));
  }), r = {
    attributes: !0,
    attributeFilter: ["class", "style"]
  };
  let a = s;
  for (; a && a !== document; )
    n.observe(a, r), a = a.parentNode;
  return () => n.disconnect();
}
u(JR, "Z1");
p(JR, "observeCSSThemeColor");
function g1() {
  var s;
  return Bt(), ((s = Array.from(document.head.querySelectorAll("meta[name='theme-color']")).filter((t) => {
    var i;
    const n = t.getAttribute("media");
    return !n || ((i = window.matchMedia(n)) == null ? void 0 : i.matches);
  }).pop()) == null ? void 0 : s.getAttribute("content")) || void 0;
}
u(g1, "Xd");
p(g1, "getMetaThemeColor");
function eA(s) {
  Bt();
  const t = Array.from(document.head.querySelectorAll("meta[name='theme-color']"));
  if (!t)
    return () => {
    };
  let i = g1();
  const n = /* @__PURE__ */ p(() => {
    const l = g1();
    l !== i && (i = l, s(l));
  }, "checkChangedColor"), r = new MutationObserver(n), a = {
    attributes: !0,
    attributeFilter: ["content"]
  }, o = [];
  return t.forEach((l) => {
    r.observe(l, a);
    const c = l.getAttribute("media");
    if (c) {
      const h = window.matchMedia(c);
      h.addEventListener("change", n), o.push(h);
    }
  }), () => {
    r.disconnect(), o.forEach((l) => l.removeEventListener("change", n));
  };
}
u(eA, "X1");
p(eA, "observeMetaThemeColor");
const fy = [], Aq = 16;
function tA(s, t = !1) {
  var i;
  if (fy.some((R) => R.seedColor === s)) {
    const R = (i = fy.find((L) => L.seedColor === s)) == null ? void 0 : i.colors;
    if (R)
      return R;
  }
  const n = [];
  t && n.push(`--wy-theme-color:${s};`);
  let r = s;
  !s.startsWith("#") && !s.startsWith("rgb") && (r = KR(s));
  const a = s.startsWith("#") ? YR(r) : GR(r), o = wi.fromInt(a), l = o.hue, c = o.chroma, h = Math.max(48, c), d = Math.min(h, 84), f = 360 / 16, y = 27.4, w = -8, g = (l + 360 - y - w + f / 2) % f + y + w - f / 2, b = {
    primary: Ye.fromHueAndChroma(l, h),
    secondary: Ye.fromHueAndChroma(l, h / 3),
    tertiary: Ye.fromHueAndChroma(l + 60, h / 2),
    neutral: Ye.fromHueAndChroma(l, Math.min(c / 12, 4)),
    "neutral-variant": Ye.fromHueAndChroma(l, Math.min(c / 6, 8)),
    error: Ye.fromHueAndChroma(g, 84),
    warning: Ye.fromHueAndChroma(g + 4 * f, d),
    // Same as yellow
    red: Ye.fromHueAndChroma(g, d),
    "deep-orange": Ye.fromHueAndChroma(g + 1 * f, d),
    orange: Ye.fromHueAndChroma(g + 2 * f, d),
    amber: Ye.fromHueAndChroma(g + 3 * f, d),
    yellow: Ye.fromHueAndChroma(g + 4 * f, d),
    lime: Ye.fromHueAndChroma(g + 5 * f, d),
    "light-green": Ye.fromHueAndChroma(g + 6 * f, d),
    green: Ye.fromHueAndChroma(g + 7 * f, d),
    teal: Ye.fromHueAndChroma(g + 8 * f, d),
    cyan: Ye.fromHueAndChroma(g + 9 * f, d),
    "light-blue": Ye.fromHueAndChroma(g + 10 * f, d),
    blue: Ye.fromHueAndChroma(g + 11 * f, d),
    indigo: Ye.fromHueAndChroma(g + 12 * f, d),
    "deep-purple": Ye.fromHueAndChroma(g + 13 * f, d),
    purple: Ye.fromHueAndChroma(g + 14 * f, d),
    pink: Ye.fromHueAndChroma(g + 15 * f, d),
    gray: Ye.fromHueAndChroma(l, 4)
  }, k = {
    //"100": 100,
    99: 99,
    95: 95,
    90: 90,
    80: 80,
    70: 70,
    60: 60,
    50: 50,
    40: 40,
    30: 30,
    20: 20,
    10: 10
    //"0": 0
  }, $ = {
    primary: k,
    secondary: k,
    tertiary: k,
    neutral: k,
    "neutral-variant": k,
    error: k,
    warning: k,
    blue: { light: 70, dark: 80 },
    indigo: { light: 60, dark: 60 },
    purple: { light: 60, dark: 70 },
    pink: { light: 60, dark: 70 },
    red: { light: 60, dark: 60 },
    orange: { light: 70, dark: 70 },
    yellow: { light: 70, dark: 80 },
    green: { light: 60, dark: 60 },
    teal: { light: 60, dark: 60 },
    cyan: { light: 50, dark: 60 },
    gray: { light: 50, dark: 60 }
  };
  for (const R in $) {
    const L = $[R];
    for (const I in L) {
      const D = f$(b[R].tone(L[I]));
      n.push(`--wy-${R}-${I}:${D};`);
    }
  }
  const C = {
    light: b.primary.tone(40),
    dark: b.primary.tone(80)
  }, E = {
    light: b.neutral.tone(99),
    dark: b.neutral.tone(10)
  }, A = {
    "surface-1": {
      light: Qn.cam16Ucs(E.light, C.light, 0.05),
      dark: Qn.cam16Ucs(E.dark, C.dark, 0.05)
    },
    "surface-2": {
      light: Qn.cam16Ucs(E.light, C.light, 0.08),
      dark: Qn.cam16Ucs(E.dark, C.dark, 0.08)
    },
    "surface-3": {
      light: Qn.cam16Ucs(E.light, C.light, 0.11),
      dark: Qn.cam16Ucs(E.dark, C.dark, 0.11)
    },
    "surface-4": {
      light: Qn.cam16Ucs(E.light, C.light, 0.12),
      dark: Qn.cam16Ucs(E.dark, C.dark, 0.12)
    },
    "surface-5": {
      light: Qn.cam16Ucs(E.light, C.light, 0.14),
      dark: Qn.cam16Ucs(E.dark, C.dark, 0.14)
    }
  };
  for (const R in A) {
    const L = A[R];
    for (const I in L) {
      const D = f$(L[I]);
      n.push(`--wy-${R}-${I}:${D};`);
    }
  }
  return fy.unshift({ seedColor: s, colors: n }), fy.length = Math.min(fy.length, Aq), n;
}
u(tA, "tm");
p(tA, "generateThemeColors");
const Eq = /* @__PURE__ */ p((s) => {
  if (Bt(), sv)
    document.adoptedStyleSheets = s.map(
      (t) => t instanceof CSSStyleSheet ? t : t.styleSheet
    );
  else
    for (const t of s) {
      const i = document.createElement("style"), n = global.litNonce;
      n !== void 0 && i.setAttribute("nonce", n), i.textContent = t.cssText, (document.head || document.documentElement).appendChild(i);
    }
}, "adoptGlobalStyles"), Yi = de`.wy-light :where(wy-chat),.wy-light :where(wy-comments),.wy-light :where(wy-files),.wy-light :where(wy-messenger),.wy-light :where(wy-notifications),.wy-light :where(wy-posts),:host(.wy-light),:host .wy-light,::slotted(.wy-light){color-scheme:light;--wy-primary: var(--wy-primary-40, #006399);--wy-on-primary: var(--wy-white, #ffffff);--wy-primary-container: var(--wy-primary-90, #cde5ff);--wy-on-primary-container: var(--wy-primary-10, #001d32);--wy-secondary: var(--wy-secondary-40, #3b6a1c);--wy-on-secondary: var(--wy-white, #ffffff);--wy-secondary-container: var(--wy-secondary-90, #bbf294);--wy-on-secondary-container: var(--wy-secondary-10, #0a2100);--wy-tertiary: var(--wy-tertiary-40, #3b6a1c);--wy-on-tertiary: var(--wy-white, #ffffff);--wy-tertiary-container: var(--wy-tertiary-90, #bbf294);--wy-on-tertiary-container: var(--wy-tertiary-10, #0a2100);--wy-error: var(--wy-error-40, #ba1824);--wy-on-error: var(--wy-white, #ffffff);--wy-error-container: var(--wy-error-90, #ffdad7);--wy-on-error-container: var(--wy-error-10, #410004);--wy-warning: var(--wy-warning-70, #afb140);--wy-on-warning: var(--wy-black, #000000);--wy-warning-container: var(--wy-warning-90, #e7e971);--wy-on-warning-container: var(--wy-warning-10, #1c1d00);--wy-background: var(--wy-neutral-99, #fcfcff);--wy-on-background: var(--wy-neutral-10, #1a1c1e);--wy-surface: var(--wy-neutral-99, #fcfcff);--wy-on-surface: var(--wy-neutral-10, #1a1c1e);--wy-surface-variant: var(--wy-neutral-variant-90, #dee3eb);--wy-on-surface-variant: var(--wy-neutral-variant-30, #42474e);--wy-outline: var(--wy-neutral-variant-50, #72777e);--wy-outline-variant: var(--wy-neutral-variant-80, #c2c7ce);--wy-inverse-surface: var(--wy-neutral-20, #2f3033);--wy-on-inverse-surface: var(--wy-neutral-95, #f0f0f4);--wy-inverse-primary: var(--wy-primary-80, #95ccff);--wy-surface-1: var(--wy-surface-1-light, #f1f2f7);--wy-surface-2: var(--wy-surface-2-light, #eaedf3);--wy-surface-3: var(--wy-surface-3-light, #e3e7ee);--wy-surface-4: var(--wy-surface-4-light, #e1e6ed);--wy-surface-5: var(--wy-surface-5-light, #dce2ea);--wy-highlight: var(--wy-primary-95, #e8f2ff);--wy-on-highlight: var(--wy-primary-10, #001d32);--wy-link: var(--wy-primary-40, #006399);--wy-presence-active: var(--wy-green-light, #00a38b);--wy-blue: var(--wy-blue-light, #89a9fc);--wy-indigo: var(--wy-indigo-light, #9185de);--wy-purple: var(--wy-purple-light, #c675b7);--wy-pink: var(--wy-pink-light, #d57194);--wy-red: var(--wy-red-light, #db726c);--wy-orange: var(--wy-orange-light, #e89a3a);--wy-yellow: var(--wy-yellow-light, #afb140);--wy-green: var(--wy-green-light, #00a38b);--wy-teal: var(--wy-teal-light, #00a0a8);--wy-cyan: var(--wy-cyan-light, #0082a1);--wy-gray: var(--wy-gray-light, #76777a);--wy-code-text: var(--wy-code-text-light, #3b3b3b);--wy-code-variable: var(--wy-code-variable-light, #001080);--wy-code-operator: var(--wy-code-operator-light, #000000);--wy-code-prolog: var(--wy-code-prolog-light, #000080);--wy-code-comment: var(--wy-code-comment-light, #008000);--wy-code-builtin: var(--wy-code-builtin-light, #0070C1);--wy-code-number: var(--wy-code-number-light, #098658);--wy-code-inserted: var(--wy-code-inserted-light, #098658);--wy-code-constant: var(--wy-code-constant-light, #811F3F);--wy-code-hexcode: var(--wy-code-hexcode-light, #811F3F);--wy-code-regex: var(--wy-code-regex-light, #811F3F);--wy-code-char: var(--wy-code-char-light, #811F3F);--wy-code-tag: var(--wy-code-tag-light, #800000);--wy-code-attr-name: var(--wy-code-attr-name-light, #E50000);--wy-code-selector: var(--wy-code-selector-light, #E50000);--wy-code-property: var(--wy-code-property-light, #E50000);--wy-code-deleted: var(--wy-code-deleted-light, #A31515);--wy-code-string: var(--wy-code-string-light, #A31515);--wy-code-changed: var(--wy-code-changed-light, #0451A5);--wy-code-punctuation: var(--wy-code-punctuation-light, #000000);--wy-code-function: var(--wy-code-function-light, #0000FF);--wy-code-keyword: var(--wy-code-keyword-light, #AF00DB);--wy-code-class-name: var(--wy-code-class-name-light, #267F99)}.wy-dark:not(.wy-light) :where(wy-chat),.wy-dark:not(.wy-light) :where(wy-comments),.wy-dark:not(.wy-light) :where(wy-files),.wy-dark:not(.wy-light) :where(wy-messenger),.wy-dark:not(.wy-light) :where(wy-notifications),.wy-dark:not(.wy-light) :where(wy-posts),:host(.wy-dark:not(.wy-light)),:host .wy-dark:not(.wy-light),::slotted(.wy-dark:not(.wy-light)){color-scheme:dark;--wy-primary: var(--wy-primary-80, #95ccff);--wy-on-primary: var(--wy-primary-20, #003352);--wy-primary-container: var(--wy-primary-30, #004a75);--wy-on-primary-container: var(--wy-primary-90, #cde5ff);--wy-secondary: var(--wy-secondary-80, #a0d57b);--wy-on-secondary: var(--wy-secondary-20, #163800);--wy-secondary-container: var(--wy-secondary-30, #245103);--wy-on-secondary-container: var(--wy-secondary-90, #bbf294);--wy-tertiary: var(--wy-tertiary-80, #a0d57b);--wy-on-tertiary: var(--wy-tertiary-20, #163800);--wy-tertiary-container: var(--wy-tertiary-30, #245103);--wy-on-tertiary-container: var(--wy-tertiary-90, #bbf294);--wy-error: var(--wy-error-80, #ffb3ae);--wy-on-error: var(--wy-error-20, #68000b);--wy-error-container: var(--wy-error-30, #930014);--wy-on-error-container: var(--wy-error-90, #ffdad7);--wy-warning: var(--wy-warning-90, #e7e971);--wy-on-warning: var(--wy-warning-30, #484a00);--wy-warning-container: var(--wy-warning-50, #7a7c05);--wy-on-warning-container: var(--wy-warning-95, #f5f77d);--wy-background: var(--wy-neutral-10, #1a1c1e);--wy-on-background: var(--wy-neutral-90, #e2e2e5);--wy-surface: var(--wy-neutral-10, #1a1c1e);--wy-on-surface: var(--wy-neutral-90, #e2e2e5);--wy-surface-variant: var(--wy-neutral-variant-30, #42474e);--wy-on-surface-variant: var(--wy-neutral-variant-80, #c2c7ce);--wy-outline: var(--wy-neutral-variant-60, #8c9198);--wy-outline-variant: var(--wy-neutral-variant-30, #42474e);--wy-inverse-surface: var(--wy-neutral-90, #e2e2e5);--wy-on-inverse-surface: var(--wy-neutral-20, #2f3033);--wy-inverse-primary: var(--wy-primary-40, #006399);--wy-surface-1: var(--wy-surface-1-dark, #212427);--wy-surface-2: var(--wy-surface-2-dark, #25292d);--wy-surface-3: var(--wy-surface-3-dark, #292e33);--wy-surface-4: var(--wy-surface-4-dark, #2b3035);--wy-surface-5: var(--wy-surface-5-dark, #2d3338);--wy-highlight: var(--wy-primary-20, #003352);--wy-on-highlight: var(--wy-primary-90, #cde5ff);--wy-link: var(--wy-primary-80, #95ccff);--wy-presence-active: var(--wy-green-dark, #00a38b);--wy-blue: var(--wy-blue-dark, #b1c5ff);--wy-indigo: var(--wy-indigo-dark, #9185de);--wy-purple: var(--wy-purple-dark, #e38fd3);--wy-pink: var(--wy-pink-dark, #f48bae);--wy-red: var(--wy-red-dark, #db726c);--wy-orange: var(--wy-orange-dark, #e89a3a);--wy-yellow: var(--wy-yellow-dark, #cacc58);--wy-green: var(--wy-green-dark, #00a38b);--wy-teal: var(--wy-teal-dark, #00a0a8);--wy-cyan: var(--wy-cyan-dark, #009dc3);--wy-gray: var(--wy-gray-dark, #909194);--wy-code-text: var(--wy-code-text-dark, #cccccc);--wy-code-variable: var(--wy-code-variable-dark, #9CDCFE);--wy-code-operator: var(--wy-code-operator-dark, #d4d4d4);--wy-code-prolog: var(--wy-code-prolog-dark, #569CD6);--wy-code-comment: var(--wy-code-comment-dark, #6a9955);--wy-code-builtin: var(--wy-code-builtin-dark, #4fc1ff);--wy-code-number: var(--wy-code-number-dark, #b5cea8);--wy-code-inserted: var(--wy-code-inserted-dark, #b5cea8);--wy-code-constant: var(--wy-code-constant-dark, #646695);--wy-code-hexcode: var(--wy-code-hexcode-dark, #646695);--wy-code-regex: var(--wy-code-regex-dark, #d16969);--wy-code-char: var(--wy-code-char-dark, #d16969);--wy-code-tag: var(--wy-code-tag-dark, #569cd6);--wy-code-attr-name: var(--wy-code-attr-name-dark, #9cdcfe);--wy-code-selector: var(--wy-code-selector-dark, #9cdcfe);--wy-code-property: var(--wy-code-property-dark, #9cdcfe);--wy-code-deleted: var(--wy-code-deleted-dark, #ce9178);--wy-code-string: var(--wy-code-string-dark, #ce9178);--wy-code-changed: var(--wy-code-changed-dark, #569cd6);--wy-code-punctuation: var(--wy-code-punctuation-dark, #D4D4D4);--wy-code-function: var(--wy-code-function-dark, #569cd6);--wy-code-keyword: var(--wy-code-keyword-dark, #C586C0);--wy-code-class-name: var(--wy-code-class-name-dark, #4ec9b0)}`, zq = de`@property --wy-component-color{syntax: \"<color>\"; inherits: true; initial-value: currentColor;}@property --wy-component-background-color{syntax: \"<color>\"; inherits: true; initial-value: transparent;}`, _q = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), Eq([zq, Yi]);
    }
  }, u(i, "t"), i), p(t, "WeavyStyles"), t;
}, "WeavyStylesMixin"), Lq = /* @__PURE__ */ p((s) => {
  var i;
  var t;
  return t = (i = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...r) {
      super(...r), this.version = rn.version, this.whenUrl().then(() => {
        this.isDestroyed || this.checkVersion();
      });
    }
    /**
     * Checks the version of the Weavy Context against the Weavy Environment version.
     *
     * @param {string} [version] - Optional version to check against the environment version.
     */
    async checkVersion(r = this.version) {
      var a, o;
      await this.whenUrl(), this.networkStateIsPending = !0;
      let l;
      try {
        if (l = await fetch(new URL("/version", this.url), await this.fetchOptions({}, !1)), !l.ok)
          throw new Error("Could not verify environment version.");
        this.networkStateIsPending = !1, this.serverState = "ok";
      } catch (h) {
        this.networkStateIsPending = !1, this.serverState = "unreachable", console.warn("Could not check version: " + h.toString());
        return;
      }
      const c = await l.text();
      if (c.startsWith("v") && (!r || !c || r !== c))
        try {
          const h = r.split(".").slice(0, 2), d = c.split(".").slice(0, 2);
          if (h[0] !== d[0])
            throw new Error();
          h[1] !== d[1] && console.warn(
            `Version inconsistency: ${rn.sourceName}@${this.version} ≠ ${(a = this.url) == null ? void 0 : a.hostname}@${c}`
          );
        } catch {
          throw new Error(
            `Version mismatch! ${rn.sourceName}@${this.version} ≠ ${(o = this.url) == null ? void 0 : o.hostname}@${c}`
          );
        }
    }
  }, u(i, "t"), i), p(t, "WeavyVersion"), t;
}, "WeavyVersionMixin");
var IO, Hd;
let iA = (IO = (Hd = class extends Event {
  constructor(t, i, n) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.callback = i, this.subscribe = n ?? !1;
  }
}, u(Hd, "nn"), Hd), p(IO, "s"), IO);
var WO, Yd;
let Er = (WO = (Yd = class {
  constructor(t, i, n, r) {
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (a, o) => {
      this.unsubscribe && (this.unsubscribe !== o && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = a, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(a, o)), this.unsubscribe = o;
    }, this.host = t, i.context !== void 0) {
      const a = i;
      this.context = a.context, this.callback = a.callback, this.subscribe = a.subscribe ?? !1;
    } else this.context = i, this.callback = n, this.subscribe = r ?? !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new iA(this.context, this.t, this.subscribe));
  }
}, u(Yd, "an"), Yd), p(WO, "s"), WO);
var Gd;
const nA = (Gd = class {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, i = !1) {
    const n = i || !Object.is(t, this.o);
    this.o = t, n && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [i, { disposer: n }] of this.subscriptions) i(this.o, n);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, i, n) {
    if (!n) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: /* @__PURE__ */ p(() => {
      this.subscriptions.delete(t);
    }, "disposer"), consumerHost: i });
    const { disposer: r } = this.subscriptions.get(t);
    t(this.value, r);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}, u(Gd, "yp"), Gd);
p(nA, "s");
let Iq = nA;
var VO, Kd;
let Wq = (VO = (Kd = class extends Event {
  constructor(t) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t;
  }
}, u(Kd, "on"), Kd), p(VO, "e"), VO);
var ZO, Jd;
let y$ = (ZO = (Jd = class extends Iq {
  constructor(t, i, n) {
    var r, a;
    super(i.context !== void 0 ? i.initialValue : n), this.onContextRequest = (o) => {
      const l = o.composedPath()[0];
      o.context === this.context && l !== this.host && (o.stopPropagation(), this.addCallback(o.callback, l, o.subscribe));
    }, this.onProviderRequest = (o) => {
      const l = o.composedPath()[0];
      if (o.context !== this.context || l === this.host) return;
      const c = /* @__PURE__ */ new Set();
      for (const [h, { consumerHost: d }] of this.subscriptions) c.has(h) || (c.add(h), d.dispatchEvent(new iA(this.context, h, !0)));
      o.stopPropagation();
    }, this.host = t, i.context !== void 0 ? this.context = i.context : this.context = i, this.attachListeners(), (a = (r = this.host).addController) == null || a.call(r, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new Wq(this.context));
  }
}, u(Jd, "cn"), Jd), p(ZO, "i"), ZO);
function Xr({ context: s }) {
  return (t, i) => {
    const n = /* @__PURE__ */ new WeakMap();
    if (typeof i == "object") return i.addInitializer(function() {
      n.set(this, new y$(this, { context: s }));
    }), { get() {
      return t.get.call(this);
    }, set(r) {
      var a;
      return (a = n.get(this)) == null || a.setValue(r), t.set.call(this, r);
    }, init(r) {
      var a;
      return (a = n.get(this)) == null || a.setValue(r), r;
    } };
    {
      t.constructor.addInitializer((o) => {
        n.set(o, new y$(o, { context: s }));
      });
      const r = Object.getOwnPropertyDescriptor(t, i);
      let a;
      if (r === void 0) {
        const o = /* @__PURE__ */ new WeakMap();
        a = { get() {
          return o.get(this);
        }, set(l) {
          n.get(this).setValue(l), o.set(this, l);
        }, configurable: !0, enumerable: !0 };
      } else {
        const o = r.set;
        a = { ...r, set(l) {
          n.get(this).setValue(l), o == null || o.call(this, l);
        } };
      }
      return void Object.defineProperty(t, i, a);
    }
  };
}
u(Xr, "er");
p(Xr, "e$3");
function wt({ context: s, subscribe: t }) {
  return (i, n) => {
    typeof n == "object" ? n.addInitializer(function() {
      new Er(this, { context: s, callback: /* @__PURE__ */ p((r) => {
        i.set.call(this, r);
      }, "callback"), subscribe: t });
    }) : i.constructor.addInitializer((r) => {
      new Er(r, { context: s, callback: /* @__PURE__ */ p((a) => {
        r[n] = a;
      }, "callback"), subscribe: t });
    });
  };
}
u(wt, "Qt");
p(wt, "c");
var eu;
const sA = (eu = class extends Event {
  /**
   *
   * @param context the context key to request
   * @param callback the callback that should be invoked when the context with the specified key is available
   * @param subscribe when, true indicates we want to subscribe to future updates
   */
  constructor(t, i, n) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.callback = i, this.subscribe = n ?? !1;
  }
}, u(eu, "wp"), eu);
p(sA, "ContextRequestEvent");
let Vq = sA;
var tu;
const rA = (tu = class extends Event {
  /**
   *
   * @param context the context which this provider can provide
   */
  constructor(t) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t;
  }
}, u(tu, "fp"), tu);
p(rA, "ContextProviderEvent");
let Zq = rA;
var iu;
const aA = (iu = class extends y$ {
  constructor(t, i, n) {
    i.context !== void 0 ? super(t, i) : super(t, i, n), i.context !== void 0 ? this._context = i.context : this._context = i, this.isAttached = !0, this.host instanceof G || this.dispatchWhenConnected();
  }
  dispatchWhenConnected() {
    this.isAttached && (this.host.isConnected ? this.host.dispatchEvent(new Zq(this._context)) : requestAnimationFrame(this.dispatchWhenConnected));
  }
  detachListeners() {
    this.isAttached = !1, this.host.removeEventListener("context-request", this.onContextRequest), this.host.removeEventListener("context-provider", this.onProviderRequest);
  }
}, u(iu, "mp"), iu);
p(aA, "WyContextProvider");
let oA = aA;
const Pt = Symbol.for("weavy-client");
function lA(s, t) {
  return Bt(), new oA(s, { context: Pt, initialValue: t });
}
u(lA, "am");
p(lA, "createWeavyContextProvider");
const Ji = _1() ? lA(document.documentElement) : void 0, Dq = /* @__PURE__ */ p((s) => {
  var n;
  var t, i;
  return i = (n = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...a) {
      super(...a), U(this, t), this.host !== document.documentElement ? (Ji == null || Ji.detachListeners(), q(this, t, new oA(this.host, {
        context: Pt,
        initialValue: this
      }))) : Ji == null || Ji.setValue(this);
    }
    destroy() {
      var a;
      super.destroy(), this.host !== document.documentElement ? (a = P(this, t)) == null || a.detachListeners() : (Ji == null ? void 0 : Ji.value) === this && (Ji == null || Ji.setValue(void 0));
    }
  }, u(n, "i"), n), t = /* @__PURE__ */ new WeakMap(), p(i, "WeavyContextProvider"), i;
}, "WeavyContextProviderMixin");
var og, lg, Us, My, Mt;
const Ry = (Mt = class {
  // CONSTRUCTOR
  constructor(t) {
    U(this, og), U(this, lg), U(this, Us), U(this, My), this.weavySid = ff(), this.weavyId = `${Mt.sourceName}#${this.weavySid}`, this.cloudFilePickerUrl = Mt.defaults.cloudFilePickerUrl, this.disableEnvironmentImports = Mt.defaults.disableEnvironmentImports, this.gcTime = Mt.defaults.gcTime, this.reactions = Mt.defaults.reactions, this.scrollBehavior = Mt.defaults.scrollBehavior, this.staleTime = Mt.defaults.staleTime, this.tokenFactoryRetryDelay = Mt.defaults.tokenFactoryRetryDelay, this.tokenFactoryTimeout = Mt.defaults.tokenFactoryTimeout, q(this, lg, new Promise((n) => {
      q(this, og, n);
    })), q(this, My, !1), console.info(`${Mt.sourceName}@${Mt.version} #${this.weavySid}`), Bt(), this.host = document.documentElement;
    const i = {};
    for (const n in t) {
      const r = n;
      t[r] !== void 0 && Object.assign(i, { [r]: t[r] });
    }
    i != null && i.host && (this.host = i.host, delete i.host), Object.assign(this, i);
  }
  async whenUrl() {
    await P(this, lg);
  }
  /**
   * The URL to the weavy environment.
   */
  get url() {
    return P(this, Us);
  }
  set url(t) {
    var i;
    if (this.isDestroyed)
      throw new mt();
    try {
      if (typeof t == "string")
        t && q(this, Us, new URL(t, window.location.toString()));
      else if (t instanceof URL)
        q(this, Us, t || void 0);
      else if (t == null)
        q(this, Us, void 0);
      else
        throw -1;
    } catch {
      throw new TypeError("Invalid url");
    }
    t && !this.disableEnvironmentImports && globalThis.WEAVY_IMPORT_URL === void 0 && (globalThis.WEAVY_IMPORT_URL = new URL(
      "./uikit-web/",
      t
    ).href), P(this, Us) && ((i = P(this, og)) == null || i.call(this, P(this, Us)));
  }
  /**
   * Prefix to use for caches.
   */
  get cachePrefix() {
    return `${Mt.version}:${this.url}`;
  }
  get isDestroyed() {
    return P(this, My);
  }
  destroy() {
    q(this, My, !0), console.info(this.weavyId, "was destroyed");
  }
}, u(Mt, "Gt"), Mt);
og = /* @__PURE__ */ new WeakMap(), lg = /* @__PURE__ */ new WeakMap(), Us = /* @__PURE__ */ new WeakMap(), My = /* @__PURE__ */ new WeakMap(), p(Ry, "WeavyClient"), Ry.version = "26.0.3", Ry.sourceName = "@weavy/uikit-web", Ry.defaults = {
  cloudFilePickerUrl: "https://filebrowser.weavy.io/v14/",
  disableEnvironmentImports: !1,
  gcTime: 1e3 * 60 * 60 * 24,
  // 24h,
  locale: xR,
  reactions: ["😍", "😎", "😉", "😜", "👍"],
  notificationEvents: !1,
  scrollBehavior: "auto",
  staleTime: 1e3 * 1,
  // 1s
  tokenFactoryRetryDelay: 2e3,
  tokenFactoryTimeout: 2e4
};
let rn = Ry;
var nu;
const cA = (nu = class extends Dq(
  vq(
    Cq(
      xq(
        bq(
          kq(
            Oq(
              Pq(Lq($q(_q(rn))))
            )
          )
        )
      )
    )
  )
) {
}, u(nu, "vp"), nu);
p(cA, "Weavy");
let cg = cA;
var su;
const hA = (su = class {
  constructor(t, i, n, r, a) {
    var o, l;
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this._callback = (c, h) => {
      this.unsubscribe && (this.unsubscribe !== h && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = c, this.host.requestUpdate(), (!this.provided || this.subscribe) && (this.provided = !0, this.callback && this.callback(c, h)), this.unsubscribe = h;
    }, this.host = t, i.context !== void 0) {
      const c = i;
      this.context = c.context, this.callback = c.callback, this.subscribe = c.subscribe ?? !1, this.ref = c.ref ?? t;
    } else
      this.context = i, this.callback = n, this.subscribe = r ?? !1, this.ref = a ?? t;
    (l = (o = this.host).addController) == null || l.call(o, this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.ref.dispatchEvent(
      new Vq(this.context, this._callback, this.subscribe)
    );
  }
}, u(su, "gp"), su);
p(hA, "ContextConsumer");
let qq = hA;
var ru;
const dA = (ru = class {
  /**
   * @param host - The host element
   * @param context - The Context to use. Should be constructed using createContext().
   */
  constructor(t, i, n) {
    this.whenRef = new Promise((r) => this.resolveRef = r), t.addController(this), this.host = t, this.ref = n, this.setContext(i);
  }
  /**
   * The DOM connected element that can subscribe to a context
   */
  get ref() {
    return this._ref;
  }
  set ref(t) {
    var i;
    this._ref = t, t && ((i = this.resolveRef) == null || i.call(this, t));
  }
  async setContext(t) {
    this.whenContext = new Promise((n) => this.resolveContext = n);
    const i = await this.whenRef;
    this.context = new qq(this.host, {
      context: t,
      subscribe: !0,
      callback: /* @__PURE__ */ p((n, r) => {
        var a;
        (a = this.resolveContext) == null || a.call(this, n), this.host.requestUpdate();
      }, "callback"),
      ref: i
    }), await N$(i), this.context.dispatchRequest();
  }
  hostUpdate() {
    var t, i;
    (t = this.context) != null && t.value && ((i = this.resolveContext) == null || i.call(this, this.context.value));
  }
}, u(ru, "bp"), ru);
p(dA, "ContextController");
let Uq = dA;
const Nq = { attribute: !0, type: String, converter: n1, reflect: !1, hasChanged: _k }, Bq = /* @__PURE__ */ p((s = Nq, t, i) => {
  const { kind: n, metadata: r } = i;
  let a = globalThis.litPropertyMetadata.get(r);
  if (a === void 0 && globalThis.litPropertyMetadata.set(r, a = /* @__PURE__ */ new Map()), a.set(i.name, s), n === "accessor") {
    const { name: o } = i;
    return { set(l) {
      const c = t.get.call(this);
      t.set.call(this, l), this.requestUpdate(o, c, s);
    }, init(l) {
      return l !== void 0 && this.P(o, void 0, s), l;
    } };
  }
  if (n === "setter") {
    const { name: o } = i;
    return function(l) {
      const c = this[o];
      t.call(this, l), this.requestUpdate(o, c, s);
    };
  }
  throw Error("Unsupported decorator location: " + n);
}, "r$1");
function x(s) {
  return (t, i) => typeof i == "object" ? Bq(s, t, i) : ((n, r, a) => {
    const o = r.hasOwnProperty(a);
    return r.constructor.createProperty(a, o ? { ...n, wrapped: !0 } : n), o ? Object.getOwnPropertyDescriptor(r, a) : void 0;
  })(s, t, i);
}
u(x, "w");
p(x, "n");
function B(s) {
  return x({ ...s, state: !0, attribute: !1 });
}
u(B, "D");
p(B, "r");
const jq = /* @__PURE__ */ p((s, t, i) => (i.configurable = !0, i.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(s, t, i), i), "e$2");
function uA(s) {
  return (t, i) => {
    const { slot: n, selector: r } = s ?? {}, a = "slot" + (n ? `[name=${n}]` : ":not([name])");
    return jq(t, i, { get() {
      var o;
      const l = (o = this.renderRoot) == null ? void 0 : o.querySelector(a), c = (l == null ? void 0 : l.assignedElements(s)) ?? [];
      return r === void 0 ? c : c.filter((h) => h.matches(r));
    } });
  };
}
u(uA, "hm");
p(uA, "o");
var hg, au;
const pA = (au = class {
  //notificationsToasts: NotificationsToastsType = "browser";
  // PROPERTY INIT
  constructor(t) {
    U(this, hg), this.notifications = "button-list", this.notificationsBadge = "count", q(this, hg, t), Object.keys(this).forEach((i) => {
      i in t && Object.assign(this, { [i]: t[i] });
    });
  }
  /**
   * Provides a reference to the host.
   */
  get component() {
    return P(this, hg);
  }
}, u(au, "xp"), au);
hg = /* @__PURE__ */ new WeakMap(), p(pA, "WeavyComponentSettings");
let v4 = pA;
const fA = Symbol.for("weavy-component-settings");
var If = /* @__PURE__ */ ((s) => (s.Chat = "chat", s.Comments = "comments", s.Feeds = "feeds", s.Files = "files", s.Messenger = "messenger", s))(If || {});
const O4 = {
  attachments: "attachments",
  bots: "bots",
  cloud_files: "cloudFiles",
  comments: "comments",
  embeds: "embeds",
  google_meet: "googleMeet",
  meetings: "meetings",
  mentions: "mentions",
  microsoft_teams: "microsoftTeams",
  polls: "polls",
  previews: "previews",
  reactions: "reactions",
  receipts: "receipts",
  thumbnails: "thumbnails",
  typing: "typing",
  versions: "versions",
  web_dav: "webDAV",
  webhooks: "webhooks",
  zoom_meetings: "zoomMeetings"
}, Xq = {
  attachments: "noAttachments",
  cloud_files: "noCloudFiles",
  comments: "noComments",
  embeds: "noEmbeds",
  google_meet: "noGoogleMeet",
  mentions: "noMentions",
  microsoft_teams: "noMicrosoftTeams",
  polls: "noPolls",
  previews: "noPreviews",
  reactions: "noReactions",
  receipts: "noReceipts",
  thumbnails: "noThumbnails",
  typing: "noTyping",
  versions: "noVersions",
  web_dav: "noWebDAV",
  zoom_meetings: "noZoomMeetings"
};
var ou;
const yA = (ou = class {
  get result() {
    return this._result && this.observer ? this.observer.trackResult(this._result) : { isPending: !0 };
  }
  constructor(t) {
    t.addController(this), this.host = t, this.whenContext = new Promise((i) => this.resolveContext = i), this.whenQueryClient = new Promise((i) => this.resolveQueryClient = i), this.setContext();
  }
  async setContext() {
    await _o(this.host), this.context = new Er(this.host, {
      context: Pt,
      subscribe: !0,
      callback: /* @__PURE__ */ p((t) => {
        var i, n;
        t && ((i = this.resolveContext) == null || i.call(this, t), this.queryClient = t.queryClient, (n = this.resolveQueryClient) == null || n.call(this, t.queryClient));
      }, "callback")
    });
  }
  async trackQuery(t, i = !0) {
    var n;
    const r = await this.whenQueryClient;
    if (!r)
      throw new Error("No QueryClient provided");
    (n = this.observerUnsubscribe) == null || n.call(this);
    const a = new iR(r, t);
    this.observer = a, this.observerSubscribe(i);
  }
  observerSubscribe(t = !0) {
    var i;
    if (this.queryClient && this.observer) {
      t ? this._result = this.observer.getOptimisticResult(this.observer.options) : this._result = this.observer.getCurrentResult(), this.observerUnsubscribe = this.observer.subscribe(() => {
        if (this.observer) {
          const r = Lf(this.result, this.observer.getCurrentResult());
          r !== this._result && (this._result = r, this.host.requestUpdate());
        }
      }), this.observer.updateResult(), this.host.requestUpdate();
      let n;
      t ? n = this.observer.fetchOptimistic(this.observer.options) : n = (i = this.queryClient.getQueryCache().get(this.observer.options.queryHash)) == null ? void 0 : i.promise, n == null || n.catch(() => {
      }).finally(() => {
        var r;
        (r = this.observer) == null || r.updateResult();
      });
    }
  }
  untrackQuery() {
    var t;
    (t = this.observerUnsubscribe) == null || t.call(this), this.observerUnsubscribe = void 0, this._result = void 0, this.observer = void 0, this.host.requestUpdate();
  }
  hostConnected() {
    this.observerSubscribe();
  }
  hostDisconnected() {
    var t;
    (t = this.observerUnsubscribe) == null || t.call(this);
  }
}, u(ou, "$p"), ou);
p(yA, "QueryController");
let Ei = yA;
const r5 = Symbol.for("weavy-app"), dv = Symbol.for("weavy-user"), a5 = Symbol.for("weavy-product-features"), mA = Symbol.for("weavy-link"), wA = Symbol.for("weavy-bot-user");
var Fq = Object.defineProperty, Hq = Object.getOwnPropertyDescriptor, Le = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Hq(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Fq(t, i, r), r;
}, "__decorateClass$18"), Ay, Ey, dg, ug, pg, fg, zy, _y, yg, mg, wg, gg, vg, Og, ga, ql, Ul, cs, lu;
const gA = (lu = class extends G {
  // PROPERTY INIT
  constructor() {
    super(), U(this, Ay), U(this, Ey), U(this, dg), U(this, ug), U(this, pg), U(this, fg), U(this, zy), U(this, _y), U(this, yg), U(this, mg), U(this, wg), U(this, gg), U(this, vg), U(this, Og), U(this, ga), U(this, ql), U(this, Ul), U(this, cs), this.storage = UM("localStorage"), this.storageLinkHandler = (t) => {
      t.storageArea === this.storage && t.key === "wy-link" && t.newValue && this.readStorageLink();
    }, this.linkEventHandler = async (t) => {
      t.defaultPrevented || (this.link && this.link.id === t.detail.link.id && (this.link = void 0, await this.updateComplete), this.link = t.detail.link, this.link || this.provideStorageLink(t.detail.link));
    }, this.notificationEventHandler = (t) => {
      t.stopPropagation(), t.defaultPrevented || this.isConnected && this.checkVisibility(B$) && this.matchesLink(t.detail.link) && t.preventDefault();
    }, this.notifications = "button-list", this.notificationsBadge = "count", this.noAttachments = !1, this.noCloudFiles = !1, this.noComments = !1, this.noEmbeds = !1, this.noGoogleMeet = !1, this.noMentions = !1, this.noMicrosoftTeams = !1, this.noPolls = !1, this.noPreviews = !1, this.noReactions = !1, this.noReceipts = !1, this.noThumbnails = !1, this.noTyping = !1, this.noVersions = !1, this.noWebDAV = !1, this.noZoomMeetings = !1, q(this, Ey, new Promise((t) => {
      q(this, Ay, t);
    })), q(this, ug, new Promise((t) => {
      q(this, dg, t);
    })), q(this, fg, new Promise((t) => {
      q(this, pg, t);
    })), q(this, _y, new Promise((t) => {
      q(this, zy, t);
    })), q(this, mg, new Promise((t) => {
      q(this, yg, t);
    })), q(this, gg, new Promise((t) => {
      q(this, wg, t);
    })), q(this, Og, new Promise((t) => {
      q(this, vg, t);
    })), q(this, ga, new Ei(this)), q(this, ql, new Ei(this)), q(this, Ul, new Ei(this)), q(this, cs, new Ei(this)), this.settings = new v4(this);
  }
  /**
   * Checks if an Entity is matching the component.
   *
   * @param {EntityType} link Entity to check for match
   * @returns { boolean } True if the entity is matching the component
   */
  matchesLink(t) {
    var i, n, r;
    return (
      // Messenger conversation
      (i = t == null ? void 0 : t.app) != null && i.type && !this.componentType && (n = this.appTypes) != null && n.includes(t.app.type) ? t.bot ? t.bot === this.bot : !0 : (
        // Normal contextual app
        !!(t && t.app && this.componentType !== Ni.Unknown && this.uid && ((r = t.app) == null ? void 0 : r.uid) === this.uid)
      )
    );
  }
  get link() {
    return this._link;
  }
  set link(t) {
    const i = this._link;
    !this.uid && this.componentType && this.componentType !== Ni.Unknown ? this.whenApp().then(() => {
      this._link = this.matchesLink(t) ? t : void 0, this.requestUpdate("link", i);
    }) : (this._link = this.matchesLink(t) ? t : void 0, this.requestUpdate("link", i));
  }
  /**
   * Clears the link and resets the promise.
   */
  clearLink() {
    this.link && (q(this, _y, new Promise((t) => {
      q(this, zy, t);
    })), this.link = void 0);
  }
  /**
   * Shares a link with other blocks that may consume it automatically.
   *
   * @param {LinkType} link - The entity to provide
   */
  provideStorageLink(t) {
    var i;
    (i = this.storage) == null || i.setItem("wy-link", btoa(JSON.stringify(t)));
  }
  /**
   * Reads a link from storage provides it in the .link property/context.
   */
  readStorageLink() {
    if (!this.storage) {
      console.error("Storage not available");
      return;
    }
    const t = this.storage.getItem("wy-link");
    if (t)
      try {
        const i = JSON.parse(atob(t));
        i && (this.link = i);
      } catch (i) {
        console.error("Error parsing link", i);
      }
  }
  /**
   * Consumes a link in the storage. Make sure to consume it after it has been used.
   */
  consumeStorageLink() {
    var t;
    (t = this.storage) == null || t.removeItem("wy-link");
  }
  get bot() {
    return this._bot;
  }
  set bot(t) {
    this._bot = t || void 0;
  }
  set name(t) {
    this._initialAppName ?? (this._initialAppName = t), this._appName = t;
  }
  get name() {
    return this._appName;
  }
  async whenApp() {
    return await P(this, Ey);
  }
  async whenBotUser() {
    return await P(this, ug);
  }
  async whenHasFeatures() {
    return await P(this, fg);
  }
  async whenLink() {
    return await P(this, _y);
  }
  async whenSettings() {
    return await P(this, mg);
  }
  async whenUser() {
    return await P(this, gg);
  }
  async whenWeavy() {
    return await P(this, Og);
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("wy-link", this.linkEventHandler), window.addEventListener("storage", this.storageLinkHandler), this.app && this.requestUpdate("app"), this.botUser && this.requestUpdate("botUser"), this.hasFeatures && this.requestUpdate("hasFeatures"), this.link && this.requestUpdate("link"), this.settings && this.requestUpdate("settings"), this.user && this.requestUpdate("user"), this.weavy && this.requestUpdate("weavy");
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), document.removeEventListener("wy-link", this.linkEventHandler), window.removeEventListener("storage", this.storageLinkHandler), (t = this.weavy) == null || t.host.removeEventListener("wy-notification", this.notificationEventHandler, { capture: !0 });
  }
  async scheduleUpdate() {
    await _o(this), super.scheduleUpdate();
  }
  willUpdate(t) {
    var i, n, r, a, o, l, c, h, d, f, y, w, g, b, k, $, C, E, A, R, L;
    if (super.willUpdate(t), this.weavyContextConsumer ?? (this.weavyContextConsumer = new Er(this, { context: Pt, subscribe: !0 })), (i = this.weavyContextConsumer) != null && i.value && this.weavy !== ((n = this.weavyContextConsumer) == null ? void 0 : n.value) && (this.weavy = (r = this.weavyContextConsumer) == null ? void 0 : r.value), Object.keys(this.settings).find((I) => t.has(I)) && (this.settings = new v4(this)), t.has("weavy") && this.weavy && P(this, cs).trackQuery(ln(this.weavy, ["user"])), (a = P(this, cs).result) != null && a.isPending || this.user && P(this, cs).result.data && this.user.id !== P(this, cs).result.data.id && (console.warn("User changed, invalidating cache"), (o = this.weavy) == null || o.queryClient.invalidateQueries()), (l = P(this, cs).result) != null && l.isPending || (this.user = (c = P(this, cs).result) == null ? void 0 : c.data), (t.has("productType") || t.has("weavy")) && this.productType && this.weavy && P(this, Ul).trackQuery(
      ln(this.weavy, ["features", this.productType])
    ), !((h = P(this, Ul).result) != null && h.isPending)) {
      const I = (d = P(this, Ul).result) == null ? void 0 : d.data;
      if (I) {
        const D = {};
        I.forEach((ee) => {
          const se = this[Xq[ee]];
          O4[ee] ? D[O4[ee]] = !se : console.warn("Unknown feature provided:", ee);
        });
        const j = this.hasFeatures;
        this.hasFeatures = D, this.requestUpdate("features", j);
      }
    }
    if (t.has("componentType") || t.has("uid") || t.has("name") || t.has("weavy"))
      if (q(this, Ey, new Promise((I) => {
        q(this, Ay, I);
      })), this.componentType && this.uid && this.weavy) {
        const I = this.name ? { name: this.name } : void 0;
        P(this, ga).trackQuery(yR(this.weavy, this.uid, this.componentType, I));
      } else
        P(this, ga).untrackQuery(), this.app = void 0, this.name = this._initialAppName;
    (f = P(this, ga).result) != null && f.isPending || (this.app = (y = P(this, ga).result) == null ? void 0 : y.data, (w = this.app) != null && w.name && (this.name = this.app.name)), (t.has("weavy") || t.has("bot")) && this.weavy && this.bot && P(this, ql).trackQuery(ln(this.weavy, ["users", this.bot])), (g = P(this, ql).result) != null && g.isPending || (this.botUser = (b = P(this, ql).result) == null ? void 0 : b.data), t.has("uid") && (this.uid || t.get("uid")) && this.uid !== t.get("uid") && this.clearLink(), (!this.link && (t.has("uid") && this.uid || t.has("app") && this.app) && this.componentType && this.componentType !== Ni.Unknown || (t.has("appTypes") || t.has("bot")) && this.appTypes) && this.readStorageLink(), t.has("link") && this.link && (console.info(`Opening notification link in ${this.uid ?? this.componentType ?? this.productType}`), this.consumeStorageLink()), t.has("app") && this.app && ((k = P(this, Ay)) == null || k.call(this, this.app)), t.has("botUser") && this.botUser && (($ = P(this, dg)) == null || $.call(this, this.botUser)), t.has("hasFeatures") && this.hasFeatures && ((C = P(this, pg)) == null || C.call(this, this.hasFeatures)), t.has("link") && this.link && ((E = P(this, zy)) == null || E.call(this, this.link)), t.has("settings") && this.settings && ((A = P(this, yg)) == null || A.call(this, this.settings)), t.has("user") && this.user && ((R = P(this, wg)) == null || R.call(this, this.user)), t.has("weavy") && this.weavy && (this.weavy.host.addEventListener("wy-notification", this.notificationEventHandler, { capture: !0 }), (L = P(this, vg)) == null || L.call(this, this.weavy));
  }
}, u(lu, "kp"), lu);
Ay = /* @__PURE__ */ new WeakMap(), Ey = /* @__PURE__ */ new WeakMap(), dg = /* @__PURE__ */ new WeakMap(), ug = /* @__PURE__ */ new WeakMap(), pg = /* @__PURE__ */ new WeakMap(), fg = /* @__PURE__ */ new WeakMap(), zy = /* @__PURE__ */ new WeakMap(), _y = /* @__PURE__ */ new WeakMap(), yg = /* @__PURE__ */ new WeakMap(), mg = /* @__PURE__ */ new WeakMap(), wg = /* @__PURE__ */ new WeakMap(), gg = /* @__PURE__ */ new WeakMap(), vg = /* @__PURE__ */ new WeakMap(), Og = /* @__PURE__ */ new WeakMap(), ga = /* @__PURE__ */ new WeakMap(), ql = /* @__PURE__ */ new WeakMap(), Ul = /* @__PURE__ */ new WeakMap(), cs = /* @__PURE__ */ new WeakMap(), p(gA, "WeavyComponent");
let Ce = gA;
Le([
  B()
], Ce.prototype, "weavy", 2);
Le([
  Xr({ context: r5 }),
  B()
], Ce.prototype, "app", 2);
Le([
  Xr({ context: wA }),
  B()
], Ce.prototype, "botUser", 2);
Le([
  Xr({ context: a5 }),
  B()
], Ce.prototype, "hasFeatures", 2);
Le([
  Xr({ context: fA }),
  B()
], Ce.prototype, "settings", 2);
Le([
  Xr({ context: dv }),
  B()
], Ce.prototype, "user", 2);
Le([
  Xr({ context: mA })
], Ce.prototype, "_link", 2);
Le([
  x({ type: Object })
], Ce.prototype, "link", 1);
Le([
  B()
], Ce.prototype, "productType", 2);
Le([
  B()
], Ce.prototype, "componentType", 2);
Le([
  B()
], Ce.prototype, "appTypes", 2);
Le([
  x({ type: String })
], Ce.prototype, "bot", 1);
Le([
  x({ type: String })
], Ce.prototype, "uid", 2);
Le([
  x({ type: String })
], Ce.prototype, "name", 1);
Le([
  x({ type: String })
], Ce.prototype, "notifications", 2);
Le([
  x({ type: String })
], Ce.prototype, "notificationsBadge", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noAttachments", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noCloudFiles", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noComments", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noEmbeds", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noGoogleMeet", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noMentions", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noMicrosoftTeams", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noPolls", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noPreviews", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noReactions", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noReceipts", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noThumbnails", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noTyping", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noVersions", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noWebDAV", 2);
Le([
  x({ type: Boolean })
], Ce.prototype, "noZoomMeetings", 2);
const Yq = new Map(Dk(dR)), DH = new Map(Dk(uR)), Gq = new Map(Object.entries(pR));
new Map(Object.entries(fR));
var Kq = Object.defineProperty, ya = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = void 0, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = o(t, i, r) || r);
  return r && Kq(t, i, r), r;
}, "__decorateClass$17");
const tt = /* @__PURE__ */ p((s) => {
  var $;
  var t, i, n, r, a, o, l, c, h, d, f, y, w, g;
  const b = ($ = class extends s {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...E) {
      super(...E), U(this, t), U(this, i, new Promise((A) => {
        q(this, t, A);
      })), U(this, n), U(this, r, new Promise((A) => {
        q(this, n, A);
      })), U(this, a), U(this, o, new Promise((A) => {
        q(this, a, A);
      })), U(this, l), U(this, c, new Promise((A) => {
        q(this, l, A);
      })), U(this, h), U(this, d, new Promise((A) => {
        q(this, h, A);
      })), U(this, f), U(this, y, new Promise((A) => {
        q(this, f, A);
      })), U(this, w), U(this, g, new Promise((A) => {
        q(this, w, A);
      }));
    }
    async whenApp() {
      return await P(this, i);
    }
    async whenBotUser() {
      return await P(this, r);
    }
    async whenHasFeatures() {
      return await P(this, o);
    }
    async whenLink() {
      return await P(this, c);
    }
    async whenSettings() {
      return await P(this, d);
    }
    async whenUser() {
      return await P(this, y);
    }
    async whenWeavy() {
      return await P(this, g);
    }
    willUpdate(E) {
      var A, R, L, I, D, j, ee;
      super.willUpdate(E), E.has("app") && this.app && ((A = P(this, t)) == null || A.call(this, this.app)), E.has("botUser") && this.botUser && ((R = P(this, n)) == null || R.call(this, this.botUser)), E.has("hasFeatures") && this.hasFeatures && ((L = P(this, a)) == null || L.call(this, this.hasFeatures)), E.has("link") && this.link && ((I = P(this, l)) == null || I.call(this, this.link)), E.has("settings") && this.settings && ((D = P(this, h)) == null || D.call(this, this.settings)), E.has("user") && this.user && ((j = P(this, f)) == null || j.call(this, this.user)), E.has("weavy") && this.weavy && ((ee = P(this, w)) == null || ee.call(this, this.weavy));
    }
    connectedCallback() {
      super.connectedCallback(), this.app && this.requestUpdate("app"), this.botUser && this.requestUpdate("botUser"), this.hasFeatures && this.requestUpdate("hasFeatures"), this.link && this.requestUpdate("link"), this.settings && this.requestUpdate("settings"), this.user && this.requestUpdate("user"), this.weavy && this.requestUpdate("weavy");
    }
  }, u($, "S"), $);
  t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), p(b, "WeavyComponentConsumer");
  let k = b;
  return ya([
    wt({ context: r5, subscribe: !0 }),
    B()
  ], k.prototype, "app"), ya([
    wt({ context: wA, subscribe: !0 }),
    B()
  ], k.prototype, "botUser"), ya([
    wt({ context: a5, subscribe: !0 }),
    B()
  ], k.prototype, "hasFeatures"), ya([
    wt({ context: mA, subscribe: !0 }),
    B()
  ], k.prototype, "link"), ya([
    wt({ context: fA, subscribe: !0 }),
    B()
  ], k.prototype, "settings"), ya([
    wt({ context: dv, subscribe: !0 }),
    B()
  ], k.prototype, "user"), ya([
    wt({ context: Pt, subscribe: !0 }),
    B()
  ], k.prototype, "weavy"), k;
}, "WeavyComponentConsumerMixin");
function vA(s) {
  return typeof s == "string" && s ? s = eval == null ? void 0 : (0, eval)(`"use strict";(${s})`) : s = void 0, s;
}
u(vA, "vm");
p(vA, "indirectEvalObject");
function Jm(s) {
  if (s)
    try {
      return new URL(s, window.location.toString());
    } catch {
      console.warn("Invalid url: ", s);
    }
}
u(Jm, "fl");
p(Jm, "toUrl");
const F = /* @__PURE__ */ p((s) => (t, i) => {
  i !== void 0 ? i.addInitializer(() => {
    !customElements.get(s) && customElements.define(
      s,
      t
    );
  }) : !customElements.get(s) && customElements.define(s, t);
}, "customElement"), fe = de`@charset \"UTF-8\";:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]){box-sizing:border-box;text-align:initial;font-size:var(--wy-font-size, var(--wy-size, 1em))}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:before,:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:after{box-sizing:inherit}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a){text-decoration:var(--wy-link-decoration, none);color:var(--wy-link, var(--wy-primary-40, #006399))}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a):hover,:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a):hover{text-decoration:var(--wy-link-hover-decoration, unset)}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a):where(:not([href]):not([class])),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a):where(:not([href]):not([class])):hover,:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a):where(:not([href]):not([class])),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a):where(:not([href]):not([class])):hover{text-decoration:none}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(p),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(p){margin-top:0;margin-bottom:calc(1 * var(--wy-size, 1rem))}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(label),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(label){cursor:inherit}:where(:host([hidden])),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"])[hidden],:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *[hidden]{display:none!important}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where([role=button]),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where([role=button]){cursor:pointer}.wy-scroll-y{scroll-padding-top:var(--wy-scrollbar-adjust-top, 0);scroll-padding-bottom:var(--wy-scrollbar-adjust-bottom, 0)}.wy-scroll-y{overflow-y:auto;max-height:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-scroll-y:not(body){-webkit-overflow-scrolling:touch}.wy-scroll-y:not(.wy-scroll-x){overflow-x:hidden;touch-action:pan-y}.wy-scroll-x{overflow-x:auto;max-width:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-scroll-x:not(.wy-scroll-y){overflow-y:hidden;touch-action:pan-x}.wy-appbars{--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));background-color:var(--wy-component-background-color);box-shadow:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0 calc(-1 * var(--wy-border, 1px)) 0 0 inset}@supports (position: sticky){.wy-appbars{position:sticky;top:0;z-index:1020}}.wy-appbars>.wy-appbar,.wy-appbars>.wy-toolbar{background-color:transparent;box-shadow:none}.wy-appbar{--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));display:grid;align-items:center;justify-content:space-between;justify-items:center;height:var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem)))));padding:calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))));flex:0 0 var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem)))));grid-template-columns:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) minmax(0,max-content) var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));column-gap:calc(2 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))) + var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))));line-height:var(--wy-line-height, 1.5);background-color:var(--wy-component-background-color);color:var(--wy-component-color);box-shadow:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0 calc(-1 * var(--wy-border, 1px)) 0 0 inset}.wy-appbar .wy-badge{align-self:center}.wy-appbar .wy-button{max-height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))}.wy-appbar-buttons,.wy-toolbar-buttons,.wy-appbar-section{display:flex;flex:0 0 auto;align-items:center;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));max-width:100%}.wy-appbar-buttons-first{justify-content:flex-start}.wy-appbar-buttons-last{justify-content:flex-end}.wy-toolbar-buttons-last{margin-inline-start:auto}.wy-appbar-text{max-width:100%;display:block;color:inherit!important;-webkit-user-select:none;user-select:none}.wy-appbar-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-appbar-text a,.wy-appbar-text a:hover{color:inherit}.wy-appbar-text-trashed{text-decoration:line-through}.wy-toolbars-bottom{position:absolute;z-index:1030;bottom:calc(var(--wy-footerbar-height, calc(4 * var(--wy-size, 1rem))) / 2);left:0;right:0;min-height:var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem)))));display:flex;flex-direction:column;justify-content:center;justify-items:center}.wy-toolbar{--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-start;justify-items:center;min-height:var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem)))));padding:calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))));flex:1 0 var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem)))));column-gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));line-height:var(--wy-line-height, 1.5);background-color:var(--wy-component-background-color);color:var(--wy-component-color);box-shadow:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0 calc(-1 * var(--wy-border, 1px)) 0 0 inset}.wy-toolbar-center{margin:0 auto;border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)))}.wy-toolbar-center .wy-input{text-align:center}.wy-toolbar-text{margin-left:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))}.wy-footerbar{--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));position:absolute;bottom:0;left:0;right:0;z-index:1020}.wy-footerbar:after{content:\"\";background-color:var(--wy-component-background-color);color:var(--wy-component-color);box-shadow:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0 var(--wy-border, 1px) 0 0 inset;position:absolute;width:100%;left:0;bottom:0;height:100%;z-index:-1}.wy-footerbar-sticky{position:sticky}[part~=wy-button]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));color:var(--wy-component-color);background:var(--wy-component-background-color, transparent);height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));font-family:var(--wy-button-font-family, var(--wy-font-family, unset)),inherit;font-size:var(--wy-button-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-button-font-weight, var(--wy-font-weight, unset));line-height:var(--wy-button-line-height, var(--wy-line-height, 1.5));text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;user-select:none;border:var(--wy-button-border-width, var(--wy-border-outline, 0)) solid var(--wy-outline, var(--wy-neutral-variant-50, #72777e));border-radius:var(--wy-button-border-radius, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));display:inline-flex;align-items:center;justify-content:center;gap:var(--wy-button-gap, var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))))));position:relative}[part~=wy-button][part~=wy-button-sm]{height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .8);padding:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .25) calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .5)}[part~=wy-button]:disabled{opacity:var(--wy-opacity-disabled, 38%);cursor:unset;pointer-events:none}[part~=wy-button-state-layer]>*{z-index:3}[part~=wy-button-state-layer]:before{content:\"\";z-index:2;position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;background:var(--wy-component-color);opacity:0%}[part~=wy-button-state-layer]:hover:before{opacity:8%}[part~=wy-button-state-layer]:focus:before,[part~=wy-button-state-layer]:active:before,[part~=wy-button-state-layer][part~=wy-active]:before{opacity:12%}[part~=wy-button-icon]{--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));width:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))));line-height:1;align-items:center;justify-content:center}[part~=wy-button-icon][part~=wy-button-sm]{height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);width:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);padding:0;margin:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .5)}[part~=wy-button-icon][part~=wy-button-sm][part~=wy-button-state-layer]:before{margin:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * -.1)}[part~=wy-button-icon][part~=wy-active]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-button-icon-inline]{height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));width:auto;min-width:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));background:var(--wy-component-background-color);color:currentColor;display:flex;padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))}[part~=wy-button-icon-inline][part~=wy-button-sm]{height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);min-width:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);padding:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .25);margin:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .5)}[part~=wy-button-icon-inline][part~=wy-button-sm][part~=wy-button-state-layer]:before{margin:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * -.1)}[part~=wy-button-inline]{border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));padding:calc(.5 * var(--wy-size, 1rem)) calc(.75 * var(--wy-size, 1rem));margin-inline:calc(-.25 * var(--wy-size, 1rem))}[part~=wy-button-primary]{--wy-component-background-color: var(--wy-primary, var(--wy-primary-40, #006399));--wy-component-color: var(--wy-on-primary, var(--wy-white, #ffffff))}[part~=wy-button-variant]{--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}[part~=wy-button-primary-text]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-button-inherit-color]{--wy-component-color: currentColor}[part~=wy-button-no-color]{--wy-component-color: unset}[part=wy-button-link]{padding:0;color:var(--wy-link-color, var(--wy-primary, var(--wy-primary-40, #006399)));text-decoration:var(--wy-link-decoration, none)}[part=wy-button-link]:hover,[part=wy-button-link]:focus{text-decoration:var(--wy-link-hover-decoration, unset)}[part~=wy-buttons]{display:flex;align-items:center;flex-wrap:wrap;gap:calc(.5 * var(--wy-size, 1rem))}[part~=wy-buttons-reverse]{flex-direction:row-reverse}[part~=wy-buttons-floating]{position:sticky;padding:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) 0;top:0;height:0;margin-bottom:calc(-1 * var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));z-index:1030;--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}.wy-code pre,.wy-editor .cm-content pre,.wy-content pre{text-wrap:pretty}.wy-code .code,.wy-code code[class*=language-],.wy-code pre[class*=language-],.wy-editor .cm-content .code,.wy-content .code,.wy-editor .cm-content code[class*=language-],.wy-content code[class*=language-],.wy-editor .cm-content pre[class*=language-],.wy-content pre[class*=language-]{color:var(--wy-code-text, var(--wy-code-text-light, #3b3b3b));font-family:var(--wy-font-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace);text-align:left;white-space:pre-wrap;word-spacing:normal;word-break:normal;word-wrap:break-word;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none}@media print{.wy-code code[class*=language-],.wy-code pre[class*=language-],.wy-editor .cm-content code[class*=language-],.wy-content code[class*=language-],.wy-editor .cm-content pre[class*=language-],.wy-content pre[class*=language-]{text-shadow:none}}.wy-code pre[class*=language-],.wy-editor .cm-content pre[class*=language-],.wy-content pre[class*=language-]{padding:1em;margin:.5em 0;overflow:auto}.wy-code :not(pre)>code[class*=language-],.wy-code pre[class*=language-],.wy-editor .cm-content :not(pre)>code[class*=language-],.wy-content :not(pre)>code[class*=language-],.wy-editor .cm-content pre[class*=language-],.wy-content pre[class*=language-]{color:var(--wy-code-text, var(--wy-code-text-light, #3b3b3b));background:var(--wy-background, var(--wy-neutral-99, #fcfcff))}.wy-code :not(pre)>code[class*=language-],.wy-editor .cm-content :not(pre)>code[class*=language-],.wy-content :not(pre)>code[class*=language-]{padding:.1em;border-radius:.3em;white-space:normal}.wy-code .token.variable,.wy-editor .cm-content .token.variable,.wy-content .token.variable{color:var(--wy-code-variable, var(--wy-code-variable-light, #001080))}.wy-code .token.operator,.wy-editor .cm-content .token.operator,.wy-content .token.operator{color:var(--wy-code-operator, var(--wy-code-operator-light, #000000))}.wy-code .token.prolog,.wy-editor .cm-content .token.prolog,.wy-content .token.prolog{color:var(--wy-code-prolog, var(--wy-code-prolog-light, #000080))}.wy-code .token.comment,.wy-editor .cm-content .token.comment,.wy-content .token.comment{color:var(--wy-code-comment, var(--wy-code-comment-light, #008000))}.wy-code .token.builtin,.wy-editor .cm-content .token.builtin,.wy-content .token.builtin{color:var(--wy-code-builtin, var(--wy-code-builtin-light, #0070C1))}.wy-code .token.number,.wy-editor .cm-content .token.number,.wy-content .token.number{color:var(--wy-code-number, var(--wy-code-number-light, #098658))}.wy-code .token.inserted,.wy-editor .cm-content .token.inserted,.wy-content .token.inserted{color:var(--wy-code-inserted, var(--wy-code-inserted-light, #098658))}.wy-code .token.constant,.wy-editor .cm-content .token.constant,.wy-content .token.constant{color:var(--wy-code-constant, var(--wy-code-constant-light, #811F3F))}.wy-code .token.hexcode,.wy-editor .cm-content .token.hexcode,.wy-content .token.hexcode{color:var(--wy-code-hexcode, var(--wy-code-hexcode-light, #811F3F))}.wy-code .token.regex,.wy-editor .cm-content .token.regex,.wy-content .token.regex{color:var(--wy-code-regex, var(--wy-code-regex-light, #811F3F))}.wy-code .token.char,.wy-editor .cm-content .token.char,.wy-content .token.char{color:var(--wy-code-char, var(--wy-code-char-light, #811F3F))}.wy-code .token.tag,.wy-editor .cm-content .token.tag,.wy-content .token.tag{color:var(--wy-code-tag, var(--wy-code-tag-light, #800000))}.wy-code .token.attr-name,.wy-editor .cm-content .token.attr-name,.wy-content .token.attr-name{color:var(--wy-code-attr-name, var(--wy-code-attr-name-light, #E50000))}.wy-code .token.selector,.wy-editor .cm-content .token.selector,.wy-content .token.selector{color:var(--wy-code-selector, var(--wy-code-selector-light, #E50000))}.wy-code .token.property,.wy-editor .cm-content .token.property,.wy-content .token.property{color:var(--wy-code-property, var(--wy-code-property-light, #E50000))}.wy-code .token.deleted,.wy-editor .cm-content .token.deleted,.wy-content .token.deleted{color:var(--wy-code-deleted, var(--wy-code-deleted-light, #A31515))}.wy-code .token.string,.wy-editor .cm-content .token.string,.wy-content .token.string{color:var(--wy-code-string, var(--wy-code-string-light, #A31515))}.wy-code .token.changed,.wy-editor .cm-content .token.changed,.wy-content .token.changed{color:var(--wy-code-changed, var(--wy-code-changed-light, #0451A5))}.wy-code .token.punctuation,.wy-editor .cm-content .token.punctuation,.wy-content .token.punctuation{color:var(--wy-code-punctuation, var(--wy-code-punctuation-light, #000000))}.wy-code .token.function,.wy-editor .cm-content .token.function,.wy-content .token.function{color:var(--wy-code-function, var(--wy-code-function-light, #0000FF))}.wy-code .token.keyword,.wy-editor .cm-content .token.keyword,.wy-content .token.keyword{color:var(--wy-code-keyword, var(--wy-code-keyword-light, #AF00DB))}.wy-code .token.class-name,.wy-editor .cm-content .token.class-name,.wy-content .token.class-name{color:var(--wy-code-class-name, var(--wy-code-class-name-light, #267F99))}.wy-code .token.important,.wy-code .token.bold,.wy-editor .cm-content .token.important,.wy-content .token.important,.wy-editor .cm-content .token.bold,.wy-content .token.bold{font-weight:700}.wy-code .token.italic,.wy-editor .cm-content .token.italic,.wy-content .token.italic{font-style:italic}.wy-content{overflow-wrap:break-word;min-width:0}.wy-content :not(pre)>code{font-family:var(--wy-font-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace);overflow-wrap:inherit}.wy-content pre,.wy-content pre>code[class*=language-]{white-space:pre-wrap}.wy-content :first-child{margin-top:0}.wy-content :last-child{margin-bottom:0}.wy-content:empty{display:none}.wy-hashtag{color:var(--wy-primary, var(--wy-primary-40, #006399))}.wy-mention{font-weight:700}.wy-emoji-icon{display:inline-flex;justify-content:center;align-items:center;line-height:1;width:1em;height:1em;font-size:calc(1.25 * var(--wy-size, 1rem))}.wy-emoji-icon-sm{width:calc(1.125 * var(--wy-size, 1rem));height:calc(1.125 * var(--wy-size, 1rem));font-size:calc(1.125 * var(--wy-size, 1rem))}.wy-empty{display:flex;align-items:center;justify-content:center;flex:1;min-width:0;position:relative;flex-direction:column;gap:var(--wy-gap-lg, calc(1.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}[part~=wy-icon]{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;position:relative;width:var(--wy-component-icon-width);height:var(--wy-component-icon-height)}[part~=wy-icon][width=\"24\"]{width:var(--wy-component-icon-width, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-icon][height=\"24\"]{height:var(--wy-component-icon-height, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-icon-first]{margin-left:calc(-.5 * var(--wy-size, 1rem))}[part~=wy-icon-last]{margin-right:calc(-.5 * var(--wy-size, 1rem))}[part~=wy-icon-padded]{margin:16.66666667%}[part~=wy-icon-inline]{vertical-align:-.25em}[part~=wy-icon-overlay]{position:absolute;bottom:0;right:0;border-radius:50%}:host(wy-icon-stack),[part~=wy-icon-stack]{display:inline-flex;position:relative;line-height:1}[part~=wy-icon-stack-layer]{position:absolute}[part~=wy-icon-stack-overlay]{position:absolute;bottom:0;right:0;border-radius:50%;width:calc(var(--wy-component-icon-width) / 2);height:calc(var(--wy-component-icon-height) / 2)}[part~=wy-icon-current-color]{fill:currentColor}[part~=wy-icon-state]{transition:opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));align-self:center;justify-self:center;margin:auto;opacity:0}[part~=wy-icon-state][part~=wy-active]{opacity:1}[part~=wy-icon-display]{color:var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));border-radius:var(--wy-component-border-radius, var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))));display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem));margin:auto}[part~=wy-icon-display-icon]{color:var(--wy-component-color);--wy-component-icon-width: calc(4 * var(--wy-size, 1rem));--wy-component-icon-height: calc(4 * var(--wy-size, 1rem));padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem))}[part~=wy-icon-display-text],[part~=wy-icon-display-meta]{color:var(--wy-component-color);padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem));text-align:center}[part~=wy-icon-color-primary]{fill:var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-icon-color-secondary]{fill:var(--wy-secondary, var(--wy-secondary-40, #3b6a1c))}[part~=wy-icon-color-tertiary]{fill:var(--wy-tertiary, var(--wy-tertiary-40, #3b6a1c))}[part~=wy-icon-color-surface]{fill:var(--wy-surface, var(--wy-neutral-99, #fcfcff))}[part~=wy-icon-color-surface-variant]{fill:var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb))}[part~=wy-icon-color-error]{fill:var(--wy-error, var(--wy-error-40, #ba1824))}[part~=wy-icon-color-warning]{fill:var(--wy-warning, var(--wy-warning-70, #afb140))}[part~=wy-icon-color-blue]{fill:var(--wy-blue, var(--wy-blue-light, #89a9fc))}[part~=wy-icon-color-indigo]{fill:var(--wy-indigo, var(--wy-indigo-light, #9185de))}[part~=wy-icon-color-purple]{fill:var(--wy-purple, var(--wy-purple-light, #c675b7))}[part~=wy-icon-color-pink]{fill:var(--wy-pink, var(--wy-pink-light, #d57194))}[part~=wy-icon-color-red]{fill:var(--wy-red, var(--wy-red-light, #db726c))}[part~=wy-icon-color-orange]{fill:var(--wy-orange, var(--wy-orange-light, #e89a3a))}[part~=wy-icon-color-yellow]{fill:var(--wy-yellow, var(--wy-yellow-light, #afb140))}[part~=wy-icon-color-green]{fill:var(--wy-green, var(--wy-green-light, #00a38b))}[part~=wy-icon-color-teal]{fill:var(--wy-teal, var(--wy-teal-light, #00a0a8))}[part~=wy-icon-color-cyan]{fill:var(--wy-cyan, var(--wy-cyan-light, #0082a1))}[part~=wy-icon-color-gray]{fill:var(--wy-gray, var(--wy-gray-light, #76777a))}[part~=wy-icon-color-black]{fill:var(--wy-black, var(--wy-black, #000000))}[part~=wy-icon-color-white]{fill:var(--wy-white, var(--wy-white, #ffffff))}[part*=wy-kind-]{fill:var(--wy-gray, var(--wy-gray-light, #76777a))}[part~=wy-kind-archive]{fill:var(--wy-orange, var(--wy-orange-light, #e89a3a))}[part~=wy-kind-audio]{fill:var(--wy-teal, var(--wy-teal-light, #00a0a8))}[part~=wy-kind-code]{fill:var(--wy-green, var(--wy-green-light, #00a38b))}[part~=wy-kind-document]{fill:var(--wy-blue, var(--wy-blue-light, #89a9fc))}[part~=wy-kind-email]{fill:var(--wy-red, var(--wy-red-light, #db726c))}[part~=wy-kind-presentation]{fill:var(--wy-orange, var(--wy-orange-light, #e89a3a))}[part~=wy-kind-spreadsheet]{fill:var(--wy-green, var(--wy-green-light, #00a38b))}[part~=wy-kind-image]{fill:var(--wy-pink, var(--wy-pink-light, #d57194))}[part~=wy-kind-text]{fill:var(--wy-cyan, var(--wy-cyan-light, #0082a1))}[part~=wy-kind-video]{fill:var(--wy-purple, var(--wy-purple-light, #c675b7))}[part~=wy-ext-pdf]{fill:var(--wy-red, var(--wy-red-light, #db726c))}[part~=wy-kind-text-icon]{width:calc(1.25 * var(--wy-size, 1rem));height:calc(1.25 * var(--wy-size, 1rem));vertical-align:calc(-.3125 * var(--wy-size, 1rem))}.wy-image-grid{display:flex;flex-wrap:wrap;justify-content:space-evenly;position:relative;border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));overflow:hidden;column-gap:1px;row-gap:1px}.wy-image-grid .wy-image{padding:0;width:50%;position:relative;flex:auto;background-color:inherit;background-clip:content-box}.wy-image-grid .wy-image:first-of-type:not(:nth-last-of-type(2)){flex-basis:100%!important}.wy-image-grid .wy-image-area{display:block;height:100%;cursor:pointer}.wy-image-grid .wy-image-area img{position:absolute;height:100%;width:100%;object-fit:contain}.wy-image-grid .wy-image-area img.wy-loading{transition:opacity .15s ease-out;opacity:0}.wy-image-grid .wy-image-area img.wy-loading.wy-loaded{opacity:1;transition:opacity .15s ease-out}.wy-image-grid .wy-image-area img.wy-loading.wy-loaded~img{transition-delay:.15s;opacity:0}.wy-image-grid .wy-more{position:absolute;line-height:100%;color:var(--wy-white, #ffffff);top:0;left:0;bottom:0;right:0;display:flex;align-items:center;justify-content:center;font-size:calc(1.5 * var(--wy-size, 1rem));background:rgba(0,0,0,var(--wy-opacity-disabled, 38%))}.wy-title{font-family:var(--wy-headings-font-family, var(--wy-font-family, unset));font-size:var(--wy-headings-font-size, 1.25em);font-style:var(--wy-headings-font-style, unset);font-weight:var(--wy-headings-font-weight, var(--wy-font-weight-bold, bolder));line-height:var(--wy-headings-line-height, var(--wy-line-height, 1.5));margin-block:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}.wy-input{--wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);border:var(--wy-input-border-width, var(--wy-border, 1px)) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));display:block;width:100%;min-height:calc(var(--wy-input-font-size, var(--wy-font-size, 1em)) * 1.5 * var(--wy-size, 1rem) + var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * 2 + var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) * 2);padding:var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));font-family:var(--wy-input-font-family, var(--wy-font-family, inherit)),inherit;font-size:var(--wy-input-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-input-font-weight, var(--wy-font-weight, unset));line-height:var(--wy-input-line-height, var(--wy-line-height, calc(1.5 * var(--wy-size, 1rem))));background-clip:padding-box;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:var(--wy-input-border-radius, var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))))}.wy-input:focus{--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));color:var(--wy-component-color);border-color:var(--wy-primary, var(--wy-primary-40, #006399));outline:0}.wy-input::placeholder{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));opacity:1}.wy-input:disabled{opacity:38%}.wy-input::file-selector-button,.wy-input::-webkit-file-upload-button{color:var(--wy-component-color);background-color:var(--wy-component-background-color);padding:var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));margin:calc(-1 * var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) calc(-1 * var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))));margin-inline-end:var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--wy-input-border-width, var(--wy-border, 1px));border-radius:0}.wy-input:hover:not(:disabled):not([readonly])::file-selector-button,.wy-input:hover:not(:disabled):not([readonly]) ::-webkit-file-upload-button{background-color:var(--wy-component-background-color)}.wy-input[type=file]{overflow:hidden}.wy-input[type=file]:not(:disabled):not([readonly]){cursor:pointer}.wy-input::-webkit-date-and-time-value{height:calc(var(--wy-input-line-height, var(--wy-line-height, calc(1.5 * var(--wy-size, 1rem)))) * 1em)}.wy-input[type=search]::-webkit-search-cancel-button{-webkit-appearance:none}.wy-input-filled{--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);border-radius:var(--wy-input-filled-border-radius, var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem)))));border-color:var(--wy-component-background-color)}.wy-input-filled:focus{border-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-label{display:inline-block;margin-bottom:calc(.5 * var(--wy-size, 1rem))}.wy-description{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)));margin-top:calc(.25 * var(--wy-size, 1rem))}.wy-is-invalid,.wy-is-invalid:focus{border-color:var(--wy-error, var(--wy-error-40, #ba1824))}.wy-invalid-feedback{margin-top:calc(.25 * var(--wy-size, 1rem));font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)));color:var(--wy-error, var(--wy-error-40, #ba1824))}.wy-input-group{position:relative;display:flex;gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));align-items:center}.wy-input-group-button-icon{position:absolute;top:0;right:0;z-index:4;border-radius:var(--wy-input-border-radius, var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))));--wy-component-background-color: transparent}.wy-input-group-input:placeholder-shown~.wy-input-group-button-icon[type=reset]{display:none}.wy-input-group-input:not(:placeholder-shown)~.wy-input-group-button-icon[type=reset]+.wy-input-group-button-icon{display:none}.wy-item{--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));position:relative;display:flex;align-items:center;gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));text-decoration:none}.wy-list-item{min-height:calc(3 * var(--wy-size, 1rem))}.wy-list-item-lg{min-height:calc(4.5 * var(--wy-size, 1rem))}.wy-item-inner{display:flex;align-items:center;gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));flex:1 1 100%}.wy-item-body{width:100%;min-width:0}.wy-item-rows{display:flex;flex-direction:column;width:100%;row-gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));min-width:0}.wy-item-rows:only-child{margin-inline-start:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-item-rows-compact{row-gap:0}.wy-item-rows-single{margin-inline-start:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-item-title{color:var(--wy-component-color);font-size:var(--wy-item-title-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-item-title-font-weight, var(--wy-font-weight, unset))}.wy-item-title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-item-title-lg{color:var(--wy-component-color);font-size:var(--wy-item-title-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-item-title-font-weight, var(--wy-font-weight, unset))}.wy-item-title-lg{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.wy-item-text{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}.wy-item-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-item-text .wy-icon{width:calc(1.25 * var(--wy-size, 1rem));height:calc(1.25 * var(--wy-size, 1rem));vertical-align:calc(-.3125 * var(--wy-size, 1rem))}.wy-item-quote{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e))}.wy-item-quote:before,.wy-item-quote:after{content:'\"'}.wy-item-actions{--wy-component-background-color: transparent;display:flex;align-items:center;justify-items:flex-end;flex:0 0 auto;margin:calc(-.25 * var(--wy-size, 1rem))}.wy-item-top{align-self:flex-start}.wy-item-actions-bottom{align-self:flex-start;margin-block:calc(-.5 * var(--wy-size, 1rem))}.wy-item-row{display:flex;align-items:center;column-gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))}.wy-item-row .wy-item-title,.wy-item-row .wy-item-text{margin-right:auto}.wy-item-row .wy-meta{white-space:nowrap}.wy-item-right{margin-left:auto}.wy-item-hover{-webkit-user-select:none;user-select:none;cursor:pointer}.wy-item-hover:hover,.wy-item-hover:focus{--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);text-decoration:none}.wy-item-hover:active{--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));background-color:var(--wy-component-background-color);color:var(--wy-component-color)}.wy-item-hover.wy-disabled,.wy-item-hover:disabled{opacity:var(--wy-opacity-disabled, 38%);pointer-events:none}.wy-item-hover.wy-active{--wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));--wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));background-color:var(--wy-component-background-color);color:var(--wy-component-color);border-color:var(--wy-component-background-color)}.wy-item-trashed{text-decoration:line-through;opacity:var(--wy-opacity-disabled, 38%)}.wy-item-trashed.wy-item-hover:hover{opacity:1}.wy-list{border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));display:flex;flex-direction:column;gap:var(--wy-border);min-width:0}.wy-list .wy-item:not(.wy-item-hover){--wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color)}.wy-list .wy-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.wy-list .wy-item:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.wy-list-bordered{border:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));gap:0}.wy-list-bordered .wy-item{border-top:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));border-left:none;border-right:none}.wy-list-bordered .wy-item:first-child{border-top:none}.wy-list-bordered .wy-item:last-child{border-bottom:none}.wy-list-bordered .wy-item+.wy-list-bordered .wy-item{border-top-width:0}@keyframes wy-highlight{0%{--wy-component-background-color: var(--wy-highlight, var(--wy-primary-95, #e8f2ff));--wy-component-color: var(--wy-on-highlight, var(--wy-primary-10, #001d32))}}.wy-messages{padding:var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));flex:1 1 100%}.wy-message-placeholder{opacity:.5}.wy-date-separator{font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));pointer-events:none;margin:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));text-align:center;position:sticky;top:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));z-index:10}.wy-date-separator time{background:var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));color:var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));display:inline-block}.wy-message{display:flex;flex-direction:row;align-items:flex-start;margin-bottom:calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + .5 * var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))));scroll-margin-block:6rem;--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}.wy-message[part~=wy-highlight]{animation:wy-highlight 3s 1.5s ease-in-out both}.wy-message .wy-image-grid,.wy-message .wy-attachments{border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))}.wy-message-meta{font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));margin:0 0 calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))));color:var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}.wy-message-bubble{background-color:var(--wy-component-background-color);color:var(--wy-component-color);border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));display:flex;flex-direction:column;padding:var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));max-width:min(32 * var(--wy-size, 1rem),100% - 2 * var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))))}.wy-message-bubble>div{flex:1 1 100%}.wy-message-author{margin:calc(1.375 * var(--wy-size, 1rem)) calc(.5 * var(--wy-size, 1rem)) 0 0}.wy-message-content{display:flex;flex-direction:column;width:100%;align-items:flex-start;flex-wrap:wrap;min-width:0;position:relative}.wy-message-content-row{display:flex;flex-direction:row;align-items:center;max-width:100%}.wy-message-bot{--wy-component-background-color: var(--wy-tertiary-container, var(--wy-tertiary-90, #bbf294));--wy-component-color: var(--wy-on-tertiary-container, var(--wy-tertiary-10, #0a2100))}.wy-message-me{margin-right:0;margin-left:calc(2.5 * var(--wy-size, 1rem));align-items:flex-end;--wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));--wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32))}.wy-message-me .wy-message-meta{margin:0 calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) 0}.wy-message-me .wy-message-content{align-items:flex-end}.wy-message-me .wy-message-content-row{flex-direction:row-reverse}.wy-message-emoji .wy-message-bubble{background:none;padding:0 0 var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))}.wy-message-emoji .wy-content .wy-emoji{width:calc(3 * var(--wy-size, 1rem));height:calc(3 * var(--wy-size, 1rem));margin:0}.wy-message-emoji.wy-message-me .wy-content{text-align:end}.wy-readby-status{display:flex;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));height:calc(1.125 * var(--wy-size, 1rem));justify-content:flex-end;margin-top:calc(-.125 * var(--wy-size, 1rem))}.wy-message-readmore{justify-self:center;text-align:center}.wy-meta{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}.wy-meta-sm{font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)))}.wy-dialog{background:none;border:none;padding:0;margin:0}.wy-dialog[popover]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1055}.wy-overlay-dialog{width:100%;height:100%;align-items:center;justify-content:center;overflow:visible;max-width:100%;max-height:100%}.wy-overlay-dialog[open]{display:flex}.wy-overlay-dialog:popover-open{display:flex}.wy-overlay-dialog:focus-visible{outline:none}.wy-overlay{--wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;flex-direction:column}.wy-overlay.wy-modal{width:100%;height:100%;overflow:hidden;border-radius:0}@media (min-width: 768px){.wy-overlay.wy-modal-padded{border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));box-shadow:var(--wy-shadow-level4, 0 calc(1 * var(--wy-size, 1rem)) calc(2.25 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .14), 0 calc(.375 * var(--wy-size, 1rem)) calc(1.875 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .12), 0 calc(.5 * var(--wy-size, 1rem)) calc(.625 * var(--wy-size, 1rem)) calc(-.3125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2));margin-left:calc(4 * var(--wy-size, 1rem));margin-top:auto;margin-right:calc(4 * var(--wy-size, 1rem));margin-bottom:auto;width:calc(32 * var(--wy-size, 1rem));max-height:calc(32 * var(--wy-size, 1rem))}}@media (min-width: 768px){.wy-overlay.wy-modal-full{margin:0;border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));box-shadow:var(--wy-shadow-level4, 0 calc(1 * var(--wy-size, 1rem)) calc(2.25 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .14), 0 calc(.375 * var(--wy-size, 1rem)) calc(1.875 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .12), 0 calc(.5 * var(--wy-size, 1rem)) calc(.625 * var(--wy-size, 1rem)) calc(-.3125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2));max-width:calc(100% - 2 * var(--wy-size, 1rem));max-height:calc(100% - 2 * var(--wy-size, 1rem))}}.wy-overlay{opacity:0;visibility:hidden;transition:opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, .1s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) .01s,transform var(--wy-transition-fast, var(--wy-transition-duration-fast, .1s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) .01s,visibility .01s step-end var(--wy-transition-duration-fast, .1s)}.wy-overlay.wy-open{transition:opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))),transform var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))),visibility var(--wy-transition-duration, .2s) step-start;visibility:visible}.wy-overlay.wy-open.wy-transition{opacity:1;transform:none}.wy-pane{display:flex;flex-direction:column;position:relative;min-height:0;height:100%;flex:1 1 auto}.wy-pane-body{display:flex;flex-direction:column;flex:1}.wy-pane-group{padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}.wy-pane-background{--wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color)}.wy-pane-toolbar{display:flex;flex:1;justify-content:space-evenly;align-items:center;padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))}.wy-picker-list{background:var(--wy-component-background-color);color:var(--wy-component-color);border:none}.wy-picker-list>.wy-picker-list-item:first-child,.wy-picker-list>:first-child .wy-picker-list-item{border-top:none}.wy-picker-list>.wy-picker-list-item:last-child,.wy-picker-list>:last-child .wy-picker-list-item{border-bottom:none}.wy-picker-list-item{display:flex;align-items:center;padding:calc(.25 * var(--wy-size, 1rem)) calc(.5 * var(--wy-size, 1rem))}.wy-picker-list-item>wy-icon{margin-left:calc(.25 * var(--wy-size, 1rem));margin-right:calc(.25 * var(--wy-size, 1rem));flex:0 0 auto}.wy-picker-list-item>button{margin-block-start:auto;flex:0 0 auto}.wy-picker-list-item-title{flex-grow:1}.wy-picker-list-item-title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-main{display:flex;height:calc(100% - var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem))))));min-height:0}@media (max-width: 767.98px){.wy-main{flex-direction:column}}.wy-preview{--wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;flex-direction:column;align-items:stretch;justify-content:stretch;position:relative;flex:1 1 100%;min-width:calc(16 * var(--wy-size, 1rem));min-height:calc(16 * var(--wy-size, 1rem));max-height:100%;max-width:100%}.wy-preview-layout{width:100%;height:100%}.wy-preview-swiper{display:flex;flex-direction:row;flex:1 1 100%;align-items:center;justify-content:start;min-width:calc(16 * var(--wy-size, 1rem));min-height:calc(16 * var(--wy-size, 1rem));max-height:100%;max-width:100%;overflow-x:scroll;scroll-snap-type:x mandatory;scroll-behavior:auto;overscroll-behavior-x:none;scrollbar-width:none}.wy-preview-swiper::-webkit-scrollbar{display:none}.wy-preview-swiper-disabled{overflow-x:hidden}.wy-preview-area{position:relative;min-width:100%;min-height:100%;width:100%;height:100%;flex:1 1 auto;display:flex;flex-direction:column;scroll-snap-stop:always;scroll-snap-align:center}.wy-nav-prev,.wy-nav-next{--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));background-color:var(--wy-component-background-color);position:absolute;top:50%;z-index:1000;border-radius:50%}.wy-nav-prev{left:calc(.5 * var(--wy-size, 1rem))}.wy-nav-next{right:calc(.5 * var(--wy-size, 1rem))}.wy-document{--wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);align-self:flex-start;padding:calc(2 * var(--wy-size, 1rem)) calc(3.5 * var(--wy-size, 1rem));width:100%;min-height:100%;flex:1 0 auto}@media (min-width: 768px){.wy-document{padding:calc(3 * var(--wy-size, 1rem)) calc(4 * var(--wy-size, 1rem));margin:calc(2 * var(--wy-size, 1rem)) auto;border-radius:calc(.125 * var(--wy-size, 1rem));box-shadow:var(--wy-shadow-level2, 0 calc(.25 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.625 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12), 0 calc(.125 * var(--wy-size, 1rem)) calc(.25 * var(--wy-size, 1rem)) calc(-.0625 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2));width:120ch;min-height:170ch;max-width:calc(100% - 3.5 * var(--wy-size, 1rem))}}.wy-content-code{align-self:flex-start;width:100%;padding:calc(2 * var(--wy-size, 1rem)) calc(3.5 * var(--wy-size, 1rem))}.wy-content-iframe{border:0;display:block;width:100%;height:100%;top:0;left:0;flex:1 1 100%}.wy-content-iframe.wy-loaded{--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color)}.wy-content-iframe.wy-loaded~.wy-content-iframe-fallback,.wy-content-iframe.wy-loaded~.wy-spinner,.wy-content-iframe.wy-loaded~wy-spinner{display:none}.wy-content-iframe.wy-loading:not(.wy-loaded){position:absolute;visibility:hidden;z-index:-1;pointer-events:none}.wy-content-iframe.wy-loading:not(.wy-loaded):not(.wy-fallback)~.wy-content-iframe-fallback{display:none}.wy-content-iframe.wy-loading:not(.wy-loaded).wy-fallback~.wy-spinner,.wy-content-iframe.wy-loading:not(.wy-loaded).wy-fallback~wy-spinner{display:none}.wy-content-iframe~.wy-spinner,.wy-content-iframe~wy-spinner{margin:auto}.wy-content-html pre,.wy-content-html code{word-break:break-word;white-space:pre-wrap}.wy-content-image{min-width:0;display:flex;align-items:center;justify-content:center;position:relative;margin:auto;max-height:100%;max-width:100%;transition:transform var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))),transform-origin var(--wy-transition-duration, .2s) step-end}.wy-content-image.wy-zoom{cursor:zoom-out;transition:transform var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))),transform-origin var(--wy-transition-duration, .2s) step-start}.wy-content-image img{min-width:0;min-height:0;width:100%;height:100%}.wy-content-image img:not(.wy-loading-transition):not([data-controller~=image])~.wy-spinner,.wy-content-image img:not(.wy-loading-transition):not([data-controller~=image])~wy-spinner{display:none}.wy-content-image img.wy-loading,.wy-content-image img[data-controller~=image]{transition:opacity .15s ease-out;opacity:0}.wy-content-image img.wy-loading.wy-loaded,.wy-content-image img[data-controller~=image].wy-loaded{opacity:1;transition:opacity .15s ease-out}.wy-content-image img.wy-loading.wy-loaded~img,.wy-content-image img[data-controller~=image].wy-loaded~img{transition-delay:.15s;opacity:0}.wy-content-image img.wy-loading.wy-loaded~.wy-spinner,.wy-content-image img.wy-loading.wy-loaded~wy-spinner,.wy-content-image img[data-controller~=image].wy-loaded~.wy-spinner,.wy-content-image img[data-controller~=image].wy-loaded~wy-spinner{display:none}.wy-content-image img.wy-responsive-image-thumb{position:absolute;z-index:-1}.wy-content-image img~.wy-spinner,.wy-content-image img~wy-spinner{position:absolute}.wy-content-video:not(.wy-error){min-height:0;max-width:100%;max-height:100%;flex:1 1 auto}.wy-content-video,.wy-content-audio{margin:auto}.wy-content-video.wy-loading:not(.wy-loaded),.wy-content-video[data-controller~=media]:not(.wy-loaded),.wy-content-audio.wy-loading:not(.wy-loaded),.wy-content-audio[data-controller~=media]:not(.wy-loaded){visibility:hidden}.wy-content-video.wy-loading.wy-loaded~.wy-spinner,.wy-content-video.wy-loading.wy-loaded~wy-spinner,.wy-content-video[data-controller~=media].wy-loaded~.wy-spinner,.wy-content-video[data-controller~=media].wy-loaded~wy-spinner,.wy-content-audio.wy-loading.wy-loaded~.wy-spinner,.wy-content-audio.wy-loading.wy-loaded~wy-spinner,.wy-content-audio[data-controller~=media].wy-loaded~.wy-spinner,.wy-content-audio[data-controller~=media].wy-loaded~wy-spinner{display:none}.wy-content-video:focus,.wy-content-audio:focus{outline:none}.wy-pdf-container{position:absolute;width:100%;height:100%;bottom:0;left:0}.wy-pdf-container{overflow-y:auto;max-height:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-pdf-container:not(body){-webkit-overflow-scrolling:touch}.wy-pdf-container{overflow-x:auto;max-width:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-content-pdf .textLayer{position:absolute;text-align:initial;top:0;right:0;bottom:0;left:0;overflow:clip;opacity:1;line-height:1;text-size-adjust:none;forced-color-adjust:none;transform-origin:0 0;caret-color:CanvasText;z-index:0}.wy-content-pdf .textLayer.highlighting{touch-action:none}.wy-content-pdf .textLayer :is(span,br){color:transparent;position:absolute;white-space:pre;cursor:text;transform-origin:0% 0%}.wy-content-pdf .textLayer>:not(.markedContent),.wy-content-pdf .textLayer .markedContent span:not(.markedContent){z-index:1}.wy-content-pdf .textLayer span.markedContent{top:0;height:0}.wy-content-pdf .textLayer span[role=img]{-webkit-user-select:none;user-select:none;cursor:default}.wy-content-pdf .textLayer .highlight{--highlight-bg-color: rgb(180 0 170 / .25);--highlight-selected-bg-color: rgb(0 100 0 / .25);--highlight-backdrop-filter: none;--highlight-selected-backdrop-filter: none}@media screen and (forced-colors: active){.wy-content-pdf .textLayer .highlight{--highlight-bg-color: transparent;--highlight-selected-bg-color: transparent;--highlight-backdrop-filter: var(--hcm-highlight-filter);--highlight-selected-backdrop-filter: var(--hcm-highlight-selected-filter)}}.wy-content-pdf .textLayer .highlight{margin:-1px;padding:1px;background-color:var(--highlight-bg-color);-webkit-backdrop-filter:var(--highlight-backdrop-filter);backdrop-filter:var(--highlight-backdrop-filter);border-radius:4px}.wy-content-pdf .textLayer .highlight.appended{position:initial}.wy-content-pdf .textLayer .highlight.begin{border-radius:4px 0 0 4px}.wy-content-pdf .textLayer .highlight.end{border-radius:0 4px 4px 0}.wy-content-pdf .textLayer .highlight.middle{border-radius:0}.wy-content-pdf .textLayer .highlight.selected{background-color:var(--highlight-selected-bg-color);-webkit-backdrop-filter:var(--highlight-selected-backdrop-filter);backdrop-filter:var(--highlight-selected-backdrop-filter)}.wy-content-pdf .textLayer ::selection{background:#0000ff40;background:color-mix(in srgb,AccentColor,transparent 75%)}.wy-content-pdf .textLayer br::selection{background:transparent}.wy-content-pdf .textLayer .endOfContent{display:block;position:absolute;top:100%;right:0;bottom:0;left:0;z-index:0;cursor:default;-webkit-user-select:none;user-select:none}.wy-content-pdf .textLayer.selecting .endOfContent{top:0}.wy-content-pdf .annotationLayer{--annotation-unfocused-field-background: url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\");--input-focus-border-color: Highlight;--input-focus-outline: 1px solid Canvas;--input-unfocused-border-color: transparent;--input-disabled-border-color: transparent;--input-hover-border-color: black;--link-outline: none}@media screen and (forced-colors: active){.wy-content-pdf .annotationLayer{--input-focus-border-color: CanvasText;--input-unfocused-border-color: ActiveText;--input-disabled-border-color: GrayText;--input-hover-border-color: Highlight;--link-outline: 1.5px solid LinkText}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea):required,.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:required,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) input:required{outline:1.5px solid selectedItem}.wy-content-pdf .annotationLayer .linkAnnotation{outline:var(--link-outline)}.wy-content-pdf .annotationLayer .linkAnnotation:hover{-webkit-backdrop-filter:var(--hcm-highlight-filter);backdrop-filter:var(--hcm-highlight-filter)}.wy-content-pdf .annotationLayer .linkAnnotation>a:hover{opacity:0!important;background:none!important;box-shadow:none}.wy-content-pdf .annotationLayer .popupAnnotation .popup{outline:calc(1.5px * var(--scale-factor)) solid CanvasText!important;background-color:ButtonFace!important;color:ButtonText!important}.wy-content-pdf .annotationLayer .highlightArea:hover:after{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-backdrop-filter:var(--hcm-highlight-filter);backdrop-filter:var(--hcm-highlight-filter);content:\"\";pointer-events:none}.wy-content-pdf .annotationLayer .popupAnnotation.focused .popup{outline:calc(3px * var(--scale-factor)) solid Highlight!important}}.wy-content-pdf .annotationLayer{position:absolute;top:0;left:0;pointer-events:none;transform-origin:0 0}.wy-content-pdf .annotationLayer[data-main-rotation=\"90\"] .norotate{transform:rotate(270deg) translate(-100%)}.wy-content-pdf .annotationLayer[data-main-rotation=\"180\"] .norotate{transform:rotate(180deg) translate(-100%,-100%)}.wy-content-pdf .annotationLayer[data-main-rotation=\"270\"] .norotate{transform:rotate(90deg) translateY(-100%)}.wy-content-pdf .annotationLayer.disabled section,.wy-content-pdf .annotationLayer.disabled .popup{pointer-events:none}.wy-content-pdf .annotationLayer .annotationContent{position:absolute;width:100%;height:100%;pointer-events:none}.wy-content-pdf .annotationLayer .annotationContent.freetext{background:transparent;border:none;top:0;right:0;bottom:0;left:0;overflow:visible;white-space:nowrap;font:10px sans-serif;line-height:1.35;-webkit-user-select:none;user-select:none}.wy-content-pdf .annotationLayer section{position:absolute;text-align:initial;pointer-events:auto;box-sizing:border-box;transform-origin:0 0}.wy-content-pdf .annotationLayer section:has(div.annotationContent) canvas.annotationContent{display:none}.textLayer.selecting~.wy-content-pdf .annotationLayer section{pointer-events:none}.wy-content-pdf .annotationLayer :is(.linkAnnotation,.buttonWidgetAnnotation.pushButton)>a{position:absolute;font-size:1em;top:0;left:0;width:100%;height:100%}.wy-content-pdf .annotationLayer :is(.linkAnnotation,.buttonWidgetAnnotation.pushButton):not(.hasBorder)>a:hover{opacity:.2;background-color:#ff0;box-shadow:0 2px 10px #ff0}.wy-content-pdf .annotationLayer .linkAnnotation.hasBorder:hover{background-color:#ff03}.wy-content-pdf .annotationLayer .hasBorder{background-size:100% 100%}.wy-content-pdf .annotationLayer .textAnnotation img{position:absolute;cursor:pointer;width:100%;height:100%;top:0;left:0}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea),.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) input{background-image:var(--annotation-unfocused-field-background);border:2px solid var(--input-unfocused-border-color);box-sizing:border-box;font:calc(9px * var(--scale-factor)) sans-serif;height:100%;margin:0;vertical-align:top;width:100%}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea):required,.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:required,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) input:required{outline:1.5px solid red}.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select option{padding:0}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input{border-radius:50%}.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea{resize:none}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea)[disabled],.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select[disabled],.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) input[disabled]{background:none;border:2px solid var(--input-disabled-border-color);cursor:not-allowed}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea):hover,.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:hover,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) input:hover{border:2px solid var(--input-hover-border-color)}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea):hover,.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:hover,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:hover{border-radius:2px}.wy-content-pdf .annotationLayer .textWidgetAnnotation :is(input,textarea):focus,.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:focus{background:none;border:2px solid var(--input-focus-border-color);border-radius:2px;outline:var(--input-focus-outline)}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) :focus{background-image:none;background-color:transparent}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox :focus{border:2px solid var(--input-focus-border-color);border-radius:2px;outline:var(--input-focus-outline)}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton :focus{border:2px solid var(--input-focus-border-color);outline:var(--input-focus-outline)}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before{background-color:CanvasText;content:\"\";display:block;position:absolute}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after{height:80%;left:45%;width:1px}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before{transform:rotate(45deg)}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after{transform:rotate(-45deg)}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before{border-radius:50%;height:50%;left:25%;top:25%;width:50%}.wy-content-pdf .annotationLayer .textWidgetAnnotation input.comb{font-family:monospace;padding-left:2px;padding-right:0}.wy-content-pdf .annotationLayer .textWidgetAnnotation input.comb:focus{width:103%}.wy-content-pdf .annotationLayer .buttonWidgetAnnotation:is(.checkBox,.radioButton) input{-webkit-appearance:none;-moz-appearance:none;appearance:none}.wy-content-pdf .annotationLayer .fileAttachmentAnnotation .popupTriggerArea{height:100%;width:100%}.wy-content-pdf .annotationLayer .popupAnnotation{position:absolute;font-size:calc(9px * var(--scale-factor));pointer-events:none;width:max-content;max-width:45%;height:auto}.wy-content-pdf .annotationLayer .popup{background-color:#ff9;box-shadow:0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor)) #888;border-radius:calc(2px * var(--scale-factor));outline:1.5px solid rgb(255,255,74);padding:calc(6px * var(--scale-factor));cursor:pointer;font:message-box;white-space:normal;word-wrap:break-word;pointer-events:auto}.wy-content-pdf .annotationLayer .popupAnnotation.focused .popup{outline-width:3px}.wy-content-pdf .annotationLayer .popup *{font-size:calc(9px * var(--scale-factor))}.wy-content-pdf .annotationLayer .popup>.header{display:inline-block}.wy-content-pdf .annotationLayer .popup>.header h1{display:inline}.wy-content-pdf .annotationLayer .popup>.header .popupDate{display:inline-block;margin-left:calc(5px * var(--scale-factor));width:fit-content}.wy-content-pdf .annotationLayer .popupContent{border-top:1px solid rgb(51,51,51);margin-top:calc(2px * var(--scale-factor));padding-top:calc(2px * var(--scale-factor))}.wy-content-pdf .annotationLayer .richText>*{white-space:pre-wrap;font-size:calc(9px * var(--scale-factor))}.wy-content-pdf .annotationLayer .popupTriggerArea{cursor:pointer}.wy-content-pdf .annotationLayer section svg{position:absolute;width:100%;height:100%;top:0;left:0}.wy-content-pdf .annotationLayer .annotationTextContent{position:absolute;width:100%;height:100%;opacity:0;color:transparent;-webkit-user-select:none;user-select:none;pointer-events:none}.wy-content-pdf .annotationLayer .annotationTextContent span{width:100%;display:inline-block}.wy-content-pdf .annotationLayer svg.quadrilateralsContainer{contain:strict;width:0;height:0;position:absolute;top:0;left:0;z-index:-1}:host{--xfa-unfocused-field-background: url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\");--xfa-focus-outline: auto}@media screen and (forced-colors: active){:host{--xfa-focus-outline: 2px solid CanvasText}.wy-content-pdf .xfaLayer *:required{outline:1.5px solid selectedItem}}.wy-content-pdf .xfaLayer{background-color:transparent}.wy-content-pdf .xfaLayer .highlight{margin:-1px;padding:1px;background-color:#efcbed;border-radius:4px}.wy-content-pdf .xfaLayer .highlight.appended{position:initial}.wy-content-pdf .xfaLayer .highlight.begin{border-radius:4px 0 0 4px}.wy-content-pdf .xfaLayer .highlight.end{border-radius:0 4px 4px 0}.wy-content-pdf .xfaLayer .highlight.middle{border-radius:0}.wy-content-pdf .xfaLayer .highlight.selected{background-color:#cbdfcb}.wy-content-pdf .xfaPage{overflow:hidden;position:relative}.wy-content-pdf .xfaContentarea{position:absolute}.wy-content-pdf .xfaPrintOnly{display:none}.wy-content-pdf .xfaLayer{position:absolute;text-align:initial;top:0;left:0;transform-origin:0 0;line-height:1.2}.wy-content-pdf .xfaLayer *{color:inherit;font:inherit;font-style:inherit;font-weight:inherit;font-kerning:inherit;letter-spacing:-.01px;text-align:inherit;text-decoration:inherit;box-sizing:border-box;background-color:transparent;padding:0;margin:0;pointer-events:auto;line-height:inherit}.wy-content-pdf .xfaLayer *:required{outline:1.5px solid red}.wy-content-pdf .xfaLayer div,.wy-content-pdf .xfaLayer svg,.wy-content-pdf .xfaLayer svg *{pointer-events:none}.wy-content-pdf .xfaLayer a{color:#00f}.wy-content-pdf .xfaRich li{margin-left:3em}.wy-content-pdf .xfaFont{color:#000;font-weight:400;font-kerning:none;font-size:10px;font-style:normal;letter-spacing:0;text-decoration:none;vertical-align:0}.wy-content-pdf .xfaCaption{overflow:hidden;flex:0 0 auto}.wy-content-pdf .xfaCaptionForCheckButton{overflow:hidden;flex:1 1 auto}.wy-content-pdf .xfaLabel{height:100%;width:100%}.wy-content-pdf .xfaLeft{display:flex;flex-direction:row;align-items:center}.wy-content-pdf .xfaRight{display:flex;flex-direction:row-reverse;align-items:center}.wy-content-pdf :is(.xfaLeft,.xfaRight)>:is(.xfaCaption,.xfaCaptionForCheckButton){max-height:100%}.wy-content-pdf .xfaTop{display:flex;flex-direction:column;align-items:flex-start}.wy-content-pdf .xfaBottom{display:flex;flex-direction:column-reverse;align-items:flex-start}.wy-content-pdf :is(.xfaTop,.xfaBottom)>:is(.xfaCaption,.xfaCaptionForCheckButton){width:100%}.wy-content-pdf .xfaBorder{background-color:transparent;position:absolute;pointer-events:none}.wy-content-pdf .xfaWrapped{width:100%;height:100%}.wy-content-pdf :is(.xfaTextfield,.xfaSelect):focus{background-image:none;background-color:transparent;outline:var(--xfa-focus-outline);outline-offset:-1px}.wy-content-pdf :is(.xfaCheckbox,.xfaRadio):focus{outline:var(--xfa-focus-outline)}.wy-content-pdf .xfaTextfield,.wy-content-pdf .xfaSelect{height:100%;width:100%;flex:1 1 auto;border:none;resize:none;background-image:var(--xfa-unfocused-field-background)}.wy-content-pdf .xfaSelect{padding-inline:2px}.wy-content-pdf :is(.xfaTop,.xfaBottom)>:is(.xfaTextfield,.xfaSelect){flex:0 1 auto}.wy-content-pdf .xfaButton{cursor:pointer;width:100%;height:100%;border:none;text-align:center}.wy-content-pdf .xfaLink{width:100%;height:100%;position:absolute;top:0;left:0}.wy-content-pdf .xfaCheckbox,.wy-content-pdf .xfaRadio{width:100%;height:100%;flex:0 0 auto;border:none}.wy-content-pdf .xfaRich{white-space:pre-wrap;width:100%;height:100%}.wy-content-pdf .xfaImage{object-position:left top;object-fit:contain;width:100%;height:100%}.wy-content-pdf .xfaLrTb,.wy-content-pdf .xfaRlTb,.wy-content-pdf .xfaTb{display:flex;flex-direction:column;align-items:stretch}.wy-content-pdf .xfaLr{display:flex;flex-direction:row;align-items:stretch}.wy-content-pdf .xfaRl{display:flex;flex-direction:row-reverse;align-items:stretch}.wy-content-pdf .xfaTb>div{justify-content:left}.wy-content-pdf .xfaPosition,.wy-content-pdf .xfaArea{position:relative}.wy-content-pdf .xfaValignMiddle{display:flex;align-items:center}.wy-content-pdf .xfaTable{display:flex;flex-direction:column;align-items:stretch}.wy-content-pdf .xfaTable .xfaRow{display:flex;flex-direction:row;align-items:stretch}.wy-content-pdf .xfaTable .xfaRlRow{display:flex;flex-direction:row-reverse;align-items:stretch;flex:1}.wy-content-pdf .xfaTable .xfaRlRow>div{flex:1}.wy-content-pdf :is(.xfaNonInteractive,.xfaDisabled,.xfaReadOnly) :is(input,textarea){background:initial}@media print{.wy-content-pdf .xfaTextfield,.wy-content-pdf .xfaSelect{background:transparent}.wy-content-pdf .xfaSelect{-webkit-appearance:none;-moz-appearance:none;appearance:none;text-indent:1px;text-overflow:\"\"}}:host{--viewer-container-height: 0;--pdfViewer-padding-bottom: 0;--page-margin: 1px auto -8px;--page-border: 9px solid transparent;--spreadHorizontalWrapped-margin-LR: -3.5px;--loading-icon-delay: .4s}@media screen and (forced-colors: active){:host{--pdfViewer-padding-bottom: 9px;--page-margin: 8px auto -1px;--page-border: 1px solid CanvasText;--spreadHorizontalWrapped-margin-LR: 3.5px}}.wy-content-pdf [data-main-rotation=\"90\"]{transform:rotate(90deg) translateY(-100%)}.wy-content-pdf [data-main-rotation=\"180\"]{transform:rotate(180deg) translate(-100%,-100%)}.wy-content-pdf [data-main-rotation=\"270\"]{transform:rotate(270deg) translate(-100%)}.wy-content-pdf #hiddenCopyElement,.wy-content-pdf .hiddenCanvasElement{position:absolute;top:0;left:0;width:0;height:0;display:none}.wy-content-pdf .pdfViewer{--scale-factor: 1;--page-bg-color: unset;padding-bottom:var(--pdfViewer-padding-bottom);--hcm-highlight-filter: none;--hcm-highlight-selected-filter: none}@media screen and (forced-colors: active){.wy-content-pdf .pdfViewer{--hcm-highlight-filter: invert(100%)}}.wy-content-pdf .pdfViewer.copyAll{cursor:wait}.wy-content-pdf .pdfViewer .canvasWrapper{overflow:hidden;width:100%;height:100%}.wy-content-pdf .pdfViewer .canvasWrapper canvas{position:absolute;top:0;left:0;margin:0;display:block;width:100%;height:100%;contain:content}.wy-content-pdf .pdfViewer .canvasWrapper canvas .structTree{contain:strict}.wy-content-pdf .pdfViewer .page{--scale-round-x: 1px;--scale-round-y: 1px;direction:ltr;width:816px;height:1056px;margin:var(--page-margin);position:relative;overflow:visible;border:var(--page-border);background-clip:content-box;background-color:var(--page-bg-color, rgb(255, 255, 255))}.wy-content-pdf .pdfViewer .dummyPage{position:relative;width:0;height:var(--viewer-container-height)}.wy-content-pdf .pdfViewer.noUserSelect{-webkit-user-select:none;user-select:none}.wy-content-pdf .pdfViewer.removePageBorders .page{margin:0 auto 10px;border:none}.wy-content-pdf .pdfViewer.singlePageView{display:inline-block}.wy-content-pdf .pdfViewer.singlePageView .page{margin:0;border:none}.wy-content-pdf .pdfViewer:is(.scrollHorizontal,.scrollWrapped),.wy-content-pdf .spread{margin-inline:3.5px;text-align:center}.wy-content-pdf .pdfViewer.scrollHorizontal,.wy-content-pdf .spread{white-space:nowrap}.wy-content-pdf .pdfViewer.removePageBorders,.wy-content-pdf .pdfViewer:is(.scrollHorizontal,.scrollWrapped) .spread{margin-inline:0}.wy-content-pdf .spread :is(.page,.dummyPage),.wy-content-pdf .pdfViewer:is(.scrollHorizontal,.scrollWrapped) :is(.page,.spread){display:inline-block;vertical-align:middle}.wy-content-pdf .spread .page,.wy-content-pdf .pdfViewer:is(.scrollHorizontal,.scrollWrapped) .page{margin-inline:var(--spreadHorizontalWrapped-margin-LR)}.wy-content-pdf .pdfViewer.removePageBorders .spread .page,.wy-content-pdf .pdfViewer.removePageBorders:is(.scrollHorizontal,.scrollWrapped) .page{margin-inline:5px}.wy-content-pdf .pdfViewer .page.loadingIcon:after{position:absolute;top:0;left:0;content:\"\";width:100%;height:100%;display:none;transition-property:display;transition-delay:var(--loading-icon-delay);z-index:5;contain:strict}.wy-content-pdf .pdfViewer .page.loading:after{display:block}.wy-content-pdf .pdfViewer .page:not(.loading):after{transition-property:none;display:none}.wy-content-pdf .pdfPresentationMode .pdfViewer{padding-bottom:0}.wy-content-pdf .pdfPresentationMode .spread{margin:0}.wy-content-pdf .pdfPresentationMode .pdfViewer .page{margin:0 auto;border:2px solid transparent}.wy-content-pdf .pdfViewer .page{box-shadow:var(--wy-shadow-level2, 0 calc(.25 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.625 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12), 0 calc(.125 * var(--wy-size, 1rem)) calc(.25 * var(--wy-size, 1rem)) calc(-.0625 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2));background-color:var(--wy-white, var(--wy-white, #ffffff))}.wy-content-pdf .pdfViewer .page.loadingIcon:after{background:url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' width='24' height='24' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cstyle type='text/css'%3Eg%7Banimation:rotate 2s linear infinite;transform-origin:center center%7Dcircle%7Bstroke-dasharray:1,100;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,color 6s ease-in-out infinite%7D@keyframes rotate%7B100%25%7Btransform:rotate(360deg)%7D%7D@keyframes dash%7B0%25%7Bstroke-dasharray:1,100;stroke-dashoffset:0%7D50%25%7Bstroke-dasharray:44.5,100;stroke-dashoffset:-17.5px%7D100%25%7Bstroke-dasharray:44.5,100;stroke-dashoffset:-62px%7D%7D@keyframes color%7B0%25,100%25%7Bstroke:%23216eb4%7D40%25%7Bstroke:%2328b7cf%7D66%25%7Bstroke:%23216eb4%7D80%25,90%25%7Bstroke:%2328b7cf%7D%7D%3C/style%3E%3Cg%3E%3Ccircle fill='none' cx='12' cy='12' r='11' stroke-linecap='butt' stroke-width='2' /%3E%3C/g%3E%3C/svg%3E\") center no-repeat}.wy-pdf-page-number{width:calc(3 * var(--wy-size, 1rem))}.wy-pdf-zoom-level{width:calc(5 * var(--wy-size, 1rem))}.wy-content-text{word-break:break-word;white-space:pre-wrap}[part~=wy-reaction]{font-size:calc(1.125 * var(--wy-size, 1rem))}[part~=wy-reactions]{display:inline-flex;align-items:center;column-gap:calc(.25 * var(--wy-size, 1rem))}[part~=wy-reactions] :first-child:not(:only-child){margin-left:calc(.25 * var(--wy-size, 1rem))}[part~=wy-reactions] :last-child:not(:only-child){margin-right:calc(.25 * var(--wy-size, 1rem))}[part~=wy-reaction-count]{margin:0 calc(.25 * var(--wy-size, 1rem)) 0;line-height:1;font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}[part~=wy-reaction-menu]{width:max-content;position:absolute;z-index:1000;border:none;--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;margin:0;text-align:left;background-clip:padding-box;box-shadow:var(--wy-shadow-level1, 0 calc(.125 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.1875 * var(--wy-size, 1rem)) calc(.0625 * var(--wy-size, 1rem)) calc(-.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12));overflow:hidden;padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));font-size:calc(1.25 * var(--wy-size, 1rem));border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))))}[part~=wy-reaction-picker]{display:flex;flex-direction:row;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}[part~=wy-reactions-line]{display:flex;align-items:center;padding-left:calc(.1875 * var(--wy-size, 1rem));padding-right:calc(.1875 * var(--wy-size, 1rem));gap:calc(.1875 * var(--wy-size, 1rem));justify-content:end}[part~=wy-reactions-line-reverse]{flex-direction:row-reverse;justify-content:start}[part~=wy-reactions-line-bottom]{position:absolute;bottom:calc(-1 * var(--wy-size, 1rem));right:calc(.25 * var(--wy-size, 1rem));z-index:1}[part~=wy-reactions-line-below]{position:relative;height:0;min-height:0;max-height:0;margin:calc(var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) - var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) calc(-1 * var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))) calc(-1 * var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))));padding-left:calc(.125 * var(--wy-size, 1rem));padding-right:calc(.125 * var(--wy-size, 1rem));gap:calc(.125 * var(--wy-size, 1rem));flex:1 0 auto;justify-content:flex-end}.wy-sheet{--wy-scrollbar-adjust-top: 0;--wy-scrollbar-adjust-bottom: 0;--wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);position:fixed;z-index:1055;display:flex;flex-direction:column;overflow:hidden;bottom:calc(.5 * var(--wy-size, 1rem));left:calc(.5 * var(--wy-size, 1rem));right:calc(.5 * var(--wy-size, 1rem));max-height:max(50vh,50%);min-height:calc(3 * var(--wy-size, 1rem));margin:calc(.5 * var(--wy-size, 1rem)) auto;max-width:calc(32 * var(--wy-size, 1rem));transition:opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));box-shadow:var(--wy-shadow-level1, 0 calc(.125 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.1875 * var(--wy-size, 1rem)) calc(.0625 * var(--wy-size, 1rem)) calc(-.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12))}.wy-sheet>.wy-appbars,.wy-sheet>.wy-appbar{border-top-left-radius:inherit;border-top-right-radius:inherit}.wy-sheet-body{overflow:hidden;padding:calc(.5 * var(--wy-size, 1rem));position:relative;min-height:calc(3 * var(--wy-size, 1rem))}.wy-sheet-body.wy-scroll-y{overflow-y:auto}.wy-sheet-no-padding{padding:0}.wy-sheet:not(.wy-show){opacity:0;transform:translateY(calc(32 * var(--wy-size, 1rem)))}.wy-sheet.wy-show{opacity:1;transform:none;transition:transform var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))),opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));pointer-events:auto}@starting-style{.wy-sheet.wy-show{opacity:0;transform:translateY(calc(32 * var(--wy-size, 1rem)))}}.wy-toasts{background:none;border:none;padding:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));margin:0;width:100%;height:100%;display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;align-items:flex-end;justify-content:flex-end;pointer-events:none}.wy-toasts[popover]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1070}.wy-toasts>::slotted(*){pointer-events:auto}.wy-toast{--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background:var(--wy-component-background-color);color:var(--wy-component-color);gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));margin-top:0;margin-bottom:var(--wy-gap-lg, calc(1.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));display:flex;cursor:pointer;border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));padding:0;-webkit-user-select:none;user-select:none;box-shadow:var(--wy-shadow-level2, 0 calc(.25 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.625 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12), 0 calc(.125 * var(--wy-size, 1rem)) calc(.25 * var(--wy-size, 1rem)) calc(-.0625 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2));position:relative;overflow:hidden;min-height:calc(4.5 * var(--wy-size, 1rem));max-width:calc(32 * var(--wy-size, 1rem))}.wy-toast.wy-fade{transition-property:opacity,min-height,padding-top,padding-bottom,margin-top,margin-bottom,height;transition-duration:var(--wy-transition-duration, .2s);transition-timing-function:var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))}.wy-toast.wy-fade:not(.wy-show){opacity:0;min-height:0;height:0;padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0;pointer-events:none}.wy-toast-action{position:sticky;top:calc(4.5 * var(--wy-size, 1rem));bottom:calc(4.5 * var(--wy-size, 1rem));z-index:990;background-color:var(--wy-primary, var(--wy-primary-40, #006399));color:var(--wy-on-primary, var(--wy-white, #ffffff));padding:calc(.5 * var(--wy-size, 1rem)) calc(1 * var(--wy-size, 1rem));margin-left:auto;margin-right:auto;margin-top:0;margin-bottom:calc(.5 * var(--wy-size, 1rem));border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));width:max-content;min-height:0;max-width:calc(100% - 3 * var(--wy-size, 1rem));height:auto;align-self:center;text-align:center;box-shadow:none}.wy-toast-primary{background:var(--wy-on-primary-container, var(--wy-primary-10, #001d32));color:var(--wy-primary-container, var(--wy-primary-90, #cde5ff))}.wy-placeholder{cursor:wait;color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));background:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));opacity:.5;animation:wy-placeholder-glow 2s ease-in-out infinite}@keyframes wy-placeholder-glow{50%{opacity:.2}}.wy-meeting .wy-item-title{font-weight:700}.wy-meeting .wy-item-text{font-size:var(--wy-font-size, var(--wy-size, 1em))}.wy-meeting.wy-disabled .wy-item-title{font-weight:400}.wy-dragging:after{content:attr(data-drag-title);background-color:#ffffff80;display:flex;justify-content:center;align-items:center;border:calc(.125 * var(--wy-size, 1rem)) dashed var(--wy-primary, var(--wy-primary-40, #006399));font-weight:var(--wy-font-weight-bold, bolder);z-index:10000;position:absolute;top:0;left:0;bottom:0;right:0}.wy-message-editor-top{background-color:var(--wy-component-background-color);color:var(--wy-component-color)}@supports (position: sticky){.wy-message-editor-top{position:sticky;top:0;z-index:1020}}.wy-message-editor-bottom{background-color:var(--wy-component-background-color);color:var(--wy-component-color)}@supports (position: sticky){.wy-message-editor-bottom{position:sticky;bottom:0;z-index:1020}}.wy-message-form .wy-spinner{display:none}.wy-message-form.wy-uploading .wy-spinner{display:block}.wy-message-form.wy-uploading [data-icon=plus]{display:none}.wy-message-form .wy-picker-list:not(:empty){border-top:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-message-editor-inputs{display:flex;flex-direction:row;align-items:flex-end;padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));min-height:calc(var(--wy-input-font-size, var(--wy-font-size, 1em)) * 1.5 * var(--wy-size, 1rem) + var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * 2 + var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) * 2);gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-message-editor-buttons{flex:1 0 auto}.wy-message-editor-text{flex:1 1 100%;display:flex;flex-direction:column}.wy-message-editor-mention,.wy-message-editor-link{background:#00f;color:#fff}.wy-message-editor .cm-editor,.wy-message-editor-grow:after,.wy-message-editor-grow>textarea,.wy-message-editor-textfield{flex:1 1 100%;max-height:11.25em;background-color:var(--wy-background, var(--wy-neutral-99, #fcfcff));color:var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));border-radius:var(--wy-input-filled-border-radius, var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem)))));border:var(--wy-input-border-width, var(--wy-border, 1px)) solid var(--wy-background, var(--wy-neutral-99, #fcfcff))}.wy-message-editor .cm-editor:focus,.wy-message-editor-grow:focus:after,.wy-message-editor-grow>textarea:focus,.wy-message-editor-textfield:focus{border-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-message-editor .cm-editor .cm-content,.wy-message-editor-textcontent{font-family:var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;font-size:var(--wy-input-font-size, var(--wy-font-size, 1em));padding:var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));min-height:calc(var(--wy-input-font-size, var(--wy-font-size, 1em)) * 1.5 * var(--wy-size, 1rem) + var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * 2 - var(--wy-input-border-width, var(--wy-border, 1px)));line-height:calc(1.5 * var(--wy-size, 1rem))}.wy-message-editor-grow{display:grid}.wy-message-editor-grow:after,.wy-message-editor-grow>textarea{grid-area:1/1/2/2}.wy-message-editor-grow:after{content:attr(data-replicated-value) \" \";white-space:pre-wrap;visibility:hidden}.wy-message-editor-grow>textarea{resize:none;overflow:hidden}.wy-editor .cm-scroller{font-family:unset;line-height:1.5}.wy-editor .cm-widgetBuffer{vertical-align:unset}.wy-editor .cm-placeholder{pointer-events:none;color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e))}.wy-editor .cm-content{caret-color:var(--wy-on-background, var(--wy-neutral-10, #1a1c1e))}.wy-editor .cm-content .wy-link{text-decoration:var(--wy-link-decoration, none);color:var(--wy-link, var(--wy-primary-40, #006399))}.wy-editor .cm-editor{box-sizing:border-box;flex-direction:column;position:relative!important;display:flex!important}.wy-editor .cm-editor.cm-focused{--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));color:var(--wy-component-color);border-color:var(--wy-primary, var(--wy-primary-40, #006399));outline:0}.wy-editor .cm-editor .cm-scroller{overflow:auto}.wy-editor .cm-editor .cm-line{display:block;padding:0px var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) 0px var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))}.wy-editor .cm-tooltip.cm-tooltip-autocomplete>ul{font-family:unset;max-height:calc(15 * var(--wy-size, 1rem))}.wy-editor .cm-tooltip.cm-tooltip-autocomplete>ul>li{padding:0}.wy-editor .cm-tooltip{border:none;background-clip:padding-box;background-color:var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));color:var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));box-shadow:var(--wy-shadow-level1, 0 calc(.125 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.1875 * var(--wy-size, 1rem)) calc(.0625 * var(--wy-size, 1rem)) calc(-.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12));overflow:hidden;z-index:1000}.wy-editor .cm-tooltip-autocomplete ul li[aria-selected]{background:var(--wy-primary-container, var(--wy-primary-90, #cde5ff));color:unset}.wy-editor .cm-tooltip-autocomplete .cm-completionLabel{display:none}.wy-editor .cm-tooltip-autocomplete .wy-item-hover:hover,.wy-editor .cm-tooltip-autocomplete .wy-item-hover:focus{background:var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb))}.wy-message-editor .cm-editor.cm-focused{border-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-message-editor .wy-is-invalid+[data-editor-target] .cm-editor,.wy-message-editor .wy-is-invalid .cm-editor{border-color:var(--wy-error, var(--wy-error-40, #ba1824))!important}.wy-chat-conversation{overflow-anchor:none;display:flex;flex-direction:column;flex:1 0 min-content;height:100%;width:100%;min-height:0;min-width:0}.wy-truncated-text-and-icon{display:flex;align-items:center;gap:.25rem}.wy-truncated-text-and-icon>:first-child{line-height:var(--wy-line-height, 1.5);flex:0 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.wy-truncated-text-and-icon>:last-child:not(:first-child){flex:0 0 auto;white-space:nowrap}[part~=wy-filename]{font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)));height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);display:flex;flex-direction:column;justify-content:center}[part~=wy-filename] .wy-truncated-text-and-icon{justify-content:space-between}.wy-files{position:relative;display:flex;flex-direction:column;flex:1;min-height:0;container-type:inline-size}@supports (position: sticky){wy-files-appbar{position:sticky;top:0;z-index:1020}}.wy-table-files thead{text-align:left;display:none}@container (inline-size >= 576px){.wy-table-files thead{display:table-header-group}}.wy-table-files tr[part~=wy-highlight]{animation:wy-highlight 3s 1.5s ease-in-out both}.wy-table-files tr>:nth-child(2){width:100%}.wy-table-files tr>:nth-child(2) td{padding:0 var(--wy-table-cell-padding-x, var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))))))}.wy-table-files tr>:nth-child(4){width:calc(7 * var(--wy-size, 1rem));display:none}@container (inline-size >= 768px){.wy-table-files tr>:nth-child(4){display:table-cell}}.wy-table-files tr>:nth-child(4){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-table-files tr>:nth-child(5){width:calc(7.5 * var(--wy-size, 1rem));text-align:right;display:none}@container (inline-size >= 768px){.wy-table-files tr>:nth-child(5){display:table-cell}}.wy-table-files tr>:nth-child(5){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-table-files tr>:nth-child(6){width:calc(7 * var(--wy-size, 1rem));text-align:right;display:none}@container (inline-size >= 576px){.wy-table-files tr>:nth-child(6){display:table-cell}}.wy-table-files tr>:nth-child(6){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-sidebar{--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background:var(--wy-component-background-color);color:var(--wy-component-color);min-width:0;min-height:0;flex-grow:0;flex-shrink:0;flex-basis:calc(18 * var(--wy-size, 1rem));z-index:10;display:flex;flex-direction:column;transition:flex-basis var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));position:relative;order:9999}.wy-sidebar>*{transition:opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, .1s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) calc(var(--wy-transition-duration, .2s) - var(--wy-transition-duration-fast, .1s));min-width:calc(18 * var(--wy-size, 1rem))}.wy-sidebar[hidden]{display:flex!important;flex-basis:0}.wy-sidebar[hidden]>*{transition:opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, .1s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));opacity:0}@media (min-width: 768px){.wy-sidebar>*{min-width:calc(18 * var(--wy-size, 1rem))}.wy-sidebar .wy-sidebar-handle{display:none}}@media (max-width: 767.98px){.wy-sidebar{transition:flex-basis var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))),margin-top var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));border-top-left-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));border-top-right-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));flex-basis:50vh}.wy-sidebar:not([hidden]){margin-top:calc(-1 * var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))))}.wy-sidebar:not([hidden]).wy-maximized{flex-basis:calc(100% - var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem))))) * .5);margin-top:calc(-50% + var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem))))) * 2.5 - var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))))}.wy-sidebar:not([hidden]).wy-maximized~* .wy-nav-prev,.wy-sidebar:not([hidden]).wy-maximized~* .wy-nav-next{display:none}.wy-sidebar>*{min-height:var(--wy-appbar-height, calc(max(1lh, var(--wy-button-size, calc(2.5 * var(--wy-size, 1rem)))) + 2 * var(--wy-padding, calc(.25 * var(--wy-size, 1rem)))))}}.wy-sidebar-handle{width:calc(4 * var(--wy-size, 1rem));background-clip:content-box;background-color:var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));height:calc(1 * var(--wy-size, 1rem));border:calc(.375 * var(--wy-size, 1rem)) solid transparent;position:absolute;top:0;z-index:2;left:50%;margin-left:calc(-2 * var(--wy-size, 1rem));border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));cursor:pointer}.wy-table{table-layout:fixed;width:100%;vertical-align:top;border-collapse:collapse}.wy-table th,.wy-table td{background-color:var(--wy-component-background-color);padding:var(--wy-table-cell-padding-y, var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) var(--wy-table-cell-padding-x, var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))))));box-shadow:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0 -1px 0 0 inset;line-height:1;vertical-align:middle;height:calc(2.5 * var(--wy-size, 1rem))}.wy-table th:first-child,.wy-table td:first-child{padding-left:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}.wy-table th:last-child,.wy-table td:last-child{padding-right:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}.wy-table>tbody{vertical-align:inherit}.wy-table>thead{vertical-align:bottom}.wy-table .wy-table-cell-icon{vertical-align:middle;text-align:center;padding:calc(var(--wy-table-cell-padding-y, var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .5) var(--wy-table-cell-padding-x, var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))))));width:calc(calc(2.5 * var(--wy-size, 1rem)) + var(--wy-table-cell-padding-x, var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))) * 2);font-size:var(--wy-font-size, var(--wy-size, 1em));font-weight:var(--wy-font-weight, unset);text-transform:none;letter-spacing:normal}.wy-table .wy-table-cell-text{width:100%}.wy-table .wy-table-cell-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-table-hover>tbody>tr:hover>*{--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));color:var(--wy-component-color);cursor:pointer}.wy-table-row-trashed th,.wy-table-row-trashed td{text-decoration:line-through}.wy-table-row-trashed th:not(:last-child)>*,.wy-table-row-trashed td:not(:last-child)>*{opacity:var(--wy-opacity-disabled, 38%)}.wy-table-row-trashed th>a,.wy-table-row-trashed td>a{color:var(--wy-component-color)}.wy-table-row-trashed:hover th,.wy-table-row-trashed:hover td{opacity:1}.wy-table-no-result{text-align:center;padding:calc(1 * var(--wy-size, 1rem))}.wy-table-sort-link{display:inline-flex;align-items:center;color:var(--wy-link, var(--wy-primary-40, #006399));cursor:pointer}.wy-posts{display:flex;flex-direction:column;gap:calc(1 * var(--wy-size, 1rem))}.wy-post{--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;flex-direction:column;position:relative;--wy-component-border-radius: var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));border-radius:var(--wy-component-border-radius)}.wy-post[part~=wy-highlight]{animation:wy-highlight 3s 1.5s ease-in-out both}.wy-post .wy-image-grid{border-radius:0}.wy-post wy-comment-list{border-top:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-post-body{display:flex;flex-direction:column;padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));gap:var(--wy-gap-lg, calc(1.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-post-body:empty{display:none}.wy-post-footer{display:flex;align-items:center;justify-content:space-between;padding:0 calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) * .75) calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) * .75)}.wy-post-footer .wy-meta{margin-right:calc(.5 * var(--wy-size, 1rem))}.wy-post-comments:not(:empty){padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}.wy-post-dragging:after{content:attr(data-drag-title,\"Drop files here to upload.\");background-color:#ffffff80;display:flex;justify-content:center;align-items:center;border:calc(.125 * var(--wy-size, 1rem)) dashed var(--wy-primary, var(--wy-primary-40, #006399));font-weight:var(--wy-font-weight-bold, bolder);z-index:10000;position:absolute;top:0;left:0;bottom:0;right:0}.wy-poll{flex:1 1 100%;min-width:0;display:flex;flex-direction:column;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-poll-form{background:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;flex-direction:column;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-poll-form:empty{display:none}.wy-poll-option{overflow:hidden;position:relative;background-color:var(--wy-background, var(--wy-neutral-99, #fcfcff));border:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));min-height:calc(2.5 * var(--wy-size, 1rem));cursor:pointer}.wy-poll-option .wy-progress{position:absolute;top:0;left:0;bottom:0;background-color:var(--wy-surface-5, var(--wy-surface-5-light, #dce2ea))}.wy-poll-option>:not(.wy-progress){z-index:1}.wy-embed{display:flex;flex-direction:column;word-wrap:break-word;border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));clip-path:border-box;overflow:hidden}.wy-embed-photo a{display:flex}.wy-embed-photo img{width:100%;height:auto}.wy-embed-photo-sm a{padding:0 calc(1 * var(--wy-size, 1rem))}.wy-embed-photo-sm img{display:block;margin:0 auto;width:auto;max-width:100%;border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))}.wy-embed-video{position:relative;display:block;width:100%;padding:0;overflow:hidden}.wy-embed-video:before{display:block;content:\"\";padding-top:56.25%}.wy-embed-video iframe,.wy-embed-video embed,.wy-embed-video object,.wy-embed-video video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.wy-embed-caption{--wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);padding:calc(.5 * var(--wy-size, 1rem)) calc(1 * var(--wy-size, 1rem)) calc(1 * var(--wy-size, 1rem));position:relative}.wy-embed-link{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));text-transform:uppercase;font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}.wy-embed-link:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.wy-embed-title{font-weight:var(--wy-headings-font-weight, var(--wy-font-weight-bold, bolder));margin-bottom:calc(.5 * var(--wy-size, 1rem))}.wy-embed-description{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e))}.wy-embed-preview a[target=_blank]{pointer-events:none}.wy-embed-preview .wy-embed{border:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));display:none}.wy-embed-preview .wy-embed:first-child{display:block}.wy-embed-preview .wy-embed-caption{border-bottom-left-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));border-bottom-right-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)))}.wy-embed-preview .wy-embed-actions{display:flex}.wy-embed-actions{display:none;justify-content:space-between;padding:calc(.5 * var(--wy-size, 1rem)) calc(.25 * var(--wy-size, 1rem))}.wy-embed-cycle{visibility:hidden}.wy-embed-show-cycle .wy-embed-cycle{visibility:visible}.wy-post-editor{padding:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));display:flex;flex-direction:column;gap:var(--wy-gap-lg, calc(1.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-post-editor.wy-uploading .wy-icon-active-stack>:first-child{opacity:0}.wy-post-editor.wy-uploading .wy-icon-active-stack>:last-child{opacity:1}.wy-post-editor .wy-picker-list:not(:empty){margin-top:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));border-top:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-post-editor-inputs{display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;flex-wrap:wrap;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-post-editor-buttons{display:flex;flex-direction:row;align-items:flex-end;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));flex:1 0 auto}.wy-post-editor-text{flex:1 1 100%;display:flex;flex-direction:column}.wy-post-editor-mention,.wy-post-editor-link{background:#00f;color:#fff}.wy-post-editor .cm-editor,.wy-post-editor-grow:after,.wy-post-editor-grow>textarea,.wy-post-editor-textfield{flex:1 1 100%;max-height:11.25em;min-height:4em;background-color:var(--wy-background, var(--wy-neutral-99, #fcfcff));color:var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));border:var(--wy-input-border-width, var(--wy-border, 1px)) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));caret-color:var(--wy-primary, var(--wy-primary-40, #006399))}.wy-post-editor .cm-editor:focus,.wy-post-editor-grow:focus:after,.wy-post-editor-grow>textarea:focus,.wy-post-editor-textfield:focus{border-color:var(--wy-primary, var(--wy-primary-40, #006399))}.wy-post-editor .cm-editor .cm-content,.wy-post-editor-textcontent{font-family:var(--wy-input-font-family, var(--wy-font-family, inherit)),inherit;font-size:var(--wy-input-font-size, var(--wy-font-size, 1em));padding:var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))}.wy-post-editor-grow{display:grid}.wy-post-editor-grow:after,.wy-post-editor-grow>textarea{grid-area:1/1/2/2}.wy-post-editor-grow:after{content:attr(data-replicated-value) \" \";white-space:pre-wrap;visibility:hidden}.wy-post-editor-grow>textarea{resize:none;overflow:hidden}.wy-post-editor .cm-editor .cm-line{padding:0}.wy-post-editor .wy-is-invalid+[data-editor-target] .cm-editor,.wy-post-editor .wy-is-invalid .cm-editor{border-color:var(--wy-error, var(--wy-error-40, #ba1824))!important}.wy-comments{display:flex;flex-direction:column;gap:var(--wy-gap-xl, calc(2 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-comment{--wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));--wy-component-border-radius: var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));border-radius:var(--wy-component-border-radius);background-color:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;flex-direction:column;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));position:relative}.wy-comment[part~=wy-highlight]{animation:wy-highlight 3s 1.5s ease-in-out both}.wy-comment-body{flex:1 0 auto;z-index:1}.wy-comment-content{padding:0 var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));display:flex;flex-direction:column;gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))}.wy-comment-editor .wy-spinner{display:none}.wy-comment-editor.wy-uploading .wy-spinner{display:block}.wy-comment-editor.wy-uploading [data-icon=plus]{display:none}.wy-comment-editor .wy-picker-list:not(:empty){border-top:var(--wy-border, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-comment-editor.wy-comment-editor-bottom{position:sticky;bottom:0;z-index:999;background-color:var(--wy-component-background-color);color:var(--wy-component-color)}.wy-comment-editor-inputs{display:flex;flex-direction:row;align-items:flex-end;padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));min-height:calc(3.5 * var(--wy-size, 1rem));gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-comment-editor-buttons{flex:1 0 auto}.wy-comment-editor-text{flex:1 1 100%;display:flex;flex-direction:column}.wy-comment-editor-mention,.wy-comment-editor-link{background:#00f;color:#fff}.wy-comment-editor .cm-editor,.wy-comment-editor-grow:after,.wy-comment-editor-grow>textarea,.wy-comment-editor-textfield{flex:1 1 100%;max-height:calc(11.25 * var(--wy-size, 1rem));background-color:var(--wy-background, var(--wy-neutral-99, #fcfcff));color:var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));border-radius:calc(1.25 * var(--wy-size, 1rem));border:var(--wy-input-border-width, var(--wy-border, 1px)) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}.wy-comment-editor .cm-editor:focus,.wy-comment-editor-grow:focus:after,.wy-comment-editor-grow>textarea:focus,.wy-comment-editor-textfield:focus{border-color:var(--wy-primary, var(--wy-primary-40, #006399))}.wy-comment-editor .cm-editor .cm-content,.wy-comment-editor-textcontent{font-family:var(--wy-input-font-family, var(--wy-font-family, inherit)),inherit;font-size:var(--wy-input-font-size, var(--wy-font-size, 1em));padding:var(--wy-input-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-input-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))}.wy-comment-editor-grow{display:grid}.wy-comment-editor-grow:after,.wy-comment-editor-grow>textarea{grid-area:1/1/2/2}.wy-comment-editor-grow:after{content:attr(data-replicated-value) \" \";white-space:pre-wrap;visibility:hidden}.wy-comment-editor-grow>textarea{resize:none;overflow:hidden}.wy-comment-editor{position:relative}.wy-comment-editor .wy-is-invalid+.cm-editor,.wy-comment-editor .wy-is-invalid .cm-editor{border-color:var(--wy-error, var(--wy-error-40, #ba1824))!important}.wy-badge{display:inline-block;padding:.35em .65em;font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));font-weight:var(--wy-font-weight-bold, bolder);line-height:1;color:var(--wy-on-primary, var(--wy-white, #ffffff));text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));background-color:var(--wy-primary, var(--wy-primary-40, #006399))}.wy-badge:empty{display:none}.wy-badge-reveal{opacity:1;transition:opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) calc(var(--wy-transition-duration, .2s) + var(--wy-transition-reveal-delay, 1s))}@starting-style{.wy-badge-reveal{opacity:0}}.wy-button-badge{position:absolute;right:0;top:0;margin:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .5);padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));min-width:calc(var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em))) + var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));max-width:calc(var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em))) * 3 + var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) * 2);height:calc(var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em))) + var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));line-height:calc(var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em))) - var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));display:block;text-align:center}.wy-button-badge{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-button-badge:empty{display:none}.wy-button-dot{position:absolute;right:0;top:0;content-visibility:hidden;padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));margin:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))));line-height:0;min-width:0;height:0}.wy-button-dot:empty{display:none}[part~=wy-tabs]{display:flex;overflow-y:hidden;padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));flex:1 1 auto}[part~=wy-tabs]{overflow-x:auto;max-width:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}[part~=wy-tabs]{scrollbar-width:thin;scrollbar-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) transparent}[part~=wy-tabs]::-webkit-scrollbar{height:.375rem;width:.375rem;background:transparent;z-index:999}[part~=wy-tabs]::-webkit-scrollbar-track{background:transparent}[part~=wy-tabs]::-webkit-scrollbar-thumb{background-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));opacity:75%;border:0 solid transparent;border-radius:0;background-clip:padding-box}[part~=wy-tabs]::-webkit-scrollbar-thumb:hover{background-color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));opacity:75%}[part~=wy-tabs]::-webkit-scrollbar-thumb:window-inactive{background-color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));opacity:50%}[part~=wy-tab]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));--wy-component-background-color: transparent;color:var(--wy-component-color);background:var(--wy-component-background-color);border:none;border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));position:relative;text-align:center;text-decoration:none;cursor:pointer;-webkit-user-select:none;user-select:none}[part~=wy-tab] .wy-tab-icon{position:relative;padding:calc(.25 * var(--wy-size, 1rem)) calc(1 * var(--wy-size, 1rem));border-radius:var(--wy-button-border-radius, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));display:inline-flex}[part~=wy-tab] .wy-tab-icon:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;background:var(--wy-component-color);opacity:0%}[part~=wy-tab]:hover .wy-tab-icon:before{opacity:8%}[part~=wy-tab]:focus .wy-tab-icon:before,[part~=wy-tab]:active .wy-tab-icon:before,[part~=wy-tab].wy-active .wy-tab-icon:before{opacity:12%}[part~=wy-tab] .wy-tab-label{font-family:var(--wy-button-font-family, var(--wy-font-family, unset)),inherit;line-height:var(--wy-button-line-height, var(--wy-line-height, 1.5));font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));font-weight:var(--wy-font-weight, unset)}[part~=wy-button-state-layer][part~=wy-button-sm][part~=wy-tab-sm]{padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .5);margin:var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) auto;font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)));height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6)}[part~=wy-button-state-layer][part~=wy-button-sm][part~=wy-tab-sm]:before{margin:calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * -.25) calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * 0)}.wy-conversations{position:relative}.wy-conversation{display:flex;position:relative}.wy-conversation .wy-item-title{font-weight:var(--wy-item-title-font-weight, var(--wy-font-weight, unset));font-size:var(--wy-item-title-font-size, var(--wy-font-size, 1em))}.wy-conversation.wy-unread .wy-item-title{font-weight:var(--wy-font-weight-bold, bolder)}.wy-conversation.wy-unread .wy-item-text,.wy-conversation.wy-unread .wy-meta{color:var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));font-weight:var(--wy-font-weight-bold, bolder)}.wy-conversation .wy-item-text .wy-typing-show{font-weight:var(--wy-font-weight, unset)}.wy-conversation .wy-item-text .wy-typing-show{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`;
var Jq = Object.defineProperty, eU = Object.getOwnPropertyDescriptor, _t = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? eU(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Jq(t, i, r), r;
}, "__decorateClass$16");
function m$(s) {
  return s != null && s !== !1;
}
u(m$, "au");
p(m$, "acceptedValue");
const OA = "wy-context";
var DO, cu;
let lt = (DO = (cu = class extends G {
  constructor() {
    super(), this.provider = !1, this.childElementCount && (this.provider = !0), this.weavy ?? (this.weavy = new cg({ host: this.provider ? this : void 0 }));
  }
  /**
   * The semver version of the package.
   */
  get version() {
    return cg.version;
  }
  /**
   * The Weavy source name; package name.
   */
  get sourceName() {
    return cg.sourceName;
  }
  willUpdate(t) {
    if (super.willUpdate(t), this.weavy) {
      const i = {};
      Array.from(t.keys()).forEach((n) => {
        n !== "weavy" && (m$(this[n]) || m$(t.get(n))) && Object.assign(i, { [n]: this[n] });
      }), Object.assign(this.weavy, i);
    }
  }
  render() {
    return O` <slot></slot> `;
  }
}, u(cu, "yn"), cu), p(DO, "WyContext"), DO);
lt.styles = [
  fe,
  Yi,
  de`
      :host {
        display: contents;
      }
    `
];
_t([
  x({ attribute: !0, type: Boolean })
], lt.prototype, "provider", 2);
_t([
  x({
    attribute: !0,
    converter: {
      fromAttribute: /* @__PURE__ */ p((s) => Jm(s), "fromAttribute")
    }
  })
], lt.prototype, "cloudFilePickerUrl", 2);
_t([
  x({
    attribute: !0,
    converter: {
      fromAttribute: /* @__PURE__ */ p((s) => Jm(s), "fromAttribute")
    }
  }),
  x({ type: Boolean })
], lt.prototype, "disableEnvironmentImports", 2);
_t([
  x({ attribute: !0 })
], lt.prototype, "locale", 2);
_t([
  x({ attribute: !0, type: Array })
], lt.prototype, "locales", 2);
_t([
  x({ attribute: !0, type: Number })
], lt.prototype, "gcTime", 2);
_t([
  x({ attribute: !0, type: Array })
], lt.prototype, "reactions", 2);
_t([
  x({ type: Boolean })
], lt.prototype, "notificationEvents", 2);
_t([
  x({ type: Boolean })
], lt.prototype, "notificationToasts", 2);
_t([
  x({ attribute: !0 })
], lt.prototype, "scrollBehavior", 2);
_t([
  x({ attribute: !0, type: Number })
], lt.prototype, "staleTime", 2);
_t([
  x({
    attribute: !0,
    converter: {
      fromAttribute: /* @__PURE__ */ p((s) => vA(s), "fromAttribute")
    }
  })
], lt.prototype, "tokenFactory", 2);
_t([
  x({ attribute: !0, type: Number })
], lt.prototype, "tokenFactoryRetryDelay", 2);
_t([
  x({ attribute: !0, type: Number })
], lt.prototype, "tokenFactoryTimeout", 2);
_t([
  x({
    attribute: !0,
    converter: {
      fromAttribute: /* @__PURE__ */ p((s) => Jm(s), "fromAttribute")
    }
  })
], lt.prototype, "tokenUrl", 2);
_t([
  x({
    attribute: !0,
    converter: {
      fromAttribute: /* @__PURE__ */ p((s) => Jm(s), "fromAttribute")
    }
  })
], lt.prototype, "url", 2);
_t([
  B()
], lt.prototype, "weavy", 2);
lt = _t([
  F(OA)
], lt);
var hu;
const bA = (hu = class {
  constructor(t, i) {
    this.firstUpdate = !0, this.styles = [], t.addController(this), this.host = t, i && (this.styles = i);
  }
  checkThemeUpdate() {
    const t = this.themeColor || w1(this.host) || g1();
    if (t && t !== this._resolvedThemeColor) {
      this._resolvedThemeColor = t, console.info("Configuring theme", this._resolvedThemeColor);
      const i = tA(this._resolvedThemeColor).join(""), n = de`
        :host {
          ${vM(i)};
        }
      `, r = this.host.renderRoot;
      OM(r, [...this.styles, n]);
    }
  }
  hostUpdate() {
    this.firstUpdate && (this.checkThemeUpdate(), this.firstUpdate = !1);
  }
  hostConnected() {
    this.cssObserverDisconnect = JR(this.host, () => this.checkThemeUpdate()), this.metaObserverDisconnect = eA(() => this.checkThemeUpdate());
  }
  hostDisconnected() {
    var t, i;
    (t = this.cssObserverDisconnect) == null || t.call(this), (i = this.metaObserverDisconnect) == null || i.call(this);
  }
}, u(hu, "Cp"), hu);
p(bA, "ThemeController");
let Fr = bA;
const o5 = de`:host{display:contents}`, Hr = de`:host{font-family:var(--wy-font-family, unset)}`;
var tU = Object.defineProperty, iU = Object.getOwnPropertyDescriptor, l5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? iU(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && tU(t, i, r), r;
}, "__decorateClass$15");
const $A = "wy-component";
var qO, du;
let xo = (qO = (du = class extends Ce {
  constructor() {
    super(), this.componentType = Ni.Unknown, new Fr(this, xo.styles);
  }
  render() {
    return O`<slot></slot>`;
  }
}, u(du, "wn"), du), p(qO, "WyComponent"), qO);
xo.styles = [Yi, o5, Hr];
l5([
  x()
], xo.prototype, "componentType", 2);
l5([
  x()
], xo.prototype, "productType", 2);
xo = l5([
  F($A)
], xo);
const Wf = de`:host{position:relative;display:flex;flex-direction:column;flex:1;min-height:3rem;min-width:16rem;isolation:isolate}`, ew = de`.wy-scroll-y{scroll-padding-top:var(--wy-scrollbar-adjust-top, 0);scroll-padding-bottom:var(--wy-scrollbar-adjust-bottom, 0)}.wy-scroll-y{overflow-y:auto;max-height:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-scroll-y:not(body){-webkit-overflow-scrolling:touch}.wy-scroll-y:not(.wy-scroll-x){overflow-x:hidden;touch-action:pan-y}.wy-scroll-x{overflow-x:auto;max-width:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-scroll-x:not(.wy-scroll-y){overflow-y:hidden;touch-action:pan-x}:host{overflow-y:auto;max-height:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}:host:not(body){-webkit-overflow-scrolling:touch}`;
function xA(s, t, i = {}, n) {
  var r, a;
  if (s) {
    if (s = JSON.parse(JSON.stringify(s)), s != null && s.pages) {
      let o = -1;
      return {
        pages: [...s.pages.map((l, c) => {
          if (o >= 0)
            return l;
          const h = l.data || [], d = h.filter(
            (f) => f.id !== t.id && !n
          );
          return i && i.by ? (o = d.findIndex((f) => {
            let y = i.by && f[i.by], w = i.by && t[i.by];
            if (i.by === "updated_at" && (y ?? (y = f.created_at), w ?? (w = t.created_at)), typeof y == "string" && typeof w == "string") {
              const g = y.localeCompare(w, void 0, {
                sensitivity: "base",
                numeric: !0
              });
              return i.descending ? g < 0 : g > 0;
            }
            return y && w && (i.descending ? y < w : y > w);
          }), o >= 0 ? (d.splice(o, 0, t), l.data = [...d], l.end && (l.end += 1 + d.length - h.length)) : s && c == s.pages.length - 1 && l.end === l.count ? (l.data = [...d, t], l.end && (l.end += 1 + d.length - h.length)) : l.data = [...d]) : c === 0 && (i.descending ? l.data = [t, ...d] : l.data = [...d, t], l.end && (l.end += 1 + d.length - h.length)), l;
        }) ?? []],
        pageParams: [...s.pageParams]
      };
    } else if ((r = s == null ? void 0 : s.data) != null && r.length) {
      let o = -1;
      const l = [
        ...((a = s.data) == null ? void 0 : a.filter(
          (h) => h.id !== t.id && !n
        )) || []
      ];
      let c = s.count;
      return i && i.by ? (o = l.findIndex((h) => {
        let d = h[i.by], f = t[i.by];
        if (i.by === "updated_at" && (d ?? (d = h.created_at), f ?? (f = t.created_at)), typeof d == "string" && typeof f == "string") {
          const y = d.localeCompare(f, void 0, {
            sensitivity: "base",
            numeric: !0
          });
          return i.descending ? y < 0 : y > 0;
        }
        return d && f && (i.descending ? d < f : d > f);
      }), o >= 0 ? l.splice(o, 0, t) : (l.push(t), c++)) : (i.descending ? l.unshift(t) : l.push(t), c++), {
        data: l,
        count: c
      };
    }
  }
  return s;
}
u(xA, "_m");
p(xA, "addToQueryData");
function c5(s, t, i) {
  var n, r;
  const a = t === void 0 ? () => !0 : t instanceof Function ? t : (o) => o.id === t;
  return s && (s = JSON.parse(JSON.stringify(s)), s.pages ? {
    pages: s.pages.map((o) => (o.data && (o.data = [
      ...o.data.map((l) => (a(l) && (l = { ...l }, i(l)), l))
    ]), o)) ?? [],
    pageParams: s.pageParams
  } : (n = s.data) != null && n.length ? {
    ...s,
    data: [
      ...((r = s.data) == null ? void 0 : r.map((o) => (a(o) && (o = { ...o }, i(o)), o))) || []
    ]
  } : s.data ? {
    data: [
      ...s.data.map((o) => (a(o) && (o = { ...o }, i(o)), o))
    ],
    count: s.count
  } : s);
}
u(c5, "Vy");
p(c5, "updateQueryData");
function h5(s, t) {
  var i, n, r;
  if (t !== void 0) {
    const a = t instanceof Function ? t : (o) => o.id === t;
    if (s) {
      if (s = JSON.parse(JSON.stringify(s)), s.pages)
        return {
          pages: s.pages.map((o) => (o.data && (o.data = [...o.data.filter((l) => !a(l))]), o)) ?? [],
          pageParams: s.pageParams
        };
      if ((i = s.data) != null && i.length) {
        const o = (n = s.data) == null ? void 0 : n.length;
        let l = s.count;
        const c = [...((r = s.data) == null ? void 0 : r.filter((h) => !a(h))) || []];
        return o !== c.length && l--, {
          data: c,
          count: l
        };
      }
    }
  }
  return s;
}
u(h5, "By");
p(h5, "removeQueryData");
const zr = /* @__PURE__ */ p((s, t, i, n) => s.setQueryData(t, (r) => xA(r, i, n)), "addCacheItem"), Fe = /* @__PURE__ */ p((s, t, i, n) => s.setQueryData(t, (r) => c5(
  r,
  i,
  n
)), "updateCacheItem"), Se = /* @__PURE__ */ p((s, t, i, n) => {
  s.setQueriesData(t, (r) => c5(
    r,
    i,
    n
  ));
}, "updateCacheItems"), d5 = /* @__PURE__ */ p((s, t, i) => s.setQueryData(t, (n) => h5(
  n,
  i
)), "removeCacheItem"), nU = /* @__PURE__ */ p((s, t, i) => {
  s.setQueriesData(t, (n) => h5(n, i));
}, "removeCacheItems"), v1 = /* @__PURE__ */ p((s, t, i) => {
  s.setQueriesData(t, (n) => {
    const { count: r } = n;
    return { count: i(r) };
  });
}, "updateCacheItemsCount");
function w$(s, t, i, n = 1) {
  var r;
  if (!s)
    return;
  const a = s.getQueryData(t);
  (r = a == null ? void 0 : a.pages) != null && r.length && a.pages.length > 1 && s.setQueryData(
    t,
    (o) => ({
      pages: o.pages.slice(0, n),
      pageParams: o.pageParams.slice(0, n)
    }),
    i
  );
}
u(w$, "ou");
p(w$, "keepPages");
function _r(s, t, i) {
  const n = s.getQueryCache().find({ queryKey: t });
  if (n && n.state.data) {
    const r = n.state.data.pages.flatMap((a) => a.data).filter((a) => a && a.id < 0).sort((a, o) => a && o ? a.id - o.id : 0);
    return r.length ? i ? r[r.length - 1] : r[0] : null;
  }
  return null;
}
u(_r, "Bs");
p(_r, "getPendingCacheItem");
function tw(s, t, i) {
  const n = s.getQueryCache().find({ queryKey: t });
  return n && n.state.data ? n.state.data.pages.flatMap((r) => r.data).find((r) => (r == null ? void 0 : r.id) === i) : null;
}
u(tw, "ml");
p(tw, "getCacheItem");
function zs(s) {
  return ((s == null ? void 0 : s.pages.flatMap((t) => t.data)) || []).filter((t) => t);
}
u(zs, "ms");
p(zs, "getFlatInfiniteResultData");
function kA(s, t, i = {}) {
  return {
    ...i,
    initialPageParam: 0,
    queryKey: ["messages", t],
    queryFn: /* @__PURE__ */ p(async (n) => {
      var r;
      const a = n.pageParam, o = "/api/apps/" + t + "/messages?order_by=id+desc&skip=" + a, l = await (await s.fetch(o)).json();
      return l.data = ((r = l.data) == null ? void 0 : r.reverse()) || [], l;
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((n) => {
      if (n != null && n.end && (n == null ? void 0 : n.end) < (n == null ? void 0 : n.count))
        return n.end;
    }, "getNextPageParam"),
    select: /* @__PURE__ */ p((n) => ({
      // reverse scroll
      pages: [...n.pages].reverse(),
      pageParams: [...n.pageParams].reverse()
    }), "select")
  };
}
u(kA, "Mm");
p(kA, "getMessagesOptions");
function SA(s, t) {
  return {
    mutationFn: /* @__PURE__ */ p(async (i) => (await s.fetch("/api/apps/" + i.app_id + "/messages", {
      method: "POST",
      body: JSON.stringify({
        text: i.text,
        blobs: i.blobs,
        embed_id: i.embed_id || null,
        meeting_id: i.meeting_id,
        options: i.poll_options.filter((n) => n.text.trim() !== "").map((n) => ({ text: n.text }))
      })
    })).json(), "mutationFn"),
    mutationKey: t,
    onMutate: /* @__PURE__ */ p(async (i) => {
      const n = ["messages", i.app_id];
      await s.queryClient.cancelQueries({ queryKey: n });
      const r = _r(s.queryClient, n, !1), a = {
        id: r ? r.id - 1 : -1,
        app: { id: i.app_id },
        text: i.text,
        html: i.text,
        plain: i.text,
        created_by: i.user,
        created_at: (/* @__PURE__ */ new Date()).toUTCString(),
        attachments: { count: 0 },
        reactions: { count: 0 },
        is_starred: !1,
        is_subscribed: !0,
        is_trashed: !1
      };
      zr(s.queryClient, n, a);
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((i) => {
      Fe(
        s.queryClient,
        ["members", i.app.id],
        i.created_by.id,
        (r) => {
          r.marked_id = i.id, r.marked_at = i.created_at;
        }
      );
      const n = ["messages", i.app.id];
      if (!tw(s.queryClient, n, i.id)) {
        const r = _r(s.queryClient, n, !0);
        r ? Fe(s.queryClient, n, r.id, (a) => {
          a.id = i.id, a.app = i.app, a.text = i.text, a.html = i.html, a.embed = i.embed, a.meeting = i.meeting, a.attachments = i.attachments, a.options = i.options, a.created_at = i.created_at, a.created_by = i.created_by, a.updated_at = i.updated_at, a.updated_by = i.updated_by;
        }) : zr(s.queryClient, n, i);
      }
    }, "onSuccess")
  };
}
u(SA, "zm");
p(SA, "getAddMessageMutationOptions");
var uu;
const PA = (uu = class {
  get result() {
    return this._result && this.observer ? this.observer.trackResult(this._result) : { isPending: !0 };
  }
  constructor(t) {
    t.addController(this), this.host = t, this.whenContext = new Promise((i) => this.resolveContext = i), this.whenQueryClient = new Promise((i) => this.resolveQueryClient = i), this.setContext();
  }
  async setContext() {
    await _o(this.host), this.context = new Er(this.host, {
      context: Pt,
      subscribe: !0,
      callback: /* @__PURE__ */ p((t) => {
        var i, n;
        t && ((i = this.resolveContext) == null || i.call(this, t), this.queryClient = t.queryClient, (n = this.resolveQueryClient) == null || n.call(this, t.queryClient));
      }, "callback")
    });
  }
  async trackInfiniteQuery(t, i = !0) {
    var n;
    const r = await this.whenQueryClient;
    if (!r)
      throw new Error("No QueryClient provided");
    (n = this.observerUnsubscribe) == null || n.call(this);
    const a = new gq(r, t);
    this.observer = a, this.observerSubscribe(i);
  }
  observerSubscribe(t = !0) {
    var i;
    if (this.queryClient && this.observer) {
      t ? this._result = this.observer.getOptimisticResult(
        this.observer.options
      ) : this._result = this.observer.getCurrentResult(), this.observerUnsubscribe = this.observer.subscribe(() => {
        if (this.observer) {
          const r = Lf(this.result, this.observer.getCurrentResult());
          r !== this._result && (this._result = r, this.host.requestUpdate());
        }
      }), this.observer.updateResult(), this.host.requestUpdate();
      let n;
      t ? n = this.observer.fetchOptimistic(this.observer.options) : n = (i = this.queryClient.getQueryCache().get(
        this.observer.options.queryHash
      )) == null ? void 0 : i.promise, n == null || n.catch(() => {
      }).finally(() => {
        var r;
        (r = this.observer) == null || r.updateResult();
      });
    }
  }
  untrackInfiniteQuery() {
    var t;
    (t = this.observerUnsubscribe) == null || t.call(this), this.observerUnsubscribe = void 0, this._result = void 0, this.observer = void 0, this.host.requestUpdate();
  }
  hostConnected() {
    this.observerSubscribe();
  }
  hostDisconnected() {
    var t;
    (t = this.observerUnsubscribe) == null || t.call(this);
  }
}, u(uu, "_p"), uu);
p(PA, "InfiniteQueryController");
let Vo = PA;
function CA(s) {
  for (; s; )
    if (s = s.nextElementSibling, s instanceof HTMLElement && /absolute|sticky|fixed/.test(getComputedStyle(s).position) === !1)
      return s;
  return null;
}
u(CA, "Sm");
p(CA, "getNextPositionedChild");
function iw(s, t = !1) {
  if (Bt(), s) {
    let i = getComputedStyle(s);
    const n = i.position === "absolute", r = t ? /(auto|scroll|overlay|hidden)/ : /(auto|overlay|scroll)/;
    if (i.position === "fixed" && document.scrollingElement)
      return document.scrollingElement;
    for (let a = s; a = a.parentElement || a.parentNode || a.host; )
      if (a instanceof Element && (i = getComputedStyle(a), !(n && i.position === "static") && r.test(i.overflow + i.overflowY + i.overflowX)))
        return a;
  }
  return document.scrollingElement || s;
}
u(iw, "vl");
p(iw, "getScrollParent");
function QA(s) {
  if (s && s.isConnected) {
    const t = iw(s);
    return t.clientHeight !== t.scrollHeight;
  }
  return !1;
}
u(QA, "Em");
p(QA, "hasScroll");
function TA(s, t = 32) {
  if (s) {
    const i = iw(s);
    return Math.abs(i.scrollTop + i.clientHeight - i.scrollHeight) < t;
  }
  return !1;
}
u(TA, "Om");
p(TA, "isParentAtBottom");
async function MA(s, t = !1) {
  if (s) {
    const i = iw(s);
    Math.abs(i.scrollTop + i.clientHeight - i.scrollHeight) > 1 && (t ? i.scrollTo({
      top: i.scrollHeight,
      left: 0,
      behavior: "smooth"
    }) : i.scrollTop = i.scrollHeight), await new Promise((n) => {
      let r = i.scrollTop;
      const a = /* @__PURE__ */ p(() => {
        t && i.scrollTop === r && (i.scrollTop = i.scrollHeight), r = i.scrollTop, Math.abs(i.scrollTop + i.clientHeight - i.scrollHeight) > 1 ? requestAnimationFrame(a) : n(void 0);
      }, "scrollCheck");
      requestAnimationFrame(a);
    });
  }
}
u(MA, "Am");
p(MA, "scrollParentToBottom");
const sU = 0, rU = void 0;
function RA(s, t, i = !1) {
  Bt(), t ?? (t = /* @__PURE__ */ p(() => Promise.reject(new Error("No scroll function defined")), "whenNext"));
  const n = i ? iw(s) : document.documentElement, r = n === document.documentElement ? document : n;
  let a = !1;
  const o = new IntersectionObserver(
    (l) => {
      l.forEach((c) => {
        if (c.isIntersecting && !a)
          if (a = !0, i && n && r instanceof HTMLElement) {
            const h = CA(c.target) || c.target, d = n.scrollHeight, f = h.offsetTop, y = /* @__PURE__ */ p(() => {
              queueMicrotask(() => {
                if (d !== n.scrollHeight) {
                  if (h != null && h.isConnected) {
                    const w = h.offsetTop - f;
                    n.scrollTop += w;
                  }
                  requestAnimationFrame(() => a = !1);
                } else
                  queueMicrotask(() => {
                    if (d !== n.scrollHeight) {
                      if (h != null && h.isConnected) {
                        const w = h.offsetTop - f;
                        n.scrollTop += w;
                      }
                      requestAnimationFrame(() => a = !1);
                    } else
                      requestAnimationFrame(() => {
                        if (o.takeRecords().length && h != null && h.isConnected) {
                          const w = h.offsetTop - f;
                          n.scrollTop += w;
                        }
                        requestAnimationFrame(() => a = !1);
                      });
                  });
              });
            }, "afterNext");
            t().then(y);
          } else
            t().then(() => {
              requestAnimationFrame(() => a = !1);
            });
      });
    },
    { root: r, threshold: sU, rootMargin: rU }
  );
  return o.observe(s), o;
}
u(RA, "Im");
p(RA, "createScroller");
var pu;
const AA = (pu = class {
  constructor(t, i = !1) {
    this.reverse = !1, this.isObservePending = !1, t.addController(this), this.host = t, this.reverse = i;
  }
  observe(t, i) {
    t && i && !t.isLoading && !this.isObservePending && (this.isObservePending = !0, requestAnimationFrame(() => {
      var n;
      this.loadMoreRefElement = i, (n = this.scroller) == null || n.disconnect(), this.scroller = RA(
        i,
        async () => {
          t.hasNextPage && !t.isFetching && (await t.fetchNextPage({ cancelRefetch: !1 }), this.reverse && await this.host.updateComplete);
        },
        this.reverse
      ), this.isObservePending = !1;
    }));
  }
  hostConnected() {
    var t;
    this.loadMoreRefElement && ((t = this.scroller) == null || t.observe(this.loadMoreRefElement));
  }
  hostDisconnected() {
    var t;
    (t = this.scroller) == null || t.disconnect();
  }
}, u(pu, "Pp"), pu);
p(AA, "InfiniteScrollController");
let Zo = AA;
var fu;
const EA = (fu = class extends Zo {
  constructor(t) {
    super(t, !0);
  }
}, u(fu, "Mp"), fu);
p(EA, "ReverseInfiniteScrollController");
let aU = EA;
var yu;
const zA = (yu = class {
  constructor(t) {
    t.addController(this), this.host = t, this.whenContext = new Promise((i) => this.resolveContext = i), this.whenObserver = new Promise((i) => this.resolveObserver = i), this.setContext();
  }
  async setContext() {
    await _o(this.host), this.context = new Er(this.host, { context: Pt, subscribe: !0 });
  }
  hostUpdate() {
    var t, i;
    (t = this.context) != null && t.value && ((i = this.resolveContext) == null || i.call(this));
  }
  async trackMutation(t, i) {
    var n, r, a, o;
    if (i || (await this.whenContext, i = (r = (n = this.context) == null ? void 0 : n.value) == null ? void 0 : r.queryClient), !i)
      throw new Error("No QueryClient provided");
    return (a = this.observerUnsubscribe) == null || a.call(this), this.observer && (this.whenObserver = new Promise((l) => this.resolveObserver = l)), this.observer = new Ve(i, { ...t }), this.observerSubscribe(), (o = this.resolveObserver) == null || o.call(this, this.observer), this.observer;
  }
  observerSubscribe() {
    this.observer && (this.result = this.observer.getCurrentResult(), this.observerUnsubscribe ?? (this.observerUnsubscribe = this.observer.subscribe(() => {
      if (this.observer) {
        const t = Lf(this.result, this.observer.getCurrentResult());
        this.result !== t && (this.result = t, this.host.requestUpdate());
      }
    })), this.host.requestUpdate());
  }
  untrackMutation() {
    var t;
    (t = this.observerUnsubscribe) == null || t.call(this), this.observerUnsubscribe = void 0, this.result = void 0, this.observer = void 0, this.host.requestUpdate();
  }
  async mutate(t, i) {
    return (await this.whenObserver).mutate(t, i);
  }
  hostConnected() {
    this.observerSubscribe();
  }
  hostDisconnected() {
    var t;
    (t = this.observerUnsubscribe) == null || t.call(this);
  }
}, u(yu, "zp"), yu);
p(zA, "MutationController");
let cn = zA;
const { I: oU } = aq, b4 = /* @__PURE__ */ p((s, t) => (s == null ? void 0 : s._$litType$) !== void 0, "nt"), lU = /* @__PURE__ */ p((s) => {
  var t;
  return ((t = s == null ? void 0 : s._$litType$) == null ? void 0 : t.h) != null;
}, "ot"), cU = /* @__PURE__ */ p((s) => s.strings === void 0, "rt"), $4 = /* @__PURE__ */ p(() => document.createComment(""), "lt"), ba = /* @__PURE__ */ p((s, t, i) => {
  var n;
  const r = s._$AA.parentNode, a = t === void 0 ? s._$AB : t._$AA;
  if (i === void 0) {
    const o = r.insertBefore($4(), a), l = r.insertBefore($4(), a);
    i = new oU(o, l, s, s.options);
  } else {
    const o = i._$AB.nextSibling, l = i._$AM, c = l !== s;
    if (c) {
      let h;
      (n = i._$AQ) == null || n.call(i, s), i._$AM = s, i._$AP !== void 0 && (h = s._$AU) !== l._$AU && i._$AP(h);
    }
    if (o !== a || c) {
      let h = i._$AA;
      for (; h !== o; ) {
        const d = h.nextSibling;
        r.insertBefore(h, a), h = d;
      }
    }
  }
  return i;
}, "at"), ma = /* @__PURE__ */ p((s, t, i = s) => (s._$AI(t, i), s), "ct"), hU = {}, O1 = /* @__PURE__ */ p((s, t = hU) => s._$AH = t, "dt"), g$ = /* @__PURE__ */ p((s) => s._$AH, "ut"), UO = /* @__PURE__ */ p((s) => {
  var t;
  (t = s._$AP) == null || t.call(s, !1, !0);
  let i = s._$AA;
  const n = s._$AB.nextSibling;
  for (; i !== n; ) {
    const r = i.nextSibling;
    i.remove(), i = r;
  }
}, "pt"), dU = /* @__PURE__ */ p((s) => {
  s._$AR();
}, "ft"), Vf = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, _s = /* @__PURE__ */ p((s) => (...t) => ({ _$litDirective$: s, values: t }), "e$1");
var mu;
const _A = (mu = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, i, n) {
    this.t = t, this._$AM = i, this.i = n;
  }
  _$AS(t, i) {
    return this.update(t, i);
  }
  update(t, i) {
    return this.render(...i);
  }
}, u(mu, "Sp"), mu);
p(_A, "i");
let Yr = _A;
const Yy = /* @__PURE__ */ p((s, t) => {
  var i;
  const n = s._$AN;
  if (n === void 0) return !1;
  for (const r of n) (i = r._$AO) == null || i.call(r, t, !1), Yy(r, t);
  return !0;
}, "mt"), b1 = /* @__PURE__ */ p((s) => {
  let t, i;
  do {
    if ((t = s._$AM) === void 0) break;
    i = t._$AN, i.delete(s), s = t;
  } while ((i == null ? void 0 : i.size) === 0);
}, "_t"), LA = /* @__PURE__ */ p((s) => {
  for (let t; t = s._$AM; s = t) {
    let i = t._$AN;
    if (i === void 0) t._$AN = i = /* @__PURE__ */ new Set();
    else if (i.has(s)) break;
    i.add(s), uU(t);
  }
}, "wt");
function IA(s) {
  this._$AN !== void 0 ? (b1(this), this._$AM = s, LA(this)) : this._$AM = s;
}
u(IA, "Bm");
p(IA, "bt");
function WA(s, t = !1, i = 0) {
  const n = this._$AH, r = this._$AN;
  if (r !== void 0 && r.size !== 0) if (t) if (Array.isArray(n)) for (let a = i; a < n.length; a++) Yy(n[a], !1), b1(n[a]);
  else n != null && (Yy(n, !1), b1(n));
  else Yy(this, s);
}
u(WA, "Um");
p(WA, "yt");
const uU = /* @__PURE__ */ p((s) => {
  s.type == Vf.CHILD && (s._$AP ?? (s._$AP = WA), s._$AQ ?? (s._$AQ = IA));
}, "gt");
var wu;
const VA = (wu = class extends Yr {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, i, n) {
    super._$AT(t, i, n), LA(this), this.isConnected = t._$AU;
  }
  _$AO(t, i = !0) {
    var n, r;
    t !== this.isConnected && (this.isConnected = t, t ? (n = this.reconnected) == null || n.call(this) : (r = this.disconnected) == null || r.call(this)), i && (Yy(this, t), b1(this));
  }
  setValue(t) {
    if (cU(this.t)) this.t._$AI(t, this);
    else {
      const i = [...this.t._$AH];
      i[this.i] = t, this.t._$AI(i, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}, u(wu, "Ep"), wu);
p(VA, "$t");
let pU = VA;
const ke = /* @__PURE__ */ p(() => new fU(), "ii");
var gu;
const ZA = (gu = class {
}, u(gu, "Op"), gu);
p(ZA, "Zt");
let fU = ZA;
const NO = /* @__PURE__ */ new WeakMap(), pe = _s(class extends pU {
  render(s) {
    return M;
  }
  update(s, [t]) {
    var i;
    const n = t !== this.Y;
    return n && this.Y !== void 0 && this.rt(void 0), (n || this.lt !== this.ct) && (this.Y = t, this.ht = (i = s.options) == null ? void 0 : i.host, this.rt(this.ct = s.element)), M;
  }
  rt(s) {
    if (this.isConnected || (s = void 0), typeof this.Y == "function") {
      const t = this.ht ?? globalThis;
      let i = NO.get(t);
      i === void 0 && (i = /* @__PURE__ */ new WeakMap(), NO.set(t, i)), i.get(this.Y) !== void 0 && this.Y.call(this.ht, void 0), i.set(this.Y, s), s !== void 0 && this.Y.call(this.ht, s);
    } else this.Y.value = s;
  }
  get lt() {
    var s, t;
    return typeof this.Y == "function" ? (s = NO.get(this.ht ?? globalThis)) == null ? void 0 : s.get(this.Y) : (t = this.Y) == null ? void 0 : t.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
function DA(s, t) {
  const i = s.queryClient, n = t;
  return {
    mutationKey: n,
    mutationFn: /* @__PURE__ */ p(async ({ optionId: r }) => {
      const a = await s.fetch(`/api/options/${r}/vote`, { method: "POST" });
      if (!a.ok) {
        const o = await a.json();
        throw new Error(o.detail || o.title, { cause: o });
      }
      return a.json();
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => (Se(i, { queryKey: n }, r.parentId, (a) => {
      var o, l;
      (o = a.options) != null && o.data && (a.options.data = (l = a.options.data) == null ? void 0 : l.map((c) => {
        var h, d;
        if (c.has_voted) {
          c.has_voted = !1;
          const f = ((h = c.votes) == null ? void 0 : h.count) || 1;
          c.votes ? c.votes.count = f - 1 : c.votes = { count: f - 1 };
        } else if (!c.has_voted && c.id === r.optionId) {
          c.has_voted = !0;
          const f = ((d = c.votes) == null ? void 0 : d.count) || 0;
          c.votes ? c.votes.count = f + 1 : c.votes = { count: f + 1 };
        }
        return c;
      }));
    }), { id: r.optionId }), "onMutate"),
    onSuccess: /* @__PURE__ */ p(async (r, a) => {
      const o = await (await s.fetch("/api/" + a.parentType + "/" + a.parentId)).json();
      Se(
        i,
        { queryKey: n, exact: !1 },
        a.parentId,
        (l) => Object.assign(l, o)
      );
    }, "onSuccess")
    /*onError(error: Error, variables: MutatePollVariables) {
      updateCacheItems(queryClient, { queryKey: postsKey, exact: false }, variables.id, (existingPost: PostType) => Object.assign(existingPost, { is_subscribed: variables..is_subscribed }));
    },*/
  };
}
u(DA, "Nm");
p(DA, "getPollMutationOptions");
function uv(s, t) {
  return new Ve(s.queryClient, DA(s, t));
}
u(uv, "Vh");
p(uv, "getPollMutation");
function qA(s, t) {
  return {
    queryKey: ["votes", t],
    enabled: !1,
    queryFn: /* @__PURE__ */ p(async () => await (await s.fetch(`/api/options/${t}`)).json(), "queryFn")
  };
}
u(qA, "jm");
p(qA, "getVotesOptions");
const ko = /* @__PURE__ */ p((s, t) => !!(s && t && t.indexOf(s) !== -1), "hasPermission");
function UA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, messageId: i }) => {
      const n = i ? `/api/apps/${t}/mark?messageId=${i}` : `/api/apps/${t}/mark`;
      await s.fetch(n, { method: i ? "PUT" : "DELETE" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      await s.queryClient.cancelQueries({ queryKey: ["apps", t.appId] }), await s.queryClient.cancelQueries({ queryKey: ["apps", "list"], exact: !1 }), await s.queryClient.cancelQueries({ queryKey: ["members", t.appId] }), s.queryClient.setQueryData(
        ["apps", t.appId],
        (i) => i && { ...i, is_unread: !t.messageId || t.messageId < i.last_message.id }
      ), Se(
        s.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        t.appId,
        (i) => {
          i.is_unread = !t.messageId || t.messageId < i.last_message.id;
        }
      ), t.userId && Fe(s.queryClient, ["members", t.appId], t.userId, (i) => {
        t.messageId ? (i.marked_at = (/* @__PURE__ */ new Date()).toISOString(), i.marked_id = t.messageId) : (i.marked_at = void 0, i.marked_id = void 0);
      });
    }, "onMutate"),
    onError: /* @__PURE__ */ p((t, i) => {
      console.error(t.message), Se(
        s.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        i.appId,
        (n) => {
          n.is_unread = !n.is_unread;
        }
      );
    }, "onError"),
    onSettled: /* @__PURE__ */ p((t, i, n) => {
      s.queryClient.invalidateQueries({ queryKey: ["apps", n.appId] }), s.queryClient.invalidateQueries({ queryKey: ["apps", "list"], exact: !1 }), s.queryClient.invalidateQueries({ queryKey: ["members", n.appId] });
    }, "onSettled")
  };
}
u(UA, "Wm");
p(UA, "getMarkConversationMutationOptions");
function NA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, star: i }) => {
      await s.fetch(`/api/apps/${t}/stars`, { method: i ? "POST" : "DELETE" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      Se(
        s.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        t.appId,
        (i) => {
          i.is_starred = t.star;
        }
      );
    }, "onMutate"),
    onError: /* @__PURE__ */ p((t, i) => {
      console.error(t.message), Se(
        s.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        i.appId,
        (n) => {
          n.is_starred = !i.star;
        }
      );
    }, "onError")
  };
}
u(NA, "Qm");
p(NA, "getStarConversationMutationOptions");
function BA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, pin: i }) => {
      await s.fetch(`/api/apps/${t}/pin`, { method: i ? "PUT" : "DELETE" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      Se(
        s.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        t.appId,
        (i) => {
          i.is_pinned = t.pin;
        }
      );
    }, "onMutate"),
    onSettled: /* @__PURE__ */ p(async () => {
      await s.queryClient.invalidateQueries({ queryKey: ["apps"] });
    }, "onSettled")
  };
}
u(BA, "Km");
p(BA, "getPinConversationMutationOptions");
function jA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, members: i }) => {
      await s.fetch(`/api/apps/${t}/members/${i.join(",")}`, { method: "DELETE" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      d5(s.queryClient, ["apps", "list"], t.appId);
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((t, i) => {
      s.queryClient.removeQueries({ queryKey: ["apps", i.appId] }), s.queryClient.removeQueries({ queryKey: ["members", i.appId] });
    }, "onSuccess"),
    onSettled: /* @__PURE__ */ p(() => {
      s.queryClient.invalidateQueries({ queryKey: ["apps"] }), s.queryClient.invalidateQueries({ queryKey: ["members"] });
    }, "onSettled")
  };
}
u(jA, "Gm");
p(jA, "getLeaveConversationMutationOptions");
function XA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, userId: i, access: n }) => {
      await s.fetch(`/api/apps/${t}/members/${i}`, { method: "PUT", body: JSON.stringify({ access: n }) });
    }, "mutationFn"),
    onSettled: /* @__PURE__ */ p((t, i, n) => {
      s.queryClient.invalidateQueries({ queryKey: ["apps"] }), s.queryClient.invalidateQueries({ queryKey: ["members", n.appId] });
    }, "onSettled")
  };
}
u(XA, "Ym");
p(XA, "getUpdateMemberMutationOptions");
function FA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, members: i }) => {
      await s.fetch(`/api/apps/${t}/members`, {
        method: "PUT",
        body: JSON.stringify(
          i.map((n) => ({ id: n, access: "write" }))
        )
      });
    }, "mutationFn"),
    onSettled: /* @__PURE__ */ p((t, i, n) => {
      s.queryClient.invalidateQueries({ queryKey: ["apps"] }), s.queryClient.invalidateQueries({ queryKey: ["members", n.appId] });
    }, "onSettled")
  };
}
u(FA, "Zm");
p(FA, "getAddMembersToConversationMutationOptions");
function HA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t, name: i, blobId: n }) => (await s.fetch(`/api/apps/${t}`, {
      method: "PATCH",
      body: JSON.stringify({
        name: i,
        picture: n
      })
    })).json(), "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      const i = /* @__PURE__ */ p((n) => {
        typeof t.name == "string" && (n.display_name = t.name), typeof (t == null ? void 0 : t.thumbnailUrl) == "string" && (n.avatar_url = t.thumbnailUrl);
      }, "modifyAppItem");
      Fe(s.queryClient, ["apps", t.appId], void 0, i), Se(s.queryClient, { queryKey: ["apps", "list"], exact: !1 }, t.appId, i);
    }, "onMutate")
  };
}
u(HA, "Xm");
p(HA, "getUpdateConversationMutationOptions");
function YA(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ appId: t }) => {
      await s.fetch(`/api/apps/${t}/trash`, { method: "POST" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      d5(s.queryClient, ["apps", "list"], t.appId);
    }, "onMutate"),
    onSettled: /* @__PURE__ */ p(() => {
      s.queryClient.invalidateQueries({ queryKey: ["apps"] });
    }, "onSettled")
  };
}
u(YA, "Jm");
p(YA, "getTrashConversationMutationOptions");
function u5(s) {
  return new Ve(s.queryClient, UA(s));
}
u(u5, "qy");
p(u5, "getMarkConversationMutation");
function GA(s) {
  return new Ve(s.queryClient, NA(s));
}
u(GA, "tv");
p(GA, "getStarConversationMutation");
function KA(s) {
  return new Ve(s.queryClient, BA(s));
}
u(KA, "ev");
p(KA, "getPinConversationMutation");
function p5(s) {
  return new Ve(s.queryClient, jA(s));
}
u(p5, "Ny");
p(p5, "getLeaveConversationMutation");
function JA(s) {
  return new Ve(s.queryClient, XA(s));
}
u(JA, "iv");
p(JA, "getUpdateMemberMutation");
function eE(s) {
  return new Ve(s.queryClient, FA(s));
}
u(eE, "sv");
p(eE, "getAddMembersToConversationMutation");
function f5(s) {
  return new Ve(s.queryClient, HA(s));
}
u(f5, "jy");
p(f5, "getUpdateConversationMutation");
function tE(s) {
  return new Ve(s.queryClient, YA(s));
}
u(tE, "rv");
p(tE, "getTrashConversationMutation");
function iE(s, t, i = [Te.ChatRoom, Te.PrivateChat], n) {
  return ln(s, ["apps", t], void 0, {
    initialData: /* @__PURE__ */ p(() => {
      var r;
      return (r = s == null ? void 0 : s.queryClient.getQueryData(["apps", "list", i, n])) == null ? void 0 : r.pages.flatMap((a) => a.data).find((a) => (a == null ? void 0 : a.id) === t);
    }, "initialData")
  });
}
u(iE, "nv");
p(iE, "getConversationOptions");
function v$(s, t, i = [Te.ChatRoom, Te.PrivateChat], n) {
  return u1(s, ["apps", t], void 0, {
    initialData: /* @__PURE__ */ p(() => {
      var r;
      return (r = s == null ? void 0 : s.queryClient.getQueryData(["apps", "list", i, n])) == null ? void 0 : r.pages.flatMap((a) => a.data).find((a) => (a == null ? void 0 : a.id) === t);
    }, "initialData")
  });
}
u(v$, "du");
p(v$, "getConversation");
async function nE(s, t, i, n) {
  let r;
  if (typeof t == "number")
    r = await v$(s, t, i, n);
  else if (typeof t.id == "number" && !t.type)
    r = await v$(s, t.id, i, n);
  else if (typeof t.type == "string")
    r = t;
  else
    return;
  return i.includes(r.type) ? r : void 0;
}
u(nE, "av");
p(nE, "resolveAppWithType");
var vu;
const sE = (vu = class {
  constructor(t, i) {
    this.additionalTargets = /* @__PURE__ */ new Set(), this.setExportParts = (n) => {
      (!this.host.hasAttribute("exportparts") || this.shadowParts) && (this.shadowParts ?? (this.shadowParts = /* @__PURE__ */ new Set()), n.forEach((r) => {
        var a;
        r.part.forEach((o) => {
          var l;
          return (l = this.shadowParts) == null ? void 0 : l.add(o);
        }), (a = r.getAttribute("exportparts")) == null || a.split(", ").forEach((o) => {
          var l;
          return (l = this.shadowParts) == null ? void 0 : l.add(o);
        });
      }), this.shadowParts.size && this.host.setAttribute("exportparts", Array.from(this.shadowParts.values()).join(", ")));
    }, t.addController(this), this.host = t, this.addLocalName = i;
  }
  addPartsFrom(t) {
    var i;
    t && !this.additionalTargets.has(t) && (this.setExportParts([t]), (i = this.observer) == null || i.observe(t, {
      attributeFilter: ["part", "exportparts"]
    }), this.additionalTargets.add(t));
  }
  async hostConnected() {
    if (await this.host.updateComplete, O0(this.host) && this.host.shadowRoot) {
      const t = Array.from(this.host.shadowRoot.querySelectorAll("[part], [exportparts]"));
      this.setExportParts(t), this.observer = new MutationObserver((i) => {
        const n = i.filter((r) => r.target instanceof Element).map((r) => r.target);
        this.setExportParts(n);
      }), this.observer.observe(this.host.shadowRoot, {
        subtree: !0,
        childList: !0,
        attributeFilter: ["part", "exportparts"]
      }), Array.from(this.additionalTargets).forEach((i) => {
        var n;
        (n = this.observer) == null || n.observe(i, {
          attributeFilter: ["part", "exportparts"]
        });
      });
    }
  }
  hostUpdated() {
    O0(this.host) && this.addLocalName !== !1 && !this.host.part.contains(this.host.localName) && (this.addLocalName || getComputedStyle(this.host).display !== "contents") && this.host.part.add(this.host.localName);
  }
  hostDisconnected() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
}, u(vu, "Ap"), vu);
p(sE, "ShadowPartsController");
let ae = sE;
function y5(s, t, i) {
  return {
    queryKey: ["members", t],
    queryFn: /* @__PURE__ */ p(async () => await (await s.fetch("/api/apps/" + t + "/members")).json(), "queryFn"),
    ...i
  };
}
u(y5, "Wy");
p(y5, "getMemberOptions");
function rE(s, t, i, n) {
  return {
    queryKey: ["searchmembers"],
    initialPageParam: 0,
    enabled: !0,
    queryFn: /* @__PURE__ */ p(async (r) => {
      const a = t(), o = r.pageParam;
      let l;
      i ? l = await s.fetch(`/api/apps/${i}/members?member=false&q=${a}&skip=${o}${n() !== void 0 ? `&bot=${!!n()}` : ""}`) : l = await s.fetch(`/api/users?q=${a}&skip=${o}${n() !== void 0 ? `&bot=${!!n()}` : ""}`);
      const c = await l.json();
      return c.data = c.data || [], c;
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((r) => {
      if (r.end && r.end < r.count)
        return r.end;
    }, "getNextPageParam")
  };
}
u(rE, "ov");
p(rE, "getInfiniteSearchMemberOptions");
const Do = de`[part~=wy-pager]{position:relative;align-self:center;justify-self:center}[part~=wy-pager-bottom]{width:16px;height:256px;max-height:100%;margin-top:-256px;margin-inline:auto;pointer-events:none}[part~=wy-pager-top]{width:16px;height:256px;max-height:100%;margin-bottom:-256px;margin-inline:auto;pointer-events:none}`;
var yU = "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M1,10V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z", mU = "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z", wU = "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z", gU = "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", vU = "M13 13H11V7H13M11 15H13V17H11M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3Z", x4 = "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z", OU = "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z", aE = "M7.5,18A5.5,5.5 0 0,1 2,12.5A5.5,5.5 0 0,1 7.5,7H18A4,4 0 0,1 22,11A4,4 0 0,1 18,15H9.5A2.5,2.5 0 0,1 7,12.5A2.5,2.5 0 0,1 9.5,10H17V11.5H9.5A1,1 0 0,0 8.5,12.5A1,1 0 0,0 9.5,13.5H18A2.5,2.5 0 0,0 20.5,11A2.5,2.5 0 0,0 18,8.5H7.5A4,4 0 0,0 3.5,12.5A4,4 0 0,0 7.5,16.5H17V18H7.5Z", bU = "M12,3A9,9 0 0,0 3,12H0L4,16L8,12H5A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19C10.5,19 9.09,18.5 7.94,17.7L6.5,19.14C8.04,20.3 9.94,21 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M14,12A2,2 0 0,0 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12Z", oE = "M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21", lE = "M20.84,22.73L18.11,20H3V19L5,17V11C5,9.86 5.29,8.73 5.83,7.72L1.11,3L2.39,1.73L22.11,21.46L20.84,22.73M19,15.8V11C19,7.9 16.97,5.17 14,4.29C14,4.19 14,4.1 14,4A2,2 0 0,0 12,2A2,2 0 0,0 10,4C10,4.1 10,4.19 10,4.29C9.39,4.47 8.8,4.74 8.26,5.09L19,15.8M12,23A2,2 0 0,0 14,21H10A2,2 0 0,0 12,23Z", $U = "M15.39,14.04V14.04C15.39,12.62 14.24,11.47 12.82,11.47C11.41,11.47 10.26,12.62 10.26,14.04V14.04C10.26,15.45 11.41,16.6 12.82,16.6C14.24,16.6 15.39,15.45 15.39,14.04M17.1,14.04C17.1,16.4 15.18,18.31 12.82,18.31C11.19,18.31 9.77,17.39 9.05,16.04C8.33,17.39 6.91,18.31 5.28,18.31C2.94,18.31 1.04,16.43 1,14.11V14.11H1V7H1V7C1,6.56 1.39,6.18 1.86,6.18C2.33,6.18 2.7,6.56 2.71,7V7H2.71V10.62C3.43,10.08 4.32,9.76 5.28,9.76C6.91,9.76 8.33,10.68 9.05,12.03C9.77,10.68 11.19,9.76 12.82,9.76C15.18,9.76 17.1,11.68 17.1,14.04V14.04M7.84,14.04V14.04C7.84,12.62 6.69,11.47 5.28,11.47C3.86,11.47 2.71,12.62 2.71,14.04V14.04C2.71,15.45 3.86,16.6 5.28,16.6C6.69,16.6 7.84,15.45 7.84,14.04M22.84,16.96V16.96C22.95,17.12 23,17.3 23,17.47C23,17.73 22.88,18 22.66,18.15C22.5,18.26 22.33,18.32 22.15,18.32C21.9,18.32 21.65,18.21 21.5,18L19.59,15.47L17.7,18V18C17.53,18.21 17.28,18.32 17.03,18.32C16.85,18.32 16.67,18.26 16.5,18.15C16.29,18 16.17,17.72 16.17,17.46C16.17,17.29 16.23,17.11 16.33,16.96V16.96H16.33V16.96L18.5,14.04L16.33,11.11V11.11H16.33V11.11C16.22,10.96 16.17,10.79 16.17,10.61C16.17,10.35 16.29,10.1 16.5,9.93C16.89,9.65 17.41,9.72 17.7,10.09V10.09L19.59,12.61L21.5,10.09C21.76,9.72 22.29,9.65 22.66,9.93C22.89,10.1 23,10.36 23,10.63C23,10.8 22.95,10.97 22.84,11.11V11.11H22.84V11.11L20.66,14.04L22.84,16.96V16.96H22.84Z", xU = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 17H7V10H9V17M13 17H11V7H13V17M17 17H15V13H17V17Z", BO = "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z", kU = "M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z", SU = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z", PU = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z", CU = "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z", QU = "M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z", TU = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", MU = "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z", RU = "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z", AU = "M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20Z", EU = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9Z", zU = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10Z", _U = "M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z", LU = "M13,19A1,1 0 0,0 14,20H16V22H13.5C12.95,22 12,21.55 12,21C12,21.55 11.05,22 10.5,22H8V20H10A1,1 0 0,0 11,19V5A1,1 0 0,0 10,4H8V2H10.5C11.05,2 12,2.45 12,3C12,2.45 12.95,2 13.5,2H16V4H14A1,1 0 0,0 13,5V19Z", cE = "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z", hE = "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8.46,11.88L9.87,10.47L12,12.59L14.12,10.47L15.53,11.88L13.41,14L15.53,16.12L14.12,17.53L12,15.41L9.88,17.53L8.47,16.12L10.59,14L8.46,11.88M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z", IU = "M14,14H16L12,10L8,14H10V18H14V14M6,7H18V19C18,19.5 17.8,20 17.39,20.39C17,20.8 16.5,21 16,21H8C7.5,21 7,20.8 6.61,20.39C6.2,20 6,19.5 6,19V7M19,4V6H5V4H8.5L9.5,3H14.5L15.5,4H19Z", WU = "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z", VU = "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z", ZU = "M3 6.2L8 9.39L13 6.2L8 3L3 6.2M13 6.2L18 9.39L23 6.2L18 3L13 6.2M3 12.55L8 15.74L13 12.55L8 9.35L3 12.55M18 9.35L13 12.55L18 15.74L23 12.55L18 9.35M8.03 16.8L13.04 20L18.04 16.8L13.04 13.61L8.03 16.8Z", DU = "M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", qU = "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z", UU = "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z", k4 = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6.12,15.5L9.86,19.24L11.28,17.83L8.95,15.5L11.28,13.17L9.86,11.76L6.12,15.5M17.28,15.5L13.54,11.76L12.12,13.17L14.45,15.5L12.12,17.83L13.54,19.24L17.28,15.5Z", S4 = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z", NU = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z", BU = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6,20H15L18,20V12L14,16L12,14L6,20M8,9A2,2 0 0,0 6,11A2,2 0 0,0 8,13A2,2 0 0,0 10,11A2,2 0 0,0 8,9Z", jU = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,13H11V18A2,2 0 0,1 9,20A2,2 0 0,1 7,18A2,2 0 0,1 9,16C9.4,16 9.7,16.1 10,16.3V11H13V13M13,9V3.5L18.5,9H13Z", XU = "M12.6,12.3H10.6V15.5H12.7C13.3,15.5 13.6,15.3 13.9,15C14.2,14.7 14.3,14.4 14.3,13.9C14.3,13.4 14.2,13.1 13.9,12.8C13.6,12.5 13.2,12.3 12.6,12.3M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.2,16C14.6,16.5 14.1,16.7 12.8,16.7H10.6V20H9V11H12.8C14.1,11 14.7,11.3 15.2,11.8C15.8,12.4 16,13 16,13.9C16,14.8 15.8,15.5 15.2,16M13,9V3.5L18.5,9H13Z", FU = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13.5,16V19H10.5V16H8L12,12L16,16H13.5M13,9V3.5L18.5,9H13Z", HU = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M17,19V13L14,15.2V13H7V19H14V16.8L17,19Z", YU = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.2,20H13.8L12,13.2L10.2,20H8.8L6.6,11H8.1L9.5,17.8L11.3,11H12.6L14.4,17.8L15.8,11H17.3L15.2,20M13,9V3.5L18.5,9H13Z", GU = "M20,2H4C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2M12,4L15,7H13V9H11V7H9M7,15L4,12L7,9V11H9V13H7M12,20L9,17H11V15H13V17H15M17,15V13H15V11H17V9L20,12", KU = "M17 4H20C21.1 4 22 4.9 22 6V8H20V6H17V4M4 8V6H7V4H4C2.9 4 2 4.9 2 6V8H4M20 16V18H17V20H20C21.1 20 22 19.1 22 18V16H20M7 18H4V16H2V18C2 19.1 2.9 20 4 20H7V18M18 8H6V16H18V8Z", JU = "M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M18 12H16V14H18V16H16V18H14V16H16V14H14V12H16V10H14V8H16V10H18V12Z", eN = "M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z", tN = "M7.71,3.5L1.15,15L4.58,21L11.13,9.5M9.73,15L6.3,21H19.42L22.85,15M22.28,14L15.42,2H8.58L8.57,2L15.43,14H22.28Z", iN = "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z", nN = "M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3A9,9 0 0,0 4,12H1L4.96,16.03L9,12H6A7,7 0 0,1 13,5A7,7 0 0,1 20,12A7,7 0 0,1 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21A9,9 0 0,0 22,12A9,9 0 0,0 13,3", sN = "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z", rN = "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z", aN = "M17,17H7V7H17M21,11V9H19V7C19,5.89 18.1,5 17,5H15V3H13V5H11V3H9V5H7C5.89,5 5,5.89 5,7V9H3V11H5V13H3V15H5V17A2,2 0 0,0 7,19H9V21H11V19H13V21H15V19H17A2,2 0 0,0 19,17V15H21V13H19V11M13,13H11V11H13M15,9H9V15H15V9Z", oN = "M7,10L12,15L17,10H7Z", lN = "M7,15L12,10L17,15H7Z", cN = "M18.21 10.29Q19 10.34 19.7 10.68 20.39 11 20.9 11.57 21.41 12.12 21.71 12.83 22 13.54 22 14.34 22 15.18 21.68 15.92 21.36 16.66 20.8 17.21 20.25 17.76 19.5 18.08 18.78 18.41 17.94 18.41H7Q5.97 18.41 5.06 18 4.15 17.61 3.47 16.94 2.79 16.26 2.4 15.35 2 14.44 2 13.41 2 12.59 2.26 11.83 2.5 11.08 3 10.45 3.44 9.82 4.08 9.35 4.72 8.88 5.5 8.63 5.87 8.5 6.21 8.5 6.56 8.43 6.93 8.41H6.94Q7.37 7.75 7.95 7.23 8.5 6.71 9.2 6.34 9.87 6 10.62 5.78 11.37 5.59 12.16 5.59 13.22 5.59 14.2 5.94 15.18 6.29 16 6.91 16.8 7.53 17.37 8.39 17.95 9.26 18.21 10.29M12.16 6.84Q11.05 6.84 10.06 7.3 9.06 7.75 8.36 8.6 8.73 8.7 9.07 8.85 9.4 9 9.73 9.2L13.71 11.58L16 10.62Q16.21 10.53 16.44 10.45 16.67 10.38 16.92 10.33 16.68 9.55 16.21 8.91 15.74 8.27 15.11 7.81 14.5 7.35 13.73 7.1 13 6.84 12.16 6.84M4 15.66L12.27 12.18L9.08 10.26Q8.59 9.97 8.06 9.81 7.5 9.66 6.95 9.66 6.19 9.66 5.5 9.96 4.84 10.26 4.34 10.77 3.84 11.29 3.54 11.97 3.25 12.65 3.25 13.41 3.25 14 3.45 14.59 3.64 15.19 4 15.66M17.94 17.16Q18.41 17.16 18.84 17 19.27 16.86 19.64 16.58L13.61 13L5.03 16.59Q5.47 16.86 5.97 17 6.47 17.16 7 17.16M20.45 15.61Q20.75 15 20.75 14.34 20.75 13.7 20.5 13.17 20.26 12.65 19.85 12.28 19.43 11.91 18.88 11.71 18.32 11.5 17.7 11.5 17.35 11.5 17 11.6 16.66 11.68 16.33 11.81 16 11.93 15.67 12.08 15.35 12.23 15.04 12.37Z", hN = "M19,13H5V11H19V13Z", dN = "M21 2C22.05 2 22.92 2.81 23 3.85L23 4V16C23 17.05 22.18 17.92 21.15 18L21 18H14V20H16V22H8V20H10V18H3C1.95 18 1.08 17.18 1 16.15L1 16V4C1 2.94 1.81 2.08 2.85 2L3 2H21M21 4H3V16H21V4M12 11C14.21 11 16 11.9 16 13V14H8V13C8 11.9 9.79 11 12 11M12 6C13.11 6 14 6.9 14 8S13.11 10 12 10 10 9.11 10 8 10.9 6 12 6Z", uN = "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z", O$ = "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z", pN = "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z", fN = "M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z", dE = "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z", yN = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z", uE = "M13,3A9,9 0 0,0 4,12H1L4.89,15.89L4.96,16.03L9,12H6A7,7 0 0,1 13,5A7,7 0 0,1 20,12A7,7 0 0,1 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21A9,9 0 0,0 22,12A9,9 0 0,0 13,3Z", mN = "M4,3H5V5H3V4A1,1 0 0,1 4,3M20,3A1,1 0 0,1 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M21,20A1,1 0 0,1 20,21H19V19H21V20M15,21V19H17V21H15M11,21V19H13V21H11M7,21V19H9V21H7M4,21A1,1 0 0,1 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M3,7H5V9H3V7M21,7V9H19V7H21Z", wN = "M2,21L23,12L2,3V10L17,12L2,14V21Z", gN = "M13,19H14A1,1 0 0,1 15,20H15.73L13,17.27V19M22,20V21.18L20.82,20H22M21,22.72L19.73,24L17.73,22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H4A1,1 0 0,1 3,16V12A1,1 0 0,1 4,11H6.73L4.73,9H4A1,1 0 0,1 3,8V7.27L1,5.27L2.28,4L21,22.72M4,3H20A1,1 0 0,1 21,4V8A1,1 0 0,1 20,9H9.82L7,6.18V5H5.82L3.84,3C3.89,3 3.94,3 4,3M20,11A1,1 0 0,1 21,12V16A1,1 0 0,1 20,17H17.82L11.82,11H20M9,7H10V5H9V7M9,15H10V14.27L9,13.27V15M5,13V15H7V13H5Z", vN = "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M15.08 16L12 14.15L8.93 16L9.74 12.5L7.03 10.16L10.61 9.85L12 6.55L13.39 9.84L16.97 10.15L14.26 12.5L15.08 16Z", ON = "M21 11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5V11M12 21C15.75 20 19 15.54 19 11.22V6.3L12 3.18L5 6.3V11.22C5 15.54 8.25 20 12 21M15.05 16L11.97 14.15L8.9 16L9.71 12.5L7 10.16L10.58 9.85L11.97 6.55L13.37 9.84L16.95 10.15L14.23 12.5L15.05 16", bN = "M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z", $N = "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z", xN = "M20.8 22.7L17.9 19.8L18.2 21L12 17.3L5.8 21L7.4 14L2 9.2L6.9 8.8L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M22 9.2L14.8 8.6L12 2L10 6.8L16.9 13.7L22 9.2Z", kN = "M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z", SN = "M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z", PN = "M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19A2,2 0 0,0 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z", CN = "M5,9V21H1V9H5M9,21A2,2 0 0,1 7,19V9C7,8.45 7.22,7.95 7.59,7.59L14.17,1L15.23,2.06C15.5,2.33 15.67,2.7 15.67,3.11L15.64,3.43L14.69,8H21C22.11,8 23,8.9 23,10V12C23,12.26 22.95,12.5 22.86,12.73L19.84,19.78C19.54,20.5 18.83,21 18,21H9M9,19H18.03L21,12V10H12.21L13.34,4.68L9,9.03V19Z", QN = "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z", TN = "M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z", MN = "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z", RN = "M3 5V19H20V5H3M7 7V9H5V7H7M5 13V11H7V13H5M5 15H7V17H5V15M18 17H9V15H18V17M18 13H9V11H18V13M18 9H9V7H18V9Z", AN = "M4 5V18H21V5H4M14 7V10.5H11V7H14M6 7H9V10.5H6V7M6 16V12.5H9V16H6M11 16V12.5H14V16H11M19 16H16V12.5H19V16M16 10.5V7H19V10.5H16Z", EN = "M2.28,3L1,4.27L2.47,5.74C2.04,6 1.61,6.29 1.2,6.6L3,9C3.53,8.6 4.08,8.25 4.66,7.93L6.89,10.16C6.15,10.5 5.44,10.91 4.8,11.4L6.6,13.8C7.38,13.22 8.26,12.77 9.2,12.47L11.75,15C10.5,15.07 9.34,15.5 8.4,16.2L12,21L14.46,17.73L17.74,21L19,19.72M12,3C9.85,3 7.8,3.38 5.9,4.07L8.29,6.47C9.5,6.16 10.72,6 12,6C15.38,6 18.5,7.11 21,9L22.8,6.6C19.79,4.34 16.06,3 12,3M12,9C11.62,9 11.25,9 10.88,9.05L14.07,12.25C15.29,12.53 16.43,13.07 17.4,13.8L19.2,11.4C17.2,9.89 14.7,9 12,9Z";
const P4 = mN, C4 = {
  "zoom-meetings": '<path d="M21.5 12.5c0 .96-.08 1.91-.23 2.83a7.198 7.198 0 01-5.95 5.95 17.527 17.527 0 01-5.66 0 7.198 7.198 0 01-5.95-5.95 17.527 17.527 0 010-5.66c.49-3.05 2.9-5.46 5.95-5.95a17.527 17.527 0 015.66 0c3.05.49 5.46 2.9 5.95 5.95.15.92.23 1.86.23 2.83z" fill="#0b5cff"/><path d="M14.43 14.75c0 .53-.43.96-.96.96H9.29c-1.07 0-1.93-.86-1.93-1.93v-3.54c0-.53.43-.96.96-.96h4.18c1.07 0 1.93.86 1.93 1.93v3.54zM16.87 9.86l-1.41 1.06c-.24.18-.39.47-.39.77v1.61c0 .3.14.59.39.77l1.41 1.06c.32.24.77.01.77-.39v-4.5c0-.4-.45-.62-.77-.39z" fill="#fff"/>',
  "google-meet": '<path fill="#1e88e5" d="M3.5 9.07v5.86l2.09.42 2.1-.42V9.07l-2.1-.42-2.09.42z"/><path d="M17.73 12v5.86c0 .69-.56 1.26-1.26 1.26H7.69l-.42-2.09.42-2.09h5.86v-2.93l2.09-.42 2.09.42z" fill="#4caf50"/><path d="M17.73 6.14V12h-4.19V9.07H7.68l-.42-2.09.42-2.09h8.79c.69 0 1.26.56 1.26 1.26z" fill="#fbc02d"/><path d="M7.69 14.93v4.19H4.76c-.69 0-1.26-.56-1.26-1.26v-2.93h4.19z" fill="#1565c0"/><path fill="#e53935" d="M7.69 4.88v4.19H3.5l4.19-4.19z"/><path fill="#2e7d32" d="M18.15 12l-.42 3.54L13.55 12l4.18-3.54.42 3.54z"/><path d="M21.5 6.19v11.63c0 .35-.41.55-.68.33l-3.09-2.6V8.48l3.09-2.6c.27-.22.68-.03.68.33z" fill="#4caf50"/>',
  "webex-meetings": '<defs><radialGradient id="prefix__b" cx="-951.63" cy="549.04" fx="-951.63" fy="549.04" r=".05" gradientTransform="matrix(-87.16473 -146.04628 -122.52671 73.12756 -15652.44 -179117.85)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#007383"/><stop offset=".41" stop-color="#00717e" stop-opacity=".75"/><stop offset=".87" stop-color="#007281" stop-opacity="0"/></radialGradient><radialGradient id="prefix__c" cx="-952.67" cy="549.07" fx="-952.67" fy="549.07" r=".05" gradientTransform="rotate(-126.7 -53497.341 -58162.752) scale(138.69 -91.09)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#218970"/><stop offset=".46" stop-color="#267e6a"/><stop offset="1" stop-color="#026c51" stop-opacity="0"/></radialGradient><radialGradient id="prefix__d" cx="-952.61" cy="541.2" fx="-952.61" fy="541.2" r=".05" gradientTransform="matrix(-33.8827 -107.79009 -56.09397 17.63256 -1902.72 -112216.84)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#178697"/><stop offset=".41" stop-color="#17838f" stop-opacity=".79"/><stop offset=".87" stop-color="#007281" stop-opacity="0"/></radialGradient><radialGradient id="prefix__e" cx="-949.76" cy="547.24" fx="-949.76" fy="547.24" r=".05" gradientTransform="matrix(-146.98086 -246.36712 -75.94201 45.30646 -98045.43 -258761.67)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#25342f" stop-opacity=".3"/><stop offset="1" stop-color="#25342f" stop-opacity="0"/></radialGradient><radialGradient id="prefix__f" cx="-942.87" cy="563.62" fx="-942.87" fy="563.62" r=".05" gradientTransform="rotate(85.1 -69752.427 38265.017) scale(108.08 -61.22)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#056d4f"/><stop offset=".23" stop-color="#056c4e" stop-opacity=".75"/><stop offset=".6" stop-color="#056c4e" stop-opacity=".3"/><stop offset=".87" stop-color="#056c4f" stop-opacity="0"/></radialGradient><radialGradient id="prefix__g" cx="-940.36" cy="556.77" fx="-940.36" fy="556.77" r=".05" gradientTransform="matrix(68.96997 106.65216 55.9082 -36.1548 33735.1 120422.29)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#22b67b"/><stop offset=".41" stop-color="#24be82"/><stop offset="1" stop-color="#24be82" stop-opacity=".07"/></radialGradient><radialGradient id="prefix__i" cx="-940.77" cy="554.96" fx="-940.77" fy="554.96" r=".05" gradientTransform="rotate(49.69 -177135.555 122596.9) scale(165.85 -165.4)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#09f8ff"/><stop offset="1" stop-color="#0bf7f9" stop-opacity="0"/></radialGradient><radialGradient id="prefix__j" cx="-944.1" cy="553.18" fx="-944.1" fy="553.18" r=".05" gradientTransform="rotate(48.05 -367132.581 263331.898) scale(336.36 -335.78)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00b8ff"/><stop offset=".75" stop-color="#00b9fc" stop-opacity="0"/></radialGradient><radialGradient id="prefix__k" cx="-951.17" cy="546.23" fx="-951.17" fy="546.23" r=".05" gradientTransform="matrix(-48.64247 -154.74493 -107.10322 33.66679 12252.88 -165563.53)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00bcff" stop-opacity=".76"/><stop offset=".57" stop-color="#00bafc" stop-opacity="0"/></radialGradient><radialGradient id="prefix__l" cx="-953.78" cy="550.07" fx="-953.78" fy="550.07" r=".05" gradientTransform="matrix(-72.9418 -88.45403 -61.91396 51.05608 -35502.54 -112443.2)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#5fec50"/><stop offset="1" stop-color="#3cc08e" stop-opacity="0"/></radialGradient><radialGradient id="prefix__m" cx="-954.59" cy="523.18" fx="-954.59" fy="523.18" r=".05" gradientTransform="rotate(-79.11 -8961.313 -26349.067) scale(34.73 -23.99)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#28855b"/><stop offset="1" stop-color="#14795c" stop-opacity="0"/></radialGradient><radialGradient id="prefix__n" cx="-955.7" cy="534.72" fx="-955.7" fy="534.72" r=".05" gradientTransform="matrix(6.00138 -27.99393 -39.07222 -8.37636 26647.75 -22260.21)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#28855b"/><stop offset="1" stop-color="#14795c" stop-opacity="0"/></radialGradient><radialGradient id="prefix__o" cx="-954.99" cy="550.19" fx="-954.99" fy="550.19" r=".05" gradientTransform="matrix(-64.43177 -69.7019 -48.95728 45.25565 -34575.21 -91452.74)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#5ff05b"/><stop offset=".81" stop-color="#5de955" stop-opacity="0"/></radialGradient><radialGradient id="prefix__p" cx="-938.28" cy="553.05" fx="-938.28" fy="553.05" r=".05" gradientTransform="matrix(66.96005 51.3617 71.4219 -93.11248 23342.15 99701.75)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".97" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__q" cx="-940.1" cy="550.5" fx="-940.1" fy="550.5" r=".05" gradientTransform="matrix(98.43675 14.71147 21.98813 -147.126 80455.97 94829.3)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".59" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__r" cx="-938.38" cy="551.97" fx="-938.38" fy="551.97" r=".05" gradientTransform="rotate(24.69 -231174.852 140478.806) scale(85.04 -151.66)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".76" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__s" cx="-945.2" cy="560.82" fx="-945.2" fy="560.82" r=".05" gradientTransform="rotate(95.79 -93552.04 41883.384) scale(153.04 -83.75)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".59" stop-color="#123aa8" stop-opacity="0"/><stop offset="1" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__t" cx="-945.05" cy="562.66" fx="-945.05" fy="562.66" r=".05" gradientTransform="rotate(93.66 -104350.43 63182.76) scale(184.18 -65.64)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".88" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__u" cx="-942.29" cy="567.94" fx="-942.29" fy="567.94" r=".05" gradientTransform="matrix(8.78957 97.33394 51.50044 -4.65066 -20951.98 94373.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".88" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__v" cx="-942.85" cy="562.23" fx="-942.85" fy="562.23" r=".05" gradientTransform="matrix(4.89377 101.88254 84.00315 -4.03496 -42611.94 98338.06)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".88" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__w" cx="-941.74" cy="549.74" fx="-941.74" fy="549.74" r=".05" gradientTransform="rotate(-23.2 244205.91 -321749.854) scale(113.62 -222.29)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#123aa8"/><stop offset=".71" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__x" cx="-959.91" cy="553.32" fx="-959.91" fy="553.32" r=".05" gradientTransform="matrix(-70.50332 -26.36011 -45.18376 120.84945 -42670.87 -92159.05)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1a3da0"/><stop offset=".71" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__y" cx="-940.3" cy="551.63" fx="-940.3" fy="551.63" r=".05" gradientTransform="matrix(137.44492 41.41855 41.86 -138.90985 106154.62 115588.85)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1e3882"/><stop offset=".76" stop-color="#123aa8" stop-opacity="0"/></radialGradient><radialGradient id="prefix__A" cx="-940.77" cy="554.96" fx="-940.77" fy="554.96" r=".05" gradientTransform="rotate(49.69 -177135.55 122596.884) scale(165.85 -165.4)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#09f8ff"/><stop offset="1" stop-color="#0bf7f9" stop-opacity="0"/></radialGradient><radialGradient id="prefix__D" cx="-951.17" cy="546.23" fx="-951.17" fy="546.23" r=".05" gradientTransform="matrix(-48.64247 -154.74493 -107.10322 33.66679 12252.88 -165563.53)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00bcff" stop-opacity=".76"/><stop offset=".57" stop-color="#00bafc" stop-opacity="0"/></radialGradient><linearGradient id="prefix__a" x1="76.14" y1="-95.89" x2="64.37" y2="-99.75" gradientTransform="matrix(1 0 0 -1 -58.17 -86.5)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#5cee64"/><stop offset="1" stop-color="#0bf"/></linearGradient><linearGradient id="prefix__h" x1="56.74" y1="-98.36" x2="65.09" y2="-98.43" gradientTransform="matrix(1 0 0 -1 -58.17 -86.5)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#09f8ff"/><stop offset="1" stop-color="#0bf7f9" stop-opacity="0"/></linearGradient><linearGradient id="prefix__z" x1="61.48" y1="-92.95" x2="67.9" y2="-97.04" gradientTransform="matrix(1 0 0 -1 -58.17 -86.5)" gradientUnits="userSpaceOnUse"><stop offset=".23" stop-color="#1dc4ff"/><stop offset="1" stop-color="#1cc1ff" stop-opacity="0"/></linearGradient><linearGradient id="prefix__B" x1="63.13" y1="-92.11" x2="64.93" y2="-93.74" gradientTransform="matrix(1 0 0 -1 -58.17 -86.5)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#26fbff"/><stop offset=".64" stop-color="#0bf7f9" stop-opacity="0"/></linearGradient><linearGradient id="prefix__C" x1="60.36" y1="-97.78" x2="62.85" y2="-97.95" gradientTransform="matrix(1 0 0 -1 -58.17 -86.5)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#26fbff"/><stop offset=".64" stop-color="#0bf7f9" stop-opacity="0"/></linearGradient></defs><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__a)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__b)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__c)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__d)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__e)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__f)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__g)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__h)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__i)"/><path d="M15.37 5.44c-1.34 0-2.88.45-3.9 2.4-.59 1.12-.89 2.38-1.16 3.63-.09.41-.18.83-.28 1.22v5.66c.51-.14 1.05-.42 1.57-.95 1.96-1.99 2.28-7.2 3.26-8.19.11-.11.23-.18.36-.18.39 0 .7.5.99 1.1.32.67.71 1.43 1.84 1.43.52 0 1.72-.38 1.72-1.85 0-.88-1.47-4.28-4.39-4.28z" fill="url(#prefix__j)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__k)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__l)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__m)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__n)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__o)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="#316aff"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__p)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__q)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__r)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__s)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__t)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__u)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__v)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__w)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__x)"/><path d="M19.22 7.44c-.13 0-.26.01-.39.04.62.89.93 1.83.93 2.23 0 1.47-1.2 1.85-1.72 1.85-.41 0-.71-.1-.96-.25v.03c-.07.29-.13.61-.23.92-.19.6-.45 1.28-.73 1.81-.3.57-.59.9-.94.89-.4-.02-.72-.54-1.13-1.99-.13-.47-.25-.98-.36-1.49-.28-1.25-.62-2.52-1.2-3.63-.95-1.82-2.56-2.4-3.85-2.4-1.2 0-2.09.57-2.79 1.28-.19.2-.41.46-.62.78.61.15 1.19.61 1.28 1.48.02.17.15 1.49.58 3.03.12-.38.3-.95.72-1.88.2-.42.39-.7.56-.87.15-.16.29-.22.41-.22.13 0 .59.12 1.03 1.68.55 1.93.96 5.01 2.52 6.65.69.72 1.65 1.19 2.99 1.19 1.17 0 2.15-.52 2.84-1.24 1.14-1.18 1.77-3.14 2-3.86.64-2.06.82-3.92.84-4.11.12-1.12-.83-1.91-1.77-1.91z" fill="url(#prefix__y)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__z)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__A)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__B)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__C)"/><path d="M8.59 18.51c-3.33 0-4.47-4.22-4.72-5.04-.64-2.06-.83-3.92-.85-4.11-.12-1.12.78-1.91 1.77-1.91.75 0 1.62.45 1.73 1.54.02.18.17 1.76.71 3.48.56 1.8 1.16 2.49 1.59 2.49.69 0 1.12-1.78 1.49-3.48.28-1.25.57-2.51 1.16-3.63 1.02-1.95 2.57-2.4 3.9-2.4 2.93 0 4.39 3.4 4.39 4.28 0 1.47-1.2 1.85-1.72 1.85-1.14 0-1.52-.76-1.84-1.43-.29-.6-.6-1.1-.99-1.1-.13 0-.25.07-.36.18-.98 1-1.31 6.2-3.26 8.19-1.08 1.1-2.26 1.1-3 1.1z" fill="url(#prefix__D)"/>',
  "microsoft-teams": '<path d="M15.56 9.91h4.65c.44 0 .8.36.8.8v4.24c0 1.61-1.31 2.92-2.92 2.92h-.01c-1.61 0-2.92-1.31-2.92-2.92v-4.62c0-.23.19-.42.42-.42z" fill="#5059c9"/><circle cx="18.7" cy="7.19" r="1.88" fill="#5059c9"/><circle cx="12.84" cy="6.35" r="2.72" fill="#7b83eb"/><path d="M16.47 9.91H8.8a.79.79 0 00-.77.8v4.83c-.06 2.6 2 4.77 4.6 4.83 2.6-.06 4.67-2.23 4.6-4.83v-4.83a.783.783 0 00-.77-.8z" fill="#7b83eb"/><path d="M3.77 7.4h7.67c.42 0 .77.34.77.77v7.67c0 .42-.34.77-.77.77H3.77a.77.77 0 01-.77-.77V8.17c0-.42.34-.77.77-.77z" fill="#5a62c3"/><path d="M9.62 10.32H8.09v4.18h-.98v-4.18H5.58v-.81h4.04v.81z" fill="#fff"/>'
}, Q4 = {
  "account-minus": yU,
  "account-plus": mU,
  alert: wU,
  "alert-circle": gU,
  "alert-octagon": vU,
  attachment: aE,
  back: x4,
  "backup-restore": bU,
  bell: oE,
  "bell-off": lE,
  bot: aN,
  check: BO,
  "check-all": kU,
  "check-circle-outline": PU,
  "checkbox-blank": CU,
  "checkbox-marked": QU,
  "circle-outline": TU,
  "check-circle": SU,
  close: MU,
  "close-circle": RU,
  comment: EU,
  "comment-outline": zU,
  "content-save": _U,
  delete: cE,
  "delete-restore": IU,
  "delete-forever": hE,
  "dots-vertical": WU,
  download: VU,
  earth: DU,
  "emoticon-plus": "M 19 0 L 19 3 L 16 3 L 16 5 L 19 5 L 19 8 L 21 8 L 21 5 L 24 5 L 24 3 L 21 3 L 21 0 L 19 0 z M 12 2 C 6.5 2 2 6.5 2 12 C 2 17.5 6.5 22 12 22 C 17.5 22 22 17.5 22 12 L 20 12 C 20 16.4 16.4 20 12 20 C 7.6 20 4 16.4 4 12 C 4 7.6 7.6 4 12 4 L 12 2 z M 8.5 8 C 7.7 8 7 8.7 7 9.5 C 7 10.3 7.7 11 8.5 11 C 9.3 11 10 10.3 10 9.5 C 10 8.7 9.3 8 8.5 8 z M 15.5 8 C 14.7 8 14 8.7 14 9.5 C 14 10.3 14.7 11 15.5 11 C 16.3 11 17 10.3 17 9.5 C 17 8.7 16.3 8 15.5 8 z M 6.9 14 C 7.7 16 9.7 17.5 12 17.5 C 14.3 17.5 16.3 16 17.1 14 L 6.9 14 z",
  "fit-screen": KU,
  "fit-width": GU,
  "help-circle": iN,
  information: sN,
  magnify: rN,
  "menu-down": oN,
  "menu-up": lN,
  minus: hN,
  next: OU,
  "open-in-new": uN,
  pencil: O$,
  pin: pN,
  unpin: fN,
  plus: dE,
  "plus-circle-outline": yN,
  poll: xU,
  previous: x4,
  read: BO,
  restore: uE,
  unread: BO,
  send: wN,
  "server-network-off": gN,
  "shield-star": vN,
  "shield-star-outline": ON,
  sort: bN,
  star: $N,
  unstar: xN,
  "swap-horizontal": kN,
  textbox: eN,
  "thumb-up": PN,
  "thumb-up-outline": CN,
  trashcan: QN,
  video: MN,
  "view-list-outline": RN,
  "view-module-outline": AN,
  "wifi-off": EN,
  // Files
  email: qU,
  file: UU,
  "file-upload": FU,
  "file-music": jU,
  "file-image": BU,
  "file-video": HU,
  "file-code": k4,
  "file-xml": k4,
  "file-document": S4,
  "file-word": YU,
  "file-excel": NU,
  "file-pdf": S4,
  "file-powerpoint": XU,
  "file-compressed": JU,
  // Integrations
  meeting: dN,
  box: $U,
  cloud: AU,
  dropbox: ZU,
  "google-drive": tN,
  onedrive: cN
}, T4 = {
  attach: aE,
  create: dE,
  "delete-forever": hE,
  edit: O$,
  modify: O$,
  rename: LU,
  replace: SN,
  restore: uE,
  subscribe: oE,
  trash: cE,
  unsubscribe: lE,
  upload: TN,
  version: nN
}, M4 = {
  dropbox: "#0061fe",
  onedrive: "#0078d4",
  box: "#0161d5",
  "google-drive": "#1a73e8",
  zoom: "#4a8cff"
};
function b$(s) {
  return s && s in Q4 ? Q4[s] : "";
}
u(b$, "gu");
p(b$, "getIconMapping");
function pE(s) {
  return s && s in C4 ? C4[s] : "";
}
u(pE, "Mg");
p(pE, "getSvgMapping");
function fE(s) {
  return s && s in T4 ? T4[s] : "";
}
u(fE, "zg");
p(fE, "getFileActionIconMapping");
const Me = /* @__PURE__ */ p((s) => s ?? M, "to");
var Ou;
const yE = (Ou = class extends Yr {
  constructor(t) {
    var i;
    if (super(t), t.type !== Vf.ATTRIBUTE || t.name !== "part" || ((i = t.strings) == null ? void 0 : i.length) > 2)
      throw new Error(
        "`partMap()` can only be used in the `part` attribute and must be the only section in the attribute."
      );
  }
  render(t) {
    return " " + Object.keys(t).filter((i) => t[i]).join(" ") + " ";
  }
  update(t, [i]) {
    var n, r;
    if (this._previousShadowParts === void 0) {
      this._previousShadowParts = /* @__PURE__ */ new Set(), t.strings !== void 0 && (this._staticShadowParts = new Set(
        t.strings.join(" ").split(/\s/).filter((o) => o !== "")
      ));
      for (const o in i)
        i[o] && !((n = this._staticShadowParts) != null && n.has(o)) && this._previousShadowParts.add(o);
      return this.render(i);
    }
    const a = t.element.part;
    for (const o of this._previousShadowParts)
      o in i || (a.remove(o), this._previousShadowParts.delete(o));
    for (const o in i) {
      const l = !!i[o];
      l !== this._previousShadowParts.has(o) && !((r = this._staticShadowParts) != null && r.has(o)) && (l ? (a.add(o), this._previousShadowParts.add(o)) : (a.remove(o), this._previousShadowParts.delete(o)));
    }
    return pn;
  }
}, u(Ou, "Lp"), Ou);
p(yE, "ShadowPartMapDirective");
let zN = yE;
const At = _s(zN);
var bu;
const mE = (bu = class extends Yr {
  constructor(t) {
    if (super(t), this.it = M, t.type !== Vf.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === M || t == null) return this._t = void 0, this.it = t;
    if (t === pn) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const i = [t];
    return i.raw = i, this._t = { _$litType$: this.constructor.resultType, strings: i, values: [] };
  }
}, u(bu, "Rp"), bu);
p(mE, "le");
let $1 = mE;
$1.directiveName = "unsafeHTML", $1.resultType = 1;
const So = _s($1);
var $u;
const wE = ($u = class extends $1 {
}, u($u, "Ip"), $u);
p(wE, "pe");
let $$ = wE;
$$.directiveName = "unsafeSVG", $$.resultType = 2;
const R4 = _s($$), Lt = de`:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]){box-sizing:border-box;text-align:initial;font-size:var(--wy-font-size, var(--wy-size, 1em))}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:before,:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:after{box-sizing:inherit}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a){text-decoration:var(--wy-link-decoration, none);color:var(--wy-link, var(--wy-primary-40, #006399))}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a):hover,:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a):hover{text-decoration:var(--wy-link-hover-decoration, unset)}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a):where(:not([href]):not([class])),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(a):where(:not([href]):not([class])):hover,:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a):where(:not([href]):not([class])),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(a):where(:not([href]):not([class])):hover{text-decoration:none}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(p),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(p){margin-top:0;margin-bottom:calc(1 * var(--wy-size, 1rem))}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where(label),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where(label){cursor:inherit}:where(:host([hidden])),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"])[hidden],:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *[hidden]{display:none!important}:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]):where([role=button]),:where(:host,:host>*,[class^=wy-],[class*=\" wy-\"]) *:where([role=button]){cursor:pointer}`, m5 = de`[part~=wy-icon]{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;position:relative;width:var(--wy-component-icon-width);height:var(--wy-component-icon-height)}[part~=wy-icon][width=\"24\"]{width:var(--wy-component-icon-width, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-icon][height=\"24\"]{height:var(--wy-component-icon-height, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-icon-first]{margin-left:calc(-.5 * var(--wy-size, 1rem))}[part~=wy-icon-last]{margin-right:calc(-.5 * var(--wy-size, 1rem))}[part~=wy-icon-padded]{margin:16.66666667%}[part~=wy-icon-inline]{vertical-align:-.25em}[part~=wy-icon-overlay]{position:absolute;bottom:0;right:0;border-radius:50%}:host(wy-icon-stack),[part~=wy-icon-stack]{display:inline-flex;position:relative;line-height:1}[part~=wy-icon-stack-layer]{position:absolute}[part~=wy-icon-stack-overlay]{position:absolute;bottom:0;right:0;border-radius:50%;width:calc(var(--wy-component-icon-width) / 2);height:calc(var(--wy-component-icon-height) / 2)}[part~=wy-icon-current-color]{fill:currentColor}[part~=wy-icon-state]{transition:opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1)));align-self:center;justify-self:center;margin:auto;opacity:0}[part~=wy-icon-state][part~=wy-active]{opacity:1}[part~=wy-icon-display]{color:var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));border-radius:var(--wy-component-border-radius, var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))));display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem));margin:auto}[part~=wy-icon-display-icon]{color:var(--wy-component-color);--wy-component-icon-width: calc(4 * var(--wy-size, 1rem));--wy-component-icon-height: calc(4 * var(--wy-size, 1rem));padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem))}[part~=wy-icon-display-text],[part~=wy-icon-display-meta]{color:var(--wy-component-color);padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem));text-align:center}[part~=wy-icon-color-primary]{fill:var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-icon-color-secondary]{fill:var(--wy-secondary, var(--wy-secondary-40, #3b6a1c))}[part~=wy-icon-color-tertiary]{fill:var(--wy-tertiary, var(--wy-tertiary-40, #3b6a1c))}[part~=wy-icon-color-surface]{fill:var(--wy-surface, var(--wy-neutral-99, #fcfcff))}[part~=wy-icon-color-surface-variant]{fill:var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb))}[part~=wy-icon-color-error]{fill:var(--wy-error, var(--wy-error-40, #ba1824))}[part~=wy-icon-color-warning]{fill:var(--wy-warning, var(--wy-warning-70, #afb140))}[part~=wy-icon-color-blue]{fill:var(--wy-blue, var(--wy-blue-light, #89a9fc))}[part~=wy-icon-color-indigo]{fill:var(--wy-indigo, var(--wy-indigo-light, #9185de))}[part~=wy-icon-color-purple]{fill:var(--wy-purple, var(--wy-purple-light, #c675b7))}[part~=wy-icon-color-pink]{fill:var(--wy-pink, var(--wy-pink-light, #d57194))}[part~=wy-icon-color-red]{fill:var(--wy-red, var(--wy-red-light, #db726c))}[part~=wy-icon-color-orange]{fill:var(--wy-orange, var(--wy-orange-light, #e89a3a))}[part~=wy-icon-color-yellow]{fill:var(--wy-yellow, var(--wy-yellow-light, #afb140))}[part~=wy-icon-color-green]{fill:var(--wy-green, var(--wy-green-light, #00a38b))}[part~=wy-icon-color-teal]{fill:var(--wy-teal, var(--wy-teal-light, #00a0a8))}[part~=wy-icon-color-cyan]{fill:var(--wy-cyan, var(--wy-cyan-light, #0082a1))}[part~=wy-icon-color-gray]{fill:var(--wy-gray, var(--wy-gray-light, #76777a))}[part~=wy-icon-color-black]{fill:var(--wy-black, var(--wy-black, #000000))}[part~=wy-icon-color-white]{fill:var(--wy-white, var(--wy-white, #ffffff))}[part*=wy-kind-]{fill:var(--wy-gray, var(--wy-gray-light, #76777a))}[part~=wy-kind-archive]{fill:var(--wy-orange, var(--wy-orange-light, #e89a3a))}[part~=wy-kind-audio]{fill:var(--wy-teal, var(--wy-teal-light, #00a0a8))}[part~=wy-kind-code]{fill:var(--wy-green, var(--wy-green-light, #00a38b))}[part~=wy-kind-document]{fill:var(--wy-blue, var(--wy-blue-light, #89a9fc))}[part~=wy-kind-email]{fill:var(--wy-red, var(--wy-red-light, #db726c))}[part~=wy-kind-presentation]{fill:var(--wy-orange, var(--wy-orange-light, #e89a3a))}[part~=wy-kind-spreadsheet]{fill:var(--wy-green, var(--wy-green-light, #00a38b))}[part~=wy-kind-image]{fill:var(--wy-pink, var(--wy-pink-light, #d57194))}[part~=wy-kind-text]{fill:var(--wy-cyan, var(--wy-cyan-light, #0082a1))}[part~=wy-kind-video]{fill:var(--wy-purple, var(--wy-purple-light, #c675b7))}[part~=wy-ext-pdf]{fill:var(--wy-red, var(--wy-red-light, #db726c))}[part~=wy-kind-text-icon]{width:calc(1.25 * var(--wy-size, 1rem));height:calc(1.25 * var(--wy-size, 1rem));vertical-align:calc(-.3125 * var(--wy-size, 1rem))}`;
var _N = Object.defineProperty, LN = Object.getOwnPropertyDescriptor, pt = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? LN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && _N(t, i, r), r;
}, "__decorateClass$14"), jO, xu;
let Je = (jO = (xu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.color = "", this.size = 24, this.path = P4, this.inline = !1, this.first = !1, this.last = !1, this.padded = !1, this.layer = !1, this.state = !1, this.active = !1, this.uniqueId = `wy-icon-${ff()}`;
  }
  willUpdate(t) {
    t.has("name") && this.name && (this.path = b$(this.name) || P4, this.overlayPath = b$(this.overlayName) || this.overlayPath, this.nativeIconColor = this.color === "native" && M4[this.name] || void 0, this.nativeOverlayColor = this.overlayName && M4[this.overlayName] || void 0);
  }
  render() {
    var t;
    const i = this.kind ? Uk(this.kind) : this.kind, n = (t = this.ext) != null && t.startsWith(".") ? this.ext.substring(1) : this.ext, r = {
      "wy-icon": !0,
      "wy-icon-current-color": !i && !this.color,
      ["wy-kind-" + i]: !!i,
      ["wy-ext-" + n]: !!n,
      ["wy-icon-color-" + this.color]: !!this.color,
      "wy-icon-first": this.first,
      "wy-icon-last": this.last,
      "wy-icon-padded": this.padded,
      "wy-icon-inline": this.inline,
      "wy-icon-stack-layer": this.layer,
      "wy-icon-state": this.state,
      "wy-active": this.active
    }, a = this.size !== 24, o = this.size / 16, l = a ? `width: var(--wy-component-icon-width, calc(${o} * var(--wy-size, 1rem))); height: var(--wy-component-icon-height, calc(${o} * var(--wy-size, 1rem)));` : "", c = this.svg && pE(this.svg);
    return this.overlayPath ? [
      O`
          <style>
            .icon-mask-bg {
              width: var(--wy-component-icon-width, calc(${o} * var(--wy-size, 1rem)));
              height: var(--wy-component-icon-height, calc(${o} * var(--wy-size, 1rem)));
              fill: white;
            }

            .icon-mask {
              width: calc(var(--wy-component-icon-width, calc(${o} * var(--wy-size, 1rem))));
              height: calc(var(--wy-component-icon-height, calc(${o} * var(--wy-size, 1rem))));
              ry: calc(var(--wy-border-radius-pill, var(--wy-border-radius, 50%)) * 2);
              x: calc(var(--wy-component-icon-width, calc(${o} * var(--wy-size, 1rem))) / 2);
              y: calc(var(--wy-component-icon-height, calc(${o} * var(--wy-size, 1rem))) / 2);
              stroke: black;
              stroke-width: 4px;
              fill: black;
            }
          </style>
        `,
      O`
          <wy-icon-stack style="${l}">
            <svg
              part=${At(r)}
              viewBox="0 0 24 24"
              width="${this.size}"
              height="${this.size}"
              style="mask-image: url(#${this.uniqueId}-mask); -webkit-mask-image: url(#${this.uniqueId}-mask);"
            >
              <defs>
                <mask id="${this.uniqueId}-mask">
                  <rect class="icon-mask-bg" />
                  <rect class="icon-mask" />
                </mask>
              </defs>
              ${c ? R4(c) : u4`
          <path d="${this.path}" style="fill: ${Me(this.nativeIconColor)}" />
        `}
              <!--rect width="24" height="24" fill="transparent" /-->
            </svg>
            <svg part="wy-icon-stack-overlay" viewBox="0 0 24 24" width="${this.size / 2}" height="${this.size / 2}">
              <path d="${this.overlayPath}" style="fill: ${Me(this.nativeOverlayColor)}" />
              <!--rect width="24" height="24" fill="transparent" /-->
            </svg>
          </wy-icon-stack>
        `
    ] : O`
      <svg
        part=${At(r)}
        style="${l}"
        viewBox="0 0 24 24"
        width="${this.size}"
        height="${this.size}"
      >
        ${c ? R4(c) : u4`
          <path d="${this.path}" style="fill: ${Me(this.nativeIconColor)}" />
        `}
        <!--rect width="24" height="24" fill="transparent" /-->
      </svg>
    `;
  }
}, u(xu, "fn"), xu), p(jO, "WyIcon"), jO);
Je.styles = [
  Lt,
  m5,
  de`
      :host {
        display: contents;
      }
    `
];
pt([
  x()
], Je.prototype, "name", 2);
pt([
  x()
], Je.prototype, "overlayName", 2);
pt([
  x()
], Je.prototype, "svg", 2);
pt([
  x()
], Je.prototype, "color", 2);
pt([
  x({ type: Number })
], Je.prototype, "size", 2);
pt([
  x()
], Je.prototype, "kind", 2);
pt([
  x()
], Je.prototype, "ext", 2);
pt([
  x({ attribute: !1 })
], Je.prototype, "path", 2);
pt([
  x({ attribute: !1 })
], Je.prototype, "overlayPath", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "inline", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "first", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "last", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "padded", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "layer", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "state", 2);
pt([
  x({ type: Boolean })
], Je.prototype, "active", 2);
pt([
  B()
], Je.prototype, "nativeIconColor", 2);
pt([
  B()
], Je.prototype, "nativeOverlayColor", 2);
Je = pt([
  F("wy-icon")
], Je);
var XO, ku;
let x$ = (XO = (ku = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    return O`<slot></slot>`;
  }
}, u(ku, "mn"), ku), p(XO, "WyIconStack"), XO);
x$.styles = [Lt, m5];
x$ = pt([
  F("wy-icon-stack")
], x$);
var FO, Su;
let k$ = (FO = (Su = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    return O`
      <div part="wy-icon-display-icon">
        <slot></slot>
      </div>
      <div part="wy-icon-display-text">
        <slot name="text"></slot>
      </div>
      <div part="wy-icon-display-meta">
        <slot name="meta"></slot>
      </div>
    `;
  }
}, u(Su, "vn"), Su), p(FO, "WyIconDisplay"), FO);
k$.styles = [Lt, m5];
k$ = pt([
  F("wy-icon-display")
], k$);
const IN = de`[part~=wy-progress]{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;position:relative;width:var(--wy-component-icon-width);height:var(--wy-component-icon-height)}[part~=wy-progress]:not([width]),[part~=wy-progress][width=\"24\"]{width:var(--wy-component-icon-width, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-progress]:not([height]),[part~=wy-progress][height=\"24\"]{height:var(--wy-component-icon-height, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-progress-padded]{margin:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem))}[part~=wy-progress-reveal]{opacity:1;transition:width var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),height var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),margin var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) calc(var(--wy-transition-duration, .2s) + var(--wy-transition-reveal-delay, 1s))}@starting-style{[part~=wy-progress-reveal]{width:0;height:0;opacity:0;margin:0}}[part~=wy-progress][part~=wy-primary]{color:var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-progress-remaining]{fill:none;stroke:var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb))}[part~=wy-progress-done]{fill:none;stroke:currentColor}[part~=wy-spinner]{align-self:center;justify-self:center;margin:auto}[part~=wy-spinner-padded]{margin:calc(1 * var(--wy-size, 1rem))}[part~=wy-spinner-overlay]{position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}[part~=wy-spinner-reveal]{opacity:1;transition:width var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),height var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),margin var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) calc(var(--wy-transition-duration, .2s) + var(--wy-transition-reveal-delay, 1s))}@starting-style{[part~=wy-spinner-reveal]{width:0;height:0;opacity:0;margin:0}}[part~=wy-spinner-circle]{stroke-dasharray:1,100;stroke-dashoffset:0;transform-origin:center;fill:none!important}[part~=wy-spinner][part~=wy-spin]{animation:wy-rotate 1.4s linear infinite}[part~=wy-spinner-circle][part~=wy-spin]{animation:wy-dash 1.4s ease-in-out infinite,wy-color 2.8s ease-in-out infinite}@keyframes wy-rotate{to{transform:rotate(360deg)}}@keyframes wy-dash{0%{stroke-dasharray:1,100;stroke-dashoffset:0}50%{stroke-dasharray:44.5,100;stroke-dashoffset:-17.5}to{stroke-dasharray:44.5,100;stroke-dashoffset:-62}}@keyframes wy-color{0%,to{stroke:var(--wy-primary, var(--wy-primary-40, #006399))}25%{stroke:var(--wy-primary, var(--wy-primary-40, #006399))}50%{stroke:transparent}75%{stroke:var(--wy-primary, var(--wy-primary-40, #006399))}}`, WN = de`[part~=wy-progress]{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;position:relative;width:var(--wy-component-icon-width);height:var(--wy-component-icon-height)}[part~=wy-progress]:not([width]),[part~=wy-progress][width=\"24\"]{width:var(--wy-component-icon-width, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-progress]:not([height]),[part~=wy-progress][height=\"24\"]{height:var(--wy-component-icon-height, calc(1.5 * var(--wy-size, 1rem)))}[part~=wy-progress-padded]{margin:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem))}[part~=wy-progress-reveal]{opacity:1;transition:width var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),height var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),margin var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) var(--wy-transition-reveal-delay, 1s),opacity var(--wy-transition, var(--wy-transition-duration, .2s) var(--wy-transition-curve, cubic-bezier(.4, 0, .2, 1))) calc(var(--wy-transition-duration, .2s) + var(--wy-transition-reveal-delay, 1s))}@starting-style{[part~=wy-progress-reveal]{width:0;height:0;opacity:0;margin:0}}[part~=wy-progress][part~=wy-primary]{color:var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-progress-remaining]{fill:none;stroke:var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb))}[part~=wy-progress-done]{fill:none;stroke:currentColor}`;
var VN = Object.defineProperty, ZN = Object.getOwnPropertyDescriptor, qo = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? ZN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && VN(t, i, r), r;
}, "__decorateClass$13"), HO, Pu;
let Bn = (HO = (Pu = class extends G {
  constructor() {
    super(...arguments), this.shadowParts = new ae(this), this.size = 24, this.noSpin = !1, this.padded = !1, this.overlay = !1, this.progress = NaN, this.reveal = !1;
  }
  render() {
    const t = this.noSpin && this.progress && 100 - this.progress || void 0;
    if (t !== void 0) {
      const i = Math.PI * 20, n = {
        "wy-progress": !0,
        "wy-primary": !0,
        "wy-progress-padded": this.padded,
        "wy-progress-reveal": this.reveal
      };
      return O`<svg
        part="${At(n)}"
        viewBox="0 0 24 24"
        width=${this.size}
        height=${this.size}
        transform="rotate(-90)"
      >
        <circle
          part="wy-progress-circle wy-progress-remaining"
          cx="12"
          cy="12"
          r=${10}
          stroke-linecap="butt"
          stroke-width="2"
          fill="none"
          stroke="#eee"
        ></circle>
        <circle
          part="wy-progress-circle wy-progress-done"
          cx="12"
          cy="12"
          r=${10}
          stroke-dasharray=${i}
          stroke-dashoffset=${i * t / 100}
          stroke-linecap="butt"
          stroke-width="2"
          fill="none"
          stroke="currentColor"
          path-length="200"
        ></circle>
      </svg>`;
    } else {
      const i = {
        "wy-spinner": !0,
        "wy-spin": !this.noSpin,
        "wy-spinner-overlay": this.overlay,
        "wy-spinner-padded": this.padded,
        "wy-spinner-reveal": this.reveal
      }, n = {
        "wy-spinner-circle": !0,
        "wy-spin": !this.noSpin
      };
      return O`<svg
        part="${At(i)}"
        width=${this.size}
        height=${this.size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          part="${At(n)}"
          fill="none"
          cx="12"
          cy="12"
          r="11"
          stroke-linecap="butt"
          stroke-width="2"
        />
      </svg>`;
    }
  }
}, u(Pu, "gn"), Pu), p(HO, "WySpinner"), HO);
Bn.styles = [
  Lt,
  IN,
  WN,
  de`
      :host {
        display: contents;
      }
    `
];
qo([
  x({ type: Number })
], Bn.prototype, "size", 2);
qo([
  x({ type: Boolean })
], Bn.prototype, "noSpin", 2);
qo([
  x({ type: Boolean })
], Bn.prototype, "padded", 2);
qo([
  x({ type: Boolean })
], Bn.prototype, "overlay", 2);
qo([
  x({ type: Number })
], Bn.prototype, "progress", 2);
qo([
  x({ type: Boolean })
], Bn.prototype, "reveal", 2);
Bn = qo([
  F("wy-spinner")
], Bn);
var DN = Object.defineProperty, qN = Object.getOwnPropertyDescriptor, w5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? qN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && DN(t, i, r), r;
}, "__decorateClass$12"), YO, Cu;
let wf = (YO = (Cu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.noNetwork = !1, this.handleUpdate = () => this.requestUpdate();
  }
  willUpdate(t) {
    if (t.has("weavy")) {
      const i = t.get("weavy");
      i && i !== this.weavy && i.removeNetworkListener(this.handleUpdate), this.weavy && i !== this.weavy && this.weavy.addNetworkListener(this.handleUpdate);
    }
  }
  render() {
    var t, i, n, r;
    return O`
      <div class="wy-empty">
        ${this.weavy && !this.noNetwork && ((t = this.weavy) == null ? void 0 : t.network.state) === "unreachable" ? O`
              <wy-icon-display>
                <wy-icon name="server-network-off"></wy-icon>
                <span slot="text">${T("The server is offline, try again in a few minutes...")}</span>
                <wy-spinner slot="meta" ?hidden=${!((i = this.weavy) != null && i.network.isPending)}></wy-spinner>
              </wy-icon-display>
            ` : !this.noNetwork && ((n = this.weavy) == null ? void 0 : n.network.state) === "offline" ? O`
              <wy-icon-display>
                <wy-icon name="wifi-off"></wy-icon>
                <span slot="text">${T("You are currently offline.")}</span>
                <wy-spinner slot="meta" ?hidden=${!((r = this.weavy) != null && r.network.isPending)}></wy-spinner>
              </wy-icon-display>
            ` : O`
              <slot>
                <wy-icon-display>
                  <wy-icon name="information"></wy-icon>
                  <slot slot="text" name="title">
                    <span>${T("Nothing to see here yet.")}</span>
                  </slot>
                </wy-icon-display>
              </slot>
            `}
      </div>
    `;
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this.weavy) == null || t.addNetworkListener(this.handleUpdate);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this.weavy) == null || t.removeNetworkListener(this.handleUpdate);
  }
}, u(Cu, "bn"), Cu), p(YO, "WyEmpty"), YO);
wf.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
w5([
  wt({ context: Pt, subscribe: !0 }),
  B()
], wf.prototype, "weavy", 2);
w5([
  x({ type: Boolean })
], wf.prototype, "noNetwork", 2);
wf = w5([
  F("wy-empty"),
  be()
], wf);
const A4 = /* @__PURE__ */ p((s, t, i) => {
  const n = /* @__PURE__ */ new Map();
  for (let r = t; r <= i; r++) n.set(s[r], r);
  return n;
}, "Jt"), zi = _s(class extends Yr {
  constructor(s) {
    if (super(s), s.type !== Vf.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(s, t, i) {
    let n;
    i === void 0 ? i = t : t !== void 0 && (n = t);
    const r = [], a = [];
    let o = 0;
    for (const l of s) r[o] = n ? n(l, o) : o, a[o] = i(l, o), o++;
    return { values: a, keys: r };
  }
  render(s, t, i) {
    return this.dt(s, t, i).values;
  }
  update(s, [t, i, n]) {
    const r = g$(s), { values: a, keys: o } = this.dt(t, i, n);
    if (!Array.isArray(r)) return this.ut = o, a;
    const l = this.ut ?? (this.ut = []), c = [];
    let h, d, f = 0, y = r.length - 1, w = 0, g = a.length - 1;
    for (; f <= y && w <= g; ) if (r[f] === null) f++;
    else if (r[y] === null) y--;
    else if (l[f] === o[w]) c[w] = ma(r[f], a[w]), f++, w++;
    else if (l[y] === o[g]) c[g] = ma(r[y], a[g]), y--, g--;
    else if (l[f] === o[g]) c[g] = ma(r[f], a[g]), ba(s, c[g + 1], r[f]), f++, g--;
    else if (l[y] === o[w]) c[w] = ma(r[y], a[w]), ba(s, r[f], r[y]), y--, w++;
    else if (h === void 0 && (h = A4(o, w, g), d = A4(l, f, y)), h.has(l[f])) if (h.has(l[y])) {
      const b = d.get(o[w]), k = b !== void 0 ? r[b] : null;
      if (k === null) {
        const $ = ba(s, r[f]);
        ma($, a[w]), c[w] = $;
      } else c[w] = ma(k, a[w]), ba(s, r[f], k), r[b] = null;
      w++;
    } else UO(r[y]), y--;
    else UO(r[f]), f++;
    for (; w <= g; ) {
      const b = ba(s, c[g + 1]);
      ma(b, a[w]), c[w++] = b;
    }
    for (; f <= y; ) {
      const b = r[f++];
      b !== null && UO(b);
    }
    return this.ut = o, O1(s, c), pn;
  }
}), S$ = _s(class extends Yr {
  constructor() {
    super(...arguments), this.key = M;
  }
  render(s, t) {
    return this.key = s, t;
  }
  update(s, [t, i]) {
    return t !== this.key && (O1(s), this.key = t), i;
  }
});
function jn(s) {
  s.stopPropagation();
}
u(jn, "Ti");
p(jn, "inputConsume");
function gE(s) {
  s.key === "Escape" && (s.preventDefault(), s.stopPropagation(), s.target.value = "", s.target.dispatchEvent(new InputEvent("input", { data: "", inputType: "deleteContent" })));
}
u(gE, "Fg");
p(gE, "inputClearOnEscape");
function xm(s) {
  s.key === "Escape" && (s.preventDefault(), s.stopPropagation(), s.target.blur(), s.target.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 })));
}
u(xm, "jc");
p(xm, "inputBlurOnEscape");
function vE(s) {
  s.key === "Enter" && s.target.blur();
}
u(vE, "Dg");
p(vE, "inputBlurOnEnter");
function g5(s) {
  s.target.value ? gE(s) : xm(s);
}
u(g5, "tw");
p(g5, "inputClearAndBlurOnEscape");
function v5(s) {
  s.key === "Enter" && (s.preventDefault(), s.stopPropagation(), s.target.click());
}
u(v5, "ew");
p(v5, "clickOnEnter");
function OE(s) {
  s.key === " " && (s.preventDefault(), s.stopPropagation());
}
u(OE, "Hg");
p(OE, "consumeOnSpace");
function ei(s) {
  v5(s), OE(s);
}
u(ei, "xe");
p(ei, "clickOnEnterAndConsumeOnSpace");
function _i(s) {
  s.key === " " && (s.preventDefault(), s.stopPropagation(), s.target.click());
}
u(_i, "je");
p(_i, "clickOnSpace");
function pv(s) {
  v5(s), _i(s);
}
u(pv, "qh");
p(pv, "clickOnEnterAndSpace");
const ot = _s(class extends Yr {
  constructor(s) {
    var t;
    if (super(s), s.type !== Vf.ATTRIBUTE || s.name !== "class" || ((t = s.strings) == null ? void 0 : t.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(s) {
    return " " + Object.keys(s).filter((t) => s[t]).join(" ") + " ";
  }
  update(s, [t]) {
    var i, n;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), s.strings !== void 0 && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((a) => a !== "")));
      for (const a in t) t[a] && !((i = this.nt) != null && i.has(a)) && this.st.add(a);
      return this.render(t);
    }
    const r = s.element.classList;
    for (const a of this.st) a in t || (r.remove(a), this.st.delete(a));
    for (const a in t) {
      const o = !!t[a];
      o === this.st.has(a) || (n = this.nt) != null && n.has(a) || (o ? (r.add(a), this.st.add(a)) : (r.remove(a), this.st.delete(a)));
    }
    return pn;
  }
});
function O5(s) {
  const t = [s];
  for (; s && s.parent; )
    s = s.parent, t.push(s);
  return t;
}
u(O5, "iw");
p(O5, "getEntityChain");
function b5(s, t, i) {
  return s.type === t && (!i || s.id === i.id);
}
u(b5, "sw");
p(b5, "isEntityMatch");
function nw(s, t, i) {
  return O5(s).some((n) => n && b5(n, t, i));
}
u(nw, "gl");
p(nw, "isEntityChainMatch");
function $5(s, t, i) {
  return O5(s).find((n) => n && b5(n, t, i));
}
u($5, "rw");
p($5, "getEntityChainMatch");
function x5(s, t, i, n) {
  const r = $5(s, n);
  return r && r.parent ? nw(r.parent, t, i) : !1;
}
u(x5, "nw");
p(x5, "hasEntityChildType");
async function k5(s, t, i) {
  var n, r, a;
  let o;
  if (t && (n = i.link.app) != null && n.id) {
    const c = await t.fetch(`/api/apps/${i.link.app.id}`);
    c.ok && (o = (await c.json()).metadata);
  }
  const l = new CustomEvent("wy-link", {
    bubbles: !0,
    composed: !0,
    cancelable: !0,
    detail: {
      link: {
        ...i.link,
        bot: S5(i)
      },
      app_type: ((r = i.link.app) == null ? void 0 : r.type) && Yq.get((a = i.link.app) == null ? void 0 : a.type) || Ni.Unknown,
      source_name: o == null ? void 0 : o.source_name,
      source_url: o == null ? void 0 : o.source_url,
      source_data: o == null ? void 0 : o.source_data
    }
  });
  return s.dispatchEvent(l);
}
u(k5, "aw");
p(k5, "dispatchLinkEvent");
function S5(s) {
  var t, i;
  return (t = s.link.app) != null && t.type && Gq.has((i = s.link.app) == null ? void 0 : i.type) && s.actor.is_bot ? s.actor.uid : void 0;
}
u(S5, "ow");
p(S5, "getBotName");
function P5(s) {
  const t = s.args;
  switch (s.template) {
    case "**{0}** added *{1}* to **{2}**": {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} added ${n} to ${r}`),
        titleHtml: T(O`<strong>${i}</strong> added <em>${n}</em> to <strong>${r}</strong>`)
      };
    }
    case "**{0}** edited *{1}*": {
      const [i, n] = t;
      return {
        title: T(ie`${i} edited ${n}`),
        titleHtml: T(O`<strong>${i}</strong> edited <em>${n}</em>`)
      };
    }
    case '**{0}** commented on *{1}*: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} commented on ${n}`),
        titleHtml: T(O`<strong>${i}</strong> commented on <em>${n}</em>`),
        detail: r
      };
    }
    case '**{0}** commented on **{1}**: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} commented on ${n}`),
        titleHtml: T(O`<strong>${i}</strong> commented on <strong>${n}</strong>`),
        detail: r
      };
    }
    case '**{0}** replied to your post: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} replied to your post`),
        titleHtml: T(O`<strong>${i}</strong> replied to your post`),
        detail: n
      };
    }
    case '**{0}** replied to a post: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} replied to a post`),
        titleHtml: T(O`<strong>${i}</strong> replied to a post`),
        detail: n
      };
    }
    case '**{0}** mentioned you in a comment: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} mentioned you in a comment`),
        titleHtml: T(O`<strong>${i}</strong> mentioned you in a comment`),
        detail: n
      };
    }
    case '**{0}** posted in **{1}**: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} posted in ${n}`),
        titleHtml: T(O`<strong>${i}</strong> posted in <strong>${n}</strong>`),
        detail: r
      };
    }
    case '**{0}** mentioned you in a post: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} mentioned you in a post`),
        titleHtml: T(O`<strong>${i}</strong> mentioned you in a post`),
        detail: n
      };
    }
    case 'New message from **{0}**: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`New message from ${i}`),
        titleHtml: T(O`New message from <strong>${i}</strong>`),
        detail: n
      };
    }
    case '**{0}** sent a message in **{1}**: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} sent a message in ${n}`),
        titleHtml: T(O`<strong>${i}</strong> sent a message in <strong>${n}</strong>`),
        detail: r
      };
    }
    case '**{0}** mentioned you in a message: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} mentioned you in a message`),
        titleHtml: T(O`<strong>${i}</strong> mentioned you in a message`),
        detail: n
      };
    }
    case '**{0}** edited a post: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} edited a post`),
        titleHtml: T(O`<strong>${i}</strong> edited a post`),
        detail: n
      };
    }
    case "**{0}** liked *{1}*": {
      const [i, n] = t;
      return {
        title: T(ie`${i} liked ${n}`),
        titleHtml: T(O`<strong>${i}</strong> liked <em>${n}</em>`)
      };
    }
    case "**{0}** reacted {2} to *{1}*": {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} reacted ${n} to ${r}`),
        titleHtml: T(O`<strong>${i}</strong> reacted ${n} to <em>${r}</em>`)
      };
    }
    case '**{0}** liked your comment: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} liked your comment`),
        titleHtml: T(O`<strong>${i}</strong> liked your comment`),
        detail: n
      };
    }
    case '**{0}** reacted {1} to your comment: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} reacted ${n} to your comment`),
        titleHtml: T(O`<strong>${i}</strong> reacted ${n} to your comment`),
        detail: r
      };
    }
    case '**{0}** liked your message: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} liked your message`),
        titleHtml: T(O`<strong>${i}</strong> liked your message`),
        detail: n
      };
    }
    case '**{0}** reacted {1} to your message: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} reacted ${n} to your message`),
        titleHtml: T(O`<strong>${i}</strong> reacted ${n} to your message`),
        detail: r
      };
    }
    case '**{0}** liked your post: "{1}"': {
      const [i, n] = t;
      return {
        title: T(ie`${i} liked your post`),
        titleHtml: T(O`<strong>${i}</strong> liked your post`),
        detail: n
      };
    }
    case '**{0}** reacted {1} to your post: "{2}"': {
      const [i, n, r] = t;
      return {
        title: T(ie`${i} reacted ${n} to your post`),
        titleHtml: T(O`<strong>${i}</strong> reacted ${n} to your post`),
        detail: r
      };
    }
    case "**{0}** voted on your poll": {
      const [i] = t;
      return {
        title: T(ie`${i} voted on your poll`),
        titleHtml: T(O`<strong>${i}</strong> voted on your poll`)
      };
    }
    case "**{0}** and **{1}** voted on your poll": {
      const [i, n] = t;
      return {
        title: T(ie`${i} and ${n} voted on your poll`),
        titleHtml: T(O`<strong>${i}</strong> and <strong>${n}</strong> voted on your poll`)
      };
    }
    case "**{0}**, **{1}** and **{2}** voted on your poll": {
      const [i, n, r] = t;
      return {
        title: T(ie`${i}, ${n} and ${r} voted on your poll`),
        titleHtml: T(
          O`<strong>${i}</strong>, <strong>${n}</strong> and <strong>${r}</strong> voted on your poll`
        )
      };
    }
    case "**{0}** and {1} others voted on your poll": {
      const [i, n] = t;
      return {
        title: T(ie`${i} and ${n} others voted on your poll`),
        titleHtml: T(O`<strong>${i}</strong> and ${n} others voted on your poll`)
      };
    }
    default:
      return console.error(`Notification template not found! '${s.template}'`), { title: "", titleHtml: M };
  }
}
u(P5, "cw");
p(P5, "getNotificationText");
var C5 = /* @__PURE__ */ ((s) => (s.Active = "active", s.Away = "away", s))(C5 || {});
const Q5 = de`:host(wy-avatar){position:relative;display:inline-flex}[part~=wy-avatar-shape]{border-radius:var(--wy-avatar-border-radius, var(--wy-border-radius-pill, var(--wy-border-radius, 50%)))}[part~=wy-avatar-img]{width:var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem)));height:var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem)));object-fit:cover}[part~=wy-avatar-initials]{background-color:var(--wy-component-avatar-background-color, var(--wy-primary, var(--wy-primary-40, #006399)));color:var(--wy-component-avatar-color, var(--wy-on-primary, var(--wy-white, #ffffff)));width:var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem)));height:var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem)));display:flex;align-items:center;align-content:center;justify-content:center;justify-items:center;font-size:calc(var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem))))}[part~=wy-avatar-initials-text]{font-size:max(8px,var(--wy-avatar-font-size, .382em));font-weight:var(--wy-avatar-font-weight, var(--wy-font-weight-bold, unset));line-height:1}[part~=wy-avatar-type]{display:flex;position:absolute;z-index:1;bottom:0;right:-8.3333333333%;border-radius:50%;background-color:var(--wy-primary, var(--wy-primary-40, #006399));color:var(--wy-on-primary, var(--wy-white, #ffffff))}:host(wy-avatar-group){position:relative;display:inline-flex;flex-shrink:0;width:var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem)));height:var(--wy-component-avatar-size, calc(2 * var(--wy-size, 1rem)))}[part~=wy-avatar-back]{position:absolute;top:0;left:0}[part~=wy-avatar-front]{position:absolute;bottom:0;right:0}:host(wy-avatar-header){padding:calc(1.5 * var(--wy-size, 1rem));margin-left:auto;margin-right:auto;text-align:center;display:flex;flex-direction:column;justify-content:center;align-items:center}`, bE = de`[part~=wy-presence]{width:calc(.75 * var(--wy-size, 1rem));height:calc(.75 * var(--wy-size, 1rem));border-radius:50%;position:absolute;bottom:0;right:-5%;box-sizing:border-box}[part~=wy-presence]:not([part~=wy-presence-active]){display:none}[part~=wy-presence]:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border-radius:inherit;background-color:var(--wy-presence-active, var(--wy-green-light, #00a38b));background-clip:content-box;padding:calc(.125 * var(--wy-size, 1rem));box-sizing:border-box}[part~=wy-presence-mask]{-webkit-mask-image:radial-gradient(circle calc(.75 * var(--wy-size, 1rem)) at bottom calc(.375 * var(--wy-size, 1rem)) right calc(.375 * var(--wy-size, 1rem) - 5%),rgba(0,0,0,0) calc(.375 * var(--wy-size, 1rem)),rgb(0,0,0) calc(.375 * var(--wy-size, 1rem) + 1px));mask-image:radial-gradient(circle calc(.75 * var(--wy-size, 1rem)) at bottom calc(.375 * var(--wy-size, 1rem)) right calc(.375 * var(--wy-size, 1rem) - 5%),#0000 calc(.375 * var(--wy-size, 1rem)),#000 calc(.375 * var(--wy-size, 1rem) + 1px))}[part~=wy-presence-in-text]{position:absolute;bottom:unset;right:unset}[part~=wy-presence-in-text]:after{left:calc(-1 * var(--wy-size, 1rem))}`;
var UN = Object.defineProperty, NN = Object.getOwnPropertyDescriptor, T5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? NN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && UN(t, i, r), r;
}, "__decorateClass$11"), GO, Qu;
let gf = (GO = (Qu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.placement = "avatar";
  }
  render() {
    const t = {
      "wy-presence": !0,
      "wy-presence-active": this.status === C5.Active,
      "wy-presence-in-text": this.placement === "text"
    };
    return O` <span part=${At(t)} data-presence-id=${this.id}></span> `;
  }
}, u(Qu, "xn"), Qu), p(GO, "WyPresence"), GO);
gf.styles = [
  Lt,
  bE,
  de`
      :host {
        display: contents;
      }
    `
];
T5([
  x()
], gf.prototype, "placement", 2);
T5([
  x()
], gf.prototype, "status", 2);
gf = T5([
  F("wy-presence")
], gf);
var BN = Object.defineProperty, jN = Object.getOwnPropertyDescriptor, On = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? jN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && BN(t, i, r), r;
}, "__decorateClass$10"), KO, Tu;
let Cs = (KO = (Tu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.size = 32, this.src = "", this.name = "", this.isBot = !1;
  }
  render() {
    const t = this.size / 16;
    let i;
    !this.src && this.name && (i = DM(this.name));
    const n = {
      "wy-avatar-shape": !0,
      "wy-avatar-img": !!this.src,
      "wy-avatar-initials": !this.src,
      "wy-presence-mask": this.presence === C5.Active
    };
    return O`
      ${this.src ? O`
            <img
              alt=""
              title="${Me(this.title || this.name)}"
              part=${At(n)}
              style="--wy-component-avatar-size: calc(${t} * var(--wy-size, 1rem));"
              height="${this.size}"
              width="${this.size}"
              src="${this.src}"
              decoding="async"
              loading="lazy"
            />
          ` : O`
            <div
              part=${At(n)}
              style="--wy-component-avatar-size: calc(${t} * var(--wy-size, 1rem));"
              title="${Me(this.title || this.name)}"
            >
              <span part="wy-avatar-initials-text">${i}</span>
            </div>
          `}
      ${this.isBot ? O`<wy-icon part="wy-avatar-type" name="bot" size="${this.size / 3 * 1.25}"></wy-icon>` : M}
      ${this.presence && !this.isBot ? O`<wy-presence .status=${this.presence} id=${this.id}></wy-presence>` : M}
    `;
  }
}, u(Tu, "$n"), Tu), p(KO, "WyAvatar"), KO);
Cs.styles = [Lt, Q5, bE];
On([
  x({ type: Number })
], Cs.prototype, "size", 2);
On([
  x()
], Cs.prototype, "src", 2);
On([
  x()
], Cs.prototype, "name", 2);
On([
  x({ type: Boolean, reflect: !0 })
], Cs.prototype, "isBot", 2);
On([
  x()
], Cs.prototype, "presence", 2);
Cs = On([
  F("wy-avatar")
], Cs);
var JO, Mu;
let Po = (JO = (Mu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.size = 32, this.uniqueId = `wy-avatar-${ff()}`;
  }
  render() {
    if (!this.user)
      return M;
    const t = this.size / 16, i = (this.members || []).filter((a) => {
      var o;
      return a.id !== ((o = this.user) == null ? void 0 : o.id);
    }).slice(0, 2).reverse(), n = (i == null ? void 0 : i.shift()) || this.user, r = (i == null ? void 0 : i.shift()) || (n !== this.user ? this.user : void 0);
    return [
      O`
        <style>
          :host {
            --wy-component-avatar-size: calc(${t} * var(--wy-size, 1rem));
          }

          .avatar-mask-bg {
            width: calc(${t * 2 / 3} * var(--wy-size, 1rem));
            height: calc(${t * 2 / 3} * var(--wy-size, 1rem));
            fill: white;
          }

          .avatar-mask {
            width: calc(${t * 2 / 3} * var(--wy-size, 1rem));
            height: calc(${t * 2 / 3} * var(--wy-size, 1rem));
            ry: var(--wy-avatar-border-radius, var(--wy-border-radius-pill, var(--wy-border-radius, 50%)));
            x: calc(${t / 3} * var(--wy-size, 1rem));
            y: calc(${t / 3} * var(--wy-size, 1rem));
            stroke: black;
            stroke-width: 4px;
            fill: black;
          }
        </style>
      `,
      O`
        <svg>
          <defs>
            <mask id="${this.uniqueId}-mask">
              <rect class="avatar-mask-bg" />
              <rect class="avatar-mask" />
            </mask>
          </defs>
        </svg>
      `,
      O`
        <wy-avatar
          part="wy-avatar-back"
          style="mask-image: url(#${this.uniqueId}-mask); -webkit-mask-image: url(#${this.uniqueId}-mask);"
          .src=${r == null ? void 0 : r.avatar_url}
          .name=${r == null ? void 0 : r.display_name}
          size=${this.size * 2 / 3}
        ></wy-avatar>
        <wy-avatar
          part="wy-avatar-front"
          .src=${n.avatar_url}
          .name=${n.display_name}
          .isBot=${n.is_bot}
          size=${this.size * 2 / 3}
        ></wy-avatar>
      `
    ];
  }
}, u(Mu, "kn"), Mu), p(JO, "WyAvatarGroup"), JO);
Po.styles = [
  Lt,
  Q5,
  de`
      :host {
        display: contents;
      }
    `
];
On([
  x({ type: Number })
], Po.prototype, "size", 2);
On([
  x({
    type: Array,
    attribute: !1
  })
], Po.prototype, "members", 2);
On([
  wt({ context: dv, subscribe: !0 }),
  B()
], Po.prototype, "user", 2);
Po = On([
  F("wy-avatar-group")
], Po);
var eb, Ru;
let P$ = (eb = (Ru = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    return O`<slot></slot>`;
  }
}, u(Ru, "Cn"), Ru), p(eb, "WyAvatarHeader"), eb);
P$.styles = [Lt, Q5];
P$ = On([
  F("wy-avatar-header")
], P$);
const $E = de`[part~=wy-button]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));color:var(--wy-component-color);background:var(--wy-component-background-color, transparent);height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));font-family:var(--wy-button-font-family, var(--wy-font-family, unset)),inherit;font-size:var(--wy-button-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-button-font-weight, var(--wy-font-weight, unset));line-height:var(--wy-button-line-height, var(--wy-line-height, 1.5));text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;user-select:none;border:var(--wy-button-border-width, var(--wy-border-outline, 0)) solid var(--wy-outline, var(--wy-neutral-variant-50, #72777e));border-radius:var(--wy-button-border-radius, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));display:inline-flex;align-items:center;justify-content:center;gap:var(--wy-button-gap, var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))))));position:relative}[part~=wy-button][part~=wy-button-sm]{height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .8);padding:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .25) calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .5)}[part~=wy-button]:disabled{opacity:var(--wy-opacity-disabled, 38%);cursor:unset;pointer-events:none}[part~=wy-button-state-layer]>*{z-index:3}[part~=wy-button-state-layer]:before{content:\"\";z-index:2;position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;background:var(--wy-component-color);opacity:0%}[part~=wy-button-state-layer]:hover:before{opacity:8%}[part~=wy-button-state-layer]:focus:before,[part~=wy-button-state-layer]:active:before,[part~=wy-button-state-layer][part~=wy-active]:before{opacity:12%}[part~=wy-button-icon]{--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));width:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))));line-height:1;align-items:center;justify-content:center}[part~=wy-button-icon][part~=wy-button-sm]{height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);width:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);padding:0;margin:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .5)}[part~=wy-button-icon][part~=wy-button-sm][part~=wy-button-state-layer]:before{margin:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * -.1)}[part~=wy-button-icon][part~=wy-active]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-button-icon-inline]{height:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));width:auto;min-width:var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));background:var(--wy-component-background-color);color:currentColor;display:flex;padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))}[part~=wy-button-icon-inline][part~=wy-button-sm]{height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);min-width:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6);padding:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .25);margin:calc(var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) * .5)}[part~=wy-button-icon-inline][part~=wy-button-sm][part~=wy-button-state-layer]:before{margin:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * -.1)}[part~=wy-button-inline]{border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));padding:calc(.5 * var(--wy-size, 1rem)) calc(.75 * var(--wy-size, 1rem));margin-inline:calc(-.25 * var(--wy-size, 1rem))}[part~=wy-button-primary]{--wy-component-background-color: var(--wy-primary, var(--wy-primary-40, #006399));--wy-component-color: var(--wy-on-primary, var(--wy-white, #ffffff))}[part~=wy-button-variant]{--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}[part~=wy-button-primary-text]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399))}[part~=wy-button-inherit-color]{--wy-component-color: currentColor}[part~=wy-button-no-color]{--wy-component-color: unset}[part=wy-button-link]{padding:0;color:var(--wy-link-color, var(--wy-primary, var(--wy-primary-40, #006399)));text-decoration:var(--wy-link-decoration, none)}[part=wy-button-link]:hover,[part=wy-button-link]:focus{text-decoration:var(--wy-link-hover-decoration, unset)}[part~=wy-buttons]{display:flex;align-items:center;flex-wrap:wrap;gap:calc(.5 * var(--wy-size, 1rem))}[part~=wy-buttons-reverse]{flex-direction:row-reverse}[part~=wy-buttons-floating]{position:sticky;padding:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))) 0;top:0;height:0;margin-bottom:calc(-1 * var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));z-index:1030;--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}`, xE = de`.wy-scroll-y{scroll-padding-top:var(--wy-scrollbar-adjust-top, 0);scroll-padding-bottom:var(--wy-scrollbar-adjust-bottom, 0)}.wy-scroll-y{overflow-y:auto;max-height:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-scroll-y:not(body){-webkit-overflow-scrolling:touch}.wy-scroll-y:not(.wy-scroll-x){overflow-x:hidden;touch-action:pan-y}.wy-scroll-x{overflow-x:auto;max-width:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}.wy-scroll-x:not(.wy-scroll-y){overflow-y:hidden;touch-action:pan-x}[part~=wy-tabs]{display:flex;overflow-y:hidden;padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));flex:1 1 auto}[part~=wy-tabs]{overflow-x:auto;max-width:100%;overflow-anchor:none;touch-action:pan-y,pan-x;will-change:scroll-position,opacity;backface-visibility:hidden}[part~=wy-tabs]{scrollbar-width:thin;scrollbar-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) transparent}[part~=wy-tabs]::-webkit-scrollbar{height:.375rem;width:.375rem;background:transparent;z-index:999}[part~=wy-tabs]::-webkit-scrollbar-track{background:transparent}[part~=wy-tabs]::-webkit-scrollbar-thumb{background-color:var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));opacity:75%;border:0 solid transparent;border-radius:0;background-clip:padding-box}[part~=wy-tabs]::-webkit-scrollbar-thumb:hover{background-color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));opacity:75%}[part~=wy-tabs]::-webkit-scrollbar-thumb:window-inactive{background-color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));opacity:50%}[part~=wy-tab]{--wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));--wy-component-background-color: transparent;color:var(--wy-component-color);background:var(--wy-component-background-color);border:none;border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));position:relative;text-align:center;text-decoration:none;cursor:pointer;-webkit-user-select:none;user-select:none}[part~=wy-tab] .wy-tab-icon{position:relative;padding:calc(.25 * var(--wy-size, 1rem)) calc(1 * var(--wy-size, 1rem));border-radius:var(--wy-button-border-radius, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))));display:inline-flex}[part~=wy-tab] .wy-tab-icon:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;background:var(--wy-component-color);opacity:0%}[part~=wy-tab]:hover .wy-tab-icon:before{opacity:8%}[part~=wy-tab]:focus .wy-tab-icon:before,[part~=wy-tab]:active .wy-tab-icon:before,[part~=wy-tab].wy-active .wy-tab-icon:before{opacity:12%}[part~=wy-tab] .wy-tab-label{font-family:var(--wy-button-font-family, var(--wy-font-family, unset)),inherit;line-height:var(--wy-button-line-height, var(--wy-line-height, 1.5));font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));font-weight:var(--wy-font-weight, unset)}[part~=wy-button-state-layer][part~=wy-button-sm][part~=wy-tab-sm]{padding:var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .5);margin:var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) auto;font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)));height:calc(var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * .6)}[part~=wy-button-state-layer][part~=wy-button-sm][part~=wy-tab-sm]:before{margin:calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * -.25) calc(var(--wy-button-padding-x, calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) * 0)}`;
var XN = Object.defineProperty, FN = Object.getOwnPropertyDescriptor, bn = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? FN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && XN(t, i, r), r;
}, "__decorateClass$$"), tb, Au;
let Xn = (tb = (Au = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this, !1), this.kind = "filled", this.active = !1, this.small = !1, this.disabled = !1;
  }
  render() {
    const t = {
      "wy-button": !0,
      "wy-active": !!this.active,
      "wy-disabled": !!this.disabled,
      "wy-button-inline": this.kind === "inline",
      "wy-button-icon": this.kind === "icon",
      "wy-button-icon-inline": this.kind === "icon-inline",
      "wy-button-link": this.kind === "link",
      "wy-button-primary": this.color === "primary",
      "wy-button-primary-text": this.color === "primary-text",
      "wy-button-inherit-color": this.color === "inherit",
      "wy-button-no-color": this.color === "none",
      "wy-button-variant": this.color === "variant",
      "wy-button-type-submit": this.type === "submit",
      "wy-button-type-reset": this.type === "reset",
      "wy-button-state-layer": this.kind !== "link" && !this.disabled,
      "wy-button-sm": !!this.small,
      "wy-tab": this.kind === "tab",
      "wy-tab-sm": this.kind === "tab" && !!this.small
    };
    return O`
      <button part=${At(t)} type=${Me(this.type)} ?disabled=${this.disabled}>
        <slot></slot>
      </button>
    `;
  }
}, u(Au, "_n"), Au), p(tb, "WyButton"), tb);
Xn.styles = [
  Lt,
  $E,
  xE,
  de`
      :host {
        display: contents;
        position: relative;
      }
    `
];
bn([
  x()
], Xn.prototype, "type", 2);
bn([
  x()
], Xn.prototype, "kind", 2);
bn([
  x({ type: Boolean })
], Xn.prototype, "active", 2);
bn([
  x()
], Xn.prototype, "color", 2);
bn([
  x({ type: Boolean })
], Xn.prototype, "small", 2);
bn([
  x({ type: Boolean, reflect: !0 })
], Xn.prototype, "disabled", 2);
Xn = bn([
  F("wy-button")
], Xn);
var ib, Eu;
let Co = (ib = (Eu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.tabs = !1, this.floating = !1, this.reverse = !1;
  }
  render() {
    const t = {
      "wy-buttons": !this.tabs,
      "wy-buttons-reverse": this.reverse,
      "wy-tabs": this.tabs,
      "wy-buttons-floating": this.floating
    };
    return O`<div part=${At(t)}><slot></slot></div>`;
  }
}, u(Eu, "Pn"), Eu), p(ib, "WyButtons"), ib);
Co.styles = [
  Lt,
  $E,
  xE,
  de`
      :host {
        display: contents;
      }
    `
];
bn([
  x({ type: Boolean })
], Co.prototype, "tabs", 2);
bn([
  x({ type: Boolean })
], Co.prototype, "floating", 2);
bn([
  x({ type: Boolean })
], Co.prototype, "reverse", 2);
Co = bn([
  F("wy-buttons")
], Co);
var HN = Object.defineProperty, YN = Object.getOwnPropertyDescriptor, M5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? YN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && HN(t, i, r), r;
}, "__decorateClass$_"), nb, zu;
let vf = (nb = (zu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.enableSwap = !1;
  }
  createRenderRoot() {
    return this;
  }
  dispatchRemove(t) {
    const i = new CustomEvent("embed-remove", { detail: { id: t } });
    return this.dispatchEvent(i);
  }
  dispatchSwap() {
    const t = new CustomEvent("embed-swap", { detail: {} });
    return this.dispatchEvent(t);
  }
  render() {
    const t = this.embed.type === "photo" && this.embed.provider_name.toLocaleLowerCase() === "giphy", i = !this.embed.html && !t;
    return O`
      <div class="wy-embed-actions">
        ${this.enableSwap ? O`<wy-button kind="icon" @click=${() => this.dispatchSwap()}
              ><wy-icon name="swap-horizontal"></wy-icon
            ></wy-button>` : O`<wy-button class="wy-embed-cycle"></wy-button>`}

        <wy-button kind="icon" @click=${() => this.dispatchRemove(this.embed.id)}
          ><wy-icon name="close-circle"></wy-icon
        ></wy-button>
      </div>

      ${this.embed.type === "audio" ? O`<div class="wy-embed-audio"></div>` : M}
      ${this.embed.type === "video" && this.embed.html ? O`<div class="wy-embed-video"><div>${So(this.embed.html)}</div></div>` : M}
      ${this.embed.type === "rich" ? O`<div class="wy-embed-rich"></div>` : M}
      ${this.embed.type === "photo" && this.embed.thumbnail_url ? O`
            <div
              class=${ot({
      "wy-embed-photo": !0,
      "wy-embed-photo-sm": (this.embed.thumbnail_width || 0) < 250
    })}>
              <a href=${this.embed.original_url} target="_blank">
                <img
                  src=${this.embed.thumbnail_url}
                  width=${Me(this.embed.thumbnail_width)}
                  height=${Me(this.embed.thumbnail_height)}
                  alt="" />
              </a>
            </div>
          ` : M}
      ${this.embed.type !== "audio" && this.embed.type !== "video" && this.embed.type !== "rich" && this.embed.type !== "photo" && this.embed.thumbnail_url ? O`
            <div
              class=${ot({
      "wy-embed-photo": !0,
      "wy-embed-photo-sm": (this.embed.thumbnail_width || 0) < 250
    })}>
              <a href=${this.embed.original_url} target="_blank">
                <img
                  src=${this.embed.thumbnail_url}
                  width=${Me(this.embed.thumbnail_width)}
                  height=${Me(this.embed.thumbnail_height)}
                  alt="" />
              </a>
            </div>
          ` : M}
      ${i ? O` <div class="wy-embed-caption">
            <a class="wy-embed-link" href=${this.embed.original_url} target="_blank">${this.embed.host}</a>
            ${this.embed.title ? O`<div class="wy-embed-title">${this.embed.title}</div>` : M}
            ${this.embed.description ? O`<div class="wy-embed-description">${this.embed.description}</div>` : M}
          </div>` : M}
    `;
  }
}, u(zu, "Mn"), zu), p(nb, "WyEmbed"), nb);
vf.styles = fe;
M5([
  x({ attribute: !1 })
], vf.prototype, "embed", 2);
M5([
  x({ type: Boolean, attribute: !1 })
], vf.prototype, "enableSwap", 2);
vf = M5([
  F("wy-embed")
], vf);
const fv = /* @__PURE__ */ p((s, t = 3) => {
  const i = [" B", " KB", " MB", " GB", " TB", " PB", " EB", " ZB", " YB"];
  let n = s, r = 0;
  for (; r < i.length - 1 && n >= 1024; )
    n = 100 * n / 1024 / 100, r++;
  return n.toLocaleString(void 0, { maximumSignificantDigits: t }) + i[r];
}, "fileSizeAsString");
function Gi(s) {
  return s.lastIndexOf(".") === -1 ? "." : (s.substring(s.lastIndexOf("."), s.length) || s).toLowerCase();
}
u(Gi, "ai");
p(Gi, "getExtension");
function R5(s) {
  switch (s) {
    case ".aac":
    case ".aif":
    case ".aiff":
    case ".au":
    case ".gsm":
    case ".m4a":
    case ".mid":
    case ".midi":
    case ".mka":
    case ".mp3":
    case ".oga":
    case ".ogg":
    case ".ra":
    case ".ram":
    case ".snd":
    case ".spx":
    case ".wav":
    case ".wma":
      return !0;
    default:
      return !1;
  }
}
u(R5, "pw");
p(R5, "isAudio");
function kE(s) {
  switch (s) {
    case ".ai":
    case ".apng":
    case ".bmp":
    case ".emf":
    case ".eps":
    case ".gif":
    case ".heic":
    case ".ico":
    case ".jpg":
    case ".jpeg":
    case ".png":
    case ".psd":
    case ".svg":
    case ".tif":
    case ".tiff":
    case ".webp":
    case ".wmf":
      return !0;
    default:
      return !1;
  }
}
u(kE, "Kg");
p(kE, "isImage");
function SE(s) {
  switch (Gi(s)) {
    case ".apng":
    case ".bmp":
    case ".gif":
    case ".ico":
    case ".jpg":
    case ".jpeg":
    case ".png":
    case ".svg":
    case ".webp":
      return !0;
    default:
      return !1;
  }
}
u(SE, "Gg");
p(SE, "isWebImage");
function A5(s) {
  switch (s) {
    case ".3g2":
    case ".asx":
    case ".asf":
    case ".avi":
    case ".flv":
    case ".mk3d":
    case ".mkv":
    case ".mov":
    case ".mp4":
    case ".mpeg":
    case ".mpg":
    case ".ogm":
    case ".ogv":
    case ".ogx":
    case ".qt":
    case ".rm":
    case ".rv":
    case ".smi":
    case ".smil":
    case ".swf":
    case ".webm":
    case ".wmv":
    case ".xaml":
      return !0;
    default:
      return !1;
  }
}
u(A5, "uw");
p(A5, "isVideo");
function PE(s) {
  switch (s) {
    case ".markdown":
    case ".md":
      return !0;
    default:
      return !1;
  }
}
u(PE, "Yg");
p(PE, "isMarkdown");
function E5(s) {
  switch (s) {
    case ".htm":
    case ".html":
    case ".xhtml":
    case ".xml":
      return !0;
    default:
      return !1;
  }
}
u(E5, "yw");
p(E5, "isMarkup");
function yv(s) {
  if (E5(s))
    return !0;
  switch (s) {
    case ".as":
    case ".as3":
    case ".asm":
    case ".aspx":
    case ".bat":
    case ".c":
    case ".cc":
    case ".cmake":
    case ".coffee":
    case ".cpp":
    case ".cs":
    case ".css":
    case ".cxx":
    case ".diff":
    case ".erb":
    case ".erl":
    case ".groovy":
    case ".gvy":
    case ".h":
    case ".haml":
    case ".hh":
    case ".hpp":
    case ".hxx":
    case ".java":
    case ".js":
    case ".json":
    case ".jsx":
    case ".less":
    case ".lst":
    case ".m":
    case ".make":
    case ".ml":
    case ".mm":
    case ".out":
    case ".patch":
    case ".php":
    case ".pl":
    case ".plist":
    case ".properties":
    case ".py":
    case ".rb":
    case ".sass":
    case ".scala":
    case ".scm":
    case ".script":
    case ".scss":
    case ".sh":
    case ".sml":
    case ".sql":
    case ".vb":
    case ".vi":
    case ".vim":
    case ".xsd":
    case ".xsl":
    case ".yaml":
    case ".yml":
      return !0;
    default:
      return !1;
  }
}
u(yv, "Kh");
p(yv, "isCode");
function z5(s) {
  if (yv(s) || PE(s))
    return !0;
  switch (s) {
    case ".txt":
      return !0;
    default:
      return !1;
  }
}
u(z5, "ww");
p(z5, "isText");
function Ls(s) {
  const t = Gi(s);
  if (t === "") return { icon: "file" };
  if (R5(t))
    return { icon: "file-music", color: "indigo" };
  if (kE(t))
    return { icon: "file-image", color: "cyan" };
  if (A5(t))
    return { icon: "file-video", color: "pink" };
  if (E5(t))
    return { icon: "file-xml", color: "purple" };
  if (yv(t))
    return { icon: "file-code", color: "purple" };
  if (z5(t))
    return { icon: "file-document" };
  switch (t) {
    case ".7z":
    case ".zip":
      return { icon: "file-compressed", color: "orange" };
    case ".doc":
    case ".docm":
    case ".docx":
    case ".dotm":
    case ".dotx":
      return { icon: "file-word", color: "native" };
    case ".eml":
    case ".msg":
      return { icon: "email", color: "" };
    case ".xls":
    case ".xlsm":
    case ".xlsx":
    case ".xltx":
      return { icon: "file-excel", color: "native" };
    case ".pdf":
      return { icon: "file-pdf", color: "native" };
    case ".ppt":
    case ".pptm":
    case ".pptx":
    case ".potx":
      return { icon: "file-powerpoint", color: "native" };
    case ".pages":
      return { icon: "file", color: "orange" };
    case ".numbers":
      return { icon: "file", color: "green" };
    case ".keynote":
      return { icon: "file", color: "blue" };
  }
  return { icon: "file" };
}
u(Ls, "vs");
p(Ls, "getIcon");
function CE(s) {
  const t = Gi(s);
  return t === "" ? "none" : SE(t) ? "image" : yv(t) ? "code" : z5(t) ? "text" : R5(t) ? "audio" : A5(t) ? "video" : "none";
}
u(CE, "Zg");
p(CE, "getWebPreviewFormat");
function Uo(s) {
  switch (s) {
    case "Google Drive":
      return "google-drive";
    case "Dropbox":
      return "dropbox";
    case "OneDrive":
      return "onedrive";
    case "Box":
      return "box";
    default:
      return "";
  }
}
u(Uo, "yo");
p(Uo, "getProvider");
function mv(s) {
  let t = "file";
  switch (Gi(s)) {
    case ".7z":
    case ".zip":
      t = "archive";
      break;
    case ".aac":
    case ".aif":
    case ".aiff":
    case ".au":
    case ".gsm":
    case ".m4a":
    case ".mid":
    case ".midi":
    case ".mka":
    case ".mp3":
    case ".oga":
    case ".ogg":
    case ".ra":
    case ".ram":
    case ".snd":
    case ".spx":
    case ".wav":
    case ".wma":
      t = "audio";
      break;
    case ".c":
    case ".cgi":
    case ".cpp":
    case ".cs":
    case ".cshtml":
    case ".css":
    case ".html":
    case ".java":
    case ".js":
    case ".json":
    case ".less":
    case ".php":
    case ".pl":
    case ".ps1":
    case ".py":
    case ".rb":
    case ".rs":
    case ".scss":
    case ".sh":
    case ".swift":
    case ".sql":
    case ".ts":
    case ".xml":
    case ".yaml":
    case ".yml":
      t = "code";
      break;
    case ".doc":
    case ".docm":
    case ".docx":
    case ".dotm":
    case ".dotx":
    case ".gdoc":
    case ".pages":
    case ".pdf":
      t = "document";
      break;
    case ".eml":
    case ".msg":
      t = "email";
      break;
    case ".gslides":
    case ".keynote":
    case ".ppt":
    case ".pptm":
    case ".pptx":
    case ".potx":
      t = "presentation";
      break;
    case ".gsheet":
    case ".numbers":
    case ".xls":
    case ".xlsm":
    case ".xlsx":
    case ".xltx":
      t = "spreadsheet";
      break;
    case ".ai":
    case ".apng":
    case ".bmp":
    case ".emf":
    case ".eps":
    case ".gif":
    case ".heic":
    case ".ico":
    case ".jpg":
    case ".jpeg":
    case ".png":
    case ".psd":
    case ".svg":
    case ".tif":
    case ".tiff":
    case ".webp":
    case ".wmf":
      t = "image";
      break;
    case ".md":
    case ".markdown":
    case ".txt":
      t = "text";
      break;
    case ".3g2":
    case ".asx":
    case ".asf":
    case ".avi":
    case ".flv":
    case ".mk3d":
    case ".mkv":
    case ".mov":
    case ".mp4":
    case ".mpeg":
    case ".mpg":
    case ".ogm":
    case ".ogv":
    case ".ogx":
    case ".qt":
    case ".rm":
    case ".rv":
    case ".smi":
    case ".smil":
    case ".swf":
    case ".webm":
    case ".wmv":
    case ".xaml":
      t = "video";
      break;
  }
  return t;
}
u(mv, "Gh");
p(mv, "getKind");
function wv(s) {
  const t = s.target, i = t == null ? void 0 : t.value.lastIndexOf(".");
  i === -1 ? t == null || t.select() : i !== void 0 && (t == null || t.setSelectionRange(0, i));
}
u(wv, "Yh");
p(wv, "handleSelectFilename");
var GN = Object.defineProperty, KN = Object.getOwnPropertyDescriptor, Zf = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? KN(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && GN(t, i, r), r;
}, "__decorateClass$Z"), sb, _u;
let Qs = (sb = (_u = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.name = "", this.previewUrl = "", this.url = "", this.size = 0;
  }
  render() {
    const t = this.size && this.size > 0 ? fv(this.size) : null, i = Gi(this.name), { icon: n } = Ls(this.name), r = mv(this.name), a = Uo(this.provider);
    return O`
      <a href=${this.previewUrl || this.url} class="wy-item wy-list-item-lg" target="_blank" title=${this.name}>
        <wy-icon name=${n} .overlayName=${a} size="48" kind=${r} ext=${i}></wy-icon>
        <div class="wy-item-body ">
          <div class="wy-item-title">${this.name}</div>
          ${t ? O`<div class="wy-item-text" title="${t}">${t}</div>` : ""}
        </div>
      </a>
    `;
  }
}, u(_u, "zn"), _u), p(sb, "WyAttachment"), sb);
Qs.styles = fe;
Zf([
  x()
], Qs.prototype, "name", 2);
Zf([
  x()
], Qs.prototype, "previewUrl", 2);
Zf([
  x()
], Qs.prototype, "url", 2);
Zf([
  x()
], Qs.prototype, "provider", 2);
Zf([
  x({ type: Number })
], Qs.prototype, "size", 2);
Qs = Zf([
  F("wy-attachment")
], Qs);
const QE = "important", JN = " !" + QE, x1 = _s(class extends Yr {
  constructor(s) {
    var t;
    if (super(s), s.type !== Vf.ATTRIBUTE || s.name !== "style" || ((t = s.strings) == null ? void 0 : t.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(s) {
    return Object.keys(s).reduce((t, i) => {
      const n = s[i];
      return n == null ? t : t + `${i = i.includes("-") ? i : i.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${n};`;
    }, "");
  }
  update(s, [t]) {
    const { style: i } = s.element;
    if (this.ft === void 0) return this.ft = new Set(Object.keys(t)), this.render(t);
    for (const n of this.ft) t[n] == null && (this.ft.delete(n), n.includes("-") ? i.removeProperty(n) : i[n] = null);
    for (const n in t) {
      const r = t[n];
      if (r != null) {
        this.ft.add(n);
        const a = typeof r == "string" && r.endsWith(JN);
        n.includes("-") || a ? i.setProperty(n, a ? r.slice(0, -11) : r, a ? QE : "") : i[n] = r;
      }
    }
    return pn;
  }
});
function km(s) {
  const t = s;
  t && (t.complete && t.naturalHeight !== 0 ? t.classList.contains("wy-loading") ? t.decode().then(() => {
    t.classList.add("wy-loaded"), t.part.add("wy-loaded");
  }) : (t.classList.add("wy-loading", "wy-loaded"), t.part.add("wy-loading", "wy-loaded")) : (t.classList.add("wy-loading"), t.part.add("wy-loading")));
}
u(km, "Qc");
p(km, "checkImageLoad");
function Sm(s) {
  const t = s.target;
  t.tagName === "IMG" && t.classList.contains("wy-loading") && !t.classList.contains("wy-loaded") && (t.classList.add("wy-loaded"), t.part.add("wy-loaded"));
}
u(Sm, "Kc");
p(Sm, "imageLoaded");
var eB = Object.defineProperty, tB = Object.getOwnPropertyDescriptor, _5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? tB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && eB(t, i, r), r;
}, "__decorateClass$Y"), rb, Lu;
let Of = (rb = (Lu = class extends G {
  constructor() {
    super(...arguments), this.images = [], this.limit = 3;
  }
  //protected exportParts = new ShadowPartsController(this);
  createRenderRoot() {
    return this;
  }
  dispatchFileOpen(t, i) {
    if (t.preventDefault(), !i.is_trashed) {
      const n = new CustomEvent("file-open", { detail: { fileId: i.id } });
      this.dispatchEvent(n);
    }
  }
  render() {
    const t = this.images.length > this.limit ? this.images.length - this.limit : 0, i = this.images.slice(0, this.limit);
    return O`
      <div class="wy-image-grid">
        ${i.map((n, r) => {
      const a = n.width && n.height ? n.width / n.height : 1, o = 64, l = 2, c = a.toPrecision(5), h = (a * o).toPrecision(5) + "px", d = (100 / a).toPrecision(5) + "%", f = n.width + "px", y = n.width && n.width > 0 ? l * n.width + "px" : "none";
      return n.preview_url ? O`
            <a
              href="#"
              @click=${(w) => {
        !w.defaultPrevented && this.dispatchFileOpen(w, n);
      }}
              class="wy-image"
              style=${x1({
        flexBasis: h,
        flexGrow: c,
        flexShrink: c,
        width: f,
        maxWidth: y
      })}>
              <div class="wy-image-area" style=${x1({ paddingBottom: d })}>
                <img
                  src=${n.preview_url}
                  ${pe(km)}
                  @load=${Sm}
                  alt=""
                  loading="lazy"
                  decoding="async" />
                ${r === i.length - 1 && t ? O`<span class="wy-more">+${t}</span>` : ""}
              </div>
            </a>
          ` : M;
    })}
      </div>
    `;
  }
}, u(Lu, "Sn"), Lu), p(rb, "WyImageGrid"), rb);
Of.styles = fe;
_5([
  x({ attribute: !1 })
], Of.prototype, "images", 2);
_5([
  x({ type: Number })
], Of.prototype, "limit", 2);
Of = _5([
  F("wy-image-grid")
], Of);
var iB = Object.defineProperty, nB = Object.getOwnPropertyDescriptor, L5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? nB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && iB(t, i, r), r;
}, "__decorateClass$X"), ab, Iu;
let bf = (ab = (Iu = class extends G {
  constructor() {
    super(...arguments), this.files = [], this.limit = 3;
  }
  //protected exportParts = new ShadowPartsController(this);
  createRenderRoot() {
    return this;
  }
  dispatchFileOpen(t, i) {
    t.preventDefault();
    const n = new CustomEvent("file-open", { detail: { fileId: i.id } });
    return this.dispatchEvent(n);
  }
  render() {
    return O`
      <div class="wy-list wy-list-bordered">
        ${this.files.map((t) => {
      const i = t.size && t.size > 0 ? fv(t.size) : null, n = Gi(t.name), { icon: r } = Ls(t.name), a = mv(t.name), o = Uo(t.provider);
      return O`
            <a
              @click=${(l) => {
        !l.defaultPrevented && !t.is_trashed && this.dispatchFileOpen(l, t);
      }}
              class="wy-item wy-list-item"
              href="${Me(t.download_url)}"
              title=${t.name}>
              <wy-icon name=${r} .overlayName=${o} size="48" kind=${a} ext=${n}></wy-icon>
              <div class="wy-item-body ">
                <div class="wy-item-title">${t.name}</div>
                ${i ? O`<div class="wy-item-text" title="${i}">${i}</div>` : ""}
              </div>
            </a>
          `;
    })}
      </div>
    `;
  }
}, u(Iu, "En"), Iu), p(ab, "WyAttachmentsList"), ab);
bf.styles = fe;
L5([
  x({ attribute: !1 })
], bf.prototype, "files", 2);
L5([
  x({ type: Number })
], bf.prototype, "limit", 2);
bf = L5([
  F("wy-attachments-list")
], bf);
const k1 = Math.min, Ta = Math.max, S1 = Math.round, Lw = Math.floor, Nn = /* @__PURE__ */ p((s) => ({
  x: s,
  y: s
}), "createCoords"), sB = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, rB = {
  start: "end",
  end: "start"
};
function C$(s, t, i) {
  return Ta(s, k1(t, i));
}
u(C$, "$u");
p(C$, "clamp");
function sw(s, t) {
  return typeof s == "function" ? s(t) : s;
}
u(sw, "xl");
p(sw, "evaluate");
function Lr(s) {
  return s.split("-")[0];
}
u(Lr, "Ws");
p(Lr, "getSide");
function rw(s) {
  return s.split("-")[1];
}
u(rw, "$l");
p(rw, "getAlignment");
function I5(s) {
  return s === "x" ? "y" : "x";
}
u(I5, "mw");
p(I5, "getOppositeAxis");
function W5(s) {
  return s === "y" ? "height" : "width";
}
u(W5, "vw");
p(W5, "getAxisLength");
function Qo(s) {
  return ["top", "bottom"].includes(Lr(s)) ? "y" : "x";
}
u(Qo, "Za");
p(Qo, "getSideAxis");
function V5(s) {
  return I5(Qo(s));
}
u(V5, "gw");
p(V5, "getAlignmentAxis");
function TE(s, t, i) {
  i === void 0 && (i = !1);
  const n = rw(s), r = V5(s), a = W5(r);
  let o = r === "x" ? n === (i ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = Pm(o)), [o, Pm(o)];
}
u(TE, "o0");
p(TE, "getAlignmentSides");
function ME(s) {
  const t = Pm(s);
  return [P1(s), t, P1(t)];
}
u(ME, "c0");
p(ME, "getExpandedPlacements");
function P1(s) {
  return s.replace(/start|end/g, (t) => rB[t]);
}
u(P1, "yh");
p(P1, "getOppositeAlignmentPlacement");
function RE(s, t, i) {
  const n = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (s) {
    case "top":
    case "bottom":
      return i ? t ? r : n : t ? n : r;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
u(RE, "l0");
p(RE, "getSideList");
function AE(s, t, i, n) {
  const r = rw(s);
  let a = RE(Lr(s), i === "start", n);
  return r && (a = a.map((o) => o + "-" + r), t && (a = a.concat(a.map(P1)))), a;
}
u(AE, "d0");
p(AE, "getOppositeAxisPlacements");
function Pm(s) {
  return s.replace(/left|right|bottom|top/g, (t) => sB[t]);
}
u(Pm, "Zc");
p(Pm, "getOppositePlacement");
function EE(s) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...s
  };
}
u(EE, "h0");
p(EE, "expandPaddingObject");
function zE(s) {
  return typeof s != "number" ? EE(s) : {
    top: s,
    right: s,
    bottom: s,
    left: s
  };
}
u(zE, "p0");
p(zE, "getPaddingObject");
function Cm(s) {
  const {
    x: t,
    y: i,
    width: n,
    height: r
  } = s;
  return {
    width: n,
    height: r,
    top: i,
    left: t,
    right: t + n,
    bottom: i + r,
    x: t,
    y: i
  };
}
u(Cm, "Xc");
p(Cm, "rectToClientRect");
function Q$(s, t, i) {
  let {
    reference: n,
    floating: r
  } = s;
  const a = Qo(t), o = V5(t), l = W5(o), c = Lr(t), h = a === "y", d = n.x + n.width / 2 - r.width / 2, f = n.y + n.height / 2 - r.height / 2, y = n[l] / 2 - r[l] / 2;
  let w;
  switch (c) {
    case "top":
      w = {
        x: d,
        y: n.y - r.height
      };
      break;
    case "bottom":
      w = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      w = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      w = {
        x: n.x - r.width,
        y: f
      };
      break;
    default:
      w = {
        x: n.x,
        y: n.y
      };
  }
  switch (rw(t)) {
    case "start":
      w[o] -= y * (i && h ? -1 : 1);
      break;
    case "end":
      w[o] += y * (i && h ? -1 : 1);
      break;
  }
  return w;
}
u(Q$, "ku");
p(Q$, "computeCoordsFromPlacement");
const aB = /* @__PURE__ */ p(async (s, t, i) => {
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: o
  } = i, l = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let h = await o.getElementRects({
    reference: s,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: f
  } = Q$(h, n, c), y = n, w = {}, g = 0;
  for (let b = 0; b < l.length; b++) {
    const {
      name: k,
      fn: $
    } = l[b], {
      x: C,
      y: E,
      data: A,
      reset: R
    } = await $({
      x: d,
      y: f,
      initialPlacement: n,
      placement: y,
      strategy: r,
      middlewareData: w,
      rects: h,
      platform: o,
      elements: {
        reference: s,
        floating: t
      }
    });
    d = C ?? d, f = E ?? f, w = {
      ...w,
      [k]: {
        ...w[k],
        ...A
      }
    }, R && g <= 50 && (g++, typeof R == "object" && (R.placement && (y = R.placement), R.rects && (h = R.rects === !0 ? await o.getElementRects({
      reference: s,
      floating: t,
      strategy: r
    }) : R.rects), {
      x: d,
      y: f
    } = Q$(h, y, c)), b = -1);
  }
  return {
    x: d,
    y: f,
    placement: y,
    strategy: r,
    middlewareData: w
  };
}, "computePosition$1");
async function Z5(s, t) {
  var i;
  t === void 0 && (t = {});
  const {
    x: n,
    y: r,
    platform: a,
    rects: o,
    elements: l,
    strategy: c
  } = s, {
    boundary: h = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: y = !1,
    padding: w = 0
  } = sw(t, s), g = zE(w), b = l[y ? f === "floating" ? "reference" : "floating" : f], k = Cm(await a.getClippingRect({
    element: (i = await (a.isElement == null ? void 0 : a.isElement(b))) == null || i ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: h,
    rootBoundary: d,
    strategy: c
  })), $ = f === "floating" ? {
    x: n,
    y: r,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), E = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = Cm(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: $,
    offsetParent: C,
    strategy: c
  }) : $);
  return {
    top: (k.top - A.top + g.top) / E.y,
    bottom: (A.bottom - k.bottom + g.bottom) / E.y,
    left: (k.left - A.left + g.left) / E.x,
    right: (A.right - k.right + g.right) / E.x
  };
}
u(Z5, "bw");
p(Z5, "detectOverflow");
const oB = /* @__PURE__ */ p(function(s) {
  return s === void 0 && (s = {}), {
    name: "flip",
    options: s,
    async fn(t) {
      var i, n;
      const {
        placement: r,
        middlewareData: a,
        rects: o,
        initialPlacement: l,
        platform: c,
        elements: h
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: y,
        fallbackStrategy: w = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: b = !0,
        ...k
      } = sw(s, t);
      if ((i = a.arrow) != null && i.alignmentOffset)
        return {};
      const $ = Lr(r), C = Qo(l), E = Lr(l) === l, A = await (c.isRTL == null ? void 0 : c.isRTL(h.floating)), R = y || (E || !b ? [Pm(l)] : ME(l)), L = g !== "none";
      !y && L && R.push(...AE(l, b, g, A));
      const I = [l, ...R], D = await Z5(t, k), j = [];
      let ee = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (d && j.push(D[$]), f) {
        const re = TE(r, o, A);
        j.push(D[re[0]], D[re[1]]);
      }
      if (ee = [...ee, {
        placement: r,
        overflows: j
      }], !j.every((re) => re <= 0)) {
        var se, oe;
        const re = (((se = a.flip) == null ? void 0 : se.index) || 0) + 1, _e = I[re];
        if (_e)
          return {
            data: {
              index: re,
              overflows: ee
            },
            reset: {
              placement: _e
            }
          };
        let Pe = (oe = ee.filter((He) => He.overflows[0] <= 0).sort((He, We) => He.overflows[1] - We.overflows[1])[0]) == null ? void 0 : oe.placement;
        if (!Pe)
          switch (w) {
            case "bestFit": {
              var we;
              const He = (we = ee.filter((We) => {
                if (L) {
                  const ft = Qo(We.placement);
                  return ft === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ft === "y";
                }
                return !0;
              }).map((We) => [We.placement, We.overflows.filter((ft) => ft > 0).reduce((ft, Ct) => ft + Ct, 0)]).sort((We, ft) => We[1] - ft[1])[0]) == null ? void 0 : we[0];
              He && (Pe = He);
              break;
            }
            case "initialPlacement":
              Pe = l;
              break;
          }
        if (r !== Pe)
          return {
            reset: {
              placement: Pe
            }
          };
      }
      return {};
    }
  };
}, "flip$1");
async function _E(s, t) {
  const {
    placement: i,
    platform: n,
    elements: r
  } = s, a = await (n.isRTL == null ? void 0 : n.isRTL(r.floating)), o = Lr(i), l = rw(i), c = Qo(i) === "y", h = ["left", "top"].includes(o) ? -1 : 1, d = a && c ? -1 : 1, f = sw(t, s);
  let {
    mainAxis: y,
    crossAxis: w,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return l && typeof g == "number" && (w = l === "end" ? g * -1 : g), c ? {
    x: w * d,
    y: y * h
  } : {
    x: y * h,
    y: w * d
  };
}
u(_E, "w0");
p(_E, "convertValueToCoords");
const lB = /* @__PURE__ */ p(function(s) {
  return s === void 0 && (s = 0), {
    name: "offset",
    options: s,
    async fn(t) {
      var i, n;
      const {
        x: r,
        y: a,
        placement: o,
        middlewareData: l
      } = t, c = await _E(t, s);
      return o === ((i = l.offset) == null ? void 0 : i.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: r + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, "offset$1"), cB = /* @__PURE__ */ p(function(s) {
  return s === void 0 && (s = {}), {
    name: "shift",
    options: s,
    async fn(t) {
      const {
        x: i,
        y: n,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: /* @__PURE__ */ p((k) => {
            let {
              x: $,
              y: C
            } = k;
            return {
              x: $,
              y: C
            };
          }, "fn")
        },
        ...c
      } = sw(s, t), h = {
        x: i,
        y: n
      }, d = await Z5(t, c), f = Qo(Lr(r)), y = I5(f);
      let w = h[y], g = h[f];
      if (a) {
        const k = y === "y" ? "top" : "left", $ = y === "y" ? "bottom" : "right", C = w + d[k], E = w - d[$];
        w = C$(C, w, E);
      }
      if (o) {
        const k = f === "y" ? "top" : "left", $ = f === "y" ? "bottom" : "right", C = g + d[k], E = g - d[$];
        g = C$(C, g, E);
      }
      const b = l.fn({
        ...t,
        [y]: w,
        [f]: g
      });
      return {
        ...b,
        data: {
          x: b.x - i,
          y: b.y - n
        }
      };
    }
  };
}, "shift$1");
function aw() {
  return typeof window < "u";
}
u(aw, "kl");
p(aw, "hasWindow");
function No(s) {
  return D5(s) ? (s.nodeName || "").toLowerCase() : "#document";
}
u(No, "fo");
p(No, "getNodeName");
function Oi(s) {
  var t;
  return (s == null || (t = s.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
u(Oi, "Le");
p(Oi, "getWindow");
function $n(s) {
  var t;
  return (t = (D5(s) ? s.ownerDocument : s.document) || window.document) == null ? void 0 : t.documentElement;
}
u($n, "Ci");
p($n, "getDocumentElement");
function D5(s) {
  return aw() ? s instanceof Node || s instanceof Oi(s).Node : !1;
}
u(D5, "xw");
p(D5, "isNode");
function Fi(s) {
  return aw() ? s instanceof Element || s instanceof Oi(s).Element : !1;
}
u(Fi, "Xe");
p(Fi, "isElement");
function fn(s) {
  return aw() ? s instanceof HTMLElement || s instanceof Oi(s).HTMLElement : !1;
}
u(fn, "bi");
p(fn, "isHTMLElement");
function T$(s) {
  return !aw() || typeof ShadowRoot > "u" ? !1 : s instanceof ShadowRoot || s instanceof Oi(s).ShadowRoot;
}
u(T$, "Cu");
p(T$, "isShadowRoot");
function Df(s) {
  const {
    overflow: t,
    overflowX: i,
    overflowY: n,
    display: r
  } = Hi(s);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + i) && !["inline", "contents"].includes(r);
}
u(Df, "uc");
p(Df, "isOverflowElement");
function LE(s) {
  return ["table", "td", "th"].includes(No(s));
}
u(LE, "v0");
p(LE, "isTableElement");
function ow(s) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return s.matches(t);
    } catch {
      return !1;
    }
  });
}
u(ow, "Cl");
p(ow, "isTopLayer");
function gv(s) {
  const t = vv(), i = Fi(s) ? Hi(s) : s;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => i[n] ? i[n] !== "none" : !1) || (i.containerType ? i.containerType !== "normal" : !1) || !t && (i.backdropFilter ? i.backdropFilter !== "none" : !1) || !t && (i.filter ? i.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (i.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (i.contain || "").includes(n));
}
u(gv, "Jh");
p(gv, "isContainingBlock");
function IE(s) {
  let t = Ts(s);
  for (; fn(t) && !To(t); ) {
    if (gv(t))
      return t;
    if (ow(t))
      return null;
    t = Ts(t);
  }
  return null;
}
u(IE, "g0");
p(IE, "getContainingBlock");
function vv() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
u(vv, "tp");
p(vv, "isWebKit");
function To(s) {
  return ["html", "body", "#document"].includes(No(s));
}
u(To, "Xa");
p(To, "isLastTraversableNode");
function Hi(s) {
  return Oi(s).getComputedStyle(s);
}
u(Hi, "Je");
p(Hi, "getComputedStyle$1");
function lw(s) {
  return Fi(s) ? {
    scrollLeft: s.scrollLeft,
    scrollTop: s.scrollTop
  } : {
    scrollLeft: s.scrollX,
    scrollTop: s.scrollY
  };
}
u(lw, "_l");
p(lw, "getNodeScroll");
function Ts(s) {
  if (No(s) === "html")
    return s;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    s.assignedSlot || // DOM Element detected.
    s.parentNode || // ShadowRoot detected.
    T$(s) && s.host || // Fallback.
    $n(s)
  );
  return T$(t) ? t.host : t;
}
u(Ts, "cs");
p(Ts, "getParentNode");
function q5(s) {
  const t = Ts(s);
  return To(t) ? s.ownerDocument ? s.ownerDocument.body : s.body : fn(t) && Df(t) ? t : q5(t);
}
u(q5, "$w");
p(q5, "getNearestOverflowAncestor");
function $f(s, t, i) {
  var n;
  t === void 0 && (t = []), i === void 0 && (i = !0);
  const r = q5(s), a = r === ((n = s.ownerDocument) == null ? void 0 : n.body), o = Oi(r);
  if (a) {
    const l = C1(o);
    return t.concat(o, o.visualViewport || [], Df(r) ? r : [], l && i ? $f(l) : []);
  }
  return t.concat(r, $f(r, [], i));
}
u($f, "Lo");
p($f, "getOverflowAncestors");
function C1(s) {
  return s.parent && Object.getPrototypeOf(s.parent) ? s.frameElement : null;
}
u(C1, "wh");
p(C1, "getFrameElement");
function U5(s) {
  const t = Hi(s);
  let i = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const r = fn(s), a = r ? s.offsetWidth : i, o = r ? s.offsetHeight : n, l = S1(i) !== a || S1(n) !== o;
  return l && (i = a, n = o), {
    width: i,
    height: n,
    $: l
  };
}
u(U5, "kw");
p(U5, "getCssDimensions");
function Ov(s) {
  return Fi(s) ? s : s.contextElement;
}
u(Ov, "ep");
p(Ov, "unwrapElement");
function Ma(s) {
  const t = Ov(s);
  if (!fn(t))
    return Nn(1);
  const i = t.getBoundingClientRect(), {
    width: n,
    height: r,
    $: a
  } = U5(t);
  let o = (a ? S1(i.width) : i.width) / n, l = (a ? S1(i.height) : i.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: o,
    y: l
  };
}
u(Ma, "Or");
p(Ma, "getScale");
const hB = /* @__PURE__ */ Nn(0);
function N5(s) {
  const t = Oi(s);
  return !vv() || !t.visualViewport ? hB : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
u(N5, "Cw");
p(N5, "getVisualOffsets");
function WE(s, t, i) {
  return t === void 0 && (t = !1), !i || t && i !== Oi(s) ? !1 : t;
}
u(WE, "x0");
p(WE, "shouldAddVisualOffsets");
function Ir(s, t, i, n) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  const r = s.getBoundingClientRect(), a = Ov(s);
  let o = Nn(1);
  t && (n ? Fi(n) && (o = Ma(n)) : o = Ma(s));
  const l = WE(a, i, n) ? N5(a) : Nn(0);
  let c = (r.left + l.x) / o.x, h = (r.top + l.y) / o.y, d = r.width / o.x, f = r.height / o.y;
  if (a) {
    const y = Oi(a), w = n && Fi(n) ? Oi(n) : n;
    let g = y, b = C1(g);
    for (; b && n && w !== g; ) {
      const k = Ma(b), $ = b.getBoundingClientRect(), C = Hi(b), E = $.left + (b.clientLeft + parseFloat(C.paddingLeft)) * k.x, A = $.top + (b.clientTop + parseFloat(C.paddingTop)) * k.y;
      c *= k.x, h *= k.y, d *= k.x, f *= k.y, c += E, h += A, g = Oi(b), b = C1(g);
    }
  }
  return Cm({
    width: d,
    height: f,
    x: c,
    y: h
  });
}
u(Ir, "Qs");
p(Ir, "getBoundingClientRect");
function bv(s, t) {
  const i = lw(s).scrollLeft;
  return t ? t.left + i : Ir($n(s)).left + i;
}
u(bv, "ip");
p(bv, "getWindowScrollBarX");
function B5(s, t, i) {
  i === void 0 && (i = !1);
  const n = s.getBoundingClientRect(), r = n.left + t.scrollLeft - (i ? 0 : (
    // RTL <body> scrollbar.
    bv(s, n)
  )), a = n.top + t.scrollTop;
  return {
    x: r,
    y: a
  };
}
u(B5, "_w");
p(B5, "getHTMLOffset");
function VE(s) {
  let {
    elements: t,
    rect: i,
    offsetParent: n,
    strategy: r
  } = s;
  const a = r === "fixed", o = $n(n), l = t ? ow(t.floating) : !1;
  if (n === o || l && a)
    return i;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Nn(1);
  const d = Nn(0), f = fn(n);
  if ((f || !f && !a) && ((No(n) !== "body" || Df(o)) && (c = lw(n)), fn(n))) {
    const w = Ir(n);
    h = Ma(n), d.x = w.x + n.clientLeft, d.y = w.y + n.clientTop;
  }
  const y = o && !f && !a ? B5(o, c, !0) : Nn(0);
  return {
    width: i.width * h.x,
    height: i.height * h.y,
    x: i.x * h.x - c.scrollLeft * h.x + d.x + y.x,
    y: i.y * h.y - c.scrollTop * h.y + d.y + y.y
  };
}
u(VE, "$0");
p(VE, "convertOffsetParentRelativeRectToViewportRelativeRect");
function ZE(s) {
  return Array.from(s.getClientRects());
}
u(ZE, "k0");
p(ZE, "getClientRects");
function DE(s) {
  const t = $n(s), i = lw(s), n = s.ownerDocument.body, r = Ta(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = Ta(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -i.scrollLeft + bv(s);
  const l = -i.scrollTop;
  return Hi(n).direction === "rtl" && (o += Ta(t.clientWidth, n.clientWidth) - r), {
    width: r,
    height: a,
    x: o,
    y: l
  };
}
u(DE, "C0");
p(DE, "getDocumentRect");
function qE(s, t) {
  const i = Oi(s), n = $n(s), r = i.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, l = 0, c = 0;
  if (r) {
    a = r.width, o = r.height;
    const h = vv();
    (!h || h && t === "fixed") && (l = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: l,
    y: c
  };
}
u(qE, "_0");
p(qE, "getViewportRect");
function UE(s, t) {
  const i = Ir(s, !0, t === "fixed"), n = i.top + s.clientTop, r = i.left + s.clientLeft, a = fn(s) ? Ma(s) : Nn(1), o = s.clientWidth * a.x, l = s.clientHeight * a.y, c = r * a.x, h = n * a.y;
  return {
    width: o,
    height: l,
    x: c,
    y: h
  };
}
u(UE, "P0");
p(UE, "getInnerBoundingClientRect");
function M$(s, t, i) {
  let n;
  if (t === "viewport")
    n = qE(s, i);
  else if (t === "document")
    n = DE($n(s));
  else if (Fi(t))
    n = UE(t, i);
  else {
    const r = N5(s);
    n = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Cm(n);
}
u(M$, "_u");
p(M$, "getClientRectFromClippingAncestor");
function j5(s, t) {
  const i = Ts(s);
  return i === t || !Fi(i) || To(i) ? !1 : Hi(i).position === "fixed" || j5(i, t);
}
u(j5, "Pw");
p(j5, "hasFixedPositionAncestor");
function NE(s, t) {
  const i = t.get(s);
  if (i)
    return i;
  let n = $f(s, [], !1).filter((l) => Fi(l) && No(l) !== "body"), r = null;
  const a = Hi(s).position === "fixed";
  let o = a ? Ts(s) : s;
  for (; Fi(o) && !To(o); ) {
    const l = Hi(o), c = gv(o);
    !c && l.position === "fixed" && (r = null), (a ? !c && !r : !c && l.position === "static" && r && ["absolute", "fixed"].includes(r.position) || Df(o) && !c && j5(s, o)) ? n = n.filter((h) => h !== o) : r = l, o = Ts(o);
  }
  return t.set(s, n), n;
}
u(NE, "M0");
p(NE, "getClippingElementAncestors");
function BE(s) {
  let {
    element: t,
    boundary: i,
    rootBoundary: n,
    strategy: r
  } = s;
  const a = [...i === "clippingAncestors" ? ow(t) ? [] : NE(t, this._c) : [].concat(i), n], o = a[0], l = a.reduce((c, h) => {
    const d = M$(t, h, r);
    return c.top = Ta(d.top, c.top), c.right = k1(d.right, c.right), c.bottom = k1(d.bottom, c.bottom), c.left = Ta(d.left, c.left), c;
  }, M$(t, o, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
u(BE, "z0");
p(BE, "getClippingRect");
function jE(s) {
  const {
    width: t,
    height: i
  } = U5(s);
  return {
    width: t,
    height: i
  };
}
u(jE, "S0");
p(jE, "getDimensions");
function XE(s, t, i) {
  const n = fn(t), r = $n(t), a = i === "fixed", o = Ir(s, !0, a, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Nn(0);
  if (n || !n && !a)
    if ((No(t) !== "body" || Df(r)) && (l = lw(t)), n) {
      const y = Ir(t, !0, a, t);
      c.x = y.x + t.clientLeft, c.y = y.y + t.clientTop;
    } else r && (c.x = bv(r));
  const h = r && !n && !a ? B5(r, l) : Nn(0), d = o.left + l.scrollLeft - c.x - h.x, f = o.top + l.scrollTop - c.y - h.y;
  return {
    x: d,
    y: f,
    width: o.width,
    height: o.height
  };
}
u(XE, "E0");
p(XE, "getRectRelativeToOffsetParent");
function bg(s) {
  return Hi(s).position === "static";
}
u(bg, "Md");
p(bg, "isStaticPositioned");
function R$(s, t) {
  if (!fn(s) || Hi(s).position === "fixed")
    return null;
  if (t)
    return t(s);
  let i = s.offsetParent;
  return $n(s) === i && (i = i.ownerDocument.body), i;
}
u(R$, "Pu");
p(R$, "getTrueOffsetParent");
function X5(s, t) {
  const i = Oi(s);
  if (ow(s))
    return i;
  if (!fn(s)) {
    let r = Ts(s);
    for (; r && !To(r); ) {
      if (Fi(r) && !bg(r))
        return r;
      r = Ts(r);
    }
    return i;
  }
  let n = R$(s, t);
  for (; n && LE(n) && bg(n); )
    n = R$(n, t);
  return n && To(n) && bg(n) && !gv(n) ? i : n || IE(s) || i;
}
u(X5, "Mw");
p(X5, "getOffsetParent");
const dB = /* @__PURE__ */ p(async function(s) {
  const t = this.getOffsetParent || X5, i = this.getDimensions, n = await i(s.floating);
  return {
    reference: XE(s.reference, await t(s.floating), s.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
}, "getElementRects");
function FE(s) {
  return Hi(s).direction === "rtl";
}
u(FE, "A0");
p(FE, "isRTL");
const uB = {
  convertOffsetParentRelativeRectToViewportRelativeRect: VE,
  getDocumentElement: $n,
  getClippingRect: BE,
  getOffsetParent: X5,
  getElementRects: dB,
  getClientRects: ZE,
  getDimensions: jE,
  getScale: Ma,
  isElement: Fi,
  isRTL: FE
};
function F5(s, t) {
  return s.x === t.x && s.y === t.y && s.width === t.width && s.height === t.height;
}
u(F5, "zw");
p(F5, "rectsAreEqual");
function HE(s, t) {
  let i = null, n;
  const r = $n(s);
  function a() {
    var l;
    clearTimeout(n), (l = i) == null || l.disconnect(), i = null;
  }
  u(a, "a"), p(a, "cleanup");
  function o(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), a();
    const h = s.getBoundingClientRect(), {
      left: d,
      top: f,
      width: y,
      height: w
    } = h;
    if (l || t(), !y || !w)
      return;
    const g = Lw(f), b = Lw(r.clientWidth - (d + y)), k = Lw(r.clientHeight - (f + w)), $ = Lw(d), C = {
      rootMargin: -g + "px " + -b + "px " + -k + "px " + -$ + "px",
      threshold: Ta(0, k1(1, c)) || 1
    };
    let E = !0;
    function A(R) {
      const L = R[0].intersectionRatio;
      if (L !== c) {
        if (!E)
          return o();
        L ? o(!1, L) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !F5(h, s.getBoundingClientRect()) && o(), E = !1;
    }
    u(A, "O"), p(A, "handleObserve");
    try {
      i = new IntersectionObserver(A, {
        ...C,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      i = new IntersectionObserver(A, C);
    }
    i.observe(s);
  }
  return u(o, "o"), p(o, "refresh"), o(!0), a;
}
u(HE, "R0");
p(HE, "observeMove");
function H5(s, t, i, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, h = Ov(s), d = r || a ? [...h ? $f(h) : [], ...$f(t)] : [];
  d.forEach(($) => {
    r && $.addEventListener("scroll", i, {
      passive: !0
    }), a && $.addEventListener("resize", i);
  });
  const f = h && l ? HE(h, i) : null;
  let y = -1, w = null;
  o && (w = new ResizeObserver(($) => {
    let [C] = $;
    C && C.target === h && w && (w.unobserve(t), cancelAnimationFrame(y), y = requestAnimationFrame(() => {
      var E;
      (E = w) == null || E.observe(t);
    })), i();
  }), h && !c && w.observe(h), w.observe(t));
  let g, b = c ? Ir(s) : null;
  c && k();
  function k() {
    const $ = Ir(s);
    b && !F5(b, $) && i(), b = $, g = requestAnimationFrame(k);
  }
  return u(k, "S"), p(k, "frameLoop"), i(), () => {
    var $;
    d.forEach((C) => {
      r && C.removeEventListener("scroll", i), a && C.removeEventListener("resize", i);
    }), f == null || f(), ($ = w) == null || $.disconnect(), w = null, c && cancelAnimationFrame(g);
  };
}
u(H5, "Sw");
p(H5, "autoUpdate");
const YE = lB, GE = cB, KE = oB, JE = /* @__PURE__ */ p((s, t, i) => {
  const n = /* @__PURE__ */ new Map(), r = {
    platform: uB,
    ...i
  }, a = {
    ...r.platform,
    _c: n
  };
  return aB(s, t, {
    ...r,
    platform: a
  });
}, "computePosition");
function ez(s, t, i, n, r, a, o) {
  return new Ve(s.queryClient, {
    mutationFn: /* @__PURE__ */ p(async () => await s.fetch(`/api/${r}/${n}/reactions`, {
      method: a ? "POST" : "DELETE",
      body: JSON.stringify({ content: a })
    }), "mutationFn"),
    onMutate: /* @__PURE__ */ p(() => {
      const l = i === "apps" && r === "posts" ? [r, t] : [i, t, r];
      Fe(s.queryClient, l, n, (c) => {
        xf(c, a, o);
      });
    }, "onMutate")
  });
}
u(ez, "I0");
p(ez, "reactionMutation");
function tz(s, t, i) {
  return {
    queryKey: [t, i, "reactions"],
    enabled: !1,
    queryFn: /* @__PURE__ */ p(async () => await (await s.fetch("/api/" + t + "/" + i + "/reactions")).json(), "queryFn")
  };
}
u(tz, "T0");
p(tz, "getReactionListOptions");
function xf(s, t, i) {
  var n;
  return !t && !((n = s.reactions) != null && n.data) || (s.reactions || (s.reactions = { count: 0, data: [] }), s.reactions.data || (s.reactions.data = []), t ? s.reactions.data = [
    ...s.reactions.data.filter((r) => {
      var a;
      return ((a = r.created_by) == null ? void 0 : a.id) !== i.id;
    }),
    { content: t, created_by: i }
  ] : s.reactions.data && (s.reactions.data = [...s.reactions.data.filter((r) => {
    var a;
    return ((a = r.created_by) == null ? void 0 : a.id) !== i.id;
  })])), s;
}
u(xf, "Ro");
p(xf, "updateReaction");
var pB = Object.defineProperty, fB = Object.getOwnPropertyDescriptor, Y5 = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? fB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && pB(t, i, r), r;
}, "__decorateClass$W"), ob, Wu;
let kf = (ob = (Wu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.noPadding = !1, this.show = !1, this.viewportRef = ke();
  }
  close() {
    var t, i, n;
    this.show = !1;
    try {
      (t = this.viewportRef.value) != null && t.popover ? (i = this.viewportRef.value) == null || i.hidePopover() : (n = this.viewportRef.value) == null || n.close();
    } catch {
    }
  }
  handleClose(t) {
    (t.type === "toggle" && t.newState === "closed" || t.type === "close") && (this.show = !1, this.dispatchEvent(new CustomEvent("close")), this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 })));
  }
  willUpdate(t) {
    super.willUpdate(t);
  }
  render() {
    return O`
      <dialog class="wy-dialog" tabindex="0" ${pe(this.viewportRef)} popover>
        <div class="wy-sheet ${this.show ? "wy-show" : ""}">
          <slot name="header">
            <header class="wy-appbars">
              <nav class="wy-appbar">
                <wy-button kind="icon" @click=${() => this.close()}>
                  <wy-icon name="close"></wy-icon>
                </wy-button>
                <slot name="appbar-text" class="wy-appbar-text"></slot>
                <slot name="appbar-buttons" class="wy-appbar-buttons wy-appbar-buttons-last"></slot>
              </nav>
            </header>
          </slot>
          <div class="wy-sheet-body wy-scroll-y ${this.noPadding ? "wy-sheet-no-padding" : ""}">
            <slot></slot>
          </div>
        </div>
      </dialog>
    `;
  }
  updated(t) {
    var i, n, r, a, o, l, c;
    if (t.has("show"))
      try {
        this.show ? (i = this.viewportRef.value) != null && i.popover ? (n = this.viewportRef.value) == null || n.showPopover() : (r = this.viewportRef.value) == null || r.show() : (a = this.viewportRef.value) != null && a.popover ? (o = this.viewportRef.value) == null || o.hidePopover() : (l = this.viewportRef.value) == null || l.close();
      } catch {
      }
    t.has("show") && this.show && ((c = this.viewportRef.value) == null || c.focus());
  }
  firstUpdated(t) {
    var i;
    (i = this.viewportRef.value) == null || i.addEventListener(
      this.viewportRef.value.popover ? "toggle" : "close",
      (n) => this.handleClose(n)
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.close();
  }
}, u(Wu, "On"), Wu), p(ob, "WySheet"), ob);
kf.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
Y5([
  x({ type: Boolean })
], kf.prototype, "noPadding", 2);
Y5([
  x({ type: Boolean })
], kf.prototype, "show", 2);
kf = Y5([
  F("wy-sheet")
], kf);
const yB = de`[part~=wy-reaction]{font-size:calc(1.125 * var(--wy-size, 1rem))}[part~=wy-reactions]{display:inline-flex;align-items:center;column-gap:calc(.25 * var(--wy-size, 1rem))}[part~=wy-reactions] :first-child:not(:only-child){margin-left:calc(.25 * var(--wy-size, 1rem))}[part~=wy-reactions] :last-child:not(:only-child){margin-right:calc(.25 * var(--wy-size, 1rem))}[part~=wy-reaction-count]{margin:0 calc(.25 * var(--wy-size, 1rem)) 0;line-height:1;font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}[part~=wy-reaction-menu]{width:max-content;position:absolute;z-index:1000;border:none;--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);display:flex;margin:0;text-align:left;background-clip:padding-box;box-shadow:var(--wy-shadow-level1, 0 calc(.125 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.1875 * var(--wy-size, 1rem)) calc(.0625 * var(--wy-size, 1rem)) calc(-.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12));overflow:hidden;padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));font-size:calc(1.25 * var(--wy-size, 1rem));border-radius:var(--wy-border-radius-pill, var(--wy-border-radius, calc(2.5 * var(--wy-size, 1rem))))}[part~=wy-reaction-picker]{display:flex;flex-direction:row;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}[part~=wy-reactions-line]{display:flex;align-items:center;padding-left:calc(.1875 * var(--wy-size, 1rem));padding-right:calc(.1875 * var(--wy-size, 1rem));gap:calc(.1875 * var(--wy-size, 1rem));justify-content:end}[part~=wy-reactions-line-reverse]{flex-direction:row-reverse;justify-content:start}[part~=wy-reactions-line-bottom]{position:absolute;bottom:calc(-1 * var(--wy-size, 1rem));right:calc(.25 * var(--wy-size, 1rem));z-index:1}[part~=wy-reactions-line-below]{position:relative;height:0;min-height:0;max-height:0;margin:calc(var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))) - var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) calc(-1 * var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))) calc(-1 * var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))));padding-left:calc(.125 * var(--wy-size, 1rem));padding-right:calc(.125 * var(--wy-size, 1rem));gap:calc(.125 * var(--wy-size, 1rem));flex:1 0 auto;justify-content:flex-end}`, iz = de`.wy-item{--wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));position:relative;display:flex;align-items:center;gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));text-decoration:none}.wy-list-item{min-height:calc(3 * var(--wy-size, 1rem))}.wy-list-item-lg{min-height:calc(4.5 * var(--wy-size, 1rem))}.wy-item-inner{display:flex;align-items:center;gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));flex:1 1 100%}.wy-item-body{width:100%;min-width:0}.wy-item-rows{display:flex;flex-direction:column;width:100%;row-gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));min-width:0}.wy-item-rows:only-child{margin-inline-start:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-item-rows-compact{row-gap:0}.wy-item-rows-single{margin-inline-start:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))))}.wy-item-title{color:var(--wy-component-color);font-size:var(--wy-item-title-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-item-title-font-weight, var(--wy-font-weight, unset))}.wy-item-title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-item-title-lg{color:var(--wy-component-color);font-size:var(--wy-item-title-font-size, var(--wy-font-size, 1em));font-weight:var(--wy-item-title-font-weight, var(--wy-font-weight, unset))}.wy-item-title-lg{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.wy-item-text{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}.wy-item-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.wy-item-text .wy-icon{width:calc(1.25 * var(--wy-size, 1rem));height:calc(1.25 * var(--wy-size, 1rem));vertical-align:calc(-.3125 * var(--wy-size, 1rem))}.wy-item-quote{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e))}.wy-item-quote:before,.wy-item-quote:after{content:'\"'}.wy-item-actions{--wy-component-background-color: transparent;display:flex;align-items:center;justify-items:flex-end;flex:0 0 auto;margin:calc(-.25 * var(--wy-size, 1rem))}.wy-item-top{align-self:flex-start}.wy-item-actions-bottom{align-self:flex-start;margin-block:calc(-.5 * var(--wy-size, 1rem))}.wy-item-row{display:flex;align-items:center;column-gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))}.wy-item-row .wy-item-title,.wy-item-row .wy-item-text{margin-right:auto}.wy-item-row .wy-meta{white-space:nowrap}.wy-item-right{margin-left:auto}.wy-item-hover{-webkit-user-select:none;user-select:none;cursor:pointer}.wy-item-hover:hover,.wy-item-hover:focus{--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);text-decoration:none}.wy-item-hover:active{--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));background-color:var(--wy-component-background-color);color:var(--wy-component-color)}.wy-item-hover.wy-disabled,.wy-item-hover:disabled{opacity:var(--wy-opacity-disabled, 38%);pointer-events:none}.wy-item-hover.wy-active{--wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));--wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));background-color:var(--wy-component-background-color);color:var(--wy-component-color);border-color:var(--wy-component-background-color)}.wy-item-trashed{text-decoration:line-through;opacity:var(--wy-opacity-disabled, 38%)}.wy-item-trashed.wy-item-hover:hover{opacity:1}`, nz = de`.wy-emoji-icon{display:inline-flex;justify-content:center;align-items:center;line-height:1;width:1em;height:1em;font-size:calc(1.25 * var(--wy-size, 1rem))}.wy-emoji-icon-sm{width:calc(1.125 * var(--wy-size, 1rem));height:calc(1.125 * var(--wy-size, 1rem));font-size:calc(1.125 * var(--wy-size, 1rem))}`;
var mB = Object.defineProperty, wB = Object.getOwnPropertyDescriptor, bt = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? wB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && mB(t, i, r), r;
}, "__decorateClass$V"), lb, Vu;
let ct = (lb = (Vu = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.directionX = "left", this.directionY = "up", this.small = !1, this.reactions = [], this.emojis = [], this.parentType = "apps", this.entityType = "messages", this.line = !1, this.lineReverse = !1, this.lineBottom = !1, this.lineBelow = !1, this._placement = "bottom-start", this.show = !1, this.showSheet = !1, this.buttonRef = ke(), this.menuRef = ke(), this.reactionListQuery = new Ei(this), this._documentClickHandler = (t) => {
      var i;
      this.show && (t.preventDefault(), (i = this.menuRef.value) != null && i.popover || (this.show = !1));
    }, this.handleReaction = async (t) => {
      var i;
      if (!this.weavy || !this.parentId || !this.user)
        return;
      const n = ez(
        this.weavy,
        this.parentId,
        this.parentType,
        this.entityId,
        this.entityType,
        this.reactedEmoji === t ? void 0 : t,
        this.user
      );
      this.reactedEmoji = t, await n.mutate(), (i = this.reactionListQuery.observer) == null || i.refetch();
    };
  }
  handleClose(t) {
    (t.type === "toggle" && t.newState === "closed" || t.type === "click") && (this.show = !1, this.dispatchEvent(new CustomEvent("close")), this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 })));
  }
  handleClickToggle(t) {
    t.stopPropagation(), this.show = !this.show;
  }
  handleReactionsClick() {
    var t;
    (t = this.reactionListQuery.observer) == null || t.refetch(), this.showSheet = !this.showSheet, this.show = !1;
  }
  willUpdate(t) {
    var i, n, r, a, o;
    if (super.willUpdate(t), (t.has("weavy") || t.has("entityId") || t.has("showSheet")) && this.weavy && this.entityId && this.showSheet && this.reactionListQuery.trackQuery(tz(this.weavy, this.entityType, this.entityId)), (t.has("reactions") || t.has("user")) && this.user && (this.reactedEmoji = (n = (i = this.reactions) == null ? void 0 : i.find((l) => {
      var c, h;
      return ((c = l.created_by) == null ? void 0 : c.id) === ((h = this.user) == null ? void 0 : h.id);
    })) == null ? void 0 : n.content), (t.has("directionX") || t.has("directionY")) && (this._placement = this.directionX === "right" && this.directionY === "down" ? "bottom-start" : this.directionX === "left" && this.directionY === "down" ? "bottom-end" : this.directionX === "right" && this.directionY === "up" ? "top-start" : "top-end"), t.has("show") && (this.show && !this._computePositionCleanup && this.buttonRef.value && this.menuRef.value ? this._computePositionCleanup = H5(this.buttonRef.value, this.menuRef.value, () => {
      requestAnimationFrame(() => {
        this.buttonRef.value && this.menuRef.value && JE(this.buttonRef.value, this.menuRef.value, {
          placement: this._placement,
          strategy: this.menuRef.value.popover ? "absolute" : "fixed",
          middleware: [
            KE(),
            YE({ mainAxis: 0, alignmentAxis: -8 }),
            GE({ mainAxis: !0, crossAxis: !0, padding: 4, altBoundary: !0 })
          ]
        }).then(({ x: l, y: c }) => {
          this.menuRef.value && Object.assign(this.menuRef.value.style, {
            marginLeft: `${l}px`,
            marginTop: `${c}px`,
            top: 0,
            left: 0,
            position: this.menuRef.value.popover ? void 0 : "fixed",
            zIndex: this.menuRef.value.popover ? void 0 : 1075
          });
        });
      });
    }) : !this.show && this._computePositionCleanup && (this._computePositionCleanup(), this._computePositionCleanup = void 0)), this.show) {
      requestAnimationFrame(() => {
        document.addEventListener("click", this._documentClickHandler, { once: !0, capture: !0 });
      });
      try {
        (r = this.menuRef.value) == null || r.showPopover();
      } catch {
      }
    } else
      try {
        (a = this.menuRef.value) == null || a.hidePopover();
      } catch {
      }
    t.has("weavy") && (o = this.weavy) != null && o.reactions && this.emojis != this.weavy.reactions && (this.emojis = this.weavy.reactions);
  }
  render() {
    var t, i, n;
    const { data: r, isPending: a } = this.reactionListQuery.result ?? {}, o = [
      ...new Map((t = this.reactions) == null ? void 0 : t.map((d) => [d.content, d])).values()
    ], l = O`
      ${o.length ? O`
            <wy-button
              kind="icon-inline"
              ?active=${this.showSheet}
              ?small=${this.small}
              @click=${this.handleReactionsClick}
            >
              <div part="wy-reactions">
                ${o.map((d) => {
      const f = {
        "wy-emoji-icon": !0,
        "wy-emoji-icon-sm": this.small
      };
      return O`<span class=${ot(f)} title="">${d.content}</span>`;
    })}
                ${this.reactions && ((i = this.reactions) == null ? void 0 : i.length) > 1 ? O`<small part="wy-reaction-count">${this.reactions.length}</small>` : M}
              </div>
            </wy-button>
          ` : M}

      <div ${pe(this.buttonRef)}>
        <wy-button
          part="wy-reaction-menu-button"
          kind="icon"
          ?active=${this.show}
          ?small=${this.small}
          @click=${this.handleClickToggle}
          @keydown=${ei}
          @keyup=${_i}
          title=${T("React", { desc: "Button action to react" })}
        >
          <wy-icon name="emoticon-plus" size=${this.small ? 18 : 20}></wy-icon>
        </wy-button>
      </div>

      <div
        ${pe(this.menuRef)}
        part="wy-reaction-menu"
        @click=${this.handleClickToggle}
        @keyup=${pv}
        ?hidden=${!this.show}
        ?popover=${!kg()}
      >
        <div part="wy-reaction-picker">
          ${this.emojis.map(
      (d) => O`
                <wy-button
                  kind="icon"
                  color="none"
                  ?active=${this.reactedEmoji === d}
                  @click=${() => {
        this.handleReaction(d);
      }}
                >
                  <span class="wy-emoji-icon">${d}</span>
                </wy-button>
              `
    )}
        </div>
      </div>
    `, c = O`
      ${this.weavy && this.showSheet ? O`
            <wy-sheet
              .show=${this.showSheet}
              @close=${() => this.showSheet = !1}
              @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
            >
              <span slot="appbar-text">${T("Reactions")}</span>
              <!-- <wy-spinner></wy-spinner> -->
              ${this.showSheet && r && !a ? O`
                    ${(n = r.data) == null ? void 0 : n.map((d) => O` <wy-reaction-item .reaction=${d}></wy-reaction-item> `)}
                  ` : M}
            </wy-sheet>
          ` : M}
    `, h = {
      "wy-reactions-line": !0,
      "wy-reactions-line-reverse": this.lineReverse,
      "wy-reactions-line-bottom": this.lineBottom,
      "wy-reactions-line-below": this.lineBelow
    };
    return this.line || this.lineReverse || this.lineBottom || this.lineBelow ? O`
          <div part=${At(h)}>${l}</div>
          ${c}
        ` : [l, c];
  }
  firstUpdated(t) {
    var i;
    (i = this.menuRef.value) == null || i.addEventListener(
      this.menuRef.value.popover ? "toggle" : "click",
      (n) => this.handleClose(n)
    );
  }
  disconnectedCallback() {
    var t;
    (t = this._computePositionCleanup) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Vu, "An"), Vu), p(lb, "WyReactions"), lb);
ct.styles = [
  Lt,
  yB,
  nz,
  de`
      :host {
        display: contents;
      }
    `
];
bt([
  x()
], ct.prototype, "directionX", 2);
bt([
  x()
], ct.prototype, "directionY", 2);
bt([
  x({ type: Boolean })
], ct.prototype, "small", 2);
bt([
  x({ attribute: !1 })
], ct.prototype, "reactions", 2);
bt([
  x({ attribute: !1 })
], ct.prototype, "emojis", 2);
bt([
  x({ type: String })
], ct.prototype, "parentType", 2);
bt([
  x({ attribute: !0, type: Number })
], ct.prototype, "parentId", 2);
bt([
  x({ attribute: !0, type: String })
], ct.prototype, "entityType", 2);
bt([
  x({ attribute: !0, type: Number })
], ct.prototype, "entityId", 2);
bt([
  x({ type: Boolean })
], ct.prototype, "line", 2);
bt([
  x({ type: Boolean })
], ct.prototype, "lineReverse", 2);
bt([
  x({ type: Boolean })
], ct.prototype, "lineBottom", 2);
bt([
  x({ type: Boolean })
], ct.prototype, "lineBelow", 2);
bt([
  B()
], ct.prototype, "_placement", 2);
bt([
  B()
], ct.prototype, "reactedEmoji", 2);
bt([
  B()
], ct.prototype, "show", 2);
bt([
  B()
], ct.prototype, "showSheet", 2);
ct = bt([
  F("wy-reactions"),
  be()
], ct);
var cb, Zu;
let Qm = (cb = (Zu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    var t, i, n;
    return O`
      <div class="wy-item wy-list-item">
        <wy-avatar
          .src=${(t = this.reaction.created_by) == null ? void 0 : t.avatar_url}
          .name=${(i = this.reaction.created_by) == null ? void 0 : i.display_name}
        ></wy-avatar>
        <div class="wy-item-body">${(n = this.reaction.created_by) == null ? void 0 : n.display_name}</div>
        <span class="wy-emoji-icon">${this.reaction.content}</span>
      </div>
    `;
  }
}, u(Zu, "Ln"), Zu), p(cb, "WyReactionItem"), cb);
Qm.styles = [Lt, iz, nz];
bt([
  x({ attribute: !1 })
], Qm.prototype, "reaction", 2);
Qm = bt([
  F("wy-reaction-item")
], Qm);
function Q1(s) {
  switch (s) {
    case "zoom":
      return "zoom-meetings";
    case "microsoft":
      return "microsoft-teams";
    case "google":
      return "google-meet";
  }
}
u(Q1, "fh");
p(Q1, "getMeetingIconName");
function T1(s) {
  switch (s) {
    case "zoom":
      return T("Zoom meeting");
    case "microsoft":
      return T("Teams meeting");
    case "google":
      return T("Google Meet");
  }
}
u(T1, "mh");
p(T1, "getMeetingTitle");
var gB = Object.defineProperty, vB = Object.getOwnPropertyDescriptor, sz = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? vB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && gB(t, i, r), r;
}, "__decorateClass$U"), hb, Du;
let Tm = (hb = (Du = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    const t = ((/* @__PURE__ */ new Date()).getTime() - new Date(this.meeting.created_at).getTime()) / 36e5 > 2;
    return O`
      <div class="wy-list">
        ${t ? O`<div class="wy-item wy-list-item wy-meeting wy-disabled" title="${T("Meeting ended")}">
                <wy-icon svg="${Q1(this.meeting.provider)}" size="48" ></wy-icon>                
                <div class="wy-item-body">
                  <div class="wy-item-title">${T1(this.meeting.provider)}</div>
                  <div class="wy-item-text">${this.meeting.code}</div>
                </div> 
              </div>` : O`<a class="wy-item wy-list-item wy-meeting" href=${this.meeting.join_url} target="_blank"  title="${T("Join meeting")}">
              <wy-icon svg="${Q1(this.meeting.provider)}" size="48" color="native"></wy-icon>
              <div class="wy-item-body">
                <div class="wy-item-title">${T1(this.meeting.provider)}</div>
                <div class="wy-item-text">${this.meeting.code}</div>                
              </div>
            </a>`}
      </div>
    `;
  }
}, u(Du, "Rn"), Du), p(hb, "WyMeetingCard"), hb);
Tm.styles = fe;
sz([
  x({ attribute: !1 })
], Tm.prototype, "meeting", 2);
Tm = sz([
  F("wy-meeting-card"),
  be()
], Tm);
var OB = Object.defineProperty, bB = Object.getOwnPropertyDescriptor, rz = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? bB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && OB(t, i, r), r;
}, "__decorateClass$T"), db, qu;
let Mm = (db = (qu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.text = "";
  }
  render() {
    const t = this.text.trim();
    let i = "";
    return t.length && (i = t.split(/(\n+)/).map((n) => `<div>${n.split(/(\s+)/).map((r) => `<span class="wy-placeholder">${this.escapeHTML(r)}</span>`).join(" ")}</div>`).join(" ")), O`
      <div>${So(i)}</div>
    `;
  }
  escapeHTML(t) {
    const i = document.createElement("div");
    return i.textContent = t, i.innerHTML;
  }
}, u(qu, "In"), qu), p(db, "WySkeleton"), db);
Mm.styles = fe;
rz([
  x()
], Mm.prototype, "text", 2);
Mm = rz([
  F("wy-skeleton")
], Mm);
var Uu;
const az = (Uu = class {
  constructor(t) {
    this.delay = NaN, this.sleep = !1, t.addController(this), this.host = t;
  }
  createObserver(t) {
    var i;
    (i = this.scrollObserver) == null || i.disconnect(), this.swipeElement = t, this.scrollObserver = new IntersectionObserver(
      (n) => {
        n.forEach(async (r) => {
          r.isIntersecting && !this.sleep && r.intersectionRatio >= 1 && (this.sleep = !0, Number.isNaN(this.delay) || await new Promise((a) => {
            setTimeout(a, this.delay);
          }), r.target === this.prevElement && this.whenPrev && await this.whenPrev(), r.target === this.nextElement && this.whenNext && await this.whenNext(), await this.host.updateComplete);
        });
      },
      { root: t, threshold: 1, rootMargin: "0px" }
    );
  }
  observe(t, i) {
    var n, r, a, o;
    this.prevElement && ((n = this.scrollObserver) == null || n.unobserve(this.prevElement), this.prevElement = void 0), this.nextElement && ((r = this.scrollObserver) == null || r.unobserve(this.nextElement), this.nextElement = void 0), t && ((a = this.scrollObserver) == null || a.observe(t), this.prevElement = t), i && ((o = this.scrollObserver) == null || o.observe(i), this.nextElement = i), this.sleep = !1;
  }
  clearObserver() {
    var t;
    this.prevElement = void 0, this.nextElement = void 0, (t = this.scrollObserver) == null || t.disconnect(), this.sleep = !1;
  }
  hostConnected() {
    this.scrollObserver && (this.prevElement && this.scrollObserver.observe(this.prevElement), this.nextElement && this.scrollObserver.observe(this.nextElement), this.sleep = !1);
  }
  hostDisconnected() {
    var t;
    (t = this.scrollObserver) == null || t.disconnect();
  }
}, u(Uu, "Tp"), Uu);
p(az, "SwipeScrollController");
let $B = az;
var Ns, Nl, Nu;
const oz = (Nu = class {
  constructor(t) {
    if (U(this, Ns), U(this, Nl), q(this, Ns, /* @__PURE__ */ new Map()), this.keyPrefix = "WEAVY_OFFLINE_CACHE", t)
      q(this, Nl, t);
    else
      try {
        Bt(), q(this, Nl, window.sessionStorage);
      } catch {
        console.warn("Session storage not available.");
      }
  }
  resetPersistPropertiesCache() {
    P(this, Ns).clear();
  }
  async getStorageItem(t, i) {
    var n;
    const r = (n = P(this, Nl)) == null ? void 0 : n.getItem(`${t}-${i.toString()}`);
    if (r)
      return JSON.parse(r);
  }
  async setStorageItem(t, i, n) {
    var r;
    const a = JSON.stringify(n);
    a && ((r = P(this, Nl)) == null || r.setItem(`${t}-${i.toString()}`, a));
  }
  async persistProperties(t, i, n, r) {
    const a = `${this.keyPrefix}:${r ? `${r}:` : ""}${typeof t}:${i}`;
    n.forEach(async (o) => {
      if (!P(this, Ns).has(o)) {
        const l = await this.getStorageItem(a, o);
        l && (t[o] = l), P(this, Ns).set(o, l);
      }
      if (t[o] !== P(this, Ns).get(o)) {
        const l = t[o];
        P(this, Ns).set(o, l), this.setStorageItem(a, o, l);
      }
    });
  }
}, u(Nu, "Fp"), Nu);
Ns = /* @__PURE__ */ new WeakMap(), Nl = /* @__PURE__ */ new WeakMap(), p(oz, "PersistStorageCache");
let xB = oz;
var Bl, Ly, Bu;
const lz = (Bu = class {
  constructor(t) {
    U(this, Bl), U(this, Ly), q(this, Bl, ""), this.properties = [], this.persistStorageCache = new xB(), t.addController(this), this.host = t;
  }
  get prefixKey() {
    return P(this, Bl);
  }
  set prefixKey(t) {
    t !== P(this, Bl) && (this.persistStorageCache.resetPersistPropertiesCache(), q(this, Bl, t), this.host.requestUpdate());
  }
  get cachePrefix() {
    return P(this, Ly);
  }
  set cachePrefix(t) {
    t !== P(this, Ly) && (this.persistStorageCache.resetPersistPropertiesCache(), q(this, Ly, t), this.host.requestUpdate());
  }
  observe(t, i, n) {
    this.properties = t, i && (this.prefixKey = i), n && (this.cachePrefix = n);
  }
  hostUpdate() {
    this.prefixKey && this.properties && this.host.weavy && this.persistStorageCache.persistProperties(this.host, this.prefixKey, this.properties, this.cachePrefix ? `${this.host.weavy.cachePrefix}:${this.cachePrefix}` : this.host.weavy.cachePrefix);
  }
}, u(Bu, "Dp"), Bu);
Bl = /* @__PURE__ */ new WeakMap(), Ly = /* @__PURE__ */ new WeakMap(), p(lz, "PersistStateController");
let G5 = lz;
var kB = Object.defineProperty, SB = Object.getOwnPropertyDescriptor, cw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? SB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && kB(t, i, r), r;
}, "__decorateClass$S"), ub, ju;
let Wr = (ub = (ju = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.show = !0, this.maximized = !1, this.filled = !1, this.header = !1, this.viewportRef = ke();
  }
  close() {
    var t;
    (t = this.viewportRef.value) == null || t.close(), this.show = !1;
  }
  handleClose(t) {
    this.show = !1, this.dispatchEvent(new CustomEvent("close")), this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }));
  }
  willUpdate(t) {
    var i, n;
    super.willUpdate(t), t.has("show") && (this.show ? (i = this.viewportRef.value) == null || i.showModal() : (n = this.viewportRef.value) == null || n.close());
  }
  render() {
    const t = {
      "wy-open": this.show,
      "wy-modal-padded": !this.filled && !this.maximized,
      "wy-modal-full": this.maximized && !this.filled
    };
    return O`
      <dialog class="wy-dialog wy-overlay-dialog" ${pe(this.viewportRef)}>
        <div class="wy-overlay wy-transition wy-modal ${ot(t)}">
          ${this.header ? O`
                <slot name="header">
                  <header class="wy-appbars">
                    <nav class="wy-appbar">
                      <wy-button kind="icon" @click=${() => this.close()}><wy-icon name="close"></wy-icon></wy-button>
                      <slot name="appbar-text" class="wy-appbar-text"></slot>
                      <slot name="appbar-buttons" class="wy-appbar-buttons wy-appbar-buttons-last"></slot>
                    </nav>
                  </header>
                </slot>
              ` : M}
          <slot></slot>
        </div>
      </dialog>
    `;
  }
  updated(t) {
    var i;
    t.has("show") && this.show && ((i = this.viewportRef.value) == null || i.focus());
  }
  firstUpdated(t) {
    var i;
    (i = this.viewportRef.value) == null || i.addEventListener("close", (n) => this.handleClose(n));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.close();
  }
}, u(ju, "Fn"), ju), p(ub, "WyOverlay"), ub);
Wr.styles = [
  fe,
  Yi
];
cw([
  x({ type: Boolean })
], Wr.prototype, "show", 2);
cw([
  x({ type: Boolean })
], Wr.prototype, "maximized", 2);
cw([
  x({ type: Boolean })
], Wr.prototype, "filled", 2);
cw([
  x({ type: Boolean })
], Wr.prototype, "header", 2);
Wr = cw([
  F("wy-overlay")
], Wr);
const $v = de`.wy-dropdown{position:relative}.wy-dropdown-toggle{white-space:nowrap}.wy-dropdown-menu{width:max-content;position:absolute;z-index:1000;min-width:calc(10 * var(--wy-size, 1rem));border:none;padding:0;--wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));background-color:var(--wy-component-background-color);color:var(--wy-component-color);font-size:var(--wy-font-size, var(--wy-size, 1em));text-align:left;background-clip:padding-box;border-radius:var(--wy-dropdown-border-radius, var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))));box-shadow:var(--wy-dropdown-shadow, var(--wy-shadow-level1, 0 calc(.125 * var(--wy-size, 1rem)) calc(.125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .14), 0 calc(.1875 * var(--wy-size, 1rem)) calc(.0625 * var(--wy-size, 1rem)) calc(-.125 * var(--wy-size, 1rem)) rgba(0, 0, 0, .2), 0 calc(.0625 * var(--wy-size, 1rem)) calc(.3125 * var(--wy-size, 1rem)) 0 rgba(0, 0, 0, .12)));overflow:hidden}.wy-dropdown-menu:not([popover]){display:block}.wy-dropdown-item{background-color:transparent;color:var(--wy-component-color, var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e)));width:100%;padding:var(--wy-dropdown-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))) var(--wy-dropdown-padding-x, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));clear:both;font-family:var(--wy-font-family, unset),inherit;font-size:inherit;font-weight:var(--wy-font-weight, unset);line-height:1;text-align:inherit;text-decoration:none;white-space:nowrap;border:0;gap:var(--wy-dropdown-gap, var(--wy-gap, calc(.5 * var(--wy-size, 1rem))));cursor:pointer;display:flex;align-items:center}.wy-dropdown-item:hover,.wy-dropdown-item:focus{--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));color:var(--wy-component-color);background-color:var(--wy-component-background-color);text-decoration:none}.wy-dropdown-item.wy-active,.wy-dropdown-item:active{--wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));--wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));color:var(--wy-component-color);background-color:var(--wy-component-background-color);text-decoration:none}.wy-dropdown-item.wy-disabled,.wy-dropdown-item:disabled{color:var(--wy-component-color);background-color:var(--wy-component-background-color);pointer-events:none;opacity:var(--wy-opacity-disabled, 38%)}.wy-dropdown-item>img,.wy-dropdown-item>wy-icon{margin-right:calc(.5 * var(--wy-size, 1rem))}.wy-dropdown-item>img,.wy-dropdown-item>img .wy-icon,.wy-dropdown-item>wy-icon,.wy-dropdown-item>wy-icon .wy-icon{color:inherit}.wy-dropdown-item:active>wy-icon,.wy-dropdown-item:active>wy-icon .wy-icon{color:inherit}.wy-dropdown-item.wy-option wy-icon{visibility:hidden}.wy-dropdown-item.wy-option.wy-selected wy-icon{visibility:visible}.wy-dropdown-divider{height:0;margin:0;overflow:hidden;border:none;border-top:var(--wy-dropdown-border-width, var(--wy-border, 1px)) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce))}`;
var PB = Object.defineProperty, CB = Object.getOwnPropertyDescriptor, Xt = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? CB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && PB(t, i, r), r;
}, "__decorateClass$R"), pb, Xu;
let bi = (pb = (Xu = class extends G {
  constructor() {
    super(), this.exportParts = new ae(this), this.directionX = "right", this.directionY = "down", this.icon = "dots-vertical", this.small = !1, this.noWrapper = !1, this.disabled = !1, this._placement = "bottom-start", this.showMenu = !1, this.buttonRef = ke(), this.menuRef = ke(), this._documentClickHandler = (t) => {
      var i;
      this.showMenu && (t.preventDefault(), (i = this.menuRef.value) != null && i.popover || (this.showMenu = !1));
    }, this.addEventListener("click", (t) => {
      t.preventDefault();
    });
  }
  handleClose(t) {
    (t.type === "toggle" && t.newState === "closed" || t.type === "click") && (this.showMenu = !1, this.dispatchEvent(new CustomEvent("close")), this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 })));
  }
  handleClickToggle(t) {
    t.stopPropagation(), this.showMenu = !this.showMenu;
  }
  willUpdate(t) {
    var i, n, r;
    if ((t.has("directionX") || t.has("directionY")) && (this._placement = this.directionX === "right" && this.directionY === "down" ? "bottom-start" : this.directionX === "left" && this.directionY === "down" ? "bottom-end" : this.directionX === "right" && this.directionY === "up" ? "top-start" : "top-end"), t.has("showMenu") && (this.showMenu && !this.computePositionCleanup && this.buttonRef.value && this.menuRef.value ? this.computePositionCleanup = H5(this.buttonRef.value, this.menuRef.value, () => {
      this.buttonRef.value && this.menuRef.value && JE(this.buttonRef.value, this.menuRef.value, {
        placement: this._placement,
        strategy: this.menuRef.value.popover ? "absolute" : "fixed",
        middleware: [
          KE(),
          YE(({ placement: a }) => a.includes("top") ? 9 : 13),
          GE({ mainAxis: !0, crossAxis: !0, padding: 4, altBoundary: !0 })
        ]
      }).then(({ x: a, y: o }) => {
        this.menuRef.value && Object.assign(this.menuRef.value.style, {
          marginLeft: `${a}px`,
          marginTop: `${o}px`,
          top: 0,
          left: 0,
          position: this.menuRef.value.popover ? void 0 : "fixed",
          zIndex: this.menuRef.value.popover ? void 0 : 1075
        });
      });
    }) : !this.showMenu && this.computePositionCleanup && ((i = this.computePositionCleanup) == null || i.call(this), this.computePositionCleanup = void 0)), this.showMenu) {
      requestAnimationFrame(() => {
        document.addEventListener("click", this._documentClickHandler, { once: !0, capture: !0 });
      });
      try {
        (n = this.menuRef.value) == null || n.showPopover();
      } catch {
      }
    } else
      try {
        (r = this.menuRef.value) == null || r.hidePopover();
      } catch {
      }
  }
  render() {
    const t = this._slotButton.length === 0 || this._slotButton.length === 1 && this._slotButton[0] instanceof Je;
    return O`
      <span>
        <span
          ${pe(this.buttonRef)}
          @click=${this.handleClickToggle}
          @keydown=${ei}
          @keyup=${_i}
        >
          <wy-button
            .kind=${t ? "icon" : void 0}
            ?small=${this.small}
            title=${this.title}
            ?active=${this.showMenu}
            ?disabled=${this.disabled}
          >
            <slot name="button" @slotchange=${() => this.requestUpdate()}>
              <wy-icon name=${this.icon}></wy-icon>
            </slot>
          </wy-button>
        </span>

        <div
          ${pe(this.menuRef)}
          @click=${this.handleClickToggle}
          @keyup=${pv}
          class="wy-dropdown-menu"
          ?hidden=${kg() && !this.showMenu}
          ?popover=${!kg()}
        >
          <slot></slot>
        </div>
      </span>
    `;
  }
  firstUpdated(t) {
    var i;
    (i = this.menuRef.value) == null || i.addEventListener(this.menuRef.value.popover ? "toggle" : "click", (n) => this.handleClose(n));
  }
  disconnectedCallback() {
    var t;
    (t = this.computePositionCleanup) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Xu, "Dn"), Xu), p(pb, "WyDropdown"), pb);
bi.styles = [
  Lt,
  $v,
  de`
      /*:host {
        position: relative;
      }*/
    `
];
Xt([
  x()
], bi.prototype, "directionX", 2);
Xt([
  x()
], bi.prototype, "directionY", 2);
Xt([
  x()
], bi.prototype, "icon", 2);
Xt([
  x({ type: Boolean })
], bi.prototype, "small", 2);
Xt([
  x({ type: Boolean })
], bi.prototype, "noWrapper", 2);
Xt([
  x({ type: Boolean })
], bi.prototype, "disabled", 2);
Xt([
  B()
], bi.prototype, "_placement", 2);
Xt([
  B()
], bi.prototype, "showMenu", 2);
Xt([
  uA({ slot: "button" })
], bi.prototype, "_slotButton", 2);
Xt([
  B()
], bi.prototype, "computePositionCleanup", 2);
bi = Xt([
  F("wy-dropdown")
], bi);
var fb, Fu;
let Rm = (fb = (Fu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.active = !1;
  }
  render() {
    return O`<div class="wy-dropdown-item ${ot({ "wy-active": this.active })}" tabindex="0"
      ><slot></slot
    ></div>`;
  }
}, u(Fu, "Hn"), Fu), p(fb, "WyDropdownItem"), fb);
Rm.styles = [
  Lt,
  $v,
  de`
      :host {
        display: contents;
      }
    `
];
Xt([
  x({ type: Boolean })
], Rm.prototype, "active", 2);
Rm = Xt([
  F("wy-dropdown-item")
], Rm);
var yb, Hu;
let Sf = (yb = (Hu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.active = !1, this.selected = !1;
  }
  render() {
    const t = {
      visibility: this.selected ? null : "hidden"
    };
    return O`
      <div
        class="wy-dropdown-item wy-option ${ot({ "wy-active": this.active, "wy-selected": this.selected })}"
        tabindex="0"
      >
        <slot name="icon" style=${x1(t)}><wy-icon name="check"></wy-icon></slot>
        <slot></slot>
      </div>
    `;
  }
}, u(Hu, "Vn"), Hu), p(yb, "WyDropdownOption"), yb);
Sf.styles = [
  Lt,
  $v,
  de`
      :host {
        display: contents;
      }
    `
];
Xt([
  x({ type: Boolean })
], Sf.prototype, "active", 2);
Xt([
  x({ type: Boolean })
], Sf.prototype, "selected", 2);
Sf = Xt([
  F("wy-dropdown-option")
], Sf);
var mb, Yu;
let M1 = (mb = (Yu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    return O`<hr class="wy-dropdown-divider" />`;
  }
}, u(Yu, "Bn"), Yu), p(mb, "WyDropdownDivider"), mb);
M1.styles = [
  Lt,
  $v,
  de`
      :host {
        display: contents;
      }
    `
];
M1 = Xt([
  F("wy-dropdown-divider")
], M1);
var QB = Object.defineProperty, TB = Object.getOwnPropertyDescriptor, xv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? TB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && QB(t, i, r), r;
}, "__decorateClass$Q"), wb, Gu;
let Mo = (wb = (Gu = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    const t = this.icon, i = Uo(this.provider);
    return O`
      <wy-icon-display>
        <wy-icon name=${t} .overlayName=${i}></wy-icon>
        <span slot="text">
          ${this.provider ? O`
                <span>${T("No preview available :(")} </span>
                <a href=${this.src} target="_blank">${T(ie`Open in ${this.provider}?`)}</a>
              ` : O`<span>${T("No preview available :(")}</span>`}
        </span>
      </wy-icon-display>
    `;
  }
}, u(Gu, "Un"), Gu), p(wb, "WyPreviewIcon"), wb);
Mo.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
      `
];
xv([
  x()
], Mo.prototype, "src", 2);
xv([
  x()
], Mo.prototype, "icon", 2);
xv([
  x()
], Mo.prototype, "provider", 2);
Mo = xv([
  F("wy-preview-icon"),
  be()
], Mo);
var MB = Object.defineProperty, RB = Object.getOwnPropertyDescriptor, kv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? RB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && MB(t, i, r), r;
}, "__decorateClass$P"), gb, Ku;
let Ro = (gb = (Ku = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    if (this.width && this.height) {
      const t = { "--width": this.width, "--height": this.height };
      return O`
        <div class="wy-content-image wy-responsive-image" style=${x1(t)}>
          <img
            class="wy-loading-transition"
            src=${this.src}
            ${pe(km)}
            @load=${Sm}
            width=${this.width}
            height=${this.height}
            decoding="async"
            alt=${T("Preview")} />
          <wy-spinner></wy-spinner>
        </div>
      `;
    } else
      return O`
        <div class="wy-content-image wy-responsive-image wy-intrinsic-image">
          <img src=${this.src} ${pe(km)} @load=${Sm} decoding="async" alt=${T("Preview")} />
        </div>
      `;
  }
}, u(Ku, "qn"), Ku), p(gb, "WyPreviewImage"), gb);
Ro.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
kv([
  x()
], Ro.prototype, "src", 2);
kv([
  x({ type: Number })
], Ro.prototype, "width", 2);
kv([
  x({ type: Number })
], Ro.prototype, "height", 2);
Ro = kv([
  F("wy-preview-image"),
  be()
], Ro);
function K5(s) {
  s.classList.contains("wy-loading") && s.classList.add("wy-loaded"), s.classList.add("wy-error"), s.outerHTML = s.outerHTML.replace(/<(video|audio)/, "<div").replace(/(video|audio)>/, "div>");
}
u(K5, "Dw");
p(K5, "mediaFallback");
function A$(s) {
  const t = s.target;
  (t.tagName === "VIDEO" || t.tagName === "AUDIO") && t.classList.contains("wy-loading") && t.classList.add("wy-loaded");
}
u(A$, "Mu");
p(A$, "mediaLoaded");
function E$(s) {
  const t = s.target;
  if (t.tagName === "SOURCE" && t.parentNode) {
    const i = t.parentNode, n = parseInt(i.dataset.errors || "0") + 1;
    i.dataset.errors = n.toString(), i.querySelectorAll("source").length >= n && (console.warn(i.tagName.toLowerCase() + " source error, switching to fallback"), K5(i));
  }
}
u(E$, "zu");
p(E$, "mediaError");
function z$(s) {
  const t = s.target;
  (t.tagName === "VIDEO" || t.tagName === "AUDIO") && (t.tagName === "VIDEO" && !t.videoWidth || t.tagName === "AUDIO" && !t.duration) && (console.warn(t.tagName.toLowerCase() + " track not available, switching to fallback"), K5(t));
}
u(z$, "Su");
p(z$, "codecError");
var AB = Object.defineProperty, EB = Object.getOwnPropertyDescriptor, hw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? EB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && AB(t, i, r), r;
}, "__decorateClass$O"), vb, Ju;
let Vr = (vb = (Ju = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.format = "", this.name = "";
  }
  registerLoading(t) {
    this.unregisterLoading(), t && (this.mediaElement = t, t.classList.add("wy-loading"), t.addEventListener("error", E$, !0), t.addEventListener("loadedmetadata", A$, !0), t.addEventListener("loadedmetadata", z$, !0));
  }
  unregisterLoading() {
    this.mediaElement && (this.mediaElement.pause(), this.mediaElement.removeAttribute("autoplay"), this.mediaElement.setAttribute("preload", "none"), this.mediaElement.removeEventListener("error", E$, !0), this.mediaElement.removeEventListener("loadedmetadata", A$, !0), this.mediaElement.removeEventListener("loadedmetadata", z$, !0), this.mediaElement = void 0);
  }
  render() {
    return this.format === "video" ? O`
          <video ${pe(this.registerLoading)} class="wy-content-video" controls crossorigin="use-credentials" autoplay>
            <source src=${this.src} type=${Me(this.mediaType)} />
            <wy-preview-icon src=${this.src} icon="file-video"></wy-preview-icon>
          </video>
          <wy-spinner></wy-spinner>
        ` : O`
          <audio ${pe(this.registerLoading)} class="wy-content-audio" controls crossorigin="use-credentials" autoplay>
            <source src=${this.src} type=${Me(this.mediaType)} />
          </audio>
        `;
  }
  disconnectedCallback() {
    this.unregisterLoading(), super.disconnectedCallback();
  }
}, u(Ju, "Nn"), Ju), p(vb, "WyPreviewMedia"), vb);
Vr.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
hw([
  x()
], Vr.prototype, "format", 2);
hw([
  x()
], Vr.prototype, "src", 2);
hw([
  x()
], Vr.prototype, "name", 2);
hw([
  x()
], Vr.prototype, "mediaType", 2);
Vr = hw([
  F("wy-preview-media")
], Vr);
var zB = Object.defineProperty, _B = Object.getOwnPropertyDescriptor, Bo = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? _B(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && zB(t, i, r), r;
}, "__decorateClass$N"), Ob, ep;
let Fn = (Ob = (ep = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.html = !1, this.code = !1, this.textOrHtmlContent = "", this.loading = !0;
  }
  async updated(t) {
    (t.has("weavy") || t.has("src")) && this.weavy && (this.loading = !0, fetch(this.src, await this.weavy.fetchOptions()).then(qM).then((i) => new Response(i)).then((i) => i.text()).then((i) => {
      this.loading = !1, this.textOrHtmlContent = i;
    }));
  }
  render() {
    return this.loading ? O`
      <wy-empty><wy-spinner></wy-spinner></wy-empty>
    ` : this.html ? this.code ? O` <div class="wy-content-code wy-code">${So(this.textOrHtmlContent)}</div> ` : O`
            <div class="wy-document wy-light">
              <div class="wy-content-html">${So(this.textOrHtmlContent)}</div>
            </div>
          ` : this.code ? O` <div class="wy-content-code">${this.textOrHtmlContent}</div> ` : O`
          <div class="wy-document wy-light">
            <pre class="wy-content-text">${this.textOrHtmlContent}</pre>
          </div>
        `;
  }
}, u(ep, "jn"), ep), p(Ob, "WyPreviewText"), Ob);
Fn.styles = [
  fe,
  Yi,
  de`
      :host {
        display: contents;
      }
    `
];
Bo([
  wt({ context: Pt, subscribe: !0 }),
  B()
], Fn.prototype, "weavy", 2);
Bo([
  x()
], Fn.prototype, "src", 2);
Bo([
  x({ type: Boolean })
], Fn.prototype, "html", 2);
Bo([
  x({ type: Boolean })
], Fn.prototype, "code", 2);
Bo([
  B()
], Fn.prototype, "textOrHtmlContent", 2);
Bo([
  B()
], Fn.prototype, "loading", 2);
Fn = Bo([
  F("wy-preview-text")
], Fn);
var LB = Object.defineProperty, IB = Object.getOwnPropertyDescriptor, dw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? IB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && LB(t, i, r), r;
}, "__decorateClass$M"), bb, tp;
let Zr = (bb = (tp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  registerLoading(t) {
    var i;
    if ((i = this.unregisterLoading) == null || i.call(this), t) {
      this.embedElement = t, t.classList.add("wy-loading");
      const n = window.setTimeout(() => {
        t.classList.add("wy-fallback");
      }, 2500), r = /* @__PURE__ */ p((a) => {
        const o = a.target;
        o.tagName === "OBJECT" && o.classList.contains("wy-loading") && !o.classList.contains("wy-loaded") && (o.classList.add("wy-loaded"), window.clearTimeout(n));
      }, "embedLoaded");
      t.addEventListener("load", r, !0), this.unregisterLoading = () => {
        this.embedElement && (t.removeEventListener("load", r, !0), window.clearTimeout(n), this.embedElement = void 0);
      };
    }
  }
  render() {
    return O`
      <object title=${T("Preview")} ${pe(this.registerLoading)} class="wy-content-iframe" data=${this.src}></object>
      <wy-spinner overlay></wy-spinner>
      <wy-preview-icon
        src=${this.src}
        icon=${this.icon}
        provider=${Me(this.provider)}
        class="wy-content-iframe-fallback"></wy-preview-icon>
    `;
  }
  disconnectedCallback() {
    var t;
    (t = this.unregisterLoading) == null || t.call(this), super.disconnectedCallback();
  }
}, u(tp, "Wn"), tp), p(bb, "WyPreviewEmbed"), bb);
Zr.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
dw([
  x()
], Zr.prototype, "src", 2);
dw([
  x()
], Zr.prototype, "name", 2);
dw([
  x()
], Zr.prototype, "icon", 2);
dw([
  x()
], Zr.prototype, "provider", 2);
Zr = dw([
  F("wy-preview-embed"),
  be()
], Zr);
function wc(s = "", t = "", i = "", n = !1) {
  if (Bt(), s) {
    const r = document.createElement("a");
    n && (/^(data:|blob:)/.test(s) ? r.download = i || "download" : s = s.includes("?d=1") || s.includes("&d=1") ? s : s.includes("?") ? s + "&d=1" : s + "?d=1"), t && (r.target = t), r.href = s, document.body.appendChild(r);
    try {
      r.click();
    } catch {
      if (console.warn("Could not open link normally, trying fallback"), /^(?:blob:|data:)/.test(s))
        console.error(`Could not ${n ? "download" : "open"} ${i}`);
      else
        try {
          window.open(s, t);
        } catch {
          console.error(`Could not ${n ? "download" : "open"} ${i}`);
        }
    }
    document.body.removeChild(r);
  }
}
u(wc, "Mo");
p(wc, "openUrl");
function _$(s, t) {
  return new URL(
    s,
    typeof WEAVY_IMPORT_URL == "string" && (!t || !new URL(t).href.startsWith(WEAVY_IMPORT_URL)) ? WEAVY_IMPORT_URL : t
  );
}
u(_$, "Eu");
p(_$, "environmentUrl");
var WB = Object.defineProperty, VB = Object.getOwnPropertyDescriptor, Sv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? VB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && WB(t, i, r), r;
}, "__decorateClass$L"), $b, ip;
let Ao = ($b = (ip = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.whenPdfjs = new Promise((t) => {
      this.whenPdfjsResolve = t;
    }), this.MAX_CANVAS_PIXELS = 0, this.TEXT_LAYER_MODE = 0, this.MAX_IMAGE_SIZE = -1, this.CMAP_PACKED = !0, this.DEFAULT_SCALE_DELTA = 1.1, this.MIN_SCALE = 0.25, this.MAX_SCALE = 10, this.DEFAULT_SCALE_VALUE = "auto", this.ENABLE_XFA = !0, this.DEFAULT_WORKER_URL = "/pdfjs/pdf.worker.min.mjs", this.DEFAULT_CMAPS_URL = "/pdfjs/cmaps/", this.pageNumberRef = ke(), this.totalPagesRef = ke(), this.zoomLevelRef = ke(), this.viewerContainerRef = ke(), this.resizer = new ResizeObserver(() => {
      this.pdfViewer && (this.delayedResize && (clearTimeout(this.delayedResize), this.delayedResize = void 0), this.delayedResize = window.setTimeout(() => {
        this.pdfViewer && (this.pdfViewer.currentScaleValue = this.pdfViewer._currentScaleValue);
      }, 100));
    });
  }
  ////////
  async open() {
    var t;
    const { pdfjsLib: i } = await this.whenPdfjs;
    if (!this.pdfViewer || !this.pdfHistory || !this.l10n || !this.pdfLinkService)
      return;
    this.pdfLoadingTask && await this.close();
    const n = i.getDocument({
      url: this.src,
      maxImageSize: this.MAX_IMAGE_SIZE,
      enableXfa: this.ENABLE_XFA,
      cMapUrl: ((t = this.CMAP_URL) == null ? void 0 : t.toString()) || "",
      cMapPacked: this.CMAP_PACKED
    });
    this.pdfLoadingTask = n, n.onProgress = (r) => {
    };
    try {
      const r = await n.promise;
      this.pdfDocument = r, this.pdfViewer.setDocument(r), this.pdfLinkService.setDocument(r), this.pdfHistory.initialize({
        // @ts-expect-error Type 'string | null' is not assignable to type 'string'.
        fingerprint: r.fingerprints[0]
      });
    } catch (r) {
      let a = "pdfjs-loading-error";
      r instanceof i.InvalidPDFException ? a = "pdfjs-invalid-file-error" : r instanceof i.MissingPDFException ? a = "pdfjs-missing-file-error" : r instanceof i.UnexpectedResponseException && (a = "pdfjs-unexpected-response-error"), this.l10n.get(a, void 0, void 0).then((o) => {
        this.pdfViewError(i, o, { message: r == null ? void 0 : r.message });
      });
    }
  }
  async close() {
    var t, i;
    if (!this.pdfLoadingTask)
      return Promise.resolve();
    const n = this.pdfLoadingTask.destroy();
    return this.pdfLoadingTask = void 0, this.pdfDocument && (this.pdfDocument = void 0, (t = this.pdfViewer) == null || t.setDocument(null), (i = this.pdfLinkService) == null || i.setDocument(null, null), this.pdfHistory && this.pdfHistory.reset()), await n;
  }
  pdfViewError(t, i, n) {
    const r = [`PDF.js v${(t == null ? void 0 : t.version) || "?"} (build: ${(t == null ? void 0 : t.build) || "?"})`];
    n && (r.push(`Message: ${n.message}`), n.stack ? r.push(`Stack: ${n.stack}`) : (n.filename && r.push(`File: ${n.filename}`), n.lineNumber && r.push(`Line: ${n.lineNumber}`))), console.error(`${i}

${r.join(`
`)}`);
  }
  ///////
  setPage(t) {
    this.pdfViewer && (this.pdfViewer.currentPageNumber = t);
  }
  zoomIn(t) {
    if (this.pdfViewer) {
      let i = this.pdfViewer.currentScale;
      do
        i = parseFloat((i * this.DEFAULT_SCALE_DELTA).toFixed(2)), i = Math.ceil(i * 10) / 10, i = Math.min(this.MAX_SCALE, i);
      while (--t && i < this.MAX_SCALE);
      this.pdfViewer.currentScaleValue = i.toFixed(2);
    }
  }
  zoomOut(t) {
    if (this.pdfViewer) {
      let i = this.pdfViewer.currentScale;
      do
        i = parseFloat((i / this.DEFAULT_SCALE_DELTA).toFixed(2)), i = Math.floor(i * 10) / 10, i = Math.max(this.MIN_SCALE, i);
      while (--t && i > this.MIN_SCALE);
      this.pdfViewer.currentScaleValue = i.toFixed(2);
    }
  }
  setScale(t) {
    this.pdfViewer && (this.pdfViewer.currentScaleValue = typeof t == "number" ? t.toFixed(2) : t);
  }
  updatePage() {
    if (this.pdfViewer && this.pageNumberRef.value) {
      const t = parseInt(this.pageNumberRef.value.value);
      isNaN(t) ? this.setPage(this.pdfViewer.currentPageNumber) : t > this.pdfViewer.pagesCount ? this.setPage(this.pdfViewer.pagesCount) : t <= 0 ? this.setPage(1) : this.setPage(t);
    }
  }
  select(t) {
    const i = t.target;
    i && i.setSelectionRange(0, i.value.length);
  }
  fitToPage() {
    this.setScale("page-fit");
  }
  fitToWidth() {
    this.setScale("page-width");
  }
  updateZoom() {
    if (this.pdfViewer && this.zoomLevelRef.value) {
      const t = parseFloat(this.zoomLevelRef.value.value.replace("%", ""));
      isNaN(t) ? this.setScale(this.pdfViewer.currentScale + 1e-4) : this.setScale(t / 100);
    }
  }
  // clearDocument() {
  //   try {
  //     this.loadingTask?.destroy();
  //     //console.debug("loadingTask cleanup", loadingTask)
  //   } catch (e) {
  //     /* No worries */
  //   }
  //   try {
  //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //     // @ts-ignore due to incorrect param type def?
  //     this.pdfViewer?.setDocument(null);
  //   } catch (e) {
  //     /* No worries */
  //   }
  //   try {
  //     this.pdfLinkService.setDocument(null, null);
  //   } catch (e) {
  //     /* No worries */
  //   }
  // }
  async willUpdate(t) {
    var i;
    t.has("weavy") && this.weavy && (this.pdfjsLib || (await this.weavy.whenUrl(), this.pdfjsLib = await import(
      /* webpackIgnore: true */
      /* @vite-ignore */
      new URL("./es/pdfjs-dist/build/pdf.mjs.js", typeof WEAVY_IMPORT_URL == "string" && (!import.meta.url || !new URL(import.meta.url).href.startsWith(WEAVY_IMPORT_URL)) ? WEAVY_IMPORT_URL : import.meta.url).href
    ), globalThis.pdfjsLib = this.pdfjsLib, this.pdfjsViewer = await import(
      /* webpackIgnore: true */
      /* @vite-ignore */
      new URL("./es/pdfjs-dist/web/pdf_viewer.mjs.js", typeof WEAVY_IMPORT_URL == "string" && (!import.meta.url || !new URL(import.meta.url).href.startsWith(WEAVY_IMPORT_URL)) ? WEAVY_IMPORT_URL : import.meta.url).href
    ), (i = this.whenPdfjsResolve) == null || i.call(this, {
      pdfjsLib: this.pdfjsLib,
      pdfjsViewer: this.pdfjsViewer
    })), this.pdfjsLib && !this.WORKER_URL && (this.WORKER_URL = _$(this.DEFAULT_WORKER_URL, import.meta.url), this.WORKER_URL.searchParams.append("v", this.weavy.version), this.pdfjsLib.GlobalWorkerOptions.workerSrc = this.WORKER_URL.toString()), this.CMAP_URL || (this.CMAP_URL = _$(this.DEFAULT_CMAPS_URL, import.meta.url)));
  }
  update(t) {
    super.update(t), (t.has("weavy") || t.has("src") || t.has("pdfViewer")) && this.weavy && this.src && this.pdfViewer && this.open();
  }
  async updated() {
    var t, i, n, r, a, o;
    if (this.weavy && this.viewerContainerRef.value && !this.pdfViewer) {
      const { pdfjsLib: l, pdfjsViewer: c } = await this.whenPdfjs;
      this.viewerContainerRef.value && !this.pdfViewer && (this.pdfEventBus = new c.EventBus(), this.pdfLinkService = new c.PDFLinkService({
        eventBus: this.pdfEventBus
      }), this.l10n = new c.GenericL10n((t = this.weavy) == null ? void 0 : t.locale), this.pdfViewer = new c.PDFViewer({
        container: this.viewerContainerRef.value,
        eventBus: this.pdfEventBus,
        linkService: this.pdfLinkService,
        //findController: this.pdfFindController,
        annotationEditorMode: l.AnnotationEditorType.DISABLE,
        l10n: this.l10n,
        maxCanvasPixels: this.MAX_CANVAS_PIXELS,
        textLayerMode: this.TEXT_LAYER_MODE
      }), (i = this.pdfLinkService) == null || i.setViewer(this.pdfViewer), this.pdfHistory = new c.PDFHistory({
        eventBus: this.pdfEventBus,
        linkService: this.pdfLinkService
      }), (n = this.pdfLinkService) == null || n.setHistory(this.pdfHistory), (r = this.pdfEventBus) == null || r.on("scalechanging", () => {
        this.zoomLevelRef.value && this.pdfViewer ? this.zoomLevelRef.value.value = Math.round(this.pdfViewer.currentScale * 100).toFixed(0) + "%" : console.warn("Could not set zoom level");
      }), (a = this.pdfEventBus) == null || a.on("pagechanging", () => {
        this.pageNumberRef.value && this.pdfViewer ? this.pageNumberRef.value.value = this.pdfViewer.currentPageNumber.toFixed(0) : console.warn("Could not set page number");
      }), (o = this.pdfEventBus) == null || o.on("pagesinit", () => {
        this.isConnected && this.pdfViewer && this.pageNumberRef.value && this.totalPagesRef.value ? (this.pdfViewer.currentScaleValue = this.DEFAULT_SCALE_VALUE, this.pageNumberRef.value.value = "1", this.totalPagesRef.value.innerText = this.pdfViewer.pagesCount.toFixed(0), this.resizer.observe(this.pdfViewer.container)) : console.warn("Could not init pdf page");
      }));
    }
  }
  render() {
    return O`
      <div class="wy-content-pdf">
        <div class="wy-toolbars-bottom">
          <nav class="wy-toolbar wy-toolbar-center">
            <div class="wy-toolbar-buttons">
              <input
                type="text"
                class="wy-input wy-pdf-page-number"
                ${pe(this.pageNumberRef)}
                @keydown=${xm}
                @keyup=${jn}
                @change=${this.updatePage}
                @click=${this.select}
              />
              <span class="wy-toolbar-text">/</span>
              <span class="wy-toolbar-text" ${pe(this.totalPagesRef)}>1</span>
            </div>
            <div class="wy-toolbar-buttons">
              <wy-button kind="icon" class="btn-zoom-out" @click=${this.zoomOut} title=${T("Zoom out")}>
                <wy-icon name="minus"></wy-icon>
              </wy-button>
              <input
                type="text"
                class="wy-input wy-pdf-zoom-level"
                ${pe(this.zoomLevelRef)}
                @keydown=${xm}
                @keyup=${jn}
                @change=${this.updateZoom}
                @click=${this.select}
                value="100%"
              />
              <wy-button kind="icon" class="btn-zoom-in" @click=${this.zoomIn} title=${T("Zoom in")}>
                <wy-icon name="plus"></wy-icon>
              </wy-button>
            </div>
            <div class="wy-toolbar-buttons">
              <wy-button kind="icon" class="btn-fit-page" @click=${this.fitToWidth} title=${T("Fit to width")}>
                <wy-icon name="fit-width"></wy-icon>
              </wy-button>
              <wy-button kind="icon" @click=${this.fitToPage} title=${T("Fit to screen")}>
                <wy-icon name="fit-screen"></wy-icon>
              </wy-button>
            </div>
          </nav>
        </div>
        <div ${pe(this.viewerContainerRef)} class="wy-pdf-container">
          <div class="pdfViewer"></div>
        </div>
      </div>
    `;
  }
  connectedCallback() {
    super.connectedCallback(), this.pdfViewer && this.resizer.observe(this.pdfViewer.container);
  }
  disconnectedCallback() {
    var t;
    this.resizer.unobserve(this);
    try {
      this.close(), (t = this.pdfViewer) == null || t.cleanup();
    } catch {
    }
    this.pdfViewer = void 0, super.disconnectedCallback();
  }
}, u(ip, "Qn"), ip), p($b, "WyPdfViewer"), $b);
Ao.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
Sv([
  wt({ context: Pt, subscribe: !0 }),
  B()
], Ao.prototype, "weavy", 2);
Sv([
  x()
], Ao.prototype, "src", 2);
Sv([
  B()
], Ao.prototype, "pdfViewer", 2);
Ao = Sv([
  F("wy-pdf-viewer"),
  be()
], Ao);
var ZB = Object.defineProperty, DB = Object.getOwnPropertyDescriptor, cz = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? DB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && ZB(t, i, r), r;
}, "__decorateClass$K"), xb, np;
let Am = (xb = (np = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  render() {
    const t = this.file;
    if (!t) return M;
    const { icon: i } = Ls(t.name), n = Gi(t.name);
    let r = t.preview_url || t.download_url || "";
    t.preview_format === "image" && (n === ".gif" || n === ".svg") && (r = t.download_url || "");
    const a = r, o = t.external_url, l = t.is_trashed ? "none" : t.preview_format, c = t.name, h = t.width, d = t.height, f = t.media_type, y = t.provider;
    return l === "image" ? O`<wy-preview-image
        src=${a}
        width=${Me(h)}
        height=${Me(d)}
      ></wy-preview-image>` : l === "pdf" ? O`<wy-pdf-viewer src=${a}></wy-pdf-viewer>` : l === "video" || l === "audio" ? O`<wy-preview-media
        format=${l}
        src=${a}
        name=${c}
        mediaType=${f}
      ></wy-preview-media>` : l === "text" ? O`<wy-preview-text src=${a}></wy-preview-text>` : l === "code" ? O`<wy-preview-text src=${a} ?html=${!/^(?:blob:|data:)/.test(a)} code></wy-preview-text>` : l === "html" ? O`<wy-preview-text src=${a} html></wy-preview-text>` : l === "embed" ? O`<wy-preview-embed
        src=${a}
        name=${c}
        icon=${i}
        provider=${Me(y)}
      ></wy-preview-embed>` : l === "none" ? o ? O`<wy-preview-icon src=${o} icon=${i} provider=${Me(y)}></wy-preview-icon>` : O`<wy-preview-icon src=${a} icon=${i}></wy-preview-icon>` : M;
  }
}, u(np, "Kn"), np), p(xb, "WyPreviewItem"), xb);
Am.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
cz([
  x({ type: Object })
], Am.prototype, "file", 2);
Am = cz([
  F("wy-preview-item")
], Am);
var qB = Object.defineProperty, UB = Object.getOwnPropertyDescriptor, qf = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? UB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && qB(t, i, r), r;
}, "__decorateClass$J"), kb, sp;
let Dr = (kb = (sp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.noWrapper = !1, this.small = !1, this.hasEventListener = {
      "edit-name": !1,
      subscribe: !1,
      trash: !1,
      restore: !1,
      "delete-forever": !1
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addEventListener(t, i, n) {
    if (this.hasEventListener) {
      const r = t;
      Object.prototype.hasOwnProperty.call(this.hasEventListener, r) && Object.assign(this.hasEventListener, {
        [r]: !0
      });
    }
    super.addEventListener(t, i, n);
  }
  triggerDownload() {
    this.file && wc(this.file.download_url, "_top", this.file.name, !0);
  }
  triggerExternal() {
    this.file && wc(this.file.external_url, "_blank", this.file.name);
  }
  triggerApplication() {
    this.file && wc(this.file.application_url, "_top", this.file.name);
  }
  dispatchEditName() {
    const t = new CustomEvent("edit-name", {
      detail: { file: this.file }
    });
    return this.dispatchEvent(t);
  }
  dispatchSubscribe(t) {
    const i = new CustomEvent("subscribe", {
      detail: {
        file: this.file,
        subscribe: t
      }
    });
    return this.dispatchEvent(i);
  }
  dispatchTrash() {
    const t = new CustomEvent("trash", {
      detail: { file: this.file }
    });
    return this.dispatchEvent(t);
  }
  dispatchRestore() {
    const t = new CustomEvent("restore", {
      detail: { file: this.file }
    });
    return this.dispatchEvent(t);
  }
  dispatchDeleteForever() {
    const t = new CustomEvent("delete-forever", {
      detail: { file: this.file }
    });
    return this.dispatchEvent(t);
  }
  render() {
    var t;
    if (!this.file)
      return M;
    const { icon: i } = Ls(this.file.name), n = this.file.id >= 1, r = this.file.provider, a = this.file.provider || "app";
    return O`
      <wy-dropdown directionX="left" ?noWrapper=${this.noWrapper} ?small=${this.small}>
        ${n && this.file.is_trashed ? O`
              ${this.hasEventListener.restore ? O`
                    <wy-dropdown-item @click=${() => this.dispatchRestore()}>
                      <wy-icon name="delete-restore"></wy-icon>
                      ${T("Restore")}
                    </wy-dropdown-item>
                  ` : M}
              ${this.hasEventListener.restore && this.hasEventListener["delete-forever"] ? O` <wy-dropdown-divider></wy-dropdown-divider> ` : M}
              ${this.hasEventListener["delete-forever"] ? O`
                    <wy-dropdown-item @click=${() => this.dispatchDeleteForever()}>
                      <wy-icon name="delete-forever"></wy-icon>
                      ${T("Delete")}
                    </wy-dropdown-item>
                  ` : M}
            ` : M}
        ${this.file.is_trashed ? M : O`
              ${this.file.external_url ? O`
                    <wy-dropdown-item @click=${() => this.triggerExternal()}>
                      <wy-icon name=${i}></wy-icon>
                      ${T(ie`Open in ${r}`)}
                    </wy-dropdown-item>
                  ` : O`
                    ${this.file.application_url && (t = this.hasFeatures) != null && t.webDAV ? O`
                          <wy-dropdown-item @click=${() => this.triggerApplication()}>
                            <wy-icon name=${this.file.provider ? Uk(this.file.provider) : i}></wy-icon>
                            ${T(ie`Open in ${a}`)}
                          </wy-dropdown-item>
                        ` : M}
                    <wy-dropdown-item @click=${() => this.triggerDownload()}>
                      <wy-icon name="download"></wy-icon>
                      ${T("Download")}
                    </wy-dropdown-item>
                  `}
              ${n ? O`
                    ${this.hasEventListener["edit-name"] ? O`
                          <wy-dropdown-item @click=${() => this.dispatchEditName()}>
                            <wy-icon name="textbox"></wy-icon>
                            ${T("Rename")}
                          </wy-dropdown-item>
                        ` : M}
                    ${this.hasEventListener.subscribe ? this.file.is_subscribed ? O`
                            <wy-dropdown-item @click=${() => this.dispatchSubscribe(!1)}>
                              <wy-icon name="bell-off"></wy-icon>
                              ${T("Unsubscribe")}
                            </wy-dropdown-item>
                          ` : O`
                            <wy-dropdown-item @click=${() => this.dispatchSubscribe(!0)}>
                              <wy-icon name="bell"></wy-icon>
                              ${T("Subscribe")}
                            </wy-dropdown-item>
                          ` : M}
                    ${this.hasEventListener.trash ? O`
                          <wy-dropdown-divider></wy-dropdown-divider>
                          <wy-dropdown-item @click=${() => this.dispatchTrash()}>
                            <wy-icon name="delete"></wy-icon>
                            ${T("Trash")}
                          </wy-dropdown-item>
                        ` : M}
                  ` : M}
            `}
        <slot></slot>
      </wy-dropdown>
    `;
  }
}, u(sp, "Gn"), sp), p(kb, "WyFileMenu"), kb);
qf([
  wt({ context: a5, subscribe: !0 }),
  B()
], Dr.prototype, "hasFeatures", 2);
qf([
  x({ type: Object })
], Dr.prototype, "file", 2);
qf([
  x({ type: Boolean })
], Dr.prototype, "noWrapper", 2);
qf([
  x({ type: Boolean })
], Dr.prototype, "small", 2);
qf([
  x({ type: Object })
], Dr.prototype, "hasEventListener", 2);
Dr = qf([
  F("wy-file-menu"),
  be()
], Dr);
function hz(s, t, i, n = {}) {
  return {
    ...n,
    initialPageParam: 0,
    queryKey: [t, i, "comments"],
    queryFn: /* @__PURE__ */ p(async (r) => {
      const a = r.pageParam, o = "/api/" + t + "/" + i + "/comments?order_by=id&skip=" + a, l = await (await s.fetch(o)).json();
      return l.data = l.data || [], l;
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((r) => {
      if (r.end && r.end < r.count)
        return r.end;
    }, "getNextPageParam")
  };
}
u(hz, "pb");
p(hz, "getCommentsOptions");
function dz(s, t) {
  return {
    mutationFn: /* @__PURE__ */ p(async (i) => (await s.fetch("/api/comments/" + i.id, {
      method: "PATCH",
      body: JSON.stringify({
        text: i.text,
        blobs: i.blobs,
        attachments: i.attachments,
        meeting_id: i.meetingId,
        options: i.pollOptions.filter((n) => n.text.trim() !== "").map((n) => ({ id: n.id, text: n.text })),
        embed_id: i.embedId || null
      })
    })).json(), "mutationFn"),
    mutationKey: t,
    onSuccess: /* @__PURE__ */ p((i, n) => {
      n.id && Fe(s.queryClient, [n.type, n.parentId, "comments"], n.id, (r) => {
        r.text = i.text, r.html = i.html, r.attachments = i.attachments, r.meeting = i.meeting, r.updated_at = i.updated_at, r.updated_by = i.updated_by, r.options = i.options, r.embed = i.embed;
      });
    }, "onSuccess")
  };
}
u(dz, "ub");
p(dz, "getUpdateCommentMutationOptions");
function uz(s) {
  const t = s.queryClient;
  return {
    mutationFn: /* @__PURE__ */ p(async (i) => (await s.fetch("/api/" + i.type + "/" + i.parentId + "/comments", {
      method: "POST",
      body: JSON.stringify({
        text: i.text,
        blobs: i.blobs,
        meeting_id: i.meetingId,
        options: i.pollOptions.filter((n) => n.text.trim() !== "").map((n) => ({ text: n.text })),
        embed_id: i.embedId
      })
    })).json(), "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (i) => {
      const n = [i.type, i.parentId, "comments"];
      await t.cancelQueries({ queryKey: n });
      const r = _r(s.queryClient, n, !1);
      if (i.user) {
        const a = {
          id: r ? r.id - 1 : -1,
          app: i.type === "apps" ? { id: i.parentId } : { id: -1 },
          is_trashed: !1,
          text: i.text,
          html: i.text,
          plain: i.text,
          created_by: i.user,
          created_at: (/* @__PURE__ */ new Date()).toUTCString(),
          attachments: { count: 0 },
          reactions: { count: 0 },
          is_subscribed: !1,
          is_starred: !1
        };
        i.type === "files" ? a.parent = { type: Bi.File, id: i.parentId } : i.type === "posts" && (a.parent = { type: Bi.Post, id: i.parentId }), zr(t, n, a, { descending: !1 });
      }
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((i, n) => {
      var r, a;
      const o = [n.type, ((r = i.parent) == null ? void 0 : r.id) ?? i.app.id, "comments"];
      if (!tw(s.queryClient, o, i.id)) {
        const l = _r(s.queryClient, o, !0);
        l ? Fe(s.queryClient, o, l.id, (c) => {
          c.id = i.id, c.app = i.app, c.text = i.text, c.html = i.html, c.embed = i.embed, c.meeting = i.meeting, c.attachments = i.attachments, c.options = i.options, c.created_at = i.created_at, c.created_by = i.created_by, c.updated_at = i.updated_at, c.updated_by = i.updated_by;
        }) : zr(s.queryClient, o, i), ((a = i.parent) == null ? void 0 : a.type) === Bi.Post && Fe(t, ["posts", i.app.id], i.parent.id, (c) => {
          c.comments ? c.comments.count += 1 : c.comments = { count: 1 };
        });
      }
    }, "onSuccess")
  };
}
u(uz, "yb");
p(uz, "getAddCommentMutationOptions");
function pz(s, t, i) {
  const n = s.queryClient, r = {
    mutationKey: [t, i, "comments"],
    mutationFn: /* @__PURE__ */ p(async ({ id: a }) => {
      if (!(await s.fetch("/api/comments/" + a + "/trash", { method: "POST" })).ok)
        throw new Error();
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (a) => {
      Se(
        n,
        { queryKey: r.mutationKey, exact: !1 },
        a.id,
        (o) => Object.assign(o, { is_trashed: !0 })
      );
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((a, o) => {
      Se(
        n,
        { queryKey: r.mutationKey, exact: !1 },
        o.id,
        (l) => Object.assign(l, a)
      ), Fe(n, [o.type, o.appId], o.parentId, (l) => {
        l.comments.count -= 1;
      });
    }, "onSuccess")
  };
  return r;
}
u(pz, "wb");
p(pz, "getTrashCommentMutationOptions");
function fz(s, t, i) {
  return new Ve(s.queryClient, pz(s, t, i));
}
u(fz, "fb");
p(fz, "getTrashCommentMutation");
function yz(s, t, i) {
  const n = s.queryClient, r = {
    mutationKey: [t, i, "comments"],
    mutationFn: /* @__PURE__ */ p(async ({ id: a }) => {
      const o = await s.fetch("/api/comments/" + a + "/restore", { method: "POST" });
      if (!o.ok) {
        const l = await o.json();
        throw new Error(l.detail || l.title, { cause: l });
      }
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (a) => {
      Se(
        n,
        { queryKey: r.mutationKey, exact: !1 },
        a.id,
        (o) => Object.assign(o, { is_trashed: !1 })
      );
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((a, o) => {
      Se(
        n,
        { queryKey: r.mutationKey, exact: !1 },
        o.id,
        (l) => Object.assign(l, a)
      ), Fe(n, [o.type, o.appId], o.parentId, (l) => {
        l.comments.count += 1;
      });
    }, "onSuccess")
  };
  return r;
}
u(yz, "mb");
p(yz, "getRestoreCommentMutationOptions");
function mz(s, t, i) {
  return new Ve(s.queryClient, yz(s, t, i));
}
u(mz, "vb");
p(mz, "getRestoreCommentMutation");
var NB = Object.defineProperty, BB = Object.getOwnPropertyDescriptor, wz = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? BB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && NB(t, i, r), r;
}, "__decorateClass$I"), Sb, rp;
let Em = (Sb = (rp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  dispatchRestore() {
    const t = new CustomEvent("restore", { detail: { id: this.commentId } });
    return this.dispatchEvent(t);
  }
  render() {
    return O`
      <div class="wy-item">
        <div class="wy-item-body">${T("Comment was trashed.")}</div>
        <wy-button @click=${() => this.dispatchRestore()} class="wy-button-variant">${T("Undo")}</wy-button>
      </div>
    `;
  }
}, u(rp, "Yn"), rp), p(Sb, "WyCommentTrashed"), Sb);
Em.styles = fe;
wz([
  x({ type: Number })
], Em.prototype, "commentId", 2);
Em = wz([
  F("wy-comment-trashed"),
  be()
], Em);
const jB = 1e3 * 60 * 60, Pb = jB * 24;
function Uf(s, t, i, n = 7) {
  i ?? (i = /* @__PURE__ */ new Date());
  const r = new Date(i.getFullYear(), i.getMonth(), i.getDate()), a = t.valueOf() - i.valueOf(), o = t.toDateString() === i.toDateString(), l = t.valueOf() > r.valueOf() - Pb * n && t.valueOf() < r.valueOf() + Pb * n;
  if (!o && l) {
    const c = Math.round(a / Pb);
    return new Intl.RelativeTimeFormat(s, { numeric: "auto" }).format(c, "days");
  } else return o ? new Intl.DateTimeFormat(s, { timeStyle: "short" }).format(t) : new Intl.DateTimeFormat(s, { dateStyle: "short" }).format(t);
}
u(Uf, "mc");
p(Uf, "relativeTime");
var XB = Object.defineProperty, FB = Object.getOwnPropertyDescriptor, Pv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? FB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && XB(t, i, r), r;
}, "__decorateClass$H"), Cb, ap;
let Eo = (Cb = (ap = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.totalVotes = 0, this.showSheet = !1, this.getVotesQuery = new Ei(this);
  }
  updated(t) {
    t.has("weavy") && this.weavy && this.option && this.option.id && this.getVotesQuery.trackQuery(qA(this.weavy, this.option.id));
  }
  dispatchVote(t) {
    if (!t)
      return;
    const i = new CustomEvent("vote", { detail: { id: t } });
    return this.dispatchEvent(i);
  }
  openSheet(t) {
    var i;
    t.preventDefault(), t.stopPropagation(), (i = this.getVotesQuery.observer) == null || i.refetch(), this.showSheet = !this.showSheet;
  }
  render() {
    var t, i;
    if (!this.option || !this.option.id)
      return M;
    const { data: n, isLoading: r } = this.getVotesQuery.result ?? {}, a = this.totalVotes > 0 ? Math.round((((t = this.option.votes) == null ? void 0 : t.count) || 0) / this.totalVotes * 100) : 0;
    return O`
      <div
        class="wy-item wy-list-item wy-poll-option"
        tabindex="0"
        @click=${() => {
      var o;
      return this.dispatchVote((o = this.option) == null ? void 0 : o.id);
    }}
        @keydown=${ei}
        @keyup=${_i}
      >
        <div class="wy-progress" style="width: ${a + "%"}"></div>
        ${this.option.has_voted ? O`<wy-icon name="check-circle"></wy-icon>` : O`<wy-icon name="circle-outline"></wy-icon>`}
        <div class="wy-item-body">${this.option.text}</div>
        ${a > 0 ? O`<span
              class="wy-facepile"
              tabindex="0"
              @click=${(o) => this.openSheet(o)}
              @keydown=${ei}
              @keyup=${_i}
            >
              ${a + "%"}
            </span>` : M}
      </div>

      ${this.weavy ? O`
            <wy-sheet
              .show=${this.showSheet}
              @close=${() => this.showSheet = !1}
              @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
            >
              <span slot="appbar-text">${T(ie`Votes on ${this.option.text}`)}</span>
              <!-- <wy-spinner></wy-spinner> -->
              ${this.showSheet && n && !r ? O`
                    ${(i = n.votes) != null && i.data ? n.votes.data.map(
      (o) => O`
                        <div class="wy-item wy-list-item">
                          <wy-avatar .size=${32} .src=${o.avatar_url} .name=${o.display_name}></wy-avatar>
                          <div class="wy-item-body">${o.display_name}</div>
                        </div>
                      `
    ) : M}
                  ` : M}
            </wy-sheet>
          ` : M}
    `;
  }
}, u(ap, "Zn"), ap), p(Cb, "WyPollOption"), Cb);
Eo.styles = fe;
Pv([
  x({ type: Number, attribute: !1 })
], Eo.prototype, "totalVotes", 2);
Pv([
  x({ attribute: !1 })
], Eo.prototype, "option", 2);
Pv([
  B()
], Eo.prototype, "showSheet", 2);
Eo = Pv([
  F("wy-poll-option"),
  be()
], Eo);
var HB = Object.defineProperty, YB = Object.getOwnPropertyDescriptor, gz = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? YB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && HB(t, i, r), r;
}, "__decorateClass$G"), Qb, op;
let zm = (Qb = (op = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.pollOptions = [];
  }
  dispatchVote(t) {
    const i = new CustomEvent("vote", { detail: { id: t } });
    return this.dispatchEvent(i);
  }
  render() {
    const t = this.pollOptions.reduce((i, n) => {
      var r;
      return i + (((r = n.votes) == null ? void 0 : r.count) || 0);
    }, 0);
    return O`
      <div class="wy-poll">
        ${this.pollOptions.map(
      (i) => O`<wy-poll-option
              @vote=${(n) => this.dispatchVote(n.detail.id)}
              .option=${i}
              .totalVotes=${t}></wy-poll-option>`
    )}
      </div>
    `;
  }
}, u(op, "Xn"), op), p(Qb, "WyPoll"), Qb);
zm.styles = [
  fe,
  de`
      :host {
        display: grid;
      }
    `
];
gz([
  x({ type: Array, attribute: !1 })
], zm.prototype, "pollOptions", 2);
zm = gz([
  F("wy-poll")
], zm);
var GB = Object.defineProperty, KB = Object.getOwnPropertyDescriptor, ii = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? KB(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && GB(t, i, r), r;
}, "__decorateClass$F"), Tb, lp;
let St = (Tb = (lp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.location = "apps", this.createdAt = "", this.modifiedAt = void 0, this.isTrashed = !1, this.text = "", this.html = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.previewRef = ke(), this.highlightRef = ke(), this.highlight = !1;
  }
  dispatchVote(t) {
    const i = new CustomEvent("vote", { detail: { id: t } });
    return this.dispatchEvent(i);
  }
  dispatchTrash() {
    const t = new CustomEvent("trash", { detail: { id: this.commentId } });
    return this.dispatchEvent(t);
  }
  dispatchEdit(t) {
    const i = new CustomEvent("edit", { detail: { edit: t } });
    return this.dispatchEvent(i);
  }
  willUpdate(t) {
    t.has("link") && (this.highlight = !!(this.link && nw(this.link, Bi.Comment, { id: this.commentId }))), t.has("highlight") && (this.highlight ? this.part.add("wy-highlight") : this.part.remove("wy-highlight"));
  }
  render() {
    var t, i, n, r, a, o, l;
    const c = (t = this.attachments) == null ? void 0 : t.filter((y) => y.kind === "image" && y.thumbnail_url), h = (i = this.attachments) == null ? void 0 : i.filter((y) => y.kind !== "image" || !y.thumbnail_url), d = new Intl.DateTimeFormat((n = this.weavy) == null ? void 0 : n.locale, {
      dateStyle: "full",
      timeStyle: "short"
    }).format(new Date(this.createdAt)), f = Uf((r = this.weavy) == null ? void 0 : r.locale, new Date(this.createdAt));
    return this.commentId < 0 ? O`<div class="wy-item wy-item-sm wy-comment-header">
            <wy-avatar
              .src="${this.createdBy.avatar_url}"
              .size=${32}
              .name=${this.createdBy.display_name}
              .isBot=${this.createdBy.is_bot}
            ></wy-avatar>
            <div class="wy-item-body">
              <div class="wy-item-title"><span class="wy-placeholder">${this.createdBy.display_name}</span></div>
              <div class="wy-item-text">
                <time class="wy-placeholder">${f}</time>
              </div>
            </div>
          </div>
          <div class="wy-comment-body">
            <div class="wy-comment-content">
              ${this.html ? O`<div class="wy-content"><wy-skeleton .text=${this.text}></wy-skeleton></div>` : ""}
            </div>
          </div>` : O`<div class="wy-item wy-comment-header" ${pe(this.highlightRef)}>
            <wy-avatar
              .src=${this.createdBy.avatar_url}
              .size=${32}
              .name=${this.createdBy.display_name}
              .isBot=${this.createdBy.is_bot}
            ></wy-avatar>
            <div class="wy-item-body">
              <div class="wy-item-title">${this.createdBy.display_name}</div>
              <div class="wy-item-text">
                <time datetime=${this.createdAt} title=${d}>${f}</time>
                ${this.modifiedAt ? O`<time datetime=${this.modifiedAt}> · ${T("edited")}</time>` : M}
              </div>
            </div>

            ${this.user && this.user.id === this.createdBy.id ? O`
                  <div class="wy-item-actions wy-item-top">
                    <wy-dropdown>
                      ${this.user.id === this.createdBy.id ? O`<wy-dropdown-item @click=${() => this.dispatchEdit(!0)}>
                            <wy-icon name="pencil"></wy-icon>
                            ${T("Edit")}
                          </wy-dropdown-item>` : M}
                      ${this.user.id === this.createdBy.id ? O`<wy-dropdown-item @click=${() => this.dispatchTrash()}>
                            <wy-icon name="trashcan"></wy-icon>
                            ${T("Trash")}
                          </wy-dropdown-item>` : M}
                    </wy-dropdown>
                  </div>
                ` : M}
          </div>
          <div class="wy-comment-body">
            <div class="wy-comment-content">
              <!-- image grid -->
              ${c && c.length ? O`<wy-image-grid
                    .images=${c}
                    @file-open=${(y) => {
      var w;
      (w = this.previewRef.value) == null || w.open(y.detail.fileId);
    }}
                  ></wy-image-grid>` : ""}

              <!-- embeds -->
              ${this.embed && (a = this.hasFeatures) != null && a.embeds ? O` <wy-embed class="wy-embed" .embed=${this.embed}></wy-embed> ` : M}
              ${this.html ? O`<div class="wy-content">${So(this.html)}</div>` : ""}

              <!-- poll -->
              ${this.pollOptions && this.pollOptions.length > 0 ? O`
                    <wy-poll
                      .pollOptions=${this.pollOptions}
                      @vote=${(y) => this.dispatchVote(y.detail.id)}
                    ></wy-poll>
                  ` : M}

              <!-- files -->
              ${h && h.length ? O`<wy-attachments-list
                    .files=${h ?? []}
                    @file-open=${(y) => {
      var w;
      (w = this.previewRef.value) == null || w.open(y.detail.fileId);
    }}
                  ></wy-attachments-list>` : ""}

              <!-- meeting -->
              ${this.meeting ? O`<wy-meeting-card .meeting=${this.meeting}></wy-meeting-card>` : ""}
            </div>
          </div>

          ${(o = this.hasFeatures) != null && o.reactions ? O` <wy-reactions
                lineBottom
                small
                .reactions=${this.reactions}
                parentType=${this.location}
                parentId=${this.parentId}
                entityId=${this.commentId}
                entityType="comments"
              ></wy-reactions>` : M}
          ${(l = this.attachments) != null && l.length ? O`<wy-preview ${pe(this.previewRef)} .files=${this.attachments} .isAttachment=${!0}></wy-preview> ` : M} `;
  }
  updated(t) {
    var i;
    t.has("highlight") && this.highlight && ((i = this.highlightRef.value) == null || i.scrollIntoView({ block: "nearest" }));
  }
}, u(lp, "Jn"), lp), p(Tb, "WyCommentView"), Tb);
St.styles = fe;
ii([
  x({ type: Number })
], St.prototype, "commentId", 2);
ii([
  x({ type: Number })
], St.prototype, "parentId", 2);
ii([
  x({ attribute: !1 })
], St.prototype, "location", 2);
ii([
  x({ attribute: !1 })
], St.prototype, "createdBy", 2);
ii([
  x()
], St.prototype, "createdAt", 2);
ii([
  x()
], St.prototype, "modifiedAt", 2);
ii([
  x({ type: Boolean })
], St.prototype, "isTrashed", 2);
ii([
  x()
], St.prototype, "text", 2);
ii([
  x()
], St.prototype, "html", 2);
ii([
  x({ type: Array })
], St.prototype, "attachments", 2);
ii([
  x({ attribute: !1 })
], St.prototype, "embed", 2);
ii([
  x({ type: Array })
], St.prototype, "pollOptions", 2);
ii([
  x({ attribute: !1 })
], St.prototype, "meeting", 2);
ii([
  x({ type: Array })
], St.prototype, "reactions", 2);
ii([
  x({ type: Boolean })
], St.prototype, "highlight", 2);
St = ii([
  F("wy-comment-view"),
  be()
], St);
var vz = "Expected a function", E4 = NaN, JB = "[object Symbol]", ej = /^\s+|\s+$/g, tj = /^[-+]0x[0-9a-f]+$/i, ij = /^0b[01]+$/i, nj = /^0o[0-7]+$/i, sj = parseInt, rj = typeof _w == "object" && _w && _w.Object === Object && _w, aj = typeof self == "object" && self && self.Object === Object && self, oj = rj || aj || Function("return this")(), lj = Object.prototype, cj = lj.toString, hj = Math.max, dj = Math.min, Mb = /* @__PURE__ */ p(function() {
  return oj.Date.now();
}, "now");
function Oz(s, t, i) {
  var n, r, a, o, l, c, h = 0, d = !1, f = !1, y = !0;
  if (typeof s != "function")
    throw new TypeError(vz);
  t = L$(t) || 0, _m(i) && (d = !!i.leading, f = "maxWait" in i, a = f ? hj(L$(i.maxWait) || 0, t) : a, y = "trailing" in i ? !!i.trailing : y);
  function w(L) {
    var I = n, D = r;
    return n = r = void 0, h = L, o = s.apply(D, I), o;
  }
  u(w, "g"), p(w, "invokeFunc");
  function g(L) {
    return h = L, l = setTimeout($, t), d ? w(L) : o;
  }
  u(g, "x"), p(g, "leadingEdge");
  function b(L) {
    var I = L - c, D = L - h, j = t - I;
    return f ? dj(j, a - D) : j;
  }
  u(b, "k"), p(b, "remainingWait");
  function k(L) {
    var I = L - c, D = L - h;
    return c === void 0 || I >= t || I < 0 || f && D >= a;
  }
  u(k, "S"), p(k, "shouldInvoke");
  function $() {
    var L = Mb();
    if (k(L))
      return C(L);
    l = setTimeout($, b(L));
  }
  u($, "P"), p($, "timerExpired");
  function C(L) {
    return l = void 0, y && n ? w(L) : (n = r = void 0, o);
  }
  u(C, "E"), p(C, "trailingEdge");
  function E() {
    l !== void 0 && clearTimeout(l), h = 0, n = c = r = l = void 0;
  }
  u(E, "z"), p(E, "cancel");
  function A() {
    return l === void 0 ? o : C(Mb());
  }
  u(A, "U"), p(A, "flush");
  function R() {
    var L = Mb(), I = k(L);
    if (n = arguments, r = this, c = L, I) {
      if (l === void 0)
        return g(c);
      if (f)
        return l = setTimeout($, t), w(c);
    }
    return l === void 0 && (l = setTimeout($, t)), o;
  }
  return u(R, "O"), p(R, "debounced"), R.cancel = E, R.flush = A, R;
}
u(Oz, "Bb");
p(Oz, "debounce");
function bz(s, t, i) {
  var n = !0, r = !0;
  if (typeof s != "function")
    throw new TypeError(vz);
  return _m(i) && (n = "leading" in i ? !!i.leading : n, r = "trailing" in i ? !!i.trailing : r), Oz(s, t, {
    leading: n,
    maxWait: t,
    trailing: r
  });
}
u(bz, "Ub");
p(bz, "throttle");
function _m(s) {
  var t = typeof s;
  return !!s && (t == "object" || t == "function");
}
u(_m, "tl");
p(_m, "isObject");
function $z(s) {
  return !!s && typeof s == "object";
}
u($z, "qb");
p($z, "isObjectLike");
function xz(s) {
  return typeof s == "symbol" || $z(s) && cj.call(s) == JB;
}
u(xz, "Nb");
p(xz, "isSymbol");
function L$(s) {
  if (typeof s == "number")
    return s;
  if (xz(s))
    return E4;
  if (_m(s)) {
    var t = typeof s.valueOf == "function" ? s.valueOf() : s;
    s = _m(t) ? t + "" : t;
  }
  if (typeof s != "string")
    return s === 0 ? s : +s;
  s = s.replace(ej, "");
  var i = ij.test(s);
  return i || nj.test(s) ? sj(s.slice(2), i ? 2 : 8) : tj.test(s) ? E4 : +s;
}
u(L$, "Au");
p(L$, "toNumber");
var uj = bz;
const R1 = /* @__PURE__ */ bR(uj);
function kz(s, t) {
  return new Ve(s.queryClient, {
    mutationFn: /* @__PURE__ */ p(async () => await s.fetch(`/api/apps/${t}/typing`, {
      method: "PUT",
      body: JSON.stringify({})
    }), "mutationFn")
  });
}
u(kz, "Wb");
p(kz, "typingMutation");
function I$(s, t) {
  return new Ve(s.queryClient, {
    mutationFn: /* @__PURE__ */ p(async () => {
      const i = await s.fetch(`/x/${t}/meetings`, { method: "POST" });
      if (!i.ok)
        throw new Error("Failed to create meeting");
      return await i.json();
    }, "mutationFn")
  });
}
u(I$, "Lu");
p(I$, "addMeetingMutation");
function Ke(s, t, i, n) {
  const r = s.getMutationCache(), a = r.find({
    mutationKey: t,
    predicate: /* @__PURE__ */ p((o) => o.state.variables === i, "predicate")
  });
  if (a && a.state.context) {
    const o = { ...a.state.context };
    n(o);
    const l = { ...a.state, context: o };
    a.state = l, r.notify({
      mutation: a,
      type: "updated",
      action: {
        type: "pending",
        context: a.state.context,
        variables: a.state.variables,
        isPaused: !1
      }
    });
  }
}
u(Ke, "Lt");
p(Ke, "updateMutationContext");
function J5(s, t, i) {
  const n = s.getMutationCache().find({ mutationKey: t, exact: !0, predicate: i });
  n && s.getMutationCache().remove(n);
}
u(J5, "qw");
p(J5, "removeMutation");
function Sz(s, t) {
  const i = s.getMutationCache();
  i.findAll({ mutationKey: t, exact: !0 }).forEach((n) => {
    i.remove(n);
  });
}
u(Sz, "Qb");
p(Sz, "removeMutations");
const eS = /* @__PURE__ */ p((s, t, i = 0, n = "application/octet-stream", r, a = Date.now()) => {
  const o = s && (s instanceof URL ? s.toString() : URL.createObjectURL(s));
  return {
    id: a,
    app: { id: -1 },
    refId: a,
    name: t,
    kind: mv(t),
    size: i,
    media_type: n,
    embed_url: "",
    preview_format: CE(t),
    thumbnail_url: o,
    preview_url: o,
    download_url: o,
    rev: -1,
    created_by: r,
    created_at: (/* @__PURE__ */ new Date()).toUTCString(),
    is_subscribed: !1,
    is_trashed: !1,
    is_starred: !1
  };
}, "getTempFile");
function Pz(s) {
  const t = s ? s.reduce(
    (i, n) => {
      var r, a;
      const o = (r = n.context) == null ? void 0 : r.file;
      return o && (a = n.context) != null && a.status.progress && o.size ? {
        loaded: i.loaded + n.context.status.progress * o.size,
        total: i.total + o.size
      } : i;
    },
    { loaded: 0, total: 0 }
  ) : { loaded: 0, total: 0 };
  return {
    loaded: t.loaded,
    total: t.total,
    percent: t.total > 0 ? t.loaded / t.total : null
  };
}
u(Pz, "Kb");
p(Pz, "getFileMutationsTotalProgress");
function Cz(s) {
  return s ? s.some((t) => {
    var i;
    return ((i = t.context) == null ? void 0 : i.status.state) === "conflict";
  }) ? "conflict" : s.some((t) => t.status === "error") ? "error" : s.every((t) => t.status === "success") ? "ok" : "pending" : "ok";
}
u(Cz, "Gb");
p(Cz, "getFileMutationsTotalStatus");
function Qz(s) {
  return (s == null ? void 0 : s.filter((t) => {
    var i;
    return ((i = t.context) == null ? void 0 : i.status.state) === "conflict" || t.status === "error";
  })) || [];
}
u(Qz, "Yb");
p(Qz, "getFileMutationsByConflictOrError");
function Tz(s, t, i) {
  const n = s.queryClient;
  n.getMutationCache().findAll({
    mutationKey: ["apps", t.id, "files"],
    exact: !0,
    predicate: /* @__PURE__ */ p((r) => {
      var a, o;
      return /error|success/.test(r.state.status) && ((o = (a = r.state.variables) == null ? void 0 : a.blob) == null ? void 0 : o.name) === i;
    }, "predicate")
  }).forEach((r) => {
    n.getMutationCache().remove(r);
  });
}
u(Tz, "Zb");
p(Tz, "removeSettledFileMutations");
function Mz(s, t, i) {
  const n = s.queryClient, r = ["apps", i.id, "files"];
  return {
    mutationFn: /* @__PURE__ */ p(async ({ blob: a, replace: o = !1 }) => {
      const l = await s.fetch("/api/apps/" + i.id + "/files", {
        method: "POST",
        body: JSON.stringify({ blob_id: a.id, replace: o })
      });
      if (!l.ok) {
        const c = await l.json();
        throw new Error(c.detail || c.title, { cause: c });
      }
      return await l.json();
    }, "mutationFn"),
    mutationKey: r,
    onMutate: /* @__PURE__ */ p(async (a) => {
      await n.cancelQueries({ queryKey: r, exact: !0 }), Rz(s, i, a.blob.name), Tz(s, i, a.blob.name);
      let o;
      try {
        o = a.blob.thumbnail_url && new URL(a.blob.thumbnail_url) || void 0;
      } catch {
      }
      const l = eS(o, a.blob.name, a.blob.size, a.blob.media_type, t);
      return {
        type: a.replace ? "replace" : "create",
        file: l,
        status: { state: "pending" }
      };
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((a, o, l) => (Ke(n, r, o, (c) => {
      c && (c.status.state = "ok", c.status.progress = void 0, c.status.text = void 0);
    }), n.invalidateQueries({ queryKey: r })), "onSuccess"),
    onError(a, o, l) {
      var c, h, d;
      ((c = a == null ? void 0 : a.cause) == null ? void 0 : c.status) === 409 ? Ke(n, r, o, (f) => {
        f && (f.status.progress = void 0, f.status.state = "conflict", f.status.text = a.message);
      }) : ((h = l == null ? void 0 : l.file) != null && h.refId || (d = l == null ? void 0 : l.file) == null || d.id, Ke(n, r, o, (f) => {
        f && (f.status.state = "error", f.status.progress = void 0, f.status.text = a.message);
      }));
    }
  };
}
u(Mz, "Xb");
p(Mz, "getCreateFileMutationOptions");
function Rz(s, t, i, n) {
  const r = s.queryClient;
  r.getMutationCache().findAll({
    mutationKey: ["apps", t.id, "blobs", n],
    exact: !0,
    status: "success",
    predicate: /* @__PURE__ */ p((a) => {
      var o;
      return ((o = a.state.data) == null ? void 0 : o.name) === i;
    }, "predicate")
  }).forEach((a) => {
    r.getMutationCache().remove(a);
  });
}
u(Rz, "Jb");
p(Rz, "removeSuccessfulUploadBlobMutations");
async function tS(s, t, i) {
  const n = new FormData();
  n.append("blob", t);
  const r = await s.upload("/api/blobs", "POST", n, p1.Auto, (a) => {
    i && i({ progress: a });
  });
  if (!r.ok) {
    const a = await r.json();
    throw new Error(a.detail || a.title, { cause: a });
  }
  return await r.json();
}
u(tS, "Nw");
p(tS, "uploadBlob");
function Az(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async (t) => await tS(s, t.file, t.onProgress), "mutationFn")
    // TODO: implement onmutate, onsuccess, onerror...
  };
}
u(Az, "t2");
p(Az, "getSimpleUploadBlobMutationOptions");
function iS(s, t, i, n) {
  const r = s.queryClient, a = ["apps", i.id, "blobs", n];
  return {
    mutationFn: /* @__PURE__ */ p(async (o) => await tS(s, o.file, o.onProgress), "mutationFn"),
    mutationKey: a,
    onMutate: /* @__PURE__ */ p(async (o) => {
      await r.cancelQueries({ queryKey: a, exact: !0 });
      const l = eS(o.file, o.file.name, o.file.size, o.file.type, t);
      return o.onProgress = ({ progress: c }) => {
        Ke(r, a, o, (h) => {
          h.status.state = "pending", h.status.progress = c;
        });
      }, { type: "upload", file: l, status: { state: "pending" } };
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((o, l, c) => {
      Ke(r, a, l, (h) => {
        h.status.state = "ok", h.status.progress = void 0, h.status.text = void 0;
      });
    }, "onSuccess"),
    onError(o, l, c) {
      const h = o.cause;
      h && h.status === 409 ? Ke(r, a, l, (d) => {
        d.status.state = "conflict", d.status.progress = void 0, d.status.text = h.detail || h.title;
      }) : Ke(r, a, l, (d) => {
        d && (d.status.state = "error", d.status.progress = void 0, d.status.text = h.detail || h.title);
      });
    }
  };
}
u(iS, "jw");
p(iS, "getUploadBlobMutationOptions");
function W$(s, t) {
  return s.findAll(t.filters).map(
    (i) => t.select ? t.select(i) : i.state
  );
}
u(W$, "Ru");
p(W$, "getResult");
var cp;
const Ez = (cp = class {
  constructor(t) {
    this.alwaysUpdate = !1, t.addController(this), this.host = t, this.setContext();
  }
  async setContext() {
    this.whenContext = new Promise((t) => this.resolveContext = t), await _o(this.host), this.context = new Er(this.host, { context: Pt, subscribe: !0 });
  }
  hostUpdate() {
    var t, i;
    (t = this.context) != null && t.value && ((i = this.resolveContext) == null || i.call(this));
  }
  async trackMutationState(t, i) {
    var n, r, a;
    if (i || (await this.whenContext, i = (r = (n = this.context) == null ? void 0 : n.value) == null ? void 0 : r.queryClient), !i)
      throw new Error("No QueryClient provided");
    return (a = this.mutationCacheUnsubscribe) == null || a.call(this), this.options = t, this.mutationCache = i.getMutationCache(), this.mutationCacheSubscribe(), this.result;
  }
  mutationCacheSubscribe() {
    this.mutationCache && this.options && (this.result = W$(this.mutationCache, this.options), this.mutationCacheUnsubscribe = this.mutationCache.subscribe((t) => {
      if (this.mutationCache && this.options && /added|removed|updated/.test(t.type)) {
        const i = W$(this.mutationCache, this.options);
        (this.result !== i || yc(this.result, i)) && (this.result = i, this.host.requestUpdate());
      }
    }), this.host.requestUpdate());
  }
  untrackMutationState() {
    var t;
    (t = this.mutationCacheUnsubscribe) == null || t.call(this), this.mutationCacheUnsubscribe = void 0, this.result = void 0, this.options = void 0, this.mutationCache = void 0, this.host.requestUpdate();
  }
  hostConnected() {
    this.mutationCacheSubscribe();
  }
  hostDisconnected() {
    var t;
    (t = this.mutationCacheUnsubscribe) == null || t.call(this);
  }
}, u(cp, "Hp"), cp);
p(Ez, "MutationStateController");
let zz = Ez;
async function _z(s, t) {
  const i = await s.fetch("/api/blobs/external", { method: "POST", body: JSON.stringify(t) });
  if (!i.ok) {
    const n = await i.json();
    throw new Error(n.detail || n.title, { cause: n });
  }
  return await i.json();
}
u(_z, "e2");
p(_z, "externalBlob");
function Lz(s, t, i, n) {
  const r = s.queryClient, a = ["apps", i.id, "blobs", n];
  return {
    mutationFn: /* @__PURE__ */ p(async (o) => await _z(s, o.externalBlob), "mutationFn"),
    mutationKey: a,
    onMutate: /* @__PURE__ */ p(async (o) => (await r.cancelQueries({ queryKey: a, exact: !0 }), { type: "attach", file: eS(void 0, o.externalBlob.name, o.externalBlob.size, void 0, t), status: { state: "pending" } }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((o, l, c) => {
      Ke(r, a, l, (h) => {
        h.status.state = "ok", h.status.progress = void 0, h.status.text = void 0;
      });
    }, "onSuccess"),
    onError(o, l, c) {
      const h = o.cause;
      h && h.status === 409 ? Ke(r, a, l, (d) => {
        d.status.state = "conflict", d.status.progress = void 0, d.status.text = h.detail || h.title;
      }) : Ke(r, a, l, (d) => {
        d && (d.status.state = "error", d.status.progress = void 0, d.status.text = h.detail || h.title);
      });
    }
  };
}
u(Lz, "i2");
p(Lz, "getExternalBlobMutationOptions");
function nS(s, t, i, n) {
  return new Ve(s.queryClient, Lz(s, t, i, n));
}
u(nS, "Ww");
p(nS, "getExternalBlobMutation");
const pj = /(((https?|ftp):\/\/|(www|ftp)\.)[\w]+(.[\w]+)([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#]))/gim;
let jl = [], Lm = [], A1 = [], $g = [], ps = {};
const fj = /* @__PURE__ */ p((s, t) => s.length === t.length && s.every((i, n) => i === t[n]), "arrayEquals");
function Iz() {
  return !!Object.keys(ps).length;
}
u(Iz, "n2");
p(Iz, "isFetchingEmbeds");
async function Wz(s, t) {
  new FormData().append("url", s);
  let i;
  try {
    const n = await t.fetch("/api/embeds", { method: "POST", body: JSON.stringify({ url: s }) });
    if (!n.ok)
      throw new Error();
    i = await n.json(), delete ps[s], Lm = [...Lm, s];
  } catch {
    A1 = [...A1, s], delete ps[s];
  }
  return i;
}
u(Wz, "a2");
p(Wz, "fetchEmbed");
const yj = /* @__PURE__ */ p(() => {
  jl = [], Lm = [], A1 = [], $g = [], ps = {};
}, "clearEmbeds"), z4 = /* @__PURE__ */ p((s) => {
  Lm = s;
}, "initEmbeds"), mj = /* @__PURE__ */ p(async (s, t, i) => {
  var n;
  let r = ((n = s.match(pj)) == null ? void 0 : n.map((a) => a)) || null;
  if (r !== null && (r = r.map((a) => a.startsWith("//") ? "http:" + a : !a.startsWith("http://") && !a.startsWith("https://") ? "http://" + a : a)), !(r === null || r.length === 0) && (r.length !== jl.length || !fj(r, jl))) {
    jl = r, r.forEach((a) => {
      !Lm.includes(a) && !A1.includes(a) && !$g.includes(a) && typeof ps[a] > "u" && (Bt(), ps[a] = window.setTimeout(async () => {
        const o = await Wz(a, i);
        o && t(o);
      }, 500));
    }), $g = $g.filter((a) => jl.includes(a));
    for (const a in ps)
      jl.includes(a) || (Bt(), window.clearTimeout(ps[a]), delete ps[a]);
  }
}, "getEmbeds");
var Iy, hp;
const Vz = (hp = class {
  constructor(t) {
    U(this, Iy, !1), t.addController(this), this.host = t, t.addEventListener("dragstart", () => this.isDragActive = !0), t.addEventListener("dragenter", () => this.isDragActive = !0), t.addEventListener("dragover", (i) => {
      i.preventDefault(), this.isDragActive = !0;
    }), t.addEventListener("dragleave", () => this.isDragActive = !1), t.addEventListener("dragend", () => this.isDragActive = !1), t.addEventListener("drop", (i) => this.handleDrop(i));
  }
  get isDragActive() {
    return P(this, Iy);
  }
  set isDragActive(t) {
    P(this, Iy) !== t && (q(this, Iy, t), this.host.requestUpdate());
  }
  handleDrop(t) {
    var i, n;
    t.preventDefault();
    const r = [];
    (i = t.dataTransfer) != null && i.items ? [...t.dataTransfer.items].forEach((a) => {
      if (a.kind === "file") {
        const o = a.getAsFile();
        o ? r.push(o) : console.error("Could not add file");
      }
    }) : (n = t.dataTransfer) != null && n.files && [...t.dataTransfer.files].forEach((a) => {
      r.push(a);
    }), r.length && this.dispatchUploadFiles(r), this.isDragActive = !1;
  }
  dispatchUploadFiles(t) {
    const i = new CustomEvent("drop-files", { detail: { files: t } });
    return this.host.dispatchEvent(i);
  }
  hostDisconnected() {
  }
}, u(hp, "Vp"), hp);
Iy = /* @__PURE__ */ new WeakMap(), p(Vz, "DropZoneController");
let Zz = Vz;
const Di = _1() ? window.navigator.userAgent : "", Dz = Di.includes("iPad") || Di.includes("Android") && !Di.includes("Mobi") || !1, wj = Di.includes("Mobi") || Dz || !1, gj = !wj && !Dz, _4 = Di.includes("Windows") ? "Windows" : Di.includes("Macintosh") ? "Mac" : Di.includes("iPad") || Di.includes("iPhone") || Di.includes("iPod") ? "iOS" : Di.includes("Android") ? "Android" : void 0;
_4 === "Android" && Di.includes("; wv") || _4 === "iOS" && Di.includes("Safari");
var vj = Object.defineProperty, Oj = Object.getOwnPropertyDescriptor, Nf = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Oj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && vj(t, i, r), r;
}, "__decorateClass$E"), Rb, dp;
let Ms = (Rb = (dp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.status = {
      state: "ok"
    }, this.hasHover = !0, this.isRenaming = !1;
  }
  dispatchEditName(t) {
    const i = new CustomEvent("edit-name", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchRename(t, i) {
    const n = new CustomEvent("rename", { detail: { file: t, name: i } });
    return this.dispatchEvent(n);
  }
  dispatchTrash(t) {
    const i = new CustomEvent("trash", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchRestore(t) {
    const i = new CustomEvent("restore", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchDeleteForever(t) {
    const i = new CustomEvent("delete-forever", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchSubscribe(t, i) {
    const n = new CustomEvent("subscribe", { detail: { file: t, subscribe: i } });
    return this.dispatchEvent(n);
  }
  render() {
    const t = this.file;
    if (!t) return M;
    const { icon: i } = Ls(t.name), n = fE(this.actionType), r = Gi(t.name), a = Uo(t.provider), o = /* @__PURE__ */ p((c) => {
      c.stopImmediatePropagation();
      const h = c.target;
      h.value && h.value !== t.name ? this.dispatchRename(t, h.value) : this.dispatchEditName({ id: NaN });
    }, "handleRename"), l = /* @__PURE__ */ p((c) => {
      const h = c.target;
      c.key === "Escape" ? (c.preventDefault(), h.value = t.name, h.blur()) : c.key === "Enter" && (c.preventDefault(), h.blur());
    }, "handleRenameKey");
    return O`
      <div
        class="wy-item wy-list-item ${ot({
      "wy-item-trashed": t.is_trashed,
      "wy-item-hover": this.hasHover && !t.is_trashed && !this.isRenaming
    })}"
        title=${t.name}>
        ${this.status.state === "error" ? O`<wy-icon name="alert-octagon" color="error" title=${Me(this.status.text)}></wy-icon>` : this.status.state === "conflict" ? O`<wy-icon name="alert" color="yellow" title=${Me(this.status.text)}></wy-icon>` : this.status.state === "pending" ? O`<wy-spinner ?nospin=${!!this.status.progress} .progress=${this.status.progress}></wy-spinner>` : O`<wy-icon .name=${i} .overlayName=${a} .overlayPath=${n} .size=${24} .kind=${t.kind} ext=${r}></wy-icon>`}
        <div class="wy-item-body">
          ${this.isRenaming ? O`
                <input
                  type="text"
                  maxlength="256"
                  class="wy-input"
                  .defaultValue=${t.name}
                  @blur=${o}
                  @keyup=${(c) => {
      jn(c), l(c);
    }}
                  @click=${(c) => c.preventDefault()}
                  @focus=${wv}
                  ${pe(U$)} />
              ` : O`
                <span title=${t.name + (this.status.text ? `: ${this.status.text}` : "")}
                  ><slot name="title"
                    >${this.title || t.name}${this.status.text ? O`: <em>${this.status.text}</em>` : M}</slot
                  ></span
                >
              `}
        </div>
        <div class="wy-item-actions">
          <slot name="actions">
            <wy-file-menu
              .file=${t}
              @edit-name=${(c) => this.dispatchEditName(c.detail.file)}
              @trash=${(c) => this.dispatchTrash(c.detail.file)}
              @restore=${(c) => this.dispatchRestore(c.detail.file)}
              @delete-forever=${(c) => this.dispatchDeleteForever(c.detail.file)}
              @subscribe=${(c) => this.dispatchSubscribe(c.detail.file, c.detail.subscribe)}>
            </wy-file-menu>
          </slot>
        </div>
      </div>
    `;
  }
}, u(dp, "ea"), dp), p(Rb, "WyFileItem"), Rb);
Ms.styles = fe;
Nf([
  x({ type: Object })
], Ms.prototype, "file", 2);
Nf([
  x({ type: Object })
], Ms.prototype, "status", 2);
Nf([
  x({ type: Boolean })
], Ms.prototype, "hasHover", 2);
Nf([
  x()
], Ms.prototype, "actionType", 2);
Nf([
  B()
], Ms.prototype, "isRenaming", 2);
Ms = Nf([
  F("wy-file-item")
], Ms);
var bj = Object.defineProperty, $j = Object.getOwnPropertyDescriptor, it = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? $j(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && bj(t, i, r), r;
}, "__decorateClass$D"), Ab, up;
let Ze = (Ab = (up = class extends tt(G) {
  constructor() {
    super(), this.exportParts = new ae(this), this.disabled = !1, this._placeholder = "", this.text = "", this.options = [], this.attachments = [], this.buttonText = "", this.typing = !0, this.draft = !1, this.editorType = "posts", this.editorClass = "wy-post-editor", this.editorLocation = "apps", this.editorError = !1, this.showPolls = !1, this.pollOptions = [], this.embeds = [], this.draftKey = "", this.uploadBlobMutation = new cn(
      this
    ), this.mutatingFiles = new zz(this), this.fileInputRef = ke(), this.cloudFilesRef = ke(), this.dropZone = new Zz(this), this.keyMap = [], this.editorRef = ke(), this.editorInitialized = !1, this.throttledTyping = R1(
      async () => {
        this.weavy && this.app && (this.app.type === Te.ChatRoom || this.app.type === Te.PrivateChat) && await (await kz(this.weavy, this.app.id)).mutate();
      },
      2e3,
      { leading: !0, trailing: !1 }
    ), this.throttledDrafting = R1(
      async () => {
        this.saveDraft();
      },
      500,
      { leading: !0, trailing: !0 }
    ), this.openFileInput = () => {
      var t;
      (t = this.fileInputRef.value) == null || t.click();
    }, this.openCloudFiles = () => {
      var t;
      (t = this.cloudFilesRef.value) == null || t.open();
    }, this.createMeeting = async (t) => {
      if (this.weavy && t.source === this.authWindow && this.weavy.url.origin === t.origin && t.data && t.data.name && t.data.name.endsWith("-authorized")) {
        const i = t.data.name.slice(0, -11), n = await I$(this.weavy, i).mutate();
        n.auth_url || (this.meeting = n);
      }
    }, this.addEventListener("drop-files", this.handleDropFiles), this.addEventListener("keydown", xm), this.addEventListener("keyup", jn);
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(t) {
    this._placeholder = t;
  }
  willUpdate(t) {
    var i;
    if (super.willUpdate(t), (t.has("weavy") || t.has("app") || t.has("user") || t.has("parentId")) && this.weavy && this.app && this.user) {
      this.draftKey = `draft-${this.editorType}-${this.parentId || this.app.id}`, this.uploadBlobMutation.trackMutation(
        iS(
          this.weavy,
          this.user,
          this.app,
          `${this.editorLocation}-${this.parentId || this.app.id}`
        )
      );
      const n = [
        "apps",
        this.app.id,
        "blobs",
        `${this.editorLocation}-${this.parentId || this.app.id}`
      ];
      if (this.mutatingFiles.trackMutationState(
        { filters: { mutationKey: n, exact: !0 } },
        this.weavy.queryClient
      ), this.externalBlobMutation = nS(
        this.weavy,
        this.user,
        this.app,
        `${this.editorLocation}-${this.parentId || this.app.id}`
      ), this.draft) {
        const r = localStorage.getItem(this.draftKey);
        if (r) {
          const a = JSON.parse(r);
          this.text = a.text, this.embeds = a.embeds, this.meeting = a.meeting, ((i = a.pollOptions) == null ? void 0 : i.length) > 0 && (this.showPolls = !0, this.pollOptions = a.pollOptions), z4(this.embeds.map((o) => o.original_url));
        } else
          this.clearEditor();
      }
      this.embed && (this.embeds = [this.embed], z4(this.embeds.map((r) => r.original_url))), this.options && this.options.length > 0 && (this.pollOptions = this.options, this.showPolls = !0);
    }
    t.has("text") && this.editor && this.editor.dispatch({ changes: { from: 0, to: this.editor.state.doc.length, insert: this.text } });
  }
  updated(t) {
    if ((t.has("weavy") || t.has("app") || t.has("user") || t.has("parentId")) && this.weavy && this.app && this.user && this.editorRef.value && this.weavy.whenUrl().then(() => {
      import(
        /* webpackIgnore: true */
        /* @vite-ignore */
        new URL("./es/editor.js", typeof WEAVY_IMPORT_URL == "string" && (!import.meta.url || !new URL(import.meta.url).href.startsWith(WEAVY_IMPORT_URL)) ? WEAVY_IMPORT_URL : import.meta.url).href
      ).then((i) => i.editor).then(
        ({
          weavyHighlighter: i,
          syntaxHighlighting: n,
          history: r,
          dropCursor: a,
          mentions: o,
          autocompletion: l,
          placeholder: c,
          keymap: h,
          weavyKeymap: d,
          defaultKeymap: f,
          historyKeymap: y,
          markdown: w,
          languages: g,
          EditorView: b,
          EditorState: k,
          weavyDesktopMessageKeymap: $,
          Compartment: C
        }) => {
          var E, A, R;
          this.editorInitialized = !0, this.editorRef.value && !this.editor && (this.editorRef.value.innerHTML = ""), this.editorEditable = new C(), this.EditorView = b;
          const L = this.editorType === "messages" && gj && $ ? [...$] : [];
          this.editorExtensions = [
            b.contentAttributes.of({
              spellcheck: "true",
              autocorrect: "on",
              autocapitalize: "on"
            }),
            r(),
            a(),
            o,
            l({
              override: (E = this.hasFeatures) != null && E.mentions ? [(I) => this.autocomplete(I)] : null,
              //showMention
              closeOnBlur: !1,
              aboveCursor: this.editorType !== "posts",
              icons: !1,
              addToOptions: [
                {
                  render: /* @__PURE__ */ p(function(I, D) {
                    var j, ee, se, oe;
                    const we = document.createElement("div");
                    we.classList.add("wy-item"), we.classList.add("wy-list-item"), we.classList.add("wy-item-hover"), (!((j = I.item) != null && j.access) || I.item.access === Fs.None) && we.classList.add("wy-disabled");
                    const re = document.createElement("wy-avatar");
                    re.src = ((ee = I.item) == null ? void 0 : ee.avatar_url) || "", re.name = ((se = I.item) == null ? void 0 : se.display_name) || "";
                    const _e = document.createElement("div");
                    return _e.classList.add("wy-item-body"), _e.innerText = ((oe = I.item) == null ? void 0 : oe.display_name) || "", we.appendChild(re), we.appendChild(_e), we;
                  }, "render"),
                  position: 10
                }
              ]
            }),
            c(this.placeholder),
            n(i, { fallback: !0 }),
            b.lineWrapping,
            h.of([...L, ...d, ...f, ...y]),
            w({ codeLanguages: g }),
            b.domEventHandlers({
              paste: /* @__PURE__ */ p((I, D) => {
                var j, ee;
                let se = [];
                const oe = ((j = I.clipboardData) == null ? void 0 : j.items) || [];
                for (const we in oe) {
                  const re = oe[we];
                  if (re.kind === "file") {
                    const _e = re.getAsFile();
                    _e && (se = [...se, _e]);
                  }
                }
                if (se.length > 0 && (ee = this.hasFeatures) != null && ee.attachments) {
                  for (let we = 0; we < se.length; we++)
                    this.handleUploadFiles(se);
                  return !0;
                }
              }, "paste"),
              keyup: /* @__PURE__ */ p((I, D) => {
                var j, ee;
                this.typing && D.state.doc.toString() !== "" && (j = this.hasFeatures) != null && j.typing && this.throttledTyping(), this.draft && this.throttledDrafting(), (ee = this.hasFeatures) != null && ee.embeds && D.state.doc.toString() !== "" && this.handleEmbeds(D.state.doc.toString());
              }, "keyup")
            }),
            b.updateListener.of((I) => {
            }),
            this.editorEditable.of(b.editable.of(!this.disabled))
          ], this.editor ? this.editor.dispatch({
            // Update readonly state
            effects: this.editorEditable.reconfigure(b.editable.of(!this.disabled))
          }) : (this.editor = new b({
            state: k.create({
              doc: this.text,
              extensions: this.editorExtensions
            }),
            parent: this.editorRef.value
          }), (R = (A = this.editorRef.value) == null ? void 0 : A.querySelector(".cm-editor")) == null || R.addEventListener("Weavy-SoftSubmit", this.submit.bind(this)));
        }
      );
    }), t.has("disabled") && this.editor && this.editorEditable && this.EditorView && this.editor.dispatch({
      // Update readonly state
      effects: this.editorEditable.reconfigure(this.EditorView.editable.of(!this.disabled))
    }), t.has("placeholder")) {
      const i = this.renderRoot.querySelector(".cm-placeholder");
      i && this.editor && (i.setAttribute("aria-label", `placeholder ${this.placeholder}`), i.innerText = this.placeholder);
    }
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("message", this.createMeeting);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("message", this.createMeeting);
  }
  handleRemoveMeeting() {
    this.meeting = void 0;
  }
  async autocomplete(t) {
    if (!this.weavy || !this.app)
      return null;
    let i = t.matchBefore(/(?!\]\(@)(^[^@]{0,1}|[^@]{2})@([^@]+)/);
    if (!t.explicit && !i) return null;
    i = t.matchBefore(/@[^@]+/);
    const n = i == null ? void 0 : i.text.substring(1), r = await this.weavy.fetch(`/api/apps/${this.app.id}/members?member=null&q=${n}`), a = await (r == null ? void 0 : r.json());
    let o = [];
    return a.data && (o = a.data.filter((l) => typeof l.display_name < "u").map((l) => ({
      item: l,
      label: l.display_name,
      apply: /* @__PURE__ */ p((c, h, d, f) => {
        const y = "[" + l.display_name + "](@u" + l.id.toString() + ")";
        let w = c.state.update({ changes: { from: d - 1, to: d } });
        c.dispatch(w), w = c.state.update({
          changes: { from: d - 1, to: f - 1, insert: y }
        }), c.dispatch(w);
      }, "apply")
    }))), {
      from: i ? i.from + 1 : t.pos,
      options: o,
      filter: !1
    };
  }
  handleDropFiles(t) {
    const i = t.detail;
    i.files && this.handleUploadFiles(i.files);
  }
  async handleUploadFiles(t, i) {
    if (t) {
      for (let n = 0; n < t.length; n++) {
        const r = { file: t[n] };
        await this.uploadBlobMutation.mutate(r), this.saveDraft();
      }
      i && (i.value = "");
    }
  }
  handleExternalBlobs(t) {
    var i;
    if (t)
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        (i = this.externalBlobMutation) == null || i.mutate({ externalBlob: r });
      }
  }
  handleRemoveUpload(t) {
    !this.weavy || !this.app || J5(
      this.weavy.queryClient,
      ["apps", this.app.id, "blobs", `${this.editorLocation}-${this.parentId || this.app.id}`],
      (i) => {
        var n, r;
        return ((n = i.state.data) == null ? void 0 : n.id) === ((r = t.data) == null ? void 0 : r.id);
      }
    );
  }
  saveDraft() {
    var t;
    if (!this.draft) return;
    const i = this.mutatingFiles.result;
    let n = (t = this.editor) == null ? void 0 : t.state.doc.toString();
    n === void 0 && (n = this.text), (!i || !i.length) && !this.meeting && !this.embeds.length && (!this.pollOptions.length || this.pollOptions.filter((r) => r.text.trim() !== "").length === 0) && n === "" ? localStorage.removeItem(this.draftKey) : localStorage.setItem(
      this.draftKey,
      JSON.stringify({
        meeting: this.meeting,
        text: n,
        pollOptions: this.pollOptions.filter((r) => r.text.trim() !== ""),
        embeds: this.embeds
      })
    );
  }
  handleRemoveAttachment(t) {
    this.attachments = this.attachments.filter((i) => i.id !== t.id);
  }
  async submit() {
    var t, i, n, r;
    const a = this.mutatingFiles.result, o = a == null ? void 0 : a.some((w) => w.status === "pending"), l = (t = this.editor) == null ? void 0 : t.state.doc.toString().trim(), c = (i = this.meeting) == null ? void 0 : i.id, h = a == null ? void 0 : a.map((w) => {
      var g;
      return (g = w.data) == null ? void 0 : g.id;
    }), d = ((n = this.attachments) == null ? void 0 : n.map((w) => w.id)) || [], f = this.pollOptions.filter((w) => w.text.trim() !== "");
    if (Iz() || o || !l && !c && (h == null ? void 0 : h.length) == 0 && f.length == 0 && d.length == 0 && this.embeds.length == 0)
      return;
    const y = {
      detail: { text: l, meetingId: c, blobs: h, attachments: d, pollOptions: f, embed: (r = this.embeds[0]) == null ? void 0 : r.id },
      bubbles: !0,
      composed: !0
    };
    this.dispatchEvent(new CustomEvent("submit", y)), this.resetEditor();
  }
  resetEditor() {
    this.clearEditor(), this.weavy && this.app && Sz(this.weavy.queryClient, [
      "apps",
      this.app.id,
      "blobs",
      `${this.editorLocation}-${this.parentId || this.app.id}`
    ]), localStorage.removeItem(this.draftKey);
  }
  clearEditor() {
    var t;
    (t = this.editor) == null || t.dispatch({ changes: { from: 0, to: this.editor.state.doc.length, insert: "" } }), this.text = "", this.meeting = void 0, this.pollOptions = [], this.showPolls = !1, this.embeds = [], yj();
  }
  async handleMeetingClick(t) {
    if (!this.weavy || !this.user)
      return;
    const i = await I$(this.weavy, t).mutate();
    i.auth_url ? this.authWindow = window.open(i.auth_url, "oauthwin", "height=640,width=480") : this.meeting = i;
  }
  setEmbeds(t) {
    this.embeds = [t, ...this.embeds], this.saveDraft();
  }
  async handleEmbeds(t) {
    this.weavy && await mj(t, this.setEmbeds.bind(this), this.weavy);
  }
  removeEmbed(t) {
    this.embeds = this.embeds.filter((i) => i.id !== t.detail.id), this.saveDraft();
  }
  swapEmbed() {
    const t = this.embeds.shift();
    t && (this.embeds = [...this.embeds, t]), this.saveDraft();
  }
  openPolls() {
    if (this.showPolls)
      this.showPolls = !1;
    else {
      if (this.pollOptions.length === 0) {
        const t = { id: null, text: "" };
        this.pollOptions = [...this.pollOptions, t];
      }
      this.showPolls = !0;
    }
  }
  handlePollOptionChange(t, i) {
    const n = [...this.pollOptions];
    n[i].text = t.target.value, this.pollOptions = n, this.saveDraft();
  }
  handlePollOptionAdd(t, i) {
    if (i === this.pollOptions.length - 1 && this.pollOptions.length < 5) {
      const n = { id: null, text: "" };
      this.pollOptions = [...this.pollOptions, n], this.saveDraft();
    }
  }
  /**
   * Editor loading fallback dummy.
   * Hard copy of the rendered nodes when the editor is empty. Cleaned up to not be editable.
   */
  renderEditorDummy() {
    return this.editorInitialized ? M : O`
      <div class="cm-editor">
        <div class="cm-announced"></div>
        <div tabindex="-1" class="cm-scroller">
          <div class="cm-content cm-lineWrapping">
            <div class="cm-line"
              ><img class="cm-widgetBuffer" aria-hidden="true" /><span class="cm-placeholder">${this.placeholder}</span
              ><br
            /></div>
          </div>
        </div>
      </div>
    `;
  }
  renderTopSlot() {
    return M;
  }
  renderMiddleSlot() {
    var t, i, n, r, a, o;
    return O`
      <!-- Input -->
      <div class=${ot({ "wy-post-editor-text": !0, "wy-is-invalid": this.editorError })} ${pe(this.editorRef)}>
        ${this.renderEditorDummy()}
      </div>

      <div class="wy-post-editor-inputs">
        <div class="wy-post-editor-buttons">
          ${(t = this.hasFeatures) != null && t.attachments ? O`<wy-button
                  kind="icon"
                  @click=${this.openFileInput}
                  title=${T("From device")}
                  ?disabled=${this.disabled}
                >
                  <wy-icon name="attachment"></wy-icon>
                </wy-button>
                <input
                  type="file"
                  ${pe(this.fileInputRef)}
                  @click=${(l) => l.stopPropagation()}
                  @change=${(l) => this.handleUploadFiles(
      Array.from(l.target.files || []),
      l.target
    )}
                  multiple
                  hidden
                  tabindex="-1"
                  ?disabled=${this.disabled}
                />` : M}
          ${(i = this.hasFeatures) != null && i.cloudFiles ? O`<wy-button
                kind="icon"
                @click=${this.openCloudFiles}
                title=${T("From cloud")}
                ?disabled=${this.disabled}
              >
                <wy-icon name="cloud"></wy-icon>
              </wy-button>` : M}
          ${(n = this.hasFeatures) != null && n.zoomMeetings ? O`
                <wy-button
                  kind="icon"
                  @click=${() => this.handleMeetingClick("zoom")}
                  title=${T("Zoom meeting")}
                  ?disabled=${this.disabled}
                >
                  <wy-icon svg="zoom-meetings"></wy-icon>
                </wy-button>
              ` : M}
          ${(r = this.hasFeatures) != null && r.googleMeet ? O`
                <wy-button
                  kind="icon"
                  @click=${() => this.handleMeetingClick("google")}
                  title=${T("Google Meet")}
                  ?disabled=${this.disabled}
                >
                  <wy-icon svg="google-meet"></wy-icon>
                </wy-button>
              ` : M}
          ${(a = this.hasFeatures) != null && a.microsoftTeams ? O`
                <wy-button
                  kind="icon"
                  @click=${() => this.handleMeetingClick("microsoft")}
                  title=${T("Microsoft Teams")}
                  ?disabled=${this.disabled}
                >
                  <wy-icon svg="microsoft-teams"></wy-icon>
                </wy-button>
              ` : M}
          ${(o = this.hasFeatures) != null && o.polls ? O`<wy-button kind="icon" @click=${this.openPolls} title=${T("Poll")} ?disabled=${this.disabled}>
                <wy-icon name="poll"></wy-icon>
              </wy-button>` : M}
        </div>

        <!-- Button -->
        <wy-button @click="${this.submit}" color="primary" title=${this.buttonText} ?disabled=${this.disabled}>
          ${this.buttonText}
        </wy-button>
      </div>
    `;
  }
  renderBottomSlot() {
    return this.renderLists();
  }
  renderLists() {
    var t, i, n, r, a, o, l, c;
    const h = this.mutatingFiles.result;
    return this.disabled ? M : O`
      <!-- polls -->
      ${(t = this.hasFeatures) != null && t.polls && this.showPolls && this.pollOptions.length > 0 ? O`
            <div class="wy-poll-form">
              ${this.pollOptions.map((d, f) => O`<input
                  value=${d.text}
                  @change=${(y) => this.handlePollOptionChange(y, f)}
                  @keyup=${jn}
                  class="wy-input"
                  type="text"
                  placeholder=${T("+ add an option")}
                  @focus=${(y) => this.handlePollOptionAdd(y, f)}
                />`)}
            </div>
          ` : M}

      <!-- meetings -->
      ${((i = this.meeting) == null ? void 0 : i.provider) === "zoom" && (n = this.hasFeatures) != null && n.zoomMeetings || ((r = this.meeting) == null ? void 0 : r.provider) === "google" && (a = this.hasFeatures) != null && a.googleMeet || ((o = this.meeting) == null ? void 0 : o.provider) === "microsoft" && (l = this.hasFeatures) != null && l.microsoftTeams ? O`
            <div class="wy-item wy-list-item">
              <wy-icon svg="${Q1(this.meeting.provider)}"></wy-icon>
              <div class="wy-item-body">${T1(this.meeting.provider)}</div>
              <wy-button kind="icon" @click=${this.handleRemoveMeeting}>
                <wy-icon name="close-circle"></wy-icon>
              </wy-button>
            </div>
          ` : M}

      <!-- blobs -->
      ${h && h.length ? zi(
      h,
      (d) => "mutation" + d.submittedAt,
      (d) => {
        var f;
        if ((f = d.context) != null && f.file) {
          const y = d.context.file, w = {
            ...d.context.status
          };
          return O`
                  <wy-file-item
                    .file=${d.context.file}
                    .status=${w}
                    title="${qk(d.context.type)}: ${y.name + (w.text ? `: ${w.text}` : "")}"
                  >
                    <span slot="title"
                      ><strong></strong> ${y.name}
                      ${w.text ? O`: <em>${w.text}</em>` : M}</span
                    >
                    <wy-button
                      slot="actions"
                      kind="icon"
                      @click=${() => this.handleRemoveUpload(d)}
                      title=${T("Discard", { desc: "Button action to discard" })}
                    >
                      <wy-icon name="close"></wy-icon>
                    </wy-button>
                  </wy-file-item>
                `;
        }
        return M;
      }
    ) : M}

      <!-- attachments -->
      ${this.attachments && this.attachments.map(
      (d) => O`<wy-file-item .file=${d} title="${d.name}">
          <span slot="title">${d.name}</span>
          <wy-button
            slot="actions"
            kind="icon"
            @click=${() => this.handleRemoveAttachment(d)}
            title=${T("Remove", { desc: "Button action to remove" })}
          >
            <wy-icon name="close"></wy-icon>
          </wy-button>
        </wy-file-item>`
    )}

      <!-- embeds -->
      ${(c = this.hasFeatures) != null && c.embeds && this.embeds.length > 0 ? O`<div class="wy-embed-preview">
            ${this.embeds.map(
      (d) => O`
                <wy-embed
                  class="wy-embed"
                  .embed=${d}
                  @embed-remove=${this.removeEmbed}
                  @embed-swap=${this.swapEmbed}
                  .enableSwap=${this.embeds.length > 1}
                ></wy-embed>
              `
    )}
          </div> ` : M}
    `;
  }
  renderCloudFiles() {
    return this.disabled ? M : O`
      <wy-cloud-files
        ${pe(this.cloudFilesRef)}
        @external-blobs=${(t) => this.handleExternalBlobs(t.detail.externalBlobs)}
      ></wy-cloud-files>
    `;
  }
  render() {
    const t = this.dropZone.isDragActive;
    return O`
      <div
        class=${ot({
      "wy-editor": !0,
      [this.editorClass]: !0,
      "wy-dragging": t
    })}
        data-drag-title=${T("Drop files here to upload.")}
      >
        ${this.renderTopSlot()} ${this.renderMiddleSlot()} ${this.renderBottomSlot()}
      </div>
      ${this.renderCloudFiles()}
    `;
  }
}, u(up, "ia"), up), p(Ab, "WyEditor"), Ab);
Ze.styles = fe;
it([
  x({ type: Boolean })
], Ze.prototype, "disabled", 2);
it([
  x({ attribute: !1 })
], Ze.prototype, "parentId", 2);
it([
  x()
], Ze.prototype, "placeholder", 1);
it([
  x()
], Ze.prototype, "text", 2);
it([
  x({ attribute: !1 })
], Ze.prototype, "embed", 2);
it([
  x({ attribute: !1 })
], Ze.prototype, "options", 2);
it([
  x({ attribute: !1 })
], Ze.prototype, "attachments", 2);
it([
  x()
], Ze.prototype, "buttonText", 2);
it([
  x({ type: Boolean })
], Ze.prototype, "typing", 2);
it([
  x({ type: Boolean })
], Ze.prototype, "draft", 2);
it([
  x()
], Ze.prototype, "editorType", 2);
it([
  x()
], Ze.prototype, "editorClass", 2);
it([
  x()
], Ze.prototype, "editorLocation", 2);
it([
  B()
], Ze.prototype, "meeting", 2);
it([
  B()
], Ze.prototype, "editorError", 2);
it([
  B()
], Ze.prototype, "showPolls", 2);
it([
  B()
], Ze.prototype, "pollOptions", 2);
it([
  B()
], Ze.prototype, "embeds", 2);
it([
  B()
], Ze.prototype, "draftKey", 2);
it([
  B()
], Ze.prototype, "keyMap", 2);
it([
  B()
], Ze.prototype, "editorExtensions", 2);
it([
  B()
], Ze.prototype, "editor", 2);
Ze = it([
  F("wy-editor"),
  be()
], Ze);
var xj = Object.defineProperty, kj = Object.getOwnPropertyDescriptor, Ft = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? kj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && xj(t, i, r), r;
}, "__decorateClass$C"), Eb, pp;
let vt = (Eb = (pp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.location = "apps", this.createdAt = "", this.modifiedAt = void 0, this.isSubscribed = !1, this.isTrashed = !1, this.text = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.seenBy = [], this.updateCommentMutation = new cn(this);
  }
  dispatchEdit(t) {
    const i = new CustomEvent("edit", { detail: { edit: t } });
    return this.dispatchEvent(i);
  }
  handleSubmit(t) {
    this.updateCommentMutation.mutate({
      id: this.commentId,
      type: this.location,
      parentId: this.parentId,
      text: t.detail.text,
      meetingId: t.detail.meetingId,
      blobs: t.detail.blobs,
      attachments: t.detail.attachments,
      pollOptions: t.detail.pollOptions,
      embedId: t.detail.embed
    }), this.dispatchEdit(!1);
  }
  async willUpdate(t) {
    (t.has("parentId") || t.has("weavy")) && this.parentId && this.weavy && this.updateCommentMutation.trackMutation(
      dz(this.weavy, [this.location, this.parentId, "comments"])
    );
  }
  render() {
    return O`
      <nav class="wy-item">
        <div class="wy-item-body">
          <div class="wy-item-title">${T("Edit comment")}</div>
        </div>

        <wy-button @click=${() => this.dispatchEdit(!1)} kind="icon">
          <wy-icon name="close"></wy-icon>
        </wy-button>
      </nav>
      <wy-editor
        editorLocation=${this.location}
        .text=${this.text}
        .embed=${this.embed}
        .options=${this.pollOptions}
        .attachments=${this.attachments ?? []}
        .parentId=${this.commentId}
        .typing=${!1}
        .draft=${!1}
        placeholder=${T("Edit comment...")}
        buttonText=${T("Update", { desc: "Button action to update" })}
        @submit=${(t) => this.handleSubmit(t)}></wy-editor>
    `;
  }
}, u(pp, "sa"), pp), p(Eb, "WyCommentEdit"), Eb);
vt.styles = fe;
Ft([
  wt({ context: Pt, subscribe: !0 }),
  B()
], vt.prototype, "weavy", 2);
Ft([
  x({ type: Number })
], vt.prototype, "parentId", 2);
Ft([
  x({ attribute: !1 })
], vt.prototype, "location", 2);
Ft([
  x({ type: Number })
], vt.prototype, "commentId", 2);
Ft([
  x({ attribute: !1 })
], vt.prototype, "createdBy", 2);
Ft([
  x()
], vt.prototype, "createdAt", 2);
Ft([
  x()
], vt.prototype, "modifiedAt", 2);
Ft([
  x({ type: Boolean })
], vt.prototype, "isSubscribed", 2);
Ft([
  x({ type: Boolean })
], vt.prototype, "isTrashed", 2);
Ft([
  x()
], vt.prototype, "text", 2);
Ft([
  x({ type: Array })
], vt.prototype, "attachments", 2);
Ft([
  x({ type: Array })
], vt.prototype, "pollOptions", 2);
Ft([
  x({ attribute: !1 })
], vt.prototype, "meeting", 2);
Ft([
  x({ attribute: !1 })
], vt.prototype, "embed", 2);
Ft([
  x({ type: Array })
], vt.prototype, "reactions", 2);
Ft([
  x({ type: Array })
], vt.prototype, "seenBy", 2);
vt = Ft([
  F("wy-comment-edit"),
  be()
], vt);
var Sj = Object.defineProperty, Pj = Object.getOwnPropertyDescriptor, It = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Pj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Sj(t, i, r), r;
}, "__decorateClass$B"), zb, fp;
let ht = (zb = (fp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.location = "apps", this.createdAt = "", this.modifiedAt = void 0, this.isTrashed = !1, this.html = "", this.text = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.commentCount = 0, this.seenBy = [], this.editing = !1;
  }
  dispatchVote(t) {
    const i = new CustomEvent("vote", { detail: { id: t, parentId: this.commentId, parentType: "comments" } });
    return this.dispatchEvent(i);
  }
  dispatchSubscribe(t) {
    const i = new CustomEvent("subscribe", { detail: { id: this.commentId, subscribe: t } });
    return this.dispatchEvent(i);
  }
  dispatchTrash() {
    const t = new CustomEvent("trash", { detail: { id: this.commentId } });
    return this.dispatchEvent(t);
  }
  dispatchRestore() {
    const t = new CustomEvent("restore", { detail: { id: this.commentId } });
    return this.dispatchEvent(t);
  }
  render() {
    return O`
      ${this.isTrashed ? O`<wy-comment-trashed
            class="wy-comment"
            commentId=${this.commentId}
            @restore=${() => {
      this.dispatchRestore();
    }}></wy-comment-trashed> ` : M}
      ${!this.isTrashed && this.editing ? O`<wy-comment-edit
            class="wy-comment"
            .commentId=${this.commentId}
            .parentId=${this.parentId}
            .location=${this.location}
            .text=${this.text}
            .pollOptions=${this.pollOptions}
            .attachments=${this.attachments}
            .embed=${this.embed}
            @edit=${(t) => {
      this.editing = t.detail.edit;
    }}></wy-comment-edit> ` : M}
      ${!this.isTrashed && !this.editing ? O`<wy-comment-view
            class="wy-comment"
            id="comment-view-${this.commentId}"
            .commentId=${this.commentId}
            .parentId=${this.parentId}
            .location=${this.location}
            .createdBy=${this.createdBy}
            .createdAt=${this.createdAt}
            .modifiedAt=${this.modifiedAt}
            .isTrashed=${this.isTrashed}
            .text=${this.text}
            .html=${this.html}            
            .attachments=${this.attachments}
            .embed=${this.embed}
            .meeting=${this.meeting}
            .pollOptions=${this.pollOptions}
            .reactions=${this.reactions}
            @edit=${(t) => {
      this.editing = t.detail.edit;
    }}
            @subscribe=${(t) => {
      this.dispatchSubscribe(t.detail.subscribe);
    }}
            @trash=${() => {
      this.dispatchTrash();
    }}
            @vote=${(t) => {
      this.dispatchVote(t.detail.id);
    }}></wy-comment-view> ` : M}
    `;
  }
}, u(fp, "ra"), fp), p(zb, "WyComment"), zb);
ht.styles = [fe, de`:host { display: contents; }`];
It([
  x({ type: Number })
], ht.prototype, "commentId", 2);
It([
  x({ type: Number })
], ht.prototype, "parentId", 2);
It([
  x({ attribute: !1 })
], ht.prototype, "location", 2);
It([
  x({ attribute: !1 })
], ht.prototype, "createdBy", 2);
It([
  x()
], ht.prototype, "createdAt", 2);
It([
  x()
], ht.prototype, "modifiedAt", 2);
It([
  x({ type: Boolean })
], ht.prototype, "isTrashed", 2);
It([
  x()
], ht.prototype, "html", 2);
It([
  x()
], ht.prototype, "text", 2);
It([
  x({ attribute: !1 })
], ht.prototype, "attachments", 2);
It([
  x({ type: Array })
], ht.prototype, "pollOptions", 2);
It([
  x({ attribute: !1 })
], ht.prototype, "meeting", 2);
It([
  x({ attribute: !1 })
], ht.prototype, "embed", 2);
It([
  x({ type: Array })
], ht.prototype, "reactions", 2);
It([
  x({ attribute: !1 })
], ht.prototype, "commentCount", 2);
It([
  x({ type: Array })
], ht.prototype, "seenBy", 2);
It([
  B()
], ht.prototype, "editing", 2);
ht = It([
  F("wy-comment")
], ht);
var Cj = Object.defineProperty, Qj = Object.getOwnPropertyDescriptor, Tj = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Qj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Cj(t, i, r), r;
}, "__decorateClass$A"), _b, yp;
let V$ = (_b = (yp = class extends Ze {
  constructor() {
    super(), this.editorType = "comments", this.editorClass = "wy-comment-editor";
  }
  willUpdate(t) {
    super.willUpdate(t), t.has("editorLocation") && this.editorLocation === "files" && (this.editorClass = "wy-comment-editor wy-comment-editor-bottom");
  }
  renderTopSlot() {
    return M;
  }
  renderMiddleSlot() {
    var t, i, n, r, a, o, l, c, h, d, f;
    return O`<div class="wy-comment-editor-inputs">
      <!-- Add -->
      ${(t = this.hasFeatures) != null && t.attachments || (i = this.hasFeatures) != null && i.cloudFiles || (n = this.hasFeatures) != null && n.zoomMeetings || (r = this.hasFeatures) != null && r.googleMeet || (a = this.hasFeatures) != null && a.microsoftTeams ? O`<wy-dropdown icon="plus" directionY="up" ?disabled=${this.disabled}>
            ${(o = this.hasFeatures) != null && o.attachments ? O`<wy-dropdown-item @click=${this.openFileInput} title=${T("From device")}>
                    <wy-icon name="attachment"></wy-icon>
                    <span>${T("From device")}</span>
                  </wy-dropdown-item>
                  <input
                    type="file"
                    ${pe(this.fileInputRef)}
                    @click=${(y) => y.stopPropagation()}
                    @change=${(y) => this.handleUploadFiles(
      Array.from(y.target.files || []),
      y.target
    )}
                    multiple
                    hidden
                    tabindex="-1"
                  />` : M}
            ${(l = this.hasFeatures) != null && l.cloudFiles ? O`<wy-dropdown-item @click=${this.openCloudFiles} title=${T("From cloud")}>
                  <wy-icon name="cloud"></wy-icon>
                  <span>${T("From cloud")}</span>
                </wy-dropdown-item>` : M}
            ${(c = this.hasFeatures) != null && c.zoomMeetings ? O`
                  <wy-dropdown-item @click=${() => this.handleMeetingClick("zoom")} title=${T("Zoom meeting")}>
                    <wy-icon svg="zoom-meetings"></wy-icon>
                    <span>${T("Zoom meeting")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(h = this.hasFeatures) != null && h.googleMeet ? O`
                  <wy-dropdown-item @click=${() => this.handleMeetingClick("google")} title=${T("Google Meet")}>
                    <wy-icon svg="google-meet"></wy-icon>
                    <span>${T("Google Meet")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(d = this.hasFeatures) != null && d.microsoftTeams ? O`
                  <wy-dropdown-item
                    @click=${() => this.handleMeetingClick("microsoft")}
                    title=${T("Microsoft Teams")}
                  >
                    <wy-icon svg="microsoft-teams"></wy-icon>
                    <span>${T("Microsoft Teams")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(f = this.hasFeatures) != null && f.polls ? O`<wy-dropdown-item @click=${this.openPolls} title=${T("Poll")}>
                  <wy-icon name="poll"></wy-icon>
                  <span>${T("Poll")}</span>
                </wy-dropdown-item>` : M}
          </wy-dropdown>` : M}

      <!-- Input -->
      <div
        class=${ot({ "wy-comment-editor-text": !0, "wy-is-invalid": this.editorError })}
        ${pe(this.editorRef)}
      >
        ${this.renderEditorDummy()}
      </div>

      <!-- Button -->
      <wy-button kind="icon" @click="${this.submit}" title=${this.buttonText} ?disabled=${this.disabled}>
        <wy-icon name="send"></wy-icon>
      </wy-button>
    </div>`;
  }
  renderBottomSlot() {
    return this.renderLists();
  }
}, u(yp, "na"), yp), p(_b, "WyCommentEditor"), _b);
V$ = Tj([
  F("wy-comment-editor"),
  be()
], V$);
var Mj = Object.defineProperty, Rj = Object.getOwnPropertyDescriptor, qz = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$b"), sS = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Rj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Mj(t, i, r), r;
}, "__decorateClass$z"), Uz = /* @__PURE__ */ p((s, t, i) => t.has(s) || qz("Cannot " + i), "__accessCheck$b"), L4 = /* @__PURE__ */ p((s, t, i) => (Uz(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$b"), Aj = /* @__PURE__ */ p((s, t, i) => t.has(s) ? qz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$b"), I4 = /* @__PURE__ */ p((s, t, i, n) => (Uz(s, t, "write to private field"), t.set(s, i), i), "__privateSet$b"), Xl, Lb, mp;
let Pf = (Lb = (mp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.location = "apps", this.commentsQuery = new Vo(this), this.addCommentMutation = new cn(this), this.infiniteScroll = new Zo(this), this.pagerRef = ke(), Aj(this, Xl), this.handleRealtimeCommentCreated = () => {
      var t;
      (t = this.weavy) == null || t.queryClient.invalidateQueries({ queryKey: [this.location, this.parentId, "comments"] });
    }, this.handleRealtimeReactionAdded = (t) => {
      !this.weavy || t.entity.type !== "comment" || Fe(
        this.weavy.queryClient,
        [this.location, this.parentId, "comments"],
        t.entity.id,
        (i) => {
          xf(i, t.reaction, t.actor);
        }
      );
    }, this.handleRealtimeReactionDeleted = (t) => {
      !this.weavy || t.entity.type !== "comment" || Fe(
        this.weavy.queryClient,
        [this.location, this.parentId, "comments"],
        t.entity.id,
        (i) => {
          xf(i, void 0, t.actor);
        }
      );
    };
  }
  async willUpdate(t) {
    var i;
    if (super.willUpdate(t), (t.has("parentId") || t.has("weavy")) && this.parentId && this.weavy && (this.commentsQuery.trackInfiniteQuery(hz(this.weavy, this.location, this.parentId)), this.addCommentMutation.trackMutation(uz(this.weavy)), this.removeCommentMutation = fz(this.weavy, this.location, this.parentId), this.restoreCommentMutation = mz(this.weavy, this.location, this.parentId), this.pollMutation = uv(this.weavy, [this.location, this.parentId, "comments"])), (t.has("weavy") || t.has("app")) && this.weavy && this.app) {
      (i = L4(this, Xl)) == null || i.call(this);
      const n = `a${this.app.id}`;
      this.weavy.subscribe(n, "comment_created", this.handleRealtimeCommentCreated), this.weavy.subscribe(n, "reaction_added", this.handleRealtimeReactionAdded), this.weavy.subscribe(n, "reaction_removed", this.handleRealtimeReactionDeleted), I4(this, Xl, () => {
        var r, a, o;
        (r = this.weavy) == null || r.unsubscribe(n, "comment_created", this.handleRealtimeCommentCreated), (a = this.weavy) == null || a.unsubscribe(n, "reaction_added", this.handleRealtimeReactionAdded), (o = this.weavy) == null || o.unsubscribe(n, "reaction_removed", this.handleRealtimeReactionDeleted), I4(this, Xl, void 0);
      });
    }
  }
  update(t) {
    super.update(t), this.infiniteScroll.observe(this.commentsQuery.result, this.pagerRef.value);
  }
  async handleSubmit(t) {
    this.app && this.user && await this.addCommentMutation.mutate({
      appId: this.app.id,
      parentId: this.parentId,
      type: this.location,
      text: t.detail.text,
      meetingId: t.detail.meetingId,
      blobs: t.detail.blobs,
      pollOptions: t.detail.pollOptions,
      embedId: t.detail.embed,
      user: this.user
    });
  }
  renderComments(t) {
    if (t) {
      const i = zs(t);
      return zi(
        i,
        (n) => n.id,
        (n) => {
          var r, a, o;
          return [
            O`<wy-comment
              id="comment-${n.id}"
              .commentId=${n.id}
              .parentId=${this.parentId}
              .location=${this.location}
              .createdBy=${n.created_by}
              .createdAt=${n.created_at}
              .modifiedAt=${n.updated_at}
              .isTrashed=${n.is_trashed}
              .html=${n.html}
              .text=${n.text}
              .attachments=${(r = n.attachments) == null ? void 0 : r.data}
              .embed=${n.embed}
              .meeting=${n.meeting}
              .pollOptions=${(a = n.options) == null ? void 0 : a.data}
              .reactions=${(o = n.reactions) == null ? void 0 : o.data}
              @trash=${async (l) => {
              var c;
              const h = await this.whenApp();
              (c = this.removeCommentMutation) == null || c.mutate({
                id: l.detail.id,
                appId: h.id,
                parentId: this.parentId,
                type: this.location
              });
            }}
              @restore=${async (l) => {
              var c;
              const h = await this.whenApp();
              (c = this.restoreCommentMutation) == null || c.mutate({
                id: l.detail.id,
                appId: h.id,
                parentId: this.parentId,
                type: this.location
              });
            }}
              @vote=${(l) => {
              var c;
              (c = this.pollMutation) == null || c.mutate({
                optionId: l.detail.id,
                parentType: l.detail.parentType,
                parentId: l.detail.parentId
              });
            }}
            ></wy-comment>`
          ];
        }
      );
    }
    return M;
  }
  render() {
    var t;
    const { data: i, hasNextPage: n, isPending: r } = this.commentsQuery.result ?? {};
    return O`
      <div class="wy-comments">
        ${i ? this.renderComments(i) : r ? O`<wy-spinner padded reveal></wy-spinner>` : M}
        ${n ? O`<div ${pe(this.pagerRef)} part="wy-pager wy-pager-bottom"></div>` : M}
      </div>

      <wy-comment-editor
        editorLocation=${this.location}
        .parentId=${this.parentId}
        .typing=${!1}
        .draft=${!0}
        ?disabled=${!ko(Ar.Create, (t = this.app) == null ? void 0 : t.permissions)}
        placeholder=${T("Create a comment...")}
        buttonText=${T("Comment", { desc: "Button action to comment" })}
        @submit=${(a) => this.handleSubmit(a)}
      ></wy-comment-editor>
    `;
  }
  disconnectedCallback() {
    var t;
    (t = L4(this, Xl)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(mp, "aa"), mp), p(Lb, "WyCommentList"), Lb);
Xl = /* @__PURE__ */ new WeakMap();
Pf.styles = [fe, Do];
sS([
  x({ type: Number })
], Pf.prototype, "parentId", 2);
sS([
  x({ attribute: !1 })
], Pf.prototype, "location", 2);
Pf = sS([
  F("wy-comment-list"),
  be()
], Pf);
function Cv(s, t) {
  return ["apps", s.id, "file", t.id, "versions"];
}
u(Cv, "ap");
p(Cv, "getFileVersionsKey");
function Nz(s, t, i) {
  const n = s.queryClient, r = ["apps", t.id, "files"], a = Cv(t, i), o = {
    mutationKey: r,
    mutationFn: /* @__PURE__ */ p(async ({ versionFile: l }) => {
      if (l.id >= 1 && l.rev) {
        if (!(await s.fetch(`/api/files/${l.id}/versions/${l.rev}/restore`, {
          method: "POST"
        })).ok)
          throw new Error();
      } else
        throw new Error(`Could not restore ${l.name} to version ${l.rev}.`);
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (l) => (Se(
      n,
      { queryKey: o.mutationKey, exact: !1 },
      l.versionFile.id,
      (c) => Object.assign(c, l.versionFile, { status: "pending" })
    ), { type: "version", file: i, status: { state: "pending" } }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((l, c) => {
      Se(
        n,
        { queryKey: o.mutationKey, exact: !1 },
        c.versionFile.id,
        (h) => Object.assign(h, l, { status: "ok" })
      ), Ke(n, o.mutationKey, c, (h) => {
        h.status.state = "ok";
      });
    }, "onSuccess"),
    onError(l, c, h) {
      h != null && h.file && Se(
        n,
        { queryKey: o.mutationKey, exact: !1 },
        c.versionFile.id,
        (d) => Object.assign(d, h.file, { status: "error" })
      ), Ke(n, o.mutationKey, c, (d) => {
        d.status.state = "error", d.status.text = l.message;
      });
    },
    onSettled() {
      n.invalidateQueries({ queryKey: a });
    }
  };
  return o;
}
u(Nz, "_2");
p(Nz, "getFileVersionRestoreMutationOptions");
function Bz(s, t, i) {
  return new Ve(s.queryClient, Nz(s, t, i));
}
u(Bz, "P2");
p(Bz, "getFileVersionRestoreMutation");
function jz(s, t, i) {
  const n = s.queryClient, r = Cv(t, i);
  return {
    mutationKey: r,
    mutationFn: /* @__PURE__ */ p(async ({ versionFile: a }) => {
      if (a.id >= 1 && a.rev) {
        const o = await s.fetch(`/api/files/${a.id}/versions/${a.rev}`, {
          method: "DELETE"
        });
        if (!o.ok) {
          const l = await o.json();
          throw new Error(l.detail || l.title, { cause: l });
        }
      } else {
        const o = {
          status: 400,
          title: `Could not remove ${a.name} version ${a.rev}.`
        };
        throw new Error(o.detail || o.title, { cause: o });
      }
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (a) => {
      Fe(
        n,
        r,
        /* @__PURE__ */ p((o) => o.id === a.versionFile.id && o.rev === a.versionFile.rev, "versionPredicate"),
        (o) => Object.assign(o, { status: "pending" })
      );
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((a, o) => {
      d5(n, r, /* @__PURE__ */ p((l) => l.id === o.versionFile.id && l.rev === o.versionFile.rev, "versionPredicate"));
    }, "onSuccess"),
    onError(a, o) {
      Fe(
        n,
        r,
        /* @__PURE__ */ p((l) => l.id === o.versionFile.id && l.rev === o.versionFile.rev, "versionPredicate"),
        (l) => Object.assign(l, { status: void 0 })
      );
    }
  };
}
u(jz, "M2");
p(jz, "getFileVersionDeleteMutationOptions");
function Xz(s, t, i) {
  return new Ve(s.queryClient, jz(s, t, i));
}
u(Xz, "z2");
p(Xz, "getFileVersionDeleteMutation");
var Ej = Object.defineProperty, zj = Object.getOwnPropertyDescriptor, rS = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? zj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Ej(t, i, r), r;
}, "__decorateClass$y"), Ib, wp;
let Cf = (Ib = (wp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.fileVersionsQuery = new Ei(this);
  }
  selectVersion(t) {
    this.activeVersion = t, this.dispatchFileVersionSelect(t);
  }
  dispatchFileVersionSelect(t) {
    const i = new CustomEvent("file-version-select", { detail: { versionFile: t } });
    return this.dispatchEvent(i);
  }
  handleRevert(t) {
    var i;
    (i = this.fileVersionRestoreMutation) == null || i.mutate({ versionFile: t }), this.selectVersion(t);
  }
  handleRemove(t) {
    var i;
    (i = this.fileVersionDeleteMutation) == null || i.mutate({ versionFile: t }), this.activeVersion === t && (this.activeVersion = this.file);
  }
  triggerDownload(t) {
    wc(t.download_url, "_top", t.name, !0);
  }
  willUpdate(t) {
    super.willUpdate(t), (t.has("weavy") || t.has("file") || t.has("app")) && this.weavy && this.file && this.app && (this.fileVersionsQuery.trackQuery(
      ln(
        this.weavy,
        Cv(this.app, this.file),
        `/api/files/${this.file.id}/versions`
      )
    ), this.fileVersionRestoreMutation = Bz(this.weavy, this.app, this.file), this.fileVersionDeleteMutation = Xz(this.weavy, this.app, this.file));
  }
  render() {
    const { data: t, isPending: i } = this.fileVersionsQuery.result ?? { isPending: !0 };
    return i ? O`<wy-spinner overlay></wy-spinner>` : t != null && t.data ? O`
          <div class="wy-list wy-versions">
            ${zi(
      t.data,
      (n) => n.id,
      (n, r) => {
        var a, o, l, c;
        const h = Ls(n.name || "").icon, d = t.data ? t.data.length - r : NaN, f = Gi(n.name), y = new Date(n.updated_at || n.created_at), w = !!this.file.external_url, g = new Intl.DateTimeFormat((a = this.weavy) == null ? void 0 : a.locale, {
          dateStyle: "full",
          timeStyle: "short"
        }).format(y), b = Uf((o = this.weavy) == null ? void 0 : o.locale, new Date(y));
        return w ? O`
                      <wy-empty noNetwork>
                        <span slot="title">${T("Versions are not available for external cloud files.")}</span>
                      </wy-empty>
                    ` : O`
                      <div
                        class="wy-item wy-list-item-lg wy-item-hover ${ot({
          "wy-active": n.rev == ((l = this.activeVersion) == null ? void 0 : l.rev)
        })}"
                        tabindex="0"
                        @click=${() => this.selectVersion(n)}
                        @keydown=${ei}
                        @keyup=${_i}
                      >
                        <wy-icon name=${h} size="48" kind=${n.kind} ext=${f}></wy-icon>
                        <div class="wy-item-body">
                          <div class="wy-item-title">${d}. ${n.name}</div>
                          <div class="wy-item-text">
                            <time datetime=${n.updated_at || n.created_at} title=${g}
                              >${b}</time
                            >
                            · ${(c = n.updated_by) == null ? void 0 : c.display_name}</div
                          >
                        </div>

                        <wy-dropdown directionX="left">
                          <wy-dropdown-item @click=${() => this.triggerDownload(n)}>
                            <wy-icon name="download"></wy-icon>
                            ${T("Download")}
                          </wy-dropdown-item>                          

                          ${r !== 0 ? O`
                                <wy-dropdown-divider></wy-dropdown-divider>
                                <wy-dropdown-item @click=${() => this.handleRevert(n)}>
                                  <wy-icon name="restore"></wy-icon>
                                  ${"Revert"}
                                </wy-dropdown-item>
                                <wy-dropdown-item @click=${() => this.handleRemove(n)}>
                                  <wy-icon name="delete"></wy-icon>
                                  ${T("Remove", { desc: "Button action to remove" })}
                                </wy-dropdown-item>
                              ` : M}
                        </wy-dropdown>
                      </div>
                    `;
      }
    )}
          </div>
        ` : M;
  }
}, u(wp, "oa"), wp), p(Ib, "WyFileVersions"), Ib);
Cf.styles = fe;
rS([
  x({ attribute: !1 })
], Cf.prototype, "file", 2);
rS([
  x({ attribute: !1 })
], Cf.prototype, "activeVersion", 2);
Cf = rS([
  F("wy-file-versions"),
  be()
], Cf);
var _j = Object.defineProperty, Lj = Object.getOwnPropertyDescriptor, Ht = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Lj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && _j(t, i, r), r;
}, "__decorateClass$x"), Wb, gp;
let Ot = (Wb = (gp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.currentId = NaN, this.isAttachment = !1, this.filled = !1, this.showOverlay = !1, this.commentsOpen = !1, this.versionsOpen = !1, this.sidePanelMaximized = !1, this.persistState = new G5(this), this.previewFileRef = ke(), this.swipeScrollRef = ke(), this.prevRef = ke(), this.nextRef = ke(), this.swipeScroller = new $B(this), this.disableSwipeScroll = !1, this.handleKeys = (t) => {
      this.showOverlay && (t.key === "ArrowLeft" ? (t.stopPropagation(), this.setPrev()) : t.key === "ArrowRight" && (t.stopPropagation(), this.setNext()));
    };
  }
  async dispatchOpen() {
    const t = await this.whenApp(), i = await this.whenHasFeatures(), n = this.currentId, r = this.commentsOpen ? "comments" : this.versionsOpen ? "versions" : void 0, a = this.currentFile ? [this.currentFile] : [], o = this.isAttachment, l = new CustomEvent("wy-preview-open", {
      detail: { fileId: n, tab: r, files: a, app: t, hasFeatures: i, isAttachment: o },
      cancelable: !0,
      bubbles: !1,
      composed: !0
    });
    this.dispatchEvent(l) || (this.showOverlay = !1, this.commentsOpen = !1, this.versionsOpen = !1);
  }
  async dispatchClose() {
    const t = new CustomEvent("wy-preview-close", { cancelable: !1, bubbles: !1, composed: !0 });
    this.dispatchEvent(t);
  }
  async open(t, i) {
    await this.whenApp(), await this.updateComplete, t && (this.currentId = t), i && this.toggleSidebarTab(i, !0), this.showOverlay = !0;
  }
  close() {
    this.showOverlay = !1;
  }
  toggleSidebarTab(t, i) {
    t === "comments" ? (this.versionsOpen = !1, this.commentsOpen = i !== void 0 ? i : !this.commentsOpen) : t === "versions" ? (this.commentsOpen = !1, this.versionsOpen = i !== void 0 ? i : !this.versionsOpen) : (this.commentsOpen = !1, this.versionsOpen = !1);
  }
  handleVersionFile(t) {
    this.versionFile = t.detail.versionFile;
  }
  scrollToPrev() {
    var t;
    this.prevRef.value && (this.unblockSwipeScroll(), this.prevRef.value.scrollIntoView({ behavior: (t = this.weavy) == null ? void 0 : t.scrollBehavior }));
  }
  scrollToNext() {
    var t;
    this.nextRef.value && (this.unblockSwipeScroll(), this.nextRef.value.scrollIntoView({ behavior: (t = this.weavy) == null ? void 0 : t.scrollBehavior }));
  }
  blockSwipeScroll(t = 20) {
    window.clearTimeout(this.disableSwipeScrollTimeout), this.disableSwipeScroll = !0, this.disableSwipeScrollTimeout = window.setTimeout(() => this.disableSwipeScroll = !1, t);
  }
  unblockSwipeScroll() {
    window.clearTimeout(this.disableSwipeScrollTimeout), this.disableSwipeScroll = !1;
  }
  setPrev() {
    this.previousFile && (this.currentId = this.previousFile.id, this.blockSwipeScroll());
  }
  setNext() {
    this.nextFile && (this.currentId = this.nextFile.id, this.blockSwipeScroll());
  }
  currentPreviewFileCallback(t) {
    t == null || t.scrollIntoView(), requestAnimationFrame(() => t == null ? void 0 : t.scrollIntoView());
  }
  async willUpdate(t) {
    if (await super.willUpdate(t), (t.has("app") || t.has("user")) && this.app && this.user && !this.isAttachment && (this.persistState.observe(["commentsOpen", "versionsOpen"], `a${this.app.id}-preview`, `u${this.user.id}`), this.commentsOpen && this.versionsOpen && (this.versionsOpen = !1)), t.has("queryResult") && this.queryResult) {
      const { data: i } = this.queryResult ?? {};
      this.files = i == null ? void 0 : i.filter((n) => n && !n.is_trashed);
    }
    if (t.has("infiniteQueryResult") && this.infiniteQueryResult) {
      const { data: i } = this.infiniteQueryResult ?? {};
      this.files = zs(i).filter((n) => n && !n.is_trashed);
    }
    t.has("currentFile") && this.currentFile && this.currentFile.id !== this.currentId && (this.currentId = this.currentFile.id), (t.has("files") || t.has("currentId") || t.has("showOverlay")) && this.files && this.showOverlay && (this.currentFile = void 0, this.previousFile = void 0, this.nextFile = void 0, this.versionFile = void 0, this.currentFile = this.files.find((i, n) => this.files && i.id === this.currentId ? (n >= 1 && (this.previousFile = this.files[n - 1]), n < this.files.length - 1 && (this.nextFile = this.files[n + 1]), this.infiniteQueryResult && n >= this.files.length - 2 && this.infiniteQueryResult.hasNextPage && !this.infiniteQueryResult.isFetchingNextPage && this.infiniteQueryResult.fetchNextPage(), this.infiniteQueryResult && n <= 1 && this.infiniteQueryResult.hasPreviousPage && !this.infiniteQueryResult.isFetchingPreviousPage && this.infiniteQueryResult.fetchPreviousPage(), !0) : !1)), t.has("currentFile") && this.currentFile && !this.files && (this.files = [this.currentFile]), t.has("showOverlay") && (this.showOverlay ? await this.dispatchOpen() : t.get("showOverlay") && await this.dispatchClose());
  }
  renderHeader(t) {
    var i, n, r, a;
    const o = {
      "wy-appbar-text-trashed": !!(t != null && t.is_trashed)
    };
    return O` <header class="wy-appbars">
      <nav class="wy-appbar">
        <wy-button kind="icon" @click=${() => this.close()}><wy-icon name="close"></wy-icon></wy-button>
        <div class="wy-appbar-text ${ot(o)}">
          ${t ? O` <span>${t.name}</span> ` : M}
        </div>
        <div class="wy-appbar-buttons wy-appbar-buttons-last">
          ${t ? O`
                ${t.id >= 1 && !this.isAttachment && (i = this.hasFeatures) != null && i.comments ? O`
                      <wy-button
                        kind="icon"
                        ?active=${this.commentsOpen}
                        @click=${() => this.toggleSidebarTab("comments")}
                        title=${T("Comments")}
                      >
                        <wy-icon-stack>
                          ${(n = t.comments) != null && n.count && ((r = t.comments) == null ? void 0 : r.count) > 0 ? O`<wy-icon name="comment" state ?active=${!this.commentsOpen}></wy-icon>
                                <wy-icon name="comment" layer state ?active=${this.commentsOpen}></wy-icon>` : O`<wy-icon name="comment-outline" state ?active=${!this.commentsOpen}></wy-icon>
                                <wy-icon name="comment" layer state ?active=${this.commentsOpen}></wy-icon>`}
                        </wy-icon-stack>
                      </wy-button>
                    ` : M}
                <wy-file-menu .file=${t}>
                  ${t.id >= 1 && !this.isAttachment && (a = this.hasFeatures) != null && a.versions ? O`
                        <wy-dropdown-item
                          ?active=${this.versionsOpen}
                          @click=${() => this.toggleSidebarTab("versions")}
                        >
                          <wy-icon name="backup-restore"></wy-icon>
                          ${T("Versions")}
                        </wy-dropdown-item>
                      ` : M}
                </wy-file-menu>
              ` : M}
        </div>
      </nav>
    </header>`;
  }
  render() {
    let t = this.files === void 0;
    this.queryResult ? t = this.queryResult.isPending : this.infiniteQueryResult && (t = this.infiniteQueryResult.isPending);
    const i = this.versionFile || this.currentFile, n = [this.previousFile, i, this.nextFile].filter((a) => a);
    this.commentsOpen && this.versionsOpen && (this.versionsOpen = !1);
    const r = {
      "wy-preview-swiper-disabled": this.disableSwipeScroll
    };
    return this.weavy ? O`
      <wy-overlay
        class="wy-dark"
        maximized
        ?filled=${this.filled}
        .show=${this.showOverlay}
        @keyup=${this.handleKeys}
        @close=${() => {
      this.showOverlay = !1;
    }}
        @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
      >
        ${this.showOverlay ? O`<div class="wy-preview-layout">
              ${this.renderHeader(this.currentFile)}

              <div class="wy-main">
                ${this.isAttachment ? M : O` <aside
                        id="tab-comments"
                        class="wy-sidebar ${ot({
      "wy-active": this.commentsOpen,
      "wy-maximized": this.sidePanelMaximized
    })}"
                        ?hidden=${!this.commentsOpen}
                      >
                        <nav class="wy-item">
                          <div class="wy-item-body">
                            <div class="wy-item-title">${T("Comments")}</div>
                          </div>
                          <wy-button kind="icon" @click=${() => this.toggleSidebarTab("comments", !1)}>
                            <wy-icon name="close"></wy-icon>
                          </wy-button>
                          <button
                            @click=${() => this.sidePanelMaximized = !this.sidePanelMaximized}
                            class="wy-sidebar-handle"
                            title=${this.sidePanelMaximized ? T("Restore side panel") : T("Maximize side panel")}
                          ></button>
                        </nav>
                        <div class="wy-pane wy-scroll-y">
                          ${this.commentsOpen && this.currentFile && this.currentFile.id >= 1 && this.app && this.user ? O`
                                <wy-comment-list
                                  .parentId=${this.currentFile.id}
                                  .location=${"files"}
                                ></wy-comment-list>
                              ` : M}
                        </div>
                      </aside>
                      <aside
                        id="tab-versions"
                        class="wy-sidebar ${ot({
      "wy-active": this.versionsOpen,
      "wy-maximized": this.sidePanelMaximized
    })}"
                        ?hidden=${!this.versionsOpen}
                      >
                        <nav class="wy-item">
                          <div class="wy-item-body">
                            <div class="wy-item-title">${T("Versions")}</div>
                          </div>
                          <wy-button kind="icon" @click=${() => this.toggleSidebarTab("versions", !1)}>
                            <wy-icon name="close"></wy-icon>
                          </wy-button>
                          <button
                            @click=${() => this.sidePanelMaximized = !this.sidePanelMaximized}
                            class="wy-sidebar-handle"
                            title=${this.sidePanelMaximized ? T("Restore side panel") : T("Maximize side panel")}
                          ></button>
                        </nav>
                        <div class="wy-pane wy-scroll-y">
                          <div class="wy-pane-body">
                            ${this.versionsOpen && this.currentFile && this.app ? O`
                                  <wy-file-versions
                                    .file=${this.currentFile}
                                    .activeVersion=${this.versionFile || this.currentFile}
                                    @file-version-select=${(a) => this.handleVersionFile(a)}
                                  ></wy-file-versions>
                                ` : M}
                          </div>
                        </div>
                      </aside>`}

                <div class="wy-preview">
                  <div ${pe(this.swipeScrollRef)} class="wy-preview-swiper ${ot(r)}">
                    ${zi(
      n,
      (a) => "preview-area-" + (a == null ? void 0 : a.id),
      (a) => {
        const o = a === i ? this.currentPreviewFileCallback : a === this.nextFile ? this.nextRef : a === this.previousFile ? this.prevRef : void 0;
        return a ? O`
                              <div
                                id="preview-${a.id}"
                                ${pe(o)}
                                class="wy-preview-area wy-scroll-y wy-scroll-x"
                              >
                                ${t ? O` <wy-spinner overlay></wy-spinner> ` : O` <wy-preview-item .file=${a}></wy-preview-item> `}
                              </div>
                            ` : M;
      }
    )}
                  </div>
                  ${this.currentFile ? O`
                        ${this.previousFile ? O`
                              <nav class="wy-nav-prev">
                                <wy-button kind="icon" @click=${() => this.scrollToPrev()}>
                                  <wy-icon name="previous"></wy-icon>
                                </wy-button>
                              </nav>
                            ` : M}
                        ${this.nextFile ? O`
                              <nav class="wy-nav-next">
                                <wy-button kind="icon" @click=${() => this.scrollToNext()}>
                                  <wy-icon name="next"></wy-icon>
                                </wy-button>
                              </nav>
                            ` : M}
                      ` : M}
                </div>
              </div>
            </div> ` : M}
      </wy-overlay>
    ` : M;
  }
  updated() {
    requestAnimationFrame(
      () => requestAnimationFrame(() => {
        var t, i;
        this.swipeScrollRef.value ? ((t = this.swipeScroller).whenPrev ?? (t.whenPrev = async () => this.setPrev()), (i = this.swipeScroller).whenNext ?? (i.whenNext = async () => this.setNext()), this.swipeScroller.createObserver(this.swipeScrollRef.value), this.swipeScroller.observe(this.prevRef.value, this.nextRef.value)) : this.swipeScroller.clearObserver();
      })
    );
  }
}, u(gp, "ca"), gp), p(Wb, "WyPreview"), Wb);
Ot.styles = [fe];
Ht([
  x({ attribute: !1 })
], Ot.prototype, "files", 2);
Ht([
  x({ attribute: !1 })
], Ot.prototype, "queryResult", 2);
Ht([
  x({ attribute: !1 })
], Ot.prototype, "infiniteQueryResult", 2);
Ht([
  x({ type: Object })
], Ot.prototype, "user", 2);
Ht([
  x({ type: Number })
], Ot.prototype, "currentId", 2);
Ht([
  x({ type: Boolean })
], Ot.prototype, "isAttachment", 2);
Ht([
  x({ type: Boolean })
], Ot.prototype, "filled", 2);
Ht([
  B()
], Ot.prototype, "currentFile", 2);
Ht([
  B()
], Ot.prototype, "previousFile", 2);
Ht([
  B()
], Ot.prototype, "nextFile", 2);
Ht([
  B()
], Ot.prototype, "showOverlay", 2);
Ht([
  B()
], Ot.prototype, "commentsOpen", 2);
Ht([
  B()
], Ot.prototype, "versionsOpen", 2);
Ht([
  B()
], Ot.prototype, "versionFile", 2);
Ht([
  B()
], Ot.prototype, "sidePanelMaximized", 2);
Ht([
  B()
], Ot.prototype, "disableSwipeScroll", 2);
Ot = Ht([
  F("wy-preview"),
  be()
], Ot);
var Ij = Object.defineProperty, Wj = Object.getOwnPropertyDescriptor, Wt = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Wj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Ij(t, i, r), r;
}, "__decorateClass$w"), Vb, vp;
let dt = (Vb = (vp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.me = !1, this.isBot = !1, this.isPrivateChat = !1, this.displayName = "", this.avatar = "", this.createdAt = "", this.html = "", this.text = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.seenBy = [], this.highlight = !1, this.previewRef = ke(), this.highlightRef = ke();
  }
  dispatchVote(t) {
    const i = new CustomEvent("vote", { detail: { id: t, parentId: this.messageId } });
    return this.dispatchEvent(i);
  }
  willUpdate(t) {
    t.has("link") && (this.highlight = !!(this.link && nw(this.link, Bi.Message, { id: this.messageId })));
  }
  render() {
    var t, i, n, r, a, o, l;
    const c = ((t = this.attachments) == null ? void 0 : t.filter((y) => y.kind === "image" && y.thumbnail_url)) || [], h = ((i = this.attachments) == null ? void 0 : i.filter((y) => y.kind !== "image" || !y.thumbnail_url)) || [], d = this.createdAt ? new Intl.DateTimeFormat((n = this.weavy) == null ? void 0 : n.locale, { dateStyle: "full", timeStyle: "short" }).format(
      new Date(this.createdAt)
    ) : "", f = this.createdAt ? new Intl.DateTimeFormat((r = this.weavy) == null ? void 0 : r.locale, { timeStyle: "short" }).format(new Date(this.createdAt)) : "";
    return O`
      <div
        class=${ot({ "wy-message": !0, "wy-message-me": this.me, "wy-message-bot": this.isBot })}
        part=${At({ "wy-highlight": this.highlight })}
        ${pe(this.highlightRef)}
      >
        ${this.me ? "" : O`
              <div class="wy-message-author">
                <wy-avatar
                  .src="${this.avatar}"
                  .size=${32}
                  .name="${this.displayName}"
                  .isBot=${this.isBot}
                ></wy-avatar>
              </div>
            `}

        <div class="wy-message-content">
          <div class="wy-message-meta">
            ${!this.isPrivateChat && !this.me ? O` <span>${this.displayName} · </span> ` : ""}
            <time datetime=${this.createdAt} title=${d}>${f}</time>
          </div>

          <div class="wy-message-bubble">
            ${this.messageId < 0 ? O`<wy-skeleton .text=${this.text}></wy-skeleton>` : O`
                  <!-- image grid -->
                  ${c.length ? O`<wy-image-grid
                        .images=${c}
                        @file-open=${(y) => {
      var w;
      (w = this.previewRef.value) == null || w.open(y.detail.fileId);
    }}
                      ></wy-image-grid>` : ""}

                  <!-- embeds -->
                  ${this.embed && (a = this.hasFeatures) != null && a.embeds ? O` <wy-embed class="wy-embed" .embed=${this.embed}></wy-embed> ` : M}

                  <!-- text -->
                  ${this.html ? O`<div class="wy-content">${So(this.html)}</div>` : ""}

                  <!-- poll -->
                  ${this.pollOptions && this.pollOptions.length > 0 ? O`
                        <wy-poll
                          .pollOptions=${this.pollOptions}
                          @vote=${(y) => this.dispatchVote(y.detail.id)}
                        ></wy-poll>
                      ` : M}

                  <!-- meeting -->
                  ${this.meeting ? O`<wy-meeting-card .meeting=${this.meeting}></wy-meeting-card>` : ""}

                  <!-- files -->
                  ${h.length ? O`<wy-attachments-list
                        .files=${h}
                        @file-open=${(y) => {
      var w;
      (w = this.previewRef.value) == null || w.open(y.detail.fileId);
    }}
                      ></wy-attachments-list>` : ""}

                  <!-- reactions -->
                  ${(o = this.hasFeatures) != null && o.reactions && this.conversation ? O`
                        ${S$(
      `reactions-${this.conversation.id}-${this.messageId}`,
      O`
                            <wy-reactions
                              lineBelow
                              ?lineReverse=${!this.me}
                              small
                              directionX=${this.me ? "right" : "left"}
                              .reactions=${this.reactions}
                              parentId=${this.conversation.id}
                              parentType="apps"
                              entityId=${this.messageId}
                              entityType="messages"
                            ></wy-reactions>
                          `
    )}
                      ` : M}
                `}
          </div>
        </div>
      </div>
      ${(l = this.hasFeatures) != null && l.receipts ? O`<div class="wy-readby-status">
            ${this.seenBy && this.seenBy.length ? O`
                  ${this.seenBy.map((y) => {
      var w;
      const g = y.marked_at ? new Intl.DateTimeFormat((w = this.weavy) == null ? void 0 : w.locale, {
        dateStyle: "full",
        timeStyle: "short"
      }).format(new Date(y.marked_at)) : "";
      return O`<wy-avatar
                      title=${T(ie`Seen by ${y.display_name} at ${g}`)}
                      .name=${y.display_name}
                      .src=${y.avatar_url}
                      size=${18}
                    ></wy-avatar>`;
    })}
                ` : M}
          </div>` : M}
      ${this.attachments ? S$(
      `preview-message-${this.messageId}`,
      O`
              <wy-preview
                ${pe(this.previewRef)}
                .files=${[...c, ...h]}
                .isAttachment=${!0}
              ></wy-preview>
            `
    ) : M}
    `;
  }
  updated(t) {
    var i;
    t.has("highlight") && this.highlight && ((i = this.highlightRef.value) == null || i.scrollIntoView({ block: "nearest" }));
  }
}, u(vp, "la"), vp), p(Vb, "WyMessage"), Vb);
dt.styles = fe;
Wt([
  x({ attribute: !1 })
], dt.prototype, "conversation", 2);
Wt([
  x({ type: Number })
], dt.prototype, "messageId", 2);
Wt([
  x({ type: Boolean })
], dt.prototype, "me", 2);
Wt([
  x({ type: Boolean })
], dt.prototype, "isBot", 2);
Wt([
  x({ type: Boolean })
], dt.prototype, "isPrivateChat", 2);
Wt([
  x()
], dt.prototype, "displayName", 2);
Wt([
  x()
], dt.prototype, "avatar", 2);
Wt([
  x()
], dt.prototype, "createdAt", 2);
Wt([
  x()
], dt.prototype, "html", 2);
Wt([
  x()
], dt.prototype, "text", 2);
Wt([
  x({ type: Array })
], dt.prototype, "attachments", 2);
Wt([
  x({ attribute: !1 })
], dt.prototype, "meeting", 2);
Wt([
  x({ type: Array })
], dt.prototype, "pollOptions", 2);
Wt([
  x({ attribute: !1 })
], dt.prototype, "embed", 2);
Wt([
  x({ type: Array })
], dt.prototype, "reactions", 2);
Wt([
  x({ type: Array })
], dt.prototype, "seenBy", 2);
Wt([
  x({ type: Boolean })
], dt.prototype, "highlight", 2);
dt = Wt([
  F("wy-message"),
  be()
], dt);
var Vj = Object.defineProperty, Zj = Object.getOwnPropertyDescriptor, Gr = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Zj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Vj(t, i, r), r;
}, "__decorateClass$v"), Zb, Op;
let yn = (Zb = (Op = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.dataUpdatedAt = NaN, this.unreadMarkerShow = !0;
  }
  dispatchVote(t, i) {
    const n = new CustomEvent("vote", { detail: { id: t, parentId: i, parentType: "messages" } });
    return this.dispatchEvent(n);
  }
  render() {
    const t = zs(this.infiniteMessages);
    let i;
    return O`
      <div class="wy-messages">
        <slot name="start"></slot>
        <!-- this.user ?? -->
        ${t && this.conversation && this.user ? zi(
      t,
      (n) => n.id,
      (n, r) => {
        var a, o, l, c, h, d, f;
        const y = new Date(n.created_at);
        let w = O``;
        if ((i == null ? void 0 : i.toDateString()) !== y.toDateString()) {
          const b = new Intl.DateTimeFormat((a = this.weavy) == null ? void 0 : a.locale, {
            dateStyle: "short"
          }).format(y);
          i = y, w = O`<div class="wy-date-separator"><time>${b}</time></div>`;
        }
        let g = O``;
        return this.unreadMarkerId && this.unreadMarkerId === n.id && (g = O`<div
                    id="unread-marker"
                    class="wy-toast wy-toast-action wy-fade ${this.unreadMarkerShow ? "wy-show" : ""}"
                    tabindex=${this.unreadMarkerShow ? 0 : -1}
                    @click=${() => {
          var b;
          let k = `#message-${this.unreadMarkerId}`;
          this.unreadMarkerPosition === "below" && (k += "~ wy-message"), (b = this.renderRoot.querySelector(k)) == null || b.scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth"
          });
        }}
                    @keydown=${ei}
                    @keyup=${_i}
                  >
                    ${T("New messages")}
                  </div>`), O`${[
          O`${w}`,
          O`${this.unreadMarkerPosition === "above" ? g : M}`,
          S$(
            `message-${n.id}`,
            O`<wy-message
                      id="message-${n.id}"
                      .conversation=${this.conversation}
                      .messageId=${n.id}
                      .me=${n.created_by.id === ((o = this.user) == null ? void 0 : o.id)}
                      .isBot=${n.created_by.is_bot || !1}
                      .isPrivateChat=${((l = this.conversation) == null ? void 0 : l.type) === Te.PrivateChat || ((c = this.conversation) == null ? void 0 : c.type) === Te.BotChat}
                      .displayName=${n.created_by.display_name}
                      .avatar=${n.created_by.avatar_url}
                      .createdAt=${n.created_at}
                      .text=${n.plain}
                      .html=${n.html}
                      .attachments=${(h = n.attachments) == null ? void 0 : h.data}
                      .meeting=${n.meeting}
                      .pollOptions=${(d = n.options) == null ? void 0 : d.data}
                      .embed=${n.embed}
                      .reactions=${(f = n.reactions) == null ? void 0 : f.data}
                      .seenBy=${this.members && this.members.data && this.members.data.length > 0 ? this.members.data.filter((b) => {
              var k;
              return b.marked_id === n.id && b.id !== ((k = this.user) == null ? void 0 : k.id);
            }) : []}
                      @vote=${(b) => {
              this.dispatchVote(b.detail.id, b.detail.parentId);
            }}
                    ></wy-message>`
          ),
          O`${this.unreadMarkerPosition === "below" ? g : M}`
        ]}`;
      }
    ) : M}
        <slot name="end"></slot>
      </div>
    `;
  }
}, u(Op, "da"), Op), p(Zb, "WyMessages"), Zb);
yn.styles = [
  fe,
  de`
      :host(wy-messages) {
        display: contents;
      }
      wy-message {
        scroll-margin-block: 6rem;
      }
    `
];
Gr([
  x({ attribute: !1 })
], yn.prototype, "conversation", 2);
Gr([
  x({ attribute: !1 })
], yn.prototype, "infiniteMessages", 2);
Gr([
  x({ type: Number })
], yn.prototype, "dataUpdatedAt", 2);
Gr([
  x({ attribute: !1 })
], yn.prototype, "members", 2);
Gr([
  x({ attribute: !1 })
], yn.prototype, "unreadMarkerId", 2);
Gr([
  x({ attribute: !1 })
], yn.prototype, "unreadMarkerPosition", 2);
Gr([
  x({ attribute: !1 })
], yn.prototype, "unreadMarkerShow", 2);
yn = Gr([
  F("wy-messages"),
  be()
], yn);
var Dj = Object.defineProperty, qj = Object.getOwnPropertyDescriptor, Uj = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? qj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Dj(t, i, r), r;
}, "__decorateClass$u"), Db, bp;
let Z$ = (Db = (bp = class extends Ze {
  constructor() {
    super(), this.editorType = "messages", this.editorClass = "wy-message-editor";
  }
  renderTopSlot() {
    return this.renderLists();
  }
  renderMiddleSlot() {
    var t, i, n, r, a, o, l, c, h, d, f, y;
    return O` <div class="wy-message-editor-inputs">
      <!-- Add -->
      ${(t = this.hasFeatures) != null && t.attachments || (i = this.hasFeatures) != null && i.cloudFiles || (n = this.hasFeatures) != null && n.polls || (r = this.hasFeatures) != null && r.zoomMeetings || (a = this.hasFeatures) != null && a.googleMeet || (o = this.hasFeatures) != null && o.microsoftTeams ? O`<wy-dropdown icon="plus" directionY="up" ?disabled=${this.disabled}>
            ${(l = this.hasFeatures) != null && l.attachments ? O`
                  <wy-dropdown-item @click=${this.openFileInput} title=${T("From device")}>
                    <wy-icon name="attachment"></wy-icon>
                    <span>${T("From device")}</span>
                  </wy-dropdown-item>
                  <input
                    type="file"
                    ${pe(this.fileInputRef)}
                    @click=${(w) => w.stopPropagation()}
                    @change=${(w) => this.handleUploadFiles(
      Array.from(w.target.files || []),
      w.target
    )}
                    multiple
                    hidden
                    tabindex="-1"
                  />
                ` : M}
            ${(c = this.hasFeatures) != null && c.cloudFiles ? O`
                  <wy-dropdown-item @click=${this.openCloudFiles} title=${T("From cloud")}>
                    <wy-icon name="cloud"></wy-icon>
                    <span>${T("From cloud")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(h = this.hasFeatures) != null && h.polls ? O`
                  <wy-dropdown-item @click=${this.openPolls} title=${T("Poll")}>
                    <wy-icon name="poll"></wy-icon>
                    <span>${T("Poll")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(d = this.hasFeatures) != null && d.zoomMeetings ? O`
                  <wy-dropdown-item @click=${() => this.handleMeetingClick("zoom")} title=${T("Zoom meeting")}>
                    <wy-icon svg="zoom-meetings"></wy-icon>
                    <span>${T("Zoom meeting")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(f = this.hasFeatures) != null && f.googleMeet ? O`
                  <wy-dropdown-item @click=${() => this.handleMeetingClick("google")} title=${T("Google Meet")}>
                    <wy-icon svg="google-meet"></wy-icon>
                    <span>${T("Google Meet")}</span>
                  </wy-dropdown-item>
                ` : M}
            ${(y = this.hasFeatures) != null && y.microsoftTeams ? O`
                  <wy-dropdown-item
                    @click=${() => this.handleMeetingClick("microsoft")}
                    title=${T("Microsoft Teams")}
                  >
                    <wy-icon svg="microsoft-teams"></wy-icon>
                    <span>${T("Microsoft Teams")}</span>
                  </wy-dropdown-item>
                ` : M}
          </wy-dropdown>` : M}

      <!-- Input -->
      <div class="wy-message-editor-text" ${pe(this.editorRef)}> ${this.renderEditorDummy()} </div>

      <!-- Button -->
      <wy-button
        kind="icon"
        color="primary-text"
        title=${T("Send", { desc: "Button action to send" })}
        @click="${this.submit}"
        ?disabled=${this.disabled}
      >
        <wy-icon name="send"></wy-icon>
      </wy-button>
    </div>`;
  }
  renderBottomSlot() {
    return M;
  }
}, u(bp, "ha"), bp), p(Db, "WyMessageEditor"), Db);
Z$ = Uj([
  F("wy-message-editor"),
  be()
], Z$);
var $p;
const Fz = ($p = class {
  constructor(t) {
    this.typingTimeout = null, this.discardTime = 5 * 1e3, this.typingMembers = [], this.names = [], this.ellipsis = "", this.handleRealtimeTyping = (i) => {
      i.entity.id === this.appId && i.actor.id !== this.userId && (this.setTypers(i.actor), this.updateTyping());
    }, this.handleRealtimeStopTyping = (i) => {
      this.typingMembers.forEach((n, r) => {
        n.id === i.actor.id && this.typingMembers.splice(r, 1);
      }), this.updateTyping();
    }, t.addController(this), this.host = t, this.setContext();
  }
  get weavy() {
    var t;
    return (t = this.context) == null ? void 0 : t.value;
  }
  get appId() {
    return this._appId;
  }
  set appId(t) {
    t !== this._appId && (this.typingMembers = [], this.unregisterRealtime(), this._appId = t, this.registerRealtime());
  }
  get userId() {
    return this._userId;
  }
  set userId(t) {
    t !== this._userId && (this.typingMembers = [], this.unregisterRealtime(), this._userId = t, this.registerRealtime());
  }
  async setContext() {
    this.whenContext = new Promise((t) => this.resolveContext = t), await _o(this.host), this.context = new Er(this.host, { context: Pt, subscribe: !0 });
  }
  hostUpdate() {
    var t, i, n;
    (t = this.context) != null && t.value && ((n = this.resolveContext) == null || n.call(this, (i = this.context) == null ? void 0 : i.value));
  }
  async registerRealtime() {
    var t, i;
    this.appId && this._userId && (await this.whenContext, (t = this.weavy) == null || t.subscribe(`a${this.appId}`, "typing", this.handleRealtimeTyping), (i = this.weavy) == null || i.subscribe(`a${this.appId}`, "message_created", this.handleRealtimeStopTyping));
  }
  async unregisterRealtime() {
    var t, i;
    this.appId && this.userId && (await this.whenContext, (t = this.weavy) == null || t.unsubscribe(`a${this.appId}`, "typing", this.handleRealtimeTyping), (i = this.weavy) == null || i.unsubscribe(`a${this.appId}`, "message_created", this.handleRealtimeStopTyping));
  }
  /**
   * @fires typing
   */
  updateTyping() {
    this.typingTimeout && (clearTimeout(this.typingTimeout), this.typingTimeout = null);
    const t = Date.now();
    if (this.typingMembers.forEach((i, n) => {
      t - i.time > this.discardTime && this.typingMembers.splice(n, 1);
    }), this.typingMembers.length) {
      const i = Date.now(), n = Math.round(
        (i - Math.max.apply(
          null,
          this.typingMembers.map((r) => r.time)
        )) / 1e3
      ) % 3 + 1;
      this.ellipsis = ".".repeat(n), this.names = this.typingMembers.map((r) => r.display_name).sort(), this.typingTimeout = window.setTimeout(() => this.updateTyping(), 1e3);
    } else
      this.names = [];
    this.host.requestUpdate(), this.host.dispatchEvent(new CustomEvent("typing", { bubbles: !0, composed: !1, detail: { count: this.typingMembers.length } }));
  }
  setTypers(t) {
    this.typingMembers.forEach((n, r) => {
      n.id === t.id && this.typingMembers.splice(r, 1);
    });
    const i = { ...t, time: Date.now() };
    this.typingMembers.push(i);
  }
}, u($p, "Bp"), $p);
p(Fz, "TypingController");
let Hz = Fz;
const Nj = de`@keyframes wy-highlight{0%{--wy-component-background-color: var(--wy-highlight, var(--wy-primary-95, #e8f2ff));--wy-component-color: var(--wy-on-highlight, var(--wy-primary-10, #001d32))}}.wy-messages{padding:var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));flex:1 1 100%}.wy-message-placeholder{opacity:.5}.wy-date-separator{font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));pointer-events:none;margin:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));text-align:center;position:sticky;top:var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));z-index:10}.wy-date-separator time{background:var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));color:var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));padding:var(--wy-padding-sm, calc(.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))));display:inline-block}.wy-message{display:flex;flex-direction:row;align-items:flex-start;margin-bottom:calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + .5 * var(--wy-button-size, calc(var(--wy-button-line-height, 1.5) * var(--wy-size, 1rem) + 2 * var(--wy-button-padding-y, var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))));scroll-margin-block:6rem;--wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));--wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}.wy-message[part~=wy-highlight]{animation:wy-highlight 3s 1.5s ease-in-out both}.wy-message .wy-image-grid,.wy-message .wy-attachments{border-radius:var(--wy-border-radius-sm, calc(var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem))) - .25 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))}.wy-message-meta{font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)));margin:0 0 calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))));color:var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e))}.wy-message-bubble{background-color:var(--wy-component-background-color);color:var(--wy-component-color);border-radius:var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));display:flex;flex-direction:column;padding:var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))));gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));max-width:min(32 * var(--wy-size, 1rem),100% - 2 * var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))))))}.wy-message-bubble>div{flex:1 1 100%}.wy-message-author{margin:calc(1.375 * var(--wy-size, 1rem)) calc(.5 * var(--wy-size, 1rem)) 0 0}.wy-message-content{display:flex;flex-direction:column;width:100%;align-items:flex-start;flex-wrap:wrap;min-width:0;position:relative}.wy-message-content-row{display:flex;flex-direction:row;align-items:center;max-width:100%}.wy-message-bot{--wy-component-background-color: var(--wy-tertiary-container, var(--wy-tertiary-90, #bbf294));--wy-component-color: var(--wy-on-tertiary-container, var(--wy-tertiary-10, #0a2100))}.wy-message-me{margin-right:0;margin-left:calc(2.5 * var(--wy-size, 1rem));align-items:flex-end;--wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));--wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32))}.wy-message-me .wy-message-meta{margin:0 calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))) 0}.wy-message-me .wy-message-content{align-items:flex-end}.wy-message-me .wy-message-content-row{flex-direction:row-reverse}.wy-message-emoji .wy-message-bubble{background:none;padding:0 0 var(--wy-message-padding, var(--wy-padding-lg, calc(1.5 * var(--wy-padding, calc(.5 * var(--wy-size, 1rem))))))}.wy-message-emoji .wy-content .wy-emoji{width:calc(3 * var(--wy-size, 1rem));height:calc(3 * var(--wy-size, 1rem));margin:0}.wy-message-emoji.wy-message-me .wy-content{text-align:end}.wy-readby-status{display:flex;gap:var(--wy-gap-sm, calc(.5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem)))));height:calc(1.125 * var(--wy-size, 1rem));justify-content:flex-end;margin-top:calc(-.125 * var(--wy-size, 1rem))}.wy-message-readmore{justify-self:center;text-align:center}`, Bj = de`@keyframes wy-bouncing{to{transform:translate3d(0,calc(-.25 * var(--wy-size, 1rem)),0)}}@keyframes wy-bouncing-fade{to{opacity:.2}}[part~=wy-bouncer]{width:calc(1.5 * var(--wy-size, 1rem));height:calc(.75 * var(--wy-size, 1rem))}[part~=wy-bouncer-dot]{position:relative;animation:wy-bouncing .6s infinite alternate,wy-bouncing-fade .6s infinite alternate;fill:currentColor}[part~=wy-bouncer-dot-start]{animation-delay:0s,.6s}[part~=wy-bouncer-dot-middle]{animation-delay:.3s,.3s}[part~=wy-bouncer-dot-end]{animation-delay:.6s,0s}`;
var jj = Object.defineProperty, Xj = Object.getOwnPropertyDescriptor, Kn = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Xj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && jj(t, i, r), r;
}, "__decorateClass$t"), qb, xp;
let Li = (qb = (xp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.typing = new Hz(this), this.isBot = !1, this.isPrivateChat = !1, this.typingMembers = [], this.names = [];
  }
  willUpdate(t) {
    t.has("conversationId") && (this.typing.appId = this.conversationId), t.has("userId") && (this.typing.userId = this.userId);
    const { typingMembers: i, names: n } = this.typing;
    this.typingMembers = i, this.names = n, i.length ? this.typingTime || (this.typingTime = /* @__PURE__ */ new Date()) : this.typingTime = void 0;
  }
  render() {
    var t, i, n, r, a;
    const o = this.typingMembers.map(
      (f) => {
        var y;
        return (y = this.members) == null ? void 0 : y.find((w) => w.id === f.id);
      }
    ), l = new Intl.ListFormat((t = this.weavy) == null ? void 0 : t.locale, { style: "long", type: "conjunction" }).format(
      this.names
    ), c = this.typingTime ? new Intl.DateTimeFormat((i = this.weavy) == null ? void 0 : i.locale, { dateStyle: "full", timeStyle: "short" }).format(this.typingTime) : "", h = this.typingTime ? new Intl.DateTimeFormat((n = this.weavy) == null ? void 0 : n.locale, { timeStyle: "short" }).format(this.typingTime) : "", d = O`
      <svg part="wy-bouncer" viewBox="0 0 32 16" xmlns="http://www.w3.org/2000/svg">
        <circle part="wy-bouncer-dot wy-bouncer-dot-start" cx="4" cy="10" r="4" />
        <circle part="wy-bouncer-dot wy-bouncer-dot-middle" cx="16" cy="10" r="4" />
        <circle part="wy-bouncer-dot wy-bouncer-dot-end" cx="28" cy="10" r="4" />
      </svg>
    `;
    return o.length ? O`
          <div class=${ot({ "wy-message": !0, "wy-message-bot": this.isBot })}>
            <div class="wy-message-author">
              ${o.length > 1 ? O`
                    <wy-avatar-group
                      .size=${32}
                      .members=${o}
                      title=${l}
                    ></wy-avatar-group>
                  ` : O`
                    <wy-avatar
                      .size=${32}
                      .src=${(r = o[0]) == null ? void 0 : r.avatar_url}
                      .name=${l}
                      .isBot=${this.isBot}
                    ></wy-avatar>
                  `}
            </div>

            <div class="wy-message-content">
              <div class="wy-message-meta">
                ${this.isPrivateChat ? O`
                      <time datetime=${Me((a = this.typingTime) == null ? void 0 : a.toISOString())} title=${c}>${h}</time>
                    ` : l}
              </div>
              <div class="wy-message-bubble"> ${d} </div>
            </div>
          </div>
        ` : M;
  }
}, u(xp, "pa"), xp), p(qb, "WyMessageTyping"), qb);
Li.styles = [Lt, Bj, Nj];
Kn([
  wt({ context: Pt, subscribe: !0 }),
  B()
], Li.prototype, "weavy", 2);
Kn([
  x({ attribute: !0, type: Number })
], Li.prototype, "conversationId", 2);
Kn([
  x({ attribute: !0, type: Number })
], Li.prototype, "userId", 2);
Kn([
  x({ type: Boolean })
], Li.prototype, "isBot", 2);
Kn([
  x({ type: Boolean })
], Li.prototype, "isPrivateChat", 2);
Kn([
  x({ attribute: !1 })
], Li.prototype, "members", 2);
Kn([
  B()
], Li.prototype, "typingMembers", 2);
Kn([
  B()
], Li.prototype, "names", 2);
Kn([
  B()
], Li.prototype, "typingTime", 2);
Li = Kn([
  F("wy-message-typing")
], Li);
var Fj = Object.defineProperty, Hj = Object.getOwnPropertyDescriptor, Yz = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$a"), jo = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Hj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Fj(t, i, r), r;
}, "__decorateClass$s"), Gz = /* @__PURE__ */ p((s, t, i) => t.has(s) || Yz("Cannot " + i), "__accessCheck$a"), W4 = /* @__PURE__ */ p((s, t, i) => (Gz(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$a"), Yj = /* @__PURE__ */ p((s, t, i) => t.has(s) ? Yz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$a"), V4 = /* @__PURE__ */ p((s, t, i, n) => (Gz(s, t, "write to private field"), t.set(s, i), i), "__privateSet$a"), Fl, Ub, kp;
let mn = (Ub = (kp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.lastReadMessagePosition = "below", this.showNewMessages = !1, this.releaseFocusEvent = () => new CustomEvent("release-focus", { bubbles: !0, composed: !0 }), this.messagesQuery = new Vo(this), this.membersQuery = new Ei(this), this.addMessageMutation = new cn(this), this.infiniteScroll = new aU(this), this.pagerRef = ke(), this.bottomRef = ke(), this.shouldBeAtBottom = !0, this.isTyping = !1, this.handleRealtimeMessage = (t) => {
      if (!this.weavy || !this.conversation || !this.conversationId || !this.user)
        return;
      const i = ["messages", t.message.app.id];
      let n = tw(this.weavy.queryClient, i, t.message.id);
      n || (t.message.created_by.id === this.user.id && (n = _r(this.weavy.queryClient, i, !0), n && Fe(this.weavy.queryClient, i, n.id, (r) => {
        r.id = t.message.id, r.app = t.message.app, r.text = t.message.text, r.html = t.message.html, r.embed = t.message.embed, r.meeting = t.message.meeting, r.attachments = t.message.attachments, r.options = t.message.options, r.created_at = t.message.created_at, r.created_by = t.message.created_by, r.updated_at = t.message.updated_at, r.updated_by = t.message.updated_by;
      })), n || zr(this.weavy.queryClient, i, t.message)), this.weavy.queryClient.setQueryData(
        ["apps", t.message.app.id],
        (r) => r && { ...r, last_message: t.message }
      ), !this.conversation.display_name && t.message.plain && this.setEmptyConversationTitle(t.message.plain), t.actor.id !== this.user.id && (this.isAtBottom ? (this.markAsRead(t.message.id), requestAnimationFrame(() => {
        this.scrollToBottom();
      })) : (this.weavy.queryClient.setQueryData(
        ["apps", t.message.app.id],
        (r) => r && { ...r, is_unread: !0 }
      ), this.lastReadMessagePosition = "above", this.lastReadMessageId = t.message.id, this.showNewMessages = !0), Fe(
        this.weavy.queryClient,
        ["members", t.message.app.id],
        t.actor.id,
        (r) => {
          r.marked_id = t.message.id, r.marked_at = t.message.created_at;
        }
      ));
    }, this.handleRealtimeReactionAdded = (t) => {
      !this.weavy || !this.user || !this.conversation || Se(
        this.weavy.queryClient,
        { queryKey: ["messages"], exact: !1 },
        t.entity.id,
        (i) => {
          i.reactions || (i.reactions = { count: 0 }), i.reactions.data = [
            ...(i.reactions.data || []).filter((n) => {
              var r;
              return ((r = n.created_by) == null ? void 0 : r.id) !== t.actor.id;
            }),
            { content: t.reaction, created_by: t.actor }
          ];
        }
      );
    }, this.handleRealtimeReactionDeleted = (t) => {
      !this.weavy || !this.conversation || !this.user || Se(
        this.weavy.queryClient,
        { queryKey: ["messages"], exact: !1 },
        t.entity.id,
        (i) => {
          i.reactions && i.reactions.data && (i.reactions.data = i.reactions.data.filter((n) => {
            var r;
            return ((r = n.created_by) == null ? void 0 : r.id) !== t.actor.id;
          }));
        }
      );
    }, this.markAsReadHandler = () => {
      !document.hidden && this.isAtBottom && this.markAsRead();
    }, Yj(this, Fl);
  }
  isPrivateChat(t) {
    var i;
    return ((i = t ?? this.conversation) == null ? void 0 : i.type) === Te.PrivateChat;
  }
  isChatRoom(t) {
    var i;
    return ((i = t ?? this.conversation) == null ? void 0 : i.type) === Te.ChatRoom;
  }
  async handleTyping(t) {
    this.isTyping = !!t.detail.count, this.isTyping && this.isAtBottom && requestAnimationFrame(() => {
      this.scrollToBottom(!0);
    });
  }
  async handleSubmit(t) {
    if (!this.conversation || !this.user)
      throw new Error("Error submitting message. Missing user or conversation.");
    const i = await this.addMessageMutation.mutate({
      app_id: this.conversation.id,
      text: t.detail.text,
      meeting_id: t.detail.meetingId,
      poll_options: t.detail.pollOptions,
      embed_id: t.detail.embed,
      blobs: t.detail.blobs,
      user: this.user
    });
    return this.showNewMessages = !1, requestAnimationFrame(() => {
      this.scrollToBottom();
    }), i;
  }
  async setEmptyConversationTitle(t) {
    var i;
    !this.conversation || this.conversation.display_name || await ((i = this.updateConversationMutation) == null ? void 0 : i.mutate({ appId: this.conversation.id, name: t }));
  }
  get isAtBottom() {
    return this.bottomRef.value ? TA(this.bottomRef.value) : !0;
  }
  async scrollToBottom(t = !1) {
    this.bottomRef.value && await xg(this.bottomRef.value), QA(this.bottomRef.value) && this.conversationId && (requestAnimationFrame(() => {
      var i;
      w$((i = this.weavy) == null ? void 0 : i.queryClient, ["messages", this.conversationId], void 0, 1);
    }), MA(this.bottomRef.value, t));
  }
  async markAsRead(t) {
    var i, n;
    await h3(), await Promise.race([xg(this), N$(this, !1)]), this.isConnected && this.conversation && this.conversation.last_message && ((n = this.markConversationMutation) == null || n.mutate({
      appId: this.conversation.id,
      messageId: t ?? this.conversation.last_message.id,
      userId: (i = this.user) == null ? void 0 : i.id
    }));
  }
  willUpdate(t) {
    var i, n, r, a, o, l, c, h, d, f;
    if (super.willUpdate(t), t.has("weavy") && this.weavy && (this.updateConversationMutation = f5(this.weavy), this.markConversationMutation = u5(this.weavy)), (t.has("weavy") || t.has("conversationId")) && this.weavy) {
      (f = W4(this, Fl)) == null || f.call(this);
      const y = t.get("conversationId");
      if (y && requestAnimationFrame(() => {
        var w;
        w$((w = this.weavy) == null ? void 0 : w.queryClient, ["messages", y], void 0, 1);
      }), this.conversationId) {
        this.membersQuery.trackQuery(y5(this.weavy, this.conversationId, {})), this.messagesQuery.trackInfiniteQuery(kA(this.weavy, this.conversationId)), this.addMessageMutation.trackMutation(
          SA(this.weavy, ["messages", this.conversationId])
        ), this.pollMutation = uv(this.weavy, ["messages", this.conversationId]), this.lastReadMessageId = void 0, this.showNewMessages = !1;
        const w = `a${this.conversationId}`;
        this.weavy.subscribe(w, "message_created", this.handleRealtimeMessage), this.weavy.subscribe(w, "reaction_added", this.handleRealtimeReactionAdded), this.weavy.subscribe(w, "reaction_removed", this.handleRealtimeReactionDeleted), V4(this, Fl, () => {
          var g, b, k;
          (g = this.weavy) == null || g.unsubscribe(w, "message_created", this.handleRealtimeMessage), (b = this.weavy) == null || b.unsubscribe(w, "reaction_added", this.handleRealtimeReactionAdded), (k = this.weavy) == null || k.unsubscribe(w, "reaction_removed", this.handleRealtimeReactionDeleted), V4(this, Fl, void 0);
        });
      } else
        this.messagesQuery.untrackInfiniteQuery(), this.addMessageMutation.untrackMutation(), this.membersQuery.untrackQuery();
    }
    if (t.has("showNewMessages") && this.showNewMessages && (this.shouldBeAtBottom = this.isAtBottom), t.has("conversationId") && t.get("conversationId") !== this.conversationId ? this.shouldBeAtBottom = !!this.conversationId : this.shouldBeAtBottom = this.isAtBottom, t.has("conversation")) {
      const y = t.get("conversation");
      if ((y == null ? void 0 : y.id) !== ((i = this.conversation) == null ? void 0 : i.id) || (y == null ? void 0 : y.is_unread) !== ((n = this.conversation) == null ? void 0 : n.is_unread))
        if ((r = this.conversation) != null && r.is_unread) {
          const w = (l = (o = (a = this.membersQuery.result.data) == null ? void 0 : a.data) == null ? void 0 : o.find(
            (g) => {
              var b;
              return g.id === ((b = this.user) == null ? void 0 : b.id);
            }
          )) == null ? void 0 : l.marked_id;
          w && w < this.conversation.last_message.id && (this.lastReadMessagePosition = "below", this.lastReadMessageId = w, this.showNewMessages = !0), ((y == null ? void 0 : y.id) !== ((c = this.conversation) == null ? void 0 : c.id) || (y == null ? void 0 : y.last_message.id) !== ((h = this.conversation) == null ? void 0 : h.last_message.id) && (this.shouldBeAtBottom || this.isAtBottom)) && this.markAsRead();
        } else (y == null ? void 0 : y.id) !== ((d = this.conversation) == null ? void 0 : d.id) && (this.showNewMessages = !1);
    }
  }
  update(t) {
    super.update(t), this.infiniteScroll.observe(this.messagesQuery.result, this.pagerRef.value);
  }
  render() {
    var t, i, n;
    const { isPending: r } = ((t = this.weavy) == null ? void 0 : t.network) ?? { isPending: !0 }, { data: a, isPending: o, hasNextPage: l } = this.messagesQuery.result ?? { isPending: r };
    return O`
      ${this.conversation && a ? O`
            ${!l && !o ? O` <!-- Top of the conversation --> ` : M}
            <wy-messages
              .conversation=${this.conversation}
              .infiniteMessages=${a}
              .unreadMarkerId=${this.lastReadMessageId}
              .unreadMarkerPosition=${this.lastReadMessagePosition}
              .unreadMarkerShow=${this.showNewMessages}
              @vote=${(c) => {
      var h;
      (h = this.pollMutation) == null || h.mutate({
        optionId: c.detail.id,
        parentType: c.detail.parentType,
        parentId: c.detail.parentId
      });
    }}
            >
              ${l ? O`<div slot="start" ${pe(this.pagerRef)} part="wy-pager wy-pager-top"></div>` : M}
              <wy-message-typing
                slot="end"
                .conversationId=${this.conversation.id}
                .userId=${(i = this.user) == null ? void 0 : i.id}
                .isPrivateChat=${this.isPrivateChat()}
                .members=${this.conversation.members.data}
                @typing=${(c) => this.handleTyping(c)}
              ></wy-message-typing>
            </wy-messages>
          ` : O`
            <div class="wy-messages">
              <wy-empty class="wy-pane">
                ${o || !this.conversation ? O`<wy-spinner overlay></wy-spinner>` : T("Start the conversation!")}
              </wy-empty>
            </div>
          `}
      ${this.conversation ? O`
            <div ${pe(this.bottomRef)}></div>
            <div class="wy-footerbar wy-footerbar-sticky">
              <wy-message-editor
                .draft=${!0}
                placeholder=${T("Type a message...")}
                ?disabled=${!ko(Ar.Create, (n = this.conversation) == null ? void 0 : n.permissions)}
                @submit=${(c) => this.handleSubmit(c)}
              ></wy-message-editor>
            </div>
          ` : M}
    `;
  }
  updated() {
    this.shouldBeAtBottom && requestAnimationFrame(() => {
      this.scrollToBottom();
    }), this.bottomObserver || (this.bottomObserver = new IntersectionObserver((t) => {
      t.forEach((i) => {
        var n;
        i.isIntersecting && !this.isTyping && (n = this.conversation) != null && n.is_unread && this.markAsRead();
      });
    })), this.bottomRef && this.bottomRef.value && this.bottomObserver.observe(this.bottomRef.value);
  }
  // hook up observer
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("visibilitychange", this.markAsReadHandler), this.conversationId && this.requestUpdate("conversationId");
  }
  disconnectedCallback() {
    var t;
    (t = W4(this, Fl)) == null || t.call(this), this.bottomObserver && this.bottomObserver.disconnect(), document.removeEventListener("visibilitychange", this.markAsReadHandler), this.conversation = void 0, this.shouldBeAtBottom = this.isAtBottom, super.disconnectedCallback();
  }
}, u(kp, "ua"), kp), p(Ub, "WyConversation"), Ub);
Fl = /* @__PURE__ */ new WeakMap();
mn.styles = [
  fe,
  Do,
  de`
      :host {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
      }

      wy-messages {
        display: contents;
      }

      wy-message {
        scroll-margin-block: 6rem;
      }
    `
];
jo([
  Xr({ context: r5 }),
  x({ attribute: !1 })
], mn.prototype, "conversation", 2);
jo([
  x({ type: Number })
], mn.prototype, "conversationId", 2);
jo([
  x()
], mn.prototype, "cssClass", 2);
jo([
  B()
], mn.prototype, "lastReadMessagePosition", 2);
jo([
  B()
], mn.prototype, "lastReadMessageId", 2);
jo([
  B()
], mn.prototype, "showNewMessages", 2);
mn = jo([
  F("wy-conversation"),
  be()
], mn);
var Dt = /* @__PURE__ */ ((s) => (s.All = "", s.Activity = "activity", s.Mention = "mention", s.Reaction = "reaction", s))(Dt || {});
function Kz(s, t = Dt.All, i, n = {}) {
  return {
    ...n,
    initialPageParam: 0,
    queryKey: ["notifications", "list", i, t],
    queryFn: /* @__PURE__ */ p(async (r) => {
      var a;
      const o = new URLSearchParams({
        skip: ((a = r.pageParam) == null ? void 0 : a.toString()) || "0",
        type: t
      }), l = `/api/${i ? `apps/${i.toString()}/` : ""}notifications?${o.toString()}`, c = await (await s.fetch(l)).json();
      return c.data = c.data || [], c;
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((r) => {
      if (r.end && r.end < r.count)
        return r.end;
    }, "getNextPageParam")
  };
}
u(Kz, "Q2");
p(Kz, "getNotificationsOptions");
function Jz(s, t = Dt.All, i) {
  var n;
  const r = (n = s.queryClient.getQueryData(["notifications", "list", i, t])) == null ? void 0 : n.pages.flatMap((o) => o.data);
  let a;
  return r == null || r.forEach((o) => {
    a = a && o && a.id > o.id ? a : o;
  }), a;
}
u(Jz, "K2");
p(Jz, "getLastNotification");
function e_(s, t) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ notificationId: i }) => {
      const n = new URL(`/api/${t ? `apps/${t.toString()}/` : ""}notifications/mark`, s.url);
      i && n.searchParams.append("id", i.toString()), await s.fetch(n, { method: "PUT" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (i) => {
      const n = [];
      return Se(
        s.queryClient,
        { queryKey: t ? ["notifications", "list", t] : ["notifications", "list"], exact: !1 },
        void 0,
        (r) => {
          n.push({ id: r.id, is_unread: r.is_unread }), r.is_unread = !1;
        }
      ), t && n.length && Se(
        s.queryClient,
        { queryKey: ["notifications", "list"], exact: !1 },
        (r) => !!n.find((a) => a.id === r.id && r.is_unread),
        (r) => {
          r.is_unread = !1;
        }
      ), t || v1(
        s.queryClient,
        { queryKey: ["notifications", "badge"], exact: !1 },
        () => 0
      ), v1(
        s.queryClient,
        {
          queryKey: t ? ["apps", "notifications", "badge", t] : ["apps", "notifications", "badge"],
          exact: !1
        },
        () => 0
      ), { changedNotifications: n };
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p(() => {
      t && s.queryClient.invalidateQueries({ queryKey: ["notifications", "badge"], exact: !1 });
    }, "onSuccess"),
    onSettled: /* @__PURE__ */ p(() => {
      s.queryClient.invalidateQueries({ queryKey: ["notifications", "list"], exact: !1 }), s.queryClient.invalidateQueries({ queryKey: ["notifications", "badge"], exact: !1 }), s.queryClient.invalidateQueries({ queryKey: ["apps", "notifications", "badge"], exact: !1 });
    }, "onSettled"),
    onError: /* @__PURE__ */ p((i, n, r) => {
      console.error(i.message);
    }, "onError")
  };
}
u(e_, "G2");
p(e_, "getMarkNotificationsMutationOptions");
function t_(s, t) {
  return new Ve(s.queryClient, e_(s, t));
}
u(t_, "Y2");
p(t_, "getMarkNotificationsMutation");
function i_(s) {
  return {
    mutationFn: /* @__PURE__ */ p(async ({ markAsRead: t, notificationId: i }) => {
      const n = `/api/notifications/${i}/mark`;
      await s.fetch(n, { method: t ? "PUT" : "DELETE" });
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (t) => {
      const i = /* @__PURE__ */ new Map();
      Se(
        s.queryClient,
        { queryKey: ["notifications", "list"], exact: !1 },
        t.notificationId,
        (n) => {
          !!n.is_unread === t.markAsRead && i.set(n.id, n), n.is_unread = !t.markAsRead;
        }
      ), i.size && (v1(
        s.queryClient,
        { queryKey: ["notifications", "badge"], exact: !1 },
        (n) => Math.max(0, n + (t.markAsRead ? -1 : 1))
      ), i.forEach((n) => {
        n.link.app && v1(
          s.queryClient,
          {
            queryKey: ["apps", "notifications", "badge"],
            predicate: /* @__PURE__ */ p((r) => {
              var a, o;
              return r.queryKey[3] === ((a = n.link.app) == null ? void 0 : a.id) || r.queryKey[3] === ((o = n.link.app) == null ? void 0 : o.uid);
            }, "predicate"),
            exact: !1
          },
          (r) => Math.max(0, r + (t.markAsRead ? -1 : 1))
        );
      }));
    }, "onMutate"),
    onError: /* @__PURE__ */ p((t, i) => {
      Se(
        s.queryClient,
        { queryKey: ["notifications", "list"], exact: !1 },
        i.notificationId,
        (n) => {
          n.is_unread = i.markAsRead;
        }
      ), s.queryClient.invalidateQueries({ queryKey: ["notifications", "badge"], exact: !1 }), s.queryClient.invalidateQueries({ queryKey: ["apps", "notifications", "badge"], exact: !1 });
    }, "onError")
  };
}
u(i_, "Z2");
p(i_, "getMarkNotificationMutationOptions");
function aS(s) {
  return new Ve(s.queryClient, i_(s));
}
u(aS, "Xw");
p(aS, "getMarkNotificationMutation");
function n_(s, t = Dt.All, i, n = {}) {
  const r = new URLSearchParams({
    type: t,
    count_only: "true",
    unread: "true"
  }), a = `/api/${i ? `apps/${i.toString()}/` : ""}notifications?${r.toString()}`;
  return ln(s, i ? ["apps", "notifications", "badge", i, t] : ["notifications", "badge", t], a, n);
}
u(n_, "X2");
p(n_, "getBadgeOptions");
var Gj = Object.defineProperty, Kj = Object.getOwnPropertyDescriptor, s_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$9"), r_ = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? Kj(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && Gj(t, i, r), r;
}, "__decorateClass$r"), a_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || s_("Cannot " + i), "__accessCheck$9"), Z4 = /* @__PURE__ */ p((s, t, i) => (a_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$9"), Jj = /* @__PURE__ */ p((s, t, i) => t.has(s) ? s_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$9"), D4 = /* @__PURE__ */ p((s, t, i, n) => (a_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$9"), Hl, Nb, Sp;
let Im = (Nb = (Sp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.typeFilter = Dt.All, this.badgeQuery = new Ei(this), this.handleRefresh = () => {
      this.badgeQuery.result.refetch();
    }, Jj(this, Hl);
  }
  async willUpdate(t) {
    var i, n;
    super.willUpdate(t), (t.has("weavy") || t.has("typeFilter") || t.has("app")) && this.weavy && this.badgeQuery.trackQuery(n_(this.weavy, this.typeFilter, (i = this.app) == null ? void 0 : i.id), !0), t.has("weavy") && this.weavy && ((n = Z4(this, Hl)) == null || n.call(this), this.weavy.subscribe(null, "notification_created", this.handleRefresh), this.weavy.subscribe(null, "notification_updated", this.handleRefresh), this.weavy.subscribe(null, "notifications_marked", this.handleRefresh), D4(this, Hl, () => {
      var r, a, o;
      (r = this.weavy) == null || r.unsubscribe(null, "notification_created", this.handleRefresh), (a = this.weavy) == null || a.unsubscribe(null, "notification_updated", this.handleRefresh), (o = this.weavy) == null || o.unsubscribe(null, "notifications_marked", this.handleRefresh), D4(this, Hl, void 0);
    }));
  }
  render() {
    var t;
    const { data: i, isPending: n } = this.badgeQuery.result ?? {}, r = i != null && i.count ? i.count >= 100 ? "99+" : i.count : "";
    return O`
      ${this.user && !n && i != null && i.count ? O`
          <span class="wy-badge ${((t = this.settings) == null ? void 0 : t.notificationsBadge) === "count" ? "wy-button-badge" : "wy-button-dot"}" title=${i == null ? void 0 : i.count}>${r}</span> 
        ` : M}
    `;
  }
  disconnectedCallback() {
    var t;
    (t = Z4(this, Hl)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Sp, "ya"), Sp), p(Nb, "WyNotificationBadge"), Nb);
Hl = /* @__PURE__ */ new WeakMap();
Im.styles = [
  fe,
  o5
];
r_([
  x()
], Im.prototype, "typeFilter", 2);
Im = r_([
  F("wy-notification-badge"),
  be()
], Im);
var eX = Object.defineProperty, tX = Object.getOwnPropertyDescriptor, o_ = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? tX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && eX(t, i, r), r;
}, "__decorateClass$q"), Bb, Pp;
let E1 = (Bb = (Pp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.showNotifications = !1, this.notificationsRef = ke(), this.appSubscribeMutation = new cn(this);
  }
  handleSubscribe(t) {
    var i;
    (i = this.app) != null && i.id && this.appSubscribeMutation.mutate({ subscribe: t });
  }
  willUpdate(t) {
    (t.has("weavy") || t.has("app")) && this.weavy && this.app && this.appSubscribeMutation.trackMutation(e5(this.weavy, this.app));
  }
  render() {
    var t, i, n, r;
    return ((t = this.settings) == null ? void 0 : t.notifications) === "none" ? M : O`
      <wy-button
        kind="icon"
        ?active=${this.showNotifications}
        @click=${() => this.showNotifications = !this.showNotifications}
      >
        <wy-icon name="bell"></wy-icon>
        ${((i = this.settings) == null ? void 0 : i.notificationsBadge) !== "none" ? O` <wy-notification-badge></wy-notification-badge> ` : M}
      </wy-button>

      <wy-sheet
        noPadding
        .show=${this.showNotifications}
        @close=${() => this.showNotifications = !1}
        @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
      >
        <wy-dropdown slot="appbar-buttons" ?disabled=${!this.app}>
          ${(n = this.app) != null && n.is_subscribed ? O`<wy-dropdown-item @click=${() => this.handleSubscribe(!1)}>
                <wy-icon name="bell-off"></wy-icon>
                ${T("Unsubscribe")}
              </wy-dropdown-item>` : O`<wy-dropdown-item @click=${() => this.handleSubscribe(!0)}>
                <wy-icon name="bell"></wy-icon>
                ${T("Subscribe")}
              </wy-dropdown-item>`}
        </wy-dropdown>
        <span slot="appbar-text">${T("Notifications")}</span>
        ${this.showNotifications ? O`
              <wy-notification-list ${pe(this.notificationsRef)}>
                ${(r = this.app) != null && r.is_subscribed ? M : O`
                      <wy-empty slot="empty">
                          <div>${T("You are not subscribed to updates yet.")}</div>
                          <wy-button color="primary" @click=${() => this.handleSubscribe(!0)}>${T("Subscribe")}</wy-button>
                      </wy-empty>
                    `}
              </wy-notification-list>
            ` : M}
      </wy-sheet>
    `;
  }
}, u(Pp, "wa"), Pp), p(Bb, "WyNotificationButtonList"), Bb);
o_([
  B()
], E1.prototype, "showNotifications", 2);
E1 = o_([
  F("wy-notification-button-list"),
  be()
], E1);
var iX = Object.defineProperty, nX = Object.getOwnPropertyDescriptor, sX = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? nX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && iX(t, i, r), r;
}, "__decorateClass$p");
const l_ = "wy-chat";
var jb, Cp;
let Wm = (jb = (Cp = class extends Ce {
  constructor() {
    super(), this.productType = If.Chat, this.componentType = vi.Chat, new Fr(this, Wm.styles);
  }
  render() {
    return this.app ? O`
          <wy-buttons floating reverse>
            <wy-notification-button-list></wy-notification-button-list>
          </wy-buttons>
          <wy-conversation .conversation=${this.app} .conversationId=${this.app.id}></wy-conversation>
        ` : O` <wy-empty><wy-spinner padded reveal></wy-spinner></wy-empty> `;
  }
}, u(Cp, "fa"), Cp), p(jb, "WyChat"), jb);
Wm.styles = [fe, Wf, ew, Yi, Hr];
Wm = sX([
  F(l_),
  be()
], Wm);
var rX = Object.defineProperty, aX = Object.getOwnPropertyDescriptor, oX = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? aX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && rX(t, i, r), r;
}, "__decorateClass$o");
const c_ = "wy-comments";
var Xb, Qp;
let Vm = (Xb = (Qp = class extends Ce {
  constructor() {
    super(), this.productType = If.Comments, this.componentType = vi.Comments, new Fr(this, Vm.styles);
  }
  render() {
    return this.app ? O`
          <wy-buttons floating reverse>
            <wy-notification-button-list></wy-notification-button-list>
          </wy-buttons>
          <wy-comment-list parentId=${this.app.id} .location=${"apps"}></wy-comment-list>
        ` : O`
          <wy-empty>
            <wy-spinner padded reveal></wy-spinner>
          </wy-empty>
        `;
  }
}, u(Qp, "ma"), Qp), p(Xb, "WyComments"), Xb);
Vm.styles = [fe, Wf, ew, Yi, Hr];
Vm = oX([
  F(c_),
  be()
], Vm);
function h_(s, t, i = {}, n = {}) {
  if (!s)
    throw new Error("useFileList must be used within a WeavyContext");
  return {
    ...n,
    queryKey: ["apps", t, "files", i],
    initialPageParam: 0,
    queryFn: /* @__PURE__ */ p(async (r) => {
      const a = r.pageParam, o = !!(i != null && i.trashed), l = i.order ? i.order.by + (i.order.descending ? "+desc" : "") : "";
      let c = "/api/apps/" + t + "/files?skip=" + a + "&order_by=" + l;
      return o && (c += "&trashed=null"), await (await s.fetch(c)).json();
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((r) => r.end && r.end < r.count ? r.end : null, "getNextPageParam")
  };
}
u(h_, "p5");
p(h_, "getInfiniteFileListOptions");
function d_(s, t) {
  const i = s.queryClient, n = {
    mutationKey: ["apps", t.id, "files"],
    mutationFn: /* @__PURE__ */ p(async ({ file: r, name: a }) => {
      if (r.id >= 1) {
        const o = await s.fetch("/api/files/" + r.id, {
          method: "PATCH",
          body: JSON.stringify({
            name: a
          })
        });
        if (!o.ok) {
          const l = await o.json();
          throw new Error(l.detail || l.title, { cause: l });
        }
        return o.json();
      } else
        throw new Error(`Could not rename ${r.name}`);
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p((r) => (Se(
      i,
      { queryKey: n.mutationKey, exact: !1 },
      r.file.id,
      (a) => Object.assign(a, { name: r.name })
    ), { type: "rename", file: r.file, status: { state: "pending" } }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, r)
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "ok";
      });
    }, "onSuccess"),
    onError(r, a) {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { name: a.file.name })
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "error", o.status.text = r.message;
      });
    }
  };
  return n;
}
u(d_, "u5");
p(d_, "getRenameFileMutationOptions");
function u_(s, t) {
  return new Ve(s.queryClient, d_(s, t));
}
u(u_, "y5");
p(u_, "getRenameFileMutation");
function p_(s, t) {
  const i = s.queryClient, n = {
    mutationKey: ["apps", t.id, "files"],
    mutationFn: /* @__PURE__ */ p(async ({ file: r }) => {
      if (r.id >= 1) {
        if (!(await s.fetch("/api/files/" + r.id + "/trash", { method: "POST" })).ok)
          throw new Error();
      } else
        throw new Error(`Could not trash ${r.name}.`);
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => (Se(
      i,
      { queryKey: n.mutationKey, exact: !1 },
      r.file.id,
      (a) => Object.assign(a, { is_trashed: !0 })
    ), { type: "trash", file: r.file, status: { state: "pending" } }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, r)
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "ok";
      });
    }, "onSuccess"),
    onError(r, a) {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { is_trashed: !1 })
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "error", o.status.text = r.message;
      });
    }
  };
  return n;
}
u(p_, "w5");
p(p_, "getTrashFileMutationOptions");
function f_(s, t) {
  return new Ve(s.queryClient, p_(s, t));
}
u(f_, "f5");
p(f_, "getTrashFileMutation");
function y_(s, t) {
  const i = s.queryClient, n = {
    mutationKey: ["apps", t.id, "files"],
    mutationFn: /* @__PURE__ */ p(async ({ file: r }) => {
      if (r.id >= 1) {
        const a = await s.fetch("/api/files/" + r.id + "/restore", { method: "POST" });
        if (!a.ok) {
          const o = await a.json();
          throw new Error(o.detail || o.title, { cause: o });
        }
      } else {
        const a = { status: 400, title: `Could not restore ${r.name}.` };
        throw new Error(a.detail || a.title, { cause: a });
      }
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => (Se(
      i,
      { queryKey: n.mutationKey, exact: !1 },
      r.file.id,
      (a) => Object.assign(a, { status: "pending" })
    ), { type: "restore", file: r.file, status: { state: "pending" } }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { is_trashed: !1, status: "ok" })
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "ok";
      });
    }, "onSuccess"),
    onError(r, a) {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { is_trashed: !0 })
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "error", o.status.text = r.message;
      });
    }
  };
  return n;
}
u(y_, "m5");
p(y_, "getRestoreFileMutationOptions");
function m_(s, t) {
  return new Ve(s.queryClient, y_(s, t));
}
u(m_, "v5");
p(m_, "getRestoreFileMutation");
function w_(s, t) {
  const i = s.queryClient, n = {
    mutationKey: ["apps", t.id, "files"],
    mutationFn: /* @__PURE__ */ p(async ({ file: r }) => {
      if (r.id >= 1 && r.is_trashed) {
        const a = await s.fetch("/api/files/" + r.id, { method: "DELETE" });
        if (!a.ok) {
          const o = await a.json();
          throw new Error(o.detail || o.title, { cause: o });
        }
      } else {
        const a = { status: 400, title: `Could not delete ${r.name} forever.` };
        throw new Error(a.detail || a.title, { cause: a });
      }
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => (Se(
      i,
      { queryKey: n.mutationKey, exact: !1 },
      r.file.id,
      (a) => Object.assign(a, { status: "pending" })
    ), { type: "delete-forever", file: r.file, status: { state: "pending" } }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      nU(i, { queryKey: n.mutationKey, exact: !1 }, a.file.id), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "ok";
      });
    }, "onSuccess"),
    onError(r, a) {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { status: void 0 })
      ), Ke(i, n.mutationKey, a, (o) => {
        o.status.state = "error", o.status.text = r.message;
      });
    }
  };
  return n;
}
u(w_, "g5");
p(w_, "getDeleteForeverFileMutationOptions");
function g_(s, t) {
  return new Ve(s.queryClient, w_(s, t));
}
u(g_, "b5");
p(g_, "getDeleteForeverFileMutation");
function v_(s, t) {
  const i = s.queryClient, n = ["apps", t.id, "files"];
  return {
    mutationKey: n,
    mutationFn: /* @__PURE__ */ p(async ({ file: r, subscribe: a }) => {
      if (r.id >= 1) {
        const o = await s.fetch(`/api/files/${r.id}/${a ? "subscribe" : "unsubscribe"}`, {
          method: "POST"
        });
        if (!o.ok) {
          const l = await o.json();
          throw new Error(l.detail || l.title, { cause: l });
        }
      } else
        throw new Error(`Could not ${a ? "subscribe" : "unsubscribe"} to ${r.name}.`);
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => (Se(
      i,
      { queryKey: n, exact: !1 },
      r.file.id,
      (a) => Object.assign(a, { is_subscribed: r.subscribe, status: "pending" })
    ), {
      type: r.subscribe ? "subscribe" : "unsubscribe",
      file: r.file,
      status: { state: "pending" }
    }), "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { status: "ok" })
      ), Ke(i, n, a, (o) => {
        o.status.state = "ok";
      });
    }, "onSuccess"),
    onError(r, a) {
      Se(
        i,
        { queryKey: n, exact: !1 },
        a.file.id,
        (o) => Object.assign(o, { is_subscribed: a.file.is_subscribed, status: "error" })
      ), Ke(i, n, a, (o) => {
        o.status.state = "error", o.status.text = r.message;
      });
    }
  };
}
u(v_, "x5");
p(v_, "getSubscribeFileMutationOptions");
function O_(s, t) {
  return new Ve(s.queryClient, v_(s, t));
}
u(O_, "$5");
p(O_, "getSubscribeFileMutation");
const lX = /* @__PURE__ */ p((s) => {
  var f;
  var t, i, n, r, a, o, l, c, h, d;
  return d = (f = class extends s {
    /**
     * @constructor
     * @hideconstructor
     */
    constructor(...w) {
      super(...w), U(this, r), U(this, t, []), U(this, i), U(this, n, /* @__PURE__ */ new Set());
    }
    get eventParent() {
      return P(this, i);
    }
    set eventParent(w) {
      w != null && w.eventChildren && w.eventChildren.add(this), q(this, i, w);
    }
    get eventChildren() {
      return P(this, n);
    }
    /**
     * Registers one or several event listeners. All event listeners are managed and automatically unregistered on destroy.
     *
     * When listening to weavy events, you may also listen to `before:` and `after:` events by simply adding the prefix to a weavy event.
     * Event handlers listening to weavy events may return modified data that is returned to the trigger. The data is passed on to the next event in the trigger event chain. If an event handler calls `event.stopPropagation()` or `return false`, the event chain will be stopped and the value is returned.
     *
     * @example <caption>Instance event</caption>
     * myInstance.on("before:options", function(options) { ... })
     * myInstance.on("options", function(options) { ... })
     * myInstance.on("after:options", function(options) { ... })
     *
     * @category eventhandling
     * @function
     * @name WeavyEvents#on
     * @param {string} events - One or several event names separated by spaces. You may provide any namespaces in the names or use the general namespace parameter instead.
     * @param {string|Object} [selector] - Only applicable if the context supports selectors, for instance jQuery.on().
     * @param {function} handler - The listener. The first argument is always the event, followed by any data arguments provided by the trigger.
     */
    on(...w) {
      const g = ye(this, r, h).call(this, w);
      if (w[3]) {
        const b = /* @__PURE__ */ p((...k) => {
          try {
            g.handler.apply(this, k);
          } catch {
            try {
              g.handler();
            } catch ($) {
              console.warn("Could not invoke one handler:", $);
            }
          }
          ye(this, r, l).call(this, g.events, g.selector, null, g.handler);
        }, "attachedHandler");
        ye(this, r, a).call(this, g.events, g.selector, b, g.handler);
      } else
        ye(this, r, a).call(this, g.events, g.selector, g.handler, g.handler);
    }
    /**
     * Registers one or several event listeners that are executed once. All event listeners are managed and automatically unregistered on destroy.
     *
     * Similar to {@link WeavyEvents#on}.
     *
     * @category eventhandling
     * @function
     * @name WeavyEvents#one
     * @param {string} events - One or several event names separated by spaces. You may provide any namespaces in the names or use the general namespace parameter instead.
     * @param {string|Object} [selector] - Only applicable if the context supports selectors, for instance jQuery.on().
     * @param {Function} handler - The listener. The first argument is always the event, followed by any data arguments provided by the trigger.
     */
    one(w, g, b) {
      this.on(w, g, b, !0);
    }
    /**
     * Unregisters event listeners. The arguments must match the arguments provided on registration using .on() or .one().
     *
     * @category eventhandling
     * @function
     * @name WeavyEvents#off
     * @param {string} events - One or several event names separated by spaces. You may provide any namespaces in the names or use the general namespace parameter instead.
     * @param {string} [selector] - Only applicable if the context supports selectors, for instance jQuery.on().
     * @param {function} handler - The listener. The first argument is always the event, followed by any data arguments provided by the trigger.
     * @returns {boolean} Was the handler removed?
     */
    off(...w) {
      const g = ye(this, r, h).call(this, w), b = ye(this, r, o).call(this, g.events, g.selector, g.handler);
      return ye(this, r, l).call(this, g.events, g.selector, b, g.handler);
    }
    /**
     * Clears all registered eventhandlers
     *
     * @category eventhandling
     * @function
     * @name WeavyEvents#clear
     */
    clearEventHandlers() {
      P(this, t).length = 0;
    }
    /**
     * Trigger a custom event. Events are per default triggered on the weavy instance using the weavy namespace.
     *
     * The trigger has an event chain that adds `before:` and `after:` events automatically for all events except when any custom `prefix:` is specified. This way you may customize the eventchain by specifying `before:`, `on:` and `after:` in your event name to fire them one at the time. The `on:` prefix will then be removed from the name when the event is fired.
     *
     * Eventhandlers listening to the event may return modified data that is returned by the trigger event. The data is passed on to the next event in the trigger event chain. If an event handler calls `event.stopPropagation()` or `return false`, the event chain will be stopped and the value is returned.
     *
     * @example
     * // Normal triggering
     * weavyEvents.triggerEvent("myevent");
     *
     * // Will trigger the following events on the root instance
     * // 1. before:myevent.event.weavy
     * // 2. myevent.event.weavy
     * // 3. after:myevent.event.weavy
     *
     * @example
     * // Custom triggering, one at the time
     * weavyEvents.triggerEvent("before:myevent");
     * weavyEvents.triggerEvent("on:myevent");
     * weavyEvents.triggerEvent("after:myevent");
     *
     * @example
     * // Advanced triggering with data handling
     *
     * function doSomething() {
     *     // Will trigger the events sequentially and check the response data in between
     *
     *     var myTriggerData = { counter: 123, label: "my label" };
     *
     *     // Custom triggering, one at the time
     *
     *     // 1. Trigger before: and save the response data back to myTriggerData
     *     myTriggerData = weavyEvents.triggerEvent("before:myevent", myTriggerData);
     *
     *     if (myTriggerData === false) {
     *         console.warn("before:myevent was cancelled by event.stopPropagation() or return false");
     *         return;
     *     }
     *
     *     // ...
     *
     *     // 2. Continue with on: and save the response data back to myTriggerData
     *     myTriggerData = weavyEvents.triggerEvent("on:myevent", myTriggerData);
     *
     *     if (myTriggerData === false) {
     *         console.warn("on:myevent was cancelled by event.stopPropagation() or return false");
     *         return;
     *     }
     *
     *     // ...
     *
     *     // 3. At last trigger after: and save the response data back to myTriggerData
     *     myTriggerData = weavyEvents.triggerEvent("after:myevent", myTriggerData);
     *
     *     if (myTriggerData === false) {
     *         console.warn("after:myevent was cancelled by event.stopPropagation() or return false");
     *         return;
     *     }
     *
     *     console.log("myevent was fully executed", myTriggerData);
     *     return myTriggerData;
     * }
     *
     * @category eventhandling
     * @function
     * @name WeavyEvents#triggerEvent
     * @param {string} name - The name of the event.
     * @param {(Array/Object/JSON)} [data] - Data may be an array or plain object with data or a JSON encoded string.
     * @param {any} ...additionalData - Any raw extra data
     * @returns {data} The data passed to the event trigger including any modifications by event handlers. Returns false if the event is cancelled.
     */
    triggerEvent(w, g, ...b) {
      const k = /^(before|on|after):/.test(w), $ = k ? w.split(":")[0] : "";
      w = w.replace(/^(before|on|after):/, "");
      const C = "before:" + w, E = w, A = "after:" + w;
      if (g && typeof g == "string")
        try {
          g = JSON.parse(g);
        } catch {
          console.warn("Could not parse event data", w, g);
        }
      let R;
      if (k) {
        if ($ === "before" || $ === "after") {
          if (P(this, i) && (R = P(this, i).triggerEvent(
            $ === "before" ? C : A,
            g,
            ...b
          ), g = R || R === !1 ? R : g, g === !1) || (R = ye(this, r, c).call(this, $ === "before" ? C : A, g, ...b), g = R || R === !1 ? R : g, g === !1))
            return g;
        } else if ($ === "on" && (R = ye(this, r, c).call(this, E, g, ...b), g = R || R === !1 ? R : g, g === !1 || P(this, i) && (R = P(this, i).triggerEvent("on:" + E, g, ...b), g = R || R === !1 ? R : g, g === !1)))
          return g;
      } else {
        if (P(this, i) && (R = P(this, i).triggerEvent(C, g, ...b), g = R || R === !1 ? R : g, g === !1) || (R = ye(this, r, c).call(this, C, g, ...b), g = R || R === !1 ? R : g, g === !1) || (R = ye(this, r, c).call(this, E, g, ...b), g = R || R === !1 ? R : g, g === !1) || P(this, i) && (R = P(this, i).triggerEvent("on:" + E, g, ...b), g = R || R === !1 ? R : g, g === !1) || P(this, i) && (R = P(this, i).triggerEvent(A, g, ...b), g = R || R === !1 ? R : g, g === !1))
          return g;
        R = ye(this, r, c).call(this, A, g, ...b), g = R || R === !1 ? R : g;
      }
      return g;
    }
  }, u(f, "y"), f), t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakSet(), /**
  * Saves a single event handler.
  *
  * @internal
  * @function
  * @param {string} event - One or more events. Multiple events are currently not registered individually.
  * @param {string|Object} [selector] - Optional refinement selector
  * @param {function} handler - The handler function. may be wrapped for once-handlers
  * @param {function} originalHandler - The original non-wrapped event handler.
  */
  a = /* @__PURE__ */ p(function(y, w, g, b) {
    P(this, t).push({
      events: y,
      selector: w,
      handler: g,
      originalHandler: b
    });
  }, "#registerEventHandler"), /**
  * Returns the event handler or wrapped event handler. The arguments must match the registered event handler.
  *
  * @internal
  * @function
  * @param {string} events - The events registered
  * @param {string|Object} [selector] - The optional selector for the handler.
  * @param {function} handler - The registered handler
  * @param {function} [originalHandler] - The original registered handler
  */
  o = /* @__PURE__ */ p(function(y, w, g, b) {
    const k = {
      events: y,
      selector: w,
      handler: g,
      originalHandler: b || g
    }, $ = P(this, t).filter((C) => yc(k, C, !0)).pop();
    return $ && $.handler;
  }, "#getEventHandler"), /**
  * Unregister an event handler. Arguments must match the registered event handler.
  *
  * @internal
  * @function
  * @param {string} event - The events registered
  * @param {function} handler - The registered handler
  * @param {string|Object} [selector] - The optional selector for the handler.
  * @returns {boolean} - True if any handler was removed
  */
  l = /* @__PURE__ */ p(function(y, w, g, b) {
    const k = {
      events: y,
      selector: w,
      handler: g,
      originalHandler: b
    };
    let $ = !1;
    return P(this, t).forEach((C, E) => {
      yc(k, C, !0) && ($ = !0, P(this, t).splice(E, 1));
    }), $;
  }, "#unregisterEventHandler"), /**
  * Triggers any local event handlers registered. Each handler may modify the data and return it or return false to cancel the event chain. .stopPropagation() and .preventDefault() may also be used.
  *
  * @example
  * weavyEvents.on("myevent", function(e, data) { ... })
  *
  * triggerHandler(this, "myevent", { key: 1 })
  *
  * @internal
  * @function
  * @param {any} eventName - The name of the event. Event names without prefix will also trigger handlers with the "on:" prefix.
  * @param {any} data - Any data to pass to the handler
  * @param {any} ...additionalData - Any extra data
  */
  c = /* @__PURE__ */ p(function(y, w, ...g) {
    let b = !1;
    return P(this, t).forEach((k) => {
      k.events.split(" ").forEach(($) => {
        if ($ = $.indexOf("on:") === 0 ? $.split("on:")[1] : $, y === $ && (!k.selector || yc(k.selector, w, !0))) {
          const C = k.handler(w, ...g);
          C ? w = C : C === !1 && (b = !0);
        }
      });
    }), b ? !1 : w;
  }, "#triggerHandler"), /**
  * Extracts and normalizes all parts of the events arguments.
  *
  * @internal
  * @function
  * @param {Array.<Object>} eventArguments - The function argument list: `[context], events, [selector], handler`
  * @returns {Object}
  * @property {string} events - Event names with added namespace for local events.
  * @property {string|Object} selector - The optional selector.
  * @property {function} handler - The handler function
  * @
  */
  h = /* @__PURE__ */ p(function(y) {
    const w = typeof y[1] == "function" ? y[1] : y[2], g = typeof y[1] == "function" ? null : y[1];
    return { events: y[0], selector: g, handler: w };
  }, "#getEventArguments"), p(d, "WeavyEvents"), d;
}, "MixinWeavyEvents"), cX = lX(class {
});
function D$(s) {
  var t;
  let i = "";
  try {
    i = ((t = /^((?:https?:\/\/[^/]+)|(?:file:\/\/))\/?/.exec(s)) == null ? void 0 : t[1]) || "";
  } catch {
    console.error(
      "Unable to resolve location origin. Make sure you are using http, https or file protocol and have a valid location URL."
    );
  }
  return i;
}
u(D$, "qu");
p(D$, "extractOrigin");
var Tp;
const b_ = (Tp = class extends cX {
  constructor(t = {}) {
    super(), this.contentWindows = /* @__PURE__ */ new Set(), this.contentWindowsMapByWeavyId = /* @__PURE__ */ new Map(), this.contentWindowOrigins = /* @__PURE__ */ new WeakMap(), this.contentWindowNames = /* @__PURE__ */ new WeakMap(), this.contentWindowWeavyIds = /* @__PURE__ */ new WeakMap(), this.contentWindowDomain = /* @__PURE__ */ new WeakMap(), this.origin = _1() ? D$(window.location.href) : "", this.timeout = 2e3, t != null && t.timeout && (this.timeout = t.timeout), window.addEventListener("message", (i) => {
      var n, r;
      if (i.data.name && i.data.weavyId !== void 0) {
        if (i.data.weavyMessageId && i.data.name !== "message-receipt" && i.data.name !== "unready")
          try {
            (n = i.source) == null || n.postMessage(
              { name: "message-receipt", weavyId: i.data.weavyId, weavyMessageId: i.data.weavyMessageId },
              { targetOrigin: i.origin }
            );
          } catch {
            console.error("could not post back message-receipt to source");
          }
        switch (i.data.name) {
          case "register-child": {
            if ((!i.source || !this.contentWindowWeavyIds.has(i.source)) && console.warn("register-child: contentWindow not pre-registered", i.source), i.source && this.contentWindowOrigins.get(i.source) !== i.origin) {
              console.error(
                "register-child: " + this.contentWindowNames.get(i.source) + " has invalid origin",
                i.origin
              );
              return;
            }
            try {
              const a = i.source ? this.contentWindowWeavyIds.get(i.source) : void 0, o = i.source ? this.contentWindowNames.get(i.source) : void 0;
              o && i.source && i.source.postMessage(
                {
                  name: "register-window",
                  windowName: o,
                  weavyId: a || !0
                },
                { targetOrigin: i.origin }
              );
            } catch (a) {
              console.error("could not register frame window", a);
            }
            break;
          }
          case "ready": {
            i.source && this.contentWindowsMapByWeavyId.has(i.data.weavyId) && this.contentWindowNames.has(i.source) && (r = this.contentWindowsMapByWeavyId.get(i.data.weavyId)) != null && r.get(this.contentWindowNames.get(i.source)) && (this.contentWindowDomain.set(i.source, i.origin), this.distributeMessage(i));
            break;
          }
          case "unready": {
            this.contentWindowsMapByWeavyId.has(i.data.weavyId) && this.distributeMessage(i, !0);
            break;
          }
          default: {
            (i.source === window || this.contentWindowsMapByWeavyId.size) && this.distributeMessage(i);
            break;
          }
        }
      }
    });
  }
  /**
   * The weavy console logging.
   */
  get console() {
    return console;
  }
  distributeMessage(t, i = !1) {
    const n = t.source === window && t.origin === this.origin;
    if (i || (i = t.source && this.contentWindowOrigins.has(t.source) && t.origin === this.contentWindowOrigins.get(t.source) || !1), n || i) {
      i && !t.data.windowName && t.source && (t.data.windowName = this.contentWindowNames.get(t.source));
      const r = t.data.name;
      this.triggerEvent(r, t.data, t), this.triggerEvent("message", t.data, t);
    }
  }
  /**
   * Sends the id of a frame to the frame content scripts, so that the frame gets aware of which id it has.
   * The frame needs to have a unique name attribute.
   *
   * @category panels
   * @param {string} weavyId - The id of the group or entity which the contentWindow belongs to.
   * @param {Window} contentWindow - The frame window to send the data to.
   */
  registerContentWindow(t, i, n, r) {
    var a;
    try {
      if (!i) {
        console.error("registerContentWindow() No valid contentWindow to register, must be a window and have a name.");
        return;
      }
    } catch {
      console.error("registerContentWindow() cannot access contentWindowName");
    }
    t.self && (t = t.self), this.console.log("registerContentWindow", t), (!n || n === "true") && (n = !0), this.contentWindowsMapByWeavyId.has(n) || this.contentWindowsMapByWeavyId.set(n, /* @__PURE__ */ new Map()), (a = this.contentWindowsMapByWeavyId.get(n)) == null || a.set(i, t), this.contentWindows.add(t), this.contentWindowNames.set(t, i), this.contentWindowWeavyIds.set(t, n), this.contentWindowOrigins.set(t, r);
  }
  unregisterAll(t) {
    var i;
    this.contentWindowsMapByWeavyId.has(t) && ((i = this.contentWindowsMapByWeavyId.get(t)) == null || i.forEach((n, r) => {
      this.unregisterContentWindow(r, t);
    }), this.contentWindowsMapByWeavyId.get(t), this.contentWindowsMapByWeavyId.delete(t));
  }
  unregisterContentWindow(t, i) {
    var n, r, a, o;
    if (this.contentWindowsMapByWeavyId.has(i)) {
      if ((n = this.contentWindowsMapByWeavyId.get(i)) != null && n.has(t)) {
        const l = (r = this.contentWindowsMapByWeavyId.get(i)) == null ? void 0 : r.get(t);
        if (l)
          try {
            this.contentWindows.delete(l), this.contentWindowNames.delete(l), this.contentWindowWeavyIds.delete(l), this.contentWindowOrigins.delete(l);
          } catch {
          }
      }
      if ((a = this.contentWindowsMapByWeavyId.get(i)) == null || a.delete(t), ((o = this.contentWindowsMapByWeavyId.get(i)) == null ? void 0 : o.size) === 0)
        try {
          this.contentWindowsMapByWeavyId.delete(i);
        } catch {
        }
    }
  }
  async whenPostMessage(t, i, n) {
    Bt(), n === null && (n = void 0);
    const r = t === window.self, a = r ? D$(window.location.href) : this.contentWindowOrigins.get(t);
    if (r || t && a === this.contentWindowDomain.get(t)) {
      i.weavyMessageId || (i.weavyMessageId = ff() + ff());
      let o;
      await Promise.race([
        new Promise((l, c) => {
          o = window.setTimeout(() => {
            c(new Error("postMessage() receipt timed out: " + i.weavyMessageId + ", " + i.name));
          }, this.timeout || 2e3);
        }),
        new Promise((l) => {
          this.on("message-receipt", { weavyId: i.weavyId, weavyMessageId: i.weavyMessageId }, () => {
            clearTimeout(o), l(void 0);
          }), t.postMessage(i, { targetOrigin: a, transfer: n });
        })
      ]);
    } else
      throw new Error("postMessage() Invalid window origin: " + a + ", " + i.name);
  }
  postToChildren(t, i) {
    if (typeof t != "object" || !t.name) {
      console.error("postToChildren() Invalid message format", t);
      return;
    }
    i === null && (i = void 0), t.distributeName = t.name, t.name = "distribute", t.weavyId = t.weavyId || !0, this.contentWindows.forEach((n) => {
      const r = this.contentWindowOrigins.get(n);
      if (r === this.contentWindowDomain.get(n))
        try {
          n.postMessage(t, { targetOrigin: r, transfer: i });
        } catch {
          console.warn(
            "postToChildren() could not distribute message to " + this.contentWindowNames.get(n)
          );
        }
    });
  }
  async postToFrame(t, i, n, r) {
    var a;
    if (typeof n != "object" || !n.name) {
      console.error("postToFrame() Invalid message format", n);
      return;
    }
    const o = (a = this.contentWindowsMapByWeavyId.get(i)) == null ? void 0 : a.get(t);
    if (!o)
      throw new Error(`postToFrame() Window not registered: ${i}, ${t}`);
    return n.weavyId = i, await this.whenPostMessage(o, n, r);
  }
  async postToSelf(t, i) {
    if (typeof t != "object" || !t.name) {
      console.error("postToSelf() Invalid message format", t);
      return;
    }
    return t.weavyId = t.weavyId || !0, await this.whenPostMessage(window.self, t, i);
  }
  postToSource(t, i, n) {
    if (t.source && t.data.weavyId !== void 0) {
      const r = t.source === window.self && t.origin === this.origin, a = this.contentWindowOrigins.has(t.source) && t.origin === this.contentWindowOrigins.get(t.source);
      if (n === null && (n = void 0), r || a) {
        i.weavyId = t.data.weavyId;
        try {
          t.source.postMessage(i, { targetOrigin: t.origin, transfer: n });
        } catch (o) {
          console.error("postToSource() Could not post message back to source", o);
        }
      }
    }
  }
}, u(Tp, "Up"), Tp);
p(b_, "WeavyPostalParent");
let hX = b_;
var dX = Object.defineProperty, uX = Object.getOwnPropertyDescriptor, Qv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? uX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && dX(t, i, r), r;
}, "__decorateClass$n"), Fb, Mp;
let zo = (Fb = (Mp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.iframeVisible = !1, this.showOverlay = !1, this.isRegistered = !1, this.iframeElementRef = ke(), this.overlayRef = ke();
  }
  open() {
    this.showOverlay = !0;
  }
  close() {
    this.showOverlay = !1, this.iframeVisible = !1;
  }
  get origin() {
    let t = "";
    try {
      window.location.ancestorOrigins && 0 < window.location.ancestorOrigins.length ? t = window.location.ancestorOrigins[window.location.ancestorOrigins.length - 1] : window.top && (t = window.top.document.location.origin);
    } catch {
    }
    if (!t)
      try {
        t = window.self.document.location.origin;
      } catch {
        console.error("Filebrowser: Could not read current origin.");
      }
    return t;
  }
  dispatchExternalBlobs(t) {
    const i = new CustomEvent("external-blobs", { detail: { externalBlobs: t } });
    return this.dispatchEvent(i);
  }
  connectedCallback() {
    super.connectedCallback(), this.handleFiles = (t, i) => {
      var n, r;
      i.source === ((r = (n = this.iframeElementRef.value) == null ? void 0 : n.contentWindow) == null ? void 0 : r.self) && (this.dispatchExternalBlobs(t.blobs), this.close());
    }, this.handleClose = (t, i) => {
      var n, r;
      i.source === ((r = (n = this.iframeElementRef.value) == null ? void 0 : n.contentWindow) == null ? void 0 : r.self) && this.close();
    }, this.handleGoogleSelected = (t, i) => {
      var n, r;
      i.source === ((r = (n = this.iframeElementRef.value) == null ? void 0 : n.contentWindow) == null ? void 0 : r.self) && this.overlayRef.value && (this.overlayRef.value.maximized = !0);
    }, this.weavyPostal || (this.weavyPostal = new hX()), this.weavyPostal.on("add-external-blobs", this.handleFiles), this.weavyPostal.on("request:file-browser-close", this.handleClose), this.weavyPostal.on("google-selected", this.handleGoogleSelected);
  }
  disconnectedCallback() {
    var t, i, n;
    super.disconnectedCallback(), (t = this.weavyPostal) == null || t.off("add-external-blobs", this.handleFiles), (i = this.weavyPostal) == null || i.off("request:file-browser-close", this.handleClose), (n = this.weavyPostal) == null || n.off("google-selected", this.handleGoogleSelected);
  }
  updated() {
    var t, i;
    this.weavy && (this.showOverlay && !this.src && (this.src = new URL(
      "?origin=" + this.origin + "&v=X&t=" + Date.now().toString() + "&weavyId=wy-filebrowser",
      this.weavy.cloudFilePickerUrl
    )), this.weavyPostal && !this.isRegistered && this.showOverlay && this.src ? (t = this.iframeElementRef.value) != null && t.contentWindow && (this.weavyPostal.registerContentWindow(
      (i = this.iframeElementRef.value) == null ? void 0 : i.contentWindow.self,
      "weavy-filebrowser",
      "wy-filebrowser",
      this.src.origin
    ), this.isRegistered = !0) : this.weavyPostal && this.isRegistered && !this.showOverlay && this.src && (this.weavyPostal.unregisterContentWindow("weavy-filebrowser", "wy-filebrowser"), this.isRegistered = !1, this.src = void 0));
  }
  render() {
    var t;
    return this.weavy ? O`
      <wy-overlay
        .show=${this.showOverlay}
        ${pe(this.overlayRef)}
        @close=${() => this.close()}
        @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
      >
        ${this.showOverlay ? O`
              <wy-spinner overlay ?hidden=${this.iframeVisible}></wy-spinner>
              <iframe
                ${pe(this.iframeElementRef)}
                @load=${() => this.iframeVisible = !0}
                src=${Me((t = this.src) == null ? void 0 : t.toString())}
                style="flex: 1 1 100%; border: 0;"
                id="weavy-filebrowser"
                name="weavy-filebrowser"
                title=${T("Cloud File Browser")}
              ></iframe>
            ` : M}
      </wy-overlay>
    ` : M;
  }
}, u(Mp, "va"), Mp), p(Fb, "WyCloudFiles"), Fb);
zo.styles = fe;
Qv([
  B()
], zo.prototype, "src", 2);
Qv([
  B()
], zo.prototype, "iframeVisible", 2);
Qv([
  B()
], zo.prototype, "showOverlay", 2);
zo = Qv([
  F("wy-cloud-files"),
  be()
], zo);
var pX = Object.defineProperty, fX = Object.getOwnPropertyDescriptor, uw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? fX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && pX(t, i, r), r;
}, "__decorateClass$m"), Hb, Rp;
let qr = (Hb = (Rp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.order = { by: "name", descending: !1 }, this.view = "list", this.showTrashed = !1, this.showUploadSheet = !1, this.mutatingFiles = new zz(
      this
    ), this.fileInputRef = ke(), this.cloudFilesRef = ke(), this.openFileInput = () => {
      var t;
      (t = this.fileInputRef.value) == null || t.click();
    }, this.openCloudFiles = () => {
      var t;
      (t = this.cloudFilesRef.value) == null || t.open();
    };
  }
  // remove file attachment
  async handleRemoveMutation(t) {
    var i;
    const n = await this.whenWeavy(), r = await this.whenApp(), a = t.status === "error" && !((i = t.variables) != null && i.blob) ? ["apps", r.id, "blobs", void 0] : ["apps", r.id, "files"];
    J5(
      n.queryClient,
      a,
      (o) => o.state.submittedAt === t.submittedAt
    );
  }
  handleOverwriteUpload(t) {
    var i;
    const n = (i = t.variables) == null ? void 0 : i.blob;
    n && this.dispatchCreateFiles([n], !0);
  }
  dispatchUploadFiles(t, i) {
    const n = new CustomEvent("upload-files", { detail: { files: t, input: i } });
    return this.dispatchEvent(n);
  }
  dispatchExternalBlobs(t) {
    const i = new CustomEvent("external-blobs", { detail: { externalBlobs: t } });
    return this.dispatchEvent(i);
  }
  dispatchCreateFiles(t, i = !1) {
    const n = new CustomEvent("create-files", { detail: { blobs: t, replace: i } });
    return this.dispatchEvent(n);
  }
  dispatchOrder(t) {
    const i = new CustomEvent("order", { detail: { order: t } });
    return this.dispatchEvent(i);
  }
  dispatchView(t) {
    const i = new CustomEvent("view", { detail: { view: t } });
    return this.dispatchEvent(i);
  }
  dispatchShowTrashed(t) {
    const i = new CustomEvent("show-trashed", { detail: { showTrashed: t } });
    return this.dispatchEvent(i);
  }
  dispatchSubscribe(t) {
    const i = new CustomEvent("subscribe", { detail: { subscribe: t } });
    return this.dispatchEvent(i);
  }
  willUpdate(t) {
    super.willUpdate(t), (t.has("weavy") || t.has("app")) && this.weavy && this.app && this.mutatingFiles.trackMutationState(
      { filters: { mutationKey: ["apps", this.app.id], exact: !1 } },
      this.weavy.queryClient
    );
  }
  renderFileMutation(t) {
    var i, n, r;
    if ((i = t.context) != null && i.file) {
      const a = t.context.file, o = {
        ...t.context.status
      };
      return t.context.status.state === "conflict" && (o.text = T("Replace existing file?")), O`
        <wy-file-item
          .file=${(n = t.context) == null ? void 0 : n.file}
          .status=${o}
          .actionType=${t.context.type}
          title="${qk(t.context.type)}: ${a.name}"
        >
          <span slot="title">${a.name}</span>
          ${o.text ? O`: <span slot="actions" title=${o.text}><em>${o.text}</em></span>` : M}
          ${o.state === "conflict" && (r = t.variables) != null && r.blob ? O`
                <wy-button
                  slot="actions"
                  kind="icon"
                  @click=${() => this.handleOverwriteUpload(
        t
      )}
                  title=${T("Replace")}
                >
                  <wy-icon name="check"></wy-icon>
                </wy-button>
              ` : M}
          <wy-button
            slot="actions"
            kind="icon"
            @click=${() => this.handleRemoveMutation(t)}
            title=${T("Discard", { desc: "Button action to discard" })}
          >
            <wy-icon name="close"></wy-icon>
          </wy-button>
        </wy-file-item>
      `;
    }
    return M;
  }
  render() {
    var t, i, n, r;
    const a = this.mutatingFiles.result, o = Qz(a), l = a != null && a.length ? a.filter((d) => {
      var f;
      return ((f = d.context) == null ? void 0 : f.file) && !o.includes(d);
    }) : [], c = Pz(a), h = Cz(a);
    return O`
      <nav class="wy-toolbar">
        <div class="wy-toolbar-buttons">
          ${ko(Ar.Create, (t = this.app) == null ? void 0 : t.permissions) ? O`
                <wy-dropdown title=${T("Add files")}>
                  <span slot="button">${T("Add files")}</span>
                  <wy-icon slot="button" name="plus" last></wy-icon>
                  <wy-dropdown-item @click=${this.openFileInput} title=${T("From device")}>
                    <wy-icon name="attachment"></wy-icon>
                    <span>${T("From device")}</span>
                  </wy-dropdown-item>
                  <input
                    type="file"
                    data-testid="uploadFile"
                    ${pe(this.fileInputRef)}
                    @click=${(d) => d.stopPropagation()}
                    @change=${(d) => this.dispatchUploadFiles(d.target.files, d.target)}
                    multiple
                    hidden
                    tabindex="-1"
                  />
                  ${(i = this.hasFeatures) != null && i.cloudFiles ? O`
                        <wy-dropdown-item @click=${this.openCloudFiles} title=${T("From cloud")}>
                          <wy-icon name="cloud"></wy-icon>
                          <span>${T("From cloud")}</span>
                        </wy-dropdown-item>
                      ` : M}
                </wy-dropdown>
              ` : M}
        </div>
        <div class="wy-toolbar-buttons wy-toolbar-buttons-last">
          ${a != null && a.length ? O`
                <wy-button
                  kind="icon"
                  @click=${() => {
      this.showUploadSheet = !this.showUploadSheet;
    }}
                  title=${T(h === "conflict" ? "File conflict" : h === "error" ? "Upload error" : h === "pending" ? "Pending" : "All uploads finished")}
                >
                  ${h === "conflict" ? O`<wy-icon name="alert" color="yellow" title=${T("File conflict")}></wy-icon>` : h === "error" ? O`<wy-icon name="alert-octagon" color="error" title=${T("Upload error")}></wy-icon>` : h === "pending" ? O`<wy-spinner
                        ?nospin=${c !== void 0 && c.percent !== null}
                        progress=${Me(c.percent !== null ? c.percent : void 0)}
                        title=${T("Pending")}
                      ></wy-spinner>` : O`<wy-icon name="check" title=${T("All uploads finished")}></wy-icon>`}
                </wy-button>
              ` : M}
          ${this.app ? O` <wy-notification-button-list></wy-notification-button-list> ` : M}

          <wy-dropdown icon="sort" title="Sort items by" directionX="left">
            <wy-dropdown-option
              ?selected=${this.order.by === "name"}
              @click=${() => this.dispatchOrder({ ...this.order, by: "name" })}
            >
              ${T("Name")}
            </wy-dropdown-option>
            <wy-dropdown-option
              ?selected=${this.order.by === "updated_at"}
              @click=${() => this.dispatchOrder({ ...this.order, by: "updated_at" })}
            >
              ${T("Modified")}
            </wy-dropdown-option>
            <wy-dropdown-option
              ?selected=${this.order.by === "size"}
              @click=${() => this.dispatchOrder({ ...this.order, by: "size" })}
            >
              ${T("Size")}
            </wy-dropdown-option>
            <wy-dropdown-divider></wy-dropdown-divider>
            <wy-dropdown-option
              ?selected=${!this.order.descending}
              @click=${() => this.dispatchOrder({ ...this.order, descending: !1 })}
            >
              ${T("Ascending")}
            </wy-dropdown-option>
            <wy-dropdown-option
              ?selected=${this.order.descending}
              @click=${() => this.dispatchOrder({ ...this.order, descending: !0 })}
            >
              ${T("Descending")}
            </wy-dropdown-option>
          </wy-dropdown>

          <wy-dropdown
            icon=${this.view === "grid" ? "view-module-outline" : "view-list-outline"}
            title="View options"
            directionX="left"
          >
            <wy-dropdown-option ?selected=${this.view === "list"} @click=${() => this.dispatchView("list")}>
              ${T("List view")}
            </wy-dropdown-option>
            <wy-dropdown-option ?selected=${this.view === "grid"} @click=${() => this.dispatchView("grid")}>
              ${T("Grid view")}
            </wy-dropdown-option>
            <wy-dropdown-divider></wy-dropdown-divider>
            <wy-dropdown-option ?selected=${!this.showTrashed} @click=${() => this.dispatchShowTrashed(!1)}>
              ${T("Hide trashed")}
            </wy-dropdown-option>
            <wy-dropdown-option ?selected=${this.showTrashed} @click=${() => this.dispatchShowTrashed(!0)}>
              ${T("Show trashed")}
            </wy-dropdown-option>
          </wy-dropdown>

          <wy-dropdown directionX="left" ?disabled=${!this.app}>
            ${(n = this.app) != null && n.is_subscribed ? O`<wy-dropdown-item @click=${() => this.dispatchSubscribe(!1)}>
                  <wy-icon name="bell-off"></wy-icon>
                  ${T("Unsubscribe")}
                </wy-dropdown-item>` : O`<wy-dropdown-item @click=${() => this.dispatchSubscribe(!0)}>
                  <wy-icon name="bell"></wy-icon>
                  ${T("Subscribe")}
                </wy-dropdown-item>`}
            ${(r = this.app) != null && r.archive_url ? O`<wy-dropdown-item
                  @click=${() => {
      var d, f;
      return wc((d = this.app) == null ? void 0 : d.archive_url, "_top", `${(f = this.app) == null ? void 0 : f.uid}.zip`, !0);
    }}
                >
                  <wy-icon name="download"></wy-icon>
                  ${T("Download files")}
                </wy-dropdown-item>` : M}
          </wy-dropdown>
        </div>
      </nav>

      ${this.weavy ? O`
            <wy-sheet
              .show=${this.showUploadSheet}
              @close=${() => this.showUploadSheet = !1}
              @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
            >
              <wy-button
                kind="icon"
                slot="appbar-buttons"
                @click=${() => {
      a == null || a.forEach((d) => this.handleRemoveMutation(d));
    }}
                title=${T("Remove all", { desc: "Button action to remove all" })}
              >
                <wy-icon name="trashcan"></wy-icon>
              </wy-button>
              <span slot="appbar-text">${T("File actions")}</span>
              ${o.length ? O`
                    ${zi(
      o,
      (d) => "mutation" + d.submittedAt,
      (d) => this.renderFileMutation(d)
    )}
                    ${l.length ? O`<hr />` : M}
                  ` : M}
              ${l.length ? O`
                    ${zi(
      l,
      (d) => "mutation" + d.submittedAt,
      (d) => this.renderFileMutation(d)
    )}
                  ` : M}
            </wy-sheet>
          ` : M}

      <wy-cloud-files
        ${pe(this.cloudFilesRef)}
        @external-blobs=${(d) => this.dispatchExternalBlobs(d.detail.externalBlobs)}
      ></wy-cloud-files>
    `;
  }
}, u(Rp, "ga"), Rp), p(Hb, "WyFilesAppbar"), Hb);
qr.styles = [fe];
uw([
  x({ type: Object })
], qr.prototype, "order", 2);
uw([
  x()
], qr.prototype, "view", 2);
uw([
  x({ type: Boolean })
], qr.prototype, "showTrashed", 2);
uw([
  B()
], qr.prototype, "showUploadSheet", 2);
qr = uw([
  F("wy-files-appbar"),
  be()
], qr);
const yX = de`[part~=wy-grid]{display:grid;grid-auto-flow:dense;grid-template-columns:repeat(auto-fill,minmax(calc(10 * var(--wy-size, 1rem)),1fr));grid-gap:var(--wy-gap, calc(.5 * var(--wy-size, 1rem)));padding:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}`, mX = de`@keyframes wy-highlight{0%{--wy-component-background-color: var(--wy-highlight, var(--wy-primary-95, #e8f2ff));--wy-component-color: var(--wy-on-highlight, var(--wy-primary-10, #001d32))}}[part~=wy-card]{--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));--wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));--wy-component-border-radius: var(--wy-border-radius, calc(.5 * var(--wy-size, 1rem)));background-color:var(--wy-component-background-color);color:var(--wy-component-color);border-radius:var(--wy-component-border-radius);position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-clip:border-box}[part~=wy-card][part~=wy-highlight]{animation:wy-highlight 3s 1.5s ease-in-out both}[part~=wy-card-primary]{--wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));--wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32))}[part~=wy-card-hover]{cursor:pointer;-webkit-user-select:none;user-select:none}[part~=wy-card-hover]:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;background:var(--wy-component-color);opacity:0%}[part~=wy-card-hover]:hover:before{opacity:var(--wy-opacity-state-hover, 8%)}[part~=wy-card-hover]:focus:before{opacity:var(--wy-opacity-state-focus, 12%)}[part~=wy-card-hover]:active:before,[part~=wy-card-hover][part~=wy-active]:before{opacity:var(--wy-opacity-state-active, 12%)}[part~=wy-card-actions]{position:absolute;top:calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + .5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))));right:calc(var(--wy-padding, calc(.5 * var(--wy-size, 1rem))) + .5 * var(--wy-gap, calc(.5 * var(--wy-size, 1rem))));align-items:center;display:flex}[part~=wy-card-content]{flex:1 0 auto;padding-block-end:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));padding-inline-start:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)));padding-inline-end:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}[part~=wy-card-content][part~=wy-card-top]{padding-block-start:var(--wy-padding, calc(.5 * var(--wy-size, 1rem)))}[part~=wy-card-top]{border-radius:var(--wy-component-border-radius);object-fit:cover;object-position:top center;flex:1 1 100%;max-height:calc(10 * var(--wy-size, 1rem))}[part~=wy-card-icon]{--wy-component-icon-width: calc(6 * var(--wy-size, 1rem));--wy-component-icon-height: calc(6 * var(--wy-size, 1rem));display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;padding:calc(1 * var(--wy-size, 1rem)) calc(2 * var(--wy-size, 1rem));margin:auto}[part~=wy-card-image]{width:auto;height:auto}[part~=wy-card-image][part~=wy-loading]{transition:opacity .15s ease-out;opacity:0}[part~=wy-card-image][part~=wy-loading][part~=wy-loaded]{opacity:1;transition:opacity .15s ease-out}[part~=wy-card-top-image]{object-position:50% 38%}[part~=wy-trashed]{opacity:var(--wy-opacity-disabled, 38%);text-decoration:line-through}`;
function $_(s, t, i, n, r) {
  return s && s.length ? O`
        <table class="wy-table wy-table-hover wy-table-files">
          <thead>${x_.call(this, t)}</thead>
          <tbody>
            ${zi(
    s,
    (a) => a.id,
    (a) => k_.call(this, this.weavy, { file: a }, i, n, r)
  )}
          </tbody>
        </table>
        <slot name="end"></slot>
      ` : M;
}
u($_, "O5");
p($_, "renderFileTable");
function x_(s) {
  const t = [
    { by: void 0, title: "" },
    // File icon
    { by: "name", title: T("Name") },
    { by: void 0, title: "" },
    // Comments icon
    { by: "updated_at", title: T("Modified") },
    { by: void 0, title: T("Kind") },
    { by: "size", title: T("Size") },
    { by: void 0, title: "" }
    // Menu
  ];
  return O`
    <tr>
      ${t.map((i) => {
    if (i.title) {
      const n = i.by === (s == null ? void 0 : s.by), r = /* @__PURE__ */ p((a) => {
        a.preventDefault(), i.by && this.dispatchOrder({ by: i.by, descending: n && !(s != null && s.descending) });
      }, "onHeaderClick");
      return O` <th>
            ${i.by ? O`<div
                  class="wy-table-sort-link"
                  tabindex="0"
                  @click=${r}
                  @keydown=${ei}
                  @keyup=${_i}
                  >${i.title}
                  ${n && O`<wy-icon name=${s != null && s.descending ? "menu-down" : "menu-up"}></wy-icon>` || M}</div
                >` : i.title}
          </th>`;
    } else
      return O`<th class="wy-table-cell-icon"></th>`;
  })}
    </tr>
  `;
}
u(x_, "A5");
p(x_, "renderFileTableHeaders");
function k_(s, { file: t }, i, n, r) {
  var a;
  const o = t.size && t.size > 0 ? fv(t.size) : M, l = t.updated_at || t.created_at, c = new Intl.DateTimeFormat(s == null ? void 0 : s.locale, { dateStyle: "full", timeStyle: "short" }).format(
    new Date(l)
  ), h = new Intl.DateTimeFormat(s == null ? void 0 : s.locale, { dateStyle: "short" }).format(new Date(l)), d = !!(i && i === t.id), { icon: f } = Ls(t.name), y = Gi(t.name), w = Uo(t.provider), g = /* @__PURE__ */ p(($) => {
    $.stopImmediatePropagation();
    const C = $.target;
    C.value && C.value !== t.name ? this.dispatchRename(t, C.value) : this.dispatchEditName({ id: NaN });
  }, "handleRename"), b = /* @__PURE__ */ p(($) => {
    const C = $.target;
    $.key === "Escape" ? ($.preventDefault(), C.value = t.name, C.blur()) : $.key === "Enter" && ($.preventDefault(), C.blur());
  }, "handleRenameKey"), k = !!(n && n === t.id);
  return O`
    <tr
      class=${ot({ "wy-table-row-trashed": t.is_trashed })}
      part=${At({ "wy-highlight": k })}
      @click=${($) => {
    !$.defaultPrevented && !t.is_trashed && this.dispatchFileOpen(t.id);
  }}
      ${k && r ? pe(r) : M}
    >
      <td class="wy-table-cell-icon"
        ><wy-icon name=${f} .overlayName=${w} size="24" kind=${t.kind} ext=${y}></wy-icon
      ></td>
      <td class="wy-table-cell-text">
        ${d ? O`
              <input
                type="text"
                maxlength="256"
                class="wy-input"
                .defaultValue=${t.name}
                @blur=${g}
                @keyup=${($) => {
    jn($), b($);
  }}
                @click=${($) => $.preventDefault()}
                @focus=${wv}
                ${pe(U$)}
              />
            ` : O`${t.name}`}
      </td>
      <td class="wy-table-cell-icon"
        >${(a = t.comments) != null && a.count ? O`<wy-button
              kind="icon"
              @click=${($) => {
    !$.defaultPrevented && !t.is_trashed && ($.target.blur(), this.dispatchFileOpen(t.id, "comments"), $.stopPropagation());
  }}
              title=${T(ie`${t.comments.count} comments`)}
            >
              <span class="wy-badge">${t.comments.count}</span>
            </wy-button>` : M}</td
      >
      <td><time datetime="${l}" title=${c}>${h}</time></td>
      <td>${t.kind}</td>
      <td>${o}</td>
      <td class="wy-table-cell-icon">
        <wy-file-menu
          .file=${t}
          @edit-name=${($) => this.dispatchEditName($.detail.file)}
          @trash=${($) => this.dispatchTrash($.detail.file)}
          @restore=${($) => this.dispatchRestore($.detail.file)}
          @delete-forever=${($) => this.dispatchDeleteForever($.detail.file)}
          @subscribe=${($) => this.dispatchSubscribe($.detail.file, $.detail.subscribe)}
        >
        </wy-file-menu>
      </td>
    </tr>
  `;
}
u(k_, "L5");
p(k_, "renderFileTableRow");
function S_(s, t, i, n) {
  var r, a;
  const o = s.size && s.size > 0 ? fv(s.size) : M, l = s.updated_at || s.created_at, c = new Intl.DateTimeFormat((r = this.weavy) == null ? void 0 : r.locale, { dateStyle: "full", timeStyle: "short" }).format(
    new Date(l)
  ), h = !!(t && t === s.id), { icon: d } = Ls(s.name), f = Gi(s.name), y = Uo(s.provider), w = /* @__PURE__ */ p(($) => {
    $.stopImmediatePropagation();
    const C = $.target;
    C.value && C.value !== s.name ? this.dispatchRename(s, C.value) : this.dispatchEditName({ id: NaN });
  }, "handleRename"), g = /* @__PURE__ */ p(($) => {
    const C = $.target;
    $.key === "Escape" ? ($.preventDefault(), C.value = s.name, C.blur()) : $.key === "Enter" && ($.preventDefault(), C.blur());
  }, "handleRenameKey"), b = {
    "wy-trashed": s.is_trashed
  }, k = !!(i && i === s.id);
  return O`
    <div
      part=${At({
    "wy-card": !0,
    "wy-card-trashed": s.is_trashed,
    "wy-card-hover": !s.is_trashed && !h,
    "wy-highlight": k
  })}
      title="${s.name} • ${o} • ${c}"
      tabindex="0"
      @click=${($) => {
    !$.defaultPrevented && !s.is_trashed && this.dispatchFileOpen(s.id);
  }}
      @keydown=${ei}
      @keyup=${_i}
      ${k && n ? pe(n) : M}
    >
      <div part="wy-card-actions">
        <wy-file-menu
          small
          .file=${s}
          @edit-name=${($) => this.dispatchEditName($.detail.file)}
          @trash=${($) => this.dispatchTrash($.detail.file)}
          @restore=${($) => this.dispatchRestore($.detail.file)}
          @delete-forever=${($) => this.dispatchDeleteForever($.detail.file)}
          @subscribe=${($) => this.dispatchSubscribe($.detail.file, $.detail.subscribe)}
        ></wy-file-menu>
      </div>
      ${!s.is_trashed && s.thumbnail_url ? O`
            <img
              part="wy-card-top wy-card-content wy-card-image ${At({
    "wy-card-top-image": s.kind === "image",
    ...b
  })}"
              width=${Me(s.width)}
              height=${Me(s.height)}
              src=${s.thumbnail_url}
              alt=${s.name}
              ${pe(km)}
              @load=${Sm}
              loading="lazy"
              decoding="async"
            />
          ` : O`
            <div part="wy-card-top wy-card-content wy-card-icon ${At(b)}">
              <wy-icon name=${d} .overlayName=${y} size="96" kind=${s.kind} ext=${f}></wy-icon>
            </div>
          `}
      <div part="wy-card-content wy-filename ${At(b)}">
        ${h ? O`
              <input
                type="text"
                maxlength="256"
                class="wy-input"
                .defaultValue=${s.name}
                @blur=${w}
                @keyup=${($) => {
    jn($), g($);
  }}
                @click=${($) => $.preventDefault()}
                @focus=${wv}
                ${pe(U$)}
              />
            ` : O`<div class="wy-truncated-text-and-icon"
              ><div>${s.name}</div> ${(a = s.comments) != null && a.count ? O`<wy-button
                    small
                    kind="icon"
                    @click=${($) => {
    !$.defaultPrevented && !s.is_trashed && ($.target.blur(), this.dispatchFileOpen(s.id, "comments"), $.stopPropagation());
  }}
                    title=${T(ie`${s.comments.count} comments`)}
                  >
                    <span class="wy-badge">${s.comments.count}</span>
                  </wy-button>` : M}</div
            >`}
      </div>
    </div>
  `;
}
u(S_, "R5");
p(S_, "renderFileCard");
var wX = Object.defineProperty, gX = Object.getOwnPropertyDescriptor, Kr = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? gX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && wX(t, i, r), r;
}, "__decorateClass$l"), Yb, Ap;
let wn = (Yb = (Ap = class extends tt(G) {
  constructor() {
    super(), this.exportParts = new ae(this), this.order = { by: "name", descending: !1 }, this.view = "list", this.isRenamingId = NaN, this.highlightId = NaN, this.highlightComment = !1, this.highlightRef = ke(), this.addEventListener("edit-name", (t) => {
      this.isRenamingId = t.detail.file.id;
    }), this.addEventListener("rename", () => {
      this.isRenamingId = NaN;
    });
  }
  dispatchFileOpen(t, i) {
    const n = new CustomEvent("file-open", { detail: { fileId: t, tab: i } });
    return this.dispatchEvent(n);
  }
  dispatchOrder(t) {
    const i = new CustomEvent("order", { detail: { order: t } });
    return this.dispatchEvent(i);
  }
  dispatchEditName(t) {
    const i = new CustomEvent("edit-name", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchRename(t, i) {
    const n = new CustomEvent("rename", { detail: { file: t, name: i } });
    return this.dispatchEvent(n);
  }
  dispatchTrash(t) {
    const i = new CustomEvent("trash", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchRestore(t) {
    const i = new CustomEvent("restore", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchDeleteForever(t) {
    const i = new CustomEvent("delete-forever", { detail: { file: t } });
    return this.dispatchEvent(i);
  }
  dispatchSubscribe(t, i) {
    const n = new CustomEvent("subscribe", { detail: { file: t, subscribe: i } });
    return this.dispatchEvent(n);
  }
  willUpdate(t) {
    var i;
    t.has("link") && (this.highlightId = this.link && ((i = $5(this.link, Bi.File)) == null ? void 0 : i.id), this.highlightComment = this.link && this.highlightId ? x5(this.link, Bi.File, { id: this.highlightId }, Bi.Comment) : !1), t.has("highlightComment") && this.highlightComment && this.highlightId && this.dispatchFileOpen(this.highlightId, "comments");
  }
  render() {
    return this.files && this.files.length ? this.view === "grid" ? O`
          <div part="wy-grid">
            ${zi(
      this.files,
      (t) => t.id,
      (t) => S_.call(this, t, this.isRenamingId, this.highlightId, this.highlightRef)
    )}
          </div>
          <slot name="end"></slot>
        ` : $_.call(this, this.files, this.order, this.isRenamingId, this.highlightId, this.highlightRef) : M;
  }
  updated(t) {
    var i;
    t.has("highlightId") && this.highlightId && ((i = this.highlightRef.value) == null || i.scrollIntoView({ block: "nearest" }));
  }
}, u(Ap, "ba"), Ap), p(Yb, "WyFilesList"), Yb);
wn.styles = [fe, ew, yX, mX];
Kr([
  x({ attribute: !1 })
], wn.prototype, "files", 2);
Kr([
  x({ type: Number })
], wn.prototype, "dataUpdatedAt", 2);
Kr([
  x({ attribute: !1 })
], wn.prototype, "order", 2);
Kr([
  x()
], wn.prototype, "view", 2);
Kr([
  B()
], wn.prototype, "isRenamingId", 2);
Kr([
  B()
], wn.prototype, "highlightId", 2);
Kr([
  B()
], wn.prototype, "highlightComment", 2);
wn = Kr([
  F("wy-files-list"),
  be()
], wn);
var vX = Object.defineProperty, OX = Object.getOwnPropertyDescriptor, P_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$8"), Tv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? OX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && vX(t, i, r), r;
}, "__decorateClass$k"), C_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || P_("Cannot " + i), "__accessCheck$8"), q4 = /* @__PURE__ */ p((s, t, i) => (C_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$8"), bX = /* @__PURE__ */ p((s, t, i) => t.has(s) ? P_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$8"), U4 = /* @__PURE__ */ p((s, t, i, n) => (C_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$8"), Yl;
const Q_ = "wy-files";
var Gb, Ep;
let Ur = (Gb = (Ep = class extends Ce {
  constructor() {
    super(), this.productType = If.Files, this.componentType = vi.Files, this.view = "list", this.order = { by: "name", descending: !1 }, this.showTrashed = !1, this.filesQuery = new Vo(this), this.persistState = new G5(this), this.infiniteScroll = new Zo(this), this.pagerRef = ke(), this.previewRef = ke(), this.dropZone = new Zz(this), this.appSubscribeMutation = new cn(this), this.uploadBlobMutation = new cn(this), this.createFileMutation = new cn(this), this.handleRealtimeFileCreated = (t) => {
      !this.weavy || !this.app || (t.file.created_by = t.actor, this.weavy.queryClient.invalidateQueries({ queryKey: this.getFilesQueryKey(this.app) }));
    }, this.handleRealtimeFileUpdated = (t) => {
      !this.weavy || !this.app || this.weavy.queryClient.invalidateQueries({ queryKey: this.getFilesQueryKey(this.app) });
    }, this.handleRealtimeFileTrashed = (t) => {
      !this.weavy || !this.app || this.weavy.queryClient.invalidateQueries({ queryKey: this.getFilesQueryKey(this.app) });
    }, this.handleRealtimeFileRestored = (t) => {
      !this.weavy || !this.app || this.weavy.queryClient.invalidateQueries({ queryKey: this.getFilesQueryKey(this.app) });
    }, this.handleRealtimeFileDeleted = (t) => {
      !this.weavy || !this.app || this.weavy.queryClient.invalidateQueries({ queryKey: this.getFilesQueryKey(this.app) });
    }, this.handleRealtimeCommentCreated = () => {
      !this.weavy || !this.app || this.weavy.queryClient.invalidateQueries({ queryKey: this.getFilesQueryKey(this.app) });
    }, bX(this, Yl), this.addEventListener("drop-files", this.handleBlobUpload), new Fr(this, Ur.styles);
  }
  // upload files
  handleBlobUpload(t) {
    const i = t.detail;
    if (i.files) {
      for (let n = 0; n < i.files.length; n++) {
        const r = { file: i.files[n] };
        this.uploadBlobMutation.mutate(r).then((a) => this.handleCreateFile(a));
      }
      i.input && (i.input.value = "");
    }
  }
  // upload files
  handleExternalBlobs(t) {
    var i;
    if (t.detail.externalBlobs)
      for (let n = 0; n < t.detail.externalBlobs.length; n++) {
        const r = t.detail.externalBlobs[n];
        (i = this.externalBlobMutation) == null || i.mutate({ externalBlob: r }).then((a) => this.handleCreateFile(a));
      }
  }
  // add uploaded files
  async handleCreateFile(t, i) {
    return await this.createFileMutation.mutate({ blob: t, replace: i });
  }
  handleSubscribe(t) {
    var i;
    (i = this.app) != null && i.id && this.appSubscribeMutation.mutate({ subscribe: t });
  }
  getFilesQueryKey(t) {
    return ["apps", t.id, "files"];
  }
  willUpdate(t) {
    var i;
    if (super.willUpdate(t), (t.has("uid") || t.has("weavy") || t.has("user")) && this.uid && this.weavy && this.user && this.persistState.observe(["view", "order", "showTrashed"], this.uid, `u${this.user.id}`), (t.has("weavy") || t.has("app") || t.has("order") || t.has("showTrashed")) && this.weavy && this.app && this.filesQuery.trackInfiniteQuery(
      h_(this.weavy, this.app.id, {
        order: this.order,
        trashed: this.showTrashed
      })
    ), (t.has("weavy") || t.has("app") || t.has("user")) && this.weavy && this.app && this.user) {
      this.appSubscribeMutation.trackMutation(e5(this.weavy, this.app)), this.uploadBlobMutation.trackMutation(iS(this.weavy, this.user, this.app)), this.createFileMutation.trackMutation(Mz(this.weavy, this.user, this.app)), this.externalBlobMutation = nS(this.weavy, this.user, this.app), this.renameFileMutation = u_(this.weavy, this.app), this.subscribeFileMutation = O_(this.weavy, this.app), this.trashFileMutation = f_(this.weavy, this.app), this.restoreFileMutation = m_(this.weavy, this.app), this.deleteForeverFileMutation = g_(this.weavy, this.app), (i = q4(this, Yl)) == null || i.call(this);
      const n = `a${this.app.id}`;
      this.weavy.subscribe(n, "file_created", this.handleRealtimeFileCreated), this.weavy.subscribe(n, "file_updated", this.handleRealtimeFileUpdated), this.weavy.subscribe(n, "file_trashed", this.handleRealtimeFileTrashed), this.weavy.subscribe(n, "file_restored", this.handleRealtimeFileRestored), this.weavy.subscribe(n, "file_deleted", this.handleRealtimeFileDeleted), this.weavy.subscribe(n, "comment_created", this.handleRealtimeCommentCreated), U4(this, Yl, () => {
        var r, a, o, l, c, h;
        (r = this.weavy) == null || r.unsubscribe(n, "file_created", this.handleRealtimeFileCreated), (a = this.weavy) == null || a.unsubscribe(n, "file_updated", this.handleRealtimeFileUpdated), (o = this.weavy) == null || o.unsubscribe(n, "file_trashed", this.handleRealtimeFileTrashed), (l = this.weavy) == null || l.unsubscribe(n, "file_restored", this.handleRealtimeFileRestored), (c = this.weavy) == null || c.unsubscribe(n, "file_deleted", this.handleRealtimeFileDeleted), (h = this.weavy) == null || h.unsubscribe(n, "comment_created", this.handleRealtimeCommentCreated), U4(this, Yl, void 0);
      });
    }
  }
  updated() {
    this.infiniteScroll.observe(this.filesQuery.result, this.pagerRef.value);
  }
  render() {
    const { data: t, dataUpdatedAt: i, hasNextPage: n, isPending: r } = this.filesQuery.result, a = this.dropZone.isDragActive, o = zs(t);
    return [
      O`
        <wy-files-appbar
          .order=${this.order}
          .showTrashed=${this.showTrashed}
          .view=${this.view}
          @upload-files=${this.handleBlobUpload}
          @external-blobs=${this.handleExternalBlobs}
          @create-files=${(l) => l.detail.blobs.forEach((c) => this.handleCreateFile(c, l.detail.replace))}
          @order=${(l) => {
        this.order = l.detail.order;
      }}
          @show-trashed=${(l) => {
        this.showTrashed = l.detail.showTrashed;
      }}
          @view=${(l) => {
        this.view = l.detail.view;
      }}
          @subscribe=${(l) => this.handleSubscribe(l.detail.subscribe)}
        >
        </wy-files-appbar>
      `,
      this.app ? O`
            <div
              class="wy-files ${ot({ "wy-dragging": a })}"
              data-drag-title=${T("Drop files here to upload.")}
            >
              ${o.length ? O`
                    <wy-files-list
                      .view=${this.view}
                      .files=${o}
                      .dataUpdatedAt=${i}
                      .order=${this.order}
                      @file-open=${(l) => {
        var c;
        (c = this.previewRef.value) == null || c.open(l.detail.fileId, l.detail.tab);
      }}
                      @order=${(l) => {
        this.order = l.detail.order;
      }}
                      @rename=${(l) => {
        var c;
        (c = this.renameFileMutation) == null || c.mutate({ file: l.detail.file, name: l.detail.name });
      }}
                      @subscribe=${(l) => {
        var c;
        (c = this.subscribeFileMutation) == null || c.mutate({
          file: l.detail.file,
          subscribe: l.detail.subscribe
        });
      }}
                      @trash=${(l) => {
        var c;
        (c = this.trashFileMutation) == null || c.mutate({ file: l.detail.file });
      }}
                      @restore=${(l) => {
        var c;
        (c = this.restoreFileMutation) == null || c.mutate({ file: l.detail.file });
      }}
                      @delete-forever=${(l) => {
        var c;
        (c = this.deleteForeverFileMutation) == null || c.mutate({ file: l.detail.file });
      }}
                    >
                      ${n ? O`<div slot="end" ${pe(this.pagerRef)} part="wy-pager wy-pager-bottom"></div>` : M}
                    </wy-files-list>
                  ` : O`
                    <wy-empty>
                      ${r ? O`<wy-spinner padded reveal></wy-spinner>` : O` <wy-icon-display>
                            <wy-icon name="file-upload"></wy-icon>
                            <span slot="text">${T("Add some files to get started!")}</span>
                          </wy-icon-display>`}
                    </wy-empty>
                  `}
            </div>
            ${t ? O` <wy-preview ${pe(this.previewRef)} .infiniteQueryResult=${this.filesQuery.result}></wy-preview> ` : M}
          ` : O`<wy-empty><wy-spinner padded reveal></wy-spinner></wy-empty>`
    ];
  }
  disconnectedCallback() {
    var t;
    (t = q4(this, Yl)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Ep, "xa"), Ep), p(Gb, "WyFiles"), Gb);
Yl = /* @__PURE__ */ new WeakMap();
Ur.styles = [Yi, fe, Wf, Hr, Do];
Tv([
  x()
], Ur.prototype, "view", 2);
Tv([
  x({ type: Object })
], Ur.prototype, "order", 2);
Tv([
  x({ type: Boolean })
], Ur.prototype, "showTrashed", 2);
Ur = Tv([
  F(Q_),
  be()
], Ur);
const N4 = /* @__PURE__ */ p((s) => lU(s) ? s._$litType$.h : s.strings, "Pt"), $X = _s(class extends Yr {
  constructor(s) {
    super(s), this.et = /* @__PURE__ */ new WeakMap();
  }
  render(s) {
    return [s];
  }
  update(s, [t]) {
    const i = b4(this.it) ? N4(this.it) : null, n = b4(t) ? N4(t) : null;
    if (i !== null && (n === null || i !== n)) {
      const r = g$(s).pop();
      let a = this.et.get(i);
      if (a === void 0) {
        const o = document.createDocumentFragment();
        a = WM(M, o), a.setConnected(!1), this.et.set(i, a);
      }
      O1(a, [r]), ba(a, void 0, r);
    }
    if (n !== null) {
      if (i === null || i !== n) {
        const r = this.et.get(n);
        if (r !== void 0) {
          const a = g$(r).pop();
          dU(s), ba(s, void 0, a), O1(s, [a]);
        }
      }
      this.it = t;
    } else this.it = void 0;
    return this.render(t);
  }
}), xX = de`.wy-messenger-layout{display:flex;flex:1;align-items:stretch;position:relative;container-type:inline-size;align-self:stretch;min-height:0;min-width:0}wy-conversation-list{flex:0 1 50%;min-width:0;max-width:24rem;border-right:1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c1c7ce))}.wy-messenger-conversation{display:flex;flex-direction:column;overflow-anchor:none;height:100%;width:100%;flex:0 1 100%;min-width:max(50%,16rem)}.wy-close-conversation{display:none}@container (max-width: 768px){wy-conversation-list{flex:0 1 100%;min-width:0;max-width:none;border-right:none}wy-conversation-list[conversationid]{display:none}.wy-messenger-conversation[data-conversation-id=\"\"]{display:none}.wy-close-conversation{display:contents}wy-empty{display:none}}`;
var kX = Object.defineProperty, SX = Object.getOwnPropertyDescriptor, Jr = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? SX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && kX(t, i, r), r;
}, "__decorateClass$j"), Kb, zp;
let gn = (Kb = (zp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.botFilter = void 0, this.selected = [], this.select = [], this.text = "", this.peopleQuery = new Vo(this), this.inputRef = ke(), this.infiniteScroll = new Zo(this), this.pagerRef = ke(), this.throttledSearch = R1(
      async () => {
        var t;
        this.text = ((t = this.inputRef.value) == null ? void 0 : t.value) || "";
      },
      250,
      { leading: !1, trailing: !0 }
    );
  }
  dispatchSubmit() {
    this.selected = [...this.selected, ...this.select];
    const t = new CustomEvent("submit", { detail: { members: this.selected } });
    return this.dispatchEvent(t);
  }
  isChecked(t) {
    return this.select.find((i) => i.id === t) != null;
  }
  handleSelected(t, i) {
    i ? this.select = [...this.select, t] : (this.select = this.select.filter((n) => n.id !== t.id), this.selected = this.selected.filter((n) => n.id !== t.id));
  }
  async clear() {
    this.text = "";
  }
  getSelected() {
    return this.selected.length > 0 ? O`
        ${this.selected.map((t) => O`
            <div
              class="wy-item wy-list-item wy-item-hover"
              @click=${() => this.handleSelected(t, !1)}
              @keydown=${ei}
              @keyup=${ei}
            >
              <wy-avatar
                id=${t.id}
                .src=${t.avatar_url}
                .name=${t.display_name}
                .presence=${t.presence}
                .isBot=${t.is_bot}
                size=${32}
              ></wy-avatar>
              <div class="wy-item-body"> ${t.display_name} </div>
              <wy-icon name="checkbox-marked"></wy-icon>
            </div>
          `)}
      ` : M;
  }
  getSearchResult() {
    const { data: t, hasNextPage: i, isPending: n } = this.peopleQuery.result ?? { data: [], isPending: !0 }, r = zs(t), a = !!r.length, o = [];
    return n ? o.push(O`<wy-spinner overlay></wy-spinner>`) : a || o.push(O`<div class="wy-pane-group">
        <div class="wy-table-no-result">
          ${this.text ? T("Your search did not match any people.") : T("No more users found.")}
        </div>
      </div>`), a && o.push(
      O` ${r.filter((l) => this.selected.find((c) => c.id === l.id) === void 0).map((l) => O`<div
              class="wy-item wy-list-item wy-item-hover"
              @click=${() => this.handleSelected(l, !this.isChecked(l.id))}
              @keydown=${ei}
              @keyup=${ei}
            >
              <wy-avatar
                id=${l.id}
                .src=${l.avatar_url}
                .name=${l.display_name}
                .presence=${l.presence}
                .isBot=${l.is_bot}
                size=${32}
              ></wy-avatar>
              <div class="wy-item-body"> ${l.display_name} </div>
              <wy-icon name="${this.isChecked(l.id) ? "checkbox-marked" : "checkbox-blank"}"></wy-icon>
            </div>`) ?? M}`
    ), i && o.push(O`<div ${pe(this.pagerRef)} part="wy-pager wy-pager-bottom"></div>`), o;
  }
  render() {
    return O`<div class="wy-pane wy-scroll-y">
      <div class="wy-pane-body">
        <div class="wy-pane-group">
          <div class="wy-input-group">
            <input
              class="wy-input wy-input-group-input wy-input-filled"
              name="search"
              .value=${this.text || ""}
              ${pe(this.inputRef)}
              @input=${() => this.throttledSearch()}
              @keydown=${g5}
              @keyup=${jn}
              placeholder=${T("Search...")}
            />
            <wy-button type="reset" @click=${this.clear} kind="icon" class="wy-input-group-button-icon">
              <wy-icon name="close-circle"></wy-icon>
            </wy-button>
            <wy-button kind="icon" class="wy-input-group-button-icon">
              <wy-icon name="magnify"></wy-icon>
            </wy-button>
          </div>
        </div>
        <div>
          <wy-buttons tabs>
            <wy-button
              ?active=${this.botFilter === void 0}
              @click=${() => this.botFilter = void 0}
              kind="tab"
              small
              >${T("All")}</wy-button
            >
            <wy-button ?active=${this.botFilter === !1} @click=${() => this.botFilter = !1} kind="tab" small
              >${T("People")}</wy-button
            >
            <wy-button ?active=${this.botFilter === !0} @click=${() => this.botFilter = !0} kind="tab" small
              >${T("Bots")}</wy-button
            >
          </wy-buttons>
        </div>
        <div class="wy-pane-body">
          ${this.getSelected()} ${this.getSearchResult()}
        </div>
      </div>
      <div class="wy-footerbar wy-footerbar-sticky">
        <div class="wy-pane-group">
          <wy-buttons reverse>
            <wy-button
              color="primary"
              @click=${this.dispatchSubmit}
              ?disabled=${this.selected.length === 0 && this.select.length === 0 ? !0 : void 0}
              >${this.buttonTitle ?? T("Create")}</wy-button
            >
          </wy-buttons>
        </div>
      </div>
    </div>`;
  }
  async willUpdate(t) {
    t.has("weavy") && this.weavy && this.peopleQuery.trackInfiniteQuery(
      rE(
        this.weavy,
        () => this.text,
        this.appId,
        () => this.botFilter
      )
    );
  }
  async updated(t) {
    var i, n, r;
    this.infiniteScroll.observe(this.peopleQuery.result, this.pagerRef.value), (t.has("text") || t.has("botFilter")) && (this.select.length > 0 && (this.selected = [...this.selected, ...this.select], this.select = []), await ((n = (i = this.peopleQuery.result) == null ? void 0 : i.refetch) == null ? void 0 : n.call(i)), (r = this.inputRef.value) == null || r.focus());
  }
}, u(zp, "$a"), zp), p(Kb, "WyUsersSearch"), Kb);
gn.styles = [
  fe,
  Do,
  de`
      :host {
        display: contents;
      }
    `
];
Jr([
  wt({ context: Pt, subscribe: !0 }),
  B()
], gn.prototype, "weavy", 2);
Jr([
  x({ attribute: !1 })
], gn.prototype, "appId", 2);
Jr([
  x({ attribute: !1 })
], gn.prototype, "buttonTitle", 2);
Jr([
  B()
], gn.prototype, "botFilter", 2);
Jr([
  B()
], gn.prototype, "selected", 2);
Jr([
  B()
], gn.prototype, "select", 2);
Jr([
  B()
], gn.prototype, "text", 2);
gn = Jr([
  F("wy-users-search"),
  be()
], gn);
var PX = Object.defineProperty, CX = Object.getOwnPropertyDescriptor, oS = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? CX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && PX(t, i, r), r;
}, "__decorateClass$i"), Jb, _p;
let Qf = (Jb = (_p = class extends tt(G) {
  constructor() {
    super(...arguments), this.uploadBlobMutation = new cn(this), this.fileInputRef = ke(), this.openFileInput = () => {
      var t;
      (t = this.fileInputRef.value) == null || t.click();
    };
  }
  async handleBlobChange(t, i) {
    if (t && this.weavy) {
      const n = { file: t[0] };
      this.uploadBlobMutation.trackMutation(Az(this.weavy));
      const r = await this.uploadBlobMutation.mutate(n);
      i && (i.value = "");
      const a = new CustomEvent("blob-uploaded", { detail: { blob: r } });
      this.dispatchEvent(a);
    }
  }
  render() {
    return O` <slot
        name="placeholder"
        @click=${this.openFileInput}
        @keydown=${ei}
        @keyup=${_i}
      ></slot>
      <input
        accept=${Me(this.accept)}
        type="file"
        ${pe(this.fileInputRef)}
        @click=${(t) => t.stopPropagation()}
        @change=${(t) => this.handleBlobChange(t.target.files, t.target)}
        hidden
      />
      <slot name="label">
        ${this.label ? O`<wy-button @click=${this.openFileInput}>${this.label}</wy-button>` : M}
      </slot>`;
  }
}, u(_p, "ka"), _p), p(Jb, "WyBlobUpload"), Jb);
Qf.styles = [
  de`
      :host {
        text-align: center;
      }
      slot[name="placeholder"] {
        cursor: pointer;
      }
    `
];
oS([
  x({ attribute: !1 })
], Qf.prototype, "label", 2);
oS([
  x({ attribute: !1 })
], Qf.prototype, "accept", 2);
Qf = oS([
  F("wy-blob-upload"),
  be()
], Qf);
var QX = Object.defineProperty, TX = Object.getOwnPropertyDescriptor, T_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$7"), Xo = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? TX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && QX(t, i, r), r;
}, "__decorateClass$h"), M_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || T_("Cannot " + i), "__accessCheck$7"), B4 = /* @__PURE__ */ p((s, t, i) => (M_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$7"), MX = /* @__PURE__ */ p((s, t, i) => t.has(s) ? T_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$7"), j4 = /* @__PURE__ */ p((s, t, i, n) => (M_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$7"), Gl, e0, Lp;
let Hn = (e0 = (Lp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.showDetails = !1, this.showAddMembers = !1, this.conversationTitle = "", this.conversationTitleInput = "", this.releaseFocusEvent = () => new CustomEvent("release-focus", { bubbles: !0, composed: !0 }), this.membersQuery = new Ei(this), this.handleRealtimeAppUpdated = (t) => {
      !this.conversationId || t.app.id !== this.conversationId || (this.conversationTitle = this.conversationTitleInput = t.app.display_name);
    }, this.handlePresenceChange = (t) => {
      if (!this.weavy)
        return;
      Array.isArray(t) || (t = [parseInt(t)]);
      const i = /* @__PURE__ */ p((n) => {
        const r = n.members.data ?? [];
        return r.forEach((a) => {
          a.presence = t.indexOf(a.id) != -1 ? "active" : "away";
        }), n.members.data = r, n;
      }, "updateMembersInApps");
      this.weavy.queryClient.setQueryData(["apps", this.conversationId], i);
    }, MX(this, Gl);
  }
  isBotChat(t) {
    var i;
    return ((i = t ?? this.conversation) == null ? void 0 : i.type) === Te.BotChat;
  }
  isChatRoom(t) {
    var i;
    return ((i = t ?? this.conversation) == null ? void 0 : i.type) === Te.ChatRoom;
  }
  isPrivateChat(t) {
    var i;
    return ((i = t ?? this.conversation) == null ? void 0 : i.type) === Te.PrivateChat;
  }
  async addMembers(t) {
    var i;
    this.showAddMembers = !1, this.showDetails = !0, !(!this.weavy || !this.conversationId) && (await ((i = this.addMembersMutation) == null ? void 0 : i.mutate({ appId: this.conversationId, members: t.map((n) => n.id) })), await this.membersQuery.result.refetch(), await this.weavy.queryClient.invalidateQueries({ queryKey: ["apps"] }));
  }
  async handleSaveConversationName() {
    var t;
    if (!this.weavy || !this.conversationId)
      return;
    const i = this.conversationTitleInput.trim() === "" ? null : this.conversationTitleInput.trim();
    await ((t = this.updateConversationMutation) == null ? void 0 : t.mutate({ appId: this.conversationId, name: i }));
  }
  async handleAvatarUploaded(t) {
    var i;
    !this.weavy || !this.conversationId || await ((i = this.updateConversationMutation) == null ? void 0 : i.mutate({
      appId: this.conversationId,
      blobId: t.id,
      thumbnailUrl: t.thumbnail_url
    }));
  }
  async clearAvatar() {
    var t;
    !this.weavy || !this.conversationId || await ((t = this.updateConversationMutation) == null ? void 0 : t.mutate({ appId: this.conversationId, blobId: null, thumbnailUrl: null }));
  }
  async updateMember(t, i) {
    var n;
    !this.weavy || !this.conversationId || (await ((n = this.updateMemberMutation) == null ? void 0 : n.mutate({
      appId: this.conversationId,
      userId: t,
      access: i
    })), await this.membersQuery.result.refetch());
  }
  async leaveConversation(t) {
    var i;
    !this.weavy || !this.conversationId || !this.user || (t && await ((i = this.leaveConversationMutation) == null ? void 0 : i.mutate({
      appId: this.conversationId,
      members: [t]
    })), t ? await this.membersQuery.result.refetch() : (this.showDetails = !1, this.conversation = void 0, this.conversationId = void 0), await this.weavy.queryClient.invalidateQueries({ queryKey: ["apps"] }));
  }
  willUpdate(t) {
    var i;
    if (super.willUpdate(t), t.has("weavy") && this.weavy && (this.leaveConversationMutation = p5(this.weavy), this.addMembersMutation = eE(this.weavy), this.updateConversationMutation = f5(this.weavy), this.updateMemberMutation = JA(this.weavy)), t.has("conversationId") && (this.showDetails = !1), (t.has("weavy") || t.has("conversationId")) && this.weavy)
      if ((i = B4(this, Gl)) == null || i.call(this), this.conversationId) {
        this.membersQuery.trackQuery(
          y5(this.weavy, this.conversationId, {
            initialData: /* @__PURE__ */ p(() => {
              var r, a;
              if (this.conversationId)
                return (a = (r = this.weavy) == null ? void 0 : r.queryClient.getQueryData(["apps", this.conversationId])) == null ? void 0 : a.members;
            }, "initialData")
          })
        );
        const n = `a${this.conversationId}`;
        this.weavy.subscribe(n, "app_updated", this.handleRealtimeAppUpdated), this.weavy.subscribe(null, "online", this.handlePresenceChange), j4(this, Gl, () => {
          var r, a;
          (r = this.weavy) == null || r.unsubscribe(n, "app_updated", this.handleRealtimeAppUpdated), (a = this.weavy) == null || a.unsubscribe(null, "online", this.handlePresenceChange), j4(this, Gl, void 0);
        });
      } else
        this.membersQuery.untrackQuery();
    t.has("conversation") && this.conversation && (this.conversationTitleInput = this.conversationTitle = this.conversation.display_name);
  }
  render() {
    var t, i, n, r;
    const { data: a } = this.membersQuery.result ?? {}, o = ((a == null ? void 0 : a.data) || []).filter((c) => c.access === Fs.Admin).length, l = this.user && this.isPrivateChat() ? ((n = (((i = (t = this.conversation) == null ? void 0 : t.members) == null ? void 0 : i.data) || []).filter((c) => {
      var h;
      return c.id !== ((h = this.user) == null ? void 0 : h.id);
    })) == null ? void 0 : n[0]) ?? this.user : null;
    return O`
      <header class="wy-appbars">
        <nav class="wy-appbar">
          <slot class="wy-appbar-buttons wy-appbar-buttons-first" name="action"></slot>
          ${this.conversation && this.user ? O`
                <div class="wy-appbar-section">
                  ${this.conversation.type === Te.PrivateChat ? O`<wy-presence
                        placement="text"
                        .status=${l == null ? void 0 : l.presence}
                        id=${Me(l == null ? void 0 : l.id)}
                      ></wy-presence>` : M}
                  <span class="wy-appbar-text">${this.conversationTitle}</span>
                </div>
              ` : O`<span></span>`}
          ${this.isChatRoom() ? O`<wy-button kind="icon" @click=${() => this.showDetails = !0} title="${T("Details")}">
                <wy-icon name="information"></wy-icon>
              </wy-button>` : M}
        </nav>
      </header>

      <!-- details modal -->
      ${this.weavy ? O`
            <wy-overlay
              .show=${this.showDetails}
              @close=${() => {
      this.showDetails = !1;
    }}
              @release-focus=${() => this.dispatchEvent(this.releaseFocusEvent())}
            >
              <header class="wy-appbars">
                <nav class="wy-appbar">
                  <wy-button
                    kind="icon"
                    @click=${() => {
      this.showDetails = !1;
    }}
                  >
                    <wy-icon name="close"></wy-icon>
                  </wy-button>
                  <div class="wy-appbar-text">${this.conversationTitle}</div>
                </nav>
              </header>
              <div class="wy-scroll-y">
                ${this.showDetails && this.conversation && this.user ? O`
                      <wy-avatar-header>
                        ${this.isChatRoom() ? O`
                              <wy-blob-upload
                                @blob-uploaded=${(c) => this.handleAvatarUploaded(c.detail.blob)}
                                .accept=${"image/*"}
                                .label=${T("Select picture")}
                              >
                                <div slot="placeholder">
                                  ${this.conversation.avatar_url ? O`<wy-avatar .size=${96} src=${this.conversation.avatar_url}></wy-avatar>` : O`<wy-avatar-group
                                        .members=${a == null ? void 0 : a.data}
                                        title=${this.conversation.display_name}
                                        .size=${96}
                                      ></wy-avatar-group>`}
                                </div>
                                ${this.conversation.avatar_url ? O`<div slot="label"
                                      ><wy-button @click=${() => this.clearAvatar()}
                                        >${T("Remove picture")}</wy-button
                                      ></div
                                    >` : M}
                              </wy-blob-upload>
                            ` : O`
                              <wy-avatar
                                src=${Me(l == null ? void 0 : l.avatar_url)}
                                name=${Me(l == null ? void 0 : l.display_name)}
                                presence=${(l == null ? void 0 : l.presence) || "away"}
                                ?isBot=${l == null ? void 0 : l.is_bot}
                                id=${Me(l == null ? void 0 : l.id)}
                                size=${96}
                              ></wy-avatar>
                            `}
                      </wy-avatar-header>
                      ${this.isChatRoom() ? O`
                            <div class="wy-pane-group">
                              <label class="wy-label" for="roomName">${T("Room name")}</label>

                              <input
                                id="roomName"
                                class="wy-input"
                                .value=${this.conversationTitleInput}
                                @input=${(c) => {
      this.conversationTitleInput = c.target.value;
    }}
                                @keyup=${vE}
                                @blur=${() => this.handleSaveConversationName()}
                              />

                              <div class="wy-description">
                                ${T("Changing the name of a group chat changes it for everyone.")}
                              </div>
                              <br />
                              <label class="wy-label">${T("Members")}</label>
                              ${a ? O`
                                    <div class="wy-list">
                                      ${((r = a.data) == null ? void 0 : r.map(
      (c) => {
        var h, d;
        return O`
                                          <div class="wy-item wy-list-item">
                                            <wy-avatar
                                              .src=${c.avatar_url}
                                              .name=${c.display_name}
                                              .isBot=${c.is_bot}
                                              size=${32}
                                            ></wy-avatar>
                                            <div class="wy-item-body">
                                              ${c.display_name}
                                              ${c.access === Fs.Admin ? O` <wy-icon
                                                    size="20"
                                                    inline
                                                    name="shield-star"
                                                    title=${T("Admin")}
                                                  ></wy-icon>` : M}
                                            </div>
                                            ${this.user && this.user.id === c.id && !ko(Ar.Admin, (h = this.conversation) == null ? void 0 : h.permissions) ? O` <wy-button
                                                  @click=${() => this.leaveConversation(c.id)}
                                                  title=${T("Leave conversation")}
                                                  kind="icon"
                                                >
                                                  <wy-icon name="close"></wy-icon>
                                                </wy-button>` : ko(Ar.Admin, (d = this.conversation) == null ? void 0 : d.permissions) ? O`<wy-dropdown>
                                                  <wy-dropdown-item @click=${() => this.leaveConversation(c.id)}>
                                                    <wy-icon name="account-minus"></wy-icon>
                                                    ${this.user && this.user.id === c.id ? T("Leave conversation") : T("Remove member")}
                                                  </wy-dropdown-item>
                                                  ${o > 1 && c.access === Fs.Admin ? O`<wy-dropdown-item
                                                        @click=${() => this.updateMember(c.id, Fs.Write)}
                                                      >
                                                        <wy-icon name="shield-star-outline"></wy-icon>
                                                        ${T("Remove as admin")}
                                                      </wy-dropdown-item>` : c.access !== Fs.Admin ? O`<wy-dropdown-item
                                                        @click=${() => this.updateMember(c.id, Fs.Admin)}
                                                      >
                                                        <wy-icon name="shield-star"></wy-icon>
                                                        ${T("Make admin")}
                                                      </wy-dropdown-item>` : M}
                                                </wy-dropdown>` : M}
                                          </div>
                                        `;
      }
    )) ?? M}
                                    </div>
                                  ` : M}
                              <wy-button
                                kind="filled"
                                color="primary"
                                @click=${() => {
      this.showDetails = !1, this.showAddMembers = !0;
    }}
                                title=${T("Add members")}
                              >
                                ${T("Add members")}
                              </wy-button>
                            </div>
                          ` : M}
                    ` : M}
              </div>
            </wy-overlay>
          ` : M}

      <!-- add members modal -->
      ${this.weavy ? O`
            <wy-overlay
              .show=${this.showAddMembers}
              @close=${() => {
      this.showAddMembers = !1;
    }}
              @release-focus=${() => this.dispatchEvent(this.releaseFocusEvent())}
            >
              <header class="wy-appbars">
                <nav class="wy-appbar">
                  <wy-button
                    kind="icon"
                    @click=${() => {
      this.showAddMembers = !1;
    }}
                  >
                    <wy-icon name="close"></wy-icon>
                  </wy-button>
                  <div class="wy-appbar-text">${T("Add members")}</div>
                </nav>
              </header>
              ${this.showAddMembers ? O`
                    <wy-users-search
                      .buttonTitle=${T("Add members")}
                      .appId=${this.conversationId}
                      @submit=${(c) => this.addMembers(c.detail.members)}
                    ></wy-users-search>
                  ` : M}
            </wy-overlay>
          ` : M}
    `;
  }
  disconnectedCallback() {
    var t;
    (t = B4(this, Gl)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Lp, "Ca"), Lp), p(e0, "WyConversationAppbar"), e0);
Gl = /* @__PURE__ */ new WeakMap();
Hn.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
Xo([
  x({ attribute: !1 })
], Hn.prototype, "conversationId", 2);
Xo([
  x({ attribute: !1 })
], Hn.prototype, "conversation", 2);
Xo([
  x({ type: Boolean })
], Hn.prototype, "showDetails", 2);
Xo([
  x({ type: Boolean })
], Hn.prototype, "showAddMembers", 2);
Xo([
  x({ type: String })
], Hn.prototype, "conversationTitle", 2);
Xo([
  B()
], Hn.prototype, "conversationTitleInput", 2);
Hn = Xo([
  F("wy-conversation-appbar"),
  be()
], Hn);
var RX = Object.defineProperty, AX = Object.getOwnPropertyDescriptor, Mv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? AX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && RX(t, i, r), r;
}, "__decorateClass$g"), t0, Ip;
let Tf = (t0 = (Ip = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.typing = new Hz(this);
  }
  willUpdate(t) {
    t.has("appId") && (this.typing.appId = this.appId), t.has("userId") && (this.typing.userId = this.userId);
  }
  render() {
    var t;
    const { names: i, ellipsis: n } = this.typing;
    let r;
    if (i.length === 1) {
      const a = i[0];
      r = T(ie`${a} is typing${n}`, { desc: "A is typing..." });
    } else if (i.length > 1) {
      const a = new Intl.ListFormat((t = this.weavy) == null ? void 0 : t.locale, { style: "long", type: "conjunction" }).format(
        i
      );
      r = T(ie`${a} are typing${n}`, {
        desc: "A, B and C are typing..."
      });
    }
    return r ? O`<span>${r}</span>` : O`<slot></slot>`;
  }
}, u(Ip, "_a"), Ip), p(t0, "WyTyping"), t0);
Mv([
  wt({ context: Pt, subscribe: !0 }),
  B()
], Tf.prototype, "weavy", 2);
Mv([
  x({ attribute: !0, type: Number })
], Tf.prototype, "appId", 2);
Mv([
  x({ attribute: !0, type: Number })
], Tf.prototype, "userId", 2);
Tf = Mv([
  F("wy-typing"),
  be()
], Tf);
var EX = Object.defineProperty, zX = Object.getOwnPropertyDescriptor, R_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$6"), xi = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? zX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && EX(t, i, r), r;
}, "__decorateClass$f"), A_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || R_("Cannot " + i), "__accessCheck$6"), X4 = /* @__PURE__ */ p((s, t, i) => (A_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$6"), _X = /* @__PURE__ */ p((s, t, i) => t.has(s) ? R_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$6"), F4 = /* @__PURE__ */ p((s, t, i, n) => (A_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$6"), Kl, i0, Wp;
let jt = (i0 = (Wp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.unread = !1, this.avatarUrl = "", this.hideAvatar = !1, this.displayName = "", this.type = Te.PrivateChat, this.selected = !1, this.starred = !1, this.pinned = !1, this.handleMessageCreated = (t) => {
      !this.user || !this.weavy || (Fe(
        this.weavy.queryClient,
        ["apps", t.message.app.id],
        void 0,
        (i) => {
          var n;
          i.last_message = t.message, i.is_unread = t.message.created_by.id !== ((n = this.user) == null ? void 0 : n.id);
        }
      ), Se(
        this.weavy.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        t.message.app.id,
        (i) => {
          var n;
          i.last_message = t.message, i.is_unread = t.message.created_by.id !== ((n = this.user) == null ? void 0 : n.id);
        }
      ));
    }, this.handleConversationUpdated = () => {
      var t;
      (t = this.weavy) == null || t.queryClient.invalidateQueries({ queryKey: ["apps"], exact: !1 });
    }, this.handleConversationMarked = (t) => {
      var i;
      this.user && t.actor.id === this.user.id && ((i = this.weavy) == null || i.queryClient.invalidateQueries({ queryKey: ["apps"], exact: !1 }));
    }, _X(this, Kl);
  }
  dispatchSelected(t, i) {
    t.preventDefault();
    const n = new CustomEvent("selected", { detail: { id: i } });
    return this.dispatchEvent(n);
  }
  handleStar(t, i) {
    const n = new CustomEvent("star", {
      detail: { id: this.conversationId, star: i }
    });
    return this.dispatchEvent(n);
  }
  handlePin(t, i) {
    const n = new CustomEvent("pin", {
      detail: { id: this.conversationId, pin: i }
    });
    return this.dispatchEvent(n);
  }
  dispatchMarked(t) {
    var i;
    const n = new CustomEvent("mark", {
      detail: { id: this.conversationId, messageId: t ? (i = this.lastMessage) == null ? void 0 : i.id : null }
    });
    return this.dispatchEvent(n);
  }
  handleLeaveConversation() {
    const t = new CustomEvent("leave", {
      detail: { id: this.conversationId }
    });
    return this.dispatchEvent(t);
  }
  handleTrashConversation() {
    const t = new CustomEvent("trash", {
      detail: { id: this.conversationId }
    });
    return this.dispatchEvent(t);
  }
  willUpdate(t) {
    var i;
    if (t.has("weavy") && this.weavy) {
      (i = X4(this, Kl)) == null || i.call(this);
      const n = `a${this.conversationId}`;
      this.weavy.subscribe(n, "app_updated", this.handleConversationUpdated), this.weavy.subscribe(n, "member_added", this.handleConversationUpdated), this.weavy.subscribe(n, "message_created", this.handleMessageCreated), this.weavy.subscribe(n, "app_marked", this.handleConversationMarked), F4(this, Kl, () => {
        var r, a, o, l;
        (r = this.weavy) == null || r.unsubscribe(n, "app_updated", this.handleConversationUpdated), (a = this.weavy) == null || a.unsubscribe(n, "member_added", this.handleConversationUpdated), (o = this.weavy) == null || o.unsubscribe(n, "message_created", this.handleMessageCreated), (l = this.weavy) == null || l.unsubscribe(n, "app_marked", this.handleConversationMarked), F4(this, Kl, void 0);
      });
    }
  }
  render() {
    var t, i, n, r, a, o, l, c, h, d, f, y, w, g, b, k, $;
    const C = (t = this.lastMessage) != null && t.created_at ? new Intl.DateTimeFormat((i = this.weavy) == null ? void 0 : i.locale, { dateStyle: "full", timeStyle: "short" }).format(
      new Date(this.lastMessage.created_at)
    ) : "", E = (n = this.lastMessage) != null && n.created_at ? Uf((r = this.weavy) == null ? void 0 : r.locale, new Date(this.lastMessage.created_at)) : "", A = this.type === Te.PrivateChat && this.user ? ((o = (((a = this.members) == null ? void 0 : a.data) || []).filter((R) => {
      var L;
      return R.id !== ((L = this.user) == null ? void 0 : L.id);
    })) == null ? void 0 : o[0]) ?? this.user : null;
    return O`
      <div
        class=${ot({
      "wy-item wy-list-item-lg wy-item-hover wy-conversation": !0,
      "wy-unread": this.unread,
      "wy-active": this.selected
    })}
        tabindex="0"
        @click=${(R) => this.dispatchSelected(R, this.conversationId)}
        @keydown=${ei}
        @keyup=${_i}
      >
        ${this.type !== Te.BotChat ? this.avatarUrl ? O`<wy-avatar .size=${48} src=${this.avatarUrl}></wy-avatar>` : this.type == Te.ChatRoom ? O` <wy-avatar-group
                .members=${(l = this.members) == null ? void 0 : l.data}
                title=${this.displayName}
                .size=${48}
              ></wy-avatar-group>` : O`
                <wy-avatar
                  src=${Me(A == null ? void 0 : A.avatar_url)}
                  name=${Me(A == null ? void 0 : A.display_name)}
                  presence=${(A == null ? void 0 : A.presence) || "away"}
                  ?isBot=${A == null ? void 0 : A.is_bot}
                  id=${Me(A == null ? void 0 : A.id)}
                  size=${48}
                ></wy-avatar>
              ` : M}

        <div class="wy-item-rows">
          <div class="wy-item-row">
            <div class="wy-item-title"
              >${this.displayName || ((c = this.lastMessage) == null ? void 0 : c.plain) || T("Untitled conversation")}</div
            >
            ${this.lastMessage ? O`<time class="wy-meta" datetime=${this.lastMessage.created_at.toString()} title=${C}
                  >${E}</time
                >` : M}
          </div>
          <div class="wy-item-row">
            <div class="wy-item-text">
              ${this.user ? O`
                    <wy-typing appId=${this.conversationId} userId=${this.user.id}>
                      ${this.lastMessage ? O`
                            ${this.user.id === this.lastMessage.created_by.id ? O`${T("You")}: ` : M}
                            ${this.members.count > 2 && this.user.id !== ((h = this.lastMessage) == null ? void 0 : h.created_by.id) ? O`${(d = this.lastMessage) == null ? void 0 : d.created_by.display_name}: ` : M}
                          ` : M}
                      ${(f = this.lastMessage) != null && f.text ? O`<span>${this.lastMessage.plain}</span>` : M}
                      ${!((y = this.lastMessage) != null && y.text) && (((g = (w = this.lastMessage) == null ? void 0 : w.attachments) == null ? void 0 : g.count) || 0) > 0 ? O`<wy-icon kind="text-icon" name="attachment"></wy-icon>` : M}
                      ${!((b = this.lastMessage) != null && b.text) && ($ = (k = this.lastMessage) == null ? void 0 : k.meeting) != null && $.id ? O`<wy-icon kind="text-icon" name="video"></wy-icon>` : M}
                      ${this.lastMessage ? M : O`&nbsp;`}
                    </wy-typing>
                  ` : M}
            </div>

            <div class="wy-item-actions wy-item-actions-bottom">
              ${this.starred ? O`<wy-button
                    kind="icon"
                    @click=${(R) => {
      R.stopPropagation(), this.handleStar(R, !1);
    }}
                  >
                    <wy-icon name="star" size=${24} color="yellow"></wy-icon>
                  </wy-button>` : M}
              ${this.pinned ? O`<wy-button
                    kind="icon"
                    @click=${(R) => {
      R.stopPropagation(), this.handlePin(R, !1);
    }}
                  >
                    <wy-icon name="pin" size=${24} color=""></wy-icon>
                  </wy-button>` : M}

              <wy-dropdown directionX="left">
                <wy-dropdown-item @click=${() => this.dispatchMarked(this.unread)}>
                  <wy-icon name=${this.unread ? "read" : "unread"}></wy-icon>
                  ${this.unread ? T("Mark as read") : T("Mark as unread")}
                </wy-dropdown-item>
                <wy-dropdown-item @click=${(R) => this.handlePin(R, !this.pinned)}>
                  <wy-icon name=${this.pinned ? "unpin" : "pin"}></wy-icon>
                  ${this.pinned ? T("Unpin") : T("Pin")}
                </wy-dropdown-item>
                <wy-dropdown-item @click=${(R) => this.handleStar(R, !this.starred)}>
                  <wy-icon name=${this.starred ? "unstar" : "star"}></wy-icon>
                  ${this.starred ? T("Unstar") : T("Star")}
                </wy-dropdown-item>
                ${this.type === Te.ChatRoom ? O`<wy-dropdown-item @click=${() => this.handleLeaveConversation()}>
                      <wy-icon name="account-minus"></wy-icon>
                      ${T("Leave conversation")}
                    </wy-dropdown-item>` : M}
                ${this.type === Te.BotChat ? O`
                      <wy-dropdown-item @click=${() => this.handleTrashConversation()}>
                        <wy-icon name="trashcan"></wy-icon>
                        ${T("Trash")}
                      </wy-dropdown-item>
                    ` : M}
              </wy-dropdown>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  connectedCallback() {
    super.connectedCallback(), this.weavy && this.requestUpdate("weavy");
  }
  disconnectedCallback() {
    var t;
    (t = X4(this, Kl)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Wp, "Pa"), Wp), p(i0, "WyConversationListItem"), i0);
Kl = /* @__PURE__ */ new WeakMap();
jt.styles = fe;
xi([
  wt({ context: Pt, subscribe: !0 }),
  B()
], jt.prototype, "weavy", 2);
xi([
  x({ attribute: !0, type: Number })
], jt.prototype, "conversationId", 2);
xi([
  x({ attribute: !0, type: Boolean })
], jt.prototype, "unread", 2);
xi([
  x({ attribute: !0 })
], jt.prototype, "avatarUrl", 2);
xi([
  x({ attribute: !0, type: Boolean })
], jt.prototype, "hideAvatar", 2);
xi([
  x({ attribute: !0 })
], jt.prototype, "displayName", 2);
xi([
  x({ attribute: !0, type: String, reflect: !0 })
], jt.prototype, "type", 2);
xi([
  x({ attribute: !0, type: Boolean, reflect: !0 })
], jt.prototype, "selected", 2);
xi([
  x({ attribute: !0, type: Boolean, reflect: !0 })
], jt.prototype, "starred", 2);
xi([
  x({ attribute: !0, type: Boolean, reflect: !0 })
], jt.prototype, "pinned", 2);
xi([
  x({ attribute: !1 })
], jt.prototype, "members", 2);
xi([
  x({ attribute: !1 })
], jt.prototype, "lastMessage", 2);
xi([
  wt({ context: dv, subscribe: !0 }),
  B()
], jt.prototype, "user", 2);
jt = xi([
  F("wy-conversation-list-item"),
  be()
], jt);
var LX = Object.defineProperty, IX = Object.getOwnPropertyDescriptor, lS = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? IX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && LX(t, i, r), r;
}, "__decorateClass$e"), n0, Vp;
let Mf = (n0 = (Vp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.show = !1;
  }
  open() {
    this.show = !0;
  }
  close() {
    this.show = !1;
  }
  async submit(t = []) {
    var i;
    const n = this.bot ? { members: [this.bot], type: vi.BotChat } : { members: t == null ? void 0 : t.map((o) => o.id), type: t.length === 1 ? vi.PrivateChat : vi.ChatRoom }, r = await ((i = this.addConversationMutation) == null ? void 0 : i.mutate(n));
    this.close();
    const a = new CustomEvent("selected", { detail: { id: r == null ? void 0 : r.id } });
    return this.dispatchEvent(a);
  }
  updated(t) {
    t.has("weavy") && this.weavy && (this.addConversationMutation = vR(this.weavy));
  }
  render() {
    return O`
      <wy-button kind="icon" @click=${() => this.bot ? this.submit() : this.open()}>
        <wy-icon name="plus"></wy-icon>
      </wy-button>

      ${!this.bot && this.weavy ? O`<wy-overlay
            .show=${this.show}
            @close=${() => {
      this.show = !1;
    }}
            @release-focus=${() => this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }))}
          >
            <header class="wy-appbars">
              <nav class="wy-appbar">
                <wy-button kind="icon" @click=${() => this.close()}>
                  <wy-icon name="close"></wy-icon>
                </wy-button>
                <div class="wy-appbar-text">${T("New conversation")}</div>
              </nav>
            </header>
            ${this.show ? O` <wy-users-search @submit=${(t) => this.submit(t.detail.members)}></wy-users-search> ` : M}
          </wy-overlay>` : M}
    `;
  }
}, u(Vp, "Ma"), Vp), p(n0, "WyConversationNew"), n0);
Mf.styles = [fe];
lS([
  x()
], Mf.prototype, "bot", 2);
lS([
  B()
], Mf.prototype, "show", 2);
Mf = lS([
  F("wy-conversation-new"),
  be()
], Mf);
var WX = Object.defineProperty, VX = Object.getOwnPropertyDescriptor, E_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$5"), Fo = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? VX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && WX(t, i, r), r;
}, "__decorateClass$d"), z_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || E_("Cannot " + i), "__accessCheck$5"), H4 = /* @__PURE__ */ p((s, t, i) => (z_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$5"), ZX = /* @__PURE__ */ p((s, t, i) => t.has(s) ? E_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$5"), Y4 = /* @__PURE__ */ p((s, t, i, n) => (z_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$5"), Jl, s0, Zp;
let Yn = (s0 = (Zp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.conversationTypes = [Te.ChatRoom, Te.PrivateChat], this.searchText = "", this.inputRef = ke(), this.conversationsQuery = new Vo(this), this.infiniteScroll = new Zo(this), this.pagerRef = ke(), this.handleRefresh = () => {
      this.conversationsQuery.result.refetch();
    }, this.handlePresenceChange = (t) => {
      if (!this.weavy)
        return;
      Array.isArray(t) || (t = [parseInt(t)]);
      const i = /* @__PURE__ */ p((n) => {
        const r = n.members.data ?? [];
        r.forEach((a) => {
          a.presence = t.indexOf(a.id) != -1 ? "active" : "away";
        }), n.members.data = r;
      }, "updateMembersInApps");
      Se(
        this.weavy.queryClient,
        { queryKey: ["apps", "list"], exact: !1 },
        void 0,
        i
      );
    }, this.throttledSearch = R1(
      async () => {
        var t;
        this.searchText = ((t = this.inputRef.value) == null ? void 0 : t.value) || "";
      },
      250,
      { leading: !1, trailing: !0 }
    ), ZX(this, Jl);
  }
  dispatchSelected(t) {
    this.conversationId = t;
    const i = new CustomEvent("conversation-selected", { detail: { id: t } });
    return this.dispatchEvent(i);
  }
  async handleMark(t, i) {
    var n, r;
    await ((r = this.markConversationMutation) == null ? void 0 : r.mutate({ appId: t, messageId: i, userId: (n = this.user) == null ? void 0 : n.id }));
  }
  async handleStar(t, i) {
    var n;
    await ((n = this.starConversationMutation) == null ? void 0 : n.mutate({ appId: t, star: i }));
  }
  async handlePin(t, i) {
    var n;
    await ((n = this.pinConversationMutation) == null ? void 0 : n.mutate({ appId: t, pin: i }));
  }
  async handleLeaveConversation(t) {
    var i;
    const n = await this.whenUser();
    await ((i = this.leaveConversationMutation) == null ? void 0 : i.mutate({ appId: t, members: [n.id] })), this.dispatchSelected(void 0), this.conversationsQuery.result.refetch();
  }
  async handleTrashConversation(t) {
    var i;
    await ((i = this.trashConversationMutation) == null ? void 0 : i.mutate({ appId: t })), this.dispatchSelected(void 0), this.conversationsQuery.result.refetch();
  }
  async clear() {
    this.searchText = "";
  }
  async willUpdate(t) {
    var i;
    super.willUpdate(t), (t.has("weavy") || t.has("conversationTypes")) && this.weavy && (this.conversationsQuery.trackInfiniteQuery(
      OR(this.weavy, {}, this.conversationTypes, this.bot, () => this.searchText, "pinned_at desc,rev desc")
    ), this.markConversationMutation = u5(this.weavy), this.starConversationMutation = GA(this.weavy), this.pinConversationMutation = KA(this.weavy), this.leaveConversationMutation = p5(this.weavy), this.trashConversationMutation = tE(this.weavy), (i = H4(this, Jl)) == null || i.call(this), this.weavy.subscribe(null, "app_created", this.handleRefresh), this.weavy.subscribe(null, "message_created", this.handleRefresh), this.weavy.subscribe(null, "member_added", this.handleRefresh), this.weavy.subscribe(null, "online", this.handlePresenceChange), Y4(this, Jl, () => {
      var n, r, a, o;
      (n = this.weavy) == null || n.unsubscribe(null, "app_created", this.handleRefresh), (r = this.weavy) == null || r.unsubscribe(null, "message_created", this.handleRefresh), (a = this.weavy) == null || a.unsubscribe(null, "member_added", this.handleRefresh), (o = this.weavy) == null || o.unsubscribe(null, "online", this.handlePresenceChange), Y4(this, Jl, void 0);
    })), t.has("user") && this.user && (this.bot || (this.avatarUser ?? (this.avatarUser = this.user)));
  }
  update(t) {
    super.update(t), this.infiniteScroll.observe(this.conversationsQuery.result, this.pagerRef.value);
  }
  async updated(t) {
    var i, n;
    t.has("searchText") && t.get("searchText") && this.conversationsQuery.result && await ((n = (i = this.conversationsQuery.result).refetch) == null ? void 0 : n.call(i));
  }
  renderConversations(t, i) {
    if (i) {
      const n = zs(i);
      return zi(
        n,
        (r) => r == null ? void 0 : r.id,
        (r) => [
          O`<wy-conversation-list-item
              .conversationId=${r == null ? void 0 : r.id}
              .avatarUrl=${r == null ? void 0 : r.avatar_url}
              .hideAvatar=${!!this.bot}
              .displayName=${r.display_name}
              .lastMessage=${r.last_message}
              .members=${r.members}
              .unread=${r.is_unread}
              .starred=${r.is_starred}
              .pinned=${r.is_pinned}
              .type=${r.type}
              .selected=${this.conversationId == r.id}
              @selected=${(a) => this.dispatchSelected(a.detail.id)}
              @mark=${(a) => this.handleMark(a.detail.id, a.detail.messageId)}
              @star=${(a) => this.handleStar(a.detail.id, a.detail.star)}
              @pin=${(a) => this.handlePin(a.detail.id, a.detail.pin)}
              @leave=${(a) => this.handleLeaveConversation(a.detail.id)}
              @trash=${(a) => this.handleTrashConversation(a.detail.id)}
            ></wy-conversation-list-item>`
        ]
      );
    }
    return M;
  }
  render() {
    var t, i, n, r;
    const { data: a, isPending: o, hasNextPage: l } = this.conversationsQuery.result ?? {}, c = !this.avatarUser;
    return O`
      ${this.user ? O`
            <header class="wy-appbars">
              <nav class="wy-appbar">
                ${c ? O` <wy-spinner></wy-spinner> ` : O`
                      <wy-avatar
                        .src=${(t = this.avatarUser) == null ? void 0 : t.avatar_url}
                        .name=${(i = this.avatarUser) == null ? void 0 : i.display_name}
                        .size=${24}
                      ></wy-avatar>
                    `}
                <div class="wy-appbar-text"
                  >${this.name ?? (this.bot ? (n = this.avatarUser) == null ? void 0 : n.display_name : T("Messenger"))}</div
                >
                <wy-conversation-new
                  .bot=${this.bot}
                  @selected=${(h) => this.dispatchSelected(h.detail.id)}
                ></wy-conversation-new>
              </nav>
            </header>
            ${this.bot ? M : O`
                  <div class="wy-pane-body">
                    <div class="wy-pane-group">
                      <div class="wy-input-group">
                        <input
                          class="wy-input wy-input-group-input wy-input-filled"
                          name="text"
                          .value=${this.searchText || ""}
                          ${pe(this.inputRef)}
                          @input=${() => this.throttledSearch()}
                          @keydown=${g5}
                          @keyup=${jn}
                          placeholder=${T("Search for conversations...")}
                        />
                        <wy-button type="reset" @click=${this.clear} kind="icon" class="wy-input-group-button-icon">
                          <wy-icon name="close-circle"></wy-icon>
                        </wy-button>
                        <wy-button kind="icon" class="wy-input-group-button-icon">
                          <wy-icon name="magnify"></wy-icon>
                        </wy-button>
                      </div>
                    </div>
                  </div>
                `}
            <div class="wy-conversations">
              ${!o && this.user && a ? (r = a.pages[0]) != null && r.count || this.searchText ? this.renderConversations(this.user, a) : O`
                      <div class="wy-pane-body">
                        <div class="wy-pane-group">
                          <wy-empty noNetwork>${T("Create a conversation to get started.")}</wy-empty>
                        </div>
                      </div>
                    ` : O`<wy-empty><wy-spinner padded></wy-spinner></wy-empty>`}
              ${l ? O`<div ${pe(this.pagerRef)} part="wy-pager wy-pager-bottom"></div>` : M}
            </div>
          ` : O`<wy-empty class="wy-pane"><wy-spinner overlay></wy-spinner></wy-empty>`}
    `;
  }
  disconnectedCallback() {
    var t;
    (t = H4(this, Jl)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Zp, "za"), Zp), p(s0, "WeavyConversationList"), s0);
Jl = /* @__PURE__ */ new WeakMap();
Yn.styles = [
  fe,
  de`
      :host {
        position: relative;
      }
    `,
  Do
];
Fo([
  x({ type: Object })
], Yn.prototype, "avatarUser", 2);
Fo([
  x({ type: String })
], Yn.prototype, "name", 2);
Fo([
  x({ type: Number })
], Yn.prototype, "conversationId", 2);
Fo([
  x({ type: Array })
], Yn.prototype, "conversationTypes", 2);
Fo([
  x()
], Yn.prototype, "bot", 2);
Fo([
  B()
], Yn.prototype, "searchText", 2);
Yn = Fo([
  F("wy-conversation-list"),
  be()
], Yn);
var DX = Object.defineProperty, qX = Object.getOwnPropertyDescriptor, __ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$4"), L_ = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? qX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && DX(t, i, r), r;
}, "__decorateClass$c"), I_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || __("Cannot " + i), "__accessCheck$4"), G4 = /* @__PURE__ */ p((s, t, i) => (I_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$4"), UX = /* @__PURE__ */ p((s, t, i) => t.has(s) ? __("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$4"), K4 = /* @__PURE__ */ p((s, t, i, n) => (I_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$4"), ec, r0, Dp;
let z1 = (r0 = (Dp = class extends mn {
  constructor() {
    super(...arguments), this.conversationTitle = "", this.handleRealtimeAppUpdated = (t) => {
      !this.conversation || t.app.id !== this.conversation.id || (this.conversationTitle = t.app.display_name);
    }, this.handleRealtimeMarked = (t) => {
      !this.weavy || !this.conversation || Fe(
        this.weavy.queryClient,
        ["members", this.conversation.id],
        t.actor.id,
        (i) => {
          i.marked_id = t.marked_id, i.marked_at = t.marked_at;
        }
      );
    }, UX(this, ec);
  }
  willUpdate(t) {
    var i;
    if (super.willUpdate(t), (t.has("weavy") || t.has("conversation")) && this.weavy && t.has("conversation") && this.conversation && (this.conversationTitle = this.conversation.display_name), (t.has("weavy") || t.has("conversationId")) && this.weavy && this.conversationId !== t.get("conversationId") && ((i = G4(this, ec)) == null || i.call(this), this.conversationId)) {
      const n = `a${this.conversationId}`;
      this.weavy.subscribe(n, "app_updated", this.handleRealtimeAppUpdated), this.weavy.subscribe(n, "app_marked", this.handleRealtimeMarked), K4(this, ec, () => {
        var r, a;
        (r = this.weavy) == null || r.unsubscribe(n, "app_marked", this.handleRealtimeMarked), (a = this.weavy) == null || a.unsubscribe(n, "app_updated", this.handleRealtimeAppUpdated), K4(this, ec, void 0);
      });
    }
  }
  render() {
    var t, i, n, r, a;
    const { data: o, isPending: l, hasNextPage: c } = this.messagesQuery.result ?? {}, { data: h, isPending: d } = this.membersQuery.result ?? {}, f = this.user && this.isPrivateChat() ? ((n = (((i = (t = this.conversation) == null ? void 0 : t.members) == null ? void 0 : i.data) || []).filter((y) => {
      var w;
      return y.id !== ((w = this.user) == null ? void 0 : w.id);
    })) == null ? void 0 : n[0]) ?? this.user : null;
    return O`
      ${this.conversation && o ? O`
            ${!c && !l ? O`
                  <wy-avatar-header>
                    ${this.conversation.avatar_url ? O`<wy-avatar .size=${96} src=${this.conversation.avatar_url}></wy-avatar>` : this.isChatRoom() ? O` <wy-avatar-group
                          .members=${h == null ? void 0 : h.data}
                          title=${this.conversation.display_name}
                          .size=${96}
                        ></wy-avatar-group>` : f != null && f.avatar_url ? O`
                          <wy-avatar
                            src=${Me(f == null ? void 0 : f.avatar_url)}
                            name=${this.conversation.display_name}
                            ?isBot=${f == null ? void 0 : f.is_bot}
                            size=${96}
                          ></wy-avatar>
                        ` : M}
                  </wy-avatar-header>
                ` : M}
            <wy-messages
              .conversation=${this.conversation}
              .infiniteMessages=${o}
              .members=${h}
              .unreadMarkerId=${this.lastReadMessageId}
              .unreadMarkerPosition=${this.lastReadMessagePosition}
              .unreadMarkerShow=${this.showNewMessages}
              @vote=${(y) => {
      var w;
      (w = this.pollMutation) == null || w.mutate({
        optionId: y.detail.id,
        parentType: y.detail.parentType,
        parentId: y.detail.parentId
      });
    }}
            >
              ${c ? O`<div slot="start" ${pe(this.pagerRef)} part="wy-pager wy-pager-top"></div>` : M}
              <wy-message-typing
                slot="end"
                .conversationId=${this.conversation.id}
                .userId=${(r = this.user) == null ? void 0 : r.id}
                .isPrivateChat=${this.isPrivateChat()}
                .members=${this.conversation.members.data}
                @typing=${(y) => this.handleTyping(y)}
              ></wy-message-typing>
            </wy-messages>
          ` : O`
            <div class="wy-messages">
              <wy-empty class="wy-pane">
                ${l || d || !this.conversation ? O`<wy-spinner overlay></wy-spinner>` : T("Start the conversation!")}
              </wy-empty>
            </div>
          `}
      ${this.conversation ? O`
            <div ${pe(this.bottomRef)}></div>
            <div class="wy-footerbar wy-footerbar-sticky">
              <wy-message-editor
                .app=${this.conversation}
                .draft=${!0}
                placeholder=${T("Type a message...")}
                ?disabled=${!ko(Ar.Create, (a = this.conversation) == null ? void 0 : a.permissions)}
                @submit=${(y) => this.handleSubmit(y)}
              ></wy-message-editor>
            </div>
          ` : M}
    `;
  }
  disconnectedCallback() {
    var t;
    (t = G4(this, ec)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Dp, "Sa"), Dp), p(r0, "WyConversationExtended"), r0);
ec = /* @__PURE__ */ new WeakMap();
L_([
  B()
], z1.prototype, "conversationTitle", 2);
z1 = L_([
  F("wy-conversation-extended"),
  be()
], z1);
var NX = Object.defineProperty, BX = Object.getOwnPropertyDescriptor, W_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$3"), pw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? BX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && NX(t, i, r), r;
}, "__decorateClass$b"), V_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || W_("Cannot " + i), "__accessCheck$3"), J4 = /* @__PURE__ */ p((s, t, i) => (V_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$3"), jX = /* @__PURE__ */ p((s, t, i) => t.has(s) ? W_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$3"), e3 = /* @__PURE__ */ p((s, t, i, n) => (V_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$3"), tc, a0, qp;
let Nr = (a0 = (qp = class extends G {
  constructor() {
    super(...arguments), this.private = !0, this.rooms = !0, this.badgeQuery = new Ei(this), this.handleBadgeRefresh = async () => {
      this.badgeQuery.result.isRefetching || await this.badgeQuery.result.refetch();
    }, this.handleRealtimeMessage = (t) => {
      this.handleBadgeRefresh();
    }, this.handleRealtimeSeenBy = (t) => {
      this.handleBadgeRefresh();
    }, jX(this, tc);
  }
  async willUpdate(t) {
    var i;
    if (t.has("weavy") && this.weavy) {
      const n = [];
      this.rooms && n.push(Te.ChatRoom), this.private && n.push(Te.PrivateChat), this.bot && n.push(Te.BotChat), this.badgeQuery.trackQuery(wR(this.weavy, n, this.bot), !0), (i = J4(this, tc)) == null || i.call(this), this.weavy.subscribe(null, "message_created", this.handleRealtimeMessage), this.weavy.subscribe(null, "app_marked", this.handleBadgeRefresh), e3(this, tc, () => {
        var r, a;
        (r = this.weavy) == null || r.unsubscribe(null, "message_created", this.handleRealtimeMessage), (a = this.weavy) == null || a.unsubscribe(null, "app_marked", this.handleBadgeRefresh), e3(this, tc, void 0);
      });
    }
  }
  render() {
    const { data: t, isPending: i } = this.badgeQuery.result ?? {}, n = t ? t.count : 0;
    return O`
      ${!i && n > 0 ? O` <span class="wy-badge wy-badge-danger wy-badge-reveal">${n}</span> ` : M}
    `;
  }
  connectedCallback() {
    super.connectedCallback(), this.weavy && this.requestUpdate("weavy");
  }
  disconnectedCallback() {
    var t;
    (t = J4(this, tc)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(qp, "Ea"), qp), p(a0, "WyMessengerBadge"), a0);
tc = /* @__PURE__ */ new WeakMap();
Nr.styles = fe;
pw([
  wt({ context: Pt, subscribe: !0 }),
  B()
], Nr.prototype, "weavy", 2);
pw([
  x({ attribute: !1, type: Boolean })
], Nr.prototype, "private", 2);
pw([
  x({ attribute: !1, type: Boolean })
], Nr.prototype, "rooms", 2);
pw([
  x()
], Nr.prototype, "bot", 2);
Nr = pw([
  F("wy-messenger-badge")
], Nr);
var XX = Object.defineProperty, FX = Object.getOwnPropertyDescriptor, Rv = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? FX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && XX(t, i, r), r;
}, "__decorateClass$a");
const qH = new Map(
  Object.entries({
    [vi.ChatRoom]: Te.ChatRoom,
    [vi.PrivateChat]: Te.PrivateChat,
    [Te.ChatRoom]: vi.ChatRoom,
    [Te.PrivateChat]: vi.PrivateChat
  })
);
new Map(
  Object.entries({
    [vi.BotChat]: Te.BotChat,
    [Te.BotChat]: vi.BotChat
  })
);
const Z_ = "wy-messenger";
var o0, Up;
let Br = (o0 = (Up = class extends Ce {
  constructor() {
    super(), this.productType = If.Messenger, this.appTypes = [Te.ChatRoom, Te.PrivateChat], this.conversationId = null, this.conversationQuery = new Ei(this), this.botQuery = new Ei(this), this.persistState = new G5(this), this.releaseFocusEvent = () => new CustomEvent("release-focus", { bubbles: !0, composed: !0 }), new Fr(this, Br.styles);
  }
  get bot() {
    return super.bot;
  }
  set bot(t) {
    super.bot = t, this._bot ? this.appTypes = [Te.BotChat] : this.appTypes = [Te.ChatRoom, Te.PrivateChat], this.conversationId = null;
  }
  /**
   * Checks if a conversation belongs to Messenger.
   *
   * @deprecated
   * @param conversation {AppRef | AppType | number} - The conversation or id to check if it belongs to Messenger.
   * @returns Promise<Boolean>
   */
  async conversationBelongsToMessenger(t) {
    return console.warn("conversationBelongsToMessenger() is deprecated. Compare app to to .appTypes instead."), this.weavy ? !!await nE(this.weavy, t, this.appTypes, this.bot) : !1;
  }
  /**
   * Set the active conversation.
   *
   * @deprecated
   * @param id {number} - The id of the conversation to select.
   */
  async selectConversation(t) {
    return console.warn("selectConversation() is deprecated. Set .conversationId instead."), this.conversationId = t, !0;
  }
  /**
   * Deselects any active conversation.
   * @deprecated
   */
  clearConversation() {
    console.warn("clearConversation() is deprecated. Set .conversationId to null instead."), this.conversationId = null;
  }
  async willUpdate(t) {
    var i, n;
    super.willUpdate(t), (t.has("weavy") || t.has("bot") || t.has("user")) && this.weavy && this.user && this.persistState.observe(["conversationId"], this.bot || "messenger", `u${(i = this.user) == null ? void 0 : i.id}`), t.has("link") && (n = this.link) != null && n.app && (this.conversationId = this.link.app.id);
  }
  update(t) {
    super.update(t), (t.has("conversationId") || t.has("weavy")) && this.weavy && (this.conversationId ? this.conversationQuery.trackQuery(iE(this.weavy, this.conversationId, this.appTypes)) : this.conversationQuery.untrackQuery());
  }
  render() {
    var t;
    const { isPending: i } = ((t = this.weavy) == null ? void 0 : t.network) ?? { isPending: !0 }, { data: n, isPending: r } = this.conversationQuery.result ?? { isPending: i };
    return O`
      <div class="wy-messenger-layout">
        <wy-conversation-list
          class="wy-scroll-y"
          .conversationTypes=${this.appTypes}
          .bot=${this.bot}
          .avatarUser=${this.botUser}
          .name=${this.name}
          conversationId=${Me(this.conversationId !== null ? this.conversationId : void 0)}
          @conversation-selected=${(a) => this.conversationId = a.detail.id}
        ></wy-conversation-list>

        <div
          class="wy-messenger-conversation wy-scroll-y"
          data-conversation-id=${this.conversationId !== null ? this.conversationId : ""}
        >
          <wy-conversation-appbar
            .conversationId=${this.conversationId || void 0}
            .conversation=${n}
            @release-focus=${() => this.dispatchEvent(this.releaseFocusEvent())}
          >
            <span slot="action" class="wy-close-conversation">
              <wy-button kind="icon" @click=${() => this.conversationId = null}>
                <wy-icon name="back"></wy-icon>
              </wy-button>
              <wy-messenger-badge slot="badge" .bot=${this.bot}></wy-messenger-badge>
            </span>
          </wy-conversation-appbar>

          ${$X(
      this.conversationId ? r ? O`<wy-empty><wy-spinner reveal></wy-spinner></wy-empty>` : this.bot ? O`<wy-conversation
                      .conversationId=${this.conversationId}
                      .conversation=${n}
                    ></wy-conversation>` : O`<wy-conversation-extended
                      .conversationId=${this.conversationId}
                      .conversation=${n}
                    ></wy-conversation-extended>` : O`<wy-empty noNetwork>${T("Select a conversation")}</wy-empty>`
    )}
        </div>
      </div>
    `;
  }
}, u(Up, "Oa"), Up), p(o0, "WyMessenger"), o0);
Br.styles = [Yi, fe, xX, Wf, Hr];
Rv([
  B()
], Br.prototype, "appTypes", 2);
Rv([
  x({ type: String })
], Br.prototype, "bot", 1);
Rv([
  x({ type: Number })
], Br.prototype, "conversationId", 2);
Br = Rv([
  F(Z_),
  be()
], Br);
const HX = de`.wy-meta{color:var(--wy-outline, var(--wy-neutral-variant-50, #72777e));font-size:var(--wy-font-size-sm, calc(.875 * var(--wy-font-size, 1em)))}.wy-meta-sm{font-size:var(--wy-font-size-xs, calc(.75 * var(--wy-font-size, 1em)))}`, YX = de`.wy-notification.wy-read{opacity:var(--wy-opacity-muted, 60%);--wy-component-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e))}`;
var GX = Object.defineProperty, KX = Object.getOwnPropertyDescriptor, fw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? KX(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && GX(t, i, r), r;
}, "__decorateClass$9"), l0, Np;
let jr = (l0 = (Np = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.selected = !1, this.standalone = !1;
  }
  dispatchSelect(t) {
    const i = new CustomEvent("select", {
      detail: { notificationId: this.notificationId }
    });
    return this.dispatchEvent(i);
  }
  dispatchMark(t, i) {
    if (t.stopPropagation(), i === !!this.notification.is_unread) {
      const n = new CustomEvent("mark", {
        detail: { notificationId: this.notificationId, markAsRead: i }
      });
      return this.dispatchEvent(n);
    }
    return !0;
  }
  dispatchHide() {
    if (this.standalone) {
      const t = new CustomEvent("hide", {
        bubbles: !0
      });
      return this.dispatchEvent(t);
    }
    return !0;
  }
  dispatchClose() {
    if (this.standalone) {
      const t = new CustomEvent("close", {
        bubbles: !0
      });
      return this.dispatchEvent(t);
    }
    return !0;
  }
  async handleClick(t) {
    this.dispatchSelect(t), this.dispatchMark(t, !0), this.dispatchHide(), await k5(this, this.weavy, this.notification), this.dispatchClose();
  }
  render() {
    var t, i;
    const n = this.notification.created_at ? new Intl.DateTimeFormat((t = this.weavy) == null ? void 0 : t.locale, { dateStyle: "full", timeStyle: "short" }).format(
      new Date(this.notification.created_at)
    ) : "", r = this.notification.created_at ? Uf((i = this.weavy) == null ? void 0 : i.locale, new Date(this.notification.created_at)) : "", a = this.notification.actor, { title: o, titleHtml: l, detail: c } = P5(this.notification), h = this.standalone ? M : O`
          <div class="wy-item-actions wy-item-right">
            <wy-button
              kind="icon-inline"
              @click=${(f) => this.dispatchMark(f, !!this.notification.is_unread) && this.dispatchClose()}
              title=${this.notification.is_unread ? T("Mark as read") : T("Mark as unread")}
            >
              <wy-icon
                name=${this.notification.is_unread ? "read" : "unread"}
                color=${this.notification.is_unread ? "" : "secondary"}
              ></wy-icon>
            </wy-button>
          </div>
        `, d = this.standalone ? M : O`
          <time class="wy-meta" datetime=${this.notification.created_at.toString()} title=${n}>
            ${r}
          </time>
        `;
    return O`
      <div
        class=${ot({
      "wy-item wy-list-item-lg wy-item-hover wy-notification": !0,
      "wy-unread": !this.standalone && !!this.notification.is_unread,
      "wy-read": !this.standalone && !this.notification.is_unread,
      "wy-active": !this.standalone && this.selected
    })}
        tabindex="0"
        @click=${(f) => this.handleClick(f)}
        @keydown=${ei}
        @keyup=${_i}
      >
        <div class="wy-item-inner">
          <wy-avatar
            class="wy-item-top"
            src=${Me(a == null ? void 0 : a.avatar_url)}
            name=${Me(a == null ? void 0 : a.display_name)}
            presence=${(a == null ? void 0 : a.presence) || "away"}
            ?isBot=${a == null ? void 0 : a.is_bot}
            id=${Me(a == null ? void 0 : a.id)}
            size=${48}
          ></wy-avatar>

          <div class="wy-item-rows wy-item-rows-compact">
            <div class="wy-item-row">
              <div class="wy-item-title-lg" title=${o + (c ? `: "${c}"` : "")}>
                ${l}${c ? O`: <q class="wy-item-quote">${c}</q> ` : M}
              </div>
            </div>
            <div class="wy-item-row"> ${d} ${h} </div>
          </div>

          ${this.standalone ? O`
                <wy-button
                  kind="icon"
                  @click=${(f) => this.dispatchMark(f, !!this.notification.is_unread) && this.dispatchClose()}
                >
                  <wy-icon name="close"></wy-icon>
                </wy-button>
              ` : M}
        </div>
      </div>
    `;
  }
}, u(Np, "Aa"), Np), p(l0, "WyNotificationListItem"), l0);
jr.styles = [Lt, iz, HX, YX];
fw([
  x({ type: Number })
], jr.prototype, "notificationId", 2);
fw([
  x({ type: Boolean, reflect: !0 })
], jr.prototype, "selected", 2);
fw([
  x({ type: Boolean })
], jr.prototype, "standalone", 2);
fw([
  x({ attribute: !1 })
], jr.prototype, "notification", 2);
jr = fw([
  F("wy-notification-list-item"),
  be()
], jr);
var JX = Object.defineProperty, eF = Object.getOwnPropertyDescriptor, D_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$2"), cS = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? eF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && JX(t, i, r), r;
}, "__decorateClass$8"), q_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || D_("Cannot " + i), "__accessCheck$2"), t3 = /* @__PURE__ */ p((s, t, i) => (q_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$2"), tF = /* @__PURE__ */ p((s, t, i) => t.has(s) ? D_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$2"), i3 = /* @__PURE__ */ p((s, t, i, n) => (q_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$2"), ic, c0, Bp;
let Rf = (c0 = (Bp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.typeFilter = Dt.All, this.notificationsQuery = new Vo(this), this.infiniteScroll = new Zo(this), this.pagerRef = ke(), this.handleRefresh = (t) => {
      this.notificationsQuery.result.refetch();
    }, this.handlePresenceChange = (t) => {
      this.weavy && (Array.isArray(t) || (t = [parseInt(t)]), Fe(this.weavy.queryClient, ["notifications", "list"], void 0, (i) => {
        const n = i.actor;
        n.presence = t.indexOf(n.id) != -1 ? "active" : "away", i.actor = n;
      }));
    }, tF(this, ic);
  }
  async markAllAsRead() {
    var t, i, n;
    const r = await this.whenWeavy(), a = (i = Jz(r, Dt.All, (t = this.app) == null ? void 0 : t.id)) == null ? void 0 : i.id;
    await ((n = this.markNotificationsMutation) == null ? void 0 : n.mutate({ notificationId: a }));
  }
  async handleMark(t, i) {
    var n;
    await ((n = this.markNotificationMutation) == null ? void 0 : n.mutate({ markAsRead: t, notificationId: i }));
  }
  handleSelect(t) {
    this.notificationId = t.id;
  }
  async willUpdate(t) {
    var i, n, r;
    super.willUpdate(t), (t.has("weavy") || t.has("typeFilter") || t.has("app")) && this.weavy && this.notificationsQuery.trackInfiniteQuery(Kz(this.weavy, this.typeFilter, (i = this.app) == null ? void 0 : i.id)), (t.has("weavy") || t.has("app")) && this.weavy && (this.markNotificationsMutation = t_(this.weavy, (n = this.app) == null ? void 0 : n.id)), t.has("weavy") && this.weavy && (this.markNotificationMutation = aS(this.weavy), (r = t3(this, ic)) == null || r.call(this), this.weavy.subscribe(null, "online", this.handlePresenceChange), this.weavy.subscribe(null, "notification_created", this.handleRefresh), this.weavy.subscribe(null, "notification_updated", this.handleRefresh), this.weavy.subscribe(null, "notifications_marked", this.handleRefresh), i3(this, ic, () => {
      var a, o, l, c;
      (a = this.weavy) == null || a.unsubscribe(null, "online", this.handlePresenceChange), (o = this.weavy) == null || o.unsubscribe(null, "notification_created", this.handleRefresh), (l = this.weavy) == null || l.unsubscribe(null, "notification_updated", this.handleRefresh), (c = this.weavy) == null || c.unsubscribe(null, "notifications_marked", this.handleRefresh), i3(this, ic, void 0);
    }));
  }
  update(t) {
    super.update(t), this.infiniteScroll.observe(this.notificationsQuery.result, this.pagerRef.value);
  }
  renderNotifications(t, i) {
    if (i) {
      const n = zs(i);
      return zi(
        n,
        (r) => r == null ? void 0 : r.id,
        (r) => [
          O`<wy-notification-list-item
              notificationId=${r.id}
              .notification=${r}
              .selected=${this.notificationId == r.id}
              @select=${(a) => this.handleSelect(r)}
              @mark=${(a) => this.handleMark(a.detail.markAsRead, a.detail.notificationId)}
            ></wy-notification-list-item>`
        ]
      );
    }
    return M;
  }
  render() {
    var t;
    const { data: i, hasNextPage: n, isPending: r } = this.notificationsQuery.result ?? {};
    return O`
      ${this.user ? O`
            <div class="wy-pane-toolbar">
              <wy-buttons tabs>
                <wy-button
                  ?active=${this.typeFilter === Dt.All}
                  @click=${() => this.typeFilter = Dt.All}
                  kind="tab"
                  small
                >
                  ${T("All")}
                </wy-button>
                <wy-button
                  ?active=${this.typeFilter === Dt.Activity}
                  @click=${() => this.typeFilter = Dt.Activity}
                  kind="tab"
                  small
                >
                  ${T("Activities")}
                </wy-button>
                <wy-button
                  ?active=${this.typeFilter === Dt.Mention}
                  @click=${() => this.typeFilter = Dt.Mention}
                  kind="tab"
                  small
                >
                  ${T("Mentions")}
                </wy-button>
                <wy-button
                  ?active=${this.typeFilter === Dt.Reaction}
                  @click=${() => this.typeFilter = Dt.Reaction}
                  kind="tab"
                  small
                >
                  ${T("Reactions")}
                </wy-button>
              </wy-buttons>
              <wy-button
                slot="buttons"
                kind="icon"
                @click=${() => this.markAllAsRead()}
                title=${T("Mark all as read")}
              >
                <wy-icon name="check-all"></wy-icon>
              </wy-button>
              <slot name="buttons"></slot>
            </div>

            <div class="wy-notifications">
              ${!r && this.user && i ? (t = i.pages[0]) != null && t.count ? this.renderNotifications(this.user, i) : O`
                      <div class="wy-pane-body">
                        <div class="wy-pane-group">
                          <slot name="empty">
                            <wy-empty>${T("No updates yet.")}</wy-empty>
                          </slot>
                        </div>
                      </div>
                    ` : O`<wy-empty><wy-spinner padded></wy-spinner></wy-empty>`}
              ${n ? O`<div ${pe(this.pagerRef)} part="wy-pager wy-pager-bottom"></div>` : M}
            </div>
          ` : O`<wy-empty class="wy-pane"><wy-spinner overlay></wy-spinner></wy-empty>`}
    `;
  }
  disconnectedCallback() {
    var t;
    (t = t3(this, ic)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Bp, "La"), Bp), p(c0, "WyNotificationList"), c0);
ic = /* @__PURE__ */ new WeakMap();
Rf.styles = [
  fe,
  Do,
  de`
      :host {
        position: relative;
      }
    `
];
cS([
  x({ type: Number })
], Rf.prototype, "notificationId", 2);
cS([
  x()
], Rf.prototype, "typeFilter", 2);
Rf = cS([
  F("wy-notification-list"),
  be()
], Rf);
var iF = Object.defineProperty, nF = Object.getOwnPropertyDescriptor, sF = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? nF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && iF(t, i, r), r;
}, "__decorateClass$7");
const U_ = "wy-notifications";
var h0, jp;
let Zm = (h0 = (jp = class extends Ce {
  constructor() {
    super(), this.componentType = Ni.Unknown, this.notificationsRef = ke(), new Fr(this, Zm.styles);
  }
  /**
   * Mark all events as read.
   */
  markAllAsRead() {
    var t;
    (t = this.notificationsRef.value) == null || t.markAllAsRead();
  }
  render() {
    return O`
      ${this.user ? O` <wy-notification-list ${pe(this.notificationsRef)}></wy-notification-list> ` : O`
            <wy-empty>
              <wy-spinner padded reveal></wy-spinner>
            </wy-empty>
          `}
    `;
  }
}, u(jp, "Ra"), jp), p(h0, "WyNotifications"), h0);
Zm.styles = [Yi, fe, Wf, ew, Hr];
Zm = sF([
  F(U_),
  be()
], Zm);
var rF = Object.defineProperty, aF = Object.getOwnPropertyDescriptor, yw = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? aF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && rF(t, i, r), r;
}, "__decorateClass$6"), d0, Xp;
let Dm = (d0 = (Xp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.show = !1, this.viewportRef = ke();
  }
  close() {
    var t;
    this.show = !1;
    try {
      (t = this.viewportRef.value) == null || t.hidePopover();
    } catch {
    }
  }
  handleClose(t) {
    (t.type === "toggle" && t.newState === "closed" || t.type === "click") && (this.show = !1, this.dispatchEvent(new CustomEvent("hide")), this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 })));
  }
  render() {
    return O`
      <div class="wy-toasts" tabindex="0" ${pe(this.viewportRef)} ?hidden=${!this.show} popover>
        <slot></slot>
      </div>
    `;
  }
  willUpdate(t) {
    var i, n, r;
    if (t.has("show"))
      try {
        this.show ? (i = this.viewportRef.value) == null || i.showPopover() : (n = this.viewportRef.value) == null || n.hidePopover();
      } catch {
      }
    t.has("show") && this.show && ((r = this.viewportRef.value) == null || r.focus());
  }
  firstUpdated(t) {
    var i, n;
    (i = this.viewportRef.value) == null || i.addEventListener(this.viewportRef.value.popover ? "toggle" : "click", (r) => {
      this.handleClose(r);
    }), this.show && ((n = this.viewportRef.value) == null || n.showPopover());
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
}, u(Xp, "Ia"), Xp), p(d0, "WyToasts"), d0);
Dm.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
yw([
  x({ type: Boolean })
], Dm.prototype, "show", 2);
Dm = yw([
  F("wy-toasts")
], Dm);
var u0, Fp;
let Rs = (u0 = (Fp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.toastRef = ke(), this.show = !1, this.duration = Rs.defaultDuration;
  }
  hide() {
    this.show = !1;
  }
  async close(t = !1) {
    this.show = !1, await new Promise((i) => requestAnimationFrame(i)), this.toastRef.value && await xg(this.toastRef.value, !1), this.dispatchEvent(new CustomEvent("closed", { detail: { silent: t } })), this.dispatchEvent(new CustomEvent("release-focus", { bubbles: !0, composed: !0 }));
  }
  async willUpdate(t) {
    t.has("show") && (this.timeout && (window.clearTimeout(this.timeout), this.timeout = void 0), this.show && this.duration > 0 && this.duration < 1 / 0 && (this.timeout = window.setTimeout(() => this.close(!0), this.duration)));
  }
  render() {
    return O`
      <div
        ${pe(this.toastRef)}
        class="wy-toast wy-fade ${this.show ? "wy-show" : ""}"
        @hide=${(t) => {
      t.stopPropagation(), this.hide();
    }}
        @close=${() => this.close()}
        @keyup=${pv}
      >
        <slot></slot>
      </div>
    `;
  }
  firstUpdated() {
    requestAnimationFrame(() => {
      this.show = !0;
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.timeout && (window.clearTimeout(this.timeout), this.timeout = void 0);
  }
}, u(Fp, "Ta"), Fp), p(u0, "WyToast"), u0);
Rs.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
Rs.defaultDuration = 5e4;
yw([
  B()
], Rs.prototype, "show", 2);
yw([
  x({ type: Number })
], Rs.prototype, "duration", 2);
Rs = yw([
  F("wy-toast")
], Rs);
var oF = Object.defineProperty, lF = Object.getOwnPropertyDescriptor, N_ = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError$1"), Bf = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? lF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && oF(t, i, r), r;
}, "__decorateClass$5"), B_ = /* @__PURE__ */ p((s, t, i) => t.has(s) || N_("Cannot " + i), "__accessCheck$1"), n3 = /* @__PURE__ */ p((s, t, i) => (B_(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet$1"), cF = /* @__PURE__ */ p((s, t, i) => t.has(s) ? N_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd$1"), s3 = /* @__PURE__ */ p((s, t, i, n) => (B_(s, t, "write to private field"), t.set(s, i), i), "__privateSet$1"), nc;
const j_ = "wy-notification-toasts";
var p0, Hp;
let Gn = (p0 = (Hp = class extends Ce {
  constructor() {
    super(), this.componentType = Ni.Unknown, this.typeFilter = Dt.All, this.appearance = "internal", this.requestUserPermission = !1, this.duration = Rs.defaultDuration, this._notifications = [], this._nativeNotifications = [], this.handleEvent = async (t) => {
      var i;
      if (this.typeFilter === Dt.All || this.typeFilter === t.notification.type)
        if (t.action === "notification_deleted")
          this.removeNotification(t.notification.id), this.closeNativeNotification(t.notification.id);
        else {
          const { title: n, detail: r } = P5(t.notification), a = {
            ...t.notification,
            title: n,
            detail: r,
            lang: (i = this.weavy) == null ? void 0 : i.locale
          };
          a.link.bot = S5(a);
          const o = new CustomEvent("wy-notification", {
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            detail: a
          });
          (!this.requestUserPermission && this.appearance !== "native" || await this.hasUserPermission()) && this.dispatchEvent(o) && (t.action === "notification_created" && t.notification.is_unread ? await this.addOrUpdateNotification(t.notification) : await this.updateNotification(t.notification), await this.addOrUpdateNativeNotification(a));
        }
    }, cF(this, nc), new Fr(this, Gn.styles);
  }
  async addOrUpdateNotification(t) {
    if (!this.requestUserPermission || await this.hasUserPermission()) {
      const i = [...this._notifications], n = i.findIndex((r) => r.id === t.id);
      n !== -1 ? (i.splice(n, 1, t), this._notifications = i) : (i.push(t), this._notifications = i);
    }
  }
  async updateNotification(t) {
    if (!this.requestUserPermission || await this.hasUserPermission()) {
      const i = [...this._notifications], n = i.findIndex((r) => r.id === t.id);
      n !== -1 && (i.splice(n, 1, t), this._notifications = i);
    }
  }
  removeNotification(t) {
    const i = [...this._notifications], n = i.findIndex((r) => r.id === t);
    n !== -1 && (i.splice(n, 1), this._notifications = i);
  }
  async addOrUpdateNativeNotification(t) {
    if (this.appearance === "native" && await this.hasUserPermission()) {
      const i = this.removeNativeNotification(t.id), n = t.actor, r = new Notification(t.title, {
        tag: `wy-${t.id}`,
        lang: t.lang,
        body: t.detail,
        icon: n.avatar_url,
        // @ts-expect-error Property `renotify` not available in ts types yet
        renotify: i && e.notification.is_unread
      });
      r.onclick = async () => {
        this.handleMark(!0, t.id), await k5(this, this.weavy, t);
      }, r.onclose = () => {
        this.removeNativeNotification(t.id);
      }, this._nativeNotifications = [...this._nativeNotifications, r];
    }
  }
  removeNativeNotification(t) {
    const i = [...this._nativeNotifications], n = i.findIndex(
      (r) => r.tag === `wy-${t}`
    );
    return n ? (i.splice(n, 1), this._nativeNotifications = i, !0) : !1;
  }
  closeNativeNotification(t) {
    const i = this._nativeNotifications.findIndex(
      (n) => n.tag === `wy-${t}`
    );
    return i ? (this._nativeNotifications[i].close(), !0) : !1;
  }
  async hasUserPermission() {
    if (!("Notification" in window))
      console.error("This browser does not support desktop notifications");
    else if (!window.isSecureContext)
      console.error(
        `Desktop notifications can only be used in secure contexts. 
        See https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts`
      );
    else {
      if (Notification.permission === "granted")
        return !0;
      if (Notification.permission !== "denied")
        return await Notification.requestPermission() === "granted";
    }
    return !1;
  }
  clearNotifications() {
    this._notifications = [];
  }
  async handleMark(t, i) {
    var n;
    await ((n = this.markNotificationMutation) == null ? void 0 : n.mutate({ markAsRead: t, notificationId: i }));
  }
  async willUpdate(t) {
    var i;
    super.willUpdate(t), t.has("weavy") && this.weavy && (this.markNotificationMutation = aS(this.weavy), (i = n3(this, nc)) == null || i.call(this), this.weavy.subscribe(null, "notification_created", this.handleEvent), this.weavy.subscribe(null, "notification_updated", this.handleEvent), s3(this, nc, () => {
      var n, r;
      (n = this.weavy) == null || n.unsubscribe(null, "notification_created", this.handleEvent), (r = this.weavy) == null || r.unsubscribe(null, "notification_updated", this.handleEvent), s3(this, nc, void 0);
    })), (t.has("requestUserPermission") && this.requestUserPermission || t.has("appearance") && this.appearance === "native") && this.hasUserPermission();
  }
  render() {
    return O`
      ${this.user && this.appearance === "internal" ? O`
            <wy-toasts ?show=${!!this._notifications.length} @hide=${this.clearNotifications}>
              ${zi(
      this._notifications,
      (t) => t.id,
      (t) => O`
                    <wy-toast
                      duration=${this.duration}
                      @closed=${(i) => {
        i.detail.silent || this.handleMark(!0, t.id), this.removeNotification(t.id);
      }}
                    >
                      <wy-notification-list-item standalone .notification=${t}></wy-notification-list-item>
                    </wy-toast>
                  `
    )}
            </wy-toasts>
          ` : M}
    `;
  }
  disconnectedCallback() {
    var t;
    (t = n3(this, nc)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(Hp, "Fa"), Hp), p(p0, "WyNotificationToasts"), p0);
nc = /* @__PURE__ */ new WeakMap();
Gn.styles = [Yi, o5, Hr];
Bf([
  x()
], Gn.prototype, "typeFilter", 2);
Bf([
  x()
], Gn.prototype, "appearance", 2);
Bf([
  x({ type: Boolean })
], Gn.prototype, "requestUserPermission", 2);
Bf([
  x({ type: Number })
], Gn.prototype, "duration", 2);
Bf([
  B()
], Gn.prototype, "_notifications", 2);
Gn = Bf([
  F(j_),
  be()
], Gn);
function X_(s, t) {
  const i = s.queryClient, n = {
    mutationKey: ["posts", t.id],
    mutationFn: /* @__PURE__ */ p(async ({ id: r }) => {
      if (!(await s.fetch("/api/posts/" + r + "/trash", { method: "POST" })).ok)
        throw new Error();
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        r.id,
        (a) => Object.assign(a, { is_trashed: !0 })
      );
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.id,
        (o) => Object.assign(o, r)
      );
    }, "onSuccess")
  };
  return n;
}
u(X_, "A4");
p(X_, "getTrashPostMutationOptions");
function F_(s, t) {
  return new Ve(s.queryClient, X_(s, t));
}
u(F_, "L4");
p(F_, "getTrashPostMutation");
function H_(s, t) {
  const i = s.queryClient, n = {
    mutationKey: ["posts", t.id],
    mutationFn: /* @__PURE__ */ p(async ({ id: r }) => {
      const a = await s.fetch("/api/posts/" + r + "/restore", { method: "POST" });
      if (!a.ok) {
        const o = await a.json();
        throw new Error(o.detail || o.title, { cause: o });
      }
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        r.id,
        (a) => Object.assign(a, { is_trashed: !1 })
      );
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n.mutationKey, exact: !1 },
        a.id,
        (o) => Object.assign(o, { is_trashed: !1 })
      );
    }, "onSuccess")
  };
  return n;
}
u(H_, "R4");
p(H_, "getRestorePostMutationOptions");
function Y_(s, t) {
  return new Ve(s.queryClient, H_(s, t));
}
u(Y_, "I4");
p(Y_, "getRestorePostMutation");
function G_(s, t) {
  const i = s.queryClient, n = ["posts", t.id];
  return {
    mutationKey: n,
    mutationFn: /* @__PURE__ */ p(async ({ id: r, subscribe: a }) => {
      const o = await s.fetch(
        `/api/posts/${r}/${a ? "subscribe" : "unsubscribe"}`,
        { method: "POST" }
      );
      if (!o.ok) {
        const l = await o.json();
        throw new Error(l.detail || l.title, { cause: l });
      }
      return o.json();
    }, "mutationFn"),
    onMutate: /* @__PURE__ */ p(async (r) => {
      Se(
        i,
        { queryKey: n, exact: !1 },
        r.id,
        (a) => Object.assign(a, { is_subscribed: r.subscribe })
      );
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((r, a) => {
      Se(
        i,
        { queryKey: n, exact: !1 },
        a.id,
        (o) => Object.assign(o, r)
      );
    }, "onSuccess")
  };
}
u(G_, "T4");
p(G_, "getSubscribePostMutationOptions");
function K_(s, t) {
  return new Ve(s.queryClient, G_(s, t));
}
u(K_, "F4");
p(K_, "getSubscribePostMutation");
function J_(s, t) {
  return {
    initialPageParam: 0,
    queryKey: ["posts", t],
    queryFn: /* @__PURE__ */ p(async (i) => {
      const n = i.pageParam, r = "/api/apps/" + t + "/posts?order_by=id+desc&skip=" + n, a = await (await s.fetch(r)).json();
      return a.data = a.data || [], a;
    }, "queryFn"),
    getNextPageParam: /* @__PURE__ */ p((i) => {
      if (i.end && i.end < i.count)
        return i.end;
    }, "getNextPageParam")
  };
}
u(J_, "D4");
p(J_, "getPostsOptions");
function eL(s, t) {
  return {
    mutationFn: /* @__PURE__ */ p(async (i) => (await s.fetch("/api/posts/" + i.id, {
      method: "PATCH",
      body: JSON.stringify({
        text: i.text,
        blobs: i.blobs,
        attachments: i.attachments,
        meeting_id: i.meetingId,
        options: i.pollOptions.filter((n) => n.text.trim() !== "").map((n) => ({ id: n.id, text: n.text })),
        embed_id: i.embed || null
      })
    })).json(), "mutationFn"),
    mutationKey: t,
    onMutate: /* @__PURE__ */ p(async (i) => {
      Fe(s.queryClient, ["posts", i.appId], i.id, (n) => {
        n.text = i.text, n.html = i.text;
      });
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((i, n) => {
      n.id && Fe(s.queryClient, ["posts", n.appId], n.id, (r) => {
        r.text = i.text, r.html = i.html, r.attachments = i.attachments, r.embed = i.embed, r.meeting = i.meeting, r.updated_at = i.updated_at, r.updated_by = i.updated_by, r.options = i.options;
      });
    }, "onSuccess")
  };
}
u(eL, "H4");
p(eL, "getUpdatePostMutationOptions");
function tL(s, t) {
  const i = s.queryClient;
  return {
    mutationFn: /* @__PURE__ */ p(async (n) => (await s.fetch("/api/apps/" + n.appId + "/posts", {
      method: "POST",
      body: JSON.stringify({
        text: n.text,
        blobs: n.blobs,
        meeting_id: n.meetingId,
        options: n.pollOptions.filter((r) => r.text.trim() !== "").map((r) => ({ text: r.text })),
        embed_id: n.embed
      })
    })).json(), "mutationFn"),
    mutationKey: t,
    onMutate: /* @__PURE__ */ p(async (n) => {
      const r = ["posts", n.appId];
      await i.cancelQueries({ queryKey: r });
      const a = _r(s.queryClient, r, !1);
      if (n.user) {
        const o = {
          id: a ? a.id - 1 : -1,
          app: { id: n.appId },
          is_subscribed: !0,
          is_trashed: !1,
          text: n.text,
          html: n.text,
          plain: n.text,
          created_by: n.user,
          created_at: (/* @__PURE__ */ new Date()).toUTCString(),
          attachments: { count: 0 },
          reactions: { count: 0 },
          is_starred: !1,
          comments: { count: 0 }
        };
        zr(i, ["posts", n.appId], o, { descending: !0 });
      }
    }, "onMutate"),
    onSuccess: /* @__PURE__ */ p((n) => {
      const r = ["posts", n.app.id];
      if (!tw(s.queryClient, r, n.id)) {
        const a = _r(s.queryClient, r, !0);
        a ? Fe(s.queryClient, r, a.id, (o) => {
          o.id = n.id, o.app = n.app, o.text = n.text, o.html = n.html, o.embed = n.embed, o.meeting = n.meeting, o.attachments = n.attachments, o.options = n.options, o.created_at = n.created_at, o.created_by = n.created_by, o.updated_at = n.updated_at, o.updated_by = n.updated_by;
        }) : zr(s.queryClient, r, n);
      }
    }, "onSuccess")
  };
}
u(tL, "V4");
p(tL, "getAddPostMutationOptions");
var hF = Object.defineProperty, dF = Object.getOwnPropertyDescriptor, iL = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? dF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && hF(t, i, r), r;
}, "__decorateClass$4"), f0, Yp;
let qm = (f0 = (Yp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this);
  }
  dispatchRestore() {
    const t = new CustomEvent("restore", { detail: {} });
    return this.dispatchEvent(t);
  }
  render() {
    return O`
      <div class="wy-item">
        <div class="wy-item-body">${T("Post was trashed.")}</div>
        <wy-button @click=${() => this.dispatchRestore()} class="wy-button-variant">${T("Undo")}</wy-button>
      </div>
    `;
  }
}, u(Yp, "Da"), Yp), p(f0, "WyPostTrashed"), f0);
qm.styles = fe;
iL([
  x({ type: Number })
], qm.prototype, "postId", 2);
qm = iL([
  F("wy-post-trashed"),
  be()
], qm);
var uF = Object.defineProperty, pF = Object.getOwnPropertyDescriptor, $t = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? pF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && uF(t, i, r), r;
}, "__decorateClass$3"), y0, Gp;
let et = (y0 = (Gp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.createdAt = "", this.modifiedAt = void 0, this.isSubscribed = !1, this.isTrashed = !1, this.html = "", this.text = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.commentCount = 0, this.seenBy = [], this.showComments = !1, this.loadComments = !1, this.highlight = !1, this.isCommentLinked = !1, this.previewRef = ke(), this.highlightRef = ke();
  }
  dispatchVote(t) {
    const i = new CustomEvent("vote", { detail: { id: t } });
    return this.dispatchEvent(i);
  }
  dispatchSubscribe(t) {
    const i = new CustomEvent("subscribe", { detail: { id: this.postId, subscribe: t } });
    return this.dispatchEvent(i);
  }
  dispatchTrash() {
    const t = new CustomEvent("trash", { detail: { id: this.postId } });
    return this.dispatchEvent(t);
  }
  dispatchEdit(t) {
    const i = new CustomEvent("edit", { detail: { edit: t } });
    return this.dispatchEvent(i);
  }
  handleCommentsClick(t) {
    t.preventDefault(), this.showComments = !this.showComments, this.loadComments = !0;
  }
  willUpdate(t) {
    t.has("link") && (this.highlight = !!(this.link && nw(this.link, Bi.Post, { id: this.postId })), this.isCommentLinked = !!(this.link && x5(this.link, Bi.Post, { id: this.postId }, Bi.Comment))), t.has("isCommentLinked") && this.isCommentLinked && (this.loadComments = !0, this.showComments = !0);
  }
  render() {
    var t, i, n, r, a, o, l, c;
    const h = (t = this.attachments) == null ? void 0 : t.filter((g) => g.kind === "image" && g.thumbnail_url), d = (i = this.attachments) == null ? void 0 : i.filter((g) => g.kind !== "image" || !g.thumbnail_url), f = new Intl.DateTimeFormat((n = this.weavy) == null ? void 0 : n.locale, {
      dateStyle: "full",
      timeStyle: "short"
    }).format(new Date(this.createdAt)), y = Uf((r = this.weavy) == null ? void 0 : r.locale, new Date(this.createdAt)), w = this.modifiedAt && this.weavy ? new Intl.DateTimeFormat(this.weavy.locale, { dateStyle: "full", timeStyle: "short" }).format(
      new Date(this.modifiedAt)
    ) : "";
    return this.postId < 0 ? O`<div class="wy-post">
          <div class="wy-item">
            <wy-avatar
              .src="${this.createdBy.avatar_url}"
              .isBot=${this.createdBy.is_bot}
              .size=${48}
              .name=${this.createdBy.display_name}
            ></wy-avatar>
            <div class="wy-item-rows">
              <div class="wy-item-row">
                <div class="wy-item-title"><span class="wy-placeholder">${this.createdBy.display_name}</span></div>
              </div>
              <div class="wy-item-row">
                <div class="wy-item-text">
                  <time class="wy-placeholder">${y}</time>
                </div>
              </div>
            </div>
          </div>
          <div class="wy-post-body">
            <div class="wy-content"><wy-skeleton .text=${this.text}></wy-skeleton></div>
          </div>
        </div>` : O`
          <div class="wy-post" part=${At({ "wy-highlight": this.highlight && !this.isCommentLinked })} ${pe(
      this.highlightRef
    )}>
            <div class="wy-item">
              <wy-avatar .src="${this.createdBy.avatar_url}" .isBot=${this.createdBy.is_bot} .size=${48} .name=${this.createdBy.display_name}></wy-avatar>
              <div class="wy-item-rows">
                <div class="wy-item-row">
                  <div class="wy-item-title">${this.createdBy.display_name}</div>
                </div>
                <div class="wy-item-row">
                  <div class="wy-item-text">
                    <time datetime=${this.createdAt} title=${f}>${y}</time>
                    ${this.modifiedAt ? O`<time datetime="${this.modifiedAt}" title=${w}> · ${T("edited")}</time>` : M}
                  </div>
                  </div>
                </div>

                <div class="wy-item-actions wy-item-top">
                  <wy-dropdown>
                    ${this.isSubscribed ? O`<wy-dropdown-item @click=${() => this.dispatchSubscribe(!1)}>
                            <wy-icon name="bell-off"></wy-icon>
                            ${T("Unsubscribe")}
                          </wy-dropdown-item>` : O`<wy-dropdown-item @click=${() => this.dispatchSubscribe(!0)}>
                            <wy-icon name="bell"></wy-icon>
                            ${T("Subscribe")}
                          </wy-dropdown-item>`}
                    ${this.user && this.user.id === this.createdBy.id ? O`<wy-dropdown-item @click=${() => this.dispatchEdit(!0)}>
                            <wy-icon name="pencil"></wy-icon>
                            ${T("Edit")}
                          </wy-dropdown-item>` : M}
                    ${this.user && this.user.id === this.createdBy.id ? O`<wy-dropdown-item @click=${() => this.dispatchTrash()}>
                            <wy-icon name="trashcan"></wy-icon>
                            ${T("Trash")}
                          </wy-dropdown-item>` : M}
                  </wy-dropdown>
                </div>
              </div>
              <!-- image grid -->
              ${h && h.length ? O`<wy-image-grid
                      .images=${h}
                      @file-open=${(g) => {
      var b;
      (b = this.previewRef.value) == null || b.open(g.detail.fileId);
    }}
                    ></wy-image-grid>` : ""}

              <!-- embeds -->
              ${this.embed && (a = this.hasFeatures) != null && a.embeds ? O` <wy-embed class="wy-embed" .embed=${this.embed}></wy-embed> ` : M}

              <div class="wy-post-body">
                ${this.html ? O`<div class="wy-content">${So(this.html)}</div>` : ""}

                <!-- poll -->
                ${this.pollOptions && this.pollOptions.length > 0 ? O`
                        <wy-poll
                          .pollOptions=${this.pollOptions}
                          @vote=${(g) => this.dispatchVote(g.detail.id)}
                        ></wy-poll>
                      ` : M}

                <!-- files -->
                ${d && d.length ? O`<wy-attachments-list
                        .files=${d ?? []}
                        @file-open=${(g) => {
      var b;
      (b = this.previewRef.value) == null || b.open(g.detail.fileId);
    }}
                      ></wy-attachments-list>` : ""}

                <!-- meeting -->
                ${this.meeting ? O`<wy-meeting-card .meeting=${this.meeting}></wy-meeting-card>` : ""}
              </div>

              <div class="wy-post-footer">
                <div>
                  <!-- comment count -->
                  ${(o = this.hasFeatures) != null && o.comments ? O` <wy-button
                          small
                          kind="inline"
                          ?active=${this.showComments}
                          class="wy-meta"
                          color="inherit"
                          @click=${(g) => this.handleCommentsClick(g)}
                        >
                          ${this.commentCount !== 1 ? T(ie`${this.commentCount} comments`) : T("1 comment")}
                        </wy-button>` : M}
                </div>
                ${(l = this.hasFeatures) != null && l.reactions && this.app ? O`
                        <wy-reactions
                          line
                          small
                          .reactions=${this.reactions}
                          parentId=${this.app.id}
                          parentType="apps"
                          entityId=${this.postId}
                          entityType="posts"
                        ></wy-reactions>
                      ` : M}
              </div>

              <!-- comments -->
              ${this.loadComments ? O`
                      <div class="wy-post-comments" ?hidden=${!this.showComments}>
                        <wy-comment-list .parentId=${this.postId} .location=${"posts"}></wy-comment-list>
                      </div>
                    ` : M}
            </div>
          
            ${(c = this.attachments) != null && c.length ? O`<wy-preview
                    ${pe(this.previewRef)}
                    .files=${this.attachments}
                    .isAttachment=${!0}
                  ></wy-preview> ` : M}
           
          </div>
        `;
  }
  updated(t) {
    var i;
    t.has("highlight") && this.highlight && ((i = this.highlightRef.value) == null || i.scrollIntoView({ block: "nearest" }));
  }
}, u(Gp, "Ha"), Gp), p(y0, "WyPostView"), y0);
et.styles = [
  fe,
  de`
      :host {
        display: contents;
      }
    `
];
$t([
  x({ type: Number })
], et.prototype, "postId", 2);
$t([
  x({ attribute: !1 })
], et.prototype, "createdBy", 2);
$t([
  x()
], et.prototype, "createdAt", 2);
$t([
  x()
], et.prototype, "modifiedAt", 2);
$t([
  x({ type: Boolean })
], et.prototype, "isSubscribed", 2);
$t([
  x({ type: Boolean })
], et.prototype, "isTrashed", 2);
$t([
  x()
], et.prototype, "html", 2);
$t([
  x()
], et.prototype, "text", 2);
$t([
  x({ type: Array })
], et.prototype, "attachments", 2);
$t([
  x({ type: Array })
], et.prototype, "pollOptions", 2);
$t([
  x({ attribute: !1 })
], et.prototype, "meeting", 2);
$t([
  x({ attribute: !1 })
], et.prototype, "embed", 2);
$t([
  x({ type: Array })
], et.prototype, "reactions", 2);
$t([
  x({ attribute: !1 })
], et.prototype, "commentCount", 2);
$t([
  x({ type: Array })
], et.prototype, "seenBy", 2);
$t([
  B()
], et.prototype, "showComments", 2);
$t([
  B()
], et.prototype, "loadComments", 2);
$t([
  x({ type: Boolean })
], et.prototype, "highlight", 2);
$t([
  B()
], et.prototype, "isCommentLinked", 2);
et = $t([
  F("wy-post-view"),
  be()
], et);
var fF = Object.defineProperty, yF = Object.getOwnPropertyDescriptor, ui = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? yF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && fF(t, i, r), r;
}, "__decorateClass$2"), m0, Kp;
let zt = (m0 = (Kp = class extends tt(G) {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.temp = !1, this.createdAt = "", this.modifiedAt = void 0, this.isSubscribed = !1, this.isTrashed = !1, this.text = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.seenBy = [], this.updatePostMutation = new cn(this);
  }
  dispatchEdit(t) {
    const i = new CustomEvent("edit", { detail: { edit: t } });
    return this.dispatchEvent(i);
  }
  async handleSubmit(t) {
    const i = await this.whenApp();
    this.updatePostMutation.mutate({
      id: this.postId,
      appId: i.id,
      text: t.detail.text,
      meetingId: t.detail.meetingId,
      blobs: t.detail.blobs,
      attachments: t.detail.attachments,
      pollOptions: t.detail.pollOptions,
      embed: t.detail.embed
    }), this.dispatchEdit(!1);
  }
  async willUpdate(t) {
    super.willUpdate(t), (t.has("weavy") || t.has("app")) && this.weavy && this.app && this.updatePostMutation.trackMutation(eL(this.weavy, ["posts", this.app.id]));
  }
  render() {
    return O`
      <nav class="wy-item">
        <div class="wy-item-body">
          <div class="wy-item-title">${T("Edit post")}</div>
        </div>

        <wy-button kind="icon" @click=${() => this.dispatchEdit(!1)}>
          <wy-icon name="close"></wy-icon>
        </wy-button>
      </nav>
      <wy-editor
        editorLocation="apps"
        .text=${this.text}
        .embed=${this.embed}
        .options=${this.pollOptions}
        .attachments=${this.attachments ?? []}
        .parentId=${this.postId}
        .typing=${!1}
        .draft=${!1}
        placeholder=${T("Edit post...")}
        buttonText=${T("Update", { desc: "Button action to update" })}
        @submit=${(t) => this.handleSubmit(t)}></wy-editor>
    `;
  }
}, u(Kp, "Va"), Kp), p(m0, "WyPostEdit"), m0);
zt.styles = fe;
ui([
  x({ type: Number })
], zt.prototype, "postId", 2);
ui([
  x({ type: Boolean })
], zt.prototype, "temp", 2);
ui([
  x({ attribute: !1 })
], zt.prototype, "createdBy", 2);
ui([
  x()
], zt.prototype, "createdAt", 2);
ui([
  x()
], zt.prototype, "modifiedAt", 2);
ui([
  x({ type: Boolean })
], zt.prototype, "isSubscribed", 2);
ui([
  x({ type: Boolean })
], zt.prototype, "isTrashed", 2);
ui([
  x()
], zt.prototype, "text", 2);
ui([
  x({ type: Array })
], zt.prototype, "attachments", 2);
ui([
  x({ type: Array })
], zt.prototype, "pollOptions", 2);
ui([
  x({ attribute: !1 })
], zt.prototype, "meeting", 2);
ui([
  x({ attribute: !1 })
], zt.prototype, "embed", 2);
ui([
  x({ type: Array })
], zt.prototype, "reactions", 2);
ui([
  x({ type: Array })
], zt.prototype, "seenBy", 2);
zt = ui([
  F("wy-post-edit"),
  be()
], zt);
var mF = Object.defineProperty, wF = Object.getOwnPropertyDescriptor, Vt = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? wF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && mF(t, i, r), r;
}, "__decorateClass$1"), w0, Jp;
let ut = (w0 = (Jp = class extends G {
  constructor() {
    super(...arguments), this.exportParts = new ae(this), this.createdAt = "", this.modifiedAt = void 0, this.isSubscribed = !1, this.isTrashed = !1, this.html = "", this.text = "", this.plain = "", this.attachments = [], this.pollOptions = [], this.reactions = [], this.commentCount = 0, this.seenBy = [], this.editing = !1;
  }
  dispatchVote(t) {
    const i = new CustomEvent("vote", { detail: { id: t, parentId: this.postId, parentType: "posts" } });
    return this.dispatchEvent(i);
  }
  dispatchSubscribe(t) {
    const i = new CustomEvent("subscribe", { detail: { id: this.postId, subscribe: t } });
    return this.dispatchEvent(i);
  }
  dispatchTrash() {
    const t = new CustomEvent("trash", { detail: { id: this.postId } });
    return this.dispatchEvent(t);
  }
  dispatchRestore() {
    const t = new CustomEvent("restore", { detail: { id: this.postId } });
    return this.dispatchEvent(t);
  }
  render() {
    return O`
      ${this.isTrashed ? O`<wy-post-trashed
            class="wy-post"
            postId=${this.postId}
            @restore=${() => {
      this.dispatchRestore();
    }}></wy-post-trashed> ` : M}
      ${!this.isTrashed && this.editing ? O`<wy-post-edit
            class="wy-post"
            .postId=${this.postId}
            .text=${this.text}
            .embed=${this.embed}
            .pollOptions=${this.pollOptions}
            .attachments=${this.attachments}
            @edit=${(t) => {
      this.editing = t.detail.edit;
    }}></wy-post-edit> ` : M}
      ${!this.isTrashed && !this.editing ? O`<wy-post-view
            id="${this.id}"
            .postId=${this.postId}
            .createdBy=${this.createdBy}
            .createdAt=${this.createdAt}
            .modifiedAt=${this.modifiedAt}
            .isSubscribed=${this.isSubscribed}
            .isTrashed=${this.isTrashed}
            .html=${this.html}
            .text=${this.plain}
            .attachments=${this.attachments ?? []}
            .meeting=${this.meeting}
            .pollOptions=${this.pollOptions}
            .embed=${this.embed}
            .reactions=${this.reactions}
            .commentCount=${this.commentCount}
            @edit=${(t) => {
      this.editing = t.detail.edit;
    }}
            @subscribe=${(t) => {
      this.dispatchSubscribe(t.detail.subscribe);
    }}
            @trash=${() => {
      this.dispatchTrash();
    }}
            @vote=${(t) => {
      this.dispatchVote(t.detail.id);
    }}></wy-post-view> ` : M}
    `;
  }
}, u(Jp, "Ba"), Jp), p(w0, "WyPost"), w0);
ut.styles = fe;
Vt([
  x({ type: Number })
], ut.prototype, "postId", 2);
Vt([
  x({ attribute: !1 })
], ut.prototype, "createdBy", 2);
Vt([
  x()
], ut.prototype, "createdAt", 2);
Vt([
  x()
], ut.prototype, "modifiedAt", 2);
Vt([
  x({ type: Boolean })
], ut.prototype, "isSubscribed", 2);
Vt([
  x({ type: Boolean })
], ut.prototype, "isTrashed", 2);
Vt([
  x()
], ut.prototype, "html", 2);
Vt([
  x()
], ut.prototype, "text", 2);
Vt([
  x()
], ut.prototype, "plain", 2);
Vt([
  x({ attribute: !1 })
], ut.prototype, "attachments", 2);
Vt([
  x({ type: Array })
], ut.prototype, "pollOptions", 2);
Vt([
  x({ attribute: !1 })
], ut.prototype, "meeting", 2);
Vt([
  x({ attribute: !1 })
], ut.prototype, "embed", 2);
Vt([
  x({ type: Array })
], ut.prototype, "reactions", 2);
Vt([
  x({ attribute: !1 })
], ut.prototype, "commentCount", 2);
Vt([
  x({ type: Array })
], ut.prototype, "seenBy", 2);
Vt([
  B()
], ut.prototype, "editing", 2);
ut = Vt([
  F("wy-post")
], ut);
var gF = Object.defineProperty, vF = Object.getOwnPropertyDescriptor, nL = /* @__PURE__ */ p((s) => {
  throw TypeError(s);
}, "__typeError"), OF = /* @__PURE__ */ p((s, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? vF(t, i) : t, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = (n ? o(t, i, r) : o(r)) || r);
  return n && r && gF(t, i, r), r;
}, "__decorateClass"), sL = /* @__PURE__ */ p((s, t, i) => t.has(s) || nL("Cannot " + i), "__accessCheck"), r3 = /* @__PURE__ */ p((s, t, i) => (sL(s, t, "read from private field"), i ? i.call(s) : t.get(s)), "__privateGet"), bF = /* @__PURE__ */ p((s, t, i) => t.has(s) ? nL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, i), "__privateAdd"), a3 = /* @__PURE__ */ p((s, t, i, n) => (sL(s, t, "write to private field"), t.set(s, i), i), "__privateSet"), sc;
const rL = "wy-posts";
var g0, ef;
let Um = (g0 = (ef = class extends Ce {
  constructor() {
    super(), this.productType = If.Feeds, this.componentType = vi.Posts, this.postsQuery = new Vo(this), this.infiniteScroll = new Zo(this), this.pagerRef = ke(), this.addPostMutation = new cn(this), this.handleRealtimePostCreated = async (t) => {
      var i;
      const n = await this.whenWeavy(), r = await this.whenApp(), a = await this.whenUser();
      t.post.app.id !== r.id || ((i = t.post.created_by) == null ? void 0 : i.id) === a.id || (t.post.created_by = t.actor, zr(n.queryClient, ["posts", r.id], t.post, {
        descending: !0
      }));
    }, this.handleRealtimeCommentCreated = async (t) => {
      const i = await this.whenWeavy(), n = await this.whenApp(), r = await this.whenUser();
      t.actor.id === r.id || !t.comment.parent || (Fe(i.queryClient, ["posts", n.id], t.comment.parent.id, (a) => {
        a.comments ? a.comments.count += 1 : a.comments = { count: 1 };
      }), i.queryClient.invalidateQueries({ queryKey: ["posts", t.comment.app.id, "comments"] }));
    }, this.handleRealtimeReactionAdded = async (t) => {
      const i = await this.whenWeavy(), n = await this.whenApp();
      t.entity.type === "post" && Fe(i.queryClient, ["posts", n.id], t.entity.id, (r) => {
        xf(r, t.reaction, t.actor);
      });
    }, this.handleRealtimeReactionDeleted = async (t) => {
      const i = await this.whenWeavy(), n = await this.whenApp();
      t.entity.type === "post" && Fe(i.queryClient, ["posts", n.id], t.entity.id, (r) => {
        xf(r, void 0, t.actor);
      });
    }, bF(this, sc), new Fr(this, Um.styles);
  }
  async handleSubmit(t) {
    const i = await this.whenApp(), n = await this.whenUser();
    this.addPostMutation.mutate({
      appId: i.id,
      text: t.detail.text,
      meetingId: t.detail.meetingId,
      blobs: t.detail.blobs,
      pollOptions: t.detail.pollOptions,
      embed: t.detail.embed,
      user: n
    });
  }
  willUpdate(t) {
    var i;
    if (super.willUpdate(t), (t.has("weavy") || t.has("app")) && this.weavy && this.app && this.postsQuery.trackInfiniteQuery(J_(this.weavy, this.app.id)), (t.has("weavy") || t.has("app")) && this.weavy && this.app) {
      this.addPostMutation.trackMutation(tL(this.weavy, ["posts", this.app.id])), this.subscribePostMutation = K_(this.weavy, this.app), this.removePostMutation = F_(this.weavy, this.app), this.restorePostMutation = Y_(this.weavy, this.app), this.pollMutation = uv(this.weavy, ["posts", this.app.id]), (i = r3(this, sc)) == null || i.call(this);
      const n = `a${this.app.id}`;
      this.weavy.subscribe(n, "post_created", this.handleRealtimePostCreated), this.weavy.subscribe(n, "comment_created", this.handleRealtimeCommentCreated), this.weavy.subscribe(n, "reaction_added", this.handleRealtimeReactionAdded), this.weavy.subscribe(n, "reaction_removed", this.handleRealtimeReactionDeleted), a3(this, sc, () => {
        var r, a, o, l;
        (r = this.weavy) == null || r.unsubscribe(n, "post_created", this.handleRealtimePostCreated), (a = this.weavy) == null || a.unsubscribe(n, "comment_created", this.handleRealtimeCommentCreated), (o = this.weavy) == null || o.unsubscribe(n, "reaction_added", this.handleRealtimeReactionAdded), (l = this.weavy) == null || l.unsubscribe(n, "reaction_removed", this.handleRealtimeReactionDeleted), a3(this, sc, void 0);
      });
    }
  }
  update(t) {
    super.update(t), this.infiniteScroll.observe(this.postsQuery.result, this.pagerRef.value);
  }
  render() {
    const { data: t, isPending: i, hasNextPage: n } = this.postsQuery.result ?? {}, r = zs(t);
    return this.app ? O`
          <wy-buttons floating reverse>
            <wy-notification-button-list></wy-notification-button-list>
          </wy-buttons>

          <div class="wy-posts">
            <div class="wy-post">
              <wy-editor
                editorLocation="apps"
                ?disabled=${!ko(Ar.Create, this.app.permissions)}
                .typing=${!1}
                .draft=${!0}
                placeholder=${T("Create a post...")}
                buttonText=${T("Post")}
                @submit=${(a) => this.handleSubmit(a)}
              ></wy-editor>
            </div>

            <!-- this.user ?? -->
            ${i ? O`<wy-empty><wy-spinner padded reveal></wy-spinner></wy-empty> ` : O`
                  ${this.app && this.user && r ? zi(
      r,
      (a) => a.id,
      (a) => {
        var o, l, c, h;
        return this.app && this.user ? O`<wy-post
                                id="post-${a.id}"
                                .postId=${a.id}
                                .createdBy=${a.created_by}
                                .createdAt=${a.created_at}
                                .modifiedAt=${a.updated_at}
                                .isSubscribed=${a.is_subscribed}
                                .isTrashed=${a.is_trashed}
                                .html=${a.html}
                                .text=${a.text}
                                .plain=${a.plain}
                                .attachments=${(o = a.attachments) == null ? void 0 : o.data}
                                .meeting=${a.meeting}
                                .pollOptions=${(l = a.options) == null ? void 0 : l.data}
                                .embed=${a.embed}
                                .reactions=${(c = a.reactions) == null ? void 0 : c.data}
                                .commentCount=${((h = a.comments) == null ? void 0 : h.count) || 0}
                                @subscribe=${(d) => {
          var f;
          (f = this.subscribePostMutation) == null || f.mutate({
            id: d.detail.id,
            subscribe: d.detail.subscribe
          });
        }}
                                @trash=${(d) => {
          var f;
          (f = this.removePostMutation) == null || f.mutate({ id: d.detail.id });
        }}
                                @restore=${(d) => {
          var f;
          (f = this.restorePostMutation) == null || f.mutate({ id: d.detail.id });
        }}
                                @vote=${(d) => {
          var f;
          (f = this.pollMutation) == null || f.mutate({
            optionId: d.detail.id,
            parentType: d.detail.parentType,
            parentId: d.detail.parentId
          });
        }}
                              ></wy-post>` : M;
      }
    ) : O`<wy-empty><wy-spinner padded reveal></wy-spinner></wy-empty>`}
                  ${n ? O`<div ${pe(this.pagerRef)} part="wy-pager wy-pager-bottom"></div>` : M}
                `}
          </div>
        ` : O`<wy-empty><wy-spinner padded reveal></wy-spinner></wy-empty>`;
  }
  disconnectedCallback() {
    var t;
    (t = r3(this, sc)) == null || t.call(this), super.disconnectedCallback();
  }
}, u(ef, "Ua"), ef), p(g0, "WyPosts"), g0);
sc = /* @__PURE__ */ new WeakMap();
Um.styles = [Yi, fe, Wf, ew, Hr, Do];
Um = OF([
  F(rL),
  be()
], Um);
const ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get WyAttachment() {
    return Qs;
  },
  get WyAttachmentsList() {
    return bf;
  },
  get WyAvatar() {
    return Cs;
  },
  get WyAvatarGroup() {
    return Po;
  },
  get WyBlobUpload() {
    return Qf;
  },
  get WyButton() {
    return Xn;
  },
  get WyButtons() {
    return Co;
  },
  get WyCloudFiles() {
    return zo;
  },
  get WyComment() {
    return ht;
  },
  get WyCommentEdit() {
    return vt;
  },
  get WyCommentEditor() {
    return V$;
  },
  get WyCommentList() {
    return Pf;
  },
  get WyCommentTrashed() {
    return Em;
  },
  get WyCommentView() {
    return St;
  },
  get WyConversation() {
    return mn;
  },
  get WyConversationAppbar() {
    return Hn;
  },
  get WyConversationExtended() {
    return z1;
  },
  get WyConversationList() {
    return Yn;
  },
  get WyConversationListItem() {
    return jt;
  },
  get WyConversationNew() {
    return Mf;
  },
  get WyDropdown() {
    return bi;
  },
  get WyDropdownDivider() {
    return M1;
  },
  get WyDropdownItem() {
    return Rm;
  },
  get WyDropdownOption() {
    return Sf;
  },
  get WyEditor() {
    return Ze;
  },
  get WyEmbed() {
    return vf;
  },
  get WyEmpty() {
    return wf;
  },
  get WyFileItem() {
    return Ms;
  },
  get WyFileMenu() {
    return Dr;
  },
  get WyFileVersions() {
    return Cf;
  },
  get WyFilesAppbar() {
    return qr;
  },
  get WyFilesList() {
    return wn;
  },
  get WyIcon() {
    return Je;
  },
  get WyImageGrid() {
    return Of;
  },
  get WyMeetingCard() {
    return Tm;
  },
  get WyMessage() {
    return dt;
  },
  get WyMessageEditor() {
    return Z$;
  },
  get WyMessageTyping() {
    return Li;
  },
  get WyMessages() {
    return yn;
  },
  get WyMessengerBadge() {
    return Nr;
  },
  get WyNotificationBadge() {
    return Im;
  },
  get WyNotificationButtonList() {
    return E1;
  },
  get WyNotificationList() {
    return Rf;
  },
  get WyNotificationListItem() {
    return jr;
  },
  get WyOverlay() {
    return Wr;
  },
  get WyPdfViewer() {
    return Ao;
  },
  get WyPoll() {
    return zm;
  },
  get WyPollOption() {
    return Eo;
  },
  get WyPost() {
    return ut;
  },
  get WyPostEdit() {
    return zt;
  },
  get WyPostTrashed() {
    return qm;
  },
  get WyPostView() {
    return et;
  },
  get WyPresence() {
    return gf;
  },
  get WyPreview() {
    return Ot;
  },
  get WyPreviewEmbed() {
    return Zr;
  },
  get WyPreviewIcon() {
    return Mo;
  },
  get WyPreviewImage() {
    return Ro;
  },
  get WyPreviewItem() {
    return Am;
  },
  get WyPreviewMedia() {
    return Vr;
  },
  get WyPreviewText() {
    return Fn;
  },
  get WyReactionItem() {
    return Qm;
  },
  get WyReactions() {
    return ct;
  },
  get WySheet() {
    return kf;
  },
  get WySkeleton() {
    return Mm;
  },
  get WySpinner() {
    return Bn;
  },
  get WyToast() {
    return Rs;
  },
  get WyToasts() {
    return Dm;
  },
  get WyTyping() {
    return Tf;
  },
  get WyUsersSearch() {
    return gn;
  }
}, Symbol.toStringTag, { value: "Module" }));
rn.version = "26.0.3";
rn.sourceName = "@weavy/uikit-react";
const $F = $L(null);
function UH(s, t = []) {
  var l, c, h, d, f;
  const [i, n] = VS(), r = {
    ...s,
    cloudFilePickerUrl: (l = s.cloudFilePickerUrl) == null ? void 0 : l.toString(),
    locales: ZS(() => s.locales, [(c = s.locales) == null ? void 0 : c.length]),
    tokenUrl: (h = s.tokenUrl) == null ? void 0 : h.toString(),
    tokenFactory: ZS(
      () => s.tokenFactory,
      [(d = s.tokenFactory) == null ? void 0 : d.toString(), ...t]
    ),
    url: (f = s.url) == null ? void 0 : f.toString()
  }, [a, o] = VS(r);
  return v0(() => {
    if (!i) {
      const w = (Ji == null ? void 0 : Ji.value) ?? new cg(r);
      n(w);
    }
  }, []), v0(() => {
    if (i && !i.isDestroyed) {
      const y = {};
      Object.entries(r).forEach(([w, g]) => {
        g !== a[w] && Object.assign(y, { [w]: g });
      }), Object.keys(y).length && (o(r), Object.assign(i, y));
    }
  }, [r]), i;
}
u(UH, "useWeavy");
const aL = Promise.resolve(), hS = class hS {
  constructor(t, i) {
    this.o = [], this.t = !0, this.i = !1, this.l = t, this.h = i, this.u = new Promise((n, r) => {
      this.p = n;
    });
  }
  addController(t) {
    this.o.push(t);
  }
  removeController(t) {
    var i;
    (i = this.o) == null || i.splice(this.o.indexOf(t) >>> 0, 1);
  }
  requestUpdate() {
    this.t || (this.t = !0, aL.then(() => this.h(++this.l)));
  }
  get updateComplete() {
    return this.u;
  }
  m() {
    this.i = !0, this.o.forEach((t) => {
      var i;
      return (i = t.hostConnected) == null ? void 0 : i.call(t);
    });
  }
  _() {
    this.i = !1, this.o.forEach((t) => {
      var i;
      return (i = t.hostDisconnected) == null ? void 0 : i.call(t);
    });
  }
  v() {
    this.o.forEach((t) => {
      var i;
      return (i = t.hostUpdate) == null ? void 0 : i.call(t);
    });
  }
  C() {
    this.t = !1;
    const t = this.p;
    this.u = new Promise((i, n) => {
      this.p = i;
    }), this.o.forEach((i) => {
      var n;
      return (n = i.hostUpdated) == null ? void 0 : n.call(i);
    }), t(this.t);
  }
};
u(hS, "s");
let q$ = hS;
const xF = /* @__PURE__ */ u((s, t) => {
  const { useState: i, useLayoutEffect: n } = s, [r, a] = i(0);
  let o = !1;
  const [l] = i(() => {
    const c = new q$(r, a), h = t(c);
    return c.M = h, c.m(), o = !0, aL.then(() => {
      o && c._();
    }), c;
  });
  return l.t = !0, n(() => (o = !1, l.i || l.m(), () => l._()), []), n(() => l.C()), l.v(), l.M;
}, "e$2");
function kF(s, t) {
  var a;
  const n = ((/* @__PURE__ */ u((o) => !!o && o.current !== void 0, "isRef"))(s) ? s.current : s) || void 0, r = xF(
    Y,
    (o) => new Uq(o, t ?? Pt, n)
  );
  return v0(() => {
    n && (r.ref = n);
  }, [r, n]), (a = r.context) == null ? void 0 : a.value;
}
u(kF, "useWeavyContext");
const SF = /* @__PURE__ */ new Set(["children", "localName", "ref", "style", "className"]), o3 = /* @__PURE__ */ new WeakMap(), l3 = /* @__PURE__ */ u((s, t, i, n, r) => {
  const a = r == null ? void 0 : r[t];
  a === void 0 ? (s[t] = i, i == null && t in HTMLElement.prototype && s.removeAttribute(t)) : i !== n && ((o, l, c) => {
    let h = o3.get(o);
    h === void 0 && o3.set(o, h = /* @__PURE__ */ new Map());
    let d = h.get(l);
    c !== void 0 ? d === void 0 ? (h.set(l, d = { handleEvent: c }), o.addEventListener(l, d)) : d.handleEvent = c : d !== void 0 && (h.delete(l), o.removeEventListener(l, d));
  })(s, a, i);
}, "t"), K = /* @__PURE__ */ u(({ react: s, tagName: t, elementClass: i, events: n, displayName: r }) => {
  const a = new Set(Object.keys(n ?? {})), o = s.forwardRef((l, c) => {
    const h = s.useRef(/* @__PURE__ */ new Map()), d = s.useRef(null), f = {}, y = {};
    for (const [w, g] of Object.entries(l)) SF.has(w) ? f[w === "className" ? "class" : w] = g : a.has(w) || w in i.prototype ? y[w] = g : f[w] = g;
    return s.useLayoutEffect(() => {
      if (d.current === null) return;
      const w = /* @__PURE__ */ new Map();
      for (const g in y) l3(d.current, g, l[g], h.current.get(g), n), h.current.delete(g), w.set(g, l[g]);
      for (const [g, b] of h.current) l3(d.current, g, void 0, b, n);
      h.current = w;
    }), s.useLayoutEffect(() => {
      var w;
      (w = d.current) == null || w.removeAttribute("defer-hydration");
    }, []), f.suppressHydrationWarning = !0, s.createElement(t, { ...f, ref: s.useCallback((w) => {
      d.current = w, typeof c == "function" ? c(w) : c !== null && (c.current = w);
    }, [c]) });
  });
  return o.displayName = r ?? i.name, o;
}, "o"), NH = K({
  react: Y,
  tagName: l_,
  elementClass: Wm,
  events: {
    onWyPreviewOpen: "wy-preview-open"
  }
}), BH = K({
  react: Y,
  tagName: c_,
  elementClass: Vm,
  events: {
    onWyPreviewOpen: "wy-preview-open"
  }
}), jH = K({
  react: Y,
  tagName: $A,
  elementClass: xo
}), PF = K({
  react: Y,
  tagName: OA,
  elementClass: lt,
  events: {
    onWyNotifications: "wy-notifications"
  }
});
function XH({
  children: s,
  ...t
}) {
  const i = xL(null), n = kF(i.current);
  return /* @__PURE__ */ Y.createElement(PF, { ref: i, ...t }, /* @__PURE__ */ Y.createElement($F.Provider, { value: n ?? null }, s));
}
u(XH, "WyContext");
const FH = K({
  react: Y,
  tagName: Q_,
  elementClass: Ur,
  events: {
    onWyPreviewOpen: "wy-preview-open"
  }
}), HH = K({
  react: Y,
  tagName: Z_,
  elementClass: Br,
  events: {
    onWyPreviewOpen: "wy-preview-open"
  }
}), YH = K({
  react: Y,
  tagName: U_,
  elementClass: Zm,
  events: {
    onWyLink: "wy-link"
  }
}), GH = K({
  react: Y,
  tagName: j_,
  elementClass: Gn,
  events: {
    onWyLink: "wy-link",
    onWyNotification: "wy-notification"
  }
}), KH = K({
  react: Y,
  tagName: rL,
  elementClass: Um,
  events: {
    onWyPreviewOpen: "wy-preview-open"
  }
}), CF = K({
  react: Y,
  tagName: "wy-attachment",
  elementClass: ne.WyAttachment
}), QF = K({
  react: Y,
  tagName: "wy-attachments-list",
  elementClass: ne.WyAttachmentsList,
  events: {
    onFileOpen: "file-open"
  }
}), TF = K({
  react: Y,
  tagName: "wy-avatar",
  elementClass: ne.WyAvatar
}), MF = K({
  react: Y,
  tagName: "wy-blob-upload",
  elementClass: ne.WyBlobUpload
}), RF = K({
  react: Y,
  tagName: "wy-button",
  elementClass: ne.WyButton
}), AF = K({
  react: Y,
  tagName: "wy-buttons",
  elementClass: ne.WyButtons
}), EF = K({
  react: Y,
  tagName: "wy-cloud-files",
  elementClass: ne.WyCloudFiles,
  events: {
    onExternalBlobs: "external-blobs",
    onReleaseFocus: "release-focus"
  }
}), zF = K({
  react: Y,
  tagName: "wy-comment-list",
  elementClass: ne.WyCommentList
}), _F = K({
  react: Y,
  tagName: "wy-comment",
  elementClass: ne.WyComment,
  events: {
    onVote: "vote",
    onSubscribe: "subscribe",
    onTrash: "trash",
    onRestore: "restore"
  }
}), LF = K({
  react: Y,
  tagName: "wy-comment-view",
  elementClass: ne.WyCommentView,
  events: {
    onVote: "vote",
    onTrash: "trash",
    onEdit: "edit"
  }
}), IF = K({
  react: Y,
  tagName: "wy-comment-edit",
  elementClass: ne.WyCommentEdit,
  events: {
    onEdit: "edit"
  }
}), WF = K({
  react: Y,
  tagName: "wy-comment-editor",
  elementClass: ne.WyCommentEditor,
  events: {
    onSubmit: "submit"
  }
}), VF = K({
  react: Y,
  tagName: "wy-comment-trashed",
  elementClass: ne.WyCommentTrashed,
  events: {
    onRestore: "restore"
  }
}), ZF = K({
  react: Y,
  tagName: "wy-conversation",
  elementClass: ne.WyConversation,
  events: {
    onReleaseFocus: "release-focus"
  }
}), DF = K({
  react: Y,
  tagName: "wy-conversation-extended",
  elementClass: ne.WyConversationExtended,
  events: {
    onReleaseFocus: "release-focus"
  }
}), qF = K({
  react: Y,
  tagName: "wy-conversation-appbar",
  elementClass: ne.WyConversationAppbar,
  events: {
    onReleaseFocus: "release-focus"
  }
}), UF = K({
  react: Y,
  tagName: "wy-conversation-new",
  elementClass: ne.WyConversationNew,
  events: {
    onReleaseFocus: "release-focus"
  }
}), NF = K({
  react: Y,
  tagName: "wy-conversation-list",
  elementClass: ne.WyConversationList,
  events: {
    onConversationSelected: "conversation-selected"
  }
}), BF = K({
  react: Y,
  tagName: "wy-conversation-list-item",
  elementClass: ne.WyConversationListItem,
  events: {
    onRefetch: "refetch",
    onSelected: "selected",
    onStar: "star",
    onPin: "pin",
    onMark: "mark",
    onLeave: "leave"
  }
}), jF = K({
  react: Y,
  tagName: "wy-dropdown",
  elementClass: ne.WyDropdown
}), XF = K({
  react: Y,
  tagName: "wy-dropdown-item",
  elementClass: ne.WyDropdownItem
}), FF = K({
  react: Y,
  tagName: "wy-dropdown-option",
  elementClass: ne.WyDropdownOption
}), HF = K({
  react: Y,
  tagName: "wy-dropdown-divider",
  elementClass: ne.WyDropdownDivider
}), YF = K({
  react: Y,
  tagName: "wy-editor",
  elementClass: ne.WyEditor,
  events: {
    onSubmit: "submit"
  }
}), GF = K({
  react: Y,
  tagName: "wy-embed",
  elementClass: ne.WyEmbed,
  events: {
    onEmbedRemove: "embed-remove",
    onEmbedSwap: "embed-swap"
  }
}), KF = K({
  react: Y,
  tagName: "wy-empty",
  elementClass: ne.WyEmpty
}), JF = K({
  react: Y,
  tagName: "wy-file-item",
  elementClass: ne.WyFileItem,
  events: {
    onEditName: "edit-name",
    onRename: "rename",
    onTrash: "trash",
    onRestore: "restore",
    onDeleteForever: "delete-forever",
    onSubscribe: "subscribe"
  }
}), eH = K({
  react: Y,
  tagName: "wy-file-menu",
  elementClass: ne.WyFileMenu,
  events: {
    onEditName: "edit-name",
    onSubscribe: "subscribe",
    onTrash: "trash",
    onRestore: "restore",
    onDeleteForever: "delete-forever"
  }
}), tH = K({
  react: Y,
  tagName: "wy-file-versions",
  elementClass: ne.WyFileVersions,
  events: {
    onFileVersionSelect: "file-version-select"
  }
}), iH = K({
  react: Y,
  tagName: "wy-files-appbar",
  elementClass: ne.WyFilesAppbar,
  events: {
    onReleaseFocus: "release-focus",
    onUploadFiles: "upload-files",
    onExternalBlobs: "external-blobs",
    onCreateFiles: "create-files",
    onOrder: "order",
    onView: "view",
    onShowTrashed: "show-trashed",
    onSubscribe: "subscribe"
  }
}), nH = K({
  react: Y,
  tagName: "wy-files-list",
  elementClass: ne.WyFilesList,
  events: {
    onFileOpen: "file-open",
    onOrder: "order",
    onEditName: "edit-name",
    onRename: "rename",
    onTrash: "trash",
    onRestore: "restore",
    onDeleteForever: "delete-forever",
    onSubscribe: "subscribe"
  }
}), sH = K({
  react: Y,
  tagName: "wy-icon",
  elementClass: ne.WyIcon
}), rH = K({
  react: Y,
  tagName: "wy-image-grid",
  elementClass: ne.WyImageGrid,
  events: {
    onFileOpen: "file-open"
  }
}), aH = K({
  react: Y,
  tagName: "wy-meeting-card",
  elementClass: ne.WyMeetingCard
}), oH = K({
  react: Y,
  tagName: "wy-message",
  elementClass: ne.WyMessage
}), lH = K({
  react: Y,
  tagName: "wy-messages",
  elementClass: ne.WyMessages,
  events: {
    onScrollToBottom: "scroll-to-bottom"
  }
}), cH = K({
  react: Y,
  tagName: "wy-message-editor",
  elementClass: ne.WyMessageEditor,
  events: {
    onSubmit: "submit"
  }
}), hH = K({
  react: Y,
  tagName: "wy-message-typing",
  elementClass: ne.WyMessageTyping
}), dH = K({
  react: Y,
  tagName: "wy-messenger-badge",
  elementClass: ne.WyMessengerBadge
}), uH = K({
  react: Y,
  tagName: "wy-notification-badge",
  elementClass: ne.WyNotificationBadge
}), pH = K({
  react: Y,
  tagName: "wy-notification-button-list",
  elementClass: ne.WyNotificationButtonList
}), fH = K({
  react: Y,
  tagName: "wy-notification-list",
  elementClass: ne.WyNotificationList
}), yH = K({
  react: Y,
  tagName: "wy-notification-list-item",
  elementClass: ne.WyNotificationListItem
}), mH = K({
  react: Y,
  tagName: "wy-overlay",
  elementClass: ne.WyOverlay,
  events: {
    onReleaseFocus: "release-focus",
    onClose: "close"
  }
}), wH = K({
  react: Y,
  tagName: "wy-pdf-viewer",
  elementClass: ne.WyPdfViewer
}), gH = K({
  react: Y,
  tagName: "wy-poll",
  elementClass: ne.WyPoll,
  events: {
    onReleaseFocus: "release-focus",
    onVote: "vote"
  }
}), vH = K({
  react: Y,
  tagName: "wy-poll-option",
  elementClass: ne.WyPollOption,
  events: {
    onReleaseFocus: "release-focus",
    onVote: "vote"
  }
}), OH = K({
  react: Y,
  tagName: "wy-post",
  elementClass: ne.WyPost,
  events: {
    onVote: "vote",
    onSubscribe: "subscribe",
    onTrash: "trash",
    onRestore: "restore"
  }
}), bH = K({
  react: Y,
  tagName: "wy-post-view",
  elementClass: ne.WyPostView,
  events: {
    onVote: "vote",
    onSubscribe: "subscribe",
    onTrash: "trash",
    onEdit: "edit"
  }
}), $H = K({
  react: Y,
  tagName: "wy-post-edit",
  elementClass: ne.WyPostEdit,
  events: {
    onEdit: "edit"
  }
}), xH = K({
  react: Y,
  tagName: "wy-post-trashed",
  elementClass: ne.WyPostTrashed,
  events: {
    onRestore: "restore"
  }
}), kH = K({
  react: Y,
  tagName: "wy-presence",
  elementClass: ne.WyPresence
}), SH = K({
  react: Y,
  tagName: "wy-preview",
  elementClass: ne.WyPreview,
  events: {
    onReleaseFocus: "release-focus",
    onWyPreviewOpen: "wy-preview-open",
    onWyPreviewClose: "wy-preview-close"
  }
}), PH = K({
  react: Y,
  tagName: "wy-preview-item",
  elementClass: ne.WyPreviewItem
}), CH = K({
  react: Y,
  tagName: "wy-preview-embed",
  elementClass: ne.WyPreviewEmbed
}), QH = K({
  react: Y,
  tagName: "wy-preview-icon",
  elementClass: ne.WyPreviewIcon
}), TH = K({
  react: Y,
  tagName: "wy-preview-image",
  elementClass: ne.WyPreviewImage
}), MH = K({
  react: Y,
  tagName: "wy-preview-media",
  elementClass: ne.WyPreviewMedia
}), RH = K({
  react: Y,
  tagName: "wy-preview-text",
  elementClass: ne.WyPreviewText
}), AH = K({
  react: Y,
  tagName: "wy-reactions",
  elementClass: ne.WyReactions,
  events: {
    onReleaseFocus: "release-focus"
  }
}), EH = K({
  react: Y,
  tagName: "wy-reaction-item",
  elementClass: ne.WyReactionItem
}), zH = K({
  react: Y,
  tagName: "wy-sheet",
  elementClass: ne.WySheet,
  events: {
    onReleaseFocus: "release-focus",
    onClose: "close"
  }
}), _H = K({
  react: Y,
  tagName: "wy-skeleton",
  elementClass: ne.WySkeleton
}), LH = K({
  react: Y,
  tagName: "wy-spinner",
  elementClass: ne.WySpinner
}), IH = K({
  react: Y,
  tagName: "wy-typing",
  elementClass: ne.WyTyping
}), WH = K({
  react: Y,
  tagName: "wy-users-search",
  elementClass: ne.WyUsersSearch,
  events: {
    onSubmit: "submit"
  }
}), JH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WyAttachment: CF,
  WyAttachmentsList: QF,
  WyAvatar: TF,
  WyBlobUpload: MF,
  WyButton: RF,
  WyButtons: AF,
  WyCloudFiles: EF,
  WyComment: _F,
  WyCommentEdit: IF,
  WyCommentEditor: WF,
  WyCommentList: zF,
  WyCommentTrashed: VF,
  WyCommentView: LF,
  WyConversation: ZF,
  WyConversationAppbar: qF,
  WyConversationExtended: DF,
  WyConversationList: NF,
  WyConversationListItem: BF,
  WyConversationNew: UF,
  WyDropdown: jF,
  WyDropdownDivider: HF,
  WyDropdownItem: XF,
  WyDropdownOption: FF,
  WyEditor: YF,
  WyEmbed: GF,
  WyEmpty: KF,
  WyFileItem: JF,
  WyFileMenu: eH,
  WyFileVersions: tH,
  WyFilesAppbar: iH,
  WyFilesList: nH,
  WyIcon: sH,
  WyImageGrid: rH,
  WyMeetingCard: aH,
  WyMessage: oH,
  WyMessageEditor: cH,
  WyMessageTyping: hH,
  WyMessages: lH,
  WyMessengerBadge: dH,
  WyNotificationBadge: uH,
  WyNotificationButtonList: pH,
  WyNotificationList: fH,
  WyNotificationListitem: yH,
  WyOverlay: mH,
  WyPdfViewer: wH,
  WyPoll: gH,
  WyPollOption: vH,
  WyPost: OH,
  WyPostEdit: $H,
  WyPostTrashed: xH,
  WyPostView: bH,
  WyPresence: kH,
  WyPreview: SH,
  WyPreviewEmbed: CH,
  WyPreviewIcon: QH,
  WyPreviewImage: TH,
  WyPreviewItem: PH,
  WyPreviewMedia: MH,
  WyPreviewText: RH,
  WyReactionItem: EH,
  WyReactions: AH,
  WySheet: zH,
  WySkeleton: _H,
  WySpinner: LH,
  WyTyping: IH,
  WyUsersSearch: WH
}, Symbol.toStringTag, { value: "Module" }));
export {
  Yq as AppTypeGuids,
  DH as AppTypeStrings,
  qH as MessengerTypes,
  cg as Weavy,
  JH as WeavyComponents,
  $F as WeavyContext,
  NH as WyChat,
  BH as WyComments,
  jH as WyComponent,
  XH as WyContext,
  FH as WyFiles,
  HH as WyMessenger,
  GH as WyNotificationToasts,
  YH as WyNotifications,
  KH as WyPosts,
  UH as useWeavy,
  kF as useWeavyContext
};
